import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
export type GetUserTestsByUserIdQueryVariables = Exact<{
  userID: Scalars['uuid'];
  dnaSkinTestID: Scalars['Int'];
  dnaVitaminTestID: Scalars['Int'];
  fromDate?: InputMaybe<Scalars['timestamptz']>;
  toDate?: InputMaybe<Scalars['timestamptz']>;
  states?: Array<Dnavisit_Test_Statuses_Enum> | Dnavisit_Test_Statuses_Enum;
}>;


export type GetUserTestsByUserIdQuery = { __typename?: 'query_root', tests: Array<{ __typename?: 'tests', test_id: any, created_at: any, tests_test_definition: { __typename?: 'test_definitions', test_type: Test_Types_Enum } }> };

export type GetUserDnaTestsByTestsIdsQueryVariables = Exact<{
  testIDS?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  states?: Array<Dnavisit_Test_Statuses_Enum> | Dnavisit_Test_Statuses_Enum;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserDnaTestsByTestsIdsQuery = { __typename?: 'query_root', dnavisit_tests: Array<{ __typename?: 'dnavisit_tests', test_id: any, state?: Dnavisit_Test_Statuses_Enum | null, tracking_number?: string | null, patient_pdf_id?: any | null, visit_summary_pdf_id?: any | null, sapphiros_barcode?: string | null, visit_summary_appointment_date?: any | null, visit_summary_appointment_url?: string | null, created_at?: any | null }>, dnavisit_tests_aggregate: { __typename?: 'dnavisit_tests_aggregate', aggregate?: { __typename?: 'dnavisit_tests_aggregate_fields', count: number } | null } };

export type GetDiagnosticReportsByParticipantsQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  providerCodexId: Scalars['String'];
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum> | Hasura_Dnavisit_Test_Statuses_Enum>;
}>;


export type GetDiagnosticReportsByParticipantsQuery = { __typename?: 'query_root', getDiagnosticReportsByParticipants: { __typename?: 'AppointmentsDiagnosticReportsOutput', diagnosticReports: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', createdAt?: string | null, diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, providerPdfId?: string | null, swabCode: string, providerPdf?: { __typename?: 'FileOutput', contentType?: string | null, creation?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }>, patientPdf?: { __typename?: 'FileOutput', contentType?: string | null, creation?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null }> } };

export type GetProviderDiagnosticReportsByPatientQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  exceptAppointmentCodexId: Scalars['String'];
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum> | Hasura_Dnavisit_Test_Statuses_Enum>;
}>;


export type GetProviderDiagnosticReportsByPatientQuery = { __typename?: 'query_root', getDiagnosticReportsByPatient: { __typename?: 'AppointmentsDiagnosticReportsOutput', total: number, diagnosticReports: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, providerPdfId?: string | null, swabCode: string, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }>, providerPdf?: { __typename?: 'FileOutput', contentType?: string | null, creation?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null }> } };

export type GetDiagnosticReportsByPatientQueryVariables = Exact<{
  patientCodexId: Scalars['String'];
  exceptAppointmentCodexId: Scalars['String'];
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum> | Hasura_Dnavisit_Test_Statuses_Enum>;
}>;


export type GetDiagnosticReportsByPatientQuery = { __typename?: 'query_root', getDiagnosticReportsByPatient: { __typename?: 'AppointmentsDiagnosticReportsOutput', total: number, diagnosticReports: Array<{ __typename?: 'GetFHIRAppointmentDiagnosticReportOutput', diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, patientPdfId?: string | null, swabCode: string, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }>, patientPdf?: { __typename?: 'FileOutput', contentType?: string | null, creation?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null }> } };

export type GetAcuityCalendarMutationVariables = Exact<{
  providerId: Scalars['String'];
}>;


export type GetAcuityCalendarMutation = { __typename?: 'mutation_root', GetAcuityCalendarInformation?: { __typename?: 'AcuityCalendarResult', calendar_id: number, active: boolean, owner_id?: string | null, provider_calendar: string, provider_id: string } | null };

export type UpdateAvailabilityOverridesMutationVariables = Exact<{
  overrides: Array<AvailabilityOverrideGroupInput> | AvailabilityOverrideGroupInput;
}>;


export type UpdateAvailabilityOverridesMutation = { __typename?: 'mutation_root', UpdateAvailabilityOverrides?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type GetAcuityProviderTimeSlotsQueryVariables = Exact<{
  providerCalendarId: Scalars['String'];
  date: Scalars['String'];
}>;


export type GetAcuityProviderTimeSlotsQuery = { __typename?: 'query_root', GetProviderTimeSlots: { __typename?: 'ProviderWorkingHoursAndBlockedTime', providerWorkingHours: { __typename?: 'ProviderWeeklyWorkingHours', data: { __typename?: 'AcuityWorkingHoursPerDay', Monday: Array<string>, Tuesday: Array<string>, Wednesday: Array<string>, Thursday: Array<string>, Friday: Array<string>, Saturday: Array<string>, Sunday: Array<string> } }, blocks: Array<{ __typename?: 'FormatedAvailableTime', start: string, end: string, enabled: boolean }> } };

export type GetFreeProvidersByTimeSlotsQueryVariables = Exact<{
  speciality?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  providerCanSpeak?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  date: Scalars['String'];
  appointmentTypeId: Scalars['String'];
  appointmentAccepted?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  medicalRole?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  serverOfferedRange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortByDirections?: InputMaybe<Scalars['String']>;
  yearOfExpirienceRange?: InputMaybe<Scalars['String']>;
}>;


export type GetFreeProvidersByTimeSlotsQuery = { __typename?: 'query_root', getFreeProvidersByTimeSlots: { __typename?: 'GetFHIRProvidersOutput', total?: number | null, providers: Array<{ __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_email: string, SENSITIVE_phone: string, SENSITIVE_gender: string, SENSITIVE_national_provider_identifier: string, SENSITIVE_languages_of_communication: Array<string>, SENSITIVE_about?: string | null, SENSITIVE_profile_picture_id?: string | null, SENSITIVE_education: Array<{ __typename?: 'ProviderEducationOutput', medicalSchool: string, residency?: string | null, undergraduate: string }>, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', yearsOfPractice: string, certifications: Array<string>, fellowships?: string | null, medicalRole: string, titles: Array<string>, stateLicenses?: Array<{ __typename?: 'ProviderStateLicenseOutput', id: string, state: string, licenseType: StateLicenseType, licenseNumber: string, expirationDate: string }> | null }, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, healthCareServiceFhirId: string, price: string, priceCategory: PriceCategory, serviceType: ServiceType }>, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', address1?: string | null, address2?: string | null, country?: string | null, city?: string | null, state?: string | null, province?: string | null, zipCode?: string | null } | null, SENSITIVE_office_information?: { __typename?: 'OfficeAddressInformationOutput', officeName?: string | null, email: string, address1?: string | null, city?: string | null, state?: string | null } | null }> } };

export type GetProviderAvailabilityMonthDatesQueryVariables = Exact<{
  appointmentTypeId: Scalars['String'];
  month: Scalars['String'];
  providerCalendarId?: InputMaybe<Scalars['String']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProviderAvailabilityMonthDatesQuery = { __typename?: 'query_root', GetProviderAvailabilityMonthDates: { __typename?: 'ProviderAvailabilityMonthDates', dates: Array<string> } };

export type GetProviderAvailabilityServiceTypesQueryVariables = Exact<{
  providerCalendarId: Scalars['String'];
}>;


export type GetProviderAvailabilityServiceTypesQuery = { __typename?: 'query_root', GetProviderAvailabilityServiceTypes: { __typename?: 'ProviderAvailabilityServiceTypes', serviceTypes: Array<{ __typename?: 'AppointmentType', active: boolean, category: string, description?: string | null, duration: number, id: number, name: string, paddingAfter: number, paddingBefore: number, price: string, type: string }> } };

export type GetProviderAvailabilityTimeSlotsQueryVariables = Exact<{
  appointmentTypeId: Scalars['String'];
  date: Scalars['String'];
  providerCalendarId?: InputMaybe<Scalars['String']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProviderAvailabilityTimeSlotsQuery = { __typename?: 'query_root', GetProviderAvailabilityTimeSlots: { __typename?: 'ProviderAvailabilityTimeSlots', timeSlots: Array<{ __typename?: 'AvailabilityTime', slotsAvailable: number, time: string }> } };

export type GetAvailableAppointmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableAppointmentTypesQuery = { __typename?: 'query_root', GetAvailableAppointmentTypes?: { __typename?: 'GetAvailableAppointmentTypesResult', appointmentTypes?: Array<{ __typename?: 'AppointmentType', active: boolean, addonIDs?: Array<number> | null, calendarIDs: Array<number>, category: string, classSize?: number | null, color: string, description?: string | null, duration: number, formIDs?: Array<number> | null, id: number, name: string, paddingAfter: number, paddingBefore: number, price: string, type: string, private: boolean, schedulingUrl: string, image?: string | null }> | null } | null };

export type GetNotesByAppointmentIdQueryVariables = Exact<{
  appointmentCodexId: Scalars['String'];
}>;


export type GetNotesByAppointmentIdQuery = { __typename?: 'query_root', getAppointmentNotesByAppointmentId: { __typename?: 'GetAppointmentNotesByAppointmentIdOutput', nabla_notes: Array<{ __typename?: 'NablaNote', appointment_id: string, nabla_notes: string }> } };

export type GetAvailabilityOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailabilityOverridesQuery = { __typename?: 'query_root', GetAvailabilityOverrides: { __typename?: 'AvailabilityOverridesResponse', overrides: Array<{ __typename?: 'AvailabilityOverrideGroup', startDate: string, endDate: string, intervals: Array<{ __typename?: 'TimeRange', toTimePeriod: string, to: string, fromTimePeriod: string, from: string }> }> } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'query_root', countries: Array<{ __typename?: 'countries', code: string, name: string, flag?: string | null, id: number }> };

export type UpsertEducationCourseMutationVariables = Exact<{
  input: EducationCourseInput;
}>;


export type UpsertEducationCourseMutation = { __typename?: 'mutation_root', upsertEducationCourse: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type DeleteEducationCourseMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEducationCourseMutation = { __typename?: 'mutation_root', deleteEducationCourse: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetEducationCoursesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetEducationCoursesQuery = { __typename?: 'query_root', getEducationCourses: { __typename?: 'EducationCoursesListOutput', total: number, courses: Array<{ __typename?: 'EducationCourseListItemOutput', description: string, createdAt: string, id: string, title: string, updatedAt: string, visibilityRoles: Array<string>, contentCounters: Array<{ __typename?: 'EducationCourseContentCounterOutput', type: string, value: number }>, courseImageFile: { __typename?: 'FileOutput', fileId?: string | null } }> } };

export type GetEducationCourseDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEducationCourseDetailsQuery = { __typename?: 'query_root', getEducationCourseDetails: { __typename?: 'EducationCourseOutput', description: string, createdAt: string, id: string, visibilityRoles: Array<string>, title: string, updatedAt: string, courseImageFile: { __typename?: 'FileOutput', fileId?: string | null }, educationModules: Array<{ __typename?: 'EducationModuleOutput', courseId: string, createdAt: string, id: string, title: string, updatedAt: string, additionalMaterialsModules?: Array<{ __typename?: 'EducationModuleAdditionalMaterialOutput', createdAt: string, id: string, linkedModuleId: string, moduleId: string, linkedModule: { __typename?: 'LinkedEducationModuleOutput', courseId: string, id: string, title: string } }> | null, educationModuleItems?: Array<{ __typename?: 'EducationModuleItemOutput', category: EducationCourseModuleItemCategory, createdAt: string, id: string, moduleId: string, title: string, updatedAt: string, file: { __typename?: 'FileOutput', contentType?: string | null, creation?: string | null, fileName?: string | null, size?: number | null, url?: string | null, fileId?: string | null } }> | null }> } };

export type GetEducationModulesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Roles_Enum> | Roles_Enum>;
  excludeModuleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetEducationModulesQuery = { __typename?: 'query_root', getEducationModules: { __typename?: 'EducationModulesListOutput', modules: Array<{ __typename?: 'EducationModuleOutput', title: string, id: string }> } };

export type RegisterTestKitMutationVariables = Exact<{
  swabBarcode: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
  testType: Scalars['String'];
  questionnaireResponses: Scalars['jsonb'];
  questionnaireResponseResourceId?: InputMaybe<Scalars['String']>;
}>;


export type RegisterTestKitMutation = { __typename?: 'mutation_root', RegisterTestKit?: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } | null };

export type RegisterDiagnosticSolutionTestKitMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
  zrtSwabCode: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
}>;


export type RegisterDiagnosticSolutionTestKitMutation = { __typename?: 'mutation_root', RegisterDiagnosticSolutionTestKit?: { __typename?: 'DiagnosticSolutionOutput', testId: string, test_type: string } | null };

export type RegisterTestKitByMyProviderMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
  testType: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
  zrtSwabCode: Scalars['String'];
}>;


export type RegisterTestKitByMyProviderMutation = { __typename?: 'mutation_root', requestZrtTest: { __typename?: 'RequestZrtTestOutput', requestStatus: ProviderRequestStatus, serviceRequestId: string } };

export type RegisterMosaicTestKitMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
  testId: Scalars['String'];
  validateNpi?: InputMaybe<Scalars['Boolean']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
}>;


export type RegisterMosaicTestKitMutation = { __typename?: 'mutation_root', RegisterMosaicTestKit?: { __typename?: 'MosaicResponseOutput', testId: string, trackingNumber?: string | null } | null };

export type UpdateTestKitProviderMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
  swabCode: Scalars['String'];
}>;


export type UpdateTestKitProviderMutation = { __typename?: 'mutation_root', updateTestKitProvider: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type RegisterDnaVitaminTestKitMutationVariables = Exact<{
  testKitId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
}>;


export type RegisterDnaVitaminTestKitMutation = { __typename?: 'mutation_root', RegisterDnaVitaminTestKit?: { __typename?: 'DnaVitaminResponseOutput', dnaVitaminOrderId: string, testKitId: string, trackingNumber?: string | null } | null };

export type DeleteRecommendationByRequestUserCodexIdMutationVariables = Exact<{
  recommendationId: Scalars['String'];
}>;


export type DeleteRecommendationByRequestUserCodexIdMutation = { __typename?: 'mutation_root', deleteRecommendationByRequestUserCodexId: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type RequestDnaTestKitMutationVariables = Exact<{
  swabCode: Scalars['String'];
  providerCodexId?: InputMaybe<Scalars['String']>;
  testType: Hasura_Test_Types_Enum;
  trackingNumber?: InputMaybe<Scalars['String']>;
}>;


export type RequestDnaTestKitMutation = { __typename?: 'mutation_root', requestDnaTestKit: { __typename?: 'RequestDnaTestKitOutput', success: boolean, swabCode: string } };

export type PendingPatientZrtTestQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type PendingPatientZrtTestQuery = { __typename?: 'query_root', pending_patient_zrt: Array<{ __typename?: 'pending_patient_zrt', id: number, created_at?: any | null, notification_id?: string | null, provider_full_name?: string | null, test_type: string, swabcode: string, status?: any | null, provider_id?: any | null, user_id: any }> };

export type GetTestKitResultsByRequestPatientCodexIdForPatientQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  providerFullNameQuery?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum> | Hasura_Test_Types_Enum>;
}>;


export type GetTestKitResultsByRequestPatientCodexIdForPatientQuery = { __typename?: 'query_root', getTestKitResultsByRequestPatientCodexId: { __typename?: 'TestKitResultsOutput', total: number, diagnosticReports: Array<{ __typename?: 'TestKitResultOutput', createdAt?: string | null, diagnosticReportId: string, diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum, diagnosticReportTestType: Hasura_Test_Types_Enum, providerCodexId?: string | null, providerFirstName?: string | null, providerLastName?: string | null, swabCode: string, patientPdf?: { __typename?: 'FileOutput', contentType?: string | null, creation?: string | null, fileId?: string | null, fileName?: string | null, size?: number | null, url?: string | null } | null }> } };

export type PendingZrtTestSubscriptionVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['uuid']>;
}>;


export type PendingZrtTestSubscription = { __typename?: 'subscription_root', pending_patient_zrt: Array<{ __typename?: 'pending_patient_zrt', id: number, created_at?: any | null, notification_id?: string | null, provider_full_name?: string | null, test_type: string, swabcode: string, status?: any | null, provider_id?: any | null, user_id: any, questionnaire_required: boolean, questionnaire_updated_at?: any | null, diagnostic_report_id?: any | null, user?: { __typename?: 'users', id: any, account_closed_at?: any | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null } | null }> };

export type GetDnaTestKitWithResultByUserIdSubscriptionVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetDnaTestKitWithResultByUserIdSubscription = { __typename?: 'subscription_root', tests: Array<{ __typename?: 'tests', user_id: any, state: Dnavisit_Test_Statuses_Enum, test_id: any }> };

export type GetLatestDnaVisitTestsMutationVariables = Exact<{ [key: string]: never; }>;


export type GetLatestDnaVisitTestsMutation = { __typename?: 'mutation_root', GetLatestDnaVisitTests: any };

export type GetDnaTestBySwabcodeIdWithNoErrorsMutationVariables = Exact<{
  swabCode: Scalars['String'];
}>;


export type GetDnaTestBySwabcodeIdWithNoErrorsMutation = { __typename?: 'mutation_root', getDnaTestBySwabCodeIDWithNoErrors: { __typename?: 'DNAValidTestBySwabCode', existingDnaTests: boolean } };

export type GetLatestDnaTestsForSuperAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestDnaTestsForSuperAdminQuery = { __typename?: 'query_root', dnavisit_tests: Array<{ __typename?: 'dnavisit_tests', state?: Dnavisit_Test_Statuses_Enum | null, errors?: any | null, sapphiros_barcode?: string | null, created_at?: any | null, tracking_number?: string | null, dna_test_questionnaire_pdf_id?: any | null, health_questionnaire_pdf_id?: any | null, provider_report_pdf_id?: any | null, patient_pdf_id?: any | null, sapphiros_report_pdf_id?: any | null, visit_summary_pdf_id?: any | null, dnavisit_tests_test: { __typename?: 'tests', tests_user: { __typename?: 'users', SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_email?: string | null, id: any }, tests_test_definition: { __typename?: 'test_definitions', test_type: Test_Types_Enum } } }> };

export type ValidateFedexTrackingNumberQueryVariables = Exact<{
  trackingNumber: Scalars['String'];
}>;


export type ValidateFedexTrackingNumberQuery = { __typename?: 'query_root', ValidateFedexTrackingNumber: { __typename?: 'FedexTrackingResponse', isValid: boolean } };

export type GetSignedUrlFromStorageMutationVariables = Exact<{
  fileId: Scalars['String'];
}>;


export type GetSignedUrlFromStorageMutation = { __typename?: 'mutation_root', GetSignUrlFormStorage?: { __typename?: 'SuccessGetSignUrlFormStorage', status: number, url: string } | null };

export type GetSignedUrlFromStorageByAdminMutationVariables = Exact<{
  userId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type GetSignedUrlFromStorageByAdminMutation = { __typename?: 'mutation_root', GetSignUrlFromStorageByAdmin?: { __typename?: 'SuccessGetSignUrlFormStorage', status: number, url: string } | null };

export type GetVonageSignUrlFormStorageMutationVariables = Exact<{
  appointmentId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type GetVonageSignUrlFormStorageMutation = { __typename?: 'mutation_root', GetVonageSignUrlFormStorage?: { __typename?: 'SuccessGetVonageSignUrlFormStorage', status: number, url: string } | null };

export type GetProviderPatientSignedUrlMutationVariables = Exact<{
  patientCodexId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type GetProviderPatientSignedUrlMutation = { __typename?: 'mutation_root', GetProviderPatientSignedUrl?: { __typename?: 'SuccessGetSignUrlFormStorage', status: number, url: string } | null };

export type GetEncounterSignUrlFromStorageMutationVariables = Exact<{
  encounterId?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
}>;


export type GetEncounterSignUrlFromStorageMutation = { __typename?: 'mutation_root', GetEncounterSignUrlFromStorage?: { __typename?: 'SuccessGetSignUrlFormStorage', status: number, url: string } | null };

export type GetFileByIdQueryVariables = Exact<{
  fileId: Scalars['uuid'];
}>;


export type GetFileByIdQuery = { __typename?: 'query_root', files_by_pk?: { __typename?: 'files', id: any, file_name: string, created_at: any } | null };

export type GetSignUrlFromStorageForRequesterQueryVariables = Exact<{
  fileId: Scalars['String'];
  requestedUserId: Scalars['String'];
}>;


export type GetSignUrlFromStorageForRequesterQuery = { __typename?: 'query_root', GetSignUrlFromStorageForRequester?: { __typename?: 'SuccessGetSignUrlFormStorage', status: number, url: string } | null };

export type GetThirdPartyConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThirdPartyConfigQuery = { __typename?: 'query_root', frontEndAuthConfigs: any };

export type GetBarcodeScanningDisabledStateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetBarcodeScanningDisabledStateSubscription = { __typename?: 'subscription_root', global_configs: Array<{ __typename?: 'global_configs', value: any }> };

export type GetInactivityModalVariablesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetInactivityModalVariablesSubscription = { __typename?: 'subscription_root', global_configs: Array<{ __typename?: 'global_configs', value: any }> };

export type GetUserLogoutBasedOnLastActivityVariablesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetUserLogoutBasedOnLastActivityVariablesSubscription = { __typename?: 'subscription_root', global_configs: Array<{ __typename?: 'global_configs', value: any }> };

export type GetMyVisitSummaryModalDisabledStateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetMyVisitSummaryModalDisabledStateSubscription = { __typename?: 'subscription_root', global_configs: Array<{ __typename?: 'global_configs', value: any }> };

export type GetAppointmentsDisabledStateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentsDisabledStateSubscription = { __typename?: 'subscription_root', global_configs: Array<{ __typename?: 'global_configs', value: any }> };

export type GetSignUpProviderRouteStateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetSignUpProviderRouteStateSubscription = { __typename?: 'subscription_root', global_configs: Array<{ __typename?: 'global_configs', value: any }> };

export type GetChannelSignalsSubscriptionVariables = Exact<{
  channel: Scalars['String'];
  key: Scalars['String'];
}>;


export type GetChannelSignalsSubscription = { __typename?: 'subscription_root', channel_signals: Array<{ __typename?: 'channel_signals', last_updated: any }> };

export type GetAppointmentMediaSignalsSubscriptionVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetAppointmentMediaSignalsSubscription = { __typename?: 'subscription_root', appointment_media_signals: Array<{ __typename?: 'appointment_media_signals', file_id: any, id: number, lastUpdatedAt: any, location: number, user_id: any }> };

export type GetGoogleMeetLinkMutationVariables = Exact<{
  appointmentId: Scalars['String'];
  patientId: Scalars['String'];
  providerId: Scalars['String'];
}>;


export type GetGoogleMeetLinkMutation = { __typename?: 'mutation_root', RegisterGoogleMeet?: { __typename?: 'RegisterGoogleMeetOutput', appointmentId: string, conferenceId: string, endTime: string, eventId: string, meetLink: string, startTime: string, transcriptionEnabled: boolean } | null };

export type AcceptLegalDocumentMutationVariables = Exact<{
  legal_document_type: Hasura_Legal_Document_Types_Enum;
}>;


export type AcceptLegalDocumentMutation = { __typename?: 'mutation_root', acceptLegalDocument: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } };

export type PublishLegalDocumentMutationVariables = Exact<{
  input: PublishLegalDocumentInput;
}>;


export type PublishLegalDocumentMutation = { __typename?: 'mutation_root', publishLegalDocument: { __typename?: 'LegalDocumentOutput', type: Hasura_Legal_Document_Types_Enum, updatedByFullName: string, version: number } };

export type GetAcceptedLegalDocumentsQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetAcceptedLegalDocumentsQuery = { __typename?: 'query_root', accepted_legal_documents: Array<{ __typename?: 'accepted_legal_documents', accepted_legal_document_id: any, legal_document: { __typename?: 'legal_documents', content_web: string, content_mobile: string, legal_document_type: Legal_Document_Types_Enum } }> };

export type GetLegalDocumentAcceptanceByLegalDocumentTypeQueryVariables = Exact<{
  user_id: Scalars['uuid'];
  legal_document_type: Legal_Document_Types_Enum;
}>;


export type GetLegalDocumentAcceptanceByLegalDocumentTypeQuery = { __typename?: 'query_root', accepted_legal_documents: Array<{ __typename?: 'accepted_legal_documents', accepted_legal_document_id: any, acceptance_date: any, legal_document: { __typename?: 'legal_documents', content_web: string, content_mobile: string, legal_document_type: Legal_Document_Types_Enum } }> };

export type GetLegalDocumentQueryVariables = Exact<{
  type: Hasura_Legal_Document_Types_Enum;
}>;


export type GetLegalDocumentQuery = { __typename?: 'query_root', getLegalDocument: { __typename?: 'LegalDocumentOutput', contentWeb: string, type: Hasura_Legal_Document_Types_Enum, contentMobile: string, updatedByFullName: string } };

export type GetLegalDocumentsQueryVariables = Exact<{
  input?: InputMaybe<GetLegalDocumentsInput>;
}>;


export type GetLegalDocumentsQuery = { __typename?: 'query_root', getLegalDocuments: { __typename?: 'LegalDocumentsOutput', legalDocuments: Array<{ __typename?: 'LegalDocumentOutput', contentMobile: string, contentWeb: string, type: Hasura_Legal_Document_Types_Enum, updatedAt: string, updatedByFullName: string, version: number }> } };

export type SendMessageMutationVariables = Exact<{
  inMailId: Scalars['String'];
  text: Scalars['String'];
  attachments?: InputMaybe<Array<FileAttachmentInput> | FileAttachmentInput>;
}>;


export type SendMessageMutation = { __typename?: 'mutation_root', sendInMailMessage: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetInMailUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInMailUsageQuery = { __typename?: 'query_root', getInMailUsage: { __typename?: 'InMailUsageOutput', used: number, updatedAt: string } };

export type GetInMailsByProviderIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  providerCodexId?: InputMaybe<Scalars['String']>;
  queryName?: InputMaybe<Scalars['String']>;
}>;


export type GetInMailsByProviderIdQuery = { __typename?: 'query_root', getUserInMailsByRequestId: { __typename?: 'InMailsOutput', total: number, inMails: Array<{ __typename?: 'InMailOutput', createdAt?: string | null, lastMessageAt?: string | null, id?: string | null, patient: { __typename?: 'InMailParticipantOutput', firstName: string, lastName: string, codexId: string }, provider: { __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string } }> } };

export type MessageDetailQueryVariables = Exact<{
  filter?: InputMaybe<GetInMailDetailInput>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
}>;


export type MessageDetailQuery = { __typename?: 'query_root', getInMailDetail: { __typename?: 'InMailDetailsOutput', nextPageToken?: string | null, lastMessageAt?: string | null, id?: string | null, createdAt?: string | null, provider: { __typename?: 'InMailParticipantOutput', profilePictureId?: string | null, lastName: string, firstName: string, codexId: string }, patient: { __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string, profilePictureId?: string | null }, messages: Array<{ __typename?: 'InMailMessageOutput', date: string, senderCodexId: string, text?: string | null, attachments: Array<{ __typename?: 'Attachment', url?: string | null, title?: string | null, size?: number | null, contentType?: ContentType | null }> }> } };

export type GetProviderInMailsCountsQueryVariables = Exact<{
  providerCodexId?: InputMaybe<Scalars['String']>;
  queryName?: InputMaybe<Scalars['String']>;
}>;


export type GetProviderInMailsCountsQuery = { __typename?: 'query_root', getUserInMailsByRequestId: { __typename?: 'InMailsOutput', total: number, newTotal: number } };

export type GetProviderInMailsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  providerCodexId?: InputMaybe<Scalars['String']>;
  queryName?: InputMaybe<Scalars['String']>;
}>;


export type GetProviderInMailsQuery = { __typename?: 'query_root', getUserInMailsByRequestId: { __typename?: 'InMailsOutput', newTotal: number, total: number, inMails: Array<{ __typename?: 'InMailOutput', createdAt?: string | null, id?: string | null, lastMessageAt?: string | null, read?: boolean | null, patient: { __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string, profilePictureId?: string | null }, provider: { __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string, profilePictureId?: string | null } }>, contactsWithoutChats: Array<{ __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string, profilePictureId?: string | null }> } };

export type UpdateInAppNotificationMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
}>;


export type UpdateInAppNotificationMutation = { __typename?: 'mutation_root', updateInAppNotificationById: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type UpdateProfileNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateProfileNotificationMutation = { __typename?: 'mutation_root', UpdateProfileNotification?: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } | null };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['String'];
}>;


export type DeleteNotificationMutation = { __typename?: 'mutation_root', deleteUserNotification: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } };

export type UpdateAllUserNotificationStatusMutationVariables = Exact<{
  status: Scalars['String'];
  isLatestActivity?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateAllUserNotificationStatusMutation = { __typename?: 'mutation_root', updateAllUserNotificationsStatus: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  input: UpdateNotificationPreferencesInput;
}>;


export type UpdateNotificationPreferencesMutation = { __typename?: 'mutation_root', updateNotificationPreferences: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetUserNotificationByUserIdSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Order_By>;
  where: User_Notifications_Bool_Exp;
}>;


export type GetUserNotificationByUserIdSubscription = { __typename?: 'subscription_root', user_notifications: Array<{ __typename?: 'user_notifications', data?: any | null, id: any, status: User_Notification_Status_Enum, user_communication_delivery_id: any, user_id: any, activity_type?: string | null, is_toast?: boolean | null, is_modal: boolean, notification_type?: number | null, is_important_update?: boolean | null }> };

export type GetUserNotificationCountsByUserIdSubscriptionVariables = Exact<{
  where: User_Notifications_Bool_Exp;
}>;


export type GetUserNotificationCountsByUserIdSubscription = { __typename?: 'subscription_root', user_notifications_aggregate: { __typename?: 'user_notifications_aggregate', aggregate?: { __typename?: 'user_notifications_aggregate_fields', count: number } | null } };

export type GetUserNotificationCountsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationCountsSubscription = { __typename?: 'subscription_root', user_notifications_aggregate: { __typename?: 'user_notifications_aggregate', aggregate?: { __typename?: 'user_notifications_aggregate_fields', count: number } | null } };

export type GetExternalNotificationCountsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetExternalNotificationCountsSubscription = { __typename?: 'subscription_root', provider_unread_external_notification_counts: Array<{ __typename?: 'provider_unread_external_notification_counts', dosespot_unread_notifications: any }> };

export type UserNotificationByUserIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Order_By>;
  where: User_Notifications_Bool_Exp;
}>;


export type UserNotificationByUserIdQuery = { __typename?: 'query_root', user_notifications: Array<{ __typename?: 'user_notifications', data?: any | null, id: any, status: User_Notification_Status_Enum, is_latest_activity: boolean, user_communication_delivery_id: any, user_id: any, activity_type?: string | null }> };

export type GetNotificationsByUserIdWithCountsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<OrderByDirections>;
  isLatestActivity?: InputMaybe<Scalars['Boolean']>;
  includeStatuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  isModal?: InputMaybe<Scalars['Boolean']>;
  isToast?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetNotificationsByUserIdWithCountsQuery = { __typename?: 'query_root', getNotificationsByRequestUserIdWithCounts: { __typename?: 'GetUserNotificationsWithCounts', unreadCount: number, total: number, notifications: Array<{ __typename?: 'NotificationOutput', activity_type?: string | null, created_at: string, data?: any | null, has_priority: boolean, id: string, status: string, is_admin_notification: boolean, user_communication_delivery_id: number }> } };

export type NotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesQuery = { __typename?: 'query_root', notificationPreferences: { __typename?: 'NotificationPreferencesOutput', preferences: Array<{ __typename?: 'NotificationCategoryPreferenceOutput', category: NotificationSettingsCategory, channels: { __typename?: 'NotificationChannelPreferencesOutput', email: boolean, push: boolean } }> } };

export type SignupProviderMutationVariables = Exact<{
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  firebaseToken?: InputMaybe<Scalars['String']>;
}>;


export type SignupProviderMutation = { __typename?: 'mutation_root', SignupProvider?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type CreateScheduledAppointmentMutationVariables = Exact<{
  datetime: Scalars['String'];
  calendarId: Scalars['Int'];
  appointmentTypeId: Scalars['Int'];
  promoCode?: InputMaybe<Scalars['String']>;
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  appointmentData: CreateFhirAppointmentInputWithoutPatientCodexId;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
}>;


export type CreateScheduledAppointmentMutation = { __typename?: 'mutation_root', createScheduledAppointment: { __typename?: 'CreateScheduleAppointmentOutput', paymentLink: string, stripeRedirectedLink: string } };

export type RegisterPatchProviderMutationVariables = Exact<{
  providerData?: InputMaybe<ProviderRegisterPatchInput>;
}>;


export type RegisterPatchProviderMutation = { __typename?: 'mutation_root', RegisterPatchProvider?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type CreateCalendarAndDefineRegularHoursMutationVariables = Exact<{
  input: CreateCalendarAndDefineRegularHoursInput;
}>;


export type CreateCalendarAndDefineRegularHoursMutation = { __typename?: 'mutation_root', CreateCalendarAndDefineRegularHours?: { __typename?: 'UpdateCalendarRegularHoursResponse', Monday: Array<string>, Tuesday: Array<string>, Wednesday: Array<string>, Thursday: Array<string>, Friday: Array<string>, Saturday: Array<string>, Sunday: Array<string> } | null };

export type UpdateCalendarRegularHoursMutationVariables = Exact<{
  input: UpdateCalendarRegularHoursInput;
}>;


export type UpdateCalendarRegularHoursMutation = { __typename?: 'mutation_root', UpdateCalendarRegularHours?: { __typename?: 'UpdateCalendarRegularHoursResponse', Monday: Array<string>, Tuesday: Array<string>, Wednesday: Array<string>, Thursday: Array<string>, Friday: Array<string>, Saturday: Array<string>, Sunday: Array<string> } | null };

export type DisconnectStripeAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectStripeAccountMutation = { __typename?: 'mutation_root', DisconnectStripeAccount?: { __typename?: 'DisconnectStripeAccountOutput', status: number } | null };

export type CloseProviderAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CloseProviderAccountMutation = { __typename?: 'mutation_root', closeProviderAccount: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } };

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename?: 'mutation_root', cancelSubscription: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type ExportProviderDataMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportProviderDataMutation = { __typename?: 'mutation_root', ExportProviderData?: { __typename?: 'ExportUserDataOutput', downloadUrl: string } | null };

export type PrescribeVeradigmMutationVariables = Exact<{
  patientCodexId?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<EPrescribeSsoMode>;
}>;


export type PrescribeVeradigmMutation = { __typename?: 'mutation_root', ePrescribeJwt: { __typename?: 'EPrescribeIframeJWTOutput', jwt: string } };

export type SyncEPrescribeMedicationsByPatientMutationVariables = Exact<{
  patientCodexId: Scalars['String'];
  providerCodexId?: InputMaybe<Scalars['String']>;
  appointmentCodexId?: InputMaybe<Scalars['String']>;
}>;


export type SyncEPrescribeMedicationsByPatientMutation = { __typename?: 'mutation_root', syncEPrescribeMedicationsByPatient: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type UpdateBecomePatientRequestStatusMutationVariables = Exact<{
  requestStatus: ProviderRequestStatus;
  patientFhirId: Scalars['String'];
}>;


export type UpdateBecomePatientRequestStatusMutation = { __typename?: 'mutation_root', updateBecomePatientRequestStatus: { __typename?: 'PatchFHIRRequestBecomePatientOutput', requestStatus: ProviderRequestStatus } };

export type GetDosespotExternalUnreadNotificationQueryVariables = Exact<{
  codexProviderId: Scalars['uuid'];
}>;


export type GetDosespotExternalUnreadNotificationQuery = { __typename?: 'query_root', provider_unread_external_notification_counts: Array<{ __typename?: 'provider_unread_external_notification_counts', dosespot_unread_notifications: any }> };

export type ValidateNpiQueryVariables = Exact<{
  npiNumber?: InputMaybe<Scalars['String']>;
}>;


export type ValidateNpiQuery = { __typename?: 'query_root', ValidateNpiNumber?: { __typename?: 'IsNpiValid', isValid: boolean } | null };

export type GetAppointmentSummaryQueryVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type GetAppointmentSummaryQuery = { __typename?: 'query_root', getAppointmentSummary: { __typename?: 'VonageSummaryOutput', summaryPdfFileId?: string | null, summary?: string | null, transcription?: string | null } };

export type GetBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingInfoQuery = { __typename?: 'query_root', getProviderBilling: { __typename?: 'ProviderBillingOutput', id: number, previous_week_payout?: number | null, previous_week_refund?: number | null, reserved_balance: number, upcoming_payment: number, total_payouts: number, provider_id: string } };

export type GetFilesByRequestUserCodexIdByProviderQueryVariables = Exact<{
  sourceTypes?: InputMaybe<Array<MediaFileSourceType> | MediaFileSourceType>;
  patientCodexId?: Scalars['String'];
  limit?: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  dates?: InputMaybe<DateFilterArgs>;
}>;


export type GetFilesByRequestUserCodexIdByProviderQuery = { __typename?: 'query_root', getFilesByRequestUserCodexId: { __typename?: 'GetMediaFilesOutput', total: number, files: Array<{ __typename?: 'MediaFileOutput', fileId?: string | null, fileName?: string | null, url?: string | null, contentType?: string | null, size?: number | null, sourceType?: MediaFileSourceType | null, creation?: string | null, authorCodexId?: string | null, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_lastname?: string | null, SENSITIVE_firstname?: string | null, id: string } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_lastname: string, SENSITIVE_firstname: string, id: string } | null }> } };

export type EPrescribeMyTasksCountQueryVariables = Exact<{ [key: string]: never; }>;


export type EPrescribeMyTasksCountQuery = { __typename?: 'query_root', ePrescribeMyTasksCount: { __typename?: 'TotalOutput', total: number } };

export type GetProviderPayoutTransactionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetProviderPayoutTransactionsQuery = { __typename?: 'query_root', getProviderPayoutTransactions: { __typename?: 'ProviderPayoutsOutput', total: number, payouts: Array<{ __typename?: 'ProviderPayoutOutput', appointment_id?: string | null, appointments_total: number, category: number, created_at: string, id: number, invoice_number?: string | null, paid_at?: string | null, service_fee: number, service_total: number, status: number, stripe_fee: number, stripe_net_amount?: number | null, stripe_payment_amount?: number | null, stripe_processing_fee?: number | null, subscription_id?: number | null, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_email?: string | null, id: string } | null }> } };

export type GetProviderPayoutDetailsQueryVariables = Exact<{
  appointmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentTransactionId?: InputMaybe<Scalars['Int']>;
}>;


export type GetProviderPayoutDetailsQuery = { __typename?: 'query_root', getProviderPayoutDetails: { __typename?: 'GetFHIRAppointmentsOutput', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', acuityId?: string | null, appointmentCodexId: string, codexPatientId: string, codexProviderId?: string | null, created: string, patientFirstName?: string | null, patientLastName?: string | null, end?: string | null, start?: string | null, status: string, appointmentType?: AppointmentTypeEnum | null, appointmentStatus?: number | null, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, balanceImpact?: number | null } | null }> } };

export type GetBecomePatientRequestsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<ProviderRequestStatus> | ProviderRequestStatus>;
}>;


export type GetBecomePatientRequestsQuery = { __typename?: 'query_root', getBecomePatientRequests: { __typename?: 'BecomePatientRequestsOutput', serverNow: string, total: number, items: Array<{ __typename?: 'BecomePatientRequestItem', date: string, requestStatus: ProviderRequestStatus, patient: { __typename?: 'GetPatientOutput', SENSITIVE_country?: string | null, SENSITIVE_dob?: string | null, SENSITIVE_email?: string | null, SENSITIVE_etnicity?: Array<string> | null, SENSITIVE_firstname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_gender_describe?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, id: string, SENSITIVE_profile_picture_id?: string | null, parentCodexId?: string | null, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', state?: string | null, country?: string | null } | null, identifiers?: { __typename?: 'PatientIdentifiersOutput', fhirId?: string | null, codexId?: string | null } | null }, parent?: { __typename?: 'GetPatientOutput', autonomy_determination_status?: AutonomyDeterminationStatus | null, SENSITIVE_dob?: string | null, SENSITIVE_country?: string | null, SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_profile_picture_id?: string | null, id: string, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', state?: string | null, country?: string | null } | null } | null }> } };

export type AppointmentThirdPartySubscriptionVariables = Exact<{
  appointmentId: Scalars['uuid'];
}>;


export type AppointmentThirdPartySubscription = { __typename?: 'subscription_root', appointments: Array<{ __typename?: 'appointments', id: any, is_message_list_ready: boolean, is_prescription_ready: boolean, is_transcription_ready: boolean }> };

export type SummaryNotificationsSubscriptionVariables = Exact<{
  userId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SummaryNotificationsSubscription = { __typename?: 'subscription_root', appointments: Array<{ __typename?: 'appointments', id: any, createdAt: any, appointment_date?: any | null, status: number, provider_full_name?: string | null, is_test_kit_appointment: boolean }> };

export type SaveQuestionnaireMutationVariables = Exact<{
  questionnaireId: Scalars['Int'];
  responses: Scalars['jsonb'];
  is_complete?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveQuestionnaireMutation = { __typename?: 'mutation_root', SaveQuestionnaire?: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } | null };

export type SaveQuestionnaireManuallyMutationVariables = Exact<{
  questionnaireId: Scalars['Int'];
  userID: Scalars['uuid'];
  responses: Scalars['jsonb'];
  isComplete: Scalars['Boolean'];
}>;


export type SaveQuestionnaireManuallyMutation = { __typename?: 'mutation_root', insert_questionnaire_responses_one?: { __typename?: 'questionnaire_responses', id: any, responses: any } | null };

export type UpdateQuestionnaireMutationVariables = Exact<{
  questionnaireId: Scalars['Int'];
  responses: Scalars['jsonb'];
}>;


export type UpdateQuestionnaireMutation = { __typename?: 'mutation_root', UpdateQuestionnaire?: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } | null };

export type UpdateUserQuestionnaireResponseMutationVariables = Exact<{
  newResponse: Scalars['jsonb'];
  userID: Scalars['uuid'];
  questionnaireID: Scalars['Int'];
  is_complete?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateUserQuestionnaireResponseMutation = { __typename?: 'mutation_root', update_questionnaire_responses?: { __typename?: 'questionnaire_responses_mutation_response', returning: Array<{ __typename?: 'questionnaire_responses', responses: any }> } | null };

export type UpdateUserLatestQuestionnaireMutationVariables = Exact<{
  id: Scalars['bigint'];
  responses: Scalars['jsonb'];
  isComplete: Scalars['Boolean'];
}>;


export type UpdateUserLatestQuestionnaireMutation = { __typename?: 'mutation_root', update_questionnaire_responses?: { __typename?: 'questionnaire_responses_mutation_response', affected_rows: number } | null };

export type UpdateSelfReportedMedicationMutationVariables = Exact<{
  medications?: InputMaybe<Array<SelfReportedMedicationInput> | SelfReportedMedicationInput>;
}>;


export type UpdateSelfReportedMedicationMutation = { __typename?: 'mutation_root', updateSelfReportedMedication: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetQuestionnaireByIdQueryVariables = Exact<{
  questionnaire_id: Scalars['Int'];
}>;


export type GetQuestionnaireByIdQuery = { __typename?: 'query_root', questionnaires: Array<{ __typename?: 'questionnaires', title: string, subtitle?: string | null, data: any, questionnaires_questionnaire_questions: Array<{ __typename?: 'questionnaire_questions', questionnaire_questions_question: { __typename?: 'questions', id: number, text?: string | null, subtitle?: string | null, answers?: Array<string> | null, ui_control: Question_Ui_Control_Types_Enum, dont_know_answer?: string | null, double_text_combo_helper_texts?: any | null, dropdown_combo_answers?: any | null, dropdown_label_1?: string | null, dropdown_label_2?: string | null, measurement_unit?: Question_Measurement_Units_Enum | null, response_property?: string | null } }> }> };

export type GetQuestionnaireByUserIdAndQuestionnaireIdQueryVariables = Exact<{
  user_id: Scalars['uuid'];
  questionnaire_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetQuestionnaireByUserIdAndQuestionnaireIdQuery = { __typename?: 'query_root', questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', is_complete: boolean }> };

export type GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryVariables = Exact<{
  questionnaire_id: Scalars['Int'];
  user_id: Scalars['uuid'];
}>;


export type GetQuestionnaireResponsesByUserAndQuestionnaireIdQuery = { __typename?: 'query_root', questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', responses: any }> };

export type GetLatestQuestionnaireByIdQueryVariables = Exact<{
  questionnaire_id: Scalars['Int'];
}>;


export type GetLatestQuestionnaireByIdQuery = { __typename?: 'query_root', questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', responses: any, id: any }> };

export type UploadCapturedImageMutationVariables = Exact<{
  image: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type UploadCapturedImageMutation = { __typename?: 'mutation_root', UploadCapturedImage?: { __typename?: 'SuccessfulUploadedImage', sessionId: string, message: string, status: number } | null };

export type GetFileUrlFromStorageMutationVariables = Exact<{
  fileId: Scalars['String'];
}>;


export type GetFileUrlFromStorageMutation = { __typename?: 'mutation_root', GetSignUrlFormStorage?: { __typename?: 'SuccessGetSignUrlFormStorage', url: string, status: number } | null };

export type GetSkintellingentTestByUserIdQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['timestamptz']>;
  toDate?: InputMaybe<Scalars['timestamptz']>;
  orderBy?: InputMaybe<Array<Skintelligent_Tests_Order_By> | Skintelligent_Tests_Order_By>;
}>;


export type GetSkintellingentTestByUserIdQuery = { __typename?: 'query_root', skintelligent_tests: Array<{ __typename?: 'skintelligent_tests', test_id: any, inflammatory?: number | null, comedone?: number | null, pih?: number | null, total_lesions?: number | null, report_id?: any | null, result_image_id?: any | null, skintelligent_tests_test: { __typename?: 'tests', created_at: any }, skintelligent_tests_image_source_type?: { __typename?: 'image_source_types', value: string } | null }>, skintelligent_tests_aggregate: { __typename?: 'skintelligent_tests_aggregate', aggregate?: { __typename?: 'skintelligent_tests_aggregate_fields', count: number } | null } };

export type GetSkintellingentTestsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkintellingentTestsCountQuery = { __typename?: 'query_root', skintelligent_tests_aggregate: { __typename?: 'skintelligent_tests_aggregate', aggregate?: { __typename?: 'skintelligent_tests_aggregate_fields', count: number } | null } };

export type GetMedicationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMedicationsQuery = { __typename?: 'query_root', getMedications: { __typename?: 'MedicationsOutput', medications: Array<{ __typename?: 'MedicationOutput', activeIngredUnit?: string | null, activeNumeratorStrength?: string | null, productId?: string | null, id: string, productNdc?: string | null, proprietaryName?: string | null }> } };

export type GetSkintellingentTestBySessionIdSubscriptionVariables = Exact<{
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type GetSkintellingentTestBySessionIdSubscription = { __typename?: 'subscription_root', skintelligent_tests: Array<{ __typename?: 'skintelligent_tests', test_id: any, session_id: string, result_image_id?: any | null, report_id?: any | null, pih?: number | null, overall_score?: any | null, inflammatory?: number | null, image_source?: Image_Source_Types_Enum | null, errors?: any | null, comedone?: number | null, total_lesions?: number | null, result_processed?: boolean | null, skintelligent_tests_image_source_type?: { __typename?: 'image_source_types', value: string, comment?: string | null } | null, skintelligent_tests_test: { __typename?: 'tests', created_at: any }, skintelligent_tests_result_image?: { __typename?: 'files', id: any, type: File_Types_Enum } | null }> };

export type GetSkintellingentTestsByUserIdSubscriptionVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetSkintellingentTestsByUserIdSubscription = { __typename?: 'subscription_root', skintelligent_tests_aggregate: { __typename?: 'skintelligent_tests_aggregate', nodes: Array<{ __typename?: 'skintelligent_tests', session_id: string }> } };

export type CreateSubscriptionMethodMutationVariables = Exact<{
  paymentMethodName?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type CreateSubscriptionMethodMutation = { __typename?: 'mutation_root', createSubscription: { __typename?: 'SubscriptionOutput', currentPeriodEnd?: string | null, currentPeriodStart?: string | null, id: number, status: CodexSubscriptionStatuses, billingPlan: { __typename?: 'BillingPlan', amount: number, name: string, currency: string }, paymentIntent?: { __typename?: 'PaymentIntentOutput', clientSecret?: string | null, status: string, stripePaymentIntent: string } | null } };

export type AttachPaymentMethodMutationVariables = Exact<{
  paymentMethodName?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type AttachPaymentMethodMutation = { __typename?: 'mutation_root', attachPaymentMethod: { __typename?: 'PaymentMethodOutput', id: number } };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['Int'];
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'mutation_root', setDefaultPaymentMethod: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetClientSecretMutationVariables = Exact<{ [key: string]: never; }>;


export type GetClientSecretMutation = { __typename?: 'mutation_root', createProviderSetupIntent: { __typename?: 'SetupIntentOutput', clientSecret?: string | null } };

export type RefundPaymentTransactionMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type RefundPaymentTransactionMutation = { __typename?: 'mutation_root', refundPaymentTransaction: { __typename?: 'PaymentTransactionOutput', id: number, order_ids?: Array<number> | null } };

export type DeletePaymentMethodMutationVariables = Exact<{
  paymentMethodCodexId: Scalars['Int'];
}>;


export type DeletePaymentMethodMutation = { __typename?: 'mutation_root', deletePaymentMethod: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetPaymentMethodListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodListQuery = { __typename?: 'query_root', getPaymentMethodList: { __typename?: 'PaymentMethodsOutput', total: number, paymentMethods: Array<{ __typename?: 'PaymentMethodOutput', brand?: string | null, created_at: string, last4?: string | null, name?: string | null, stripeId: string, updated_at: string, isDefault: boolean, expirationYear?: number | null, expirationMonth?: number | null, id: number }> } };

export type GetStripeSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripeSubscriptionsQuery = { __typename?: 'query_root', stripe_subscriptions: Array<{ __typename?: 'stripe_subscriptions', id: number, customer_id: number, payment_method_id?: number | null, status: number, current_period_end?: any | null, cancelled_at?: any | null, billing_plan_id: number, stripe_billing_plan: { __typename?: 'stripe_billing_plans', amount_cents: number, created_at: any, currency: string, id: number, interval: string, interval_count: number, name: string, trial_period_days?: number | null, updated_at: any } }> };

export type GetProviderPaymentDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderPaymentDetailsQuery = { __typename?: 'query_root', getProviderPaymentDetails: { __typename?: 'GetProviderPaymentDetailsOutput', amount: number, lastPaymentAt?: string | null } };

export type GetMyBillingPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyBillingPlanQuery = { __typename?: 'query_root', getMyBillingPlan: { __typename?: 'BillingPlan', amount: number, currency: string } };

export type GetDiscountCodeQueryVariables = Exact<{
  promoCode?: InputMaybe<Scalars['String']>;
}>;


export type GetDiscountCodeQuery = { __typename?: 'query_root', getDiscountCode: { __typename?: 'DiscountOutput', amountOff?: number | null, percentOff?: number | null } };

export type GetSubscriptionBillingHistoryQueryVariables = Exact<{
  invoiceNumber?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetSubscriptionBillingHistoryQuery = { __typename?: 'query_root', getSubscriptionBillingHistory: { __typename?: 'PaymentTransactionListOutput', total: number, transactions: Array<{ __typename?: 'PaymentTransactionOutput', invoice_number?: string | null, category: number, created_at: string, id: number, paid_at?: string | null, payment_provider?: PaymentProviderEnum | null, status: number, total: number, stripe_payment_amount?: number | null, stripe_net_amount?: number | null, stripe_fee: number, subscription?: { __typename?: 'SubscriptionOutput', id: number, currentPeriodEnd?: string | null, currentPeriodStart?: string | null, status: CodexSubscriptionStatuses } | null }> } };

export type UpdateProviderApprovalMutationVariables = Exact<{
  codexId: Scalars['String'];
  approved: Scalars['Boolean'];
}>;


export type UpdateProviderApprovalMutation = { __typename?: 'mutation_root', patchCodexApproval: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', codex_approved: boolean } } };

export type PatchFhirProviderMutationVariables = Exact<{
  codexId: Scalars['String'];
  input: PatchFhirProviderInput;
}>;


export type PatchFhirProviderMutation = { __typename?: 'mutation_root', saPatchFHIRProvider: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', id: string } } };

export type ArchiveOrderMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ArchiveOrderMutation = { __typename?: 'mutation_root', archiveOrder: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type UpdateOrderStatusMutationVariables = Exact<{
  orderId: Scalars['Int'];
  status: OrderStatusEnum;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'mutation_root', updateOrderStatus: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type AddSwabCodesMutationVariables = Exact<{
  swabCodes?: InputMaybe<Array<AddSwabCodeInput> | AddSwabCodeInput>;
}>;


export type AddSwabCodesMutation = { __typename?: 'mutation_root', AddSwabCodes?: { __typename?: 'AddSwabCodesOutput', existingSwabCodes: Array<string>, invalidSwabCodesDueSomeIssue: Array<string>, invalidSwabCodesDueToTypes: Array<string>, totalAdded: number } | null };

export type SignupDelegatedAdminMutationVariables = Exact<{
  firebaseToken?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
}>;


export type SignupDelegatedAdminMutation = { __typename?: 'mutation_root', SignupDelegatedAdmin?: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } | null };

export type CreateDelegatedAdminMutationVariables = Exact<{
  permissions: Array<AdminPermissionType> | AdminPermissionType;
  email?: InputMaybe<Scalars['String']>;
}>;


export type CreateDelegatedAdminMutation = { __typename?: 'mutation_root', createDelegatedAdminInvitation: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type UpdateDelegatedAdminMutationVariables = Exact<{
  permissions: Array<AdminPermissionType> | AdminPermissionType;
  id: Scalars['String'];
}>;


export type UpdateDelegatedAdminMutation = { __typename?: 'mutation_root', updateDelegatedAdminPermissions: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type ResendDelegatedAdminInvitationMutationVariables = Exact<{
  delegatedAdminCodexId?: InputMaybe<Scalars['String']>;
}>;


export type ResendDelegatedAdminInvitationMutation = { __typename?: 'mutation_root', resendDelegatedAdminInvitation: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type DeleteDelegatedAdminMutationVariables = Exact<{
  delegatedAdminCodexId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteDelegatedAdminMutation = { __typename?: 'mutation_root', deleteDelegatedAdmin: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type UpdateProductAvailabilityMutationVariables = Exact<{
  inStock: Scalars['Boolean'];
  id: Scalars['Int'];
}>;


export type UpdateProductAvailabilityMutation = { __typename?: 'mutation_root', updateProductAvailability: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type SyncShipMonkMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncShipMonkMutation = { __typename?: 'mutation_root', syncShipMonkProducts: { __typename?: 'HttpStatusOutput', message?: string | null } };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteProductMutation = { __typename?: 'mutation_root', deleteProduct: { __typename?: 'HttpStatusOutput', message?: string | null } };

export type UpdateProductByAdminMutationVariables = Exact<{
  inStock: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  defaultFileId: Scalars['String'];
  price?: InputMaybe<Scalars['Float']>;
  providerPrice?: InputMaybe<Scalars['Float']>;
  madeIn?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  contents?: InputMaybe<Scalars['String']>;
  category: Scalars['Int'];
}>;


export type UpdateProductByAdminMutation = { __typename?: 'mutation_root', updateProduct: { __typename?: 'ProductOutput', id: number, updated_at: string } };

export type SendSupportMessageMutationVariables = Exact<{
  inMailId: Scalars['String'];
  text: Scalars['String'];
  attachments?: InputMaybe<Array<FileAttachmentInput> | FileAttachmentInput>;
}>;


export type SendSupportMessageMutation = { __typename?: 'mutation_root', sendSupportMessage: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetDiagnosticReportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  patientFhirId?: InputMaybe<Scalars['String']>;
  providerFhirId?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetDiagnosticReportsQuery = { __typename?: 'query_root', getDiagnosticReports: { __typename?: 'SADiagnosticReports', count: number, total: number, nextPageToken?: string | null, prevPageToken?: string | null, reports: Array<{ __typename?: 'SADiagnosticReport', dates: Array<Array<string>>, type: Hasura_Test_Types_Enum, identifiers: Array<Array<string>>, status: string, flags: Array<CodexTags>, patient?: { __typename?: 'SAPerson', identifiers: Array<Array<string>>, first: string, last: string } | null, provider?: { __typename?: 'SAPerson', identifiers: Array<Array<string>>, first: string, last: string } | null, appointment?: { __typename?: 'SAAppointmentOutput', appointmentId: string, end?: string | null, start?: string | null, created?: string | null, lastUpdate?: string | null } | null }> } };

export type GetAppointmentsQueryVariables = Exact<{
  patientFhirId?: InputMaybe<Scalars['String']>;
  providerFhirId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<SaAppointmentOrderBy>;
  types?: InputMaybe<Array<AppointmentTypeEnum> | AppointmentTypeEnum>;
  toDate?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentsQuery = { __typename?: 'query_root', getAppointments: { __typename?: 'SAAppointments', count: number, total: number, nextPageToken?: string | null, prevPageToken?: string | null, appointments: Array<{ __typename?: 'SAAppointment', identifiers: Array<Array<string>>, type?: AppointmentTypeEnum | null, dates: Array<Array<string>>, status: string, logs: Array<Array<string>>, patient?: { __typename?: 'SAPerson', identifiers: Array<Array<string>>, first: string, last: string } | null, provider?: { __typename?: 'SAPerson', identifiers: Array<Array<string>>, first: string, last: string } | null }> } };

export type GetPatientsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  providerCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  assignedAtFrom?: InputMaybe<Scalars['String']>;
  assignedAtTo?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SaPatientOrderBy>;
  pageToken?: InputMaybe<Scalars['String']>;
}>;


export type GetPatientsQuery = { __typename?: 'query_root', getPatients: { __typename?: 'SAPatients', count: number, nextPageToken?: string | null, prevPageToken?: string | null, total: number, patients: Array<{ __typename?: 'SAPatient', dates: Array<Array<string>>, flags: Array<CodexTags>, assignedAt?: string | null, birthDate?: string | null, gender?: string | null, profilePhoto?: string | null, appointmentCount: Array<Array<string>>, testKitCount: number, parentCodexId?: string | null, phone?: string | null, email?: string | null, identifiers: Array<Array<string>>, first: string, last: string, nextAppointment?: { __typename?: 'SAAppointmentBrief', identifiers: Array<Array<string>>, flags: Array<CodexTags>, dates: Array<Array<string>> } | null }> } };

export type GetProvidersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<SaProviderOrderBy>;
}>;


export type GetProvidersQuery = { __typename?: 'query_root', getProviders: { __typename?: 'SAProviders', count: number, nextPageToken?: string | null, prevPageToken?: string | null, total: number, providers: Array<{ __typename?: 'SAProvider', appointmentCount: Array<Array<string>>, birthDate?: string | null, dates: Array<Array<string>>, email?: string | null, first: string, flags: Array<CodexTags>, identifiers: Array<Array<string>>, gender?: string | null, last: string, patientCount: number, phone?: string | null, profilePhoto?: string | null, providerOutput?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, SENSITIVE_phone: string, SENSITIVE_national_provider_identifier: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_dob?: string | null, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', certifications: Array<string>, stateLicenses?: Array<{ __typename?: 'ProviderStateLicenseOutput', licenseNumber: string, state: string, expirationDate: string }> | null }, SENSITIVE_address_information?: { __typename?: 'AddressInformationOutput', state?: string | null, zipCode?: string | null, address1?: string | null } | null } | null, statuses: { __typename?: 'SAProviderStatuses', BAA?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, HIPAA?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, fullScriptAccount?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, personaId?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, personaInsurance?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, stripeAccount?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null } }> } };

export type GetOrdersQueryVariables = Exact<{
  to?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<OrderStatusEnum> | OrderStatusEnum>;
  patientQuery?: InputMaybe<Scalars['String']>;
  idQuery?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<OrdersOrderByCriterias>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrdersQuery = { __typename?: 'query_root', getOrders: { __typename?: 'OrderListOutput', total: number, orders: Array<{ __typename?: 'OrderOutput', created_at: string, delivery_address_id: number, delivery_date?: string | null, id: number, is_archived?: boolean | null, shipping_cost: number, status?: number | null, subtotal_amount: number, tax_amount: number, total_amount: number, tracking_number?: string | null, updated_at: string, user_id: string, delivery_address?: { __typename?: 'DeliveryAddressOutput', address1: string, address2?: string | null, city: string, country: string, created_at: string, id: number, is_deleted: boolean, phone: string, state: string, updated_at: string, user_id: string, zip_code: string } | null, order_products?: Array<{ __typename?: 'OrderProductOutput', created_at: string, id: number, order_id: number, product_id: number, quantity: number, updated_at: string, provider?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, SENSITIVE_lastname: string, SENSITIVE_firstname: string, id: string, acuityCalendarId?: string | null, acuityOwnerId?: string | null, fullscriptId?: string | null, ePrescribeUserId?: string | null, identifiers?: { __typename?: 'ProviderIdentifiersOutput', patientRequestsListId?: string | null, mosaicId?: string | null, fullscriptId?: string | null, fhirId: string, codexId?: string | null, acuityOwnerId?: string | null, acuityCalendarId?: string | null } | null } | null, product?: { __typename?: 'Product', aeromed_number?: string | null, is_shipmonk_active: boolean, contents?: string | null, created_at: string, description?: string | null, expiration_period?: number | null, id: number, image_url?: string | null, in_stock: boolean, made_in?: string | null, po_number?: number | null, price?: number | null, quantity: number, short_description?: string | null, title: string, updated_at: string } | null }> | null, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, id: string, parentCodexId?: string | null, sapphirosId?: string | null, identifiers?: { __typename?: 'PatientIdentifiersOutput', acuityCalendar?: string | null, acuityId?: string | null, acuityOwner?: string | null, codexId?: string | null, fhirId?: string | null, mosaicId?: string | null, sapphirosId?: string | null } | null } | null }> } };

export type GetOrderByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetOrderByIdQuery = { __typename?: 'query_root', getOrderById: { __typename?: 'OrderOutput', created_at: string, id: number, delivery_date?: string | null, is_archived?: boolean | null, status?: number | null, subtotal_amount: number, shipping_cost: number, tracking_number?: string | null, total_amount: number, tax_amount: number, statusHistory: Array<{ __typename?: 'OrderStatusHistoryEntry', status: OrderStatusEnum, datetime: string }>, delivery_address?: { __typename?: 'DeliveryAddressOutput', address1: string, address2?: string | null, city: string, country: string, phone: string, state: string, zip_code: string } | null, order_products?: Array<{ __typename?: 'OrderProductOutput', quantity: number, product_id: number, owner_id: string, product?: { __typename?: 'Product', aeromed_number?: string | null, is_shipmonk_active: boolean, contents?: string | null, created_at: string, description?: string | null, expiration_period?: number | null, in_stock: boolean, price?: number | null, quantity: number, title: string } | null, patientOwner?: { __typename?: 'GetPatientOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_email?: string | null, parentCodexId?: string | null, identifiers?: { __typename?: 'PatientIdentifiersOutput', codexId?: string | null, fhirId?: string | null, mosaicId?: string | null } | null } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_email: string, id: string, identifiers?: { __typename?: 'ProviderIdentifiersOutput', acuityCalendarId?: string | null, acuityOwnerId?: string | null, codexId?: string | null, ePrescribeUserId?: string | null, fhirId: string, fullscriptId?: string | null, mosaicId?: string | null, patientRequestsListId?: string | null } | null } | null }> | null, patient?: { __typename?: 'GetPatientOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_email?: string | null, identifiers?: { __typename?: 'PatientIdentifiersOutput', codexId?: string | null, fhirId?: string | null, mosaicId?: string | null } | null } | null, provider?: { __typename?: 'ProviderOutput', id: string, SENSITIVE_firstname: string, SENSITIVE_email: string, SENSITIVE_lastname: string } | null, payment?: { __typename?: 'PaymentTransactionLiteOutput', appointment_id?: string | null, category: number, id: number, order_ids?: Array<number> | null, paid_at?: string | null, patient_id?: string | null, payer_role: number, service_fee: number, service_total: number, status: number, total: number, transaction_type: number, stripe_net_amount?: number | null, stripe_fee: number, stripe_payment_amount?: number | null, stripe_processing_fee?: number | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, percentOff?: number | null, code?: string | null } | null } | null } };

export type GetAvailableSwabCodesQueryVariables = Exact<{
  to?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<Hasura_Test_Types_Enum> | Hasura_Test_Types_Enum>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAvailableSwabCodesQuery = { __typename?: 'query_root', getSwabCodes: { __typename?: 'SwabCodeListOutput', total: number, swab_codes: Array<{ __typename?: 'SwabCodeOutput', created_at: string, id: number, lab_name: string, status: string, swab_code: string, swab_usage_type: string, test_type: string, swab_codes_test?: Array<{ __typename?: 'SwabCodeTestOutput', created_at: string, state: string, test_id: string, user_id: string }> | null }> } };

export type GetPaymentTransactionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<PaymentTransactionOrderByCriterias>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  userCodexId?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  discountApplied?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<PaymentTransactionStatusEnum> | PaymentTransactionStatusEnum>;
  types?: InputMaybe<Array<PaymentTransactionPaymentTypeEnum> | PaymentTransactionPaymentTypeEnum>;
  categories?: InputMaybe<Array<PaymentTransactionPaymentCategoryEnum> | PaymentTransactionPaymentCategoryEnum>;
}>;


export type GetPaymentTransactionsQuery = { __typename?: 'query_root', getPaymentTransactions: { __typename?: 'PaymentTransactionListOutput', total: number, transactions: Array<{ __typename?: 'PaymentTransactionOutput', appointment_id?: string | null, category: number, created_at: string, order_ids?: Array<number> | null, id: number, invoice_number?: string | null, paid_at?: string | null, payer_role: number, patient_id?: string | null, provider_id?: string | null, service_fee: number, service_total: number, status: number, stripe_fee: number, total: number, transaction_type: number, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_email?: string | null, id: string, created_at: string, updated_at: string } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, id: string } | null }> } };

export type GetPaymentTransactionByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPaymentTransactionByIdQuery = { __typename?: 'query_root', getPaymentTransactionById: { __typename?: 'PaymentTransactionOutput', appointment_id?: string | null, category: number, created_at: string, updated_at: string, id: number, order_ids?: Array<number> | null, paid_at?: string | null, payer_role: number, service_fee: number, service_total: number, status: number, stripe_fee: number, subscription_id?: number | null, total: number, transaction_type: number, appointment?: { __typename?: 'GetAppointmentOutput', created: string, start?: string | null, status: string, appointmentStatus?: number | null, appointmentCodexId: string, appointmentId: string, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, code?: string | null, percentOff?: number | null } | null } | null } | null, discount?: { __typename?: 'DiscountOutput', amountOff?: number | null, code?: string | null, percentOff?: number | null } | null, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, id: string, identifiers?: { __typename?: 'PatientIdentifiersOutput', codexId?: string | null, fhirId?: string | null, sapphirosId?: string | null } | null } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_phone: string, id: string, identifiers?: { __typename?: 'ProviderIdentifiersOutput', mosaicId?: string | null, fullscriptId?: string | null, fhirId: string, codexId?: string | null, acuityCalendarId?: string | null } | null } | null, weeklyPaymentDetails?: { __typename?: 'WeeklyPaymentDetailsOutput', periodEnd: string, periodStart: string, completedAppointments: number } | null, subscription?: { __typename?: 'SubscriptionOutput', status: CodexSubscriptionStatuses, id: number, currentPeriodStart?: string | null, currentPeriodEnd?: string | null } | null, orders?: Array<{ __typename?: 'OrderOutput', created_at: string, carrier?: string | null, id: number, shipping_cost: number, status?: number | null, subtotal_amount: number, tax_amount: number, total_amount: number, payment?: { __typename?: 'PaymentTransactionLiteOutput', appointment_id?: string | null, category: number, id: number, order_ids?: Array<number> | null, paid_at?: string | null, patient_id?: string | null, payer_role: number, service_fee: number, service_total: number, status: number, total: number, transaction_type: number, stripe_net_amount?: number | null, stripe_fee: number, stripe_payment_amount?: number | null, stripe_processing_fee?: number | null } | null, order_products?: Array<{ __typename?: 'OrderProductOutput', quantity: number, product_id: number, owner_id: string, product?: { __typename?: 'Product', aeromed_number?: string | null, is_shipmonk_active: boolean, contents?: string | null, created_at: string, description?: string | null, expiration_period?: number | null, in_stock: boolean, price?: number | null, quantity: number, title: string } | null, patientOwner?: { __typename?: 'GetPatientOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_email?: string | null, parentCodexId?: string | null, identifiers?: { __typename?: 'PatientIdentifiersOutput', codexId?: string | null, fhirId?: string | null, mosaicId?: string | null } | null } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_email: string, id: string, identifiers?: { __typename?: 'ProviderIdentifiersOutput', acuityCalendarId?: string | null, acuityOwnerId?: string | null, codexId?: string | null, ePrescribeUserId?: string | null, fhirId: string, fullscriptId?: string | null, mosaicId?: string | null, patientRequestsListId?: string | null } | null } | null }> | null, patient?: { __typename?: 'GetPatientOutput', id: string, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_email?: string | null, identifiers?: { __typename?: 'PatientIdentifiersOutput', codexId?: string | null, fhirId?: string | null, mosaicId?: string | null } | null } | null }> | null, related_payments?: Array<{ __typename?: 'PaymentTransactionOutput', appointment_id?: string | null, category: number, created_at: string, updated_at: string, id: number, order_ids?: Array<number> | null, paid_at?: string | null, payer_role: number, service_fee: number, service_total: number, status: number, stripe_fee: number, subscription_id?: number | null, total: number, transaction_type: number, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, id: string } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_phone: string, id: string } | null, weeklyPaymentDetails?: { __typename?: 'WeeklyPaymentDetailsOutput', periodEnd: string, periodStart: string, completedAppointments: number } | null }> | null } };

export type ValidateDelegatedAdminInvitationTokenQueryVariables = Exact<{
  token: Scalars['String'];
  email: Scalars['String'];
}>;


export type ValidateDelegatedAdminInvitationTokenQuery = { __typename?: 'query_root', validateDelegatedAdminInvitationToken: { __typename?: 'ValidateDelegatedAdminInvitationTokenOutput', isValid: boolean, email?: string | null } };

export type GetDelegatedAdminsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<DelegatedAdminOrderByCriterias>;
  search?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDelegatedAdminsQuery = { __typename?: 'query_root', getDelegatedAdmins: { __typename?: 'GetDelegatedAdminsOutput', total: number, delegatedAdmins: Array<{ __typename?: 'DelegatedAdmin', acceptedAt?: string | null, accountDeletedAt?: string | null, email: string, firstName?: string | null, id: string, invitationId: string, invitedAt?: string | null, lastName?: string | null }> } };

export type GetDelegatedAdminByIdQueryVariables = Exact<{
  delegatedAdminCodexId: Scalars['String'];
}>;


export type GetDelegatedAdminByIdQuery = { __typename?: 'query_root', getDelegatedAdminDetails: { __typename?: 'DelegatedAdminDetailsOutput', acceptedAt?: string | null, email: string, firstName?: string | null, invitationId: string, id: string, invitedAt?: string | null, lastName?: string | null, accountDeletedAt?: string | null, deletedByEmail?: string | null, permissions: Array<AdminPermissionType> } };

export type GetAdminAppointmentDetailsQueryVariables = Exact<{
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentFhirId?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminAppointmentDetailsQuery = { __typename?: 'query_root', getAppointmentDetails: { __typename?: 'SAAppointmentDetailsOutput', appointmentIds: Array<Array<string>>, appointmentStart?: string | null, createdAt?: string | null, appointmentStatus: number, status: string, transactionCategory: string, originalTransaction?: { __typename?: 'PaymentTransactionOutput', category: number, created_at: string, id: number, status: number, order_ids?: Array<number> | null, service_fee: number, service_total: number, stripe_fee: number, stripe_net_amount?: number | null, stripe_payment_amount?: number | null, stripe_processing_fee?: number | null, total: number, transaction_type: number, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, id: string } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_phone: string, id: string } | null } | null, refundTransactions: Array<{ __typename?: 'PaymentTransactionOutput', category: number, created_at: string, id: number, status: number, service_fee: number, service_total: number, stripe_fee: number, stripe_net_amount?: number | null, stripe_payment_amount?: number | null, stripe_processing_fee?: number | null, total: number, order_ids?: Array<number> | null, transaction_type: number, patient?: { __typename?: 'GetPatientOutput', SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, id: string } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_email: string, SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_phone: string, id: string } | null }>, patient?: { __typename?: 'SAPatient', first: string, email?: string | null, flags: Array<CodexTags>, identifiers: Array<Array<string>>, last: string, phone?: string | null, dates: Array<Array<string>>, appointmentCount: Array<Array<string>>, testKitCount: number } | null, statusHistory: Array<{ __typename?: 'AppointmentStatusHistoryEntry', datetime: string, status: AppointmentStatusHistoryEnum }>, provider?: { __typename?: 'SAProvider', dates: Array<Array<string>>, email?: string | null, first: string, flags: Array<CodexTags>, identifiers: Array<Array<string>>, appointmentCount: Array<Array<string>>, patientCount: number, last: string, phone?: string | null, statuses: { __typename?: 'SAProviderStatuses', BAA?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, HIPAA?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, fullScriptAccount?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, personaId?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, personaInsurance?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null, stripeAccount?: { __typename?: 'SAProviderStatus', status?: PersonaInquiryHasuraStatus | null, updatedAt?: string | null } | null } } | null } };

export type GetProductsQueryVariables = Exact<{
  inStock?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetProductsQuery = { __typename?: 'query_root', getProducts: { __typename?: 'GetProductsOutput', total: number, lastShipMonkSyncAt?: string | null, products: Array<{ __typename?: 'ProductOutput', aeromed_number?: string | null, category?: number | null, created_at: string, updated_at: string, description?: string | null, id: number, in_stock: boolean, is_shipmonk_active: boolean, provider_price?: number | null, price?: number | null, quantity: number, reserved_quantity: number, sku?: string | null, title: string }> } };

export type GetProductDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetProductDetailsQuery = { __typename?: 'query_root', getProductDetails: { __typename?: 'ProductOutput', aeromed_number?: string | null, description?: string | null, created_at: string, id: number, in_stock: boolean, is_shipmonk_active: boolean, is_shipmonk_deleted: boolean, po_number?: number | null, price?: number | null, quantity: number, short_description?: string | null, title: string, sku?: string | null, updated_at: string, category?: number | null, provider_price?: number | null, default_image_id?: string | null, image_ids?: Array<string> | null, specs?: { __typename?: 'Specs', contents?: string | null, expiration_period?: number | null, made_in?: string | null } | null } };

export type GetTestKitAdminDetailsQueryVariables = Exact<{
  swabcode: Scalars['String'];
}>;


export type GetTestKitAdminDetailsQuery = { __typename?: 'query_root', getTestKitDetails: { __typename?: 'TestKitDetailsOutput', codexId: string, fhirId: string, labOrderId?: string | null, questionnaireCompleted: boolean, status: Hasura_Dnavisit_Test_Statuses_Enum, swabCode?: string | null, trackingNumber?: string | null, type: Hasura_Test_Types_Enum, patient: { __typename?: 'TestKitDetailsParticipant', codexId?: string | null, email?: string | null, fhirId?: string | null, firstName: string, lastName: string }, provider?: { __typename?: 'TestKitDetailsParticipant', codexId?: string | null, email?: string | null, fhirId?: string | null, firstName: string, lastName: string } | null, statusHistory: Array<{ __typename?: 'TestKitStatusHistoryEntry', datetime: string, status: Hasura_Dnavisit_Test_Statuses_Enum }> } };

export type GetAppointmentStatsQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentStatsQuery = { __typename?: 'query_root', getAppointmentStats: Array<{ __typename?: 'AppointmentStatsByDayOutput', date: string, appointmentStats: { __typename?: 'AppointmentStatsOutput', total: number, breakdown: Array<{ __typename?: 'AppointmentStatsStatusItem', status: AppointmentStatsStatusEnum, total: number }> } }> };

export type GetOrderStatsQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type GetOrderStatsQuery = { __typename?: 'query_root', getOrderStats: Array<{ __typename?: 'OrderStatsByDayOutput', date: string, orderStats: { __typename?: 'OrderStatsOutput', total: number, breakdown: Array<{ __typename?: 'OrderStatsStatusItem', status: OrderStatusEnum, total: number }> } }> };

export type GetTestKitStatsQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<TestKitStatsFiltersInput>;
}>;


export type GetTestKitStatsQuery = { __typename?: 'query_root', getTestKitStats: Array<{ __typename?: 'TestKitStatsByDayOutput', date: string, testKitStats: { __typename?: 'TestKitStatsOutput', total: number, breakdown: Array<{ __typename?: 'TestKitStatsStatusItem', status: TestKitStatsStatusEnum, total: number }> } }> };

export type GetGeneralDashboardStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneralDashboardStatsQuery = { __typename?: 'query_root', getGeneralDashboardStats: { __typename?: 'SAGeneralDashboardStats', totalAppointments: number, totalPatients: number, totalProviders: number, totalRevenue: number, totalTestKits: number } };

export type GetUserRegistrationStatsQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type GetUserRegistrationStatsQuery = { __typename?: 'query_root', getUserRegistrationStats: Array<{ __typename?: 'UserRegistrationStatsByDayOutput', date: string, userRegistrationStats: { __typename?: 'UserRegistrationStatsOutput', totalAdultPatients: number, totalMinorPatients: number, totalPatients: number, totalProviders: number } }> };

export type GetPaymentStatsQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type GetPaymentStatsQuery = { __typename?: 'query_root', getPaymentStats: Array<{ __typename?: 'PaymentStatsByDayOutput', date: string, paymentStats: { __typename?: 'PaymentStatsOutput', refunds: number, paymentForOrders: number, paymentForAppointments: number, feeReceivedByCodex: number } }> };

export type GetUserActivityLogQueryVariables = Exact<{
  userCodexId: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserActivityLogQuery = { __typename?: 'query_root', getUserActivityLog: { __typename?: 'ActivityLogOutput', total: number, logs: Array<{ __typename?: 'ActivityLogItem', createdAt: string, eventType: ActivityEventType, id: string, metadata?: { __typename?: 'ActivityLogMetadata', agreementType?: UserAgreementTypes | null, appointment_id?: string | null, order_id?: number | null, swab_code?: string | null, test_type?: Hasura_Test_Types_Enum | null, admin?: { __typename?: 'SAPerson', email?: string | null, first: string, identifiers: Array<Array<string>>, last: string, dates: Array<Array<string>>, flags: Array<CodexTags> } | null, course?: { __typename?: 'EducationCourseListItemOutput', title: string, id: string, createdAt: string } | null, legalDocument?: { __typename?: 'LegalDocumentOutput', type: Hasura_Legal_Document_Types_Enum, updatedAt: string, updatedByFullName: string, version: number } | null, patient?: { __typename?: 'GetPatientOutput', id: string, SENSITIVE_lastname?: string | null, SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null } | null, product?: { __typename?: 'ProductOutput', category?: number | null, id: number, title: string, test_type?: Hasura_Test_Types_Enum | null } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_firstname: string, SENSITIVE_lastname: string, SENSITIVE_email: string, id: string } | null } | null }> } };

export type GetSupportChatDetailQueryVariables = Exact<{
  chatId?: InputMaybe<Scalars['String']>;
  pageToken?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetSupportChatDetailQuery = { __typename?: 'query_root', getSupportChatDetail: { __typename?: 'SupportChatDetailsOutput', createdAt?: string | null, id?: string | null, lastMessageAt?: string | null, nextPageToken?: string | null, read?: boolean | null, role: Roles_Enum, messages: Array<{ __typename?: 'InMailMessageOutput', date: string, senderCodexId: string, text?: string | null, attachments: Array<{ __typename?: 'Attachment', url?: string | null, title?: string | null, creation?: string | null, contentType?: ContentType | null, size?: number | null }> }>, usage?: { __typename?: 'InMailUsageOutput', updatedAt: string, used: number } | null, user: { __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string, profilePictureId?: string | null } } };

export type GetSupportChatsQueryVariables = Exact<{
  filter?: InputMaybe<GetSupportChatsInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetSupportChatsQuery = { __typename?: 'query_root', getSupportChats: { __typename?: 'SupportChatsOutput', newTotal: number, total: number, chats: Array<{ __typename?: 'SupportChatPreviewOutput', createdAt?: string | null, id?: string | null, read?: boolean | null, lastMessageAt?: string | null, role: Roles_Enum, user: { __typename?: 'InMailParticipantOutput', codexId: string, firstName: string, lastName: string, profilePictureId?: string | null } }> } };

export type GetVerificationRequestsQueryVariables = Exact<{
  filter: SaVerificationRequestFilter;
  orderBy: SaVerificationRequestOrderBy;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetVerificationRequestsQuery = { __typename?: 'query_root', getVerificationRequests: { __typename?: 'SAVerificationRequests', total: number, requests: Array<{ __typename?: 'SAVerificationRequest', userCodexId: string, updatedAt: string, type: VerificationType, status: VerificationStatus, personaInquiryId: string, id: string, fullName: string, createdAt: string, email: string, childFullName?: string | null, childCodexId?: string | null, statusHistory: Array<{ __typename?: 'VerificationStatusHistoryEntry', status: VerificationStatus, datetime: string }> }> } };

export type GetSuperAdminsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<SuperAdminOrderByInput>;
}>;


export type GetSuperAdminsQuery = { __typename?: 'query_root', getSuperAdmins: { __typename?: 'GetSuperAdminsOutput', total: number, superAdmins: Array<{ __typename?: 'SuperAdminListItem', id: string, email: string, createdAt?: string | null }> } };

export type GetSwabCodeValidBySwabcodeQueryVariables = Exact<{
  swabcode: Scalars['String'];
}>;


export type GetSwabCodeValidBySwabcodeQuery = { __typename?: 'query_root', GetSwabCodeValidBySwabcode?: { __typename?: 'IsValidSwabCode', isValid: boolean, id: string, lab_name?: string | null, status: string, swab_code: string, swab_usage_type: string, test_type?: string | null } | null };

export type FinishTourMutationVariables = Exact<{
  appTourType: AppTourTypes;
}>;


export type FinishTourMutation = { __typename?: 'mutation_root', finishAppTour: { __typename?: 'HttpStatusOutput', status: number } };

export type ResetAppTourMutationVariables = Exact<{
  appTourType: AppTourTypes;
}>;


export type ResetAppTourMutation = { __typename?: 'mutation_root', resetAppTour: { __typename?: 'HttpStatusOutput', status: number } };

export type GetAppToursQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppToursQuery = { __typename?: 'query_root', getAppTours: { __typename?: 'AppToursOutput', app_tours: Array<{ __typename?: 'AppTourOutput', id: number, type: AppTourTypes }> } };

export type GetUnauthenticatedQuestionnaireByIdQueryVariables = Exact<{
  questionnaire_id: Scalars['Int'];
}>;


export type GetUnauthenticatedQuestionnaireByIdQuery = { __typename?: 'query_root', unauthenticated_questionnaires: Array<{ __typename?: 'unauthenticated_questionnaires', title: string, subtitle?: string | null, data: any, unauthenticated_questionnaire_questions: Array<{ __typename?: 'unauthenticated_questionnaire_questions', unauthenticated_questionnaire_questions_unauthenticated_question: { __typename?: 'unauthenticated_questions', id: number, text: string, subtitle?: string | null, answers?: any | null, ui_control: Question_Ui_Control_Types_Enum, dont_know_answer?: string | null, double_text_combo_helper_texts?: any | null, dropdown_combo_answers?: any | null, dropdown_label_1?: string | null, dropdown_label_2?: string | null, response_property?: string | null, has_tooltip?: boolean | null, tooltip_content?: string | null, placeholder?: string | null } }> }> };

export type GetUnauthenticatedQuestionsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetUnauthenticatedQuestionsByIdsQuery = { __typename?: 'query_root', unauthenticated_questions: Array<{ __typename?: 'unauthenticated_questions', id: number, text: string, subtitle?: string | null, answers?: any | null, placeholder?: string | null, ui_control: Question_Ui_Control_Types_Enum, response_property?: string | null }> };

export type SaveDnaScannedDataMutationVariables = Exact<{
  testType?: InputMaybe<Scalars['String']>;
  swabBarcode?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  skipTrackingNumber?: InputMaybe<Scalars['Boolean']>;
  token?: InputMaybe<Scalars['String']>;
}>;


export type SaveDnaScannedDataMutation = { __typename?: 'mutation_root', SaveDnaScannedData?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type ClearAllSavedDnaScannedDataForUserIdMutationVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type ClearAllSavedDnaScannedDataForUserIdMutation = { __typename?: 'mutation_root', delete_user_scanned_data?: { __typename?: 'user_scanned_data_mutation_response', affected_rows: number } | null };

export type GetDnaScannedDataByUserIdSubscriptionVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetDnaScannedDataByUserIdSubscription = { __typename?: 'subscription_root', user_scanned_data: Array<{ __typename?: 'user_scanned_data', test_type?: string | null, swab_barcode?: string | null, tracking_number?: string | null, skip_tracking_number?: boolean | null, scan_completed?: boolean | null, updated_at?: any | null }> };

export type SignupUserMutationVariables = Exact<{
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  firebaseToken?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
}>;


export type SignupUserMutation = { __typename?: 'mutation_root', SignupUser?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type GenerateCustomTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateCustomTokenMutation = { __typename?: 'mutation_root', GenerateCustomToken?: { __typename?: 'SuccessfulGeneratedCustomToken', token: string, message: string, status: number } | null };

export type ValidateCustomTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidateCustomTokenMutation = { __typename?: 'mutation_root', ValidateCustomToken?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type AccountDeletionMutationVariables = Exact<{
  token: Scalars['String'];
  userId: Scalars['String'];
}>;


export type AccountDeletionMutation = { __typename?: 'mutation_root', AccountDeletion?: { __typename?: 'HttpStatusOutput', status: number, message?: string | null } | null };

export type UpdatePersonalInfoMutationVariables = Exact<{
  id: Scalars['uuid'];
  SENSITIVE_dob?: InputMaybe<Scalars['date']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdatePersonalInfoMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', SENSITIVE_address_information?: any | null, SENSITIVE_country?: string | null, SENSITIVE_dob?: any | null, SENSITIVE_email?: string | null, SENSITIVE_etnicity?: any | null, SENSITIVE_firstname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: any | null, id: any } | null };

export type UpdateContactInfoMutationVariables = Exact<{
  id: Scalars['uuid'];
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
}>;


export type UpdateContactInfoMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', SENSITIVE_address_information?: any | null, SENSITIVE_country?: string | null, SENSITIVE_dob?: any | null, SENSITIVE_email?: string | null, SENSITIVE_etnicity?: any | null, SENSITIVE_firstname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: any | null, id: any } | null };

export type UpdateProfileInfoMutationVariables = Exact<{
  id: Scalars['uuid'];
  SENSITIVE_dob?: InputMaybe<Scalars['date']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProfileInfoMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', SENSITIVE_address_information?: any | null, SENSITIVE_country?: string | null, SENSITIVE_dob?: any | null, SENSITIVE_email?: string | null, SENSITIVE_etnicity?: any | null, SENSITIVE_firstname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: any | null, id: any } | null };

export type UpdatePhoneAndCountryByUserIdMutationVariables = Exact<{
  id: Scalars['uuid'];
  SENSITIVE_phone: Scalars['String'];
  SENSITIVE_country: Scalars['String'];
}>;


export type UpdatePhoneAndCountryByUserIdMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, SENSITIVE_country?: string | null, SENSITIVE_phone?: string | null, updated_at: any } | null };

export type UpdateProfilePictureMutationVariables = Exact<{
  image: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProfilePictureMutation = { __typename?: 'mutation_root', UpdateProfilePicture?: { __typename?: 'SuccessfullUpdatedProfilePicture', message: string, status: number, fileId: string, contentType: string } | null };

export type UpdateProviderProfilePictureMutationVariables = Exact<{
  image: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProviderProfilePictureMutation = { __typename?: 'mutation_root', UpdateProviderProfilePicture?: { __typename?: 'SuccessfullUpdatedProfilePicture', message: string, status: number, fileId: string, contentType: string } | null };

export type GenerateSessionTokenForPersonaMutationVariables = Exact<{
  inquiryId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateSessionTokenForPersonaMutation = { __typename?: 'mutation_root', GetPersonaSessionToken?: { __typename?: 'GetPersonaSessionTokenResponse', sessionToken: string } | null };

export type UpdateCustomAuthCodeAsUsedMutationVariables = Exact<{
  email: Scalars['String'];
  code: Scalars['String'];
}>;


export type UpdateCustomAuthCodeAsUsedMutation = { __typename?: 'mutation_root', update_custom_auth_code?: { __typename?: 'custom_auth_code_mutation_response', affected_rows: number } | null };

export type DeleteUserSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserSessionMutation = { __typename?: 'mutation_root', deleteUserSession?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type AcceptUserAgreementMutationVariables = Exact<{
  agreementType: UserAgreementTypes;
  acceptorRole?: InputMaybe<UserAgreementAcceptorRole>;
  autonomyDeterminationStatus?: InputMaybe<AutonomyDeterminationStatus>;
  expiration?: InputMaybe<UserAgreementExpirationType>;
  minorAutonomyEvidence?: InputMaybe<Array<MinorAutonomyEvidenceTypes> | MinorAutonomyEvidenceTypes>;
}>;


export type AcceptUserAgreementMutation = { __typename?: 'mutation_root', acceptUserAgreement: { __typename?: 'HttpStatusOutput', status: number } };

export type UpdateCartProductsProviderMutationVariables = Exact<{
  cartProductIds: Array<Scalars['Int']> | Scalars['Int'];
  providerCodexId: Scalars['String'];
}>;


export type UpdateCartProductsProviderMutation = { __typename?: 'mutation_root', updateCartProductsProvider: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type AcceptProviderAgreementMutationVariables = Exact<{
  agreementType: UserAgreementTypes;
}>;


export type AcceptProviderAgreementMutation = { __typename?: 'mutation_root', acceptUserAgreement: { __typename?: 'HttpStatusOutput', status: number } };

export type CreateSubPatientMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  dob: Scalars['String'];
  relationship?: InputMaybe<SubPatientRelationship>;
  gender: Scalars['String'];
}>;


export type CreateSubPatientMutation = { __typename?: 'mutation_root', createSubPatient: { __typename?: 'IdOutput', id: string } };

export type ExportUserDataMutationVariables = Exact<{ [key: string]: never; }>;


export type ExportUserDataMutation = { __typename?: 'mutation_root', ExportUserData?: { __typename?: 'ExportUserDataOutput', downloadUrl: string } | null };

export type CloseAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CloseAccountMutation = { __typename?: 'mutation_root', closeAccount: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type BlockUserMutationVariables = Exact<{
  userCodexId: Scalars['String'];
  blocked: Scalars['Boolean'];
}>;


export type BlockUserMutation = { __typename?: 'mutation_root', blockUser: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type CreateBecomePatientRequestMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
}>;


export type CreateBecomePatientRequestMutation = { __typename?: 'mutation_root', createBecomePatientRequest: { __typename?: 'PatchFHIRRequestBecomePatientOutput', requestStatus: ProviderRequestStatus } };

export type ConfirmProviderPatientAgreementMutationVariables = Exact<{
  providerCodexId: Scalars['String'];
}>;


export type ConfirmProviderPatientAgreementMutation = { __typename?: 'mutation_root', confirmProviderPatientAgreement: { __typename?: 'PatchFHIRRequestBecomePatientOutput', requestStatus: ProviderRequestStatus } };

export type GetUsersByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUsersByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, SENSITIVE_phone?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_email?: string | null, SENSITIVE_dob?: any | null, SENSITIVE_country?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: any | null, SENSITIVE_etnicity?: any | null, SENSITIVE_address_information?: any | null, SENSITIVE_profile_picture_id?: any | null }> };

export type GetUsersByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUsersByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, SENSITIVE_dob?: any | null, SENSITIVE_email?: string | null, SENSITIVE_firstname?: string | null, SENSITIVE_gender?: string | null, SENSITIVE_phone?: string | null, SENSITIVE_country?: string | null, SENSITIVE_lastname?: string | null, SENSITIVE_self_identity_gender?: string | null, SENSITIVE_user_measurements?: any | null, SENSITIVE_etnicity?: any | null, SENSITIVE_address_information?: any | null, SENSITIVE_profile_picture_id?: any | null, account_closed_at?: any | null, account_closure_reason?: string | null, blocked_at?: any | null }> };

export type GetChildVerificationStatusQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetChildVerificationStatusQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', kyc_child_status?: Persona_Inquiry_Status_Enum | null, SENSITIVE_dob?: any | null }> };

export type GetPersonaVerificationStatusByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetPersonaVerificationStatusByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', kyc_current_status?: Persona_Inquiry_Status_Enum | null, kyc_update_date?: any | null }> };

export type GetAgreementsByUserIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAgreementsByUserIdQuery = { __typename?: 'query_root', user_agreements: Array<{ __typename?: 'user_agreements', agreement_type: any, created_at?: any | null, id: number, status: Persona_Inquiry_Status_Enum, user_id: any }> };

export type GetAgreementAgeOfMajorityByUserIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAgreementAgeOfMajorityByUserIdQuery = { __typename?: 'query_root', user_agreements: Array<{ __typename?: 'user_agreements', agreement_type: any, created_at?: any | null, id: number, status: Persona_Inquiry_Status_Enum, user_id: any }> };

export type GetAgreementSudRecordsByUserIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAgreementSudRecordsByUserIdQuery = { __typename?: 'query_root', user_agreements: Array<{ __typename?: 'user_agreements', agreement_type: any, created_at?: any | null, id: number, status: Persona_Inquiry_Status_Enum, user_id: any, acceptor_role?: any | null }> };

export type GetAgreementSubstanceByUserIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAgreementSubstanceByUserIdQuery = { __typename?: 'query_root', user_agreements: Array<{ __typename?: 'user_agreements', agreement_type: any, created_at?: any | null, id: number, status: Persona_Inquiry_Status_Enum, user_id: any, expiration_type?: any | null }> };

export type GetUserPersonaInquiryIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserPersonaInquiryIdQuery = { __typename?: 'query_root', persona_inquiries: Array<{ __typename?: 'persona_inquiries', persona_inquiry_id: string }> };

export type GetUserEmailPreferencesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserEmailPreferencesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', EMAIL_NEW_FEATURES_SERVICES_SETTINGS: boolean, EMAIL_MONTHLY_NEWSLETTER: boolean, EMAIL_SPECIAL_OFFERS_SETTING: boolean, EMAIL_SPECIAL_OFFER_FRIENDS_SETTING: boolean, EMAIL_UNSUBSCRIBED: boolean }> };

export type GetUserPrivacyPreferencesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserPrivacyPreferencesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', PRIVACY_AFFILIATES_CODEX_LABS_SETTING: boolean, PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING: boolean, PRIVACY_CALIFORNIA_SETTINGS: boolean }> };

export type GetUserAutoApprovalPreferencesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserAutoApprovalPreferencesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING: boolean, AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING: boolean }> };

export type GetUserAlertPreferencesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserAlertPreferencesQuery = { __typename?: 'query_root', user_settings: Array<{ __typename?: 'user_settings', alert_settings?: any | null }> };

export type GetSubPatientsByParentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubPatientsByParentQuery = { __typename?: 'query_root', getSubPatientsByParent: { __typename?: 'SubPatientsOutput', total: number, subPatients: Array<{ __typename?: 'SubPatient', birthDate?: string | null, firstName: string, id: string, lastName: string, parentCodexId: string, parentRelationship?: SubPatientRelationship | null, profilePhoto?: string | null, child_fully_verified?: boolean | null, blocked_at?: string | null }> } };

export type GetClosedSubPatientsByParentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClosedSubPatientsByParentQuery = { __typename?: 'query_root', getSubPatientsByParent: { __typename?: 'SubPatientsOutput', closedTotal: number, subPatients: Array<{ __typename?: 'SubPatient', birthDate?: string | null, firstName: string, id: string, lastName: string, parentCodexId: string, parentRelationship?: SubPatientRelationship | null, profilePhoto?: string | null, child_fully_verified?: boolean | null, blocked_at?: string | null }> } };

export type MyHistoryOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<OrdersOrderByCriterias>;
  filter?: InputMaybe<OrderFilterInput>;
}>;


export type MyHistoryOrdersQuery = { __typename?: 'query_root', getOrders: { __typename?: 'OrderListOutput', total: number, orders: Array<{ __typename?: 'OrderOutput', id: number, created_at: string, status?: number | null, total_amount: number, order_products?: Array<{ __typename?: 'OrderProductOutput', product?: { __typename?: 'Product', category?: number | null, title: string, test_type?: Hasura_Test_Types_Enum | null } | null }> | null, statusHistory: Array<{ __typename?: 'OrderStatusHistoryEntry', status: OrderStatusEnum, datetime: string }> }> } };

export type GetPatientStateAgeOfMajorityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientStateAgeOfMajorityQuery = { __typename?: 'query_root', getPatientStateAgeOfMajority: { __typename?: 'AgeOfMajorityOutput', ageOfMajority: number, state: string } };

export type GetFilesByRequestUserCodexIdQueryVariables = Exact<{
  contentTypes?: InputMaybe<Array<FileTypesEnum> | FileTypesEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  sourceTypes?: InputMaybe<Array<MediaFileSourceType> | MediaFileSourceType>;
}>;


export type GetFilesByRequestUserCodexIdQuery = { __typename?: 'query_root', getFilesByRequestUserCodexId: { __typename?: 'GetMediaFilesOutput', total: number, files: Array<{ __typename?: 'MediaFileOutput', contentType?: string | null, fileId?: string | null, sourceType?: MediaFileSourceType | null, url?: string | null, appointment?: { __typename?: 'GetAppointmentOutput', appointmentCodexId: string, appointmentType?: AppointmentTypeEnum | null, start?: string | null } | null, provider?: { __typename?: 'ProviderOutput', SENSITIVE_firstname: string, SENSITIVE_lastname: string, id: string, SENSITIVE_credentials: { __typename?: 'ProviderCredentialsOutput', titles: Array<string>, medicalRole: string } } | null }> } };

export type GetReceiptsHistoryQueryVariables = Exact<{
  input: ReceiptHistoryInput;
}>;


export type GetReceiptsHistoryQuery = { __typename?: 'query_root', getReceiptsHistory: { __typename?: 'ReceiptsHistoryOutput', total: number, receipts: Array<{ __typename?: 'ReceiptHistoryItemOutput', paymentTransactionId: number, paidAt: string, category: PaymentTransactionPaymentCategoryEnum, amount: number }> } };

export type GetReceiptsHistoryByPatientQueryVariables = Exact<{
  input?: InputMaybe<ReceiptHistoryInput>;
}>;


export type GetReceiptsHistoryByPatientQuery = { __typename?: 'query_root', getReceiptsHistory: { __typename?: 'ReceiptsHistoryOutput', totalSpentOnOrders: number, totalSpentOnAppointments: number, total: number, receipts: Array<{ __typename?: 'ReceiptHistoryItemOutput', amount: number, category: PaymentTransactionPaymentCategoryEnum, paidAt: string, paymentTransactionId: number }> } };

export type GetAppointmentPaymentInfoByPatientQueryVariables = Exact<{
  find?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
}>;


export type GetAppointmentPaymentInfoByPatientQuery = { __typename?: 'query_root', getFHIRAppointmentByRequestPatientCodexId: { __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts', total: number, appointment: Array<{ __typename?: 'GetAppointmentOutput', appointmentType?: AppointmentTypeEnum | null, providerFirstName?: string | null, providerLastName?: string | null, start?: string | null, end?: string | null, paymentSessionOpenedAt?: string | null, appointmentCodexId: string, paymentInformation?: { __typename?: 'AppointmentPaymentOutput', amount?: number | null } | null }> } };

export type GetUsersVerificationStatusesByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUsersVerificationStatusesByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', kyc_current_status?: Persona_Inquiry_Status_Enum | null, kyc_insurance_status?: Persona_Inquiry_Status_Enum | null, kyc_update_date?: any | null, insurance_verify_later?: boolean | null }> };

export type GetMyAcceptedLegalDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAcceptedLegalDocumentsQuery = { __typename?: 'query_root', getAcceptedLegalDocuments: { __typename?: 'AcceptedLegalDocumentsOutput', acceptedLegalDocuments: Array<{ __typename?: 'AcceptedLegalDocumentOutput', acceptanceDate: string, acceptedVersion: number, latestVersion: number, type: Hasura_Legal_Document_Types_Enum }> } };

export type SubscriptionAgreementAgeOfMajorityByUserIdSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type SubscriptionAgreementAgeOfMajorityByUserIdSubscription = { __typename?: 'subscription_root', user_agreements: Array<{ __typename?: 'user_agreements', agreement_type: any, created_at?: any | null, id: number, status: Persona_Inquiry_Status_Enum, user_id: any }> };

export type SubscriptionUserIndicatorsSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type SubscriptionUserIndicatorsSubscription = { __typename?: 'subscription_root', user_indicators: Array<{ __typename?: 'user_indicators', boolean_state: boolean, created_at: any, id: any, indicator_type: any, updated_at: any, user_id: any }> };

export type GetUsersVerificationStatusByEmailSubscriptionVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUsersVerificationStatusByEmailSubscription = { __typename?: 'subscription_root', users: Array<{ __typename?: 'users', kyc_current_status?: Persona_Inquiry_Status_Enum | null, kyc_insurance_status?: Persona_Inquiry_Status_Enum | null, kyc_update_date?: any | null, insurance_verify_later?: boolean | null }> };

export type GetChildVerificationStatusByEmailSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetChildVerificationStatusByEmailSubscription = { __typename?: 'subscription_root', users: Array<{ __typename?: 'users', kyc_child_status?: Persona_Inquiry_Status_Enum | null, SENSITIVE_dob?: any | null }> };

export type RegisterAuthProviderMutationVariables = Exact<{
  provider_type: Scalars['String'];
}>;


export type RegisterAuthProviderMutation = { __typename?: 'mutation_root', RegisterAuthProvider?: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } | null };

export type AddServiceOfferingsMutationVariables = Exact<{
  offerings: Array<AddServiceOfferingInput> | AddServiceOfferingInput;
}>;


export type AddServiceOfferingsMutation = { __typename?: 'mutation_root', addServiceOfferings: { __typename?: 'PatchFHIRProviderOutput', update_providers_one: { __typename?: 'ProviderOutput', id: string, isStripeConnected?: boolean | null, serviceOfferings: Array<{ __typename?: 'ServiceOfferingsOutput', active: boolean, healthCareServiceFhirId: string, price: string, priceCategory: PriceCategory, serviceType: ServiceType }> } } };

export type ConnectStripeAccountMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ConnectStripeAccountMutation = { __typename?: 'mutation_root', ConnectStripeAccount?: { __typename?: 'ConnectStripeAccountOutput', status: number } | null };

export type GetVonageArchivesMutationVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetVonageArchivesMutation = { __typename?: 'mutation_root', GetVonageArchives?: { __typename?: 'SuccessfulGetVonageArchives', archives?: Array<any> | null } | null };

export type GetVonageSessionMutationVariables = Exact<{
  room: Scalars['String'];
}>;


export type GetVonageSessionMutation = { __typename?: 'mutation_root', GetVonageSession?: { __typename?: 'SuccessGetVonageSession', sessionId: string, token: string, apiKey: string } | null };

export type VonageCaptionsStartMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type VonageCaptionsStartMutation = { __typename?: 'mutation_root', VonageCaptionsStart?: { __typename?: 'VonageLiveCaptions', captionsId?: string | null, status: VonageLiveCaptionsStatus } | null };

export type VonageCaptionsStopMutationVariables = Exact<{
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type VonageCaptionsStopMutation = { __typename?: 'mutation_root', VonageCaptionsStop?: { __typename?: 'VonageLiveCaptions', captionsId?: string | null, status: VonageLiveCaptionsStatus } | null };

export type UpdateCallSettingsMutationVariables = Exact<{
  settings: Scalars['JSON'];
}>;


export type UpdateCallSettingsMutation = { __typename?: 'mutation_root', updateCallSettings: { __typename?: 'HttpStatusOutput', message?: string | null, status: number } };

export type GetCallSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCallSettingsQuery = { __typename?: 'query_root', getCallSettings: any };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  _text: any;
  admin_permission_type: any;
  app_tour_type: any;
  bigint: any;
  bpchar: any;
  date: any;
  invitation_type: any;
  jsonb: any;
  numeric: any;
  payment_provider: any;
  pending_patient_status: any;
  smallint: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  user_agreement_types: any;
  user_indicator_type: any;
  uuid: any;
};

/** The type of appointment event */
export enum Appointment_Event {
  AppointmentEnd = 'APPOINTMENT_END',
  AppointmentStart = 'APPOINTMENT_START',
  PatientJoined = 'PATIENT_JOINED',
  PatientLeft = 'PATIENT_LEFT',
  ProviderJoined = 'PROVIDER_JOINED',
  ProviderLeft = 'PROVIDER_LEFT'
}

/** The source of the appointment event */
export enum Appointment_Event_Source {
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  System = 'SYSTEM'
}

export type AcceptAgreementInput = {
  acceptorRole?: InputMaybe<UserAgreementAcceptorRole>;
  agreementType: UserAgreementTypes;
  autonomyDeterminationStatus?: InputMaybe<AutonomyDeterminationStatus>;
  expiration?: InputMaybe<UserAgreementExpirationType>;
  minorAutonomyEvidence?: InputMaybe<Array<MinorAutonomyEvidenceTypes>>;
};

export type AcceptChildAdultTransitionInvitationInput = {
  firebaseToken: Scalars['String'];
  token: Scalars['String'];
};

export type AcceptLegalDocumentInput = {
  type: Hasura_Legal_Document_Types_Enum;
};

export type AcceptedAgreementOutput = {
  __typename?: 'AcceptedAgreementOutput';
  acceptanceDate: Scalars['String'];
  agreementType: UserAgreementTypes;
};

export type AcceptedLegalDocumentOutput = {
  __typename?: 'AcceptedLegalDocumentOutput';
  acceptanceDate: Scalars['String'];
  acceptedVersion: Scalars['Int'];
  latestVersion: Scalars['Int'];
  type: Hasura_Legal_Document_Types_Enum;
};

export type AcceptedLegalDocumentsOutput = {
  __typename?: 'AcceptedLegalDocumentsOutput';
  acceptedAgreements: Array<AcceptedAgreementOutput>;
  acceptedLegalDocuments: Array<AcceptedLegalDocumentOutput>;
};

export type AccountDeletionInput = {
  token: Scalars['String'];
  userId: Scalars['String'];
};

export type AccountUser = {
  __typename?: 'AccountUser';
  account_closed_at?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  parentCodexId?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
};

export type AccountUsersOutput = {
  __typename?: 'AccountUsersOutput';
  closedTotal: Scalars['Int'];
  total: Scalars['Int'];
  users: Array<AccountUser>;
};

export enum AchievementCategory {
  Appointment = 'APPOINTMENT',
  HealthAndSafety = 'HEALTH_AND_SAFETY',
  TestKit = 'TEST_KIT',
  TreatmentPlan = 'TREATMENT_PLAN'
}

export type AchievementCategoryGroupOutput = {
  __typename?: 'AchievementCategoryGroupOutput';
  achievements: Array<AchievementOutput>;
  category: AchievementCategory;
};

export enum AchievementId {
  ActiveCarePartner = 'ACTIVE_CARE_PARTNER',
  CareConnector = 'CARE_CONNECTOR',
  ContinuityChampion = 'CONTINUITY_CHAMPION',
  FirstStep = 'FIRST_STEP',
  KitActivated = 'KIT_ACTIVATED',
  MedicationListUpdated = 'MEDICATION_LIST_UPDATED',
  NextStepPlanned = 'NEXT_STEP_PLANNED',
  OnTime = 'ON_TIME',
  OrderConfirmed = 'ORDER_CONFIRMED',
  PlanStarted = 'PLAN_STARTED',
  ProfileComplete = 'PROFILE_COMPLETE',
  ProviderConnector = 'PROVIDER_CONNECTOR',
  ReadyForYourVisit = 'READY_FOR_YOUR_VISIT',
  ResultsReady = 'RESULTS_READY',
  ResultsReviewed = 'RESULTS_REVIEWED',
  SafetyFirst = 'SAFETY_FIRST',
  SampleReady = 'SAMPLE_READY',
  SupplementListUpdated = 'SUPPLEMENT_LIST_UPDATED'
}

export type AchievementOutput = {
  __typename?: 'AchievementOutput';
  category: AchievementCategory;
  currentTier?: Maybe<Scalars['Int']>;
  currentValue: Scalars['Int'];
  description: Scalars['String'];
  hasTiers: Scalars['Boolean'];
  id: AchievementId;
  name: Scalars['String'];
  requiredValue: Scalars['Int'];
  status: AchievementProgressStatus;
};

export enum AchievementProgressStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Locked = 'LOCKED'
}

export type AchievementsOutput = {
  __typename?: 'AchievementsOutput';
  categories: Array<AchievementCategoryGroupOutput>;
  totalPoints: Scalars['Int'];
};

/** Activity log event group for filtering. */
export enum ActivityEventGroup {
  Account = 'ACCOUNT',
  LegalDocuments = 'LEGAL_DOCUMENTS',
  Messages = 'MESSAGES',
  PatientsAndCare = 'PATIENTS_AND_CARE',
  Payments = 'PAYMENTS'
}

/** Type of activity log event. */
export enum ActivityEventType {
  AccountCreated = 'ACCOUNT_CREATED',
  AccountDeleted = 'ACCOUNT_DELETED',
  AdminPermissionsUpdated = 'ADMIN_PERMISSIONS_UPDATED',
  AppointmentBooked = 'APPOINTMENT_BOOKED',
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentRescheduled = 'APPOINTMENT_RESCHEDULED',
  ChildAccountCreated = 'CHILD_ACCOUNT_CREATED',
  ChildAccountDeleted = 'CHILD_ACCOUNT_DELETED',
  ChildAdultTransitionCompleted = 'CHILD_ADULT_TRANSITION_COMPLETED',
  CourseCreated = 'COURSE_CREATED',
  CourseDeleted = 'COURSE_DELETED',
  CourseUpdated = 'COURSE_UPDATED',
  LegalDocumentAccepted = 'LEGAL_DOCUMENT_ACCEPTED',
  LegalDocumentUpdated = 'LEGAL_DOCUMENT_UPDATED',
  LoggedIn = 'LOGGED_IN',
  LoggedOut = 'LOGGED_OUT',
  MedicationPrescribed = 'MEDICATION_PRESCRIBED',
  MessageReceived = 'MESSAGE_RECEIVED',
  MessageSent = 'MESSAGE_SENT',
  OrderPurchased = 'ORDER_PURCHASED',
  PasswordUpdated = 'PASSWORD_UPDATED',
  PersonaRejected = 'PERSONA_REJECTED',
  PersonaSubmitted = 'PERSONA_SUBMITTED',
  PersonaVerified = 'PERSONA_VERIFIED',
  PostAppointmentSummaryReceived = 'POST_APPOINTMENT_SUMMARY_RECEIVED',
  ProductUpdated = 'PRODUCT_UPDATED',
  ProviderAssigned = 'PROVIDER_ASSIGNED',
  RefundReceived = 'REFUND_RECEIVED',
  StateLicenseUpdated = 'STATE_LICENSE_UPDATED',
  SupplementRecommended = 'SUPPLEMENT_RECOMMENDED',
  TestKitRecommended = 'TEST_KIT_RECOMMENDED',
  TestKitRegistered = 'TEST_KIT_REGISTERED',
  TestKitResultsReceived = 'TEST_KIT_RESULTS_RECEIVED',
  UserAgreementAccepted = 'USER_AGREEMENT_ACCEPTED',
  UserBlocked = 'USER_BLOCKED',
  UserUnblocked = 'USER_UNBLOCKED',
  WeeklyTransactionReceived = 'WEEKLY_TRANSACTION_RECEIVED'
}

export type ActivityLogFilterInput = {
  groups?: InputMaybe<Array<ActivityEventGroup>>;
};

export type ActivityLogItem = {
  __typename?: 'ActivityLogItem';
  createdAt: Scalars['String'];
  eventType: ActivityEventType;
  id: Scalars['String'];
  metadata?: Maybe<ActivityLogMetadata>;
};

export type ActivityLogMetadata = {
  __typename?: 'ActivityLogMetadata';
  admin?: Maybe<SaPerson>;
  agreementType?: Maybe<UserAgreementTypes>;
  appointment_id?: Maybe<Scalars['String']>;
  course?: Maybe<EducationCourseListItemOutput>;
  legalDocument?: Maybe<LegalDocumentOutput>;
  order_id?: Maybe<Scalars['Int']>;
  patient?: Maybe<GetPatientOutput>;
  product?: Maybe<ProductOutput>;
  provider?: Maybe<ProviderOutput>;
  swab_code?: Maybe<Scalars['String']>;
  test_type?: Maybe<Hasura_Test_Types_Enum>;
  verificationType?: Maybe<VerificationType>;
};

export type ActivityLogOutput = {
  __typename?: 'ActivityLogOutput';
  logs: Array<ActivityLogItem>;
  total: Scalars['Int'];
};

export type AcuityCalendarResult = {
  __typename?: 'AcuityCalendarResult';
  active: Scalars['Boolean'];
  calendar_id: Scalars['Int'];
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  owner_id?: Maybe<Scalars['String']>;
  provider_calendar: Scalars['String'];
  provider_id: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

export type AcuityWorkingHoursPerDay = {
  __typename?: 'AcuityWorkingHoursPerDay';
  Friday: Array<Scalars['String']>;
  Monday: Array<Scalars['String']>;
  Saturday: Array<Scalars['String']>;
  Sunday: Array<Scalars['String']>;
  Thursday: Array<Scalars['String']>;
  Tuesday: Array<Scalars['String']>;
  Wednesday: Array<Scalars['String']>;
};

export type AddFhirHealthCareServiceInput = {
  offerings: Array<AddServiceOfferingInput>;
};

export type AddServiceOfferingInput = {
  active: Scalars['Boolean'];
  price: Scalars['Float'];
  serviceType: ServiceType;
};

export type AddSwabCodeInput = {
  swabCode: Scalars['String'];
  testType?: InputMaybe<Hasura_Test_Types_Enum>;
};

export type AddSwabCodesInput = {
  swabCodes?: InputMaybe<Array<AddSwabCodeInput>>;
  swabCodesStrings?: InputMaybe<Array<Scalars['String']>>;
  testTypeFallBack?: InputMaybe<Hasura_Test_Types_Enum>;
};

export type AddSwabCodesOutput = {
  __typename?: 'AddSwabCodesOutput';
  existingSwabCodes: Array<Scalars['String']>;
  invalidSwabCodesDueSomeIssue: Array<Scalars['String']>;
  invalidSwabCodesDueToTypes: Array<Scalars['String']>;
  totalAdded: Scalars['Int'];
};

export type AddressInformationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type AddressInformationOutput = {
  __typename?: 'AddressInformationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Enum representation of admin permissions for admin permissions. */
export enum AdminPermissionType {
  AdminDashboardStats = 'ADMIN_DASHBOARD_STATS',
  BlockUsers = 'BLOCK_USERS',
  InitiateRefund = 'INITIATE_REFUND',
  ManageEducation = 'MANAGE_EDUCATION',
  UpdateProductsInfo = 'UPDATE_PRODUCTS_INFO',
  UpdateProvidersInfo = 'UPDATE_PROVIDERS_INFO',
  UpdateSwabcodesInfo = 'UPDATE_SWABCODES_INFO',
  VeradigmAdmin = 'VERADIGM_ADMIN',
  ViewActivityLogs = 'VIEW_ACTIVITY_LOGS',
  ViewAppointmentsInfo = 'VIEW_APPOINTMENTS_INFO',
  ViewOrdersInfo = 'VIEW_ORDERS_INFO',
  ViewPatientsInfo = 'VIEW_PATIENTS_INFO',
  ViewPaymentsInfo = 'VIEW_PAYMENTS_INFO',
  ViewProductsInfo = 'VIEW_PRODUCTS_INFO',
  ViewProvidersInfo = 'VIEW_PROVIDERS_INFO',
  ViewSupportChat = 'VIEW_SUPPORT_CHAT',
  ViewSwabcodesInfo = 'VIEW_SWABCODES_INFO',
  ViewTestKitsInfo = 'VIEW_TEST_KITS_INFO',
  ViewVerificationRequestInfo = 'VIEW_VERIFICATION_REQUEST_INFO'
}

export type AgeOfMajorityOutput = {
  __typename?: 'AgeOfMajorityOutput';
  ageOfMajority: Scalars['Int'];
  state: Scalars['String'];
};

export type AllergenClassOutput = {
  __typename?: 'AllergenClassOutput';
  classId: Scalars['String'];
  className: Scalars['String'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type AllergenClassesOutput = {
  __typename?: 'AllergenClassesOutput';
  allergenClasses: Array<AllergenClassOutput>;
  total: Scalars['Int'];
};

export type Annotation = {
  __typename?: 'Annotation';
  authorReference?: Maybe<ReferenceType>;
  authorString?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  time?: Maybe<Scalars['DateTime']>;
};

export type AppTourOutput = {
  __typename?: 'AppTourOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  type: AppTourTypes;
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

/** Enum representing the app tour types. */
export enum AppTourTypes {
  PatientAppointments = 'patientAppointments',
  PatientCareHistory = 'patientCareHistory',
  PatientDashboard = 'patientDashboard',
  PatientManageTestKits = 'patientManageTestKits',
  PatientMyProviders = 'patientMyProviders',
  PatientPendingTestKits = 'patientPendingTestKits',
  PatientProviders = 'patientProviders',
  PatientTestKitRegistration = 'patientTestKitRegistration',
  ProviderAppointments = 'providerAppointments',
  ProviderDashboard = 'providerDashboard',
  ProviderMyPatients = 'providerMyPatients',
  ProviderOnboardingInstructions = 'providerOnboardingInstructions',
  ProviderPatientDetails = 'providerPatientDetails'
}

export type AppToursOutput = {
  __typename?: 'AppToursOutput';
  app_tours: Array<AppTourOutput>;
};

export type AppVersionOutput = {
  __typename?: 'AppVersionOutput';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  releaseNotes: Scalars['String'];
  releaseType: AppVersionReleaseType;
  updatedAt: Scalars['String'];
  version: Scalars['String'];
};

/** App release type. Major cannot be delivered by OTA; Minor can. */
export enum AppVersionReleaseType {
  Major = 'Major',
  Minor = 'Minor'
}

export type AppVersionsOutput = {
  __typename?: 'AppVersionsOutput';
  hasMajorUpdate: Scalars['Boolean'];
  total: Scalars['Int'];
  versions: Array<AppVersionOutput>;
};

export type AppendEncounterOutput = {
  __typename?: 'AppendEncounterOutput';
  encounterId: Scalars['String'];
};

export type AppendFhirEncounterInput = {
  appointmentCodexId: Scalars['String'];
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  providerNotes: CreateFhirEncounterNotesInput;
};

export type AppointmentChat = {
  __typename?: 'AppointmentChat';
  appointmentCodexId: Scalars['String'];
  id: Scalars['String'];
  messages: Array<AppointmentChatMessage>;
  patientId: Scalars['String'];
  providerId: Scalars['String'];
};

export type AppointmentChatMessage = {
  __typename?: 'AppointmentChatMessage';
  contentType?: Maybe<ContentType>;
  date: Scalars['String'];
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
};

/** Enum representing the possible values for "from" field in AppointmentChatMessage. */
export enum AppointmentChatMessageFrom {
  Patient = 'PATIENT',
  Provider = 'PROVIDER'
}

export type AppointmentChatMessageInput = {
  contentType?: InputMaybe<ContentType>;
  date?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  from: AppointmentChatMessageFrom;
  mediaUrl?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type AppointmentDetailGql = {
  __typename?: 'AppointmentDetailGql';
  addonIDs?: Maybe<Array<Scalars['Float']>>;
  amountPaid: Scalars['String'];
  appointmentTypeID: Scalars['Float'];
  calendar: Scalars['String'];
  calendarID: Scalars['Float'];
  calendarTimezone: Scalars['String'];
  canClientCancel: Scalars['Boolean'];
  canClientReschedule: Scalars['Boolean'];
  canceled: Scalars['Boolean'];
  category: Scalars['String'];
  certificate?: Maybe<Scalars['String']>;
  classID?: Maybe<Scalars['Float']>;
  confirmationPage: Scalars['String'];
  confirmationPagePaymentLink: Scalars['String'];
  date: Scalars['String'];
  dateCreated: Scalars['String'];
  datetime: Scalars['String'];
  datetimeCreated: Scalars['String'];
  duration: Scalars['String'];
  email: Scalars['String'];
  endTime: Scalars['String'];
  firstName: Scalars['String'];
  formsText: Scalars['String'];
  id: Scalars['Float'];
  isVerified: Scalars['Boolean'];
  labels?: Maybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  noShow?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  paid: Scalars['String'];
  phone: Scalars['String'];
  priceSold: Scalars['String'];
  scheduledBy: Scalars['String'];
  time: Scalars['String'];
  timezone: Scalars['String'];
  type: Scalars['String'];
};

export type AppointmentEvent = {
  __typename?: 'AppointmentEvent';
  author: Appointment_Event_Source;
  date: Scalars['String'];
  disconnectReason?: Maybe<VonageDisconnectReason>;
  event: Appointment_Event;
  fhirId: Scalars['String'];
};

export type AppointmentMediaInsert = {
  bodySite?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  mediaId?: InputMaybe<Scalars['String']>;
};

export type AppointmentPaymentOutput = {
  __typename?: 'AppointmentPaymentOutput';
  amount?: Maybe<Scalars['Float']>;
  balanceImpact?: Maybe<Scalars['Float']>;
  discount?: Maybe<DiscountOutput>;
  status?: Maybe<Scalars['Int']>;
};

export type AppointmentRequestOutput = {
  __typename?: 'AppointmentRequestOutput';
  appointmentCodexId?: Maybe<Scalars['String']>;
  appointmentTypeId?: Maybe<Scalars['Int']>;
  approvedDate?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currentDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  patient?: Maybe<GetPatientOutput>;
  proposedDate: Scalars['String'];
  providerCodexId: Scalars['String'];
  reason: Scalars['String'];
  status: AppointmentRequestStatus;
  type: AppointmentRequestType;
  updatedAt: Scalars['String'];
};

export enum AppointmentRequestStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Outdated = 'Outdated',
  Pending = 'Pending'
}

export enum AppointmentRequestType {
  Book = 'Book',
  Reschedule = 'Reschedule'
}

export type AppointmentRequestsOutput = {
  __typename?: 'AppointmentRequestsOutput';
  requests: Array<AppointmentRequestOutput>;
  total: Scalars['Int'];
};

export type AppointmentStatsByDayOutput = {
  __typename?: 'AppointmentStatsByDayOutput';
  appointmentStats: AppointmentStatsOutput;
  date: Scalars['String'];
};

export type AppointmentStatsOutput = {
  __typename?: 'AppointmentStatsOutput';
  breakdown: Array<AppointmentStatsStatusItem>;
  total: Scalars['Int'];
};

/** Enum representing the possible values for appointment statistics status */
export enum AppointmentStatsStatusEnum {
  BookedNotPaid = 'BookedNotPaid',
  Canceled = 'Canceled',
  Completed = 'Completed',
  NoShow = 'NoShow',
  PatientMissed = 'PatientMissed',
  ProviderMissed = 'ProviderMissed',
  Upcoming = 'Upcoming'
}

export type AppointmentStatsStatusItem = {
  __typename?: 'AppointmentStatsStatusItem';
  status: AppointmentStatsStatusEnum;
  total: Scalars['Int'];
};

export type AppointmentStatusHistoryEntry = {
  __typename?: 'AppointmentStatusHistoryEntry';
  datetime: Scalars['String'];
  status: AppointmentStatusHistoryEnum;
};

/** Enum representing the possible values for appointment status history log */
export enum AppointmentStatusHistoryEnum {
  BookedNotPaid = 'BookedNotPaid',
  Canceled = 'Canceled',
  Completed = 'Completed',
  CompletedSummaryReady = 'CompletedSummaryReady',
  NoShow = 'NoShow',
  PatientMissed = 'PatientMissed',
  ProviderMissed = 'ProviderMissed',
  Upcoming = 'Upcoming'
}

export type AppointmentSummaryPdfOutput = {
  __typename?: 'AppointmentSummaryPdfOutput';
  status: AppointmentSummaryPdfStatus;
  summaryPdfFileId?: Maybe<Scalars['String']>;
};

export enum AppointmentSummaryPdfStatus {
  Pending = 'PENDING',
  Ready = 'READY'
}

export type AppointmentType = {
  __typename?: 'AppointmentType';
  active: Scalars['Boolean'];
  addonIDs?: Maybe<Array<Scalars['Int']>>;
  calendarIDs: Array<Scalars['Int']>;
  category: Scalars['String'];
  classSize?: Maybe<Scalars['Int']>;
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  formIDs?: Maybe<Array<Scalars['Int']>>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  paddingAfter: Scalars['Int'];
  paddingBefore: Scalars['Int'];
  price: Scalars['String'];
  private: Scalars['Boolean'];
  schedulingUrl: Scalars['String'];
  type: Scalars['String'];
};

/** Enum representing the possible values for "appointmentType" field in Appointment. */
export enum AppointmentTypeEnum {
  Chat = 'CHAT',
  Chat_30 = 'CHAT_30',
  Chat_60 = 'CHAT_60',
  Dnavisit = 'DNAVISIT',
  Email = 'EMAIL',
  Video = 'VIDEO',
  Video_30 = 'VIDEO_30',
  Video_60 = 'VIDEO_60'
}

export type AppointmentsDiagnosticReportsOutput = {
  __typename?: 'AppointmentsDiagnosticReportsOutput';
  diagnosticReports: Array<GetFhirAppointmentDiagnosticReportOutput>;
  total: Scalars['Int'];
};

export type ArrayFieldConfig = {
  __typename?: 'ArrayFieldConfig';
  add_button_label?: Maybe<Scalars['String']>;
  max_items?: Maybe<Scalars['Int']>;
  min_items?: Maybe<Scalars['Int']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType?: Maybe<ContentType>;
  creation?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ResourceExtension>>;
  hash?: Maybe<Scalars['String']>;
  language?: Maybe<Array<Language>>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AuthProviderInput = {
  providerType: Scalars['String'];
};

/** Enum representing the patient autonomy determination status. */
export enum AutonomyDeterminationStatus {
  EmancipatedMinor = 'EMANCIPATED_MINOR',
  HomelessUnaccompanied = 'HOMELESS_UNACCOMPANIED',
  MarriedMinor = 'MARRIED_MINOR',
  MinorParent = 'MINOR_PARENT',
  OtherStateServiceException = 'OTHER_STATE_SERVICE_EXCEPTION',
  SelfSupporting = 'SELF_SUPPORTING'
}

export type AvailabilityOverrideGroup = {
  __typename?: 'AvailabilityOverrideGroup';
  endDate: Scalars['String'];
  intervals: Array<TimeRange>;
  startDate: Scalars['String'];
};

export type AvailabilityOverrideGroupInput = {
  endDate?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<Array<TimeRangeDto>>;
  startDate: Scalars['String'];
};

export type AvailabilityOverridesResponse = {
  __typename?: 'AvailabilityOverridesResponse';
  overrides: Array<AvailabilityOverrideGroup>;
};

export type AvailabilityTime = {
  __typename?: 'AvailabilityTime';
  slotsAvailable: Scalars['Int'];
  time: Scalars['String'];
};

export type BecomePatientRequestItem = {
  __typename?: 'BecomePatientRequestItem';
  date: Scalars['String'];
  parent?: Maybe<GetPatientOutput>;
  patient: GetPatientOutput;
  requestStatus: ProviderRequestStatus;
};

export type BecomePatientRequestsOutput = {
  __typename?: 'BecomePatientRequestsOutput';
  items: Array<BecomePatientRequestItem>;
  serverNow: Scalars['String'];
  total: Scalars['Int'];
};

export type BillingPlan = {
  __typename?: 'BillingPlan';
  amount: Scalars['Float'];
  currency: Scalars['String'];
  name: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CartProductOutput = {
  __typename?: 'CartProductOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  owner_id?: Maybe<Scalars['String']>;
  patientOwner?: Maybe<GetPatientOutput>;
  product?: Maybe<ProductOutput>;
  product_id: Scalars['Int'];
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  recommendation_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

export type CartProductsOutput = {
  __typename?: 'CartProductsOutput';
  cart_products: Array<CartProductOutput>;
  shipping_for_products: Scalars['Float'];
  shipping_for_test_kits: Scalars['Float'];
  subtotal: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

/** Client platform used to store per-device settings. */
export enum ClientPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type CodeableConcept = {
  __typename?: 'CodeableConcept';
  coding?: Maybe<Array<Coding>>;
  text?: Maybe<Scalars['String']>;
};

export type CodeableConceptData = {
  __typename?: 'CodeableConceptData';
  code?: Maybe<Scalars['String']>;
  display: Scalars['String'];
  system?: Maybe<Scalars['String']>;
};

/** Enum representing the codex subscription statuses. */
export enum CodexSubscriptionStatuses {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export enum CodexTags {
  AcceptingPatients = 'AcceptingPatients',
  CodexApproved = 'CodexApproved',
  Enabled = 'Enabled',
  Errored = 'Errored',
  IdVerified = 'IdVerified',
  Ignored = 'Ignored',
  InsuranceVerified = 'InsuranceVerified',
  Test = 'Test'
}

export type Coding = {
  __typename?: 'Coding';
  code?: Maybe<Scalars['String']>;
  display?: Maybe<Scalars['String']>;
  system?: Maybe<Scalars['String']>;
};

export type Communication = {
  __typename?: 'Communication';
  basedOn?: Maybe<Array<ReferenceType>>;
  category?: Maybe<Array<CodeableConcept>>;
  encounter?: Maybe<Array<ReferenceType>>;
  extension?: Maybe<Array<ResourceExtension>>;
  id: Scalars['String'];
  identifier?: Maybe<Array<Identifier>>;
  meta: Meta;
  note?: Maybe<Array<Annotation>>;
  payload?: Maybe<Array<CommunicationPayload>>;
  priority?: Maybe<Array<CommunicationPriority>>;
  recipient: Array<ReferenceType>;
  resourceType: ResourcesTypes;
  sender: ReferenceType;
  sent?: Maybe<Scalars['String']>;
  status?: Maybe<Array<CommunicationStatus>>;
  text?: Maybe<Narrative>;
};

export type CommunicationPayload = {
  __typename?: 'CommunicationPayload';
  contentAttachment?: Maybe<Attachment>;
  contentString?: Maybe<Scalars['String']>;
};

/** Enum representing possible values for "priority" field in CommunicationRequest. */
export enum CommunicationPriority {
  Asap = 'ASAP',
  Routine = 'ROUTINE',
  Stat = 'STAT',
  Urgent = 'URGENT'
}

/** Enum representing possible values for "status" field in Communication. */
export enum CommunicationStatus {
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE',
  OnHold = 'ON_HOLD',
  Preparation = 'PREPARATION',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type ConnectStripeAccountInput = {
  code: Scalars['String'];
};

export type ConnectStripeAccountOutput = {
  __typename?: 'ConnectStripeAccountOutput';
  status: Scalars['Int'];
};

/** Enum representing the possible values for "contentType" field in Attachment. */
export enum ContentType {
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Gif = 'GIF',
  Heic = 'HEIC',
  Heif = 'HEIF',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Json = 'JSON',
  Mp3 = 'MP3',
  Mp4 = 'MP4',
  Pdf = 'PDF',
  Png = 'PNG',
  Txt = 'TXT',
  Webp = 'WEBP',
  Xls = 'XLS',
  Xlsx = 'XLSX',
  Zip = 'ZIP'
}

export type CreateAdminInvitationInput = {
  email: Scalars['String'];
  permissions: Array<AdminPermissionType>;
};

export type CreateAppVersionInput = {
  releaseNotes: Scalars['String'];
  releaseType: AppVersionReleaseType;
  version: Scalars['String'];
};

export type CreateAppoinimentOutput = {
  __typename?: 'CreateAppoinimentOutput';
  appointmentCodexId: Scalars['String'];
  appointmentId: Scalars['String'];
  appointmentUrl: Scalars['String'];
  created: Scalars['String'];
  lastProcessedDate: Scalars['String'];
  start: Scalars['String'];
  status: Scalars['String'];
};

export type CreateAppointmentRequestInput = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentTypeId?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  proposedDate: Scalars['String'];
  reason: Scalars['String'];
  type: AppointmentRequestType;
};

export type CreateCalendarAndDefineRegularHoursInput = {
  Friday: Array<TimeRangeDto>;
  Monday: Array<TimeRangeDto>;
  Saturday: Array<TimeRangeDto>;
  Sunday: Array<TimeRangeDto>;
  Thursday: Array<TimeRangeDto>;
  Tuesday: Array<TimeRangeDto>;
  Wednesday: Array<TimeRangeDto>;
  email: Scalars['String'];
};

export type CreateCartProductInput = {
  ownerId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  providerId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  recommendationId?: InputMaybe<Scalars['String']>;
};

export type CreateChildAdultTransitionInvitationInput = {
  childUserId: Scalars['String'];
  email: Scalars['String'];
};

export type CreateDeliveryAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CreateDependentLinkInput = {
  childCodexId: Scalars['String'];
};

export type CreateDnaVisitOutput = {
  __typename?: 'CreateDnaVisitOutput';
  created_at: Scalars['String'];
  dna_test_questionnaire_pdf_id: Scalars['String'];
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id: Scalars['String'];
  sapphiros_barcode: Scalars['String'];
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
};

export type CreateFhirAppointmentInput = {
  appointmentNotes?: InputMaybe<FhirAppointmentNotesObservation>;
  appointmentType?: InputMaybe<AppointmentTypeEnum>;
  appointmentUrl?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['String']>;
  mediaToAppend?: InputMaybe<Array<Scalars['String']>>;
  mediaToInsert?: InputMaybe<Array<AppointmentMediaInsert>>;
  patientCodexId: Scalars['String'];
  providerId?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  subjectOfAppointment?: InputMaybe<Scalars['String']>;
  supportingInfo?: InputMaybe<Array<Scalars['String']>>;
  symptomsLocation?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFhirAppointmentInputWithoutPatientCodexId = {
  appointmentNotes?: InputMaybe<FhirAppointmentNotesObservation>;
  appointmentType?: InputMaybe<AppointmentTypeEnum>;
  appointmentUrl?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['String']>;
  mediaToAppend?: InputMaybe<Array<Scalars['String']>>;
  mediaToInsert?: InputMaybe<Array<AppointmentMediaInsert>>;
  providerId?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  subjectOfAppointment?: InputMaybe<Scalars['String']>;
  supportingInfo?: InputMaybe<Array<Scalars['String']>>;
  symptomsLocation?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFhirAppointmentOutput = {
  __typename?: 'CreateFHIRAppointmentOutput';
  appointment: CreateAppoinimentOutput;
};

export type CreateFhirDnaVisitTestInputWithResponses = {
  codexProviderId?: InputMaybe<Scalars['String']>;
  dna_test_questionnaire_pdf_id: Scalars['String'];
  health_questionnaire_pdf_id: Scalars['String'];
  order_id: Scalars['String'];
  questionnaire_response: Scalars['JSON'];
  sapphiros_barcode: Scalars['String'];
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: InputMaybe<Scalars['String']>;
};

export type CreateFhirDnaVisitTestOutput = {
  __typename?: 'CreateFHIRDnaVisitTestOutput';
  dnavisit_test: CreateDnaVisitOutput;
};

export type CreateFhirEncounterNotesInput = {
  files?: InputMaybe<Array<FileAttachmentInput>>;
  followupRecommendations: Scalars['String'];
  providerNotes: Scalars['String'];
  providerSummary: Scalars['String'];
  systemGenerated?: InputMaybe<Scalars['String']>;
  transcription?: InputMaybe<Scalars['String']>;
};

export type CreateFhirMosaicTestOutput = {
  __typename?: 'CreateFHIRMosaicTestOutput';
  mosaic_test: CreateMosaicTestOutput;
};

export type CreateFhirOfficeLocationOutput = {
  __typename?: 'CreateFHIROfficeLocationOutput';
  insert_office_locations_one: CreateOfficeLocationOutput;
};

export type CreateFhirOrganizationInput = {
  address_information?: InputMaybe<AddressInformationInput>;
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OrganizationTypes>;
};

export type CreateFhirOrganizationOutput = {
  __typename?: 'CreateFHIROrganizationOutput';
  insert_organizations_one: CreateOrganizationOutput;
};

export type CreateFhirPatientInput = {
  codexUUID: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateFhirPatientOutput = {
  __typename?: 'CreateFHIRPatientOutput';
  insert_users_one: CreatePatientOutput;
};

export type CreateFhirProviderInput = {
  codexId: Scalars['String'];
  email: Scalars['String'];
};

export type CreateFhirProviderOutput = {
  __typename?: 'CreateFHIRProviderOutput';
  insert_providers_one: ProviderOutput;
};

export type CreateFhirProviderRoleInput = {
  locationId: Scalars['String'];
  providerId: Scalars['String'];
};

export type CreateFhirProviderRoleOutput = {
  __typename?: 'CreateFHIRProviderRoleOutput';
  insert_provider_role_one: CreateProviderRoleOutput;
};

export type CreateFhirQuestionnaireResponsesOutput = {
  __typename?: 'CreateFHIRQuestionnaireResponsesOutput';
  questionnaire_response: CreateQuestionnaireResponsesOutput;
};

export type CreateFhirZrtTestInput = {
  codexProviderId?: InputMaybe<Scalars['String']>;
  health_questionnaire_pdf_id: Scalars['String'];
  questionnaire_response: Scalars['JSON'];
  reference_code: Scalars['String'];
  status: DiagnosticReportStatus;
  swab_code: Scalars['String'];
  swab_code_without_transform: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: InputMaybe<Scalars['String']>;
  zrt_questionnaire_response_id: Scalars['String'];
};

export type CreateFhirZrtTestOutput = {
  __typename?: 'CreateFHIRZrtTestOutput';
  zrt_test: CreateZrtOutput;
};

export type CreateInMailMessageInput = {
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  recipientCodexId: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type CreateMosaicTestInput = {
  codexProviderId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  swabCode: Scalars['String'];
  testId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CreateMosaicTestOutput = {
  __typename?: 'CreateMosaicTestOutput';
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
};

export type CreateOfficeLocationOutput = {
  __typename?: 'CreateOfficeLocationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  officeName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CreateOrderInput = {
  deliveryAddress?: InputMaybe<CreateDeliveryAddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']>;
  isIos?: InputMaybe<Scalars['Boolean']>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  promoCode?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  useSavedAddress?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganizationOutput = {
  __typename?: 'CreateOrganizationOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePatientOutput = {
  __typename?: 'CreatePatientOutput';
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_email: Scalars['String'];
  SENSITIVE_etnicity?: Maybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_pharmacies?: Maybe<Array<PharmacyInformationOutput>>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<PatientMeasurementsOutput>;
  id: Scalars['String'];
  stateDobValid?: Maybe<Scalars['Boolean']>;
};

export type CreateProviderRoleOutput = {
  __typename?: 'CreateProviderRoleOutput';
  locationId: Scalars['String'];
  providerId: Scalars['String'];
};

export type CreateQuestionnaireResponsesOutput = {
  __typename?: 'CreateQuestionnaireResponsesOutput';
  created_at: Scalars['String'];
  id: Scalars['String'];
};

export type CreateScheduleAppointmentBodyInput = {
  appointmentData: CreateFhirAppointmentInputWithoutPatientCodexId;
  appointmentRequestId?: InputMaybe<Scalars['String']>;
  appointmentTypeId: Scalars['Int'];
  calendarId: Scalars['Int'];
  datetime: Scalars['String'];
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  promoCode?: InputMaybe<Scalars['String']>;
};

export type CreateScheduleAppointmentOutput = {
  __typename?: 'CreateScheduleAppointmentOutput';
  appointmentDetails: AppointmentDetailGql;
  paymentLink: Scalars['String'];
  stripeRedirectedLink: Scalars['String'];
};

export type CreateSubPatientInput = {
  SENSITIVE_dob: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  relationship?: InputMaybe<SubPatientRelationship>;
};

export type CreateZrtOutput = {
  __typename?: 'CreateZrtOutput';
  created_at: Scalars['String'];
  health_questionnaire_pdf_id: Scalars['String'];
  swab_code: Scalars['String'];
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
};

export type CustomTokenInput = {
  token: Scalars['String'];
};

export type DnaValidTestBySwabCode = {
  __typename?: 'DNAValidTestBySwabCode';
  existingDnaTests: Scalars['Boolean'];
};

export type DateFilterArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};

/** Enum representing the possible values for provider_dea_licenses.type. */
export enum DeaLicenseType {
  Dea = 'DEA',
  Nadean = 'NADEAN',
  Primary = 'Primary'
}

export type DeaSchedulesAllowedInput = {
  schedule2?: InputMaybe<Scalars['Boolean']>;
  schedule3?: InputMaybe<Scalars['Boolean']>;
  schedule4?: InputMaybe<Scalars['Boolean']>;
  schedule5?: InputMaybe<Scalars['Boolean']>;
};

export type DeaSchedulesAllowedOutput = {
  __typename?: 'DeaSchedulesAllowedOutput';
  schedule2: Scalars['Boolean'];
  schedule3: Scalars['Boolean'];
  schedule4: Scalars['Boolean'];
  schedule5: Scalars['Boolean'];
};

export type DelegatedAdmin = {
  __typename?: 'DelegatedAdmin';
  acceptedAt?: Maybe<Scalars['String']>;
  accountDeletedAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationId: Scalars['String'];
  invitedAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type DelegatedAdminCodexIdInput = {
  delegatedAdminCodexId: Scalars['String'];
};

export type DelegatedAdminDetailsOutput = {
  __typename?: 'DelegatedAdminDetailsOutput';
  acceptedAt?: Maybe<Scalars['String']>;
  accountDeletedAt?: Maybe<Scalars['String']>;
  deletedByEmail?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invitationId: Scalars['String'];
  invitedAt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  permissions: Array<AdminPermissionType>;
};

/** Enum representing the possible values for sorting delegated admins. */
export enum DelegatedAdminOrderByCriterias {
  AcceptedAt = 'ACCEPTED_AT',
  InvitedAt = 'INVITED_AT'
}

export type DelegatedAdminOrderByInput = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<DelegatedAdminOrderByCriterias>;
};

export type DelegatedAdminSignupInput = {
  firebaseToken: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  token: Scalars['String'];
};

export type DeliveryAddressOutput = {
  __typename?: 'DeliveryAddressOutput';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  phone: Scalars['String'];
  state: Scalars['String'];
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
  zip_code: Scalars['String'];
};

export type DeliveryAddressesOutput = {
  __typename?: 'DeliveryAddressesOutput';
  delivery_addresses: Array<DeliveryAddressOutput>;
  total: Scalars['Int'];
};

export type DependentLinkOutput = {
  __typename?: 'DependentLinkOutput';
  childFullscriptId: Scalars['String'];
  guardianFullscriptId: Scalars['String'];
};

export type DiagnosticReportOrderByInput = {
  direction: OrderByDirections;
  field: OrderByCriterias;
};

/** Enum representing the possible values for "status" field in CreateFHIRZrtTestInput. */
export enum DiagnosticReportStatus {
  Amended = 'AMENDED',
  Appended = 'APPENDED',
  Cancelled = 'CANCELLED',
  Corrected = 'CORRECTED',
  EnteredInError = 'ENTERED_IN_ERROR',
  Final = 'FINAL',
  Partial = 'PARTIAL',
  Preliminary = 'PRELIMINARY',
  Registered = 'REGISTERED',
  Unknown = 'UNKNOWN'
}

export type DiagnosticSolutionOutput = {
  __typename?: 'DiagnosticSolutionOutput';
  testId: Scalars['String'];
  test_type: Scalars['String'];
};

export type DiagnosticSolutionsKitIdsOutput = {
  __typename?: 'DiagnosticSolutionsKitIdsOutput';
  count?: Maybe<Scalars['Int']>;
  kitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DiagnosticSolutionsValidateKitIdResult = {
  __typename?: 'DiagnosticSolutionsValidateKitIdResult';
  errorMessage?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  kitId: Scalars['String'];
};

export type DisconnectStripeAccountOutput = {
  __typename?: 'DisconnectStripeAccountOutput';
  status: Scalars['Int'];
};

export type DiscountOutput = {
  __typename?: 'DiscountOutput';
  amountOff?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Int']>;
};

/** Enum representing the possible values for "field" field in DnaVisitOrderByInput. */
export enum DnaVisitOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  ProviderName = 'PROVIDER_NAME',
  SapphirosBarcode = 'SAPPHIROS_BARCODE',
  TestType = 'TEST_TYPE'
}

export type DnaVisitOrderByInput = {
  direction: OrderByDirections;
  field: DnaVisitOrderByCriterias;
};

export type DnaVisitTestDefinition = {
  __typename?: 'DnaVisitTestDefinition';
  test_type: Hasura_Test_Types_Enum;
};

export type DnaVisitTestOutput = {
  __typename?: 'DnaVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  diagnosticReportId: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  molecular_order_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type DnaVisitTestWithUserOutput = {
  __typename?: 'DnaVisitTestWithUserOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  diagnosticReportId: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  dnavisit_tests_npi_data: DnaVisitTestsNpiData;
  dnavisit_tests_test: DnaVisitTestsTest;
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  molecular_order_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  sapphiros_results?: Maybe<Scalars['JSON']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type DnaVisitTestsNpiData = {
  __typename?: 'DnaVisitTestsNpiData';
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  npi_number: Scalars['String'];
  prefix: Scalars['String'];
};

export type DnaVisitTestsTest = {
  __typename?: 'DnaVisitTestsTest';
  tests_test_definition: DnaVisitTestDefinition;
  tests_user: DnaVisitTestsUser;
};

export type DnaVisitTestsUser = {
  __typename?: 'DnaVisitTestsUser';
  SENSITIVE_address_information?: Maybe<DnaVisitTestsUserAddressInformation>;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type DnaVisitTestsUserAddressInformation = {
  __typename?: 'DnaVisitTestsUserAddressInformation';
  addressLine1: Scalars['String'];
  addressLine2: Scalars['String'];
  city: Scalars['String'];
  phone: Scalars['String'];
  phoneCountry: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type DnaVitaminResponseOutput = {
  __typename?: 'DnaVitaminResponseOutput';
  dnaVitaminOrderId: Scalars['String'];
  testKitId: Scalars['String'];
  trackingNumber?: Maybe<Scalars['String']>;
};

export type DownloadInvoiceOrReceiptUrlOutput = {
  __typename?: 'DownloadInvoiceOrReceiptUrlOutput';
  invoiceUrl?: Maybe<Scalars['String']>;
  receiptUrl?: Maybe<Scalars['String']>;
};

export type DynamicQuestionnaireDependencies = {
  __typename?: 'DynamicQuestionnaireDependencies';
  if: Scalars['JSONObject'];
  then: ThenObject;
};

export type EPrescribeIframeJwtOutput = {
  __typename?: 'EPrescribeIframeJWTOutput';
  jwt: Scalars['String'];
  licenseId?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  userGuid?: Maybe<Scalars['String']>;
};

export type EPrescribeJwtInput = {
  mode: EPrescribeSsoMode;
  patientCodexId?: InputMaybe<Scalars['String']>;
};

export enum EPrescribeSsoMode {
  PatientLockDownMode = 'PatientLockDownMode',
  SsoidProofing = 'SSOIDProofing',
  TaskMode = 'TaskMode',
  UtilityMode = 'UtilityMode'
}

export type EducationCourseContentCounterOutput = {
  __typename?: 'EducationCourseContentCounterOutput';
  type: Scalars['String'];
  value: Scalars['Int'];
};

export type EducationCourseInput = {
  courseImageFileId: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  modules?: InputMaybe<Array<UpsertEducationModuleInput>>;
  title: Scalars['String'];
  visibilityRoles: Array<Roles_Enum>;
};

export type EducationCourseListItemOutput = {
  __typename?: 'EducationCourseListItemOutput';
  contentCounters: Array<EducationCourseContentCounterOutput>;
  courseImageFile: FileOutput;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  visibilityRoles: Array<Scalars['String']>;
};

/** Enum representing the possible values for EducationModuleItem category. */
export enum EducationCourseModuleItemCategory {
  Article = 'Article',
  Audio = 'Audio',
  Slides = 'Slides',
  Video = 'Video'
}

export type EducationCourseOutput = {
  __typename?: 'EducationCourseOutput';
  contentCounters: Array<EducationCourseContentCounterOutput>;
  courseImageFile: FileOutput;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  educationModules: Array<EducationModuleOutput>;
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  visibilityRoles: Array<Scalars['String']>;
};

export type EducationCoursesListOutput = {
  __typename?: 'EducationCoursesListOutput';
  courses: Array<EducationCourseListItemOutput>;
  total: Scalars['Int'];
};

export type EducationModuleAdditionalMaterialOutput = {
  __typename?: 'EducationModuleAdditionalMaterialOutput';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  linkedModule: LinkedEducationModuleOutput;
  linkedModuleId: Scalars['String'];
  moduleId: Scalars['String'];
};

export type EducationModuleItemOutput = {
  __typename?: 'EducationModuleItemOutput';
  category: EducationCourseModuleItemCategory;
  createdAt: Scalars['String'];
  file: FileOutput;
  id: Scalars['String'];
  moduleId: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EducationModuleOutput = {
  __typename?: 'EducationModuleOutput';
  additionalMaterialsModules?: Maybe<Array<EducationModuleAdditionalMaterialOutput>>;
  courseId: Scalars['String'];
  createdAt: Scalars['String'];
  educationModuleItems?: Maybe<Array<EducationModuleItemOutput>>;
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EducationModulesListOutput = {
  __typename?: 'EducationModulesListOutput';
  modules: Array<EducationModuleOutput>;
  total: Scalars['Int'];
};

export type EncounterFileOutput = {
  __typename?: 'EncounterFileOutput';
  contentType?: Maybe<ContentType>;
  creation?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EncounterListOutput = {
  __typename?: 'EncounterListOutput';
  encounters: Array<EncounterOutput>;
  total: Scalars['Int'];
};

export type EncounterOutput = {
  __typename?: 'EncounterOutput';
  appointmentCodexId?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  encounterId: Scalars['String'];
  finishedAt?: Maybe<Scalars['String']>;
  patientCodexId?: Maybe<Scalars['String']>;
  patientFirstName?: Maybe<Scalars['String']>;
  patientLastName?: Maybe<Scalars['String']>;
  providerCodexId?: Maybe<Scalars['String']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** Encounter statuses extracted from FHIR: https://hl7.org/fhir/R4/valueset-encounter-status.html */
export enum EncounterStatuses {
  Arrived = 'arrived',
  Cancelled = 'cancelled',
  EnteredInError = 'entered_in_error',
  Finished = 'finished',
  InProgress = 'in_progress',
  Onleave = 'onleave',
  Planned = 'planned',
  Triaged = 'triaged',
  Unknown = 'unknown'
}

export type ExportUserDataOutput = {
  __typename?: 'ExportUserDataOutput';
  downloadUrl: Scalars['String'];
};

export type FhirAppointmentNotesObservation = {
  anythingElseQuestion?: InputMaybe<Scalars['String']>;
  howLongQuestion?: InputMaybe<Scalars['String']>;
  severityQuestion?: InputMaybe<Scalars['String']>;
  symptomsTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type FhirAppointmentNotesObservationOutput = {
  __typename?: 'FHIRAppointmentNotesObservationOutput';
  anythingElseQuestion?: Maybe<Scalars['String']>;
  howLongQuestion?: Maybe<Scalars['String']>;
  practitionerNotes?: Maybe<Scalars['String']>;
  severityQuestion?: Maybe<Scalars['String']>;
  symptomsTypes?: Maybe<Array<Scalars['String']>>;
};

export type FhirEncounterNotesOutput = {
  __typename?: 'FHIREncounterNotesOutput';
  files?: Maybe<Array<EncounterFileOutput>>;
  followupRecommendations: Scalars['String'];
  lastUpdated: Scalars['String'];
  providerNotes: Scalars['String'];
  providerSummary: Scalars['String'];
  systemGenerated: Scalars['String'];
  transcription: Scalars['String'];
};

/** Enum representing the possible values for sorting FHIR patients. */
export enum FhirPatientOrderByCriterias {
  LastAppointmentDate = 'LAST_APPOINTMENT_DATE',
  PatientName = 'PATIENT_NAME',
  SensitiveEmail = 'SENSITIVE_EMAIL',
  SensitiveFirstname = 'SENSITIVE_FIRSTNAME',
  SensitiveLastname = 'SENSITIVE_LASTNAME',
  StartPatientDate = 'START_PATIENT_DATE'
}

/** Enum representing the possible values for sorting FHIR recommendations. */
export enum FhirRecommendationsOrderByCriterias {
  CreatedAt = 'CreatedAt'
}

export type FedexTrackingResponse = {
  __typename?: 'FedexTrackingResponse';
  isValid: Scalars['Boolean'];
};

/** Enum representing the possible values for "questionnaireName" field in AttachQuestionnaireResponseInputment. */
export enum FhirQuestionnaireNames {
  DiagnosticSolutionQuestionnaire = 'DIAGNOSTIC_SOLUTION_QUESTIONNAIRE',
  DnaVitaminQuestionnaire = 'DNA_VITAMIN_QUESTIONNAIRE',
  HealthQuestionnaire = 'HEALTH_QUESTIONNAIRE',
  MosaicQuestionnaire = 'MOSAIC_QUESTIONNAIRE',
  ZrtQuestionnaire = 'ZRT_QUESTIONNAIRE'
}

export type FileAttachmentInput = {
  contentType: ContentType;
  fileId: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type FileOutput = {
  __typename?: 'FileOutput';
  contentType?: Maybe<Scalars['String']>;
  creation?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** Enum representation of file types */
export enum FileTypesEnum {
  Archive = 'Archive',
  Audio = 'Audio',
  Document = 'Document',
  Image = 'Image',
  Other = 'Other',
  Pdf = 'Pdf',
  Presentation = 'Presentation',
  Spreadsheet = 'Spreadsheet',
  Text = 'Text',
  Video = 'Video'
}

export type FormatedAvailableTime = {
  __typename?: 'FormatedAvailableTime';
  enabled: Scalars['Boolean'];
  end: Scalars['String'];
  start: Scalars['String'];
};

export type FromFhirToHasuraAnswerItemUnion = HasuraAnswerItem | HasuraMedicationItem;

export type FullscriptAllergenOutput = {
  __typename?: 'FullscriptAllergenOutput';
  created_at: Scalars['String'];
  fullscript_id: Scalars['String'];
  fullscript_name: Scalars['String'];
  id: Scalars['Int'];
  updated_at: Scalars['String'];
};

export type FullscriptAllergensOutput = {
  __typename?: 'FullscriptAllergensOutput';
  fullscript_allergens: Array<FullscriptAllergenOutput>;
  total: Scalars['Int'];
};

export type FullscriptOperationResult = {
  __typename?: 'FullscriptOperationResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type FullscriptSessionGrantResult = {
  __typename?: 'FullscriptSessionGrantResult';
  patientFullscriptId: Scalars['String'];
  sessionGrant: Scalars['String'];
};

export type GetAppointmentChatMessagesOutput = {
  __typename?: 'GetAppointmentChatMessagesOutput';
  chat?: Maybe<AppointmentChat>;
};

export type GetAppointmentMediaOutput = {
  __typename?: 'GetAppointmentMediaOutput';
  bodySite?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fhirId: Scalars['String'];
  fileId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type GetAppointmentNotesByAppointmentIdOutput = {
  __typename?: 'GetAppointmentNotesByAppointmentIdOutput';
  nabla_notes: Array<NablaNote>;
};

export type GetAppointmentOutput = {
  __typename?: 'GetAppointmentOutput';
  acuityId?: Maybe<Scalars['String']>;
  appointmentCodexId: Scalars['String'];
  appointmentId: Scalars['String'];
  appointmentNotes?: Maybe<FhirAppointmentNotesObservationOutput>;
  appointmentStatus?: Maybe<Scalars['Int']>;
  appointmentType?: Maybe<AppointmentTypeEnum>;
  appointmentUrl?: Maybe<Scalars['String']>;
  cancelationReason?: Maybe<Scalars['String']>;
  codexPatientId: Scalars['String'];
  codexProviderId?: Maybe<Scalars['String']>;
  created: Scalars['String'];
  diagnosticReports?: Maybe<Array<GetFhirAppointmentDiagnosticReportOutput>>;
  encounterId?: Maybe<Scalars['String']>;
  encounterNotes?: Maybe<FhirEncounterNotesOutput>;
  end?: Maybe<Scalars['String']>;
  events?: Maybe<Array<AppointmentEvent>>;
  isSummaryCompleted: Scalars['Boolean'];
  lastProcessedDate: Scalars['String'];
  lastUpdate?: Maybe<Scalars['String']>;
  media?: Maybe<Array<GetAppointmentMediaOutput>>;
  participant: Array<ReferenceType>;
  patientFirstName?: Maybe<Scalars['String']>;
  patientLastName?: Maybe<Scalars['String']>;
  paymentInformation?: Maybe<AppointmentPaymentOutput>;
  paymentSessionOpenedAt?: Maybe<Scalars['String']>;
  pendingRescheduleRequest?: Maybe<AppointmentRequestOutput>;
  provider?: Maybe<ProviderOutput>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Array<GetFhirRecommendationOutput>>;
  start?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusHistory: Array<AppointmentStatusHistoryEntry>;
  subjectOfAppointment?: Maybe<Scalars['String']>;
  summaryPdfFileId?: Maybe<Scalars['String']>;
  supportingInformation?: Maybe<Array<ReferenceType>>;
  symptomsLocation?: Maybe<Array<Scalars['String']>>;
  transcriptionReadyAt?: Maybe<Scalars['String']>;
  visitSummaryPdfUrl?: Maybe<Scalars['String']>;
};

export type GetAppointmentRescheduleLinkOutput = {
  __typename?: 'GetAppointmentRescheduleLinkOutput';
  rescheduleLink?: Maybe<Scalars['String']>;
};

export type GetAppointmentRescheduleRequestInput = {
  appointmentId?: InputMaybe<Scalars['String']>;
  appointmentRescheduleRequestId?: InputMaybe<Scalars['String']>;
};

export type GetAvailableAppointmentTypesResult = {
  __typename?: 'GetAvailableAppointmentTypesResult';
  appointmentTypes?: Maybe<Array<AppointmentType>>;
};

export type GetBasicPatientInfoOutput = {
  __typename?: 'GetBasicPatientInfoOutput';
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_birth_date?: Maybe<Scalars['String']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_etnicity?: Maybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_pharmacies?: Maybe<Array<PharmacyInformationOutput>>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<PatientMeasurementsOutput>;
  appointments?: Maybe<Array<GetAppointmentOutput>>;
  canReceivePrescriptions: Scalars['Boolean'];
  child_fully_verified?: Maybe<Scalars['Boolean']>;
  fhirId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kyc_approved: Scalars['Boolean'];
  lastAppointmentDate?: Maybe<Scalars['String']>;
  parentCodexId?: Maybe<Scalars['String']>;
  requestStatus?: Maybe<ProviderRequestStatus>;
};

export type GetBecomePatientRequestsInput = {
  statuses?: InputMaybe<Array<ProviderRequestStatus>>;
};

export type GetDelegatedAdminsInput = {
  inviteDateFrom?: InputMaybe<Scalars['String']>;
  inviteDateTo?: InputMaybe<Scalars['String']>;
  isAccepted?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type GetDelegatedAdminsOutput = {
  __typename?: 'GetDelegatedAdminsOutput';
  delegatedAdmins: Array<DelegatedAdmin>;
  total: Scalars['Int'];
};

export type GetEducationModulesInput = {
  excludeModuleIds?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Roles_Enum>>;
};

export type GetEncounterSignedUrlInput = {
  encounterId: Scalars['String'];
  fileId: Scalars['String'];
};

export type GetFhirAppointmentDiagnosticReportOutput = {
  __typename?: 'GetFHIRAppointmentDiagnosticReportOutput';
  createdAt?: Maybe<Scalars['String']>;
  diagnosticReportId: Scalars['String'];
  diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum;
  diagnosticReportTestType: Hasura_Test_Types_Enum;
  patientPdf?: Maybe<FileOutput>;
  patientPdfId?: Maybe<Scalars['String']>;
  providerPdf?: Maybe<FileOutput>;
  providerPdfId?: Maybe<Scalars['String']>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swabCode: Scalars['String'];
};

export type GetFhirAppointmentOutput = {
  __typename?: 'GetFHIRAppointmentOutput';
  appointment?: Maybe<GetAppointmentOutput>;
};

export type GetFhirAppointmentsOutput = {
  __typename?: 'GetFHIRAppointmentsOutput';
  appointment: Array<GetAppointmentOutput>;
  total: Scalars['Int'];
};

export type GetFhirAppointmentsOutputWithUpcomingCounts = {
  __typename?: 'GetFHIRAppointmentsOutputWithUpcomingCounts';
  appointment: Array<GetAppointmentOutput>;
  counts: UpcomingAppointmentCounts;
  total: Scalars['Int'];
};

export type GetFhirDnaAndZrtTests = {
  __typename?: 'GetFHIRDnaAndZrtTests';
  diagnostic_solution_tests: Array<RankedDiagnosticSolutionVisitTestOutput>;
  dna_tests: Array<RankedDnaVisitTestOutput>;
  mosaic_tests: Array<RankedMosaicVisitTestOutput>;
  total: Scalars['Int'];
  zrt_tests: Array<RankedZrtTestOutput>;
};

export type GetFhirDnaVisitTestByIdentifier = {
  __typename?: 'GetFHIRDnaVisitTestByIdentifier';
  dnavisit_tests?: Maybe<Array<DnaVisitTestWithUserOutput>>;
};

export type GetFhirDnaVisitTests = {
  __typename?: 'GetFHIRDnaVisitTests';
  dnavisit_tests: Array<DnaVisitTestOutput>;
  total: Scalars['Int'];
};

export type GetFhirDnaVisitTestsByUserId = {
  __typename?: 'GetFHIRDnaVisitTestsByUserId';
  dnavisit_tests: Array<DnaVisitTestOutput>;
  providers: Array<Scalars['String']>;
  total: Scalars['Int'];
};

export type GetFhirMosaicTests = {
  __typename?: 'GetFHIRMosaicTests';
  mosaicTests?: Maybe<Array<MosaicTestOutput>>;
  total: Scalars['Int'];
};

export type GetFhirPatientsByIdDateFilterInput = {
  appointmentDateEnd: Scalars['String'];
  appointmentDateStart: Scalars['String'];
};

export type GetFhirPatientsByIdOrderByInput = {
  direction: OrderByDirections;
  field: FhirPatientOrderByCriterias;
};

export type GetFhirPatientsByProviderIdOutput = {
  __typename?: 'GetFHIRPatientsByProviderIdOutput';
  patients: Array<PatientWithMemberOutput>;
  total: Scalars['Int'];
};

export type GetFhirProviderBioByIdOutput = {
  __typename?: 'GetFHIRProviderBioByIdOutput';
  providers: Array<ProviderOutput>;
};

export type GetFhirProviderByEmailOutput = {
  __typename?: 'GetFHIRProviderByEmailOutput';
  providers: Array<ProviderOutput>;
};

export type GetFhirProviderByIdOutput = {
  __typename?: 'GetFHIRProviderByIdOutput';
  providers: Array<ProviderOutput>;
  total?: Maybe<Scalars['Int']>;
};

export type GetFhirProvidersByDnaAndZrtTests = {
  __typename?: 'GetFHIRProvidersByDnaAndZrtTests';
  provider_names: Array<Scalars['String']>;
  total: Scalars['Int'];
};

export type GetFhirProvidersOutput = {
  __typename?: 'GetFHIRProvidersOutput';
  providers: Array<ProviderOutput>;
  total?: Maybe<Scalars['Float']>;
};

export type GetFhirQuestionnaireResponse = {
  __typename?: 'GetFHIRQuestionnaireResponse';
  questionnaire_response: GetQuestionnaireResponse;
};

export type GetFhirQuestionnaireResponseArr = {
  __typename?: 'GetFHIRQuestionnaireResponseArr';
  data: Array<GetQuestionnaireResponse>;
};

export type GetFhirRecommendationOutput = {
  __typename?: 'GetFHIRRecommendationOutput';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  productId: Scalars['Int'];
  productTitle: Scalars['String'];
  providerCodexId: Scalars['String'];
  providerName: Scalars['String'];
  quantity: Scalars['Int'];
  status: ServiceRequestStatus;
  totalPrice: Scalars['Float'];
};

export type GetFhirRecommendationsOrderByInput = {
  direction?: OrderByDirections;
  field?: FhirRecommendationsOrderByCriterias;
};

export type GetFhirRecommendationsOutput = {
  __typename?: 'GetFHIRRecommendationsOutput';
  recommendations: Array<GetFhirRecommendationOutput>;
  total: Scalars['Int'];
};

export type GetFhirZrtTest = {
  __typename?: 'GetFHIRZrtTest';
  zrt_test: ZrtTestOutput;
};

export type GetFhirZrtTests = {
  __typename?: 'GetFHIRZrtTests';
  zrt_tests: Array<ZrtTestOutput>;
};

export type GetFreeProvidersByTimeSlotsInput = {
  acceptedAppointments?: InputMaybe<Array<Scalars['String']>>;
  appointmentTypeId: Scalars['String'];
  date: Scalars['String'];
  gender?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  medicalRole?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  serverOfferedRange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  yearOfExperienceRange?: InputMaybe<Scalars['String']>;
};

export type GetInMailDetailInput = {
  contactCodexId?: InputMaybe<Scalars['String']>;
  inMailId?: InputMaybe<Scalars['String']>;
};

export type GetInMailsInput = {
  contactCodexId?: InputMaybe<Scalars['String']>;
  queryName?: InputMaybe<Scalars['String']>;
};

export type GetLastViewedPatientByUserQueryOutput = {
  __typename?: 'GetLastViewedPatientByUserQueryOutput';
  patients: Array<GetPatientOutput>;
};

export type GetLastViewedProvidersByUserQueryOutput = {
  __typename?: 'GetLastViewedProvidersByUserQueryOutput';
  providers: Array<ProviderOutput>;
};

export type GetLatestFhirQuestionnaireById = {
  __typename?: 'GetLatestFHIRQuestionnaireById';
  id: Scalars['String'];
  responses: Scalars['JSON'];
};

export type GetLatestFhirQuestionnaireByIdResponse = {
  __typename?: 'GetLatestFHIRQuestionnaireByIdResponse';
  questionnaire_responses: Array<GetLatestFhirQuestionnaireById>;
};

export type GetLegalDocumentInput = {
  type: Hasura_Legal_Document_Types_Enum;
  version?: InputMaybe<Scalars['Int']>;
};

export type GetLegalDocumentsInput = {
  types?: InputMaybe<Array<Hasura_Legal_Document_Types_Enum>>;
};

export type GetMediaFilesOutput = {
  __typename?: 'GetMediaFilesOutput';
  files: Array<MediaFileOutput>;
  total: Scalars['Int'];
};

export type GetMedicationRequestsBrandAndNameOutput = {
  __typename?: 'GetMedicationRequestsBrandAndNameOutput';
  medication_request_bran_and_names: Array<Scalars['String']>;
};

export type GetMedicationRequestsOutput = {
  __typename?: 'GetMedicationRequestsOutput';
  medication_requests: Array<MedicationRequestOutputDto>;
  total: Scalars['Int'];
};

export type GetMemberGroupOutput = {
  __typename?: 'GetMemberGroupOutput';
  inactive?: Maybe<Scalars['Boolean']>;
  period?: Maybe<GroupPeriod>;
};

export type GetPatientOutput = {
  __typename?: 'GetPatientOutput';
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_etnicity?: Maybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_pharmacies?: Maybe<Array<PharmacyInformationOutput>>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<PatientMeasurementsOutput>;
  account_closed_at?: Maybe<Scalars['String']>;
  account_closure_reason?: Maybe<Scalars['String']>;
  autonomy_determination_status?: Maybe<AutonomyDeterminationStatus>;
  blocked_at?: Maybe<Scalars['String']>;
  canReceivePrescriptions: Scalars['Boolean'];
  child_fully_verified?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['String'];
  data_retention_until?: Maybe<Scalars['String']>;
  highContrastMode: Scalars['Boolean'];
  id: Scalars['String'];
  identifiers?: Maybe<PatientIdentifiersOutput>;
  isContactInfoCompleted?: Maybe<Scalars['Boolean']>;
  isProfileCompleted?: Maybe<Scalars['Boolean']>;
  isQuestionnaireCompleted?: Maybe<Scalars['Boolean']>;
  is_state_dob_valid: Scalars['Boolean'];
  measurementsLastUpdatedAt?: Maybe<Scalars['String']>;
  minor_autonomy_evidence: Array<MinorAutonomyEvidenceTypes>;
  parentCodexId?: Maybe<Scalars['String']>;
  required_agreements_approved?: Maybe<Scalars['Boolean']>;
  sapphirosId?: Maybe<Scalars['String']>;
  skinTreatmentBannerDismissedAt?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type GetPaymentLinkOutput = {
  __typename?: 'GetPaymentLinkOutput';
  link: Scalars['String'];
};

export type GetPersonaSessionTokenResponse = {
  __typename?: 'GetPersonaSessionTokenResponse';
  sessionToken: Scalars['String'];
};

export type GetProductsOutput = {
  __typename?: 'GetProductsOutput';
  lastShipMonkSyncAt?: Maybe<Scalars['String']>;
  products: Array<ProductOutput>;
  total: Scalars['Int'];
};

export type GetProviderBioById = {
  __typename?: 'GetProviderBioById';
  providers: ProviderOutput;
};

export type GetProviderBioByIdQueryOutput = {
  __typename?: 'GetProviderBioByIdQueryOutput';
  providers: Array<GetProviderBioById>;
};

export type GetProviderPaymentDetailsOutput = {
  __typename?: 'GetProviderPaymentDetailsOutput';
  amount: Scalars['Float'];
  lastPaymentAt?: Maybe<Scalars['String']>;
};

export type GetQuestionnaireOutput = {
  __typename?: 'GetQuestionnaireOutput';
  data: Array<QuestionnaireDependenciesGroup>;
  questionnaires_questionnaire_questions: Array<QuestionnairesQuestionnaireQuestions>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GetQuestionnaireResponse = {
  __typename?: 'GetQuestionnaireResponse';
  created_at?: Maybe<Scalars['String']>;
  current_step_index?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  is_complete: QuestionnaireResponseStatus;
  responses: Array<FromFhirToHasuraAnswerItemUnion>;
  swab_code?: Maybe<Scalars['String']>;
  test_name_type?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type GetSignUrlFromStorageByAdminInput = {
  fileId: Scalars['String'];
  userId: Scalars['String'];
};

export type GetSuperAdminsInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type GetSuperAdminsOutput = {
  __typename?: 'GetSuperAdminsOutput';
  superAdmins: Array<SuperAdminListItem>;
  total: Scalars['Int'];
};

export type GetSupportChatDetailInput = {
  chatId?: InputMaybe<Scalars['String']>;
};

export type GetSupportChatsInput = {
  queryName?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Roles_Enum>;
};

export type GetUserNotificationsWithCounts = {
  __typename?: 'GetUserNotificationsWithCounts';
  notifications: Array<NotificationOutput>;
  total: Scalars['Int'];
  unreadCount: Scalars['Float'];
};

/** Enum representing possible url values for resources extensions */
export enum GoogleEhrExtensionsUrLs {
  CreatedAt = 'CREATED_AT',
  EhrAbout = 'EHR_ABOUT',
  EhrAppointmentChatAttachmentFileId = 'EHR_APPOINTMENT_CHAT_ATTACHMENT_FILE_ID',
  EhrAppointmentChatAttachmentFrom = 'EHR_APPOINTMENT_CHAT_ATTACHMENT_FROM',
  EhrAppointmentDiagnosticReportId = 'EHR_APPOINTMENT_DIAGNOSTIC_REPORT_ID',
  EhrAppointmentLastProcessedStartDate = 'EHR_APPOINTMENT_LAST_PROCESSED_START_DATE',
  EhrAppointmentPaidStatus = 'EHR_APPOINTMENT_PAID_STATUS',
  EhrAppointmentSummaryPdfFileId = 'EHR_APPOINTMENT_SUMMARY_PDF_FILE_ID',
  EhrAppointmentUrl = 'EHR_APPOINTMENT_URL',
  EhrAutonomyDeterminationStatusUrl = 'EHR_AUTONOMY_DETERMINATION_STATUS_URL',
  EhrDeviceCode = 'EHR_DEVICE_CODE',
  EhrDnaVisitProviderNpi = 'EHR_DNA_VISIT_PROVIDER_NPI',
  EhrDnaVisitState = 'EHR_DNA_VISIT_STATE',
  EhrDsGiMapVisitState = 'EHR_DS_GI_MAP_VISIT_STATE',
  EhrEncounterDocumentReference = 'EHR_ENCOUNTER_DOCUMENT_REFERENCE',
  EhrGenderDescribe = 'EHR_GENDER_DESCRIBE',
  EhrLastProcessedTestKitDate = 'EHR_LAST_PROCESSED_TEST_KIT_DATE',
  EhrLastProcessedTestKitStatus = 'EHR_LAST_PROCESSED_TEST_KIT_STATUS',
  EhrMedicationIsBrand = 'EHR_MEDICATION_IS_BRAND',
  EhrMinorAutonomyEvidenceUrl = 'EHR_MINOR_AUTONOMY_EVIDENCE_URL',
  EhrMosaicId = 'EHR_MOSAIC_ID',
  EhrMosaicVisitState = 'EHR_MOSAIC_VISIT_STATE',
  EhrNpiNumber = 'EHR_NPI_NUMBER',
  EhrProviderNoteType = 'EHR_PROVIDER_NOTE_TYPE',
  EhrQuestionnaireResponseCurrentIndexOfSection = 'EHR_QUESTIONNAIRE_RESPONSE_CURRENT_INDEX_OF_SECTION',
  EhrQuestionnaireResponseCurrentSection = 'EHR_QUESTIONNAIRE_RESPONSE_CURRENT_SECTION',
  EhrQuestionnaireResponseCurrentStepIndex = 'EHR_QUESTIONNAIRE_RESPONSE_CURRENT_STEP_INDEX',
  EhrQuestionnaireResponseIsArrayOfStrings = 'EHR_QUESTIONNAIRE_RESPONSE_IS_ARRAY_OF_STRINGS',
  EhrQuestionnaireResponseMedicationStatus = 'EHR_QUESTIONNAIRE_RESPONSE_MEDICATION_STATUS',
  EhrRaceExtension = 'EHR_RACE_EXTENSION',
  EhrResidencyEndDate = 'EHR_RESIDENCY_END_DATE',
  EhrResidencyStartDate = 'EHR_RESIDENCY_START_DATE',
  EhrResidencyStillActive = 'EHR_RESIDENCY_STILL_ACTIVE',
  EhrServiceOfferingPrice = 'EHR_SERVICE_OFFERING_PRICE',
  EhrSwabcode = 'EHR_SWABCODE',
  EhrTrackingNumber = 'EHR_TRACKING_NUMBER',
  EhrZrtState = 'EHR_ZRT_STATE',
  FullscriptUpdatedAt = 'FULLSCRIPT_UPDATED_AT',
  PhoneExtension = 'PHONE_EXTENSION',
  SelfIndentityGenderExtension = 'SELF_INDENTITY_GENDER_EXTENSION',
  StateDobValidUrl = 'STATE_DOB_VALID_URL'
}

export type GroupPeriod = {
  __typename?: 'GroupPeriod';
  start?: Maybe<Scalars['String']>;
};

export type HasuraAnswerItem = {
  __typename?: 'HasuraAnswerItem';
  child_questions?: Maybe<Array<Scalars['Int']>>;
  currentIndexOfSection?: Maybe<Scalars['Int']>;
  currentSection?: Maybe<Scalars['String']>;
  hasuraItemArrayResponse?: Maybe<Array<HasuraAnswerItem>>;
  hasuraMedicationItemResponse?: Maybe<HasuraMedicationItem>;
  questionID?: Maybe<Scalars['Int']>;
  responseType: Scalars['String'];
  stringArrayResponse?: Maybe<Array<Scalars['String']>>;
  stringResponse?: Maybe<Scalars['String']>;
};

export type HasuraMedicationItem = {
  __typename?: 'HasuraMedicationItem';
  child_questions?: Maybe<Array<Scalars['Int']>>;
  completed?: Maybe<Scalars['Boolean']>;
  hasuraItemArrayResponse?: Maybe<Array<HasuraAnswerItem>>;
  hasuraMedicationItemResponse?: Maybe<HasuraMedicationItem>;
  id: Scalars['String'];
  responseType: Scalars['String'];
  stringArrayResponse?: Maybe<Array<Scalars['String']>>;
  stringResponse?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "state" field in DnaVisitTestOutput. */
export enum Hasura_Dnavisit_Test_Statuses_Enum {
  AppointmentScheduled = 'AppointmentScheduled',
  ApprovedByProvider = 'ApprovedByProvider',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Issue = 'Issue',
  KitNotReceived = 'KitNotReceived',
  ProviderPending = 'ProviderPending',
  ReceivedByLab = 'ReceivedByLab',
  RegistrationFailed = 'RegistrationFailed',
  ResultsWithProvider = 'ResultsWithProvider'
}

/** Enum representing the possible values for laboratory names */
export enum Hasura_Labs_Enum {
  DiagnosticSolutions = 'DiagnosticSolutions',
  DnaVisit = 'DnaVisit',
  MolecularLabs = 'MolecularLabs',
  Mosaic = 'Mosaic',
  Zrt = 'Zrt'
}

/** Legal document types for remote schema fields (maps to Hasura legal_document_types values). */
export enum Hasura_Legal_Document_Types_Enum {
  BaaAgreement = 'BaaAgreement',
  CancellationPolicy = 'CancellationPolicy',
  ConsentToUseAndDiscloseSudRecords = 'ConsentToUseAndDiscloseSudRecords',
  CoppaAgreement = 'CoppaAgreement',
  DnaVisitRecordConsent = 'DnaVisitRecordConsent',
  GeneralTestRecordConsent = 'GeneralTestRecordConsent',
  HippaAgreement = 'HippaAgreement',
  LabSampleResultsPrivacyStatement = 'LabSampleResultsPrivacyStatement',
  NoticeOfPrivacy = 'NoticeOfPrivacy',
  PrivacyPolicy = 'PrivacyPolicy',
  ProviderDataUserAgreement = 'ProviderDataUserAgreement',
  TermsOfService = 'TermsOfService'
}

/** Enum representing the possible values for "test_type" field in PatchZrtOutput. */
export enum Hasura_Test_Types_Enum {
  DnaSkin = 'DnaSkin',
  DnaVitamin = 'DnaVitamin',
  DsGiMap = 'DsGiMap',
  MosaicOat = 'MosaicOat',
  Skintelligent = 'Skintelligent',
  ZrtHeavyMetals = 'ZrtHeavyMetals',
  ZrtHormone = 'ZrtHormone',
  ZrtInflammatory = 'ZrtInflammatory',
  ZrtNeurotransmitters = 'ZrtNeurotransmitters'
}

export type HttpStatusOutput = {
  __typename?: 'HttpStatusOutput';
  message?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
};

export type IdOutput = {
  __typename?: 'IdOutput';
  id: Scalars['String'];
};

export type Identifier = {
  __typename?: 'Identifier';
  system?: Maybe<Scalars['String']>;
  type?: Maybe<CodeableConcept>;
  use?: Maybe<IdentifierUse>;
  value?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "use" field in Identifier. */
export enum IdentifierUse {
  Official = 'OFFICIAL',
  Old = 'OLD',
  Secondary = 'SECONDARY',
  Temp = 'TEMP',
  Usual = 'USUAL'
}

export type InMailDetailsOutput = {
  __typename?: 'InMailDetailsOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  messages: Array<InMailMessageOutput>;
  nextPageToken?: Maybe<Scalars['String']>;
  patient: InMailParticipantOutput;
  provider: InMailParticipantOutput;
};

export type InMailMessageOutput = {
  __typename?: 'InMailMessageOutput';
  attachments: Array<Attachment>;
  date: Scalars['String'];
  senderCodexId: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type InMailOutput = {
  __typename?: 'InMailOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  patient: InMailParticipantOutput;
  provider: InMailParticipantOutput;
  read?: Maybe<Scalars['Boolean']>;
};

export type InMailParticipantOutput = {
  __typename?: 'InMailParticipantOutput';
  codexId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profilePictureId?: Maybe<Scalars['String']>;
};

export type InMailUsageOutput = {
  __typename?: 'InMailUsageOutput';
  updatedAt: Scalars['String'];
  used: Scalars['Int'];
};

export type InMailsOutput = {
  __typename?: 'InMailsOutput';
  contactsWithoutChats: Array<InMailParticipantOutput>;
  inMails: Array<InMailOutput>;
  newTotal: Scalars['Int'];
  total: Scalars['Int'];
};

export type InitialFillOutput = {
  __typename?: 'InitialFillOutput';
  duration?: Maybe<ValueOutput>;
  quantity?: Maybe<ValueOutput>;
};

export type InsertAppointmentChatMessages = {
  appointmentCodexId: Scalars['String'];
  communicationFhirId: Scalars['String'];
  messages: Array<AppointmentChatMessageInput>;
};

export type InsertAppointmentChatMessagesByAppointmentCodexId = {
  appointmentCodexId: Scalars['String'];
  messages: Array<AppointmentChatMessageInput>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type IsNpiValid = {
  __typename?: 'IsNpiValid';
  isValid: Scalars['Boolean'];
};

export type IsValidSwabCode = {
  __typename?: 'IsValidSwabCode';
  id: Scalars['String'];
  isValid: Scalars['Boolean'];
  lab_name?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  swab_code: Scalars['String'];
  swab_usage_type: Scalars['String'];
  test_type?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "language" field in Attachment. */
export enum Language {
  EnUs = 'EN_US'
}

export type LegalDocumentOutput = {
  __typename?: 'LegalDocumentOutput';
  contentMobile: Scalars['String'];
  contentWeb: Scalars['String'];
  type: Hasura_Legal_Document_Types_Enum;
  updatedAt: Scalars['String'];
  updatedByFullName: Scalars['String'];
  version: Scalars['Int'];
};

export type LegalDocumentsOutput = {
  __typename?: 'LegalDocumentsOutput';
  legalDocuments: Array<LegalDocumentOutput>;
};

export type LinkProviderAccountInput = {
  tokenCode: Scalars['String'];
};

export type LinkedEducationModuleOutput = {
  __typename?: 'LinkedEducationModuleOutput';
  courseId: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type MapDependentInput = {
  childCodexId: Scalars['String'];
  fullscriptPatientId: Scalars['String'];
};

export type MediaFileOutput = {
  __typename?: 'MediaFileOutput';
  appointment?: Maybe<GetAppointmentOutput>;
  authorCodexId?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  creation?: Maybe<Scalars['String']>;
  encounterId?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  patient?: Maybe<GetPatientOutput>;
  provider?: Maybe<ProviderOutput>;
  size?: Maybe<Scalars['Int']>;
  sourceType?: Maybe<MediaFileSourceType>;
  url?: Maybe<Scalars['String']>;
};

/** Enum representation of media file types */
export enum MediaFileSourceType {
  AppointmentDiagnostics = 'APPOINTMENT_DIAGNOSTICS',
  Archive = 'ARCHIVE',
  EducationCourseDetails = 'EDUCATION_COURSE_DETAILS',
  EducationCourseModuleMaterial = 'EDUCATION_COURSE_MODULE_MATERIAL',
  InMail = 'IN_MAIL',
  MedicalRecord = 'MEDICAL_RECORD',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  Product = 'PRODUCT',
  Questionnaire = 'QUESTIONNAIRE',
  QuestionnaireResponse = 'QUESTIONNAIRE_RESPONSE',
  Summary = 'SUMMARY',
  SupportChat = 'SUPPORT_CHAT',
  TestKit = 'TEST_KIT',
  User = 'USER',
  Vonage = 'VONAGE'
}

export type MediaFilesFilterInput = {
  contentTypes?: InputMaybe<Array<FileTypesEnum>>;
  dates?: InputMaybe<DateFilterArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  sourceTypes?: InputMaybe<Array<MediaFileSourceType>>;
};

export type MediaOutput = {
  __typename?: 'MediaOutput';
  bodySite?: Maybe<CodeableConcept>;
  content: Attachment;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Array<ResourceExtension>>;
  fileId: Scalars['String'];
  id: Scalars['String'];
  identifier?: Maybe<Array<Identifier>>;
  meta: Meta;
  resourceType: ResourcesTypes;
  status: MediaStatus;
  text?: Maybe<Narrative>;
};

/** Enum representing the possible values for "status" field in Media. */
export enum MediaStatus {
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  NotDone = 'NOT_DONE',
  OnHold = 'ON_HOLD',
  Preparation = 'PREPARATION',
  Stopped = 'STOPPED',
  Unknown = 'UNKNOWN'
}

export type MedicationOutput = {
  __typename?: 'MedicationOutput';
  activeIngredUnit?: Maybe<Scalars['String']>;
  activeNumeratorStrength?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  productId?: Maybe<Scalars['String']>;
  productNdc?: Maybe<Scalars['String']>;
  proprietaryName?: Maybe<Scalars['String']>;
};

export type MedicationPatientInfoOutput = {
  __typename?: 'MedicationPatientInfoOutput';
  firstName: Scalars['String'];
  id: Scalars['String'];
  isChild: Scalars['Boolean'];
  lastName: Scalars['String'];
};

export type MedicationRequestOutputDto = {
  __typename?: 'MedicationRequestOutputDto';
  activeIngredUnit?: Maybe<Scalars['String']>;
  activeNumeratorStrength?: Maybe<Scalars['String']>;
  appointmentCodexId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  daysSupply?: Maybe<Scalars['Float']>;
  delivery?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  dosage?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  expectedSupplyDuration?: Maybe<ValueOutput>;
  frequency?: Maybe<Scalars['String']>;
  fullScriptVariantId?: Maybe<Scalars['String']>;
  fullScriptVariantSKU?: Maybe<Scalars['String']>;
  initialFill?: Maybe<InitialFillOutput>;
  isOTC: Scalars['Boolean'];
  mediSpanClassification?: Maybe<Scalars['String']>;
  mediSpanId?: Maybe<Scalars['String']>;
  ndc?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  numberOfRepeatsAllowed?: Maybe<Scalars['Int']>;
  patientCodexId: Scalars['String'];
  patientInfo: MedicationPatientInfoOutput;
  pharmacyAddress?: Maybe<Scalars['String']>;
  pharmacyName?: Maybe<Scalars['String']>;
  prescriptionFhirId: Scalars['String'];
  prescriptionFullScriptId?: Maybe<Scalars['String']>;
  productNotes?: Maybe<Scalars['String']>;
  provider?: Maybe<ProviderOutput>;
  providerCodexId?: Maybe<Scalars['String']>;
  providerFullName?: Maybe<Scalars['String']>;
  quantity?: Maybe<ValueOutput>;
  requestedAt?: Maybe<Scalars['String']>;
  rxcui?: Maybe<Scalars['String']>;
  source?: Maybe<MedicationRequestSource>;
  status: MedicationRequestStatusEnum;
  substitutionAllowed?: Maybe<Scalars['Boolean']>;
  summarySubmittedDate?: Maybe<Scalars['String']>;
  takeWith?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Source of medication request origin. */
export enum MedicationRequestSource {
  Fullscript = 'FULLSCRIPT',
  SelfReported = 'SELF_REPORTED',
  Veradigm = 'VERADIGM'
}

/** Enum representing the possible values for "status" field in MedicationRequest. */
export enum MedicationRequestStatusEnum {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Draft = 'draft',
  EnteredInError = 'entered_in_error',
  OnHold = 'on_hold',
  Stopped = 'stopped',
  Unknown = 'unknown'
}

export type MedicationsOutput = {
  __typename?: 'MedicationsOutput';
  medications: Array<MedicationOutput>;
};

export type Meta = {
  __typename?: 'Meta';
  lastUpdated: Scalars['String'];
  tag: Array<Coding>;
  versionId: Scalars['String'];
};

/** Enum representing the patient minor autonomy evidence types. */
export enum MinorAutonomyEvidenceTypes {
  EmancipatedCertifiedCourtOrder = 'EMANCIPATED_CERTIFIED_COURT_ORDER',
  EmancipatedStateId = 'EMANCIPATED_STATE_ID',
  HomelessSchoolLiaisonLetter = 'HOMELESS_SCHOOL_LIAISON_LETTER',
  HomelessSelfAttestation = 'HOMELESS_SELF_ATTESTATION',
  HomelessShelterVerification = 'HOMELESS_SHELTER_VERIFICATION',
  MarriedDivorceDecree = 'MARRIED_DIVORCE_DECREE',
  MarriedMarriageCertificate = 'MARRIED_MARRIAGE_CERTIFICATE',
  MinorParentBirthCertificate = 'MINOR_PARENT_BIRTH_CERTIFICATE',
  MinorParentMedicalRecord = 'MINOR_PARENT_MEDICAL_RECORD',
  MinorParentSelfAttestation = 'MINOR_PARENT_SELF_ATTESTATION',
  OtherExceptionOtherDocument = 'OTHER_EXCEPTION_OTHER_DOCUMENT',
  OtherExceptionVerbal = 'OTHER_EXCEPTION_VERBAL',
  SelfSupportingEmployerLetter = 'SELF_SUPPORTING_EMPLOYER_LETTER',
  SelfSupportingIncomeDocument = 'SELF_SUPPORTING_INCOME_DOCUMENT',
  SelfSupportingLease = 'SELF_SUPPORTING_LEASE'
}

export type MolecularLabsValidateKitIdResult = {
  __typename?: 'MolecularLabsValidateKitIdResult';
  errorMessage?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  kitId: Scalars['String'];
};

export type MosaicResponseOutput = {
  __typename?: 'MosaicResponseOutput';
  mosaicOrderId: Scalars['String'];
  testId: Scalars['String'];
  trackingNumber?: Maybe<Scalars['String']>;
};

export type MosaicTestOutput = {
  __typename?: 'MosaicTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type MosaicTestsInput = {
  direction: OrderByDirections;
  field: ZrtOrderByCriterias;
};

export type NablaNote = {
  __typename?: 'NablaNote';
  appointment_id: Scalars['String'];
  nabla_notes: Scalars['String'];
};

export type Narrative = {
  __typename?: 'Narrative';
  div: Scalars['String'];
  status: NarrativeStatusEnum;
};

/** Enum representing the possible values for "status" field in Narrative. */
export enum NarrativeStatusEnum {
  Additional = 'Additional',
  Empty = 'Empty',
  Extensions = 'Extensions',
  Generated = 'Generated'
}

export type NotificationCategoryPreferenceInput = {
  category: NotificationSettingsCategory;
  channels: NotificationChannelPreferencesInput;
};

export type NotificationCategoryPreferenceOutput = {
  __typename?: 'NotificationCategoryPreferenceOutput';
  category: NotificationSettingsCategory;
  channels: NotificationChannelPreferencesOutput;
};

export type NotificationChannelPreferencesInput = {
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type NotificationChannelPreferencesOutput = {
  __typename?: 'NotificationChannelPreferencesOutput';
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type NotificationOutput = {
  __typename?: 'NotificationOutput';
  activity_type?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  has_priority: Scalars['Boolean'];
  id: Scalars['String'];
  is_admin_notification: Scalars['Boolean'];
  is_latest_activity: Scalars['Boolean'];
  status: Scalars['String'];
  user_communication_delivery_id: Scalars['Int'];
};

export type NotificationPreferencesOutput = {
  __typename?: 'NotificationPreferencesOutput';
  preferences: Array<NotificationCategoryPreferenceOutput>;
};

/** Notification preference category used for Email/Push gating and settings UI. */
export enum NotificationSettingsCategory {
  Account = 'ACCOUNT',
  Appointment = 'APPOINTMENT',
  Chat = 'CHAT',
  Child = 'CHILD',
  PatientReminders = 'PATIENT_REMINDERS',
  PatientRequests = 'PATIENT_REQUESTS',
  PaymentsLicense = 'PAYMENTS_LICENSE',
  Prescription = 'PRESCRIPTION',
  TestKits = 'TEST_KITS'
}

export type OfficeAddressInformationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  officeName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type OfficeAddressInformationOutput = {
  __typename?: 'OfficeAddressInformationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  officeName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type OnTreatmentPlanEventInput = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  treatmentPlanId: Scalars['String'];
};

/** A generic list of OrderByCriterias valid across both DNA Visit and ZRT */
export enum OrderByCriterias {
  Barcode = 'BARCODE',
  CreatedAt = 'CREATED_AT',
  MosaicOat = 'MosaicOat',
  ProviderName = 'PROVIDER_NAME',
  SapphirosBarcode = 'SAPPHIROS_BARCODE',
  SwabCode = 'SWAB_CODE',
  TestType = 'TEST_TYPE'
}

/** Enum representing the sorting directions. */
export enum OrderByDirections {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderFilterInput = {
  from?: InputMaybe<Scalars['String']>;
  idQuery?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  patientQuery?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<OrderStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};

export type OrderListOutput = {
  __typename?: 'OrderListOutput';
  orders: Array<OrderOutput>;
  total: Scalars['Int'];
};

export type OrderOrderByInput = {
  direction: OrderByDirections;
  field: OrdersOrderByCriterias;
};

export type OrderOutput = {
  __typename?: 'OrderOutput';
  carrier?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  delivery_address?: Maybe<DeliveryAddressOutput>;
  delivery_address_id: Scalars['Int'];
  delivery_date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_archived?: Maybe<Scalars['Boolean']>;
  order_products?: Maybe<Array<OrderProductOutput>>;
  order_type?: Maybe<Scalars['Int']>;
  patient?: Maybe<GetPatientOutput>;
  patient_id?: Maybe<Scalars['String']>;
  payment?: Maybe<PaymentTransactionLiteOutput>;
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  shipped_at?: Maybe<Scalars['String']>;
  shipping_cost: Scalars['Float'];
  status?: Maybe<Scalars['Int']>;
  statusHistory: Array<OrderStatusHistoryEntry>;
  subtotal_amount: Scalars['Float'];
  tax_amount: Scalars['Float'];
  total_amount: Scalars['Float'];
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

export type OrderProductOutput = {
  __typename?: 'OrderProductOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  order_id: Scalars['Int'];
  owner_id: Scalars['String'];
  patientOwner?: Maybe<GetPatientOutput>;
  product?: Maybe<Product>;
  product_id: Scalars['Int'];
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  updated_at: Scalars['String'];
};

export type OrderStatsByDayOutput = {
  __typename?: 'OrderStatsByDayOutput';
  date: Scalars['String'];
  orderStats: OrderStatsOutput;
};

export type OrderStatsOutput = {
  __typename?: 'OrderStatsOutput';
  breakdown: Array<OrderStatsStatusItem>;
  total: Scalars['Int'];
};

export type OrderStatsStatusItem = {
  __typename?: 'OrderStatsStatusItem';
  status: OrderStatusEnum;
  total: Scalars['Int'];
};

/** Enum representing the order status values in the database. */
export enum OrderStatusEnum {
  Canceled = 'Canceled',
  Delivered = 'Delivered',
  New = 'New',
  PendingPayment = 'PendingPayment',
  Shipped = 'Shipped'
}

export type OrderStatusHistoryEntry = {
  __typename?: 'OrderStatusHistoryEntry';
  datetime: Scalars['String'];
  status: OrderStatusEnum;
};

/** Enum representing the possible values for sorting orders. */
export enum OrdersOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Status = 'STATUS',
  TotalAmount = 'TOTAL_AMOUNT'
}

/** Enum representing the possible values for "type" field in CreateFHIROrganizationInput. */
export enum OrganizationTypes {
  ClinicalResearchSponsor = 'CLINICAL_RESEARCH_SPONSOR',
  CommunityGroup = 'COMMUNITY_GROUP',
  EducationalInstitute = 'EDUCATIONAL_INSTITUTE',
  Government = 'GOVERNMENT',
  HealthcareProvider = 'HEALTHCARE_PROVIDER',
  HospitalDepartment = 'HOSPITAL_DEPARTMENT',
  InsuranceCompany = 'INSURANCE_COMPANY',
  NonHealthcareBusiness = 'NON_HEALTHCARE_BUSINESS',
  OrganizationalTeam = 'ORGANIZATIONAL_TEAM',
  Other = 'OTHER',
  Payer = 'PAYER',
  ReligiousInstitution = 'RELIGIOUS_INSTITUTION'
}

export type PaginationArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PatchAppointmentAndEncounterOutput = {
  __typename?: 'PatchAppointmentAndEncounterOutput';
  appointment: PatchAppointmentOutput;
  encounter: AppendEncounterOutput;
  summaryPdfFileId?: Maybe<Scalars['String']>;
};

export type PatchAppointmentOutput = {
  __typename?: 'PatchAppointmentOutput';
  appointmentId: Scalars['String'];
};

export type PatchDnaVisitOutput = {
  __typename?: 'PatchDnaVisitOutput';
  created_at: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type PatchEncounterInput = {
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  encounterId: Scalars['String'];
  encounterNotes?: InputMaybe<CreateFhirEncounterNotesInput>;
  providerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PatchEncounterOutput = {
  __typename?: 'PatchEncounterOutput';
  encounterId: Scalars['String'];
  status: Scalars['String'];
};

export type PatchFhirAppointmentInput = {
  acuityId?: InputMaybe<Scalars['String']>;
  appointmentCodexId: Scalars['String'];
  appointmentNotes?: InputMaybe<FhirAppointmentNotesObservation>;
  appointmentPaidStatus?: InputMaybe<Scalars['String']>;
  appointmentType?: InputMaybe<AppointmentTypeEnum>;
  appointmentUrl?: InputMaybe<Scalars['String']>;
  cancelationReason?: InputMaybe<Scalars['String']>;
  codexProviderId?: InputMaybe<Scalars['String']>;
  diagnosticReportIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['String']>;
  lastProcessedDate?: InputMaybe<Scalars['String']>;
  mediaToAppend?: InputMaybe<Array<Scalars['String']>>;
  mediaToInsert?: InputMaybe<Array<AppointmentMediaInsert>>;
  startAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subjectOfAppointment?: InputMaybe<Scalars['String']>;
  supportingInformation?: InputMaybe<Array<ReferenceInput>>;
  symptomsLocation?: InputMaybe<Array<Scalars['String']>>;
  vonageSessionId?: InputMaybe<Scalars['String']>;
};

export type PatchFhirAppointmentOutput = {
  __typename?: 'PatchFHIRAppointmentOutput';
  appointment: PatchAppointmentOutput;
};

export type PatchFhirDnaVisitTestInput = {
  encounterId?: InputMaybe<Scalars['String']>;
  last_processed_state?: InputMaybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['String']>;
  provider_fhir_id?: InputMaybe<Scalars['String']>;
  provider_report_pdf_id?: InputMaybe<Scalars['String']>;
  sapphiros_data?: InputMaybe<Scalars['JSON']>;
  sapphiros_report_pdf_id?: InputMaybe<Scalars['String']>;
  sapphiros_results?: InputMaybe<Scalars['JSON']>;
  state?: InputMaybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  test_id: Scalars['String'];
  visit_summary_pdf_id?: InputMaybe<Scalars['String']>;
};

export type PatchFhirDnaVisitTestOutput = {
  __typename?: 'PatchFHIRDnaVisitTestOutput';
  dnavisit_test: PatchDnaVisitOutput;
};

export type PatchFhirEncounterOutput = {
  __typename?: 'PatchFHIREncounterOutput';
  encounter?: Maybe<PatchEncounterOutput>;
};

export type PatchFhirHealthCareServiceInput = {
  active: Scalars['Boolean'];
  fhirId: Scalars['String'];
  price: Scalars['String'];
};

export type PatchFhirPatientOutput = {
  __typename?: 'PatchFHIRPatientOutput';
  update_patients_one: CreatePatientOutput;
};

export type PatchFhirPatientPersonalInfoInput = {
  SENSITIVE_address_information?: InputMaybe<PatientAddressInfo>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
  SENSITIVE_dob?: InputMaybe<Scalars['String']>;
  SENSITIVE_etnicity?: InputMaybe<Array<Scalars['String']>>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender_describe?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_pharmacies?: InputMaybe<Array<PharmacyInformationInput>>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: InputMaybe<Scalars['String']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<PatientMeasurements>;
  autonomyDeterminationStatus?: InputMaybe<AutonomyDeterminationStatus>;
  codexID: Scalars['String'];
  ePrescribePatientId?: InputMaybe<Scalars['String']>;
  minorAutonomyEvidence?: InputMaybe<Array<MinorAutonomyEvidenceTypes>>;
  mosaicId?: InputMaybe<Scalars['String']>;
  sapphirosID?: InputMaybe<Scalars['String']>;
};

export type PatchFhirProviderInput = {
  about?: InputMaybe<Scalars['String']>;
  accepting_patients?: InputMaybe<Scalars['Boolean']>;
  acuityCalendarId?: InputMaybe<Scalars['String']>;
  acuityOwnerId?: InputMaybe<Scalars['String']>;
  addressInformation?: InputMaybe<AddressInformationInput>;
  credentials?: InputMaybe<ProviderCredentialsInput>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Array<ProviderEducationInput>>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderDescribe?: InputMaybe<Scalars['String']>;
  hide_contact_info?: InputMaybe<Scalars['Boolean']>;
  hide_office_address?: InputMaybe<Scalars['Boolean']>;
  languagesOfCommunication?: InputMaybe<Array<Scalars['String']>>;
  lastname?: InputMaybe<Scalars['String']>;
  nationalProviderIdentifier?: InputMaybe<Scalars['String']>;
  officeInformation?: InputMaybe<OfficeAddressInformationInput>;
  phone?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
};

export type PatchFhirProviderOutput = {
  __typename?: 'PatchFHIRProviderOutput';
  update_providers_one: ProviderOutput;
};

export type PatchFhirRequestBecomePatientOutput = {
  __typename?: 'PatchFHIRRequestBecomePatientOutput';
  requestStatus: ProviderRequestStatus;
};

export type PatchFhirZrtTestInput = {
  comments?: InputMaybe<Scalars['String']>;
  date_received?: InputMaybe<Scalars['String']>;
  date_reported?: InputMaybe<Scalars['String']>;
  last_processed_state?: InputMaybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['String']>;
  patient_pdf_size?: InputMaybe<Scalars['Int']>;
  provider_report_pdf_id?: InputMaybe<Scalars['String']>;
  provider_report_pdf_size?: InputMaybe<Scalars['Int']>;
  reference_code: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export type PatchFhirZrtTestOutput = {
  __typename?: 'PatchFHIRZrtTestOutput';
  zrt_test: PatchZrtOutput;
};

export type PatchZrtOutput = {
  __typename?: 'PatchZrtOutput';
  created_at: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  sapphiros_barcode: Scalars['String'];
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type PatientAddressInfo = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type PatientIdentifiersOutput = {
  __typename?: 'PatientIdentifiersOutput';
  acuityCalendar?: Maybe<Scalars['String']>;
  acuityId?: Maybe<Scalars['String']>;
  acuityOwner?: Maybe<Scalars['String']>;
  codexId?: Maybe<Scalars['String']>;
  fhirId?: Maybe<Scalars['String']>;
  mosaicId?: Maybe<Scalars['String']>;
  sapphirosId?: Maybe<Scalars['String']>;
};

export type PatientMeasurements = {
  heightFt?: InputMaybe<Scalars['Int']>;
  heightIn?: InputMaybe<Scalars['Int']>;
  hips?: InputMaybe<Scalars['Int']>;
  waist?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type PatientMeasurementsOutput = {
  __typename?: 'PatientMeasurementsOutput';
  heightFt?: Maybe<Scalars['Int']>;
  heightIn?: Maybe<Scalars['Int']>;
  hips?: Maybe<Scalars['Int']>;
  waist?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type PatientRequest = {
  __typename?: 'PatientRequest';
  date: Scalars['String'];
  patientFhirId: Scalars['String'];
  requestStatus: ProviderRequestStatus;
};

export type PatientWithMemberOutput = {
  __typename?: 'PatientWithMemberOutput';
  memberDetails?: Maybe<GetMemberGroupOutput>;
  patient: GetBasicPatientInfoOutput;
};

export type PaymentIntentOutput = {
  __typename?: 'PaymentIntentOutput';
  clientSecret?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripePaymentIntent: Scalars['String'];
};

export type PaymentMethodOutput = {
  __typename?: 'PaymentMethodOutput';
  brand?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripeId: Scalars['String'];
  updated_at: Scalars['String'];
};

export type PaymentMethodsOutput = {
  __typename?: 'PaymentMethodsOutput';
  paymentMethods: Array<PaymentMethodOutput>;
  total: Scalars['Int'];
};

/** Payment provider used for checkout. */
export enum PaymentProviderEnum {
  Gale = 'Gale',
  Stripe = 'Stripe'
}

export type PaymentStatsByDayOutput = {
  __typename?: 'PaymentStatsByDayOutput';
  date: Scalars['String'];
  paymentStats: PaymentStatsOutput;
};

export type PaymentStatsOutput = {
  __typename?: 'PaymentStatsOutput';
  feeReceivedByCodex: Scalars['Float'];
  paymentForAppointments: Scalars['Float'];
  paymentForOrders: Scalars['Float'];
  refunds: Scalars['Float'];
};

export type PaymentTransactionFilterInput = {
  categories?: InputMaybe<Array<PaymentTransactionPaymentCategoryEnum>>;
  discountApplied?: InputMaybe<Scalars['Boolean']>;
  from?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<PaymentTransactionStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<PaymentTransactionPaymentTypeEnum>>;
  userCodexId?: InputMaybe<Scalars['String']>;
};

export type PaymentTransactionListOutput = {
  __typename?: 'PaymentTransactionListOutput';
  total: Scalars['Int'];
  transactions: Array<PaymentTransactionOutput>;
};

export type PaymentTransactionLiteOutput = {
  __typename?: 'PaymentTransactionLiteOutput';
  appointment_id?: Maybe<Scalars['String']>;
  category: Scalars['Int'];
  created_at: Scalars['String'];
  discount?: Maybe<DiscountOutput>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  order_ids?: Maybe<Array<Scalars['Int']>>;
  paid_at?: Maybe<Scalars['String']>;
  patient_id?: Maybe<Scalars['String']>;
  payer_role: Scalars['Int'];
  payment_provider?: Maybe<PaymentProviderEnum>;
  provider_id?: Maybe<Scalars['String']>;
  related_payments?: Maybe<Array<PaymentTransactionOutput>>;
  service_fee: Scalars['Float'];
  service_total: Scalars['Float'];
  status: Scalars['Int'];
  stripe_fee: Scalars['Float'];
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  transaction_type: Scalars['Int'];
  updated_at: Scalars['String'];
};

/** Enum representing the possible values for sorting payment transactions. */
export enum PaymentTransactionOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Total = 'TOTAL'
}

export type PaymentTransactionOrderByInput = {
  direction: OrderByDirections;
  field: PaymentTransactionOrderByCriterias;
};

export type PaymentTransactionOutput = {
  __typename?: 'PaymentTransactionOutput';
  appointment?: Maybe<GetAppointmentOutput>;
  appointment_id?: Maybe<Scalars['String']>;
  category: Scalars['Int'];
  created_at: Scalars['String'];
  discount?: Maybe<DiscountOutput>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  order_ids?: Maybe<Array<Scalars['Int']>>;
  orders?: Maybe<Array<OrderOutput>>;
  paid_at?: Maybe<Scalars['String']>;
  patient?: Maybe<GetPatientOutput>;
  patient_id?: Maybe<Scalars['String']>;
  payer_role: Scalars['Int'];
  payment_provider?: Maybe<PaymentProviderEnum>;
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  related_payments?: Maybe<Array<PaymentTransactionOutput>>;
  service_fee: Scalars['Float'];
  service_total: Scalars['Float'];
  status: Scalars['Int'];
  stripe_fee: Scalars['Float'];
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription?: Maybe<SubscriptionOutput>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  transaction_type: Scalars['Int'];
  updated_at: Scalars['String'];
  weeklyPaymentDetails?: Maybe<WeeklyPaymentDetailsOutput>;
};

/** Enum representing the transaction category values in the database. */
export enum PaymentTransactionPaymentCategoryEnum {
  Appointment = 'Appointment',
  Refund = 'Refund',
  Subscription = 'Subscription',
  TestKitOrder = 'TestKitOrder',
  WeeklyPayment = 'WeeklyPayment'
}

/** Enum representing the transaction payment type values in the database. */
export enum PaymentTransactionPaymentTypeEnum {
  Charge = 'Charge',
  Payout = 'Payout',
  Refund = 'Refund'
}

/** Enum representing the transaction status values in the database. */
export enum PaymentTransactionStatusEnum {
  Failed = 'Failed',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Success = 'Success'
}

/** Enum representing inquiry hasura status. */
export enum PersonaInquiryHasuraStatus {
  Approved = 'Approved',
  Completed = 'Completed',
  Created = 'Created',
  Declined = 'Declined',
  Expired = 'Expired',
  Failed = 'Failed',
  Locked = 'Locked',
  MarkedForReview = 'MarkedForReview',
  Started = 'Started',
  Transitioned = 'Transitioned'
}

export type PharmacyInformationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  ext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  phoneCountry?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type PharmacyInformationOutput = {
  __typename?: 'PharmacyInformationOutput';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneCountry?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** Enum representing the price categories associated with service offerings. */
export enum PriceCategory {
  NotApplicable = 'NotApplicable',
  Price1 = 'Price1',
  Price2 = 'Price2',
  Price3 = 'Price3',
  Price4 = 'Price4'
}

export type Product = {
  __typename?: 'Product';
  aeromed_number?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Float']>;
  contents?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  default_image_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expiration_period?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image_ids?: Maybe<Array<Scalars['String']>>;
  image_url?: Maybe<Scalars['String']>;
  in_stock: Scalars['Boolean'];
  is_shipmonk_active: Scalars['Boolean'];
  is_shipmonk_deleted: Scalars['Boolean'];
  made_in?: Maybe<Scalars['String']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  test_type?: Maybe<Hasura_Test_Types_Enum>;
  title: Scalars['String'];
  updated_at: Scalars['String'];
};

export type ProductOutput = {
  __typename?: 'ProductOutput';
  aeromed_number?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Float']>;
  created_at: Scalars['String'];
  default_image_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image_ids?: Maybe<Array<Scalars['String']>>;
  image_url?: Maybe<Scalars['String']>;
  in_stock: Scalars['Boolean'];
  is_shipmonk_active: Scalars['Boolean'];
  is_shipmonk_deleted: Scalars['Boolean'];
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  reserved_quantity: Scalars['Int'];
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  specs?: Maybe<Specs>;
  test_type?: Maybe<Hasura_Test_Types_Enum>;
  title: Scalars['String'];
  updated_at: Scalars['String'];
};

export type ProductRecommendationInput = {
  productCodexId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type ProductRecommendationsInput = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  recommendations: Array<ProductRecommendationInput>;
};

export type ProviderAvailabilityMonthDates = {
  __typename?: 'ProviderAvailabilityMonthDates';
  dates: Array<Scalars['String']>;
};

export type ProviderAvailabilityServiceTypes = {
  __typename?: 'ProviderAvailabilityServiceTypes';
  serviceTypes: Array<AppointmentType>;
};

export type ProviderAvailabilityTimeSlots = {
  __typename?: 'ProviderAvailabilityTimeSlots';
  timeSlots: Array<AvailabilityTime>;
};

export type ProviderBillingOutput = {
  __typename?: 'ProviderBillingOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  previous_payout_date?: Maybe<Scalars['String']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  provider_id: Scalars['String'];
  reserved_balance: Scalars['Float'];
  total_payouts: Scalars['Float'];
  upcoming_payment: Scalars['Float'];
  updated_at: Scalars['String'];
};

export type ProviderCredentialsInput = {
  certifications: Array<Scalars['String']>;
  deaLicenses?: InputMaybe<Array<ProviderDeaLicenseInput>>;
  fellowships?: InputMaybe<Scalars['String']>;
  medicalRole?: InputMaybe<Scalars['String']>;
  stateLicenses?: InputMaybe<Array<ProviderStateLicenseInput>>;
  titles: Array<Scalars['String']>;
  yearsOfPractice: Scalars['String'];
};

export type ProviderCredentialsOutput = {
  __typename?: 'ProviderCredentialsOutput';
  certifications: Array<Scalars['String']>;
  deaLicenses?: Maybe<Array<ProviderDeaLicenseOutput>>;
  fellowships?: Maybe<Scalars['String']>;
  medicalRole: Scalars['String'];
  stateLicenses?: Maybe<Array<ProviderStateLicenseOutput>>;
  titles: Array<Scalars['String']>;
  yearsOfPractice: Scalars['String'];
};

export type ProviderDeaLicenseInput = {
  deaNumber: Scalars['String'];
  expiration: Scalars['String'];
  schedulesAllowed?: InputMaybe<DeaSchedulesAllowedInput>;
  type: DeaLicenseType;
};

export type ProviderDeaLicenseOutput = {
  __typename?: 'ProviderDeaLicenseOutput';
  deaNumber: Scalars['String'];
  expiration: Scalars['String'];
  id: Scalars['String'];
  schedulesAllowed: DeaSchedulesAllowedOutput;
  type: DeaLicenseType;
};

export type ProviderEducationInput = {
  isStillResident?: InputMaybe<Scalars['Boolean']>;
  medicalSchool: Scalars['String'];
  residency?: InputMaybe<Scalars['String']>;
  residencyEndDate?: InputMaybe<Scalars['String']>;
  residencyStartDate?: InputMaybe<Scalars['String']>;
  undergraduate: Scalars['String'];
};

export type ProviderEducationOutput = {
  __typename?: 'ProviderEducationOutput';
  isStillResident?: Maybe<Scalars['Boolean']>;
  medicalSchool: Scalars['String'];
  residency?: Maybe<Scalars['String']>;
  residencyEndDate?: Maybe<Scalars['String']>;
  residencyStartDate?: Maybe<Scalars['String']>;
  undergraduate: Scalars['String'];
};

export type ProviderIdentifiersOutput = {
  __typename?: 'ProviderIdentifiersOutput';
  acuityCalendarId?: Maybe<Scalars['String']>;
  acuityOwnerId?: Maybe<Scalars['String']>;
  codexId?: Maybe<Scalars['String']>;
  ePrescribeUserId?: Maybe<Scalars['String']>;
  fhirId: Scalars['String'];
  fullscriptId?: Maybe<Scalars['String']>;
  mosaicId?: Maybe<Scalars['String']>;
  patientRequestsListId?: Maybe<Scalars['String']>;
};

export type ProviderOutput = {
  __typename?: 'ProviderOutput';
  SENSITIVE_about?: Maybe<Scalars['String']>;
  SENSITIVE_address_information?: Maybe<AddressInformationOutput>;
  SENSITIVE_credentials: ProviderCredentialsOutput;
  SENSITIVE_dob?: Maybe<Scalars['String']>;
  SENSITIVE_education: Array<ProviderEducationOutput>;
  SENSITIVE_email: Scalars['String'];
  SENSITIVE_firstname: Scalars['String'];
  SENSITIVE_gender: Scalars['String'];
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_languages_of_communication: Array<Scalars['String']>;
  SENSITIVE_lastname: Scalars['String'];
  SENSITIVE_national_provider_identifier: Scalars['String'];
  SENSITIVE_office_information?: Maybe<OfficeAddressInformationOutput>;
  SENSITIVE_phone: Scalars['String'];
  SENSITIVE_profile_picture_id?: Maybe<Scalars['String']>;
  accepting_patients: Scalars['Boolean'];
  acuityCalendarId?: Maybe<Scalars['String']>;
  acuityOwnerId?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['String']>;
  codex_approved: Scalars['Boolean'];
  ePrescribeUserId?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  fullscriptId?: Maybe<Scalars['String']>;
  fully_verified: Scalars['Boolean'];
  hide_contact_info?: Maybe<Scalars['Boolean']>;
  hide_office_address?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  id_verified: Scalars['Boolean'];
  identifiers?: Maybe<ProviderIdentifiersOutput>;
  insurance_verified: Scalars['Boolean'];
  isStripeConnected?: Maybe<Scalars['Boolean']>;
  patientRequests: Array<PatientRequest>;
  patientRequestsListId?: Maybe<Scalars['String']>;
  providerBalance?: Maybe<Scalars['Float']>;
  serviceOfferings: Array<ServiceOfferingsOutput>;
  stripeAccountId?: Maybe<Scalars['String']>;
  stripePayoutsReadyAt?: Maybe<Scalars['String']>;
  subscriptionPeriodEnd?: Maybe<Scalars['String']>;
  subscriptionStatus?: Maybe<CodexSubscriptionStatuses>;
};

export type ProviderPayoutOutput = {
  __typename?: 'ProviderPayoutOutput';
  appointment?: Maybe<GetAppointmentOutput>;
  appointment_id?: Maybe<Scalars['String']>;
  appointments_total: Scalars['Int'];
  category: Scalars['Int'];
  created_at: Scalars['String'];
  discount?: Maybe<DiscountOutput>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  order_ids?: Maybe<Array<Scalars['Int']>>;
  orders?: Maybe<Array<OrderOutput>>;
  paid_at?: Maybe<Scalars['String']>;
  patient?: Maybe<GetPatientOutput>;
  patient_id?: Maybe<Scalars['String']>;
  payer_role: Scalars['Int'];
  payment_provider?: Maybe<PaymentProviderEnum>;
  provider?: Maybe<ProviderOutput>;
  provider_id?: Maybe<Scalars['String']>;
  related_payments?: Maybe<Array<PaymentTransactionOutput>>;
  service_fee: Scalars['Float'];
  service_total: Scalars['Float'];
  status: Scalars['Int'];
  stripe_fee: Scalars['Float'];
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription?: Maybe<SubscriptionOutput>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['Float'];
  transaction_type: Scalars['Int'];
  updated_at: Scalars['String'];
  weeklyPaymentDetails?: Maybe<WeeklyPaymentDetailsOutput>;
};

export type ProviderPayoutsOutput = {
  __typename?: 'ProviderPayoutsOutput';
  payouts: Array<ProviderPayoutOutput>;
  total: Scalars['Int'];
};

export type ProviderRegisterPatchInput = {
  about?: InputMaybe<Scalars['String']>;
  address_information?: InputMaybe<Scalars['jsonb']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  date_of_birth?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Scalars['jsonb']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderDescribe?: InputMaybe<Scalars['String']>;
  hide_contact_info?: InputMaybe<Scalars['Boolean']>;
  hide_office_address?: InputMaybe<Scalars['Boolean']>;
  languagesOfCommunication?: InputMaybe<Scalars['jsonb']>;
  lastname?: InputMaybe<Scalars['String']>;
  nationalProviderIdentifier?: InputMaybe<Scalars['String']>;
  office_information?: InputMaybe<Scalars['jsonb']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** The status of a request to become a patient. */
export enum ProviderRequestStatus {
  Accepted = 'Accepted',
  AwaitingAgreement = 'AwaitingAgreement',
  Cancelled = 'Cancelled',
  None = 'None',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type ProviderSignupInput = {
  email: Scalars['String'];
  firebaseToken?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type ProviderStateLicenseInput = {
  expirationDate: Scalars['String'];
  licenseNumber: Scalars['String'];
  licenseType?: InputMaybe<StateLicenseType>;
  state: Scalars['String'];
};

export type ProviderStateLicenseOutput = {
  __typename?: 'ProviderStateLicenseOutput';
  expirationDate: Scalars['String'];
  id: Scalars['String'];
  licenseNumber: Scalars['String'];
  licenseType: StateLicenseType;
  state: Scalars['String'];
};

export type ProviderTimezoneOutput = {
  __typename?: 'ProviderTimezoneOutput';
  timezone: Scalars['String'];
};

export type ProviderWeeklyWorkingHours = {
  __typename?: 'ProviderWeeklyWorkingHours';
  data: AcuityWorkingHoursPerDay;
};

export type ProviderWorkingHoursAndBlockedTime = {
  __typename?: 'ProviderWorkingHoursAndBlockedTime';
  blocks: Array<FormatedAvailableTime>;
  providerWorkingHours: ProviderWeeklyWorkingHours;
};

/** Enum representing the possible values for "provider" field in getFHIRDnaVisitTests. */
export enum ProvidersTypes {
  All = 'ALL',
  DnaVisit = 'DNA_VISIT',
  OtherProviders = 'OTHER_PROVIDERS'
}

export type PublishLegalDocumentInput = {
  contentMobile: Scalars['String'];
  contentWeb: Scalars['String'];
  type: Hasura_Legal_Document_Types_Enum;
};

export type QuestionHelperTextData = {
  __typename?: 'QuestionHelperTextData';
  helper_text_1: Scalars['String'];
  helper_text_2: Scalars['String'];
};

export type QuestionnaireDependenciesGroup = {
  __typename?: 'QuestionnaireDependenciesGroup';
  complete?: Maybe<Scalars['Boolean']>;
  dependencies?: Maybe<Array<DynamicQuestionnaireDependencies>>;
  name: Scalars['String'];
  properties: Array<Scalars['String']>;
};

export type QuestionnaireQuestionsQuestion = {
  __typename?: 'QuestionnaireQuestionsQuestion';
  all_option?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Scalars['String']>>;
  array_field_config?: Maybe<ArrayFieldConfig>;
  children?: Maybe<Array<QuestionnaireQuestionsQuestion>>;
  dont_know_answer?: Maybe<Scalars['String']>;
  double_text_combo_helper_texts?: Maybe<QuestionHelperTextData>;
  dropdown_combo_answers?: Maybe<Scalars['JSON']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  measurement_unit?: Maybe<Scalars['String']>;
  none_option?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  ui_control: Scalars['String'];
};

export type QuestionnaireResponseInput = {
  authored?: InputMaybe<Scalars['String']>;
  codexPatientId: Scalars['String'];
  completed?: InputMaybe<Scalars['Boolean']>;
  currentStepIndex?: InputMaybe<Scalars['Int']>;
  questionnaireName: FhirQuestionnaireNames;
  questionnaireResponse: Scalars['JSON'];
  serviceRequestId?: InputMaybe<Scalars['String']>;
  swabCode?: InputMaybe<Scalars['String']>;
};

/** Enum representing the possible values for "status" field in QuestionnaireResponse. */
export enum QuestionnaireResponseStatus {
  Amended = 'AMENDED',
  Completed = 'COMPLETED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  Stopped = 'STOPPED'
}

export type QuestionnairesQuestionnaireQuestions = {
  __typename?: 'QuestionnairesQuestionnaireQuestions';
  questionnaire_questions_question: QuestionnaireQuestionsQuestion;
};

/** Enum representing the possible values for roles */
export enum Roles_Enum {
  Admin = 'ADMIN',
  DelegatedAdmin = 'DELEGATED_ADMIN',
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  Superadmin = 'SUPERADMIN'
}

export type RankedDiagnosticSolutionVisitTestOutput = {
  __typename?: 'RankedDiagnosticSolutionVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type RankedDnaVisitTestOutput = {
  __typename?: 'RankedDnaVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  diagnosticReportId: Scalars['String'];
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  dnavisit_order_id: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  last_processed_date?: Maybe<Scalars['String']>;
  last_processed_state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  molecular_order_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  sapphiros_barcode: Scalars['String'];
  sapphiros_report_pdf_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  test_id: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
  visit_summary_pdf_id?: Maybe<Scalars['String']>;
};

export type RankedMosaicVisitTestOutput = {
  __typename?: 'RankedMosaicVisitTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  state?: Maybe<Hasura_Dnavisit_Test_Statuses_Enum>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['String']>;
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type RankedZrtTestOutput = {
  __typename?: 'RankedZrtTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['String']>;
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  rank: Scalars['Float'];
  reference_code: Scalars['String'];
  service_request_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

export type ReceiptHistoryInput = {
  categories?: InputMaybe<Array<PaymentTransactionPaymentCategoryEnum>>;
  dateFilterArgs?: InputMaybe<DateFilterArgs>;
  pagingArgs?: InputMaybe<PaginationArgs>;
};

export type ReceiptHistoryItemOutput = {
  __typename?: 'ReceiptHistoryItemOutput';
  amount: Scalars['Float'];
  category: PaymentTransactionPaymentCategoryEnum;
  paidAt: Scalars['String'];
  paymentTransactionId: Scalars['Int'];
};

export type ReceiptsHistoryOutput = {
  __typename?: 'ReceiptsHistoryOutput';
  receipts: Array<ReceiptHistoryItemOutput>;
  total: Scalars['Int'];
  totalSpentOnAppointments: Scalars['Float'];
  totalSpentOnOrders: Scalars['Float'];
};

export type RecommendProductsOutput = {
  __typename?: 'RecommendProductsOutput';
  serviceRequestIds: Array<Scalars['String']>;
};

export type ReferenceInput = {
  reference?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ReferenceType = {
  __typename?: 'ReferenceType';
  reference?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RegisterDiagnosticSolutionTestKitInput = {
  codexProviderId: Scalars['String'];
  swabCode: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type RegisterDnaVitaminTestKitInput = {
  testKitId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type RegisterGoogleMeetInput = {
  appointmentId: Scalars['String'];
  patientId: Scalars['String'];
  providerId: Scalars['String'];
};

export type RegisterGoogleMeetOutput = {
  __typename?: 'RegisterGoogleMeetOutput';
  appointmentId: Scalars['String'];
  conferenceId: Scalars['String'];
  endTime: Scalars['String'];
  eventId: Scalars['String'];
  meetLink: Scalars['String'];
  startTime: Scalars['String'];
  transcriptionEnabled: Scalars['Boolean'];
};

export type RegisterMosaicTestKitInput = {
  providerCodexId: Scalars['String'];
  testId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
  validateNpi?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterProviderCalendarInput = {
  calendarId: Scalars['Int'];
  ownerId: Scalars['Int'];
  providerId: Scalars['String'];
};

export type RegisterTestKitInput = {
  questionnaireResponseResourceId?: InputMaybe<Scalars['String']>;
  questionnaireResponses: Scalars['jsonb'];
  swabBarcode: Scalars['String'];
  testType: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type RequestDnaTestKitInput = {
  providerCodexId?: InputMaybe<Scalars['String']>;
  swabCode: Scalars['String'];
  testType: Hasura_Test_Types_Enum;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type RequestDnaTestKitOutput = {
  __typename?: 'RequestDnaTestKitOutput';
  success: Scalars['Boolean'];
  swabCode: Scalars['String'];
};

export type RequestZrtTestOutput = {
  __typename?: 'RequestZrtTestOutput';
  requestStatus: ProviderRequestStatus;
  serviceRequestId: Scalars['String'];
};

export type RescheduleAppointmentInput = {
  appointmentCodexId: Scalars['String'];
  datetime: Scalars['String'];
  isTest?: InputMaybe<Scalars['Boolean']>;
};

export type RescheduleAppointmentOutput = {
  __typename?: 'RescheduleAppointmentOutput';
  appointmentCodexId: Scalars['String'];
  appointmentId: Scalars['String'];
  appointmentUrl: Scalars['String'];
  created: Scalars['String'];
  lastProcessedDate: Scalars['String'];
  start: Scalars['String'];
  status: Scalars['String'];
};

export type RescheduleFhirAppointmentOutput = {
  __typename?: 'RescheduleFHIRAppointmentOutput';
  appointment: RescheduleAppointmentOutput;
};

export type ResendChildAdultTransitionInvitationInput = {
  childUserId: Scalars['String'];
};

export type ResourceExtension = {
  __typename?: 'ResourceExtension';
  url?: Maybe<GoogleEhrExtensionsUrLs>;
  valueBoolean?: Maybe<Scalars['Boolean']>;
  valueCodeableConcept?: Maybe<ValuableCodeableConcept>;
  valueString?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for "resourceType" field in BaseResource. */
export enum ResourcesTypes {
  Appointment = 'APPOINTMENT',
  Basic = 'BASIC',
  Communication = 'COMMUNICATION',
  CommunicationRequest = 'COMMUNICATION_REQUEST',
  Condition = 'CONDITION',
  DiagnosticReport = 'DIAGNOSTIC_REPORT',
  DocumentReference = 'DOCUMENT_REFERENCE',
  Encounter = 'ENCOUNTER',
  Group = 'GROUP',
  HealthCareService = 'HEALTH_CARE_SERVICE',
  List = 'LIST',
  Location = 'LOCATION',
  Media = 'MEDIA',
  Medication = 'MEDICATION',
  MedicationRequest = 'MEDICATION_REQUEST',
  Observation = 'OBSERVATION',
  Organization = 'ORGANIZATION',
  Patient = 'PATIENT',
  Provider = 'PROVIDER',
  ProviderRole = 'PROVIDER_ROLE',
  Questionnaire = 'QUESTIONNAIRE',
  QuestionnaireResponse = 'QUESTIONNAIRE_RESPONSE',
  RelatedPerson = 'RELATED_PERSON',
  SearchParameter = 'SEARCH_PARAMETER',
  ServiceRequest = 'SERVICE_REQUEST'
}

export type SaAppointment = {
  __typename?: 'SAAppointment';
  dates: Array<Array<Scalars['String']>>;
  flags: Array<CodexTags>;
  identifiers: Array<Array<Scalars['String']>>;
  logs: Array<Array<Scalars['String']>>;
  patient?: Maybe<SaPerson>;
  provider?: Maybe<SaPerson>;
  status: Scalars['String'];
  type?: Maybe<AppointmentTypeEnum>;
};

export type SaAppointmentBrief = {
  __typename?: 'SAAppointmentBrief';
  dates: Array<Array<Scalars['String']>>;
  flags: Array<CodexTags>;
  identifiers: Array<Array<Scalars['String']>>;
};

export type SaAppointmentDetailsOutput = {
  __typename?: 'SAAppointmentDetailsOutput';
  appointmentIds: Array<Array<Scalars['String']>>;
  appointmentStart?: Maybe<Scalars['String']>;
  appointmentStatus: Scalars['Int'];
  createdAt?: Maybe<Scalars['String']>;
  originalTransaction?: Maybe<PaymentTransactionOutput>;
  patient?: Maybe<SaPatient>;
  provider?: Maybe<SaProvider>;
  refundTransactions: Array<PaymentTransactionOutput>;
  status: Scalars['String'];
  statusHistory: Array<AppointmentStatusHistoryEntry>;
  transactionCategory: Scalars['String'];
};

export type SaAppointmentOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SaAppointmentOrderByField>;
};

/** Field to order SA appointments by */
export enum SaAppointmentOrderByField {
  CreatedAt = 'CreatedAt',
  Start = 'Start'
}

export type SaAppointmentOutput = {
  __typename?: 'SAAppointmentOutput';
  acuityId?: Maybe<Scalars['String']>;
  appointmentId: Scalars['String'];
  created?: Maybe<Scalars['String']>;
  diagnosticReportId?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  lastProcessedDate?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type SaAppointments = {
  __typename?: 'SAAppointments';
  appointments: Array<SaAppointment>;
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  prevPageToken?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type SaArtifact = {
  __typename?: 'SAArtifact';
  contentType: SaContentType;
  fileId?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  kind: SaArtifactTypes;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export enum SaArtifactTypes {
  DnaTestQuestionnairePdfId = 'dna_test_questionnaire_pdf_id',
  HealthQuestionnairePdfId = 'health_questionnaire_pdf_id',
  PatientPdf = 'patient_pdf',
  ProviderReportPdf = 'provider_report_pdf',
  SapphirosReportPdfId = 'sapphiros_report_pdf_id',
  VisitSummaryPdfId = 'visit_summary_pdf_id',
  ZrtQuestionnaireResponses = 'zrt_questionnaire_responses'
}

export enum SaContentType {
  Json = 'json',
  MediaId = 'mediaId',
  Url = 'url'
}

export type SaDiagnosticReport = {
  __typename?: 'SADiagnosticReport';
  appointment?: Maybe<SaAppointmentOutput>;
  artifacts: Array<SaArtifact>;
  dates: Array<Array<Scalars['String']>>;
  flags: Array<CodexTags>;
  identifiers: Array<Array<Scalars['String']>>;
  patient?: Maybe<SaPerson>;
  provider?: Maybe<SaPerson>;
  status: Scalars['String'];
  statusHistory: Array<TestKitStatusHistoryEntry>;
  type: Hasura_Test_Types_Enum;
};

export type SaDiagnosticReports = {
  __typename?: 'SADiagnosticReports';
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  prevPageToken?: Maybe<Scalars['String']>;
  reports: Array<SaDiagnosticReport>;
  total: Scalars['Int'];
};

export type SaGeneralDashboardStats = {
  __typename?: 'SAGeneralDashboardStats';
  totalAppointments: Scalars['Int'];
  totalPatients: Scalars['Int'];
  totalProviders: Scalars['Int'];
  totalRevenue: Scalars['Float'];
  totalTestKits: Scalars['Int'];
};

export type SaNarrowingQueryOptions = {
  patientFhirId?: InputMaybe<Scalars['String']>;
  providerFhirId?: InputMaybe<Scalars['String']>;
};

export type SaPageableQueryOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type SaPatient = {
  __typename?: 'SAPatient';
  appointmentCount: Array<Array<Scalars['String']>>;
  assignedAt?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  dates: Array<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first: Scalars['String'];
  flags: Array<CodexTags>;
  gender?: Maybe<Scalars['String']>;
  identifiers: Array<Array<Scalars['String']>>;
  last: Scalars['String'];
  nextAppointment?: Maybe<SaAppointmentBrief>;
  parentCodexId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  testKitCount: Scalars['Int'];
};

export type SaPatientFilterOptions = {
  assignedAtFrom?: InputMaybe<Scalars['String']>;
  assignedAtTo?: InputMaybe<Scalars['String']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerCodexId?: InputMaybe<Scalars['String']>;
};

export type SaPatientOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SaPatientOrderByField>;
};

/** Field to order SA patients by */
export enum SaPatientOrderByField {
  AssignedAt = 'AssignedAt',
  CreatedAt = 'CreatedAt'
}

export type SaPatients = {
  __typename?: 'SAPatients';
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  patients: Array<SaPatient>;
  prevPageToken?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type SaPerson = {
  __typename?: 'SAPerson';
  birthDate?: Maybe<Scalars['String']>;
  dates: Array<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first: Scalars['String'];
  flags: Array<CodexTags>;
  gender?: Maybe<Scalars['String']>;
  identifiers: Array<Array<Scalars['String']>>;
  last: Scalars['String'];
  profilePhoto?: Maybe<Scalars['String']>;
};

export type SaProvider = {
  __typename?: 'SAProvider';
  appointmentCount: Array<Array<Scalars['String']>>;
  birthDate?: Maybe<Scalars['String']>;
  dates: Array<Array<Scalars['String']>>;
  email?: Maybe<Scalars['String']>;
  first: Scalars['String'];
  flags: Array<CodexTags>;
  gender?: Maybe<Scalars['String']>;
  identifiers: Array<Array<Scalars['String']>>;
  last: Scalars['String'];
  patientCount: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  providerOutput?: Maybe<ProviderOutput>;
  statuses: SaProviderStatuses;
};

export type SaProviderFilterOptions = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  licenseAlert?: InputMaybe<SaProviderLicenseAlert>;
  licensedStates?: InputMaybe<Array<Scalars['String']>>;
};

/** License alert filter for SA providers list */
export enum SaProviderLicenseAlert {
  Expired = 'Expired',
  ExpiringSoon = 'ExpiringSoon'
}

export type SaProviderOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SaProviderOrderByField>;
};

/** Field to order SA providers by */
export enum SaProviderOrderByField {
  LastLogin = 'LastLogin',
  Name = 'Name',
  Registered = 'Registered'
}

export type SaProviderStatus = {
  __typename?: 'SAProviderStatus';
  status?: Maybe<PersonaInquiryHasuraStatus>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SaProviderStatuses = {
  __typename?: 'SAProviderStatuses';
  BAA?: Maybe<SaProviderStatus>;
  HIPAA?: Maybe<SaProviderStatus>;
  fullScriptAccount?: Maybe<SaProviderStatus>;
  personaId?: Maybe<SaProviderStatus>;
  personaInsurance?: Maybe<SaProviderStatus>;
  stripeAccount?: Maybe<SaProviderStatus>;
};

export type SaProviders = {
  __typename?: 'SAProviders';
  count: Scalars['Int'];
  nextPageToken?: Maybe<Scalars['String']>;
  prevPageToken?: Maybe<Scalars['String']>;
  providers: Array<SaProvider>;
  total: Scalars['Int'];
};

export type SaVerificationRequest = {
  __typename?: 'SAVerificationRequest';
  childCodexId?: Maybe<Scalars['String']>;
  childFullName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['String'];
  personaInquiryId: Scalars['String'];
  status: VerificationStatus;
  statusHistory: Array<VerificationStatusHistoryEntry>;
  type: VerificationType;
  updatedAt: Scalars['String'];
  userCodexId: Scalars['String'];
};

export type SaVerificationRequestFilter = {
  from?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<VerificationStatus>>;
  to?: InputMaybe<Scalars['String']>;
  verificationTypes?: InputMaybe<Array<VerificationType>>;
};

export type SaVerificationRequestOrderBy = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<VerificationRequestOrderByField>;
};

export type SaVerificationRequests = {
  __typename?: 'SAVerificationRequests';
  requests: Array<SaVerificationRequest>;
  total: Scalars['Int'];
};

export type SaveDnaScannedDataInput = {
  skipTrackingNumber?: InputMaybe<Scalars['Boolean']>;
  swabBarcode?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type SaveFhirQuestionnaireManually = {
  __typename?: 'SaveFHIRQuestionnaireManually';
  id: Scalars['String'];
  responses: Scalars['JSON'];
};

export type SaveQuestionnaireInput = {
  is_complete?: InputMaybe<Scalars['Boolean']>;
  questionnaireId: Scalars['Int'];
  responses: Scalars['jsonb'];
};

export type SeedFhirOrganizationsOutput = {
  __typename?: 'SeedFHIROrganizationsOutput';
  message: Scalars['String'];
  status: Scalars['Int'];
};

export type SelfReportedMedicationInput = {
  duration?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  ndc: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
};

export type SelfReportedMedicationsInput = {
  medications: Array<SelfReportedMedicationInput>;
};

export type SendSupportReplyInput = {
  attachments?: InputMaybe<Array<FileAttachmentInput>>;
  chatId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ServiceOfferingsOutput = {
  __typename?: 'ServiceOfferingsOutput';
  active: Scalars['Boolean'];
  healthCareServiceFhirId: Scalars['String'];
  price: Scalars['String'];
  priceCategory: PriceCategory;
  serviceType: ServiceType;
};

/** Enum representing the possible values of FHIR recommendation status. */
export enum ServiceRequestStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  EnteredInError = 'ENTERED_IN_ERROR',
  OnHold = 'ON_HOLD',
  Revoked = 'REVOKED',
  Unknown = 'UNKNOWN'
}

/** Enum representing the different types of service offerings. */
export enum ServiceType {
  Chat = 'Chat',
  Chat_30 = 'Chat_30',
  Chat_60 = 'Chat_60',
  Video = 'Video',
  Video_30 = 'Video_30',
  Video_60 = 'Video_60'
}

export type SetDefaultPaymentMethodInput = {
  paymentMethodCodexId: Scalars['Int'];
};

export type SetupIntentOutput = {
  __typename?: 'SetupIntentOutput';
  clientSecret?: Maybe<Scalars['String']>;
};

export type Specs = {
  __typename?: 'Specs';
  contents?: Maybe<Scalars['String']>;
  expiration_period?: Maybe<Scalars['Int']>;
  made_in?: Maybe<Scalars['String']>;
};

/** Enum representing the possible values for provider_state_licenses.license_type. */
export enum StateLicenseType {
  CertificateToPrescribe = 'CertificateToPrescribe',
  StateControlledSubstanceLicense = 'StateControlledSubstanceLicense',
  StateLicense = 'StateLicense'
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubPatient = {
  __typename?: 'SubPatient';
  account_closed_at?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['String']>;
  child_fully_verified?: Maybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  hasPendingAdultTransitionInvitation?: Maybe<Scalars['Boolean']>;
  hasReachedAgeOfMajority?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  parentCodexId: Scalars['String'];
  parentRelationship?: Maybe<SubPatientRelationship>;
  profilePhoto?: Maybe<Scalars['String']>;
};

/** Enum representing the sub patient relationship. */
export enum SubPatientRelationship {
  LegalGuardian = 'LEGAL_GUARDIAN',
  Parent = 'PARENT',
  Relative = 'RELATIVE'
}

export type SubPatientsOutput = {
  __typename?: 'SubPatientsOutput';
  closedTotal: Scalars['Int'];
  subPatients: Array<SubPatient>;
  total: Scalars['Int'];
};

export type SubscriptionOutput = {
  __typename?: 'SubscriptionOutput';
  billingPlan: BillingPlan;
  created_at: Scalars['String'];
  currentPeriodEnd?: Maybe<Scalars['String']>;
  currentPeriodStart?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  paymentIntent?: Maybe<PaymentIntentOutput>;
  status: CodexSubscriptionStatuses;
  updated_at: Scalars['String'];
};

export type SuccessGetSignUrlFormStorage = {
  __typename?: 'SuccessGetSignUrlFormStorage';
  status: Scalars['Int'];
  url: Scalars['String'];
};

export type SuccessGetVonageSession = {
  __typename?: 'SuccessGetVonageSession';
  apiKey: Scalars['String'];
  sessionId: Scalars['String'];
  token: Scalars['String'];
};

export type SuccessGetVonageSignUrlFormStorage = {
  __typename?: 'SuccessGetVonageSignUrlFormStorage';
  status: Scalars['Int'];
  url: Scalars['String'];
};

export type SuccessfulGeneratedCustomToken = {
  __typename?: 'SuccessfulGeneratedCustomToken';
  message: Scalars['String'];
  status: Scalars['Int'];
  token: Scalars['String'];
};

export type SuccessfulGetVonageArchives = {
  __typename?: 'SuccessfulGetVonageArchives';
  archives?: Maybe<Array<Scalars['jsonb']>>;
};

export type SuccessfulProviderUpdated = {
  __typename?: 'SuccessfulProviderUpdated';
  message: Scalars['String'];
  status: Scalars['Int'];
  update_providers_one: Scalars['jsonb'];
};

export type SuccessfulUploadedImage = {
  __typename?: 'SuccessfulUploadedImage';
  message: Scalars['String'];
  sessionId: Scalars['String'];
  status: Scalars['Int'];
};

export type SuccessfullUpdatedProfilePicture = {
  __typename?: 'SuccessfullUpdatedProfilePicture';
  contentType: Scalars['String'];
  fileId: Scalars['String'];
  message: Scalars['String'];
  status: Scalars['Int'];
};

export type SuperAdminListItem = {
  __typename?: 'SuperAdminListItem';
  createdAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
};

/** Sort fields for the superadmin list. */
export enum SuperAdminOrderByCriterias {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL'
}

export type SuperAdminOrderByInput = {
  direction?: InputMaybe<OrderByDirections>;
  field?: InputMaybe<SuperAdminOrderByCriterias>;
};

export type SupportChatDetailsOutput = {
  __typename?: 'SupportChatDetailsOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  messages: Array<InMailMessageOutput>;
  nextPageToken?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  role: Roles_Enum;
  usage?: Maybe<InMailUsageOutput>;
  user: InMailParticipantOutput;
};

export type SupportChatPreviewOutput = {
  __typename?: 'SupportChatPreviewOutput';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  role: Roles_Enum;
  user: InMailParticipantOutput;
};

export type SupportChatsOutput = {
  __typename?: 'SupportChatsOutput';
  chats: Array<SupportChatPreviewOutput>;
  newTotal: Scalars['Int'];
  total: Scalars['Int'];
};

export type SwabCodeFilterInput = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
};

export type SwabCodeListOutput = {
  __typename?: 'SwabCodeListOutput';
  swab_codes: Array<SwabCodeOutput>;
  total: Scalars['Int'];
};

export type SwabCodeOutput = {
  __typename?: 'SwabCodeOutput';
  created_at: Scalars['String'];
  id: Scalars['Int'];
  lab_name: Scalars['String'];
  status: Scalars['String'];
  swab_code: Scalars['String'];
  swab_codes_test?: Maybe<Array<SwabCodeTestOutput>>;
  swab_usage_type: Scalars['String'];
  test_type: Scalars['String'];
  updated_at: Scalars['String'];
};

export type SwabCodeTestOutput = {
  __typename?: 'SwabCodeTestOutput';
  created_at: Scalars['String'];
  state: Scalars['String'];
  test_id: Scalars['String'];
  updated_at: Scalars['String'];
  user_id: Scalars['String'];
};

export type TestKitDetailsOutput = {
  __typename?: 'TestKitDetailsOutput';
  codexId: Scalars['String'];
  fhirId: Scalars['String'];
  labOrderId?: Maybe<Scalars['String']>;
  patient: TestKitDetailsParticipant;
  provider?: Maybe<TestKitDetailsParticipant>;
  questionnaireCompleted: Scalars['Boolean'];
  status: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swabCode?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  type: Hasura_Test_Types_Enum;
};

export type TestKitDetailsParticipant = {
  __typename?: 'TestKitDetailsParticipant';
  codexId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fhirId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type TestKitResultOutput = {
  __typename?: 'TestKitResultOutput';
  createdAt?: Maybe<Scalars['String']>;
  diagnosticReportId: Scalars['String'];
  diagnosticReportStatus: Hasura_Dnavisit_Test_Statuses_Enum;
  diagnosticReportTestType: Hasura_Test_Types_Enum;
  patientPdf?: Maybe<FileOutput>;
  providerCodexId?: Maybe<Scalars['String']>;
  providerFirstName?: Maybe<Scalars['String']>;
  providerLastName?: Maybe<Scalars['String']>;
  providerPdf?: Maybe<FileOutput>;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swabCode: Scalars['String'];
};

export type TestKitResultsInput = {
  dates?: InputMaybe<DateFilterArgs>;
  pagination?: InputMaybe<PaginationArgs>;
  providerFullNameQuery?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
};

export type TestKitResultsOutput = {
  __typename?: 'TestKitResultsOutput';
  diagnosticReports: Array<TestKitResultOutput>;
  total: Scalars['Int'];
};

export type TestKitStatsByDayOutput = {
  __typename?: 'TestKitStatsByDayOutput';
  date: Scalars['String'];
  testKitStats: TestKitStatsOutput;
};

export type TestKitStatsFiltersInput = {
  labs?: InputMaybe<Array<Hasura_Labs_Enum>>;
  testTypes?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
};

export type TestKitStatsOutput = {
  __typename?: 'TestKitStatsOutput';
  breakdown: Array<TestKitStatsStatusItem>;
  total: Scalars['Int'];
};

/** Enum representing the possible values for test kit statistics status */
export enum TestKitStatsStatusEnum {
  AppointmentScheduled = 'AppointmentScheduled',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Issue = 'Issue',
  KitNotReceived = 'KitNotReceived',
  ReceivedByLab = 'ReceivedByLab',
  ResultsWithProvider = 'ResultsWithProvider'
}

export type TestKitStatsStatusItem = {
  __typename?: 'TestKitStatsStatusItem';
  status: TestKitStatsStatusEnum;
  total: Scalars['Int'];
};

export type TestKitStatusHistoryEntry = {
  __typename?: 'TestKitStatusHistoryEntry';
  datetime: Scalars['String'];
  status: Hasura_Dnavisit_Test_Statuses_Enum;
};

export type ThenObject = {
  __typename?: 'ThenObject';
  disabled?: Maybe<Array<Scalars['String']>>;
  enabled?: Maybe<Array<Scalars['String']>>;
  required?: Maybe<Array<Scalars['String']>>;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  from: Scalars['String'];
  fromTimePeriod: Scalars['String'];
  to: Scalars['String'];
  toTimePeriod: Scalars['String'];
};

export type TimeRangeDto = {
  from: Scalars['String'];
  fromTimePeriod: Scalars['String'];
  to: Scalars['String'];
  toTimePeriod: Scalars['String'];
};

export type TotalOutput = {
  __typename?: 'TotalOutput';
  total: Scalars['Int'];
};

export type UpcomingAppointmentCounts = {
  __typename?: 'UpcomingAppointmentCounts';
  month: Scalars['Int'];
  today: Scalars['Int'];
  tomorrow: Scalars['Int'];
  week: Scalars['Int'];
};

/** Enum representing the possible values for updating FHIR recommendation status. */
export enum UpdatableRecommendationStatus {
  Active = 'ACTIVE',
  OnHold = 'ON_HOLD',
  Revoked = 'REVOKED'
}

export type UpdateAvailabilityOverridesInput = {
  overrides: Array<AvailabilityOverrideGroupInput>;
};

export type UpdateBecomePatientRequestStatusInput = {
  patientFhirId: Scalars['String'];
  requestStatus: ProviderRequestStatus;
};

export type UpdateCalendarRegularHoursInput = {
  Friday: Array<TimeRangeDto>;
  Monday: Array<TimeRangeDto>;
  Saturday: Array<TimeRangeDto>;
  Sunday: Array<TimeRangeDto>;
  Thursday: Array<TimeRangeDto>;
  Tuesday: Array<TimeRangeDto>;
  Wednesday: Array<TimeRangeDto>;
  calendarId: Scalars['String'];
};

export type UpdateCalendarRegularHoursResponse = {
  __typename?: 'UpdateCalendarRegularHoursResponse';
  Friday: Array<Scalars['String']>;
  Monday: Array<Scalars['String']>;
  Saturday: Array<Scalars['String']>;
  Sunday: Array<Scalars['String']>;
  Thursday: Array<Scalars['String']>;
  Tuesday: Array<Scalars['String']>;
  Wednesday: Array<Scalars['String']>;
};

export type UpdateCallSettingsInput = {
  platform: ClientPlatform;
  settings: Scalars['JSON'];
};

export type UpdateCartProductInput = {
  id: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type UpdateCartProductsProviderInput = {
  cartProductIds: Array<Scalars['Int']>;
  providerCodexId: Scalars['String'];
};

export type UpdateDelegatedAdminPermissionsInput = {
  delegatedAdminCodexId: Scalars['String'];
  permissions: Array<AdminPermissionType>;
};

export type UpdateFhirQuestionnaireResponsesOutput = {
  __typename?: 'UpdateFHIRQuestionnaireResponsesOutput';
  questionnaire_response: UpdateQuestionnaireResponsesOutput;
};

export type UpdateFhirUserLatestQuestionnaire = {
  __typename?: 'UpdateFHIRUserLatestQuestionnaire';
  affected_rows: Scalars['Int'];
};

export type UpdateInAppNotificationInput = {
  id: Scalars['String'];
  status: Scalars['String'];
};

export type UpdateNotificationPreferencesInput = {
  preferences: Array<NotificationCategoryPreferenceInput>;
};

export type UpdateNotificationStatusInput = {
  isLatestActivity?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['String'];
};

export type UpdateOrderStatusInput = {
  orderId: Scalars['Int'];
  status: OrderStatusEnum;
};

export type UpdateProductAvailabilityInput = {
  id: Scalars['Int'];
  inStock: Scalars['Boolean'];
};

export type UpdateProductInput = {
  category: Scalars['Int'];
  contents?: InputMaybe<Scalars['String']>;
  defaultFileId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  inStock: Scalars['Boolean'];
  madeIn?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId: Scalars['Int'];
  providerPrice?: InputMaybe<Scalars['Float']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateProfilePictureInput = {
  filename?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
};

export type UpdateProviderAccountSettingsInput = {
  account_settings: Scalars['jsonb'];
};

export type UpdateProviderInput = {
  about?: InputMaybe<Scalars['String']>;
  address_information?: InputMaybe<Scalars['jsonb']>;
  credentials?: InputMaybe<Scalars['jsonb']>;
  education?: InputMaybe<Scalars['jsonb']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  languagesOfCommunication?: InputMaybe<Scalars['jsonb']>;
  lastname?: InputMaybe<Scalars['String']>;
  nationalProviderIdentifier?: InputMaybe<Scalars['String']>;
  office_information?: InputMaybe<Scalars['jsonb']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateQuestionnaireInput = {
  is_complete?: InputMaybe<Scalars['Boolean']>;
  questionnaireId: Scalars['Int'];
  responses: Scalars['jsonb'];
};

export type UpdateQuestionnaireResponsesOutput = {
  __typename?: 'UpdateQuestionnaireResponsesOutput';
  id: Scalars['String'];
};

export type UploadImageInput = {
  filename?: InputMaybe<Scalars['String']>;
  image: Scalars['String'];
  source: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};

export type UpsertEducationModuleInput = {
  additionalMaterialModuleIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<UpsertEducationModuleItemInput>>;
  title: Scalars['String'];
};

export type UpsertEducationModuleItemInput = {
  category: EducationCourseModuleItemCategory;
  fileId: Scalars['String'];
  title: Scalars['String'];
};

/** Role of the person accepting a user agreement on behalf of a child patient. */
export enum UserAgreementAcceptorRole {
  Guardian = 'Guardian',
  OtherAuthorizedAdult = 'OtherAuthorizedAdult',
  Parent = 'Parent',
  Patient = 'Patient'
}

/** Expiration mode for SUD consent agreements: manual revoke or end of treatment. */
export enum UserAgreementExpirationType {
  EndOfTreatment = 'END_OF_TREATMENT',
  Manual = 'MANUAL'
}

/** Enum representing the possible values for "agreement_type" field in user_agreements. */
export enum UserAgreementTypes {
  AgeOfMajority = 'AGE_OF_MAJORITY',
  Baa = 'BAA',
  ConsentToUseAndDiscloseSudRecords = 'CONSENT_TO_USE_AND_DISCLOSE_SUD_RECORDS',
  CoppaChild = 'COPPA_CHILD',
  Hippa = 'HIPPA',
  NoticeOfPrivacySudRecords = 'NOTICE_OF_PRIVACY_SUD_RECORDS',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsOfService = 'TERMS_OF_SERVICE'
}

export type UserRegistrationStatsByDayOutput = {
  __typename?: 'UserRegistrationStatsByDayOutput';
  date: Scalars['String'];
  userRegistrationStats: UserRegistrationStatsOutput;
};

export type UserRegistrationStatsOutput = {
  __typename?: 'UserRegistrationStatsOutput';
  totalAdultPatients: Scalars['Int'];
  totalMinorPatients: Scalars['Int'];
  totalPatients: Scalars['Int'];
  totalProviders: Scalars['Int'];
};

export type UserSignupInput = {
  country?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firebaseToken?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ValidateChildAdultTransitionInvitationTokenOutput = {
  __typename?: 'ValidateChildAdultTransitionInvitationTokenOutput';
  email?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type ValidateDelegatedAdminInvitationTokenOutput = {
  __typename?: 'ValidateDelegatedAdminInvitationTokenOutput';
  email?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type ValidateInvitationTokenInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type ValuableCodeableConcept = {
  __typename?: 'ValuableCodeableConcept';
  coding: Array<CodeableConceptData>;
};

export type ValueOutput = {
  __typename?: 'ValueOutput';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** Field to order verification requests by */
export enum VerificationRequestOrderByField {
  CreatedAt = 'CreatedAt',
  UpdatedAt = 'UpdatedAt'
}

/** Status of verification request */
export enum VerificationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type VerificationStatusHistoryEntry = {
  __typename?: 'VerificationStatusHistoryEntry';
  datetime: Scalars['String'];
  status: VerificationStatus;
};

/** Type of verification request */
export enum VerificationType {
  PatientChild = 'PatientChild',
  PatientGuardian = 'PatientGuardian',
  PatientId = 'PatientId',
  ProviderId = 'ProviderId',
  ProviderInsurance = 'ProviderInsurance'
}

export enum VonageDisconnectReason {
  ClientDisconnected = 'ClientDisconnected',
  ForceDisconnected = 'ForceDisconnected',
  NetworkDisconnected = 'NetworkDisconnected'
}

export type VonageLiveCaptions = {
  __typename?: 'VonageLiveCaptions';
  captionsId?: Maybe<Scalars['String']>;
  status: VonageLiveCaptionsStatus;
};

export enum VonageLiveCaptionsStatus {
  Failed = 'FAILED',
  Started = 'STARTED',
  Stopped = 'STOPPED',
  Transcribing = 'TRANSCRIBING'
}

export type VonageSummaryOutput = {
  __typename?: 'VonageSummaryOutput';
  summary?: Maybe<Scalars['String']>;
  summaryPdfFileId?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
};

export type WeeklyPaymentDetailsOutput = {
  __typename?: 'WeeklyPaymentDetailsOutput';
  completedAppointments: Scalars['Int'];
  periodEnd: Scalars['String'];
  periodStart: Scalars['String'];
};

export type ZrtKitIdsBatchOutput = {
  __typename?: 'ZrtKitIdsBatchOutput';
  kitIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Enum representing the possible values for "field" field in ZrtOrderByCriterias. */
export enum ZrtOrderByCriterias {
  Barcode = 'BARCODE',
  CreatedAt = 'CREATED_AT',
  ProviderName = 'PROVIDER_NAME',
  TestType = 'TEST_TYPE'
}

export type ZrtOrderByInput = {
  direction: OrderByDirections;
  field: ZrtOrderByCriterias;
};

export type ZrtTestOutput = {
  __typename?: 'ZrtTestOutput';
  appointment_codex_id?: Maybe<Scalars['String']>;
  created_at: Scalars['String'];
  fhirId: Scalars['String'];
  health_questionnaire_pdf_id?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['String']>;
  patient_fhir_id?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['String']>;
  provider_acuity_calendar_id?: Maybe<Scalars['String']>;
  provider_acuity_owner_id?: Maybe<Scalars['String']>;
  provider_codex_id?: Maybe<Scalars['String']>;
  provider_fhir_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_report_pdf_id?: Maybe<Scalars['String']>;
  questionnaire_required?: Maybe<Scalars['Boolean']>;
  reference_code: Scalars['String'];
  service_request_id?: Maybe<Scalars['String']>;
  state: Hasura_Dnavisit_Test_Statuses_Enum;
  statusHistory: Array<TestKitStatusHistoryEntry>;
  swab_code: Scalars['String'];
  test_type: Hasura_Test_Types_Enum;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['String'];
};

/** columns and relationships of "accepted_legal_documents" */
export type Accepted_Legal_Documents = {
  __typename?: 'accepted_legal_documents';
  acceptance_date: Scalars['timestamptz'];
  accepted_legal_document_id: Scalars['bigint'];
  /** An object relationship */
  accepted_legal_documents_user: Users;
  /** An object relationship */
  legal_document: Legal_Documents;
  legal_document_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "accepted_legal_documents" */
export type Accepted_Legal_Documents_Aggregate = {
  __typename?: 'accepted_legal_documents_aggregate';
  aggregate?: Maybe<Accepted_Legal_Documents_Aggregate_Fields>;
  nodes: Array<Accepted_Legal_Documents>;
};

export type Accepted_Legal_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Accepted_Legal_Documents_Aggregate_Bool_Exp_Count>;
};

export type Accepted_Legal_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "accepted_legal_documents" */
export type Accepted_Legal_Documents_Aggregate_Fields = {
  __typename?: 'accepted_legal_documents_aggregate_fields';
  avg?: Maybe<Accepted_Legal_Documents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Accepted_Legal_Documents_Max_Fields>;
  min?: Maybe<Accepted_Legal_Documents_Min_Fields>;
  stddev?: Maybe<Accepted_Legal_Documents_Stddev_Fields>;
  stddev_pop?: Maybe<Accepted_Legal_Documents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Accepted_Legal_Documents_Stddev_Samp_Fields>;
  sum?: Maybe<Accepted_Legal_Documents_Sum_Fields>;
  var_pop?: Maybe<Accepted_Legal_Documents_Var_Pop_Fields>;
  var_samp?: Maybe<Accepted_Legal_Documents_Var_Samp_Fields>;
  variance?: Maybe<Accepted_Legal_Documents_Variance_Fields>;
};


/** aggregate fields of "accepted_legal_documents" */
export type Accepted_Legal_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Accepted_Legal_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Accepted_Legal_Documents_Max_Order_By>;
  min?: InputMaybe<Accepted_Legal_Documents_Min_Order_By>;
  stddev?: InputMaybe<Accepted_Legal_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Accepted_Legal_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Accepted_Legal_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Accepted_Legal_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Accepted_Legal_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Accepted_Legal_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Accepted_Legal_Documents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Arr_Rel_Insert_Input = {
  data: Array<Accepted_Legal_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Accepted_Legal_Documents_On_Conflict>;
};

/** aggregate avg on columns */
export type Accepted_Legal_Documents_Avg_Fields = {
  __typename?: 'accepted_legal_documents_avg_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Avg_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "accepted_legal_documents". All fields are combined with a logical 'AND'. */
export type Accepted_Legal_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Accepted_Legal_Documents_Bool_Exp>>;
  _not?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Accepted_Legal_Documents_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  accepted_legal_document_id?: InputMaybe<Bigint_Comparison_Exp>;
  accepted_legal_documents_user?: InputMaybe<Users_Bool_Exp>;
  legal_document?: InputMaybe<Legal_Documents_Bool_Exp>;
  legal_document_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "accepted_legal_documents" */
export enum Accepted_Legal_Documents_Constraint {
  /** unique or primary key constraint on columns "accepted_legal_document_id" */
  AcceptedLegalDocumentsPkey = 'accepted_legal_documents_pkey'
}

/** input type for incrementing numeric columns in table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Inc_Input = {
  accepted_legal_document_id?: InputMaybe<Scalars['bigint']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Insert_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  accepted_legal_document_id?: InputMaybe<Scalars['bigint']>;
  accepted_legal_documents_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  legal_document?: InputMaybe<Legal_Documents_Obj_Rel_Insert_Input>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Accepted_Legal_Documents_Max_Fields = {
  __typename?: 'accepted_legal_documents_max_fields';
  acceptance_date?: Maybe<Scalars['timestamptz']>;
  accepted_legal_document_id?: Maybe<Scalars['bigint']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Max_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Accepted_Legal_Documents_Min_Fields = {
  __typename?: 'accepted_legal_documents_min_fields';
  acceptance_date?: Maybe<Scalars['timestamptz']>;
  accepted_legal_document_id?: Maybe<Scalars['bigint']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Min_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Mutation_Response = {
  __typename?: 'accepted_legal_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accepted_Legal_Documents>;
};

/** on_conflict condition type for table "accepted_legal_documents" */
export type Accepted_Legal_Documents_On_Conflict = {
  constraint: Accepted_Legal_Documents_Constraint;
  update_columns?: Array<Accepted_Legal_Documents_Update_Column>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "accepted_legal_documents". */
export type Accepted_Legal_Documents_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  accepted_legal_document_id?: InputMaybe<Order_By>;
  accepted_legal_documents_user?: InputMaybe<Users_Order_By>;
  legal_document?: InputMaybe<Legal_Documents_Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accepted_legal_documents */
export type Accepted_Legal_Documents_Pk_Columns_Input = {
  accepted_legal_document_id: Scalars['bigint'];
};

/** select columns of table "accepted_legal_documents" */
export enum Accepted_Legal_Documents_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AcceptedLegalDocumentId = 'accepted_legal_document_id',
  /** column name */
  LegalDocumentId = 'legal_document_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Set_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  accepted_legal_document_id?: InputMaybe<Scalars['bigint']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Accepted_Legal_Documents_Stddev_Fields = {
  __typename?: 'accepted_legal_documents_stddev_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Stddev_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Accepted_Legal_Documents_Stddev_Pop_Fields = {
  __typename?: 'accepted_legal_documents_stddev_pop_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Stddev_Pop_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Accepted_Legal_Documents_Stddev_Samp_Fields = {
  __typename?: 'accepted_legal_documents_stddev_samp_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Stddev_Samp_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accepted_Legal_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accepted_Legal_Documents_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  accepted_legal_document_id?: InputMaybe<Scalars['bigint']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Accepted_Legal_Documents_Sum_Fields = {
  __typename?: 'accepted_legal_documents_sum_fields';
  accepted_legal_document_id?: Maybe<Scalars['bigint']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Sum_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** update columns of table "accepted_legal_documents" */
export enum Accepted_Legal_Documents_Update_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AcceptedLegalDocumentId = 'accepted_legal_document_id',
  /** column name */
  LegalDocumentId = 'legal_document_id',
  /** column name */
  UserId = 'user_id'
}

export type Accepted_Legal_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Accepted_Legal_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accepted_Legal_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accepted_Legal_Documents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Accepted_Legal_Documents_Var_Pop_Fields = {
  __typename?: 'accepted_legal_documents_var_pop_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Var_Pop_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Accepted_Legal_Documents_Var_Samp_Fields = {
  __typename?: 'accepted_legal_documents_var_samp_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Var_Samp_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Accepted_Legal_Documents_Variance_Fields = {
  __typename?: 'accepted_legal_documents_variance_fields';
  accepted_legal_document_id?: Maybe<Scalars['Float']>;
  legal_document_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "accepted_legal_documents" */
export type Accepted_Legal_Documents_Variance_Order_By = {
  accepted_legal_document_id?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "active_in_mails" */
export type Active_In_Mails = {
  __typename?: 'active_in_mails';
  communication_request_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  last_message_at?: Maybe<Scalars['timestamptz']>;
  last_patient_message_at?: Maybe<Scalars['timestamptz']>;
  last_provider_message_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  patient_read: Scalars['Boolean'];
  provider_id?: Maybe<Scalars['uuid']>;
  provider_read: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "active_in_mails" */
export type Active_In_Mails_Aggregate = {
  __typename?: 'active_in_mails_aggregate';
  aggregate?: Maybe<Active_In_Mails_Aggregate_Fields>;
  nodes: Array<Active_In_Mails>;
};

export type Active_In_Mails_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Active_In_Mails_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Active_In_Mails_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Active_In_Mails_Aggregate_Bool_Exp_Count>;
};

export type Active_In_Mails_Aggregate_Bool_Exp_Bool_And = {
  arguments: Active_In_Mails_Select_Column_Active_In_Mails_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Active_In_Mails_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Active_In_Mails_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Active_In_Mails_Select_Column_Active_In_Mails_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Active_In_Mails_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Active_In_Mails_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Active_In_Mails_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "active_in_mails" */
export type Active_In_Mails_Aggregate_Fields = {
  __typename?: 'active_in_mails_aggregate_fields';
  avg?: Maybe<Active_In_Mails_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Active_In_Mails_Max_Fields>;
  min?: Maybe<Active_In_Mails_Min_Fields>;
  stddev?: Maybe<Active_In_Mails_Stddev_Fields>;
  stddev_pop?: Maybe<Active_In_Mails_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Active_In_Mails_Stddev_Samp_Fields>;
  sum?: Maybe<Active_In_Mails_Sum_Fields>;
  var_pop?: Maybe<Active_In_Mails_Var_Pop_Fields>;
  var_samp?: Maybe<Active_In_Mails_Var_Samp_Fields>;
  variance?: Maybe<Active_In_Mails_Variance_Fields>;
};


/** aggregate fields of "active_in_mails" */
export type Active_In_Mails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "active_in_mails" */
export type Active_In_Mails_Aggregate_Order_By = {
  avg?: InputMaybe<Active_In_Mails_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Active_In_Mails_Max_Order_By>;
  min?: InputMaybe<Active_In_Mails_Min_Order_By>;
  stddev?: InputMaybe<Active_In_Mails_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Active_In_Mails_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Active_In_Mails_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Active_In_Mails_Sum_Order_By>;
  var_pop?: InputMaybe<Active_In_Mails_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Active_In_Mails_Var_Samp_Order_By>;
  variance?: InputMaybe<Active_In_Mails_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "active_in_mails" */
export type Active_In_Mails_Arr_Rel_Insert_Input = {
  data: Array<Active_In_Mails_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Active_In_Mails_On_Conflict>;
};

/** aggregate avg on columns */
export type Active_In_Mails_Avg_Fields = {
  __typename?: 'active_in_mails_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "active_in_mails" */
export type Active_In_Mails_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "active_in_mails". All fields are combined with a logical 'AND'. */
export type Active_In_Mails_Bool_Exp = {
  _and?: InputMaybe<Array<Active_In_Mails_Bool_Exp>>;
  _not?: InputMaybe<Active_In_Mails_Bool_Exp>;
  _or?: InputMaybe<Array<Active_In_Mails_Bool_Exp>>;
  communication_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_patient_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_provider_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  patient_read?: InputMaybe<Boolean_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_read?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "active_in_mails" */
export enum Active_In_Mails_Constraint {
  /** unique or primary key constraint on columns "patient_id", "provider_id" */
  ActiveInMailsPatientIdProviderIdKey = 'active_in_mails_patient_id_provider_id_key',
  /** unique or primary key constraint on columns "id" */
  ActiveInMailsPkey = 'active_in_mails_pkey'
}

/** input type for incrementing numeric columns in table "active_in_mails" */
export type Active_In_Mails_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "active_in_mails" */
export type Active_In_Mails_Insert_Input = {
  communication_request_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  last_patient_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_provider_message_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  patient_read?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  provider_read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Active_In_Mails_Max_Fields = {
  __typename?: 'active_in_mails_max_fields';
  communication_request_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  last_message_at?: Maybe<Scalars['timestamptz']>;
  last_patient_message_at?: Maybe<Scalars['timestamptz']>;
  last_provider_message_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "active_in_mails" */
export type Active_In_Mails_Max_Order_By = {
  communication_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_patient_message_at?: InputMaybe<Order_By>;
  last_provider_message_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Active_In_Mails_Min_Fields = {
  __typename?: 'active_in_mails_min_fields';
  communication_request_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  last_message_at?: Maybe<Scalars['timestamptz']>;
  last_patient_message_at?: Maybe<Scalars['timestamptz']>;
  last_provider_message_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "active_in_mails" */
export type Active_In_Mails_Min_Order_By = {
  communication_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_patient_message_at?: InputMaybe<Order_By>;
  last_provider_message_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "active_in_mails" */
export type Active_In_Mails_Mutation_Response = {
  __typename?: 'active_in_mails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Active_In_Mails>;
};

/** on_conflict condition type for table "active_in_mails" */
export type Active_In_Mails_On_Conflict = {
  constraint: Active_In_Mails_Constraint;
  update_columns?: Array<Active_In_Mails_Update_Column>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};

/** Ordering options when selecting data from "active_in_mails". */
export type Active_In_Mails_Order_By = {
  communication_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_patient_message_at?: InputMaybe<Order_By>;
  last_provider_message_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  patient_read?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  provider_read?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: active_in_mails */
export type Active_In_Mails_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "active_in_mails" */
export enum Active_In_Mails_Select_Column {
  /** column name */
  CommunicationRequestId = 'communication_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastMessageAt = 'last_message_at',
  /** column name */
  LastPatientMessageAt = 'last_patient_message_at',
  /** column name */
  LastProviderMessageAt = 'last_provider_message_at',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  PatientRead = 'patient_read',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderRead = 'provider_read',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "active_in_mails_aggregate_bool_exp_bool_and_arguments_columns" columns of table "active_in_mails" */
export enum Active_In_Mails_Select_Column_Active_In_Mails_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  PatientRead = 'patient_read',
  /** column name */
  ProviderRead = 'provider_read'
}

/** select "active_in_mails_aggregate_bool_exp_bool_or_arguments_columns" columns of table "active_in_mails" */
export enum Active_In_Mails_Select_Column_Active_In_Mails_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  PatientRead = 'patient_read',
  /** column name */
  ProviderRead = 'provider_read'
}

/** input type for updating data in table "active_in_mails" */
export type Active_In_Mails_Set_Input = {
  communication_request_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  last_patient_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_provider_message_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  patient_read?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  provider_read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Active_In_Mails_Stddev_Fields = {
  __typename?: 'active_in_mails_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "active_in_mails" */
export type Active_In_Mails_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Active_In_Mails_Stddev_Pop_Fields = {
  __typename?: 'active_in_mails_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "active_in_mails" */
export type Active_In_Mails_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Active_In_Mails_Stddev_Samp_Fields = {
  __typename?: 'active_in_mails_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "active_in_mails" */
export type Active_In_Mails_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "active_in_mails" */
export type Active_In_Mails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Active_In_Mails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Active_In_Mails_Stream_Cursor_Value_Input = {
  communication_request_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  last_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_patient_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_provider_message_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  patient_read?: InputMaybe<Scalars['Boolean']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  provider_read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Active_In_Mails_Sum_Fields = {
  __typename?: 'active_in_mails_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "active_in_mails" */
export type Active_In_Mails_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "active_in_mails" */
export enum Active_In_Mails_Update_Column {
  /** column name */
  CommunicationRequestId = 'communication_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastPatientMessageAt = 'last_patient_message_at',
  /** column name */
  LastProviderMessageAt = 'last_provider_message_at',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  PatientRead = 'patient_read',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderRead = 'provider_read',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Active_In_Mails_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Active_In_Mails_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Active_In_Mails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Active_In_Mails_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Active_In_Mails_Var_Pop_Fields = {
  __typename?: 'active_in_mails_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "active_in_mails" */
export type Active_In_Mails_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Active_In_Mails_Var_Samp_Fields = {
  __typename?: 'active_in_mails_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "active_in_mails" */
export type Active_In_Mails_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Active_In_Mails_Variance_Fields = {
  __typename?: 'active_in_mails_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "active_in_mails" */
export type Active_In_Mails_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "active_support_chats" */
export type Active_Support_Chats = {
  __typename?: 'active_support_chats';
  communication_request_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  last_message_at?: Maybe<Scalars['timestamptz']>;
  last_support_admin_id?: Maybe<Scalars['uuid']>;
  last_support_message_at?: Maybe<Scalars['timestamptz']>;
  last_user_message_at?: Maybe<Scalars['timestamptz']>;
  support_read: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
  user_read: Scalars['Boolean'];
  user_role: Scalars['String'];
};

/** aggregated selection of "active_support_chats" */
export type Active_Support_Chats_Aggregate = {
  __typename?: 'active_support_chats_aggregate';
  aggregate?: Maybe<Active_Support_Chats_Aggregate_Fields>;
  nodes: Array<Active_Support_Chats>;
};

export type Active_Support_Chats_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Active_Support_Chats_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Active_Support_Chats_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Active_Support_Chats_Aggregate_Bool_Exp_Count>;
};

export type Active_Support_Chats_Aggregate_Bool_Exp_Bool_And = {
  arguments: Active_Support_Chats_Select_Column_Active_Support_Chats_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Active_Support_Chats_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Active_Support_Chats_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Active_Support_Chats_Select_Column_Active_Support_Chats_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Active_Support_Chats_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Active_Support_Chats_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Active_Support_Chats_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "active_support_chats" */
export type Active_Support_Chats_Aggregate_Fields = {
  __typename?: 'active_support_chats_aggregate_fields';
  avg?: Maybe<Active_Support_Chats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Active_Support_Chats_Max_Fields>;
  min?: Maybe<Active_Support_Chats_Min_Fields>;
  stddev?: Maybe<Active_Support_Chats_Stddev_Fields>;
  stddev_pop?: Maybe<Active_Support_Chats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Active_Support_Chats_Stddev_Samp_Fields>;
  sum?: Maybe<Active_Support_Chats_Sum_Fields>;
  var_pop?: Maybe<Active_Support_Chats_Var_Pop_Fields>;
  var_samp?: Maybe<Active_Support_Chats_Var_Samp_Fields>;
  variance?: Maybe<Active_Support_Chats_Variance_Fields>;
};


/** aggregate fields of "active_support_chats" */
export type Active_Support_Chats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "active_support_chats" */
export type Active_Support_Chats_Aggregate_Order_By = {
  avg?: InputMaybe<Active_Support_Chats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Active_Support_Chats_Max_Order_By>;
  min?: InputMaybe<Active_Support_Chats_Min_Order_By>;
  stddev?: InputMaybe<Active_Support_Chats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Active_Support_Chats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Active_Support_Chats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Active_Support_Chats_Sum_Order_By>;
  var_pop?: InputMaybe<Active_Support_Chats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Active_Support_Chats_Var_Samp_Order_By>;
  variance?: InputMaybe<Active_Support_Chats_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "active_support_chats" */
export type Active_Support_Chats_Arr_Rel_Insert_Input = {
  data: Array<Active_Support_Chats_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Active_Support_Chats_On_Conflict>;
};

/** aggregate avg on columns */
export type Active_Support_Chats_Avg_Fields = {
  __typename?: 'active_support_chats_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "active_support_chats" */
export type Active_Support_Chats_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "active_support_chats". All fields are combined with a logical 'AND'. */
export type Active_Support_Chats_Bool_Exp = {
  _and?: InputMaybe<Array<Active_Support_Chats_Bool_Exp>>;
  _not?: InputMaybe<Active_Support_Chats_Bool_Exp>;
  _or?: InputMaybe<Array<Active_Support_Chats_Bool_Exp>>;
  communication_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_support_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_support_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_user_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  support_read?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_read?: InputMaybe<Boolean_Comparison_Exp>;
  user_role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "active_support_chats" */
export enum Active_Support_Chats_Constraint {
  /** unique or primary key constraint on columns "communication_request_id" */
  ActiveSupportChatsCommunicationRequestIdKey = 'active_support_chats_communication_request_id_key',
  /** unique or primary key constraint on columns "id" */
  ActiveSupportChatsPkey = 'active_support_chats_pkey',
  /** unique or primary key constraint on columns "user_id" */
  ActiveSupportChatsUserIdKey = 'active_support_chats_user_id_key'
}

/** input type for incrementing numeric columns in table "active_support_chats" */
export type Active_Support_Chats_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "active_support_chats" */
export type Active_Support_Chats_Insert_Input = {
  communication_request_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  last_support_admin_id?: InputMaybe<Scalars['uuid']>;
  last_support_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_user_message_at?: InputMaybe<Scalars['timestamptz']>;
  support_read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_read?: InputMaybe<Scalars['Boolean']>;
  user_role?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Active_Support_Chats_Max_Fields = {
  __typename?: 'active_support_chats_max_fields';
  communication_request_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  last_message_at?: Maybe<Scalars['timestamptz']>;
  last_support_admin_id?: Maybe<Scalars['uuid']>;
  last_support_message_at?: Maybe<Scalars['timestamptz']>;
  last_user_message_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_role?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "active_support_chats" */
export type Active_Support_Chats_Max_Order_By = {
  communication_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_support_admin_id?: InputMaybe<Order_By>;
  last_support_message_at?: InputMaybe<Order_By>;
  last_user_message_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Active_Support_Chats_Min_Fields = {
  __typename?: 'active_support_chats_min_fields';
  communication_request_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  last_message_at?: Maybe<Scalars['timestamptz']>;
  last_support_admin_id?: Maybe<Scalars['uuid']>;
  last_support_message_at?: Maybe<Scalars['timestamptz']>;
  last_user_message_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_role?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "active_support_chats" */
export type Active_Support_Chats_Min_Order_By = {
  communication_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_support_admin_id?: InputMaybe<Order_By>;
  last_support_message_at?: InputMaybe<Order_By>;
  last_user_message_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "active_support_chats" */
export type Active_Support_Chats_Mutation_Response = {
  __typename?: 'active_support_chats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Active_Support_Chats>;
};

/** on_conflict condition type for table "active_support_chats" */
export type Active_Support_Chats_On_Conflict = {
  constraint: Active_Support_Chats_Constraint;
  update_columns?: Array<Active_Support_Chats_Update_Column>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};

/** Ordering options when selecting data from "active_support_chats". */
export type Active_Support_Chats_Order_By = {
  communication_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_support_admin_id?: InputMaybe<Order_By>;
  last_support_message_at?: InputMaybe<Order_By>;
  last_user_message_at?: InputMaybe<Order_By>;
  support_read?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_read?: InputMaybe<Order_By>;
  user_role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: active_support_chats */
export type Active_Support_Chats_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "active_support_chats" */
export enum Active_Support_Chats_Select_Column {
  /** column name */
  CommunicationRequestId = 'communication_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastMessageAt = 'last_message_at',
  /** column name */
  LastSupportAdminId = 'last_support_admin_id',
  /** column name */
  LastSupportMessageAt = 'last_support_message_at',
  /** column name */
  LastUserMessageAt = 'last_user_message_at',
  /** column name */
  SupportRead = 'support_read',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRead = 'user_read',
  /** column name */
  UserRole = 'user_role'
}

/** select "active_support_chats_aggregate_bool_exp_bool_and_arguments_columns" columns of table "active_support_chats" */
export enum Active_Support_Chats_Select_Column_Active_Support_Chats_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SupportRead = 'support_read',
  /** column name */
  UserRead = 'user_read'
}

/** select "active_support_chats_aggregate_bool_exp_bool_or_arguments_columns" columns of table "active_support_chats" */
export enum Active_Support_Chats_Select_Column_Active_Support_Chats_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SupportRead = 'support_read',
  /** column name */
  UserRead = 'user_read'
}

/** input type for updating data in table "active_support_chats" */
export type Active_Support_Chats_Set_Input = {
  communication_request_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  last_support_admin_id?: InputMaybe<Scalars['uuid']>;
  last_support_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_user_message_at?: InputMaybe<Scalars['timestamptz']>;
  support_read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_read?: InputMaybe<Scalars['Boolean']>;
  user_role?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Active_Support_Chats_Stddev_Fields = {
  __typename?: 'active_support_chats_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "active_support_chats" */
export type Active_Support_Chats_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Active_Support_Chats_Stddev_Pop_Fields = {
  __typename?: 'active_support_chats_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "active_support_chats" */
export type Active_Support_Chats_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Active_Support_Chats_Stddev_Samp_Fields = {
  __typename?: 'active_support_chats_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "active_support_chats" */
export type Active_Support_Chats_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "active_support_chats" */
export type Active_Support_Chats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Active_Support_Chats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Active_Support_Chats_Stream_Cursor_Value_Input = {
  communication_request_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  last_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_support_admin_id?: InputMaybe<Scalars['uuid']>;
  last_support_message_at?: InputMaybe<Scalars['timestamptz']>;
  last_user_message_at?: InputMaybe<Scalars['timestamptz']>;
  support_read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_read?: InputMaybe<Scalars['Boolean']>;
  user_role?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Active_Support_Chats_Sum_Fields = {
  __typename?: 'active_support_chats_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "active_support_chats" */
export type Active_Support_Chats_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "active_support_chats" */
export enum Active_Support_Chats_Update_Column {
  /** column name */
  CommunicationRequestId = 'communication_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastSupportAdminId = 'last_support_admin_id',
  /** column name */
  LastSupportMessageAt = 'last_support_message_at',
  /** column name */
  LastUserMessageAt = 'last_user_message_at',
  /** column name */
  SupportRead = 'support_read',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserRead = 'user_read',
  /** column name */
  UserRole = 'user_role'
}

export type Active_Support_Chats_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Active_Support_Chats_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Active_Support_Chats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Active_Support_Chats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Active_Support_Chats_Var_Pop_Fields = {
  __typename?: 'active_support_chats_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "active_support_chats" */
export type Active_Support_Chats_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Active_Support_Chats_Var_Samp_Fields = {
  __typename?: 'active_support_chats_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "active_support_chats" */
export type Active_Support_Chats_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Active_Support_Chats_Variance_Fields = {
  __typename?: 'active_support_chats_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "active_support_chats" */
export type Active_Support_Chats_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "activity_events" */
export type Activity_Events = {
  __typename?: 'activity_events';
  /** An object relationship */
  activity_events_test_type?: Maybe<Test_Types>;
  /** An object relationship */
  admin?: Maybe<Users>;
  admin_id?: Maybe<Scalars['uuid']>;
  agreement_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  appointment?: Maybe<Appointments>;
  appointment_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  author: Users;
  author_id: Scalars['uuid'];
  /** An object relationship */
  course?: Maybe<Education_Courses>;
  course_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  event_type: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  legal_document?: Maybe<Legal_Documents>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  order?: Maybe<Orders>;
  order_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  patient?: Maybe<Users>;
  patient_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  product?: Maybe<Products>;
  product_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  provider?: Maybe<Users>;
  provider_id?: Maybe<Scalars['uuid']>;
  swab_code?: Maybe<Scalars['String']>;
  test_type?: Maybe<Test_Types_Enum>;
  verification_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "activity_events" */
export type Activity_Events_Aggregate = {
  __typename?: 'activity_events_aggregate';
  aggregate?: Maybe<Activity_Events_Aggregate_Fields>;
  nodes: Array<Activity_Events>;
};

/** aggregate fields of "activity_events" */
export type Activity_Events_Aggregate_Fields = {
  __typename?: 'activity_events_aggregate_fields';
  avg?: Maybe<Activity_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Activity_Events_Max_Fields>;
  min?: Maybe<Activity_Events_Min_Fields>;
  stddev?: Maybe<Activity_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Activity_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activity_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Activity_Events_Sum_Fields>;
  var_pop?: Maybe<Activity_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Activity_Events_Var_Samp_Fields>;
  variance?: Maybe<Activity_Events_Variance_Fields>;
};


/** aggregate fields of "activity_events" */
export type Activity_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Activity_Events_Avg_Fields = {
  __typename?: 'activity_events_avg_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "activity_events". All fields are combined with a logical 'AND'. */
export type Activity_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Events_Bool_Exp>>;
  _not?: InputMaybe<Activity_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Events_Bool_Exp>>;
  activity_events_test_type?: InputMaybe<Test_Types_Bool_Exp>;
  admin?: InputMaybe<Users_Bool_Exp>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  agreement_type?: InputMaybe<String_Comparison_Exp>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  author?: InputMaybe<Users_Bool_Exp>;
  author_id?: InputMaybe<Uuid_Comparison_Exp>;
  course?: InputMaybe<Education_Courses_Bool_Exp>;
  course_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legal_document?: InputMaybe<Legal_Documents_Bool_Exp>;
  legal_document_id?: InputMaybe<Bigint_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  patient?: InputMaybe<Users_Bool_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  provider?: InputMaybe<Users_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  swab_code?: InputMaybe<String_Comparison_Exp>;
  test_type?: InputMaybe<Test_Types_Enum_Comparison_Exp>;
  verification_type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity_events" */
export enum Activity_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivityEventsPkey = 'activity_events_pkey'
}

/** input type for incrementing numeric columns in table "activity_events" */
export type Activity_Events_Inc_Input = {
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "activity_events" */
export type Activity_Events_Insert_Input = {
  activity_events_test_type?: InputMaybe<Test_Types_Obj_Rel_Insert_Input>;
  admin?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  admin_id?: InputMaybe<Scalars['uuid']>;
  agreement_type?: InputMaybe<Scalars['String']>;
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  author?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['uuid']>;
  course?: InputMaybe<Education_Courses_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  legal_document?: InputMaybe<Legal_Documents_Obj_Rel_Insert_Input>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  patient?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  swab_code?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  verification_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Activity_Events_Max_Fields = {
  __typename?: 'activity_events_max_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  agreement_type?: Maybe<Scalars['String']>;
  appointment_id?: Maybe<Scalars['uuid']>;
  author_id?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  order_id?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  swab_code?: Maybe<Scalars['String']>;
  verification_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Activity_Events_Min_Fields = {
  __typename?: 'activity_events_min_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  agreement_type?: Maybe<Scalars['String']>;
  appointment_id?: Maybe<Scalars['uuid']>;
  author_id?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  order_id?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  swab_code?: Maybe<Scalars['String']>;
  verification_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "activity_events" */
export type Activity_Events_Mutation_Response = {
  __typename?: 'activity_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Events>;
};

/** on_conflict condition type for table "activity_events" */
export type Activity_Events_On_Conflict = {
  constraint: Activity_Events_Constraint;
  update_columns?: Array<Activity_Events_Update_Column>;
  where?: InputMaybe<Activity_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_events". */
export type Activity_Events_Order_By = {
  activity_events_test_type?: InputMaybe<Test_Types_Order_By>;
  admin?: InputMaybe<Users_Order_By>;
  admin_id?: InputMaybe<Order_By>;
  agreement_type?: InputMaybe<Order_By>;
  appointment?: InputMaybe<Appointments_Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  author?: InputMaybe<Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  course?: InputMaybe<Education_Courses_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_document?: InputMaybe<Legal_Documents_Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Users_Order_By>;
  patient_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Users_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  swab_code?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  verification_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_events */
export type Activity_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "activity_events" */
export enum Activity_Events_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  LegalDocumentId = 'legal_document_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  TestType = 'test_type',
  /** column name */
  VerificationType = 'verification_type'
}

/** input type for updating data in table "activity_events" */
export type Activity_Events_Set_Input = {
  admin_id?: InputMaybe<Scalars['uuid']>;
  agreement_type?: InputMaybe<Scalars['String']>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  author_id?: InputMaybe<Scalars['uuid']>;
  course_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  swab_code?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  verification_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Activity_Events_Stddev_Fields = {
  __typename?: 'activity_events_stddev_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Activity_Events_Stddev_Pop_Fields = {
  __typename?: 'activity_events_stddev_pop_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Activity_Events_Stddev_Samp_Fields = {
  __typename?: 'activity_events_stddev_samp_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "activity_events" */
export type Activity_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Events_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars['uuid']>;
  agreement_type?: InputMaybe<Scalars['String']>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  author_id?: InputMaybe<Scalars['uuid']>;
  course_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  order_id?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  swab_code?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  verification_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Activity_Events_Sum_Fields = {
  __typename?: 'activity_events_sum_fields';
  legal_document_id?: Maybe<Scalars['bigint']>;
  order_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "activity_events" */
export enum Activity_Events_Update_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  LegalDocumentId = 'legal_document_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  TestType = 'test_type',
  /** column name */
  VerificationType = 'verification_type'
}

export type Activity_Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Activity_Events_Var_Pop_Fields = {
  __typename?: 'activity_events_var_pop_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Activity_Events_Var_Samp_Fields = {
  __typename?: 'activity_events_var_samp_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Activity_Events_Variance_Fields = {
  __typename?: 'activity_events_variance_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Table that holds the list of calendar Ids and owner ID for providers. */
export type Acuity_Provider_Calendar = {
  __typename?: 'acuity_provider_calendar';
  active: Scalars['Boolean'];
  /** An object relationship */
  acuity_provider_calendar_user_user_id?: Maybe<Users>;
  calendar_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  owner_id?: Maybe<Scalars['bigint']>;
  provider_calendar?: Maybe<Scalars['String']>;
  provider_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Aggregate = {
  __typename?: 'acuity_provider_calendar_aggregate';
  aggregate?: Maybe<Acuity_Provider_Calendar_Aggregate_Fields>;
  nodes: Array<Acuity_Provider_Calendar>;
};

/** aggregate fields of "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Aggregate_Fields = {
  __typename?: 'acuity_provider_calendar_aggregate_fields';
  avg?: Maybe<Acuity_Provider_Calendar_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Acuity_Provider_Calendar_Max_Fields>;
  min?: Maybe<Acuity_Provider_Calendar_Min_Fields>;
  stddev?: Maybe<Acuity_Provider_Calendar_Stddev_Fields>;
  stddev_pop?: Maybe<Acuity_Provider_Calendar_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Acuity_Provider_Calendar_Stddev_Samp_Fields>;
  sum?: Maybe<Acuity_Provider_Calendar_Sum_Fields>;
  var_pop?: Maybe<Acuity_Provider_Calendar_Var_Pop_Fields>;
  var_samp?: Maybe<Acuity_Provider_Calendar_Var_Samp_Fields>;
  variance?: Maybe<Acuity_Provider_Calendar_Variance_Fields>;
};


/** aggregate fields of "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Acuity_Provider_Calendar_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Acuity_Provider_Calendar_Avg_Fields = {
  __typename?: 'acuity_provider_calendar_avg_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "acuity_provider_calendar". All fields are combined with a logical 'AND'. */
export type Acuity_Provider_Calendar_Bool_Exp = {
  _and?: InputMaybe<Array<Acuity_Provider_Calendar_Bool_Exp>>;
  _not?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
  _or?: InputMaybe<Array<Acuity_Provider_Calendar_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  acuity_provider_calendar_user_user_id?: InputMaybe<Users_Bool_Exp>;
  calendar_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_id?: InputMaybe<Bigint_Comparison_Exp>;
  provider_calendar?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "acuity_provider_calendar" */
export enum Acuity_Provider_Calendar_Constraint {
  /** unique or primary key constraint on columns "calendar_id" */
  AcuityProviderCalendarCalendarIdKey = 'acuity_provider_calendar_calendar_id_key',
  /** unique or primary key constraint on columns "id" */
  AcuityProviderCalendarPkey = 'acuity_provider_calendar_pkey',
  /** unique or primary key constraint on columns "provider_id" */
  AcuityProviderCalendarProviderIdKey = 'acuity_provider_calendar_provider_id_key'
}

/** input type for incrementing numeric columns in table "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Inc_Input = {
  calendar_id?: InputMaybe<Scalars['bigint']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  acuity_provider_calendar_user_user_id?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  calendar_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  provider_calendar?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Acuity_Provider_Calendar_Max_Fields = {
  __typename?: 'acuity_provider_calendar_max_fields';
  calendar_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  owner_id?: Maybe<Scalars['bigint']>;
  provider_calendar?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Acuity_Provider_Calendar_Min_Fields = {
  __typename?: 'acuity_provider_calendar_min_fields';
  calendar_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  owner_id?: Maybe<Scalars['bigint']>;
  provider_calendar?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Mutation_Response = {
  __typename?: 'acuity_provider_calendar_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Acuity_Provider_Calendar>;
};

/** on_conflict condition type for table "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_On_Conflict = {
  constraint: Acuity_Provider_Calendar_Constraint;
  update_columns?: Array<Acuity_Provider_Calendar_Update_Column>;
  where?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
};

/** Ordering options when selecting data from "acuity_provider_calendar". */
export type Acuity_Provider_Calendar_Order_By = {
  active?: InputMaybe<Order_By>;
  acuity_provider_calendar_user_user_id?: InputMaybe<Users_Order_By>;
  calendar_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  provider_calendar?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: acuity_provider_calendar */
export type Acuity_Provider_Calendar_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "acuity_provider_calendar" */
export enum Acuity_Provider_Calendar_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ProviderCalendar = 'provider_calendar',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendar_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  provider_calendar?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Acuity_Provider_Calendar_Stddev_Fields = {
  __typename?: 'acuity_provider_calendar_stddev_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Acuity_Provider_Calendar_Stddev_Pop_Fields = {
  __typename?: 'acuity_provider_calendar_stddev_pop_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Acuity_Provider_Calendar_Stddev_Samp_Fields = {
  __typename?: 'acuity_provider_calendar_stddev_samp_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "acuity_provider_calendar" */
export type Acuity_Provider_Calendar_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Acuity_Provider_Calendar_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Acuity_Provider_Calendar_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  calendar_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  owner_id?: InputMaybe<Scalars['bigint']>;
  provider_calendar?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Acuity_Provider_Calendar_Sum_Fields = {
  __typename?: 'acuity_provider_calendar_sum_fields';
  calendar_id?: Maybe<Scalars['bigint']>;
  owner_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "acuity_provider_calendar" */
export enum Acuity_Provider_Calendar_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ProviderCalendar = 'provider_calendar',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Acuity_Provider_Calendar_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Acuity_Provider_Calendar_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Acuity_Provider_Calendar_Set_Input>;
  /** filter the rows which have to be updated */
  where: Acuity_Provider_Calendar_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Acuity_Provider_Calendar_Var_Pop_Fields = {
  __typename?: 'acuity_provider_calendar_var_pop_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Acuity_Provider_Calendar_Var_Samp_Fields = {
  __typename?: 'acuity_provider_calendar_var_samp_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Acuity_Provider_Calendar_Variance_Fields = {
  __typename?: 'acuity_provider_calendar_variance_fields';
  calendar_id?: Maybe<Scalars['Float']>;
  owner_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  address_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  is_default: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "addresses" */
export type Addresses_Aggregate = {
  __typename?: 'addresses_aggregate';
  aggregate?: Maybe<Addresses_Aggregate_Fields>;
  nodes: Array<Addresses>;
};

/** aggregate fields of "addresses" */
export type Addresses_Aggregate_Fields = {
  __typename?: 'addresses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Addresses_Max_Fields>;
  min?: Maybe<Addresses_Min_Fields>;
};


/** aggregate fields of "addresses" */
export type Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "addresses" */
export enum Addresses_Constraint {
  /** unique or primary key constraint on columns "address_id" */
  AddressesPkey = 'addresses_pkey'
}

/** input type for inserting data into table "addresses" */
export type Addresses_Insert_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Addresses_Max_Fields = {
  __typename?: 'addresses_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Addresses_Min_Fields = {
  __typename?: 'addresses_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "addresses" */
export type Addresses_Mutation_Response = {
  __typename?: 'addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Addresses>;
};

/** on_conflict condition type for table "addresses" */
export type Addresses_On_Conflict = {
  constraint: Addresses_Constraint;
  update_columns?: Array<Addresses_Update_Column>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  address_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: addresses */
export type Addresses_Pk_Columns_Input = {
  address_id: Scalars['uuid'];
};

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "addresses" */
export type Addresses_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "addresses" */
export type Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "addresses" */
export enum Addresses_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Addresses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Addresses_Bool_Exp;
};

/** Boolean expression to compare columns of type "admin_permission_type". All fields are combined with logical 'AND'. */
export type Admin_Permission_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['admin_permission_type']>;
  _gt?: InputMaybe<Scalars['admin_permission_type']>;
  _gte?: InputMaybe<Scalars['admin_permission_type']>;
  _in?: InputMaybe<Array<Scalars['admin_permission_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['admin_permission_type']>;
  _lte?: InputMaybe<Scalars['admin_permission_type']>;
  _neq?: InputMaybe<Scalars['admin_permission_type']>;
  _nin?: InputMaybe<Array<Scalars['admin_permission_type']>>;
};

/** columns and relationships of "admin_permissions" */
export type Admin_Permissions = {
  __typename?: 'admin_permissions';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  permission_type: Scalars['admin_permission_type'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "admin_permissions" */
export type Admin_Permissions_Aggregate = {
  __typename?: 'admin_permissions_aggregate';
  aggregate?: Maybe<Admin_Permissions_Aggregate_Fields>;
  nodes: Array<Admin_Permissions>;
};

export type Admin_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Admin_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Admin_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Admin_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "admin_permissions" */
export type Admin_Permissions_Aggregate_Fields = {
  __typename?: 'admin_permissions_aggregate_fields';
  avg?: Maybe<Admin_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Admin_Permissions_Max_Fields>;
  min?: Maybe<Admin_Permissions_Min_Fields>;
  stddev?: Maybe<Admin_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Admin_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Admin_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Admin_Permissions_Sum_Fields>;
  var_pop?: Maybe<Admin_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Admin_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Admin_Permissions_Variance_Fields>;
};


/** aggregate fields of "admin_permissions" */
export type Admin_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin_permissions" */
export type Admin_Permissions_Aggregate_Order_By = {
  avg?: InputMaybe<Admin_Permissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Admin_Permissions_Max_Order_By>;
  min?: InputMaybe<Admin_Permissions_Min_Order_By>;
  stddev?: InputMaybe<Admin_Permissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Admin_Permissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Admin_Permissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Admin_Permissions_Sum_Order_By>;
  var_pop?: InputMaybe<Admin_Permissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Admin_Permissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Admin_Permissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "admin_permissions" */
export type Admin_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Admin_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_Permissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Admin_Permissions_Avg_Fields = {
  __typename?: 'admin_permissions_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "admin_permissions" */
export type Admin_Permissions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "admin_permissions". All fields are combined with a logical 'AND'. */
export type Admin_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Admin_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_Permissions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  permission_type?: InputMaybe<Admin_Permission_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_permissions" */
export enum Admin_Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdminPermissionsPkey = 'admin_permissions_pkey',
  /** unique or primary key constraint on columns "permission_type", "user_id" */
  AdminPermissionsUnique = 'admin_permissions_unique'
}

/** input type for incrementing numeric columns in table "admin_permissions" */
export type Admin_Permissions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "admin_permissions" */
export type Admin_Permissions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  permission_type?: InputMaybe<Scalars['admin_permission_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Admin_Permissions_Max_Fields = {
  __typename?: 'admin_permissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  permission_type?: Maybe<Scalars['admin_permission_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "admin_permissions" */
export type Admin_Permissions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Admin_Permissions_Min_Fields = {
  __typename?: 'admin_permissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  permission_type?: Maybe<Scalars['admin_permission_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "admin_permissions" */
export type Admin_Permissions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "admin_permissions" */
export type Admin_Permissions_Mutation_Response = {
  __typename?: 'admin_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_Permissions>;
};

/** on_conflict condition type for table "admin_permissions" */
export type Admin_Permissions_On_Conflict = {
  constraint: Admin_Permissions_Constraint;
  update_columns?: Array<Admin_Permissions_Update_Column>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_permissions". */
export type Admin_Permissions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permission_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin_permissions */
export type Admin_Permissions_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "admin_permissions" */
export enum Admin_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionType = 'permission_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "admin_permissions" */
export type Admin_Permissions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  permission_type?: InputMaybe<Scalars['admin_permission_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Admin_Permissions_Stddev_Fields = {
  __typename?: 'admin_permissions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "admin_permissions" */
export type Admin_Permissions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Admin_Permissions_Stddev_Pop_Fields = {
  __typename?: 'admin_permissions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "admin_permissions" */
export type Admin_Permissions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Admin_Permissions_Stddev_Samp_Fields = {
  __typename?: 'admin_permissions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "admin_permissions" */
export type Admin_Permissions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "admin_permissions" */
export type Admin_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Permissions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  permission_type?: InputMaybe<Scalars['admin_permission_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Admin_Permissions_Sum_Fields = {
  __typename?: 'admin_permissions_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "admin_permissions" */
export type Admin_Permissions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "admin_permissions" */
export enum Admin_Permissions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionType = 'permission_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Admin_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Admin_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Admin_Permissions_Var_Pop_Fields = {
  __typename?: 'admin_permissions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "admin_permissions" */
export type Admin_Permissions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Admin_Permissions_Var_Samp_Fields = {
  __typename?: 'admin_permissions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "admin_permissions" */
export type Admin_Permissions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Admin_Permissions_Variance_Fields = {
  __typename?: 'admin_permissions_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "admin_permissions" */
export type Admin_Permissions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "age_of_majority_rules" */
export type Age_Of_Majority_Rules = {
  __typename?: 'age_of_majority_rules';
  age_of_majority: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  state_code: Scalars['bpchar'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Aggregate = {
  __typename?: 'age_of_majority_rules_aggregate';
  aggregate?: Maybe<Age_Of_Majority_Rules_Aggregate_Fields>;
  nodes: Array<Age_Of_Majority_Rules>;
};

/** aggregate fields of "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Aggregate_Fields = {
  __typename?: 'age_of_majority_rules_aggregate_fields';
  avg?: Maybe<Age_Of_Majority_Rules_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Age_Of_Majority_Rules_Max_Fields>;
  min?: Maybe<Age_Of_Majority_Rules_Min_Fields>;
  stddev?: Maybe<Age_Of_Majority_Rules_Stddev_Fields>;
  stddev_pop?: Maybe<Age_Of_Majority_Rules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Age_Of_Majority_Rules_Stddev_Samp_Fields>;
  sum?: Maybe<Age_Of_Majority_Rules_Sum_Fields>;
  var_pop?: Maybe<Age_Of_Majority_Rules_Var_Pop_Fields>;
  var_samp?: Maybe<Age_Of_Majority_Rules_Var_Samp_Fields>;
  variance?: Maybe<Age_Of_Majority_Rules_Variance_Fields>;
};


/** aggregate fields of "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Age_Of_Majority_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Age_Of_Majority_Rules_Avg_Fields = {
  __typename?: 'age_of_majority_rules_avg_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "age_of_majority_rules". All fields are combined with a logical 'AND'. */
export type Age_Of_Majority_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Age_Of_Majority_Rules_Bool_Exp>>;
  _not?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Age_Of_Majority_Rules_Bool_Exp>>;
  age_of_majority?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  state_code?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "age_of_majority_rules" */
export enum Age_Of_Majority_Rules_Constraint {
  /** unique or primary key constraint on columns "state_code" */
  AgeOfMajorityRulesPkey = 'age_of_majority_rules_pkey'
}

/** input type for incrementing numeric columns in table "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Inc_Input = {
  age_of_majority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Insert_Input = {
  age_of_majority?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  state_code?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Age_Of_Majority_Rules_Max_Fields = {
  __typename?: 'age_of_majority_rules_max_fields';
  age_of_majority?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  state_code?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Age_Of_Majority_Rules_Min_Fields = {
  __typename?: 'age_of_majority_rules_min_fields';
  age_of_majority?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  state_code?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Mutation_Response = {
  __typename?: 'age_of_majority_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Age_Of_Majority_Rules>;
};

/** on_conflict condition type for table "age_of_majority_rules" */
export type Age_Of_Majority_Rules_On_Conflict = {
  constraint: Age_Of_Majority_Rules_Constraint;
  update_columns?: Array<Age_Of_Majority_Rules_Update_Column>;
  where?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "age_of_majority_rules". */
export type Age_Of_Majority_Rules_Order_By = {
  age_of_majority?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  state_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: age_of_majority_rules */
export type Age_Of_Majority_Rules_Pk_Columns_Input = {
  state_code: Scalars['bpchar'];
};

/** select columns of table "age_of_majority_rules" */
export enum Age_Of_Majority_Rules_Select_Column {
  /** column name */
  AgeOfMajority = 'age_of_majority',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Set_Input = {
  age_of_majority?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  state_code?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Age_Of_Majority_Rules_Stddev_Fields = {
  __typename?: 'age_of_majority_rules_stddev_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Age_Of_Majority_Rules_Stddev_Pop_Fields = {
  __typename?: 'age_of_majority_rules_stddev_pop_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Age_Of_Majority_Rules_Stddev_Samp_Fields = {
  __typename?: 'age_of_majority_rules_stddev_samp_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "age_of_majority_rules" */
export type Age_Of_Majority_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Age_Of_Majority_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Age_Of_Majority_Rules_Stream_Cursor_Value_Input = {
  age_of_majority?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  state_code?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Age_Of_Majority_Rules_Sum_Fields = {
  __typename?: 'age_of_majority_rules_sum_fields';
  age_of_majority?: Maybe<Scalars['Int']>;
};

/** update columns of table "age_of_majority_rules" */
export enum Age_Of_Majority_Rules_Update_Column {
  /** column name */
  AgeOfMajority = 'age_of_majority',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  StateCode = 'state_code',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Age_Of_Majority_Rules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Age_Of_Majority_Rules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Age_Of_Majority_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Age_Of_Majority_Rules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Age_Of_Majority_Rules_Var_Pop_Fields = {
  __typename?: 'age_of_majority_rules_var_pop_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Age_Of_Majority_Rules_Var_Samp_Fields = {
  __typename?: 'age_of_majority_rules_var_samp_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Age_Of_Majority_Rules_Variance_Fields = {
  __typename?: 'age_of_majority_rules_variance_fields';
  age_of_majority?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "allergen_classes" */
export type Allergen_Classes = {
  __typename?: 'allergen_classes';
  active: Scalars['Boolean'];
  class_id: Scalars['String'];
  class_name: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "allergen_classes" */
export type Allergen_Classes_Aggregate = {
  __typename?: 'allergen_classes_aggregate';
  aggregate?: Maybe<Allergen_Classes_Aggregate_Fields>;
  nodes: Array<Allergen_Classes>;
};

/** aggregate fields of "allergen_classes" */
export type Allergen_Classes_Aggregate_Fields = {
  __typename?: 'allergen_classes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Allergen_Classes_Max_Fields>;
  min?: Maybe<Allergen_Classes_Min_Fields>;
};


/** aggregate fields of "allergen_classes" */
export type Allergen_Classes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Allergen_Classes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "allergen_classes". All fields are combined with a logical 'AND'. */
export type Allergen_Classes_Bool_Exp = {
  _and?: InputMaybe<Array<Allergen_Classes_Bool_Exp>>;
  _not?: InputMaybe<Allergen_Classes_Bool_Exp>;
  _or?: InputMaybe<Array<Allergen_Classes_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  class_id?: InputMaybe<String_Comparison_Exp>;
  class_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "allergen_classes" */
export enum Allergen_Classes_Constraint {
  /** unique or primary key constraint on columns "class_id" */
  AllergenClassesClassIdKey = 'allergen_classes_class_id_key',
  /** unique or primary key constraint on columns "id" */
  AllergenClassesPkey = 'allergen_classes_pkey'
}

/** input type for inserting data into table "allergen_classes" */
export type Allergen_Classes_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  class_id?: InputMaybe<Scalars['String']>;
  class_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Allergen_Classes_Max_Fields = {
  __typename?: 'allergen_classes_max_fields';
  class_id?: Maybe<Scalars['String']>;
  class_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Allergen_Classes_Min_Fields = {
  __typename?: 'allergen_classes_min_fields';
  class_id?: Maybe<Scalars['String']>;
  class_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "allergen_classes" */
export type Allergen_Classes_Mutation_Response = {
  __typename?: 'allergen_classes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Allergen_Classes>;
};

/** on_conflict condition type for table "allergen_classes" */
export type Allergen_Classes_On_Conflict = {
  constraint: Allergen_Classes_Constraint;
  update_columns?: Array<Allergen_Classes_Update_Column>;
  where?: InputMaybe<Allergen_Classes_Bool_Exp>;
};

/** Ordering options when selecting data from "allergen_classes". */
export type Allergen_Classes_Order_By = {
  active?: InputMaybe<Order_By>;
  class_id?: InputMaybe<Order_By>;
  class_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: allergen_classes */
export type Allergen_Classes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "allergen_classes" */
export enum Allergen_Classes_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ClassId = 'class_id',
  /** column name */
  ClassName = 'class_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "allergen_classes" */
export type Allergen_Classes_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  class_id?: InputMaybe<Scalars['String']>;
  class_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "allergen_classes" */
export type Allergen_Classes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Allergen_Classes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Allergen_Classes_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  class_id?: InputMaybe<Scalars['String']>;
  class_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "allergen_classes" */
export enum Allergen_Classes_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ClassId = 'class_id',
  /** column name */
  ClassName = 'class_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Allergen_Classes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Allergen_Classes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Allergen_Classes_Bool_Exp;
};

/** Boolean expression to compare columns of type "app_tour_type". All fields are combined with logical 'AND'. */
export type App_Tour_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['app_tour_type']>;
  _gt?: InputMaybe<Scalars['app_tour_type']>;
  _gte?: InputMaybe<Scalars['app_tour_type']>;
  _in?: InputMaybe<Array<Scalars['app_tour_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['app_tour_type']>;
  _lte?: InputMaybe<Scalars['app_tour_type']>;
  _neq?: InputMaybe<Scalars['app_tour_type']>;
  _nin?: InputMaybe<Array<Scalars['app_tour_type']>>;
};

/** columns and relationships of "app_tours" */
export type App_Tours = {
  __typename?: 'app_tours';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_completed: Scalars['Boolean'];
  type: Scalars['app_tour_type'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "app_tours" */
export type App_Tours_Aggregate = {
  __typename?: 'app_tours_aggregate';
  aggregate?: Maybe<App_Tours_Aggregate_Fields>;
  nodes: Array<App_Tours>;
};

/** aggregate fields of "app_tours" */
export type App_Tours_Aggregate_Fields = {
  __typename?: 'app_tours_aggregate_fields';
  avg?: Maybe<App_Tours_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<App_Tours_Max_Fields>;
  min?: Maybe<App_Tours_Min_Fields>;
  stddev?: Maybe<App_Tours_Stddev_Fields>;
  stddev_pop?: Maybe<App_Tours_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Tours_Stddev_Samp_Fields>;
  sum?: Maybe<App_Tours_Sum_Fields>;
  var_pop?: Maybe<App_Tours_Var_Pop_Fields>;
  var_samp?: Maybe<App_Tours_Var_Samp_Fields>;
  variance?: Maybe<App_Tours_Variance_Fields>;
};


/** aggregate fields of "app_tours" */
export type App_Tours_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Tours_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type App_Tours_Avg_Fields = {
  __typename?: 'app_tours_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "app_tours". All fields are combined with a logical 'AND'. */
export type App_Tours_Bool_Exp = {
  _and?: InputMaybe<Array<App_Tours_Bool_Exp>>;
  _not?: InputMaybe<App_Tours_Bool_Exp>;
  _or?: InputMaybe<Array<App_Tours_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<App_Tour_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "app_tours" */
export enum App_Tours_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppToursPkey = 'app_tours_pkey',
  /** unique or primary key constraint on columns "user_id", "type" */
  AppToursUserIdTypeKey = 'app_tours_user_id_type_key'
}

/** input type for incrementing numeric columns in table "app_tours" */
export type App_Tours_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "app_tours" */
export type App_Tours_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_completed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['app_tour_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type App_Tours_Max_Fields = {
  __typename?: 'app_tours_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['app_tour_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type App_Tours_Min_Fields = {
  __typename?: 'app_tours_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['app_tour_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "app_tours" */
export type App_Tours_Mutation_Response = {
  __typename?: 'app_tours_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Tours>;
};

/** on_conflict condition type for table "app_tours" */
export type App_Tours_On_Conflict = {
  constraint: App_Tours_Constraint;
  update_columns?: Array<App_Tours_Update_Column>;
  where?: InputMaybe<App_Tours_Bool_Exp>;
};

/** Ordering options when selecting data from "app_tours". */
export type App_Tours_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: app_tours */
export type App_Tours_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "app_tours" */
export enum App_Tours_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "app_tours" */
export type App_Tours_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_completed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['app_tour_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type App_Tours_Stddev_Fields = {
  __typename?: 'app_tours_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type App_Tours_Stddev_Pop_Fields = {
  __typename?: 'app_tours_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type App_Tours_Stddev_Samp_Fields = {
  __typename?: 'app_tours_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "app_tours" */
export type App_Tours_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Tours_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Tours_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_completed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['app_tour_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type App_Tours_Sum_Fields = {
  __typename?: 'app_tours_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "app_tours" */
export enum App_Tours_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsCompleted = 'is_completed',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type App_Tours_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Tours_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Tours_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Tours_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Tours_Var_Pop_Fields = {
  __typename?: 'app_tours_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type App_Tours_Var_Samp_Fields = {
  __typename?: 'app_tours_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type App_Tours_Variance_Fields = {
  __typename?: 'app_tours_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "app_versions" */
export type App_Versions = {
  __typename?: 'app_versions';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  release_notes: Scalars['String'];
  release_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['String'];
};

/** aggregated selection of "app_versions" */
export type App_Versions_Aggregate = {
  __typename?: 'app_versions_aggregate';
  aggregate?: Maybe<App_Versions_Aggregate_Fields>;
  nodes: Array<App_Versions>;
};

/** aggregate fields of "app_versions" */
export type App_Versions_Aggregate_Fields = {
  __typename?: 'app_versions_aggregate_fields';
  avg?: Maybe<App_Versions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<App_Versions_Max_Fields>;
  min?: Maybe<App_Versions_Min_Fields>;
  stddev?: Maybe<App_Versions_Stddev_Fields>;
  stddev_pop?: Maybe<App_Versions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Versions_Stddev_Samp_Fields>;
  sum?: Maybe<App_Versions_Sum_Fields>;
  var_pop?: Maybe<App_Versions_Var_Pop_Fields>;
  var_samp?: Maybe<App_Versions_Var_Samp_Fields>;
  variance?: Maybe<App_Versions_Variance_Fields>;
};


/** aggregate fields of "app_versions" */
export type App_Versions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<App_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type App_Versions_Avg_Fields = {
  __typename?: 'app_versions_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "app_versions". All fields are combined with a logical 'AND'. */
export type App_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<App_Versions_Bool_Exp>>;
  _not?: InputMaybe<App_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<App_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  release_notes?: InputMaybe<String_Comparison_Exp>;
  release_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "app_versions" */
export enum App_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppVersionsPkey = 'app_versions_pkey',
  /** unique or primary key constraint on columns "version" */
  AppVersionsVersionKey = 'app_versions_version_key'
}

/** input type for incrementing numeric columns in table "app_versions" */
export type App_Versions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "app_versions" */
export type App_Versions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  release_notes?: InputMaybe<Scalars['String']>;
  release_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type App_Versions_Max_Fields = {
  __typename?: 'app_versions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  release_notes?: Maybe<Scalars['String']>;
  release_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type App_Versions_Min_Fields = {
  __typename?: 'app_versions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  release_notes?: Maybe<Scalars['String']>;
  release_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "app_versions" */
export type App_Versions_Mutation_Response = {
  __typename?: 'app_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<App_Versions>;
};

/** on_conflict condition type for table "app_versions" */
export type App_Versions_On_Conflict = {
  constraint: App_Versions_Constraint;
  update_columns?: Array<App_Versions_Update_Column>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "app_versions". */
export type App_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  release_notes?: InputMaybe<Order_By>;
  release_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: app_versions */
export type App_Versions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "app_versions" */
export enum App_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReleaseNotes = 'release_notes',
  /** column name */
  ReleaseType = 'release_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "app_versions" */
export type App_Versions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  release_notes?: InputMaybe<Scalars['String']>;
  release_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type App_Versions_Stddev_Fields = {
  __typename?: 'app_versions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type App_Versions_Stddev_Pop_Fields = {
  __typename?: 'app_versions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type App_Versions_Stddev_Samp_Fields = {
  __typename?: 'app_versions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "app_versions" */
export type App_Versions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: App_Versions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type App_Versions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  release_notes?: InputMaybe<Scalars['String']>;
  release_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type App_Versions_Sum_Fields = {
  __typename?: 'app_versions_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "app_versions" */
export enum App_Versions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReleaseNotes = 'release_notes',
  /** column name */
  ReleaseType = 'release_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

export type App_Versions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<App_Versions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<App_Versions_Set_Input>;
  /** filter the rows which have to be updated */
  where: App_Versions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type App_Versions_Var_Pop_Fields = {
  __typename?: 'app_versions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type App_Versions_Var_Samp_Fields = {
  __typename?: 'app_versions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type App_Versions_Variance_Fields = {
  __typename?: 'app_versions_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "appointment_media_signals" */
export type Appointment_Media_Signals = {
  __typename?: 'appointment_media_signals';
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
  lastUpdatedAt: Scalars['timestamptz'];
  location: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "appointment_media_signals" */
export type Appointment_Media_Signals_Aggregate = {
  __typename?: 'appointment_media_signals_aggregate';
  aggregate?: Maybe<Appointment_Media_Signals_Aggregate_Fields>;
  nodes: Array<Appointment_Media_Signals>;
};

/** aggregate fields of "appointment_media_signals" */
export type Appointment_Media_Signals_Aggregate_Fields = {
  __typename?: 'appointment_media_signals_aggregate_fields';
  avg?: Maybe<Appointment_Media_Signals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appointment_Media_Signals_Max_Fields>;
  min?: Maybe<Appointment_Media_Signals_Min_Fields>;
  stddev?: Maybe<Appointment_Media_Signals_Stddev_Fields>;
  stddev_pop?: Maybe<Appointment_Media_Signals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appointment_Media_Signals_Stddev_Samp_Fields>;
  sum?: Maybe<Appointment_Media_Signals_Sum_Fields>;
  var_pop?: Maybe<Appointment_Media_Signals_Var_Pop_Fields>;
  var_samp?: Maybe<Appointment_Media_Signals_Var_Samp_Fields>;
  variance?: Maybe<Appointment_Media_Signals_Variance_Fields>;
};


/** aggregate fields of "appointment_media_signals" */
export type Appointment_Media_Signals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointment_Media_Signals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Appointment_Media_Signals_Avg_Fields = {
  __typename?: 'appointment_media_signals_avg_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "appointment_media_signals". All fields are combined with a logical 'AND'. */
export type Appointment_Media_Signals_Bool_Exp = {
  _and?: InputMaybe<Array<Appointment_Media_Signals_Bool_Exp>>;
  _not?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
  _or?: InputMaybe<Array<Appointment_Media_Signals_Bool_Exp>>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lastUpdatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  location?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "appointment_media_signals" */
export enum Appointment_Media_Signals_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppointmentMediaSignalsPkey = 'appointment_media_signals_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AppointmentMediaSignalsUserId = 'appointment_media_signals_user_id',
  /** unique or primary key constraint on columns "user_id", "file_id" */
  AppointmentMediaSignalsUserIdFileIdKey = 'appointment_media_signals_user_id_file_id_key'
}

/** input type for incrementing numeric columns in table "appointment_media_signals" */
export type Appointment_Media_Signals_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "appointment_media_signals" */
export type Appointment_Media_Signals_Insert_Input = {
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  lastUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Appointment_Media_Signals_Max_Fields = {
  __typename?: 'appointment_media_signals_max_fields';
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  lastUpdatedAt?: Maybe<Scalars['timestamptz']>;
  location?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Appointment_Media_Signals_Min_Fields = {
  __typename?: 'appointment_media_signals_min_fields';
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  lastUpdatedAt?: Maybe<Scalars['timestamptz']>;
  location?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "appointment_media_signals" */
export type Appointment_Media_Signals_Mutation_Response = {
  __typename?: 'appointment_media_signals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Appointment_Media_Signals>;
};

/** on_conflict condition type for table "appointment_media_signals" */
export type Appointment_Media_Signals_On_Conflict = {
  constraint: Appointment_Media_Signals_Constraint;
  update_columns?: Array<Appointment_Media_Signals_Update_Column>;
  where?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
};

/** Ordering options when selecting data from "appointment_media_signals". */
export type Appointment_Media_Signals_Order_By = {
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: appointment_media_signals */
export type Appointment_Media_Signals_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "appointment_media_signals" */
export enum Appointment_Media_Signals_Select_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Location = 'location',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "appointment_media_signals" */
export type Appointment_Media_Signals_Set_Input = {
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  lastUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Appointment_Media_Signals_Stddev_Fields = {
  __typename?: 'appointment_media_signals_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Appointment_Media_Signals_Stddev_Pop_Fields = {
  __typename?: 'appointment_media_signals_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Appointment_Media_Signals_Stddev_Samp_Fields = {
  __typename?: 'appointment_media_signals_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "appointment_media_signals" */
export type Appointment_Media_Signals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointment_Media_Signals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointment_Media_Signals_Stream_Cursor_Value_Input = {
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  lastUpdatedAt?: InputMaybe<Scalars['timestamptz']>;
  location?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Appointment_Media_Signals_Sum_Fields = {
  __typename?: 'appointment_media_signals_sum_fields';
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['Int']>;
};

/** update columns of table "appointment_media_signals" */
export enum Appointment_Media_Signals_Update_Column {
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Location = 'location',
  /** column name */
  UserId = 'user_id'
}

export type Appointment_Media_Signals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appointment_Media_Signals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointment_Media_Signals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appointment_Media_Signals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appointment_Media_Signals_Var_Pop_Fields = {
  __typename?: 'appointment_media_signals_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Appointment_Media_Signals_Var_Samp_Fields = {
  __typename?: 'appointment_media_signals_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Appointment_Media_Signals_Variance_Fields = {
  __typename?: 'appointment_media_signals_variance_fields';
  id?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "appointment_payments" */
export type Appointment_Payments = {
  __typename?: 'appointment_payments';
  amount_subtotal?: Maybe<Scalars['numeric']>;
  amount_total?: Maybe<Scalars['numeric']>;
  appointment_id: Scalars['uuid'];
  createdAt: Scalars['timestamp'];
  id: Scalars['Int'];
  payment_date: Scalars['timestamp'];
  status: Scalars['Int'];
  transaction_id: Scalars['String'];
  updatedAt: Scalars['timestamp'];
};

/** aggregated selection of "appointment_payments" */
export type Appointment_Payments_Aggregate = {
  __typename?: 'appointment_payments_aggregate';
  aggregate?: Maybe<Appointment_Payments_Aggregate_Fields>;
  nodes: Array<Appointment_Payments>;
};

export type Appointment_Payments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Appointment_Payments_Aggregate_Bool_Exp_Count>;
};

export type Appointment_Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Appointment_Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "appointment_payments" */
export type Appointment_Payments_Aggregate_Fields = {
  __typename?: 'appointment_payments_aggregate_fields';
  avg?: Maybe<Appointment_Payments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appointment_Payments_Max_Fields>;
  min?: Maybe<Appointment_Payments_Min_Fields>;
  stddev?: Maybe<Appointment_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Appointment_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appointment_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Appointment_Payments_Sum_Fields>;
  var_pop?: Maybe<Appointment_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Appointment_Payments_Var_Samp_Fields>;
  variance?: Maybe<Appointment_Payments_Variance_Fields>;
};


/** aggregate fields of "appointment_payments" */
export type Appointment_Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "appointment_payments" */
export type Appointment_Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Appointment_Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appointment_Payments_Max_Order_By>;
  min?: InputMaybe<Appointment_Payments_Min_Order_By>;
  stddev?: InputMaybe<Appointment_Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Appointment_Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Appointment_Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Appointment_Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Appointment_Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Appointment_Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Appointment_Payments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "appointment_payments" */
export type Appointment_Payments_Arr_Rel_Insert_Input = {
  data: Array<Appointment_Payments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointment_Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Appointment_Payments_Avg_Fields = {
  __typename?: 'appointment_payments_avg_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "appointment_payments" */
export type Appointment_Payments_Avg_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "appointment_payments". All fields are combined with a logical 'AND'. */
export type Appointment_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Appointment_Payments_Bool_Exp>>;
  _not?: InputMaybe<Appointment_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Appointment_Payments_Bool_Exp>>;
  amount_subtotal?: InputMaybe<Numeric_Comparison_Exp>;
  amount_total?: InputMaybe<Numeric_Comparison_Exp>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamp_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "appointment_payments" */
export enum Appointment_Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppointmentPaymentsPkey = 'appointment_payments_pkey',
  /** unique or primary key constraint on columns "transaction_id", "appointment_id" */
  AppointmentPaymentsTransactionIdAppointmentIdKey = 'appointment_payments_transaction_id_appointment_id_key'
}

/** input type for incrementing numeric columns in table "appointment_payments" */
export type Appointment_Payments_Inc_Input = {
  amount_subtotal?: InputMaybe<Scalars['numeric']>;
  amount_total?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "appointment_payments" */
export type Appointment_Payments_Insert_Input = {
  amount_subtotal?: InputMaybe<Scalars['numeric']>;
  amount_total?: InputMaybe<Scalars['numeric']>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_date?: InputMaybe<Scalars['timestamp']>;
  status?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Appointment_Payments_Max_Fields = {
  __typename?: 'appointment_payments_max_fields';
  amount_subtotal?: Maybe<Scalars['numeric']>;
  amount_total?: Maybe<Scalars['numeric']>;
  appointment_id?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  payment_date?: Maybe<Scalars['timestamp']>;
  status?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "appointment_payments" */
export type Appointment_Payments_Max_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appointment_Payments_Min_Fields = {
  __typename?: 'appointment_payments_min_fields';
  amount_subtotal?: Maybe<Scalars['numeric']>;
  amount_total?: Maybe<Scalars['numeric']>;
  appointment_id?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  payment_date?: Maybe<Scalars['timestamp']>;
  status?: Maybe<Scalars['Int']>;
  transaction_id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "appointment_payments" */
export type Appointment_Payments_Min_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "appointment_payments" */
export type Appointment_Payments_Mutation_Response = {
  __typename?: 'appointment_payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Appointment_Payments>;
};

/** on_conflict condition type for table "appointment_payments" */
export type Appointment_Payments_On_Conflict = {
  constraint: Appointment_Payments_Constraint;
  update_columns?: Array<Appointment_Payments_Update_Column>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "appointment_payments". */
export type Appointment_Payments_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: appointment_payments */
export type Appointment_Payments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "appointment_payments" */
export enum Appointment_Payments_Select_Column {
  /** column name */
  AmountSubtotal = 'amount_subtotal',
  /** column name */
  AmountTotal = 'amount_total',
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "appointment_payments" */
export type Appointment_Payments_Set_Input = {
  amount_subtotal?: InputMaybe<Scalars['numeric']>;
  amount_total?: InputMaybe<Scalars['numeric']>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_date?: InputMaybe<Scalars['timestamp']>;
  status?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Appointment_Payments_Stddev_Fields = {
  __typename?: 'appointment_payments_stddev_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "appointment_payments" */
export type Appointment_Payments_Stddev_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Appointment_Payments_Stddev_Pop_Fields = {
  __typename?: 'appointment_payments_stddev_pop_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "appointment_payments" */
export type Appointment_Payments_Stddev_Pop_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Appointment_Payments_Stddev_Samp_Fields = {
  __typename?: 'appointment_payments_stddev_samp_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "appointment_payments" */
export type Appointment_Payments_Stddev_Samp_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "appointment_payments" */
export type Appointment_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointment_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointment_Payments_Stream_Cursor_Value_Input = {
  amount_subtotal?: InputMaybe<Scalars['numeric']>;
  amount_total?: InputMaybe<Scalars['numeric']>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_date?: InputMaybe<Scalars['timestamp']>;
  status?: InputMaybe<Scalars['Int']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Appointment_Payments_Sum_Fields = {
  __typename?: 'appointment_payments_sum_fields';
  amount_subtotal?: Maybe<Scalars['numeric']>;
  amount_total?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "appointment_payments" */
export type Appointment_Payments_Sum_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** update columns of table "appointment_payments" */
export enum Appointment_Payments_Update_Column {
  /** column name */
  AmountSubtotal = 'amount_subtotal',
  /** column name */
  AmountTotal = 'amount_total',
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Appointment_Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appointment_Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointment_Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appointment_Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appointment_Payments_Var_Pop_Fields = {
  __typename?: 'appointment_payments_var_pop_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "appointment_payments" */
export type Appointment_Payments_Var_Pop_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Appointment_Payments_Var_Samp_Fields = {
  __typename?: 'appointment_payments_var_samp_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "appointment_payments" */
export type Appointment_Payments_Var_Samp_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Appointment_Payments_Variance_Fields = {
  __typename?: 'appointment_payments_variance_fields';
  amount_subtotal?: Maybe<Scalars['Float']>;
  amount_total?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "appointment_payments" */
export type Appointment_Payments_Variance_Order_By = {
  amount_subtotal?: InputMaybe<Order_By>;
  amount_total?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "appointment_requests" */
export type Appointment_Requests = {
  __typename?: 'appointment_requests';
  /** An object relationship */
  appointment?: Maybe<Appointments>;
  appointment_codex_id?: Maybe<Scalars['uuid']>;
  appointment_type_id?: Maybe<Scalars['Int']>;
  approved_date?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  notification_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  patient?: Maybe<Users>;
  patient_codex_id?: Maybe<Scalars['uuid']>;
  proposed_date: Scalars['timestamptz'];
  provider_codex_id: Scalars['uuid'];
  reason: Scalars['String'];
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status: Scalars['smallint'];
  /** 1 - reschedule, 2 - book */
  type: Scalars['smallint'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user_notification?: Maybe<User_Notifications>;
};

/** aggregated selection of "appointment_requests" */
export type Appointment_Requests_Aggregate = {
  __typename?: 'appointment_requests_aggregate';
  aggregate?: Maybe<Appointment_Requests_Aggregate_Fields>;
  nodes: Array<Appointment_Requests>;
};

/** aggregate fields of "appointment_requests" */
export type Appointment_Requests_Aggregate_Fields = {
  __typename?: 'appointment_requests_aggregate_fields';
  avg?: Maybe<Appointment_Requests_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appointment_Requests_Max_Fields>;
  min?: Maybe<Appointment_Requests_Min_Fields>;
  stddev?: Maybe<Appointment_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Appointment_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appointment_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Appointment_Requests_Sum_Fields>;
  var_pop?: Maybe<Appointment_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Appointment_Requests_Var_Samp_Fields>;
  variance?: Maybe<Appointment_Requests_Variance_Fields>;
};


/** aggregate fields of "appointment_requests" */
export type Appointment_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointment_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Appointment_Requests_Avg_Fields = {
  __typename?: 'appointment_requests_avg_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "appointment_requests". All fields are combined with a logical 'AND'. */
export type Appointment_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Appointment_Requests_Bool_Exp>>;
  _not?: InputMaybe<Appointment_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Appointment_Requests_Bool_Exp>>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointment_codex_id?: InputMaybe<Uuid_Comparison_Exp>;
  appointment_type_id?: InputMaybe<Int_Comparison_Exp>;
  approved_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  patient?: InputMaybe<Users_Bool_Exp>;
  patient_codex_id?: InputMaybe<Uuid_Comparison_Exp>;
  proposed_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  provider_codex_id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  type?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_notification?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** unique or primary key constraints on table "appointment_requests" */
export enum Appointment_Requests_Constraint {
  /** unique or primary key constraint on columns "appointment_codex_id" */
  AppointmentRequestsPendingAppointmentUniqueIdx = 'appointment_requests_pending_appointment_unique_idx',
  /** unique or primary key constraint on columns "id" */
  AppointmentRescheduleRequestsPkey = 'appointment_reschedule_requests_pkey'
}

/** input type for incrementing numeric columns in table "appointment_requests" */
export type Appointment_Requests_Inc_Input = {
  appointment_type_id?: InputMaybe<Scalars['Int']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: InputMaybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "appointment_requests" */
export type Appointment_Requests_Insert_Input = {
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointment_codex_id?: InputMaybe<Scalars['uuid']>;
  appointment_type_id?: InputMaybe<Scalars['Int']>;
  approved_date?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  patient?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  patient_codex_id?: InputMaybe<Scalars['uuid']>;
  proposed_date?: InputMaybe<Scalars['timestamptz']>;
  provider_codex_id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: InputMaybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_notification?: InputMaybe<User_Notifications_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Appointment_Requests_Max_Fields = {
  __typename?: 'appointment_requests_max_fields';
  appointment_codex_id?: Maybe<Scalars['uuid']>;
  appointment_type_id?: Maybe<Scalars['Int']>;
  approved_date?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  patient_codex_id?: Maybe<Scalars['uuid']>;
  proposed_date?: Maybe<Scalars['timestamptz']>;
  provider_codex_id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Appointment_Requests_Min_Fields = {
  __typename?: 'appointment_requests_min_fields';
  appointment_codex_id?: Maybe<Scalars['uuid']>;
  appointment_type_id?: Maybe<Scalars['Int']>;
  approved_date?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notification_id?: Maybe<Scalars['uuid']>;
  patient_codex_id?: Maybe<Scalars['uuid']>;
  proposed_date?: Maybe<Scalars['timestamptz']>;
  provider_codex_id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "appointment_requests" */
export type Appointment_Requests_Mutation_Response = {
  __typename?: 'appointment_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Appointment_Requests>;
};

/** input type for inserting object relation for remote table "appointment_requests" */
export type Appointment_Requests_Obj_Rel_Insert_Input = {
  data: Appointment_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointment_Requests_On_Conflict>;
};

/** on_conflict condition type for table "appointment_requests" */
export type Appointment_Requests_On_Conflict = {
  constraint: Appointment_Requests_Constraint;
  update_columns?: Array<Appointment_Requests_Update_Column>;
  where?: InputMaybe<Appointment_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "appointment_requests". */
export type Appointment_Requests_Order_By = {
  appointment?: InputMaybe<Appointments_Order_By>;
  appointment_codex_id?: InputMaybe<Order_By>;
  appointment_type_id?: InputMaybe<Order_By>;
  approved_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Users_Order_By>;
  patient_codex_id?: InputMaybe<Order_By>;
  proposed_date?: InputMaybe<Order_By>;
  provider_codex_id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_notification?: InputMaybe<User_Notifications_Order_By>;
};

/** primary key columns input for table: appointment_requests */
export type Appointment_Requests_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "appointment_requests" */
export enum Appointment_Requests_Select_Column {
  /** column name */
  AppointmentCodexId = 'appointment_codex_id',
  /** column name */
  AppointmentTypeId = 'appointment_type_id',
  /** column name */
  ApprovedDate = 'approved_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PatientCodexId = 'patient_codex_id',
  /** column name */
  ProposedDate = 'proposed_date',
  /** column name */
  ProviderCodexId = 'provider_codex_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "appointment_requests" */
export type Appointment_Requests_Set_Input = {
  appointment_codex_id?: InputMaybe<Scalars['uuid']>;
  appointment_type_id?: InputMaybe<Scalars['Int']>;
  approved_date?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  patient_codex_id?: InputMaybe<Scalars['uuid']>;
  proposed_date?: InputMaybe<Scalars['timestamptz']>;
  provider_codex_id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: InputMaybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Appointment_Requests_Stddev_Fields = {
  __typename?: 'appointment_requests_stddev_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Appointment_Requests_Stddev_Pop_Fields = {
  __typename?: 'appointment_requests_stddev_pop_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Appointment_Requests_Stddev_Samp_Fields = {
  __typename?: 'appointment_requests_stddev_samp_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "appointment_requests" */
export type Appointment_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointment_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointment_Requests_Stream_Cursor_Value_Input = {
  appointment_codex_id?: InputMaybe<Scalars['uuid']>;
  appointment_type_id?: InputMaybe<Scalars['Int']>;
  approved_date?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  patient_codex_id?: InputMaybe<Scalars['uuid']>;
  proposed_date?: InputMaybe<Scalars['timestamptz']>;
  provider_codex_id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: InputMaybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Appointment_Requests_Sum_Fields = {
  __typename?: 'appointment_requests_sum_fields';
  appointment_type_id?: Maybe<Scalars['Int']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['smallint']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['smallint']>;
};

/** update columns of table "appointment_requests" */
export enum Appointment_Requests_Update_Column {
  /** column name */
  AppointmentCodexId = 'appointment_codex_id',
  /** column name */
  AppointmentTypeId = 'appointment_type_id',
  /** column name */
  ApprovedDate = 'approved_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  PatientCodexId = 'patient_codex_id',
  /** column name */
  ProposedDate = 'proposed_date',
  /** column name */
  ProviderCodexId = 'provider_codex_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Appointment_Requests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appointment_Requests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointment_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appointment_Requests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appointment_Requests_Var_Pop_Fields = {
  __typename?: 'appointment_requests_var_pop_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Appointment_Requests_Var_Samp_Fields = {
  __typename?: 'appointment_requests_var_samp_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Appointment_Requests_Variance_Fields = {
  __typename?: 'appointment_requests_variance_fields';
  appointment_type_id?: Maybe<Scalars['Float']>;
  /** 1 - Pending, 2 - Declined, 3 - Outdated, 4 - Approved */
  status?: Maybe<Scalars['Float']>;
  /** 1 - reschedule, 2 - book */
  type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "appointment_status_counts" */
export type Appointment_Status_Counts = {
  __typename?: 'appointment_status_counts';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "appointment_status_counts" */
export type Appointment_Status_Counts_Aggregate = {
  __typename?: 'appointment_status_counts_aggregate';
  aggregate?: Maybe<Appointment_Status_Counts_Aggregate_Fields>;
  nodes: Array<Appointment_Status_Counts>;
};

/** aggregate fields of "appointment_status_counts" */
export type Appointment_Status_Counts_Aggregate_Fields = {
  __typename?: 'appointment_status_counts_aggregate_fields';
  avg?: Maybe<Appointment_Status_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appointment_Status_Counts_Max_Fields>;
  min?: Maybe<Appointment_Status_Counts_Min_Fields>;
  stddev?: Maybe<Appointment_Status_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Appointment_Status_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appointment_Status_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Appointment_Status_Counts_Sum_Fields>;
  var_pop?: Maybe<Appointment_Status_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Appointment_Status_Counts_Var_Samp_Fields>;
  variance?: Maybe<Appointment_Status_Counts_Variance_Fields>;
};


/** aggregate fields of "appointment_status_counts" */
export type Appointment_Status_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Appointment_Status_Counts_Avg_Fields = {
  __typename?: 'appointment_status_counts_avg_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "appointment_status_counts". All fields are combined with a logical 'AND'. */
export type Appointment_Status_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Appointment_Status_Counts_Bool_Exp>>;
  _not?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Appointment_Status_Counts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Appointment_Status_Counts_Max_Fields = {
  __typename?: 'appointment_status_counts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Appointment_Status_Counts_Min_Fields = {
  __typename?: 'appointment_status_counts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "appointment_status_counts". */
export type Appointment_Status_Counts_Order_By = {
  count?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "appointment_status_counts" */
export enum Appointment_Status_Counts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Date = 'date',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Appointment_Status_Counts_Stddev_Fields = {
  __typename?: 'appointment_status_counts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Appointment_Status_Counts_Stddev_Pop_Fields = {
  __typename?: 'appointment_status_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Appointment_Status_Counts_Stddev_Samp_Fields = {
  __typename?: 'appointment_status_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "appointment_status_counts" */
export type Appointment_Status_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointment_Status_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointment_Status_Counts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Appointment_Status_Counts_Sum_Fields = {
  __typename?: 'appointment_status_counts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Appointment_Status_Counts_Var_Pop_Fields = {
  __typename?: 'appointment_status_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Appointment_Status_Counts_Var_Samp_Fields = {
  __typename?: 'appointment_status_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Appointment_Status_Counts_Variance_Fields = {
  __typename?: 'appointment_status_counts_variance_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "appointment_status_history" */
export type Appointment_Status_History = {
  __typename?: 'appointment_status_history';
  appointment_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  status: Scalars['Int'];
};

/** aggregated selection of "appointment_status_history" */
export type Appointment_Status_History_Aggregate = {
  __typename?: 'appointment_status_history_aggregate';
  aggregate?: Maybe<Appointment_Status_History_Aggregate_Fields>;
  nodes: Array<Appointment_Status_History>;
};

export type Appointment_Status_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Appointment_Status_History_Aggregate_Bool_Exp_Count>;
};

export type Appointment_Status_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Appointment_Status_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "appointment_status_history" */
export type Appointment_Status_History_Aggregate_Fields = {
  __typename?: 'appointment_status_history_aggregate_fields';
  avg?: Maybe<Appointment_Status_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appointment_Status_History_Max_Fields>;
  min?: Maybe<Appointment_Status_History_Min_Fields>;
  stddev?: Maybe<Appointment_Status_History_Stddev_Fields>;
  stddev_pop?: Maybe<Appointment_Status_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appointment_Status_History_Stddev_Samp_Fields>;
  sum?: Maybe<Appointment_Status_History_Sum_Fields>;
  var_pop?: Maybe<Appointment_Status_History_Var_Pop_Fields>;
  var_samp?: Maybe<Appointment_Status_History_Var_Samp_Fields>;
  variance?: Maybe<Appointment_Status_History_Variance_Fields>;
};


/** aggregate fields of "appointment_status_history" */
export type Appointment_Status_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "appointment_status_history" */
export type Appointment_Status_History_Aggregate_Order_By = {
  avg?: InputMaybe<Appointment_Status_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appointment_Status_History_Max_Order_By>;
  min?: InputMaybe<Appointment_Status_History_Min_Order_By>;
  stddev?: InputMaybe<Appointment_Status_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Appointment_Status_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Appointment_Status_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Appointment_Status_History_Sum_Order_By>;
  var_pop?: InputMaybe<Appointment_Status_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Appointment_Status_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Appointment_Status_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "appointment_status_history" */
export type Appointment_Status_History_Arr_Rel_Insert_Input = {
  data: Array<Appointment_Status_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointment_Status_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Appointment_Status_History_Avg_Fields = {
  __typename?: 'appointment_status_history_avg_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Avg_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "appointment_status_history". All fields are combined with a logical 'AND'. */
export type Appointment_Status_History_Bool_Exp = {
  _and?: InputMaybe<Array<Appointment_Status_History_Bool_Exp>>;
  _not?: InputMaybe<Appointment_Status_History_Bool_Exp>;
  _or?: InputMaybe<Array<Appointment_Status_History_Bool_Exp>>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "appointment_status_history" */
export enum Appointment_Status_History_Constraint {
  /** unique or primary key constraint on columns "status", "appointment_id" */
  AppointmentStatusHistoryAppointmentIdStatusKey = 'appointment_status_history_appointment_id_status_key',
  /** unique or primary key constraint on columns "id" */
  AppointmentStatusHistoryPkey = 'appointment_status_history_pkey'
}

/** input type for incrementing numeric columns in table "appointment_status_history" */
export type Appointment_Status_History_Inc_Input = {
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "appointment_status_history" */
export type Appointment_Status_History_Insert_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Appointment_Status_History_Max_Fields = {
  __typename?: 'appointment_status_history_max_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Max_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appointment_Status_History_Min_Fields = {
  __typename?: 'appointment_status_history_min_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Min_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "appointment_status_history" */
export type Appointment_Status_History_Mutation_Response = {
  __typename?: 'appointment_status_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Appointment_Status_History>;
};

/** on_conflict condition type for table "appointment_status_history" */
export type Appointment_Status_History_On_Conflict = {
  constraint: Appointment_Status_History_Constraint;
  update_columns?: Array<Appointment_Status_History_Update_Column>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};

/** Ordering options when selecting data from "appointment_status_history". */
export type Appointment_Status_History_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: appointment_status_history */
export type Appointment_Status_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "appointment_status_history" */
export enum Appointment_Status_History_Select_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "appointment_status_history" */
export type Appointment_Status_History_Set_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Appointment_Status_History_Stddev_Fields = {
  __typename?: 'appointment_status_history_stddev_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Stddev_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Appointment_Status_History_Stddev_Pop_Fields = {
  __typename?: 'appointment_status_history_stddev_pop_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Stddev_Pop_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Appointment_Status_History_Stddev_Samp_Fields = {
  __typename?: 'appointment_status_history_stddev_samp_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Stddev_Samp_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "appointment_status_history" */
export type Appointment_Status_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointment_Status_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointment_Status_History_Stream_Cursor_Value_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Appointment_Status_History_Sum_Fields = {
  __typename?: 'appointment_status_history_sum_fields';
  status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Sum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** update columns of table "appointment_status_history" */
export enum Appointment_Status_History_Update_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status'
}

export type Appointment_Status_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appointment_Status_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointment_Status_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appointment_Status_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appointment_Status_History_Var_Pop_Fields = {
  __typename?: 'appointment_status_history_var_pop_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Var_Pop_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Appointment_Status_History_Var_Samp_Fields = {
  __typename?: 'appointment_status_history_var_samp_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Var_Samp_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Appointment_Status_History_Variance_Fields = {
  __typename?: 'appointment_status_history_variance_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "appointment_status_history" */
export type Appointment_Status_History_Variance_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "appointments" */
export type Appointments = {
  __typename?: 'appointments';
  appointment_date?: Maybe<Scalars['timestamptz']>;
  appointment_end?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  appointment_payments: Array<Appointment_Payments>;
  /** An aggregate relationship */
  appointment_payments_aggregate: Appointment_Payments_Aggregate;
  /** An object relationship */
  appointment_request?: Maybe<Appointment_Requests>;
  /** An array relationship */
  appointment_status_histories: Array<Appointment_Status_History>;
  /** An aggregate relationship */
  appointment_status_histories_aggregate: Appointment_Status_History_Aggregate;
  createdAt: Scalars['timestamp'];
  id: Scalars['uuid'];
  is_message_list_ready: Scalars['Boolean'];
  is_prescription_ready: Scalars['Boolean'];
  is_summary_completed?: Maybe<Scalars['Boolean']>;
  is_test_kit_appointment: Scalars['Boolean'];
  is_transcription_ready: Scalars['Boolean'];
  is_veradigm_prescription_ready: Scalars['Boolean'];
  payment_session_opened_at: Scalars['timestamptz'];
  /** An array relationship */
  payment_transactions: Array<Payment_Transactions>;
  /** An aggregate relationship */
  payment_transactions_aggregate: Payment_Transactions_Aggregate;
  /** An object relationship */
  provider?: Maybe<Users>;
  provider_full_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  status: Scalars['Int'];
  summary_notification: Scalars['Boolean'];
  test_kits_opened_without_summary?: Maybe<Scalars['Boolean']>;
  transcription_deleted_at?: Maybe<Scalars['timestamptz']>;
  transcription_ready_at?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamp'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "appointments" */
export type AppointmentsAppointment_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Payments_Order_By>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsAppointment_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Payments_Order_By>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsAppointment_Status_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_History_Order_By>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsAppointment_Status_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_History_Order_By>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsPayment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transactions_Order_By>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};


/** columns and relationships of "appointments" */
export type AppointmentsPayment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transactions_Order_By>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};

/** aggregated selection of "appointments" */
export type Appointments_Aggregate = {
  __typename?: 'appointments_aggregate';
  aggregate?: Maybe<Appointments_Aggregate_Fields>;
  nodes: Array<Appointments>;
};

export type Appointments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Appointments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Appointments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Appointments_Aggregate_Bool_Exp_Count>;
};

export type Appointments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Appointments_Select_Column_Appointments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Appointments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Appointments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Appointments_Select_Column_Appointments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Appointments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Appointments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Appointments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Appointments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "appointments" */
export type Appointments_Aggregate_Fields = {
  __typename?: 'appointments_aggregate_fields';
  avg?: Maybe<Appointments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appointments_Max_Fields>;
  min?: Maybe<Appointments_Min_Fields>;
  stddev?: Maybe<Appointments_Stddev_Fields>;
  stddev_pop?: Maybe<Appointments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appointments_Stddev_Samp_Fields>;
  sum?: Maybe<Appointments_Sum_Fields>;
  var_pop?: Maybe<Appointments_Var_Pop_Fields>;
  var_samp?: Maybe<Appointments_Var_Samp_Fields>;
  variance?: Maybe<Appointments_Variance_Fields>;
};


/** aggregate fields of "appointments" */
export type Appointments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appointments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "appointments" */
export type Appointments_Aggregate_Order_By = {
  avg?: InputMaybe<Appointments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appointments_Max_Order_By>;
  min?: InputMaybe<Appointments_Min_Order_By>;
  stddev?: InputMaybe<Appointments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Appointments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Appointments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Appointments_Sum_Order_By>;
  var_pop?: InputMaybe<Appointments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Appointments_Var_Samp_Order_By>;
  variance?: InputMaybe<Appointments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "appointments" */
export type Appointments_Arr_Rel_Insert_Input = {
  data: Array<Appointments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};

/** aggregate avg on columns */
export type Appointments_Avg_Fields = {
  __typename?: 'appointments_avg_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "appointments" */
export type Appointments_Avg_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "appointments". All fields are combined with a logical 'AND'. */
export type Appointments_Bool_Exp = {
  _and?: InputMaybe<Array<Appointments_Bool_Exp>>;
  _not?: InputMaybe<Appointments_Bool_Exp>;
  _or?: InputMaybe<Array<Appointments_Bool_Exp>>;
  appointment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  appointment_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  appointment_payments?: InputMaybe<Appointment_Payments_Bool_Exp>;
  appointment_payments_aggregate?: InputMaybe<Appointment_Payments_Aggregate_Bool_Exp>;
  appointment_request?: InputMaybe<Appointment_Requests_Bool_Exp>;
  appointment_status_histories?: InputMaybe<Appointment_Status_History_Bool_Exp>;
  appointment_status_histories_aggregate?: InputMaybe<Appointment_Status_History_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_message_list_ready?: InputMaybe<Boolean_Comparison_Exp>;
  is_prescription_ready?: InputMaybe<Boolean_Comparison_Exp>;
  is_summary_completed?: InputMaybe<Boolean_Comparison_Exp>;
  is_test_kit_appointment?: InputMaybe<Boolean_Comparison_Exp>;
  is_transcription_ready?: InputMaybe<Boolean_Comparison_Exp>;
  is_veradigm_prescription_ready?: InputMaybe<Boolean_Comparison_Exp>;
  payment_session_opened_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_transactions?: InputMaybe<Payment_Transactions_Bool_Exp>;
  payment_transactions_aggregate?: InputMaybe<Payment_Transactions_Aggregate_Bool_Exp>;
  provider?: InputMaybe<Users_Bool_Exp>;
  provider_full_name?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  summary_notification?: InputMaybe<Boolean_Comparison_Exp>;
  test_kits_opened_without_summary?: InputMaybe<Boolean_Comparison_Exp>;
  transcription_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  transcription_ready_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "appointments" */
export enum Appointments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppointmentsPkey = 'appointments_pkey'
}

/** input type for incrementing numeric columns in table "appointments" */
export type Appointments_Inc_Input = {
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "appointments" */
export type Appointments_Insert_Input = {
  appointment_date?: InputMaybe<Scalars['timestamptz']>;
  appointment_end?: InputMaybe<Scalars['timestamptz']>;
  appointment_payments?: InputMaybe<Appointment_Payments_Arr_Rel_Insert_Input>;
  appointment_request?: InputMaybe<Appointment_Requests_Obj_Rel_Insert_Input>;
  appointment_status_histories?: InputMaybe<Appointment_Status_History_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_message_list_ready?: InputMaybe<Scalars['Boolean']>;
  is_prescription_ready?: InputMaybe<Scalars['Boolean']>;
  is_summary_completed?: InputMaybe<Scalars['Boolean']>;
  is_test_kit_appointment?: InputMaybe<Scalars['Boolean']>;
  is_transcription_ready?: InputMaybe<Scalars['Boolean']>;
  is_veradigm_prescription_ready?: InputMaybe<Scalars['Boolean']>;
  payment_session_opened_at?: InputMaybe<Scalars['timestamptz']>;
  payment_transactions?: InputMaybe<Payment_Transactions_Arr_Rel_Insert_Input>;
  provider?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  provider_full_name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Int']>;
  summary_notification?: InputMaybe<Scalars['Boolean']>;
  test_kits_opened_without_summary?: InputMaybe<Scalars['Boolean']>;
  transcription_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  transcription_ready_at?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Appointments_Max_Fields = {
  __typename?: 'appointments_max_fields';
  appointment_date?: Maybe<Scalars['timestamptz']>;
  appointment_end?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  payment_session_opened_at?: Maybe<Scalars['timestamptz']>;
  provider_full_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['Int']>;
  transcription_deleted_at?: Maybe<Scalars['timestamptz']>;
  transcription_ready_at?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "appointments" */
export type Appointments_Max_Order_By = {
  appointment_date?: InputMaybe<Order_By>;
  appointment_end?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_session_opened_at?: InputMaybe<Order_By>;
  provider_full_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transcription_deleted_at?: InputMaybe<Order_By>;
  transcription_ready_at?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Appointments_Min_Fields = {
  __typename?: 'appointments_min_fields';
  appointment_date?: Maybe<Scalars['timestamptz']>;
  appointment_end?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  payment_session_opened_at?: Maybe<Scalars['timestamptz']>;
  provider_full_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['Int']>;
  transcription_deleted_at?: Maybe<Scalars['timestamptz']>;
  transcription_ready_at?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "appointments" */
export type Appointments_Min_Order_By = {
  appointment_date?: InputMaybe<Order_By>;
  appointment_end?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_session_opened_at?: InputMaybe<Order_By>;
  provider_full_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transcription_deleted_at?: InputMaybe<Order_By>;
  transcription_ready_at?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "appointments" */
export type Appointments_Mutation_Response = {
  __typename?: 'appointments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Appointments>;
};

/** input type for inserting object relation for remote table "appointments" */
export type Appointments_Obj_Rel_Insert_Input = {
  data: Appointments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};

/** on_conflict condition type for table "appointments" */
export type Appointments_On_Conflict = {
  constraint: Appointments_Constraint;
  update_columns?: Array<Appointments_Update_Column>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};

/** Ordering options when selecting data from "appointments". */
export type Appointments_Order_By = {
  appointment_date?: InputMaybe<Order_By>;
  appointment_end?: InputMaybe<Order_By>;
  appointment_payments_aggregate?: InputMaybe<Appointment_Payments_Aggregate_Order_By>;
  appointment_request?: InputMaybe<Appointment_Requests_Order_By>;
  appointment_status_histories_aggregate?: InputMaybe<Appointment_Status_History_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_message_list_ready?: InputMaybe<Order_By>;
  is_prescription_ready?: InputMaybe<Order_By>;
  is_summary_completed?: InputMaybe<Order_By>;
  is_test_kit_appointment?: InputMaybe<Order_By>;
  is_transcription_ready?: InputMaybe<Order_By>;
  is_veradigm_prescription_ready?: InputMaybe<Order_By>;
  payment_session_opened_at?: InputMaybe<Order_By>;
  payment_transactions_aggregate?: InputMaybe<Payment_Transactions_Aggregate_Order_By>;
  provider?: InputMaybe<Users_Order_By>;
  provider_full_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  summary_notification?: InputMaybe<Order_By>;
  test_kits_opened_without_summary?: InputMaybe<Order_By>;
  transcription_deleted_at?: InputMaybe<Order_By>;
  transcription_ready_at?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: appointments */
export type Appointments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "appointments" */
export enum Appointments_Select_Column {
  /** column name */
  AppointmentDate = 'appointment_date',
  /** column name */
  AppointmentEnd = 'appointment_end',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsMessageListReady = 'is_message_list_ready',
  /** column name */
  IsPrescriptionReady = 'is_prescription_ready',
  /** column name */
  IsSummaryCompleted = 'is_summary_completed',
  /** column name */
  IsTestKitAppointment = 'is_test_kit_appointment',
  /** column name */
  IsTranscriptionReady = 'is_transcription_ready',
  /** column name */
  IsVeradigmPrescriptionReady = 'is_veradigm_prescription_ready',
  /** column name */
  PaymentSessionOpenedAt = 'payment_session_opened_at',
  /** column name */
  ProviderFullName = 'provider_full_name',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Status = 'status',
  /** column name */
  SummaryNotification = 'summary_notification',
  /** column name */
  TestKitsOpenedWithoutSummary = 'test_kits_opened_without_summary',
  /** column name */
  TranscriptionDeletedAt = 'transcription_deleted_at',
  /** column name */
  TranscriptionReadyAt = 'transcription_ready_at',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'user_id'
}

/** select "appointments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "appointments" */
export enum Appointments_Select_Column_Appointments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMessageListReady = 'is_message_list_ready',
  /** column name */
  IsPrescriptionReady = 'is_prescription_ready',
  /** column name */
  IsSummaryCompleted = 'is_summary_completed',
  /** column name */
  IsTestKitAppointment = 'is_test_kit_appointment',
  /** column name */
  IsTranscriptionReady = 'is_transcription_ready',
  /** column name */
  IsVeradigmPrescriptionReady = 'is_veradigm_prescription_ready',
  /** column name */
  SummaryNotification = 'summary_notification',
  /** column name */
  TestKitsOpenedWithoutSummary = 'test_kits_opened_without_summary'
}

/** select "appointments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "appointments" */
export enum Appointments_Select_Column_Appointments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMessageListReady = 'is_message_list_ready',
  /** column name */
  IsPrescriptionReady = 'is_prescription_ready',
  /** column name */
  IsSummaryCompleted = 'is_summary_completed',
  /** column name */
  IsTestKitAppointment = 'is_test_kit_appointment',
  /** column name */
  IsTranscriptionReady = 'is_transcription_ready',
  /** column name */
  IsVeradigmPrescriptionReady = 'is_veradigm_prescription_ready',
  /** column name */
  SummaryNotification = 'summary_notification',
  /** column name */
  TestKitsOpenedWithoutSummary = 'test_kits_opened_without_summary'
}

/** input type for updating data in table "appointments" */
export type Appointments_Set_Input = {
  appointment_date?: InputMaybe<Scalars['timestamptz']>;
  appointment_end?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_message_list_ready?: InputMaybe<Scalars['Boolean']>;
  is_prescription_ready?: InputMaybe<Scalars['Boolean']>;
  is_summary_completed?: InputMaybe<Scalars['Boolean']>;
  is_test_kit_appointment?: InputMaybe<Scalars['Boolean']>;
  is_transcription_ready?: InputMaybe<Scalars['Boolean']>;
  is_veradigm_prescription_ready?: InputMaybe<Scalars['Boolean']>;
  payment_session_opened_at?: InputMaybe<Scalars['timestamptz']>;
  provider_full_name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Int']>;
  summary_notification?: InputMaybe<Scalars['Boolean']>;
  test_kits_opened_without_summary?: InputMaybe<Scalars['Boolean']>;
  transcription_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  transcription_ready_at?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Appointments_Stddev_Fields = {
  __typename?: 'appointments_stddev_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "appointments" */
export type Appointments_Stddev_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Appointments_Stddev_Pop_Fields = {
  __typename?: 'appointments_stddev_pop_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "appointments" */
export type Appointments_Stddev_Pop_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Appointments_Stddev_Samp_Fields = {
  __typename?: 'appointments_stddev_samp_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "appointments" */
export type Appointments_Stddev_Samp_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "appointments" */
export type Appointments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appointments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appointments_Stream_Cursor_Value_Input = {
  appointment_date?: InputMaybe<Scalars['timestamptz']>;
  appointment_end?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_message_list_ready?: InputMaybe<Scalars['Boolean']>;
  is_prescription_ready?: InputMaybe<Scalars['Boolean']>;
  is_summary_completed?: InputMaybe<Scalars['Boolean']>;
  is_test_kit_appointment?: InputMaybe<Scalars['Boolean']>;
  is_transcription_ready?: InputMaybe<Scalars['Boolean']>;
  is_veradigm_prescription_ready?: InputMaybe<Scalars['Boolean']>;
  payment_session_opened_at?: InputMaybe<Scalars['timestamptz']>;
  provider_full_name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Int']>;
  summary_notification?: InputMaybe<Scalars['Boolean']>;
  test_kits_opened_without_summary?: InputMaybe<Scalars['Boolean']>;
  transcription_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  transcription_ready_at?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Appointments_Sum_Fields = {
  __typename?: 'appointments_sum_fields';
  status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "appointments" */
export type Appointments_Sum_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** update columns of table "appointments" */
export enum Appointments_Update_Column {
  /** column name */
  AppointmentDate = 'appointment_date',
  /** column name */
  AppointmentEnd = 'appointment_end',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsMessageListReady = 'is_message_list_ready',
  /** column name */
  IsPrescriptionReady = 'is_prescription_ready',
  /** column name */
  IsSummaryCompleted = 'is_summary_completed',
  /** column name */
  IsTestKitAppointment = 'is_test_kit_appointment',
  /** column name */
  IsTranscriptionReady = 'is_transcription_ready',
  /** column name */
  IsVeradigmPrescriptionReady = 'is_veradigm_prescription_ready',
  /** column name */
  PaymentSessionOpenedAt = 'payment_session_opened_at',
  /** column name */
  ProviderFullName = 'provider_full_name',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Status = 'status',
  /** column name */
  SummaryNotification = 'summary_notification',
  /** column name */
  TestKitsOpenedWithoutSummary = 'test_kits_opened_without_summary',
  /** column name */
  TranscriptionDeletedAt = 'transcription_deleted_at',
  /** column name */
  TranscriptionReadyAt = 'transcription_ready_at',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'user_id'
}

export type Appointments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appointments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appointments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Appointments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appointments_Var_Pop_Fields = {
  __typename?: 'appointments_var_pop_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "appointments" */
export type Appointments_Var_Pop_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Appointments_Var_Samp_Fields = {
  __typename?: 'appointments_var_samp_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "appointments" */
export type Appointments_Var_Samp_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Appointments_Variance_Fields = {
  __typename?: 'appointments_variance_fields';
  status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "appointments" */
export type Appointments_Variance_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']>;
  _gt?: InputMaybe<Scalars['bpchar']>;
  _gte?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']>;
  _in?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']>;
  _lt?: InputMaybe<Scalars['bpchar']>;
  _lte?: InputMaybe<Scalars['bpchar']>;
  _neq?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']>;
};

/** columns and relationships of "cart_products" */
export type Cart_Products = {
  __typename?: 'cart_products';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  owner_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  product: Products;
  product_id: Scalars['Int'];
  provider_id?: Maybe<Scalars['uuid']>;
  quantity: Scalars['smallint'];
  recommendation_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "cart_products" */
export type Cart_Products_Aggregate = {
  __typename?: 'cart_products_aggregate';
  aggregate?: Maybe<Cart_Products_Aggregate_Fields>;
  nodes: Array<Cart_Products>;
};

/** aggregate fields of "cart_products" */
export type Cart_Products_Aggregate_Fields = {
  __typename?: 'cart_products_aggregate_fields';
  avg?: Maybe<Cart_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cart_Products_Max_Fields>;
  min?: Maybe<Cart_Products_Min_Fields>;
  stddev?: Maybe<Cart_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Cart_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cart_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Cart_Products_Sum_Fields>;
  var_pop?: Maybe<Cart_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Cart_Products_Var_Samp_Fields>;
  variance?: Maybe<Cart_Products_Variance_Fields>;
};


/** aggregate fields of "cart_products" */
export type Cart_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cart_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Cart_Products_Avg_Fields = {
  __typename?: 'cart_products_avg_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cart_products". All fields are combined with a logical 'AND'. */
export type Cart_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Cart_Products_Bool_Exp>>;
  _not?: InputMaybe<Cart_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Cart_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Smallint_Comparison_Exp>;
  recommendation_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cart_products" */
export enum Cart_Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  CartProductsPkey = 'cart_products_pkey',
  /** unique or primary key constraint on columns "user_id", "product_id", "owner_id" */
  UxCartProductsUserProductOwner = 'ux_cart_products_user_product_owner'
}

/** input type for incrementing numeric columns in table "cart_products" */
export type Cart_Products_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "cart_products" */
export type Cart_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['smallint']>;
  recommendation_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Cart_Products_Max_Fields = {
  __typename?: 'cart_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['smallint']>;
  recommendation_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Cart_Products_Min_Fields = {
  __typename?: 'cart_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['smallint']>;
  recommendation_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "cart_products" */
export type Cart_Products_Mutation_Response = {
  __typename?: 'cart_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cart_Products>;
};

/** on_conflict condition type for table "cart_products" */
export type Cart_Products_On_Conflict = {
  constraint: Cart_Products_Constraint;
  update_columns?: Array<Cart_Products_Update_Column>;
  where?: InputMaybe<Cart_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "cart_products". */
export type Cart_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  recommendation_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cart_products */
export type Cart_Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "cart_products" */
export enum Cart_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RecommendationId = 'recommendation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "cart_products" */
export type Cart_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['smallint']>;
  recommendation_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Cart_Products_Stddev_Fields = {
  __typename?: 'cart_products_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Cart_Products_Stddev_Pop_Fields = {
  __typename?: 'cart_products_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Cart_Products_Stddev_Samp_Fields = {
  __typename?: 'cart_products_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cart_products" */
export type Cart_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cart_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cart_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['smallint']>;
  recommendation_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Cart_Products_Sum_Fields = {
  __typename?: 'cart_products_sum_fields';
  id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['smallint']>;
};

/** update columns of table "cart_products" */
export enum Cart_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RecommendationId = 'recommendation_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Cart_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cart_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cart_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cart_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cart_Products_Var_Pop_Fields = {
  __typename?: 'cart_products_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Cart_Products_Var_Samp_Fields = {
  __typename?: 'cart_products_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Cart_Products_Variance_Fields = {
  __typename?: 'cart_products_variance_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "channel_signals" */
export type Channel_Signals = {
  __typename?: 'channel_signals';
  channel: Scalars['String'];
  id: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  last_updated: Scalars['timestamptz'];
};

/** aggregated selection of "channel_signals" */
export type Channel_Signals_Aggregate = {
  __typename?: 'channel_signals_aggregate';
  aggregate?: Maybe<Channel_Signals_Aggregate_Fields>;
  nodes: Array<Channel_Signals>;
};

/** aggregate fields of "channel_signals" */
export type Channel_Signals_Aggregate_Fields = {
  __typename?: 'channel_signals_aggregate_fields';
  avg?: Maybe<Channel_Signals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Channel_Signals_Max_Fields>;
  min?: Maybe<Channel_Signals_Min_Fields>;
  stddev?: Maybe<Channel_Signals_Stddev_Fields>;
  stddev_pop?: Maybe<Channel_Signals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Channel_Signals_Stddev_Samp_Fields>;
  sum?: Maybe<Channel_Signals_Sum_Fields>;
  var_pop?: Maybe<Channel_Signals_Var_Pop_Fields>;
  var_samp?: Maybe<Channel_Signals_Var_Samp_Fields>;
  variance?: Maybe<Channel_Signals_Variance_Fields>;
};


/** aggregate fields of "channel_signals" */
export type Channel_Signals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Signals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Channel_Signals_Avg_Fields = {
  __typename?: 'channel_signals_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "channel_signals". All fields are combined with a logical 'AND'. */
export type Channel_Signals_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Signals_Bool_Exp>>;
  _not?: InputMaybe<Channel_Signals_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Signals_Bool_Exp>>;
  channel?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "channel_signals" */
export enum Channel_Signals_Constraint {
  /** unique or primary key constraint on columns "key", "channel" */
  ChannelSignalsChannelKeyKey = 'channel_signals_channel_key_key',
  /** unique or primary key constraint on columns "id" */
  ChannelSignalsPkey = 'channel_signals_pkey'
}

/** input type for incrementing numeric columns in table "channel_signals" */
export type Channel_Signals_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "channel_signals" */
export type Channel_Signals_Insert_Input = {
  channel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Channel_Signals_Max_Fields = {
  __typename?: 'channel_signals_max_fields';
  channel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Channel_Signals_Min_Fields = {
  __typename?: 'channel_signals_min_fields';
  channel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  last_updated?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "channel_signals" */
export type Channel_Signals_Mutation_Response = {
  __typename?: 'channel_signals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Channel_Signals>;
};

/** on_conflict condition type for table "channel_signals" */
export type Channel_Signals_On_Conflict = {
  constraint: Channel_Signals_Constraint;
  update_columns?: Array<Channel_Signals_Update_Column>;
  where?: InputMaybe<Channel_Signals_Bool_Exp>;
};

/** Ordering options when selecting data from "channel_signals". */
export type Channel_Signals_Order_By = {
  channel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_updated?: InputMaybe<Order_By>;
};

/** primary key columns input for table: channel_signals */
export type Channel_Signals_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "channel_signals" */
export enum Channel_Signals_Select_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LastUpdated = 'last_updated'
}

/** input type for updating data in table "channel_signals" */
export type Channel_Signals_Set_Input = {
  channel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Channel_Signals_Stddev_Fields = {
  __typename?: 'channel_signals_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Channel_Signals_Stddev_Pop_Fields = {
  __typename?: 'channel_signals_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Channel_Signals_Stddev_Samp_Fields = {
  __typename?: 'channel_signals_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "channel_signals" */
export type Channel_Signals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Signals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Signals_Stream_Cursor_Value_Input = {
  channel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  last_updated?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Channel_Signals_Sum_Fields = {
  __typename?: 'channel_signals_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "channel_signals" */
export enum Channel_Signals_Update_Column {
  /** column name */
  Channel = 'channel',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LastUpdated = 'last_updated'
}

export type Channel_Signals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Channel_Signals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Channel_Signals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Channel_Signals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Channel_Signals_Var_Pop_Fields = {
  __typename?: 'channel_signals_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Channel_Signals_Var_Samp_Fields = {
  __typename?: 'channel_signals_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Channel_Signals_Variance_Fields = {
  __typename?: 'channel_signals_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "common_question_responses" */
export type Common_Question_Responses = {
  __typename?: 'common_question_responses';
  common_question_id: Scalars['Int'];
  id: Scalars['bigint'];
  responses: Scalars['jsonb'];
  user_id: Scalars['uuid'];
};


/** columns and relationships of "common_question_responses" */
export type Common_Question_ResponsesResponsesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "common_question_responses" */
export type Common_Question_Responses_Aggregate = {
  __typename?: 'common_question_responses_aggregate';
  aggregate?: Maybe<Common_Question_Responses_Aggregate_Fields>;
  nodes: Array<Common_Question_Responses>;
};

/** aggregate fields of "common_question_responses" */
export type Common_Question_Responses_Aggregate_Fields = {
  __typename?: 'common_question_responses_aggregate_fields';
  avg?: Maybe<Common_Question_Responses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Common_Question_Responses_Max_Fields>;
  min?: Maybe<Common_Question_Responses_Min_Fields>;
  stddev?: Maybe<Common_Question_Responses_Stddev_Fields>;
  stddev_pop?: Maybe<Common_Question_Responses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Common_Question_Responses_Stddev_Samp_Fields>;
  sum?: Maybe<Common_Question_Responses_Sum_Fields>;
  var_pop?: Maybe<Common_Question_Responses_Var_Pop_Fields>;
  var_samp?: Maybe<Common_Question_Responses_Var_Samp_Fields>;
  variance?: Maybe<Common_Question_Responses_Variance_Fields>;
};


/** aggregate fields of "common_question_responses" */
export type Common_Question_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Common_Question_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Common_Question_Responses_Append_Input = {
  responses?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Common_Question_Responses_Avg_Fields = {
  __typename?: 'common_question_responses_avg_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "common_question_responses". All fields are combined with a logical 'AND'. */
export type Common_Question_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Common_Question_Responses_Bool_Exp>>;
  _not?: InputMaybe<Common_Question_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Common_Question_Responses_Bool_Exp>>;
  common_question_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  responses?: InputMaybe<Jsonb_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "common_question_responses" */
export enum Common_Question_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommonQuestionResponsesPkey = 'common_question_responses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Common_Question_Responses_Delete_At_Path_Input = {
  responses?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Common_Question_Responses_Delete_Elem_Input = {
  responses?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Common_Question_Responses_Delete_Key_Input = {
  responses?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "common_question_responses" */
export type Common_Question_Responses_Inc_Input = {
  common_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "common_question_responses" */
export type Common_Question_Responses_Insert_Input = {
  common_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Common_Question_Responses_Max_Fields = {
  __typename?: 'common_question_responses_max_fields';
  common_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Common_Question_Responses_Min_Fields = {
  __typename?: 'common_question_responses_min_fields';
  common_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "common_question_responses" */
export type Common_Question_Responses_Mutation_Response = {
  __typename?: 'common_question_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Common_Question_Responses>;
};

/** on_conflict condition type for table "common_question_responses" */
export type Common_Question_Responses_On_Conflict = {
  constraint: Common_Question_Responses_Constraint;
  update_columns?: Array<Common_Question_Responses_Update_Column>;
  where?: InputMaybe<Common_Question_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "common_question_responses". */
export type Common_Question_Responses_Order_By = {
  common_question_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  responses?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: common_question_responses */
export type Common_Question_Responses_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Common_Question_Responses_Prepend_Input = {
  responses?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "common_question_responses" */
export enum Common_Question_Responses_Select_Column {
  /** column name */
  CommonQuestionId = 'common_question_id',
  /** column name */
  Id = 'id',
  /** column name */
  Responses = 'responses',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "common_question_responses" */
export type Common_Question_Responses_Set_Input = {
  common_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Common_Question_Responses_Stddev_Fields = {
  __typename?: 'common_question_responses_stddev_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Common_Question_Responses_Stddev_Pop_Fields = {
  __typename?: 'common_question_responses_stddev_pop_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Common_Question_Responses_Stddev_Samp_Fields = {
  __typename?: 'common_question_responses_stddev_samp_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "common_question_responses" */
export type Common_Question_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Common_Question_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Common_Question_Responses_Stream_Cursor_Value_Input = {
  common_question_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Common_Question_Responses_Sum_Fields = {
  __typename?: 'common_question_responses_sum_fields';
  common_question_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "common_question_responses" */
export enum Common_Question_Responses_Update_Column {
  /** column name */
  CommonQuestionId = 'common_question_id',
  /** column name */
  Id = 'id',
  /** column name */
  Responses = 'responses',
  /** column name */
  UserId = 'user_id'
}

export type Common_Question_Responses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Common_Question_Responses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Common_Question_Responses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Common_Question_Responses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Common_Question_Responses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Common_Question_Responses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Common_Question_Responses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Common_Question_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Common_Question_Responses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Common_Question_Responses_Var_Pop_Fields = {
  __typename?: 'common_question_responses_var_pop_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Common_Question_Responses_Var_Samp_Fields = {
  __typename?: 'common_question_responses_var_samp_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Common_Question_Responses_Variance_Fields = {
  __typename?: 'common_question_responses_variance_fields';
  common_question_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "common_questions" */
export type Common_Questions = {
  __typename?: 'common_questions';
  id: Scalars['Int'];
  question_id: Scalars['Int'];
};

/** aggregated selection of "common_questions" */
export type Common_Questions_Aggregate = {
  __typename?: 'common_questions_aggregate';
  aggregate?: Maybe<Common_Questions_Aggregate_Fields>;
  nodes: Array<Common_Questions>;
};

/** aggregate fields of "common_questions" */
export type Common_Questions_Aggregate_Fields = {
  __typename?: 'common_questions_aggregate_fields';
  avg?: Maybe<Common_Questions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Common_Questions_Max_Fields>;
  min?: Maybe<Common_Questions_Min_Fields>;
  stddev?: Maybe<Common_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Common_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Common_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Common_Questions_Sum_Fields>;
  var_pop?: Maybe<Common_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Common_Questions_Var_Samp_Fields>;
  variance?: Maybe<Common_Questions_Variance_Fields>;
};


/** aggregate fields of "common_questions" */
export type Common_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Common_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Common_Questions_Avg_Fields = {
  __typename?: 'common_questions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "common_questions". All fields are combined with a logical 'AND'. */
export type Common_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Common_Questions_Bool_Exp>>;
  _not?: InputMaybe<Common_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Common_Questions_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "common_questions" */
export enum Common_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommonQuestionsPkey = 'common_questions_pkey',
  /** unique or primary key constraint on columns "question_id" */
  CommonQuestionsQuestionIdKey = 'common_questions_question_id_key'
}

/** input type for incrementing numeric columns in table "common_questions" */
export type Common_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "common_questions" */
export type Common_Questions_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Common_Questions_Max_Fields = {
  __typename?: 'common_questions_max_fields';
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Common_Questions_Min_Fields = {
  __typename?: 'common_questions_min_fields';
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "common_questions" */
export type Common_Questions_Mutation_Response = {
  __typename?: 'common_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Common_Questions>;
};

/** on_conflict condition type for table "common_questions" */
export type Common_Questions_On_Conflict = {
  constraint: Common_Questions_Constraint;
  update_columns?: Array<Common_Questions_Update_Column>;
  where?: InputMaybe<Common_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "common_questions". */
export type Common_Questions_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: common_questions */
export type Common_Questions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "common_questions" */
export enum Common_Questions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id'
}

/** input type for updating data in table "common_questions" */
export type Common_Questions_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Common_Questions_Stddev_Fields = {
  __typename?: 'common_questions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Common_Questions_Stddev_Pop_Fields = {
  __typename?: 'common_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Common_Questions_Stddev_Samp_Fields = {
  __typename?: 'common_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "common_questions" */
export type Common_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Common_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Common_Questions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  question_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Common_Questions_Sum_Fields = {
  __typename?: 'common_questions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  question_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "common_questions" */
export enum Common_Questions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id'
}

export type Common_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Common_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Common_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Common_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Common_Questions_Var_Pop_Fields = {
  __typename?: 'common_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Common_Questions_Var_Samp_Fields = {
  __typename?: 'common_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Common_Questions_Variance_Fields = {
  __typename?: 'common_questions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "communication_channels" */
export type Communication_Channels = {
  __typename?: 'communication_channels';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "communication_channels" */
export type Communication_Channels_Aggregate = {
  __typename?: 'communication_channels_aggregate';
  aggregate?: Maybe<Communication_Channels_Aggregate_Fields>;
  nodes: Array<Communication_Channels>;
};

/** aggregate fields of "communication_channels" */
export type Communication_Channels_Aggregate_Fields = {
  __typename?: 'communication_channels_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Communication_Channels_Max_Fields>;
  min?: Maybe<Communication_Channels_Min_Fields>;
};


/** aggregate fields of "communication_channels" */
export type Communication_Channels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Communication_Channels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "communication_channels". All fields are combined with a logical 'AND'. */
export type Communication_Channels_Bool_Exp = {
  _and?: InputMaybe<Array<Communication_Channels_Bool_Exp>>;
  _not?: InputMaybe<Communication_Channels_Bool_Exp>;
  _or?: InputMaybe<Array<Communication_Channels_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "communication_channels" */
export enum Communication_Channels_Constraint {
  /** unique or primary key constraint on columns "value" */
  CommunicationChannelsPkey = 'communication_channels_pkey'
}

export enum Communication_Channels_Enum {
  Email = 'EMAIL',
  InAppNotification = 'IN_APP_NOTIFICATION',
  Push = 'PUSH',
  Sms = 'SMS'
}

/** Boolean expression to compare columns of type "communication_channels_enum". All fields are combined with logical 'AND'. */
export type Communication_Channels_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Communication_Channels_Enum>;
  _in?: InputMaybe<Array<Communication_Channels_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Communication_Channels_Enum>;
  _nin?: InputMaybe<Array<Communication_Channels_Enum>>;
};

/** input type for inserting data into table "communication_channels" */
export type Communication_Channels_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Communication_Channels_Max_Fields = {
  __typename?: 'communication_channels_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Communication_Channels_Min_Fields = {
  __typename?: 'communication_channels_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "communication_channels" */
export type Communication_Channels_Mutation_Response = {
  __typename?: 'communication_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Communication_Channels>;
};

/** on_conflict condition type for table "communication_channels" */
export type Communication_Channels_On_Conflict = {
  constraint: Communication_Channels_Constraint;
  update_columns?: Array<Communication_Channels_Update_Column>;
  where?: InputMaybe<Communication_Channels_Bool_Exp>;
};

/** Ordering options when selecting data from "communication_channels". */
export type Communication_Channels_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: communication_channels */
export type Communication_Channels_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "communication_channels" */
export enum Communication_Channels_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "communication_channels" */
export type Communication_Channels_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "communication_channels" */
export type Communication_Channels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Communication_Channels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Communication_Channels_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "communication_channels" */
export enum Communication_Channels_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Communication_Channels_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Communication_Channels_Set_Input>;
  /** filter the rows which have to be updated */
  where: Communication_Channels_Bool_Exp;
};

/** columns and relationships of "countries" */
export type Countries = {
  __typename?: 'countries';
  code: Scalars['String'];
  flag?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "countries" */
export type Countries_Aggregate = {
  __typename?: 'countries_aggregate';
  aggregate?: Maybe<Countries_Aggregate_Fields>;
  nodes: Array<Countries>;
};

/** aggregate fields of "countries" */
export type Countries_Aggregate_Fields = {
  __typename?: 'countries_aggregate_fields';
  avg?: Maybe<Countries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Countries_Max_Fields>;
  min?: Maybe<Countries_Min_Fields>;
  stddev?: Maybe<Countries_Stddev_Fields>;
  stddev_pop?: Maybe<Countries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Countries_Stddev_Samp_Fields>;
  sum?: Maybe<Countries_Sum_Fields>;
  var_pop?: Maybe<Countries_Var_Pop_Fields>;
  var_samp?: Maybe<Countries_Var_Samp_Fields>;
  variance?: Maybe<Countries_Variance_Fields>;
};


/** aggregate fields of "countries" */
export type Countries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Countries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Countries_Avg_Fields = {
  __typename?: 'countries_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Countries_Bool_Exp>>;
  _not?: InputMaybe<Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Countries_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  flag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "countries" */
export enum Countries_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountriesPkey = 'countries_pkey'
}

/** input type for incrementing numeric columns in table "countries" */
export type Countries_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "countries" */
export type Countries_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  flag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Countries_Max_Fields = {
  __typename?: 'countries_max_fields';
  code?: Maybe<Scalars['String']>;
  flag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Countries_Min_Fields = {
  __typename?: 'countries_min_fields';
  code?: Maybe<Scalars['String']>;
  flag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "countries" */
export type Countries_Mutation_Response = {
  __typename?: 'countries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Countries>;
};

/** on_conflict condition type for table "countries" */
export type Countries_On_Conflict = {
  constraint: Countries_Constraint;
  update_columns?: Array<Countries_Update_Column>;
  where?: InputMaybe<Countries_Bool_Exp>;
};

/** Ordering options when selecting data from "countries". */
export type Countries_Order_By = {
  code?: InputMaybe<Order_By>;
  flag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: countries */
export type Countries_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "countries" */
export enum Countries_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Flag = 'flag',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "countries" */
export type Countries_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  flag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Countries_Stddev_Fields = {
  __typename?: 'countries_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Countries_Stddev_Pop_Fields = {
  __typename?: 'countries_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Countries_Stddev_Samp_Fields = {
  __typename?: 'countries_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "countries" */
export type Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Countries_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  flag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Countries_Sum_Fields = {
  __typename?: 'countries_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "countries" */
export enum Countries_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Flag = 'flag',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Countries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Countries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Countries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Countries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Countries_Var_Pop_Fields = {
  __typename?: 'countries_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Countries_Var_Samp_Fields = {
  __typename?: 'countries_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Countries_Variance_Fields = {
  __typename?: 'countries_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** table used for storing custom auth code for user */
export type Custom_Auth_Code = {
  __typename?: 'custom_auth_code';
  SENSITIVE_email: Scalars['String'];
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  expires_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  used: Scalars['Boolean'];
};

/** aggregated selection of "custom_auth_code" */
export type Custom_Auth_Code_Aggregate = {
  __typename?: 'custom_auth_code_aggregate';
  aggregate?: Maybe<Custom_Auth_Code_Aggregate_Fields>;
  nodes: Array<Custom_Auth_Code>;
};

/** aggregate fields of "custom_auth_code" */
export type Custom_Auth_Code_Aggregate_Fields = {
  __typename?: 'custom_auth_code_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Custom_Auth_Code_Max_Fields>;
  min?: Maybe<Custom_Auth_Code_Min_Fields>;
};


/** aggregate fields of "custom_auth_code" */
export type Custom_Auth_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Auth_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "custom_auth_code". All fields are combined with a logical 'AND'. */
export type Custom_Auth_Code_Bool_Exp = {
  SENSITIVE_email?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Custom_Auth_Code_Bool_Exp>>;
  _not?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Auth_Code_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  used?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_auth_code" */
export enum Custom_Auth_Code_Constraint {
  /** unique or primary key constraint on columns "code" */
  CustomAuthCodeCodeKey = 'custom_auth_code_code_key',
  /** unique or primary key constraint on columns "id" */
  CustomAuthCodePkey = 'custom_auth_code_pkey'
}

/** input type for inserting data into table "custom_auth_code" */
export type Custom_Auth_Code_Insert_Input = {
  SENSITIVE_email?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Custom_Auth_Code_Max_Fields = {
  __typename?: 'custom_auth_code_max_fields';
  SENSITIVE_email?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Custom_Auth_Code_Min_Fields = {
  __typename?: 'custom_auth_code_min_fields';
  SENSITIVE_email?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "custom_auth_code" */
export type Custom_Auth_Code_Mutation_Response = {
  __typename?: 'custom_auth_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Auth_Code>;
};

/** on_conflict condition type for table "custom_auth_code" */
export type Custom_Auth_Code_On_Conflict = {
  constraint: Custom_Auth_Code_Constraint;
  update_columns?: Array<Custom_Auth_Code_Update_Column>;
  where?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_auth_code". */
export type Custom_Auth_Code_Order_By = {
  SENSITIVE_email?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_auth_code */
export type Custom_Auth_Code_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "custom_auth_code" */
export enum Custom_Auth_Code_Select_Column {
  /** column name */
  SensitiveEmail = 'SENSITIVE_email',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Used = 'used'
}

/** input type for updating data in table "custom_auth_code" */
export type Custom_Auth_Code_Set_Input = {
  SENSITIVE_email?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "custom_auth_code" */
export type Custom_Auth_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Auth_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Auth_Code_Stream_Cursor_Value_Input = {
  SENSITIVE_email?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expires_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "custom_auth_code" */
export enum Custom_Auth_Code_Update_Column {
  /** column name */
  SensitiveEmail = 'SENSITIVE_email',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Used = 'used'
}

export type Custom_Auth_Code_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Auth_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Auth_Code_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "dea_license_schedules" */
export type Dea_License_Schedules = {
  __typename?: 'dea_license_schedules';
  code: Scalars['String'];
  created_at: Scalars['timestamptz'];
  dea_license_id: Scalars['uuid'];
  granted_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "dea_license_schedules" */
export type Dea_License_Schedules_Aggregate = {
  __typename?: 'dea_license_schedules_aggregate';
  aggregate?: Maybe<Dea_License_Schedules_Aggregate_Fields>;
  nodes: Array<Dea_License_Schedules>;
};

export type Dea_License_Schedules_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dea_License_Schedules_Aggregate_Bool_Exp_Count>;
};

export type Dea_License_Schedules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dea_license_schedules" */
export type Dea_License_Schedules_Aggregate_Fields = {
  __typename?: 'dea_license_schedules_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Dea_License_Schedules_Max_Fields>;
  min?: Maybe<Dea_License_Schedules_Min_Fields>;
};


/** aggregate fields of "dea_license_schedules" */
export type Dea_License_Schedules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "dea_license_schedules" */
export type Dea_License_Schedules_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dea_License_Schedules_Max_Order_By>;
  min?: InputMaybe<Dea_License_Schedules_Min_Order_By>;
};

/** input type for inserting array relation for remote table "dea_license_schedules" */
export type Dea_License_Schedules_Arr_Rel_Insert_Input = {
  data: Array<Dea_License_Schedules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dea_License_Schedules_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dea_license_schedules". All fields are combined with a logical 'AND'. */
export type Dea_License_Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Dea_License_Schedules_Bool_Exp>>;
  _not?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Dea_License_Schedules_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dea_license_id?: InputMaybe<Uuid_Comparison_Exp>;
  granted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dea_license_schedules" */
export enum Dea_License_Schedules_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeaLicenseSchedulesPkey = 'dea_license_schedules_pkey',
  /** unique or primary key constraint on columns "code", "dea_license_id" */
  ProviderDeaSchedulesLicenseCodeUnique = 'provider_dea_schedules_license_code_unique'
}

/** input type for inserting data into table "dea_license_schedules" */
export type Dea_License_Schedules_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dea_license_id?: InputMaybe<Scalars['uuid']>;
  granted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Dea_License_Schedules_Max_Fields = {
  __typename?: 'dea_license_schedules_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dea_license_id?: Maybe<Scalars['uuid']>;
  granted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "dea_license_schedules" */
export type Dea_License_Schedules_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dea_license_id?: InputMaybe<Order_By>;
  granted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dea_License_Schedules_Min_Fields = {
  __typename?: 'dea_license_schedules_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dea_license_id?: Maybe<Scalars['uuid']>;
  granted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "dea_license_schedules" */
export type Dea_License_Schedules_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dea_license_id?: InputMaybe<Order_By>;
  granted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dea_license_schedules" */
export type Dea_License_Schedules_Mutation_Response = {
  __typename?: 'dea_license_schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dea_License_Schedules>;
};

/** on_conflict condition type for table "dea_license_schedules" */
export type Dea_License_Schedules_On_Conflict = {
  constraint: Dea_License_Schedules_Constraint;
  update_columns?: Array<Dea_License_Schedules_Update_Column>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};

/** Ordering options when selecting data from "dea_license_schedules". */
export type Dea_License_Schedules_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dea_license_id?: InputMaybe<Order_By>;
  granted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dea_license_schedules */
export type Dea_License_Schedules_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dea_license_schedules" */
export enum Dea_License_Schedules_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeaLicenseId = 'dea_license_id',
  /** column name */
  GrantedAt = 'granted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "dea_license_schedules" */
export type Dea_License_Schedules_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dea_license_id?: InputMaybe<Scalars['uuid']>;
  granted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "dea_license_schedules" */
export type Dea_License_Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dea_License_Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dea_License_Schedules_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dea_license_id?: InputMaybe<Scalars['uuid']>;
  granted_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "dea_license_schedules" */
export enum Dea_License_Schedules_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeaLicenseId = 'dea_license_id',
  /** column name */
  GrantedAt = 'granted_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Dea_License_Schedules_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dea_License_Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dea_License_Schedules_Bool_Exp;
};

/** columns and relationships of "delivery_addresses" */
export type Delivery_Addresses = {
  __typename?: 'delivery_addresses';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  phone: Scalars['String'];
  state: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
  zip_code: Scalars['String'];
};

/** aggregated selection of "delivery_addresses" */
export type Delivery_Addresses_Aggregate = {
  __typename?: 'delivery_addresses_aggregate';
  aggregate?: Maybe<Delivery_Addresses_Aggregate_Fields>;
  nodes: Array<Delivery_Addresses>;
};

/** aggregate fields of "delivery_addresses" */
export type Delivery_Addresses_Aggregate_Fields = {
  __typename?: 'delivery_addresses_aggregate_fields';
  avg?: Maybe<Delivery_Addresses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Delivery_Addresses_Max_Fields>;
  min?: Maybe<Delivery_Addresses_Min_Fields>;
  stddev?: Maybe<Delivery_Addresses_Stddev_Fields>;
  stddev_pop?: Maybe<Delivery_Addresses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delivery_Addresses_Stddev_Samp_Fields>;
  sum?: Maybe<Delivery_Addresses_Sum_Fields>;
  var_pop?: Maybe<Delivery_Addresses_Var_Pop_Fields>;
  var_samp?: Maybe<Delivery_Addresses_Var_Samp_Fields>;
  variance?: Maybe<Delivery_Addresses_Variance_Fields>;
};


/** aggregate fields of "delivery_addresses" */
export type Delivery_Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Delivery_Addresses_Avg_Fields = {
  __typename?: 'delivery_addresses_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "delivery_addresses". All fields are combined with a logical 'AND'. */
export type Delivery_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Addresses_Bool_Exp>>;
  address1?: InputMaybe<String_Comparison_Exp>;
  address2?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "delivery_addresses" */
export enum Delivery_Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeliveryAddressesPkey = 'delivery_addresses_pkey'
}

/** input type for incrementing numeric columns in table "delivery_addresses" */
export type Delivery_Addresses_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "delivery_addresses" */
export type Delivery_Addresses_Insert_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Delivery_Addresses_Max_Fields = {
  __typename?: 'delivery_addresses_max_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Delivery_Addresses_Min_Fields = {
  __typename?: 'delivery_addresses_min_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "delivery_addresses" */
export type Delivery_Addresses_Mutation_Response = {
  __typename?: 'delivery_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Delivery_Addresses>;
};

/** input type for inserting object relation for remote table "delivery_addresses" */
export type Delivery_Addresses_Obj_Rel_Insert_Input = {
  data: Delivery_Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Delivery_Addresses_On_Conflict>;
};

/** on_conflict condition type for table "delivery_addresses" */
export type Delivery_Addresses_On_Conflict = {
  constraint: Delivery_Addresses_Constraint;
  update_columns?: Array<Delivery_Addresses_Update_Column>;
  where?: InputMaybe<Delivery_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "delivery_addresses". */
export type Delivery_Addresses_Order_By = {
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** primary key columns input for table: delivery_addresses */
export type Delivery_Addresses_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "delivery_addresses" */
export enum Delivery_Addresses_Select_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Phone = 'phone',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ZipCode = 'zip_code'
}

/** input type for updating data in table "delivery_addresses" */
export type Delivery_Addresses_Set_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Delivery_Addresses_Stddev_Fields = {
  __typename?: 'delivery_addresses_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Delivery_Addresses_Stddev_Pop_Fields = {
  __typename?: 'delivery_addresses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Delivery_Addresses_Stddev_Samp_Fields = {
  __typename?: 'delivery_addresses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "delivery_addresses" */
export type Delivery_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Addresses_Stream_Cursor_Value_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Delivery_Addresses_Sum_Fields = {
  __typename?: 'delivery_addresses_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "delivery_addresses" */
export enum Delivery_Addresses_Update_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Phone = 'phone',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ZipCode = 'zip_code'
}

export type Delivery_Addresses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Delivery_Addresses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Delivery_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Delivery_Addresses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Delivery_Addresses_Var_Pop_Fields = {
  __typename?: 'delivery_addresses_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Delivery_Addresses_Var_Samp_Fields = {
  __typename?: 'delivery_addresses_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Delivery_Addresses_Variance_Fields = {
  __typename?: 'delivery_addresses_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests = {
  __typename?: 'diagnostic_solution_tests';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  diagnostic_solution_tests_dnavisit_test_status: Dnavisit_Test_Statuses;
  errors?: Maybe<Scalars['jsonb']>;
  state: Dnavisit_Test_Statuses_Enum;
  test_id: Scalars['uuid'];
  /** An array relationship */
  test_kits_update_states_summary_logs: Array<Test_Kits_Update_States_Summary_Log>;
  /** An aggregate relationship */
  test_kits_update_states_summary_logs_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "diagnostic_solution_tests" */
export type Diagnostic_Solution_TestsErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "diagnostic_solution_tests" */
export type Diagnostic_Solution_TestsTest_Kits_Update_States_Summary_LogsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** columns and relationships of "diagnostic_solution_tests" */
export type Diagnostic_Solution_TestsTest_Kits_Update_States_Summary_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};

/** aggregated selection of "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Aggregate = {
  __typename?: 'diagnostic_solution_tests_aggregate';
  aggregate?: Maybe<Diagnostic_Solution_Tests_Aggregate_Fields>;
  nodes: Array<Diagnostic_Solution_Tests>;
};

/** aggregate fields of "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Aggregate_Fields = {
  __typename?: 'diagnostic_solution_tests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Diagnostic_Solution_Tests_Max_Fields>;
  min?: Maybe<Diagnostic_Solution_Tests_Min_Fields>;
};


/** aggregate fields of "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Diagnostic_Solution_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Diagnostic_Solution_Tests_Append_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "diagnostic_solution_tests". All fields are combined with a logical 'AND'. */
export type Diagnostic_Solution_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Diagnostic_Solution_Tests_Bool_Exp>>;
  _not?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Diagnostic_Solution_Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  diagnostic_solution_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "diagnostic_solution_tests" */
export enum Diagnostic_Solution_Tests_Constraint {
  /** unique or primary key constraint on columns "test_id" */
  DiagnosticSolutionTestsPkey = 'diagnostic_solution_tests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Diagnostic_Solution_Tests_Delete_At_Path_Input = {
  errors?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Diagnostic_Solution_Tests_Delete_Elem_Input = {
  errors?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Diagnostic_Solution_Tests_Delete_Key_Input = {
  errors?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  diagnostic_solution_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Obj_Rel_Insert_Input>;
  errors?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Diagnostic_Solution_Tests_Max_Fields = {
  __typename?: 'diagnostic_solution_tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Diagnostic_Solution_Tests_Min_Fields = {
  __typename?: 'diagnostic_solution_tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Mutation_Response = {
  __typename?: 'diagnostic_solution_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Diagnostic_Solution_Tests>;
};

/** on_conflict condition type for table "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_On_Conflict = {
  constraint: Diagnostic_Solution_Tests_Constraint;
  update_columns?: Array<Diagnostic_Solution_Tests_Update_Column>;
  where?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "diagnostic_solution_tests". */
export type Diagnostic_Solution_Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  diagnostic_solution_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Order_By>;
  errors?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: diagnostic_solution_tests */
export type Diagnostic_Solution_Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Diagnostic_Solution_Tests_Prepend_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "diagnostic_solution_tests" */
export enum Diagnostic_Solution_Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  State = 'state',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "diagnostic_solution_tests" */
export type Diagnostic_Solution_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Diagnostic_Solution_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Diagnostic_Solution_Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "diagnostic_solution_tests" */
export enum Diagnostic_Solution_Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  State = 'state',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Diagnostic_Solution_Tests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Diagnostic_Solution_Tests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Diagnostic_Solution_Tests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Diagnostic_Solution_Tests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Diagnostic_Solution_Tests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Diagnostic_Solution_Tests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Diagnostic_Solution_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Diagnostic_Solution_Tests_Bool_Exp;
};

/** columns and relationships of "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses = {
  __typename?: 'dnavisit_test_statuses';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Aggregate = {
  __typename?: 'dnavisit_test_statuses_aggregate';
  aggregate?: Maybe<Dnavisit_Test_Statuses_Aggregate_Fields>;
  nodes: Array<Dnavisit_Test_Statuses>;
};

/** aggregate fields of "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Aggregate_Fields = {
  __typename?: 'dnavisit_test_statuses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Dnavisit_Test_Statuses_Max_Fields>;
  min?: Maybe<Dnavisit_Test_Statuses_Min_Fields>;
};


/** aggregate fields of "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dnavisit_Test_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "dnavisit_test_statuses". All fields are combined with a logical 'AND'. */
export type Dnavisit_Test_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Dnavisit_Test_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Dnavisit_Test_Statuses_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dnavisit_test_statuses" */
export enum Dnavisit_Test_Statuses_Constraint {
  /** unique or primary key constraint on columns "value" */
  DnavisitTestStatusesPkey = 'dnavisit_test_statuses_pkey'
}

export enum Dnavisit_Test_Statuses_Enum {
  /** Status once the appointment has been scheduled in DNA */
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  ApprovedByProvider = 'APPROVED_BY_PROVIDER',
  /** The order was canceled */
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Issue = 'ISSUE',
  /** Status once the user has registered the test kit (initial state) */
  KitNotReceived = 'KIT_NOT_RECEIVED',
  /** Status once the sapphiros results are published but, the schedule appointment link has not been yet shared into the chat */
  ProviderPending = 'PROVIDER_PENDING',
  /** Status once the test kit have been received by the lab (Sapphiros) */
  ReceivedByLab = 'RECEIVED_BY_LAB',
  /** Set on pending_patient_zrt when lab registration fails after questionnaire completion */
  RegistrationFailed = 'REGISTRATION_FAILED',
  /** Status once the results from the lab (Sapphiros) have reached DNA visit. */
  ResultsWithProvider = 'RESULTS_WITH_PROVIDER'
}

/** Boolean expression to compare columns of type "dnavisit_test_statuses_enum". All fields are combined with logical 'AND'. */
export type Dnavisit_Test_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  _in?: InputMaybe<Array<Dnavisit_Test_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  _nin?: InputMaybe<Array<Dnavisit_Test_Statuses_Enum>>;
};

/** input type for inserting data into table "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Dnavisit_Test_Statuses_Max_Fields = {
  __typename?: 'dnavisit_test_statuses_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Dnavisit_Test_Statuses_Min_Fields = {
  __typename?: 'dnavisit_test_statuses_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Mutation_Response = {
  __typename?: 'dnavisit_test_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dnavisit_Test_Statuses>;
};

/** input type for inserting object relation for remote table "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Obj_Rel_Insert_Input = {
  data: Dnavisit_Test_Statuses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dnavisit_Test_Statuses_On_Conflict>;
};

/** on_conflict condition type for table "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_On_Conflict = {
  constraint: Dnavisit_Test_Statuses_Constraint;
  update_columns?: Array<Dnavisit_Test_Statuses_Update_Column>;
  where?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "dnavisit_test_statuses". */
export type Dnavisit_Test_Statuses_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dnavisit_test_statuses */
export type Dnavisit_Test_Statuses_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "dnavisit_test_statuses" */
export enum Dnavisit_Test_Statuses_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "dnavisit_test_statuses" */
export type Dnavisit_Test_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dnavisit_Test_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dnavisit_Test_Statuses_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "dnavisit_test_statuses" */
export enum Dnavisit_Test_Statuses_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Dnavisit_Test_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dnavisit_Test_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dnavisit_Test_Statuses_Bool_Exp;
};

/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_Tests = {
  __typename?: 'dnavisit_tests';
  created_at?: Maybe<Scalars['timestamptz']>;
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['uuid']>;
  dnavisit_order_id?: Maybe<Scalars['String']>;
  dnavisit_post_data?: Maybe<Scalars['jsonb']>;
  dnavisit_pre_data?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  dnavisit_tests_dna_questionnaire_file?: Maybe<Files>;
  /** An object relationship */
  dnavisit_tests_dnavisit_test_status?: Maybe<Dnavisit_Test_Statuses>;
  /** An object relationship */
  dnavisit_tests_health_questionnaire_file?: Maybe<Files>;
  /** An object relationship */
  dnavisit_tests_npi_number?: Maybe<Npi_Registry_Data>;
  /** An object relationship */
  dnavisit_tests_patient_file?: Maybe<Files>;
  /** An object relationship */
  dnavisit_tests_provider_file?: Maybe<Files>;
  /** An object relationship */
  dnavisit_tests_sapphiros_file?: Maybe<Files>;
  /** An object relationship */
  dnavisit_tests_test: Tests;
  /** An object relationship */
  dnavisit_tests_visit_summary_file?: Maybe<Files>;
  errors?: Maybe<Scalars['jsonb']>;
  health_questionnaire_pdf_id?: Maybe<Scalars['uuid']>;
  new_barcode?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['uuid']>;
  provider_report_pdf_id?: Maybe<Scalars['uuid']>;
  sapphiros_barcode?: Maybe<Scalars['String']>;
  sapphiros_data?: Maybe<Scalars['jsonb']>;
  sapphiros_report_pdf_id?: Maybe<Scalars['uuid']>;
  sapphiros_results?: Maybe<Scalars['jsonb']>;
  state?: Maybe<Dnavisit_Test_Statuses_Enum>;
  test_id: Scalars['uuid'];
  /** An array relationship */
  test_kits_update_states_summary_logs: Array<Test_Kits_Update_States_Summary_Log>;
  /** An aggregate relationship */
  test_kits_update_states_summary_logs_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  visit_summary_appointment_date?: Maybe<Scalars['timestamptz']>;
  visit_summary_appointment_url?: Maybe<Scalars['String']>;
  visit_summary_pdf_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsDnavisit_Post_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsDnavisit_Pre_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsSapphiros_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsSapphiros_ResultsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsTest_Kits_Update_States_Summary_LogsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** columns and relationships of "dnavisit_tests" */
export type Dnavisit_TestsTest_Kits_Update_States_Summary_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};

/** aggregated selection of "dnavisit_tests" */
export type Dnavisit_Tests_Aggregate = {
  __typename?: 'dnavisit_tests_aggregate';
  aggregate?: Maybe<Dnavisit_Tests_Aggregate_Fields>;
  nodes: Array<Dnavisit_Tests>;
};

export type Dnavisit_Tests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Dnavisit_Tests_Aggregate_Bool_Exp_Count>;
};

export type Dnavisit_Tests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "dnavisit_tests" */
export type Dnavisit_Tests_Aggregate_Fields = {
  __typename?: 'dnavisit_tests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Dnavisit_Tests_Max_Fields>;
  min?: Maybe<Dnavisit_Tests_Min_Fields>;
};


/** aggregate fields of "dnavisit_tests" */
export type Dnavisit_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "dnavisit_tests" */
export type Dnavisit_Tests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dnavisit_Tests_Max_Order_By>;
  min?: InputMaybe<Dnavisit_Tests_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Dnavisit_Tests_Append_Input = {
  dnavisit_post_data?: InputMaybe<Scalars['jsonb']>;
  dnavisit_pre_data?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  sapphiros_data?: InputMaybe<Scalars['jsonb']>;
  sapphiros_results?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "dnavisit_tests" */
export type Dnavisit_Tests_Arr_Rel_Insert_Input = {
  data: Array<Dnavisit_Tests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dnavisit_Tests_On_Conflict>;
};

/** Boolean expression to filter rows from the table "dnavisit_tests". All fields are combined with a logical 'AND'. */
export type Dnavisit_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Dnavisit_Tests_Bool_Exp>>;
  _not?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Dnavisit_Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
  dnavisit_order_id?: InputMaybe<String_Comparison_Exp>;
  dnavisit_post_data?: InputMaybe<Jsonb_Comparison_Exp>;
  dnavisit_pre_data?: InputMaybe<Jsonb_Comparison_Exp>;
  dnavisit_tests_dna_questionnaire_file?: InputMaybe<Files_Bool_Exp>;
  dnavisit_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
  dnavisit_tests_health_questionnaire_file?: InputMaybe<Files_Bool_Exp>;
  dnavisit_tests_npi_number?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
  dnavisit_tests_patient_file?: InputMaybe<Files_Bool_Exp>;
  dnavisit_tests_provider_file?: InputMaybe<Files_Bool_Exp>;
  dnavisit_tests_sapphiros_file?: InputMaybe<Files_Bool_Exp>;
  dnavisit_tests_test?: InputMaybe<Tests_Bool_Exp>;
  dnavisit_tests_visit_summary_file?: InputMaybe<Files_Bool_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  health_questionnaire_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
  new_barcode?: InputMaybe<String_Comparison_Exp>;
  npi_number?: InputMaybe<String_Comparison_Exp>;
  patient_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_report_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
  sapphiros_barcode?: InputMaybe<String_Comparison_Exp>;
  sapphiros_data?: InputMaybe<Jsonb_Comparison_Exp>;
  sapphiros_report_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
  sapphiros_results?: InputMaybe<Jsonb_Comparison_Exp>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_summary_appointment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_summary_appointment_url?: InputMaybe<String_Comparison_Exp>;
  visit_summary_pdf_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "dnavisit_tests" */
export enum Dnavisit_Tests_Constraint {
  /** unique or primary key constraint on columns "dna_test_questionnaire_pdf_id" */
  DnavisitTestsDnaTestQuestionnairePdfIdKey = 'dnavisit_tests_dna_test_questionnaire_pdf_id_key',
  /** unique or primary key constraint on columns "dnavisit_order_id" */
  DnavisitTestsDnavisitOrderIdKey = 'dnavisit_tests_dnavisit_order_id_key',
  /** unique or primary key constraint on columns "patient_pdf_id" */
  DnavisitTestsDnavisitResultPdfIdKey = 'dnavisit_tests_dnavisit_result_pdf_id_key',
  /** unique or primary key constraint on columns "health_questionnaire_pdf_id" */
  DnavisitTestsHealthQuestionnairePdfIdKey = 'dnavisit_tests_health_questionnaire_pdf_id_key',
  /** unique or primary key constraint on columns "test_id" */
  DnavisitTestsPkey = 'dnavisit_tests_pkey',
  /** unique or primary key constraint on columns "provider_report_pdf_id" */
  DnavisitTestsProviderReportPdfIdKey = 'dnavisit_tests_provider_report_pdf_id_key',
  /** unique or primary key constraint on columns "sapphiros_report_pdf_id" */
  DnavisitTestsSapphirosReportPdfIdKey = 'dnavisit_tests_sapphiros_report_pdf_id_key',
  /** unique or primary key constraint on columns "visit_summary_pdf_id" */
  DnavisitTestsVisitSummaryPdfIdKey = 'dnavisit_tests_visit_summary_pdf_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Dnavisit_Tests_Delete_At_Path_Input = {
  dnavisit_post_data?: InputMaybe<Array<Scalars['String']>>;
  dnavisit_pre_data?: InputMaybe<Array<Scalars['String']>>;
  errors?: InputMaybe<Array<Scalars['String']>>;
  sapphiros_data?: InputMaybe<Array<Scalars['String']>>;
  sapphiros_results?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Dnavisit_Tests_Delete_Elem_Input = {
  dnavisit_post_data?: InputMaybe<Scalars['Int']>;
  dnavisit_pre_data?: InputMaybe<Scalars['Int']>;
  errors?: InputMaybe<Scalars['Int']>;
  sapphiros_data?: InputMaybe<Scalars['Int']>;
  sapphiros_results?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Dnavisit_Tests_Delete_Key_Input = {
  dnavisit_post_data?: InputMaybe<Scalars['String']>;
  dnavisit_pre_data?: InputMaybe<Scalars['String']>;
  errors?: InputMaybe<Scalars['String']>;
  sapphiros_data?: InputMaybe<Scalars['String']>;
  sapphiros_results?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "dnavisit_tests" */
export type Dnavisit_Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Scalars['uuid']>;
  dnavisit_order_id?: InputMaybe<Scalars['String']>;
  dnavisit_post_data?: InputMaybe<Scalars['jsonb']>;
  dnavisit_pre_data?: InputMaybe<Scalars['jsonb']>;
  dnavisit_tests_dna_questionnaire_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  dnavisit_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Obj_Rel_Insert_Input>;
  dnavisit_tests_health_questionnaire_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  dnavisit_tests_npi_number?: InputMaybe<Npi_Registry_Data_Obj_Rel_Insert_Input>;
  dnavisit_tests_patient_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  dnavisit_tests_provider_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  dnavisit_tests_sapphiros_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  dnavisit_tests_test?: InputMaybe<Tests_Obj_Rel_Insert_Input>;
  dnavisit_tests_visit_summary_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  errors?: InputMaybe<Scalars['jsonb']>;
  health_questionnaire_pdf_id?: InputMaybe<Scalars['uuid']>;
  new_barcode?: InputMaybe<Scalars['String']>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['uuid']>;
  provider_report_pdf_id?: InputMaybe<Scalars['uuid']>;
  sapphiros_barcode?: InputMaybe<Scalars['String']>;
  sapphiros_data?: InputMaybe<Scalars['jsonb']>;
  sapphiros_report_pdf_id?: InputMaybe<Scalars['uuid']>;
  sapphiros_results?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visit_summary_appointment_date?: InputMaybe<Scalars['timestamptz']>;
  visit_summary_appointment_url?: InputMaybe<Scalars['String']>;
  visit_summary_pdf_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Dnavisit_Tests_Max_Fields = {
  __typename?: 'dnavisit_tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['uuid']>;
  dnavisit_order_id?: Maybe<Scalars['String']>;
  health_questionnaire_pdf_id?: Maybe<Scalars['uuid']>;
  new_barcode?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['uuid']>;
  provider_report_pdf_id?: Maybe<Scalars['uuid']>;
  sapphiros_barcode?: Maybe<Scalars['String']>;
  sapphiros_report_pdf_id?: Maybe<Scalars['uuid']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  visit_summary_appointment_date?: Maybe<Scalars['timestamptz']>;
  visit_summary_appointment_url?: Maybe<Scalars['String']>;
  visit_summary_pdf_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "dnavisit_tests" */
export type Dnavisit_Tests_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Order_By>;
  dnavisit_order_id?: InputMaybe<Order_By>;
  health_questionnaire_pdf_id?: InputMaybe<Order_By>;
  new_barcode?: InputMaybe<Order_By>;
  npi_number?: InputMaybe<Order_By>;
  patient_pdf_id?: InputMaybe<Order_By>;
  provider_report_pdf_id?: InputMaybe<Order_By>;
  sapphiros_barcode?: InputMaybe<Order_By>;
  sapphiros_report_pdf_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visit_summary_appointment_date?: InputMaybe<Order_By>;
  visit_summary_appointment_url?: InputMaybe<Order_By>;
  visit_summary_pdf_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Dnavisit_Tests_Min_Fields = {
  __typename?: 'dnavisit_tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dna_test_questionnaire_pdf_id?: Maybe<Scalars['uuid']>;
  dnavisit_order_id?: Maybe<Scalars['String']>;
  health_questionnaire_pdf_id?: Maybe<Scalars['uuid']>;
  new_barcode?: Maybe<Scalars['String']>;
  npi_number?: Maybe<Scalars['String']>;
  patient_pdf_id?: Maybe<Scalars['uuid']>;
  provider_report_pdf_id?: Maybe<Scalars['uuid']>;
  sapphiros_barcode?: Maybe<Scalars['String']>;
  sapphiros_report_pdf_id?: Maybe<Scalars['uuid']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  visit_summary_appointment_date?: Maybe<Scalars['timestamptz']>;
  visit_summary_appointment_url?: Maybe<Scalars['String']>;
  visit_summary_pdf_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "dnavisit_tests" */
export type Dnavisit_Tests_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Order_By>;
  dnavisit_order_id?: InputMaybe<Order_By>;
  health_questionnaire_pdf_id?: InputMaybe<Order_By>;
  new_barcode?: InputMaybe<Order_By>;
  npi_number?: InputMaybe<Order_By>;
  patient_pdf_id?: InputMaybe<Order_By>;
  provider_report_pdf_id?: InputMaybe<Order_By>;
  sapphiros_barcode?: InputMaybe<Order_By>;
  sapphiros_report_pdf_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visit_summary_appointment_date?: InputMaybe<Order_By>;
  visit_summary_appointment_url?: InputMaybe<Order_By>;
  visit_summary_pdf_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "dnavisit_tests" */
export type Dnavisit_Tests_Mutation_Response = {
  __typename?: 'dnavisit_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dnavisit_Tests>;
};

/** on_conflict condition type for table "dnavisit_tests" */
export type Dnavisit_Tests_On_Conflict = {
  constraint: Dnavisit_Tests_Constraint;
  update_columns?: Array<Dnavisit_Tests_Update_Column>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "dnavisit_tests". */
export type Dnavisit_Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Order_By>;
  dnavisit_order_id?: InputMaybe<Order_By>;
  dnavisit_post_data?: InputMaybe<Order_By>;
  dnavisit_pre_data?: InputMaybe<Order_By>;
  dnavisit_tests_dna_questionnaire_file?: InputMaybe<Files_Order_By>;
  dnavisit_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Order_By>;
  dnavisit_tests_health_questionnaire_file?: InputMaybe<Files_Order_By>;
  dnavisit_tests_npi_number?: InputMaybe<Npi_Registry_Data_Order_By>;
  dnavisit_tests_patient_file?: InputMaybe<Files_Order_By>;
  dnavisit_tests_provider_file?: InputMaybe<Files_Order_By>;
  dnavisit_tests_sapphiros_file?: InputMaybe<Files_Order_By>;
  dnavisit_tests_test?: InputMaybe<Tests_Order_By>;
  dnavisit_tests_visit_summary_file?: InputMaybe<Files_Order_By>;
  errors?: InputMaybe<Order_By>;
  health_questionnaire_pdf_id?: InputMaybe<Order_By>;
  new_barcode?: InputMaybe<Order_By>;
  npi_number?: InputMaybe<Order_By>;
  patient_pdf_id?: InputMaybe<Order_By>;
  provider_report_pdf_id?: InputMaybe<Order_By>;
  sapphiros_barcode?: InputMaybe<Order_By>;
  sapphiros_data?: InputMaybe<Order_By>;
  sapphiros_report_pdf_id?: InputMaybe<Order_By>;
  sapphiros_results?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visit_summary_appointment_date?: InputMaybe<Order_By>;
  visit_summary_appointment_url?: InputMaybe<Order_By>;
  visit_summary_pdf_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dnavisit_tests */
export type Dnavisit_Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Dnavisit_Tests_Prepend_Input = {
  dnavisit_post_data?: InputMaybe<Scalars['jsonb']>;
  dnavisit_pre_data?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  sapphiros_data?: InputMaybe<Scalars['jsonb']>;
  sapphiros_results?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "dnavisit_tests" */
export enum Dnavisit_Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DnaTestQuestionnairePdfId = 'dna_test_questionnaire_pdf_id',
  /** column name */
  DnavisitOrderId = 'dnavisit_order_id',
  /** column name */
  DnavisitPostData = 'dnavisit_post_data',
  /** column name */
  DnavisitPreData = 'dnavisit_pre_data',
  /** column name */
  Errors = 'errors',
  /** column name */
  HealthQuestionnairePdfId = 'health_questionnaire_pdf_id',
  /** column name */
  NewBarcode = 'new_barcode',
  /** column name */
  NpiNumber = 'npi_number',
  /** column name */
  PatientPdfId = 'patient_pdf_id',
  /** column name */
  ProviderReportPdfId = 'provider_report_pdf_id',
  /** column name */
  SapphirosBarcode = 'sapphiros_barcode',
  /** column name */
  SapphirosData = 'sapphiros_data',
  /** column name */
  SapphirosReportPdfId = 'sapphiros_report_pdf_id',
  /** column name */
  SapphirosResults = 'sapphiros_results',
  /** column name */
  State = 'state',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisitSummaryAppointmentDate = 'visit_summary_appointment_date',
  /** column name */
  VisitSummaryAppointmentUrl = 'visit_summary_appointment_url',
  /** column name */
  VisitSummaryPdfId = 'visit_summary_pdf_id'
}

/** input type for updating data in table "dnavisit_tests" */
export type Dnavisit_Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Scalars['uuid']>;
  dnavisit_order_id?: InputMaybe<Scalars['String']>;
  dnavisit_post_data?: InputMaybe<Scalars['jsonb']>;
  dnavisit_pre_data?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  health_questionnaire_pdf_id?: InputMaybe<Scalars['uuid']>;
  new_barcode?: InputMaybe<Scalars['String']>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['uuid']>;
  provider_report_pdf_id?: InputMaybe<Scalars['uuid']>;
  sapphiros_barcode?: InputMaybe<Scalars['String']>;
  sapphiros_data?: InputMaybe<Scalars['jsonb']>;
  sapphiros_report_pdf_id?: InputMaybe<Scalars['uuid']>;
  sapphiros_results?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visit_summary_appointment_date?: InputMaybe<Scalars['timestamptz']>;
  visit_summary_appointment_url?: InputMaybe<Scalars['String']>;
  visit_summary_pdf_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "dnavisit_tests" */
export type Dnavisit_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dnavisit_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dnavisit_Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dna_test_questionnaire_pdf_id?: InputMaybe<Scalars['uuid']>;
  dnavisit_order_id?: InputMaybe<Scalars['String']>;
  dnavisit_post_data?: InputMaybe<Scalars['jsonb']>;
  dnavisit_pre_data?: InputMaybe<Scalars['jsonb']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  health_questionnaire_pdf_id?: InputMaybe<Scalars['uuid']>;
  new_barcode?: InputMaybe<Scalars['String']>;
  npi_number?: InputMaybe<Scalars['String']>;
  patient_pdf_id?: InputMaybe<Scalars['uuid']>;
  provider_report_pdf_id?: InputMaybe<Scalars['uuid']>;
  sapphiros_barcode?: InputMaybe<Scalars['String']>;
  sapphiros_data?: InputMaybe<Scalars['jsonb']>;
  sapphiros_report_pdf_id?: InputMaybe<Scalars['uuid']>;
  sapphiros_results?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visit_summary_appointment_date?: InputMaybe<Scalars['timestamptz']>;
  visit_summary_appointment_url?: InputMaybe<Scalars['String']>;
  visit_summary_pdf_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "dnavisit_tests" */
export enum Dnavisit_Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DnaTestQuestionnairePdfId = 'dna_test_questionnaire_pdf_id',
  /** column name */
  DnavisitOrderId = 'dnavisit_order_id',
  /** column name */
  DnavisitPostData = 'dnavisit_post_data',
  /** column name */
  DnavisitPreData = 'dnavisit_pre_data',
  /** column name */
  Errors = 'errors',
  /** column name */
  HealthQuestionnairePdfId = 'health_questionnaire_pdf_id',
  /** column name */
  NewBarcode = 'new_barcode',
  /** column name */
  NpiNumber = 'npi_number',
  /** column name */
  PatientPdfId = 'patient_pdf_id',
  /** column name */
  ProviderReportPdfId = 'provider_report_pdf_id',
  /** column name */
  SapphirosBarcode = 'sapphiros_barcode',
  /** column name */
  SapphirosData = 'sapphiros_data',
  /** column name */
  SapphirosReportPdfId = 'sapphiros_report_pdf_id',
  /** column name */
  SapphirosResults = 'sapphiros_results',
  /** column name */
  State = 'state',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisitSummaryAppointmentDate = 'visit_summary_appointment_date',
  /** column name */
  VisitSummaryAppointmentUrl = 'visit_summary_appointment_url',
  /** column name */
  VisitSummaryPdfId = 'visit_summary_pdf_id'
}

export type Dnavisit_Tests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Dnavisit_Tests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Dnavisit_Tests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Dnavisit_Tests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Dnavisit_Tests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Dnavisit_Tests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dnavisit_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dnavisit_Tests_Bool_Exp;
};

/** Do not use this table. This table holds our inventory swab codes. */
export type Do_Not_Use_Production_Swab_Codes = {
  __typename?: 'do_not_use_production_swab_codes';
  active: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  is_test: Scalars['Boolean'];
  swab_code: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  used_by?: Maybe<Scalars['String']>;
};

/** aggregated selection of "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Aggregate = {
  __typename?: 'do_not_use_production_swab_codes_aggregate';
  aggregate?: Maybe<Do_Not_Use_Production_Swab_Codes_Aggregate_Fields>;
  nodes: Array<Do_Not_Use_Production_Swab_Codes>;
};

/** aggregate fields of "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Aggregate_Fields = {
  __typename?: 'do_not_use_production_swab_codes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Do_Not_Use_Production_Swab_Codes_Max_Fields>;
  min?: Maybe<Do_Not_Use_Production_Swab_Codes_Min_Fields>;
};


/** aggregate fields of "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "do_not_use_production_swab_codes". All fields are combined with a logical 'AND'. */
export type Do_Not_Use_Production_Swab_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Bool_Exp>>;
  _not?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_test?: InputMaybe<Boolean_Comparison_Exp>;
  swab_code?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  used_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "do_not_use_production_swab_codes" */
export enum Do_Not_Use_Production_Swab_Codes_Constraint {
  /** unique or primary key constraint on columns "swab_code" */
  DoNotUseProductionSwabCodesPkey = 'do_not_use_production_swab_codes_pkey'
}

/** input type for inserting data into table "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_test?: InputMaybe<Scalars['Boolean']>;
  swab_code?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Do_Not_Use_Production_Swab_Codes_Max_Fields = {
  __typename?: 'do_not_use_production_swab_codes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  swab_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Do_Not_Use_Production_Swab_Codes_Min_Fields = {
  __typename?: 'do_not_use_production_swab_codes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  swab_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Mutation_Response = {
  __typename?: 'do_not_use_production_swab_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Do_Not_Use_Production_Swab_Codes>;
};

/** on_conflict condition type for table "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_On_Conflict = {
  constraint: Do_Not_Use_Production_Swab_Codes_Constraint;
  update_columns?: Array<Do_Not_Use_Production_Swab_Codes_Update_Column>;
  where?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "do_not_use_production_swab_codes". */
export type Do_Not_Use_Production_Swab_Codes_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  is_test?: InputMaybe<Order_By>;
  swab_code?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: do_not_use_production_swab_codes */
export type Do_Not_Use_Production_Swab_Codes_Pk_Columns_Input = {
  swab_code: Scalars['String'];
};

/** select columns of table "do_not_use_production_swab_codes" */
export enum Do_Not_Use_Production_Swab_Codes_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsedBy = 'used_by'
}

/** input type for updating data in table "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_test?: InputMaybe<Scalars['Boolean']>;
  swab_code?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_by?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "do_not_use_production_swab_codes" */
export type Do_Not_Use_Production_Swab_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Do_Not_Use_Production_Swab_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Do_Not_Use_Production_Swab_Codes_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  is_test?: InputMaybe<Scalars['Boolean']>;
  swab_code?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_by?: InputMaybe<Scalars['String']>;
};

/** update columns of table "do_not_use_production_swab_codes" */
export enum Do_Not_Use_Production_Swab_Codes_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsTest = 'is_test',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsedBy = 'used_by'
}

export type Do_Not_Use_Production_Swab_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Do_Not_Use_Production_Swab_Codes_Bool_Exp;
};

/** columns and relationships of "ecommerce_orders" */
export type Ecommerce_Orders = {
  __typename?: 'ecommerce_orders';
  created_at: Scalars['timestamptz'];
  ecommerce_order_id: Scalars['Int'];
  id: Scalars['uuid'];
  price: Scalars['numeric'];
  products: Scalars['String'];
  status: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "ecommerce_orders" */
export type Ecommerce_Orders_Aggregate = {
  __typename?: 'ecommerce_orders_aggregate';
  aggregate?: Maybe<Ecommerce_Orders_Aggregate_Fields>;
  nodes: Array<Ecommerce_Orders>;
};

/** aggregate fields of "ecommerce_orders" */
export type Ecommerce_Orders_Aggregate_Fields = {
  __typename?: 'ecommerce_orders_aggregate_fields';
  avg?: Maybe<Ecommerce_Orders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ecommerce_Orders_Max_Fields>;
  min?: Maybe<Ecommerce_Orders_Min_Fields>;
  stddev?: Maybe<Ecommerce_Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Ecommerce_Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ecommerce_Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Ecommerce_Orders_Sum_Fields>;
  var_pop?: Maybe<Ecommerce_Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Ecommerce_Orders_Var_Samp_Fields>;
  variance?: Maybe<Ecommerce_Orders_Variance_Fields>;
};


/** aggregate fields of "ecommerce_orders" */
export type Ecommerce_Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ecommerce_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ecommerce_Orders_Avg_Fields = {
  __typename?: 'ecommerce_orders_avg_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ecommerce_orders". All fields are combined with a logical 'AND'. */
export type Ecommerce_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Ecommerce_Orders_Bool_Exp>>;
  _not?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Ecommerce_Orders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ecommerce_order_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  products?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ecommerce_orders" */
export enum Ecommerce_Orders_Constraint {
  /** unique or primary key constraint on columns "id" */
  EcommerceOrdersPkey = 'ecommerce_orders_pkey'
}

/** input type for incrementing numeric columns in table "ecommerce_orders" */
export type Ecommerce_Orders_Inc_Input = {
  ecommerce_order_id?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ecommerce_orders" */
export type Ecommerce_Orders_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ecommerce_order_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  products?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Ecommerce_Orders_Max_Fields = {
  __typename?: 'ecommerce_orders_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ecommerce_order_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  products?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Ecommerce_Orders_Min_Fields = {
  __typename?: 'ecommerce_orders_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ecommerce_order_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  products?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "ecommerce_orders" */
export type Ecommerce_Orders_Mutation_Response = {
  __typename?: 'ecommerce_orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ecommerce_Orders>;
};

/** on_conflict condition type for table "ecommerce_orders" */
export type Ecommerce_Orders_On_Conflict = {
  constraint: Ecommerce_Orders_Constraint;
  update_columns?: Array<Ecommerce_Orders_Update_Column>;
  where?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "ecommerce_orders". */
export type Ecommerce_Orders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ecommerce_order_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  products?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ecommerce_orders */
export type Ecommerce_Orders_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ecommerce_orders" */
export enum Ecommerce_Orders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EcommerceOrderId = 'ecommerce_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  Products = 'products',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ecommerce_orders" */
export type Ecommerce_Orders_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ecommerce_order_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  products?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Ecommerce_Orders_Stddev_Fields = {
  __typename?: 'ecommerce_orders_stddev_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ecommerce_Orders_Stddev_Pop_Fields = {
  __typename?: 'ecommerce_orders_stddev_pop_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ecommerce_Orders_Stddev_Samp_Fields = {
  __typename?: 'ecommerce_orders_stddev_samp_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ecommerce_orders" */
export type Ecommerce_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ecommerce_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ecommerce_Orders_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  ecommerce_order_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  products?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Ecommerce_Orders_Sum_Fields = {
  __typename?: 'ecommerce_orders_sum_fields';
  ecommerce_order_id?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
};

/** update columns of table "ecommerce_orders" */
export enum Ecommerce_Orders_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EcommerceOrderId = 'ecommerce_order_id',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  Products = 'products',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Ecommerce_Orders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ecommerce_Orders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ecommerce_Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ecommerce_Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ecommerce_Orders_Var_Pop_Fields = {
  __typename?: 'ecommerce_orders_var_pop_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ecommerce_Orders_Var_Samp_Fields = {
  __typename?: 'ecommerce_orders_var_samp_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ecommerce_Orders_Variance_Fields = {
  __typename?: 'ecommerce_orders_variance_fields';
  ecommerce_order_id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "education_courses" */
export type Education_Courses = {
  __typename?: 'education_courses';
  admin_deleted_at?: Maybe<Scalars['timestamptz']>;
  course_image_file_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  /** An array relationship */
  education_modules: Array<Education_Modules>;
  /** An aggregate relationship */
  education_modules_aggregate: Education_Modules_Aggregate;
  /** An object relationship */
  file: Files;
  id: Scalars['uuid'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  visibility_roles: Array<Scalars['smallint']>;
};


/** columns and relationships of "education_courses" */
export type Education_CoursesEducation_ModulesArgs = {
  distinct_on?: InputMaybe<Array<Education_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Modules_Order_By>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};


/** columns and relationships of "education_courses" */
export type Education_CoursesEducation_Modules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Modules_Order_By>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};

/** aggregated selection of "education_courses" */
export type Education_Courses_Aggregate = {
  __typename?: 'education_courses_aggregate';
  aggregate?: Maybe<Education_Courses_Aggregate_Fields>;
  nodes: Array<Education_Courses>;
};

export type Education_Courses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Education_Courses_Aggregate_Bool_Exp_Count>;
};

export type Education_Courses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Education_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Education_Courses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "education_courses" */
export type Education_Courses_Aggregate_Fields = {
  __typename?: 'education_courses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Education_Courses_Max_Fields>;
  min?: Maybe<Education_Courses_Min_Fields>;
};


/** aggregate fields of "education_courses" */
export type Education_Courses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Education_Courses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "education_courses" */
export type Education_Courses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Education_Courses_Max_Order_By>;
  min?: InputMaybe<Education_Courses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "education_courses" */
export type Education_Courses_Arr_Rel_Insert_Input = {
  data: Array<Education_Courses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Courses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "education_courses". All fields are combined with a logical 'AND'. */
export type Education_Courses_Bool_Exp = {
  _and?: InputMaybe<Array<Education_Courses_Bool_Exp>>;
  _not?: InputMaybe<Education_Courses_Bool_Exp>;
  _or?: InputMaybe<Array<Education_Courses_Bool_Exp>>;
  admin_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  course_image_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  education_modules?: InputMaybe<Education_Modules_Bool_Exp>;
  education_modules_aggregate?: InputMaybe<Education_Modules_Aggregate_Bool_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visibility_roles?: InputMaybe<Smallint_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "education_courses" */
export enum Education_Courses_Constraint {
  /** unique or primary key constraint on columns "id" */
  EducationCoursesPkey = 'education_courses_pkey'
}

/** input type for inserting data into table "education_courses" */
export type Education_Courses_Insert_Input = {
  admin_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  course_image_file_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  education_modules?: InputMaybe<Education_Modules_Arr_Rel_Insert_Input>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibility_roles?: InputMaybe<Array<Scalars['smallint']>>;
};

/** aggregate max on columns */
export type Education_Courses_Max_Fields = {
  __typename?: 'education_courses_max_fields';
  admin_deleted_at?: Maybe<Scalars['timestamptz']>;
  course_image_file_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  visibility_roles?: Maybe<Array<Scalars['smallint']>>;
};

/** order by max() on columns of table "education_courses" */
export type Education_Courses_Max_Order_By = {
  admin_deleted_at?: InputMaybe<Order_By>;
  course_image_file_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_roles?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Education_Courses_Min_Fields = {
  __typename?: 'education_courses_min_fields';
  admin_deleted_at?: Maybe<Scalars['timestamptz']>;
  course_image_file_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  visibility_roles?: Maybe<Array<Scalars['smallint']>>;
};

/** order by min() on columns of table "education_courses" */
export type Education_Courses_Min_Order_By = {
  admin_deleted_at?: InputMaybe<Order_By>;
  course_image_file_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_roles?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "education_courses" */
export type Education_Courses_Mutation_Response = {
  __typename?: 'education_courses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Education_Courses>;
};

/** input type for inserting object relation for remote table "education_courses" */
export type Education_Courses_Obj_Rel_Insert_Input = {
  data: Education_Courses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Courses_On_Conflict>;
};

/** on_conflict condition type for table "education_courses" */
export type Education_Courses_On_Conflict = {
  constraint: Education_Courses_Constraint;
  update_columns?: Array<Education_Courses_Update_Column>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};

/** Ordering options when selecting data from "education_courses". */
export type Education_Courses_Order_By = {
  admin_deleted_at?: InputMaybe<Order_By>;
  course_image_file_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  education_modules_aggregate?: InputMaybe<Education_Modules_Aggregate_Order_By>;
  file?: InputMaybe<Files_Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_roles?: InputMaybe<Order_By>;
};

/** primary key columns input for table: education_courses */
export type Education_Courses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "education_courses" */
export enum Education_Courses_Select_Column {
  /** column name */
  AdminDeletedAt = 'admin_deleted_at',
  /** column name */
  CourseImageFileId = 'course_image_file_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibilityRoles = 'visibility_roles'
}

/** input type for updating data in table "education_courses" */
export type Education_Courses_Set_Input = {
  admin_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  course_image_file_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibility_roles?: InputMaybe<Array<Scalars['smallint']>>;
};

/** Streaming cursor of the table "education_courses" */
export type Education_Courses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Education_Courses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Education_Courses_Stream_Cursor_Value_Input = {
  admin_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  course_image_file_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  visibility_roles?: InputMaybe<Array<Scalars['smallint']>>;
};

/** update columns of table "education_courses" */
export enum Education_Courses_Update_Column {
  /** column name */
  AdminDeletedAt = 'admin_deleted_at',
  /** column name */
  CourseImageFileId = 'course_image_file_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VisibilityRoles = 'visibility_roles'
}

export type Education_Courses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Education_Courses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Education_Courses_Bool_Exp;
};

/** columns and relationships of "education_module_additional_materials" */
export type Education_Module_Additional_Materials = {
  __typename?: 'education_module_additional_materials';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  linked_module: Education_Modules;
  linked_module_id: Scalars['uuid'];
  module_id: Scalars['uuid'];
};

/** aggregated selection of "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Aggregate = {
  __typename?: 'education_module_additional_materials_aggregate';
  aggregate?: Maybe<Education_Module_Additional_Materials_Aggregate_Fields>;
  nodes: Array<Education_Module_Additional_Materials>;
};

export type Education_Module_Additional_Materials_Aggregate_Bool_Exp = {
  count?: InputMaybe<Education_Module_Additional_Materials_Aggregate_Bool_Exp_Count>;
};

export type Education_Module_Additional_Materials_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Aggregate_Fields = {
  __typename?: 'education_module_additional_materials_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Education_Module_Additional_Materials_Max_Fields>;
  min?: Maybe<Education_Module_Additional_Materials_Min_Fields>;
};


/** aggregate fields of "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Education_Module_Additional_Materials_Max_Order_By>;
  min?: InputMaybe<Education_Module_Additional_Materials_Min_Order_By>;
};

/** input type for inserting array relation for remote table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Arr_Rel_Insert_Input = {
  data: Array<Education_Module_Additional_Materials_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Module_Additional_Materials_On_Conflict>;
};

/** Boolean expression to filter rows from the table "education_module_additional_materials". All fields are combined with a logical 'AND'. */
export type Education_Module_Additional_Materials_Bool_Exp = {
  _and?: InputMaybe<Array<Education_Module_Additional_Materials_Bool_Exp>>;
  _not?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
  _or?: InputMaybe<Array<Education_Module_Additional_Materials_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  linked_module?: InputMaybe<Education_Modules_Bool_Exp>;
  linked_module_id?: InputMaybe<Uuid_Comparison_Exp>;
  module_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "education_module_additional_materials" */
export enum Education_Module_Additional_Materials_Constraint {
  /** unique or primary key constraint on columns "id" */
  EducationModuleAdditionalMaterialsPkey = 'education_module_additional_materials_pkey'
}

/** input type for inserting data into table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  linked_module?: InputMaybe<Education_Modules_Obj_Rel_Insert_Input>;
  linked_module_id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Education_Module_Additional_Materials_Max_Fields = {
  __typename?: 'education_module_additional_materials_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  linked_module_id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  linked_module_id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Education_Module_Additional_Materials_Min_Fields = {
  __typename?: 'education_module_additional_materials_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  linked_module_id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  linked_module_id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Mutation_Response = {
  __typename?: 'education_module_additional_materials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Education_Module_Additional_Materials>;
};

/** on_conflict condition type for table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_On_Conflict = {
  constraint: Education_Module_Additional_Materials_Constraint;
  update_columns?: Array<Education_Module_Additional_Materials_Update_Column>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};

/** Ordering options when selecting data from "education_module_additional_materials". */
export type Education_Module_Additional_Materials_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  linked_module?: InputMaybe<Education_Modules_Order_By>;
  linked_module_id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: education_module_additional_materials */
export type Education_Module_Additional_Materials_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "education_module_additional_materials" */
export enum Education_Module_Additional_Materials_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LinkedModuleId = 'linked_module_id',
  /** column name */
  ModuleId = 'module_id'
}

/** input type for updating data in table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  linked_module_id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "education_module_additional_materials" */
export type Education_Module_Additional_Materials_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Education_Module_Additional_Materials_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Education_Module_Additional_Materials_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  linked_module_id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "education_module_additional_materials" */
export enum Education_Module_Additional_Materials_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LinkedModuleId = 'linked_module_id',
  /** column name */
  ModuleId = 'module_id'
}

export type Education_Module_Additional_Materials_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Education_Module_Additional_Materials_Set_Input>;
  /** filter the rows which have to be updated */
  where: Education_Module_Additional_Materials_Bool_Exp;
};

/** columns and relationships of "education_module_items" */
export type Education_Module_Items = {
  __typename?: 'education_module_items';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category: Scalars['smallint'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  education_module: Education_Modules;
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid'];
  id: Scalars['uuid'];
  module_id: Scalars['uuid'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "education_module_items" */
export type Education_Module_Items_Aggregate = {
  __typename?: 'education_module_items_aggregate';
  aggregate?: Maybe<Education_Module_Items_Aggregate_Fields>;
  nodes: Array<Education_Module_Items>;
};

export type Education_Module_Items_Aggregate_Bool_Exp = {
  count?: InputMaybe<Education_Module_Items_Aggregate_Bool_Exp_Count>;
};

export type Education_Module_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Education_Module_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "education_module_items" */
export type Education_Module_Items_Aggregate_Fields = {
  __typename?: 'education_module_items_aggregate_fields';
  avg?: Maybe<Education_Module_Items_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Education_Module_Items_Max_Fields>;
  min?: Maybe<Education_Module_Items_Min_Fields>;
  stddev?: Maybe<Education_Module_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Education_Module_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Education_Module_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Education_Module_Items_Sum_Fields>;
  var_pop?: Maybe<Education_Module_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Education_Module_Items_Var_Samp_Fields>;
  variance?: Maybe<Education_Module_Items_Variance_Fields>;
};


/** aggregate fields of "education_module_items" */
export type Education_Module_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "education_module_items" */
export type Education_Module_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Education_Module_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Education_Module_Items_Max_Order_By>;
  min?: InputMaybe<Education_Module_Items_Min_Order_By>;
  stddev?: InputMaybe<Education_Module_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Education_Module_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Education_Module_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Education_Module_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Education_Module_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Education_Module_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Education_Module_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "education_module_items" */
export type Education_Module_Items_Arr_Rel_Insert_Input = {
  data: Array<Education_Module_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Module_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Education_Module_Items_Avg_Fields = {
  __typename?: 'education_module_items_avg_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "education_module_items" */
export type Education_Module_Items_Avg_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "education_module_items". All fields are combined with a logical 'AND'. */
export type Education_Module_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Education_Module_Items_Bool_Exp>>;
  _not?: InputMaybe<Education_Module_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Education_Module_Items_Bool_Exp>>;
  category?: InputMaybe<Smallint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  education_module?: InputMaybe<Education_Modules_Bool_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  module_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "education_module_items" */
export enum Education_Module_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  EducationModuleItemsPkey = 'education_module_items_pkey'
}

/** input type for incrementing numeric columns in table "education_module_items" */
export type Education_Module_Items_Inc_Input = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "education_module_items" */
export type Education_Module_Items_Insert_Input = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  education_module?: InputMaybe<Education_Modules_Obj_Rel_Insert_Input>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Education_Module_Items_Max_Fields = {
  __typename?: 'education_module_items_max_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "education_module_items" */
export type Education_Module_Items_Max_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Education_Module_Items_Min_Fields = {
  __typename?: 'education_module_items_min_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "education_module_items" */
export type Education_Module_Items_Min_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "education_module_items" */
export type Education_Module_Items_Mutation_Response = {
  __typename?: 'education_module_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Education_Module_Items>;
};

/** on_conflict condition type for table "education_module_items" */
export type Education_Module_Items_On_Conflict = {
  constraint: Education_Module_Items_Constraint;
  update_columns?: Array<Education_Module_Items_Update_Column>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "education_module_items". */
export type Education_Module_Items_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  education_module?: InputMaybe<Education_Modules_Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: education_module_items */
export type Education_Module_Items_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "education_module_items" */
export enum Education_Module_Items_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleId = 'module_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "education_module_items" */
export type Education_Module_Items_Set_Input = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Education_Module_Items_Stddev_Fields = {
  __typename?: 'education_module_items_stddev_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "education_module_items" */
export type Education_Module_Items_Stddev_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Education_Module_Items_Stddev_Pop_Fields = {
  __typename?: 'education_module_items_stddev_pop_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "education_module_items" */
export type Education_Module_Items_Stddev_Pop_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Education_Module_Items_Stddev_Samp_Fields = {
  __typename?: 'education_module_items_stddev_samp_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "education_module_items" */
export type Education_Module_Items_Stddev_Samp_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "education_module_items" */
export type Education_Module_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Education_Module_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Education_Module_Items_Stream_Cursor_Value_Input = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Education_Module_Items_Sum_Fields = {
  __typename?: 'education_module_items_sum_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "education_module_items" */
export type Education_Module_Items_Sum_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** update columns of table "education_module_items" */
export enum Education_Module_Items_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleId = 'module_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Education_Module_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Education_Module_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Education_Module_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Education_Module_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Education_Module_Items_Var_Pop_Fields = {
  __typename?: 'education_module_items_var_pop_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "education_module_items" */
export type Education_Module_Items_Var_Pop_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Education_Module_Items_Var_Samp_Fields = {
  __typename?: 'education_module_items_var_samp_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "education_module_items" */
export type Education_Module_Items_Var_Samp_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Education_Module_Items_Variance_Fields = {
  __typename?: 'education_module_items_variance_fields';
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "education_module_items" */
export type Education_Module_Items_Variance_Order_By = {
  /** 1 - article, 2 - slides, 3 - audio, 4 - video */
  category?: InputMaybe<Order_By>;
};

/** columns and relationships of "education_modules" */
export type Education_Modules = {
  __typename?: 'education_modules';
  /** An array relationship */
  additional_materials_modules: Array<Education_Module_Additional_Materials>;
  /** An aggregate relationship */
  additional_materials_modules_aggregate: Education_Module_Additional_Materials_Aggregate;
  course_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  education_course: Education_Courses;
  /** An array relationship */
  education_module_items: Array<Education_Module_Items>;
  /** An aggregate relationship */
  education_module_items_aggregate: Education_Module_Items_Aggregate;
  id: Scalars['uuid'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "education_modules" */
export type Education_ModulesAdditional_Materials_ModulesArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Additional_Materials_Order_By>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


/** columns and relationships of "education_modules" */
export type Education_ModulesAdditional_Materials_Modules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Additional_Materials_Order_By>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


/** columns and relationships of "education_modules" */
export type Education_ModulesEducation_Module_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


/** columns and relationships of "education_modules" */
export type Education_ModulesEducation_Module_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};

/** aggregated selection of "education_modules" */
export type Education_Modules_Aggregate = {
  __typename?: 'education_modules_aggregate';
  aggregate?: Maybe<Education_Modules_Aggregate_Fields>;
  nodes: Array<Education_Modules>;
};

export type Education_Modules_Aggregate_Bool_Exp = {
  count?: InputMaybe<Education_Modules_Aggregate_Bool_Exp_Count>;
};

export type Education_Modules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Education_Modules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Education_Modules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "education_modules" */
export type Education_Modules_Aggregate_Fields = {
  __typename?: 'education_modules_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Education_Modules_Max_Fields>;
  min?: Maybe<Education_Modules_Min_Fields>;
};


/** aggregate fields of "education_modules" */
export type Education_Modules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Education_Modules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "education_modules" */
export type Education_Modules_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Education_Modules_Max_Order_By>;
  min?: InputMaybe<Education_Modules_Min_Order_By>;
};

/** input type for inserting array relation for remote table "education_modules" */
export type Education_Modules_Arr_Rel_Insert_Input = {
  data: Array<Education_Modules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Modules_On_Conflict>;
};

/** Boolean expression to filter rows from the table "education_modules". All fields are combined with a logical 'AND'. */
export type Education_Modules_Bool_Exp = {
  _and?: InputMaybe<Array<Education_Modules_Bool_Exp>>;
  _not?: InputMaybe<Education_Modules_Bool_Exp>;
  _or?: InputMaybe<Array<Education_Modules_Bool_Exp>>;
  additional_materials_modules?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
  additional_materials_modules_aggregate?: InputMaybe<Education_Module_Additional_Materials_Aggregate_Bool_Exp>;
  course_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  education_course?: InputMaybe<Education_Courses_Bool_Exp>;
  education_module_items?: InputMaybe<Education_Module_Items_Bool_Exp>;
  education_module_items_aggregate?: InputMaybe<Education_Module_Items_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "education_modules" */
export enum Education_Modules_Constraint {
  /** unique or primary key constraint on columns "id" */
  EducationModulesPkey = 'education_modules_pkey'
}

/** input type for inserting data into table "education_modules" */
export type Education_Modules_Insert_Input = {
  additional_materials_modules?: InputMaybe<Education_Module_Additional_Materials_Arr_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  education_course?: InputMaybe<Education_Courses_Obj_Rel_Insert_Input>;
  education_module_items?: InputMaybe<Education_Module_Items_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Education_Modules_Max_Fields = {
  __typename?: 'education_modules_max_fields';
  course_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "education_modules" */
export type Education_Modules_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Education_Modules_Min_Fields = {
  __typename?: 'education_modules_min_fields';
  course_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "education_modules" */
export type Education_Modules_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "education_modules" */
export type Education_Modules_Mutation_Response = {
  __typename?: 'education_modules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Education_Modules>;
};

/** input type for inserting object relation for remote table "education_modules" */
export type Education_Modules_Obj_Rel_Insert_Input = {
  data: Education_Modules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Education_Modules_On_Conflict>;
};

/** on_conflict condition type for table "education_modules" */
export type Education_Modules_On_Conflict = {
  constraint: Education_Modules_Constraint;
  update_columns?: Array<Education_Modules_Update_Column>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};

/** Ordering options when selecting data from "education_modules". */
export type Education_Modules_Order_By = {
  additional_materials_modules_aggregate?: InputMaybe<Education_Module_Additional_Materials_Aggregate_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  education_course?: InputMaybe<Education_Courses_Order_By>;
  education_module_items_aggregate?: InputMaybe<Education_Module_Items_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: education_modules */
export type Education_Modules_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "education_modules" */
export enum Education_Modules_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "education_modules" */
export type Education_Modules_Set_Input = {
  course_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "education_modules" */
export type Education_Modules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Education_Modules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Education_Modules_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "education_modules" */
export enum Education_Modules_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Education_Modules_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Education_Modules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Education_Modules_Bool_Exp;
};

/** columns and relationships of "file_types" */
export type File_Types = {
  __typename?: 'file_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "file_types" */
export type File_Types_Aggregate = {
  __typename?: 'file_types_aggregate';
  aggregate?: Maybe<File_Types_Aggregate_Fields>;
  nodes: Array<File_Types>;
};

/** aggregate fields of "file_types" */
export type File_Types_Aggregate_Fields = {
  __typename?: 'file_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<File_Types_Max_Fields>;
  min?: Maybe<File_Types_Min_Fields>;
};


/** aggregate fields of "file_types" */
export type File_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file_types". All fields are combined with a logical 'AND'. */
export type File_Types_Bool_Exp = {
  _and?: InputMaybe<Array<File_Types_Bool_Exp>>;
  _not?: InputMaybe<File_Types_Bool_Exp>;
  _or?: InputMaybe<Array<File_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_types" */
export enum File_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  FileTypesPkey = 'file_types_pkey'
}

export enum File_Types_Enum {
  Archive = 'ARCHIVE',
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Presentation = 'PRESENTATION',
  Spreadsheet = 'SPREADSHEET',
  Text = 'TEXT',
  Video = 'VIDEO'
}

/** Boolean expression to compare columns of type "file_types_enum". All fields are combined with logical 'AND'. */
export type File_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<File_Types_Enum>;
  _in?: InputMaybe<Array<File_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<File_Types_Enum>;
  _nin?: InputMaybe<Array<File_Types_Enum>>;
};

/** input type for inserting data into table "file_types" */
export type File_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type File_Types_Max_Fields = {
  __typename?: 'file_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_Types_Min_Fields = {
  __typename?: 'file_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file_types" */
export type File_Types_Mutation_Response = {
  __typename?: 'file_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File_Types>;
};

/** on_conflict condition type for table "file_types" */
export type File_Types_On_Conflict = {
  constraint: File_Types_Constraint;
  update_columns?: Array<File_Types_Update_Column>;
  where?: InputMaybe<File_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "file_types". */
export type File_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file_types */
export type File_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "file_types" */
export enum File_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "file_types" */
export type File_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file_types" */
export type File_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "file_types" */
export enum File_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type File_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_Types_Bool_Exp;
};

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'files';
  /** An object relationship */
  appointment?: Maybe<Appointments>;
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  education_courses: Array<Education_Courses>;
  /** An aggregate relationship */
  education_courses_aggregate: Education_Courses_Aggregate;
  /** An array relationship */
  education_module_items: Array<Education_Module_Items>;
  /** An aggregate relationship */
  education_module_items_aggregate: Education_Module_Items_Aggregate;
  encounter_id?: Maybe<Scalars['uuid']>;
  file_name: Scalars['String'];
  id: Scalars['uuid'];
  patient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  removed_from_library_at?: Maybe<Scalars['timestamptz']>;
  size?: Maybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Int']>;
  type: File_Types_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "files" */
export type FilesEducation_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Education_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Courses_Order_By>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesEducation_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Courses_Order_By>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesEducation_Module_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesEducation_Module_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};

/** aggregated selection of "files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "files" */
export type Files_Arr_Rel_Insert_Input = {
  data: Array<Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "files" */
export type Files_Avg_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  education_courses?: InputMaybe<Education_Courses_Bool_Exp>;
  education_courses_aggregate?: InputMaybe<Education_Courses_Aggregate_Bool_Exp>;
  education_module_items?: InputMaybe<Education_Module_Items_Bool_Exp>;
  education_module_items_aggregate?: InputMaybe<Education_Module_Items_Aggregate_Bool_Exp>;
  encounter_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed_from_library_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  source_type?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<File_Types_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** input type for incrementing numeric columns in table "files" */
export type Files_Inc_Input = {
  product_id?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  education_courses?: InputMaybe<Education_Courses_Arr_Rel_Insert_Input>;
  education_module_items?: InputMaybe<Education_Module_Items_Arr_Rel_Insert_Input>;
  encounter_id?: InputMaybe<Scalars['uuid']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  removed_from_library_at?: InputMaybe<Scalars['timestamptz']>;
  size?: InputMaybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<File_Types_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  encounter_id?: Maybe<Scalars['uuid']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  patient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  removed_from_library_at?: Maybe<Scalars['timestamptz']>;
  size?: Maybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "files" */
export type Files_Max_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  encounter_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  removed_from_library_at?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  encounter_id?: Maybe<Scalars['uuid']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  patient_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  removed_from_library_at?: Maybe<Scalars['timestamptz']>;
  size?: Maybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "files" */
export type Files_Min_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  encounter_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  removed_from_library_at?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  appointment?: InputMaybe<Appointments_Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  education_courses_aggregate?: InputMaybe<Education_Courses_Aggregate_Order_By>;
  education_module_items_aggregate?: InputMaybe<Education_Module_Items_Aggregate_Order_By>;
  encounter_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  removed_from_library_at?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  source_type?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EncounterId = 'encounter_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RemovedFromLibraryAt = 'removed_from_library_at',
  /** column name */
  Size = 'size',
  /** column name */
  SourceType = 'source_type',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  encounter_id?: InputMaybe<Scalars['uuid']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  removed_from_library_at?: InputMaybe<Scalars['timestamptz']>;
  size?: InputMaybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<File_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "files" */
export type Files_Stddev_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "files" */
export type Files_Stddev_Pop_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "files" */
export type Files_Stddev_Samp_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  encounter_id?: InputMaybe<Scalars['uuid']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  removed_from_library_at?: InputMaybe<Scalars['timestamptz']>;
  size?: InputMaybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<File_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  product_id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "files" */
export type Files_Sum_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EncounterId = 'encounter_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RemovedFromLibraryAt = 'removed_from_library_at',
  /** column name */
  Size = 'size',
  /** column name */
  SourceType = 'source_type',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "files" */
export type Files_Var_Pop_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "files" */
export type Files_Var_Samp_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  product_id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "files" */
export type Files_Variance_Order_By = {
  product_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  /** 1 - summary, 2 - appointment diagnostics, 3 - vonage, 4 - in-mail, 5 - user, 6 - test kit, 7 - questionnaire, 8 - archive, 9 - product, 10 - medical record, 12 - questionnaire response, 13 - education course details, 14 - education course module material, 15 - payment receipt, 16 - support chat */
  source_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "fullscript_allergens" */
export type Fullscript_Allergens = {
  __typename?: 'fullscript_allergens';
  created_at: Scalars['timestamptz'];
  fullscript_id: Scalars['String'];
  fullscript_name: Scalars['String'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "fullscript_allergens" */
export type Fullscript_Allergens_Aggregate = {
  __typename?: 'fullscript_allergens_aggregate';
  aggregate?: Maybe<Fullscript_Allergens_Aggregate_Fields>;
  nodes: Array<Fullscript_Allergens>;
};

/** aggregate fields of "fullscript_allergens" */
export type Fullscript_Allergens_Aggregate_Fields = {
  __typename?: 'fullscript_allergens_aggregate_fields';
  avg?: Maybe<Fullscript_Allergens_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fullscript_Allergens_Max_Fields>;
  min?: Maybe<Fullscript_Allergens_Min_Fields>;
  stddev?: Maybe<Fullscript_Allergens_Stddev_Fields>;
  stddev_pop?: Maybe<Fullscript_Allergens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fullscript_Allergens_Stddev_Samp_Fields>;
  sum?: Maybe<Fullscript_Allergens_Sum_Fields>;
  var_pop?: Maybe<Fullscript_Allergens_Var_Pop_Fields>;
  var_samp?: Maybe<Fullscript_Allergens_Var_Samp_Fields>;
  variance?: Maybe<Fullscript_Allergens_Variance_Fields>;
};


/** aggregate fields of "fullscript_allergens" */
export type Fullscript_Allergens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fullscript_Allergens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fullscript_Allergens_Avg_Fields = {
  __typename?: 'fullscript_allergens_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fullscript_allergens". All fields are combined with a logical 'AND'. */
export type Fullscript_Allergens_Bool_Exp = {
  _and?: InputMaybe<Array<Fullscript_Allergens_Bool_Exp>>;
  _not?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
  _or?: InputMaybe<Array<Fullscript_Allergens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullscript_id?: InputMaybe<String_Comparison_Exp>;
  fullscript_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "fullscript_allergens" */
export enum Fullscript_Allergens_Constraint {
  /** unique or primary key constraint on columns "fullscript_id" */
  FullscriptAllergensFullscriptIdKey = 'fullscript_allergens_fullscript_id_key',
  /** unique or primary key constraint on columns "id" */
  FullscriptAllergensPkey = 'fullscript_allergens_pkey'
}

/** input type for incrementing numeric columns in table "fullscript_allergens" */
export type Fullscript_Allergens_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "fullscript_allergens" */
export type Fullscript_Allergens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fullscript_id?: InputMaybe<Scalars['String']>;
  fullscript_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Fullscript_Allergens_Max_Fields = {
  __typename?: 'fullscript_allergens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  fullscript_id?: Maybe<Scalars['String']>;
  fullscript_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Fullscript_Allergens_Min_Fields = {
  __typename?: 'fullscript_allergens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  fullscript_id?: Maybe<Scalars['String']>;
  fullscript_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "fullscript_allergens" */
export type Fullscript_Allergens_Mutation_Response = {
  __typename?: 'fullscript_allergens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fullscript_Allergens>;
};

/** on_conflict condition type for table "fullscript_allergens" */
export type Fullscript_Allergens_On_Conflict = {
  constraint: Fullscript_Allergens_Constraint;
  update_columns?: Array<Fullscript_Allergens_Update_Column>;
  where?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
};

/** Ordering options when selecting data from "fullscript_allergens". */
export type Fullscript_Allergens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fullscript_id?: InputMaybe<Order_By>;
  fullscript_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fullscript_allergens */
export type Fullscript_Allergens_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "fullscript_allergens" */
export enum Fullscript_Allergens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullscriptId = 'fullscript_id',
  /** column name */
  FullscriptName = 'fullscript_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "fullscript_allergens" */
export type Fullscript_Allergens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fullscript_id?: InputMaybe<Scalars['String']>;
  fullscript_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Fullscript_Allergens_Stddev_Fields = {
  __typename?: 'fullscript_allergens_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fullscript_Allergens_Stddev_Pop_Fields = {
  __typename?: 'fullscript_allergens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fullscript_Allergens_Stddev_Samp_Fields = {
  __typename?: 'fullscript_allergens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fullscript_allergens" */
export type Fullscript_Allergens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fullscript_Allergens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fullscript_Allergens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fullscript_id?: InputMaybe<Scalars['String']>;
  fullscript_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Fullscript_Allergens_Sum_Fields = {
  __typename?: 'fullscript_allergens_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "fullscript_allergens" */
export enum Fullscript_Allergens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullscriptId = 'fullscript_id',
  /** column name */
  FullscriptName = 'fullscript_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Fullscript_Allergens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fullscript_Allergens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fullscript_Allergens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fullscript_Allergens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fullscript_Allergens_Var_Pop_Fields = {
  __typename?: 'fullscript_allergens_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fullscript_Allergens_Var_Samp_Fields = {
  __typename?: 'fullscript_allergens_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fullscript_Allergens_Variance_Fields = {
  __typename?: 'fullscript_allergens_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Clinician ID for FullScript */
export type Fullscript_Clinicians = {
  __typename?: 'fullscript_clinicians';
  clinician_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "fullscript_clinicians" */
export type Fullscript_Clinicians_Aggregate = {
  __typename?: 'fullscript_clinicians_aggregate';
  aggregate?: Maybe<Fullscript_Clinicians_Aggregate_Fields>;
  nodes: Array<Fullscript_Clinicians>;
};

/** aggregate fields of "fullscript_clinicians" */
export type Fullscript_Clinicians_Aggregate_Fields = {
  __typename?: 'fullscript_clinicians_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fullscript_Clinicians_Max_Fields>;
  min?: Maybe<Fullscript_Clinicians_Min_Fields>;
};


/** aggregate fields of "fullscript_clinicians" */
export type Fullscript_Clinicians_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fullscript_Clinicians_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fullscript_clinicians". All fields are combined with a logical 'AND'. */
export type Fullscript_Clinicians_Bool_Exp = {
  _and?: InputMaybe<Array<Fullscript_Clinicians_Bool_Exp>>;
  _not?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
  _or?: InputMaybe<Array<Fullscript_Clinicians_Bool_Exp>>;
  clinician_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "fullscript_clinicians" */
export enum Fullscript_Clinicians_Constraint {
  /** unique or primary key constraint on columns "id" */
  FullscriptCliniciansPkey = 'fullscript_clinicians_pkey'
}

/** input type for inserting data into table "fullscript_clinicians" */
export type Fullscript_Clinicians_Insert_Input = {
  clinician_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Fullscript_Clinicians_Max_Fields = {
  __typename?: 'fullscript_clinicians_max_fields';
  clinician_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fullscript_Clinicians_Min_Fields = {
  __typename?: 'fullscript_clinicians_min_fields';
  clinician_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fullscript_clinicians" */
export type Fullscript_Clinicians_Mutation_Response = {
  __typename?: 'fullscript_clinicians_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fullscript_Clinicians>;
};

/** on_conflict condition type for table "fullscript_clinicians" */
export type Fullscript_Clinicians_On_Conflict = {
  constraint: Fullscript_Clinicians_Constraint;
  update_columns?: Array<Fullscript_Clinicians_Update_Column>;
  where?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
};

/** Ordering options when selecting data from "fullscript_clinicians". */
export type Fullscript_Clinicians_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fullscript_clinicians */
export type Fullscript_Clinicians_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "fullscript_clinicians" */
export enum Fullscript_Clinicians_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "fullscript_clinicians" */
export type Fullscript_Clinicians_Set_Input = {
  clinician_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "fullscript_clinicians" */
export type Fullscript_Clinicians_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fullscript_Clinicians_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fullscript_Clinicians_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "fullscript_clinicians" */
export enum Fullscript_Clinicians_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Fullscript_Clinicians_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fullscript_Clinicians_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fullscript_Clinicians_Bool_Exp;
};

/** columns and relationships of "gale_products" */
export type Gale_Products = {
  __typename?: 'gale_products';
  created_at: Scalars['timestamptz'];
  eligibility_checked_at?: Maybe<Scalars['timestamptz']>;
  eligibility_message?: Maybe<Scalars['String']>;
  entity_type: Scalars['String'];
  gale_product_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_eligible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** An object relationship */
  product?: Maybe<Products>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "gale_products" */
export type Gale_Products_Aggregate = {
  __typename?: 'gale_products_aggregate';
  aggregate?: Maybe<Gale_Products_Aggregate_Fields>;
  nodes: Array<Gale_Products>;
};

export type Gale_Products_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Gale_Products_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Gale_Products_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Gale_Products_Aggregate_Bool_Exp_Count>;
};

export type Gale_Products_Aggregate_Bool_Exp_Bool_And = {
  arguments: Gale_Products_Select_Column_Gale_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gale_Products_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Gale_Products_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Gale_Products_Select_Column_Gale_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gale_Products_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Gale_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gale_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gale_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "gale_products" */
export type Gale_Products_Aggregate_Fields = {
  __typename?: 'gale_products_aggregate_fields';
  avg?: Maybe<Gale_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Gale_Products_Max_Fields>;
  min?: Maybe<Gale_Products_Min_Fields>;
  stddev?: Maybe<Gale_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Gale_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gale_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Gale_Products_Sum_Fields>;
  var_pop?: Maybe<Gale_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Gale_Products_Var_Samp_Fields>;
  variance?: Maybe<Gale_Products_Variance_Fields>;
};


/** aggregate fields of "gale_products" */
export type Gale_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gale_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gale_products" */
export type Gale_Products_Aggregate_Order_By = {
  avg?: InputMaybe<Gale_Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gale_Products_Max_Order_By>;
  min?: InputMaybe<Gale_Products_Min_Order_By>;
  stddev?: InputMaybe<Gale_Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Gale_Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Gale_Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Gale_Products_Sum_Order_By>;
  var_pop?: InputMaybe<Gale_Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Gale_Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Gale_Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "gale_products" */
export type Gale_Products_Arr_Rel_Insert_Input = {
  data: Array<Gale_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gale_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Gale_Products_Avg_Fields = {
  __typename?: 'gale_products_avg_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "gale_products" */
export type Gale_Products_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "gale_products". All fields are combined with a logical 'AND'. */
export type Gale_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Gale_Products_Bool_Exp>>;
  _not?: InputMaybe<Gale_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Gale_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligibility_checked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  eligibility_message?: InputMaybe<String_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  gale_product_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "gale_products" */
export enum Gale_Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  GaleProductsPkey = 'gale_products_pkey',
  /** unique or primary key constraint on columns "product_id" */
  GaleProductsProductIdUnique = 'gale_products_product_id_unique'
}

/** input type for incrementing numeric columns in table "gale_products" */
export type Gale_Products_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "gale_products" */
export type Gale_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligibility_checked_at?: InputMaybe<Scalars['timestamptz']>;
  eligibility_message?: InputMaybe<Scalars['String']>;
  entity_type?: InputMaybe<Scalars['String']>;
  gale_product_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_eligible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Gale_Products_Max_Fields = {
  __typename?: 'gale_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  eligibility_checked_at?: Maybe<Scalars['timestamptz']>;
  eligibility_message?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  gale_product_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "gale_products" */
export type Gale_Products_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eligibility_checked_at?: InputMaybe<Order_By>;
  eligibility_message?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  gale_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gale_Products_Min_Fields = {
  __typename?: 'gale_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  eligibility_checked_at?: Maybe<Scalars['timestamptz']>;
  eligibility_message?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  gale_product_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "gale_products" */
export type Gale_Products_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eligibility_checked_at?: InputMaybe<Order_By>;
  eligibility_message?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  gale_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gale_products" */
export type Gale_Products_Mutation_Response = {
  __typename?: 'gale_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gale_Products>;
};

/** on_conflict condition type for table "gale_products" */
export type Gale_Products_On_Conflict = {
  constraint: Gale_Products_Constraint;
  update_columns?: Array<Gale_Products_Update_Column>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "gale_products". */
export type Gale_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  eligibility_checked_at?: InputMaybe<Order_By>;
  eligibility_message?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  gale_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_eligible?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gale_products */
export type Gale_Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "gale_products" */
export enum Gale_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EligibilityCheckedAt = 'eligibility_checked_at',
  /** column name */
  EligibilityMessage = 'eligibility_message',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  GaleProductId = 'gale_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsEligible = 'is_eligible',
  /** column name */
  Name = 'name',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "gale_products_aggregate_bool_exp_bool_and_arguments_columns" columns of table "gale_products" */
export enum Gale_Products_Select_Column_Gale_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsEligible = 'is_eligible'
}

/** select "gale_products_aggregate_bool_exp_bool_or_arguments_columns" columns of table "gale_products" */
export enum Gale_Products_Select_Column_Gale_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsEligible = 'is_eligible'
}

/** input type for updating data in table "gale_products" */
export type Gale_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligibility_checked_at?: InputMaybe<Scalars['timestamptz']>;
  eligibility_message?: InputMaybe<Scalars['String']>;
  entity_type?: InputMaybe<Scalars['String']>;
  gale_product_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_eligible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Gale_Products_Stddev_Fields = {
  __typename?: 'gale_products_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "gale_products" */
export type Gale_Products_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Gale_Products_Stddev_Pop_Fields = {
  __typename?: 'gale_products_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "gale_products" */
export type Gale_Products_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Gale_Products_Stddev_Samp_Fields = {
  __typename?: 'gale_products_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "gale_products" */
export type Gale_Products_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "gale_products" */
export type Gale_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gale_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gale_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  eligibility_checked_at?: InputMaybe<Scalars['timestamptz']>;
  eligibility_message?: InputMaybe<Scalars['String']>;
  entity_type?: InputMaybe<Scalars['String']>;
  gale_product_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_eligible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Gale_Products_Sum_Fields = {
  __typename?: 'gale_products_sum_fields';
  id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "gale_products" */
export type Gale_Products_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** update columns of table "gale_products" */
export enum Gale_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EligibilityCheckedAt = 'eligibility_checked_at',
  /** column name */
  EligibilityMessage = 'eligibility_message',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  GaleProductId = 'gale_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsEligible = 'is_eligible',
  /** column name */
  Name = 'name',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Gale_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gale_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gale_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gale_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gale_Products_Var_Pop_Fields = {
  __typename?: 'gale_products_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "gale_products" */
export type Gale_Products_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Gale_Products_Var_Samp_Fields = {
  __typename?: 'gale_products_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "gale_products" */
export type Gale_Products_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Gale_Products_Variance_Fields = {
  __typename?: 'gale_products_variance_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "gale_products" */
export type Gale_Products_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

export type GetFhirPatientMediaOutput = {
  __typename?: 'getFHIRPatientMediaOutput';
  media: Array<MediaOutput>;
  patientCodexId: Scalars['String'];
  total: Scalars['Int'];
};

export type GetFhirPatientOutput = {
  __typename?: 'getFHIRPatientOutput';
  users: Array<GetPatientOutput>;
};

export type Get_Appointment_Status_Counts_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']>;
  date_to?: InputMaybe<Scalars['timestamptz']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type Get_Order_Status_Counts_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']>;
  date_to?: InputMaybe<Scalars['timestamptz']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type Get_Payment_Stats_By_Day_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']>;
  date_to?: InputMaybe<Scalars['timestamptz']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type Get_Provider_Payouts_Args = {
  p_limit?: InputMaybe<Scalars['Int']>;
  p_offset?: InputMaybe<Scalars['Int']>;
  p_provider_id?: InputMaybe<Scalars['uuid']>;
};

export type Get_Test_Kit_Status_Counts_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']>;
  date_to?: InputMaybe<Scalars['timestamptz']>;
  labs?: InputMaybe<Scalars['_text']>;
  test_types?: InputMaybe<Scalars['_text']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Global configs */
export type Global_Configs = {
  __typename?: 'global_configs';
  created_at: Scalars['timestamptz'];
  name: Global_Configs_Names_Enum;
  updated_at: Scalars['timestamptz'];
  value: Scalars['jsonb'];
};


/** Global configs */
export type Global_ConfigsValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "global_configs" */
export type Global_Configs_Aggregate = {
  __typename?: 'global_configs_aggregate';
  aggregate?: Maybe<Global_Configs_Aggregate_Fields>;
  nodes: Array<Global_Configs>;
};

/** aggregate fields of "global_configs" */
export type Global_Configs_Aggregate_Fields = {
  __typename?: 'global_configs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Global_Configs_Max_Fields>;
  min?: Maybe<Global_Configs_Min_Fields>;
};


/** aggregate fields of "global_configs" */
export type Global_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Global_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Global_Configs_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "global_configs". All fields are combined with a logical 'AND'. */
export type Global_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Global_Configs_Bool_Exp>>;
  _not?: InputMaybe<Global_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Global_Configs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<Global_Configs_Names_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "global_configs" */
export enum Global_Configs_Constraint {
  /** unique or primary key constraint on columns "name" */
  GlobalConfigsPkey = 'global_configs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Global_Configs_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Global_Configs_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Global_Configs_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "global_configs" */
export type Global_Configs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Global_Configs_Names_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Global_Configs_Max_Fields = {
  __typename?: 'global_configs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Global_Configs_Min_Fields = {
  __typename?: 'global_configs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "global_configs" */
export type Global_Configs_Mutation_Response = {
  __typename?: 'global_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Global_Configs>;
};

/** Global configs names */
export type Global_Configs_Names = {
  __typename?: 'global_configs_names';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "global_configs_names" */
export type Global_Configs_Names_Aggregate = {
  __typename?: 'global_configs_names_aggregate';
  aggregate?: Maybe<Global_Configs_Names_Aggregate_Fields>;
  nodes: Array<Global_Configs_Names>;
};

/** aggregate fields of "global_configs_names" */
export type Global_Configs_Names_Aggregate_Fields = {
  __typename?: 'global_configs_names_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Global_Configs_Names_Max_Fields>;
  min?: Maybe<Global_Configs_Names_Min_Fields>;
};


/** aggregate fields of "global_configs_names" */
export type Global_Configs_Names_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Global_Configs_Names_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "global_configs_names". All fields are combined with a logical 'AND'. */
export type Global_Configs_Names_Bool_Exp = {
  _and?: InputMaybe<Array<Global_Configs_Names_Bool_Exp>>;
  _not?: InputMaybe<Global_Configs_Names_Bool_Exp>;
  _or?: InputMaybe<Array<Global_Configs_Names_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "global_configs_names" */
export enum Global_Configs_Names_Constraint {
  /** unique or primary key constraint on columns "value" */
  GlobalConfigsNamesPkey = 'global_configs_names_pkey'
}

export enum Global_Configs_Names_Enum {
  /** Disable the routes for the appointments section */
  AppointmentRoutesDisable = 'APPOINTMENT_ROUTES_DISABLE',
  /** Deactivate the barcode scanning feature for test kit registrations. */
  BarcodeScanningDisabled = 'BARCODE_SCANNING_DISABLED',
  /** Deactivates the Complete MyVisit Summary Modal */
  CompleteMyvisitSummaryModalDisabled = 'COMPLETE_MYVISIT_SUMMARY_MODAL_DISABLED',
  /** Enables sign up provider route */
  EnableSignUpProvider = 'ENABLE_SIGN_UP_PROVIDER',
  /** Combination of both values give a timer of 06:00 minutes. With an idle timer of 01:00 minute. Meaning that after one minute, the user will be prompted if it's still there. */
  InactivityModalOverallTimeoutVariable = 'INACTIVITY_MODAL_OVERALL_TIMEOUT_VARIABLE',
  /** Combination of both values give a timer of 06:00 minutes. With an idle timer of 01:00 minute. Meaning that after one minute, the user will be prompted if it's still there. */
  InactivityModalPromptBeforeIdleVariable = 'INACTIVITY_MODAL_PROMPT_BEFORE_IDLE_VARIABLE',
  /** Report status of whether the feature is enabled or not for Inactivity modal across the whole app. */
  InactivityModalStatus = 'INACTIVITY_MODAL_STATUS',
  /** Deactivate the make appointment screen. */
  MakeAppointmentDisabled = 'MAKE_APPOINTMENT_DISABLED',
  /** Deactivates the MyVisit Summary Modal */
  MyvisitSummaryModalDisabled = 'MYVISIT_SUMMARY_MODAL_DISABLED',
  /** If true, skintelligent result will be processed in a cloud function, if not it will be processed in the nest app */
  SkintelligentProcessInCloudFunction = 'SKINTELLIGENT_PROCESS_IN_CLOUD_FUNCTION',
  /** Enables / disables mechanism to logout user after closing the application and an elapsed time has passed. */
  UserLogoutBasedOnLastActivity = 'USER_LOGOUT_BASED_ON_LAST_ACTIVITY',
  /** Provides value for time limit of elapsed time before logging out an user that has closed the application. */
  UserLogoutBasedOnLastActivityTimeLimit = 'USER_LOGOUT_BASED_ON_LAST_ACTIVITY_TIME_LIMIT'
}

/** Boolean expression to compare columns of type "global_configs_names_enum". All fields are combined with logical 'AND'. */
export type Global_Configs_Names_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Global_Configs_Names_Enum>;
  _in?: InputMaybe<Array<Global_Configs_Names_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Global_Configs_Names_Enum>;
  _nin?: InputMaybe<Array<Global_Configs_Names_Enum>>;
};

/** input type for inserting data into table "global_configs_names" */
export type Global_Configs_Names_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Global_Configs_Names_Max_Fields = {
  __typename?: 'global_configs_names_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Global_Configs_Names_Min_Fields = {
  __typename?: 'global_configs_names_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "global_configs_names" */
export type Global_Configs_Names_Mutation_Response = {
  __typename?: 'global_configs_names_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Global_Configs_Names>;
};

/** on_conflict condition type for table "global_configs_names" */
export type Global_Configs_Names_On_Conflict = {
  constraint: Global_Configs_Names_Constraint;
  update_columns?: Array<Global_Configs_Names_Update_Column>;
  where?: InputMaybe<Global_Configs_Names_Bool_Exp>;
};

/** Ordering options when selecting data from "global_configs_names". */
export type Global_Configs_Names_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: global_configs_names */
export type Global_Configs_Names_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "global_configs_names" */
export enum Global_Configs_Names_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "global_configs_names" */
export type Global_Configs_Names_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "global_configs_names" */
export type Global_Configs_Names_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Configs_Names_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Configs_Names_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "global_configs_names" */
export enum Global_Configs_Names_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Global_Configs_Names_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Global_Configs_Names_Set_Input>;
  /** filter the rows which have to be updated */
  where: Global_Configs_Names_Bool_Exp;
};

/** on_conflict condition type for table "global_configs" */
export type Global_Configs_On_Conflict = {
  constraint: Global_Configs_Constraint;
  update_columns?: Array<Global_Configs_Update_Column>;
  where?: InputMaybe<Global_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "global_configs". */
export type Global_Configs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: global_configs */
export type Global_Configs_Pk_Columns_Input = {
  name: Global_Configs_Names_Enum;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Global_Configs_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "global_configs" */
export enum Global_Configs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "global_configs" */
export type Global_Configs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Global_Configs_Names_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "global_configs" */
export type Global_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Configs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Global_Configs_Names_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "global_configs" */
export enum Global_Configs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Global_Configs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Global_Configs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Global_Configs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Global_Configs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Global_Configs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Global_Configs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Global_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Global_Configs_Bool_Exp;
};

/** columns and relationships of "image_source_types" */
export type Image_Source_Types = {
  __typename?: 'image_source_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "image_source_types" */
export type Image_Source_Types_Aggregate = {
  __typename?: 'image_source_types_aggregate';
  aggregate?: Maybe<Image_Source_Types_Aggregate_Fields>;
  nodes: Array<Image_Source_Types>;
};

/** aggregate fields of "image_source_types" */
export type Image_Source_Types_Aggregate_Fields = {
  __typename?: 'image_source_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Image_Source_Types_Max_Fields>;
  min?: Maybe<Image_Source_Types_Min_Fields>;
};


/** aggregate fields of "image_source_types" */
export type Image_Source_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Image_Source_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "image_source_types". All fields are combined with a logical 'AND'. */
export type Image_Source_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Image_Source_Types_Bool_Exp>>;
  _not?: InputMaybe<Image_Source_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Image_Source_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "image_source_types" */
export enum Image_Source_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  ImageSourceTypesPkey = 'image_source_types_pkey'
}

export enum Image_Source_Types_Enum {
  Mobile = 'MOBILE',
  Pc = 'PC'
}

/** Boolean expression to compare columns of type "image_source_types_enum". All fields are combined with logical 'AND'. */
export type Image_Source_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Image_Source_Types_Enum>;
  _in?: InputMaybe<Array<Image_Source_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Image_Source_Types_Enum>;
  _nin?: InputMaybe<Array<Image_Source_Types_Enum>>;
};

/** input type for inserting data into table "image_source_types" */
export type Image_Source_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Image_Source_Types_Max_Fields = {
  __typename?: 'image_source_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Image_Source_Types_Min_Fields = {
  __typename?: 'image_source_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "image_source_types" */
export type Image_Source_Types_Mutation_Response = {
  __typename?: 'image_source_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Image_Source_Types>;
};

/** input type for inserting object relation for remote table "image_source_types" */
export type Image_Source_Types_Obj_Rel_Insert_Input = {
  data: Image_Source_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Image_Source_Types_On_Conflict>;
};

/** on_conflict condition type for table "image_source_types" */
export type Image_Source_Types_On_Conflict = {
  constraint: Image_Source_Types_Constraint;
  update_columns?: Array<Image_Source_Types_Update_Column>;
  where?: InputMaybe<Image_Source_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "image_source_types". */
export type Image_Source_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: image_source_types */
export type Image_Source_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "image_source_types" */
export enum Image_Source_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "image_source_types" */
export type Image_Source_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "image_source_types" */
export type Image_Source_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Image_Source_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_Source_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "image_source_types" */
export enum Image_Source_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Image_Source_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Image_Source_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Image_Source_Types_Bool_Exp;
};

/** columns and relationships of "in_mail_usage" */
export type In_Mail_Usage = {
  __typename?: 'in_mail_usage';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  used: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "in_mail_usage" */
export type In_Mail_Usage_Aggregate = {
  __typename?: 'in_mail_usage_aggregate';
  aggregate?: Maybe<In_Mail_Usage_Aggregate_Fields>;
  nodes: Array<In_Mail_Usage>;
};

export type In_Mail_Usage_Aggregate_Bool_Exp = {
  count?: InputMaybe<In_Mail_Usage_Aggregate_Bool_Exp_Count>;
};

export type In_Mail_Usage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<In_Mail_Usage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "in_mail_usage" */
export type In_Mail_Usage_Aggregate_Fields = {
  __typename?: 'in_mail_usage_aggregate_fields';
  avg?: Maybe<In_Mail_Usage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<In_Mail_Usage_Max_Fields>;
  min?: Maybe<In_Mail_Usage_Min_Fields>;
  stddev?: Maybe<In_Mail_Usage_Stddev_Fields>;
  stddev_pop?: Maybe<In_Mail_Usage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<In_Mail_Usage_Stddev_Samp_Fields>;
  sum?: Maybe<In_Mail_Usage_Sum_Fields>;
  var_pop?: Maybe<In_Mail_Usage_Var_Pop_Fields>;
  var_samp?: Maybe<In_Mail_Usage_Var_Samp_Fields>;
  variance?: Maybe<In_Mail_Usage_Variance_Fields>;
};


/** aggregate fields of "in_mail_usage" */
export type In_Mail_Usage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "in_mail_usage" */
export type In_Mail_Usage_Aggregate_Order_By = {
  avg?: InputMaybe<In_Mail_Usage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<In_Mail_Usage_Max_Order_By>;
  min?: InputMaybe<In_Mail_Usage_Min_Order_By>;
  stddev?: InputMaybe<In_Mail_Usage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<In_Mail_Usage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<In_Mail_Usage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<In_Mail_Usage_Sum_Order_By>;
  var_pop?: InputMaybe<In_Mail_Usage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<In_Mail_Usage_Var_Samp_Order_By>;
  variance?: InputMaybe<In_Mail_Usage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "in_mail_usage" */
export type In_Mail_Usage_Arr_Rel_Insert_Input = {
  data: Array<In_Mail_Usage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Mail_Usage_On_Conflict>;
};

/** aggregate avg on columns */
export type In_Mail_Usage_Avg_Fields = {
  __typename?: 'in_mail_usage_avg_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "in_mail_usage". All fields are combined with a logical 'AND'. */
export type In_Mail_Usage_Bool_Exp = {
  _and?: InputMaybe<Array<In_Mail_Usage_Bool_Exp>>;
  _not?: InputMaybe<In_Mail_Usage_Bool_Exp>;
  _or?: InputMaybe<Array<In_Mail_Usage_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  used?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_mail_usage" */
export enum In_Mail_Usage_Constraint {
  /** unique or primary key constraint on columns "id" */
  InMailUsageNewPkey = 'in_mail_usage_new_pkey',
  /** unique or primary key constraint on columns "user_id" */
  InMailUsageUserIdKey = 'in_mail_usage_user_id_key'
}

/** input type for incrementing numeric columns in table "in_mail_usage" */
export type In_Mail_Usage_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  used?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "in_mail_usage" */
export type In_Mail_Usage_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type In_Mail_Usage_Max_Fields = {
  __typename?: 'in_mail_usage_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type In_Mail_Usage_Min_Fields = {
  __typename?: 'in_mail_usage_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  used?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "in_mail_usage" */
export type In_Mail_Usage_Mutation_Response = {
  __typename?: 'in_mail_usage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Mail_Usage>;
};

/** on_conflict condition type for table "in_mail_usage" */
export type In_Mail_Usage_On_Conflict = {
  constraint: In_Mail_Usage_Constraint;
  update_columns?: Array<In_Mail_Usage_Update_Column>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};

/** Ordering options when selecting data from "in_mail_usage". */
export type In_Mail_Usage_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_mail_usage */
export type In_Mail_Usage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "in_mail_usage" */
export enum In_Mail_Usage_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Used = 'used',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "in_mail_usage" */
export type In_Mail_Usage_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type In_Mail_Usage_Stddev_Fields = {
  __typename?: 'in_mail_usage_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type In_Mail_Usage_Stddev_Pop_Fields = {
  __typename?: 'in_mail_usage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type In_Mail_Usage_Stddev_Samp_Fields = {
  __typename?: 'in_mail_usage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "in_mail_usage" */
export type In_Mail_Usage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Mail_Usage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Mail_Usage_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type In_Mail_Usage_Sum_Fields = {
  __typename?: 'in_mail_usage_sum_fields';
  id?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** update columns of table "in_mail_usage" */
export enum In_Mail_Usage_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Used = 'used',
  /** column name */
  UserId = 'user_id'
}

export type In_Mail_Usage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<In_Mail_Usage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Mail_Usage_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Mail_Usage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type In_Mail_Usage_Var_Pop_Fields = {
  __typename?: 'in_mail_usage_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type In_Mail_Usage_Var_Samp_Fields = {
  __typename?: 'in_mail_usage_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type In_Mail_Usage_Variance_Fields = {
  __typename?: 'in_mail_usage_variance_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "in_mail_usage" */
export type In_Mail_Usage_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "invitation_type". All fields are combined with logical 'AND'. */
export type Invitation_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['invitation_type']>;
  _gt?: InputMaybe<Scalars['invitation_type']>;
  _gte?: InputMaybe<Scalars['invitation_type']>;
  _in?: InputMaybe<Array<Scalars['invitation_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['invitation_type']>;
  _lte?: InputMaybe<Scalars['invitation_type']>;
  _neq?: InputMaybe<Scalars['invitation_type']>;
  _nin?: InputMaybe<Array<Scalars['invitation_type']>>;
};

/** columns and relationships of "invitations" */
export type Invitations = {
  __typename?: 'invitations';
  accepted_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  invited_at: Scalars['timestamptz'];
  invited_by: Scalars['uuid'];
  /** An object relationship */
  invited_by_user: Users;
  token?: Maybe<Scalars['String']>;
  type: Scalars['invitation_type'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "invitations" */
export type Invitations_Aggregate = {
  __typename?: 'invitations_aggregate';
  aggregate?: Maybe<Invitations_Aggregate_Fields>;
  nodes: Array<Invitations>;
};

export type Invitations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invitations_Aggregate_Bool_Exp_Count>;
};

export type Invitations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invitations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invitations" */
export type Invitations_Aggregate_Fields = {
  __typename?: 'invitations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invitations_Max_Fields>;
  min?: Maybe<Invitations_Min_Fields>;
};


/** aggregate fields of "invitations" */
export type Invitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invitations" */
export type Invitations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invitations_Max_Order_By>;
  min?: InputMaybe<Invitations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invitations" */
export type Invitations_Arr_Rel_Insert_Input = {
  data: Array<Invitations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invitations". All fields are combined with a logical 'AND'. */
export type Invitations_Bool_Exp = {
  _and?: InputMaybe<Array<Invitations_Bool_Exp>>;
  _not?: InputMaybe<Invitations_Bool_Exp>;
  _or?: InputMaybe<Array<Invitations_Bool_Exp>>;
  accepted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invited_by?: InputMaybe<Uuid_Comparison_Exp>;
  invited_by_user?: InputMaybe<Users_Bool_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Invitation_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitations" */
export enum Invitations_Constraint {
  /** unique or primary key constraint on columns "token" */
  AdminInvitationsTokenKey = 'admin_invitations_token_key',
  /** unique or primary key constraint on columns "user_id" */
  InvitationsPendingChildUserUidx = 'invitations_pending_child_user_uidx',
  /** unique or primary key constraint on columns "email" */
  InvitationsPendingEmailUidx = 'invitations_pending_email_uidx',
  /** unique or primary key constraint on columns "id" */
  InvitationsPkey = 'invitations_pkey'
}

/** input type for inserting data into table "invitations" */
export type Invitations_Insert_Input = {
  accepted_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_at?: InputMaybe<Scalars['timestamptz']>;
  invited_by?: InputMaybe<Scalars['uuid']>;
  invited_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['invitation_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Invitations_Max_Fields = {
  __typename?: 'invitations_max_fields';
  accepted_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_at?: Maybe<Scalars['timestamptz']>;
  invited_by?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['invitation_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invitations" */
export type Invitations_Max_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_at?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invitations_Min_Fields = {
  __typename?: 'invitations_min_fields';
  accepted_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_at?: Maybe<Scalars['timestamptz']>;
  invited_by?: Maybe<Scalars['uuid']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['invitation_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invitations" */
export type Invitations_Min_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_at?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invitations" */
export type Invitations_Mutation_Response = {
  __typename?: 'invitations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitations>;
};

/** on_conflict condition type for table "invitations" */
export type Invitations_On_Conflict = {
  constraint: Invitations_Constraint;
  update_columns?: Array<Invitations_Update_Column>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** Ordering options when selecting data from "invitations". */
export type Invitations_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_at?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  invited_by_user?: InputMaybe<Users_Order_By>;
  token?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invitations */
export type Invitations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "invitations" */
export enum Invitations_Select_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedAt = 'invited_at',
  /** column name */
  InvitedBy = 'invited_by',
  /** column name */
  Token = 'token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "invitations" */
export type Invitations_Set_Input = {
  accepted_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_at?: InputMaybe<Scalars['timestamptz']>;
  invited_by?: InputMaybe<Scalars['uuid']>;
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['invitation_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "invitations" */
export type Invitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitations_Stream_Cursor_Value_Input = {
  accepted_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_at?: InputMaybe<Scalars['timestamptz']>;
  invited_by?: InputMaybe<Scalars['uuid']>;
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['invitation_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "invitations" */
export enum Invitations_Update_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedAt = 'invited_at',
  /** column name */
  InvitedBy = 'invited_by',
  /** column name */
  Token = 'token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Invitations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invitations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitations_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "labs" */
export type Labs = {
  __typename?: 'labs';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "labs" */
export type Labs_Aggregate = {
  __typename?: 'labs_aggregate';
  aggregate?: Maybe<Labs_Aggregate_Fields>;
  nodes: Array<Labs>;
};

/** aggregate fields of "labs" */
export type Labs_Aggregate_Fields = {
  __typename?: 'labs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Labs_Max_Fields>;
  min?: Maybe<Labs_Min_Fields>;
};


/** aggregate fields of "labs" */
export type Labs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Labs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "labs". All fields are combined with a logical 'AND'. */
export type Labs_Bool_Exp = {
  _and?: InputMaybe<Array<Labs_Bool_Exp>>;
  _not?: InputMaybe<Labs_Bool_Exp>;
  _or?: InputMaybe<Array<Labs_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "labs" */
export enum Labs_Constraint {
  /** unique or primary key constraint on columns "value" */
  LabsPkey = 'labs_pkey'
}

export enum Labs_Enum {
  DiagnosticSolutions = 'DIAGNOSTIC_SOLUTIONS',
  DnaVisit = 'DNA_VISIT',
  MolecularLabs = 'MOLECULAR_LABS',
  Mosaic = 'MOSAIC',
  Zrt = 'ZRT'
}

/** Boolean expression to compare columns of type "labs_enum". All fields are combined with logical 'AND'. */
export type Labs_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Labs_Enum>;
  _in?: InputMaybe<Array<Labs_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Labs_Enum>;
  _nin?: InputMaybe<Array<Labs_Enum>>;
};

/** input type for inserting data into table "labs" */
export type Labs_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Labs_Max_Fields = {
  __typename?: 'labs_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Labs_Min_Fields = {
  __typename?: 'labs_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "labs" */
export type Labs_Mutation_Response = {
  __typename?: 'labs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Labs>;
};

/** on_conflict condition type for table "labs" */
export type Labs_On_Conflict = {
  constraint: Labs_Constraint;
  update_columns?: Array<Labs_Update_Column>;
  where?: InputMaybe<Labs_Bool_Exp>;
};

/** Ordering options when selecting data from "labs". */
export type Labs_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: labs */
export type Labs_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "labs" */
export enum Labs_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "labs" */
export type Labs_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "labs" */
export type Labs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Labs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Labs_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "labs" */
export enum Labs_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Labs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Labs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Labs_Bool_Exp;
};

/** columns and relationships of "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_User = {
  __typename?: 'latest_persona_inquiries_per_user';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inquiry_type?: Maybe<Scalars['Int']>;
  persona_event_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  persona_inquiries_user?: Maybe<Users>;
  persona_inquiry_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  persona_inquiry_status?: Maybe<Persona_Inquiry_Status>;
  /** An array relationship */
  persona_inquiry_status_histories: Array<Persona_Inquiries>;
  /** An aggregate relationship */
  persona_inquiry_status_histories_aggregate: Persona_Inquiries_Aggregate;
  status?: Maybe<Scalars['String']>;
  status_applied?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_UserPersona_Inquiry_Status_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiries_Order_By>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};


/** columns and relationships of "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_UserPersona_Inquiry_Status_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiries_Order_By>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};

/** aggregated selection of "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_User_Aggregate = {
  __typename?: 'latest_persona_inquiries_per_user_aggregate';
  aggregate?: Maybe<Latest_Persona_Inquiries_Per_User_Aggregate_Fields>;
  nodes: Array<Latest_Persona_Inquiries_Per_User>;
};

/** aggregate fields of "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_User_Aggregate_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_aggregate_fields';
  avg?: Maybe<Latest_Persona_Inquiries_Per_User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Latest_Persona_Inquiries_Per_User_Max_Fields>;
  min?: Maybe<Latest_Persona_Inquiries_Per_User_Min_Fields>;
  stddev?: Maybe<Latest_Persona_Inquiries_Per_User_Stddev_Fields>;
  stddev_pop?: Maybe<Latest_Persona_Inquiries_Per_User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Latest_Persona_Inquiries_Per_User_Stddev_Samp_Fields>;
  sum?: Maybe<Latest_Persona_Inquiries_Per_User_Sum_Fields>;
  var_pop?: Maybe<Latest_Persona_Inquiries_Per_User_Var_Pop_Fields>;
  var_samp?: Maybe<Latest_Persona_Inquiries_Per_User_Var_Samp_Fields>;
  variance?: Maybe<Latest_Persona_Inquiries_Per_User_Variance_Fields>;
};


/** aggregate fields of "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Latest_Persona_Inquiries_Per_User_Avg_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_avg_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "latest_persona_inquiries_per_user". All fields are combined with a logical 'AND'. */
export type Latest_Persona_Inquiries_Per_User_Bool_Exp = {
  _and?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Bool_Exp>>;
  _not?: InputMaybe<Latest_Persona_Inquiries_Per_User_Bool_Exp>;
  _or?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inquiry_type?: InputMaybe<Int_Comparison_Exp>;
  persona_event_id?: InputMaybe<String_Comparison_Exp>;
  persona_inquiries_user?: InputMaybe<Users_Bool_Exp>;
  persona_inquiry_id?: InputMaybe<String_Comparison_Exp>;
  persona_inquiry_status?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
  persona_inquiry_status_histories?: InputMaybe<Persona_Inquiries_Bool_Exp>;
  persona_inquiry_status_histories_aggregate?: InputMaybe<Persona_Inquiries_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_applied?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Latest_Persona_Inquiries_Per_User_Max_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inquiry_type?: Maybe<Scalars['Int']>;
  persona_event_id?: Maybe<Scalars['String']>;
  persona_inquiry_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Latest_Persona_Inquiries_Per_User_Min_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inquiry_type?: Maybe<Scalars['Int']>;
  persona_event_id?: Maybe<Scalars['String']>;
  persona_inquiry_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "latest_persona_inquiries_per_user". */
export type Latest_Persona_Inquiries_Per_User_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inquiry_type?: InputMaybe<Order_By>;
  persona_event_id?: InputMaybe<Order_By>;
  persona_inquiries_user?: InputMaybe<Users_Order_By>;
  persona_inquiry_id?: InputMaybe<Order_By>;
  persona_inquiry_status?: InputMaybe<Persona_Inquiry_Status_Order_By>;
  persona_inquiry_status_histories_aggregate?: InputMaybe<Persona_Inquiries_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  status_applied?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "latest_persona_inquiries_per_user" */
export enum Latest_Persona_Inquiries_Per_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryType = 'inquiry_type',
  /** column name */
  PersonaEventId = 'persona_event_id',
  /** column name */
  PersonaInquiryId = 'persona_inquiry_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusApplied = 'status_applied',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Latest_Persona_Inquiries_Per_User_Stddev_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_stddev_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Latest_Persona_Inquiries_Per_User_Stddev_Pop_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_stddev_pop_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Latest_Persona_Inquiries_Per_User_Stddev_Samp_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_stddev_samp_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "latest_persona_inquiries_per_user" */
export type Latest_Persona_Inquiries_Per_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latest_Persona_Inquiries_Per_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latest_Persona_Inquiries_Per_User_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  inquiry_type?: InputMaybe<Scalars['Int']>;
  persona_event_id?: InputMaybe<Scalars['String']>;
  persona_inquiry_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_applied?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Latest_Persona_Inquiries_Per_User_Sum_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_sum_fields';
  inquiry_type?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Latest_Persona_Inquiries_Per_User_Var_Pop_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_var_pop_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Latest_Persona_Inquiries_Per_User_Var_Samp_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_var_samp_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Latest_Persona_Inquiries_Per_User_Variance_Fields = {
  __typename?: 'latest_persona_inquiries_per_user_variance_fields';
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "legal_document_types" */
export type Legal_Document_Types = {
  __typename?: 'legal_document_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "legal_document_types" */
export type Legal_Document_Types_Aggregate = {
  __typename?: 'legal_document_types_aggregate';
  aggregate?: Maybe<Legal_Document_Types_Aggregate_Fields>;
  nodes: Array<Legal_Document_Types>;
};

/** aggregate fields of "legal_document_types" */
export type Legal_Document_Types_Aggregate_Fields = {
  __typename?: 'legal_document_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Legal_Document_Types_Max_Fields>;
  min?: Maybe<Legal_Document_Types_Min_Fields>;
};


/** aggregate fields of "legal_document_types" */
export type Legal_Document_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legal_Document_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "legal_document_types". All fields are combined with a logical 'AND'. */
export type Legal_Document_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Legal_Document_Types_Bool_Exp>>;
  _not?: InputMaybe<Legal_Document_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Legal_Document_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "legal_document_types" */
export enum Legal_Document_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  LegalDocumentTypesPkey = 'legal_document_types_pkey'
}

export enum Legal_Document_Types_Enum {
  /** BAA agreement */
  BaaAgreement = 'BAA_AGREEMENT',
  /** Cancellation policy */
  CancellationPolicy = 'CANCELLATION_POLICY',
  /** Consent to use and disclose substance use disorder records */
  ConsentToUseAndDiscloseSudRecords = 'CONSENT_TO_USE_AND_DISCLOSE_SUD_RECORDS',
  /** COPPA parental consent agreement */
  CoppaAgreement = 'COPPA_AGREEMENT',
  /** Consent agreement with DNA visit related to the supervision of laboratory tests. */
  DnaVisitRecordConsent = 'DNA_VISIT_RECORD_CONSENT',
  /** Consent agreement for general test records. */
  GeneralTestRecordConsent = 'GENERAL_TEST_RECORD_CONSENT',
  /** HIPPA agreement */
  HippaAgreement = 'HIPPA_AGREEMENT',
  /** Codex Labs' privacy policies for DECODE diagnostic test data, emphasizing consent-driven non-sharing, secure result handling, and user empowerment. */
  LabSampleResultsPrivacyStatement = 'LAB_SAMPLE_RESULTS_PRIVACY_STATEMENT',
  /** Notice of Privacy Practices of DECODE-ME */
  NoticeOfPrivacy = 'NOTICE_OF_PRIVACY',
  PrivacyPolicy = 'PRIVACY_POLICY',
  /** Provider data user agreement */
  ProviderDataUserAgreement = 'PROVIDER_DATA_USER_AGREEMENT',
  TermsOfService = 'TERMS_OF_SERVICE'
}

/** Boolean expression to compare columns of type "legal_document_types_enum". All fields are combined with logical 'AND'. */
export type Legal_Document_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Legal_Document_Types_Enum>;
  _in?: InputMaybe<Array<Legal_Document_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Legal_Document_Types_Enum>;
  _nin?: InputMaybe<Array<Legal_Document_Types_Enum>>;
};

/** input type for inserting data into table "legal_document_types" */
export type Legal_Document_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Legal_Document_Types_Max_Fields = {
  __typename?: 'legal_document_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Legal_Document_Types_Min_Fields = {
  __typename?: 'legal_document_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "legal_document_types" */
export type Legal_Document_Types_Mutation_Response = {
  __typename?: 'legal_document_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legal_Document_Types>;
};

/** on_conflict condition type for table "legal_document_types" */
export type Legal_Document_Types_On_Conflict = {
  constraint: Legal_Document_Types_Constraint;
  update_columns?: Array<Legal_Document_Types_Update_Column>;
  where?: InputMaybe<Legal_Document_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "legal_document_types". */
export type Legal_Document_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: legal_document_types */
export type Legal_Document_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "legal_document_types" */
export enum Legal_Document_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "legal_document_types" */
export type Legal_Document_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "legal_document_types" */
export type Legal_Document_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legal_Document_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legal_Document_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "legal_document_types" */
export enum Legal_Document_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Legal_Document_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legal_Document_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legal_Document_Types_Bool_Exp;
};

/** columns and relationships of "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications = {
  __typename?: 'legal_document_update_notifications';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  legal_document_type: Legal_Document_Types_Enum;
  notification_id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
  /** An object relationship */
  user_notification: User_Notifications;
};

/** aggregated selection of "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Aggregate = {
  __typename?: 'legal_document_update_notifications_aggregate';
  aggregate?: Maybe<Legal_Document_Update_Notifications_Aggregate_Fields>;
  nodes: Array<Legal_Document_Update_Notifications>;
};

export type Legal_Document_Update_Notifications_Aggregate_Bool_Exp = {
  count?: InputMaybe<Legal_Document_Update_Notifications_Aggregate_Bool_Exp_Count>;
};

export type Legal_Document_Update_Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Aggregate_Fields = {
  __typename?: 'legal_document_update_notifications_aggregate_fields';
  avg?: Maybe<Legal_Document_Update_Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Legal_Document_Update_Notifications_Max_Fields>;
  min?: Maybe<Legal_Document_Update_Notifications_Min_Fields>;
  stddev?: Maybe<Legal_Document_Update_Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Legal_Document_Update_Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legal_Document_Update_Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Legal_Document_Update_Notifications_Sum_Fields>;
  var_pop?: Maybe<Legal_Document_Update_Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Legal_Document_Update_Notifications_Var_Samp_Fields>;
  variance?: Maybe<Legal_Document_Update_Notifications_Variance_Fields>;
};


/** aggregate fields of "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Aggregate_Order_By = {
  avg?: InputMaybe<Legal_Document_Update_Notifications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Legal_Document_Update_Notifications_Max_Order_By>;
  min?: InputMaybe<Legal_Document_Update_Notifications_Min_Order_By>;
  stddev?: InputMaybe<Legal_Document_Update_Notifications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Legal_Document_Update_Notifications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Legal_Document_Update_Notifications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Legal_Document_Update_Notifications_Sum_Order_By>;
  var_pop?: InputMaybe<Legal_Document_Update_Notifications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Legal_Document_Update_Notifications_Var_Samp_Order_By>;
  variance?: InputMaybe<Legal_Document_Update_Notifications_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Arr_Rel_Insert_Input = {
  data: Array<Legal_Document_Update_Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Legal_Document_Update_Notifications_On_Conflict>;
};

/** aggregate avg on columns */
export type Legal_Document_Update_Notifications_Avg_Fields = {
  __typename?: 'legal_document_update_notifications_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "legal_document_update_notifications". All fields are combined with a logical 'AND'. */
export type Legal_Document_Update_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Legal_Document_Update_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Legal_Document_Update_Notifications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum_Comparison_Exp>;
  notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_notification?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** unique or primary key constraints on table "legal_document_update_notifications" */
export enum Legal_Document_Update_Notifications_Constraint {
  /** unique or primary key constraint on columns "user_id", "legal_document_type", "notification_id" */
  LegalDocumentUpdateNotificUserIdLegalDocumentTypeNKey = 'legal_document_update_notific_user_id_legal_document_type_n_key',
  /** unique or primary key constraint on columns "id" */
  LegalDocumentUpdateNotificationsPkey = 'legal_document_update_notifications_pkey'
}

/** input type for incrementing numeric columns in table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_notification?: InputMaybe<User_Notifications_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Legal_Document_Update_Notifications_Max_Fields = {
  __typename?: 'legal_document_update_notifications_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  notification_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Legal_Document_Update_Notifications_Min_Fields = {
  __typename?: 'legal_document_update_notifications_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  notification_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Mutation_Response = {
  __typename?: 'legal_document_update_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legal_Document_Update_Notifications>;
};

/** on_conflict condition type for table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_On_Conflict = {
  constraint: Legal_Document_Update_Notifications_Constraint;
  update_columns?: Array<Legal_Document_Update_Notifications_Update_Column>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "legal_document_update_notifications". */
export type Legal_Document_Update_Notifications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_document_type?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_notification?: InputMaybe<User_Notifications_Order_By>;
};

/** primary key columns input for table: legal_document_update_notifications */
export type Legal_Document_Update_Notifications_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "legal_document_update_notifications" */
export enum Legal_Document_Update_Notifications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LegalDocumentType = 'legal_document_type',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Legal_Document_Update_Notifications_Stddev_Fields = {
  __typename?: 'legal_document_update_notifications_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Legal_Document_Update_Notifications_Stddev_Pop_Fields = {
  __typename?: 'legal_document_update_notifications_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Legal_Document_Update_Notifications_Stddev_Samp_Fields = {
  __typename?: 'legal_document_update_notifications_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legal_Document_Update_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legal_Document_Update_Notifications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum>;
  notification_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Legal_Document_Update_Notifications_Sum_Fields = {
  __typename?: 'legal_document_update_notifications_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "legal_document_update_notifications" */
export enum Legal_Document_Update_Notifications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LegalDocumentType = 'legal_document_type',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  UserId = 'user_id'
}

export type Legal_Document_Update_Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legal_Document_Update_Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legal_Document_Update_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legal_Document_Update_Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legal_Document_Update_Notifications_Var_Pop_Fields = {
  __typename?: 'legal_document_update_notifications_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Legal_Document_Update_Notifications_Var_Samp_Fields = {
  __typename?: 'legal_document_update_notifications_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Legal_Document_Update_Notifications_Variance_Fields = {
  __typename?: 'legal_document_update_notifications_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "legal_document_update_notifications" */
export type Legal_Document_Update_Notifications_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "legal_documents" */
export type Legal_Documents = {
  __typename?: 'legal_documents';
  content_mobile: Scalars['String'];
  content_web: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_document_id: Scalars['bigint'];
  legal_document_type: Legal_Document_Types_Enum;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
  updated_by_user_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "legal_documents" */
export type Legal_Documents_Aggregate = {
  __typename?: 'legal_documents_aggregate';
  aggregate?: Maybe<Legal_Documents_Aggregate_Fields>;
  nodes: Array<Legal_Documents>;
};

/** aggregate fields of "legal_documents" */
export type Legal_Documents_Aggregate_Fields = {
  __typename?: 'legal_documents_aggregate_fields';
  avg?: Maybe<Legal_Documents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Legal_Documents_Max_Fields>;
  min?: Maybe<Legal_Documents_Min_Fields>;
  stddev?: Maybe<Legal_Documents_Stddev_Fields>;
  stddev_pop?: Maybe<Legal_Documents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legal_Documents_Stddev_Samp_Fields>;
  sum?: Maybe<Legal_Documents_Sum_Fields>;
  var_pop?: Maybe<Legal_Documents_Var_Pop_Fields>;
  var_samp?: Maybe<Legal_Documents_Var_Samp_Fields>;
  variance?: Maybe<Legal_Documents_Variance_Fields>;
};


/** aggregate fields of "legal_documents" */
export type Legal_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legal_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Legal_Documents_Avg_Fields = {
  __typename?: 'legal_documents_avg_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "legal_documents". All fields are combined with a logical 'AND'. */
export type Legal_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Legal_Documents_Bool_Exp>>;
  _not?: InputMaybe<Legal_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Legal_Documents_Bool_Exp>>;
  content_mobile?: InputMaybe<String_Comparison_Exp>;
  content_web?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  legal_document_id?: InputMaybe<Bigint_Comparison_Exp>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum_Comparison_Exp>;
  updated_by_user?: InputMaybe<Users_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "legal_documents" */
export enum Legal_Documents_Constraint {
  /** unique or primary key constraint on columns "legal_document_id" */
  LegalDocumentsPkey = 'legal_documents_pkey',
  /** unique or primary key constraint on columns "legal_document_type", "version" */
  LegalDocumentsTypeVersionKey = 'legal_documents_type_version_key'
}

/** input type for incrementing numeric columns in table "legal_documents" */
export type Legal_Documents_Inc_Input = {
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "legal_documents" */
export type Legal_Documents_Insert_Input = {
  content_mobile?: InputMaybe<Scalars['String']>;
  content_web?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum>;
  updated_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Legal_Documents_Max_Fields = {
  __typename?: 'legal_documents_max_fields';
  content_mobile?: Maybe<Scalars['String']>;
  content_web?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  updated_by_user_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Legal_Documents_Min_Fields = {
  __typename?: 'legal_documents_min_fields';
  content_mobile?: Maybe<Scalars['String']>;
  content_web?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  legal_document_id?: Maybe<Scalars['bigint']>;
  updated_by_user_id?: Maybe<Scalars['uuid']>;
  version?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "legal_documents" */
export type Legal_Documents_Mutation_Response = {
  __typename?: 'legal_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legal_Documents>;
};

/** input type for inserting object relation for remote table "legal_documents" */
export type Legal_Documents_Obj_Rel_Insert_Input = {
  data: Legal_Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Legal_Documents_On_Conflict>;
};

/** on_conflict condition type for table "legal_documents" */
export type Legal_Documents_On_Conflict = {
  constraint: Legal_Documents_Constraint;
  update_columns?: Array<Legal_Documents_Update_Column>;
  where?: InputMaybe<Legal_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "legal_documents". */
export type Legal_Documents_Order_By = {
  content_mobile?: InputMaybe<Order_By>;
  content_web?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  legal_document_id?: InputMaybe<Order_By>;
  legal_document_type?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<Users_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: legal_documents */
export type Legal_Documents_Pk_Columns_Input = {
  legal_document_id: Scalars['bigint'];
};

/** select columns of table "legal_documents" */
export enum Legal_Documents_Select_Column {
  /** column name */
  ContentMobile = 'content_mobile',
  /** column name */
  ContentWeb = 'content_web',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalDocumentId = 'legal_document_id',
  /** column name */
  LegalDocumentType = 'legal_document_type',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "legal_documents" */
export type Legal_Documents_Set_Input = {
  content_mobile?: InputMaybe<Scalars['String']>;
  content_web?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Legal_Documents_Stddev_Fields = {
  __typename?: 'legal_documents_stddev_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Legal_Documents_Stddev_Pop_Fields = {
  __typename?: 'legal_documents_stddev_pop_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Legal_Documents_Stddev_Samp_Fields = {
  __typename?: 'legal_documents_stddev_samp_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "legal_documents" */
export type Legal_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legal_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legal_Documents_Stream_Cursor_Value_Input = {
  content_mobile?: InputMaybe<Scalars['String']>;
  content_web?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  legal_document_id?: InputMaybe<Scalars['bigint']>;
  legal_document_type?: InputMaybe<Legal_Document_Types_Enum>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Legal_Documents_Sum_Fields = {
  __typename?: 'legal_documents_sum_fields';
  legal_document_id?: Maybe<Scalars['bigint']>;
  version?: Maybe<Scalars['Int']>;
};

/** update columns of table "legal_documents" */
export enum Legal_Documents_Update_Column {
  /** column name */
  ContentMobile = 'content_mobile',
  /** column name */
  ContentWeb = 'content_web',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LegalDocumentId = 'legal_document_id',
  /** column name */
  LegalDocumentType = 'legal_document_type',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  Version = 'version'
}

export type Legal_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legal_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legal_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legal_Documents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legal_Documents_Var_Pop_Fields = {
  __typename?: 'legal_documents_var_pop_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Legal_Documents_Var_Samp_Fields = {
  __typename?: 'legal_documents_var_samp_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Legal_Documents_Variance_Fields = {
  __typename?: 'legal_documents_variance_fields';
  legal_document_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** Medical schools */
export type Medical_Schools = {
  __typename?: 'medical_schools';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "medical_schools" */
export type Medical_Schools_Aggregate = {
  __typename?: 'medical_schools_aggregate';
  aggregate?: Maybe<Medical_Schools_Aggregate_Fields>;
  nodes: Array<Medical_Schools>;
};

/** aggregate fields of "medical_schools" */
export type Medical_Schools_Aggregate_Fields = {
  __typename?: 'medical_schools_aggregate_fields';
  avg?: Maybe<Medical_Schools_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Medical_Schools_Max_Fields>;
  min?: Maybe<Medical_Schools_Min_Fields>;
  stddev?: Maybe<Medical_Schools_Stddev_Fields>;
  stddev_pop?: Maybe<Medical_Schools_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Medical_Schools_Stddev_Samp_Fields>;
  sum?: Maybe<Medical_Schools_Sum_Fields>;
  var_pop?: Maybe<Medical_Schools_Var_Pop_Fields>;
  var_samp?: Maybe<Medical_Schools_Var_Samp_Fields>;
  variance?: Maybe<Medical_Schools_Variance_Fields>;
};


/** aggregate fields of "medical_schools" */
export type Medical_Schools_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Medical_Schools_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Medical_Schools_Avg_Fields = {
  __typename?: 'medical_schools_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "medical_schools". All fields are combined with a logical 'AND'. */
export type Medical_Schools_Bool_Exp = {
  _and?: InputMaybe<Array<Medical_Schools_Bool_Exp>>;
  _not?: InputMaybe<Medical_Schools_Bool_Exp>;
  _or?: InputMaybe<Array<Medical_Schools_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "medical_schools" */
export enum Medical_Schools_Constraint {
  /** unique or primary key constraint on columns "name" */
  MedicalSchoolsNameKey = 'medical_schools_name_key',
  /** unique or primary key constraint on columns "id" */
  MedicalSchoolsPkey = 'medical_schools_pkey'
}

/** input type for incrementing numeric columns in table "medical_schools" */
export type Medical_Schools_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "medical_schools" */
export type Medical_Schools_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Medical_Schools_Max_Fields = {
  __typename?: 'medical_schools_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Medical_Schools_Min_Fields = {
  __typename?: 'medical_schools_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "medical_schools" */
export type Medical_Schools_Mutation_Response = {
  __typename?: 'medical_schools_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Medical_Schools>;
};

/** on_conflict condition type for table "medical_schools" */
export type Medical_Schools_On_Conflict = {
  constraint: Medical_Schools_Constraint;
  update_columns?: Array<Medical_Schools_Update_Column>;
  where?: InputMaybe<Medical_Schools_Bool_Exp>;
};

/** Ordering options when selecting data from "medical_schools". */
export type Medical_Schools_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: medical_schools */
export type Medical_Schools_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "medical_schools" */
export enum Medical_Schools_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "medical_schools" */
export type Medical_Schools_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Medical_Schools_Stddev_Fields = {
  __typename?: 'medical_schools_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Medical_Schools_Stddev_Pop_Fields = {
  __typename?: 'medical_schools_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Medical_Schools_Stddev_Samp_Fields = {
  __typename?: 'medical_schools_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "medical_schools" */
export type Medical_Schools_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Medical_Schools_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Medical_Schools_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Medical_Schools_Sum_Fields = {
  __typename?: 'medical_schools_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "medical_schools" */
export enum Medical_Schools_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Medical_Schools_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Medical_Schools_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Medical_Schools_Set_Input>;
  /** filter the rows which have to be updated */
  where: Medical_Schools_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Medical_Schools_Var_Pop_Fields = {
  __typename?: 'medical_schools_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Medical_Schools_Var_Samp_Fields = {
  __typename?: 'medical_schools_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Medical_Schools_Variance_Fields = {
  __typename?: 'medical_schools_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "medications" */
export type Medications = {
  __typename?: 'medications';
  active: Scalars['Boolean'];
  active_ingred_unit?: Maybe<Scalars['String']>;
  active_numerator_strength?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  fda_sync_batch_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  product_id: Scalars['String'];
  product_ndc: Scalars['String'];
  proprietary_name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "medications" */
export type Medications_Aggregate = {
  __typename?: 'medications_aggregate';
  aggregate?: Maybe<Medications_Aggregate_Fields>;
  nodes: Array<Medications>;
};

/** aggregate fields of "medications" */
export type Medications_Aggregate_Fields = {
  __typename?: 'medications_aggregate_fields';
  avg?: Maybe<Medications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Medications_Max_Fields>;
  min?: Maybe<Medications_Min_Fields>;
  stddev?: Maybe<Medications_Stddev_Fields>;
  stddev_pop?: Maybe<Medications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Medications_Stddev_Samp_Fields>;
  sum?: Maybe<Medications_Sum_Fields>;
  var_pop?: Maybe<Medications_Var_Pop_Fields>;
  var_samp?: Maybe<Medications_Var_Samp_Fields>;
  variance?: Maybe<Medications_Variance_Fields>;
};


/** aggregate fields of "medications" */
export type Medications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Medications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Medications_Avg_Fields = {
  __typename?: 'medications_avg_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "medications". All fields are combined with a logical 'AND'. */
export type Medications_Bool_Exp = {
  _and?: InputMaybe<Array<Medications_Bool_Exp>>;
  _not?: InputMaybe<Medications_Bool_Exp>;
  _or?: InputMaybe<Array<Medications_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  active_ingred_unit?: InputMaybe<String_Comparison_Exp>;
  active_numerator_strength?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fda_sync_batch_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  product_ndc?: InputMaybe<String_Comparison_Exp>;
  proprietary_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "medications" */
export enum Medications_Constraint {
  /** unique or primary key constraint on columns "id" */
  MedicationsPkey = 'medications_pkey',
  /** unique or primary key constraint on columns "product_id" */
  MedicationsProductIdKey = 'medications_product_id_key'
}

/** input type for incrementing numeric columns in table "medications" */
export type Medications_Inc_Input = {
  active_numerator_strength?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "medications" */
export type Medications_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  active_ingred_unit?: InputMaybe<Scalars['String']>;
  active_numerator_strength?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fda_sync_batch_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['String']>;
  product_ndc?: InputMaybe<Scalars['String']>;
  proprietary_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Medications_Max_Fields = {
  __typename?: 'medications_max_fields';
  active_ingred_unit?: Maybe<Scalars['String']>;
  active_numerator_strength?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fda_sync_batch_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['String']>;
  product_ndc?: Maybe<Scalars['String']>;
  proprietary_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Medications_Min_Fields = {
  __typename?: 'medications_min_fields';
  active_ingred_unit?: Maybe<Scalars['String']>;
  active_numerator_strength?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fda_sync_batch_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['String']>;
  product_ndc?: Maybe<Scalars['String']>;
  proprietary_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "medications" */
export type Medications_Mutation_Response = {
  __typename?: 'medications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Medications>;
};

/** on_conflict condition type for table "medications" */
export type Medications_On_Conflict = {
  constraint: Medications_Constraint;
  update_columns?: Array<Medications_Update_Column>;
  where?: InputMaybe<Medications_Bool_Exp>;
};

/** Ordering options when selecting data from "medications". */
export type Medications_Order_By = {
  active?: InputMaybe<Order_By>;
  active_ingred_unit?: InputMaybe<Order_By>;
  active_numerator_strength?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fda_sync_batch_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_ndc?: InputMaybe<Order_By>;
  proprietary_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: medications */
export type Medications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "medications" */
export enum Medications_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ActiveIngredUnit = 'active_ingred_unit',
  /** column name */
  ActiveNumeratorStrength = 'active_numerator_strength',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FdaSyncBatchId = 'fda_sync_batch_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductNdc = 'product_ndc',
  /** column name */
  ProprietaryName = 'proprietary_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "medications" */
export type Medications_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  active_ingred_unit?: InputMaybe<Scalars['String']>;
  active_numerator_strength?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fda_sync_batch_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['String']>;
  product_ndc?: InputMaybe<Scalars['String']>;
  proprietary_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Medications_Stddev_Fields = {
  __typename?: 'medications_stddev_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Medications_Stddev_Pop_Fields = {
  __typename?: 'medications_stddev_pop_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Medications_Stddev_Samp_Fields = {
  __typename?: 'medications_stddev_samp_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "medications" */
export type Medications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Medications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Medications_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  active_ingred_unit?: InputMaybe<Scalars['String']>;
  active_numerator_strength?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fda_sync_batch_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['String']>;
  product_ndc?: InputMaybe<Scalars['String']>;
  proprietary_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Medications_Sum_Fields = {
  __typename?: 'medications_sum_fields';
  active_numerator_strength?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "medications_unique" */
export type Medications_Unique = {
  __typename?: 'medications_unique';
  active_ingred_unit?: Maybe<Scalars['String']>;
  active_numerator_strength?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['String']>;
  product_ndc?: Maybe<Scalars['String']>;
  proprietary_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "medications_unique" */
export type Medications_Unique_Aggregate = {
  __typename?: 'medications_unique_aggregate';
  aggregate?: Maybe<Medications_Unique_Aggregate_Fields>;
  nodes: Array<Medications_Unique>;
};

/** aggregate fields of "medications_unique" */
export type Medications_Unique_Aggregate_Fields = {
  __typename?: 'medications_unique_aggregate_fields';
  avg?: Maybe<Medications_Unique_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Medications_Unique_Max_Fields>;
  min?: Maybe<Medications_Unique_Min_Fields>;
  stddev?: Maybe<Medications_Unique_Stddev_Fields>;
  stddev_pop?: Maybe<Medications_Unique_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Medications_Unique_Stddev_Samp_Fields>;
  sum?: Maybe<Medications_Unique_Sum_Fields>;
  var_pop?: Maybe<Medications_Unique_Var_Pop_Fields>;
  var_samp?: Maybe<Medications_Unique_Var_Samp_Fields>;
  variance?: Maybe<Medications_Unique_Variance_Fields>;
};


/** aggregate fields of "medications_unique" */
export type Medications_Unique_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Medications_Unique_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Medications_Unique_Avg_Fields = {
  __typename?: 'medications_unique_avg_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "medications_unique". All fields are combined with a logical 'AND'. */
export type Medications_Unique_Bool_Exp = {
  _and?: InputMaybe<Array<Medications_Unique_Bool_Exp>>;
  _not?: InputMaybe<Medications_Unique_Bool_Exp>;
  _or?: InputMaybe<Array<Medications_Unique_Bool_Exp>>;
  active_ingred_unit?: InputMaybe<String_Comparison_Exp>;
  active_numerator_strength?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  product_ndc?: InputMaybe<String_Comparison_Exp>;
  proprietary_name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Medications_Unique_Max_Fields = {
  __typename?: 'medications_unique_max_fields';
  active_ingred_unit?: Maybe<Scalars['String']>;
  active_numerator_strength?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['String']>;
  product_ndc?: Maybe<Scalars['String']>;
  proprietary_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Medications_Unique_Min_Fields = {
  __typename?: 'medications_unique_min_fields';
  active_ingred_unit?: Maybe<Scalars['String']>;
  active_numerator_strength?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['String']>;
  product_ndc?: Maybe<Scalars['String']>;
  proprietary_name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "medications_unique". */
export type Medications_Unique_Order_By = {
  active_ingred_unit?: InputMaybe<Order_By>;
  active_numerator_strength?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_ndc?: InputMaybe<Order_By>;
  proprietary_name?: InputMaybe<Order_By>;
};

/** select columns of table "medications_unique" */
export enum Medications_Unique_Select_Column {
  /** column name */
  ActiveIngredUnit = 'active_ingred_unit',
  /** column name */
  ActiveNumeratorStrength = 'active_numerator_strength',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductNdc = 'product_ndc',
  /** column name */
  ProprietaryName = 'proprietary_name'
}

/** aggregate stddev on columns */
export type Medications_Unique_Stddev_Fields = {
  __typename?: 'medications_unique_stddev_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Medications_Unique_Stddev_Pop_Fields = {
  __typename?: 'medications_unique_stddev_pop_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Medications_Unique_Stddev_Samp_Fields = {
  __typename?: 'medications_unique_stddev_samp_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "medications_unique" */
export type Medications_Unique_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Medications_Unique_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Medications_Unique_Stream_Cursor_Value_Input = {
  active_ingred_unit?: InputMaybe<Scalars['String']>;
  active_numerator_strength?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['String']>;
  product_ndc?: InputMaybe<Scalars['String']>;
  proprietary_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Medications_Unique_Sum_Fields = {
  __typename?: 'medications_unique_sum_fields';
  active_numerator_strength?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Medications_Unique_Var_Pop_Fields = {
  __typename?: 'medications_unique_var_pop_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Medications_Unique_Var_Samp_Fields = {
  __typename?: 'medications_unique_var_samp_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Medications_Unique_Variance_Fields = {
  __typename?: 'medications_unique_variance_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** update columns of table "medications" */
export enum Medications_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ActiveIngredUnit = 'active_ingred_unit',
  /** column name */
  ActiveNumeratorStrength = 'active_numerator_strength',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FdaSyncBatchId = 'fda_sync_batch_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductNdc = 'product_ndc',
  /** column name */
  ProprietaryName = 'proprietary_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Medications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Medications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Medications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Medications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Medications_Var_Pop_Fields = {
  __typename?: 'medications_var_pop_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Medications_Var_Samp_Fields = {
  __typename?: 'medications_var_samp_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Medications_Variance_Fields = {
  __typename?: 'medications_variance_fields';
  active_numerator_strength?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "molecular_tests" */
export type Molecular_Tests = {
  __typename?: 'molecular_tests';
  created_at: Scalars['timestamptz'];
  errors?: Maybe<Scalars['jsonb']>;
  lob: Scalars['String'];
  /** An object relationship */
  molecular_tests_dnavisit_test_status: Dnavisit_Test_Statuses;
  order_id?: Maybe<Scalars['String']>;
  rejected_reason?: Maybe<Scalars['String']>;
  state: Dnavisit_Test_Statuses_Enum;
  swab_code?: Maybe<Scalars['String']>;
  test_id: Scalars['uuid'];
  /** An array relationship */
  test_kits_update_states_summary_logs: Array<Test_Kits_Update_States_Summary_Log>;
  /** An aggregate relationship */
  test_kits_update_states_summary_logs_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "molecular_tests" */
export type Molecular_TestsErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "molecular_tests" */
export type Molecular_TestsTest_Kits_Update_States_Summary_LogsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** columns and relationships of "molecular_tests" */
export type Molecular_TestsTest_Kits_Update_States_Summary_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};

/** aggregated selection of "molecular_tests" */
export type Molecular_Tests_Aggregate = {
  __typename?: 'molecular_tests_aggregate';
  aggregate?: Maybe<Molecular_Tests_Aggregate_Fields>;
  nodes: Array<Molecular_Tests>;
};

/** aggregate fields of "molecular_tests" */
export type Molecular_Tests_Aggregate_Fields = {
  __typename?: 'molecular_tests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Molecular_Tests_Max_Fields>;
  min?: Maybe<Molecular_Tests_Min_Fields>;
};


/** aggregate fields of "molecular_tests" */
export type Molecular_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Molecular_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Molecular_Tests_Append_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "molecular_tests". All fields are combined with a logical 'AND'. */
export type Molecular_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Molecular_Tests_Bool_Exp>>;
  _not?: InputMaybe<Molecular_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Molecular_Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  lob?: InputMaybe<String_Comparison_Exp>;
  molecular_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  rejected_reason?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
  swab_code?: InputMaybe<String_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "molecular_tests" */
export enum Molecular_Tests_Constraint {
  /** unique or primary key constraint on columns "test_id" */
  MolecularTestsPkey = 'molecular_tests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Molecular_Tests_Delete_At_Path_Input = {
  errors?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Molecular_Tests_Delete_Elem_Input = {
  errors?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Molecular_Tests_Delete_Key_Input = {
  errors?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "molecular_tests" */
export type Molecular_Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  lob?: InputMaybe<Scalars['String']>;
  molecular_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['String']>;
  rejected_reason?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swab_code?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Molecular_Tests_Max_Fields = {
  __typename?: 'molecular_tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  lob?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  rejected_reason?: Maybe<Scalars['String']>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Molecular_Tests_Min_Fields = {
  __typename?: 'molecular_tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  lob?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  rejected_reason?: Maybe<Scalars['String']>;
  swab_code?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "molecular_tests" */
export type Molecular_Tests_Mutation_Response = {
  __typename?: 'molecular_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Molecular_Tests>;
};

/** on_conflict condition type for table "molecular_tests" */
export type Molecular_Tests_On_Conflict = {
  constraint: Molecular_Tests_Constraint;
  update_columns?: Array<Molecular_Tests_Update_Column>;
  where?: InputMaybe<Molecular_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "molecular_tests". */
export type Molecular_Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  errors?: InputMaybe<Order_By>;
  lob?: InputMaybe<Order_By>;
  molecular_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Order_By>;
  order_id?: InputMaybe<Order_By>;
  rejected_reason?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  swab_code?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: molecular_tests */
export type Molecular_Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Molecular_Tests_Prepend_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "molecular_tests" */
export enum Molecular_Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  Lob = 'lob',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  RejectedReason = 'rejected_reason',
  /** column name */
  State = 'state',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "molecular_tests" */
export type Molecular_Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  lob?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  rejected_reason?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swab_code?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "molecular_tests" */
export type Molecular_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Molecular_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Molecular_Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  lob?: InputMaybe<Scalars['String']>;
  order_id?: InputMaybe<Scalars['String']>;
  rejected_reason?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swab_code?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "molecular_tests" */
export enum Molecular_Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  Lob = 'lob',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  RejectedReason = 'rejected_reason',
  /** column name */
  State = 'state',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Molecular_Tests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Molecular_Tests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Molecular_Tests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Molecular_Tests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Molecular_Tests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Molecular_Tests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Molecular_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Molecular_Tests_Bool_Exp;
};

/** Mosaic test results */
export type Mosaic_Tests = {
  __typename?: 'mosaic_tests';
  created_at: Scalars['timestamptz'];
  errors?: Maybe<Scalars['jsonb']>;
  /** Mosaic order ID */
  mosaic_order_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  mosaic_tests_dnavisit_test_status: Dnavisit_Test_Statuses;
  state: Dnavisit_Test_Statuses_Enum;
  swabcode?: Maybe<Scalars['String']>;
  test_id: Scalars['uuid'];
  /** An array relationship */
  test_kits_update_states_summary_logs: Array<Test_Kits_Update_States_Summary_Log>;
  /** An aggregate relationship */
  test_kits_update_states_summary_logs_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** Mosaic test results */
export type Mosaic_TestsErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Mosaic test results */
export type Mosaic_TestsTest_Kits_Update_States_Summary_LogsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** Mosaic test results */
export type Mosaic_TestsTest_Kits_Update_States_Summary_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};

/** aggregated selection of "mosaic_tests" */
export type Mosaic_Tests_Aggregate = {
  __typename?: 'mosaic_tests_aggregate';
  aggregate?: Maybe<Mosaic_Tests_Aggregate_Fields>;
  nodes: Array<Mosaic_Tests>;
};

/** aggregate fields of "mosaic_tests" */
export type Mosaic_Tests_Aggregate_Fields = {
  __typename?: 'mosaic_tests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Mosaic_Tests_Max_Fields>;
  min?: Maybe<Mosaic_Tests_Min_Fields>;
};


/** aggregate fields of "mosaic_tests" */
export type Mosaic_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mosaic_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mosaic_Tests_Append_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "mosaic_tests". All fields are combined with a logical 'AND'. */
export type Mosaic_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Mosaic_Tests_Bool_Exp>>;
  _not?: InputMaybe<Mosaic_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Mosaic_Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  mosaic_order_id?: InputMaybe<String_Comparison_Exp>;
  mosaic_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
  swabcode?: InputMaybe<String_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mosaic_tests" */
export enum Mosaic_Tests_Constraint {
  /** unique or primary key constraint on columns "test_id" */
  MosaicTestsPkey = 'mosaic_tests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mosaic_Tests_Delete_At_Path_Input = {
  errors?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mosaic_Tests_Delete_Elem_Input = {
  errors?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mosaic_Tests_Delete_Key_Input = {
  errors?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "mosaic_tests" */
export type Mosaic_Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  /** Mosaic order ID */
  mosaic_order_id?: InputMaybe<Scalars['String']>;
  mosaic_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Obj_Rel_Insert_Input>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swabcode?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Mosaic_Tests_Max_Fields = {
  __typename?: 'mosaic_tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Mosaic order ID */
  mosaic_order_id?: Maybe<Scalars['String']>;
  swabcode?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Mosaic_Tests_Min_Fields = {
  __typename?: 'mosaic_tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** Mosaic order ID */
  mosaic_order_id?: Maybe<Scalars['String']>;
  swabcode?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "mosaic_tests" */
export type Mosaic_Tests_Mutation_Response = {
  __typename?: 'mosaic_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mosaic_Tests>;
};

/** on_conflict condition type for table "mosaic_tests" */
export type Mosaic_Tests_On_Conflict = {
  constraint: Mosaic_Tests_Constraint;
  update_columns?: Array<Mosaic_Tests_Update_Column>;
  where?: InputMaybe<Mosaic_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "mosaic_tests". */
export type Mosaic_Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  errors?: InputMaybe<Order_By>;
  mosaic_order_id?: InputMaybe<Order_By>;
  mosaic_tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Order_By>;
  state?: InputMaybe<Order_By>;
  swabcode?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mosaic_tests */
export type Mosaic_Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mosaic_Tests_Prepend_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "mosaic_tests" */
export enum Mosaic_Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  MosaicOrderId = 'mosaic_order_id',
  /** column name */
  State = 'state',
  /** column name */
  Swabcode = 'swabcode',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mosaic_tests" */
export type Mosaic_Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  /** Mosaic order ID */
  mosaic_order_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swabcode?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "mosaic_tests" */
export type Mosaic_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mosaic_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mosaic_Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  /** Mosaic order ID */
  mosaic_order_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swabcode?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "mosaic_tests" */
export enum Mosaic_Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  MosaicOrderId = 'mosaic_order_id',
  /** column name */
  State = 'state',
  /** column name */
  Swabcode = 'swabcode',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mosaic_Tests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Mosaic_Tests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Mosaic_Tests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Mosaic_Tests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Mosaic_Tests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Mosaic_Tests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mosaic_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mosaic_Tests_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** account Deletion */
  AccountDeletion?: Maybe<HttpStatusOutput>;
  AddSwabCodes?: Maybe<AddSwabCodesOutput>;
  /** ConnectStripeAccount */
  ConnectStripeAccount?: Maybe<ConnectStripeAccountOutput>;
  /** createCalendarAndDefineRegularHours */
  CreateCalendarAndDefineRegularHours?: Maybe<UpdateCalendarRegularHoursResponse>;
  /** DisconnectStripeAccount */
  DisconnectStripeAccount?: Maybe<DisconnectStripeAccountOutput>;
  ExportProviderData?: Maybe<ExportUserDataOutput>;
  ExportUserData?: Maybe<ExportUserDataOutput>;
  /** generateCustomToken */
  GenerateCustomToken?: Maybe<SuccessfulGeneratedCustomToken>;
  /** Get Acuity Calendar information for Provider */
  GetAcuityCalendarInformation?: Maybe<AcuityCalendarResult>;
  /** GetEncounterSignUrlFromStorage */
  GetEncounterSignUrlFromStorage?: Maybe<SuccessGetSignUrlFormStorage>;
  /** Get latest DNA visit tests */
  GetLatestDnaVisitTests: Scalars['jsonb'];
  /** Get Persona session token to resume inquiry */
  GetPersonaSessionToken?: Maybe<GetPersonaSessionTokenResponse>;
  /** getSignUrlFormStorageByProviderForPatient */
  GetProviderPatientSignedUrl?: Maybe<SuccessGetSignUrlFormStorage>;
  /** getSignUrlFormStorage */
  GetSignUrlFormStorage?: Maybe<SuccessGetSignUrlFormStorage>;
  /** getSignUrlFromStorageByAdmin */
  GetSignUrlFromStorageByAdmin?: Maybe<SuccessGetSignUrlFormStorage>;
  /** Get Vonage archives */
  GetVonageArchives?: Maybe<SuccessfulGetVonageArchives>;
  /** get vonage session */
  GetVonageSession?: Maybe<SuccessGetVonageSession>;
  GetVonageSignUrlFormStorage?: Maybe<SuccessGetVonageSignUrlFormStorage>;
  /** registerAuthProvider */
  RegisterAuthProvider?: Maybe<HttpStatusOutput>;
  /** RegisterDiagnosticSolutionKit */
  RegisterDiagnosticSolutionTestKit?: Maybe<DiagnosticSolutionOutput>;
  RegisterDnaVitaminTestKit?: Maybe<DnaVitaminResponseOutput>;
  /** Register GoogleMeet */
  RegisterGoogleMeet?: Maybe<RegisterGoogleMeetOutput>;
  RegisterMosaicTestKit?: Maybe<MosaicResponseOutput>;
  /** register patch provider */
  RegisterPatchProvider?: Maybe<HttpStatusOutput>;
  /** Register provider acuity calendar information */
  RegisterProviderAcuityCalendarInformation?: Maybe<HttpStatusOutput>;
  /** Register Test Kit */
  RegisterTestKit?: Maybe<HttpStatusOutput>;
  /** Save DNA scanned data */
  SaveDnaScannedData?: Maybe<HttpStatusOutput>;
  /** SaveQuestionnaire */
  SaveQuestionnaire?: Maybe<HttpStatusOutput>;
  /** Signup delegated admin */
  SignupDelegatedAdmin?: Maybe<HttpStatusOutput>;
  /** Signup provider */
  SignupProvider?: Maybe<HttpStatusOutput>;
  /** user signup */
  SignupUser?: Maybe<HttpStatusOutput>;
  /** UpdateAvailabilityOverrides */
  UpdateAvailabilityOverrides?: Maybe<HttpStatusOutput>;
  /** UpdateCalendarRegularHours */
  UpdateCalendarRegularHours?: Maybe<UpdateCalendarRegularHoursResponse>;
  /** updateInAppNotifications */
  UpdateInAppNotification?: Maybe<HttpStatusOutput>;
  /** UpdateProfileNotification */
  UpdateProfileNotification?: Maybe<HttpStatusOutput>;
  /** updateProfilePicture */
  UpdateProfilePicture?: Maybe<SuccessfullUpdatedProfilePicture>;
  UpdateProvider?: Maybe<SuccessfulProviderUpdated>;
  /** UpdateProviderAccountSettings */
  UpdateProviderAccountSettings?: Maybe<HttpStatusOutput>;
  /** updateProviderProfilePicture */
  UpdateProviderProfilePicture?: Maybe<SuccessfullUpdatedProfilePicture>;
  /** UpdateQuestionnaire */
  UpdateQuestionnaire?: Maybe<HttpStatusOutput>;
  /** uploadCapturedImage */
  UploadCapturedImage?: Maybe<SuccessfulUploadedImage>;
  /** validateCustomToken */
  ValidateCustomToken?: Maybe<HttpStatusOutput>;
  /** Vonage captions start */
  VonageCaptionsStart?: Maybe<VonageLiveCaptions>;
  /** Vonage captions stop */
  VonageCaptionsStop?: Maybe<VonageLiveCaptions>;
  acceptChildAdultTransitionInvitation: HttpStatusOutput;
  acceptLegalDocument: HttpStatusOutput;
  acceptUserAgreement: HttpStatusOutput;
  acknowledgeAchievementUnlock: HttpStatusOutput;
  addMessageToAppointmentMessageList: Communication;
  addMessageToAppointmentMessageListByAppointmentCodexId: Communication;
  addServiceOfferings: PatchFhirProviderOutput;
  appendEncounterToFHIRAppointment: PatchAppointmentAndEncounterOutput;
  archiveOrder: HttpStatusOutput;
  attachPaymentMethod: PaymentMethodOutput;
  blockUser: HttpStatusOutput;
  cancelDraftQuestionnairesById: UpdateFhirQuestionnaireResponsesOutput;
  cancelFHIRAppointment: PatchFhirAppointmentOutput;
  cancelSubscription: HttpStatusOutput;
  closeAccount: HttpStatusOutput;
  closeProviderAccount: HttpStatusOutput;
  confirmProviderPatientAgreement: PatchFhirRequestBecomePatientOutput;
  createAppVersion: AppVersionOutput;
  createAppointmentMessageList: Communication;
  createAppointmentRequest: AppointmentRequestOutput;
  createBecomePatientRequest: PatchFhirRequestBecomePatientOutput;
  createCartProduct: CartProductOutput;
  createChildAdultTransitionInvitation: HttpStatusOutput;
  createDelegatedAdminInvitation: HttpStatusOutput;
  createFHIRAppointment: CreateFhirAppointmentOutput;
  createFHIRAppointmentForCurrentUser: CreateFhirAppointmentOutput;
  createFHIRDnaVisitTest: CreateFhirDnaVisitTestOutput;
  createFHIRMosaicTest: CreateFhirMosaicTestOutput;
  createFHIROfficeLocation: CreateFhirOfficeLocationOutput;
  createFHIROrganization: CreateFhirOrganizationOutput;
  createFHIRPatient: CreateFhirPatientOutput;
  createFHIRProvider: CreateFhirProviderOutput;
  createFHIRProviderRole: CreateFhirProviderRoleOutput;
  createFHIRZrtTest: CreateFhirZrtTestOutput;
  createOrder: GetPaymentLinkOutput;
  createProviderSetupIntent: SetupIntentOutput;
  createScheduledAppointment: CreateScheduleAppointmentOutput;
  createSubPatient: IdOutput;
  createSubscription: SubscriptionOutput;
  cronCheckAndUpdateOrdersDeliveryStatus: Scalars['Boolean'];
  deleteAppointmentRequest: HttpStatusOutput;
  deleteCartProduct: HttpStatusOutput;
  deleteDelegatedAdmin: HttpStatusOutput;
  deleteDeliveryAddress: HttpStatusOutput;
  deleteEducationCourse: HttpStatusOutput;
  deleteMediaFile: HttpStatusOutput;
  deletePaymentMethod: HttpStatusOutput;
  deleteProduct: HttpStatusOutput;
  deleteProvider: HttpStatusOutput;
  deleteRecommendationByRequestUserCodexId: HttpStatusOutput;
  deleteUserNotification: HttpStatusOutput;
  /** registerAuthProvider */
  deleteUserSession?: Maybe<HttpStatusOutput>;
  /** delete data from the table: "accepted_legal_documents" */
  delete_accepted_legal_documents?: Maybe<Accepted_Legal_Documents_Mutation_Response>;
  /** delete single row from the table: "accepted_legal_documents" */
  delete_accepted_legal_documents_by_pk?: Maybe<Accepted_Legal_Documents>;
  /** delete data from the table: "active_in_mails" */
  delete_active_in_mails?: Maybe<Active_In_Mails_Mutation_Response>;
  /** delete single row from the table: "active_in_mails" */
  delete_active_in_mails_by_pk?: Maybe<Active_In_Mails>;
  /** delete data from the table: "active_support_chats" */
  delete_active_support_chats?: Maybe<Active_Support_Chats_Mutation_Response>;
  /** delete single row from the table: "active_support_chats" */
  delete_active_support_chats_by_pk?: Maybe<Active_Support_Chats>;
  /** delete data from the table: "activity_events" */
  delete_activity_events?: Maybe<Activity_Events_Mutation_Response>;
  /** delete single row from the table: "activity_events" */
  delete_activity_events_by_pk?: Maybe<Activity_Events>;
  /** delete data from the table: "acuity_provider_calendar" */
  delete_acuity_provider_calendar?: Maybe<Acuity_Provider_Calendar_Mutation_Response>;
  /** delete single row from the table: "acuity_provider_calendar" */
  delete_acuity_provider_calendar_by_pk?: Maybe<Acuity_Provider_Calendar>;
  /** delete data from the table: "addresses" */
  delete_addresses?: Maybe<Addresses_Mutation_Response>;
  /** delete single row from the table: "addresses" */
  delete_addresses_by_pk?: Maybe<Addresses>;
  /** delete data from the table: "admin_permissions" */
  delete_admin_permissions?: Maybe<Admin_Permissions_Mutation_Response>;
  /** delete single row from the table: "admin_permissions" */
  delete_admin_permissions_by_pk?: Maybe<Admin_Permissions>;
  /** delete data from the table: "age_of_majority_rules" */
  delete_age_of_majority_rules?: Maybe<Age_Of_Majority_Rules_Mutation_Response>;
  /** delete single row from the table: "age_of_majority_rules" */
  delete_age_of_majority_rules_by_pk?: Maybe<Age_Of_Majority_Rules>;
  /** delete data from the table: "allergen_classes" */
  delete_allergen_classes?: Maybe<Allergen_Classes_Mutation_Response>;
  /** delete single row from the table: "allergen_classes" */
  delete_allergen_classes_by_pk?: Maybe<Allergen_Classes>;
  /** delete data from the table: "app_tours" */
  delete_app_tours?: Maybe<App_Tours_Mutation_Response>;
  /** delete single row from the table: "app_tours" */
  delete_app_tours_by_pk?: Maybe<App_Tours>;
  /** delete data from the table: "app_versions" */
  delete_app_versions?: Maybe<App_Versions_Mutation_Response>;
  /** delete single row from the table: "app_versions" */
  delete_app_versions_by_pk?: Maybe<App_Versions>;
  /** delete data from the table: "appointment_media_signals" */
  delete_appointment_media_signals?: Maybe<Appointment_Media_Signals_Mutation_Response>;
  /** delete single row from the table: "appointment_media_signals" */
  delete_appointment_media_signals_by_pk?: Maybe<Appointment_Media_Signals>;
  /** delete data from the table: "appointment_payments" */
  delete_appointment_payments?: Maybe<Appointment_Payments_Mutation_Response>;
  /** delete single row from the table: "appointment_payments" */
  delete_appointment_payments_by_pk?: Maybe<Appointment_Payments>;
  /** delete data from the table: "appointment_requests" */
  delete_appointment_requests?: Maybe<Appointment_Requests_Mutation_Response>;
  /** delete single row from the table: "appointment_requests" */
  delete_appointment_requests_by_pk?: Maybe<Appointment_Requests>;
  /** delete data from the table: "appointment_status_history" */
  delete_appointment_status_history?: Maybe<Appointment_Status_History_Mutation_Response>;
  /** delete single row from the table: "appointment_status_history" */
  delete_appointment_status_history_by_pk?: Maybe<Appointment_Status_History>;
  /** delete data from the table: "appointments" */
  delete_appointments?: Maybe<Appointments_Mutation_Response>;
  /** delete single row from the table: "appointments" */
  delete_appointments_by_pk?: Maybe<Appointments>;
  /** delete data from the table: "cart_products" */
  delete_cart_products?: Maybe<Cart_Products_Mutation_Response>;
  /** delete single row from the table: "cart_products" */
  delete_cart_products_by_pk?: Maybe<Cart_Products>;
  /** delete data from the table: "channel_signals" */
  delete_channel_signals?: Maybe<Channel_Signals_Mutation_Response>;
  /** delete single row from the table: "channel_signals" */
  delete_channel_signals_by_pk?: Maybe<Channel_Signals>;
  /** delete data from the table: "common_question_responses" */
  delete_common_question_responses?: Maybe<Common_Question_Responses_Mutation_Response>;
  /** delete single row from the table: "common_question_responses" */
  delete_common_question_responses_by_pk?: Maybe<Common_Question_Responses>;
  /** delete data from the table: "common_questions" */
  delete_common_questions?: Maybe<Common_Questions_Mutation_Response>;
  /** delete single row from the table: "common_questions" */
  delete_common_questions_by_pk?: Maybe<Common_Questions>;
  /** delete data from the table: "communication_channels" */
  delete_communication_channels?: Maybe<Communication_Channels_Mutation_Response>;
  /** delete single row from the table: "communication_channels" */
  delete_communication_channels_by_pk?: Maybe<Communication_Channels>;
  /** delete data from the table: "countries" */
  delete_countries?: Maybe<Countries_Mutation_Response>;
  /** delete single row from the table: "countries" */
  delete_countries_by_pk?: Maybe<Countries>;
  /** delete data from the table: "custom_auth_code" */
  delete_custom_auth_code?: Maybe<Custom_Auth_Code_Mutation_Response>;
  /** delete single row from the table: "custom_auth_code" */
  delete_custom_auth_code_by_pk?: Maybe<Custom_Auth_Code>;
  /** delete data from the table: "dea_license_schedules" */
  delete_dea_license_schedules?: Maybe<Dea_License_Schedules_Mutation_Response>;
  /** delete single row from the table: "dea_license_schedules" */
  delete_dea_license_schedules_by_pk?: Maybe<Dea_License_Schedules>;
  /** delete data from the table: "delivery_addresses" */
  delete_delivery_addresses?: Maybe<Delivery_Addresses_Mutation_Response>;
  /** delete single row from the table: "delivery_addresses" */
  delete_delivery_addresses_by_pk?: Maybe<Delivery_Addresses>;
  /** delete data from the table: "diagnostic_solution_tests" */
  delete_diagnostic_solution_tests?: Maybe<Diagnostic_Solution_Tests_Mutation_Response>;
  /** delete single row from the table: "diagnostic_solution_tests" */
  delete_diagnostic_solution_tests_by_pk?: Maybe<Diagnostic_Solution_Tests>;
  /** delete data from the table: "dnavisit_test_statuses" */
  delete_dnavisit_test_statuses?: Maybe<Dnavisit_Test_Statuses_Mutation_Response>;
  /** delete single row from the table: "dnavisit_test_statuses" */
  delete_dnavisit_test_statuses_by_pk?: Maybe<Dnavisit_Test_Statuses>;
  /** delete data from the table: "dnavisit_tests" */
  delete_dnavisit_tests?: Maybe<Dnavisit_Tests_Mutation_Response>;
  /** delete single row from the table: "dnavisit_tests" */
  delete_dnavisit_tests_by_pk?: Maybe<Dnavisit_Tests>;
  /** delete data from the table: "do_not_use_production_swab_codes" */
  delete_do_not_use_production_swab_codes?: Maybe<Do_Not_Use_Production_Swab_Codes_Mutation_Response>;
  /** delete single row from the table: "do_not_use_production_swab_codes" */
  delete_do_not_use_production_swab_codes_by_pk?: Maybe<Do_Not_Use_Production_Swab_Codes>;
  /** delete data from the table: "ecommerce_orders" */
  delete_ecommerce_orders?: Maybe<Ecommerce_Orders_Mutation_Response>;
  /** delete single row from the table: "ecommerce_orders" */
  delete_ecommerce_orders_by_pk?: Maybe<Ecommerce_Orders>;
  /** delete data from the table: "education_courses" */
  delete_education_courses?: Maybe<Education_Courses_Mutation_Response>;
  /** delete single row from the table: "education_courses" */
  delete_education_courses_by_pk?: Maybe<Education_Courses>;
  /** delete data from the table: "education_module_additional_materials" */
  delete_education_module_additional_materials?: Maybe<Education_Module_Additional_Materials_Mutation_Response>;
  /** delete single row from the table: "education_module_additional_materials" */
  delete_education_module_additional_materials_by_pk?: Maybe<Education_Module_Additional_Materials>;
  /** delete data from the table: "education_module_items" */
  delete_education_module_items?: Maybe<Education_Module_Items_Mutation_Response>;
  /** delete single row from the table: "education_module_items" */
  delete_education_module_items_by_pk?: Maybe<Education_Module_Items>;
  /** delete data from the table: "education_modules" */
  delete_education_modules?: Maybe<Education_Modules_Mutation_Response>;
  /** delete single row from the table: "education_modules" */
  delete_education_modules_by_pk?: Maybe<Education_Modules>;
  /** delete data from the table: "file_types" */
  delete_file_types?: Maybe<File_Types_Mutation_Response>;
  /** delete single row from the table: "file_types" */
  delete_file_types_by_pk?: Maybe<File_Types>;
  /** delete data from the table: "files" */
  delete_files?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: Maybe<Files>;
  /** delete data from the table: "fullscript_allergens" */
  delete_fullscript_allergens?: Maybe<Fullscript_Allergens_Mutation_Response>;
  /** delete single row from the table: "fullscript_allergens" */
  delete_fullscript_allergens_by_pk?: Maybe<Fullscript_Allergens>;
  /** delete data from the table: "fullscript_clinicians" */
  delete_fullscript_clinicians?: Maybe<Fullscript_Clinicians_Mutation_Response>;
  /** delete single row from the table: "fullscript_clinicians" */
  delete_fullscript_clinicians_by_pk?: Maybe<Fullscript_Clinicians>;
  /** delete data from the table: "gale_products" */
  delete_gale_products?: Maybe<Gale_Products_Mutation_Response>;
  /** delete single row from the table: "gale_products" */
  delete_gale_products_by_pk?: Maybe<Gale_Products>;
  /** delete data from the table: "global_configs" */
  delete_global_configs?: Maybe<Global_Configs_Mutation_Response>;
  /** delete single row from the table: "global_configs" */
  delete_global_configs_by_pk?: Maybe<Global_Configs>;
  /** delete data from the table: "global_configs_names" */
  delete_global_configs_names?: Maybe<Global_Configs_Names_Mutation_Response>;
  /** delete single row from the table: "global_configs_names" */
  delete_global_configs_names_by_pk?: Maybe<Global_Configs_Names>;
  /** delete data from the table: "image_source_types" */
  delete_image_source_types?: Maybe<Image_Source_Types_Mutation_Response>;
  /** delete single row from the table: "image_source_types" */
  delete_image_source_types_by_pk?: Maybe<Image_Source_Types>;
  /** delete data from the table: "in_mail_usage" */
  delete_in_mail_usage?: Maybe<In_Mail_Usage_Mutation_Response>;
  /** delete single row from the table: "in_mail_usage" */
  delete_in_mail_usage_by_pk?: Maybe<In_Mail_Usage>;
  /** delete data from the table: "invitations" */
  delete_invitations?: Maybe<Invitations_Mutation_Response>;
  /** delete single row from the table: "invitations" */
  delete_invitations_by_pk?: Maybe<Invitations>;
  /** delete data from the table: "labs" */
  delete_labs?: Maybe<Labs_Mutation_Response>;
  /** delete single row from the table: "labs" */
  delete_labs_by_pk?: Maybe<Labs>;
  /** delete data from the table: "legal_document_types" */
  delete_legal_document_types?: Maybe<Legal_Document_Types_Mutation_Response>;
  /** delete single row from the table: "legal_document_types" */
  delete_legal_document_types_by_pk?: Maybe<Legal_Document_Types>;
  /** delete data from the table: "legal_document_update_notifications" */
  delete_legal_document_update_notifications?: Maybe<Legal_Document_Update_Notifications_Mutation_Response>;
  /** delete single row from the table: "legal_document_update_notifications" */
  delete_legal_document_update_notifications_by_pk?: Maybe<Legal_Document_Update_Notifications>;
  /** delete data from the table: "legal_documents" */
  delete_legal_documents?: Maybe<Legal_Documents_Mutation_Response>;
  /** delete single row from the table: "legal_documents" */
  delete_legal_documents_by_pk?: Maybe<Legal_Documents>;
  /** delete data from the table: "medical_schools" */
  delete_medical_schools?: Maybe<Medical_Schools_Mutation_Response>;
  /** delete single row from the table: "medical_schools" */
  delete_medical_schools_by_pk?: Maybe<Medical_Schools>;
  /** delete data from the table: "medications" */
  delete_medications?: Maybe<Medications_Mutation_Response>;
  /** delete single row from the table: "medications" */
  delete_medications_by_pk?: Maybe<Medications>;
  /** delete data from the table: "molecular_tests" */
  delete_molecular_tests?: Maybe<Molecular_Tests_Mutation_Response>;
  /** delete single row from the table: "molecular_tests" */
  delete_molecular_tests_by_pk?: Maybe<Molecular_Tests>;
  /** delete data from the table: "mosaic_tests" */
  delete_mosaic_tests?: Maybe<Mosaic_Tests_Mutation_Response>;
  /** delete single row from the table: "mosaic_tests" */
  delete_mosaic_tests_by_pk?: Maybe<Mosaic_Tests>;
  /** delete data from the table: "nabla_notes" */
  delete_nabla_notes?: Maybe<Nabla_Notes_Mutation_Response>;
  /** delete single row from the table: "nabla_notes" */
  delete_nabla_notes_by_pk?: Maybe<Nabla_Notes>;
  /** delete data from the table: "npi_registry_data" */
  delete_npi_registry_data?: Maybe<Npi_Registry_Data_Mutation_Response>;
  /** delete single row from the table: "npi_registry_data" */
  delete_npi_registry_data_by_pk?: Maybe<Npi_Registry_Data>;
  /** delete data from the table: "order_payments" */
  delete_order_payments?: Maybe<Order_Payments_Mutation_Response>;
  /** delete single row from the table: "order_payments" */
  delete_order_payments_by_pk?: Maybe<Order_Payments>;
  /** delete data from the table: "order_products" */
  delete_order_products?: Maybe<Order_Products_Mutation_Response>;
  /** delete single row from the table: "order_products" */
  delete_order_products_by_pk?: Maybe<Order_Products>;
  /** delete data from the table: "order_status_history" */
  delete_order_status_history?: Maybe<Order_Status_History_Mutation_Response>;
  /** delete single row from the table: "order_status_history" */
  delete_order_status_history_by_pk?: Maybe<Order_Status_History>;
  /** delete data from the table: "orders" */
  delete_orders?: Maybe<Orders_Mutation_Response>;
  /** delete single row from the table: "orders" */
  delete_orders_by_pk?: Maybe<Orders>;
  /** delete data from the table: "orders_view" */
  delete_orders_view?: Maybe<Orders_View_Mutation_Response>;
  /** delete data from the table: "patient_achievement_events" */
  delete_patient_achievement_events?: Maybe<Patient_Achievement_Events_Mutation_Response>;
  /** delete single row from the table: "patient_achievement_events" */
  delete_patient_achievement_events_by_pk?: Maybe<Patient_Achievement_Events>;
  /** delete data from the table: "patient_achievement_progress" */
  delete_patient_achievement_progress?: Maybe<Patient_Achievement_Progress_Mutation_Response>;
  /** delete single row from the table: "patient_achievement_progress" */
  delete_patient_achievement_progress_by_pk?: Maybe<Patient_Achievement_Progress>;
  /** delete data from the table: "patient_achievement_unlocks" */
  delete_patient_achievement_unlocks?: Maybe<Patient_Achievement_Unlocks_Mutation_Response>;
  /** delete single row from the table: "patient_achievement_unlocks" */
  delete_patient_achievement_unlocks_by_pk?: Maybe<Patient_Achievement_Unlocks>;
  /** delete data from the table: "payment_transaction_orders" */
  delete_payment_transaction_orders?: Maybe<Payment_Transaction_Orders_Mutation_Response>;
  /** delete single row from the table: "payment_transaction_orders" */
  delete_payment_transaction_orders_by_pk?: Maybe<Payment_Transaction_Orders>;
  /** delete data from the table: "payment_transactions" */
  delete_payment_transactions?: Maybe<Payment_Transactions_Mutation_Response>;
  /** delete single row from the table: "payment_transactions" */
  delete_payment_transactions_by_pk?: Maybe<Payment_Transactions>;
  /** delete data from the table: "pending_patient_zrt" */
  delete_pending_patient_zrt?: Maybe<Pending_Patient_Zrt_Mutation_Response>;
  /** delete single row from the table: "pending_patient_zrt" */
  delete_pending_patient_zrt_by_pk?: Maybe<Pending_Patient_Zrt>;
  /** delete data from the table: "persona_inquiries" */
  delete_persona_inquiries?: Maybe<Persona_Inquiries_Mutation_Response>;
  /** delete single row from the table: "persona_inquiries" */
  delete_persona_inquiries_by_pk?: Maybe<Persona_Inquiries>;
  /** delete data from the table: "persona_inquiry_status" */
  delete_persona_inquiry_status?: Maybe<Persona_Inquiry_Status_Mutation_Response>;
  /** delete single row from the table: "persona_inquiry_status" */
  delete_persona_inquiry_status_by_pk?: Maybe<Persona_Inquiry_Status>;
  /** delete data from the table: "products" */
  delete_products?: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk?: Maybe<Products>;
  /** delete data from the table: "provider_billing" */
  delete_provider_billing?: Maybe<Provider_Billing_Mutation_Response>;
  /** delete single row from the table: "provider_billing" */
  delete_provider_billing_by_pk?: Maybe<Provider_Billing>;
  /** delete data from the table: "provider_dea_licenses" */
  delete_provider_dea_licenses?: Maybe<Provider_Dea_Licenses_Mutation_Response>;
  /** delete single row from the table: "provider_dea_licenses" */
  delete_provider_dea_licenses_by_pk?: Maybe<Provider_Dea_Licenses>;
  /** delete data from the table: "provider_payments" */
  delete_provider_payments?: Maybe<Provider_Payments_Mutation_Response>;
  /** delete single row from the table: "provider_payments" */
  delete_provider_payments_by_pk?: Maybe<Provider_Payments>;
  /** delete data from the table: "provider_payouts" */
  delete_provider_payouts?: Maybe<Provider_Payouts_Mutation_Response>;
  /** delete data from the table: "provider_state_licenses" */
  delete_provider_state_licenses?: Maybe<Provider_State_Licenses_Mutation_Response>;
  /** delete single row from the table: "provider_state_licenses" */
  delete_provider_state_licenses_by_pk?: Maybe<Provider_State_Licenses>;
  /** delete data from the table: "provider_unread_external_notification_counts" */
  delete_provider_unread_external_notification_counts?: Maybe<Provider_Unread_External_Notification_Counts_Mutation_Response>;
  /** delete single row from the table: "provider_unread_external_notification_counts" */
  delete_provider_unread_external_notification_counts_by_pk?: Maybe<Provider_Unread_External_Notification_Counts>;
  /** delete data from the table: "question_measurement_units" */
  delete_question_measurement_units?: Maybe<Question_Measurement_Units_Mutation_Response>;
  /** delete single row from the table: "question_measurement_units" */
  delete_question_measurement_units_by_pk?: Maybe<Question_Measurement_Units>;
  /** delete data from the table: "question_types" */
  delete_question_types?: Maybe<Question_Types_Mutation_Response>;
  /** delete single row from the table: "question_types" */
  delete_question_types_by_pk?: Maybe<Question_Types>;
  /** delete data from the table: "question_ui_control_helper_text_position" */
  delete_question_ui_control_helper_text_position?: Maybe<Question_Ui_Control_Helper_Text_Position_Mutation_Response>;
  /** delete single row from the table: "question_ui_control_helper_text_position" */
  delete_question_ui_control_helper_text_position_by_pk?: Maybe<Question_Ui_Control_Helper_Text_Position>;
  /** delete data from the table: "question_ui_control_types" */
  delete_question_ui_control_types?: Maybe<Question_Ui_Control_Types_Mutation_Response>;
  /** delete single row from the table: "question_ui_control_types" */
  delete_question_ui_control_types_by_pk?: Maybe<Question_Ui_Control_Types>;
  /** delete data from the table: "questionnaire_questions" */
  delete_questionnaire_questions?: Maybe<Questionnaire_Questions_Mutation_Response>;
  /** delete single row from the table: "questionnaire_questions" */
  delete_questionnaire_questions_by_pk?: Maybe<Questionnaire_Questions>;
  /** delete data from the table: "questionnaire_reminders" */
  delete_questionnaire_reminders?: Maybe<Questionnaire_Reminders_Mutation_Response>;
  /** delete single row from the table: "questionnaire_reminders" */
  delete_questionnaire_reminders_by_pk?: Maybe<Questionnaire_Reminders>;
  /** delete data from the table: "questionnaire_responses" */
  delete_questionnaire_responses?: Maybe<Questionnaire_Responses_Mutation_Response>;
  /** delete single row from the table: "questionnaire_responses" */
  delete_questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** delete data from the table: "questionnaires" */
  delete_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** delete single row from the table: "questionnaires" */
  delete_questionnaires_by_pk?: Maybe<Questionnaires>;
  /** delete data from the table: "questions" */
  delete_questions?: Maybe<Questions_Mutation_Response>;
  /** delete single row from the table: "questions" */
  delete_questions_by_pk?: Maybe<Questions>;
  /** delete data from the table: "recommendations" */
  delete_recommendations?: Maybe<Recommendations_Mutation_Response>;
  /** delete single row from the table: "recommendations" */
  delete_recommendations_by_pk?: Maybe<Recommendations>;
  /** delete data from the table: "shipmonk_sync_metadata" */
  delete_shipmonk_sync_metadata?: Maybe<Shipmonk_Sync_Metadata_Mutation_Response>;
  /** delete single row from the table: "shipmonk_sync_metadata" */
  delete_shipmonk_sync_metadata_by_pk?: Maybe<Shipmonk_Sync_Metadata>;
  /** delete data from the table: "skintelligent_tests" */
  delete_skintelligent_tests?: Maybe<Skintelligent_Tests_Mutation_Response>;
  /** delete single row from the table: "skintelligent_tests" */
  delete_skintelligent_tests_by_pk?: Maybe<Skintelligent_Tests>;
  /** delete data from the table: "stripe_billing_plans" */
  delete_stripe_billing_plans?: Maybe<Stripe_Billing_Plans_Mutation_Response>;
  /** delete single row from the table: "stripe_billing_plans" */
  delete_stripe_billing_plans_by_pk?: Maybe<Stripe_Billing_Plans>;
  /** delete data from the table: "stripe_customers" */
  delete_stripe_customers?: Maybe<Stripe_Customers_Mutation_Response>;
  /** delete single row from the table: "stripe_customers" */
  delete_stripe_customers_by_pk?: Maybe<Stripe_Customers>;
  /** delete data from the table: "stripe_payment_intents" */
  delete_stripe_payment_intents?: Maybe<Stripe_Payment_Intents_Mutation_Response>;
  /** delete single row from the table: "stripe_payment_intents" */
  delete_stripe_payment_intents_by_pk?: Maybe<Stripe_Payment_Intents>;
  /** delete data from the table: "stripe_payment_methods" */
  delete_stripe_payment_methods?: Maybe<Stripe_Payment_Methods_Mutation_Response>;
  /** delete single row from the table: "stripe_payment_methods" */
  delete_stripe_payment_methods_by_pk?: Maybe<Stripe_Payment_Methods>;
  /** delete data from the table: "stripe_subscriptions" */
  delete_stripe_subscriptions?: Maybe<Stripe_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "stripe_subscriptions" */
  delete_stripe_subscriptions_by_pk?: Maybe<Stripe_Subscriptions>;
  /** delete data from the table: "stripe_transaction" */
  delete_stripe_transaction?: Maybe<Stripe_Transaction_Mutation_Response>;
  /** delete single row from the table: "stripe_transaction" */
  delete_stripe_transaction_by_pk?: Maybe<Stripe_Transaction>;
  /** delete data from the table: "support_chat_usage" */
  delete_support_chat_usage?: Maybe<Support_Chat_Usage_Mutation_Response>;
  /** delete single row from the table: "support_chat_usage" */
  delete_support_chat_usage_by_pk?: Maybe<Support_Chat_Usage>;
  /** delete data from the table: "swab_code_statuses" */
  delete_swab_code_statuses?: Maybe<Swab_Code_Statuses_Mutation_Response>;
  /** delete single row from the table: "swab_code_statuses" */
  delete_swab_code_statuses_by_pk?: Maybe<Swab_Code_Statuses>;
  /** delete data from the table: "swab_codes" */
  delete_swab_codes?: Maybe<Swab_Codes_Mutation_Response>;
  /** delete single row from the table: "swab_codes" */
  delete_swab_codes_by_pk?: Maybe<Swab_Codes>;
  /** delete data from the table: "swab_usage_type" */
  delete_swab_usage_type?: Maybe<Swab_Usage_Type_Mutation_Response>;
  /** delete single row from the table: "swab_usage_type" */
  delete_swab_usage_type_by_pk?: Maybe<Swab_Usage_Type>;
  /** delete data from the table: "test_definitions" */
  delete_test_definitions?: Maybe<Test_Definitions_Mutation_Response>;
  /** delete single row from the table: "test_definitions" */
  delete_test_definitions_by_pk?: Maybe<Test_Definitions>;
  /** delete data from the table: "test_e_prescribe_npis" */
  delete_test_e_prescribe_npis?: Maybe<Test_E_Prescribe_Npis_Mutation_Response>;
  /** delete single row from the table: "test_e_prescribe_npis" */
  delete_test_e_prescribe_npis_by_pk?: Maybe<Test_E_Prescribe_Npis>;
  /** delete data from the table: "test_kits_update_states_summary_log" */
  delete_test_kits_update_states_summary_log?: Maybe<Test_Kits_Update_States_Summary_Log_Mutation_Response>;
  /** delete single row from the table: "test_kits_update_states_summary_log" */
  delete_test_kits_update_states_summary_log_by_pk?: Maybe<Test_Kits_Update_States_Summary_Log>;
  /** delete data from the table: "test_types" */
  delete_test_types?: Maybe<Test_Types_Mutation_Response>;
  /** delete single row from the table: "test_types" */
  delete_test_types_by_pk?: Maybe<Test_Types>;
  /** delete data from the table: "tests" */
  delete_tests?: Maybe<Tests_Mutation_Response>;
  /** delete single row from the table: "tests" */
  delete_tests_by_pk?: Maybe<Tests>;
  /** delete data from the table: "text_addresses" */
  delete_text_addresses?: Maybe<Text_Addresses_Mutation_Response>;
  /** delete single row from the table: "text_addresses" */
  delete_text_addresses_by_pk?: Maybe<Text_Addresses>;
  /** delete data from the table: "unauthenticated_questionnaire_questions" */
  delete_unauthenticated_questionnaire_questions?: Maybe<Unauthenticated_Questionnaire_Questions_Mutation_Response>;
  /** delete single row from the table: "unauthenticated_questionnaire_questions" */
  delete_unauthenticated_questionnaire_questions_by_pk?: Maybe<Unauthenticated_Questionnaire_Questions>;
  /** delete data from the table: "unauthenticated_questionnaires" */
  delete_unauthenticated_questionnaires?: Maybe<Unauthenticated_Questionnaires_Mutation_Response>;
  /** delete single row from the table: "unauthenticated_questionnaires" */
  delete_unauthenticated_questionnaires_by_pk?: Maybe<Unauthenticated_Questionnaires>;
  /** delete data from the table: "unauthenticated_questions" */
  delete_unauthenticated_questions?: Maybe<Unauthenticated_Questions_Mutation_Response>;
  /** delete single row from the table: "unauthenticated_questions" */
  delete_unauthenticated_questions_by_pk?: Maybe<Unauthenticated_Questions>;
  /** delete data from the table: "universities" */
  delete_universities?: Maybe<Universities_Mutation_Response>;
  /** delete single row from the table: "universities" */
  delete_universities_by_pk?: Maybe<Universities>;
  /** delete data from the table: "used_test_e_prescribe_licenses" */
  delete_used_test_e_prescribe_licenses?: Maybe<Used_Test_E_Prescribe_Licenses_Mutation_Response>;
  /** delete single row from the table: "used_test_e_prescribe_licenses" */
  delete_used_test_e_prescribe_licenses_by_pk?: Maybe<Used_Test_E_Prescribe_Licenses>;
  /** delete data from the table: "user_addresses" */
  delete_user_addresses?: Maybe<User_Addresses_Mutation_Response>;
  /** delete single row from the table: "user_addresses" */
  delete_user_addresses_by_pk?: Maybe<User_Addresses>;
  /** delete data from the table: "user_agreements" */
  delete_user_agreements?: Maybe<User_Agreements_Mutation_Response>;
  /** delete single row from the table: "user_agreements" */
  delete_user_agreements_by_pk?: Maybe<User_Agreements>;
  /** delete data from the table: "user_auth_provider_types" */
  delete_user_auth_provider_types?: Maybe<User_Auth_Provider_Types_Mutation_Response>;
  /** delete single row from the table: "user_auth_provider_types" */
  delete_user_auth_provider_types_by_pk?: Maybe<User_Auth_Provider_Types>;
  /** delete data from the table: "user_auth_providers" */
  delete_user_auth_providers?: Maybe<User_Auth_Providers_Mutation_Response>;
  /** delete single row from the table: "user_auth_providers" */
  delete_user_auth_providers_by_pk?: Maybe<User_Auth_Providers>;
  /** delete data from the table: "user_auth_tokens" */
  delete_user_auth_tokens?: Maybe<User_Auth_Tokens_Mutation_Response>;
  /** delete single row from the table: "user_auth_tokens" */
  delete_user_auth_tokens_by_pk?: Maybe<User_Auth_Tokens>;
  /** delete data from the table: "user_communication_deliveries" */
  delete_user_communication_deliveries?: Maybe<User_Communication_Deliveries_Mutation_Response>;
  /** delete single row from the table: "user_communication_deliveries" */
  delete_user_communication_deliveries_by_pk?: Maybe<User_Communication_Deliveries>;
  /** delete data from the table: "user_communications" */
  delete_user_communications?: Maybe<User_Communications_Mutation_Response>;
  /** delete single row from the table: "user_communications" */
  delete_user_communications_by_pk?: Maybe<User_Communications>;
  /** delete data from the table: "user_indicators" */
  delete_user_indicators?: Maybe<User_Indicators_Mutation_Response>;
  /** delete single row from the table: "user_indicators" */
  delete_user_indicators_by_pk?: Maybe<User_Indicators>;
  /** delete data from the table: "user_notification_status" */
  delete_user_notification_status?: Maybe<User_Notification_Status_Mutation_Response>;
  /** delete single row from the table: "user_notification_status" */
  delete_user_notification_status_by_pk?: Maybe<User_Notification_Status>;
  /** delete data from the table: "user_notifications" */
  delete_user_notifications?: Maybe<User_Notifications_Mutation_Response>;
  /** delete single row from the table: "user_notifications" */
  delete_user_notifications_by_pk?: Maybe<User_Notifications>;
  /** delete data from the table: "user_push_tokens" */
  delete_user_push_tokens?: Maybe<User_Push_Tokens_Mutation_Response>;
  /** delete single row from the table: "user_push_tokens" */
  delete_user_push_tokens_by_pk?: Maybe<User_Push_Tokens>;
  /** delete data from the table: "user_scanned_data" */
  delete_user_scanned_data?: Maybe<User_Scanned_Data_Mutation_Response>;
  /** delete single row from the table: "user_scanned_data" */
  delete_user_scanned_data_by_pk?: Maybe<User_Scanned_Data>;
  /** delete data from the table: "user_settings" */
  delete_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** delete single row from the table: "user_settings" */
  delete_user_settings_by_pk?: Maybe<User_Settings>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "vonage_appointment" */
  delete_vonage_appointment?: Maybe<Vonage_Appointment_Mutation_Response>;
  /** delete single row from the table: "vonage_appointment" */
  delete_vonage_appointment_by_pk?: Maybe<Vonage_Appointment>;
  /** delete data from the table: "zrt_tests" */
  delete_zrt_tests?: Maybe<Zrt_Tests_Mutation_Response>;
  /** delete single row from the table: "zrt_tests" */
  delete_zrt_tests_by_pk?: Maybe<Zrt_Tests>;
  dismissSkinTreatmentBanner: GetPatientOutput;
  ePrescribeJwt: EPrescribeIframeJwtOutput;
  ensureAppointmentSummaryPdf: AppointmentSummaryPdfOutput;
  finishAppTour: HttpStatusOutput;
  fullscriptDependentMap: FullscriptOperationResult;
  getDnaTestBySwabCodeIDWithNoErrors: DnaValidTestBySwabCode;
  insertFHIRQuestionnaireResponse: CreateFhirQuestionnaireResponsesOutput;
  /** insert data into the table: "accepted_legal_documents" */
  insert_accepted_legal_documents?: Maybe<Accepted_Legal_Documents_Mutation_Response>;
  /** insert a single row into the table: "accepted_legal_documents" */
  insert_accepted_legal_documents_one?: Maybe<Accepted_Legal_Documents>;
  /** insert data into the table: "active_in_mails" */
  insert_active_in_mails?: Maybe<Active_In_Mails_Mutation_Response>;
  /** insert a single row into the table: "active_in_mails" */
  insert_active_in_mails_one?: Maybe<Active_In_Mails>;
  /** insert data into the table: "active_support_chats" */
  insert_active_support_chats?: Maybe<Active_Support_Chats_Mutation_Response>;
  /** insert a single row into the table: "active_support_chats" */
  insert_active_support_chats_one?: Maybe<Active_Support_Chats>;
  /** insert data into the table: "activity_events" */
  insert_activity_events?: Maybe<Activity_Events_Mutation_Response>;
  /** insert a single row into the table: "activity_events" */
  insert_activity_events_one?: Maybe<Activity_Events>;
  /** insert data into the table: "acuity_provider_calendar" */
  insert_acuity_provider_calendar?: Maybe<Acuity_Provider_Calendar_Mutation_Response>;
  /** insert a single row into the table: "acuity_provider_calendar" */
  insert_acuity_provider_calendar_one?: Maybe<Acuity_Provider_Calendar>;
  /** insert data into the table: "addresses" */
  insert_addresses?: Maybe<Addresses_Mutation_Response>;
  /** insert a single row into the table: "addresses" */
  insert_addresses_one?: Maybe<Addresses>;
  /** insert data into the table: "admin_permissions" */
  insert_admin_permissions?: Maybe<Admin_Permissions_Mutation_Response>;
  /** insert a single row into the table: "admin_permissions" */
  insert_admin_permissions_one?: Maybe<Admin_Permissions>;
  /** insert data into the table: "age_of_majority_rules" */
  insert_age_of_majority_rules?: Maybe<Age_Of_Majority_Rules_Mutation_Response>;
  /** insert a single row into the table: "age_of_majority_rules" */
  insert_age_of_majority_rules_one?: Maybe<Age_Of_Majority_Rules>;
  /** insert data into the table: "allergen_classes" */
  insert_allergen_classes?: Maybe<Allergen_Classes_Mutation_Response>;
  /** insert a single row into the table: "allergen_classes" */
  insert_allergen_classes_one?: Maybe<Allergen_Classes>;
  /** insert data into the table: "app_tours" */
  insert_app_tours?: Maybe<App_Tours_Mutation_Response>;
  /** insert a single row into the table: "app_tours" */
  insert_app_tours_one?: Maybe<App_Tours>;
  /** insert data into the table: "app_versions" */
  insert_app_versions?: Maybe<App_Versions_Mutation_Response>;
  /** insert a single row into the table: "app_versions" */
  insert_app_versions_one?: Maybe<App_Versions>;
  /** insert data into the table: "appointment_media_signals" */
  insert_appointment_media_signals?: Maybe<Appointment_Media_Signals_Mutation_Response>;
  /** insert a single row into the table: "appointment_media_signals" */
  insert_appointment_media_signals_one?: Maybe<Appointment_Media_Signals>;
  /** insert data into the table: "appointment_payments" */
  insert_appointment_payments?: Maybe<Appointment_Payments_Mutation_Response>;
  /** insert a single row into the table: "appointment_payments" */
  insert_appointment_payments_one?: Maybe<Appointment_Payments>;
  /** insert data into the table: "appointment_requests" */
  insert_appointment_requests?: Maybe<Appointment_Requests_Mutation_Response>;
  /** insert a single row into the table: "appointment_requests" */
  insert_appointment_requests_one?: Maybe<Appointment_Requests>;
  /** insert data into the table: "appointment_status_history" */
  insert_appointment_status_history?: Maybe<Appointment_Status_History_Mutation_Response>;
  /** insert a single row into the table: "appointment_status_history" */
  insert_appointment_status_history_one?: Maybe<Appointment_Status_History>;
  /** insert data into the table: "appointments" */
  insert_appointments?: Maybe<Appointments_Mutation_Response>;
  /** insert a single row into the table: "appointments" */
  insert_appointments_one?: Maybe<Appointments>;
  /** insert data into the table: "cart_products" */
  insert_cart_products?: Maybe<Cart_Products_Mutation_Response>;
  /** insert a single row into the table: "cart_products" */
  insert_cart_products_one?: Maybe<Cart_Products>;
  /** insert data into the table: "channel_signals" */
  insert_channel_signals?: Maybe<Channel_Signals_Mutation_Response>;
  /** insert a single row into the table: "channel_signals" */
  insert_channel_signals_one?: Maybe<Channel_Signals>;
  /** insert data into the table: "common_question_responses" */
  insert_common_question_responses?: Maybe<Common_Question_Responses_Mutation_Response>;
  /** insert a single row into the table: "common_question_responses" */
  insert_common_question_responses_one?: Maybe<Common_Question_Responses>;
  /** insert data into the table: "common_questions" */
  insert_common_questions?: Maybe<Common_Questions_Mutation_Response>;
  /** insert a single row into the table: "common_questions" */
  insert_common_questions_one?: Maybe<Common_Questions>;
  /** insert data into the table: "communication_channels" */
  insert_communication_channels?: Maybe<Communication_Channels_Mutation_Response>;
  /** insert a single row into the table: "communication_channels" */
  insert_communication_channels_one?: Maybe<Communication_Channels>;
  /** insert data into the table: "countries" */
  insert_countries?: Maybe<Countries_Mutation_Response>;
  /** insert a single row into the table: "countries" */
  insert_countries_one?: Maybe<Countries>;
  /** insert data into the table: "custom_auth_code" */
  insert_custom_auth_code?: Maybe<Custom_Auth_Code_Mutation_Response>;
  /** insert a single row into the table: "custom_auth_code" */
  insert_custom_auth_code_one?: Maybe<Custom_Auth_Code>;
  /** insert data into the table: "dea_license_schedules" */
  insert_dea_license_schedules?: Maybe<Dea_License_Schedules_Mutation_Response>;
  /** insert a single row into the table: "dea_license_schedules" */
  insert_dea_license_schedules_one?: Maybe<Dea_License_Schedules>;
  /** insert data into the table: "delivery_addresses" */
  insert_delivery_addresses?: Maybe<Delivery_Addresses_Mutation_Response>;
  /** insert a single row into the table: "delivery_addresses" */
  insert_delivery_addresses_one?: Maybe<Delivery_Addresses>;
  /** insert data into the table: "diagnostic_solution_tests" */
  insert_diagnostic_solution_tests?: Maybe<Diagnostic_Solution_Tests_Mutation_Response>;
  /** insert a single row into the table: "diagnostic_solution_tests" */
  insert_diagnostic_solution_tests_one?: Maybe<Diagnostic_Solution_Tests>;
  /** insert data into the table: "dnavisit_test_statuses" */
  insert_dnavisit_test_statuses?: Maybe<Dnavisit_Test_Statuses_Mutation_Response>;
  /** insert a single row into the table: "dnavisit_test_statuses" */
  insert_dnavisit_test_statuses_one?: Maybe<Dnavisit_Test_Statuses>;
  /** insert data into the table: "dnavisit_tests" */
  insert_dnavisit_tests?: Maybe<Dnavisit_Tests_Mutation_Response>;
  /** insert a single row into the table: "dnavisit_tests" */
  insert_dnavisit_tests_one?: Maybe<Dnavisit_Tests>;
  /** insert data into the table: "do_not_use_production_swab_codes" */
  insert_do_not_use_production_swab_codes?: Maybe<Do_Not_Use_Production_Swab_Codes_Mutation_Response>;
  /** insert a single row into the table: "do_not_use_production_swab_codes" */
  insert_do_not_use_production_swab_codes_one?: Maybe<Do_Not_Use_Production_Swab_Codes>;
  /** insert data into the table: "ecommerce_orders" */
  insert_ecommerce_orders?: Maybe<Ecommerce_Orders_Mutation_Response>;
  /** insert a single row into the table: "ecommerce_orders" */
  insert_ecommerce_orders_one?: Maybe<Ecommerce_Orders>;
  /** insert data into the table: "education_courses" */
  insert_education_courses?: Maybe<Education_Courses_Mutation_Response>;
  /** insert a single row into the table: "education_courses" */
  insert_education_courses_one?: Maybe<Education_Courses>;
  /** insert data into the table: "education_module_additional_materials" */
  insert_education_module_additional_materials?: Maybe<Education_Module_Additional_Materials_Mutation_Response>;
  /** insert a single row into the table: "education_module_additional_materials" */
  insert_education_module_additional_materials_one?: Maybe<Education_Module_Additional_Materials>;
  /** insert data into the table: "education_module_items" */
  insert_education_module_items?: Maybe<Education_Module_Items_Mutation_Response>;
  /** insert a single row into the table: "education_module_items" */
  insert_education_module_items_one?: Maybe<Education_Module_Items>;
  /** insert data into the table: "education_modules" */
  insert_education_modules?: Maybe<Education_Modules_Mutation_Response>;
  /** insert a single row into the table: "education_modules" */
  insert_education_modules_one?: Maybe<Education_Modules>;
  /** insert data into the table: "file_types" */
  insert_file_types?: Maybe<File_Types_Mutation_Response>;
  /** insert a single row into the table: "file_types" */
  insert_file_types_one?: Maybe<File_Types>;
  /** insert data into the table: "files" */
  insert_files?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_files_one?: Maybe<Files>;
  /** insert data into the table: "fullscript_allergens" */
  insert_fullscript_allergens?: Maybe<Fullscript_Allergens_Mutation_Response>;
  /** insert a single row into the table: "fullscript_allergens" */
  insert_fullscript_allergens_one?: Maybe<Fullscript_Allergens>;
  /** insert data into the table: "fullscript_clinicians" */
  insert_fullscript_clinicians?: Maybe<Fullscript_Clinicians_Mutation_Response>;
  /** insert a single row into the table: "fullscript_clinicians" */
  insert_fullscript_clinicians_one?: Maybe<Fullscript_Clinicians>;
  /** insert data into the table: "gale_products" */
  insert_gale_products?: Maybe<Gale_Products_Mutation_Response>;
  /** insert a single row into the table: "gale_products" */
  insert_gale_products_one?: Maybe<Gale_Products>;
  /** insert data into the table: "global_configs" */
  insert_global_configs?: Maybe<Global_Configs_Mutation_Response>;
  /** insert data into the table: "global_configs_names" */
  insert_global_configs_names?: Maybe<Global_Configs_Names_Mutation_Response>;
  /** insert a single row into the table: "global_configs_names" */
  insert_global_configs_names_one?: Maybe<Global_Configs_Names>;
  /** insert a single row into the table: "global_configs" */
  insert_global_configs_one?: Maybe<Global_Configs>;
  /** insert data into the table: "image_source_types" */
  insert_image_source_types?: Maybe<Image_Source_Types_Mutation_Response>;
  /** insert a single row into the table: "image_source_types" */
  insert_image_source_types_one?: Maybe<Image_Source_Types>;
  /** insert data into the table: "in_mail_usage" */
  insert_in_mail_usage?: Maybe<In_Mail_Usage_Mutation_Response>;
  /** insert a single row into the table: "in_mail_usage" */
  insert_in_mail_usage_one?: Maybe<In_Mail_Usage>;
  /** insert data into the table: "invitations" */
  insert_invitations?: Maybe<Invitations_Mutation_Response>;
  /** insert a single row into the table: "invitations" */
  insert_invitations_one?: Maybe<Invitations>;
  /** insert data into the table: "labs" */
  insert_labs?: Maybe<Labs_Mutation_Response>;
  /** insert a single row into the table: "labs" */
  insert_labs_one?: Maybe<Labs>;
  /** insert data into the table: "legal_document_types" */
  insert_legal_document_types?: Maybe<Legal_Document_Types_Mutation_Response>;
  /** insert a single row into the table: "legal_document_types" */
  insert_legal_document_types_one?: Maybe<Legal_Document_Types>;
  /** insert data into the table: "legal_document_update_notifications" */
  insert_legal_document_update_notifications?: Maybe<Legal_Document_Update_Notifications_Mutation_Response>;
  /** insert a single row into the table: "legal_document_update_notifications" */
  insert_legal_document_update_notifications_one?: Maybe<Legal_Document_Update_Notifications>;
  /** insert data into the table: "legal_documents" */
  insert_legal_documents?: Maybe<Legal_Documents_Mutation_Response>;
  /** insert a single row into the table: "legal_documents" */
  insert_legal_documents_one?: Maybe<Legal_Documents>;
  /** insert data into the table: "medical_schools" */
  insert_medical_schools?: Maybe<Medical_Schools_Mutation_Response>;
  /** insert a single row into the table: "medical_schools" */
  insert_medical_schools_one?: Maybe<Medical_Schools>;
  /** insert data into the table: "medications" */
  insert_medications?: Maybe<Medications_Mutation_Response>;
  /** insert a single row into the table: "medications" */
  insert_medications_one?: Maybe<Medications>;
  /** insert data into the table: "molecular_tests" */
  insert_molecular_tests?: Maybe<Molecular_Tests_Mutation_Response>;
  /** insert a single row into the table: "molecular_tests" */
  insert_molecular_tests_one?: Maybe<Molecular_Tests>;
  /** insert data into the table: "mosaic_tests" */
  insert_mosaic_tests?: Maybe<Mosaic_Tests_Mutation_Response>;
  /** insert a single row into the table: "mosaic_tests" */
  insert_mosaic_tests_one?: Maybe<Mosaic_Tests>;
  /** insert data into the table: "nabla_notes" */
  insert_nabla_notes?: Maybe<Nabla_Notes_Mutation_Response>;
  /** insert a single row into the table: "nabla_notes" */
  insert_nabla_notes_one?: Maybe<Nabla_Notes>;
  /** insert data into the table: "npi_registry_data" */
  insert_npi_registry_data?: Maybe<Npi_Registry_Data_Mutation_Response>;
  /** insert a single row into the table: "npi_registry_data" */
  insert_npi_registry_data_one?: Maybe<Npi_Registry_Data>;
  /** insert data into the table: "order_payments" */
  insert_order_payments?: Maybe<Order_Payments_Mutation_Response>;
  /** insert a single row into the table: "order_payments" */
  insert_order_payments_one?: Maybe<Order_Payments>;
  /** insert data into the table: "order_products" */
  insert_order_products?: Maybe<Order_Products_Mutation_Response>;
  /** insert a single row into the table: "order_products" */
  insert_order_products_one?: Maybe<Order_Products>;
  /** insert data into the table: "order_status_history" */
  insert_order_status_history?: Maybe<Order_Status_History_Mutation_Response>;
  /** insert a single row into the table: "order_status_history" */
  insert_order_status_history_one?: Maybe<Order_Status_History>;
  /** insert data into the table: "orders" */
  insert_orders?: Maybe<Orders_Mutation_Response>;
  /** insert a single row into the table: "orders" */
  insert_orders_one?: Maybe<Orders>;
  /** insert data into the table: "orders_view" */
  insert_orders_view?: Maybe<Orders_View_Mutation_Response>;
  /** insert a single row into the table: "orders_view" */
  insert_orders_view_one?: Maybe<Orders_View>;
  /** insert data into the table: "patient_achievement_events" */
  insert_patient_achievement_events?: Maybe<Patient_Achievement_Events_Mutation_Response>;
  /** insert a single row into the table: "patient_achievement_events" */
  insert_patient_achievement_events_one?: Maybe<Patient_Achievement_Events>;
  /** insert data into the table: "patient_achievement_progress" */
  insert_patient_achievement_progress?: Maybe<Patient_Achievement_Progress_Mutation_Response>;
  /** insert a single row into the table: "patient_achievement_progress" */
  insert_patient_achievement_progress_one?: Maybe<Patient_Achievement_Progress>;
  /** insert data into the table: "patient_achievement_unlocks" */
  insert_patient_achievement_unlocks?: Maybe<Patient_Achievement_Unlocks_Mutation_Response>;
  /** insert a single row into the table: "patient_achievement_unlocks" */
  insert_patient_achievement_unlocks_one?: Maybe<Patient_Achievement_Unlocks>;
  /** insert data into the table: "payment_transaction_orders" */
  insert_payment_transaction_orders?: Maybe<Payment_Transaction_Orders_Mutation_Response>;
  /** insert a single row into the table: "payment_transaction_orders" */
  insert_payment_transaction_orders_one?: Maybe<Payment_Transaction_Orders>;
  /** insert data into the table: "payment_transactions" */
  insert_payment_transactions?: Maybe<Payment_Transactions_Mutation_Response>;
  /** insert a single row into the table: "payment_transactions" */
  insert_payment_transactions_one?: Maybe<Payment_Transactions>;
  /** insert data into the table: "pending_patient_zrt" */
  insert_pending_patient_zrt?: Maybe<Pending_Patient_Zrt_Mutation_Response>;
  /** insert a single row into the table: "pending_patient_zrt" */
  insert_pending_patient_zrt_one?: Maybe<Pending_Patient_Zrt>;
  /** insert data into the table: "persona_inquiries" */
  insert_persona_inquiries?: Maybe<Persona_Inquiries_Mutation_Response>;
  /** insert a single row into the table: "persona_inquiries" */
  insert_persona_inquiries_one?: Maybe<Persona_Inquiries>;
  /** insert data into the table: "persona_inquiry_status" */
  insert_persona_inquiry_status?: Maybe<Persona_Inquiry_Status_Mutation_Response>;
  /** insert a single row into the table: "persona_inquiry_status" */
  insert_persona_inquiry_status_one?: Maybe<Persona_Inquiry_Status>;
  /** insert data into the table: "products" */
  insert_products?: Maybe<Products_Mutation_Response>;
  /** insert a single row into the table: "products" */
  insert_products_one?: Maybe<Products>;
  /** insert data into the table: "provider_billing" */
  insert_provider_billing?: Maybe<Provider_Billing_Mutation_Response>;
  /** insert a single row into the table: "provider_billing" */
  insert_provider_billing_one?: Maybe<Provider_Billing>;
  /** insert data into the table: "provider_dea_licenses" */
  insert_provider_dea_licenses?: Maybe<Provider_Dea_Licenses_Mutation_Response>;
  /** insert a single row into the table: "provider_dea_licenses" */
  insert_provider_dea_licenses_one?: Maybe<Provider_Dea_Licenses>;
  /** insert data into the table: "provider_payments" */
  insert_provider_payments?: Maybe<Provider_Payments_Mutation_Response>;
  /** insert a single row into the table: "provider_payments" */
  insert_provider_payments_one?: Maybe<Provider_Payments>;
  /** insert data into the table: "provider_payouts" */
  insert_provider_payouts?: Maybe<Provider_Payouts_Mutation_Response>;
  /** insert a single row into the table: "provider_payouts" */
  insert_provider_payouts_one?: Maybe<Provider_Payouts>;
  /** insert data into the table: "provider_state_licenses" */
  insert_provider_state_licenses?: Maybe<Provider_State_Licenses_Mutation_Response>;
  /** insert a single row into the table: "provider_state_licenses" */
  insert_provider_state_licenses_one?: Maybe<Provider_State_Licenses>;
  /** insert data into the table: "provider_unread_external_notification_counts" */
  insert_provider_unread_external_notification_counts?: Maybe<Provider_Unread_External_Notification_Counts_Mutation_Response>;
  /** insert a single row into the table: "provider_unread_external_notification_counts" */
  insert_provider_unread_external_notification_counts_one?: Maybe<Provider_Unread_External_Notification_Counts>;
  /** insert data into the table: "question_measurement_units" */
  insert_question_measurement_units?: Maybe<Question_Measurement_Units_Mutation_Response>;
  /** insert a single row into the table: "question_measurement_units" */
  insert_question_measurement_units_one?: Maybe<Question_Measurement_Units>;
  /** insert data into the table: "question_types" */
  insert_question_types?: Maybe<Question_Types_Mutation_Response>;
  /** insert a single row into the table: "question_types" */
  insert_question_types_one?: Maybe<Question_Types>;
  /** insert data into the table: "question_ui_control_helper_text_position" */
  insert_question_ui_control_helper_text_position?: Maybe<Question_Ui_Control_Helper_Text_Position_Mutation_Response>;
  /** insert a single row into the table: "question_ui_control_helper_text_position" */
  insert_question_ui_control_helper_text_position_one?: Maybe<Question_Ui_Control_Helper_Text_Position>;
  /** insert data into the table: "question_ui_control_types" */
  insert_question_ui_control_types?: Maybe<Question_Ui_Control_Types_Mutation_Response>;
  /** insert a single row into the table: "question_ui_control_types" */
  insert_question_ui_control_types_one?: Maybe<Question_Ui_Control_Types>;
  /** insert data into the table: "questionnaire_questions" */
  insert_questionnaire_questions?: Maybe<Questionnaire_Questions_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_questions" */
  insert_questionnaire_questions_one?: Maybe<Questionnaire_Questions>;
  /** insert data into the table: "questionnaire_reminders" */
  insert_questionnaire_reminders?: Maybe<Questionnaire_Reminders_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_reminders" */
  insert_questionnaire_reminders_one?: Maybe<Questionnaire_Reminders>;
  /** insert data into the table: "questionnaire_responses" */
  insert_questionnaire_responses?: Maybe<Questionnaire_Responses_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_responses" */
  insert_questionnaire_responses_one?: Maybe<Questionnaire_Responses>;
  /** insert data into the table: "questionnaires" */
  insert_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** insert a single row into the table: "questionnaires" */
  insert_questionnaires_one?: Maybe<Questionnaires>;
  /** insert data into the table: "questions" */
  insert_questions?: Maybe<Questions_Mutation_Response>;
  /** insert a single row into the table: "questions" */
  insert_questions_one?: Maybe<Questions>;
  /** insert data into the table: "recommendations" */
  insert_recommendations?: Maybe<Recommendations_Mutation_Response>;
  /** insert a single row into the table: "recommendations" */
  insert_recommendations_one?: Maybe<Recommendations>;
  /** insert data into the table: "shipmonk_sync_metadata" */
  insert_shipmonk_sync_metadata?: Maybe<Shipmonk_Sync_Metadata_Mutation_Response>;
  /** insert a single row into the table: "shipmonk_sync_metadata" */
  insert_shipmonk_sync_metadata_one?: Maybe<Shipmonk_Sync_Metadata>;
  /** insert data into the table: "skintelligent_tests" */
  insert_skintelligent_tests?: Maybe<Skintelligent_Tests_Mutation_Response>;
  /** insert a single row into the table: "skintelligent_tests" */
  insert_skintelligent_tests_one?: Maybe<Skintelligent_Tests>;
  /** insert data into the table: "stripe_billing_plans" */
  insert_stripe_billing_plans?: Maybe<Stripe_Billing_Plans_Mutation_Response>;
  /** insert a single row into the table: "stripe_billing_plans" */
  insert_stripe_billing_plans_one?: Maybe<Stripe_Billing_Plans>;
  /** insert data into the table: "stripe_customers" */
  insert_stripe_customers?: Maybe<Stripe_Customers_Mutation_Response>;
  /** insert a single row into the table: "stripe_customers" */
  insert_stripe_customers_one?: Maybe<Stripe_Customers>;
  /** insert data into the table: "stripe_payment_intents" */
  insert_stripe_payment_intents?: Maybe<Stripe_Payment_Intents_Mutation_Response>;
  /** insert a single row into the table: "stripe_payment_intents" */
  insert_stripe_payment_intents_one?: Maybe<Stripe_Payment_Intents>;
  /** insert data into the table: "stripe_payment_methods" */
  insert_stripe_payment_methods?: Maybe<Stripe_Payment_Methods_Mutation_Response>;
  /** insert a single row into the table: "stripe_payment_methods" */
  insert_stripe_payment_methods_one?: Maybe<Stripe_Payment_Methods>;
  /** insert data into the table: "stripe_subscriptions" */
  insert_stripe_subscriptions?: Maybe<Stripe_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "stripe_subscriptions" */
  insert_stripe_subscriptions_one?: Maybe<Stripe_Subscriptions>;
  /** insert data into the table: "stripe_transaction" */
  insert_stripe_transaction?: Maybe<Stripe_Transaction_Mutation_Response>;
  /** insert a single row into the table: "stripe_transaction" */
  insert_stripe_transaction_one?: Maybe<Stripe_Transaction>;
  /** insert data into the table: "support_chat_usage" */
  insert_support_chat_usage?: Maybe<Support_Chat_Usage_Mutation_Response>;
  /** insert a single row into the table: "support_chat_usage" */
  insert_support_chat_usage_one?: Maybe<Support_Chat_Usage>;
  /** insert data into the table: "swab_code_statuses" */
  insert_swab_code_statuses?: Maybe<Swab_Code_Statuses_Mutation_Response>;
  /** insert a single row into the table: "swab_code_statuses" */
  insert_swab_code_statuses_one?: Maybe<Swab_Code_Statuses>;
  /** insert data into the table: "swab_codes" */
  insert_swab_codes?: Maybe<Swab_Codes_Mutation_Response>;
  /** insert a single row into the table: "swab_codes" */
  insert_swab_codes_one?: Maybe<Swab_Codes>;
  /** insert data into the table: "swab_usage_type" */
  insert_swab_usage_type?: Maybe<Swab_Usage_Type_Mutation_Response>;
  /** insert a single row into the table: "swab_usage_type" */
  insert_swab_usage_type_one?: Maybe<Swab_Usage_Type>;
  /** insert data into the table: "test_definitions" */
  insert_test_definitions?: Maybe<Test_Definitions_Mutation_Response>;
  /** insert a single row into the table: "test_definitions" */
  insert_test_definitions_one?: Maybe<Test_Definitions>;
  /** insert data into the table: "test_e_prescribe_npis" */
  insert_test_e_prescribe_npis?: Maybe<Test_E_Prescribe_Npis_Mutation_Response>;
  /** insert a single row into the table: "test_e_prescribe_npis" */
  insert_test_e_prescribe_npis_one?: Maybe<Test_E_Prescribe_Npis>;
  /** insert data into the table: "test_kits_update_states_summary_log" */
  insert_test_kits_update_states_summary_log?: Maybe<Test_Kits_Update_States_Summary_Log_Mutation_Response>;
  /** insert a single row into the table: "test_kits_update_states_summary_log" */
  insert_test_kits_update_states_summary_log_one?: Maybe<Test_Kits_Update_States_Summary_Log>;
  /** insert data into the table: "test_types" */
  insert_test_types?: Maybe<Test_Types_Mutation_Response>;
  /** insert a single row into the table: "test_types" */
  insert_test_types_one?: Maybe<Test_Types>;
  /** insert data into the table: "tests" */
  insert_tests?: Maybe<Tests_Mutation_Response>;
  /** insert a single row into the table: "tests" */
  insert_tests_one?: Maybe<Tests>;
  /** insert data into the table: "text_addresses" */
  insert_text_addresses?: Maybe<Text_Addresses_Mutation_Response>;
  /** insert a single row into the table: "text_addresses" */
  insert_text_addresses_one?: Maybe<Text_Addresses>;
  /** insert data into the table: "unauthenticated_questionnaire_questions" */
  insert_unauthenticated_questionnaire_questions?: Maybe<Unauthenticated_Questionnaire_Questions_Mutation_Response>;
  /** insert a single row into the table: "unauthenticated_questionnaire_questions" */
  insert_unauthenticated_questionnaire_questions_one?: Maybe<Unauthenticated_Questionnaire_Questions>;
  /** insert data into the table: "unauthenticated_questionnaires" */
  insert_unauthenticated_questionnaires?: Maybe<Unauthenticated_Questionnaires_Mutation_Response>;
  /** insert a single row into the table: "unauthenticated_questionnaires" */
  insert_unauthenticated_questionnaires_one?: Maybe<Unauthenticated_Questionnaires>;
  /** insert data into the table: "unauthenticated_questions" */
  insert_unauthenticated_questions?: Maybe<Unauthenticated_Questions_Mutation_Response>;
  /** insert a single row into the table: "unauthenticated_questions" */
  insert_unauthenticated_questions_one?: Maybe<Unauthenticated_Questions>;
  /** insert data into the table: "universities" */
  insert_universities?: Maybe<Universities_Mutation_Response>;
  /** insert a single row into the table: "universities" */
  insert_universities_one?: Maybe<Universities>;
  /** insert data into the table: "used_test_e_prescribe_licenses" */
  insert_used_test_e_prescribe_licenses?: Maybe<Used_Test_E_Prescribe_Licenses_Mutation_Response>;
  /** insert a single row into the table: "used_test_e_prescribe_licenses" */
  insert_used_test_e_prescribe_licenses_one?: Maybe<Used_Test_E_Prescribe_Licenses>;
  /** insert data into the table: "user_addresses" */
  insert_user_addresses?: Maybe<User_Addresses_Mutation_Response>;
  /** insert a single row into the table: "user_addresses" */
  insert_user_addresses_one?: Maybe<User_Addresses>;
  /** insert data into the table: "user_agreements" */
  insert_user_agreements?: Maybe<User_Agreements_Mutation_Response>;
  /** insert a single row into the table: "user_agreements" */
  insert_user_agreements_one?: Maybe<User_Agreements>;
  /** insert data into the table: "user_auth_provider_types" */
  insert_user_auth_provider_types?: Maybe<User_Auth_Provider_Types_Mutation_Response>;
  /** insert a single row into the table: "user_auth_provider_types" */
  insert_user_auth_provider_types_one?: Maybe<User_Auth_Provider_Types>;
  /** insert data into the table: "user_auth_providers" */
  insert_user_auth_providers?: Maybe<User_Auth_Providers_Mutation_Response>;
  /** insert a single row into the table: "user_auth_providers" */
  insert_user_auth_providers_one?: Maybe<User_Auth_Providers>;
  /** insert data into the table: "user_auth_tokens" */
  insert_user_auth_tokens?: Maybe<User_Auth_Tokens_Mutation_Response>;
  /** insert a single row into the table: "user_auth_tokens" */
  insert_user_auth_tokens_one?: Maybe<User_Auth_Tokens>;
  /** insert data into the table: "user_communication_deliveries" */
  insert_user_communication_deliveries?: Maybe<User_Communication_Deliveries_Mutation_Response>;
  /** insert a single row into the table: "user_communication_deliveries" */
  insert_user_communication_deliveries_one?: Maybe<User_Communication_Deliveries>;
  /** insert data into the table: "user_communications" */
  insert_user_communications?: Maybe<User_Communications_Mutation_Response>;
  /** insert a single row into the table: "user_communications" */
  insert_user_communications_one?: Maybe<User_Communications>;
  /** insert data into the table: "user_indicators" */
  insert_user_indicators?: Maybe<User_Indicators_Mutation_Response>;
  /** insert a single row into the table: "user_indicators" */
  insert_user_indicators_one?: Maybe<User_Indicators>;
  /** insert data into the table: "user_notification_status" */
  insert_user_notification_status?: Maybe<User_Notification_Status_Mutation_Response>;
  /** insert a single row into the table: "user_notification_status" */
  insert_user_notification_status_one?: Maybe<User_Notification_Status>;
  /** insert data into the table: "user_notifications" */
  insert_user_notifications?: Maybe<User_Notifications_Mutation_Response>;
  /** insert a single row into the table: "user_notifications" */
  insert_user_notifications_one?: Maybe<User_Notifications>;
  /** insert data into the table: "user_push_tokens" */
  insert_user_push_tokens?: Maybe<User_Push_Tokens_Mutation_Response>;
  /** insert a single row into the table: "user_push_tokens" */
  insert_user_push_tokens_one?: Maybe<User_Push_Tokens>;
  /** insert data into the table: "user_scanned_data" */
  insert_user_scanned_data?: Maybe<User_Scanned_Data_Mutation_Response>;
  /** insert a single row into the table: "user_scanned_data" */
  insert_user_scanned_data_one?: Maybe<User_Scanned_Data>;
  /** insert data into the table: "user_settings" */
  insert_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** insert a single row into the table: "user_settings" */
  insert_user_settings_one?: Maybe<User_Settings>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "vonage_appointment" */
  insert_vonage_appointment?: Maybe<Vonage_Appointment_Mutation_Response>;
  /** insert a single row into the table: "vonage_appointment" */
  insert_vonage_appointment_one?: Maybe<Vonage_Appointment>;
  /** insert data into the table: "zrt_tests" */
  insert_zrt_tests?: Maybe<Zrt_Tests_Mutation_Response>;
  /** insert a single row into the table: "zrt_tests" */
  insert_zrt_tests_one?: Maybe<Zrt_Tests>;
  linkProviderAccount: FullscriptOperationResult;
  onTreatmentPlanActivated: FullscriptOperationResult;
  patchCodexApproval: PatchFhirProviderOutput;
  patchFHIRAppointment: PatchFhirAppointmentOutput;
  patchFHIRDnaVisitTest: PatchFhirDnaVisitTestOutput;
  patchFHIREncounter: PatchFhirEncounterOutput;
  patchFHIRPatientPersonalData: PatchFhirPatientOutput;
  patchFHIRProvider: PatchFhirProviderOutput;
  patchFHIRZrtTest: PatchFhirZrtTestOutput;
  patchServiceOffering: PatchFhirProviderOutput;
  publishLegalDocument: LegalDocumentOutput;
  recommendProducts: RecommendProductsOutput;
  refundPaymentTransaction: PaymentTransactionOutput;
  rejectAppointmentRequest: HttpStatusOutput;
  removeFileFromLibrary: HttpStatusOutput;
  requestDnaTestKit: RequestDnaTestKitOutput;
  requestZrtTest: RequestZrtTestOutput;
  rescheduleAppointment: RescheduleFhirAppointmentOutput;
  resendChildAdultTransitionInvitation: HttpStatusOutput;
  resendDelegatedAdminInvitation: HttpStatusOutput;
  resetAppTour: HttpStatusOutput;
  saPatchFHIRProvider: PatchFhirProviderOutput;
  saveFHIRQuestionnaireManually: SaveFhirQuestionnaireManually;
  seedFHIROrganizations: SeedFhirOrganizationsOutput;
  sendInMailMessage: HttpStatusOutput;
  sendSupportMessage: HttpStatusOutput;
  setAdmins: HttpStatusOutput;
  setDefaultPaymentMethod: HttpStatusOutput;
  syncEPrescribeMedicationsByPatient: HttpStatusOutput;
  syncShipMonkProducts: HttpStatusOutput;
  unlinkFullscript: PatchFhirProviderOutput;
  updateAllUserNotificationsStatus: HttpStatusOutput;
  updateBecomePatientRequestStatus: PatchFhirRequestBecomePatientOutput;
  updateCallSettings: HttpStatusOutput;
  updateCartProduct: CartProductOutput;
  updateCartProductsProvider: HttpStatusOutput;
  updateDelegatedAdminPermissions: HttpStatusOutput;
  updateFHIRQuestionnaireResponse: UpdateFhirQuestionnaireResponsesOutput;
  updateFHIRUserLatestQuestionnaire: UpdateFhirUserLatestQuestionnaire;
  updateHighContrastMode: GetPatientOutput;
  updateInAppNotificationById: HttpStatusOutput;
  updateNotificationPreferences: HttpStatusOutput;
  updateOrderStatus: HttpStatusOutput;
  updateProduct: ProductOutput;
  updateProductAvailability: HttpStatusOutput;
  updateRecommendationStatus: HttpStatusOutput;
  updateSelfReportedMedication: HttpStatusOutput;
  updateTestKitProvider: HttpStatusOutput;
  /** update data of the table: "accepted_legal_documents" */
  update_accepted_legal_documents?: Maybe<Accepted_Legal_Documents_Mutation_Response>;
  /** update single row of the table: "accepted_legal_documents" */
  update_accepted_legal_documents_by_pk?: Maybe<Accepted_Legal_Documents>;
  /** update multiples rows of table: "accepted_legal_documents" */
  update_accepted_legal_documents_many?: Maybe<Array<Maybe<Accepted_Legal_Documents_Mutation_Response>>>;
  /** update data of the table: "active_in_mails" */
  update_active_in_mails?: Maybe<Active_In_Mails_Mutation_Response>;
  /** update single row of the table: "active_in_mails" */
  update_active_in_mails_by_pk?: Maybe<Active_In_Mails>;
  /** update multiples rows of table: "active_in_mails" */
  update_active_in_mails_many?: Maybe<Array<Maybe<Active_In_Mails_Mutation_Response>>>;
  /** update data of the table: "active_support_chats" */
  update_active_support_chats?: Maybe<Active_Support_Chats_Mutation_Response>;
  /** update single row of the table: "active_support_chats" */
  update_active_support_chats_by_pk?: Maybe<Active_Support_Chats>;
  /** update multiples rows of table: "active_support_chats" */
  update_active_support_chats_many?: Maybe<Array<Maybe<Active_Support_Chats_Mutation_Response>>>;
  /** update data of the table: "activity_events" */
  update_activity_events?: Maybe<Activity_Events_Mutation_Response>;
  /** update single row of the table: "activity_events" */
  update_activity_events_by_pk?: Maybe<Activity_Events>;
  /** update multiples rows of table: "activity_events" */
  update_activity_events_many?: Maybe<Array<Maybe<Activity_Events_Mutation_Response>>>;
  /** update data of the table: "acuity_provider_calendar" */
  update_acuity_provider_calendar?: Maybe<Acuity_Provider_Calendar_Mutation_Response>;
  /** update single row of the table: "acuity_provider_calendar" */
  update_acuity_provider_calendar_by_pk?: Maybe<Acuity_Provider_Calendar>;
  /** update multiples rows of table: "acuity_provider_calendar" */
  update_acuity_provider_calendar_many?: Maybe<Array<Maybe<Acuity_Provider_Calendar_Mutation_Response>>>;
  /** update data of the table: "addresses" */
  update_addresses?: Maybe<Addresses_Mutation_Response>;
  /** update single row of the table: "addresses" */
  update_addresses_by_pk?: Maybe<Addresses>;
  /** update multiples rows of table: "addresses" */
  update_addresses_many?: Maybe<Array<Maybe<Addresses_Mutation_Response>>>;
  /** update data of the table: "admin_permissions" */
  update_admin_permissions?: Maybe<Admin_Permissions_Mutation_Response>;
  /** update single row of the table: "admin_permissions" */
  update_admin_permissions_by_pk?: Maybe<Admin_Permissions>;
  /** update multiples rows of table: "admin_permissions" */
  update_admin_permissions_many?: Maybe<Array<Maybe<Admin_Permissions_Mutation_Response>>>;
  /** update data of the table: "age_of_majority_rules" */
  update_age_of_majority_rules?: Maybe<Age_Of_Majority_Rules_Mutation_Response>;
  /** update single row of the table: "age_of_majority_rules" */
  update_age_of_majority_rules_by_pk?: Maybe<Age_Of_Majority_Rules>;
  /** update multiples rows of table: "age_of_majority_rules" */
  update_age_of_majority_rules_many?: Maybe<Array<Maybe<Age_Of_Majority_Rules_Mutation_Response>>>;
  /** update data of the table: "allergen_classes" */
  update_allergen_classes?: Maybe<Allergen_Classes_Mutation_Response>;
  /** update single row of the table: "allergen_classes" */
  update_allergen_classes_by_pk?: Maybe<Allergen_Classes>;
  /** update multiples rows of table: "allergen_classes" */
  update_allergen_classes_many?: Maybe<Array<Maybe<Allergen_Classes_Mutation_Response>>>;
  /** update data of the table: "app_tours" */
  update_app_tours?: Maybe<App_Tours_Mutation_Response>;
  /** update single row of the table: "app_tours" */
  update_app_tours_by_pk?: Maybe<App_Tours>;
  /** update multiples rows of table: "app_tours" */
  update_app_tours_many?: Maybe<Array<Maybe<App_Tours_Mutation_Response>>>;
  /** update data of the table: "app_versions" */
  update_app_versions?: Maybe<App_Versions_Mutation_Response>;
  /** update single row of the table: "app_versions" */
  update_app_versions_by_pk?: Maybe<App_Versions>;
  /** update multiples rows of table: "app_versions" */
  update_app_versions_many?: Maybe<Array<Maybe<App_Versions_Mutation_Response>>>;
  /** update data of the table: "appointment_media_signals" */
  update_appointment_media_signals?: Maybe<Appointment_Media_Signals_Mutation_Response>;
  /** update single row of the table: "appointment_media_signals" */
  update_appointment_media_signals_by_pk?: Maybe<Appointment_Media_Signals>;
  /** update multiples rows of table: "appointment_media_signals" */
  update_appointment_media_signals_many?: Maybe<Array<Maybe<Appointment_Media_Signals_Mutation_Response>>>;
  /** update data of the table: "appointment_payments" */
  update_appointment_payments?: Maybe<Appointment_Payments_Mutation_Response>;
  /** update single row of the table: "appointment_payments" */
  update_appointment_payments_by_pk?: Maybe<Appointment_Payments>;
  /** update multiples rows of table: "appointment_payments" */
  update_appointment_payments_many?: Maybe<Array<Maybe<Appointment_Payments_Mutation_Response>>>;
  /** update data of the table: "appointment_requests" */
  update_appointment_requests?: Maybe<Appointment_Requests_Mutation_Response>;
  /** update single row of the table: "appointment_requests" */
  update_appointment_requests_by_pk?: Maybe<Appointment_Requests>;
  /** update multiples rows of table: "appointment_requests" */
  update_appointment_requests_many?: Maybe<Array<Maybe<Appointment_Requests_Mutation_Response>>>;
  /** update data of the table: "appointment_status_history" */
  update_appointment_status_history?: Maybe<Appointment_Status_History_Mutation_Response>;
  /** update single row of the table: "appointment_status_history" */
  update_appointment_status_history_by_pk?: Maybe<Appointment_Status_History>;
  /** update multiples rows of table: "appointment_status_history" */
  update_appointment_status_history_many?: Maybe<Array<Maybe<Appointment_Status_History_Mutation_Response>>>;
  /** update data of the table: "appointments" */
  update_appointments?: Maybe<Appointments_Mutation_Response>;
  /** update single row of the table: "appointments" */
  update_appointments_by_pk?: Maybe<Appointments>;
  /** update multiples rows of table: "appointments" */
  update_appointments_many?: Maybe<Array<Maybe<Appointments_Mutation_Response>>>;
  /** update data of the table: "cart_products" */
  update_cart_products?: Maybe<Cart_Products_Mutation_Response>;
  /** update single row of the table: "cart_products" */
  update_cart_products_by_pk?: Maybe<Cart_Products>;
  /** update multiples rows of table: "cart_products" */
  update_cart_products_many?: Maybe<Array<Maybe<Cart_Products_Mutation_Response>>>;
  /** update data of the table: "channel_signals" */
  update_channel_signals?: Maybe<Channel_Signals_Mutation_Response>;
  /** update single row of the table: "channel_signals" */
  update_channel_signals_by_pk?: Maybe<Channel_Signals>;
  /** update multiples rows of table: "channel_signals" */
  update_channel_signals_many?: Maybe<Array<Maybe<Channel_Signals_Mutation_Response>>>;
  /** update data of the table: "common_question_responses" */
  update_common_question_responses?: Maybe<Common_Question_Responses_Mutation_Response>;
  /** update single row of the table: "common_question_responses" */
  update_common_question_responses_by_pk?: Maybe<Common_Question_Responses>;
  /** update multiples rows of table: "common_question_responses" */
  update_common_question_responses_many?: Maybe<Array<Maybe<Common_Question_Responses_Mutation_Response>>>;
  /** update data of the table: "common_questions" */
  update_common_questions?: Maybe<Common_Questions_Mutation_Response>;
  /** update single row of the table: "common_questions" */
  update_common_questions_by_pk?: Maybe<Common_Questions>;
  /** update multiples rows of table: "common_questions" */
  update_common_questions_many?: Maybe<Array<Maybe<Common_Questions_Mutation_Response>>>;
  /** update data of the table: "communication_channels" */
  update_communication_channels?: Maybe<Communication_Channels_Mutation_Response>;
  /** update single row of the table: "communication_channels" */
  update_communication_channels_by_pk?: Maybe<Communication_Channels>;
  /** update multiples rows of table: "communication_channels" */
  update_communication_channels_many?: Maybe<Array<Maybe<Communication_Channels_Mutation_Response>>>;
  /** update data of the table: "countries" */
  update_countries?: Maybe<Countries_Mutation_Response>;
  /** update single row of the table: "countries" */
  update_countries_by_pk?: Maybe<Countries>;
  /** update multiples rows of table: "countries" */
  update_countries_many?: Maybe<Array<Maybe<Countries_Mutation_Response>>>;
  /** update data of the table: "custom_auth_code" */
  update_custom_auth_code?: Maybe<Custom_Auth_Code_Mutation_Response>;
  /** update single row of the table: "custom_auth_code" */
  update_custom_auth_code_by_pk?: Maybe<Custom_Auth_Code>;
  /** update multiples rows of table: "custom_auth_code" */
  update_custom_auth_code_many?: Maybe<Array<Maybe<Custom_Auth_Code_Mutation_Response>>>;
  /** update data of the table: "dea_license_schedules" */
  update_dea_license_schedules?: Maybe<Dea_License_Schedules_Mutation_Response>;
  /** update single row of the table: "dea_license_schedules" */
  update_dea_license_schedules_by_pk?: Maybe<Dea_License_Schedules>;
  /** update multiples rows of table: "dea_license_schedules" */
  update_dea_license_schedules_many?: Maybe<Array<Maybe<Dea_License_Schedules_Mutation_Response>>>;
  /** update data of the table: "delivery_addresses" */
  update_delivery_addresses?: Maybe<Delivery_Addresses_Mutation_Response>;
  /** update single row of the table: "delivery_addresses" */
  update_delivery_addresses_by_pk?: Maybe<Delivery_Addresses>;
  /** update multiples rows of table: "delivery_addresses" */
  update_delivery_addresses_many?: Maybe<Array<Maybe<Delivery_Addresses_Mutation_Response>>>;
  /** update data of the table: "diagnostic_solution_tests" */
  update_diagnostic_solution_tests?: Maybe<Diagnostic_Solution_Tests_Mutation_Response>;
  /** update single row of the table: "diagnostic_solution_tests" */
  update_diagnostic_solution_tests_by_pk?: Maybe<Diagnostic_Solution_Tests>;
  /** update multiples rows of table: "diagnostic_solution_tests" */
  update_diagnostic_solution_tests_many?: Maybe<Array<Maybe<Diagnostic_Solution_Tests_Mutation_Response>>>;
  /** update data of the table: "dnavisit_test_statuses" */
  update_dnavisit_test_statuses?: Maybe<Dnavisit_Test_Statuses_Mutation_Response>;
  /** update single row of the table: "dnavisit_test_statuses" */
  update_dnavisit_test_statuses_by_pk?: Maybe<Dnavisit_Test_Statuses>;
  /** update multiples rows of table: "dnavisit_test_statuses" */
  update_dnavisit_test_statuses_many?: Maybe<Array<Maybe<Dnavisit_Test_Statuses_Mutation_Response>>>;
  /** update data of the table: "dnavisit_tests" */
  update_dnavisit_tests?: Maybe<Dnavisit_Tests_Mutation_Response>;
  /** update single row of the table: "dnavisit_tests" */
  update_dnavisit_tests_by_pk?: Maybe<Dnavisit_Tests>;
  /** update multiples rows of table: "dnavisit_tests" */
  update_dnavisit_tests_many?: Maybe<Array<Maybe<Dnavisit_Tests_Mutation_Response>>>;
  /** update data of the table: "do_not_use_production_swab_codes" */
  update_do_not_use_production_swab_codes?: Maybe<Do_Not_Use_Production_Swab_Codes_Mutation_Response>;
  /** update single row of the table: "do_not_use_production_swab_codes" */
  update_do_not_use_production_swab_codes_by_pk?: Maybe<Do_Not_Use_Production_Swab_Codes>;
  /** update multiples rows of table: "do_not_use_production_swab_codes" */
  update_do_not_use_production_swab_codes_many?: Maybe<Array<Maybe<Do_Not_Use_Production_Swab_Codes_Mutation_Response>>>;
  /** update data of the table: "ecommerce_orders" */
  update_ecommerce_orders?: Maybe<Ecommerce_Orders_Mutation_Response>;
  /** update single row of the table: "ecommerce_orders" */
  update_ecommerce_orders_by_pk?: Maybe<Ecommerce_Orders>;
  /** update multiples rows of table: "ecommerce_orders" */
  update_ecommerce_orders_many?: Maybe<Array<Maybe<Ecommerce_Orders_Mutation_Response>>>;
  /** update data of the table: "education_courses" */
  update_education_courses?: Maybe<Education_Courses_Mutation_Response>;
  /** update single row of the table: "education_courses" */
  update_education_courses_by_pk?: Maybe<Education_Courses>;
  /** update multiples rows of table: "education_courses" */
  update_education_courses_many?: Maybe<Array<Maybe<Education_Courses_Mutation_Response>>>;
  /** update data of the table: "education_module_additional_materials" */
  update_education_module_additional_materials?: Maybe<Education_Module_Additional_Materials_Mutation_Response>;
  /** update single row of the table: "education_module_additional_materials" */
  update_education_module_additional_materials_by_pk?: Maybe<Education_Module_Additional_Materials>;
  /** update multiples rows of table: "education_module_additional_materials" */
  update_education_module_additional_materials_many?: Maybe<Array<Maybe<Education_Module_Additional_Materials_Mutation_Response>>>;
  /** update data of the table: "education_module_items" */
  update_education_module_items?: Maybe<Education_Module_Items_Mutation_Response>;
  /** update single row of the table: "education_module_items" */
  update_education_module_items_by_pk?: Maybe<Education_Module_Items>;
  /** update multiples rows of table: "education_module_items" */
  update_education_module_items_many?: Maybe<Array<Maybe<Education_Module_Items_Mutation_Response>>>;
  /** update data of the table: "education_modules" */
  update_education_modules?: Maybe<Education_Modules_Mutation_Response>;
  /** update single row of the table: "education_modules" */
  update_education_modules_by_pk?: Maybe<Education_Modules>;
  /** update multiples rows of table: "education_modules" */
  update_education_modules_many?: Maybe<Array<Maybe<Education_Modules_Mutation_Response>>>;
  /** update data of the table: "file_types" */
  update_file_types?: Maybe<File_Types_Mutation_Response>;
  /** update single row of the table: "file_types" */
  update_file_types_by_pk?: Maybe<File_Types>;
  /** update multiples rows of table: "file_types" */
  update_file_types_many?: Maybe<Array<Maybe<File_Types_Mutation_Response>>>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "files" */
  update_files_by_pk?: Maybe<Files>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "fullscript_allergens" */
  update_fullscript_allergens?: Maybe<Fullscript_Allergens_Mutation_Response>;
  /** update single row of the table: "fullscript_allergens" */
  update_fullscript_allergens_by_pk?: Maybe<Fullscript_Allergens>;
  /** update multiples rows of table: "fullscript_allergens" */
  update_fullscript_allergens_many?: Maybe<Array<Maybe<Fullscript_Allergens_Mutation_Response>>>;
  /** update data of the table: "fullscript_clinicians" */
  update_fullscript_clinicians?: Maybe<Fullscript_Clinicians_Mutation_Response>;
  /** update single row of the table: "fullscript_clinicians" */
  update_fullscript_clinicians_by_pk?: Maybe<Fullscript_Clinicians>;
  /** update multiples rows of table: "fullscript_clinicians" */
  update_fullscript_clinicians_many?: Maybe<Array<Maybe<Fullscript_Clinicians_Mutation_Response>>>;
  /** update data of the table: "gale_products" */
  update_gale_products?: Maybe<Gale_Products_Mutation_Response>;
  /** update single row of the table: "gale_products" */
  update_gale_products_by_pk?: Maybe<Gale_Products>;
  /** update multiples rows of table: "gale_products" */
  update_gale_products_many?: Maybe<Array<Maybe<Gale_Products_Mutation_Response>>>;
  /** update data of the table: "global_configs" */
  update_global_configs?: Maybe<Global_Configs_Mutation_Response>;
  /** update single row of the table: "global_configs" */
  update_global_configs_by_pk?: Maybe<Global_Configs>;
  /** update multiples rows of table: "global_configs" */
  update_global_configs_many?: Maybe<Array<Maybe<Global_Configs_Mutation_Response>>>;
  /** update data of the table: "global_configs_names" */
  update_global_configs_names?: Maybe<Global_Configs_Names_Mutation_Response>;
  /** update single row of the table: "global_configs_names" */
  update_global_configs_names_by_pk?: Maybe<Global_Configs_Names>;
  /** update multiples rows of table: "global_configs_names" */
  update_global_configs_names_many?: Maybe<Array<Maybe<Global_Configs_Names_Mutation_Response>>>;
  /** update data of the table: "image_source_types" */
  update_image_source_types?: Maybe<Image_Source_Types_Mutation_Response>;
  /** update single row of the table: "image_source_types" */
  update_image_source_types_by_pk?: Maybe<Image_Source_Types>;
  /** update multiples rows of table: "image_source_types" */
  update_image_source_types_many?: Maybe<Array<Maybe<Image_Source_Types_Mutation_Response>>>;
  /** update data of the table: "in_mail_usage" */
  update_in_mail_usage?: Maybe<In_Mail_Usage_Mutation_Response>;
  /** update single row of the table: "in_mail_usage" */
  update_in_mail_usage_by_pk?: Maybe<In_Mail_Usage>;
  /** update multiples rows of table: "in_mail_usage" */
  update_in_mail_usage_many?: Maybe<Array<Maybe<In_Mail_Usage_Mutation_Response>>>;
  /** update data of the table: "invitations" */
  update_invitations?: Maybe<Invitations_Mutation_Response>;
  /** update single row of the table: "invitations" */
  update_invitations_by_pk?: Maybe<Invitations>;
  /** update multiples rows of table: "invitations" */
  update_invitations_many?: Maybe<Array<Maybe<Invitations_Mutation_Response>>>;
  /** update data of the table: "labs" */
  update_labs?: Maybe<Labs_Mutation_Response>;
  /** update single row of the table: "labs" */
  update_labs_by_pk?: Maybe<Labs>;
  /** update multiples rows of table: "labs" */
  update_labs_many?: Maybe<Array<Maybe<Labs_Mutation_Response>>>;
  /** update data of the table: "legal_document_types" */
  update_legal_document_types?: Maybe<Legal_Document_Types_Mutation_Response>;
  /** update single row of the table: "legal_document_types" */
  update_legal_document_types_by_pk?: Maybe<Legal_Document_Types>;
  /** update multiples rows of table: "legal_document_types" */
  update_legal_document_types_many?: Maybe<Array<Maybe<Legal_Document_Types_Mutation_Response>>>;
  /** update data of the table: "legal_document_update_notifications" */
  update_legal_document_update_notifications?: Maybe<Legal_Document_Update_Notifications_Mutation_Response>;
  /** update single row of the table: "legal_document_update_notifications" */
  update_legal_document_update_notifications_by_pk?: Maybe<Legal_Document_Update_Notifications>;
  /** update multiples rows of table: "legal_document_update_notifications" */
  update_legal_document_update_notifications_many?: Maybe<Array<Maybe<Legal_Document_Update_Notifications_Mutation_Response>>>;
  /** update data of the table: "legal_documents" */
  update_legal_documents?: Maybe<Legal_Documents_Mutation_Response>;
  /** update single row of the table: "legal_documents" */
  update_legal_documents_by_pk?: Maybe<Legal_Documents>;
  /** update multiples rows of table: "legal_documents" */
  update_legal_documents_many?: Maybe<Array<Maybe<Legal_Documents_Mutation_Response>>>;
  /** update data of the table: "medical_schools" */
  update_medical_schools?: Maybe<Medical_Schools_Mutation_Response>;
  /** update single row of the table: "medical_schools" */
  update_medical_schools_by_pk?: Maybe<Medical_Schools>;
  /** update multiples rows of table: "medical_schools" */
  update_medical_schools_many?: Maybe<Array<Maybe<Medical_Schools_Mutation_Response>>>;
  /** update data of the table: "medications" */
  update_medications?: Maybe<Medications_Mutation_Response>;
  /** update single row of the table: "medications" */
  update_medications_by_pk?: Maybe<Medications>;
  /** update multiples rows of table: "medications" */
  update_medications_many?: Maybe<Array<Maybe<Medications_Mutation_Response>>>;
  /** update data of the table: "molecular_tests" */
  update_molecular_tests?: Maybe<Molecular_Tests_Mutation_Response>;
  /** update single row of the table: "molecular_tests" */
  update_molecular_tests_by_pk?: Maybe<Molecular_Tests>;
  /** update multiples rows of table: "molecular_tests" */
  update_molecular_tests_many?: Maybe<Array<Maybe<Molecular_Tests_Mutation_Response>>>;
  /** update data of the table: "mosaic_tests" */
  update_mosaic_tests?: Maybe<Mosaic_Tests_Mutation_Response>;
  /** update single row of the table: "mosaic_tests" */
  update_mosaic_tests_by_pk?: Maybe<Mosaic_Tests>;
  /** update multiples rows of table: "mosaic_tests" */
  update_mosaic_tests_many?: Maybe<Array<Maybe<Mosaic_Tests_Mutation_Response>>>;
  /** update data of the table: "nabla_notes" */
  update_nabla_notes?: Maybe<Nabla_Notes_Mutation_Response>;
  /** update single row of the table: "nabla_notes" */
  update_nabla_notes_by_pk?: Maybe<Nabla_Notes>;
  /** update multiples rows of table: "nabla_notes" */
  update_nabla_notes_many?: Maybe<Array<Maybe<Nabla_Notes_Mutation_Response>>>;
  /** update data of the table: "npi_registry_data" */
  update_npi_registry_data?: Maybe<Npi_Registry_Data_Mutation_Response>;
  /** update single row of the table: "npi_registry_data" */
  update_npi_registry_data_by_pk?: Maybe<Npi_Registry_Data>;
  /** update multiples rows of table: "npi_registry_data" */
  update_npi_registry_data_many?: Maybe<Array<Maybe<Npi_Registry_Data_Mutation_Response>>>;
  /** update data of the table: "order_payments" */
  update_order_payments?: Maybe<Order_Payments_Mutation_Response>;
  /** update single row of the table: "order_payments" */
  update_order_payments_by_pk?: Maybe<Order_Payments>;
  /** update multiples rows of table: "order_payments" */
  update_order_payments_many?: Maybe<Array<Maybe<Order_Payments_Mutation_Response>>>;
  /** update data of the table: "order_products" */
  update_order_products?: Maybe<Order_Products_Mutation_Response>;
  /** update single row of the table: "order_products" */
  update_order_products_by_pk?: Maybe<Order_Products>;
  /** update multiples rows of table: "order_products" */
  update_order_products_many?: Maybe<Array<Maybe<Order_Products_Mutation_Response>>>;
  /** update data of the table: "order_status_history" */
  update_order_status_history?: Maybe<Order_Status_History_Mutation_Response>;
  /** update single row of the table: "order_status_history" */
  update_order_status_history_by_pk?: Maybe<Order_Status_History>;
  /** update multiples rows of table: "order_status_history" */
  update_order_status_history_many?: Maybe<Array<Maybe<Order_Status_History_Mutation_Response>>>;
  /** update data of the table: "orders" */
  update_orders?: Maybe<Orders_Mutation_Response>;
  /** update single row of the table: "orders" */
  update_orders_by_pk?: Maybe<Orders>;
  /** update multiples rows of table: "orders" */
  update_orders_many?: Maybe<Array<Maybe<Orders_Mutation_Response>>>;
  /** update data of the table: "orders_view" */
  update_orders_view?: Maybe<Orders_View_Mutation_Response>;
  /** update multiples rows of table: "orders_view" */
  update_orders_view_many?: Maybe<Array<Maybe<Orders_View_Mutation_Response>>>;
  /** update data of the table: "patient_achievement_events" */
  update_patient_achievement_events?: Maybe<Patient_Achievement_Events_Mutation_Response>;
  /** update single row of the table: "patient_achievement_events" */
  update_patient_achievement_events_by_pk?: Maybe<Patient_Achievement_Events>;
  /** update multiples rows of table: "patient_achievement_events" */
  update_patient_achievement_events_many?: Maybe<Array<Maybe<Patient_Achievement_Events_Mutation_Response>>>;
  /** update data of the table: "patient_achievement_progress" */
  update_patient_achievement_progress?: Maybe<Patient_Achievement_Progress_Mutation_Response>;
  /** update single row of the table: "patient_achievement_progress" */
  update_patient_achievement_progress_by_pk?: Maybe<Patient_Achievement_Progress>;
  /** update multiples rows of table: "patient_achievement_progress" */
  update_patient_achievement_progress_many?: Maybe<Array<Maybe<Patient_Achievement_Progress_Mutation_Response>>>;
  /** update data of the table: "patient_achievement_unlocks" */
  update_patient_achievement_unlocks?: Maybe<Patient_Achievement_Unlocks_Mutation_Response>;
  /** update single row of the table: "patient_achievement_unlocks" */
  update_patient_achievement_unlocks_by_pk?: Maybe<Patient_Achievement_Unlocks>;
  /** update multiples rows of table: "patient_achievement_unlocks" */
  update_patient_achievement_unlocks_many?: Maybe<Array<Maybe<Patient_Achievement_Unlocks_Mutation_Response>>>;
  /** update data of the table: "payment_transaction_orders" */
  update_payment_transaction_orders?: Maybe<Payment_Transaction_Orders_Mutation_Response>;
  /** update single row of the table: "payment_transaction_orders" */
  update_payment_transaction_orders_by_pk?: Maybe<Payment_Transaction_Orders>;
  /** update multiples rows of table: "payment_transaction_orders" */
  update_payment_transaction_orders_many?: Maybe<Array<Maybe<Payment_Transaction_Orders_Mutation_Response>>>;
  /** update data of the table: "payment_transactions" */
  update_payment_transactions?: Maybe<Payment_Transactions_Mutation_Response>;
  /** update single row of the table: "payment_transactions" */
  update_payment_transactions_by_pk?: Maybe<Payment_Transactions>;
  /** update multiples rows of table: "payment_transactions" */
  update_payment_transactions_many?: Maybe<Array<Maybe<Payment_Transactions_Mutation_Response>>>;
  /** update data of the table: "pending_patient_zrt" */
  update_pending_patient_zrt?: Maybe<Pending_Patient_Zrt_Mutation_Response>;
  /** update single row of the table: "pending_patient_zrt" */
  update_pending_patient_zrt_by_pk?: Maybe<Pending_Patient_Zrt>;
  /** update multiples rows of table: "pending_patient_zrt" */
  update_pending_patient_zrt_many?: Maybe<Array<Maybe<Pending_Patient_Zrt_Mutation_Response>>>;
  /** update data of the table: "persona_inquiries" */
  update_persona_inquiries?: Maybe<Persona_Inquiries_Mutation_Response>;
  /** update single row of the table: "persona_inquiries" */
  update_persona_inquiries_by_pk?: Maybe<Persona_Inquiries>;
  /** update multiples rows of table: "persona_inquiries" */
  update_persona_inquiries_many?: Maybe<Array<Maybe<Persona_Inquiries_Mutation_Response>>>;
  /** update data of the table: "persona_inquiry_status" */
  update_persona_inquiry_status?: Maybe<Persona_Inquiry_Status_Mutation_Response>;
  /** update single row of the table: "persona_inquiry_status" */
  update_persona_inquiry_status_by_pk?: Maybe<Persona_Inquiry_Status>;
  /** update multiples rows of table: "persona_inquiry_status" */
  update_persona_inquiry_status_many?: Maybe<Array<Maybe<Persona_Inquiry_Status_Mutation_Response>>>;
  /** update data of the table: "products" */
  update_products?: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk?: Maybe<Products>;
  /** update multiples rows of table: "products" */
  update_products_many?: Maybe<Array<Maybe<Products_Mutation_Response>>>;
  /** update data of the table: "provider_billing" */
  update_provider_billing?: Maybe<Provider_Billing_Mutation_Response>;
  /** update single row of the table: "provider_billing" */
  update_provider_billing_by_pk?: Maybe<Provider_Billing>;
  /** update multiples rows of table: "provider_billing" */
  update_provider_billing_many?: Maybe<Array<Maybe<Provider_Billing_Mutation_Response>>>;
  /** update data of the table: "provider_dea_licenses" */
  update_provider_dea_licenses?: Maybe<Provider_Dea_Licenses_Mutation_Response>;
  /** update single row of the table: "provider_dea_licenses" */
  update_provider_dea_licenses_by_pk?: Maybe<Provider_Dea_Licenses>;
  /** update multiples rows of table: "provider_dea_licenses" */
  update_provider_dea_licenses_many?: Maybe<Array<Maybe<Provider_Dea_Licenses_Mutation_Response>>>;
  /** update data of the table: "provider_payments" */
  update_provider_payments?: Maybe<Provider_Payments_Mutation_Response>;
  /** update single row of the table: "provider_payments" */
  update_provider_payments_by_pk?: Maybe<Provider_Payments>;
  /** update multiples rows of table: "provider_payments" */
  update_provider_payments_many?: Maybe<Array<Maybe<Provider_Payments_Mutation_Response>>>;
  /** update data of the table: "provider_payouts" */
  update_provider_payouts?: Maybe<Provider_Payouts_Mutation_Response>;
  /** update multiples rows of table: "provider_payouts" */
  update_provider_payouts_many?: Maybe<Array<Maybe<Provider_Payouts_Mutation_Response>>>;
  /** update data of the table: "provider_state_licenses" */
  update_provider_state_licenses?: Maybe<Provider_State_Licenses_Mutation_Response>;
  /** update single row of the table: "provider_state_licenses" */
  update_provider_state_licenses_by_pk?: Maybe<Provider_State_Licenses>;
  /** update multiples rows of table: "provider_state_licenses" */
  update_provider_state_licenses_many?: Maybe<Array<Maybe<Provider_State_Licenses_Mutation_Response>>>;
  /** update data of the table: "provider_unread_external_notification_counts" */
  update_provider_unread_external_notification_counts?: Maybe<Provider_Unread_External_Notification_Counts_Mutation_Response>;
  /** update single row of the table: "provider_unread_external_notification_counts" */
  update_provider_unread_external_notification_counts_by_pk?: Maybe<Provider_Unread_External_Notification_Counts>;
  /** update multiples rows of table: "provider_unread_external_notification_counts" */
  update_provider_unread_external_notification_counts_many?: Maybe<Array<Maybe<Provider_Unread_External_Notification_Counts_Mutation_Response>>>;
  /** update data of the table: "question_measurement_units" */
  update_question_measurement_units?: Maybe<Question_Measurement_Units_Mutation_Response>;
  /** update single row of the table: "question_measurement_units" */
  update_question_measurement_units_by_pk?: Maybe<Question_Measurement_Units>;
  /** update multiples rows of table: "question_measurement_units" */
  update_question_measurement_units_many?: Maybe<Array<Maybe<Question_Measurement_Units_Mutation_Response>>>;
  /** update data of the table: "question_types" */
  update_question_types?: Maybe<Question_Types_Mutation_Response>;
  /** update single row of the table: "question_types" */
  update_question_types_by_pk?: Maybe<Question_Types>;
  /** update multiples rows of table: "question_types" */
  update_question_types_many?: Maybe<Array<Maybe<Question_Types_Mutation_Response>>>;
  /** update data of the table: "question_ui_control_helper_text_position" */
  update_question_ui_control_helper_text_position?: Maybe<Question_Ui_Control_Helper_Text_Position_Mutation_Response>;
  /** update single row of the table: "question_ui_control_helper_text_position" */
  update_question_ui_control_helper_text_position_by_pk?: Maybe<Question_Ui_Control_Helper_Text_Position>;
  /** update multiples rows of table: "question_ui_control_helper_text_position" */
  update_question_ui_control_helper_text_position_many?: Maybe<Array<Maybe<Question_Ui_Control_Helper_Text_Position_Mutation_Response>>>;
  /** update data of the table: "question_ui_control_types" */
  update_question_ui_control_types?: Maybe<Question_Ui_Control_Types_Mutation_Response>;
  /** update single row of the table: "question_ui_control_types" */
  update_question_ui_control_types_by_pk?: Maybe<Question_Ui_Control_Types>;
  /** update multiples rows of table: "question_ui_control_types" */
  update_question_ui_control_types_many?: Maybe<Array<Maybe<Question_Ui_Control_Types_Mutation_Response>>>;
  /** update data of the table: "questionnaire_questions" */
  update_questionnaire_questions?: Maybe<Questionnaire_Questions_Mutation_Response>;
  /** update single row of the table: "questionnaire_questions" */
  update_questionnaire_questions_by_pk?: Maybe<Questionnaire_Questions>;
  /** update multiples rows of table: "questionnaire_questions" */
  update_questionnaire_questions_many?: Maybe<Array<Maybe<Questionnaire_Questions_Mutation_Response>>>;
  /** update data of the table: "questionnaire_reminders" */
  update_questionnaire_reminders?: Maybe<Questionnaire_Reminders_Mutation_Response>;
  /** update single row of the table: "questionnaire_reminders" */
  update_questionnaire_reminders_by_pk?: Maybe<Questionnaire_Reminders>;
  /** update multiples rows of table: "questionnaire_reminders" */
  update_questionnaire_reminders_many?: Maybe<Array<Maybe<Questionnaire_Reminders_Mutation_Response>>>;
  /** update data of the table: "questionnaire_responses" */
  update_questionnaire_responses?: Maybe<Questionnaire_Responses_Mutation_Response>;
  /** update single row of the table: "questionnaire_responses" */
  update_questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** update multiples rows of table: "questionnaire_responses" */
  update_questionnaire_responses_many?: Maybe<Array<Maybe<Questionnaire_Responses_Mutation_Response>>>;
  /** update data of the table: "questionnaires" */
  update_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** update single row of the table: "questionnaires" */
  update_questionnaires_by_pk?: Maybe<Questionnaires>;
  /** update multiples rows of table: "questionnaires" */
  update_questionnaires_many?: Maybe<Array<Maybe<Questionnaires_Mutation_Response>>>;
  /** update data of the table: "questions" */
  update_questions?: Maybe<Questions_Mutation_Response>;
  /** update single row of the table: "questions" */
  update_questions_by_pk?: Maybe<Questions>;
  /** update multiples rows of table: "questions" */
  update_questions_many?: Maybe<Array<Maybe<Questions_Mutation_Response>>>;
  /** update data of the table: "recommendations" */
  update_recommendations?: Maybe<Recommendations_Mutation_Response>;
  /** update single row of the table: "recommendations" */
  update_recommendations_by_pk?: Maybe<Recommendations>;
  /** update multiples rows of table: "recommendations" */
  update_recommendations_many?: Maybe<Array<Maybe<Recommendations_Mutation_Response>>>;
  /** update data of the table: "shipmonk_sync_metadata" */
  update_shipmonk_sync_metadata?: Maybe<Shipmonk_Sync_Metadata_Mutation_Response>;
  /** update single row of the table: "shipmonk_sync_metadata" */
  update_shipmonk_sync_metadata_by_pk?: Maybe<Shipmonk_Sync_Metadata>;
  /** update multiples rows of table: "shipmonk_sync_metadata" */
  update_shipmonk_sync_metadata_many?: Maybe<Array<Maybe<Shipmonk_Sync_Metadata_Mutation_Response>>>;
  /** update data of the table: "skintelligent_tests" */
  update_skintelligent_tests?: Maybe<Skintelligent_Tests_Mutation_Response>;
  /** update single row of the table: "skintelligent_tests" */
  update_skintelligent_tests_by_pk?: Maybe<Skintelligent_Tests>;
  /** update multiples rows of table: "skintelligent_tests" */
  update_skintelligent_tests_many?: Maybe<Array<Maybe<Skintelligent_Tests_Mutation_Response>>>;
  /** update data of the table: "stripe_billing_plans" */
  update_stripe_billing_plans?: Maybe<Stripe_Billing_Plans_Mutation_Response>;
  /** update single row of the table: "stripe_billing_plans" */
  update_stripe_billing_plans_by_pk?: Maybe<Stripe_Billing_Plans>;
  /** update multiples rows of table: "stripe_billing_plans" */
  update_stripe_billing_plans_many?: Maybe<Array<Maybe<Stripe_Billing_Plans_Mutation_Response>>>;
  /** update data of the table: "stripe_customers" */
  update_stripe_customers?: Maybe<Stripe_Customers_Mutation_Response>;
  /** update single row of the table: "stripe_customers" */
  update_stripe_customers_by_pk?: Maybe<Stripe_Customers>;
  /** update multiples rows of table: "stripe_customers" */
  update_stripe_customers_many?: Maybe<Array<Maybe<Stripe_Customers_Mutation_Response>>>;
  /** update data of the table: "stripe_payment_intents" */
  update_stripe_payment_intents?: Maybe<Stripe_Payment_Intents_Mutation_Response>;
  /** update single row of the table: "stripe_payment_intents" */
  update_stripe_payment_intents_by_pk?: Maybe<Stripe_Payment_Intents>;
  /** update multiples rows of table: "stripe_payment_intents" */
  update_stripe_payment_intents_many?: Maybe<Array<Maybe<Stripe_Payment_Intents_Mutation_Response>>>;
  /** update data of the table: "stripe_payment_methods" */
  update_stripe_payment_methods?: Maybe<Stripe_Payment_Methods_Mutation_Response>;
  /** update single row of the table: "stripe_payment_methods" */
  update_stripe_payment_methods_by_pk?: Maybe<Stripe_Payment_Methods>;
  /** update multiples rows of table: "stripe_payment_methods" */
  update_stripe_payment_methods_many?: Maybe<Array<Maybe<Stripe_Payment_Methods_Mutation_Response>>>;
  /** update data of the table: "stripe_subscriptions" */
  update_stripe_subscriptions?: Maybe<Stripe_Subscriptions_Mutation_Response>;
  /** update single row of the table: "stripe_subscriptions" */
  update_stripe_subscriptions_by_pk?: Maybe<Stripe_Subscriptions>;
  /** update multiples rows of table: "stripe_subscriptions" */
  update_stripe_subscriptions_many?: Maybe<Array<Maybe<Stripe_Subscriptions_Mutation_Response>>>;
  /** update data of the table: "stripe_transaction" */
  update_stripe_transaction?: Maybe<Stripe_Transaction_Mutation_Response>;
  /** update single row of the table: "stripe_transaction" */
  update_stripe_transaction_by_pk?: Maybe<Stripe_Transaction>;
  /** update multiples rows of table: "stripe_transaction" */
  update_stripe_transaction_many?: Maybe<Array<Maybe<Stripe_Transaction_Mutation_Response>>>;
  /** update data of the table: "support_chat_usage" */
  update_support_chat_usage?: Maybe<Support_Chat_Usage_Mutation_Response>;
  /** update single row of the table: "support_chat_usage" */
  update_support_chat_usage_by_pk?: Maybe<Support_Chat_Usage>;
  /** update multiples rows of table: "support_chat_usage" */
  update_support_chat_usage_many?: Maybe<Array<Maybe<Support_Chat_Usage_Mutation_Response>>>;
  /** update data of the table: "swab_code_statuses" */
  update_swab_code_statuses?: Maybe<Swab_Code_Statuses_Mutation_Response>;
  /** update single row of the table: "swab_code_statuses" */
  update_swab_code_statuses_by_pk?: Maybe<Swab_Code_Statuses>;
  /** update multiples rows of table: "swab_code_statuses" */
  update_swab_code_statuses_many?: Maybe<Array<Maybe<Swab_Code_Statuses_Mutation_Response>>>;
  /** update data of the table: "swab_codes" */
  update_swab_codes?: Maybe<Swab_Codes_Mutation_Response>;
  /** update single row of the table: "swab_codes" */
  update_swab_codes_by_pk?: Maybe<Swab_Codes>;
  /** update multiples rows of table: "swab_codes" */
  update_swab_codes_many?: Maybe<Array<Maybe<Swab_Codes_Mutation_Response>>>;
  /** update data of the table: "swab_usage_type" */
  update_swab_usage_type?: Maybe<Swab_Usage_Type_Mutation_Response>;
  /** update single row of the table: "swab_usage_type" */
  update_swab_usage_type_by_pk?: Maybe<Swab_Usage_Type>;
  /** update multiples rows of table: "swab_usage_type" */
  update_swab_usage_type_many?: Maybe<Array<Maybe<Swab_Usage_Type_Mutation_Response>>>;
  /** update data of the table: "test_definitions" */
  update_test_definitions?: Maybe<Test_Definitions_Mutation_Response>;
  /** update single row of the table: "test_definitions" */
  update_test_definitions_by_pk?: Maybe<Test_Definitions>;
  /** update multiples rows of table: "test_definitions" */
  update_test_definitions_many?: Maybe<Array<Maybe<Test_Definitions_Mutation_Response>>>;
  /** update data of the table: "test_e_prescribe_npis" */
  update_test_e_prescribe_npis?: Maybe<Test_E_Prescribe_Npis_Mutation_Response>;
  /** update single row of the table: "test_e_prescribe_npis" */
  update_test_e_prescribe_npis_by_pk?: Maybe<Test_E_Prescribe_Npis>;
  /** update multiples rows of table: "test_e_prescribe_npis" */
  update_test_e_prescribe_npis_many?: Maybe<Array<Maybe<Test_E_Prescribe_Npis_Mutation_Response>>>;
  /** update data of the table: "test_kits_update_states_summary_log" */
  update_test_kits_update_states_summary_log?: Maybe<Test_Kits_Update_States_Summary_Log_Mutation_Response>;
  /** update single row of the table: "test_kits_update_states_summary_log" */
  update_test_kits_update_states_summary_log_by_pk?: Maybe<Test_Kits_Update_States_Summary_Log>;
  /** update multiples rows of table: "test_kits_update_states_summary_log" */
  update_test_kits_update_states_summary_log_many?: Maybe<Array<Maybe<Test_Kits_Update_States_Summary_Log_Mutation_Response>>>;
  /** update data of the table: "test_types" */
  update_test_types?: Maybe<Test_Types_Mutation_Response>;
  /** update single row of the table: "test_types" */
  update_test_types_by_pk?: Maybe<Test_Types>;
  /** update multiples rows of table: "test_types" */
  update_test_types_many?: Maybe<Array<Maybe<Test_Types_Mutation_Response>>>;
  /** update data of the table: "tests" */
  update_tests?: Maybe<Tests_Mutation_Response>;
  /** update single row of the table: "tests" */
  update_tests_by_pk?: Maybe<Tests>;
  /** update multiples rows of table: "tests" */
  update_tests_many?: Maybe<Array<Maybe<Tests_Mutation_Response>>>;
  /** update data of the table: "text_addresses" */
  update_text_addresses?: Maybe<Text_Addresses_Mutation_Response>;
  /** update single row of the table: "text_addresses" */
  update_text_addresses_by_pk?: Maybe<Text_Addresses>;
  /** update multiples rows of table: "text_addresses" */
  update_text_addresses_many?: Maybe<Array<Maybe<Text_Addresses_Mutation_Response>>>;
  /** update data of the table: "unauthenticated_questionnaire_questions" */
  update_unauthenticated_questionnaire_questions?: Maybe<Unauthenticated_Questionnaire_Questions_Mutation_Response>;
  /** update single row of the table: "unauthenticated_questionnaire_questions" */
  update_unauthenticated_questionnaire_questions_by_pk?: Maybe<Unauthenticated_Questionnaire_Questions>;
  /** update multiples rows of table: "unauthenticated_questionnaire_questions" */
  update_unauthenticated_questionnaire_questions_many?: Maybe<Array<Maybe<Unauthenticated_Questionnaire_Questions_Mutation_Response>>>;
  /** update data of the table: "unauthenticated_questionnaires" */
  update_unauthenticated_questionnaires?: Maybe<Unauthenticated_Questionnaires_Mutation_Response>;
  /** update single row of the table: "unauthenticated_questionnaires" */
  update_unauthenticated_questionnaires_by_pk?: Maybe<Unauthenticated_Questionnaires>;
  /** update multiples rows of table: "unauthenticated_questionnaires" */
  update_unauthenticated_questionnaires_many?: Maybe<Array<Maybe<Unauthenticated_Questionnaires_Mutation_Response>>>;
  /** update data of the table: "unauthenticated_questions" */
  update_unauthenticated_questions?: Maybe<Unauthenticated_Questions_Mutation_Response>;
  /** update single row of the table: "unauthenticated_questions" */
  update_unauthenticated_questions_by_pk?: Maybe<Unauthenticated_Questions>;
  /** update multiples rows of table: "unauthenticated_questions" */
  update_unauthenticated_questions_many?: Maybe<Array<Maybe<Unauthenticated_Questions_Mutation_Response>>>;
  /** update data of the table: "universities" */
  update_universities?: Maybe<Universities_Mutation_Response>;
  /** update single row of the table: "universities" */
  update_universities_by_pk?: Maybe<Universities>;
  /** update multiples rows of table: "universities" */
  update_universities_many?: Maybe<Array<Maybe<Universities_Mutation_Response>>>;
  /** update data of the table: "used_test_e_prescribe_licenses" */
  update_used_test_e_prescribe_licenses?: Maybe<Used_Test_E_Prescribe_Licenses_Mutation_Response>;
  /** update single row of the table: "used_test_e_prescribe_licenses" */
  update_used_test_e_prescribe_licenses_by_pk?: Maybe<Used_Test_E_Prescribe_Licenses>;
  /** update multiples rows of table: "used_test_e_prescribe_licenses" */
  update_used_test_e_prescribe_licenses_many?: Maybe<Array<Maybe<Used_Test_E_Prescribe_Licenses_Mutation_Response>>>;
  /** update data of the table: "user_addresses" */
  update_user_addresses?: Maybe<User_Addresses_Mutation_Response>;
  /** update single row of the table: "user_addresses" */
  update_user_addresses_by_pk?: Maybe<User_Addresses>;
  /** update multiples rows of table: "user_addresses" */
  update_user_addresses_many?: Maybe<Array<Maybe<User_Addresses_Mutation_Response>>>;
  /** update data of the table: "user_agreements" */
  update_user_agreements?: Maybe<User_Agreements_Mutation_Response>;
  /** update single row of the table: "user_agreements" */
  update_user_agreements_by_pk?: Maybe<User_Agreements>;
  /** update multiples rows of table: "user_agreements" */
  update_user_agreements_many?: Maybe<Array<Maybe<User_Agreements_Mutation_Response>>>;
  /** update data of the table: "user_auth_provider_types" */
  update_user_auth_provider_types?: Maybe<User_Auth_Provider_Types_Mutation_Response>;
  /** update single row of the table: "user_auth_provider_types" */
  update_user_auth_provider_types_by_pk?: Maybe<User_Auth_Provider_Types>;
  /** update multiples rows of table: "user_auth_provider_types" */
  update_user_auth_provider_types_many?: Maybe<Array<Maybe<User_Auth_Provider_Types_Mutation_Response>>>;
  /** update data of the table: "user_auth_providers" */
  update_user_auth_providers?: Maybe<User_Auth_Providers_Mutation_Response>;
  /** update single row of the table: "user_auth_providers" */
  update_user_auth_providers_by_pk?: Maybe<User_Auth_Providers>;
  /** update multiples rows of table: "user_auth_providers" */
  update_user_auth_providers_many?: Maybe<Array<Maybe<User_Auth_Providers_Mutation_Response>>>;
  /** update data of the table: "user_auth_tokens" */
  update_user_auth_tokens?: Maybe<User_Auth_Tokens_Mutation_Response>;
  /** update single row of the table: "user_auth_tokens" */
  update_user_auth_tokens_by_pk?: Maybe<User_Auth_Tokens>;
  /** update multiples rows of table: "user_auth_tokens" */
  update_user_auth_tokens_many?: Maybe<Array<Maybe<User_Auth_Tokens_Mutation_Response>>>;
  /** update data of the table: "user_communication_deliveries" */
  update_user_communication_deliveries?: Maybe<User_Communication_Deliveries_Mutation_Response>;
  /** update single row of the table: "user_communication_deliveries" */
  update_user_communication_deliveries_by_pk?: Maybe<User_Communication_Deliveries>;
  /** update multiples rows of table: "user_communication_deliveries" */
  update_user_communication_deliveries_many?: Maybe<Array<Maybe<User_Communication_Deliveries_Mutation_Response>>>;
  /** update data of the table: "user_communications" */
  update_user_communications?: Maybe<User_Communications_Mutation_Response>;
  /** update single row of the table: "user_communications" */
  update_user_communications_by_pk?: Maybe<User_Communications>;
  /** update multiples rows of table: "user_communications" */
  update_user_communications_many?: Maybe<Array<Maybe<User_Communications_Mutation_Response>>>;
  /** update data of the table: "user_indicators" */
  update_user_indicators?: Maybe<User_Indicators_Mutation_Response>;
  /** update single row of the table: "user_indicators" */
  update_user_indicators_by_pk?: Maybe<User_Indicators>;
  /** update multiples rows of table: "user_indicators" */
  update_user_indicators_many?: Maybe<Array<Maybe<User_Indicators_Mutation_Response>>>;
  /** update data of the table: "user_notification_status" */
  update_user_notification_status?: Maybe<User_Notification_Status_Mutation_Response>;
  /** update single row of the table: "user_notification_status" */
  update_user_notification_status_by_pk?: Maybe<User_Notification_Status>;
  /** update multiples rows of table: "user_notification_status" */
  update_user_notification_status_many?: Maybe<Array<Maybe<User_Notification_Status_Mutation_Response>>>;
  /** update data of the table: "user_notifications" */
  update_user_notifications?: Maybe<User_Notifications_Mutation_Response>;
  /** update single row of the table: "user_notifications" */
  update_user_notifications_by_pk?: Maybe<User_Notifications>;
  /** update multiples rows of table: "user_notifications" */
  update_user_notifications_many?: Maybe<Array<Maybe<User_Notifications_Mutation_Response>>>;
  /** update data of the table: "user_push_tokens" */
  update_user_push_tokens?: Maybe<User_Push_Tokens_Mutation_Response>;
  /** update single row of the table: "user_push_tokens" */
  update_user_push_tokens_by_pk?: Maybe<User_Push_Tokens>;
  /** update multiples rows of table: "user_push_tokens" */
  update_user_push_tokens_many?: Maybe<Array<Maybe<User_Push_Tokens_Mutation_Response>>>;
  /** update data of the table: "user_scanned_data" */
  update_user_scanned_data?: Maybe<User_Scanned_Data_Mutation_Response>;
  /** update single row of the table: "user_scanned_data" */
  update_user_scanned_data_by_pk?: Maybe<User_Scanned_Data>;
  /** update multiples rows of table: "user_scanned_data" */
  update_user_scanned_data_many?: Maybe<Array<Maybe<User_Scanned_Data_Mutation_Response>>>;
  /** update data of the table: "user_settings" */
  update_user_settings?: Maybe<User_Settings_Mutation_Response>;
  /** update single row of the table: "user_settings" */
  update_user_settings_by_pk?: Maybe<User_Settings>;
  /** update multiples rows of table: "user_settings" */
  update_user_settings_many?: Maybe<Array<Maybe<User_Settings_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "vonage_appointment" */
  update_vonage_appointment?: Maybe<Vonage_Appointment_Mutation_Response>;
  /** update single row of the table: "vonage_appointment" */
  update_vonage_appointment_by_pk?: Maybe<Vonage_Appointment>;
  /** update multiples rows of table: "vonage_appointment" */
  update_vonage_appointment_many?: Maybe<Array<Maybe<Vonage_Appointment_Mutation_Response>>>;
  /** update data of the table: "zrt_tests" */
  update_zrt_tests?: Maybe<Zrt_Tests_Mutation_Response>;
  /** update single row of the table: "zrt_tests" */
  update_zrt_tests_by_pk?: Maybe<Zrt_Tests>;
  /** update multiples rows of table: "zrt_tests" */
  update_zrt_tests_many?: Maybe<Array<Maybe<Zrt_Tests_Mutation_Response>>>;
  upsertEducationCourse: HttpStatusOutput;
};


/** mutation root */
export type Mutation_RootAccountDeletionArgs = {
  account?: InputMaybe<AccountDeletionInput>;
};


/** mutation root */
export type Mutation_RootAddSwabCodesArgs = {
  input: AddSwabCodesInput;
};


/** mutation root */
export type Mutation_RootConnectStripeAccountArgs = {
  connectStripeAccountInput?: InputMaybe<ConnectStripeAccountInput>;
};


/** mutation root */
export type Mutation_RootCreateCalendarAndDefineRegularHoursArgs = {
  createCalendarAndDefineRegularHoursInput?: InputMaybe<CreateCalendarAndDefineRegularHoursInput>;
};


/** mutation root */
export type Mutation_RootExportProviderDataArgs = {
  userCodexId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootExportUserDataArgs = {
  userCodexId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGetAcuityCalendarInformationArgs = {
  providerId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGetEncounterSignUrlFromStorageArgs = {
  filePath?: InputMaybe<GetEncounterSignedUrlInput>;
};


/** mutation root */
export type Mutation_RootGetPersonaSessionTokenArgs = {
  inquiryId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootGetProviderPatientSignedUrlArgs = {
  fileId: Scalars['String'];
  patientCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGetSignUrlFormStorageArgs = {
  fileId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGetSignUrlFromStorageByAdminArgs = {
  filePath?: InputMaybe<GetSignUrlFromStorageByAdminInput>;
};


/** mutation root */
export type Mutation_RootGetVonageArchivesArgs = {
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGetVonageSessionArgs = {
  room: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGetVonageSignUrlFormStorageArgs = {
  appointmentId: Scalars['String'];
  fileId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRegisterAuthProviderArgs = {
  provider?: InputMaybe<AuthProviderInput>;
};


/** mutation root */
export type Mutation_RootRegisterDiagnosticSolutionTestKitArgs = {
  registerTestKitDto?: InputMaybe<RegisterDiagnosticSolutionTestKitInput>;
};


/** mutation root */
export type Mutation_RootRegisterDnaVitaminTestKitArgs = {
  registerTestKitDto?: InputMaybe<RegisterDnaVitaminTestKitInput>;
};


/** mutation root */
export type Mutation_RootRegisterGoogleMeetArgs = {
  body: RegisterGoogleMeetInput;
};


/** mutation root */
export type Mutation_RootRegisterMosaicTestKitArgs = {
  registerTestKitDto?: InputMaybe<RegisterMosaicTestKitInput>;
};


/** mutation root */
export type Mutation_RootRegisterPatchProviderArgs = {
  providerData?: InputMaybe<ProviderRegisterPatchInput>;
};


/** mutation root */
export type Mutation_RootRegisterProviderAcuityCalendarInformationArgs = {
  calendarInformation?: InputMaybe<RegisterProviderCalendarInput>;
};


/** mutation root */
export type Mutation_RootRegisterTestKitArgs = {
  testKit?: InputMaybe<RegisterTestKitInput>;
};


/** mutation root */
export type Mutation_RootSaveDnaScannedDataArgs = {
  dnaScannedData?: InputMaybe<SaveDnaScannedDataInput>;
};


/** mutation root */
export type Mutation_RootSaveQuestionnaireArgs = {
  questionnaire?: InputMaybe<SaveQuestionnaireInput>;
};


/** mutation root */
export type Mutation_RootSignupDelegatedAdminArgs = {
  delegatedAdminData?: InputMaybe<DelegatedAdminSignupInput>;
};


/** mutation root */
export type Mutation_RootSignupProviderArgs = {
  providerData?: InputMaybe<ProviderSignupInput>;
};


/** mutation root */
export type Mutation_RootSignupUserArgs = {
  userData?: InputMaybe<UserSignupInput>;
};


/** mutation root */
export type Mutation_RootUpdateAvailabilityOverridesArgs = {
  updateAvailabilityOverridesInput: UpdateAvailabilityOverridesInput;
};


/** mutation root */
export type Mutation_RootUpdateCalendarRegularHoursArgs = {
  updateCalendarRegularHoursInput?: InputMaybe<UpdateCalendarRegularHoursInput>;
};


/** mutation root */
export type Mutation_RootUpdateInAppNotificationArgs = {
  notification?: InputMaybe<UpdateInAppNotificationInput>;
};


/** mutation root */
export type Mutation_RootUpdateProfilePictureArgs = {
  image?: InputMaybe<UpdateProfilePictureInput>;
};


/** mutation root */
export type Mutation_RootUpdateProviderArgs = {
  providerData?: InputMaybe<UpdateProviderInput>;
};


/** mutation root */
export type Mutation_RootUpdateProviderAccountSettingsArgs = {
  accountSettings?: InputMaybe<UpdateProviderAccountSettingsInput>;
};


/** mutation root */
export type Mutation_RootUpdateProviderProfilePictureArgs = {
  image?: InputMaybe<UpdateProfilePictureInput>;
};


/** mutation root */
export type Mutation_RootUpdateQuestionnaireArgs = {
  questionnaire?: InputMaybe<UpdateQuestionnaireInput>;
};


/** mutation root */
export type Mutation_RootUploadCapturedImageArgs = {
  image?: InputMaybe<UploadImageInput>;
};


/** mutation root */
export type Mutation_RootValidateCustomTokenArgs = {
  token?: InputMaybe<CustomTokenInput>;
};


/** mutation root */
export type Mutation_RootVonageCaptionsStartArgs = {
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootVonageCaptionsStopArgs = {
  sessionId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAcceptChildAdultTransitionInvitationArgs = {
  input: AcceptChildAdultTransitionInvitationInput;
};


/** mutation root */
export type Mutation_RootAcceptLegalDocumentArgs = {
  input: AcceptLegalDocumentInput;
};


/** mutation root */
export type Mutation_RootAcceptUserAgreementArgs = {
  input: AcceptAgreementInput;
};


/** mutation root */
export type Mutation_RootAcknowledgeAchievementUnlockArgs = {
  unlockId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootAddMessageToAppointmentMessageListArgs = {
  insertAppointmentChatMessages: InsertAppointmentChatMessages;
};


/** mutation root */
export type Mutation_RootAddMessageToAppointmentMessageListByAppointmentCodexIdArgs = {
  insertAppointmentChatMessages: InsertAppointmentChatMessagesByAppointmentCodexId;
};


/** mutation root */
export type Mutation_RootAddServiceOfferingsArgs = {
  registerPatchFHIRProviderServiceOfferingsInput: AddFhirHealthCareServiceInput;
};


/** mutation root */
export type Mutation_RootAppendEncounterToFhirAppointmentArgs = {
  appendEncounterToFHIRAppointmentInput: AppendFhirEncounterInput;
};


/** mutation root */
export type Mutation_RootArchiveOrderArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootAttachPaymentMethodArgs = {
  makeDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethodName?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootBlockUserArgs = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  userCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCancelDraftQuestionnairesByIdArgs = {
  questionnaireId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCancelFhirAppointmentArgs = {
  appointmentCodexId: Scalars['String'];
  cancelationReason: Scalars['String'];
};


/** mutation root */
export type Mutation_RootConfirmProviderPatientAgreementArgs = {
  providerCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateAppVersionArgs = {
  input: CreateAppVersionInput;
};


/** mutation root */
export type Mutation_RootCreateAppointmentMessageListArgs = {
  appointmentCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateAppointmentRequestArgs = {
  input: CreateAppointmentRequestInput;
};


/** mutation root */
export type Mutation_RootCreateBecomePatientRequestArgs = {
  providerCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateCartProductArgs = {
  input: CreateCartProductInput;
};


/** mutation root */
export type Mutation_RootCreateChildAdultTransitionInvitationArgs = {
  input: CreateChildAdultTransitionInvitationInput;
};


/** mutation root */
export type Mutation_RootCreateDelegatedAdminInvitationArgs = {
  input: CreateAdminInvitationInput;
};


/** mutation root */
export type Mutation_RootCreateFhirAppointmentArgs = {
  createFHIRAppointment: CreateFhirAppointmentInput;
};


/** mutation root */
export type Mutation_RootCreateFhirAppointmentForCurrentUserArgs = {
  createFHIRAppointment: CreateFhirAppointmentInputWithoutPatientCodexId;
};


/** mutation root */
export type Mutation_RootCreateFhirDnaVisitTestArgs = {
  createFHIRDnaVisitTest: CreateFhirDnaVisitTestInputWithResponses;
};


/** mutation root */
export type Mutation_RootCreateFhirMosaicTestArgs = {
  createFHIRDnaVisitTest: CreateMosaicTestInput;
};


/** mutation root */
export type Mutation_RootCreateFhirOfficeLocationArgs = {
  createFHIROfficeLocationInput: OfficeAddressInformationInput;
};


/** mutation root */
export type Mutation_RootCreateFhirOrganizationArgs = {
  createFHIROrganizationInput: CreateFhirOrganizationInput;
};


/** mutation root */
export type Mutation_RootCreateFhirPatientArgs = {
  createFHIRPatientInput: CreateFhirPatientInput;
};


/** mutation root */
export type Mutation_RootCreateFhirProviderArgs = {
  createFHIRProviderInput: CreateFhirProviderInput;
};


/** mutation root */
export type Mutation_RootCreateFhirProviderRoleArgs = {
  createFHIRProviderRoleInput: CreateFhirProviderRoleInput;
};


/** mutation root */
export type Mutation_RootCreateFhirZrtTestArgs = {
  createFHIRZrtTest: CreateFhirZrtTestInput;
};


/** mutation root */
export type Mutation_RootCreateOrderArgs = {
  input: CreateOrderInput;
};


/** mutation root */
export type Mutation_RootCreateScheduledAppointmentArgs = {
  body: CreateScheduleAppointmentBodyInput;
  isTest?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootCreateSubPatientArgs = {
  input: CreateSubPatientInput;
};


/** mutation root */
export type Mutation_RootCreateSubscriptionArgs = {
  paymentMethodName?: InputMaybe<Scalars['String']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootDeleteAppointmentRequestArgs = {
  input: GetAppointmentRescheduleRequestInput;
};


/** mutation root */
export type Mutation_RootDeleteCartProductArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteDelegatedAdminArgs = {
  input: DelegatedAdminCodexIdInput;
};


/** mutation root */
export type Mutation_RootDeleteDeliveryAddressArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteEducationCourseArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteMediaFileArgs = {
  fileId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeletePaymentMethodArgs = {
  paymentMethodCodexId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteProductArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteProviderArgs = {
  providerEmail: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteRecommendationByRequestUserCodexIdArgs = {
  recommendationId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteUserNotificationArgs = {
  notificationId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Accepted_Legal_DocumentsArgs = {
  where: Accepted_Legal_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accepted_Legal_Documents_By_PkArgs = {
  accepted_legal_document_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Active_In_MailsArgs = {
  where: Active_In_Mails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Active_In_Mails_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Active_Support_ChatsArgs = {
  where: Active_Support_Chats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Active_Support_Chats_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_EventsArgs = {
  where: Activity_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Acuity_Provider_CalendarArgs = {
  where: Acuity_Provider_Calendar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Acuity_Provider_Calendar_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AddressesArgs = {
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Addresses_By_PkArgs = {
  address_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_PermissionsArgs = {
  where: Admin_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_Permissions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Age_Of_Majority_RulesArgs = {
  where: Age_Of_Majority_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Age_Of_Majority_Rules_By_PkArgs = {
  state_code: Scalars['bpchar'];
};


/** mutation root */
export type Mutation_RootDelete_Allergen_ClassesArgs = {
  where: Allergen_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Allergen_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_App_ToursArgs = {
  where: App_Tours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_App_Tours_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_App_VersionsArgs = {
  where: App_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_App_Versions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Appointment_Media_SignalsArgs = {
  where: Appointment_Media_Signals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appointment_Media_Signals_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Appointment_PaymentsArgs = {
  where: Appointment_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appointment_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Appointment_RequestsArgs = {
  where: Appointment_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appointment_Requests_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Appointment_Status_HistoryArgs = {
  where: Appointment_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appointment_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AppointmentsArgs = {
  where: Appointments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appointments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cart_ProductsArgs = {
  where: Cart_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cart_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Channel_SignalsArgs = {
  where: Channel_Signals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Channel_Signals_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Common_Question_ResponsesArgs = {
  where: Common_Question_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Common_Question_Responses_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Common_QuestionsArgs = {
  where: Common_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Common_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Communication_ChannelsArgs = {
  where: Communication_Channels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Communication_Channels_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CountriesArgs = {
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Auth_CodeArgs = {
  where: Custom_Auth_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Auth_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Dea_License_SchedulesArgs = {
  where: Dea_License_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dea_License_Schedules_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Delivery_AddressesArgs = {
  where: Delivery_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Delivery_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Diagnostic_Solution_TestsArgs = {
  where: Diagnostic_Solution_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Diagnostic_Solution_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Dnavisit_Test_StatusesArgs = {
  where: Dnavisit_Test_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dnavisit_Test_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Dnavisit_TestsArgs = {
  where: Dnavisit_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dnavisit_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Do_Not_Use_Production_Swab_CodesArgs = {
  where: Do_Not_Use_Production_Swab_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Do_Not_Use_Production_Swab_Codes_By_PkArgs = {
  swab_code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ecommerce_OrdersArgs = {
  where: Ecommerce_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ecommerce_Orders_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Education_CoursesArgs = {
  where: Education_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Education_Courses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Education_Module_Additional_MaterialsArgs = {
  where: Education_Module_Additional_Materials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Education_Module_Additional_Materials_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Education_Module_ItemsArgs = {
  where: Education_Module_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Education_Module_Items_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Education_ModulesArgs = {
  where: Education_Modules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Education_Modules_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_File_TypesArgs = {
  where: File_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fullscript_AllergensArgs = {
  where: Fullscript_Allergens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fullscript_Allergens_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Fullscript_CliniciansArgs = {
  where: Fullscript_Clinicians_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fullscript_Clinicians_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gale_ProductsArgs = {
  where: Gale_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gale_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Global_ConfigsArgs = {
  where: Global_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Configs_By_PkArgs = {
  name: Global_Configs_Names_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Global_Configs_NamesArgs = {
  where: Global_Configs_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Global_Configs_Names_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Image_Source_TypesArgs = {
  where: Image_Source_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Image_Source_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_In_Mail_UsageArgs = {
  where: In_Mail_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Mail_Usage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InvitationsArgs = {
  where: Invitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invitations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LabsArgs = {
  where: Labs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Labs_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Legal_Document_TypesArgs = {
  where: Legal_Document_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legal_Document_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Legal_Document_Update_NotificationsArgs = {
  where: Legal_Document_Update_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legal_Document_Update_Notifications_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Legal_DocumentsArgs = {
  where: Legal_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legal_Documents_By_PkArgs = {
  legal_document_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Medical_SchoolsArgs = {
  where: Medical_Schools_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Medical_Schools_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MedicationsArgs = {
  where: Medications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Medications_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Molecular_TestsArgs = {
  where: Molecular_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Molecular_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Mosaic_TestsArgs = {
  where: Mosaic_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mosaic_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nabla_NotesArgs = {
  where: Nabla_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nabla_Notes_By_PkArgs = {
  appointment_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Npi_Registry_DataArgs = {
  where: Npi_Registry_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Npi_Registry_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Order_PaymentsArgs = {
  where: Order_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Order_ProductsArgs = {
  where: Order_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Status_HistoryArgs = {
  where: Order_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OrdersArgs = {
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Orders_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Orders_ViewArgs = {
  where: Orders_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Achievement_EventsArgs = {
  where: Patient_Achievement_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Achievement_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Achievement_ProgressArgs = {
  where: Patient_Achievement_Progress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Achievement_Progress_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Patient_Achievement_UnlocksArgs = {
  where: Patient_Achievement_Unlocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Patient_Achievement_Unlocks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_Transaction_OrdersArgs = {
  where: Payment_Transaction_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Transaction_Orders_By_PkArgs = {
  order_id: Scalars['Int'];
  payment_transaction_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_TransactionsArgs = {
  where: Payment_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Transactions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Pending_Patient_ZrtArgs = {
  where: Pending_Patient_Zrt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pending_Patient_Zrt_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Persona_InquiriesArgs = {
  where: Persona_Inquiries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Persona_Inquiries_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Persona_Inquiry_StatusArgs = {
  where: Persona_Inquiry_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Persona_Inquiry_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_BillingArgs = {
  where: Provider_Billing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Billing_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_Dea_LicensesArgs = {
  where: Provider_Dea_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Dea_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_PaymentsArgs = {
  where: Provider_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_PayoutsArgs = {
  where: Provider_Payouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_State_LicensesArgs = {
  where: Provider_State_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_State_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Provider_Unread_External_Notification_CountsArgs = {
  where: Provider_Unread_External_Notification_Counts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Provider_Unread_External_Notification_Counts_By_PkArgs = {
  codex_provider_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Question_Measurement_UnitsArgs = {
  where: Question_Measurement_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Measurement_Units_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Question_TypesArgs = {
  where: Question_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Question_Ui_Control_Helper_Text_PositionArgs = {
  where: Question_Ui_Control_Helper_Text_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Ui_Control_Helper_Text_Position_By_PkArgs = {
  helper_text_position: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Question_Ui_Control_TypesArgs = {
  where: Question_Ui_Control_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Question_Ui_Control_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_QuestionsArgs = {
  where: Questionnaire_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Questions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_RemindersArgs = {
  where: Questionnaire_Reminders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Reminders_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_ResponsesArgs = {
  where: Questionnaire_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Responses_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionnairesArgs = {
  where: Questionnaires_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaires_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionsArgs = {
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RecommendationsArgs = {
  where: Recommendations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recommendations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Shipmonk_Sync_MetadataArgs = {
  where: Shipmonk_Sync_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Shipmonk_Sync_Metadata_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Skintelligent_TestsArgs = {
  where: Skintelligent_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skintelligent_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Billing_PlansArgs = {
  where: Stripe_Billing_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Billing_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_CustomersArgs = {
  where: Stripe_Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Customers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Payment_IntentsArgs = {
  where: Stripe_Payment_Intents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Payment_Intents_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Payment_MethodsArgs = {
  where: Stripe_Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Payment_Methods_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_SubscriptionsArgs = {
  where: Stripe_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Subscriptions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Stripe_TransactionArgs = {
  where: Stripe_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stripe_Transaction_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Support_Chat_UsageArgs = {
  where: Support_Chat_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Support_Chat_Usage_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Swab_Code_StatusesArgs = {
  where: Swab_Code_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Swab_Code_Statuses_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Swab_CodesArgs = {
  where: Swab_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Swab_Codes_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Swab_Usage_TypeArgs = {
  where: Swab_Usage_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Swab_Usage_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Test_DefinitionsArgs = {
  where: Test_Definitions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Definitions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Test_E_Prescribe_NpisArgs = {
  where: Test_E_Prescribe_Npis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_E_Prescribe_Npis_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Test_Kits_Update_States_Summary_LogArgs = {
  where: Test_Kits_Update_States_Summary_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Kits_Update_States_Summary_Log_By_PkArgs = {
  log_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Test_TypesArgs = {
  where: Test_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Test_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TestsArgs = {
  where: Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Text_AddressesArgs = {
  where: Text_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Text_Addresses_By_PkArgs = {
  address_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Unauthenticated_Questionnaire_QuestionsArgs = {
  where: Unauthenticated_Questionnaire_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unauthenticated_Questionnaire_Questions_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Unauthenticated_QuestionnairesArgs = {
  where: Unauthenticated_Questionnaires_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unauthenticated_Questionnaires_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Unauthenticated_QuestionsArgs = {
  where: Unauthenticated_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unauthenticated_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UniversitiesArgs = {
  where: Universities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Universities_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Used_Test_E_Prescribe_LicensesArgs = {
  where: Used_Test_E_Prescribe_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Used_Test_E_Prescribe_Licenses_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_AddressesArgs = {
  where: User_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Addresses_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_User_AgreementsArgs = {
  where: User_Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Provider_TypesArgs = {
  where: User_Auth_Provider_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Provider_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_ProvidersArgs = {
  where: User_Auth_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Providers_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_TokensArgs = {
  where: User_Auth_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Communication_DeliveriesArgs = {
  where: User_Communication_Deliveries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Communication_Deliveries_By_PkArgs = {
  user_communication_delivery_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_User_CommunicationsArgs = {
  where: User_Communications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Communications_By_PkArgs = {
  user_communication_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_User_IndicatorsArgs = {
  where: User_Indicators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Indicators_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_User_Notification_StatusArgs = {
  where: User_Notification_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Notification_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_NotificationsArgs = {
  where: User_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Notifications_By_PkArgs = {
  user_communication_delivery_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_User_Push_TokensArgs = {
  where: User_Push_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Push_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Scanned_DataArgs = {
  where: User_Scanned_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Scanned_Data_By_PkArgs = {
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_SettingsArgs = {
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Vonage_AppointmentArgs = {
  where: Vonage_Appointment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vonage_Appointment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Zrt_TestsArgs = {
  where: Zrt_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Zrt_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootEPrescribeJwtArgs = {
  input: EPrescribeJwtInput;
};


/** mutation root */
export type Mutation_RootEnsureAppointmentSummaryPdfArgs = {
  appointmentCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootFinishAppTourArgs = {
  appTourType: AppTourTypes;
};


/** mutation root */
export type Mutation_RootFullscriptDependentMapArgs = {
  input: MapDependentInput;
};


/** mutation root */
export type Mutation_RootGetDnaTestBySwabCodeIdWithNoErrorsArgs = {
  swab_code: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsertFhirQuestionnaireResponseArgs = {
  createQuestionnaireResponsesInput: QuestionnaireResponseInput;
};


/** mutation root */
export type Mutation_RootInsert_Accepted_Legal_DocumentsArgs = {
  objects: Array<Accepted_Legal_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Accepted_Legal_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accepted_Legal_Documents_OneArgs = {
  object: Accepted_Legal_Documents_Insert_Input;
  on_conflict?: InputMaybe<Accepted_Legal_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Active_In_MailsArgs = {
  objects: Array<Active_In_Mails_Insert_Input>;
  on_conflict?: InputMaybe<Active_In_Mails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Active_In_Mails_OneArgs = {
  object: Active_In_Mails_Insert_Input;
  on_conflict?: InputMaybe<Active_In_Mails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Active_Support_ChatsArgs = {
  objects: Array<Active_Support_Chats_Insert_Input>;
  on_conflict?: InputMaybe<Active_Support_Chats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Active_Support_Chats_OneArgs = {
  object: Active_Support_Chats_Insert_Input;
  on_conflict?: InputMaybe<Active_Support_Chats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_EventsArgs = {
  objects: Array<Activity_Events_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Events_OneArgs = {
  object: Activity_Events_Insert_Input;
  on_conflict?: InputMaybe<Activity_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Acuity_Provider_CalendarArgs = {
  objects: Array<Acuity_Provider_Calendar_Insert_Input>;
  on_conflict?: InputMaybe<Acuity_Provider_Calendar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Acuity_Provider_Calendar_OneArgs = {
  object: Acuity_Provider_Calendar_Insert_Input;
  on_conflict?: InputMaybe<Acuity_Provider_Calendar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AddressesArgs = {
  objects: Array<Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Addresses_OneArgs = {
  object: Addresses_Insert_Input;
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_PermissionsArgs = {
  objects: Array<Admin_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Admin_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_Permissions_OneArgs = {
  object: Admin_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Admin_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Age_Of_Majority_RulesArgs = {
  objects: Array<Age_Of_Majority_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Age_Of_Majority_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Age_Of_Majority_Rules_OneArgs = {
  object: Age_Of_Majority_Rules_Insert_Input;
  on_conflict?: InputMaybe<Age_Of_Majority_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Allergen_ClassesArgs = {
  objects: Array<Allergen_Classes_Insert_Input>;
  on_conflict?: InputMaybe<Allergen_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Allergen_Classes_OneArgs = {
  object: Allergen_Classes_Insert_Input;
  on_conflict?: InputMaybe<Allergen_Classes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_ToursArgs = {
  objects: Array<App_Tours_Insert_Input>;
  on_conflict?: InputMaybe<App_Tours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_Tours_OneArgs = {
  object: App_Tours_Insert_Input;
  on_conflict?: InputMaybe<App_Tours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_VersionsArgs = {
  objects: Array<App_Versions_Insert_Input>;
  on_conflict?: InputMaybe<App_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_App_Versions_OneArgs = {
  object: App_Versions_Insert_Input;
  on_conflict?: InputMaybe<App_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_Media_SignalsArgs = {
  objects: Array<Appointment_Media_Signals_Insert_Input>;
  on_conflict?: InputMaybe<Appointment_Media_Signals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_Media_Signals_OneArgs = {
  object: Appointment_Media_Signals_Insert_Input;
  on_conflict?: InputMaybe<Appointment_Media_Signals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_PaymentsArgs = {
  objects: Array<Appointment_Payments_Insert_Input>;
  on_conflict?: InputMaybe<Appointment_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_Payments_OneArgs = {
  object: Appointment_Payments_Insert_Input;
  on_conflict?: InputMaybe<Appointment_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_RequestsArgs = {
  objects: Array<Appointment_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Appointment_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_Requests_OneArgs = {
  object: Appointment_Requests_Insert_Input;
  on_conflict?: InputMaybe<Appointment_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_Status_HistoryArgs = {
  objects: Array<Appointment_Status_History_Insert_Input>;
  on_conflict?: InputMaybe<Appointment_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointment_Status_History_OneArgs = {
  object: Appointment_Status_History_Insert_Input;
  on_conflict?: InputMaybe<Appointment_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AppointmentsArgs = {
  objects: Array<Appointments_Insert_Input>;
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appointments_OneArgs = {
  object: Appointments_Insert_Input;
  on_conflict?: InputMaybe<Appointments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cart_ProductsArgs = {
  objects: Array<Cart_Products_Insert_Input>;
  on_conflict?: InputMaybe<Cart_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cart_Products_OneArgs = {
  object: Cart_Products_Insert_Input;
  on_conflict?: InputMaybe<Cart_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Channel_SignalsArgs = {
  objects: Array<Channel_Signals_Insert_Input>;
  on_conflict?: InputMaybe<Channel_Signals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Channel_Signals_OneArgs = {
  object: Channel_Signals_Insert_Input;
  on_conflict?: InputMaybe<Channel_Signals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Common_Question_ResponsesArgs = {
  objects: Array<Common_Question_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Common_Question_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Common_Question_Responses_OneArgs = {
  object: Common_Question_Responses_Insert_Input;
  on_conflict?: InputMaybe<Common_Question_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Common_QuestionsArgs = {
  objects: Array<Common_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Common_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Common_Questions_OneArgs = {
  object: Common_Questions_Insert_Input;
  on_conflict?: InputMaybe<Common_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Communication_ChannelsArgs = {
  objects: Array<Communication_Channels_Insert_Input>;
  on_conflict?: InputMaybe<Communication_Channels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Communication_Channels_OneArgs = {
  object: Communication_Channels_Insert_Input;
  on_conflict?: InputMaybe<Communication_Channels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountriesArgs = {
  objects: Array<Countries_Insert_Input>;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Countries_OneArgs = {
  object: Countries_Insert_Input;
  on_conflict?: InputMaybe<Countries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Auth_CodeArgs = {
  objects: Array<Custom_Auth_Code_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Auth_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Auth_Code_OneArgs = {
  object: Custom_Auth_Code_Insert_Input;
  on_conflict?: InputMaybe<Custom_Auth_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dea_License_SchedulesArgs = {
  objects: Array<Dea_License_Schedules_Insert_Input>;
  on_conflict?: InputMaybe<Dea_License_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dea_License_Schedules_OneArgs = {
  object: Dea_License_Schedules_Insert_Input;
  on_conflict?: InputMaybe<Dea_License_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_AddressesArgs = {
  objects: Array<Delivery_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Delivery_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Delivery_Addresses_OneArgs = {
  object: Delivery_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Delivery_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Diagnostic_Solution_TestsArgs = {
  objects: Array<Diagnostic_Solution_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Diagnostic_Solution_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Diagnostic_Solution_Tests_OneArgs = {
  object: Diagnostic_Solution_Tests_Insert_Input;
  on_conflict?: InputMaybe<Diagnostic_Solution_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dnavisit_Test_StatusesArgs = {
  objects: Array<Dnavisit_Test_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Dnavisit_Test_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dnavisit_Test_Statuses_OneArgs = {
  object: Dnavisit_Test_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Dnavisit_Test_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dnavisit_TestsArgs = {
  objects: Array<Dnavisit_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Dnavisit_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dnavisit_Tests_OneArgs = {
  object: Dnavisit_Tests_Insert_Input;
  on_conflict?: InputMaybe<Dnavisit_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Do_Not_Use_Production_Swab_CodesArgs = {
  objects: Array<Do_Not_Use_Production_Swab_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Do_Not_Use_Production_Swab_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Do_Not_Use_Production_Swab_Codes_OneArgs = {
  object: Do_Not_Use_Production_Swab_Codes_Insert_Input;
  on_conflict?: InputMaybe<Do_Not_Use_Production_Swab_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ecommerce_OrdersArgs = {
  objects: Array<Ecommerce_Orders_Insert_Input>;
  on_conflict?: InputMaybe<Ecommerce_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ecommerce_Orders_OneArgs = {
  object: Ecommerce_Orders_Insert_Input;
  on_conflict?: InputMaybe<Ecommerce_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_CoursesArgs = {
  objects: Array<Education_Courses_Insert_Input>;
  on_conflict?: InputMaybe<Education_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Courses_OneArgs = {
  object: Education_Courses_Insert_Input;
  on_conflict?: InputMaybe<Education_Courses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Module_Additional_MaterialsArgs = {
  objects: Array<Education_Module_Additional_Materials_Insert_Input>;
  on_conflict?: InputMaybe<Education_Module_Additional_Materials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Module_Additional_Materials_OneArgs = {
  object: Education_Module_Additional_Materials_Insert_Input;
  on_conflict?: InputMaybe<Education_Module_Additional_Materials_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Module_ItemsArgs = {
  objects: Array<Education_Module_Items_Insert_Input>;
  on_conflict?: InputMaybe<Education_Module_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Module_Items_OneArgs = {
  object: Education_Module_Items_Insert_Input;
  on_conflict?: InputMaybe<Education_Module_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_ModulesArgs = {
  objects: Array<Education_Modules_Insert_Input>;
  on_conflict?: InputMaybe<Education_Modules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Education_Modules_OneArgs = {
  object: Education_Modules_Insert_Input;
  on_conflict?: InputMaybe<Education_Modules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_TypesArgs = {
  objects: Array<File_Types_Insert_Input>;
  on_conflict?: InputMaybe<File_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Types_OneArgs = {
  object: File_Types_Insert_Input;
  on_conflict?: InputMaybe<File_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Files_OneArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fullscript_AllergensArgs = {
  objects: Array<Fullscript_Allergens_Insert_Input>;
  on_conflict?: InputMaybe<Fullscript_Allergens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fullscript_Allergens_OneArgs = {
  object: Fullscript_Allergens_Insert_Input;
  on_conflict?: InputMaybe<Fullscript_Allergens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fullscript_CliniciansArgs = {
  objects: Array<Fullscript_Clinicians_Insert_Input>;
  on_conflict?: InputMaybe<Fullscript_Clinicians_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fullscript_Clinicians_OneArgs = {
  object: Fullscript_Clinicians_Insert_Input;
  on_conflict?: InputMaybe<Fullscript_Clinicians_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gale_ProductsArgs = {
  objects: Array<Gale_Products_Insert_Input>;
  on_conflict?: InputMaybe<Gale_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gale_Products_OneArgs = {
  object: Gale_Products_Insert_Input;
  on_conflict?: InputMaybe<Gale_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_ConfigsArgs = {
  objects: Array<Global_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Global_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Configs_NamesArgs = {
  objects: Array<Global_Configs_Names_Insert_Input>;
  on_conflict?: InputMaybe<Global_Configs_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Configs_Names_OneArgs = {
  object: Global_Configs_Names_Insert_Input;
  on_conflict?: InputMaybe<Global_Configs_Names_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Global_Configs_OneArgs = {
  object: Global_Configs_Insert_Input;
  on_conflict?: InputMaybe<Global_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_Source_TypesArgs = {
  objects: Array<Image_Source_Types_Insert_Input>;
  on_conflict?: InputMaybe<Image_Source_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_Source_Types_OneArgs = {
  object: Image_Source_Types_Insert_Input;
  on_conflict?: InputMaybe<Image_Source_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Mail_UsageArgs = {
  objects: Array<In_Mail_Usage_Insert_Input>;
  on_conflict?: InputMaybe<In_Mail_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Mail_Usage_OneArgs = {
  object: In_Mail_Usage_Insert_Input;
  on_conflict?: InputMaybe<In_Mail_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitationsArgs = {
  objects: Array<Invitations_Insert_Input>;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitations_OneArgs = {
  object: Invitations_Insert_Input;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LabsArgs = {
  objects: Array<Labs_Insert_Input>;
  on_conflict?: InputMaybe<Labs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Labs_OneArgs = {
  object: Labs_Insert_Input;
  on_conflict?: InputMaybe<Labs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_Document_TypesArgs = {
  objects: Array<Legal_Document_Types_Insert_Input>;
  on_conflict?: InputMaybe<Legal_Document_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_Document_Types_OneArgs = {
  object: Legal_Document_Types_Insert_Input;
  on_conflict?: InputMaybe<Legal_Document_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_Document_Update_NotificationsArgs = {
  objects: Array<Legal_Document_Update_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Legal_Document_Update_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_Document_Update_Notifications_OneArgs = {
  object: Legal_Document_Update_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Legal_Document_Update_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_DocumentsArgs = {
  objects: Array<Legal_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Legal_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legal_Documents_OneArgs = {
  object: Legal_Documents_Insert_Input;
  on_conflict?: InputMaybe<Legal_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Medical_SchoolsArgs = {
  objects: Array<Medical_Schools_Insert_Input>;
  on_conflict?: InputMaybe<Medical_Schools_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Medical_Schools_OneArgs = {
  object: Medical_Schools_Insert_Input;
  on_conflict?: InputMaybe<Medical_Schools_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MedicationsArgs = {
  objects: Array<Medications_Insert_Input>;
  on_conflict?: InputMaybe<Medications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Medications_OneArgs = {
  object: Medications_Insert_Input;
  on_conflict?: InputMaybe<Medications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Molecular_TestsArgs = {
  objects: Array<Molecular_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Molecular_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Molecular_Tests_OneArgs = {
  object: Molecular_Tests_Insert_Input;
  on_conflict?: InputMaybe<Molecular_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mosaic_TestsArgs = {
  objects: Array<Mosaic_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Mosaic_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mosaic_Tests_OneArgs = {
  object: Mosaic_Tests_Insert_Input;
  on_conflict?: InputMaybe<Mosaic_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabla_NotesArgs = {
  objects: Array<Nabla_Notes_Insert_Input>;
  on_conflict?: InputMaybe<Nabla_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nabla_Notes_OneArgs = {
  object: Nabla_Notes_Insert_Input;
  on_conflict?: InputMaybe<Nabla_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Npi_Registry_DataArgs = {
  objects: Array<Npi_Registry_Data_Insert_Input>;
  on_conflict?: InputMaybe<Npi_Registry_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Npi_Registry_Data_OneArgs = {
  object: Npi_Registry_Data_Insert_Input;
  on_conflict?: InputMaybe<Npi_Registry_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_PaymentsArgs = {
  objects: Array<Order_Payments_Insert_Input>;
  on_conflict?: InputMaybe<Order_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Payments_OneArgs = {
  object: Order_Payments_Insert_Input;
  on_conflict?: InputMaybe<Order_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_ProductsArgs = {
  objects: Array<Order_Products_Insert_Input>;
  on_conflict?: InputMaybe<Order_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Products_OneArgs = {
  object: Order_Products_Insert_Input;
  on_conflict?: InputMaybe<Order_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Status_HistoryArgs = {
  objects: Array<Order_Status_History_Insert_Input>;
  on_conflict?: InputMaybe<Order_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Status_History_OneArgs = {
  object: Order_Status_History_Insert_Input;
  on_conflict?: InputMaybe<Order_Status_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrdersArgs = {
  objects: Array<Orders_Insert_Input>;
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Orders_OneArgs = {
  object: Orders_Insert_Input;
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Orders_ViewArgs = {
  objects: Array<Orders_View_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Orders_View_OneArgs = {
  object: Orders_View_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Achievement_EventsArgs = {
  objects: Array<Patient_Achievement_Events_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Achievement_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Achievement_Events_OneArgs = {
  object: Patient_Achievement_Events_Insert_Input;
  on_conflict?: InputMaybe<Patient_Achievement_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Achievement_ProgressArgs = {
  objects: Array<Patient_Achievement_Progress_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Achievement_Progress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Achievement_Progress_OneArgs = {
  object: Patient_Achievement_Progress_Insert_Input;
  on_conflict?: InputMaybe<Patient_Achievement_Progress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Achievement_UnlocksArgs = {
  objects: Array<Patient_Achievement_Unlocks_Insert_Input>;
  on_conflict?: InputMaybe<Patient_Achievement_Unlocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Patient_Achievement_Unlocks_OneArgs = {
  object: Patient_Achievement_Unlocks_Insert_Input;
  on_conflict?: InputMaybe<Patient_Achievement_Unlocks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Transaction_OrdersArgs = {
  objects: Array<Payment_Transaction_Orders_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Transaction_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Transaction_Orders_OneArgs = {
  object: Payment_Transaction_Orders_Insert_Input;
  on_conflict?: InputMaybe<Payment_Transaction_Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_TransactionsArgs = {
  objects: Array<Payment_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Transactions_OneArgs = {
  object: Payment_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Payment_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pending_Patient_ZrtArgs = {
  objects: Array<Pending_Patient_Zrt_Insert_Input>;
  on_conflict?: InputMaybe<Pending_Patient_Zrt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pending_Patient_Zrt_OneArgs = {
  object: Pending_Patient_Zrt_Insert_Input;
  on_conflict?: InputMaybe<Pending_Patient_Zrt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_InquiriesArgs = {
  objects: Array<Persona_Inquiries_Insert_Input>;
  on_conflict?: InputMaybe<Persona_Inquiries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_Inquiries_OneArgs = {
  object: Persona_Inquiries_Insert_Input;
  on_conflict?: InputMaybe<Persona_Inquiries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_Inquiry_StatusArgs = {
  objects: Array<Persona_Inquiry_Status_Insert_Input>;
  on_conflict?: InputMaybe<Persona_Inquiry_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Persona_Inquiry_Status_OneArgs = {
  object: Persona_Inquiry_Status_Insert_Input;
  on_conflict?: InputMaybe<Persona_Inquiry_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_BillingArgs = {
  objects: Array<Provider_Billing_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Billing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Billing_OneArgs = {
  object: Provider_Billing_Insert_Input;
  on_conflict?: InputMaybe<Provider_Billing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Dea_LicensesArgs = {
  objects: Array<Provider_Dea_Licenses_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Dea_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Dea_Licenses_OneArgs = {
  object: Provider_Dea_Licenses_Insert_Input;
  on_conflict?: InputMaybe<Provider_Dea_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_PaymentsArgs = {
  objects: Array<Provider_Payments_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Payments_OneArgs = {
  object: Provider_Payments_Insert_Input;
  on_conflict?: InputMaybe<Provider_Payments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_PayoutsArgs = {
  objects: Array<Provider_Payouts_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Payouts_OneArgs = {
  object: Provider_Payouts_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Provider_State_LicensesArgs = {
  objects: Array<Provider_State_Licenses_Insert_Input>;
  on_conflict?: InputMaybe<Provider_State_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_State_Licenses_OneArgs = {
  object: Provider_State_Licenses_Insert_Input;
  on_conflict?: InputMaybe<Provider_State_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Unread_External_Notification_CountsArgs = {
  objects: Array<Provider_Unread_External_Notification_Counts_Insert_Input>;
  on_conflict?: InputMaybe<Provider_Unread_External_Notification_Counts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Provider_Unread_External_Notification_Counts_OneArgs = {
  object: Provider_Unread_External_Notification_Counts_Insert_Input;
  on_conflict?: InputMaybe<Provider_Unread_External_Notification_Counts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Measurement_UnitsArgs = {
  objects: Array<Question_Measurement_Units_Insert_Input>;
  on_conflict?: InputMaybe<Question_Measurement_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Measurement_Units_OneArgs = {
  object: Question_Measurement_Units_Insert_Input;
  on_conflict?: InputMaybe<Question_Measurement_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_TypesArgs = {
  objects: Array<Question_Types_Insert_Input>;
  on_conflict?: InputMaybe<Question_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Types_OneArgs = {
  object: Question_Types_Insert_Input;
  on_conflict?: InputMaybe<Question_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Ui_Control_Helper_Text_PositionArgs = {
  objects: Array<Question_Ui_Control_Helper_Text_Position_Insert_Input>;
  on_conflict?: InputMaybe<Question_Ui_Control_Helper_Text_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Ui_Control_Helper_Text_Position_OneArgs = {
  object: Question_Ui_Control_Helper_Text_Position_Insert_Input;
  on_conflict?: InputMaybe<Question_Ui_Control_Helper_Text_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Ui_Control_TypesArgs = {
  objects: Array<Question_Ui_Control_Types_Insert_Input>;
  on_conflict?: InputMaybe<Question_Ui_Control_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Question_Ui_Control_Types_OneArgs = {
  object: Question_Ui_Control_Types_Insert_Input;
  on_conflict?: InputMaybe<Question_Ui_Control_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_QuestionsArgs = {
  objects: Array<Questionnaire_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Questions_OneArgs = {
  object: Questionnaire_Questions_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_RemindersArgs = {
  objects: Array<Questionnaire_Reminders_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Reminders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Reminders_OneArgs = {
  object: Questionnaire_Reminders_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Reminders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_ResponsesArgs = {
  objects: Array<Questionnaire_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Responses_OneArgs = {
  object: Questionnaire_Responses_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionnairesArgs = {
  objects: Array<Questionnaires_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaires_OneArgs = {
  object: Questionnaires_Insert_Input;
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionsArgs = {
  objects: Array<Questions_Insert_Input>;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questions_OneArgs = {
  object: Questions_Insert_Input;
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RecommendationsArgs = {
  objects: Array<Recommendations_Insert_Input>;
  on_conflict?: InputMaybe<Recommendations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recommendations_OneArgs = {
  object: Recommendations_Insert_Input;
  on_conflict?: InputMaybe<Recommendations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shipmonk_Sync_MetadataArgs = {
  objects: Array<Shipmonk_Sync_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Shipmonk_Sync_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shipmonk_Sync_Metadata_OneArgs = {
  object: Shipmonk_Sync_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Shipmonk_Sync_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Skintelligent_TestsArgs = {
  objects: Array<Skintelligent_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Skintelligent_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Skintelligent_Tests_OneArgs = {
  object: Skintelligent_Tests_Insert_Input;
  on_conflict?: InputMaybe<Skintelligent_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Billing_PlansArgs = {
  objects: Array<Stripe_Billing_Plans_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Billing_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Billing_Plans_OneArgs = {
  object: Stripe_Billing_Plans_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Billing_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_CustomersArgs = {
  objects: Array<Stripe_Customers_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Customers_OneArgs = {
  object: Stripe_Customers_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Customers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Payment_IntentsArgs = {
  objects: Array<Stripe_Payment_Intents_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Payment_Intents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Payment_Intents_OneArgs = {
  object: Stripe_Payment_Intents_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Payment_Intents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Payment_MethodsArgs = {
  objects: Array<Stripe_Payment_Methods_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Payment_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Payment_Methods_OneArgs = {
  object: Stripe_Payment_Methods_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Payment_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_SubscriptionsArgs = {
  objects: Array<Stripe_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Subscriptions_OneArgs = {
  object: Stripe_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_TransactionArgs = {
  objects: Array<Stripe_Transaction_Insert_Input>;
  on_conflict?: InputMaybe<Stripe_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stripe_Transaction_OneArgs = {
  object: Stripe_Transaction_Insert_Input;
  on_conflict?: InputMaybe<Stripe_Transaction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Chat_UsageArgs = {
  objects: Array<Support_Chat_Usage_Insert_Input>;
  on_conflict?: InputMaybe<Support_Chat_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Chat_Usage_OneArgs = {
  object: Support_Chat_Usage_Insert_Input;
  on_conflict?: InputMaybe<Support_Chat_Usage_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Swab_Code_StatusesArgs = {
  objects: Array<Swab_Code_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Swab_Code_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Swab_Code_Statuses_OneArgs = {
  object: Swab_Code_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Swab_Code_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Swab_CodesArgs = {
  objects: Array<Swab_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Swab_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Swab_Codes_OneArgs = {
  object: Swab_Codes_Insert_Input;
  on_conflict?: InputMaybe<Swab_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Swab_Usage_TypeArgs = {
  objects: Array<Swab_Usage_Type_Insert_Input>;
  on_conflict?: InputMaybe<Swab_Usage_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Swab_Usage_Type_OneArgs = {
  object: Swab_Usage_Type_Insert_Input;
  on_conflict?: InputMaybe<Swab_Usage_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_DefinitionsArgs = {
  objects: Array<Test_Definitions_Insert_Input>;
  on_conflict?: InputMaybe<Test_Definitions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Definitions_OneArgs = {
  object: Test_Definitions_Insert_Input;
  on_conflict?: InputMaybe<Test_Definitions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_E_Prescribe_NpisArgs = {
  objects: Array<Test_E_Prescribe_Npis_Insert_Input>;
  on_conflict?: InputMaybe<Test_E_Prescribe_Npis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_E_Prescribe_Npis_OneArgs = {
  object: Test_E_Prescribe_Npis_Insert_Input;
  on_conflict?: InputMaybe<Test_E_Prescribe_Npis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Kits_Update_States_Summary_LogArgs = {
  objects: Array<Test_Kits_Update_States_Summary_Log_Insert_Input>;
  on_conflict?: InputMaybe<Test_Kits_Update_States_Summary_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Kits_Update_States_Summary_Log_OneArgs = {
  object: Test_Kits_Update_States_Summary_Log_Insert_Input;
  on_conflict?: InputMaybe<Test_Kits_Update_States_Summary_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_TypesArgs = {
  objects: Array<Test_Types_Insert_Input>;
  on_conflict?: InputMaybe<Test_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Test_Types_OneArgs = {
  object: Test_Types_Insert_Input;
  on_conflict?: InputMaybe<Test_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TestsArgs = {
  objects: Array<Tests_Insert_Input>;
  on_conflict?: InputMaybe<Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tests_OneArgs = {
  object: Tests_Insert_Input;
  on_conflict?: InputMaybe<Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_AddressesArgs = {
  objects: Array<Text_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Text_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Text_Addresses_OneArgs = {
  object: Text_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Text_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unauthenticated_Questionnaire_QuestionsArgs = {
  objects: Array<Unauthenticated_Questionnaire_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Unauthenticated_Questionnaire_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unauthenticated_Questionnaire_Questions_OneArgs = {
  object: Unauthenticated_Questionnaire_Questions_Insert_Input;
  on_conflict?: InputMaybe<Unauthenticated_Questionnaire_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unauthenticated_QuestionnairesArgs = {
  objects: Array<Unauthenticated_Questionnaires_Insert_Input>;
  on_conflict?: InputMaybe<Unauthenticated_Questionnaires_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unauthenticated_Questionnaires_OneArgs = {
  object: Unauthenticated_Questionnaires_Insert_Input;
  on_conflict?: InputMaybe<Unauthenticated_Questionnaires_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unauthenticated_QuestionsArgs = {
  objects: Array<Unauthenticated_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Unauthenticated_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unauthenticated_Questions_OneArgs = {
  object: Unauthenticated_Questions_Insert_Input;
  on_conflict?: InputMaybe<Unauthenticated_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UniversitiesArgs = {
  objects: Array<Universities_Insert_Input>;
  on_conflict?: InputMaybe<Universities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Universities_OneArgs = {
  object: Universities_Insert_Input;
  on_conflict?: InputMaybe<Universities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Used_Test_E_Prescribe_LicensesArgs = {
  objects: Array<Used_Test_E_Prescribe_Licenses_Insert_Input>;
  on_conflict?: InputMaybe<Used_Test_E_Prescribe_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Used_Test_E_Prescribe_Licenses_OneArgs = {
  object: Used_Test_E_Prescribe_Licenses_Insert_Input;
  on_conflict?: InputMaybe<Used_Test_E_Prescribe_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_AddressesArgs = {
  objects: Array<User_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<User_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Addresses_OneArgs = {
  object: User_Addresses_Insert_Input;
  on_conflict?: InputMaybe<User_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_AgreementsArgs = {
  objects: Array<User_Agreements_Insert_Input>;
  on_conflict?: InputMaybe<User_Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Agreements_OneArgs = {
  object: User_Agreements_Insert_Input;
  on_conflict?: InputMaybe<User_Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Provider_TypesArgs = {
  objects: Array<User_Auth_Provider_Types_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Provider_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Provider_Types_OneArgs = {
  object: User_Auth_Provider_Types_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Provider_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_ProvidersArgs = {
  objects: Array<User_Auth_Providers_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Providers_OneArgs = {
  object: User_Auth_Providers_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_TokensArgs = {
  objects: Array<User_Auth_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Tokens_OneArgs = {
  object: User_Auth_Tokens_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Communication_DeliveriesArgs = {
  objects: Array<User_Communication_Deliveries_Insert_Input>;
  on_conflict?: InputMaybe<User_Communication_Deliveries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Communication_Deliveries_OneArgs = {
  object: User_Communication_Deliveries_Insert_Input;
  on_conflict?: InputMaybe<User_Communication_Deliveries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CommunicationsArgs = {
  objects: Array<User_Communications_Insert_Input>;
  on_conflict?: InputMaybe<User_Communications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Communications_OneArgs = {
  object: User_Communications_Insert_Input;
  on_conflict?: InputMaybe<User_Communications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_IndicatorsArgs = {
  objects: Array<User_Indicators_Insert_Input>;
  on_conflict?: InputMaybe<User_Indicators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Indicators_OneArgs = {
  object: User_Indicators_Insert_Input;
  on_conflict?: InputMaybe<User_Indicators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Notification_StatusArgs = {
  objects: Array<User_Notification_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Notification_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Notification_Status_OneArgs = {
  object: User_Notification_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Notification_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_NotificationsArgs = {
  objects: Array<User_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<User_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Notifications_OneArgs = {
  object: User_Notifications_Insert_Input;
  on_conflict?: InputMaybe<User_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Push_TokensArgs = {
  objects: Array<User_Push_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<User_Push_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Push_Tokens_OneArgs = {
  object: User_Push_Tokens_Insert_Input;
  on_conflict?: InputMaybe<User_Push_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Scanned_DataArgs = {
  objects: Array<User_Scanned_Data_Insert_Input>;
  on_conflict?: InputMaybe<User_Scanned_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Scanned_Data_OneArgs = {
  object: User_Scanned_Data_Insert_Input;
  on_conflict?: InputMaybe<User_Scanned_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SettingsArgs = {
  objects: Array<User_Settings_Insert_Input>;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Settings_OneArgs = {
  object: User_Settings_Insert_Input;
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vonage_AppointmentArgs = {
  objects: Array<Vonage_Appointment_Insert_Input>;
  on_conflict?: InputMaybe<Vonage_Appointment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vonage_Appointment_OneArgs = {
  object: Vonage_Appointment_Insert_Input;
  on_conflict?: InputMaybe<Vonage_Appointment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zrt_TestsArgs = {
  objects: Array<Zrt_Tests_Insert_Input>;
  on_conflict?: InputMaybe<Zrt_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Zrt_Tests_OneArgs = {
  object: Zrt_Tests_Insert_Input;
  on_conflict?: InputMaybe<Zrt_Tests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLinkProviderAccountArgs = {
  linkProviderAccountInput: LinkProviderAccountInput;
};


/** mutation root */
export type Mutation_RootOnTreatmentPlanActivatedArgs = {
  onTreatmentPlanActivatedInput: OnTreatmentPlanEventInput;
};


/** mutation root */
export type Mutation_RootPatchCodexApprovalArgs = {
  approved: Scalars['Boolean'];
  codexProviderID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootPatchFhirAppointmentArgs = {
  patchFHIRAppointmentInput: PatchFhirAppointmentInput;
};


/** mutation root */
export type Mutation_RootPatchFhirDnaVisitTestArgs = {
  patchFHIRDnaVisitTest: PatchFhirDnaVisitTestInput;
};


/** mutation root */
export type Mutation_RootPatchFhirEncounterArgs = {
  patchFHIREncounter: PatchEncounterInput;
};


/** mutation root */
export type Mutation_RootPatchFhirPatientPersonalDataArgs = {
  patientPersonalInfo: PatchFhirPatientPersonalInfoInput;
};


/** mutation root */
export type Mutation_RootPatchFhirProviderArgs = {
  patchFHIRProviderInput: PatchFhirProviderInput;
};


/** mutation root */
export type Mutation_RootPatchFhirZrtTestArgs = {
  patchFHIRZrtTest: PatchFhirZrtTestInput;
};


/** mutation root */
export type Mutation_RootPatchServiceOfferingArgs = {
  patchFHIRProviderServiceOfferingsInput: PatchFhirHealthCareServiceInput;
};


/** mutation root */
export type Mutation_RootPublishLegalDocumentArgs = {
  input: PublishLegalDocumentInput;
};


/** mutation root */
export type Mutation_RootRecommendProductsArgs = {
  codexPatientId: Scalars['String'];
  input: ProductRecommendationsInput;
};


/** mutation root */
export type Mutation_RootRefundPaymentTransactionArgs = {
  id: Scalars['Float'];
};


/** mutation root */
export type Mutation_RootRejectAppointmentRequestArgs = {
  input: GetAppointmentRescheduleRequestInput;
};


/** mutation root */
export type Mutation_RootRemoveFileFromLibraryArgs = {
  fileId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRequestDnaTestKitArgs = {
  input: RequestDnaTestKitInput;
};


/** mutation root */
export type Mutation_RootRequestZrtTestArgs = {
  providerCodexId: Scalars['String'];
  testType: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
  zrtSwabCode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRescheduleAppointmentArgs = {
  rescheduleAppointmentInput: RescheduleAppointmentInput;
};


/** mutation root */
export type Mutation_RootResendChildAdultTransitionInvitationArgs = {
  input: ResendChildAdultTransitionInvitationInput;
};


/** mutation root */
export type Mutation_RootResendDelegatedAdminInvitationArgs = {
  input: DelegatedAdminCodexIdInput;
};


/** mutation root */
export type Mutation_RootResetAppTourArgs = {
  appTourType: AppTourTypes;
};


/** mutation root */
export type Mutation_RootSaPatchFhirProviderArgs = {
  patchFHIRProviderInput: PatchFhirProviderInput;
  providerCodexId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSaveFhirQuestionnaireManuallyArgs = {
  isComplete: Scalars['Boolean'];
  questionnaireId: Scalars['Int'];
  responses: Scalars['JSON'];
  userID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSendInMailMessageArgs = {
  input: CreateInMailMessageInput;
};


/** mutation root */
export type Mutation_RootSendSupportMessageArgs = {
  input: SendSupportReplyInput;
};


/** mutation root */
export type Mutation_RootSetAdminsArgs = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootSetDefaultPaymentMethodArgs = {
  input: SetDefaultPaymentMethodInput;
};


/** mutation root */
export type Mutation_RootSyncEPrescribeMedicationsByPatientArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId: Scalars['String'];
  providerCodexId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootUpdateAllUserNotificationsStatusArgs = {
  input: UpdateNotificationStatusInput;
  notificationIds?: InputMaybe<Array<Scalars['String']>>;
};


/** mutation root */
export type Mutation_RootUpdateBecomePatientRequestStatusArgs = {
  updateBecomePatientRequestStatusInput: UpdateBecomePatientRequestStatusInput;
};


/** mutation root */
export type Mutation_RootUpdateCallSettingsArgs = {
  input: UpdateCallSettingsInput;
};


/** mutation root */
export type Mutation_RootUpdateCartProductArgs = {
  input: UpdateCartProductInput;
};


/** mutation root */
export type Mutation_RootUpdateCartProductsProviderArgs = {
  input: UpdateCartProductsProviderInput;
};


/** mutation root */
export type Mutation_RootUpdateDelegatedAdminPermissionsArgs = {
  input: UpdateDelegatedAdminPermissionsInput;
};


/** mutation root */
export type Mutation_RootUpdateFhirQuestionnaireResponseArgs = {
  currentStepIndex?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  questionnaireId?: InputMaybe<Scalars['String']>;
  responses: Scalars['JSON'];
  swabCode?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootUpdateFhirUserLatestQuestionnaireArgs = {
  id: Scalars['String'];
  isComplete: Scalars['Boolean'];
  responses: Scalars['JSON'];
};


/** mutation root */
export type Mutation_RootUpdateHighContrastModeArgs = {
  enabled: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootUpdateInAppNotificationByIdArgs = {
  input: UpdateNotificationStatusInput;
  notificationId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};


/** mutation root */
export type Mutation_RootUpdateOrderStatusArgs = {
  input: UpdateOrderStatusInput;
};


/** mutation root */
export type Mutation_RootUpdateProductArgs = {
  input: UpdateProductInput;
};


/** mutation root */
export type Mutation_RootUpdateProductAvailabilityArgs = {
  input: UpdateProductAvailabilityInput;
};


/** mutation root */
export type Mutation_RootUpdateRecommendationStatusArgs = {
  recommendationId: Scalars['String'];
  status: UpdatableRecommendationStatus;
};


/** mutation root */
export type Mutation_RootUpdateSelfReportedMedicationArgs = {
  input: SelfReportedMedicationsInput;
};


/** mutation root */
export type Mutation_RootUpdateTestKitProviderArgs = {
  providerCodexId: Scalars['String'];
  swabCode: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Accepted_Legal_DocumentsArgs = {
  _inc?: InputMaybe<Accepted_Legal_Documents_Inc_Input>;
  _set?: InputMaybe<Accepted_Legal_Documents_Set_Input>;
  where: Accepted_Legal_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accepted_Legal_Documents_By_PkArgs = {
  _inc?: InputMaybe<Accepted_Legal_Documents_Inc_Input>;
  _set?: InputMaybe<Accepted_Legal_Documents_Set_Input>;
  pk_columns: Accepted_Legal_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accepted_Legal_Documents_ManyArgs = {
  updates: Array<Accepted_Legal_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Active_In_MailsArgs = {
  _inc?: InputMaybe<Active_In_Mails_Inc_Input>;
  _set?: InputMaybe<Active_In_Mails_Set_Input>;
  where: Active_In_Mails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Active_In_Mails_By_PkArgs = {
  _inc?: InputMaybe<Active_In_Mails_Inc_Input>;
  _set?: InputMaybe<Active_In_Mails_Set_Input>;
  pk_columns: Active_In_Mails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Active_In_Mails_ManyArgs = {
  updates: Array<Active_In_Mails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Active_Support_ChatsArgs = {
  _inc?: InputMaybe<Active_Support_Chats_Inc_Input>;
  _set?: InputMaybe<Active_Support_Chats_Set_Input>;
  where: Active_Support_Chats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Active_Support_Chats_By_PkArgs = {
  _inc?: InputMaybe<Active_Support_Chats_Inc_Input>;
  _set?: InputMaybe<Active_Support_Chats_Set_Input>;
  pk_columns: Active_Support_Chats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Active_Support_Chats_ManyArgs = {
  updates: Array<Active_Support_Chats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_EventsArgs = {
  _inc?: InputMaybe<Activity_Events_Inc_Input>;
  _set?: InputMaybe<Activity_Events_Set_Input>;
  where: Activity_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Events_By_PkArgs = {
  _inc?: InputMaybe<Activity_Events_Inc_Input>;
  _set?: InputMaybe<Activity_Events_Set_Input>;
  pk_columns: Activity_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Events_ManyArgs = {
  updates: Array<Activity_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Acuity_Provider_CalendarArgs = {
  _inc?: InputMaybe<Acuity_Provider_Calendar_Inc_Input>;
  _set?: InputMaybe<Acuity_Provider_Calendar_Set_Input>;
  where: Acuity_Provider_Calendar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Acuity_Provider_Calendar_By_PkArgs = {
  _inc?: InputMaybe<Acuity_Provider_Calendar_Inc_Input>;
  _set?: InputMaybe<Acuity_Provider_Calendar_Set_Input>;
  pk_columns: Acuity_Provider_Calendar_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Acuity_Provider_Calendar_ManyArgs = {
  updates: Array<Acuity_Provider_Calendar_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressesArgs = {
  _set?: InputMaybe<Addresses_Set_Input>;
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_By_PkArgs = {
  _set?: InputMaybe<Addresses_Set_Input>;
  pk_columns: Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_ManyArgs = {
  updates: Array<Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_PermissionsArgs = {
  _inc?: InputMaybe<Admin_Permissions_Inc_Input>;
  _set?: InputMaybe<Admin_Permissions_Set_Input>;
  where: Admin_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Permissions_By_PkArgs = {
  _inc?: InputMaybe<Admin_Permissions_Inc_Input>;
  _set?: InputMaybe<Admin_Permissions_Set_Input>;
  pk_columns: Admin_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_Permissions_ManyArgs = {
  updates: Array<Admin_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Age_Of_Majority_RulesArgs = {
  _inc?: InputMaybe<Age_Of_Majority_Rules_Inc_Input>;
  _set?: InputMaybe<Age_Of_Majority_Rules_Set_Input>;
  where: Age_Of_Majority_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Age_Of_Majority_Rules_By_PkArgs = {
  _inc?: InputMaybe<Age_Of_Majority_Rules_Inc_Input>;
  _set?: InputMaybe<Age_Of_Majority_Rules_Set_Input>;
  pk_columns: Age_Of_Majority_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Age_Of_Majority_Rules_ManyArgs = {
  updates: Array<Age_Of_Majority_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Allergen_ClassesArgs = {
  _set?: InputMaybe<Allergen_Classes_Set_Input>;
  where: Allergen_Classes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Allergen_Classes_By_PkArgs = {
  _set?: InputMaybe<Allergen_Classes_Set_Input>;
  pk_columns: Allergen_Classes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Allergen_Classes_ManyArgs = {
  updates: Array<Allergen_Classes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_App_ToursArgs = {
  _inc?: InputMaybe<App_Tours_Inc_Input>;
  _set?: InputMaybe<App_Tours_Set_Input>;
  where: App_Tours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_App_Tours_By_PkArgs = {
  _inc?: InputMaybe<App_Tours_Inc_Input>;
  _set?: InputMaybe<App_Tours_Set_Input>;
  pk_columns: App_Tours_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_App_Tours_ManyArgs = {
  updates: Array<App_Tours_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_App_VersionsArgs = {
  _inc?: InputMaybe<App_Versions_Inc_Input>;
  _set?: InputMaybe<App_Versions_Set_Input>;
  where: App_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_App_Versions_By_PkArgs = {
  _inc?: InputMaybe<App_Versions_Inc_Input>;
  _set?: InputMaybe<App_Versions_Set_Input>;
  pk_columns: App_Versions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_App_Versions_ManyArgs = {
  updates: Array<App_Versions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Media_SignalsArgs = {
  _inc?: InputMaybe<Appointment_Media_Signals_Inc_Input>;
  _set?: InputMaybe<Appointment_Media_Signals_Set_Input>;
  where: Appointment_Media_Signals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Media_Signals_By_PkArgs = {
  _inc?: InputMaybe<Appointment_Media_Signals_Inc_Input>;
  _set?: InputMaybe<Appointment_Media_Signals_Set_Input>;
  pk_columns: Appointment_Media_Signals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Media_Signals_ManyArgs = {
  updates: Array<Appointment_Media_Signals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_PaymentsArgs = {
  _inc?: InputMaybe<Appointment_Payments_Inc_Input>;
  _set?: InputMaybe<Appointment_Payments_Set_Input>;
  where: Appointment_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Payments_By_PkArgs = {
  _inc?: InputMaybe<Appointment_Payments_Inc_Input>;
  _set?: InputMaybe<Appointment_Payments_Set_Input>;
  pk_columns: Appointment_Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Payments_ManyArgs = {
  updates: Array<Appointment_Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_RequestsArgs = {
  _inc?: InputMaybe<Appointment_Requests_Inc_Input>;
  _set?: InputMaybe<Appointment_Requests_Set_Input>;
  where: Appointment_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Requests_By_PkArgs = {
  _inc?: InputMaybe<Appointment_Requests_Inc_Input>;
  _set?: InputMaybe<Appointment_Requests_Set_Input>;
  pk_columns: Appointment_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Requests_ManyArgs = {
  updates: Array<Appointment_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Status_HistoryArgs = {
  _inc?: InputMaybe<Appointment_Status_History_Inc_Input>;
  _set?: InputMaybe<Appointment_Status_History_Set_Input>;
  where: Appointment_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Status_History_By_PkArgs = {
  _inc?: InputMaybe<Appointment_Status_History_Inc_Input>;
  _set?: InputMaybe<Appointment_Status_History_Set_Input>;
  pk_columns: Appointment_Status_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appointment_Status_History_ManyArgs = {
  updates: Array<Appointment_Status_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AppointmentsArgs = {
  _inc?: InputMaybe<Appointments_Inc_Input>;
  _set?: InputMaybe<Appointments_Set_Input>;
  where: Appointments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appointments_By_PkArgs = {
  _inc?: InputMaybe<Appointments_Inc_Input>;
  _set?: InputMaybe<Appointments_Set_Input>;
  pk_columns: Appointments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appointments_ManyArgs = {
  updates: Array<Appointments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cart_ProductsArgs = {
  _inc?: InputMaybe<Cart_Products_Inc_Input>;
  _set?: InputMaybe<Cart_Products_Set_Input>;
  where: Cart_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cart_Products_By_PkArgs = {
  _inc?: InputMaybe<Cart_Products_Inc_Input>;
  _set?: InputMaybe<Cart_Products_Set_Input>;
  pk_columns: Cart_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cart_Products_ManyArgs = {
  updates: Array<Cart_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_SignalsArgs = {
  _inc?: InputMaybe<Channel_Signals_Inc_Input>;
  _set?: InputMaybe<Channel_Signals_Set_Input>;
  where: Channel_Signals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_Signals_By_PkArgs = {
  _inc?: InputMaybe<Channel_Signals_Inc_Input>;
  _set?: InputMaybe<Channel_Signals_Set_Input>;
  pk_columns: Channel_Signals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_Signals_ManyArgs = {
  updates: Array<Channel_Signals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Question_ResponsesArgs = {
  _append?: InputMaybe<Common_Question_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Common_Question_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Common_Question_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Common_Question_Responses_Delete_Key_Input>;
  _inc?: InputMaybe<Common_Question_Responses_Inc_Input>;
  _prepend?: InputMaybe<Common_Question_Responses_Prepend_Input>;
  _set?: InputMaybe<Common_Question_Responses_Set_Input>;
  where: Common_Question_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Question_Responses_By_PkArgs = {
  _append?: InputMaybe<Common_Question_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Common_Question_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Common_Question_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Common_Question_Responses_Delete_Key_Input>;
  _inc?: InputMaybe<Common_Question_Responses_Inc_Input>;
  _prepend?: InputMaybe<Common_Question_Responses_Prepend_Input>;
  _set?: InputMaybe<Common_Question_Responses_Set_Input>;
  pk_columns: Common_Question_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Question_Responses_ManyArgs = {
  updates: Array<Common_Question_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Common_QuestionsArgs = {
  _inc?: InputMaybe<Common_Questions_Inc_Input>;
  _set?: InputMaybe<Common_Questions_Set_Input>;
  where: Common_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Questions_By_PkArgs = {
  _inc?: InputMaybe<Common_Questions_Inc_Input>;
  _set?: InputMaybe<Common_Questions_Set_Input>;
  pk_columns: Common_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Common_Questions_ManyArgs = {
  updates: Array<Common_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Communication_ChannelsArgs = {
  _set?: InputMaybe<Communication_Channels_Set_Input>;
  where: Communication_Channels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Communication_Channels_By_PkArgs = {
  _set?: InputMaybe<Communication_Channels_Set_Input>;
  pk_columns: Communication_Channels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Communication_Channels_ManyArgs = {
  updates: Array<Communication_Channels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountriesArgs = {
  _inc?: InputMaybe<Countries_Inc_Input>;
  _set?: InputMaybe<Countries_Set_Input>;
  where: Countries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_By_PkArgs = {
  _inc?: InputMaybe<Countries_Inc_Input>;
  _set?: InputMaybe<Countries_Set_Input>;
  pk_columns: Countries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Countries_ManyArgs = {
  updates: Array<Countries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Auth_CodeArgs = {
  _set?: InputMaybe<Custom_Auth_Code_Set_Input>;
  where: Custom_Auth_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Auth_Code_By_PkArgs = {
  _set?: InputMaybe<Custom_Auth_Code_Set_Input>;
  pk_columns: Custom_Auth_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Auth_Code_ManyArgs = {
  updates: Array<Custom_Auth_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dea_License_SchedulesArgs = {
  _set?: InputMaybe<Dea_License_Schedules_Set_Input>;
  where: Dea_License_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dea_License_Schedules_By_PkArgs = {
  _set?: InputMaybe<Dea_License_Schedules_Set_Input>;
  pk_columns: Dea_License_Schedules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dea_License_Schedules_ManyArgs = {
  updates: Array<Dea_License_Schedules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_AddressesArgs = {
  _inc?: InputMaybe<Delivery_Addresses_Inc_Input>;
  _set?: InputMaybe<Delivery_Addresses_Set_Input>;
  where: Delivery_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Addresses_By_PkArgs = {
  _inc?: InputMaybe<Delivery_Addresses_Inc_Input>;
  _set?: InputMaybe<Delivery_Addresses_Set_Input>;
  pk_columns: Delivery_Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Addresses_ManyArgs = {
  updates: Array<Delivery_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Diagnostic_Solution_TestsArgs = {
  _append?: InputMaybe<Diagnostic_Solution_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Diagnostic_Solution_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Diagnostic_Solution_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Diagnostic_Solution_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Diagnostic_Solution_Tests_Prepend_Input>;
  _set?: InputMaybe<Diagnostic_Solution_Tests_Set_Input>;
  where: Diagnostic_Solution_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Diagnostic_Solution_Tests_By_PkArgs = {
  _append?: InputMaybe<Diagnostic_Solution_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Diagnostic_Solution_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Diagnostic_Solution_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Diagnostic_Solution_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Diagnostic_Solution_Tests_Prepend_Input>;
  _set?: InputMaybe<Diagnostic_Solution_Tests_Set_Input>;
  pk_columns: Diagnostic_Solution_Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Diagnostic_Solution_Tests_ManyArgs = {
  updates: Array<Diagnostic_Solution_Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dnavisit_Test_StatusesArgs = {
  _set?: InputMaybe<Dnavisit_Test_Statuses_Set_Input>;
  where: Dnavisit_Test_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dnavisit_Test_Statuses_By_PkArgs = {
  _set?: InputMaybe<Dnavisit_Test_Statuses_Set_Input>;
  pk_columns: Dnavisit_Test_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dnavisit_Test_Statuses_ManyArgs = {
  updates: Array<Dnavisit_Test_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dnavisit_TestsArgs = {
  _append?: InputMaybe<Dnavisit_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Dnavisit_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Dnavisit_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Dnavisit_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Dnavisit_Tests_Prepend_Input>;
  _set?: InputMaybe<Dnavisit_Tests_Set_Input>;
  where: Dnavisit_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dnavisit_Tests_By_PkArgs = {
  _append?: InputMaybe<Dnavisit_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Dnavisit_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Dnavisit_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Dnavisit_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Dnavisit_Tests_Prepend_Input>;
  _set?: InputMaybe<Dnavisit_Tests_Set_Input>;
  pk_columns: Dnavisit_Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dnavisit_Tests_ManyArgs = {
  updates: Array<Dnavisit_Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Do_Not_Use_Production_Swab_CodesArgs = {
  _set?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Set_Input>;
  where: Do_Not_Use_Production_Swab_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Do_Not_Use_Production_Swab_Codes_By_PkArgs = {
  _set?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Set_Input>;
  pk_columns: Do_Not_Use_Production_Swab_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Do_Not_Use_Production_Swab_Codes_ManyArgs = {
  updates: Array<Do_Not_Use_Production_Swab_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ecommerce_OrdersArgs = {
  _inc?: InputMaybe<Ecommerce_Orders_Inc_Input>;
  _set?: InputMaybe<Ecommerce_Orders_Set_Input>;
  where: Ecommerce_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ecommerce_Orders_By_PkArgs = {
  _inc?: InputMaybe<Ecommerce_Orders_Inc_Input>;
  _set?: InputMaybe<Ecommerce_Orders_Set_Input>;
  pk_columns: Ecommerce_Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ecommerce_Orders_ManyArgs = {
  updates: Array<Ecommerce_Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Education_CoursesArgs = {
  _set?: InputMaybe<Education_Courses_Set_Input>;
  where: Education_Courses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Courses_By_PkArgs = {
  _set?: InputMaybe<Education_Courses_Set_Input>;
  pk_columns: Education_Courses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Courses_ManyArgs = {
  updates: Array<Education_Courses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Module_Additional_MaterialsArgs = {
  _set?: InputMaybe<Education_Module_Additional_Materials_Set_Input>;
  where: Education_Module_Additional_Materials_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Module_Additional_Materials_By_PkArgs = {
  _set?: InputMaybe<Education_Module_Additional_Materials_Set_Input>;
  pk_columns: Education_Module_Additional_Materials_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Module_Additional_Materials_ManyArgs = {
  updates: Array<Education_Module_Additional_Materials_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Module_ItemsArgs = {
  _inc?: InputMaybe<Education_Module_Items_Inc_Input>;
  _set?: InputMaybe<Education_Module_Items_Set_Input>;
  where: Education_Module_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Module_Items_By_PkArgs = {
  _inc?: InputMaybe<Education_Module_Items_Inc_Input>;
  _set?: InputMaybe<Education_Module_Items_Set_Input>;
  pk_columns: Education_Module_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Module_Items_ManyArgs = {
  updates: Array<Education_Module_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Education_ModulesArgs = {
  _set?: InputMaybe<Education_Modules_Set_Input>;
  where: Education_Modules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Modules_By_PkArgs = {
  _set?: InputMaybe<Education_Modules_Set_Input>;
  pk_columns: Education_Modules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Education_Modules_ManyArgs = {
  updates: Array<Education_Modules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_TypesArgs = {
  _set?: InputMaybe<File_Types_Set_Input>;
  where: File_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Types_By_PkArgs = {
  _set?: InputMaybe<File_Types_Set_Input>;
  pk_columns: File_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_Types_ManyArgs = {
  updates: Array<File_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_By_PkArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fullscript_AllergensArgs = {
  _inc?: InputMaybe<Fullscript_Allergens_Inc_Input>;
  _set?: InputMaybe<Fullscript_Allergens_Set_Input>;
  where: Fullscript_Allergens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fullscript_Allergens_By_PkArgs = {
  _inc?: InputMaybe<Fullscript_Allergens_Inc_Input>;
  _set?: InputMaybe<Fullscript_Allergens_Set_Input>;
  pk_columns: Fullscript_Allergens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fullscript_Allergens_ManyArgs = {
  updates: Array<Fullscript_Allergens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fullscript_CliniciansArgs = {
  _set?: InputMaybe<Fullscript_Clinicians_Set_Input>;
  where: Fullscript_Clinicians_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fullscript_Clinicians_By_PkArgs = {
  _set?: InputMaybe<Fullscript_Clinicians_Set_Input>;
  pk_columns: Fullscript_Clinicians_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fullscript_Clinicians_ManyArgs = {
  updates: Array<Fullscript_Clinicians_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gale_ProductsArgs = {
  _inc?: InputMaybe<Gale_Products_Inc_Input>;
  _set?: InputMaybe<Gale_Products_Set_Input>;
  where: Gale_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gale_Products_By_PkArgs = {
  _inc?: InputMaybe<Gale_Products_Inc_Input>;
  _set?: InputMaybe<Gale_Products_Set_Input>;
  pk_columns: Gale_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gale_Products_ManyArgs = {
  updates: Array<Gale_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_ConfigsArgs = {
  _append?: InputMaybe<Global_Configs_Append_Input>;
  _delete_at_path?: InputMaybe<Global_Configs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Global_Configs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Global_Configs_Delete_Key_Input>;
  _prepend?: InputMaybe<Global_Configs_Prepend_Input>;
  _set?: InputMaybe<Global_Configs_Set_Input>;
  where: Global_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Configs_By_PkArgs = {
  _append?: InputMaybe<Global_Configs_Append_Input>;
  _delete_at_path?: InputMaybe<Global_Configs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Global_Configs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Global_Configs_Delete_Key_Input>;
  _prepend?: InputMaybe<Global_Configs_Prepend_Input>;
  _set?: InputMaybe<Global_Configs_Set_Input>;
  pk_columns: Global_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Configs_ManyArgs = {
  updates: Array<Global_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Configs_NamesArgs = {
  _set?: InputMaybe<Global_Configs_Names_Set_Input>;
  where: Global_Configs_Names_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Configs_Names_By_PkArgs = {
  _set?: InputMaybe<Global_Configs_Names_Set_Input>;
  pk_columns: Global_Configs_Names_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Global_Configs_Names_ManyArgs = {
  updates: Array<Global_Configs_Names_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Source_TypesArgs = {
  _set?: InputMaybe<Image_Source_Types_Set_Input>;
  where: Image_Source_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Source_Types_By_PkArgs = {
  _set?: InputMaybe<Image_Source_Types_Set_Input>;
  pk_columns: Image_Source_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Image_Source_Types_ManyArgs = {
  updates: Array<Image_Source_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Mail_UsageArgs = {
  _inc?: InputMaybe<In_Mail_Usage_Inc_Input>;
  _set?: InputMaybe<In_Mail_Usage_Set_Input>;
  where: In_Mail_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Mail_Usage_By_PkArgs = {
  _inc?: InputMaybe<In_Mail_Usage_Inc_Input>;
  _set?: InputMaybe<In_Mail_Usage_Set_Input>;
  pk_columns: In_Mail_Usage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Mail_Usage_ManyArgs = {
  updates: Array<In_Mail_Usage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitationsArgs = {
  _set?: InputMaybe<Invitations_Set_Input>;
  where: Invitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitations_By_PkArgs = {
  _set?: InputMaybe<Invitations_Set_Input>;
  pk_columns: Invitations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitations_ManyArgs = {
  updates: Array<Invitations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LabsArgs = {
  _set?: InputMaybe<Labs_Set_Input>;
  where: Labs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Labs_By_PkArgs = {
  _set?: InputMaybe<Labs_Set_Input>;
  pk_columns: Labs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Labs_ManyArgs = {
  updates: Array<Labs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Document_TypesArgs = {
  _set?: InputMaybe<Legal_Document_Types_Set_Input>;
  where: Legal_Document_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Document_Types_By_PkArgs = {
  _set?: InputMaybe<Legal_Document_Types_Set_Input>;
  pk_columns: Legal_Document_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Document_Types_ManyArgs = {
  updates: Array<Legal_Document_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Document_Update_NotificationsArgs = {
  _inc?: InputMaybe<Legal_Document_Update_Notifications_Inc_Input>;
  _set?: InputMaybe<Legal_Document_Update_Notifications_Set_Input>;
  where: Legal_Document_Update_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Document_Update_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Legal_Document_Update_Notifications_Inc_Input>;
  _set?: InputMaybe<Legal_Document_Update_Notifications_Set_Input>;
  pk_columns: Legal_Document_Update_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Document_Update_Notifications_ManyArgs = {
  updates: Array<Legal_Document_Update_Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_DocumentsArgs = {
  _inc?: InputMaybe<Legal_Documents_Inc_Input>;
  _set?: InputMaybe<Legal_Documents_Set_Input>;
  where: Legal_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Documents_By_PkArgs = {
  _inc?: InputMaybe<Legal_Documents_Inc_Input>;
  _set?: InputMaybe<Legal_Documents_Set_Input>;
  pk_columns: Legal_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legal_Documents_ManyArgs = {
  updates: Array<Legal_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Medical_SchoolsArgs = {
  _inc?: InputMaybe<Medical_Schools_Inc_Input>;
  _set?: InputMaybe<Medical_Schools_Set_Input>;
  where: Medical_Schools_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Medical_Schools_By_PkArgs = {
  _inc?: InputMaybe<Medical_Schools_Inc_Input>;
  _set?: InputMaybe<Medical_Schools_Set_Input>;
  pk_columns: Medical_Schools_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Medical_Schools_ManyArgs = {
  updates: Array<Medical_Schools_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MedicationsArgs = {
  _inc?: InputMaybe<Medications_Inc_Input>;
  _set?: InputMaybe<Medications_Set_Input>;
  where: Medications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Medications_By_PkArgs = {
  _inc?: InputMaybe<Medications_Inc_Input>;
  _set?: InputMaybe<Medications_Set_Input>;
  pk_columns: Medications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Medications_ManyArgs = {
  updates: Array<Medications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Molecular_TestsArgs = {
  _append?: InputMaybe<Molecular_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Molecular_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Molecular_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Molecular_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Molecular_Tests_Prepend_Input>;
  _set?: InputMaybe<Molecular_Tests_Set_Input>;
  where: Molecular_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Molecular_Tests_By_PkArgs = {
  _append?: InputMaybe<Molecular_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Molecular_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Molecular_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Molecular_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Molecular_Tests_Prepend_Input>;
  _set?: InputMaybe<Molecular_Tests_Set_Input>;
  pk_columns: Molecular_Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Molecular_Tests_ManyArgs = {
  updates: Array<Molecular_Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mosaic_TestsArgs = {
  _append?: InputMaybe<Mosaic_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Mosaic_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mosaic_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mosaic_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Mosaic_Tests_Prepend_Input>;
  _set?: InputMaybe<Mosaic_Tests_Set_Input>;
  where: Mosaic_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mosaic_Tests_By_PkArgs = {
  _append?: InputMaybe<Mosaic_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Mosaic_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mosaic_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mosaic_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Mosaic_Tests_Prepend_Input>;
  _set?: InputMaybe<Mosaic_Tests_Set_Input>;
  pk_columns: Mosaic_Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mosaic_Tests_ManyArgs = {
  updates: Array<Mosaic_Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nabla_NotesArgs = {
  _append?: InputMaybe<Nabla_Notes_Append_Input>;
  _delete_at_path?: InputMaybe<Nabla_Notes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Nabla_Notes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Nabla_Notes_Delete_Key_Input>;
  _prepend?: InputMaybe<Nabla_Notes_Prepend_Input>;
  _set?: InputMaybe<Nabla_Notes_Set_Input>;
  where: Nabla_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nabla_Notes_By_PkArgs = {
  _append?: InputMaybe<Nabla_Notes_Append_Input>;
  _delete_at_path?: InputMaybe<Nabla_Notes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Nabla_Notes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Nabla_Notes_Delete_Key_Input>;
  _prepend?: InputMaybe<Nabla_Notes_Prepend_Input>;
  _set?: InputMaybe<Nabla_Notes_Set_Input>;
  pk_columns: Nabla_Notes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nabla_Notes_ManyArgs = {
  updates: Array<Nabla_Notes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Npi_Registry_DataArgs = {
  _append?: InputMaybe<Npi_Registry_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Npi_Registry_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Npi_Registry_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Npi_Registry_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Npi_Registry_Data_Prepend_Input>;
  _set?: InputMaybe<Npi_Registry_Data_Set_Input>;
  where: Npi_Registry_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Npi_Registry_Data_By_PkArgs = {
  _append?: InputMaybe<Npi_Registry_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Npi_Registry_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Npi_Registry_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Npi_Registry_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Npi_Registry_Data_Prepend_Input>;
  _set?: InputMaybe<Npi_Registry_Data_Set_Input>;
  pk_columns: Npi_Registry_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Npi_Registry_Data_ManyArgs = {
  updates: Array<Npi_Registry_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_PaymentsArgs = {
  _inc?: InputMaybe<Order_Payments_Inc_Input>;
  _set?: InputMaybe<Order_Payments_Set_Input>;
  where: Order_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Payments_By_PkArgs = {
  _inc?: InputMaybe<Order_Payments_Inc_Input>;
  _set?: InputMaybe<Order_Payments_Set_Input>;
  pk_columns: Order_Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Payments_ManyArgs = {
  updates: Array<Order_Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ProductsArgs = {
  _inc?: InputMaybe<Order_Products_Inc_Input>;
  _set?: InputMaybe<Order_Products_Set_Input>;
  where: Order_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Products_By_PkArgs = {
  _inc?: InputMaybe<Order_Products_Inc_Input>;
  _set?: InputMaybe<Order_Products_Set_Input>;
  pk_columns: Order_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Products_ManyArgs = {
  updates: Array<Order_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Status_HistoryArgs = {
  _inc?: InputMaybe<Order_Status_History_Inc_Input>;
  _set?: InputMaybe<Order_Status_History_Set_Input>;
  where: Order_Status_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Status_History_By_PkArgs = {
  _inc?: InputMaybe<Order_Status_History_Inc_Input>;
  _set?: InputMaybe<Order_Status_History_Set_Input>;
  pk_columns: Order_Status_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Status_History_ManyArgs = {
  updates: Array<Order_Status_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrdersArgs = {
  _inc?: InputMaybe<Orders_Inc_Input>;
  _set?: InputMaybe<Orders_Set_Input>;
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_By_PkArgs = {
  _inc?: InputMaybe<Orders_Inc_Input>;
  _set?: InputMaybe<Orders_Set_Input>;
  pk_columns: Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_ManyArgs = {
  updates: Array<Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_ViewArgs = {
  _inc?: InputMaybe<Orders_View_Inc_Input>;
  _set?: InputMaybe<Orders_View_Set_Input>;
  where: Orders_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_View_ManyArgs = {
  updates: Array<Orders_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_EventsArgs = {
  _append?: InputMaybe<Patient_Achievement_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Patient_Achievement_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Patient_Achievement_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Patient_Achievement_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Patient_Achievement_Events_Inc_Input>;
  _prepend?: InputMaybe<Patient_Achievement_Events_Prepend_Input>;
  _set?: InputMaybe<Patient_Achievement_Events_Set_Input>;
  where: Patient_Achievement_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_Events_By_PkArgs = {
  _append?: InputMaybe<Patient_Achievement_Events_Append_Input>;
  _delete_at_path?: InputMaybe<Patient_Achievement_Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Patient_Achievement_Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Patient_Achievement_Events_Delete_Key_Input>;
  _inc?: InputMaybe<Patient_Achievement_Events_Inc_Input>;
  _prepend?: InputMaybe<Patient_Achievement_Events_Prepend_Input>;
  _set?: InputMaybe<Patient_Achievement_Events_Set_Input>;
  pk_columns: Patient_Achievement_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_Events_ManyArgs = {
  updates: Array<Patient_Achievement_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_ProgressArgs = {
  _inc?: InputMaybe<Patient_Achievement_Progress_Inc_Input>;
  _set?: InputMaybe<Patient_Achievement_Progress_Set_Input>;
  where: Patient_Achievement_Progress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_Progress_By_PkArgs = {
  _inc?: InputMaybe<Patient_Achievement_Progress_Inc_Input>;
  _set?: InputMaybe<Patient_Achievement_Progress_Set_Input>;
  pk_columns: Patient_Achievement_Progress_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_Progress_ManyArgs = {
  updates: Array<Patient_Achievement_Progress_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_UnlocksArgs = {
  _inc?: InputMaybe<Patient_Achievement_Unlocks_Inc_Input>;
  _set?: InputMaybe<Patient_Achievement_Unlocks_Set_Input>;
  where: Patient_Achievement_Unlocks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_Unlocks_By_PkArgs = {
  _inc?: InputMaybe<Patient_Achievement_Unlocks_Inc_Input>;
  _set?: InputMaybe<Patient_Achievement_Unlocks_Set_Input>;
  pk_columns: Patient_Achievement_Unlocks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Patient_Achievement_Unlocks_ManyArgs = {
  updates: Array<Patient_Achievement_Unlocks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Transaction_OrdersArgs = {
  _inc?: InputMaybe<Payment_Transaction_Orders_Inc_Input>;
  _set?: InputMaybe<Payment_Transaction_Orders_Set_Input>;
  where: Payment_Transaction_Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Transaction_Orders_By_PkArgs = {
  _inc?: InputMaybe<Payment_Transaction_Orders_Inc_Input>;
  _set?: InputMaybe<Payment_Transaction_Orders_Set_Input>;
  pk_columns: Payment_Transaction_Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Transaction_Orders_ManyArgs = {
  updates: Array<Payment_Transaction_Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_TransactionsArgs = {
  _inc?: InputMaybe<Payment_Transactions_Inc_Input>;
  _set?: InputMaybe<Payment_Transactions_Set_Input>;
  where: Payment_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Payment_Transactions_Inc_Input>;
  _set?: InputMaybe<Payment_Transactions_Set_Input>;
  pk_columns: Payment_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Transactions_ManyArgs = {
  updates: Array<Payment_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pending_Patient_ZrtArgs = {
  _inc?: InputMaybe<Pending_Patient_Zrt_Inc_Input>;
  _set?: InputMaybe<Pending_Patient_Zrt_Set_Input>;
  where: Pending_Patient_Zrt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pending_Patient_Zrt_By_PkArgs = {
  _inc?: InputMaybe<Pending_Patient_Zrt_Inc_Input>;
  _set?: InputMaybe<Pending_Patient_Zrt_Set_Input>;
  pk_columns: Pending_Patient_Zrt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pending_Patient_Zrt_ManyArgs = {
  updates: Array<Pending_Patient_Zrt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_InquiriesArgs = {
  _inc?: InputMaybe<Persona_Inquiries_Inc_Input>;
  _set?: InputMaybe<Persona_Inquiries_Set_Input>;
  where: Persona_Inquiries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Inquiries_By_PkArgs = {
  _inc?: InputMaybe<Persona_Inquiries_Inc_Input>;
  _set?: InputMaybe<Persona_Inquiries_Set_Input>;
  pk_columns: Persona_Inquiries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Inquiries_ManyArgs = {
  updates: Array<Persona_Inquiries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Inquiry_StatusArgs = {
  _set?: InputMaybe<Persona_Inquiry_Status_Set_Input>;
  where: Persona_Inquiry_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Inquiry_Status_By_PkArgs = {
  _set?: InputMaybe<Persona_Inquiry_Status_Set_Input>;
  pk_columns: Persona_Inquiry_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Persona_Inquiry_Status_ManyArgs = {
  updates: Array<Persona_Inquiry_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_ManyArgs = {
  updates: Array<Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_BillingArgs = {
  _inc?: InputMaybe<Provider_Billing_Inc_Input>;
  _set?: InputMaybe<Provider_Billing_Set_Input>;
  where: Provider_Billing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Billing_By_PkArgs = {
  _inc?: InputMaybe<Provider_Billing_Inc_Input>;
  _set?: InputMaybe<Provider_Billing_Set_Input>;
  pk_columns: Provider_Billing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Billing_ManyArgs = {
  updates: Array<Provider_Billing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Dea_LicensesArgs = {
  _set?: InputMaybe<Provider_Dea_Licenses_Set_Input>;
  where: Provider_Dea_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Dea_Licenses_By_PkArgs = {
  _set?: InputMaybe<Provider_Dea_Licenses_Set_Input>;
  pk_columns: Provider_Dea_Licenses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Dea_Licenses_ManyArgs = {
  updates: Array<Provider_Dea_Licenses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_PaymentsArgs = {
  _inc?: InputMaybe<Provider_Payments_Inc_Input>;
  _set?: InputMaybe<Provider_Payments_Set_Input>;
  where: Provider_Payments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Payments_By_PkArgs = {
  _inc?: InputMaybe<Provider_Payments_Inc_Input>;
  _set?: InputMaybe<Provider_Payments_Set_Input>;
  pk_columns: Provider_Payments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Payments_ManyArgs = {
  updates: Array<Provider_Payments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_PayoutsArgs = {
  _inc?: InputMaybe<Provider_Payouts_Inc_Input>;
  _set?: InputMaybe<Provider_Payouts_Set_Input>;
  where: Provider_Payouts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Payouts_ManyArgs = {
  updates: Array<Provider_Payouts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_State_LicensesArgs = {
  _set?: InputMaybe<Provider_State_Licenses_Set_Input>;
  where: Provider_State_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_State_Licenses_By_PkArgs = {
  _set?: InputMaybe<Provider_State_Licenses_Set_Input>;
  pk_columns: Provider_State_Licenses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_State_Licenses_ManyArgs = {
  updates: Array<Provider_State_Licenses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Unread_External_Notification_CountsArgs = {
  _inc?: InputMaybe<Provider_Unread_External_Notification_Counts_Inc_Input>;
  _set?: InputMaybe<Provider_Unread_External_Notification_Counts_Set_Input>;
  where: Provider_Unread_External_Notification_Counts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Unread_External_Notification_Counts_By_PkArgs = {
  _inc?: InputMaybe<Provider_Unread_External_Notification_Counts_Inc_Input>;
  _set?: InputMaybe<Provider_Unread_External_Notification_Counts_Set_Input>;
  pk_columns: Provider_Unread_External_Notification_Counts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Provider_Unread_External_Notification_Counts_ManyArgs = {
  updates: Array<Provider_Unread_External_Notification_Counts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Measurement_UnitsArgs = {
  _set?: InputMaybe<Question_Measurement_Units_Set_Input>;
  where: Question_Measurement_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Measurement_Units_By_PkArgs = {
  _set?: InputMaybe<Question_Measurement_Units_Set_Input>;
  pk_columns: Question_Measurement_Units_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Measurement_Units_ManyArgs = {
  updates: Array<Question_Measurement_Units_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_TypesArgs = {
  _set?: InputMaybe<Question_Types_Set_Input>;
  where: Question_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Types_By_PkArgs = {
  _set?: InputMaybe<Question_Types_Set_Input>;
  pk_columns: Question_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Types_ManyArgs = {
  updates: Array<Question_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ui_Control_Helper_Text_PositionArgs = {
  _set?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Set_Input>;
  where: Question_Ui_Control_Helper_Text_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ui_Control_Helper_Text_Position_By_PkArgs = {
  _set?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Set_Input>;
  pk_columns: Question_Ui_Control_Helper_Text_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ui_Control_Helper_Text_Position_ManyArgs = {
  updates: Array<Question_Ui_Control_Helper_Text_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ui_Control_TypesArgs = {
  _set?: InputMaybe<Question_Ui_Control_Types_Set_Input>;
  where: Question_Ui_Control_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ui_Control_Types_By_PkArgs = {
  _set?: InputMaybe<Question_Ui_Control_Types_Set_Input>;
  pk_columns: Question_Ui_Control_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Question_Ui_Control_Types_ManyArgs = {
  updates: Array<Question_Ui_Control_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_QuestionsArgs = {
  _inc?: InputMaybe<Questionnaire_Questions_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Questions_Set_Input>;
  where: Questionnaire_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Questions_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Questions_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Questions_Set_Input>;
  pk_columns: Questionnaire_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Questions_ManyArgs = {
  updates: Array<Questionnaire_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_RemindersArgs = {
  _inc?: InputMaybe<Questionnaire_Reminders_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Reminders_Set_Input>;
  where: Questionnaire_Reminders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Reminders_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Reminders_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Reminders_Set_Input>;
  pk_columns: Questionnaire_Reminders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Reminders_ManyArgs = {
  updates: Array<Questionnaire_Reminders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_ResponsesArgs = {
  _append?: InputMaybe<Questionnaire_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Questionnaire_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questionnaire_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questionnaire_Responses_Delete_Key_Input>;
  _inc?: InputMaybe<Questionnaire_Responses_Inc_Input>;
  _prepend?: InputMaybe<Questionnaire_Responses_Prepend_Input>;
  _set?: InputMaybe<Questionnaire_Responses_Set_Input>;
  where: Questionnaire_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Responses_By_PkArgs = {
  _append?: InputMaybe<Questionnaire_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Questionnaire_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questionnaire_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questionnaire_Responses_Delete_Key_Input>;
  _inc?: InputMaybe<Questionnaire_Responses_Inc_Input>;
  _prepend?: InputMaybe<Questionnaire_Responses_Prepend_Input>;
  _set?: InputMaybe<Questionnaire_Responses_Set_Input>;
  pk_columns: Questionnaire_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Responses_ManyArgs = {
  updates: Array<Questionnaire_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionnairesArgs = {
  _append?: InputMaybe<Questionnaires_Append_Input>;
  _delete_at_path?: InputMaybe<Questionnaires_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questionnaires_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questionnaires_Delete_Key_Input>;
  _inc?: InputMaybe<Questionnaires_Inc_Input>;
  _prepend?: InputMaybe<Questionnaires_Prepend_Input>;
  _set?: InputMaybe<Questionnaires_Set_Input>;
  where: Questionnaires_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaires_By_PkArgs = {
  _append?: InputMaybe<Questionnaires_Append_Input>;
  _delete_at_path?: InputMaybe<Questionnaires_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questionnaires_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questionnaires_Delete_Key_Input>;
  _inc?: InputMaybe<Questionnaires_Inc_Input>;
  _prepend?: InputMaybe<Questionnaires_Prepend_Input>;
  _set?: InputMaybe<Questionnaires_Set_Input>;
  pk_columns: Questionnaires_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaires_ManyArgs = {
  updates: Array<Questionnaires_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionsArgs = {
  _append?: InputMaybe<Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Questions_Inc_Input>;
  _prepend?: InputMaybe<Questions_Prepend_Input>;
  _set?: InputMaybe<Questions_Set_Input>;
  where: Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questions_By_PkArgs = {
  _append?: InputMaybe<Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Questions_Inc_Input>;
  _prepend?: InputMaybe<Questions_Prepend_Input>;
  _set?: InputMaybe<Questions_Set_Input>;
  pk_columns: Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questions_ManyArgs = {
  updates: Array<Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RecommendationsArgs = {
  _inc?: InputMaybe<Recommendations_Inc_Input>;
  _set?: InputMaybe<Recommendations_Set_Input>;
  where: Recommendations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Recommendations_By_PkArgs = {
  _inc?: InputMaybe<Recommendations_Inc_Input>;
  _set?: InputMaybe<Recommendations_Set_Input>;
  pk_columns: Recommendations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Recommendations_ManyArgs = {
  updates: Array<Recommendations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shipmonk_Sync_MetadataArgs = {
  _inc?: InputMaybe<Shipmonk_Sync_Metadata_Inc_Input>;
  _set?: InputMaybe<Shipmonk_Sync_Metadata_Set_Input>;
  where: Shipmonk_Sync_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Shipmonk_Sync_Metadata_By_PkArgs = {
  _inc?: InputMaybe<Shipmonk_Sync_Metadata_Inc_Input>;
  _set?: InputMaybe<Shipmonk_Sync_Metadata_Set_Input>;
  pk_columns: Shipmonk_Sync_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shipmonk_Sync_Metadata_ManyArgs = {
  updates: Array<Shipmonk_Sync_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skintelligent_TestsArgs = {
  _append?: InputMaybe<Skintelligent_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Skintelligent_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Skintelligent_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Skintelligent_Tests_Delete_Key_Input>;
  _inc?: InputMaybe<Skintelligent_Tests_Inc_Input>;
  _prepend?: InputMaybe<Skintelligent_Tests_Prepend_Input>;
  _set?: InputMaybe<Skintelligent_Tests_Set_Input>;
  where: Skintelligent_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skintelligent_Tests_By_PkArgs = {
  _append?: InputMaybe<Skintelligent_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Skintelligent_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Skintelligent_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Skintelligent_Tests_Delete_Key_Input>;
  _inc?: InputMaybe<Skintelligent_Tests_Inc_Input>;
  _prepend?: InputMaybe<Skintelligent_Tests_Prepend_Input>;
  _set?: InputMaybe<Skintelligent_Tests_Set_Input>;
  pk_columns: Skintelligent_Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Skintelligent_Tests_ManyArgs = {
  updates: Array<Skintelligent_Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Billing_PlansArgs = {
  _inc?: InputMaybe<Stripe_Billing_Plans_Inc_Input>;
  _set?: InputMaybe<Stripe_Billing_Plans_Set_Input>;
  where: Stripe_Billing_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Billing_Plans_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Billing_Plans_Inc_Input>;
  _set?: InputMaybe<Stripe_Billing_Plans_Set_Input>;
  pk_columns: Stripe_Billing_Plans_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Billing_Plans_ManyArgs = {
  updates: Array<Stripe_Billing_Plans_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_CustomersArgs = {
  _inc?: InputMaybe<Stripe_Customers_Inc_Input>;
  _set?: InputMaybe<Stripe_Customers_Set_Input>;
  where: Stripe_Customers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Customers_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Customers_Inc_Input>;
  _set?: InputMaybe<Stripe_Customers_Set_Input>;
  pk_columns: Stripe_Customers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Customers_ManyArgs = {
  updates: Array<Stripe_Customers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Payment_IntentsArgs = {
  _inc?: InputMaybe<Stripe_Payment_Intents_Inc_Input>;
  _set?: InputMaybe<Stripe_Payment_Intents_Set_Input>;
  where: Stripe_Payment_Intents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Payment_Intents_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Payment_Intents_Inc_Input>;
  _set?: InputMaybe<Stripe_Payment_Intents_Set_Input>;
  pk_columns: Stripe_Payment_Intents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Payment_Intents_ManyArgs = {
  updates: Array<Stripe_Payment_Intents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Payment_MethodsArgs = {
  _inc?: InputMaybe<Stripe_Payment_Methods_Inc_Input>;
  _set?: InputMaybe<Stripe_Payment_Methods_Set_Input>;
  where: Stripe_Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Payment_Methods_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Payment_Methods_Inc_Input>;
  _set?: InputMaybe<Stripe_Payment_Methods_Set_Input>;
  pk_columns: Stripe_Payment_Methods_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Payment_Methods_ManyArgs = {
  updates: Array<Stripe_Payment_Methods_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_SubscriptionsArgs = {
  _inc?: InputMaybe<Stripe_Subscriptions_Inc_Input>;
  _set?: InputMaybe<Stripe_Subscriptions_Set_Input>;
  where: Stripe_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Subscriptions_Inc_Input>;
  _set?: InputMaybe<Stripe_Subscriptions_Set_Input>;
  pk_columns: Stripe_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Subscriptions_ManyArgs = {
  updates: Array<Stripe_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_TransactionArgs = {
  _inc?: InputMaybe<Stripe_Transaction_Inc_Input>;
  _set?: InputMaybe<Stripe_Transaction_Set_Input>;
  where: Stripe_Transaction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Transaction_By_PkArgs = {
  _inc?: InputMaybe<Stripe_Transaction_Inc_Input>;
  _set?: InputMaybe<Stripe_Transaction_Set_Input>;
  pk_columns: Stripe_Transaction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stripe_Transaction_ManyArgs = {
  updates: Array<Stripe_Transaction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Chat_UsageArgs = {
  _inc?: InputMaybe<Support_Chat_Usage_Inc_Input>;
  _set?: InputMaybe<Support_Chat_Usage_Set_Input>;
  where: Support_Chat_Usage_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Chat_Usage_By_PkArgs = {
  _inc?: InputMaybe<Support_Chat_Usage_Inc_Input>;
  _set?: InputMaybe<Support_Chat_Usage_Set_Input>;
  pk_columns: Support_Chat_Usage_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Chat_Usage_ManyArgs = {
  updates: Array<Support_Chat_Usage_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Code_StatusesArgs = {
  _set?: InputMaybe<Swab_Code_Statuses_Set_Input>;
  where: Swab_Code_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Code_Statuses_By_PkArgs = {
  _set?: InputMaybe<Swab_Code_Statuses_Set_Input>;
  pk_columns: Swab_Code_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Code_Statuses_ManyArgs = {
  updates: Array<Swab_Code_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_CodesArgs = {
  _inc?: InputMaybe<Swab_Codes_Inc_Input>;
  _set?: InputMaybe<Swab_Codes_Set_Input>;
  where: Swab_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Codes_By_PkArgs = {
  _inc?: InputMaybe<Swab_Codes_Inc_Input>;
  _set?: InputMaybe<Swab_Codes_Set_Input>;
  pk_columns: Swab_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Codes_ManyArgs = {
  updates: Array<Swab_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Usage_TypeArgs = {
  _set?: InputMaybe<Swab_Usage_Type_Set_Input>;
  where: Swab_Usage_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Usage_Type_By_PkArgs = {
  _set?: InputMaybe<Swab_Usage_Type_Set_Input>;
  pk_columns: Swab_Usage_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Swab_Usage_Type_ManyArgs = {
  updates: Array<Swab_Usage_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test_DefinitionsArgs = {
  _append?: InputMaybe<Test_Definitions_Append_Input>;
  _delete_at_path?: InputMaybe<Test_Definitions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Test_Definitions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Test_Definitions_Delete_Key_Input>;
  _inc?: InputMaybe<Test_Definitions_Inc_Input>;
  _prepend?: InputMaybe<Test_Definitions_Prepend_Input>;
  _set?: InputMaybe<Test_Definitions_Set_Input>;
  where: Test_Definitions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Definitions_By_PkArgs = {
  _append?: InputMaybe<Test_Definitions_Append_Input>;
  _delete_at_path?: InputMaybe<Test_Definitions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Test_Definitions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Test_Definitions_Delete_Key_Input>;
  _inc?: InputMaybe<Test_Definitions_Inc_Input>;
  _prepend?: InputMaybe<Test_Definitions_Prepend_Input>;
  _set?: InputMaybe<Test_Definitions_Set_Input>;
  pk_columns: Test_Definitions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Definitions_ManyArgs = {
  updates: Array<Test_Definitions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test_E_Prescribe_NpisArgs = {
  _inc?: InputMaybe<Test_E_Prescribe_Npis_Inc_Input>;
  _set?: InputMaybe<Test_E_Prescribe_Npis_Set_Input>;
  where: Test_E_Prescribe_Npis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_E_Prescribe_Npis_By_PkArgs = {
  _inc?: InputMaybe<Test_E_Prescribe_Npis_Inc_Input>;
  _set?: InputMaybe<Test_E_Prescribe_Npis_Set_Input>;
  pk_columns: Test_E_Prescribe_Npis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_E_Prescribe_Npis_ManyArgs = {
  updates: Array<Test_E_Prescribe_Npis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Kits_Update_States_Summary_LogArgs = {
  _set?: InputMaybe<Test_Kits_Update_States_Summary_Log_Set_Input>;
  where: Test_Kits_Update_States_Summary_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Kits_Update_States_Summary_Log_By_PkArgs = {
  _set?: InputMaybe<Test_Kits_Update_States_Summary_Log_Set_Input>;
  pk_columns: Test_Kits_Update_States_Summary_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Kits_Update_States_Summary_Log_ManyArgs = {
  updates: Array<Test_Kits_Update_States_Summary_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test_TypesArgs = {
  _set?: InputMaybe<Test_Types_Set_Input>;
  where: Test_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Types_By_PkArgs = {
  _set?: InputMaybe<Test_Types_Set_Input>;
  pk_columns: Test_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Test_Types_ManyArgs = {
  updates: Array<Test_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TestsArgs = {
  _inc?: InputMaybe<Tests_Inc_Input>;
  _set?: InputMaybe<Tests_Set_Input>;
  where: Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tests_By_PkArgs = {
  _inc?: InputMaybe<Tests_Inc_Input>;
  _set?: InputMaybe<Tests_Set_Input>;
  pk_columns: Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tests_ManyArgs = {
  updates: Array<Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Text_AddressesArgs = {
  _set?: InputMaybe<Text_Addresses_Set_Input>;
  where: Text_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Text_Addresses_By_PkArgs = {
  _set?: InputMaybe<Text_Addresses_Set_Input>;
  pk_columns: Text_Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Text_Addresses_ManyArgs = {
  updates: Array<Text_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questionnaire_QuestionsArgs = {
  _inc?: InputMaybe<Unauthenticated_Questionnaire_Questions_Inc_Input>;
  _set?: InputMaybe<Unauthenticated_Questionnaire_Questions_Set_Input>;
  where: Unauthenticated_Questionnaire_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questionnaire_Questions_By_PkArgs = {
  _inc?: InputMaybe<Unauthenticated_Questionnaire_Questions_Inc_Input>;
  _set?: InputMaybe<Unauthenticated_Questionnaire_Questions_Set_Input>;
  pk_columns: Unauthenticated_Questionnaire_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questionnaire_Questions_ManyArgs = {
  updates: Array<Unauthenticated_Questionnaire_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_QuestionnairesArgs = {
  _append?: InputMaybe<Unauthenticated_Questionnaires_Append_Input>;
  _delete_at_path?: InputMaybe<Unauthenticated_Questionnaires_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Unauthenticated_Questionnaires_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Unauthenticated_Questionnaires_Delete_Key_Input>;
  _inc?: InputMaybe<Unauthenticated_Questionnaires_Inc_Input>;
  _prepend?: InputMaybe<Unauthenticated_Questionnaires_Prepend_Input>;
  _set?: InputMaybe<Unauthenticated_Questionnaires_Set_Input>;
  where: Unauthenticated_Questionnaires_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questionnaires_By_PkArgs = {
  _append?: InputMaybe<Unauthenticated_Questionnaires_Append_Input>;
  _delete_at_path?: InputMaybe<Unauthenticated_Questionnaires_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Unauthenticated_Questionnaires_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Unauthenticated_Questionnaires_Delete_Key_Input>;
  _inc?: InputMaybe<Unauthenticated_Questionnaires_Inc_Input>;
  _prepend?: InputMaybe<Unauthenticated_Questionnaires_Prepend_Input>;
  _set?: InputMaybe<Unauthenticated_Questionnaires_Set_Input>;
  pk_columns: Unauthenticated_Questionnaires_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questionnaires_ManyArgs = {
  updates: Array<Unauthenticated_Questionnaires_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_QuestionsArgs = {
  _append?: InputMaybe<Unauthenticated_Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Unauthenticated_Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Unauthenticated_Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Unauthenticated_Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Unauthenticated_Questions_Inc_Input>;
  _prepend?: InputMaybe<Unauthenticated_Questions_Prepend_Input>;
  _set?: InputMaybe<Unauthenticated_Questions_Set_Input>;
  where: Unauthenticated_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questions_By_PkArgs = {
  _append?: InputMaybe<Unauthenticated_Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Unauthenticated_Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Unauthenticated_Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Unauthenticated_Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Unauthenticated_Questions_Inc_Input>;
  _prepend?: InputMaybe<Unauthenticated_Questions_Prepend_Input>;
  _set?: InputMaybe<Unauthenticated_Questions_Set_Input>;
  pk_columns: Unauthenticated_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unauthenticated_Questions_ManyArgs = {
  updates: Array<Unauthenticated_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UniversitiesArgs = {
  _inc?: InputMaybe<Universities_Inc_Input>;
  _set?: InputMaybe<Universities_Set_Input>;
  where: Universities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Universities_By_PkArgs = {
  _inc?: InputMaybe<Universities_Inc_Input>;
  _set?: InputMaybe<Universities_Set_Input>;
  pk_columns: Universities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Universities_ManyArgs = {
  updates: Array<Universities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Used_Test_E_Prescribe_LicensesArgs = {
  _set?: InputMaybe<Used_Test_E_Prescribe_Licenses_Set_Input>;
  where: Used_Test_E_Prescribe_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Used_Test_E_Prescribe_Licenses_By_PkArgs = {
  _set?: InputMaybe<Used_Test_E_Prescribe_Licenses_Set_Input>;
  pk_columns: Used_Test_E_Prescribe_Licenses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Used_Test_E_Prescribe_Licenses_ManyArgs = {
  updates: Array<Used_Test_E_Prescribe_Licenses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_AddressesArgs = {
  _inc?: InputMaybe<User_Addresses_Inc_Input>;
  _set?: InputMaybe<User_Addresses_Set_Input>;
  where: User_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Addresses_By_PkArgs = {
  _inc?: InputMaybe<User_Addresses_Inc_Input>;
  _set?: InputMaybe<User_Addresses_Set_Input>;
  pk_columns: User_Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Addresses_ManyArgs = {
  updates: Array<User_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_AgreementsArgs = {
  _inc?: InputMaybe<User_Agreements_Inc_Input>;
  _set?: InputMaybe<User_Agreements_Set_Input>;
  where: User_Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Agreements_By_PkArgs = {
  _inc?: InputMaybe<User_Agreements_Inc_Input>;
  _set?: InputMaybe<User_Agreements_Set_Input>;
  pk_columns: User_Agreements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Agreements_ManyArgs = {
  updates: Array<User_Agreements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Provider_TypesArgs = {
  _set?: InputMaybe<User_Auth_Provider_Types_Set_Input>;
  where: User_Auth_Provider_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Provider_Types_By_PkArgs = {
  _set?: InputMaybe<User_Auth_Provider_Types_Set_Input>;
  pk_columns: User_Auth_Provider_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Provider_Types_ManyArgs = {
  updates: Array<User_Auth_Provider_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_ProvidersArgs = {
  _append?: InputMaybe<User_Auth_Providers_Append_Input>;
  _delete_at_path?: InputMaybe<User_Auth_Providers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Auth_Providers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Auth_Providers_Delete_Key_Input>;
  _inc?: InputMaybe<User_Auth_Providers_Inc_Input>;
  _prepend?: InputMaybe<User_Auth_Providers_Prepend_Input>;
  _set?: InputMaybe<User_Auth_Providers_Set_Input>;
  where: User_Auth_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Providers_By_PkArgs = {
  _append?: InputMaybe<User_Auth_Providers_Append_Input>;
  _delete_at_path?: InputMaybe<User_Auth_Providers_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Auth_Providers_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Auth_Providers_Delete_Key_Input>;
  _inc?: InputMaybe<User_Auth_Providers_Inc_Input>;
  _prepend?: InputMaybe<User_Auth_Providers_Prepend_Input>;
  _set?: InputMaybe<User_Auth_Providers_Set_Input>;
  pk_columns: User_Auth_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Providers_ManyArgs = {
  updates: Array<User_Auth_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_TokensArgs = {
  _inc?: InputMaybe<User_Auth_Tokens_Inc_Input>;
  _set?: InputMaybe<User_Auth_Tokens_Set_Input>;
  where: User_Auth_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Tokens_By_PkArgs = {
  _inc?: InputMaybe<User_Auth_Tokens_Inc_Input>;
  _set?: InputMaybe<User_Auth_Tokens_Set_Input>;
  pk_columns: User_Auth_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Tokens_ManyArgs = {
  updates: Array<User_Auth_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communication_DeliveriesArgs = {
  _inc?: InputMaybe<User_Communication_Deliveries_Inc_Input>;
  _set?: InputMaybe<User_Communication_Deliveries_Set_Input>;
  where: User_Communication_Deliveries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communication_Deliveries_By_PkArgs = {
  _inc?: InputMaybe<User_Communication_Deliveries_Inc_Input>;
  _set?: InputMaybe<User_Communication_Deliveries_Set_Input>;
  pk_columns: User_Communication_Deliveries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communication_Deliveries_ManyArgs = {
  updates: Array<User_Communication_Deliveries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_CommunicationsArgs = {
  _append?: InputMaybe<User_Communications_Append_Input>;
  _delete_at_path?: InputMaybe<User_Communications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Communications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Communications_Delete_Key_Input>;
  _inc?: InputMaybe<User_Communications_Inc_Input>;
  _prepend?: InputMaybe<User_Communications_Prepend_Input>;
  _set?: InputMaybe<User_Communications_Set_Input>;
  where: User_Communications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communications_By_PkArgs = {
  _append?: InputMaybe<User_Communications_Append_Input>;
  _delete_at_path?: InputMaybe<User_Communications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Communications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Communications_Delete_Key_Input>;
  _inc?: InputMaybe<User_Communications_Inc_Input>;
  _prepend?: InputMaybe<User_Communications_Prepend_Input>;
  _set?: InputMaybe<User_Communications_Set_Input>;
  pk_columns: User_Communications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communications_ManyArgs = {
  updates: Array<User_Communications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_IndicatorsArgs = {
  _inc?: InputMaybe<User_Indicators_Inc_Input>;
  _set?: InputMaybe<User_Indicators_Set_Input>;
  where: User_Indicators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Indicators_By_PkArgs = {
  _inc?: InputMaybe<User_Indicators_Inc_Input>;
  _set?: InputMaybe<User_Indicators_Set_Input>;
  pk_columns: User_Indicators_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Indicators_ManyArgs = {
  updates: Array<User_Indicators_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_StatusArgs = {
  _set?: InputMaybe<User_Notification_Status_Set_Input>;
  where: User_Notification_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_Status_By_PkArgs = {
  _set?: InputMaybe<User_Notification_Status_Set_Input>;
  pk_columns: User_Notification_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_Status_ManyArgs = {
  updates: Array<User_Notification_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_NotificationsArgs = {
  _append?: InputMaybe<User_Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<User_Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<User_Notifications_Inc_Input>;
  _prepend?: InputMaybe<User_Notifications_Prepend_Input>;
  _set?: InputMaybe<User_Notifications_Set_Input>;
  where: User_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notifications_By_PkArgs = {
  _append?: InputMaybe<User_Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<User_Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<User_Notifications_Inc_Input>;
  _prepend?: InputMaybe<User_Notifications_Prepend_Input>;
  _set?: InputMaybe<User_Notifications_Set_Input>;
  pk_columns: User_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notifications_ManyArgs = {
  updates: Array<User_Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Push_TokensArgs = {
  _set?: InputMaybe<User_Push_Tokens_Set_Input>;
  where: User_Push_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Push_Tokens_By_PkArgs = {
  _set?: InputMaybe<User_Push_Tokens_Set_Input>;
  pk_columns: User_Push_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Push_Tokens_ManyArgs = {
  updates: Array<User_Push_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Scanned_DataArgs = {
  _set?: InputMaybe<User_Scanned_Data_Set_Input>;
  where: User_Scanned_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Scanned_Data_By_PkArgs = {
  _set?: InputMaybe<User_Scanned_Data_Set_Input>;
  pk_columns: User_Scanned_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Scanned_Data_ManyArgs = {
  updates: Array<User_Scanned_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SettingsArgs = {
  _append?: InputMaybe<User_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<User_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Settings_Prepend_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  where: User_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_By_PkArgs = {
  _append?: InputMaybe<User_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<User_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Settings_Prepend_Input>;
  _set?: InputMaybe<User_Settings_Set_Input>;
  pk_columns: User_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Settings_ManyArgs = {
  updates: Array<User_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vonage_AppointmentArgs = {
  _set?: InputMaybe<Vonage_Appointment_Set_Input>;
  where: Vonage_Appointment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vonage_Appointment_By_PkArgs = {
  _set?: InputMaybe<Vonage_Appointment_Set_Input>;
  pk_columns: Vonage_Appointment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vonage_Appointment_ManyArgs = {
  updates: Array<Vonage_Appointment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Zrt_TestsArgs = {
  _append?: InputMaybe<Zrt_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Zrt_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Zrt_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Zrt_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Zrt_Tests_Prepend_Input>;
  _set?: InputMaybe<Zrt_Tests_Set_Input>;
  where: Zrt_Tests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Zrt_Tests_By_PkArgs = {
  _append?: InputMaybe<Zrt_Tests_Append_Input>;
  _delete_at_path?: InputMaybe<Zrt_Tests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Zrt_Tests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Zrt_Tests_Delete_Key_Input>;
  _prepend?: InputMaybe<Zrt_Tests_Prepend_Input>;
  _set?: InputMaybe<Zrt_Tests_Set_Input>;
  pk_columns: Zrt_Tests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Zrt_Tests_ManyArgs = {
  updates: Array<Zrt_Tests_Updates>;
};


/** mutation root */
export type Mutation_RootUpsertEducationCourseArgs = {
  input: EducationCourseInput;
};

/** columns and relationships of "nabla_notes" */
export type Nabla_Notes = {
  __typename?: 'nabla_notes';
  appointment_id: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  nabla_notes?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "nabla_notes" */
export type Nabla_NotesNabla_NotesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "nabla_notes" */
export type Nabla_Notes_Aggregate = {
  __typename?: 'nabla_notes_aggregate';
  aggregate?: Maybe<Nabla_Notes_Aggregate_Fields>;
  nodes: Array<Nabla_Notes>;
};

/** aggregate fields of "nabla_notes" */
export type Nabla_Notes_Aggregate_Fields = {
  __typename?: 'nabla_notes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nabla_Notes_Max_Fields>;
  min?: Maybe<Nabla_Notes_Min_Fields>;
};


/** aggregate fields of "nabla_notes" */
export type Nabla_Notes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nabla_Notes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Nabla_Notes_Append_Input = {
  nabla_notes?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "nabla_notes". All fields are combined with a logical 'AND'. */
export type Nabla_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Nabla_Notes_Bool_Exp>>;
  _not?: InputMaybe<Nabla_Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Nabla_Notes_Bool_Exp>>;
  appointment_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  nabla_notes?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "nabla_notes" */
export enum Nabla_Notes_Constraint {
  /** unique or primary key constraint on columns "appointment_id" */
  NablaNotesPkey = 'nabla_notes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Nabla_Notes_Delete_At_Path_Input = {
  nabla_notes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Nabla_Notes_Delete_Elem_Input = {
  nabla_notes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Nabla_Notes_Delete_Key_Input = {
  nabla_notes?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "nabla_notes" */
export type Nabla_Notes_Insert_Input = {
  appointment_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  nabla_notes?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Nabla_Notes_Max_Fields = {
  __typename?: 'nabla_notes_max_fields';
  appointment_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Nabla_Notes_Min_Fields = {
  __typename?: 'nabla_notes_min_fields';
  appointment_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "nabla_notes" */
export type Nabla_Notes_Mutation_Response = {
  __typename?: 'nabla_notes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nabla_Notes>;
};

/** on_conflict condition type for table "nabla_notes" */
export type Nabla_Notes_On_Conflict = {
  constraint: Nabla_Notes_Constraint;
  update_columns?: Array<Nabla_Notes_Update_Column>;
  where?: InputMaybe<Nabla_Notes_Bool_Exp>;
};

/** Ordering options when selecting data from "nabla_notes". */
export type Nabla_Notes_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  nabla_notes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nabla_notes */
export type Nabla_Notes_Pk_Columns_Input = {
  appointment_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Nabla_Notes_Prepend_Input = {
  nabla_notes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "nabla_notes" */
export enum Nabla_Notes_Select_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NablaNotes = 'nabla_notes'
}

/** input type for updating data in table "nabla_notes" */
export type Nabla_Notes_Set_Input = {
  appointment_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  nabla_notes?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "nabla_notes" */
export type Nabla_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nabla_Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nabla_Notes_Stream_Cursor_Value_Input = {
  appointment_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  nabla_notes?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "nabla_notes" */
export enum Nabla_Notes_Update_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NablaNotes = 'nabla_notes'
}

export type Nabla_Notes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Nabla_Notes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Nabla_Notes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Nabla_Notes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Nabla_Notes_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Nabla_Notes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nabla_Notes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nabla_Notes_Bool_Exp;
};

/** columns and relationships of "npi_registry_data" */
export type Npi_Registry_Data = {
  __typename?: 'npi_registry_data';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  npi_data: Scalars['jsonb'];
  npi_number: Scalars['String'];
};


/** columns and relationships of "npi_registry_data" */
export type Npi_Registry_DataNpi_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "npi_registry_data" */
export type Npi_Registry_Data_Aggregate = {
  __typename?: 'npi_registry_data_aggregate';
  aggregate?: Maybe<Npi_Registry_Data_Aggregate_Fields>;
  nodes: Array<Npi_Registry_Data>;
};

/** aggregate fields of "npi_registry_data" */
export type Npi_Registry_Data_Aggregate_Fields = {
  __typename?: 'npi_registry_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Npi_Registry_Data_Max_Fields>;
  min?: Maybe<Npi_Registry_Data_Min_Fields>;
};


/** aggregate fields of "npi_registry_data" */
export type Npi_Registry_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Npi_Registry_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Npi_Registry_Data_Append_Input = {
  npi_data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "npi_registry_data". All fields are combined with a logical 'AND'. */
export type Npi_Registry_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Npi_Registry_Data_Bool_Exp>>;
  _not?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Npi_Registry_Data_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  npi_data?: InputMaybe<Jsonb_Comparison_Exp>;
  npi_number?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "npi_registry_data" */
export enum Npi_Registry_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  NpiRegistryDataPkey = 'npi_registry_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Npi_Registry_Data_Delete_At_Path_Input = {
  npi_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Npi_Registry_Data_Delete_Elem_Input = {
  npi_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Npi_Registry_Data_Delete_Key_Input = {
  npi_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "npi_registry_data" */
export type Npi_Registry_Data_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  npi_data?: InputMaybe<Scalars['jsonb']>;
  npi_number?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Npi_Registry_Data_Max_Fields = {
  __typename?: 'npi_registry_data_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  npi_number?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Npi_Registry_Data_Min_Fields = {
  __typename?: 'npi_registry_data_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  npi_number?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "npi_registry_data" */
export type Npi_Registry_Data_Mutation_Response = {
  __typename?: 'npi_registry_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Npi_Registry_Data>;
};

/** input type for inserting object relation for remote table "npi_registry_data" */
export type Npi_Registry_Data_Obj_Rel_Insert_Input = {
  data: Npi_Registry_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Npi_Registry_Data_On_Conflict>;
};

/** on_conflict condition type for table "npi_registry_data" */
export type Npi_Registry_Data_On_Conflict = {
  constraint: Npi_Registry_Data_Constraint;
  update_columns?: Array<Npi_Registry_Data_Update_Column>;
  where?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "npi_registry_data". */
export type Npi_Registry_Data_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  npi_data?: InputMaybe<Order_By>;
  npi_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: npi_registry_data */
export type Npi_Registry_Data_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Npi_Registry_Data_Prepend_Input = {
  npi_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "npi_registry_data" */
export enum Npi_Registry_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NpiData = 'npi_data',
  /** column name */
  NpiNumber = 'npi_number'
}

/** input type for updating data in table "npi_registry_data" */
export type Npi_Registry_Data_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  npi_data?: InputMaybe<Scalars['jsonb']>;
  npi_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "npi_registry_data" */
export type Npi_Registry_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Npi_Registry_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Npi_Registry_Data_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  npi_data?: InputMaybe<Scalars['jsonb']>;
  npi_number?: InputMaybe<Scalars['String']>;
};

/** update columns of table "npi_registry_data" */
export enum Npi_Registry_Data_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NpiData = 'npi_data',
  /** column name */
  NpiNumber = 'npi_number'
}

export type Npi_Registry_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Npi_Registry_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Npi_Registry_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Npi_Registry_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Npi_Registry_Data_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Npi_Registry_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Npi_Registry_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Npi_Registry_Data_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_payments" */
export type Order_Payments = {
  __typename?: 'order_payments';
  /** In cents */
  amount: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  order_id: Scalars['Int'];
  payment_date: Scalars['timestamptz'];
  payment_intent_id: Scalars['String'];
  /** 1 - paid, 2 - failed */
  status: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "order_payments" */
export type Order_Payments_Aggregate = {
  __typename?: 'order_payments_aggregate';
  aggregate?: Maybe<Order_Payments_Aggregate_Fields>;
  nodes: Array<Order_Payments>;
};

export type Order_Payments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Payments_Aggregate_Bool_Exp_Count>;
};

export type Order_Payments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Payments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_payments" */
export type Order_Payments_Aggregate_Fields = {
  __typename?: 'order_payments_aggregate_fields';
  avg?: Maybe<Order_Payments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Payments_Max_Fields>;
  min?: Maybe<Order_Payments_Min_Fields>;
  stddev?: Maybe<Order_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Payments_Sum_Fields>;
  var_pop?: Maybe<Order_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Payments_Var_Samp_Fields>;
  variance?: Maybe<Order_Payments_Variance_Fields>;
};


/** aggregate fields of "order_payments" */
export type Order_Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_payments" */
export type Order_Payments_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Payments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Payments_Max_Order_By>;
  min?: InputMaybe<Order_Payments_Min_Order_By>;
  stddev?: InputMaybe<Order_Payments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Payments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Payments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Payments_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Payments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Payments_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Payments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_payments" */
export type Order_Payments_Arr_Rel_Insert_Input = {
  data: Array<Order_Payments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Payments_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Payments_Avg_Fields = {
  __typename?: 'order_payments_avg_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_payments" */
export type Order_Payments_Avg_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_payments". All fields are combined with a logical 'AND'. */
export type Order_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Payments_Bool_Exp>>;
  _not?: InputMaybe<Order_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Payments_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_intent_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_payments" */
export enum Order_Payments_Constraint {
  /** unique or primary key constraint on columns "payment_intent_id", "order_id" */
  OrderPaymentsOrderIdPaymentIntentIdUnique = 'order_payments_order_id_payment_intent_id_unique',
  /** unique or primary key constraint on columns "id" */
  OrderPaymentsPkey = 'order_payments_pkey'
}

/** input type for incrementing numeric columns in table "order_payments" */
export type Order_Payments_Inc_Input = {
  /** In cents */
  amount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_payments" */
export type Order_Payments_Insert_Input = {
  /** In cents */
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  payment_date?: InputMaybe<Scalars['timestamptz']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Order_Payments_Max_Fields = {
  __typename?: 'order_payments_max_fields';
  /** In cents */
  amount?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  payment_date?: Maybe<Scalars['timestamptz']>;
  payment_intent_id?: Maybe<Scalars['String']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_payments" */
export type Order_Payments_Max_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Payments_Min_Fields = {
  __typename?: 'order_payments_min_fields';
  /** In cents */
  amount?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  payment_date?: Maybe<Scalars['timestamptz']>;
  payment_intent_id?: Maybe<Scalars['String']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_payments" */
export type Order_Payments_Min_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_payments" */
export type Order_Payments_Mutation_Response = {
  __typename?: 'order_payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Payments>;
};

/** on_conflict condition type for table "order_payments" */
export type Order_Payments_On_Conflict = {
  constraint: Order_Payments_Constraint;
  update_columns?: Array<Order_Payments_Update_Column>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "order_payments". */
export type Order_Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_intent_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_payments */
export type Order_Payments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "order_payments" */
export enum Order_Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "order_payments" */
export type Order_Payments_Set_Input = {
  /** In cents */
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  payment_date?: InputMaybe<Scalars['timestamptz']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Order_Payments_Stddev_Fields = {
  __typename?: 'order_payments_stddev_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_payments" */
export type Order_Payments_Stddev_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Payments_Stddev_Pop_Fields = {
  __typename?: 'order_payments_stddev_pop_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_payments" */
export type Order_Payments_Stddev_Pop_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Payments_Stddev_Samp_Fields = {
  __typename?: 'order_payments_stddev_samp_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_payments" */
export type Order_Payments_Stddev_Samp_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_payments" */
export type Order_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Payments_Stream_Cursor_Value_Input = {
  /** In cents */
  amount?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  payment_date?: InputMaybe<Scalars['timestamptz']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Payments_Sum_Fields = {
  __typename?: 'order_payments_sum_fields';
  /** In cents */
  amount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_payments" */
export type Order_Payments_Sum_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** update columns of table "order_payments" */
export enum Order_Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Order_Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Payments_Var_Pop_Fields = {
  __typename?: 'order_payments_var_pop_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_payments" */
export type Order_Payments_Var_Pop_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Payments_Var_Samp_Fields = {
  __typename?: 'order_payments_var_samp_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_payments" */
export type Order_Payments_Var_Samp_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Payments_Variance_Fields = {
  __typename?: 'order_payments_variance_fields';
  /** In cents */
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  /** 1 - paid, 2 - failed */
  status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_payments" */
export type Order_Payments_Variance_Order_By = {
  /** In cents */
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  /** 1 - paid, 2 - failed */
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_products" */
export type Order_Products = {
  __typename?: 'order_products';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  order_id: Scalars['Int'];
  owner_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  product: Products;
  product_id: Scalars['Int'];
  provider_id?: Maybe<Scalars['uuid']>;
  quantity: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "order_products" */
export type Order_Products_Aggregate = {
  __typename?: 'order_products_aggregate';
  aggregate?: Maybe<Order_Products_Aggregate_Fields>;
  nodes: Array<Order_Products>;
};

export type Order_Products_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Products_Aggregate_Bool_Exp_Count>;
};

export type Order_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_products" */
export type Order_Products_Aggregate_Fields = {
  __typename?: 'order_products_aggregate_fields';
  avg?: Maybe<Order_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Products_Max_Fields>;
  min?: Maybe<Order_Products_Min_Fields>;
  stddev?: Maybe<Order_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Products_Sum_Fields>;
  var_pop?: Maybe<Order_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Products_Var_Samp_Fields>;
  variance?: Maybe<Order_Products_Variance_Fields>;
};


/** aggregate fields of "order_products" */
export type Order_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_products" */
export type Order_Products_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Products_Max_Order_By>;
  min?: InputMaybe<Order_Products_Min_Order_By>;
  stddev?: InputMaybe<Order_Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Products_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_products" */
export type Order_Products_Arr_Rel_Insert_Input = {
  data: Array<Order_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Products_Avg_Fields = {
  __typename?: 'order_products_avg_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_products" */
export type Order_Products_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_products". All fields are combined with a logical 'AND'. */
export type Order_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Products_Bool_Exp>>;
  _not?: InputMaybe<Order_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  owner_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_products" */
export enum Order_Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderProductsPkey = 'order_products_pkey'
}

/** input type for incrementing numeric columns in table "order_products" */
export type Order_Products_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_products" */
export type Order_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Order_Products_Max_Fields = {
  __typename?: 'order_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_products" */
export type Order_Products_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Products_Min_Fields = {
  __typename?: 'order_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  owner_id?: Maybe<Scalars['uuid']>;
  product_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_products" */
export type Order_Products_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_products" */
export type Order_Products_Mutation_Response = {
  __typename?: 'order_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Products>;
};

/** on_conflict condition type for table "order_products" */
export type Order_Products_On_Conflict = {
  constraint: Order_Products_Constraint;
  update_columns?: Array<Order_Products_Update_Column>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "order_products". */
export type Order_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_products */
export type Order_Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "order_products" */
export enum Order_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "order_products" */
export type Order_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Order_Products_Stddev_Fields = {
  __typename?: 'order_products_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_products" */
export type Order_Products_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Products_Stddev_Pop_Fields = {
  __typename?: 'order_products_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_products" */
export type Order_Products_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Products_Stddev_Samp_Fields = {
  __typename?: 'order_products_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_products" */
export type Order_Products_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_products" */
export type Order_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['Int']>;
  owner_id?: InputMaybe<Scalars['uuid']>;
  product_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Products_Sum_Fields = {
  __typename?: 'order_products_sum_fields';
  id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_products" */
export type Order_Products_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "order_products" */
export enum Order_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Order_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Products_Var_Pop_Fields = {
  __typename?: 'order_products_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_products" */
export type Order_Products_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Products_Var_Samp_Fields = {
  __typename?: 'order_products_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_products" */
export type Order_Products_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Products_Variance_Fields = {
  __typename?: 'order_products_variance_fields';
  id?: Maybe<Scalars['Float']>;
  order_id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_products" */
export type Order_Products_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_status_counts" */
export type Order_Status_Counts = {
  __typename?: 'order_status_counts';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['Int']>;
};

export type Order_Status_Counts_Aggregate = {
  __typename?: 'order_status_counts_aggregate';
  aggregate?: Maybe<Order_Status_Counts_Aggregate_Fields>;
  nodes: Array<Order_Status_Counts>;
};

/** aggregate fields of "order_status_counts" */
export type Order_Status_Counts_Aggregate_Fields = {
  __typename?: 'order_status_counts_aggregate_fields';
  avg?: Maybe<Order_Status_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Status_Counts_Max_Fields>;
  min?: Maybe<Order_Status_Counts_Min_Fields>;
  stddev?: Maybe<Order_Status_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Status_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Status_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Status_Counts_Sum_Fields>;
  var_pop?: Maybe<Order_Status_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Status_Counts_Var_Samp_Fields>;
  variance?: Maybe<Order_Status_Counts_Variance_Fields>;
};


/** aggregate fields of "order_status_counts" */
export type Order_Status_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Order_Status_Counts_Avg_Fields = {
  __typename?: 'order_status_counts_avg_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "order_status_counts". All fields are combined with a logical 'AND'. */
export type Order_Status_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Status_Counts_Bool_Exp>>;
  _not?: InputMaybe<Order_Status_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Status_Counts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Status_Counts_Max_Fields = {
  __typename?: 'order_status_counts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Order_Status_Counts_Min_Fields = {
  __typename?: 'order_status_counts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "order_status_counts". */
export type Order_Status_Counts_Order_By = {
  count?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "order_status_counts" */
export enum Order_Status_Counts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Date = 'date',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Order_Status_Counts_Stddev_Fields = {
  __typename?: 'order_status_counts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Order_Status_Counts_Stddev_Pop_Fields = {
  __typename?: 'order_status_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Order_Status_Counts_Stddev_Samp_Fields = {
  __typename?: 'order_status_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "order_status_counts" */
export type Order_Status_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Status_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Status_Counts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Order_Status_Counts_Sum_Fields = {
  __typename?: 'order_status_counts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Order_Status_Counts_Var_Pop_Fields = {
  __typename?: 'order_status_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Order_Status_Counts_Var_Samp_Fields = {
  __typename?: 'order_status_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Order_Status_Counts_Variance_Fields = {
  __typename?: 'order_status_counts_variance_fields';
  count?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "order_status_history" */
export type Order_Status_History = {
  __typename?: 'order_status_history';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  status: Scalars['Int'];
};

/** aggregated selection of "order_status_history" */
export type Order_Status_History_Aggregate = {
  __typename?: 'order_status_history_aggregate';
  aggregate?: Maybe<Order_Status_History_Aggregate_Fields>;
  nodes: Array<Order_Status_History>;
};

export type Order_Status_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Status_History_Aggregate_Bool_Exp_Count>;
};

export type Order_Status_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Status_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_status_history" */
export type Order_Status_History_Aggregate_Fields = {
  __typename?: 'order_status_history_aggregate_fields';
  avg?: Maybe<Order_Status_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Status_History_Max_Fields>;
  min?: Maybe<Order_Status_History_Min_Fields>;
  stddev?: Maybe<Order_Status_History_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Status_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Status_History_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Status_History_Sum_Fields>;
  var_pop?: Maybe<Order_Status_History_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Status_History_Var_Samp_Fields>;
  variance?: Maybe<Order_Status_History_Variance_Fields>;
};


/** aggregate fields of "order_status_history" */
export type Order_Status_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_status_history" */
export type Order_Status_History_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Status_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Status_History_Max_Order_By>;
  min?: InputMaybe<Order_Status_History_Min_Order_By>;
  stddev?: InputMaybe<Order_Status_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Status_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Status_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Status_History_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Status_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Status_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Status_History_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "order_status_history" */
export type Order_Status_History_Arr_Rel_Insert_Input = {
  data: Array<Order_Status_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Status_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Status_History_Avg_Fields = {
  __typename?: 'order_status_history_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_status_history" */
export type Order_Status_History_Avg_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_status_history". All fields are combined with a logical 'AND'. */
export type Order_Status_History_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Status_History_Bool_Exp>>;
  _not?: InputMaybe<Order_Status_History_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Status_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_status_history" */
export enum Order_Status_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderStatusHistoryPkey = 'order_status_history_pkey'
}

/** input type for incrementing numeric columns in table "order_status_history" */
export type Order_Status_History_Inc_Input = {
  order_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "order_status_history" */
export type Order_Status_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Order_Status_History_Max_Fields = {
  __typename?: 'order_status_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "order_status_history" */
export type Order_Status_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Status_History_Min_Fields = {
  __typename?: 'order_status_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  order_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "order_status_history" */
export type Order_Status_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_status_history" */
export type Order_Status_History_Mutation_Response = {
  __typename?: 'order_status_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Status_History>;
};

/** on_conflict condition type for table "order_status_history" */
export type Order_Status_History_On_Conflict = {
  constraint: Order_Status_History_Constraint;
  update_columns?: Array<Order_Status_History_Update_Column>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};

/** Ordering options when selecting data from "order_status_history". */
export type Order_Status_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_status_history */
export type Order_Status_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "order_status_history" */
export enum Order_Status_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "order_status_history" */
export type Order_Status_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Order_Status_History_Stddev_Fields = {
  __typename?: 'order_status_history_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_status_history" */
export type Order_Status_History_Stddev_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Status_History_Stddev_Pop_Fields = {
  __typename?: 'order_status_history_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_status_history" */
export type Order_Status_History_Stddev_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Status_History_Stddev_Samp_Fields = {
  __typename?: 'order_status_history_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_status_history" */
export type Order_Status_History_Stddev_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_status_history" */
export type Order_Status_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Status_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Status_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Order_Status_History_Sum_Fields = {
  __typename?: 'order_status_history_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "order_status_history" */
export type Order_Status_History_Sum_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** update columns of table "order_status_history" */
export enum Order_Status_History_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Status = 'status'
}

export type Order_Status_History_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Status_History_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Status_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Status_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Status_History_Var_Pop_Fields = {
  __typename?: 'order_status_history_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_status_history" */
export type Order_Status_History_Var_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Status_History_Var_Samp_Fields = {
  __typename?: 'order_status_history_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_status_history" */
export type Order_Status_History_Var_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Status_History_Variance_Fields = {
  __typename?: 'order_status_history_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_status_history" */
export type Order_Status_History_Variance_Order_By = {
  order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "orders" */
export type Orders = {
  __typename?: 'orders';
  carrier?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  delivery_address: Delivery_Addresses;
  delivery_address_id: Scalars['Int'];
  delivery_date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_archived?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  order_payments: Array<Order_Payments>;
  /** An aggregate relationship */
  order_payments_aggregate: Order_Payments_Aggregate;
  /** An array relationship */
  order_products: Array<Order_Products>;
  /** An aggregate relationship */
  order_products_aggregate: Order_Products_Aggregate;
  /** An array relationship */
  order_status_histories: Array<Order_Status_History>;
  /** An aggregate relationship */
  order_status_histories_aggregate: Order_Status_History_Aggregate;
  order_type: Scalars['Int'];
  patient_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  payment_transaction_orders: Array<Payment_Transaction_Orders>;
  /** An aggregate relationship */
  payment_transaction_orders_aggregate: Payment_Transaction_Orders_Aggregate;
  provider_id?: Maybe<Scalars['uuid']>;
  shipped_at?: Maybe<Scalars['timestamptz']>;
  shipping_cost: Scalars['numeric'];
  status?: Maybe<Scalars['Int']>;
  subtotal_amount: Scalars['numeric'];
  tax_amount: Scalars['numeric'];
  total_amount: Scalars['numeric'];
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};


/** columns and relationships of "orders" */
export type OrdersOrder_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Payments_Order_By>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Payments_Order_By>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Products_Order_By>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Products_Order_By>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Status_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersOrder_Status_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersPayment_Transaction_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


/** columns and relationships of "orders" */
export type OrdersPayment_Transaction_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};

/** aggregated selection of "orders" */
export type Orders_Aggregate = {
  __typename?: 'orders_aggregate';
  aggregate?: Maybe<Orders_Aggregate_Fields>;
  nodes: Array<Orders>;
};

/** aggregate fields of "orders" */
export type Orders_Aggregate_Fields = {
  __typename?: 'orders_aggregate_fields';
  avg?: Maybe<Orders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Orders_Max_Fields>;
  min?: Maybe<Orders_Min_Fields>;
  stddev?: Maybe<Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Orders_Sum_Fields>;
  var_pop?: Maybe<Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Orders_Var_Samp_Fields>;
  variance?: Maybe<Orders_Variance_Fields>;
};


/** aggregate fields of "orders" */
export type Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Orders_Avg_Fields = {
  __typename?: 'orders_avg_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "orders". All fields are combined with a logical 'AND'. */
export type Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Bool_Exp>>;
  _not?: InputMaybe<Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Bool_Exp>>;
  carrier?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_address?: InputMaybe<Delivery_Addresses_Bool_Exp>;
  delivery_address_id?: InputMaybe<Int_Comparison_Exp>;
  delivery_date?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  order_payments?: InputMaybe<Order_Payments_Bool_Exp>;
  order_payments_aggregate?: InputMaybe<Order_Payments_Aggregate_Bool_Exp>;
  order_products?: InputMaybe<Order_Products_Bool_Exp>;
  order_products_aggregate?: InputMaybe<Order_Products_Aggregate_Bool_Exp>;
  order_status_histories?: InputMaybe<Order_Status_History_Bool_Exp>;
  order_status_histories_aggregate?: InputMaybe<Order_Status_History_Aggregate_Bool_Exp>;
  order_type?: InputMaybe<Int_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_transaction_orders?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
  payment_transaction_orders_aggregate?: InputMaybe<Payment_Transaction_Orders_Aggregate_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipped_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  shipping_cost?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  subtotal_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "orders" */
export enum Orders_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrdersPkey = 'orders_pkey'
}

/** input type for incrementing numeric columns in table "orders" */
export type Orders_Inc_Input = {
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_type?: InputMaybe<Scalars['Int']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "orders" */
export type Orders_Insert_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_address?: InputMaybe<Delivery_Addresses_Obj_Rel_Insert_Input>;
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  delivery_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  order_payments?: InputMaybe<Order_Payments_Arr_Rel_Insert_Input>;
  order_products?: InputMaybe<Order_Products_Arr_Rel_Insert_Input>;
  order_status_histories?: InputMaybe<Order_Status_History_Arr_Rel_Insert_Input>;
  order_type?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payment_transaction_orders?: InputMaybe<Payment_Transaction_Orders_Arr_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Orders_Max_Fields = {
  __typename?: 'orders_max_fields';
  carrier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  order_type?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  shipped_at?: Maybe<Scalars['timestamptz']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Orders_Min_Fields = {
  __typename?: 'orders_min_fields';
  carrier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  order_type?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  shipped_at?: Maybe<Scalars['timestamptz']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "orders" */
export type Orders_Mutation_Response = {
  __typename?: 'orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Orders>;
};

/** input type for inserting object relation for remote table "orders" */
export type Orders_Obj_Rel_Insert_Input = {
  data: Orders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};

/** on_conflict condition type for table "orders" */
export type Orders_On_Conflict = {
  constraint: Orders_Constraint;
  update_columns?: Array<Orders_Update_Column>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "orders". */
export type Orders_Order_By = {
  carrier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_address?: InputMaybe<Delivery_Addresses_Order_By>;
  delivery_address_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  order_payments_aggregate?: InputMaybe<Order_Payments_Aggregate_Order_By>;
  order_products_aggregate?: InputMaybe<Order_Products_Aggregate_Order_By>;
  order_status_histories_aggregate?: InputMaybe<Order_Status_History_Aggregate_Order_By>;
  order_type?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  payment_transaction_orders_aggregate?: InputMaybe<Payment_Transaction_Orders_Aggregate_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  shipped_at?: InputMaybe<Order_By>;
  shipping_cost?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subtotal_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: orders */
export type Orders_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "orders" */
export enum Orders_Select_Column {
  /** column name */
  Carrier = 'carrier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryAddressId = 'delivery_address_id',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  OrderType = 'order_type',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ShippedAt = 'shipped_at',
  /** column name */
  ShippingCost = 'shipping_cost',
  /** column name */
  Status = 'status',
  /** column name */
  SubtotalAmount = 'subtotal_amount',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "orders" */
export type Orders_Set_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  delivery_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  order_type?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Orders_Stddev_Fields = {
  __typename?: 'orders_stddev_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Orders_Stddev_Pop_Fields = {
  __typename?: 'orders_stddev_pop_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Orders_Stddev_Samp_Fields = {
  __typename?: 'orders_stddev_samp_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "orders" */
export type Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orders_Stream_Cursor_Value_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  delivery_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  order_type?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Orders_Sum_Fields = {
  __typename?: 'orders_sum_fields';
  delivery_address_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_type?: Maybe<Scalars['Int']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "orders" */
export enum Orders_Update_Column {
  /** column name */
  Carrier = 'carrier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryAddressId = 'delivery_address_id',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  OrderType = 'order_type',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ShippedAt = 'shipped_at',
  /** column name */
  ShippingCost = 'shipping_cost',
  /** column name */
  Status = 'status',
  /** column name */
  SubtotalAmount = 'subtotal_amount',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Orders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Orders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Orders_Var_Pop_Fields = {
  __typename?: 'orders_var_pop_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Orders_Var_Samp_Fields = {
  __typename?: 'orders_var_samp_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Orders_Variance_Fields = {
  __typename?: 'orders_variance_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "orders_view" */
export type Orders_View = {
  __typename?: 'orders_view';
  carrier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  id_text?: Maybe<Scalars['String']>;
  is_archived?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  order_status_histories: Array<Order_Status_History>;
  /** An aggregate relationship */
  order_status_histories_aggregate: Order_Status_History_Aggregate;
  order_type?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  shipped_at?: Maybe<Scalars['timestamptz']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "orders_view" */
export type Orders_ViewOrder_Status_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


/** columns and relationships of "orders_view" */
export type Orders_ViewOrder_Status_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};

/** aggregated selection of "orders_view" */
export type Orders_View_Aggregate = {
  __typename?: 'orders_view_aggregate';
  aggregate?: Maybe<Orders_View_Aggregate_Fields>;
  nodes: Array<Orders_View>;
};

/** aggregate fields of "orders_view" */
export type Orders_View_Aggregate_Fields = {
  __typename?: 'orders_view_aggregate_fields';
  avg?: Maybe<Orders_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Orders_View_Max_Fields>;
  min?: Maybe<Orders_View_Min_Fields>;
  stddev?: Maybe<Orders_View_Stddev_Fields>;
  stddev_pop?: Maybe<Orders_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Orders_View_Stddev_Samp_Fields>;
  sum?: Maybe<Orders_View_Sum_Fields>;
  var_pop?: Maybe<Orders_View_Var_Pop_Fields>;
  var_samp?: Maybe<Orders_View_Var_Samp_Fields>;
  variance?: Maybe<Orders_View_Variance_Fields>;
};


/** aggregate fields of "orders_view" */
export type Orders_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Orders_View_Avg_Fields = {
  __typename?: 'orders_view_avg_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "orders_view". All fields are combined with a logical 'AND'. */
export type Orders_View_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_View_Bool_Exp>>;
  _not?: InputMaybe<Orders_View_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_View_Bool_Exp>>;
  carrier?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_address_id?: InputMaybe<Int_Comparison_Exp>;
  delivery_date?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  id_text?: InputMaybe<String_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  order_status_histories?: InputMaybe<Order_Status_History_Bool_Exp>;
  order_status_histories_aggregate?: InputMaybe<Order_Status_History_Aggregate_Bool_Exp>;
  order_type?: InputMaybe<Int_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  shipped_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  shipping_cost?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  subtotal_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "orders_view" */
export type Orders_View_Inc_Input = {
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order_type?: InputMaybe<Scalars['Int']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "orders_view" */
export type Orders_View_Insert_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  delivery_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  id_text?: InputMaybe<Scalars['String']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  order_status_histories?: InputMaybe<Order_Status_History_Arr_Rel_Insert_Input>;
  order_type?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Orders_View_Max_Fields = {
  __typename?: 'orders_view_max_fields';
  carrier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  id_text?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  shipped_at?: Maybe<Scalars['timestamptz']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Orders_View_Min_Fields = {
  __typename?: 'orders_view_min_fields';
  carrier?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  id_text?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['Int']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  shipped_at?: Maybe<Scalars['timestamptz']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "orders_view" */
export type Orders_View_Mutation_Response = {
  __typename?: 'orders_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Orders_View>;
};

/** Ordering options when selecting data from "orders_view". */
export type Orders_View_Order_By = {
  carrier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delivery_address_id?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_text?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  order_status_histories_aggregate?: InputMaybe<Order_Status_History_Aggregate_Order_By>;
  order_type?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  shipped_at?: InputMaybe<Order_By>;
  shipping_cost?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subtotal_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "orders_view" */
export enum Orders_View_Select_Column {
  /** column name */
  Carrier = 'carrier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeliveryAddressId = 'delivery_address_id',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Id = 'id',
  /** column name */
  IdText = 'id_text',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  OrderType = 'order_type',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ShippedAt = 'shipped_at',
  /** column name */
  ShippingCost = 'shipping_cost',
  /** column name */
  Status = 'status',
  /** column name */
  SubtotalAmount = 'subtotal_amount',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "orders_view" */
export type Orders_View_Set_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  delivery_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  id_text?: InputMaybe<Scalars['String']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  order_type?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Orders_View_Stddev_Fields = {
  __typename?: 'orders_view_stddev_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Orders_View_Stddev_Pop_Fields = {
  __typename?: 'orders_view_stddev_pop_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Orders_View_Stddev_Samp_Fields = {
  __typename?: 'orders_view_stddev_samp_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "orders_view" */
export type Orders_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orders_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orders_View_Stream_Cursor_Value_Input = {
  carrier?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  delivery_address_id?: InputMaybe<Scalars['Int']>;
  delivery_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  id_text?: InputMaybe<Scalars['String']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  order_type?: InputMaybe<Scalars['Int']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  shipped_at?: InputMaybe<Scalars['timestamptz']>;
  shipping_cost?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['Int']>;
  subtotal_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Orders_View_Sum_Fields = {
  __typename?: 'orders_view_sum_fields';
  delivery_address_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order_type?: Maybe<Scalars['Int']>;
  shipping_cost?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['Int']>;
  subtotal_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

export type Orders_View_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Orders_View_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Orders_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Orders_View_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Orders_View_Var_Pop_Fields = {
  __typename?: 'orders_view_var_pop_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Orders_View_Var_Samp_Fields = {
  __typename?: 'orders_view_var_samp_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Orders_View_Variance_Fields = {
  __typename?: 'orders_view_variance_fields';
  delivery_address_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  order_type?: Maybe<Scalars['Float']>;
  shipping_cost?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  subtotal_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "patient_achievement_events" */
export type Patient_Achievement_Events = {
  __typename?: 'patient_achievement_events';
  action: Scalars['String'];
  created_at: Scalars['timestamptz'];
  dedupe_key: Scalars['String'];
  id: Scalars['Int'];
  metadata: Scalars['jsonb'];
  occurred_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "patient_achievement_events" */
export type Patient_Achievement_EventsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "patient_achievement_events" */
export type Patient_Achievement_Events_Aggregate = {
  __typename?: 'patient_achievement_events_aggregate';
  aggregate?: Maybe<Patient_Achievement_Events_Aggregate_Fields>;
  nodes: Array<Patient_Achievement_Events>;
};

/** aggregate fields of "patient_achievement_events" */
export type Patient_Achievement_Events_Aggregate_Fields = {
  __typename?: 'patient_achievement_events_aggregate_fields';
  avg?: Maybe<Patient_Achievement_Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Achievement_Events_Max_Fields>;
  min?: Maybe<Patient_Achievement_Events_Min_Fields>;
  stddev?: Maybe<Patient_Achievement_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Achievement_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Achievement_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Achievement_Events_Sum_Fields>;
  var_pop?: Maybe<Patient_Achievement_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Achievement_Events_Var_Samp_Fields>;
  variance?: Maybe<Patient_Achievement_Events_Variance_Fields>;
};


/** aggregate fields of "patient_achievement_events" */
export type Patient_Achievement_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Achievement_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Patient_Achievement_Events_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Patient_Achievement_Events_Avg_Fields = {
  __typename?: 'patient_achievement_events_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "patient_achievement_events". All fields are combined with a logical 'AND'. */
export type Patient_Achievement_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Achievement_Events_Bool_Exp>>;
  _not?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Achievement_Events_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dedupe_key?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  occurred_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_achievement_events" */
export enum Patient_Achievement_Events_Constraint {
  /** unique or primary key constraint on columns "dedupe_key" */
  PatientAchievementEventsDedupeKeyKey = 'patient_achievement_events_dedupe_key_key',
  /** unique or primary key constraint on columns "id" */
  PatientAchievementEventsPkey = 'patient_achievement_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Patient_Achievement_Events_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Patient_Achievement_Events_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Patient_Achievement_Events_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "patient_achievement_events" */
export type Patient_Achievement_Events_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_achievement_events" */
export type Patient_Achievement_Events_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dedupe_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  occurred_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Patient_Achievement_Events_Max_Fields = {
  __typename?: 'patient_achievement_events_max_fields';
  action?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dedupe_key?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  occurred_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Patient_Achievement_Events_Min_Fields = {
  __typename?: 'patient_achievement_events_min_fields';
  action?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dedupe_key?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  occurred_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "patient_achievement_events" */
export type Patient_Achievement_Events_Mutation_Response = {
  __typename?: 'patient_achievement_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Achievement_Events>;
};

/** on_conflict condition type for table "patient_achievement_events" */
export type Patient_Achievement_Events_On_Conflict = {
  constraint: Patient_Achievement_Events_Constraint;
  update_columns?: Array<Patient_Achievement_Events_Update_Column>;
  where?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_achievement_events". */
export type Patient_Achievement_Events_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dedupe_key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  occurred_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_achievement_events */
export type Patient_Achievement_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Patient_Achievement_Events_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "patient_achievement_events" */
export enum Patient_Achievement_Events_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DedupeKey = 'dedupe_key',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "patient_achievement_events" */
export type Patient_Achievement_Events_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dedupe_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  occurred_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Patient_Achievement_Events_Stddev_Fields = {
  __typename?: 'patient_achievement_events_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Patient_Achievement_Events_Stddev_Pop_Fields = {
  __typename?: 'patient_achievement_events_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Patient_Achievement_Events_Stddev_Samp_Fields = {
  __typename?: 'patient_achievement_events_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "patient_achievement_events" */
export type Patient_Achievement_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Achievement_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Achievement_Events_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dedupe_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  occurred_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Patient_Achievement_Events_Sum_Fields = {
  __typename?: 'patient_achievement_events_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "patient_achievement_events" */
export enum Patient_Achievement_Events_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DedupeKey = 'dedupe_key',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  UserId = 'user_id'
}

export type Patient_Achievement_Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Patient_Achievement_Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Patient_Achievement_Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Patient_Achievement_Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Patient_Achievement_Events_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Achievement_Events_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Patient_Achievement_Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Achievement_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Achievement_Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Achievement_Events_Var_Pop_Fields = {
  __typename?: 'patient_achievement_events_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Patient_Achievement_Events_Var_Samp_Fields = {
  __typename?: 'patient_achievement_events_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Patient_Achievement_Events_Variance_Fields = {
  __typename?: 'patient_achievement_events_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "patient_achievement_progress" */
export type Patient_Achievement_Progress = {
  __typename?: 'patient_achievement_progress';
  achievement_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  current_tier?: Maybe<Scalars['Int']>;
  current_value: Scalars['Int'];
  id: Scalars['Int'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "patient_achievement_progress" */
export type Patient_Achievement_Progress_Aggregate = {
  __typename?: 'patient_achievement_progress_aggregate';
  aggregate?: Maybe<Patient_Achievement_Progress_Aggregate_Fields>;
  nodes: Array<Patient_Achievement_Progress>;
};

/** aggregate fields of "patient_achievement_progress" */
export type Patient_Achievement_Progress_Aggregate_Fields = {
  __typename?: 'patient_achievement_progress_aggregate_fields';
  avg?: Maybe<Patient_Achievement_Progress_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Achievement_Progress_Max_Fields>;
  min?: Maybe<Patient_Achievement_Progress_Min_Fields>;
  stddev?: Maybe<Patient_Achievement_Progress_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Achievement_Progress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Achievement_Progress_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Achievement_Progress_Sum_Fields>;
  var_pop?: Maybe<Patient_Achievement_Progress_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Achievement_Progress_Var_Samp_Fields>;
  variance?: Maybe<Patient_Achievement_Progress_Variance_Fields>;
};


/** aggregate fields of "patient_achievement_progress" */
export type Patient_Achievement_Progress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Achievement_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Patient_Achievement_Progress_Avg_Fields = {
  __typename?: 'patient_achievement_progress_avg_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "patient_achievement_progress". All fields are combined with a logical 'AND'. */
export type Patient_Achievement_Progress_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Achievement_Progress_Bool_Exp>>;
  _not?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Achievement_Progress_Bool_Exp>>;
  achievement_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_tier?: InputMaybe<Int_Comparison_Exp>;
  current_value?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_achievement_progress" */
export enum Patient_Achievement_Progress_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientAchievementProgressPkey = 'patient_achievement_progress_pkey',
  /** unique or primary key constraint on columns "user_id", "achievement_id" */
  PatientAchievementProgressUserIdAchievementIdKey = 'patient_achievement_progress_user_id_achievement_id_key'
}

/** input type for incrementing numeric columns in table "patient_achievement_progress" */
export type Patient_Achievement_Progress_Inc_Input = {
  current_tier?: InputMaybe<Scalars['Int']>;
  current_value?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_achievement_progress" */
export type Patient_Achievement_Progress_Insert_Input = {
  achievement_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_tier?: InputMaybe<Scalars['Int']>;
  current_value?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Patient_Achievement_Progress_Max_Fields = {
  __typename?: 'patient_achievement_progress_max_fields';
  achievement_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_tier?: Maybe<Scalars['Int']>;
  current_value?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Patient_Achievement_Progress_Min_Fields = {
  __typename?: 'patient_achievement_progress_min_fields';
  achievement_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_tier?: Maybe<Scalars['Int']>;
  current_value?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "patient_achievement_progress" */
export type Patient_Achievement_Progress_Mutation_Response = {
  __typename?: 'patient_achievement_progress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Achievement_Progress>;
};

/** on_conflict condition type for table "patient_achievement_progress" */
export type Patient_Achievement_Progress_On_Conflict = {
  constraint: Patient_Achievement_Progress_Constraint;
  update_columns?: Array<Patient_Achievement_Progress_Update_Column>;
  where?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_achievement_progress". */
export type Patient_Achievement_Progress_Order_By = {
  achievement_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_tier?: InputMaybe<Order_By>;
  current_value?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_achievement_progress */
export type Patient_Achievement_Progress_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "patient_achievement_progress" */
export enum Patient_Achievement_Progress_Select_Column {
  /** column name */
  AchievementId = 'achievement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentTier = 'current_tier',
  /** column name */
  CurrentValue = 'current_value',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "patient_achievement_progress" */
export type Patient_Achievement_Progress_Set_Input = {
  achievement_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_tier?: InputMaybe<Scalars['Int']>;
  current_value?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Patient_Achievement_Progress_Stddev_Fields = {
  __typename?: 'patient_achievement_progress_stddev_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Patient_Achievement_Progress_Stddev_Pop_Fields = {
  __typename?: 'patient_achievement_progress_stddev_pop_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Patient_Achievement_Progress_Stddev_Samp_Fields = {
  __typename?: 'patient_achievement_progress_stddev_samp_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "patient_achievement_progress" */
export type Patient_Achievement_Progress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Achievement_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Achievement_Progress_Stream_Cursor_Value_Input = {
  achievement_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_tier?: InputMaybe<Scalars['Int']>;
  current_value?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Patient_Achievement_Progress_Sum_Fields = {
  __typename?: 'patient_achievement_progress_sum_fields';
  current_tier?: Maybe<Scalars['Int']>;
  current_value?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "patient_achievement_progress" */
export enum Patient_Achievement_Progress_Update_Column {
  /** column name */
  AchievementId = 'achievement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentTier = 'current_tier',
  /** column name */
  CurrentValue = 'current_value',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Patient_Achievement_Progress_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Achievement_Progress_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Achievement_Progress_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Achievement_Progress_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Achievement_Progress_Var_Pop_Fields = {
  __typename?: 'patient_achievement_progress_var_pop_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Patient_Achievement_Progress_Var_Samp_Fields = {
  __typename?: 'patient_achievement_progress_var_samp_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Patient_Achievement_Progress_Variance_Fields = {
  __typename?: 'patient_achievement_progress_variance_fields';
  current_tier?: Maybe<Scalars['Float']>;
  current_value?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks = {
  __typename?: 'patient_achievement_unlocks';
  achievement_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  points: Scalars['Int'];
  seen_at?: Maybe<Scalars['timestamptz']>;
  tier?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Aggregate = {
  __typename?: 'patient_achievement_unlocks_aggregate';
  aggregate?: Maybe<Patient_Achievement_Unlocks_Aggregate_Fields>;
  nodes: Array<Patient_Achievement_Unlocks>;
};

/** aggregate fields of "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Aggregate_Fields = {
  __typename?: 'patient_achievement_unlocks_aggregate_fields';
  avg?: Maybe<Patient_Achievement_Unlocks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Patient_Achievement_Unlocks_Max_Fields>;
  min?: Maybe<Patient_Achievement_Unlocks_Min_Fields>;
  stddev?: Maybe<Patient_Achievement_Unlocks_Stddev_Fields>;
  stddev_pop?: Maybe<Patient_Achievement_Unlocks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Patient_Achievement_Unlocks_Stddev_Samp_Fields>;
  sum?: Maybe<Patient_Achievement_Unlocks_Sum_Fields>;
  var_pop?: Maybe<Patient_Achievement_Unlocks_Var_Pop_Fields>;
  var_samp?: Maybe<Patient_Achievement_Unlocks_Var_Samp_Fields>;
  variance?: Maybe<Patient_Achievement_Unlocks_Variance_Fields>;
};


/** aggregate fields of "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Patient_Achievement_Unlocks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Patient_Achievement_Unlocks_Avg_Fields = {
  __typename?: 'patient_achievement_unlocks_avg_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "patient_achievement_unlocks". All fields are combined with a logical 'AND'. */
export type Patient_Achievement_Unlocks_Bool_Exp = {
  _and?: InputMaybe<Array<Patient_Achievement_Unlocks_Bool_Exp>>;
  _not?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
  _or?: InputMaybe<Array<Patient_Achievement_Unlocks_Bool_Exp>>;
  achievement_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  points?: InputMaybe<Int_Comparison_Exp>;
  seen_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  tier?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "patient_achievement_unlocks" */
export enum Patient_Achievement_Unlocks_Constraint {
  /** unique or primary key constraint on columns "id" */
  PatientAchievementUnlocksPkey = 'patient_achievement_unlocks_pkey',
  /** unique or primary key constraint on columns "user_id", "tier", "achievement_id" */
  PatientAchievementUnlocksUserIdAchievementIdTierKey = 'patient_achievement_unlocks_user_id_achievement_id_tier_key'
}

/** input type for incrementing numeric columns in table "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
  tier?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Insert_Input = {
  achievement_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
  seen_at?: InputMaybe<Scalars['timestamptz']>;
  tier?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Patient_Achievement_Unlocks_Max_Fields = {
  __typename?: 'patient_achievement_unlocks_max_fields';
  achievement_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  seen_at?: Maybe<Scalars['timestamptz']>;
  tier?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Patient_Achievement_Unlocks_Min_Fields = {
  __typename?: 'patient_achievement_unlocks_min_fields';
  achievement_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  seen_at?: Maybe<Scalars['timestamptz']>;
  tier?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Mutation_Response = {
  __typename?: 'patient_achievement_unlocks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient_Achievement_Unlocks>;
};

/** on_conflict condition type for table "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_On_Conflict = {
  constraint: Patient_Achievement_Unlocks_Constraint;
  update_columns?: Array<Patient_Achievement_Unlocks_Update_Column>;
  where?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
};

/** Ordering options when selecting data from "patient_achievement_unlocks". */
export type Patient_Achievement_Unlocks_Order_By = {
  achievement_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  points?: InputMaybe<Order_By>;
  seen_at?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: patient_achievement_unlocks */
export type Patient_Achievement_Unlocks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "patient_achievement_unlocks" */
export enum Patient_Achievement_Unlocks_Select_Column {
  /** column name */
  AchievementId = 'achievement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Points = 'points',
  /** column name */
  SeenAt = 'seen_at',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Set_Input = {
  achievement_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
  seen_at?: InputMaybe<Scalars['timestamptz']>;
  tier?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Patient_Achievement_Unlocks_Stddev_Fields = {
  __typename?: 'patient_achievement_unlocks_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Patient_Achievement_Unlocks_Stddev_Pop_Fields = {
  __typename?: 'patient_achievement_unlocks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Patient_Achievement_Unlocks_Stddev_Samp_Fields = {
  __typename?: 'patient_achievement_unlocks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "patient_achievement_unlocks" */
export type Patient_Achievement_Unlocks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Patient_Achievement_Unlocks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Patient_Achievement_Unlocks_Stream_Cursor_Value_Input = {
  achievement_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
  seen_at?: InputMaybe<Scalars['timestamptz']>;
  tier?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Patient_Achievement_Unlocks_Sum_Fields = {
  __typename?: 'patient_achievement_unlocks_sum_fields';
  id?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['Int']>;
};

/** update columns of table "patient_achievement_unlocks" */
export enum Patient_Achievement_Unlocks_Update_Column {
  /** column name */
  AchievementId = 'achievement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Points = 'points',
  /** column name */
  SeenAt = 'seen_at',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Patient_Achievement_Unlocks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Patient_Achievement_Unlocks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Patient_Achievement_Unlocks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Patient_Achievement_Unlocks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Patient_Achievement_Unlocks_Var_Pop_Fields = {
  __typename?: 'patient_achievement_unlocks_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Patient_Achievement_Unlocks_Var_Samp_Fields = {
  __typename?: 'patient_achievement_unlocks_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Patient_Achievement_Unlocks_Variance_Fields = {
  __typename?: 'patient_achievement_unlocks_variance_fields';
  id?: Maybe<Scalars['Float']>;
  points?: Maybe<Scalars['Float']>;
  tier?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "payment_provider". All fields are combined with logical 'AND'. */
export type Payment_Provider_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['payment_provider']>;
  _gt?: InputMaybe<Scalars['payment_provider']>;
  _gte?: InputMaybe<Scalars['payment_provider']>;
  _in?: InputMaybe<Array<Scalars['payment_provider']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['payment_provider']>;
  _lte?: InputMaybe<Scalars['payment_provider']>;
  _neq?: InputMaybe<Scalars['payment_provider']>;
  _nin?: InputMaybe<Array<Scalars['payment_provider']>>;
};

/** columns and relationships of "payment_stats_by_day" */
export type Payment_Stats_By_Day = {
  __typename?: 'payment_stats_by_day';
  date?: Maybe<Scalars['date']>;
  fee_received_by_codex?: Maybe<Scalars['numeric']>;
  payment_for_appointments?: Maybe<Scalars['numeric']>;
  payment_for_orders?: Maybe<Scalars['numeric']>;
  refunds?: Maybe<Scalars['numeric']>;
};

export type Payment_Stats_By_Day_Aggregate = {
  __typename?: 'payment_stats_by_day_aggregate';
  aggregate?: Maybe<Payment_Stats_By_Day_Aggregate_Fields>;
  nodes: Array<Payment_Stats_By_Day>;
};

/** aggregate fields of "payment_stats_by_day" */
export type Payment_Stats_By_Day_Aggregate_Fields = {
  __typename?: 'payment_stats_by_day_aggregate_fields';
  avg?: Maybe<Payment_Stats_By_Day_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Stats_By_Day_Max_Fields>;
  min?: Maybe<Payment_Stats_By_Day_Min_Fields>;
  stddev?: Maybe<Payment_Stats_By_Day_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Stats_By_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Stats_By_Day_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Stats_By_Day_Sum_Fields>;
  var_pop?: Maybe<Payment_Stats_By_Day_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Stats_By_Day_Var_Samp_Fields>;
  variance?: Maybe<Payment_Stats_By_Day_Variance_Fields>;
};


/** aggregate fields of "payment_stats_by_day" */
export type Payment_Stats_By_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Payment_Stats_By_Day_Avg_Fields = {
  __typename?: 'payment_stats_by_day_avg_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "payment_stats_by_day". All fields are combined with a logical 'AND'. */
export type Payment_Stats_By_Day_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Stats_By_Day_Bool_Exp>>;
  _not?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Stats_By_Day_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  fee_received_by_codex?: InputMaybe<Numeric_Comparison_Exp>;
  payment_for_appointments?: InputMaybe<Numeric_Comparison_Exp>;
  payment_for_orders?: InputMaybe<Numeric_Comparison_Exp>;
  refunds?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Payment_Stats_By_Day_Max_Fields = {
  __typename?: 'payment_stats_by_day_max_fields';
  date?: Maybe<Scalars['date']>;
  fee_received_by_codex?: Maybe<Scalars['numeric']>;
  payment_for_appointments?: Maybe<Scalars['numeric']>;
  payment_for_orders?: Maybe<Scalars['numeric']>;
  refunds?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Payment_Stats_By_Day_Min_Fields = {
  __typename?: 'payment_stats_by_day_min_fields';
  date?: Maybe<Scalars['date']>;
  fee_received_by_codex?: Maybe<Scalars['numeric']>;
  payment_for_appointments?: Maybe<Scalars['numeric']>;
  payment_for_orders?: Maybe<Scalars['numeric']>;
  refunds?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "payment_stats_by_day". */
export type Payment_Stats_By_Day_Order_By = {
  date?: InputMaybe<Order_By>;
  fee_received_by_codex?: InputMaybe<Order_By>;
  payment_for_appointments?: InputMaybe<Order_By>;
  payment_for_orders?: InputMaybe<Order_By>;
  refunds?: InputMaybe<Order_By>;
};

/** select columns of table "payment_stats_by_day" */
export enum Payment_Stats_By_Day_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  FeeReceivedByCodex = 'fee_received_by_codex',
  /** column name */
  PaymentForAppointments = 'payment_for_appointments',
  /** column name */
  PaymentForOrders = 'payment_for_orders',
  /** column name */
  Refunds = 'refunds'
}

/** aggregate stddev on columns */
export type Payment_Stats_By_Day_Stddev_Fields = {
  __typename?: 'payment_stats_by_day_stddev_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Payment_Stats_By_Day_Stddev_Pop_Fields = {
  __typename?: 'payment_stats_by_day_stddev_pop_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Payment_Stats_By_Day_Stddev_Samp_Fields = {
  __typename?: 'payment_stats_by_day_stddev_samp_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "payment_stats_by_day" */
export type Payment_Stats_By_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Stats_By_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Stats_By_Day_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']>;
  fee_received_by_codex?: InputMaybe<Scalars['numeric']>;
  payment_for_appointments?: InputMaybe<Scalars['numeric']>;
  payment_for_orders?: InputMaybe<Scalars['numeric']>;
  refunds?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Payment_Stats_By_Day_Sum_Fields = {
  __typename?: 'payment_stats_by_day_sum_fields';
  fee_received_by_codex?: Maybe<Scalars['numeric']>;
  payment_for_appointments?: Maybe<Scalars['numeric']>;
  payment_for_orders?: Maybe<Scalars['numeric']>;
  refunds?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Payment_Stats_By_Day_Var_Pop_Fields = {
  __typename?: 'payment_stats_by_day_var_pop_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Payment_Stats_By_Day_Var_Samp_Fields = {
  __typename?: 'payment_stats_by_day_var_samp_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Payment_Stats_By_Day_Variance_Fields = {
  __typename?: 'payment_stats_by_day_variance_fields';
  fee_received_by_codex?: Maybe<Scalars['Float']>;
  payment_for_appointments?: Maybe<Scalars['Float']>;
  payment_for_orders?: Maybe<Scalars['Float']>;
  refunds?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment_transaction_orders" */
export type Payment_Transaction_Orders = {
  __typename?: 'payment_transaction_orders';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  order: Orders;
  order_id: Scalars['Int'];
  /** An object relationship */
  payment_transaction: Payment_Transactions;
  payment_transaction_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "payment_transaction_orders" */
export type Payment_Transaction_Orders_Aggregate = {
  __typename?: 'payment_transaction_orders_aggregate';
  aggregate?: Maybe<Payment_Transaction_Orders_Aggregate_Fields>;
  nodes: Array<Payment_Transaction_Orders>;
};

export type Payment_Transaction_Orders_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Transaction_Orders_Aggregate_Bool_Exp_Count>;
};

export type Payment_Transaction_Orders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_transaction_orders" */
export type Payment_Transaction_Orders_Aggregate_Fields = {
  __typename?: 'payment_transaction_orders_aggregate_fields';
  avg?: Maybe<Payment_Transaction_Orders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Transaction_Orders_Max_Fields>;
  min?: Maybe<Payment_Transaction_Orders_Min_Fields>;
  stddev?: Maybe<Payment_Transaction_Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Transaction_Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Transaction_Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Transaction_Orders_Sum_Fields>;
  var_pop?: Maybe<Payment_Transaction_Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Transaction_Orders_Var_Samp_Fields>;
  variance?: Maybe<Payment_Transaction_Orders_Variance_Fields>;
};


/** aggregate fields of "payment_transaction_orders" */
export type Payment_Transaction_Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Transaction_Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Transaction_Orders_Max_Order_By>;
  min?: InputMaybe<Payment_Transaction_Orders_Min_Order_By>;
  stddev?: InputMaybe<Payment_Transaction_Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Transaction_Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Transaction_Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Transaction_Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Transaction_Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Transaction_Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Transaction_Orders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Arr_Rel_Insert_Input = {
  data: Array<Payment_Transaction_Orders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Transaction_Orders_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Transaction_Orders_Avg_Fields = {
  __typename?: 'payment_transaction_orders_avg_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Avg_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_transaction_orders". All fields are combined with a logical 'AND'. */
export type Payment_Transaction_Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Transaction_Orders_Bool_Exp>>;
  _not?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Transaction_Orders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  order?: InputMaybe<Orders_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  payment_transaction?: InputMaybe<Payment_Transactions_Bool_Exp>;
  payment_transaction_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_transaction_orders" */
export enum Payment_Transaction_Orders_Constraint {
  /** unique or primary key constraint on columns "payment_transaction_id", "order_id" */
  PaymentTransactionOrdersPkey = 'payment_transaction_orders_pkey'
}

/** input type for incrementing numeric columns in table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Inc_Input = {
  order_id?: InputMaybe<Scalars['Int']>;
  payment_transaction_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  order?: InputMaybe<Orders_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['Int']>;
  payment_transaction?: InputMaybe<Payment_Transactions_Obj_Rel_Insert_Input>;
  payment_transaction_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Payment_Transaction_Orders_Max_Fields = {
  __typename?: 'payment_transaction_orders_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  order_id?: Maybe<Scalars['Int']>;
  payment_transaction_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Transaction_Orders_Min_Fields = {
  __typename?: 'payment_transaction_orders_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  order_id?: Maybe<Scalars['Int']>;
  payment_transaction_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Mutation_Response = {
  __typename?: 'payment_transaction_orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Transaction_Orders>;
};

/** on_conflict condition type for table "payment_transaction_orders" */
export type Payment_Transaction_Orders_On_Conflict = {
  constraint: Payment_Transaction_Orders_Constraint;
  update_columns?: Array<Payment_Transaction_Orders_Update_Column>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_transaction_orders". */
export type Payment_Transaction_Orders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order?: InputMaybe<Orders_Order_By>;
  order_id?: InputMaybe<Order_By>;
  payment_transaction?: InputMaybe<Payment_Transactions_Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_transaction_orders */
export type Payment_Transaction_Orders_Pk_Columns_Input = {
  order_id: Scalars['Int'];
  payment_transaction_id: Scalars['Int'];
};

/** select columns of table "payment_transaction_orders" */
export enum Payment_Transaction_Orders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PaymentTransactionId = 'payment_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  order_id?: InputMaybe<Scalars['Int']>;
  payment_transaction_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Payment_Transaction_Orders_Stddev_Fields = {
  __typename?: 'payment_transaction_orders_stddev_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Stddev_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Transaction_Orders_Stddev_Pop_Fields = {
  __typename?: 'payment_transaction_orders_stddev_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Stddev_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Transaction_Orders_Stddev_Samp_Fields = {
  __typename?: 'payment_transaction_orders_stddev_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Stddev_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Transaction_Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Transaction_Orders_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  order_id?: InputMaybe<Scalars['Int']>;
  payment_transaction_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Payment_Transaction_Orders_Sum_Fields = {
  __typename?: 'payment_transaction_orders_sum_fields';
  order_id?: Maybe<Scalars['Int']>;
  payment_transaction_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Sum_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** update columns of table "payment_transaction_orders" */
export enum Payment_Transaction_Orders_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PaymentTransactionId = 'payment_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Payment_Transaction_Orders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Transaction_Orders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Transaction_Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Transaction_Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Transaction_Orders_Var_Pop_Fields = {
  __typename?: 'payment_transaction_orders_var_pop_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Var_Pop_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Transaction_Orders_Var_Samp_Fields = {
  __typename?: 'payment_transaction_orders_var_samp_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Var_Samp_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Transaction_Orders_Variance_Fields = {
  __typename?: 'payment_transaction_orders_variance_fields';
  order_id?: Maybe<Scalars['Float']>;
  payment_transaction_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_transaction_orders" */
export type Payment_Transaction_Orders_Variance_Order_By = {
  order_id?: InputMaybe<Order_By>;
  payment_transaction_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_transactions" */
export type Payment_Transactions = {
  __typename?: 'payment_transactions';
  /** An object relationship */
  appointment?: Maybe<Appointments>;
  appointment_id?: Maybe<Scalars['uuid']>;
  category: Scalars['smallint'];
  created_at: Scalars['timestamptz'];
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  external_entity_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invoice_number?: Maybe<Scalars['String']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  payer_role: Scalars['smallint'];
  payment_provider: Scalars['payment_provider'];
  /** An array relationship */
  payment_transaction_orders: Array<Payment_Transaction_Orders>;
  /** An aggregate relationship */
  payment_transaction_orders_aggregate: Payment_Transaction_Orders_Aggregate;
  provider_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  receipt_file?: Maybe<Files>;
  receipt_file_id?: Maybe<Scalars['uuid']>;
  service_fee: Scalars['numeric'];
  service_total: Scalars['numeric'];
  status: Scalars['smallint'];
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee: Scalars['numeric'];
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total: Scalars['numeric'];
  transaction_type: Scalars['smallint'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "payment_transactions" */
export type Payment_TransactionsPayment_Transaction_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


/** columns and relationships of "payment_transactions" */
export type Payment_TransactionsPayment_Transaction_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};

/** aggregated selection of "payment_transactions" */
export type Payment_Transactions_Aggregate = {
  __typename?: 'payment_transactions_aggregate';
  aggregate?: Maybe<Payment_Transactions_Aggregate_Fields>;
  nodes: Array<Payment_Transactions>;
};

export type Payment_Transactions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Payment_Transactions_Aggregate_Bool_Exp_Count>;
};

export type Payment_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Payment_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_transactions" */
export type Payment_Transactions_Aggregate_Fields = {
  __typename?: 'payment_transactions_aggregate_fields';
  avg?: Maybe<Payment_Transactions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Payment_Transactions_Max_Fields>;
  min?: Maybe<Payment_Transactions_Min_Fields>;
  stddev?: Maybe<Payment_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Payment_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Payment_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Payment_Transactions_Sum_Fields>;
  var_pop?: Maybe<Payment_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Payment_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Payment_Transactions_Variance_Fields>;
};


/** aggregate fields of "payment_transactions" */
export type Payment_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_transactions" */
export type Payment_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Payment_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Transactions_Max_Order_By>;
  min?: InputMaybe<Payment_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Payment_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Payment_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Payment_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Payment_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Payment_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Payment_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Payment_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "payment_transactions" */
export type Payment_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Payment_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Payment_Transactions_Avg_Fields = {
  __typename?: 'payment_transactions_avg_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "payment_transactions" */
export type Payment_Transactions_Avg_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "payment_transactions". All fields are combined with a logical 'AND'. */
export type Payment_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Payment_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Transactions_Bool_Exp>>;
  appointment?: InputMaybe<Appointments_Bool_Exp>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<Smallint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_amount_off?: InputMaybe<Numeric_Comparison_Exp>;
  discount_code?: InputMaybe<String_Comparison_Exp>;
  discount_percent_off?: InputMaybe<Numeric_Comparison_Exp>;
  external_entity_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  paid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  payer_role?: InputMaybe<Smallint_Comparison_Exp>;
  payment_provider?: InputMaybe<Payment_Provider_Comparison_Exp>;
  payment_transaction_orders?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
  payment_transaction_orders_aggregate?: InputMaybe<Payment_Transaction_Orders_Aggregate_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  receipt_file?: InputMaybe<Files_Bool_Exp>;
  receipt_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_fee?: InputMaybe<Numeric_Comparison_Exp>;
  service_total?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  stripe_entity_type?: InputMaybe<Smallint_Comparison_Exp>;
  stripe_fee?: InputMaybe<Numeric_Comparison_Exp>;
  stripe_net_amount?: InputMaybe<Numeric_Comparison_Exp>;
  stripe_payment_amount?: InputMaybe<Numeric_Comparison_Exp>;
  stripe_processing_fee?: InputMaybe<Numeric_Comparison_Exp>;
  subscription_id?: InputMaybe<Int_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_type?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_transactions" */
export enum Payment_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PaymentTransactionsPkey = 'payment_transactions_pkey'
}

/** input type for incrementing numeric columns in table "payment_transactions" */
export type Payment_Transactions_Inc_Input = {
  category?: InputMaybe<Scalars['smallint']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "payment_transactions" */
export type Payment_Transactions_Insert_Input = {
  appointment?: InputMaybe<Appointments_Obj_Rel_Insert_Input>;
  appointment_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  external_entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  payment_provider?: InputMaybe<Scalars['payment_provider']>;
  payment_transaction_orders?: InputMaybe<Payment_Transaction_Orders_Arr_Rel_Insert_Input>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  receipt_file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  receipt_file_id?: InputMaybe<Scalars['uuid']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Payment_Transactions_Max_Fields = {
  __typename?: 'payment_transactions_max_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  external_entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  payer_role?: Maybe<Scalars['smallint']>;
  payment_provider?: Maybe<Scalars['payment_provider']>;
  provider_id?: Maybe<Scalars['uuid']>;
  receipt_file_id?: Maybe<Scalars['uuid']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "payment_transactions" */
export type Payment_Transactions_Max_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_code?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  external_entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  payment_provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  receipt_file_id?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Transactions_Min_Fields = {
  __typename?: 'payment_transactions_min_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  external_entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  payer_role?: Maybe<Scalars['smallint']>;
  payment_provider?: Maybe<Scalars['payment_provider']>;
  provider_id?: Maybe<Scalars['uuid']>;
  receipt_file_id?: Maybe<Scalars['uuid']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "payment_transactions" */
export type Payment_Transactions_Min_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_code?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  external_entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  payment_provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  receipt_file_id?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment_transactions" */
export type Payment_Transactions_Mutation_Response = {
  __typename?: 'payment_transactions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Transactions>;
};

/** input type for inserting object relation for remote table "payment_transactions" */
export type Payment_Transactions_Obj_Rel_Insert_Input = {
  data: Payment_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Payment_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "payment_transactions" */
export type Payment_Transactions_On_Conflict = {
  constraint: Payment_Transactions_Constraint;
  update_columns?: Array<Payment_Transactions_Update_Column>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_transactions". */
export type Payment_Transactions_Order_By = {
  appointment?: InputMaybe<Appointments_Order_By>;
  appointment_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_code?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  external_entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  payment_provider?: InputMaybe<Order_By>;
  payment_transaction_orders_aggregate?: InputMaybe<Payment_Transaction_Orders_Aggregate_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  receipt_file?: InputMaybe<Files_Order_By>;
  receipt_file_id?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_transactions */
export type Payment_Transactions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "payment_transactions" */
export enum Payment_Transactions_Select_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountAmountOff = 'discount_amount_off',
  /** column name */
  DiscountCode = 'discount_code',
  /** column name */
  DiscountPercentOff = 'discount_percent_off',
  /** column name */
  ExternalEntityId = 'external_entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  PayerRole = 'payer_role',
  /** column name */
  PaymentProvider = 'payment_provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ReceiptFileId = 'receipt_file_id',
  /** column name */
  ServiceFee = 'service_fee',
  /** column name */
  ServiceTotal = 'service_total',
  /** column name */
  Status = 'status',
  /** column name */
  StripeEntityType = 'stripe_entity_type',
  /** column name */
  StripeFee = 'stripe_fee',
  /** column name */
  StripeNetAmount = 'stripe_net_amount',
  /** column name */
  StripePaymentAmount = 'stripe_payment_amount',
  /** column name */
  StripeProcessingFee = 'stripe_processing_fee',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Total = 'total',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "payment_transactions" */
export type Payment_Transactions_Set_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  external_entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  payment_provider?: InputMaybe<Scalars['payment_provider']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  receipt_file_id?: InputMaybe<Scalars['uuid']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Payment_Transactions_Stddev_Fields = {
  __typename?: 'payment_transactions_stddev_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "payment_transactions" */
export type Payment_Transactions_Stddev_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Payment_Transactions_Stddev_Pop_Fields = {
  __typename?: 'payment_transactions_stddev_pop_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "payment_transactions" */
export type Payment_Transactions_Stddev_Pop_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Payment_Transactions_Stddev_Samp_Fields = {
  __typename?: 'payment_transactions_stddev_samp_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "payment_transactions" */
export type Payment_Transactions_Stddev_Samp_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "payment_transactions" */
export type Payment_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Transactions_Stream_Cursor_Value_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  external_entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  payment_provider?: InputMaybe<Scalars['payment_provider']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  receipt_file_id?: InputMaybe<Scalars['uuid']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Payment_Transactions_Sum_Fields = {
  __typename?: 'payment_transactions_sum_fields';
  category?: Maybe<Scalars['smallint']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  payer_role?: Maybe<Scalars['smallint']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "payment_transactions" */
export type Payment_Transactions_Sum_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** update columns of table "payment_transactions" */
export enum Payment_Transactions_Update_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountAmountOff = 'discount_amount_off',
  /** column name */
  DiscountCode = 'discount_code',
  /** column name */
  DiscountPercentOff = 'discount_percent_off',
  /** column name */
  ExternalEntityId = 'external_entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  PayerRole = 'payer_role',
  /** column name */
  PaymentProvider = 'payment_provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ReceiptFileId = 'receipt_file_id',
  /** column name */
  ServiceFee = 'service_fee',
  /** column name */
  ServiceTotal = 'service_total',
  /** column name */
  Status = 'status',
  /** column name */
  StripeEntityType = 'stripe_entity_type',
  /** column name */
  StripeFee = 'stripe_fee',
  /** column name */
  StripeNetAmount = 'stripe_net_amount',
  /** column name */
  StripePaymentAmount = 'stripe_payment_amount',
  /** column name */
  StripeProcessingFee = 'stripe_processing_fee',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Total = 'total',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Payment_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Payment_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Payment_Transactions_Var_Pop_Fields = {
  __typename?: 'payment_transactions_var_pop_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "payment_transactions" */
export type Payment_Transactions_Var_Pop_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Payment_Transactions_Var_Samp_Fields = {
  __typename?: 'payment_transactions_var_samp_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "payment_transactions" */
export type Payment_Transactions_Var_Samp_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Payment_Transactions_Variance_Fields = {
  __typename?: 'payment_transactions_variance_fields';
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "payment_transactions" */
export type Payment_Transactions_Variance_Order_By = {
  category?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "pending_patient_status". All fields are combined with logical 'AND'. */
export type Pending_Patient_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['pending_patient_status']>;
  _gt?: InputMaybe<Scalars['pending_patient_status']>;
  _gte?: InputMaybe<Scalars['pending_patient_status']>;
  _in?: InputMaybe<Array<Scalars['pending_patient_status']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['pending_patient_status']>;
  _lte?: InputMaybe<Scalars['pending_patient_status']>;
  _neq?: InputMaybe<Scalars['pending_patient_status']>;
  _nin?: InputMaybe<Array<Scalars['pending_patient_status']>>;
};

/** columns and relationships of "pending_patient_zrt" */
export type Pending_Patient_Zrt = {
  __typename?: 'pending_patient_zrt';
  created_at?: Maybe<Scalars['timestamptz']>;
  diagnostic_report_id?: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  notification_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  patient: Users;
  provider_full_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  provider_unavailable_notification_id?: Maybe<Scalars['String']>;
  questionnaire_required: Scalars['Boolean'];
  questionnaire_updated_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['pending_patient_status']>;
  swabcode: Scalars['String'];
  test_type: Scalars['String'];
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "pending_patient_zrt" */
export type Pending_Patient_Zrt_Aggregate = {
  __typename?: 'pending_patient_zrt_aggregate';
  aggregate?: Maybe<Pending_Patient_Zrt_Aggregate_Fields>;
  nodes: Array<Pending_Patient_Zrt>;
};

export type Pending_Patient_Zrt_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Pending_Patient_Zrt_Aggregate_Bool_Exp_Count>;
};

export type Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_And = {
  arguments: Pending_Patient_Zrt_Select_Column_Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Pending_Patient_Zrt_Select_Column_Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Pending_Patient_Zrt_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "pending_patient_zrt" */
export type Pending_Patient_Zrt_Aggregate_Fields = {
  __typename?: 'pending_patient_zrt_aggregate_fields';
  avg?: Maybe<Pending_Patient_Zrt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pending_Patient_Zrt_Max_Fields>;
  min?: Maybe<Pending_Patient_Zrt_Min_Fields>;
  stddev?: Maybe<Pending_Patient_Zrt_Stddev_Fields>;
  stddev_pop?: Maybe<Pending_Patient_Zrt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pending_Patient_Zrt_Stddev_Samp_Fields>;
  sum?: Maybe<Pending_Patient_Zrt_Sum_Fields>;
  var_pop?: Maybe<Pending_Patient_Zrt_Var_Pop_Fields>;
  var_samp?: Maybe<Pending_Patient_Zrt_Var_Samp_Fields>;
  variance?: Maybe<Pending_Patient_Zrt_Variance_Fields>;
};


/** aggregate fields of "pending_patient_zrt" */
export type Pending_Patient_Zrt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Aggregate_Order_By = {
  avg?: InputMaybe<Pending_Patient_Zrt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pending_Patient_Zrt_Max_Order_By>;
  min?: InputMaybe<Pending_Patient_Zrt_Min_Order_By>;
  stddev?: InputMaybe<Pending_Patient_Zrt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pending_Patient_Zrt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pending_Patient_Zrt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pending_Patient_Zrt_Sum_Order_By>;
  var_pop?: InputMaybe<Pending_Patient_Zrt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pending_Patient_Zrt_Var_Samp_Order_By>;
  variance?: InputMaybe<Pending_Patient_Zrt_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Arr_Rel_Insert_Input = {
  data: Array<Pending_Patient_Zrt_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Pending_Patient_Zrt_On_Conflict>;
};

/** aggregate avg on columns */
export type Pending_Patient_Zrt_Avg_Fields = {
  __typename?: 'pending_patient_zrt_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pending_patient_zrt". All fields are combined with a logical 'AND'. */
export type Pending_Patient_Zrt_Bool_Exp = {
  _and?: InputMaybe<Array<Pending_Patient_Zrt_Bool_Exp>>;
  _not?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
  _or?: InputMaybe<Array<Pending_Patient_Zrt_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  diagnostic_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  notification_id?: InputMaybe<String_Comparison_Exp>;
  patient?: InputMaybe<Users_Bool_Exp>;
  provider_full_name?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_unavailable_notification_id?: InputMaybe<String_Comparison_Exp>;
  questionnaire_required?: InputMaybe<Boolean_Comparison_Exp>;
  questionnaire_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Pending_Patient_Status_Comparison_Exp>;
  swabcode?: InputMaybe<String_Comparison_Exp>;
  test_type?: InputMaybe<String_Comparison_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pending_patient_zrt" */
export enum Pending_Patient_Zrt_Constraint {
  /** unique or primary key constraint on columns "id" */
  PendingPatientZrtPkey = 'pending_patient_zrt_pkey',
  /** unique or primary key constraint on columns "swabcode" */
  PendingPatientZrtSwabcodeKey = 'pending_patient_zrt_swabcode_key'
}

/** input type for incrementing numeric columns in table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  diagnostic_report_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  notification_id?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  provider_full_name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  provider_unavailable_notification_id?: InputMaybe<Scalars['String']>;
  questionnaire_required?: InputMaybe<Scalars['Boolean']>;
  questionnaire_updated_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['pending_patient_status']>;
  swabcode?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Scalars['String']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pending_Patient_Zrt_Max_Fields = {
  __typename?: 'pending_patient_zrt_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  diagnostic_report_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  notification_id?: Maybe<Scalars['String']>;
  provider_full_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  provider_unavailable_notification_id?: Maybe<Scalars['String']>;
  questionnaire_updated_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['pending_patient_status']>;
  swabcode?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  diagnostic_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  provider_full_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  provider_unavailable_notification_id?: InputMaybe<Order_By>;
  questionnaire_updated_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  swabcode?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pending_Patient_Zrt_Min_Fields = {
  __typename?: 'pending_patient_zrt_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  diagnostic_report_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  notification_id?: Maybe<Scalars['String']>;
  provider_full_name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  provider_unavailable_notification_id?: Maybe<Scalars['String']>;
  questionnaire_updated_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['pending_patient_status']>;
  swabcode?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  diagnostic_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  provider_full_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  provider_unavailable_notification_id?: InputMaybe<Order_By>;
  questionnaire_updated_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  swabcode?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Mutation_Response = {
  __typename?: 'pending_patient_zrt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pending_Patient_Zrt>;
};

/** on_conflict condition type for table "pending_patient_zrt" */
export type Pending_Patient_Zrt_On_Conflict = {
  constraint: Pending_Patient_Zrt_Constraint;
  update_columns?: Array<Pending_Patient_Zrt_Update_Column>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};

/** Ordering options when selecting data from "pending_patient_zrt". */
export type Pending_Patient_Zrt_Order_By = {
  created_at?: InputMaybe<Order_By>;
  diagnostic_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_id?: InputMaybe<Order_By>;
  patient?: InputMaybe<Users_Order_By>;
  provider_full_name?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  provider_unavailable_notification_id?: InputMaybe<Order_By>;
  questionnaire_required?: InputMaybe<Order_By>;
  questionnaire_updated_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  swabcode?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pending_patient_zrt */
export type Pending_Patient_Zrt_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "pending_patient_zrt" */
export enum Pending_Patient_Zrt_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiagnosticReportId = 'diagnostic_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ProviderFullName = 'provider_full_name',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderUnavailableNotificationId = 'provider_unavailable_notification_id',
  /** column name */
  QuestionnaireRequired = 'questionnaire_required',
  /** column name */
  QuestionnaireUpdatedAt = 'questionnaire_updated_at',
  /** column name */
  Status = 'status',
  /** column name */
  Swabcode = 'swabcode',
  /** column name */
  TestType = 'test_type',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "pending_patient_zrt_aggregate_bool_exp_bool_and_arguments_columns" columns of table "pending_patient_zrt" */
export enum Pending_Patient_Zrt_Select_Column_Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  QuestionnaireRequired = 'questionnaire_required'
}

/** select "pending_patient_zrt_aggregate_bool_exp_bool_or_arguments_columns" columns of table "pending_patient_zrt" */
export enum Pending_Patient_Zrt_Select_Column_Pending_Patient_Zrt_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  QuestionnaireRequired = 'questionnaire_required'
}

/** input type for updating data in table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  diagnostic_report_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  notification_id?: InputMaybe<Scalars['String']>;
  provider_full_name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  provider_unavailable_notification_id?: InputMaybe<Scalars['String']>;
  questionnaire_required?: InputMaybe<Scalars['Boolean']>;
  questionnaire_updated_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['pending_patient_status']>;
  swabcode?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Scalars['String']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Pending_Patient_Zrt_Stddev_Fields = {
  __typename?: 'pending_patient_zrt_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pending_Patient_Zrt_Stddev_Pop_Fields = {
  __typename?: 'pending_patient_zrt_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pending_Patient_Zrt_Stddev_Samp_Fields = {
  __typename?: 'pending_patient_zrt_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pending_Patient_Zrt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pending_Patient_Zrt_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  diagnostic_report_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  notification_id?: InputMaybe<Scalars['String']>;
  provider_full_name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  provider_unavailable_notification_id?: InputMaybe<Scalars['String']>;
  questionnaire_required?: InputMaybe<Scalars['Boolean']>;
  questionnaire_updated_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['pending_patient_status']>;
  swabcode?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Scalars['String']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Pending_Patient_Zrt_Sum_Fields = {
  __typename?: 'pending_patient_zrt_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "pending_patient_zrt" */
export enum Pending_Patient_Zrt_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiagnosticReportId = 'diagnostic_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationId = 'notification_id',
  /** column name */
  ProviderFullName = 'provider_full_name',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderUnavailableNotificationId = 'provider_unavailable_notification_id',
  /** column name */
  QuestionnaireRequired = 'questionnaire_required',
  /** column name */
  QuestionnaireUpdatedAt = 'questionnaire_updated_at',
  /** column name */
  Status = 'status',
  /** column name */
  Swabcode = 'swabcode',
  /** column name */
  TestType = 'test_type',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Pending_Patient_Zrt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pending_Patient_Zrt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pending_Patient_Zrt_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pending_Patient_Zrt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pending_Patient_Zrt_Var_Pop_Fields = {
  __typename?: 'pending_patient_zrt_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pending_Patient_Zrt_Var_Samp_Fields = {
  __typename?: 'pending_patient_zrt_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pending_Patient_Zrt_Variance_Fields = {
  __typename?: 'pending_patient_zrt_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pending_patient_zrt" */
export type Pending_Patient_Zrt_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "persona_inquiries" */
export type Persona_Inquiries = {
  __typename?: 'persona_inquiries';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Int']>;
  persona_event_id: Scalars['String'];
  /** An object relationship */
  persona_inquiries_persona_inquiry_status: Persona_Inquiry_Status;
  /** An object relationship */
  persona_inquiries_user: Users;
  persona_inquiry_id: Scalars['String'];
  status: Persona_Inquiry_Status_Enum;
  status_applied: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "persona_inquiries" */
export type Persona_Inquiries_Aggregate = {
  __typename?: 'persona_inquiries_aggregate';
  aggregate?: Maybe<Persona_Inquiries_Aggregate_Fields>;
  nodes: Array<Persona_Inquiries>;
};

export type Persona_Inquiries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Persona_Inquiries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Persona_Inquiries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Persona_Inquiries_Aggregate_Bool_Exp_Count>;
};

export type Persona_Inquiries_Aggregate_Bool_Exp_Bool_And = {
  arguments: Persona_Inquiries_Select_Column_Persona_Inquiries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Persona_Inquiries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Persona_Inquiries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Persona_Inquiries_Select_Column_Persona_Inquiries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Persona_Inquiries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Persona_Inquiries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Persona_Inquiries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "persona_inquiries" */
export type Persona_Inquiries_Aggregate_Fields = {
  __typename?: 'persona_inquiries_aggregate_fields';
  avg?: Maybe<Persona_Inquiries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Persona_Inquiries_Max_Fields>;
  min?: Maybe<Persona_Inquiries_Min_Fields>;
  stddev?: Maybe<Persona_Inquiries_Stddev_Fields>;
  stddev_pop?: Maybe<Persona_Inquiries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Persona_Inquiries_Stddev_Samp_Fields>;
  sum?: Maybe<Persona_Inquiries_Sum_Fields>;
  var_pop?: Maybe<Persona_Inquiries_Var_Pop_Fields>;
  var_samp?: Maybe<Persona_Inquiries_Var_Samp_Fields>;
  variance?: Maybe<Persona_Inquiries_Variance_Fields>;
};


/** aggregate fields of "persona_inquiries" */
export type Persona_Inquiries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "persona_inquiries" */
export type Persona_Inquiries_Aggregate_Order_By = {
  avg?: InputMaybe<Persona_Inquiries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Persona_Inquiries_Max_Order_By>;
  min?: InputMaybe<Persona_Inquiries_Min_Order_By>;
  stddev?: InputMaybe<Persona_Inquiries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Persona_Inquiries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Persona_Inquiries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Persona_Inquiries_Sum_Order_By>;
  var_pop?: InputMaybe<Persona_Inquiries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Persona_Inquiries_Var_Samp_Order_By>;
  variance?: InputMaybe<Persona_Inquiries_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Persona_Inquiries_Avg_Fields = {
  __typename?: 'persona_inquiries_avg_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Avg_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "persona_inquiries". All fields are combined with a logical 'AND'. */
export type Persona_Inquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Persona_Inquiries_Bool_Exp>>;
  _not?: InputMaybe<Persona_Inquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Persona_Inquiries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inquiry_type?: InputMaybe<Int_Comparison_Exp>;
  persona_event_id?: InputMaybe<String_Comparison_Exp>;
  persona_inquiries_persona_inquiry_status?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
  persona_inquiries_user?: InputMaybe<Users_Bool_Exp>;
  persona_inquiry_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum_Comparison_Exp>;
  status_applied?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "persona_inquiries" */
export enum Persona_Inquiries_Constraint {
  /** unique or primary key constraint on columns "persona_event_id" */
  PersonaInquiriesPersonaEventIdKey = 'persona_inquiries_persona_event_id_key',
  /** unique or primary key constraint on columns "id" */
  PersonaInquiriesPkey = 'persona_inquiries_pkey'
}

/** input type for incrementing numeric columns in table "persona_inquiries" */
export type Persona_Inquiries_Inc_Input = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "persona_inquiries" */
export type Persona_Inquiries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Scalars['Int']>;
  persona_event_id?: InputMaybe<Scalars['String']>;
  persona_inquiries_persona_inquiry_status?: InputMaybe<Persona_Inquiry_Status_Obj_Rel_Insert_Input>;
  persona_inquiries_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  persona_inquiry_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  status_applied?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Persona_Inquiries_Max_Fields = {
  __typename?: 'persona_inquiries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Int']>;
  persona_event_id?: Maybe<Scalars['String']>;
  persona_inquiry_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
  persona_event_id?: InputMaybe<Order_By>;
  persona_inquiry_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Persona_Inquiries_Min_Fields = {
  __typename?: 'persona_inquiries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Int']>;
  persona_event_id?: Maybe<Scalars['String']>;
  persona_inquiry_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
  persona_event_id?: InputMaybe<Order_By>;
  persona_inquiry_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "persona_inquiries" */
export type Persona_Inquiries_Mutation_Response = {
  __typename?: 'persona_inquiries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Persona_Inquiries>;
};

/** on_conflict condition type for table "persona_inquiries" */
export type Persona_Inquiries_On_Conflict = {
  constraint: Persona_Inquiries_Constraint;
  update_columns?: Array<Persona_Inquiries_Update_Column>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};

/** Ordering options when selecting data from "persona_inquiries". */
export type Persona_Inquiries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inquiry_type?: InputMaybe<Order_By>;
  persona_event_id?: InputMaybe<Order_By>;
  persona_inquiries_persona_inquiry_status?: InputMaybe<Persona_Inquiry_Status_Order_By>;
  persona_inquiries_user?: InputMaybe<Users_Order_By>;
  persona_inquiry_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_applied?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: persona_inquiries */
export type Persona_Inquiries_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "persona_inquiries" */
export enum Persona_Inquiries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryType = 'inquiry_type',
  /** column name */
  PersonaEventId = 'persona_event_id',
  /** column name */
  PersonaInquiryId = 'persona_inquiry_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusApplied = 'status_applied',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "persona_inquiries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "persona_inquiries" */
export enum Persona_Inquiries_Select_Column_Persona_Inquiries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  StatusApplied = 'status_applied'
}

/** select "persona_inquiries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "persona_inquiries" */
export enum Persona_Inquiries_Select_Column_Persona_Inquiries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  StatusApplied = 'status_applied'
}

/** input type for updating data in table "persona_inquiries" */
export type Persona_Inquiries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Scalars['Int']>;
  persona_event_id?: InputMaybe<Scalars['String']>;
  persona_inquiry_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  status_applied?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Persona_Inquiries_Stddev_Fields = {
  __typename?: 'persona_inquiries_stddev_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Stddev_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Persona_Inquiries_Stddev_Pop_Fields = {
  __typename?: 'persona_inquiries_stddev_pop_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Stddev_Pop_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Persona_Inquiries_Stddev_Samp_Fields = {
  __typename?: 'persona_inquiries_stddev_samp_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Stddev_Samp_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "persona_inquiries" */
export type Persona_Inquiries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Persona_Inquiries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Persona_Inquiries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Scalars['Int']>;
  persona_event_id?: InputMaybe<Scalars['String']>;
  persona_inquiry_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  status_applied?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Persona_Inquiries_Sum_Fields = {
  __typename?: 'persona_inquiries_sum_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Sum_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** update columns of table "persona_inquiries" */
export enum Persona_Inquiries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InquiryType = 'inquiry_type',
  /** column name */
  PersonaEventId = 'persona_event_id',
  /** column name */
  PersonaInquiryId = 'persona_inquiry_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusApplied = 'status_applied',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Persona_Inquiries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Persona_Inquiries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Persona_Inquiries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Persona_Inquiries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Persona_Inquiries_Var_Pop_Fields = {
  __typename?: 'persona_inquiries_var_pop_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Var_Pop_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Persona_Inquiries_Var_Samp_Fields = {
  __typename?: 'persona_inquiries_var_samp_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Var_Samp_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Persona_Inquiries_Variance_Fields = {
  __typename?: 'persona_inquiries_variance_fields';
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "persona_inquiries" */
export type Persona_Inquiries_Variance_Order_By = {
  /** 1 - PersonaID, 2 - Insurance */
  inquiry_type?: InputMaybe<Order_By>;
};

/** Status of persona inquiry */
export type Persona_Inquiry_Status = {
  __typename?: 'persona_inquiry_status';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "persona_inquiry_status" */
export type Persona_Inquiry_Status_Aggregate = {
  __typename?: 'persona_inquiry_status_aggregate';
  aggregate?: Maybe<Persona_Inquiry_Status_Aggregate_Fields>;
  nodes: Array<Persona_Inquiry_Status>;
};

/** aggregate fields of "persona_inquiry_status" */
export type Persona_Inquiry_Status_Aggregate_Fields = {
  __typename?: 'persona_inquiry_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Persona_Inquiry_Status_Max_Fields>;
  min?: Maybe<Persona_Inquiry_Status_Min_Fields>;
};


/** aggregate fields of "persona_inquiry_status" */
export type Persona_Inquiry_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Persona_Inquiry_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "persona_inquiry_status". All fields are combined with a logical 'AND'. */
export type Persona_Inquiry_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Persona_Inquiry_Status_Bool_Exp>>;
  _not?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Persona_Inquiry_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "persona_inquiry_status" */
export enum Persona_Inquiry_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  PersonaInquiryStatusPkey = 'persona_inquiry_status_pkey'
}

export enum Persona_Inquiry_Status_Enum {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Locked = 'LOCKED',
  MarkedForReview = 'MARKED_FOR_REVIEW',
  Started = 'STARTED',
  Transitioned = 'TRANSITIONED'
}

/** Boolean expression to compare columns of type "persona_inquiry_status_enum". All fields are combined with logical 'AND'. */
export type Persona_Inquiry_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Persona_Inquiry_Status_Enum>;
  _in?: InputMaybe<Array<Persona_Inquiry_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Persona_Inquiry_Status_Enum>;
  _nin?: InputMaybe<Array<Persona_Inquiry_Status_Enum>>;
};

/** input type for inserting data into table "persona_inquiry_status" */
export type Persona_Inquiry_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Persona_Inquiry_Status_Max_Fields = {
  __typename?: 'persona_inquiry_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Persona_Inquiry_Status_Min_Fields = {
  __typename?: 'persona_inquiry_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "persona_inquiry_status" */
export type Persona_Inquiry_Status_Mutation_Response = {
  __typename?: 'persona_inquiry_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Persona_Inquiry_Status>;
};

/** input type for inserting object relation for remote table "persona_inquiry_status" */
export type Persona_Inquiry_Status_Obj_Rel_Insert_Input = {
  data: Persona_Inquiry_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Persona_Inquiry_Status_On_Conflict>;
};

/** on_conflict condition type for table "persona_inquiry_status" */
export type Persona_Inquiry_Status_On_Conflict = {
  constraint: Persona_Inquiry_Status_Constraint;
  update_columns?: Array<Persona_Inquiry_Status_Update_Column>;
  where?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "persona_inquiry_status". */
export type Persona_Inquiry_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: persona_inquiry_status */
export type Persona_Inquiry_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "persona_inquiry_status" */
export enum Persona_Inquiry_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "persona_inquiry_status" */
export type Persona_Inquiry_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "persona_inquiry_status" */
export type Persona_Inquiry_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Persona_Inquiry_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Persona_Inquiry_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "persona_inquiry_status" */
export enum Persona_Inquiry_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Persona_Inquiry_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Persona_Inquiry_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Persona_Inquiry_Status_Bool_Exp;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  admin_deleted_at?: Maybe<Scalars['timestamptz']>;
  aeromed_number?: Maybe<Scalars['String']>;
  category: Scalars['Int'];
  contents?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** in months */
  expiration_period?: Maybe<Scalars['smallint']>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** An array relationship */
  gale_products: Array<Gale_Products>;
  /** An aggregate relationship */
  gale_products_aggregate: Gale_Products_Aggregate;
  id: Scalars['Int'];
  image_url?: Maybe<Scalars['String']>;
  in_stock: Scalars['Boolean'];
  is_shipmonk_active: Scalars['Boolean'];
  is_shipmonk_deleted: Scalars['Boolean'];
  made_in?: Maybe<Scalars['String']>;
  po_number?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  provider_price?: Maybe<Scalars['numeric']>;
  quantity: Scalars['Int'];
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  test_type?: Maybe<Test_Types_Enum>;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "products" */
export type ProductsFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsGale_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Gale_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gale_Products_Order_By>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsGale_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gale_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gale_Products_Order_By>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  admin_deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  aeromed_number?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<Int_Comparison_Exp>;
  contents?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  expiration_period?: InputMaybe<Smallint_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  gale_products?: InputMaybe<Gale_Products_Bool_Exp>;
  gale_products_aggregate?: InputMaybe<Gale_Products_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  in_stock?: InputMaybe<Boolean_Comparison_Exp>;
  is_shipmonk_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_shipmonk_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  made_in?: InputMaybe<String_Comparison_Exp>;
  po_number?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  provider_price?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  short_description?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  test_type?: InputMaybe<Test_Types_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsPkey = 'products_pkey',
  /** unique or primary key constraint on columns "sku" */
  ProductsSkuKey = 'products_sku_key'
}

/** input type for incrementing numeric columns in table "products" */
export type Products_Inc_Input = {
  category?: InputMaybe<Scalars['Int']>;
  /** in months */
  expiration_period?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  po_number?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  provider_price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  admin_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  aeromed_number?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['Int']>;
  contents?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** in months */
  expiration_period?: InputMaybe<Scalars['smallint']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input>;
  gale_products?: InputMaybe<Gale_Products_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  in_stock?: InputMaybe<Scalars['Boolean']>;
  is_shipmonk_active?: InputMaybe<Scalars['Boolean']>;
  is_shipmonk_deleted?: InputMaybe<Scalars['Boolean']>;
  made_in?: InputMaybe<Scalars['String']>;
  po_number?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  provider_price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  short_description?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  admin_deleted_at?: Maybe<Scalars['timestamptz']>;
  aeromed_number?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Int']>;
  contents?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** in months */
  expiration_period?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  made_in?: Maybe<Scalars['String']>;
  po_number?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  provider_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['Int']>;
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  admin_deleted_at?: Maybe<Scalars['timestamptz']>;
  aeromed_number?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['Int']>;
  contents?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** in months */
  expiration_period?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  made_in?: Maybe<Scalars['String']>;
  po_number?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  provider_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['Int']>;
  short_description?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on_conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns?: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  admin_deleted_at?: InputMaybe<Order_By>;
  aeromed_number?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  contents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  expiration_period?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  gale_products_aggregate?: InputMaybe<Gale_Products_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  in_stock?: InputMaybe<Order_By>;
  is_shipmonk_active?: InputMaybe<Order_By>;
  is_shipmonk_deleted?: InputMaybe<Order_By>;
  made_in?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  provider_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  AdminDeletedAt = 'admin_deleted_at',
  /** column name */
  AeromedNumber = 'aeromed_number',
  /** column name */
  Category = 'category',
  /** column name */
  Contents = 'contents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpirationPeriod = 'expiration_period',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InStock = 'in_stock',
  /** column name */
  IsShipmonkActive = 'is_shipmonk_active',
  /** column name */
  IsShipmonkDeleted = 'is_shipmonk_deleted',
  /** column name */
  MadeIn = 'made_in',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  Price = 'price',
  /** column name */
  ProviderPrice = 'provider_price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  Sku = 'sku',
  /** column name */
  TestType = 'test_type',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  admin_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  aeromed_number?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['Int']>;
  contents?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** in months */
  expiration_period?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  in_stock?: InputMaybe<Scalars['Boolean']>;
  is_shipmonk_active?: InputMaybe<Scalars['Boolean']>;
  is_shipmonk_deleted?: InputMaybe<Scalars['Boolean']>;
  made_in?: InputMaybe<Scalars['String']>;
  po_number?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  provider_price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  short_description?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "products" */
export type Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Stream_Cursor_Value_Input = {
  admin_deleted_at?: InputMaybe<Scalars['timestamptz']>;
  aeromed_number?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['Int']>;
  contents?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  /** in months */
  expiration_period?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  in_stock?: InputMaybe<Scalars['Boolean']>;
  is_shipmonk_active?: InputMaybe<Scalars['Boolean']>;
  is_shipmonk_deleted?: InputMaybe<Scalars['Boolean']>;
  made_in?: InputMaybe<Scalars['String']>;
  po_number?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
  provider_price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['Int']>;
  short_description?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  category?: Maybe<Scalars['Int']>;
  /** in months */
  expiration_period?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  po_number?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  provider_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  AdminDeletedAt = 'admin_deleted_at',
  /** column name */
  AeromedNumber = 'aeromed_number',
  /** column name */
  Category = 'category',
  /** column name */
  Contents = 'contents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExpirationPeriod = 'expiration_period',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  InStock = 'in_stock',
  /** column name */
  IsShipmonkActive = 'is_shipmonk_active',
  /** column name */
  IsShipmonkDeleted = 'is_shipmonk_deleted',
  /** column name */
  MadeIn = 'made_in',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  Price = 'price',
  /** column name */
  ProviderPrice = 'provider_price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  Sku = 'sku',
  /** column name */
  TestType = 'test_type',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  category?: Maybe<Scalars['Float']>;
  /** in months */
  expiration_period?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  po_number?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  provider_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_billing" */
export type Provider_Billing = {
  __typename?: 'provider_billing';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  previous_payout_date?: Maybe<Scalars['String']>;
  previous_week_payout?: Maybe<Scalars['numeric']>;
  previous_week_refund?: Maybe<Scalars['numeric']>;
  provider_id: Scalars['uuid'];
  reserved_balance: Scalars['numeric'];
  upcoming_payment: Scalars['numeric'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "provider_billing" */
export type Provider_Billing_Aggregate = {
  __typename?: 'provider_billing_aggregate';
  aggregate?: Maybe<Provider_Billing_Aggregate_Fields>;
  nodes: Array<Provider_Billing>;
};

/** aggregate fields of "provider_billing" */
export type Provider_Billing_Aggregate_Fields = {
  __typename?: 'provider_billing_aggregate_fields';
  avg?: Maybe<Provider_Billing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Billing_Max_Fields>;
  min?: Maybe<Provider_Billing_Min_Fields>;
  stddev?: Maybe<Provider_Billing_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Billing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Billing_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Billing_Sum_Fields>;
  var_pop?: Maybe<Provider_Billing_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Billing_Var_Samp_Fields>;
  variance?: Maybe<Provider_Billing_Variance_Fields>;
};


/** aggregate fields of "provider_billing" */
export type Provider_Billing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Billing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Provider_Billing_Avg_Fields = {
  __typename?: 'provider_billing_avg_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_billing". All fields are combined with a logical 'AND'. */
export type Provider_Billing_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Billing_Bool_Exp>>;
  _not?: InputMaybe<Provider_Billing_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Billing_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  previous_payout_date?: InputMaybe<String_Comparison_Exp>;
  previous_week_payout?: InputMaybe<Numeric_Comparison_Exp>;
  previous_week_refund?: InputMaybe<Numeric_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  reserved_balance?: InputMaybe<Numeric_Comparison_Exp>;
  upcoming_payment?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_billing" */
export enum Provider_Billing_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderBillingPkey = 'provider_billing_pkey',
  /** unique or primary key constraint on columns "provider_id" */
  ProviderBillingProviderIdKey = 'provider_billing_provider_id_key'
}

/** input type for incrementing numeric columns in table "provider_billing" */
export type Provider_Billing_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  previous_week_payout?: InputMaybe<Scalars['numeric']>;
  previous_week_refund?: InputMaybe<Scalars['numeric']>;
  reserved_balance?: InputMaybe<Scalars['numeric']>;
  upcoming_payment?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "provider_billing" */
export type Provider_Billing_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_payout_date?: InputMaybe<Scalars['String']>;
  previous_week_payout?: InputMaybe<Scalars['numeric']>;
  previous_week_refund?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  reserved_balance?: InputMaybe<Scalars['numeric']>;
  upcoming_payment?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Provider_Billing_Max_Fields = {
  __typename?: 'provider_billing_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  previous_payout_date?: Maybe<Scalars['String']>;
  previous_week_payout?: Maybe<Scalars['numeric']>;
  previous_week_refund?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['uuid']>;
  reserved_balance?: Maybe<Scalars['numeric']>;
  upcoming_payment?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Provider_Billing_Min_Fields = {
  __typename?: 'provider_billing_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  previous_payout_date?: Maybe<Scalars['String']>;
  previous_week_payout?: Maybe<Scalars['numeric']>;
  previous_week_refund?: Maybe<Scalars['numeric']>;
  provider_id?: Maybe<Scalars['uuid']>;
  reserved_balance?: Maybe<Scalars['numeric']>;
  upcoming_payment?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "provider_billing" */
export type Provider_Billing_Mutation_Response = {
  __typename?: 'provider_billing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Billing>;
};

/** on_conflict condition type for table "provider_billing" */
export type Provider_Billing_On_Conflict = {
  constraint: Provider_Billing_Constraint;
  update_columns?: Array<Provider_Billing_Update_Column>;
  where?: InputMaybe<Provider_Billing_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_billing". */
export type Provider_Billing_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_payout_date?: InputMaybe<Order_By>;
  previous_week_payout?: InputMaybe<Order_By>;
  previous_week_refund?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  reserved_balance?: InputMaybe<Order_By>;
  upcoming_payment?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_billing */
export type Provider_Billing_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "provider_billing" */
export enum Provider_Billing_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousPayoutDate = 'previous_payout_date',
  /** column name */
  PreviousWeekPayout = 'previous_week_payout',
  /** column name */
  PreviousWeekRefund = 'previous_week_refund',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ReservedBalance = 'reserved_balance',
  /** column name */
  UpcomingPayment = 'upcoming_payment',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "provider_billing" */
export type Provider_Billing_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_payout_date?: InputMaybe<Scalars['String']>;
  previous_week_payout?: InputMaybe<Scalars['numeric']>;
  previous_week_refund?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  reserved_balance?: InputMaybe<Scalars['numeric']>;
  upcoming_payment?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Provider_Billing_Stddev_Fields = {
  __typename?: 'provider_billing_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Billing_Stddev_Pop_Fields = {
  __typename?: 'provider_billing_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Billing_Stddev_Samp_Fields = {
  __typename?: 'provider_billing_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "provider_billing" */
export type Provider_Billing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Billing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Billing_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_payout_date?: InputMaybe<Scalars['String']>;
  previous_week_payout?: InputMaybe<Scalars['numeric']>;
  previous_week_refund?: InputMaybe<Scalars['numeric']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  reserved_balance?: InputMaybe<Scalars['numeric']>;
  upcoming_payment?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Provider_Billing_Sum_Fields = {
  __typename?: 'provider_billing_sum_fields';
  id?: Maybe<Scalars['Int']>;
  previous_week_payout?: Maybe<Scalars['numeric']>;
  previous_week_refund?: Maybe<Scalars['numeric']>;
  reserved_balance?: Maybe<Scalars['numeric']>;
  upcoming_payment?: Maybe<Scalars['numeric']>;
};

/** update columns of table "provider_billing" */
export enum Provider_Billing_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousPayoutDate = 'previous_payout_date',
  /** column name */
  PreviousWeekPayout = 'previous_week_payout',
  /** column name */
  PreviousWeekRefund = 'previous_week_refund',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ReservedBalance = 'reserved_balance',
  /** column name */
  UpcomingPayment = 'upcoming_payment',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Provider_Billing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Billing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Billing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Billing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Billing_Var_Pop_Fields = {
  __typename?: 'provider_billing_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Provider_Billing_Var_Samp_Fields = {
  __typename?: 'provider_billing_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Provider_Billing_Variance_Fields = {
  __typename?: 'provider_billing_variance_fields';
  id?: Maybe<Scalars['Float']>;
  previous_week_payout?: Maybe<Scalars['Float']>;
  previous_week_refund?: Maybe<Scalars['Float']>;
  reserved_balance?: Maybe<Scalars['Float']>;
  upcoming_payment?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_dea_licenses" */
export type Provider_Dea_Licenses = {
  __typename?: 'provider_dea_licenses';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  dea_license_schedules: Array<Dea_License_Schedules>;
  /** An aggregate relationship */
  dea_license_schedules_aggregate: Dea_License_Schedules_Aggregate;
  dea_number: Scalars['String'];
  expiration: Scalars['date'];
  id: Scalars['uuid'];
  provider_id: Scalars['uuid'];
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "provider_dea_licenses" */
export type Provider_Dea_LicensesDea_License_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dea_License_Schedules_Order_By>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};


/** columns and relationships of "provider_dea_licenses" */
export type Provider_Dea_LicensesDea_License_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dea_License_Schedules_Order_By>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};

/** aggregated selection of "provider_dea_licenses" */
export type Provider_Dea_Licenses_Aggregate = {
  __typename?: 'provider_dea_licenses_aggregate';
  aggregate?: Maybe<Provider_Dea_Licenses_Aggregate_Fields>;
  nodes: Array<Provider_Dea_Licenses>;
};

export type Provider_Dea_Licenses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Provider_Dea_Licenses_Aggregate_Bool_Exp_Count>;
};

export type Provider_Dea_Licenses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "provider_dea_licenses" */
export type Provider_Dea_Licenses_Aggregate_Fields = {
  __typename?: 'provider_dea_licenses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_Dea_Licenses_Max_Fields>;
  min?: Maybe<Provider_Dea_Licenses_Min_Fields>;
};


/** aggregate fields of "provider_dea_licenses" */
export type Provider_Dea_Licenses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Provider_Dea_Licenses_Max_Order_By>;
  min?: InputMaybe<Provider_Dea_Licenses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Arr_Rel_Insert_Input = {
  data: Array<Provider_Dea_Licenses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_Dea_Licenses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "provider_dea_licenses". All fields are combined with a logical 'AND'. */
export type Provider_Dea_Licenses_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Dea_Licenses_Bool_Exp>>;
  _not?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Dea_Licenses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dea_license_schedules?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
  dea_license_schedules_aggregate?: InputMaybe<Dea_License_Schedules_Aggregate_Bool_Exp>;
  dea_number?: InputMaybe<String_Comparison_Exp>;
  expiration?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_dea_licenses" */
export enum Provider_Dea_Licenses_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderDeaLicensesPkey = 'provider_dea_licenses_pkey'
}

/** input type for inserting data into table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dea_license_schedules?: InputMaybe<Dea_License_Schedules_Arr_Rel_Insert_Input>;
  dea_number?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Provider_Dea_Licenses_Max_Fields = {
  __typename?: 'provider_dea_licenses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dea_number?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dea_number?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Provider_Dea_Licenses_Min_Fields = {
  __typename?: 'provider_dea_licenses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dea_number?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dea_number?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Mutation_Response = {
  __typename?: 'provider_dea_licenses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Dea_Licenses>;
};

/** on_conflict condition type for table "provider_dea_licenses" */
export type Provider_Dea_Licenses_On_Conflict = {
  constraint: Provider_Dea_Licenses_Constraint;
  update_columns?: Array<Provider_Dea_Licenses_Update_Column>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_dea_licenses". */
export type Provider_Dea_Licenses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dea_license_schedules_aggregate?: InputMaybe<Dea_License_Schedules_Aggregate_Order_By>;
  dea_number?: InputMaybe<Order_By>;
  expiration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_dea_licenses */
export type Provider_Dea_Licenses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider_dea_licenses" */
export enum Provider_Dea_Licenses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeaNumber = 'dea_number',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dea_number?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "provider_dea_licenses" */
export type Provider_Dea_Licenses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Dea_Licenses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Dea_Licenses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dea_number?: InputMaybe<Scalars['String']>;
  expiration?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "provider_dea_licenses" */
export enum Provider_Dea_Licenses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeaNumber = 'dea_number',
  /** column name */
  Expiration = 'expiration',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Provider_Dea_Licenses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Dea_Licenses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Dea_Licenses_Bool_Exp;
};

/** columns and relationships of "provider_payments" */
export type Provider_Payments = {
  __typename?: 'provider_payments';
  amount: Scalars['numeric'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  paid_at?: Maybe<Scalars['timestamptz']>;
  status: Scalars['smallint'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "provider_payments" */
export type Provider_Payments_Aggregate = {
  __typename?: 'provider_payments_aggregate';
  aggregate?: Maybe<Provider_Payments_Aggregate_Fields>;
  nodes: Array<Provider_Payments>;
};

/** aggregate fields of "provider_payments" */
export type Provider_Payments_Aggregate_Fields = {
  __typename?: 'provider_payments_aggregate_fields';
  avg?: Maybe<Provider_Payments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Payments_Max_Fields>;
  min?: Maybe<Provider_Payments_Min_Fields>;
  stddev?: Maybe<Provider_Payments_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Payments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Payments_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Payments_Sum_Fields>;
  var_pop?: Maybe<Provider_Payments_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Payments_Var_Samp_Fields>;
  variance?: Maybe<Provider_Payments_Variance_Fields>;
};


/** aggregate fields of "provider_payments" */
export type Provider_Payments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Payments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Provider_Payments_Avg_Fields = {
  __typename?: 'provider_payments_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_payments". All fields are combined with a logical 'AND'. */
export type Provider_Payments_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Payments_Bool_Exp>>;
  _not?: InputMaybe<Provider_Payments_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Payments_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  paid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_payments" */
export enum Provider_Payments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderPaymentsPkey = 'provider_payments_pkey'
}

/** input type for incrementing numeric columns in table "provider_payments" */
export type Provider_Payments_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "provider_payments" */
export type Provider_Payments_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Provider_Payments_Max_Fields = {
  __typename?: 'provider_payments_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Provider_Payments_Min_Fields = {
  __typename?: 'provider_payments_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "provider_payments" */
export type Provider_Payments_Mutation_Response = {
  __typename?: 'provider_payments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Payments>;
};

/** on_conflict condition type for table "provider_payments" */
export type Provider_Payments_On_Conflict = {
  constraint: Provider_Payments_Constraint;
  update_columns?: Array<Provider_Payments_Update_Column>;
  where?: InputMaybe<Provider_Payments_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_payments". */
export type Provider_Payments_Order_By = {
  amount?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_payments */
export type Provider_Payments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "provider_payments" */
export enum Provider_Payments_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "provider_payments" */
export type Provider_Payments_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Provider_Payments_Stddev_Fields = {
  __typename?: 'provider_payments_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Payments_Stddev_Pop_Fields = {
  __typename?: 'provider_payments_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Payments_Stddev_Samp_Fields = {
  __typename?: 'provider_payments_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "provider_payments" */
export type Provider_Payments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Payments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Payments_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Provider_Payments_Sum_Fields = {
  __typename?: 'provider_payments_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['smallint']>;
};

/** update columns of table "provider_payments" */
export enum Provider_Payments_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Provider_Payments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Payments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Payments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Payments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Payments_Var_Pop_Fields = {
  __typename?: 'provider_payments_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Provider_Payments_Var_Samp_Fields = {
  __typename?: 'provider_payments_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Provider_Payments_Variance_Fields = {
  __typename?: 'provider_payments_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_payouts" */
export type Provider_Payouts = {
  __typename?: 'provider_payouts';
  appointment_id?: Maybe<Scalars['uuid']>;
  appointments_total?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  external_entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  payer_role?: Maybe<Scalars['smallint']>;
  payment_provider?: Maybe<Scalars['payment_provider']>;
  provider_id?: Maybe<Scalars['uuid']>;
  receipt_file_id?: Maybe<Scalars['uuid']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

export type Provider_Payouts_Aggregate = {
  __typename?: 'provider_payouts_aggregate';
  aggregate?: Maybe<Provider_Payouts_Aggregate_Fields>;
  nodes: Array<Provider_Payouts>;
};

/** aggregate fields of "provider_payouts" */
export type Provider_Payouts_Aggregate_Fields = {
  __typename?: 'provider_payouts_aggregate_fields';
  avg?: Maybe<Provider_Payouts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Payouts_Max_Fields>;
  min?: Maybe<Provider_Payouts_Min_Fields>;
  stddev?: Maybe<Provider_Payouts_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Payouts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Payouts_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Payouts_Sum_Fields>;
  var_pop?: Maybe<Provider_Payouts_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Payouts_Var_Samp_Fields>;
  variance?: Maybe<Provider_Payouts_Variance_Fields>;
};


/** aggregate fields of "provider_payouts" */
export type Provider_Payouts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Provider_Payouts_Avg_Fields = {
  __typename?: 'provider_payouts_avg_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_payouts". All fields are combined with a logical 'AND'. */
export type Provider_Payouts_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Payouts_Bool_Exp>>;
  _not?: InputMaybe<Provider_Payouts_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Payouts_Bool_Exp>>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  appointments_total?: InputMaybe<Int_Comparison_Exp>;
  category?: InputMaybe<Smallint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount_amount_off?: InputMaybe<Numeric_Comparison_Exp>;
  discount_code?: InputMaybe<String_Comparison_Exp>;
  discount_percent_off?: InputMaybe<Numeric_Comparison_Exp>;
  external_entity_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  paid_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  payer_role?: InputMaybe<Smallint_Comparison_Exp>;
  payment_provider?: InputMaybe<Payment_Provider_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  receipt_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_fee?: InputMaybe<Numeric_Comparison_Exp>;
  service_total?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<Smallint_Comparison_Exp>;
  stripe_entity_type?: InputMaybe<Smallint_Comparison_Exp>;
  stripe_fee?: InputMaybe<Numeric_Comparison_Exp>;
  stripe_net_amount?: InputMaybe<Numeric_Comparison_Exp>;
  stripe_payment_amount?: InputMaybe<Numeric_Comparison_Exp>;
  stripe_processing_fee?: InputMaybe<Numeric_Comparison_Exp>;
  subscription_id?: InputMaybe<Int_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_type?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "provider_payouts" */
export type Provider_Payouts_Inc_Input = {
  appointments_total?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['smallint']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "provider_payouts" */
export type Provider_Payouts_Insert_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  appointments_total?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  external_entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  payment_provider?: InputMaybe<Scalars['payment_provider']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  receipt_file_id?: InputMaybe<Scalars['uuid']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Provider_Payouts_Max_Fields = {
  __typename?: 'provider_payouts_max_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  appointments_total?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  external_entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  payer_role?: Maybe<Scalars['smallint']>;
  payment_provider?: Maybe<Scalars['payment_provider']>;
  provider_id?: Maybe<Scalars['uuid']>;
  receipt_file_id?: Maybe<Scalars['uuid']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Provider_Payouts_Min_Fields = {
  __typename?: 'provider_payouts_min_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  appointments_total?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['smallint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  external_entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  invoice_number?: Maybe<Scalars['String']>;
  paid_at?: Maybe<Scalars['timestamptz']>;
  patient_id?: Maybe<Scalars['uuid']>;
  payer_role?: Maybe<Scalars['smallint']>;
  payment_provider?: Maybe<Scalars['payment_provider']>;
  provider_id?: Maybe<Scalars['uuid']>;
  receipt_file_id?: Maybe<Scalars['uuid']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "provider_payouts" */
export type Provider_Payouts_Mutation_Response = {
  __typename?: 'provider_payouts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Payouts>;
};

/** Ordering options when selecting data from "provider_payouts". */
export type Provider_Payouts_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  appointments_total?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  discount_amount_off?: InputMaybe<Order_By>;
  discount_code?: InputMaybe<Order_By>;
  discount_percent_off?: InputMaybe<Order_By>;
  external_entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  paid_at?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  payer_role?: InputMaybe<Order_By>;
  payment_provider?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  receipt_file_id?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_total?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_entity_type?: InputMaybe<Order_By>;
  stripe_fee?: InputMaybe<Order_By>;
  stripe_net_amount?: InputMaybe<Order_By>;
  stripe_payment_amount?: InputMaybe<Order_By>;
  stripe_processing_fee?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "provider_payouts" */
export enum Provider_Payouts_Select_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  AppointmentsTotal = 'appointments_total',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountAmountOff = 'discount_amount_off',
  /** column name */
  DiscountCode = 'discount_code',
  /** column name */
  DiscountPercentOff = 'discount_percent_off',
  /** column name */
  ExternalEntityId = 'external_entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  PaidAt = 'paid_at',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  PayerRole = 'payer_role',
  /** column name */
  PaymentProvider = 'payment_provider',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ReceiptFileId = 'receipt_file_id',
  /** column name */
  ServiceFee = 'service_fee',
  /** column name */
  ServiceTotal = 'service_total',
  /** column name */
  Status = 'status',
  /** column name */
  StripeEntityType = 'stripe_entity_type',
  /** column name */
  StripeFee = 'stripe_fee',
  /** column name */
  StripeNetAmount = 'stripe_net_amount',
  /** column name */
  StripePaymentAmount = 'stripe_payment_amount',
  /** column name */
  StripeProcessingFee = 'stripe_processing_fee',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Total = 'total',
  /** column name */
  TransactionType = 'transaction_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "provider_payouts" */
export type Provider_Payouts_Set_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  appointments_total?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  external_entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  payment_provider?: InputMaybe<Scalars['payment_provider']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  receipt_file_id?: InputMaybe<Scalars['uuid']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Provider_Payouts_Stddev_Fields = {
  __typename?: 'provider_payouts_stddev_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Payouts_Stddev_Pop_Fields = {
  __typename?: 'provider_payouts_stddev_pop_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Payouts_Stddev_Samp_Fields = {
  __typename?: 'provider_payouts_stddev_samp_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "provider_payouts" */
export type Provider_Payouts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Payouts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Payouts_Stream_Cursor_Value_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  appointments_total?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['smallint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_amount_off?: InputMaybe<Scalars['numeric']>;
  discount_code?: InputMaybe<Scalars['String']>;
  discount_percent_off?: InputMaybe<Scalars['numeric']>;
  external_entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['timestamptz']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  payer_role?: InputMaybe<Scalars['smallint']>;
  payment_provider?: InputMaybe<Scalars['payment_provider']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  receipt_file_id?: InputMaybe<Scalars['uuid']>;
  service_fee?: InputMaybe<Scalars['numeric']>;
  service_total?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['smallint']>;
  stripe_entity_type?: InputMaybe<Scalars['smallint']>;
  stripe_fee?: InputMaybe<Scalars['numeric']>;
  stripe_net_amount?: InputMaybe<Scalars['numeric']>;
  stripe_payment_amount?: InputMaybe<Scalars['numeric']>;
  stripe_processing_fee?: InputMaybe<Scalars['numeric']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['numeric']>;
  transaction_type?: InputMaybe<Scalars['smallint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Provider_Payouts_Sum_Fields = {
  __typename?: 'provider_payouts_sum_fields';
  appointments_total?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['smallint']>;
  discount_amount_off?: Maybe<Scalars['numeric']>;
  discount_percent_off?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  payer_role?: Maybe<Scalars['smallint']>;
  service_fee?: Maybe<Scalars['numeric']>;
  service_total?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['smallint']>;
  stripe_entity_type?: Maybe<Scalars['smallint']>;
  stripe_fee?: Maybe<Scalars['numeric']>;
  stripe_net_amount?: Maybe<Scalars['numeric']>;
  stripe_payment_amount?: Maybe<Scalars['numeric']>;
  stripe_processing_fee?: Maybe<Scalars['numeric']>;
  subscription_id?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['numeric']>;
  transaction_type?: Maybe<Scalars['smallint']>;
};

export type Provider_Payouts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Payouts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Payouts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Payouts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Payouts_Var_Pop_Fields = {
  __typename?: 'provider_payouts_var_pop_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Provider_Payouts_Var_Samp_Fields = {
  __typename?: 'provider_payouts_var_samp_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Provider_Payouts_Variance_Fields = {
  __typename?: 'provider_payouts_variance_fields';
  appointments_total?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['Float']>;
  discount_amount_off?: Maybe<Scalars['Float']>;
  discount_percent_off?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payer_role?: Maybe<Scalars['Float']>;
  service_fee?: Maybe<Scalars['Float']>;
  service_total?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  stripe_entity_type?: Maybe<Scalars['Float']>;
  stripe_fee?: Maybe<Scalars['Float']>;
  stripe_net_amount?: Maybe<Scalars['Float']>;
  stripe_payment_amount?: Maybe<Scalars['Float']>;
  stripe_processing_fee?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transaction_type?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "provider_state_licenses" */
export type Provider_State_Licenses = {
  __typename?: 'provider_state_licenses';
  created_at: Scalars['timestamptz'];
  expiration_14_days_notification_id?: Maybe<Scalars['uuid']>;
  expiration_30_days_notification_id?: Maybe<Scalars['uuid']>;
  expiration_date: Scalars['date'];
  expiration_notification_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  license_number: Scalars['String'];
  license_type: Scalars['String'];
  provider_id: Scalars['uuid'];
  state: Scalars['bpchar'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "provider_state_licenses" */
export type Provider_State_Licenses_Aggregate = {
  __typename?: 'provider_state_licenses_aggregate';
  aggregate?: Maybe<Provider_State_Licenses_Aggregate_Fields>;
  nodes: Array<Provider_State_Licenses>;
};

export type Provider_State_Licenses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Provider_State_Licenses_Aggregate_Bool_Exp_Count>;
};

export type Provider_State_Licenses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "provider_state_licenses" */
export type Provider_State_Licenses_Aggregate_Fields = {
  __typename?: 'provider_state_licenses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Provider_State_Licenses_Max_Fields>;
  min?: Maybe<Provider_State_Licenses_Min_Fields>;
};


/** aggregate fields of "provider_state_licenses" */
export type Provider_State_Licenses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "provider_state_licenses" */
export type Provider_State_Licenses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Provider_State_Licenses_Max_Order_By>;
  min?: InputMaybe<Provider_State_Licenses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "provider_state_licenses" */
export type Provider_State_Licenses_Arr_Rel_Insert_Input = {
  data: Array<Provider_State_Licenses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Provider_State_Licenses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "provider_state_licenses". All fields are combined with a logical 'AND'. */
export type Provider_State_Licenses_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_State_Licenses_Bool_Exp>>;
  _not?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_State_Licenses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration_14_days_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  expiration_30_days_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  expiration_notification_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  license_number?: InputMaybe<String_Comparison_Exp>;
  license_type?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_state_licenses" */
export enum Provider_State_Licenses_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProviderStateLicensesPkey = 'provider_state_licenses_pkey'
}

/** input type for inserting data into table "provider_state_licenses" */
export type Provider_State_Licenses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_14_days_notification_id?: InputMaybe<Scalars['uuid']>;
  expiration_30_days_notification_id?: InputMaybe<Scalars['uuid']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  expiration_notification_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  license_number?: InputMaybe<Scalars['String']>;
  license_type?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Provider_State_Licenses_Max_Fields = {
  __typename?: 'provider_state_licenses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_14_days_notification_id?: Maybe<Scalars['uuid']>;
  expiration_30_days_notification_id?: Maybe<Scalars['uuid']>;
  expiration_date?: Maybe<Scalars['date']>;
  expiration_notification_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  license_number?: Maybe<Scalars['String']>;
  license_type?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "provider_state_licenses" */
export type Provider_State_Licenses_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiration_14_days_notification_id?: InputMaybe<Order_By>;
  expiration_30_days_notification_id?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  expiration_notification_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  license_type?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Provider_State_Licenses_Min_Fields = {
  __typename?: 'provider_state_licenses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  expiration_14_days_notification_id?: Maybe<Scalars['uuid']>;
  expiration_30_days_notification_id?: Maybe<Scalars['uuid']>;
  expiration_date?: Maybe<Scalars['date']>;
  expiration_notification_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  license_number?: Maybe<Scalars['String']>;
  license_type?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "provider_state_licenses" */
export type Provider_State_Licenses_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiration_14_days_notification_id?: InputMaybe<Order_By>;
  expiration_30_days_notification_id?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  expiration_notification_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  license_type?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "provider_state_licenses" */
export type Provider_State_Licenses_Mutation_Response = {
  __typename?: 'provider_state_licenses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_State_Licenses>;
};

/** on_conflict condition type for table "provider_state_licenses" */
export type Provider_State_Licenses_On_Conflict = {
  constraint: Provider_State_Licenses_Constraint;
  update_columns?: Array<Provider_State_Licenses_Update_Column>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_state_licenses". */
export type Provider_State_Licenses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  expiration_14_days_notification_id?: InputMaybe<Order_By>;
  expiration_30_days_notification_id?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  expiration_notification_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  license_type?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_state_licenses */
export type Provider_State_Licenses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "provider_state_licenses" */
export enum Provider_State_Licenses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Expiration_14DaysNotificationId = 'expiration_14_days_notification_id',
  /** column name */
  Expiration_30DaysNotificationId = 'expiration_30_days_notification_id',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  ExpirationNotificationId = 'expiration_notification_id',
  /** column name */
  Id = 'id',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  LicenseType = 'license_type',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "provider_state_licenses" */
export type Provider_State_Licenses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_14_days_notification_id?: InputMaybe<Scalars['uuid']>;
  expiration_30_days_notification_id?: InputMaybe<Scalars['uuid']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  expiration_notification_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  license_number?: InputMaybe<Scalars['String']>;
  license_type?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "provider_state_licenses" */
export type Provider_State_Licenses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_State_Licenses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_State_Licenses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiration_14_days_notification_id?: InputMaybe<Scalars['uuid']>;
  expiration_30_days_notification_id?: InputMaybe<Scalars['uuid']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  expiration_notification_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  license_number?: InputMaybe<Scalars['String']>;
  license_type?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "provider_state_licenses" */
export enum Provider_State_Licenses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Expiration_14DaysNotificationId = 'expiration_14_days_notification_id',
  /** column name */
  Expiration_30DaysNotificationId = 'expiration_30_days_notification_id',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  ExpirationNotificationId = 'expiration_notification_id',
  /** column name */
  Id = 'id',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  LicenseType = 'license_type',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Provider_State_Licenses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_State_Licenses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_State_Licenses_Bool_Exp;
};

/** Tracks unread notifications for provider */
export type Provider_Unread_External_Notification_Counts = {
  __typename?: 'provider_unread_external_notification_counts';
  codex_provider_id: Scalars['uuid'];
  dosespot_unread_notifications: Scalars['numeric'];
  fhir_provider_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Aggregate = {
  __typename?: 'provider_unread_external_notification_counts_aggregate';
  aggregate?: Maybe<Provider_Unread_External_Notification_Counts_Aggregate_Fields>;
  nodes: Array<Provider_Unread_External_Notification_Counts>;
};

/** aggregate fields of "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Aggregate_Fields = {
  __typename?: 'provider_unread_external_notification_counts_aggregate_fields';
  avg?: Maybe<Provider_Unread_External_Notification_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Provider_Unread_External_Notification_Counts_Max_Fields>;
  min?: Maybe<Provider_Unread_External_Notification_Counts_Min_Fields>;
  stddev?: Maybe<Provider_Unread_External_Notification_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Provider_Unread_External_Notification_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Provider_Unread_External_Notification_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Provider_Unread_External_Notification_Counts_Sum_Fields>;
  var_pop?: Maybe<Provider_Unread_External_Notification_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Provider_Unread_External_Notification_Counts_Var_Samp_Fields>;
  variance?: Maybe<Provider_Unread_External_Notification_Counts_Variance_Fields>;
};


/** aggregate fields of "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Provider_Unread_External_Notification_Counts_Avg_Fields = {
  __typename?: 'provider_unread_external_notification_counts_avg_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "provider_unread_external_notification_counts". All fields are combined with a logical 'AND'. */
export type Provider_Unread_External_Notification_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Bool_Exp>>;
  _not?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Bool_Exp>>;
  codex_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  dosespot_unread_notifications?: InputMaybe<Numeric_Comparison_Exp>;
  fhir_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "provider_unread_external_notification_counts" */
export enum Provider_Unread_External_Notification_Counts_Constraint {
  /** unique or primary key constraint on columns "codex_provider_id" */
  ProviderUnreadExternalNotificationCountsPkey = 'provider_unread_external_notification_counts_pkey'
}

/** input type for incrementing numeric columns in table "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Inc_Input = {
  dosespot_unread_notifications?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Insert_Input = {
  codex_provider_id?: InputMaybe<Scalars['uuid']>;
  dosespot_unread_notifications?: InputMaybe<Scalars['numeric']>;
  fhir_provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Provider_Unread_External_Notification_Counts_Max_Fields = {
  __typename?: 'provider_unread_external_notification_counts_max_fields';
  codex_provider_id?: Maybe<Scalars['uuid']>;
  dosespot_unread_notifications?: Maybe<Scalars['numeric']>;
  fhir_provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Provider_Unread_External_Notification_Counts_Min_Fields = {
  __typename?: 'provider_unread_external_notification_counts_min_fields';
  codex_provider_id?: Maybe<Scalars['uuid']>;
  dosespot_unread_notifications?: Maybe<Scalars['numeric']>;
  fhir_provider_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Mutation_Response = {
  __typename?: 'provider_unread_external_notification_counts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Provider_Unread_External_Notification_Counts>;
};

/** on_conflict condition type for table "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_On_Conflict = {
  constraint: Provider_Unread_External_Notification_Counts_Constraint;
  update_columns?: Array<Provider_Unread_External_Notification_Counts_Update_Column>;
  where?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
};

/** Ordering options when selecting data from "provider_unread_external_notification_counts". */
export type Provider_Unread_External_Notification_Counts_Order_By = {
  codex_provider_id?: InputMaybe<Order_By>;
  dosespot_unread_notifications?: InputMaybe<Order_By>;
  fhir_provider_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: provider_unread_external_notification_counts */
export type Provider_Unread_External_Notification_Counts_Pk_Columns_Input = {
  codex_provider_id: Scalars['uuid'];
};

/** select columns of table "provider_unread_external_notification_counts" */
export enum Provider_Unread_External_Notification_Counts_Select_Column {
  /** column name */
  CodexProviderId = 'codex_provider_id',
  /** column name */
  DosespotUnreadNotifications = 'dosespot_unread_notifications',
  /** column name */
  FhirProviderId = 'fhir_provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Set_Input = {
  codex_provider_id?: InputMaybe<Scalars['uuid']>;
  dosespot_unread_notifications?: InputMaybe<Scalars['numeric']>;
  fhir_provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Provider_Unread_External_Notification_Counts_Stddev_Fields = {
  __typename?: 'provider_unread_external_notification_counts_stddev_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Provider_Unread_External_Notification_Counts_Stddev_Pop_Fields = {
  __typename?: 'provider_unread_external_notification_counts_stddev_pop_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Provider_Unread_External_Notification_Counts_Stddev_Samp_Fields = {
  __typename?: 'provider_unread_external_notification_counts_stddev_samp_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "provider_unread_external_notification_counts" */
export type Provider_Unread_External_Notification_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Provider_Unread_External_Notification_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Provider_Unread_External_Notification_Counts_Stream_Cursor_Value_Input = {
  codex_provider_id?: InputMaybe<Scalars['uuid']>;
  dosespot_unread_notifications?: InputMaybe<Scalars['numeric']>;
  fhir_provider_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Provider_Unread_External_Notification_Counts_Sum_Fields = {
  __typename?: 'provider_unread_external_notification_counts_sum_fields';
  dosespot_unread_notifications?: Maybe<Scalars['numeric']>;
};

/** update columns of table "provider_unread_external_notification_counts" */
export enum Provider_Unread_External_Notification_Counts_Update_Column {
  /** column name */
  CodexProviderId = 'codex_provider_id',
  /** column name */
  DosespotUnreadNotifications = 'dosespot_unread_notifications',
  /** column name */
  FhirProviderId = 'fhir_provider_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Provider_Unread_External_Notification_Counts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Provider_Unread_External_Notification_Counts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Provider_Unread_External_Notification_Counts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Provider_Unread_External_Notification_Counts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Provider_Unread_External_Notification_Counts_Var_Pop_Fields = {
  __typename?: 'provider_unread_external_notification_counts_var_pop_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Provider_Unread_External_Notification_Counts_Var_Samp_Fields = {
  __typename?: 'provider_unread_external_notification_counts_var_samp_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Provider_Unread_External_Notification_Counts_Variance_Fields = {
  __typename?: 'provider_unread_external_notification_counts_variance_fields';
  dosespot_unread_notifications?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** Creates kit ids batch with ZRT */
  CreateKitIdsBatch?: Maybe<ZrtKitIdsBatchOutput>;
  /** Creates kit ids for Diagnostic Solutions */
  CreateKitIdsDiagnosticSolutions?: Maybe<DiagnosticSolutionsKitIdsOutput>;
  /** List Acuity availability overrides (blocked times) for a calendar */
  GetAvailabilityOverrides: AvailabilityOverridesResponse;
  /** GetAvailableAppointmentTypes */
  GetAvailableAppointmentTypes?: Maybe<GetAvailableAppointmentTypesResult>;
  /** Gets provider availability dates from Acuity */
  GetProviderAvailabilityMonthDates: ProviderAvailabilityMonthDates;
  /** Gets provider availability type service from Acuity */
  GetProviderAvailabilityServiceTypes: ProviderAvailabilityServiceTypes;
  /** Gets provider availability times slots from Acuity by date */
  GetProviderAvailabilityTimeSlots: ProviderAvailabilityTimeSlots;
  /** Gets provider time slots and block times from Acuity */
  GetProviderTimeSlots: ProviderWorkingHoursAndBlockedTime;
  /** getSignUrlFromStorageForRequester */
  GetSignUrlFromStorageForRequester?: Maybe<SuccessGetSignUrlFormStorage>;
  /** Checks if swab is valid and returns its data */
  GetSwabCodeValidBySwabcode?: Maybe<IsValidSwabCode>;
  /** Query to validate fedex tracking number */
  ValidateFedexTrackingNumber: FedexTrackingResponse;
  /** Validates kit ids of Diagnostic Solutions */
  ValidateKitIdDiagnosticSolutions?: Maybe<DiagnosticSolutionsValidateKitIdResult>;
  /** Validates kit ids of Molecular Labs */
  ValidateKitIdMolecularLabs?: Maybe<MolecularLabsValidateKitIdResult>;
  /** Validate NPI number */
  ValidateNpiNumber?: Maybe<IsNpiValid>;
  /** An array relationship */
  accepted_legal_documents: Array<Accepted_Legal_Documents>;
  /** An aggregate relationship */
  accepted_legal_documents_aggregate: Accepted_Legal_Documents_Aggregate;
  /** fetch data from the table: "accepted_legal_documents" using primary key columns */
  accepted_legal_documents_by_pk?: Maybe<Accepted_Legal_Documents>;
  /** An array relationship */
  active_in_mails: Array<Active_In_Mails>;
  /** An aggregate relationship */
  active_in_mails_aggregate: Active_In_Mails_Aggregate;
  /** fetch data from the table: "active_in_mails" using primary key columns */
  active_in_mails_by_pk?: Maybe<Active_In_Mails>;
  /** An array relationship */
  active_support_chats: Array<Active_Support_Chats>;
  /** An aggregate relationship */
  active_support_chats_aggregate: Active_Support_Chats_Aggregate;
  /** fetch data from the table: "active_support_chats" using primary key columns */
  active_support_chats_by_pk?: Maybe<Active_Support_Chats>;
  /** fetch data from the table: "activity_events" */
  activity_events: Array<Activity_Events>;
  /** fetch aggregated fields from the table: "activity_events" */
  activity_events_aggregate: Activity_Events_Aggregate;
  /** fetch data from the table: "activity_events" using primary key columns */
  activity_events_by_pk?: Maybe<Activity_Events>;
  /** fetch data from the table: "acuity_provider_calendar" */
  acuity_provider_calendar: Array<Acuity_Provider_Calendar>;
  /** fetch aggregated fields from the table: "acuity_provider_calendar" */
  acuity_provider_calendar_aggregate: Acuity_Provider_Calendar_Aggregate;
  /** fetch data from the table: "acuity_provider_calendar" using primary key columns */
  acuity_provider_calendar_by_pk?: Maybe<Acuity_Provider_Calendar>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** An array relationship */
  admin_permissions: Array<Admin_Permissions>;
  /** An aggregate relationship */
  admin_permissions_aggregate: Admin_Permissions_Aggregate;
  /** fetch data from the table: "admin_permissions" using primary key columns */
  admin_permissions_by_pk?: Maybe<Admin_Permissions>;
  /** fetch data from the table: "age_of_majority_rules" */
  age_of_majority_rules: Array<Age_Of_Majority_Rules>;
  /** fetch aggregated fields from the table: "age_of_majority_rules" */
  age_of_majority_rules_aggregate: Age_Of_Majority_Rules_Aggregate;
  /** fetch data from the table: "age_of_majority_rules" using primary key columns */
  age_of_majority_rules_by_pk?: Maybe<Age_Of_Majority_Rules>;
  /** fetch data from the table: "allergen_classes" */
  allergen_classes: Array<Allergen_Classes>;
  /** fetch aggregated fields from the table: "allergen_classes" */
  allergen_classes_aggregate: Allergen_Classes_Aggregate;
  /** fetch data from the table: "allergen_classes" using primary key columns */
  allergen_classes_by_pk?: Maybe<Allergen_Classes>;
  /** fetch data from the table: "app_tours" */
  app_tours: Array<App_Tours>;
  /** fetch aggregated fields from the table: "app_tours" */
  app_tours_aggregate: App_Tours_Aggregate;
  /** fetch data from the table: "app_tours" using primary key columns */
  app_tours_by_pk?: Maybe<App_Tours>;
  /** fetch data from the table: "app_versions" */
  app_versions: Array<App_Versions>;
  /** fetch aggregated fields from the table: "app_versions" */
  app_versions_aggregate: App_Versions_Aggregate;
  /** fetch data from the table: "app_versions" using primary key columns */
  app_versions_by_pk?: Maybe<App_Versions>;
  /** fetch data from the table: "appointment_media_signals" */
  appointment_media_signals: Array<Appointment_Media_Signals>;
  /** fetch aggregated fields from the table: "appointment_media_signals" */
  appointment_media_signals_aggregate: Appointment_Media_Signals_Aggregate;
  /** fetch data from the table: "appointment_media_signals" using primary key columns */
  appointment_media_signals_by_pk?: Maybe<Appointment_Media_Signals>;
  /** An array relationship */
  appointment_payments: Array<Appointment_Payments>;
  /** An aggregate relationship */
  appointment_payments_aggregate: Appointment_Payments_Aggregate;
  /** fetch data from the table: "appointment_payments" using primary key columns */
  appointment_payments_by_pk?: Maybe<Appointment_Payments>;
  /** fetch data from the table: "appointment_requests" */
  appointment_requests: Array<Appointment_Requests>;
  /** fetch aggregated fields from the table: "appointment_requests" */
  appointment_requests_aggregate: Appointment_Requests_Aggregate;
  /** fetch data from the table: "appointment_requests" using primary key columns */
  appointment_requests_by_pk?: Maybe<Appointment_Requests>;
  /** fetch data from the table: "appointment_status_counts" */
  appointment_status_counts: Array<Appointment_Status_Counts>;
  /** fetch aggregated fields from the table: "appointment_status_counts" */
  appointment_status_counts_aggregate: Appointment_Status_Counts_Aggregate;
  /** fetch data from the table: "appointment_status_history" */
  appointment_status_history: Array<Appointment_Status_History>;
  /** fetch aggregated fields from the table: "appointment_status_history" */
  appointment_status_history_aggregate: Appointment_Status_History_Aggregate;
  /** fetch data from the table: "appointment_status_history" using primary key columns */
  appointment_status_history_by_pk?: Maybe<Appointment_Status_History>;
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** fetch data from the table: "appointments" using primary key columns */
  appointments_by_pk?: Maybe<Appointments>;
  /** fetch data from the table: "cart_products" */
  cart_products: Array<Cart_Products>;
  /** fetch aggregated fields from the table: "cart_products" */
  cart_products_aggregate: Cart_Products_Aggregate;
  /** fetch data from the table: "cart_products" using primary key columns */
  cart_products_by_pk?: Maybe<Cart_Products>;
  /** fetch data from the table: "channel_signals" */
  channel_signals: Array<Channel_Signals>;
  /** fetch aggregated fields from the table: "channel_signals" */
  channel_signals_aggregate: Channel_Signals_Aggregate;
  /** fetch data from the table: "channel_signals" using primary key columns */
  channel_signals_by_pk?: Maybe<Channel_Signals>;
  /** fetch data from the table: "common_question_responses" */
  common_question_responses: Array<Common_Question_Responses>;
  /** fetch aggregated fields from the table: "common_question_responses" */
  common_question_responses_aggregate: Common_Question_Responses_Aggregate;
  /** fetch data from the table: "common_question_responses" using primary key columns */
  common_question_responses_by_pk?: Maybe<Common_Question_Responses>;
  /** fetch data from the table: "common_questions" */
  common_questions: Array<Common_Questions>;
  /** fetch aggregated fields from the table: "common_questions" */
  common_questions_aggregate: Common_Questions_Aggregate;
  /** fetch data from the table: "common_questions" using primary key columns */
  common_questions_by_pk?: Maybe<Common_Questions>;
  /** fetch data from the table: "communication_channels" */
  communication_channels: Array<Communication_Channels>;
  /** fetch aggregated fields from the table: "communication_channels" */
  communication_channels_aggregate: Communication_Channels_Aggregate;
  /** fetch data from the table: "communication_channels" using primary key columns */
  communication_channels_by_pk?: Maybe<Communication_Channels>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  cronAppointmentSummaryReminder: Scalars['Boolean'];
  cronCancelAppointmentsForExpiredSubscriptionGracePeriod: Scalars['Boolean'];
  cronCancelUnpaidAppointments: Scalars['Boolean'];
  cronCleanupExpiredAiTranscripts: Scalars['Boolean'];
  cronCleanupOldActivityEvents: Scalars['Boolean'];
  cronCleanupStaleChannelSignals: Scalars['Boolean'];
  cronClearAllToastNotifications: Scalars['Boolean'];
  cronExpireStaleAppointmentRequests: Scalars['Boolean'];
  cronHandleProviderStateLicenses: Scalars['Boolean'];
  cronHealthQuestionerUpdateReminder: Scalars['Boolean'];
  cronRecommendationReminder: Scalars['Boolean'];
  cronSyncPaymentTransactions: Scalars['Boolean'];
  /** fetch data from the table: "custom_auth_code" */
  custom_auth_code: Array<Custom_Auth_Code>;
  /** fetch aggregated fields from the table: "custom_auth_code" */
  custom_auth_code_aggregate: Custom_Auth_Code_Aggregate;
  /** fetch data from the table: "custom_auth_code" using primary key columns */
  custom_auth_code_by_pk?: Maybe<Custom_Auth_Code>;
  /** An array relationship */
  dea_license_schedules: Array<Dea_License_Schedules>;
  /** An aggregate relationship */
  dea_license_schedules_aggregate: Dea_License_Schedules_Aggregate;
  /** fetch data from the table: "dea_license_schedules" using primary key columns */
  dea_license_schedules_by_pk?: Maybe<Dea_License_Schedules>;
  /** fetch data from the table: "delivery_addresses" */
  delivery_addresses: Array<Delivery_Addresses>;
  /** fetch aggregated fields from the table: "delivery_addresses" */
  delivery_addresses_aggregate: Delivery_Addresses_Aggregate;
  /** fetch data from the table: "delivery_addresses" using primary key columns */
  delivery_addresses_by_pk?: Maybe<Delivery_Addresses>;
  /** fetch data from the table: "diagnostic_solution_tests" */
  diagnostic_solution_tests: Array<Diagnostic_Solution_Tests>;
  /** fetch aggregated fields from the table: "diagnostic_solution_tests" */
  diagnostic_solution_tests_aggregate: Diagnostic_Solution_Tests_Aggregate;
  /** fetch data from the table: "diagnostic_solution_tests" using primary key columns */
  diagnostic_solution_tests_by_pk?: Maybe<Diagnostic_Solution_Tests>;
  /** fetch data from the table: "dnavisit_test_statuses" */
  dnavisit_test_statuses: Array<Dnavisit_Test_Statuses>;
  /** fetch aggregated fields from the table: "dnavisit_test_statuses" */
  dnavisit_test_statuses_aggregate: Dnavisit_Test_Statuses_Aggregate;
  /** fetch data from the table: "dnavisit_test_statuses" using primary key columns */
  dnavisit_test_statuses_by_pk?: Maybe<Dnavisit_Test_Statuses>;
  /** fetch data from the table: "dnavisit_tests" */
  dnavisit_tests: Array<Dnavisit_Tests>;
  /** fetch aggregated fields from the table: "dnavisit_tests" */
  dnavisit_tests_aggregate: Dnavisit_Tests_Aggregate;
  /** fetch data from the table: "dnavisit_tests" using primary key columns */
  dnavisit_tests_by_pk?: Maybe<Dnavisit_Tests>;
  /** fetch data from the table: "do_not_use_production_swab_codes" */
  do_not_use_production_swab_codes: Array<Do_Not_Use_Production_Swab_Codes>;
  /** fetch aggregated fields from the table: "do_not_use_production_swab_codes" */
  do_not_use_production_swab_codes_aggregate: Do_Not_Use_Production_Swab_Codes_Aggregate;
  /** fetch data from the table: "do_not_use_production_swab_codes" using primary key columns */
  do_not_use_production_swab_codes_by_pk?: Maybe<Do_Not_Use_Production_Swab_Codes>;
  ePrescribeMyTasksCount: TotalOutput;
  /** fetch data from the table: "ecommerce_orders" */
  ecommerce_orders: Array<Ecommerce_Orders>;
  /** fetch aggregated fields from the table: "ecommerce_orders" */
  ecommerce_orders_aggregate: Ecommerce_Orders_Aggregate;
  /** fetch data from the table: "ecommerce_orders" using primary key columns */
  ecommerce_orders_by_pk?: Maybe<Ecommerce_Orders>;
  /** An array relationship */
  education_courses: Array<Education_Courses>;
  /** An aggregate relationship */
  education_courses_aggregate: Education_Courses_Aggregate;
  /** fetch data from the table: "education_courses" using primary key columns */
  education_courses_by_pk?: Maybe<Education_Courses>;
  /** fetch data from the table: "education_module_additional_materials" */
  education_module_additional_materials: Array<Education_Module_Additional_Materials>;
  /** fetch aggregated fields from the table: "education_module_additional_materials" */
  education_module_additional_materials_aggregate: Education_Module_Additional_Materials_Aggregate;
  /** fetch data from the table: "education_module_additional_materials" using primary key columns */
  education_module_additional_materials_by_pk?: Maybe<Education_Module_Additional_Materials>;
  /** An array relationship */
  education_module_items: Array<Education_Module_Items>;
  /** An aggregate relationship */
  education_module_items_aggregate: Education_Module_Items_Aggregate;
  /** fetch data from the table: "education_module_items" using primary key columns */
  education_module_items_by_pk?: Maybe<Education_Module_Items>;
  /** An array relationship */
  education_modules: Array<Education_Modules>;
  /** An aggregate relationship */
  education_modules_aggregate: Education_Modules_Aggregate;
  /** fetch data from the table: "education_modules" using primary key columns */
  education_modules_by_pk?: Maybe<Education_Modules>;
  /** fetch data from the table: "file_types" */
  file_types: Array<File_Types>;
  /** fetch aggregated fields from the table: "file_types" */
  file_types_aggregate: File_Types_Aggregate;
  /** fetch data from the table: "file_types" using primary key columns */
  file_types_by_pk?: Maybe<File_Types>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  frontEndAuthConfigs: Scalars['JSON'];
  fullscriptDependentCreateLink: DependentLinkOutput;
  /** fetch data from the table: "fullscript_allergens" */
  fullscript_allergens: Array<Fullscript_Allergens>;
  /** fetch aggregated fields from the table: "fullscript_allergens" */
  fullscript_allergens_aggregate: Fullscript_Allergens_Aggregate;
  /** fetch data from the table: "fullscript_allergens" using primary key columns */
  fullscript_allergens_by_pk?: Maybe<Fullscript_Allergens>;
  /** fetch data from the table: "fullscript_clinicians" */
  fullscript_clinicians: Array<Fullscript_Clinicians>;
  /** fetch aggregated fields from the table: "fullscript_clinicians" */
  fullscript_clinicians_aggregate: Fullscript_Clinicians_Aggregate;
  /** fetch data from the table: "fullscript_clinicians" using primary key columns */
  fullscript_clinicians_by_pk?: Maybe<Fullscript_Clinicians>;
  /** An array relationship */
  gale_products: Array<Gale_Products>;
  /** An aggregate relationship */
  gale_products_aggregate: Gale_Products_Aggregate;
  /** fetch data from the table: "gale_products" using primary key columns */
  gale_products_by_pk?: Maybe<Gale_Products>;
  getAcceptedLegalDocuments: AcceptedLegalDocumentsOutput;
  getAccountUsers: AccountUsersOutput;
  getAchievements: AchievementsOutput;
  getActiveRecommendationsByPatientCodexId: GetFhirRecommendationsOutput;
  getAllDraftTestQuestionnairesByPatient: GetFhirQuestionnaireResponseArr;
  getAllergenClasses: AllergenClassesOutput;
  getAppTours: AppToursOutput;
  getAppVersions: AppVersionsOutput;
  getAppointmentDetails: SaAppointmentDetailsOutput;
  getAppointmentMessageByCommunicationFhirId: GetAppointmentChatMessagesOutput;
  getAppointmentMessageListByAppointmentCodexId: GetAppointmentChatMessagesOutput;
  getAppointmentNotesByAppointmentId: GetAppointmentNotesByAppointmentIdOutput;
  getAppointmentRescheduleLink: GetAppointmentRescheduleLinkOutput;
  getAppointmentRetryPaymentLink: GetPaymentLinkOutput;
  getAppointmentStats: Array<AppointmentStatsByDayOutput>;
  getAppointmentSummary: VonageSummaryOutput;
  getAppointments: SaAppointments;
  getBecomePatientRequests: BecomePatientRequestsOutput;
  getCallSettings: Scalars['JSON'];
  getCartProducts: CartProductsOutput;
  getDelegatedAdminDetails: DelegatedAdminDetailsOutput;
  getDelegatedAdmins: GetDelegatedAdminsOutput;
  getDeliveryAddresses: DeliveryAddressesOutput;
  getDiagnosticReports: SaDiagnosticReports;
  getDiagnosticReportsByParticipants: AppointmentsDiagnosticReportsOutput;
  getDiagnosticReportsByPatient: AppointmentsDiagnosticReportsOutput;
  getDiscountCode: DiscountOutput;
  getDraftTestQuestionnairesById: GetFhirQuestionnaireResponse;
  getEducationCourseDetails: EducationCourseOutput;
  getEducationCourses: EducationCoursesListOutput;
  getEducationModules: EducationModulesListOutput;
  getFHIRAppointmentByAcuityId: GetFhirAppointmentOutput;
  getFHIRAppointmentByCodexId: GetFhirAppointmentOutput;
  getFHIRAppointmentByPatientCodexId: GetFhirAppointmentsOutput;
  getFHIRAppointmentByRequestPatientCodexId: GetFhirAppointmentsOutputWithUpcomingCounts;
  getFHIRAppointmentByRequestProviderId: GetFhirAppointmentsOutputWithUpcomingCounts;
  getFHIRDPrivderInfoByZrtSwabcode: ProviderOutput;
  getFHIRDiagnosticSolutionTests: GetFhirMosaicTests;
  getFHIRDnaAndZrtTests: GetFhirDnaAndZrtTests;
  getFHIRDnaVisitTestByOrderId: GetFhirDnaVisitTestByIdentifier;
  getFHIRDnaVisitTestBySwabcode: GetFhirDnaVisitTestByIdentifier;
  getFHIRDnaVisitTestByTestId: GetFhirDnaVisitTestByIdentifier;
  getFHIRDnaVisitTests: GetFhirDnaVisitTests;
  getFHIRDnaVisitTestsByUserId: GetFhirDnaVisitTestsByUserId;
  getFHIREncountersByPatient: EncounterListOutput;
  getFHIREncountersByProvider: EncounterListOutput;
  getFHIRMediaByRequestPatientCodexID: GetFhirPatientMediaOutput;
  getFHIRMedicationRequestBranAndNamesByPatientCodexId: GetMedicationRequestsBrandAndNameOutput;
  getFHIRMedicationRequestByFhirId: GetMedicationRequestsOutput;
  getFHIRMedicationRequestByPatientCodexId: GetMedicationRequestsOutput;
  getFHIRMosaicTests: GetFhirMosaicTests;
  getFHIRPatientAppointmentsByProvider: GetFhirAppointmentsOutputWithUpcomingCounts;
  getFHIRPatientByFHIRID: GetFhirPatientOutput;
  getFHIRPatientbyCodexID: GetFhirPatientOutput;
  getFHIRPatientbyCodexIDParameter: GetFhirPatientOutput;
  getFHIRPatientbyEmail: GetFhirPatientOutput;
  getFHIRPatientbyMediaCodexIDParameter: GetFhirPatientMediaOutput;
  getFHIRPatientsById: GetFhirPatientsByProviderIdOutput;
  getFHIRProviderBioById: GetFhirProviderBioByIdOutput;
  getFHIRProviderByRequestId: GetFhirProviderByIdOutput;
  getFHIRProviderbyCodexIdArgument: GetProviderBioByIdQueryOutput;
  getFHIRProviderbyEmail: GetFhirProviderByEmailOutput;
  getFHIRProviderbyId: GetFhirProviderByIdOutput;
  getFHIRProviders: GetFhirProvidersOutput;
  getFHIRProvidersByDnaAndZrtTests: GetFhirProvidersByDnaAndZrtTests;
  getFHIRQuestionnaireByCodexID: GetQuestionnaireOutput;
  getFHIRQuestionnaireResponse: GetFhirQuestionnaireResponse;
  getFHIRZrtTestByTestId: GetFhirZrtTest;
  getFHIRZrtTests: GetFhirZrtTests;
  getFilesByRequestUserCodexId: GetMediaFilesOutput;
  getFreeProvidersByTimeSlots: GetFhirProvidersOutput;
  getFullscriptAllergens: FullscriptAllergensOutput;
  getFullscriptAllergensFromQuestionnaireResponse: FullscriptAllergensOutput;
  getGeneralDashboardStats: SaGeneralDashboardStats;
  getInMailDetail: InMailDetailsOutput;
  getInMailUsage: InMailUsageOutput;
  getInvoiceOrReceiptUrl: DownloadInvoiceOrReceiptUrlOutput;
  getLastViewedPatientByProvider: GetLastViewedPatientByUserQueryOutput;
  getLastViewedProvidersByUser: GetLastViewedProvidersByUserQueryOutput;
  getLatestFHIRQuestionnaire: GetFhirQuestionnaireResponse;
  getLatestFHIRQuestionnaireById: GetLatestFhirQuestionnaireByIdResponse;
  getLegalDocument: LegalDocumentOutput;
  getLegalDocuments: LegalDocumentsOutput;
  getMedications: MedicationsOutput;
  getMyBillingPlan: BillingPlan;
  getNotificationsByRequestUserIdWithCounts: GetUserNotificationsWithCounts;
  getOrderById: OrderOutput;
  getOrderRetryPaymentLink: GetPaymentLinkOutput;
  getOrderStats: Array<OrderStatsByDayOutput>;
  getOrders: OrderListOutput;
  getPatientStateAgeOfMajority: AgeOfMajorityOutput;
  getPatients: SaPatients;
  getPaymentMethodList: PaymentMethodsOutput;
  getPaymentStats: Array<PaymentStatsByDayOutput>;
  getPaymentTransactionById: PaymentTransactionOutput;
  getPaymentTransactions: PaymentTransactionListOutput;
  getProductDetails: ProductOutput;
  getProducts: GetProductsOutput;
  getProviderAppointmentRequests: AppointmentRequestsOutput;
  getProviderBilling: ProviderBillingOutput;
  getProviderByPatientId: GetFhirProvidersOutput;
  getProviderPaymentDetails: GetProviderPaymentDetailsOutput;
  getProviderPayoutDetails: GetFhirAppointmentsOutput;
  getProviderPayoutTransactions: ProviderPayoutsOutput;
  getProviderTimezone: ProviderTimezoneOutput;
  getProviders: SaProviders;
  getProvidersByPatientId: GetFhirProviderByIdOutput;
  getReceiptsHistory: ReceiptsHistoryOutput;
  getRecommendationsByRequestPatientCodexId: GetFhirRecommendationsOutput;
  getSessionGrant: FullscriptSessionGrantResult;
  getSubPatientsByParent: SubPatientsOutput;
  getSubscriptionBillingHistory: PaymentTransactionListOutput;
  getSuperAdmins: GetSuperAdminsOutput;
  getSupportChatDetail: SupportChatDetailsOutput;
  getSupportChats: SupportChatsOutput;
  getSwabCodes: SwabCodeListOutput;
  getTestKitDetails: TestKitDetailsOutput;
  getTestKitResultsByRequestPatientCodexId: TestKitResultsOutput;
  getTestKitStats: Array<TestKitStatsByDayOutput>;
  getUnfilledSummariesByRequestProviderId: GetFhirAppointmentsOutput;
  getUserActivityLog: ActivityLogOutput;
  getUserInMailsByRequestId: InMailsOutput;
  getUserRegistrationStats: Array<UserRegistrationStatsByDayOutput>;
  getVerificationRequests: SaVerificationRequests;
  /** execute function "get_appointment_status_counts" which returns "appointment_status_counts" */
  get_appointment_status_counts: Array<Appointment_Status_Counts>;
  /** execute function "get_appointment_status_counts" and query aggregates on result of table type "appointment_status_counts" */
  get_appointment_status_counts_aggregate: Appointment_Status_Counts_Aggregate;
  /** execute function "get_order_status_counts" which returns "order_status_counts" */
  get_order_status_counts: Array<Order_Status_Counts>;
  /** execute function "get_order_status_counts" and query aggregates on result of table type "order_status_counts" */
  get_order_status_counts_aggregate: Order_Status_Counts_Aggregate;
  /** execute function "get_payment_stats_by_day" which returns "payment_stats_by_day" */
  get_payment_stats_by_day: Array<Payment_Stats_By_Day>;
  /** execute function "get_payment_stats_by_day" and query aggregates on result of table type "payment_stats_by_day" */
  get_payment_stats_by_day_aggregate: Payment_Stats_By_Day_Aggregate;
  /** execute function "get_provider_payouts" which returns "provider_payouts" */
  get_provider_payouts: Array<Provider_Payouts>;
  /** execute function "get_provider_payouts" and query aggregates on result of table type "provider_payouts" */
  get_provider_payouts_aggregate: Provider_Payouts_Aggregate;
  /** execute function "get_test_kit_status_counts" which returns "test_kit_status_counts" */
  get_test_kit_status_counts: Array<Test_Kit_Status_Counts>;
  /** execute function "get_test_kit_status_counts" and query aggregates on result of table type "test_kit_status_counts" */
  get_test_kit_status_counts_aggregate: Test_Kit_Status_Counts_Aggregate;
  /** fetch data from the table: "global_configs" */
  global_configs: Array<Global_Configs>;
  /** fetch aggregated fields from the table: "global_configs" */
  global_configs_aggregate: Global_Configs_Aggregate;
  /** fetch data from the table: "global_configs" using primary key columns */
  global_configs_by_pk?: Maybe<Global_Configs>;
  /** fetch data from the table: "global_configs_names" */
  global_configs_names: Array<Global_Configs_Names>;
  /** fetch aggregated fields from the table: "global_configs_names" */
  global_configs_names_aggregate: Global_Configs_Names_Aggregate;
  /** fetch data from the table: "global_configs_names" using primary key columns */
  global_configs_names_by_pk?: Maybe<Global_Configs_Names>;
  health: Scalars['String'];
  /** fetch data from the table: "image_source_types" */
  image_source_types: Array<Image_Source_Types>;
  /** fetch aggregated fields from the table: "image_source_types" */
  image_source_types_aggregate: Image_Source_Types_Aggregate;
  /** fetch data from the table: "image_source_types" using primary key columns */
  image_source_types_by_pk?: Maybe<Image_Source_Types>;
  /** An array relationship */
  in_mail_usage: Array<In_Mail_Usage>;
  /** An aggregate relationship */
  in_mail_usage_aggregate: In_Mail_Usage_Aggregate;
  /** fetch data from the table: "in_mail_usage" using primary key columns */
  in_mail_usage_by_pk?: Maybe<In_Mail_Usage>;
  /** An array relationship */
  invitations: Array<Invitations>;
  /** An aggregate relationship */
  invitations_aggregate: Invitations_Aggregate;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** fetch data from the table: "labs" */
  labs: Array<Labs>;
  /** fetch aggregated fields from the table: "labs" */
  labs_aggregate: Labs_Aggregate;
  /** fetch data from the table: "labs" using primary key columns */
  labs_by_pk?: Maybe<Labs>;
  /** fetch data from the table: "latest_persona_inquiries_per_user" */
  latest_persona_inquiries_per_user: Array<Latest_Persona_Inquiries_Per_User>;
  /** fetch aggregated fields from the table: "latest_persona_inquiries_per_user" */
  latest_persona_inquiries_per_user_aggregate: Latest_Persona_Inquiries_Per_User_Aggregate;
  /** fetch data from the table: "legal_document_types" */
  legal_document_types: Array<Legal_Document_Types>;
  /** fetch aggregated fields from the table: "legal_document_types" */
  legal_document_types_aggregate: Legal_Document_Types_Aggregate;
  /** fetch data from the table: "legal_document_types" using primary key columns */
  legal_document_types_by_pk?: Maybe<Legal_Document_Types>;
  /** An array relationship */
  legal_document_update_notifications: Array<Legal_Document_Update_Notifications>;
  /** An aggregate relationship */
  legal_document_update_notifications_aggregate: Legal_Document_Update_Notifications_Aggregate;
  /** fetch data from the table: "legal_document_update_notifications" using primary key columns */
  legal_document_update_notifications_by_pk?: Maybe<Legal_Document_Update_Notifications>;
  /** fetch data from the table: "legal_documents" */
  legal_documents: Array<Legal_Documents>;
  /** fetch aggregated fields from the table: "legal_documents" */
  legal_documents_aggregate: Legal_Documents_Aggregate;
  /** fetch data from the table: "legal_documents" using primary key columns */
  legal_documents_by_pk?: Maybe<Legal_Documents>;
  /** fetch data from the table: "medical_schools" */
  medical_schools: Array<Medical_Schools>;
  /** fetch aggregated fields from the table: "medical_schools" */
  medical_schools_aggregate: Medical_Schools_Aggregate;
  /** fetch data from the table: "medical_schools" using primary key columns */
  medical_schools_by_pk?: Maybe<Medical_Schools>;
  /** fetch data from the table: "medications" */
  medications: Array<Medications>;
  /** fetch aggregated fields from the table: "medications" */
  medications_aggregate: Medications_Aggregate;
  /** fetch data from the table: "medications" using primary key columns */
  medications_by_pk?: Maybe<Medications>;
  /** fetch data from the table: "medications_unique" */
  medications_unique: Array<Medications_Unique>;
  /** fetch aggregated fields from the table: "medications_unique" */
  medications_unique_aggregate: Medications_Unique_Aggregate;
  /** fetch data from the table: "molecular_tests" */
  molecular_tests: Array<Molecular_Tests>;
  /** fetch aggregated fields from the table: "molecular_tests" */
  molecular_tests_aggregate: Molecular_Tests_Aggregate;
  /** fetch data from the table: "molecular_tests" using primary key columns */
  molecular_tests_by_pk?: Maybe<Molecular_Tests>;
  /** fetch data from the table: "mosaic_tests" */
  mosaic_tests: Array<Mosaic_Tests>;
  /** fetch aggregated fields from the table: "mosaic_tests" */
  mosaic_tests_aggregate: Mosaic_Tests_Aggregate;
  /** fetch data from the table: "mosaic_tests" using primary key columns */
  mosaic_tests_by_pk?: Maybe<Mosaic_Tests>;
  /** fetch data from the table: "nabla_notes" */
  nabla_notes: Array<Nabla_Notes>;
  /** fetch aggregated fields from the table: "nabla_notes" */
  nabla_notes_aggregate: Nabla_Notes_Aggregate;
  /** fetch data from the table: "nabla_notes" using primary key columns */
  nabla_notes_by_pk?: Maybe<Nabla_Notes>;
  notificationPreferences: NotificationPreferencesOutput;
  /** fetch data from the table: "npi_registry_data" */
  npi_registry_data: Array<Npi_Registry_Data>;
  /** fetch aggregated fields from the table: "npi_registry_data" */
  npi_registry_data_aggregate: Npi_Registry_Data_Aggregate;
  /** fetch data from the table: "npi_registry_data" using primary key columns */
  npi_registry_data_by_pk?: Maybe<Npi_Registry_Data>;
  /** An array relationship */
  order_payments: Array<Order_Payments>;
  /** An aggregate relationship */
  order_payments_aggregate: Order_Payments_Aggregate;
  /** fetch data from the table: "order_payments" using primary key columns */
  order_payments_by_pk?: Maybe<Order_Payments>;
  /** An array relationship */
  order_products: Array<Order_Products>;
  /** An aggregate relationship */
  order_products_aggregate: Order_Products_Aggregate;
  /** fetch data from the table: "order_products" using primary key columns */
  order_products_by_pk?: Maybe<Order_Products>;
  /** fetch data from the table: "order_status_counts" */
  order_status_counts: Array<Order_Status_Counts>;
  /** fetch aggregated fields from the table: "order_status_counts" */
  order_status_counts_aggregate: Order_Status_Counts_Aggregate;
  /** fetch data from the table: "order_status_history" */
  order_status_history: Array<Order_Status_History>;
  /** fetch aggregated fields from the table: "order_status_history" */
  order_status_history_aggregate: Order_Status_History_Aggregate;
  /** fetch data from the table: "order_status_history" using primary key columns */
  order_status_history_by_pk?: Maybe<Order_Status_History>;
  /** fetch data from the table: "orders" */
  orders: Array<Orders>;
  /** fetch aggregated fields from the table: "orders" */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table: "orders_view" */
  orders_view: Array<Orders_View>;
  /** fetch aggregated fields from the table: "orders_view" */
  orders_view_aggregate: Orders_View_Aggregate;
  /** fetch data from the table: "patient_achievement_events" */
  patient_achievement_events: Array<Patient_Achievement_Events>;
  /** fetch aggregated fields from the table: "patient_achievement_events" */
  patient_achievement_events_aggregate: Patient_Achievement_Events_Aggregate;
  /** fetch data from the table: "patient_achievement_events" using primary key columns */
  patient_achievement_events_by_pk?: Maybe<Patient_Achievement_Events>;
  /** fetch data from the table: "patient_achievement_progress" */
  patient_achievement_progress: Array<Patient_Achievement_Progress>;
  /** fetch aggregated fields from the table: "patient_achievement_progress" */
  patient_achievement_progress_aggregate: Patient_Achievement_Progress_Aggregate;
  /** fetch data from the table: "patient_achievement_progress" using primary key columns */
  patient_achievement_progress_by_pk?: Maybe<Patient_Achievement_Progress>;
  /** fetch data from the table: "patient_achievement_unlocks" */
  patient_achievement_unlocks: Array<Patient_Achievement_Unlocks>;
  /** fetch aggregated fields from the table: "patient_achievement_unlocks" */
  patient_achievement_unlocks_aggregate: Patient_Achievement_Unlocks_Aggregate;
  /** fetch data from the table: "patient_achievement_unlocks" using primary key columns */
  patient_achievement_unlocks_by_pk?: Maybe<Patient_Achievement_Unlocks>;
  /** fetch data from the table: "payment_stats_by_day" */
  payment_stats_by_day: Array<Payment_Stats_By_Day>;
  /** fetch aggregated fields from the table: "payment_stats_by_day" */
  payment_stats_by_day_aggregate: Payment_Stats_By_Day_Aggregate;
  /** An array relationship */
  payment_transaction_orders: Array<Payment_Transaction_Orders>;
  /** An aggregate relationship */
  payment_transaction_orders_aggregate: Payment_Transaction_Orders_Aggregate;
  /** fetch data from the table: "payment_transaction_orders" using primary key columns */
  payment_transaction_orders_by_pk?: Maybe<Payment_Transaction_Orders>;
  /** An array relationship */
  payment_transactions: Array<Payment_Transactions>;
  /** An aggregate relationship */
  payment_transactions_aggregate: Payment_Transactions_Aggregate;
  /** fetch data from the table: "payment_transactions" using primary key columns */
  payment_transactions_by_pk?: Maybe<Payment_Transactions>;
  /** fetch data from the table: "pending_patient_zrt" */
  pending_patient_zrt: Array<Pending_Patient_Zrt>;
  /** fetch aggregated fields from the table: "pending_patient_zrt" */
  pending_patient_zrt_aggregate: Pending_Patient_Zrt_Aggregate;
  /** fetch data from the table: "pending_patient_zrt" using primary key columns */
  pending_patient_zrt_by_pk?: Maybe<Pending_Patient_Zrt>;
  /** fetch data from the table: "persona_inquiries" */
  persona_inquiries: Array<Persona_Inquiries>;
  /** fetch aggregated fields from the table: "persona_inquiries" */
  persona_inquiries_aggregate: Persona_Inquiries_Aggregate;
  /** fetch data from the table: "persona_inquiries" using primary key columns */
  persona_inquiries_by_pk?: Maybe<Persona_Inquiries>;
  /** fetch data from the table: "persona_inquiry_status" */
  persona_inquiry_status: Array<Persona_Inquiry_Status>;
  /** fetch aggregated fields from the table: "persona_inquiry_status" */
  persona_inquiry_status_aggregate: Persona_Inquiry_Status_Aggregate;
  /** fetch data from the table: "persona_inquiry_status" using primary key columns */
  persona_inquiry_status_by_pk?: Maybe<Persona_Inquiry_Status>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "provider_billing" */
  provider_billing: Array<Provider_Billing>;
  /** fetch aggregated fields from the table: "provider_billing" */
  provider_billing_aggregate: Provider_Billing_Aggregate;
  /** fetch data from the table: "provider_billing" using primary key columns */
  provider_billing_by_pk?: Maybe<Provider_Billing>;
  /** An array relationship */
  provider_dea_licenses: Array<Provider_Dea_Licenses>;
  /** An aggregate relationship */
  provider_dea_licenses_aggregate: Provider_Dea_Licenses_Aggregate;
  /** fetch data from the table: "provider_dea_licenses" using primary key columns */
  provider_dea_licenses_by_pk?: Maybe<Provider_Dea_Licenses>;
  /** fetch data from the table: "provider_payments" */
  provider_payments: Array<Provider_Payments>;
  /** fetch aggregated fields from the table: "provider_payments" */
  provider_payments_aggregate: Provider_Payments_Aggregate;
  /** fetch data from the table: "provider_payments" using primary key columns */
  provider_payments_by_pk?: Maybe<Provider_Payments>;
  /** fetch data from the table: "provider_payouts" */
  provider_payouts: Array<Provider_Payouts>;
  /** fetch aggregated fields from the table: "provider_payouts" */
  provider_payouts_aggregate: Provider_Payouts_Aggregate;
  /** An array relationship */
  provider_state_licenses: Array<Provider_State_Licenses>;
  /** An aggregate relationship */
  provider_state_licenses_aggregate: Provider_State_Licenses_Aggregate;
  /** fetch data from the table: "provider_state_licenses" using primary key columns */
  provider_state_licenses_by_pk?: Maybe<Provider_State_Licenses>;
  /** fetch data from the table: "provider_unread_external_notification_counts" */
  provider_unread_external_notification_counts: Array<Provider_Unread_External_Notification_Counts>;
  /** fetch aggregated fields from the table: "provider_unread_external_notification_counts" */
  provider_unread_external_notification_counts_aggregate: Provider_Unread_External_Notification_Counts_Aggregate;
  /** fetch data from the table: "provider_unread_external_notification_counts" using primary key columns */
  provider_unread_external_notification_counts_by_pk?: Maybe<Provider_Unread_External_Notification_Counts>;
  /** fetch data from the table: "question_measurement_units" */
  question_measurement_units: Array<Question_Measurement_Units>;
  /** fetch aggregated fields from the table: "question_measurement_units" */
  question_measurement_units_aggregate: Question_Measurement_Units_Aggregate;
  /** fetch data from the table: "question_measurement_units" using primary key columns */
  question_measurement_units_by_pk?: Maybe<Question_Measurement_Units>;
  /** fetch data from the table: "question_types" */
  question_types: Array<Question_Types>;
  /** fetch aggregated fields from the table: "question_types" */
  question_types_aggregate: Question_Types_Aggregate;
  /** fetch data from the table: "question_types" using primary key columns */
  question_types_by_pk?: Maybe<Question_Types>;
  /** fetch data from the table: "question_ui_control_helper_text_position" */
  question_ui_control_helper_text_position: Array<Question_Ui_Control_Helper_Text_Position>;
  /** fetch aggregated fields from the table: "question_ui_control_helper_text_position" */
  question_ui_control_helper_text_position_aggregate: Question_Ui_Control_Helper_Text_Position_Aggregate;
  /** fetch data from the table: "question_ui_control_helper_text_position" using primary key columns */
  question_ui_control_helper_text_position_by_pk?: Maybe<Question_Ui_Control_Helper_Text_Position>;
  /** fetch data from the table: "question_ui_control_types" */
  question_ui_control_types: Array<Question_Ui_Control_Types>;
  /** fetch aggregated fields from the table: "question_ui_control_types" */
  question_ui_control_types_aggregate: Question_Ui_Control_Types_Aggregate;
  /** fetch data from the table: "question_ui_control_types" using primary key columns */
  question_ui_control_types_by_pk?: Maybe<Question_Ui_Control_Types>;
  /** fetch data from the table: "questionnaire_questions" */
  questionnaire_questions: Array<Questionnaire_Questions>;
  /** fetch aggregated fields from the table: "questionnaire_questions" */
  questionnaire_questions_aggregate: Questionnaire_Questions_Aggregate;
  /** fetch data from the table: "questionnaire_questions" using primary key columns */
  questionnaire_questions_by_pk?: Maybe<Questionnaire_Questions>;
  /** fetch data from the table: "questionnaire_reminders" */
  questionnaire_reminders: Array<Questionnaire_Reminders>;
  /** fetch aggregated fields from the table: "questionnaire_reminders" */
  questionnaire_reminders_aggregate: Questionnaire_Reminders_Aggregate;
  /** fetch data from the table: "questionnaire_reminders" using primary key columns */
  questionnaire_reminders_by_pk?: Maybe<Questionnaire_Reminders>;
  /** fetch data from the table: "questionnaire_responses" */
  questionnaire_responses: Array<Questionnaire_Responses>;
  /** fetch aggregated fields from the table: "questionnaire_responses" */
  questionnaire_responses_aggregate: Questionnaire_Responses_Aggregate;
  /** fetch data from the table: "questionnaire_responses" using primary key columns */
  questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** fetch data from the table: "questionnaires" */
  questionnaires: Array<Questionnaires>;
  /** fetch aggregated fields from the table: "questionnaires" */
  questionnaires_aggregate: Questionnaires_Aggregate;
  /** fetch data from the table: "questionnaires" using primary key columns */
  questionnaires_by_pk?: Maybe<Questionnaires>;
  /** fetch data from the table: "questions" */
  questions: Array<Questions>;
  /** fetch aggregated fields from the table: "questions" */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table: "recommendations" */
  recommendations: Array<Recommendations>;
  /** fetch aggregated fields from the table: "recommendations" */
  recommendations_aggregate: Recommendations_Aggregate;
  /** fetch data from the table: "recommendations" using primary key columns */
  recommendations_by_pk?: Maybe<Recommendations>;
  /** fetch data from the table: "shipmonk_sync_metadata" */
  shipmonk_sync_metadata: Array<Shipmonk_Sync_Metadata>;
  /** fetch aggregated fields from the table: "shipmonk_sync_metadata" */
  shipmonk_sync_metadata_aggregate: Shipmonk_Sync_Metadata_Aggregate;
  /** fetch data from the table: "shipmonk_sync_metadata" using primary key columns */
  shipmonk_sync_metadata_by_pk?: Maybe<Shipmonk_Sync_Metadata>;
  /** fetch data from the table: "skintelligent_tests" */
  skintelligent_tests: Array<Skintelligent_Tests>;
  /** fetch aggregated fields from the table: "skintelligent_tests" */
  skintelligent_tests_aggregate: Skintelligent_Tests_Aggregate;
  /** fetch data from the table: "skintelligent_tests" using primary key columns */
  skintelligent_tests_by_pk?: Maybe<Skintelligent_Tests>;
  /** fetch data from the table: "stripe_billing_plans" */
  stripe_billing_plans: Array<Stripe_Billing_Plans>;
  /** fetch aggregated fields from the table: "stripe_billing_plans" */
  stripe_billing_plans_aggregate: Stripe_Billing_Plans_Aggregate;
  /** fetch data from the table: "stripe_billing_plans" using primary key columns */
  stripe_billing_plans_by_pk?: Maybe<Stripe_Billing_Plans>;
  /** An array relationship */
  stripe_customers: Array<Stripe_Customers>;
  /** An aggregate relationship */
  stripe_customers_aggregate: Stripe_Customers_Aggregate;
  /** fetch data from the table: "stripe_customers" using primary key columns */
  stripe_customers_by_pk?: Maybe<Stripe_Customers>;
  /** fetch data from the table: "stripe_latest_subscription_per_user_view" */
  stripe_latest_subscription_per_user_view: Array<Stripe_Latest_Subscription_Per_User_View>;
  /** fetch aggregated fields from the table: "stripe_latest_subscription_per_user_view" */
  stripe_latest_subscription_per_user_view_aggregate: Stripe_Latest_Subscription_Per_User_View_Aggregate;
  /** fetch data from the table: "stripe_payment_intents" */
  stripe_payment_intents: Array<Stripe_Payment_Intents>;
  /** fetch aggregated fields from the table: "stripe_payment_intents" */
  stripe_payment_intents_aggregate: Stripe_Payment_Intents_Aggregate;
  /** fetch data from the table: "stripe_payment_intents" using primary key columns */
  stripe_payment_intents_by_pk?: Maybe<Stripe_Payment_Intents>;
  /** An array relationship */
  stripe_payment_methods: Array<Stripe_Payment_Methods>;
  /** An aggregate relationship */
  stripe_payment_methods_aggregate: Stripe_Payment_Methods_Aggregate;
  /** fetch data from the table: "stripe_payment_methods" using primary key columns */
  stripe_payment_methods_by_pk?: Maybe<Stripe_Payment_Methods>;
  /** An array relationship */
  stripe_subscriptions: Array<Stripe_Subscriptions>;
  /** An aggregate relationship */
  stripe_subscriptions_aggregate: Stripe_Subscriptions_Aggregate;
  /** fetch data from the table: "stripe_subscriptions" using primary key columns */
  stripe_subscriptions_by_pk?: Maybe<Stripe_Subscriptions>;
  /** fetch data from the table: "stripe_transaction" */
  stripe_transaction: Array<Stripe_Transaction>;
  /** fetch aggregated fields from the table: "stripe_transaction" */
  stripe_transaction_aggregate: Stripe_Transaction_Aggregate;
  /** fetch data from the table: "stripe_transaction" using primary key columns */
  stripe_transaction_by_pk?: Maybe<Stripe_Transaction>;
  /** An array relationship */
  support_chat_usage: Array<Support_Chat_Usage>;
  /** An aggregate relationship */
  support_chat_usage_aggregate: Support_Chat_Usage_Aggregate;
  /** fetch data from the table: "support_chat_usage" using primary key columns */
  support_chat_usage_by_pk?: Maybe<Support_Chat_Usage>;
  /** fetch data from the table: "swab_code_statuses" */
  swab_code_statuses: Array<Swab_Code_Statuses>;
  /** fetch aggregated fields from the table: "swab_code_statuses" */
  swab_code_statuses_aggregate: Swab_Code_Statuses_Aggregate;
  /** fetch data from the table: "swab_code_statuses" using primary key columns */
  swab_code_statuses_by_pk?: Maybe<Swab_Code_Statuses>;
  /** fetch data from the table: "swab_codes" */
  swab_codes: Array<Swab_Codes>;
  /** fetch aggregated fields from the table: "swab_codes" */
  swab_codes_aggregate: Swab_Codes_Aggregate;
  /** fetch data from the table: "swab_codes" using primary key columns */
  swab_codes_by_pk?: Maybe<Swab_Codes>;
  /** fetch data from the table: "swab_usage_type" */
  swab_usage_type: Array<Swab_Usage_Type>;
  /** fetch aggregated fields from the table: "swab_usage_type" */
  swab_usage_type_aggregate: Swab_Usage_Type_Aggregate;
  /** fetch data from the table: "swab_usage_type" using primary key columns */
  swab_usage_type_by_pk?: Maybe<Swab_Usage_Type>;
  /** fetch data from the table: "test_definitions" */
  test_definitions: Array<Test_Definitions>;
  /** fetch aggregated fields from the table: "test_definitions" */
  test_definitions_aggregate: Test_Definitions_Aggregate;
  /** fetch data from the table: "test_definitions" using primary key columns */
  test_definitions_by_pk?: Maybe<Test_Definitions>;
  /** fetch data from the table: "test_e_prescribe_npis" */
  test_e_prescribe_npis: Array<Test_E_Prescribe_Npis>;
  /** fetch aggregated fields from the table: "test_e_prescribe_npis" */
  test_e_prescribe_npis_aggregate: Test_E_Prescribe_Npis_Aggregate;
  /** fetch data from the table: "test_e_prescribe_npis" using primary key columns */
  test_e_prescribe_npis_by_pk?: Maybe<Test_E_Prescribe_Npis>;
  /** fetch data from the table: "test_kit_status_counts" */
  test_kit_status_counts: Array<Test_Kit_Status_Counts>;
  /** fetch aggregated fields from the table: "test_kit_status_counts" */
  test_kit_status_counts_aggregate: Test_Kit_Status_Counts_Aggregate;
  /** fetch data from the table: "test_kits_update_states_summary_log" */
  test_kits_update_states_summary_log: Array<Test_Kits_Update_States_Summary_Log>;
  /** fetch aggregated fields from the table: "test_kits_update_states_summary_log" */
  test_kits_update_states_summary_log_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  /** fetch data from the table: "test_kits_update_states_summary_log" using primary key columns */
  test_kits_update_states_summary_log_by_pk?: Maybe<Test_Kits_Update_States_Summary_Log>;
  /** fetch data from the table: "test_types" */
  test_types: Array<Test_Types>;
  /** fetch aggregated fields from the table: "test_types" */
  test_types_aggregate: Test_Types_Aggregate;
  /** fetch data from the table: "test_types" using primary key columns */
  test_types_by_pk?: Maybe<Test_Types>;
  /** fetch data from the table: "tests" */
  tests: Array<Tests>;
  /** fetch aggregated fields from the table: "tests" */
  tests_aggregate: Tests_Aggregate;
  /** fetch data from the table: "tests" using primary key columns */
  tests_by_pk?: Maybe<Tests>;
  /** fetch data from the table: "text_addresses" */
  text_addresses: Array<Text_Addresses>;
  /** fetch aggregated fields from the table: "text_addresses" */
  text_addresses_aggregate: Text_Addresses_Aggregate;
  /** fetch data from the table: "text_addresses" using primary key columns */
  text_addresses_by_pk?: Maybe<Text_Addresses>;
  /** An array relationship */
  unauthenticated_questionnaire_questions: Array<Unauthenticated_Questionnaire_Questions>;
  /** An aggregate relationship */
  unauthenticated_questionnaire_questions_aggregate: Unauthenticated_Questionnaire_Questions_Aggregate;
  /** fetch data from the table: "unauthenticated_questionnaire_questions" using primary key columns */
  unauthenticated_questionnaire_questions_by_pk?: Maybe<Unauthenticated_Questionnaire_Questions>;
  /** fetch data from the table: "unauthenticated_questionnaires" */
  unauthenticated_questionnaires: Array<Unauthenticated_Questionnaires>;
  /** fetch aggregated fields from the table: "unauthenticated_questionnaires" */
  unauthenticated_questionnaires_aggregate: Unauthenticated_Questionnaires_Aggregate;
  /** fetch data from the table: "unauthenticated_questionnaires" using primary key columns */
  unauthenticated_questionnaires_by_pk?: Maybe<Unauthenticated_Questionnaires>;
  /** fetch data from the table: "unauthenticated_questions" */
  unauthenticated_questions: Array<Unauthenticated_Questions>;
  /** fetch aggregated fields from the table: "unauthenticated_questions" */
  unauthenticated_questions_aggregate: Unauthenticated_Questions_Aggregate;
  /** fetch data from the table: "unauthenticated_questions" using primary key columns */
  unauthenticated_questions_by_pk?: Maybe<Unauthenticated_Questions>;
  /** fetch data from the table: "universities" */
  universities: Array<Universities>;
  /** fetch aggregated fields from the table: "universities" */
  universities_aggregate: Universities_Aggregate;
  /** fetch data from the table: "universities" using primary key columns */
  universities_by_pk?: Maybe<Universities>;
  updateAppointmentSummaryNotificationState: HttpStatusOutput;
  /** fetch data from the table: "used_test_e_prescribe_licenses" */
  used_test_e_prescribe_licenses: Array<Used_Test_E_Prescribe_Licenses>;
  /** fetch aggregated fields from the table: "used_test_e_prescribe_licenses" */
  used_test_e_prescribe_licenses_aggregate: Used_Test_E_Prescribe_Licenses_Aggregate;
  /** fetch data from the table: "used_test_e_prescribe_licenses" using primary key columns */
  used_test_e_prescribe_licenses_by_pk?: Maybe<Used_Test_E_Prescribe_Licenses>;
  /** fetch data from the table: "user_addresses" */
  user_addresses: Array<User_Addresses>;
  /** fetch aggregated fields from the table: "user_addresses" */
  user_addresses_aggregate: User_Addresses_Aggregate;
  /** fetch data from the table: "user_addresses" using primary key columns */
  user_addresses_by_pk?: Maybe<User_Addresses>;
  /** An array relationship */
  user_agreements: Array<User_Agreements>;
  /** An aggregate relationship */
  user_agreements_aggregate: User_Agreements_Aggregate;
  /** fetch data from the table: "user_agreements" using primary key columns */
  user_agreements_by_pk?: Maybe<User_Agreements>;
  /** fetch data from the table: "user_auth_provider_types" */
  user_auth_provider_types: Array<User_Auth_Provider_Types>;
  /** fetch aggregated fields from the table: "user_auth_provider_types" */
  user_auth_provider_types_aggregate: User_Auth_Provider_Types_Aggregate;
  /** fetch data from the table: "user_auth_provider_types" using primary key columns */
  user_auth_provider_types_by_pk?: Maybe<User_Auth_Provider_Types>;
  /** fetch data from the table: "user_auth_providers" */
  user_auth_providers: Array<User_Auth_Providers>;
  /** fetch aggregated fields from the table: "user_auth_providers" */
  user_auth_providers_aggregate: User_Auth_Providers_Aggregate;
  /** fetch data from the table: "user_auth_providers" using primary key columns */
  user_auth_providers_by_pk?: Maybe<User_Auth_Providers>;
  /** fetch data from the table: "user_auth_tokens" */
  user_auth_tokens: Array<User_Auth_Tokens>;
  /** fetch aggregated fields from the table: "user_auth_tokens" */
  user_auth_tokens_aggregate: User_Auth_Tokens_Aggregate;
  /** fetch data from the table: "user_auth_tokens" using primary key columns */
  user_auth_tokens_by_pk?: Maybe<User_Auth_Tokens>;
  /** An array relationship */
  user_communication_deliveries: Array<User_Communication_Deliveries>;
  /** An aggregate relationship */
  user_communication_deliveries_aggregate: User_Communication_Deliveries_Aggregate;
  /** fetch data from the table: "user_communication_deliveries" using primary key columns */
  user_communication_deliveries_by_pk?: Maybe<User_Communication_Deliveries>;
  /** fetch data from the table: "user_communications" */
  user_communications: Array<User_Communications>;
  /** fetch aggregated fields from the table: "user_communications" */
  user_communications_aggregate: User_Communications_Aggregate;
  /** fetch data from the table: "user_communications" using primary key columns */
  user_communications_by_pk?: Maybe<User_Communications>;
  /** fetch data from the table: "user_indicators" */
  user_indicators: Array<User_Indicators>;
  /** fetch aggregated fields from the table: "user_indicators" */
  user_indicators_aggregate: User_Indicators_Aggregate;
  /** fetch data from the table: "user_indicators" using primary key columns */
  user_indicators_by_pk?: Maybe<User_Indicators>;
  /** fetch data from the table: "user_notification_status" */
  user_notification_status: Array<User_Notification_Status>;
  /** fetch aggregated fields from the table: "user_notification_status" */
  user_notification_status_aggregate: User_Notification_Status_Aggregate;
  /** fetch data from the table: "user_notification_status" using primary key columns */
  user_notification_status_by_pk?: Maybe<User_Notification_Status>;
  /** fetch data from the table: "user_notifications" */
  user_notifications: Array<User_Notifications>;
  /** fetch aggregated fields from the table: "user_notifications" */
  user_notifications_aggregate: User_Notifications_Aggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  user_notifications_by_pk?: Maybe<User_Notifications>;
  /** An array relationship */
  user_push_tokens: Array<User_Push_Tokens>;
  /** An aggregate relationship */
  user_push_tokens_aggregate: User_Push_Tokens_Aggregate;
  /** fetch data from the table: "user_push_tokens" using primary key columns */
  user_push_tokens_by_pk?: Maybe<User_Push_Tokens>;
  /** fetch data from the table: "user_scanned_data" */
  user_scanned_data: Array<User_Scanned_Data>;
  /** fetch aggregated fields from the table: "user_scanned_data" */
  user_scanned_data_aggregate: User_Scanned_Data_Aggregate;
  /** fetch data from the table: "user_scanned_data" using primary key columns */
  user_scanned_data_by_pk?: Maybe<User_Scanned_Data>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  validateChildAdultTransitionInvitationToken: ValidateChildAdultTransitionInvitationTokenOutput;
  validateDelegatedAdminInvitationToken: ValidateDelegatedAdminInvitationTokenOutput;
  /** fetch data from the table: "vonage_appointment" */
  vonage_appointment: Array<Vonage_Appointment>;
  /** fetch aggregated fields from the table: "vonage_appointment" */
  vonage_appointment_aggregate: Vonage_Appointment_Aggregate;
  /** fetch data from the table: "vonage_appointment" using primary key columns */
  vonage_appointment_by_pk?: Maybe<Vonage_Appointment>;
  /** fetch data from the table: "zrt_tests" */
  zrt_tests: Array<Zrt_Tests>;
  /** fetch aggregated fields from the table: "zrt_tests" */
  zrt_tests_aggregate: Zrt_Tests_Aggregate;
  /** fetch data from the table: "zrt_tests" using primary key columns */
  zrt_tests_by_pk?: Maybe<Zrt_Tests>;
};


export type Query_RootCreateKitIdsDiagnosticSolutionsArgs = {
  count?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetProviderAvailabilityMonthDatesArgs = {
  appointmentTypeId: Scalars['String'];
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  month: Scalars['String'];
  providerCalendarId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetProviderAvailabilityServiceTypesArgs = {
  providerCalendarId: Scalars['String'];
};


export type Query_RootGetProviderAvailabilityTimeSlotsArgs = {
  appointmentTypeId: Scalars['String'];
  date: Scalars['String'];
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  providerCalendarId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetProviderTimeSlotsArgs = {
  date: Scalars['String'];
  providerCalendarId: Scalars['String'];
};


export type Query_RootGetSignUrlFromStorageForRequesterArgs = {
  fileId: Scalars['String'];
  requestedUserId: Scalars['String'];
};


export type Query_RootGetSwabCodeValidBySwabcodeArgs = {
  swabcode: Scalars['String'];
};


export type Query_RootValidateFedexTrackingNumberArgs = {
  trackingNumber: Scalars['String'];
};


export type Query_RootValidateKitIdDiagnosticSolutionsArgs = {
  kitId?: InputMaybe<Scalars['Int']>;
};


export type Query_RootValidateKitIdMolecularLabsArgs = {
  kitId?: InputMaybe<Scalars['String']>;
};


export type Query_RootValidateNpiNumberArgs = {
  npiNumber?: InputMaybe<Scalars['String']>;
};


export type Query_RootAccepted_Legal_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accepted_Legal_Documents_Order_By>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


export type Query_RootAccepted_Legal_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accepted_Legal_Documents_Order_By>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


export type Query_RootAccepted_Legal_Documents_By_PkArgs = {
  accepted_legal_document_id: Scalars['bigint'];
};


export type Query_RootActive_In_MailsArgs = {
  distinct_on?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_In_Mails_Order_By>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


export type Query_RootActive_In_Mails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_In_Mails_Order_By>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


export type Query_RootActive_In_Mails_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootActive_Support_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Support_Chats_Order_By>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


export type Query_RootActive_Support_Chats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Support_Chats_Order_By>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


export type Query_RootActive_Support_Chats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootActivity_EventsArgs = {
  distinct_on?: InputMaybe<Array<Activity_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Events_Order_By>>;
  where?: InputMaybe<Activity_Events_Bool_Exp>;
};


export type Query_RootActivity_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Events_Order_By>>;
  where?: InputMaybe<Activity_Events_Bool_Exp>;
};


export type Query_RootActivity_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAcuity_Provider_CalendarArgs = {
  distinct_on?: InputMaybe<Array<Acuity_Provider_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acuity_Provider_Calendar_Order_By>>;
  where?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
};


export type Query_RootAcuity_Provider_Calendar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acuity_Provider_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acuity_Provider_Calendar_Order_By>>;
  where?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
};


export type Query_RootAcuity_Provider_Calendar_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_By_PkArgs = {
  address_id: Scalars['uuid'];
};


export type Query_RootAdmin_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Admin_Permissions_Order_By>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


export type Query_RootAdmin_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Admin_Permissions_Order_By>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


export type Query_RootAdmin_Permissions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootAge_Of_Majority_RulesArgs = {
  distinct_on?: InputMaybe<Array<Age_Of_Majority_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Age_Of_Majority_Rules_Order_By>>;
  where?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
};


export type Query_RootAge_Of_Majority_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Age_Of_Majority_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Age_Of_Majority_Rules_Order_By>>;
  where?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
};


export type Query_RootAge_Of_Majority_Rules_By_PkArgs = {
  state_code: Scalars['bpchar'];
};


export type Query_RootAllergen_ClassesArgs = {
  distinct_on?: InputMaybe<Array<Allergen_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Allergen_Classes_Order_By>>;
  where?: InputMaybe<Allergen_Classes_Bool_Exp>;
};


export type Query_RootAllergen_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Allergen_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Allergen_Classes_Order_By>>;
  where?: InputMaybe<Allergen_Classes_Bool_Exp>;
};


export type Query_RootAllergen_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootApp_ToursArgs = {
  distinct_on?: InputMaybe<Array<App_Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Tours_Order_By>>;
  where?: InputMaybe<App_Tours_Bool_Exp>;
};


export type Query_RootApp_Tours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Tours_Order_By>>;
  where?: InputMaybe<App_Tours_Bool_Exp>;
};


export type Query_RootApp_Tours_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootApp_VersionsArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Query_RootApp_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Query_RootApp_Versions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAppointment_Media_SignalsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Media_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Media_Signals_Order_By>>;
  where?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
};


export type Query_RootAppointment_Media_Signals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Media_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Media_Signals_Order_By>>;
  where?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
};


export type Query_RootAppointment_Media_Signals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAppointment_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Payments_Order_By>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


export type Query_RootAppointment_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Payments_Order_By>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


export type Query_RootAppointment_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAppointment_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Requests_Order_By>>;
  where?: InputMaybe<Appointment_Requests_Bool_Exp>;
};


export type Query_RootAppointment_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Requests_Order_By>>;
  where?: InputMaybe<Appointment_Requests_Bool_Exp>;
};


export type Query_RootAppointment_Requests_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAppointment_Status_CountsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Query_RootAppointment_Status_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Query_RootAppointment_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_History_Order_By>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


export type Query_RootAppointment_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_History_Order_By>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


export type Query_RootAppointment_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Query_RootAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Query_RootAppointments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCart_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Cart_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cart_Products_Order_By>>;
  where?: InputMaybe<Cart_Products_Bool_Exp>;
};


export type Query_RootCart_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cart_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cart_Products_Order_By>>;
  where?: InputMaybe<Cart_Products_Bool_Exp>;
};


export type Query_RootCart_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootChannel_SignalsArgs = {
  distinct_on?: InputMaybe<Array<Channel_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Signals_Order_By>>;
  where?: InputMaybe<Channel_Signals_Bool_Exp>;
};


export type Query_RootChannel_Signals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Signals_Order_By>>;
  where?: InputMaybe<Channel_Signals_Bool_Exp>;
};


export type Query_RootChannel_Signals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommon_Question_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Common_Question_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Question_Responses_Order_By>>;
  where?: InputMaybe<Common_Question_Responses_Bool_Exp>;
};


export type Query_RootCommon_Question_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Common_Question_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Question_Responses_Order_By>>;
  where?: InputMaybe<Common_Question_Responses_Bool_Exp>;
};


export type Query_RootCommon_Question_Responses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootCommon_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Common_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Questions_Order_By>>;
  where?: InputMaybe<Common_Questions_Bool_Exp>;
};


export type Query_RootCommon_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Common_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Questions_Order_By>>;
  where?: InputMaybe<Common_Questions_Bool_Exp>;
};


export type Query_RootCommon_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCommunication_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Communication_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Channels_Order_By>>;
  where?: InputMaybe<Communication_Channels_Bool_Exp>;
};


export type Query_RootCommunication_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Channels_Order_By>>;
  where?: InputMaybe<Communication_Channels_Bool_Exp>;
};


export type Query_RootCommunication_Channels_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCustom_Auth_CodeArgs = {
  distinct_on?: InputMaybe<Array<Custom_Auth_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Custom_Auth_Code_Order_By>>;
  where?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
};


export type Query_RootCustom_Auth_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Auth_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Custom_Auth_Code_Order_By>>;
  where?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
};


export type Query_RootCustom_Auth_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDea_License_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dea_License_Schedules_Order_By>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};


export type Query_RootDea_License_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dea_License_Schedules_Order_By>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};


export type Query_RootDea_License_Schedules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDelivery_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Addresses_Order_By>>;
  where?: InputMaybe<Delivery_Addresses_Bool_Exp>;
};


export type Query_RootDelivery_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Addresses_Order_By>>;
  where?: InputMaybe<Delivery_Addresses_Bool_Exp>;
};


export type Query_RootDelivery_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDiagnostic_Solution_TestsArgs = {
  distinct_on?: InputMaybe<Array<Diagnostic_Solution_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnostic_Solution_Tests_Order_By>>;
  where?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
};


export type Query_RootDiagnostic_Solution_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Diagnostic_Solution_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnostic_Solution_Tests_Order_By>>;
  where?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
};


export type Query_RootDiagnostic_Solution_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Query_RootDnavisit_Test_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Test_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Test_Statuses_Order_By>>;
  where?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
};


export type Query_RootDnavisit_Test_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Test_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Test_Statuses_Order_By>>;
  where?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
};


export type Query_RootDnavisit_Test_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootDnavisit_TestsArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Tests_Order_By>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


export type Query_RootDnavisit_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Tests_Order_By>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


export type Query_RootDnavisit_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Query_RootDo_Not_Use_Production_Swab_CodesArgs = {
  distinct_on?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Order_By>>;
  where?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
};


export type Query_RootDo_Not_Use_Production_Swab_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Order_By>>;
  where?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
};


export type Query_RootDo_Not_Use_Production_Swab_Codes_By_PkArgs = {
  swab_code: Scalars['String'];
};


export type Query_RootEcommerce_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Orders_Order_By>>;
  where?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
};


export type Query_RootEcommerce_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Orders_Order_By>>;
  where?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
};


export type Query_RootEcommerce_Orders_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEducation_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Education_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Courses_Order_By>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


export type Query_RootEducation_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Courses_Order_By>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


export type Query_RootEducation_Courses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEducation_Module_Additional_MaterialsArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Additional_Materials_Order_By>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


export type Query_RootEducation_Module_Additional_Materials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Additional_Materials_Order_By>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


export type Query_RootEducation_Module_Additional_Materials_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEducation_Module_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


export type Query_RootEducation_Module_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


export type Query_RootEducation_Module_Items_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEducation_ModulesArgs = {
  distinct_on?: InputMaybe<Array<Education_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Modules_Order_By>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};


export type Query_RootEducation_Modules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Modules_Order_By>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};


export type Query_RootEducation_Modules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFile_TypesArgs = {
  distinct_on?: InputMaybe<Array<File_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Types_Order_By>>;
  where?: InputMaybe<File_Types_Bool_Exp>;
};


export type Query_RootFile_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Types_Order_By>>;
  where?: InputMaybe<File_Types_Bool_Exp>;
};


export type Query_RootFile_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFullscriptDependentCreateLinkArgs = {
  input: CreateDependentLinkInput;
};


export type Query_RootFullscript_AllergensArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Allergens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Allergens_Order_By>>;
  where?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
};


export type Query_RootFullscript_Allergens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Allergens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Allergens_Order_By>>;
  where?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
};


export type Query_RootFullscript_Allergens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFullscript_CliniciansArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Clinicians_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Clinicians_Order_By>>;
  where?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
};


export type Query_RootFullscript_Clinicians_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Clinicians_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Clinicians_Order_By>>;
  where?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
};


export type Query_RootFullscript_Clinicians_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGale_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Gale_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gale_Products_Order_By>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};


export type Query_RootGale_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gale_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gale_Products_Order_By>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};


export type Query_RootGale_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGetAccountUsersArgs = {
  isClosed?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootGetActiveRecommendationsByPatientCodexIdArgs = {
  codexPatientId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetFhirRecommendationsOrderByInput>;
};


export type Query_RootGetAllergenClassesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetAppVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetAppointmentDetailsArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentFhirId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetAppointmentMessageByCommunicationFhirIdArgs = {
  communicationFhirId: Scalars['String'];
};


export type Query_RootGetAppointmentMessageListByAppointmentCodexIdArgs = {
  appointmentCodexId: Scalars['String'];
};


export type Query_RootGetAppointmentNotesByAppointmentIdArgs = {
  appointmentCodexId: Scalars['String'];
};


export type Query_RootGetAppointmentRescheduleLinkArgs = {
  appointmentCodexId: Scalars['String'];
};


export type Query_RootGetAppointmentRetryPaymentLinkArgs = {
  appointmentCodexId: Scalars['String'];
};


export type Query_RootGetAppointmentStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetAppointmentSummaryArgs = {
  appointmentCodexId: Scalars['String'];
};


export type Query_RootGetAppointmentsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  narrowing?: InputMaybe<SaNarrowingQueryOptions>;
  orderBy?: InputMaybe<SaAppointmentOrderBy>;
  paging?: InputMaybe<SaPageableQueryOptions>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<AppointmentTypeEnum>>;
};


export type Query_RootGetBecomePatientRequestsArgs = {
  input?: InputMaybe<GetBecomePatientRequestsInput>;
};


export type Query_RootGetCallSettingsArgs = {
  platform: ClientPlatform;
};


export type Query_RootGetDelegatedAdminDetailsArgs = {
  input: DelegatedAdminCodexIdInput;
};


export type Query_RootGetDelegatedAdminsArgs = {
  filters?: InputMaybe<GetDelegatedAdminsInput>;
  orderBy?: InputMaybe<DelegatedAdminOrderByInput>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type Query_RootGetDeliveryAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetDiagnosticReportsArgs = {
  narrowing?: InputMaybe<SaNarrowingQueryOptions>;
  paging?: InputMaybe<SaPageableQueryOptions>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type Query_RootGetDiagnosticReportsByParticipantsArgs = {
  patientCodexId: Scalars['String'];
  providerCodexId: Scalars['String'];
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
};


export type Query_RootGetDiagnosticReportsByPatientArgs = {
  exceptAppointmentCodexId?: InputMaybe<Scalars['String']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
};


export type Query_RootGetDiscountCodeArgs = {
  promoCode: Scalars['String'];
};


export type Query_RootGetDraftTestQuestionnairesByIdArgs = {
  questionnaireId: Scalars['String'];
};


export type Query_RootGetEducationCourseDetailsArgs = {
  id: Scalars['String'];
};


export type Query_RootGetEducationCoursesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type Query_RootGetEducationModulesArgs = {
  filters?: InputMaybe<GetEducationModulesInput>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type Query_RootGetFhirAppointmentByAcuityIdArgs = {
  appointmentAcuityId: Scalars['String'];
};


export type Query_RootGetFhirAppointmentByCodexIdArgs = {
  appointmentCodexId: Scalars['String'];
};


export type Query_RootGetFhirAppointmentByPatientCodexIdArgs = {
  appointmentStatus?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirAppointmentByRequestPatientCodexIdArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  codexProviderId?: InputMaybe<Scalars['String']>;
  dayFilter?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  providerName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
};


export type Query_RootGetFhirAppointmentByRequestProviderIdArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  dayFilter?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  patientName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
};


export type Query_RootGetFhirdPrivderInfoByZrtSwabcodeArgs = {
  getFHIRDPrivderInfoByZrtSwabcode: Scalars['String'];
};


export type Query_RootGetFhirDiagnosticSolutionTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MosaicTestsInput>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirDnaAndZrtTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DiagnosticReportOrderByInput>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirDnaVisitTestByOrderIdArgs = {
  getFHIRDnaVisitTestByOrderId: Scalars['String'];
};


export type Query_RootGetFhirDnaVisitTestBySwabcodeArgs = {
  getFHIRDnaVisitTestBySwabcode: Scalars['String'];
};


export type Query_RootGetFhirDnaVisitTestByTestIdArgs = {
  getFHIRDnaVisitTestByTestId: Scalars['String'];
};


export type Query_RootGetFhirDnaVisitTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DnaVisitOrderByInput>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirDnaVisitTestsByUserIdArgs = {
  codexPatientId?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DnaVisitOrderByInput>;
  providerName?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirEncountersByPatientArgs = {
  finishedAtEnd?: InputMaybe<Scalars['String']>;
  finishedAtStart?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirEncountersByProviderArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  status?: EncounterStatuses;
};


export type Query_RootGetFhirMediaByRequestPatientCodexIdArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirMedicationRequestBranAndNamesByPatientCodexIdArgs = {
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirMedicationRequestByFhirIdArgs = {
  fhirId: Scalars['String'];
};


export type Query_RootGetFhirMedicationRequestByPatientCodexIdArgs = {
  brandAndName?: InputMaybe<Scalars['String']>;
  encounterId?: InputMaybe<Scalars['String']>;
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  includeSubPatients?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Array<MedicationRequestSource>>;
  statuses?: InputMaybe<Array<MedicationRequestStatusEnum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirMosaicTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MosaicTestsInput>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirPatientAppointmentsByProviderArgs = {
  appointmentCodexId?: InputMaybe<Scalars['String']>;
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  dayFilter?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  isSummaryCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  tzOffset?: InputMaybe<Scalars['Float']>;
  withOtherProviders?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootGetFhirPatientByFhiridArgs = {
  fhirId: Scalars['String'];
};


export type Query_RootGetFhirPatientbyCodexIdParameterArgs = {
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirPatientbyEmailArgs = {
  email: Scalars['String'];
};


export type Query_RootGetFhirPatientbyMediaCodexIdParameterArgs = {
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientCodexId: Scalars['String'];
  sort?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirPatientsByIdArgs = {
  dateFilter?: InputMaybe<GetFhirPatientsByIdDateFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetFhirPatientsByIdOrderByInput>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  searchCriteria?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirProviderbyCodexIdArgumentArgs = {
  codexProviderId: Scalars['String'];
};


export type Query_RootGetFhirProviderbyEmailArgs = {
  email: Scalars['String'];
};


export type Query_RootGetFhirProviderbyIdArgs = {
  providerId: Scalars['String'];
};


export type Query_RootGetFhirProvidersArgs = {
  acceptedAppointments?: InputMaybe<Array<Scalars['String']>>;
  gender?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  medicalRole?: InputMaybe<Array<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  serverOfferedRange?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  yearOfExperienceRange?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirProvidersByDnaAndZrtTestsArgs = {
  patientCodexId?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFhirQuestionnaireByCodexIdArgs = {
  questionnaireId: Scalars['Int'];
};


export type Query_RootGetFhirQuestionnaireResponseArgs = {
  codexPatientId: Scalars['String'];
  identifier: Scalars['String'];
  swabCode?: InputMaybe<Scalars['String']>;
  system: Scalars['String'];
};


export type Query_RootGetFhirZrtTestByTestIdArgs = {
  getFHIRZrtTestByTestId: Scalars['String'];
};


export type Query_RootGetFhirZrtTestsArgs = {
  find?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ZrtOrderByInput>;
  provider?: InputMaybe<ProvidersTypes>;
  providerName?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Array<Hasura_Dnavisit_Test_Statuses_Enum>>;
  testType?: InputMaybe<Array<Hasura_Test_Types_Enum>>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFilesByRequestUserCodexIdArgs = {
  input: MediaFilesFilterInput;
};


export type Query_RootGetFreeProvidersByTimeSlotsArgs = {
  input: GetFreeProvidersByTimeSlotsInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetFullscriptAllergensArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetFullscriptAllergensFromQuestionnaireResponseArgs = {
  codexPatientId: Scalars['String'];
  identifier: Scalars['String'];
  system: Scalars['String'];
};


export type Query_RootGetInMailDetailArgs = {
  filter?: InputMaybe<GetInMailDetailInput>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetInvoiceOrReceiptUrlArgs = {
  appointmentId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['Int']>;
  paymentTransactionId?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetLatestFhirQuestionnaireArgs = {
  identifier: Scalars['String'];
  system: Scalars['String'];
};


export type Query_RootGetLatestFhirQuestionnaireByIdArgs = {
  questionnaire_id: Scalars['Int'];
};


export type Query_RootGetLegalDocumentArgs = {
  input: GetLegalDocumentInput;
};


export type Query_RootGetLegalDocumentsArgs = {
  input: GetLegalDocumentsInput;
};


export type Query_RootGetMedicationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetNotificationsByRequestUserIdWithCountsArgs = {
  includeStatuses?: InputMaybe<Array<Scalars['String']>>;
  isImportantUpdate?: InputMaybe<Scalars['Boolean']>;
  isLatestActivity?: InputMaybe<Scalars['Boolean']>;
  isModal?: InputMaybe<Scalars['Boolean']>;
  isToast?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<OrderByDirections>;
};


export type Query_RootGetOrderByIdArgs = {
  id: Scalars['Int'];
};


export type Query_RootGetOrderRetryPaymentLinkArgs = {
  orderId: Scalars['Int'];
};


export type Query_RootGetOrderStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderOrderByInput>;
};


export type Query_RootGetPatientsArgs = {
  filter?: InputMaybe<SaPatientFilterOptions>;
  orderBy?: InputMaybe<SaPatientOrderBy>;
  paging?: InputMaybe<SaPageableQueryOptions>;
};


export type Query_RootGetPaymentStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetPaymentTransactionByIdArgs = {
  id: Scalars['Int'];
};


export type Query_RootGetPaymentTransactionsArgs = {
  filter?: InputMaybe<PaymentTransactionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PaymentTransactionOrderByInput>;
};


export type Query_RootGetProductDetailsArgs = {
  id: Scalars['Int'];
};


export type Query_RootGetProductsArgs = {
  categories?: InputMaybe<Array<Scalars['Int']>>;
  inStock?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetProviderAppointmentRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetProviderPayoutDetailsArgs = {
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  paymentTransactionId?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetProviderPayoutTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetProvidersArgs = {
  filter?: InputMaybe<SaProviderFilterOptions>;
  orderBy?: InputMaybe<SaProviderOrderBy>;
  paging?: InputMaybe<SaPageableQueryOptions>;
};


export type Query_RootGetProvidersByPatientIdArgs = {
  appointmentTypeId?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
  patientCodexId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetReceiptsHistoryArgs = {
  input: ReceiptHistoryInput;
};


export type Query_RootGetRecommendationsByRequestPatientCodexIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GetFhirRecommendationsOrderByInput>;
  statuses?: InputMaybe<Array<ServiceRequestStatus>>;
};


export type Query_RootGetSessionGrantArgs = {
  patientCodexId: Scalars['String'];
};


export type Query_RootGetSubPatientsByParentArgs = {
  isClosed?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootGetSubscriptionBillingHistoryArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetSuperAdminsArgs = {
  filters?: InputMaybe<GetSuperAdminsInput>;
  orderBy?: InputMaybe<SuperAdminOrderByInput>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type Query_RootGetSupportChatDetailArgs = {
  filter?: InputMaybe<GetSupportChatDetailInput>;
  limit?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetSupportChatsArgs = {
  filter?: InputMaybe<GetSupportChatsInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetSwabCodesArgs = {
  filter?: InputMaybe<SwabCodeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetTestKitDetailsArgs = {
  swabcode: Scalars['String'];
};


export type Query_RootGetTestKitResultsByRequestPatientCodexIdArgs = {
  input: TestKitResultsInput;
};


export type Query_RootGetTestKitStatsArgs = {
  filters: TestKitStatsFiltersInput;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetUnfilledSummariesByRequestProviderIdArgs = {
  appointmentStatus?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetUserActivityLogArgs = {
  filters?: InputMaybe<ActivityLogFilterInput>;
  fromDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['String']>;
  userCodexId: Scalars['String'];
};


export type Query_RootGetUserInMailsByRequestIdArgs = {
  filter?: InputMaybe<GetInMailsInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetUserRegistrationStatsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetVerificationRequestsArgs = {
  filter?: InputMaybe<SaVerificationRequestFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SaVerificationRequestOrderBy>;
};


export type Query_RootGet_Appointment_Status_CountsArgs = {
  args?: InputMaybe<Get_Appointment_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Query_RootGet_Appointment_Status_Counts_AggregateArgs = {
  args?: InputMaybe<Get_Appointment_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Query_RootGet_Order_Status_CountsArgs = {
  args?: InputMaybe<Get_Order_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Query_RootGet_Order_Status_Counts_AggregateArgs = {
  args?: InputMaybe<Get_Order_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Query_RootGet_Payment_Stats_By_DayArgs = {
  args?: InputMaybe<Get_Payment_Stats_By_Day_Args>;
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Query_RootGet_Payment_Stats_By_Day_AggregateArgs = {
  args?: InputMaybe<Get_Payment_Stats_By_Day_Args>;
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Query_RootGet_Provider_PayoutsArgs = {
  args: Get_Provider_Payouts_Args;
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Query_RootGet_Provider_Payouts_AggregateArgs = {
  args: Get_Provider_Payouts_Args;
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Query_RootGet_Test_Kit_Status_CountsArgs = {
  args?: InputMaybe<Get_Test_Kit_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Query_RootGet_Test_Kit_Status_Counts_AggregateArgs = {
  args?: InputMaybe<Get_Test_Kit_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Query_RootGlobal_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Order_By>>;
  where?: InputMaybe<Global_Configs_Bool_Exp>;
};


export type Query_RootGlobal_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Order_By>>;
  where?: InputMaybe<Global_Configs_Bool_Exp>;
};


export type Query_RootGlobal_Configs_By_PkArgs = {
  name: Global_Configs_Names_Enum;
};


export type Query_RootGlobal_Configs_NamesArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Names_Order_By>>;
  where?: InputMaybe<Global_Configs_Names_Bool_Exp>;
};


export type Query_RootGlobal_Configs_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Names_Order_By>>;
  where?: InputMaybe<Global_Configs_Names_Bool_Exp>;
};


export type Query_RootGlobal_Configs_Names_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootImage_Source_TypesArgs = {
  distinct_on?: InputMaybe<Array<Image_Source_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Source_Types_Order_By>>;
  where?: InputMaybe<Image_Source_Types_Bool_Exp>;
};


export type Query_RootImage_Source_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Source_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Source_Types_Order_By>>;
  where?: InputMaybe<Image_Source_Types_Bool_Exp>;
};


export type Query_RootImage_Source_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootIn_Mail_UsageArgs = {
  distinct_on?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<In_Mail_Usage_Order_By>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


export type Query_RootIn_Mail_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<In_Mail_Usage_Order_By>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


export type Query_RootIn_Mail_Usage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Query_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Query_RootInvitations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLabsArgs = {
  distinct_on?: InputMaybe<Array<Labs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Labs_Order_By>>;
  where?: InputMaybe<Labs_Bool_Exp>;
};


export type Query_RootLabs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Labs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Labs_Order_By>>;
  where?: InputMaybe<Labs_Bool_Exp>;
};


export type Query_RootLabs_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootLatest_Persona_Inquiries_Per_UserArgs = {
  distinct_on?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Order_By>>;
  where?: InputMaybe<Latest_Persona_Inquiries_Per_User_Bool_Exp>;
};


export type Query_RootLatest_Persona_Inquiries_Per_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Order_By>>;
  where?: InputMaybe<Latest_Persona_Inquiries_Per_User_Bool_Exp>;
};


export type Query_RootLegal_Document_TypesArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Types_Order_By>>;
  where?: InputMaybe<Legal_Document_Types_Bool_Exp>;
};


export type Query_RootLegal_Document_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Types_Order_By>>;
  where?: InputMaybe<Legal_Document_Types_Bool_Exp>;
};


export type Query_RootLegal_Document_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootLegal_Document_Update_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Update_Notifications_Order_By>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


export type Query_RootLegal_Document_Update_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Update_Notifications_Order_By>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


export type Query_RootLegal_Document_Update_Notifications_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootLegal_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Documents_Order_By>>;
  where?: InputMaybe<Legal_Documents_Bool_Exp>;
};


export type Query_RootLegal_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Documents_Order_By>>;
  where?: InputMaybe<Legal_Documents_Bool_Exp>;
};


export type Query_RootLegal_Documents_By_PkArgs = {
  legal_document_id: Scalars['bigint'];
};


export type Query_RootMedical_SchoolsArgs = {
  distinct_on?: InputMaybe<Array<Medical_Schools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medical_Schools_Order_By>>;
  where?: InputMaybe<Medical_Schools_Bool_Exp>;
};


export type Query_RootMedical_Schools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Medical_Schools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medical_Schools_Order_By>>;
  where?: InputMaybe<Medical_Schools_Bool_Exp>;
};


export type Query_RootMedical_Schools_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMedicationsArgs = {
  distinct_on?: InputMaybe<Array<Medications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Order_By>>;
  where?: InputMaybe<Medications_Bool_Exp>;
};


export type Query_RootMedications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Medications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Order_By>>;
  where?: InputMaybe<Medications_Bool_Exp>;
};


export type Query_RootMedications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMedications_UniqueArgs = {
  distinct_on?: InputMaybe<Array<Medications_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Unique_Order_By>>;
  where?: InputMaybe<Medications_Unique_Bool_Exp>;
};


export type Query_RootMedications_Unique_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Medications_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Unique_Order_By>>;
  where?: InputMaybe<Medications_Unique_Bool_Exp>;
};


export type Query_RootMolecular_TestsArgs = {
  distinct_on?: InputMaybe<Array<Molecular_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Molecular_Tests_Order_By>>;
  where?: InputMaybe<Molecular_Tests_Bool_Exp>;
};


export type Query_RootMolecular_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Molecular_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Molecular_Tests_Order_By>>;
  where?: InputMaybe<Molecular_Tests_Bool_Exp>;
};


export type Query_RootMolecular_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Query_RootMosaic_TestsArgs = {
  distinct_on?: InputMaybe<Array<Mosaic_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mosaic_Tests_Order_By>>;
  where?: InputMaybe<Mosaic_Tests_Bool_Exp>;
};


export type Query_RootMosaic_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mosaic_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mosaic_Tests_Order_By>>;
  where?: InputMaybe<Mosaic_Tests_Bool_Exp>;
};


export type Query_RootMosaic_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Query_RootNabla_NotesArgs = {
  distinct_on?: InputMaybe<Array<Nabla_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nabla_Notes_Order_By>>;
  where?: InputMaybe<Nabla_Notes_Bool_Exp>;
};


export type Query_RootNabla_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nabla_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nabla_Notes_Order_By>>;
  where?: InputMaybe<Nabla_Notes_Bool_Exp>;
};


export type Query_RootNabla_Notes_By_PkArgs = {
  appointment_id: Scalars['String'];
};


export type Query_RootNpi_Registry_DataArgs = {
  distinct_on?: InputMaybe<Array<Npi_Registry_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Npi_Registry_Data_Order_By>>;
  where?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
};


export type Query_RootNpi_Registry_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Npi_Registry_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Npi_Registry_Data_Order_By>>;
  where?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
};


export type Query_RootNpi_Registry_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrder_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Payments_Order_By>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


export type Query_RootOrder_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Payments_Order_By>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


export type Query_RootOrder_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Products_Order_By>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


export type Query_RootOrder_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Products_Order_By>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


export type Query_RootOrder_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrder_Status_CountsArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Query_RootOrder_Status_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Query_RootOrder_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


export type Query_RootOrder_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


export type Query_RootOrder_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOrders_ViewArgs = {
  distinct_on?: InputMaybe<Array<Orders_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_View_Order_By>>;
  where?: InputMaybe<Orders_View_Bool_Exp>;
};


export type Query_RootOrders_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_View_Order_By>>;
  where?: InputMaybe<Orders_View_Bool_Exp>;
};


export type Query_RootPatient_Achievement_EventsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Events_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
};


export type Query_RootPatient_Achievement_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Events_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
};


export type Query_RootPatient_Achievement_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPatient_Achievement_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Progress_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
};


export type Query_RootPatient_Achievement_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Progress_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
};


export type Query_RootPatient_Achievement_Progress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPatient_Achievement_UnlocksArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Unlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Unlocks_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
};


export type Query_RootPatient_Achievement_Unlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Unlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Unlocks_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
};


export type Query_RootPatient_Achievement_Unlocks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPayment_Stats_By_DayArgs = {
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Query_RootPayment_Stats_By_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Query_RootPayment_Transaction_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


export type Query_RootPayment_Transaction_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


export type Query_RootPayment_Transaction_Orders_By_PkArgs = {
  order_id: Scalars['Int'];
  payment_transaction_id: Scalars['Int'];
};


export type Query_RootPayment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transactions_Order_By>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};


export type Query_RootPayment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transactions_Order_By>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};


export type Query_RootPayment_Transactions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPending_Patient_ZrtArgs = {
  distinct_on?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pending_Patient_Zrt_Order_By>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


export type Query_RootPending_Patient_Zrt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pending_Patient_Zrt_Order_By>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


export type Query_RootPending_Patient_Zrt_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPersona_InquiriesArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiries_Order_By>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};


export type Query_RootPersona_Inquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiries_Order_By>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};


export type Query_RootPersona_Inquiries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPersona_Inquiry_StatusArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiry_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiry_Status_Order_By>>;
  where?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
};


export type Query_RootPersona_Inquiry_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiry_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiry_Status_Order_By>>;
  where?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
};


export type Query_RootPersona_Inquiry_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProvider_BillingArgs = {
  distinct_on?: InputMaybe<Array<Provider_Billing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Billing_Order_By>>;
  where?: InputMaybe<Provider_Billing_Bool_Exp>;
};


export type Query_RootProvider_Billing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Billing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Billing_Order_By>>;
  where?: InputMaybe<Provider_Billing_Bool_Exp>;
};


export type Query_RootProvider_Billing_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProvider_Dea_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Dea_Licenses_Order_By>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


export type Query_RootProvider_Dea_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Dea_Licenses_Order_By>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


export type Query_RootProvider_Dea_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payments_Order_By>>;
  where?: InputMaybe<Provider_Payments_Bool_Exp>;
};


export type Query_RootProvider_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payments_Order_By>>;
  where?: InputMaybe<Provider_Payments_Bool_Exp>;
};


export type Query_RootProvider_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProvider_PayoutsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Query_RootProvider_Payouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Query_RootProvider_State_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_State_Licenses_Order_By>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


export type Query_RootProvider_State_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_State_Licenses_Order_By>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


export type Query_RootProvider_State_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProvider_Unread_External_Notification_CountsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Order_By>>;
  where?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
};


export type Query_RootProvider_Unread_External_Notification_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Order_By>>;
  where?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
};


export type Query_RootProvider_Unread_External_Notification_Counts_By_PkArgs = {
  codex_provider_id: Scalars['uuid'];
};


export type Query_RootQuestion_Measurement_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Question_Measurement_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Measurement_Units_Order_By>>;
  where?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
};


export type Query_RootQuestion_Measurement_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Measurement_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Measurement_Units_Order_By>>;
  where?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
};


export type Query_RootQuestion_Measurement_Units_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootQuestion_TypesArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


export type Query_RootQuestion_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


export type Query_RootQuestion_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootQuestion_Ui_Control_Helper_Text_PositionArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
};


export type Query_RootQuestion_Ui_Control_Helper_Text_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
};


export type Query_RootQuestion_Ui_Control_Helper_Text_Position_By_PkArgs = {
  helper_text_position: Scalars['String'];
};


export type Query_RootQuestion_Ui_Control_TypesArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Types_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};


export type Query_RootQuestion_Ui_Control_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Types_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};


export type Query_RootQuestion_Ui_Control_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootQuestionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};


export type Query_RootQuestionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};


export type Query_RootQuestionnaire_Questions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuestionnaire_RemindersArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Reminders_Order_By>>;
  where?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
};


export type Query_RootQuestionnaire_Reminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Reminders_Order_By>>;
  where?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
};


export type Query_RootQuestionnaire_Reminders_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuestionnaire_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Query_RootQuestionnaire_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Query_RootQuestionnaire_Responses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Query_RootQuestionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Query_RootQuestionnaires_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Query_RootQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Query_RootQuestions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Query_RootRecommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Query_RootRecommendations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShipmonk_Sync_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Shipmonk_Sync_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipmonk_Sync_Metadata_Order_By>>;
  where?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
};


export type Query_RootShipmonk_Sync_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shipmonk_Sync_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipmonk_Sync_Metadata_Order_By>>;
  where?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
};


export type Query_RootShipmonk_Sync_Metadata_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSkintelligent_TestsArgs = {
  distinct_on?: InputMaybe<Array<Skintelligent_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skintelligent_Tests_Order_By>>;
  where?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
};


export type Query_RootSkintelligent_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Skintelligent_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skintelligent_Tests_Order_By>>;
  where?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
};


export type Query_RootSkintelligent_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Query_RootStripe_Billing_PlansArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Billing_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Billing_Plans_Order_By>>;
  where?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
};


export type Query_RootStripe_Billing_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Billing_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Billing_Plans_Order_By>>;
  where?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
};


export type Query_RootStripe_Billing_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStripe_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customers_Order_By>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


export type Query_RootStripe_Customers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customers_Order_By>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


export type Query_RootStripe_Customers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStripe_Latest_Subscription_Per_User_ViewArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Order_By>>;
  where?: InputMaybe<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>;
};


export type Query_RootStripe_Latest_Subscription_Per_User_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Order_By>>;
  where?: InputMaybe<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>;
};


export type Query_RootStripe_Payment_IntentsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Intents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Intents_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
};


export type Query_RootStripe_Payment_Intents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Intents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Intents_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
};


export type Query_RootStripe_Payment_Intents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStripe_Payment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Methods_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


export type Query_RootStripe_Payment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Methods_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


export type Query_RootStripe_Payment_Methods_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStripe_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Subscriptions_Order_By>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};


export type Query_RootStripe_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Subscriptions_Order_By>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};


export type Query_RootStripe_Subscriptions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootStripe_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Transaction_Order_By>>;
  where?: InputMaybe<Stripe_Transaction_Bool_Exp>;
};


export type Query_RootStripe_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Transaction_Order_By>>;
  where?: InputMaybe<Stripe_Transaction_Bool_Exp>;
};


export type Query_RootStripe_Transaction_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootSupport_Chat_UsageArgs = {
  distinct_on?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Support_Chat_Usage_Order_By>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


export type Query_RootSupport_Chat_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Support_Chat_Usage_Order_By>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


export type Query_RootSupport_Chat_Usage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSwab_Code_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Swab_Code_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Code_Statuses_Order_By>>;
  where?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
};


export type Query_RootSwab_Code_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Swab_Code_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Code_Statuses_Order_By>>;
  where?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
};


export type Query_RootSwab_Code_Statuses_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSwab_CodesArgs = {
  distinct_on?: InputMaybe<Array<Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Codes_Order_By>>;
  where?: InputMaybe<Swab_Codes_Bool_Exp>;
};


export type Query_RootSwab_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Codes_Order_By>>;
  where?: InputMaybe<Swab_Codes_Bool_Exp>;
};


export type Query_RootSwab_Codes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootSwab_Usage_TypeArgs = {
  distinct_on?: InputMaybe<Array<Swab_Usage_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Usage_Type_Order_By>>;
  where?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
};


export type Query_RootSwab_Usage_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Swab_Usage_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Usage_Type_Order_By>>;
  where?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
};


export type Query_RootSwab_Usage_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTest_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Test_Definitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Definitions_Order_By>>;
  where?: InputMaybe<Test_Definitions_Bool_Exp>;
};


export type Query_RootTest_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Definitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Definitions_Order_By>>;
  where?: InputMaybe<Test_Definitions_Bool_Exp>;
};


export type Query_RootTest_Definitions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTest_E_Prescribe_NpisArgs = {
  distinct_on?: InputMaybe<Array<Test_E_Prescribe_Npis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_E_Prescribe_Npis_Order_By>>;
  where?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
};


export type Query_RootTest_E_Prescribe_Npis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_E_Prescribe_Npis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_E_Prescribe_Npis_Order_By>>;
  where?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
};


export type Query_RootTest_E_Prescribe_Npis_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTest_Kit_Status_CountsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Query_RootTest_Kit_Status_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Query_RootTest_Kits_Update_States_Summary_LogArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


export type Query_RootTest_Kits_Update_States_Summary_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


export type Query_RootTest_Kits_Update_States_Summary_Log_By_PkArgs = {
  log_id: Scalars['uuid'];
};


export type Query_RootTest_TypesArgs = {
  distinct_on?: InputMaybe<Array<Test_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Types_Order_By>>;
  where?: InputMaybe<Test_Types_Bool_Exp>;
};


export type Query_RootTest_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Types_Order_By>>;
  where?: InputMaybe<Test_Types_Bool_Exp>;
};


export type Query_RootTest_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTestsArgs = {
  distinct_on?: InputMaybe<Array<Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tests_Order_By>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};


export type Query_RootTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tests_Order_By>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};


export type Query_RootTests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Query_RootText_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Text_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Addresses_Order_By>>;
  where?: InputMaybe<Text_Addresses_Bool_Exp>;
};


export type Query_RootText_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Addresses_Order_By>>;
  where?: InputMaybe<Text_Addresses_Bool_Exp>;
};


export type Query_RootText_Addresses_By_PkArgs = {
  address_id: Scalars['uuid'];
};


export type Query_RootUnauthenticated_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


export type Query_RootUnauthenticated_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


export type Query_RootUnauthenticated_Questionnaire_Questions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUnauthenticated_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaires_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};


export type Query_RootUnauthenticated_Questionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaires_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};


export type Query_RootUnauthenticated_Questionnaires_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUnauthenticated_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
};


export type Query_RootUnauthenticated_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
};


export type Query_RootUnauthenticated_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUniversitiesArgs = {
  distinct_on?: InputMaybe<Array<Universities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Universities_Order_By>>;
  where?: InputMaybe<Universities_Bool_Exp>;
};


export type Query_RootUniversities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Universities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Universities_Order_By>>;
  where?: InputMaybe<Universities_Bool_Exp>;
};


export type Query_RootUniversities_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUpdateAppointmentSummaryNotificationStateArgs = {
  appointmentCodexId: Scalars['String'];
  summaryNotification: Scalars['Boolean'];
};


export type Query_RootUsed_Test_E_Prescribe_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Order_By>>;
  where?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
};


export type Query_RootUsed_Test_E_Prescribe_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Order_By>>;
  where?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
};


export type Query_RootUsed_Test_E_Prescribe_Licenses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_AddressesArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Query_RootUser_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Query_RootUser_Addresses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUser_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Query_RootUser_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Query_RootUser_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Auth_Provider_TypesArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Provider_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Provider_Types_Order_By>>;
  where?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
};


export type Query_RootUser_Auth_Provider_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Provider_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Provider_Types_Order_By>>;
  where?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
};


export type Query_RootUser_Auth_Provider_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_Auth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Providers_Order_By>>;
  where?: InputMaybe<User_Auth_Providers_Bool_Exp>;
};


export type Query_RootUser_Auth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Providers_Order_By>>;
  where?: InputMaybe<User_Auth_Providers_Bool_Exp>;
};


export type Query_RootUser_Auth_Providers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUser_Auth_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Tokens_Order_By>>;
  where?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
};


export type Query_RootUser_Auth_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Tokens_Order_By>>;
  where?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
};


export type Query_RootUser_Auth_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Communication_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communication_Deliveries_Order_By>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};


export type Query_RootUser_Communication_Deliveries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communication_Deliveries_Order_By>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};


export type Query_RootUser_Communication_Deliveries_By_PkArgs = {
  user_communication_delivery_id: Scalars['bigint'];
};


export type Query_RootUser_CommunicationsArgs = {
  distinct_on?: InputMaybe<Array<User_Communications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communications_Order_By>>;
  where?: InputMaybe<User_Communications_Bool_Exp>;
};


export type Query_RootUser_Communications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Communications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communications_Order_By>>;
  where?: InputMaybe<User_Communications_Bool_Exp>;
};


export type Query_RootUser_Communications_By_PkArgs = {
  user_communication_id: Scalars['bigint'];
};


export type Query_RootUser_IndicatorsArgs = {
  distinct_on?: InputMaybe<Array<User_Indicators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Indicators_Order_By>>;
  where?: InputMaybe<User_Indicators_Bool_Exp>;
};


export type Query_RootUser_Indicators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Indicators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Indicators_Order_By>>;
  where?: InputMaybe<User_Indicators_Bool_Exp>;
};


export type Query_RootUser_Indicators_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootUser_Notification_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Status_Order_By>>;
  where?: InputMaybe<User_Notification_Status_Bool_Exp>;
};


export type Query_RootUser_Notification_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Status_Order_By>>;
  where?: InputMaybe<User_Notification_Status_Bool_Exp>;
};


export type Query_RootUser_Notification_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Query_RootUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Query_RootUser_Notifications_By_PkArgs = {
  user_communication_delivery_id: Scalars['bigint'];
};


export type Query_RootUser_Push_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Push_Tokens_Order_By>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


export type Query_RootUser_Push_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Push_Tokens_Order_By>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


export type Query_RootUser_Push_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Scanned_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Scanned_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Scanned_Data_Order_By>>;
  where?: InputMaybe<User_Scanned_Data_Bool_Exp>;
};


export type Query_RootUser_Scanned_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scanned_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Scanned_Data_Order_By>>;
  where?: InputMaybe<User_Scanned_Data_Bool_Exp>;
};


export type Query_RootUser_Scanned_Data_By_PkArgs = {
  user_id: Scalars['uuid'];
};


export type Query_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Query_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootValidateChildAdultTransitionInvitationTokenArgs = {
  input: ValidateInvitationTokenInput;
};


export type Query_RootValidateDelegatedAdminInvitationTokenArgs = {
  input: ValidateInvitationTokenInput;
};


export type Query_RootVonage_AppointmentArgs = {
  distinct_on?: InputMaybe<Array<Vonage_Appointment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vonage_Appointment_Order_By>>;
  where?: InputMaybe<Vonage_Appointment_Bool_Exp>;
};


export type Query_RootVonage_Appointment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vonage_Appointment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vonage_Appointment_Order_By>>;
  where?: InputMaybe<Vonage_Appointment_Bool_Exp>;
};


export type Query_RootVonage_Appointment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootZrt_TestsArgs = {
  distinct_on?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zrt_Tests_Order_By>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};


export type Query_RootZrt_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zrt_Tests_Order_By>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};


export type Query_RootZrt_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};

/** columns and relationships of "question_measurement_units" */
export type Question_Measurement_Units = {
  __typename?: 'question_measurement_units';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "question_measurement_units" */
export type Question_Measurement_Units_Aggregate = {
  __typename?: 'question_measurement_units_aggregate';
  aggregate?: Maybe<Question_Measurement_Units_Aggregate_Fields>;
  nodes: Array<Question_Measurement_Units>;
};

/** aggregate fields of "question_measurement_units" */
export type Question_Measurement_Units_Aggregate_Fields = {
  __typename?: 'question_measurement_units_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Question_Measurement_Units_Max_Fields>;
  min?: Maybe<Question_Measurement_Units_Min_Fields>;
};


/** aggregate fields of "question_measurement_units" */
export type Question_Measurement_Units_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Measurement_Units_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "question_measurement_units". All fields are combined with a logical 'AND'. */
export type Question_Measurement_Units_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Measurement_Units_Bool_Exp>>;
  _not?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Measurement_Units_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_measurement_units" */
export enum Question_Measurement_Units_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuestionMeasurementUnitsPkey = 'question_measurement_units_pkey'
}

export enum Question_Measurement_Units_Enum {
  /** FEET_AND_INCHES, METERS */
  Height = 'HEIGHT',
  /** POUNDS, KILOGRAMS */
  Weight = 'WEIGHT',
  /** FEET_AND_INCHES, CENTIMETERS, METERS */
  Width = 'WIDTH'
}

/** Boolean expression to compare columns of type "question_measurement_units_enum". All fields are combined with logical 'AND'. */
export type Question_Measurement_Units_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Question_Measurement_Units_Enum>;
  _in?: InputMaybe<Array<Question_Measurement_Units_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Question_Measurement_Units_Enum>;
  _nin?: InputMaybe<Array<Question_Measurement_Units_Enum>>;
};

/** input type for inserting data into table "question_measurement_units" */
export type Question_Measurement_Units_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Measurement_Units_Max_Fields = {
  __typename?: 'question_measurement_units_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Question_Measurement_Units_Min_Fields = {
  __typename?: 'question_measurement_units_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "question_measurement_units" */
export type Question_Measurement_Units_Mutation_Response = {
  __typename?: 'question_measurement_units_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Measurement_Units>;
};

/** input type for inserting object relation for remote table "question_measurement_units" */
export type Question_Measurement_Units_Obj_Rel_Insert_Input = {
  data: Question_Measurement_Units_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Measurement_Units_On_Conflict>;
};

/** on_conflict condition type for table "question_measurement_units" */
export type Question_Measurement_Units_On_Conflict = {
  constraint: Question_Measurement_Units_Constraint;
  update_columns?: Array<Question_Measurement_Units_Update_Column>;
  where?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
};

/** Ordering options when selecting data from "question_measurement_units". */
export type Question_Measurement_Units_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_measurement_units */
export type Question_Measurement_Units_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "question_measurement_units" */
export enum Question_Measurement_Units_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "question_measurement_units" */
export type Question_Measurement_Units_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "question_measurement_units" */
export type Question_Measurement_Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Measurement_Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Measurement_Units_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "question_measurement_units" */
export enum Question_Measurement_Units_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Question_Measurement_Units_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Measurement_Units_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Measurement_Units_Bool_Exp;
};

/** columns and relationships of "question_types" */
export type Question_Types = {
  __typename?: 'question_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "question_types" */
export type Question_Types_Aggregate = {
  __typename?: 'question_types_aggregate';
  aggregate?: Maybe<Question_Types_Aggregate_Fields>;
  nodes: Array<Question_Types>;
};

/** aggregate fields of "question_types" */
export type Question_Types_Aggregate_Fields = {
  __typename?: 'question_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Question_Types_Max_Fields>;
  min?: Maybe<Question_Types_Min_Fields>;
};


/** aggregate fields of "question_types" */
export type Question_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "question_types". All fields are combined with a logical 'AND'. */
export type Question_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Types_Bool_Exp>>;
  _not?: InputMaybe<Question_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_types" */
export enum Question_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuestionTypesPkey = 'question_types_pkey'
}

export enum Question_Types_Enum {
  Integer = 'INTEGER',
  Number = 'NUMBER',
  String = 'STRING'
}

/** Boolean expression to compare columns of type "question_types_enum". All fields are combined with logical 'AND'. */
export type Question_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Question_Types_Enum>;
  _in?: InputMaybe<Array<Question_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Question_Types_Enum>;
  _nin?: InputMaybe<Array<Question_Types_Enum>>;
};

/** input type for inserting data into table "question_types" */
export type Question_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Types_Max_Fields = {
  __typename?: 'question_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Question_Types_Min_Fields = {
  __typename?: 'question_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "question_types" */
export type Question_Types_Mutation_Response = {
  __typename?: 'question_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Types>;
};

/** on_conflict condition type for table "question_types" */
export type Question_Types_On_Conflict = {
  constraint: Question_Types_Constraint;
  update_columns?: Array<Question_Types_Update_Column>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "question_types". */
export type Question_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_types */
export type Question_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "question_types" */
export enum Question_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "question_types" */
export type Question_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "question_types" */
export type Question_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "question_types" */
export enum Question_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Question_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Types_Bool_Exp;
};

/** columns and relationships of "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position = {
  __typename?: 'question_ui_control_helper_text_position';
  helper_text_position: Scalars['String'];
};

/** aggregated selection of "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Aggregate = {
  __typename?: 'question_ui_control_helper_text_position_aggregate';
  aggregate?: Maybe<Question_Ui_Control_Helper_Text_Position_Aggregate_Fields>;
  nodes: Array<Question_Ui_Control_Helper_Text_Position>;
};

/** aggregate fields of "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Aggregate_Fields = {
  __typename?: 'question_ui_control_helper_text_position_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Question_Ui_Control_Helper_Text_Position_Max_Fields>;
  min?: Maybe<Question_Ui_Control_Helper_Text_Position_Min_Fields>;
};


/** aggregate fields of "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "question_ui_control_helper_text_position". All fields are combined with a logical 'AND'. */
export type Question_Ui_Control_Helper_Text_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Bool_Exp>>;
  _not?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Bool_Exp>>;
  helper_text_position?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_ui_control_helper_text_position" */
export enum Question_Ui_Control_Helper_Text_Position_Constraint {
  /** unique or primary key constraint on columns "helper_text_position" */
  QuestionUiControlHelperTextPositionPkey = 'question_ui_control_helper_text_position_pkey'
}

export enum Question_Ui_Control_Helper_Text_Position_Enum {
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** Boolean expression to compare columns of type "question_ui_control_helper_text_position_enum". All fields are combined with logical 'AND'. */
export type Question_Ui_Control_Helper_Text_Position_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  _in?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  _nin?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Enum>>;
};

/** input type for inserting data into table "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Insert_Input = {
  helper_text_position?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Ui_Control_Helper_Text_Position_Max_Fields = {
  __typename?: 'question_ui_control_helper_text_position_max_fields';
  helper_text_position?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Question_Ui_Control_Helper_Text_Position_Min_Fields = {
  __typename?: 'question_ui_control_helper_text_position_min_fields';
  helper_text_position?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Mutation_Response = {
  __typename?: 'question_ui_control_helper_text_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Ui_Control_Helper_Text_Position>;
};

/** input type for inserting object relation for remote table "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Obj_Rel_Insert_Input = {
  data: Question_Ui_Control_Helper_Text_Position_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Ui_Control_Helper_Text_Position_On_Conflict>;
};

/** on_conflict condition type for table "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_On_Conflict = {
  constraint: Question_Ui_Control_Helper_Text_Position_Constraint;
  update_columns?: Array<Question_Ui_Control_Helper_Text_Position_Update_Column>;
  where?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "question_ui_control_helper_text_position". */
export type Question_Ui_Control_Helper_Text_Position_Order_By = {
  helper_text_position?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_ui_control_helper_text_position */
export type Question_Ui_Control_Helper_Text_Position_Pk_Columns_Input = {
  helper_text_position: Scalars['String'];
};

/** select columns of table "question_ui_control_helper_text_position" */
export enum Question_Ui_Control_Helper_Text_Position_Select_Column {
  /** column name */
  HelperTextPosition = 'helper_text_position'
}

/** input type for updating data in table "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Set_Input = {
  helper_text_position?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "question_ui_control_helper_text_position" */
export type Question_Ui_Control_Helper_Text_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Ui_Control_Helper_Text_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Ui_Control_Helper_Text_Position_Stream_Cursor_Value_Input = {
  helper_text_position?: InputMaybe<Scalars['String']>;
};

/** update columns of table "question_ui_control_helper_text_position" */
export enum Question_Ui_Control_Helper_Text_Position_Update_Column {
  /** column name */
  HelperTextPosition = 'helper_text_position'
}

export type Question_Ui_Control_Helper_Text_Position_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Ui_Control_Helper_Text_Position_Bool_Exp;
};

/** columns and relationships of "question_ui_control_types" */
export type Question_Ui_Control_Types = {
  __typename?: 'question_ui_control_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "question_ui_control_types" */
export type Question_Ui_Control_Types_Aggregate = {
  __typename?: 'question_ui_control_types_aggregate';
  aggregate?: Maybe<Question_Ui_Control_Types_Aggregate_Fields>;
  nodes: Array<Question_Ui_Control_Types>;
};

/** aggregate fields of "question_ui_control_types" */
export type Question_Ui_Control_Types_Aggregate_Fields = {
  __typename?: 'question_ui_control_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Question_Ui_Control_Types_Max_Fields>;
  min?: Maybe<Question_Ui_Control_Types_Min_Fields>;
};


/** aggregate fields of "question_ui_control_types" */
export type Question_Ui_Control_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Question_Ui_Control_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "question_ui_control_types". All fields are combined with a logical 'AND'. */
export type Question_Ui_Control_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Question_Ui_Control_Types_Bool_Exp>>;
  _not?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Question_Ui_Control_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "question_ui_control_types" */
export enum Question_Ui_Control_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  QuestionUiControlTypesPkey = 'question_ui_control_types_pkey'
}

export enum Question_Ui_Control_Types_Enum {
  Checkbox = 'CHECKBOX',
  CheckboxGroupAdvanced = 'CHECKBOX_GROUP_ADVANCED',
  ComboTextWithDropdown = 'COMBO_TEXT_WITH_DROPDOWN',
  Date = 'DATE',
  DateWithHours = 'DATE_WITH_HOURS',
  DateWithHoursDropdown = 'DATE_WITH_HOURS_DROPDOWN',
  DateWithHoursText = 'DATE_WITH_HOURS_TEXT',
  DoubleDropdownCombo = 'DOUBLE_DROPDOWN_COMBO',
  DoubleTextComboLHelperText = 'DOUBLE_TEXT_COMBO_L_HELPER_TEXT',
  Dropdown_35Percent = 'DROPDOWN_35_PERCENT',
  Dropdown_50Percent = 'DROPDOWN_50_PERCENT',
  Email = 'EMAIL',
  LookupField = 'LOOKUP_FIELD',
  LookupWithMultiselect = 'LOOKUP_WITH_MULTISELECT',
  Mix = 'MIX',
  NumberCounter = 'NUMBER_COUNTER',
  Password = 'PASSWORD',
  Phone = 'PHONE',
  RadioButton = 'RADIO_BUTTON',
  RadioWithImage = 'RADIO_WITH_IMAGE',
  Slider = 'SLIDER',
  SmallText = 'SMALL_TEXT',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA',
  TextAreaGroupFiles = 'TEXT_AREA_GROUP_FILES'
}

/** Boolean expression to compare columns of type "question_ui_control_types_enum". All fields are combined with logical 'AND'. */
export type Question_Ui_Control_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Question_Ui_Control_Types_Enum>;
  _in?: InputMaybe<Array<Question_Ui_Control_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Question_Ui_Control_Types_Enum>;
  _nin?: InputMaybe<Array<Question_Ui_Control_Types_Enum>>;
};

/** input type for inserting data into table "question_ui_control_types" */
export type Question_Ui_Control_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Question_Ui_Control_Types_Max_Fields = {
  __typename?: 'question_ui_control_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Question_Ui_Control_Types_Min_Fields = {
  __typename?: 'question_ui_control_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "question_ui_control_types" */
export type Question_Ui_Control_Types_Mutation_Response = {
  __typename?: 'question_ui_control_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_Ui_Control_Types>;
};

/** input type for inserting object relation for remote table "question_ui_control_types" */
export type Question_Ui_Control_Types_Obj_Rel_Insert_Input = {
  data: Question_Ui_Control_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_Ui_Control_Types_On_Conflict>;
};

/** on_conflict condition type for table "question_ui_control_types" */
export type Question_Ui_Control_Types_On_Conflict = {
  constraint: Question_Ui_Control_Types_Constraint;
  update_columns?: Array<Question_Ui_Control_Types_Update_Column>;
  where?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "question_ui_control_types". */
export type Question_Ui_Control_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: question_ui_control_types */
export type Question_Ui_Control_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "question_ui_control_types" */
export enum Question_Ui_Control_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "question_ui_control_types" */
export type Question_Ui_Control_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "question_ui_control_types" */
export type Question_Ui_Control_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Question_Ui_Control_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Ui_Control_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "question_ui_control_types" */
export enum Question_Ui_Control_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Question_Ui_Control_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Ui_Control_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Question_Ui_Control_Types_Bool_Exp;
};

/** columns and relationships of "questionnaire_questions" */
export type Questionnaire_Questions = {
  __typename?: 'questionnaire_questions';
  id: Scalars['bigint'];
  question_id: Scalars['Int'];
  questionnaire_id: Scalars['Int'];
  /** An object relationship */
  questionnaire_questions_question: Questions;
  /** An object relationship */
  questionnaire_questions_questionnaire: Questionnaires;
};

/** aggregated selection of "questionnaire_questions" */
export type Questionnaire_Questions_Aggregate = {
  __typename?: 'questionnaire_questions_aggregate';
  aggregate?: Maybe<Questionnaire_Questions_Aggregate_Fields>;
  nodes: Array<Questionnaire_Questions>;
};

export type Questionnaire_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Questionnaire_Questions_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_questions" */
export type Questionnaire_Questions_Aggregate_Fields = {
  __typename?: 'questionnaire_questions_aggregate_fields';
  avg?: Maybe<Questionnaire_Questions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Questionnaire_Questions_Max_Fields>;
  min?: Maybe<Questionnaire_Questions_Min_Fields>;
  stddev?: Maybe<Questionnaire_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Questions_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Questions_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Questions_Variance_Fields>;
};


/** aggregate fields of "questionnaire_questions" */
export type Questionnaire_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "questionnaire_questions" */
export type Questionnaire_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Questions_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Questions_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_questions" */
export type Questionnaire_Questions_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Questions_Avg_Fields = {
  __typename?: 'questionnaire_questions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_questions". All fields are combined with a logical 'AND'. */
export type Questionnaire_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Questions_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Questions_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  question_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_questions_question?: InputMaybe<Questions_Bool_Exp>;
  questionnaire_questions_questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
};

/** unique or primary key constraints on table "questionnaire_questions" */
export enum Questionnaire_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireQuestionsPkey = 'questionnaire_questions_pkey',
  /** unique or primary key constraint on columns "question_id", "questionnaire_id" */
  QuestionnaireQuestionsQuestionnaireIdQuestionIdKey = 'questionnaire_questions_questionnaire_id_question_id_key'
}

/** input type for incrementing numeric columns in table "questionnaire_questions" */
export type Questionnaire_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  question_id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "questionnaire_questions" */
export type Questionnaire_Questions_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  question_id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  questionnaire_questions_question?: InputMaybe<Questions_Obj_Rel_Insert_Input>;
  questionnaire_questions_questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Questionnaire_Questions_Max_Fields = {
  __typename?: 'questionnaire_questions_max_fields';
  id?: Maybe<Scalars['bigint']>;
  question_id?: Maybe<Scalars['Int']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Questions_Min_Fields = {
  __typename?: 'questionnaire_questions_min_fields';
  id?: Maybe<Scalars['bigint']>;
  question_id?: Maybe<Scalars['Int']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_questions" */
export type Questionnaire_Questions_Mutation_Response = {
  __typename?: 'questionnaire_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Questions>;
};

/** on_conflict condition type for table "questionnaire_questions" */
export type Questionnaire_Questions_On_Conflict = {
  constraint: Questionnaire_Questions_Constraint;
  update_columns?: Array<Questionnaire_Questions_Update_Column>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_questions". */
export type Questionnaire_Questions_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_questions_question?: InputMaybe<Questions_Order_By>;
  questionnaire_questions_questionnaire?: InputMaybe<Questionnaires_Order_By>;
};

/** primary key columns input for table: questionnaire_questions */
export type Questionnaire_Questions_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "questionnaire_questions" */
export enum Questionnaire_Questions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionnaireId = 'questionnaire_id'
}

/** input type for updating data in table "questionnaire_questions" */
export type Questionnaire_Questions_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  question_id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Questions_Stddev_Fields = {
  __typename?: 'questionnaire_questions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Questions_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Questions_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_questions" */
export type Questionnaire_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Questions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  question_id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Questionnaire_Questions_Sum_Fields = {
  __typename?: 'questionnaire_questions_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  question_id?: Maybe<Scalars['Int']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_questions" */
export enum Questionnaire_Questions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  QuestionnaireId = 'questionnaire_id'
}

export type Questionnaire_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Questions_Var_Pop_Fields = {
  __typename?: 'questionnaire_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Questions_Var_Samp_Fields = {
  __typename?: 'questionnaire_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Questions_Variance_Fields = {
  __typename?: 'questionnaire_questions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  question_id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "questionnaire_questions" */
export type Questionnaire_Questions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_reminders" */
export type Questionnaire_Reminders = {
  __typename?: 'questionnaire_reminders';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  last_reminder_at: Scalars['timestamptz'];
  questionnaire_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "questionnaire_reminders" */
export type Questionnaire_Reminders_Aggregate = {
  __typename?: 'questionnaire_reminders_aggregate';
  aggregate?: Maybe<Questionnaire_Reminders_Aggregate_Fields>;
  nodes: Array<Questionnaire_Reminders>;
};

/** aggregate fields of "questionnaire_reminders" */
export type Questionnaire_Reminders_Aggregate_Fields = {
  __typename?: 'questionnaire_reminders_aggregate_fields';
  avg?: Maybe<Questionnaire_Reminders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Questionnaire_Reminders_Max_Fields>;
  min?: Maybe<Questionnaire_Reminders_Min_Fields>;
  stddev?: Maybe<Questionnaire_Reminders_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Reminders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Reminders_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Reminders_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Reminders_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Reminders_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Reminders_Variance_Fields>;
};


/** aggregate fields of "questionnaire_reminders" */
export type Questionnaire_Reminders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Reminders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Questionnaire_Reminders_Avg_Fields = {
  __typename?: 'questionnaire_reminders_avg_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "questionnaire_reminders". All fields are combined with a logical 'AND'. */
export type Questionnaire_Reminders_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Reminders_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Reminders_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_reminder_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_reminders" */
export enum Questionnaire_Reminders_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireRemindersPkey = 'questionnaire_reminders_pkey',
  /** unique or primary key constraint on columns "user_id", "questionnaire_id" */
  QuestionnaireRemindersUserQuestionnaireKey = 'questionnaire_reminders_user_questionnaire_key'
}

/** input type for incrementing numeric columns in table "questionnaire_reminders" */
export type Questionnaire_Reminders_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "questionnaire_reminders" */
export type Questionnaire_Reminders_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_reminder_at?: InputMaybe<Scalars['timestamptz']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Questionnaire_Reminders_Max_Fields = {
  __typename?: 'questionnaire_reminders_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  last_reminder_at?: Maybe<Scalars['timestamptz']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Questionnaire_Reminders_Min_Fields = {
  __typename?: 'questionnaire_reminders_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  last_reminder_at?: Maybe<Scalars['timestamptz']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "questionnaire_reminders" */
export type Questionnaire_Reminders_Mutation_Response = {
  __typename?: 'questionnaire_reminders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Reminders>;
};

/** on_conflict condition type for table "questionnaire_reminders" */
export type Questionnaire_Reminders_On_Conflict = {
  constraint: Questionnaire_Reminders_Constraint;
  update_columns?: Array<Questionnaire_Reminders_Update_Column>;
  where?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_reminders". */
export type Questionnaire_Reminders_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_reminder_at?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_reminders */
export type Questionnaire_Reminders_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "questionnaire_reminders" */
export enum Questionnaire_Reminders_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastReminderAt = 'last_reminder_at',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "questionnaire_reminders" */
export type Questionnaire_Reminders_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_reminder_at?: InputMaybe<Scalars['timestamptz']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Reminders_Stddev_Fields = {
  __typename?: 'questionnaire_reminders_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Reminders_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_reminders_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Reminders_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_reminders_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "questionnaire_reminders" */
export type Questionnaire_Reminders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Reminders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Reminders_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  last_reminder_at?: InputMaybe<Scalars['timestamptz']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Questionnaire_Reminders_Sum_Fields = {
  __typename?: 'questionnaire_reminders_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "questionnaire_reminders" */
export enum Questionnaire_Reminders_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastReminderAt = 'last_reminder_at',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Questionnaire_Reminders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Reminders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Reminders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Reminders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Reminders_Var_Pop_Fields = {
  __typename?: 'questionnaire_reminders_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Reminders_Var_Samp_Fields = {
  __typename?: 'questionnaire_reminders_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Questionnaire_Reminders_Variance_Fields = {
  __typename?: 'questionnaire_reminders_variance_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "questionnaire_responses" */
export type Questionnaire_Responses = {
  __typename?: 'questionnaire_responses';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  is_complete: Scalars['Boolean'];
  questionnaire_id: Scalars['Int'];
  /** An object relationship */
  questionnaire_responses_questionnaire: Questionnaires;
  responses: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};


/** columns and relationships of "questionnaire_responses" */
export type Questionnaire_ResponsesResponsesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate = {
  __typename?: 'questionnaire_responses_aggregate';
  aggregate?: Maybe<Questionnaire_Responses_Aggregate_Fields>;
  nodes: Array<Questionnaire_Responses>;
};

/** aggregate fields of "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate_Fields = {
  __typename?: 'questionnaire_responses_aggregate_fields';
  avg?: Maybe<Questionnaire_Responses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Questionnaire_Responses_Max_Fields>;
  min?: Maybe<Questionnaire_Responses_Min_Fields>;
  stddev?: Maybe<Questionnaire_Responses_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Responses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Responses_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Responses_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Responses_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Responses_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Responses_Variance_Fields>;
};


/** aggregate fields of "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Questionnaire_Responses_Append_Input = {
  responses?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Questionnaire_Responses_Avg_Fields = {
  __typename?: 'questionnaire_responses_avg_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "questionnaire_responses". All fields are combined with a logical 'AND'. */
export type Questionnaire_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Responses_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Responses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_complete?: InputMaybe<Boolean_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_responses_questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  responses?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_responses" */
export enum Questionnaire_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireResponsesPkey = 'questionnaire_responses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Questionnaire_Responses_Delete_At_Path_Input = {
  responses?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Questionnaire_Responses_Delete_Elem_Input = {
  responses?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Questionnaire_Responses_Delete_Key_Input = {
  responses?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "questionnaire_responses" */
export type Questionnaire_Responses_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "questionnaire_responses" */
export type Questionnaire_Responses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  questionnaire_responses_questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  responses?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Questionnaire_Responses_Max_Fields = {
  __typename?: 'questionnaire_responses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Questionnaire_Responses_Min_Fields = {
  __typename?: 'questionnaire_responses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "questionnaire_responses" */
export type Questionnaire_Responses_Mutation_Response = {
  __typename?: 'questionnaire_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Responses>;
};

/** on_conflict condition type for table "questionnaire_responses" */
export type Questionnaire_Responses_On_Conflict = {
  constraint: Questionnaire_Responses_Constraint;
  update_columns?: Array<Questionnaire_Responses_Update_Column>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_responses". */
export type Questionnaire_Responses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_complete?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_responses_questionnaire?: InputMaybe<Questionnaires_Order_By>;
  responses?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_responses */
export type Questionnaire_Responses_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Questionnaire_Responses_Prepend_Input = {
  responses?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "questionnaire_responses" */
export enum Questionnaire_Responses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'is_complete',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  Responses = 'responses',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "questionnaire_responses" */
export type Questionnaire_Responses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Responses_Stddev_Fields = {
  __typename?: 'questionnaire_responses_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Responses_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_responses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Responses_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_responses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "questionnaire_responses" */
export type Questionnaire_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Responses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  responses?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Questionnaire_Responses_Sum_Fields = {
  __typename?: 'questionnaire_responses_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "questionnaire_responses" */
export enum Questionnaire_Responses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsComplete = 'is_complete',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  Responses = 'responses',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Questionnaire_Responses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Questionnaire_Responses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Questionnaire_Responses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Questionnaire_Responses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Questionnaire_Responses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Responses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Questionnaire_Responses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Responses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Responses_Var_Pop_Fields = {
  __typename?: 'questionnaire_responses_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Responses_Var_Samp_Fields = {
  __typename?: 'questionnaire_responses_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Questionnaire_Responses_Variance_Fields = {
  __typename?: 'questionnaire_responses_variance_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "questionnaires" */
export type Questionnaires = {
  __typename?: 'questionnaires';
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  /** An array relationship */
  questionnaires_questionnaire_questions: Array<Questionnaire_Questions>;
  /** An aggregate relationship */
  questionnaires_questionnaire_questions_aggregate: Questionnaire_Questions_Aggregate;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaires_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaires_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};

/** aggregated selection of "questionnaires" */
export type Questionnaires_Aggregate = {
  __typename?: 'questionnaires_aggregate';
  aggregate?: Maybe<Questionnaires_Aggregate_Fields>;
  nodes: Array<Questionnaires>;
};

/** aggregate fields of "questionnaires" */
export type Questionnaires_Aggregate_Fields = {
  __typename?: 'questionnaires_aggregate_fields';
  avg?: Maybe<Questionnaires_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Questionnaires_Max_Fields>;
  min?: Maybe<Questionnaires_Min_Fields>;
  stddev?: Maybe<Questionnaires_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaires_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaires_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaires_Sum_Fields>;
  var_pop?: Maybe<Questionnaires_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaires_Var_Samp_Fields>;
  variance?: Maybe<Questionnaires_Variance_Fields>;
};


/** aggregate fields of "questionnaires" */
export type Questionnaires_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaires_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Questionnaires_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Questionnaires_Avg_Fields = {
  __typename?: 'questionnaires_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "questionnaires". All fields are combined with a logical 'AND'. */
export type Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaires_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  questionnaires_questionnaire_questions?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
  questionnaires_questionnaire_questions_aggregate?: InputMaybe<Questionnaire_Questions_Aggregate_Bool_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaires" */
export enum Questionnaires_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnairesPkey = 'questionnaires_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Questionnaires_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Questionnaires_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Questionnaires_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "questionnaires" */
export type Questionnaires_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "questionnaires" */
export type Questionnaires_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  questionnaires_questionnaire_questions?: InputMaybe<Questionnaire_Questions_Arr_Rel_Insert_Input>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Questionnaires_Max_Fields = {
  __typename?: 'questionnaires_max_fields';
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Questionnaires_Min_Fields = {
  __typename?: 'questionnaires_min_fields';
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "questionnaires" */
export type Questionnaires_Mutation_Response = {
  __typename?: 'questionnaires_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaires>;
};

/** input type for inserting object relation for remote table "questionnaires" */
export type Questionnaires_Obj_Rel_Insert_Input = {
  data: Questionnaires_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};

/** on_conflict condition type for table "questionnaires" */
export type Questionnaires_On_Conflict = {
  constraint: Questionnaires_Constraint;
  update_columns?: Array<Questionnaires_Update_Column>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaires". */
export type Questionnaires_Order_By = {
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  questionnaires_questionnaire_questions_aggregate?: InputMaybe<Questionnaire_Questions_Aggregate_Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaires */
export type Questionnaires_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Questionnaires_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "questionnaires" */
export enum Questionnaires_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Notes = 'notes',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "questionnaires" */
export type Questionnaires_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Questionnaires_Stddev_Fields = {
  __typename?: 'questionnaires_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Questionnaires_Stddev_Pop_Fields = {
  __typename?: 'questionnaires_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Questionnaires_Stddev_Samp_Fields = {
  __typename?: 'questionnaires_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "questionnaires" */
export type Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaires_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Questionnaires_Sum_Fields = {
  __typename?: 'questionnaires_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "questionnaires" */
export enum Questionnaires_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Notes = 'notes',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title'
}

export type Questionnaires_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Questionnaires_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Questionnaires_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Questionnaires_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Questionnaires_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaires_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Questionnaires_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaires_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaires_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaires_Var_Pop_Fields = {
  __typename?: 'questionnaires_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Questionnaires_Var_Samp_Fields = {
  __typename?: 'questionnaires_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Questionnaires_Variance_Fields = {
  __typename?: 'questionnaires_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "questions" */
export type Questions = {
  __typename?: 'questions';
  all_option?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Scalars['String']>>;
  default?: Maybe<Scalars['String']>;
  dont_know_answer?: Maybe<Scalars['String']>;
  double_text_combo_helper_texts?: Maybe<Scalars['jsonb']>;
  dropdown_combo_answers?: Maybe<Scalars['jsonb']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  helper_text_position?: Maybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id: Scalars['Int'];
  measurement_unit?: Maybe<Question_Measurement_Units_Enum>;
  none_option?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type: Question_Types_Enum;
  ui_control: Question_Ui_Control_Types_Enum;
};


/** columns and relationships of "questions" */
export type QuestionsDouble_Text_Combo_Helper_TextsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "questions" */
export type QuestionsDropdown_Combo_AnswersArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "questions" */
export type Questions_Aggregate = {
  __typename?: 'questions_aggregate';
  aggregate?: Maybe<Questions_Aggregate_Fields>;
  nodes: Array<Questions>;
};

/** aggregate fields of "questions" */
export type Questions_Aggregate_Fields = {
  __typename?: 'questions_aggregate_fields';
  avg?: Maybe<Questions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Questions_Max_Fields>;
  min?: Maybe<Questions_Min_Fields>;
  stddev?: Maybe<Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Questions_Sum_Fields>;
  var_pop?: Maybe<Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Questions_Var_Samp_Fields>;
  variance?: Maybe<Questions_Variance_Fields>;
};


/** aggregate fields of "questions" */
export type Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Questions_Append_Input = {
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Questions_Avg_Fields = {
  __typename?: 'questions_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "questions". All fields are combined with a logical 'AND'. */
export type Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Questions_Bool_Exp>>;
  _not?: InputMaybe<Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Questions_Bool_Exp>>;
  all_option?: InputMaybe<String_Comparison_Exp>;
  answers?: InputMaybe<String_Array_Comparison_Exp>;
  default?: InputMaybe<String_Comparison_Exp>;
  dont_know_answer?: InputMaybe<String_Comparison_Exp>;
  double_text_combo_helper_texts?: InputMaybe<Jsonb_Comparison_Exp>;
  dropdown_combo_answers?: InputMaybe<Jsonb_Comparison_Exp>;
  dropdown_label_1?: InputMaybe<String_Comparison_Exp>;
  dropdown_label_2?: InputMaybe<String_Comparison_Exp>;
  helper_text?: InputMaybe<String_Comparison_Exp>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum_Comparison_Exp>;
  none_option?: InputMaybe<String_Comparison_Exp>;
  response_property?: InputMaybe<String_Comparison_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Question_Types_Enum_Comparison_Exp>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "questions" */
export enum Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionsPkey = 'questions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Questions_Delete_At_Path_Input = {
  double_text_combo_helper_texts?: InputMaybe<Array<Scalars['String']>>;
  dropdown_combo_answers?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Questions_Delete_Elem_Input = {
  double_text_combo_helper_texts?: InputMaybe<Scalars['Int']>;
  dropdown_combo_answers?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Questions_Delete_Key_Input = {
  double_text_combo_helper_texts?: InputMaybe<Scalars['String']>;
  dropdown_combo_answers?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "questions" */
export type Questions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "questions" */
export type Questions_Insert_Input = {
  all_option?: InputMaybe<Scalars['String']>;
  answers?: InputMaybe<Array<Scalars['String']>>;
  default?: InputMaybe<Scalars['String']>;
  dont_know_answer?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
  dropdown_label_1?: InputMaybe<Scalars['String']>;
  dropdown_label_2?: InputMaybe<Scalars['String']>;
  helper_text?: InputMaybe<Scalars['String']>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum>;
  none_option?: InputMaybe<Scalars['String']>;
  response_property?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Question_Types_Enum>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum>;
};

/** aggregate max on columns */
export type Questions_Max_Fields = {
  __typename?: 'questions_max_fields';
  all_option?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Scalars['String']>>;
  default?: Maybe<Scalars['String']>;
  dont_know_answer?: Maybe<Scalars['String']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  none_option?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Questions_Min_Fields = {
  __typename?: 'questions_min_fields';
  all_option?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Scalars['String']>>;
  default?: Maybe<Scalars['String']>;
  dont_know_answer?: Maybe<Scalars['String']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  helper_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  none_option?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "questions" */
export type Questions_Mutation_Response = {
  __typename?: 'questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Questions>;
};

/** input type for inserting object relation for remote table "questions" */
export type Questions_Obj_Rel_Insert_Input = {
  data: Questions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questions_On_Conflict>;
};

/** on_conflict condition type for table "questions" */
export type Questions_On_Conflict = {
  constraint: Questions_Constraint;
  update_columns?: Array<Questions_Update_Column>;
  where?: InputMaybe<Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "questions". */
export type Questions_Order_By = {
  all_option?: InputMaybe<Order_By>;
  answers?: InputMaybe<Order_By>;
  default?: InputMaybe<Order_By>;
  dont_know_answer?: InputMaybe<Order_By>;
  double_text_combo_helper_texts?: InputMaybe<Order_By>;
  dropdown_combo_answers?: InputMaybe<Order_By>;
  dropdown_label_1?: InputMaybe<Order_By>;
  dropdown_label_2?: InputMaybe<Order_By>;
  helper_text?: InputMaybe<Order_By>;
  helper_text_position?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement_unit?: InputMaybe<Order_By>;
  none_option?: InputMaybe<Order_By>;
  response_property?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  ui_control?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questions */
export type Questions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Questions_Prepend_Input = {
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "questions" */
export enum Questions_Select_Column {
  /** column name */
  AllOption = 'all_option',
  /** column name */
  Answers = 'answers',
  /** column name */
  Default = 'default',
  /** column name */
  DontKnowAnswer = 'dont_know_answer',
  /** column name */
  DoubleTextComboHelperTexts = 'double_text_combo_helper_texts',
  /** column name */
  DropdownComboAnswers = 'dropdown_combo_answers',
  /** column name */
  DropdownLabel_1 = 'dropdown_label_1',
  /** column name */
  DropdownLabel_2 = 'dropdown_label_2',
  /** column name */
  HelperText = 'helper_text',
  /** column name */
  HelperTextPosition = 'helper_text_position',
  /** column name */
  Id = 'id',
  /** column name */
  MeasurementUnit = 'measurement_unit',
  /** column name */
  NoneOption = 'none_option',
  /** column name */
  ResponseProperty = 'response_property',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  UiControl = 'ui_control'
}

/** input type for updating data in table "questions" */
export type Questions_Set_Input = {
  all_option?: InputMaybe<Scalars['String']>;
  answers?: InputMaybe<Array<Scalars['String']>>;
  default?: InputMaybe<Scalars['String']>;
  dont_know_answer?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
  dropdown_label_1?: InputMaybe<Scalars['String']>;
  dropdown_label_2?: InputMaybe<Scalars['String']>;
  helper_text?: InputMaybe<Scalars['String']>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum>;
  none_option?: InputMaybe<Scalars['String']>;
  response_property?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Question_Types_Enum>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum>;
};

/** aggregate stddev on columns */
export type Questions_Stddev_Fields = {
  __typename?: 'questions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Questions_Stddev_Pop_Fields = {
  __typename?: 'questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Questions_Stddev_Samp_Fields = {
  __typename?: 'questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "questions" */
export type Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questions_Stream_Cursor_Value_Input = {
  all_option?: InputMaybe<Scalars['String']>;
  answers?: InputMaybe<Array<Scalars['String']>>;
  default?: InputMaybe<Scalars['String']>;
  dont_know_answer?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
  dropdown_label_1?: InputMaybe<Scalars['String']>;
  dropdown_label_2?: InputMaybe<Scalars['String']>;
  helper_text?: InputMaybe<Scalars['String']>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum>;
  none_option?: InputMaybe<Scalars['String']>;
  response_property?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Question_Types_Enum>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum>;
};

/** aggregate sum on columns */
export type Questions_Sum_Fields = {
  __typename?: 'questions_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "questions" */
export enum Questions_Update_Column {
  /** column name */
  AllOption = 'all_option',
  /** column name */
  Answers = 'answers',
  /** column name */
  Default = 'default',
  /** column name */
  DontKnowAnswer = 'dont_know_answer',
  /** column name */
  DoubleTextComboHelperTexts = 'double_text_combo_helper_texts',
  /** column name */
  DropdownComboAnswers = 'dropdown_combo_answers',
  /** column name */
  DropdownLabel_1 = 'dropdown_label_1',
  /** column name */
  DropdownLabel_2 = 'dropdown_label_2',
  /** column name */
  HelperText = 'helper_text',
  /** column name */
  HelperTextPosition = 'helper_text_position',
  /** column name */
  Id = 'id',
  /** column name */
  MeasurementUnit = 'measurement_unit',
  /** column name */
  NoneOption = 'none_option',
  /** column name */
  ResponseProperty = 'response_property',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  UiControl = 'ui_control'
}

export type Questions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Questions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Questions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Questions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Questions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Questions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questions_Var_Pop_Fields = {
  __typename?: 'questions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Questions_Var_Samp_Fields = {
  __typename?: 'questions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Questions_Variance_Fields = {
  __typename?: 'questions_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "recommendations" */
export type Recommendations = {
  __typename?: 'recommendations';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  product: Products;
  product_id: Scalars['Int'];
  reminder_sent: Scalars['Boolean'];
  service_request_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "recommendations" */
export type Recommendations_Aggregate = {
  __typename?: 'recommendations_aggregate';
  aggregate?: Maybe<Recommendations_Aggregate_Fields>;
  nodes: Array<Recommendations>;
};

/** aggregate fields of "recommendations" */
export type Recommendations_Aggregate_Fields = {
  __typename?: 'recommendations_aggregate_fields';
  avg?: Maybe<Recommendations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Recommendations_Max_Fields>;
  min?: Maybe<Recommendations_Min_Fields>;
  stddev?: Maybe<Recommendations_Stddev_Fields>;
  stddev_pop?: Maybe<Recommendations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Recommendations_Stddev_Samp_Fields>;
  sum?: Maybe<Recommendations_Sum_Fields>;
  var_pop?: Maybe<Recommendations_Var_Pop_Fields>;
  var_samp?: Maybe<Recommendations_Var_Samp_Fields>;
  variance?: Maybe<Recommendations_Variance_Fields>;
};


/** aggregate fields of "recommendations" */
export type Recommendations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Recommendations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Recommendations_Avg_Fields = {
  __typename?: 'recommendations_avg_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "recommendations". All fields are combined with a logical 'AND'. */
export type Recommendations_Bool_Exp = {
  _and?: InputMaybe<Array<Recommendations_Bool_Exp>>;
  _not?: InputMaybe<Recommendations_Bool_Exp>;
  _or?: InputMaybe<Array<Recommendations_Bool_Exp>>;
  appointment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  reminder_sent?: InputMaybe<Boolean_Comparison_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "recommendations" */
export enum Recommendations_Constraint {
  /** unique or primary key constraint on columns "id" */
  RecommendationsPkey = 'recommendations_pkey'
}

/** input type for incrementing numeric columns in table "recommendations" */
export type Recommendations_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "recommendations" */
export type Recommendations_Insert_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['Int']>;
  reminder_sent?: InputMaybe<Scalars['Boolean']>;
  service_request_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Recommendations_Max_Fields = {
  __typename?: 'recommendations_max_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  service_request_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Recommendations_Min_Fields = {
  __typename?: 'recommendations_min_fields';
  appointment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  service_request_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "recommendations" */
export type Recommendations_Mutation_Response = {
  __typename?: 'recommendations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recommendations>;
};

/** on_conflict condition type for table "recommendations" */
export type Recommendations_On_Conflict = {
  constraint: Recommendations_Constraint;
  update_columns?: Array<Recommendations_Update_Column>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};

/** Ordering options when selecting data from "recommendations". */
export type Recommendations_Order_By = {
  appointment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  reminder_sent?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: recommendations */
export type Recommendations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "recommendations" */
export enum Recommendations_Select_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ReminderSent = 'reminder_sent',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "recommendations" */
export type Recommendations_Set_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  reminder_sent?: InputMaybe<Scalars['Boolean']>;
  service_request_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Recommendations_Stddev_Fields = {
  __typename?: 'recommendations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Recommendations_Stddev_Pop_Fields = {
  __typename?: 'recommendations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Recommendations_Stddev_Samp_Fields = {
  __typename?: 'recommendations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "recommendations" */
export type Recommendations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recommendations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Recommendations_Stream_Cursor_Value_Input = {
  appointment_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  product_id?: InputMaybe<Scalars['Int']>;
  reminder_sent?: InputMaybe<Scalars['Boolean']>;
  service_request_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Recommendations_Sum_Fields = {
  __typename?: 'recommendations_sum_fields';
  id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "recommendations" */
export enum Recommendations_Update_Column {
  /** column name */
  AppointmentId = 'appointment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ReminderSent = 'reminder_sent',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Recommendations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Recommendations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Recommendations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Recommendations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Recommendations_Var_Pop_Fields = {
  __typename?: 'recommendations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Recommendations_Var_Samp_Fields = {
  __typename?: 'recommendations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Recommendations_Variance_Fields = {
  __typename?: 'recommendations_variance_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata = {
  __typename?: 'shipmonk_sync_metadata';
  id: Scalars['Int'];
  last_successful_sync_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Aggregate = {
  __typename?: 'shipmonk_sync_metadata_aggregate';
  aggregate?: Maybe<Shipmonk_Sync_Metadata_Aggregate_Fields>;
  nodes: Array<Shipmonk_Sync_Metadata>;
};

/** aggregate fields of "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Aggregate_Fields = {
  __typename?: 'shipmonk_sync_metadata_aggregate_fields';
  avg?: Maybe<Shipmonk_Sync_Metadata_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Shipmonk_Sync_Metadata_Max_Fields>;
  min?: Maybe<Shipmonk_Sync_Metadata_Min_Fields>;
  stddev?: Maybe<Shipmonk_Sync_Metadata_Stddev_Fields>;
  stddev_pop?: Maybe<Shipmonk_Sync_Metadata_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shipmonk_Sync_Metadata_Stddev_Samp_Fields>;
  sum?: Maybe<Shipmonk_Sync_Metadata_Sum_Fields>;
  var_pop?: Maybe<Shipmonk_Sync_Metadata_Var_Pop_Fields>;
  var_samp?: Maybe<Shipmonk_Sync_Metadata_Var_Samp_Fields>;
  variance?: Maybe<Shipmonk_Sync_Metadata_Variance_Fields>;
};


/** aggregate fields of "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shipmonk_Sync_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Shipmonk_Sync_Metadata_Avg_Fields = {
  __typename?: 'shipmonk_sync_metadata_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "shipmonk_sync_metadata". All fields are combined with a logical 'AND'. */
export type Shipmonk_Sync_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Shipmonk_Sync_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Shipmonk_Sync_Metadata_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_successful_sync_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shipmonk_sync_metadata" */
export enum Shipmonk_Sync_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShipmonkSyncMetadataPkey = 'shipmonk_sync_metadata_pkey'
}

/** input type for incrementing numeric columns in table "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  last_successful_sync_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Shipmonk_Sync_Metadata_Max_Fields = {
  __typename?: 'shipmonk_sync_metadata_max_fields';
  id?: Maybe<Scalars['Int']>;
  last_successful_sync_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Shipmonk_Sync_Metadata_Min_Fields = {
  __typename?: 'shipmonk_sync_metadata_min_fields';
  id?: Maybe<Scalars['Int']>;
  last_successful_sync_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Mutation_Response = {
  __typename?: 'shipmonk_sync_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Shipmonk_Sync_Metadata>;
};

/** on_conflict condition type for table "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_On_Conflict = {
  constraint: Shipmonk_Sync_Metadata_Constraint;
  update_columns?: Array<Shipmonk_Sync_Metadata_Update_Column>;
  where?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "shipmonk_sync_metadata". */
export type Shipmonk_Sync_Metadata_Order_By = {
  id?: InputMaybe<Order_By>;
  last_successful_sync_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shipmonk_sync_metadata */
export type Shipmonk_Sync_Metadata_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "shipmonk_sync_metadata" */
export enum Shipmonk_Sync_Metadata_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LastSuccessfulSyncAt = 'last_successful_sync_at'
}

/** input type for updating data in table "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  last_successful_sync_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Shipmonk_Sync_Metadata_Stddev_Fields = {
  __typename?: 'shipmonk_sync_metadata_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Shipmonk_Sync_Metadata_Stddev_Pop_Fields = {
  __typename?: 'shipmonk_sync_metadata_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Shipmonk_Sync_Metadata_Stddev_Samp_Fields = {
  __typename?: 'shipmonk_sync_metadata_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "shipmonk_sync_metadata" */
export type Shipmonk_Sync_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shipmonk_Sync_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shipmonk_Sync_Metadata_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  last_successful_sync_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Shipmonk_Sync_Metadata_Sum_Fields = {
  __typename?: 'shipmonk_sync_metadata_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "shipmonk_sync_metadata" */
export enum Shipmonk_Sync_Metadata_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LastSuccessfulSyncAt = 'last_successful_sync_at'
}

export type Shipmonk_Sync_Metadata_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Shipmonk_Sync_Metadata_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shipmonk_Sync_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shipmonk_Sync_Metadata_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Shipmonk_Sync_Metadata_Var_Pop_Fields = {
  __typename?: 'shipmonk_sync_metadata_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Shipmonk_Sync_Metadata_Var_Samp_Fields = {
  __typename?: 'shipmonk_sync_metadata_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Shipmonk_Sync_Metadata_Variance_Fields = {
  __typename?: 'shipmonk_sync_metadata_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "skintelligent_tests" */
export type Skintelligent_Tests = {
  __typename?: 'skintelligent_tests';
  comedone?: Maybe<Scalars['Int']>;
  errors?: Maybe<Scalars['jsonb']>;
  image_source?: Maybe<Image_Source_Types_Enum>;
  inflammatory?: Maybe<Scalars['Int']>;
  original_image_id?: Maybe<Scalars['uuid']>;
  overall_score?: Maybe<Scalars['numeric']>;
  pih?: Maybe<Scalars['Int']>;
  raw_data?: Maybe<Scalars['jsonb']>;
  report_id?: Maybe<Scalars['uuid']>;
  result_image_id?: Maybe<Scalars['uuid']>;
  result_processed?: Maybe<Scalars['Boolean']>;
  session_id: Scalars['String'];
  /** An object relationship */
  skintelligent_tests_image_source_type?: Maybe<Image_Source_Types>;
  /** An object relationship */
  skintelligent_tests_original_image?: Maybe<Files>;
  /** An object relationship */
  skintelligent_tests_report?: Maybe<Files>;
  /** An object relationship */
  skintelligent_tests_result_image?: Maybe<Files>;
  /** An object relationship */
  skintelligent_tests_test: Tests;
  test_id: Scalars['uuid'];
  total_lesions?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "skintelligent_tests" */
export type Skintelligent_TestsErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "skintelligent_tests" */
export type Skintelligent_TestsRaw_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "skintelligent_tests" */
export type Skintelligent_Tests_Aggregate = {
  __typename?: 'skintelligent_tests_aggregate';
  aggregate?: Maybe<Skintelligent_Tests_Aggregate_Fields>;
  nodes: Array<Skintelligent_Tests>;
};

/** aggregate fields of "skintelligent_tests" */
export type Skintelligent_Tests_Aggregate_Fields = {
  __typename?: 'skintelligent_tests_aggregate_fields';
  avg?: Maybe<Skintelligent_Tests_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skintelligent_Tests_Max_Fields>;
  min?: Maybe<Skintelligent_Tests_Min_Fields>;
  stddev?: Maybe<Skintelligent_Tests_Stddev_Fields>;
  stddev_pop?: Maybe<Skintelligent_Tests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skintelligent_Tests_Stddev_Samp_Fields>;
  sum?: Maybe<Skintelligent_Tests_Sum_Fields>;
  var_pop?: Maybe<Skintelligent_Tests_Var_Pop_Fields>;
  var_samp?: Maybe<Skintelligent_Tests_Var_Samp_Fields>;
  variance?: Maybe<Skintelligent_Tests_Variance_Fields>;
};


/** aggregate fields of "skintelligent_tests" */
export type Skintelligent_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Skintelligent_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Skintelligent_Tests_Append_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Skintelligent_Tests_Avg_Fields = {
  __typename?: 'skintelligent_tests_avg_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skintelligent_tests". All fields are combined with a logical 'AND'. */
export type Skintelligent_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Skintelligent_Tests_Bool_Exp>>;
  _not?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Skintelligent_Tests_Bool_Exp>>;
  comedone?: InputMaybe<Int_Comparison_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  image_source?: InputMaybe<Image_Source_Types_Enum_Comparison_Exp>;
  inflammatory?: InputMaybe<Int_Comparison_Exp>;
  original_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  overall_score?: InputMaybe<Numeric_Comparison_Exp>;
  pih?: InputMaybe<Int_Comparison_Exp>;
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>;
  report_id?: InputMaybe<Uuid_Comparison_Exp>;
  result_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  result_processed?: InputMaybe<Boolean_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  skintelligent_tests_image_source_type?: InputMaybe<Image_Source_Types_Bool_Exp>;
  skintelligent_tests_original_image?: InputMaybe<Files_Bool_Exp>;
  skintelligent_tests_report?: InputMaybe<Files_Bool_Exp>;
  skintelligent_tests_result_image?: InputMaybe<Files_Bool_Exp>;
  skintelligent_tests_test?: InputMaybe<Tests_Bool_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_lesions?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "skintelligent_tests" */
export enum Skintelligent_Tests_Constraint {
  /** unique or primary key constraint on columns "test_id" */
  SkintelligentTestsPkey = 'skintelligent_tests_pkey',
  /** unique or primary key constraint on columns "session_id" */
  SkintelligentTestsSessionIdKey = 'skintelligent_tests_session_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Skintelligent_Tests_Delete_At_Path_Input = {
  errors?: InputMaybe<Array<Scalars['String']>>;
  raw_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Skintelligent_Tests_Delete_Elem_Input = {
  errors?: InputMaybe<Scalars['Int']>;
  raw_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Skintelligent_Tests_Delete_Key_Input = {
  errors?: InputMaybe<Scalars['String']>;
  raw_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "skintelligent_tests" */
export type Skintelligent_Tests_Inc_Input = {
  comedone?: InputMaybe<Scalars['Int']>;
  inflammatory?: InputMaybe<Scalars['Int']>;
  overall_score?: InputMaybe<Scalars['numeric']>;
  pih?: InputMaybe<Scalars['Int']>;
  total_lesions?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "skintelligent_tests" */
export type Skintelligent_Tests_Insert_Input = {
  comedone?: InputMaybe<Scalars['Int']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  image_source?: InputMaybe<Image_Source_Types_Enum>;
  inflammatory?: InputMaybe<Scalars['Int']>;
  original_image_id?: InputMaybe<Scalars['uuid']>;
  overall_score?: InputMaybe<Scalars['numeric']>;
  pih?: InputMaybe<Scalars['Int']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  result_image_id?: InputMaybe<Scalars['uuid']>;
  result_processed?: InputMaybe<Scalars['Boolean']>;
  session_id?: InputMaybe<Scalars['String']>;
  skintelligent_tests_image_source_type?: InputMaybe<Image_Source_Types_Obj_Rel_Insert_Input>;
  skintelligent_tests_original_image?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  skintelligent_tests_report?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  skintelligent_tests_result_image?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  skintelligent_tests_test?: InputMaybe<Tests_Obj_Rel_Insert_Input>;
  test_id?: InputMaybe<Scalars['uuid']>;
  total_lesions?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Skintelligent_Tests_Max_Fields = {
  __typename?: 'skintelligent_tests_max_fields';
  comedone?: Maybe<Scalars['Int']>;
  inflammatory?: Maybe<Scalars['Int']>;
  original_image_id?: Maybe<Scalars['uuid']>;
  overall_score?: Maybe<Scalars['numeric']>;
  pih?: Maybe<Scalars['Int']>;
  report_id?: Maybe<Scalars['uuid']>;
  result_image_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  total_lesions?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Skintelligent_Tests_Min_Fields = {
  __typename?: 'skintelligent_tests_min_fields';
  comedone?: Maybe<Scalars['Int']>;
  inflammatory?: Maybe<Scalars['Int']>;
  original_image_id?: Maybe<Scalars['uuid']>;
  overall_score?: Maybe<Scalars['numeric']>;
  pih?: Maybe<Scalars['Int']>;
  report_id?: Maybe<Scalars['uuid']>;
  result_image_id?: Maybe<Scalars['uuid']>;
  session_id?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  total_lesions?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "skintelligent_tests" */
export type Skintelligent_Tests_Mutation_Response = {
  __typename?: 'skintelligent_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skintelligent_Tests>;
};

/** on_conflict condition type for table "skintelligent_tests" */
export type Skintelligent_Tests_On_Conflict = {
  constraint: Skintelligent_Tests_Constraint;
  update_columns?: Array<Skintelligent_Tests_Update_Column>;
  where?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "skintelligent_tests". */
export type Skintelligent_Tests_Order_By = {
  comedone?: InputMaybe<Order_By>;
  errors?: InputMaybe<Order_By>;
  image_source?: InputMaybe<Order_By>;
  inflammatory?: InputMaybe<Order_By>;
  original_image_id?: InputMaybe<Order_By>;
  overall_score?: InputMaybe<Order_By>;
  pih?: InputMaybe<Order_By>;
  raw_data?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  result_image_id?: InputMaybe<Order_By>;
  result_processed?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  skintelligent_tests_image_source_type?: InputMaybe<Image_Source_Types_Order_By>;
  skintelligent_tests_original_image?: InputMaybe<Files_Order_By>;
  skintelligent_tests_report?: InputMaybe<Files_Order_By>;
  skintelligent_tests_result_image?: InputMaybe<Files_Order_By>;
  skintelligent_tests_test?: InputMaybe<Tests_Order_By>;
  test_id?: InputMaybe<Order_By>;
  total_lesions?: InputMaybe<Order_By>;
};

/** primary key columns input for table: skintelligent_tests */
export type Skintelligent_Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Skintelligent_Tests_Prepend_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "skintelligent_tests" */
export enum Skintelligent_Tests_Select_Column {
  /** column name */
  Comedone = 'comedone',
  /** column name */
  Errors = 'errors',
  /** column name */
  ImageSource = 'image_source',
  /** column name */
  Inflammatory = 'inflammatory',
  /** column name */
  OriginalImageId = 'original_image_id',
  /** column name */
  OverallScore = 'overall_score',
  /** column name */
  Pih = 'pih',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ResultImageId = 'result_image_id',
  /** column name */
  ResultProcessed = 'result_processed',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TotalLesions = 'total_lesions'
}

/** input type for updating data in table "skintelligent_tests" */
export type Skintelligent_Tests_Set_Input = {
  comedone?: InputMaybe<Scalars['Int']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  image_source?: InputMaybe<Image_Source_Types_Enum>;
  inflammatory?: InputMaybe<Scalars['Int']>;
  original_image_id?: InputMaybe<Scalars['uuid']>;
  overall_score?: InputMaybe<Scalars['numeric']>;
  pih?: InputMaybe<Scalars['Int']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  result_image_id?: InputMaybe<Scalars['uuid']>;
  result_processed?: InputMaybe<Scalars['Boolean']>;
  session_id?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  total_lesions?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Skintelligent_Tests_Stddev_Fields = {
  __typename?: 'skintelligent_tests_stddev_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skintelligent_Tests_Stddev_Pop_Fields = {
  __typename?: 'skintelligent_tests_stddev_pop_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skintelligent_Tests_Stddev_Samp_Fields = {
  __typename?: 'skintelligent_tests_stddev_samp_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skintelligent_tests" */
export type Skintelligent_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skintelligent_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skintelligent_Tests_Stream_Cursor_Value_Input = {
  comedone?: InputMaybe<Scalars['Int']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  image_source?: InputMaybe<Image_Source_Types_Enum>;
  inflammatory?: InputMaybe<Scalars['Int']>;
  original_image_id?: InputMaybe<Scalars['uuid']>;
  overall_score?: InputMaybe<Scalars['numeric']>;
  pih?: InputMaybe<Scalars['Int']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  result_image_id?: InputMaybe<Scalars['uuid']>;
  result_processed?: InputMaybe<Scalars['Boolean']>;
  session_id?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  total_lesions?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Skintelligent_Tests_Sum_Fields = {
  __typename?: 'skintelligent_tests_sum_fields';
  comedone?: Maybe<Scalars['Int']>;
  inflammatory?: Maybe<Scalars['Int']>;
  overall_score?: Maybe<Scalars['numeric']>;
  pih?: Maybe<Scalars['Int']>;
  total_lesions?: Maybe<Scalars['Int']>;
};

/** update columns of table "skintelligent_tests" */
export enum Skintelligent_Tests_Update_Column {
  /** column name */
  Comedone = 'comedone',
  /** column name */
  Errors = 'errors',
  /** column name */
  ImageSource = 'image_source',
  /** column name */
  Inflammatory = 'inflammatory',
  /** column name */
  OriginalImageId = 'original_image_id',
  /** column name */
  OverallScore = 'overall_score',
  /** column name */
  Pih = 'pih',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  ResultImageId = 'result_image_id',
  /** column name */
  ResultProcessed = 'result_processed',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TotalLesions = 'total_lesions'
}

export type Skintelligent_Tests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Skintelligent_Tests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Skintelligent_Tests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Skintelligent_Tests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Skintelligent_Tests_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Skintelligent_Tests_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Skintelligent_Tests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Skintelligent_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Skintelligent_Tests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skintelligent_Tests_Var_Pop_Fields = {
  __typename?: 'skintelligent_tests_var_pop_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skintelligent_Tests_Var_Samp_Fields = {
  __typename?: 'skintelligent_tests_var_samp_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skintelligent_Tests_Variance_Fields = {
  __typename?: 'skintelligent_tests_variance_fields';
  comedone?: Maybe<Scalars['Float']>;
  inflammatory?: Maybe<Scalars['Float']>;
  overall_score?: Maybe<Scalars['Float']>;
  pih?: Maybe<Scalars['Float']>;
  total_lesions?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['smallint']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['smallint']>>;
  _eq?: InputMaybe<Array<Scalars['smallint']>>;
  _gt?: InputMaybe<Array<Scalars['smallint']>>;
  _gte?: InputMaybe<Array<Scalars['smallint']>>;
  _in?: InputMaybe<Array<Array<Scalars['smallint']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['smallint']>>;
  _lte?: InputMaybe<Array<Scalars['smallint']>>;
  _neq?: InputMaybe<Array<Scalars['smallint']>>;
  _nin?: InputMaybe<Array<Array<Scalars['smallint']>>>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "stripe_billing_plans" */
export type Stripe_Billing_Plans = {
  __typename?: 'stripe_billing_plans';
  active: Scalars['Boolean'];
  amount_cents: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  interval: Scalars['String'];
  interval_count: Scalars['Int'];
  name: Scalars['String'];
  stripe_price_id: Scalars['String'];
  stripe_product_id: Scalars['String'];
  trial_period_days?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "stripe_billing_plans" */
export type Stripe_Billing_Plans_Aggregate = {
  __typename?: 'stripe_billing_plans_aggregate';
  aggregate?: Maybe<Stripe_Billing_Plans_Aggregate_Fields>;
  nodes: Array<Stripe_Billing_Plans>;
};

/** aggregate fields of "stripe_billing_plans" */
export type Stripe_Billing_Plans_Aggregate_Fields = {
  __typename?: 'stripe_billing_plans_aggregate_fields';
  avg?: Maybe<Stripe_Billing_Plans_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Billing_Plans_Max_Fields>;
  min?: Maybe<Stripe_Billing_Plans_Min_Fields>;
  stddev?: Maybe<Stripe_Billing_Plans_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Billing_Plans_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Billing_Plans_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Billing_Plans_Sum_Fields>;
  var_pop?: Maybe<Stripe_Billing_Plans_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Billing_Plans_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Billing_Plans_Variance_Fields>;
};


/** aggregate fields of "stripe_billing_plans" */
export type Stripe_Billing_Plans_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Billing_Plans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Billing_Plans_Avg_Fields = {
  __typename?: 'stripe_billing_plans_avg_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe_billing_plans". All fields are combined with a logical 'AND'. */
export type Stripe_Billing_Plans_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Billing_Plans_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Billing_Plans_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  amount_cents?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  interval?: InputMaybe<String_Comparison_Exp>;
  interval_count?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stripe_price_id?: InputMaybe<String_Comparison_Exp>;
  stripe_product_id?: InputMaybe<String_Comparison_Exp>;
  trial_period_days?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe_billing_plans" */
export enum Stripe_Billing_Plans_Constraint {
  /** unique or primary key constraint on columns "name" */
  StripeBillingPlansNameKey = 'stripe_billing_plans_name_key',
  /** unique or primary key constraint on columns "id" */
  StripeBillingPlansPkey = 'stripe_billing_plans_pkey'
}

/** input type for incrementing numeric columns in table "stripe_billing_plans" */
export type Stripe_Billing_Plans_Inc_Input = {
  amount_cents?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  trial_period_days?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_billing_plans" */
export type Stripe_Billing_Plans_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['String']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  trial_period_days?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stripe_Billing_Plans_Max_Fields = {
  __typename?: 'stripe_billing_plans_max_fields';
  amount_cents?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['String']>;
  interval_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  trial_period_days?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Stripe_Billing_Plans_Min_Fields = {
  __typename?: 'stripe_billing_plans_min_fields';
  amount_cents?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['String']>;
  interval_count?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  trial_period_days?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "stripe_billing_plans" */
export type Stripe_Billing_Plans_Mutation_Response = {
  __typename?: 'stripe_billing_plans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Billing_Plans>;
};

/** input type for inserting object relation for remote table "stripe_billing_plans" */
export type Stripe_Billing_Plans_Obj_Rel_Insert_Input = {
  data: Stripe_Billing_Plans_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stripe_Billing_Plans_On_Conflict>;
};

/** on_conflict condition type for table "stripe_billing_plans" */
export type Stripe_Billing_Plans_On_Conflict = {
  constraint: Stripe_Billing_Plans_Constraint;
  update_columns?: Array<Stripe_Billing_Plans_Update_Column>;
  where?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe_billing_plans". */
export type Stripe_Billing_Plans_Order_By = {
  active?: InputMaybe<Order_By>;
  amount_cents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stripe_price_id?: InputMaybe<Order_By>;
  stripe_product_id?: InputMaybe<Order_By>;
  trial_period_days?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe_billing_plans */
export type Stripe_Billing_Plans_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stripe_billing_plans" */
export enum Stripe_Billing_Plans_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AmountCents = 'amount_cents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Name = 'name',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  TrialPeriodDays = 'trial_period_days',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "stripe_billing_plans" */
export type Stripe_Billing_Plans_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['String']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  trial_period_days?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stripe_Billing_Plans_Stddev_Fields = {
  __typename?: 'stripe_billing_plans_stddev_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Billing_Plans_Stddev_Pop_Fields = {
  __typename?: 'stripe_billing_plans_stddev_pop_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Billing_Plans_Stddev_Samp_Fields = {
  __typename?: 'stripe_billing_plans_stddev_samp_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_billing_plans" */
export type Stripe_Billing_Plans_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Billing_Plans_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Billing_Plans_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Scalars['String']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  trial_period_days?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stripe_Billing_Plans_Sum_Fields = {
  __typename?: 'stripe_billing_plans_sum_fields';
  amount_cents?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['Int']>;
  trial_period_days?: Maybe<Scalars['Int']>;
};

/** update columns of table "stripe_billing_plans" */
export enum Stripe_Billing_Plans_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AmountCents = 'amount_cents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Name = 'name',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  TrialPeriodDays = 'trial_period_days',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stripe_Billing_Plans_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Billing_Plans_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Billing_Plans_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Billing_Plans_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Billing_Plans_Var_Pop_Fields = {
  __typename?: 'stripe_billing_plans_var_pop_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Billing_Plans_Var_Samp_Fields = {
  __typename?: 'stripe_billing_plans_var_samp_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Billing_Plans_Variance_Fields = {
  __typename?: 'stripe_billing_plans_variance_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "stripe_customers" */
export type Stripe_Customers = {
  __typename?: 'stripe_customers';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  stripe_customer_id: Scalars['String'];
  /** An array relationship */
  stripe_payment_methods: Array<Stripe_Payment_Methods>;
  /** An aggregate relationship */
  stripe_payment_methods_aggregate: Stripe_Payment_Methods_Aggregate;
  /** An array relationship */
  stripe_subscriptions: Array<Stripe_Subscriptions>;
  /** An aggregate relationship */
  stripe_subscriptions_aggregate: Stripe_Subscriptions_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "stripe_customers" */
export type Stripe_CustomersStripe_Payment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Methods_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "stripe_customers" */
export type Stripe_CustomersStripe_Payment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Methods_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


/** columns and relationships of "stripe_customers" */
export type Stripe_CustomersStripe_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Subscriptions_Order_By>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "stripe_customers" */
export type Stripe_CustomersStripe_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Subscriptions_Order_By>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};

/** aggregated selection of "stripe_customers" */
export type Stripe_Customers_Aggregate = {
  __typename?: 'stripe_customers_aggregate';
  aggregate?: Maybe<Stripe_Customers_Aggregate_Fields>;
  nodes: Array<Stripe_Customers>;
};

export type Stripe_Customers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Stripe_Customers_Aggregate_Bool_Exp_Count>;
};

export type Stripe_Customers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Stripe_Customers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "stripe_customers" */
export type Stripe_Customers_Aggregate_Fields = {
  __typename?: 'stripe_customers_aggregate_fields';
  avg?: Maybe<Stripe_Customers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Customers_Max_Fields>;
  min?: Maybe<Stripe_Customers_Min_Fields>;
  stddev?: Maybe<Stripe_Customers_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Customers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Customers_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Customers_Sum_Fields>;
  var_pop?: Maybe<Stripe_Customers_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Customers_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Customers_Variance_Fields>;
};


/** aggregate fields of "stripe_customers" */
export type Stripe_Customers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stripe_customers" */
export type Stripe_Customers_Aggregate_Order_By = {
  avg?: InputMaybe<Stripe_Customers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stripe_Customers_Max_Order_By>;
  min?: InputMaybe<Stripe_Customers_Min_Order_By>;
  stddev?: InputMaybe<Stripe_Customers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stripe_Customers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stripe_Customers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stripe_Customers_Sum_Order_By>;
  var_pop?: InputMaybe<Stripe_Customers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stripe_Customers_Var_Samp_Order_By>;
  variance?: InputMaybe<Stripe_Customers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stripe_customers" */
export type Stripe_Customers_Arr_Rel_Insert_Input = {
  data: Array<Stripe_Customers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stripe_Customers_On_Conflict>;
};

/** aggregate avg on columns */
export type Stripe_Customers_Avg_Fields = {
  __typename?: 'stripe_customers_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stripe_customers" */
export type Stripe_Customers_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stripe_customers". All fields are combined with a logical 'AND'. */
export type Stripe_Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Customers_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Customers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_methods?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
  stripe_payment_methods_aggregate?: InputMaybe<Stripe_Payment_Methods_Aggregate_Bool_Exp>;
  stripe_subscriptions?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
  stripe_subscriptions_aggregate?: InputMaybe<Stripe_Subscriptions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe_customers" */
export enum Stripe_Customers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StripeCustomersPkey = 'stripe_customers_pkey',
  /** unique or primary key constraint on columns "user_id", "stripe_customer_id" */
  StripeCustomersUserIdCustomerIdKey = 'stripe_customers_user_id_customer_id_key'
}

/** input type for incrementing numeric columns in table "stripe_customers" */
export type Stripe_Customers_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_customers" */
export type Stripe_Customers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  stripe_payment_methods?: InputMaybe<Stripe_Payment_Methods_Arr_Rel_Insert_Input>;
  stripe_subscriptions?: InputMaybe<Stripe_Subscriptions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Stripe_Customers_Max_Fields = {
  __typename?: 'stripe_customers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "stripe_customers" */
export type Stripe_Customers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stripe_Customers_Min_Fields = {
  __typename?: 'stripe_customers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "stripe_customers" */
export type Stripe_Customers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stripe_customers" */
export type Stripe_Customers_Mutation_Response = {
  __typename?: 'stripe_customers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Customers>;
};

/** input type for inserting object relation for remote table "stripe_customers" */
export type Stripe_Customers_Obj_Rel_Insert_Input = {
  data: Stripe_Customers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Stripe_Customers_On_Conflict>;
};

/** on_conflict condition type for table "stripe_customers" */
export type Stripe_Customers_On_Conflict = {
  constraint: Stripe_Customers_Constraint;
  update_columns?: Array<Stripe_Customers_Update_Column>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe_customers". */
export type Stripe_Customers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  stripe_payment_methods_aggregate?: InputMaybe<Stripe_Payment_Methods_Aggregate_Order_By>;
  stripe_subscriptions_aggregate?: InputMaybe<Stripe_Subscriptions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe_customers */
export type Stripe_Customers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stripe_customers" */
export enum Stripe_Customers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "stripe_customers" */
export type Stripe_Customers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Stripe_Customers_Stddev_Fields = {
  __typename?: 'stripe_customers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stripe_customers" */
export type Stripe_Customers_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Customers_Stddev_Pop_Fields = {
  __typename?: 'stripe_customers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stripe_customers" */
export type Stripe_Customers_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Customers_Stddev_Samp_Fields = {
  __typename?: 'stripe_customers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stripe_customers" */
export type Stripe_Customers_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stripe_customers" */
export type Stripe_Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Customers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Stripe_Customers_Sum_Fields = {
  __typename?: 'stripe_customers_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stripe_customers" */
export type Stripe_Customers_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "stripe_customers" */
export enum Stripe_Customers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Stripe_Customers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Customers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Customers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Customers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Customers_Var_Pop_Fields = {
  __typename?: 'stripe_customers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stripe_customers" */
export type Stripe_Customers_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stripe_Customers_Var_Samp_Fields = {
  __typename?: 'stripe_customers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stripe_customers" */
export type Stripe_Customers_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stripe_Customers_Variance_Fields = {
  __typename?: 'stripe_customers_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stripe_customers" */
export type Stripe_Customers_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "stripe_latest_subscription_per_user_view" */
export type Stripe_Latest_Subscription_Per_User_View = {
  __typename?: 'stripe_latest_subscription_per_user_view';
  billing_plan_id?: Maybe<Scalars['Int']>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['timestamptz']>;
  current_period_start?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  row_number?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['Int']>;
  /** An object relationship */
  stripe_customer?: Maybe<Stripe_Customers>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "stripe_latest_subscription_per_user_view" */
export type Stripe_Latest_Subscription_Per_User_View_Aggregate = {
  __typename?: 'stripe_latest_subscription_per_user_view_aggregate';
  aggregate?: Maybe<Stripe_Latest_Subscription_Per_User_View_Aggregate_Fields>;
  nodes: Array<Stripe_Latest_Subscription_Per_User_View>;
};

/** aggregate fields of "stripe_latest_subscription_per_user_view" */
export type Stripe_Latest_Subscription_Per_User_View_Aggregate_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_aggregate_fields';
  avg?: Maybe<Stripe_Latest_Subscription_Per_User_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Latest_Subscription_Per_User_View_Max_Fields>;
  min?: Maybe<Stripe_Latest_Subscription_Per_User_View_Min_Fields>;
  stddev?: Maybe<Stripe_Latest_Subscription_Per_User_View_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Latest_Subscription_Per_User_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Latest_Subscription_Per_User_View_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Latest_Subscription_Per_User_View_Sum_Fields>;
  var_pop?: Maybe<Stripe_Latest_Subscription_Per_User_View_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Latest_Subscription_Per_User_View_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Latest_Subscription_Per_User_View_Variance_Fields>;
};


/** aggregate fields of "stripe_latest_subscription_per_user_view" */
export type Stripe_Latest_Subscription_Per_User_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Latest_Subscription_Per_User_View_Avg_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_avg_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe_latest_subscription_per_user_view". All fields are combined with a logical 'AND'. */
export type Stripe_Latest_Subscription_Per_User_View_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>>;
  billing_plan_id?: InputMaybe<Int_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payment_method_id?: InputMaybe<Int_Comparison_Exp>;
  row_number?: InputMaybe<Bigint_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  stripe_customer?: InputMaybe<Stripe_Customers_Bool_Exp>;
  stripe_subscription_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Stripe_Latest_Subscription_Per_User_View_Max_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_max_fields';
  billing_plan_id?: Maybe<Scalars['Int']>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['timestamptz']>;
  current_period_start?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  row_number?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['Int']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Stripe_Latest_Subscription_Per_User_View_Min_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_min_fields';
  billing_plan_id?: Maybe<Scalars['Int']>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['timestamptz']>;
  current_period_start?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  row_number?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['Int']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "stripe_latest_subscription_per_user_view". */
export type Stripe_Latest_Subscription_Per_User_View_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  row_number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_customer?: InputMaybe<Stripe_Customers_Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "stripe_latest_subscription_per_user_view" */
export enum Stripe_Latest_Subscription_Per_User_View_Select_Column {
  /** column name */
  BillingPlanId = 'billing_plan_id',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  RowNumber = 'row_number',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Stripe_Latest_Subscription_Per_User_View_Stddev_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_stddev_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Latest_Subscription_Per_User_View_Stddev_Pop_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_stddev_pop_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Latest_Subscription_Per_User_View_Stddev_Samp_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_stddev_samp_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_latest_subscription_per_user_view" */
export type Stripe_Latest_Subscription_Per_User_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Latest_Subscription_Per_User_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Latest_Subscription_Per_User_View_Stream_Cursor_Value_Input = {
  billing_plan_id?: InputMaybe<Scalars['Int']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  row_number?: InputMaybe<Scalars['bigint']>;
  status?: InputMaybe<Scalars['Int']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stripe_Latest_Subscription_Per_User_View_Sum_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_sum_fields';
  billing_plan_id?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  row_number?: Maybe<Scalars['bigint']>;
  status?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Stripe_Latest_Subscription_Per_User_View_Var_Pop_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_var_pop_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Latest_Subscription_Per_User_View_Var_Samp_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_var_samp_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Latest_Subscription_Per_User_View_Variance_Fields = {
  __typename?: 'stripe_latest_subscription_per_user_view_variance_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  row_number?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "stripe_payment_intents" */
export type Stripe_Payment_Intents = {
  __typename?: 'stripe_payment_intents';
  amount_cents: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  currency: Scalars['String'];
  customer_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status: Scalars['Int'];
  stripe_payment_intent_id: Scalars['String'];
  subscription_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "stripe_payment_intents" */
export type Stripe_Payment_Intents_Aggregate = {
  __typename?: 'stripe_payment_intents_aggregate';
  aggregate?: Maybe<Stripe_Payment_Intents_Aggregate_Fields>;
  nodes: Array<Stripe_Payment_Intents>;
};

/** aggregate fields of "stripe_payment_intents" */
export type Stripe_Payment_Intents_Aggregate_Fields = {
  __typename?: 'stripe_payment_intents_aggregate_fields';
  avg?: Maybe<Stripe_Payment_Intents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Payment_Intents_Max_Fields>;
  min?: Maybe<Stripe_Payment_Intents_Min_Fields>;
  stddev?: Maybe<Stripe_Payment_Intents_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Payment_Intents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Payment_Intents_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Payment_Intents_Sum_Fields>;
  var_pop?: Maybe<Stripe_Payment_Intents_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Payment_Intents_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Payment_Intents_Variance_Fields>;
};


/** aggregate fields of "stripe_payment_intents" */
export type Stripe_Payment_Intents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Payment_Intents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Payment_Intents_Avg_Fields = {
  __typename?: 'stripe_payment_intents_avg_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe_payment_intents". All fields are combined with a logical 'AND'. */
export type Stripe_Payment_Intents_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Payment_Intents_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Payment_Intents_Bool_Exp>>;
  amount_cents?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payment_method_id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  stripe_payment_intent_id?: InputMaybe<String_Comparison_Exp>;
  subscription_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe_payment_intents" */
export enum Stripe_Payment_Intents_Constraint {
  /** unique or primary key constraint on columns "id" */
  StripePaymentIntentsPkey = 'stripe_payment_intents_pkey',
  /** unique or primary key constraint on columns "stripe_payment_intent_id" */
  StripePaymentIntentsStripePidKey = 'stripe_payment_intents_stripe_pid_key'
}

/** input type for incrementing numeric columns in table "stripe_payment_intents" */
export type Stripe_Payment_Intents_Inc_Input = {
  amount_cents?: InputMaybe<Scalars['Int']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: InputMaybe<Scalars['Int']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_payment_intents" */
export type Stripe_Payment_Intents_Insert_Input = {
  amount_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: InputMaybe<Scalars['Int']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stripe_Payment_Intents_Max_Fields = {
  __typename?: 'stripe_payment_intents_max_fields';
  amount_cents?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Int']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Stripe_Payment_Intents_Min_Fields = {
  __typename?: 'stripe_payment_intents_min_fields';
  amount_cents?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Int']>;
  stripe_payment_intent_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "stripe_payment_intents" */
export type Stripe_Payment_Intents_Mutation_Response = {
  __typename?: 'stripe_payment_intents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Payment_Intents>;
};

/** on_conflict condition type for table "stripe_payment_intents" */
export type Stripe_Payment_Intents_On_Conflict = {
  constraint: Stripe_Payment_Intents_Constraint;
  update_columns?: Array<Stripe_Payment_Intents_Update_Column>;
  where?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe_payment_intents". */
export type Stripe_Payment_Intents_Order_By = {
  amount_cents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_payment_intent_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe_payment_intents */
export type Stripe_Payment_Intents_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stripe_payment_intents" */
export enum Stripe_Payment_Intents_Select_Column {
  /** column name */
  AmountCents = 'amount_cents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentIntentId = 'stripe_payment_intent_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "stripe_payment_intents" */
export type Stripe_Payment_Intents_Set_Input = {
  amount_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: InputMaybe<Scalars['Int']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stripe_Payment_Intents_Stddev_Fields = {
  __typename?: 'stripe_payment_intents_stddev_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Payment_Intents_Stddev_Pop_Fields = {
  __typename?: 'stripe_payment_intents_stddev_pop_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Payment_Intents_Stddev_Samp_Fields = {
  __typename?: 'stripe_payment_intents_stddev_samp_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_payment_intents" */
export type Stripe_Payment_Intents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Payment_Intents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Payment_Intents_Stream_Cursor_Value_Input = {
  amount_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: InputMaybe<Scalars['Int']>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stripe_Payment_Intents_Sum_Fields = {
  __typename?: 'stripe_payment_intents_sum_fields';
  amount_cents?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Int']>;
  subscription_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "stripe_payment_intents" */
export enum Stripe_Payment_Intents_Update_Column {
  /** column name */
  AmountCents = 'amount_cents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripePaymentIntentId = 'stripe_payment_intent_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stripe_Payment_Intents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Payment_Intents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Payment_Intents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Payment_Intents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Payment_Intents_Var_Pop_Fields = {
  __typename?: 'stripe_payment_intents_var_pop_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Payment_Intents_Var_Samp_Fields = {
  __typename?: 'stripe_payment_intents_var_samp_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Payment_Intents_Variance_Fields = {
  __typename?: 'stripe_payment_intents_variance_fields';
  amount_cents?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - canceled, 2 - processing, 3 - requires_action, 4 - requires_confirmation, 5 - requires_payment_method, 6 - requires_capture, 7 - succeeded */
  status?: Maybe<Scalars['Float']>;
  subscription_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "stripe_payment_methods" */
export type Stripe_Payment_Methods = {
  __typename?: 'stripe_payment_methods';
  brand?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  customer_id: Scalars['Int'];
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  is_default: Scalars['Boolean'];
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripe_payment_method_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "stripe_payment_methods" */
export type Stripe_Payment_Methods_Aggregate = {
  __typename?: 'stripe_payment_methods_aggregate';
  aggregate?: Maybe<Stripe_Payment_Methods_Aggregate_Fields>;
  nodes: Array<Stripe_Payment_Methods>;
};

export type Stripe_Payment_Methods_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Stripe_Payment_Methods_Aggregate_Bool_Exp_Count>;
};

export type Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_And = {
  arguments: Stripe_Payment_Methods_Select_Column_Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Stripe_Payment_Methods_Select_Column_Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Stripe_Payment_Methods_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "stripe_payment_methods" */
export type Stripe_Payment_Methods_Aggregate_Fields = {
  __typename?: 'stripe_payment_methods_aggregate_fields';
  avg?: Maybe<Stripe_Payment_Methods_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Payment_Methods_Max_Fields>;
  min?: Maybe<Stripe_Payment_Methods_Min_Fields>;
  stddev?: Maybe<Stripe_Payment_Methods_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Payment_Methods_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Payment_Methods_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Payment_Methods_Sum_Fields>;
  var_pop?: Maybe<Stripe_Payment_Methods_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Payment_Methods_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Payment_Methods_Variance_Fields>;
};


/** aggregate fields of "stripe_payment_methods" */
export type Stripe_Payment_Methods_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Aggregate_Order_By = {
  avg?: InputMaybe<Stripe_Payment_Methods_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stripe_Payment_Methods_Max_Order_By>;
  min?: InputMaybe<Stripe_Payment_Methods_Min_Order_By>;
  stddev?: InputMaybe<Stripe_Payment_Methods_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stripe_Payment_Methods_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stripe_Payment_Methods_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stripe_Payment_Methods_Sum_Order_By>;
  var_pop?: InputMaybe<Stripe_Payment_Methods_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stripe_Payment_Methods_Var_Samp_Order_By>;
  variance?: InputMaybe<Stripe_Payment_Methods_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Arr_Rel_Insert_Input = {
  data: Array<Stripe_Payment_Methods_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stripe_Payment_Methods_On_Conflict>;
};

/** aggregate avg on columns */
export type Stripe_Payment_Methods_Avg_Fields = {
  __typename?: 'stripe_payment_methods_avg_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Avg_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stripe_payment_methods". All fields are combined with a logical 'AND'. */
export type Stripe_Payment_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Payment_Methods_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Payment_Methods_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  exp_month?: InputMaybe<Int_Comparison_Exp>;
  exp_year?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  last4?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_method_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe_payment_methods" */
export enum Stripe_Payment_Methods_Constraint {
  /** unique or primary key constraint on columns "stripe_payment_method_id", "customer_id" */
  StripePaymentMethodsCustomerIdKey = 'stripe_payment_methods_customer_id_key',
  /** unique or primary key constraint on columns "id" */
  StripePaymentMethodsPkey = 'stripe_payment_methods_pkey',
  /** unique or primary key constraint on columns "customer_id" */
  UxSpmCustomerOneDefault = 'ux_spm_customer_one_default'
}

/** input type for incrementing numeric columns in table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Inc_Input = {
  customer_id?: InputMaybe<Scalars['Int']>;
  exp_month?: InputMaybe<Scalars['Int']>;
  exp_year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Insert_Input = {
  brand?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  exp_month?: InputMaybe<Scalars['Int']>;
  exp_year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  stripe_payment_method_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stripe_Payment_Methods_Max_Fields = {
  __typename?: 'stripe_payment_methods_max_fields';
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripe_payment_method_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Max_Order_By = {
  brand?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last4?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stripe_payment_method_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stripe_Payment_Methods_Min_Fields = {
  __typename?: 'stripe_payment_methods_min_fields';
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stripe_payment_method_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Min_Order_By = {
  brand?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last4?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stripe_payment_method_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Mutation_Response = {
  __typename?: 'stripe_payment_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Payment_Methods>;
};

/** on_conflict condition type for table "stripe_payment_methods" */
export type Stripe_Payment_Methods_On_Conflict = {
  constraint: Stripe_Payment_Methods_Constraint;
  update_columns?: Array<Stripe_Payment_Methods_Update_Column>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe_payment_methods". */
export type Stripe_Payment_Methods_Order_By = {
  brand?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  last4?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stripe_payment_method_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe_payment_methods */
export type Stripe_Payment_Methods_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stripe_payment_methods" */
export enum Stripe_Payment_Methods_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  ExpMonth = 'exp_month',
  /** column name */
  ExpYear = 'exp_year',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Name = 'name',
  /** column name */
  StripePaymentMethodId = 'stripe_payment_method_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "stripe_payment_methods_aggregate_bool_exp_bool_and_arguments_columns" columns of table "stripe_payment_methods" */
export enum Stripe_Payment_Methods_Select_Column_Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDefault = 'is_default'
}

/** select "stripe_payment_methods_aggregate_bool_exp_bool_or_arguments_columns" columns of table "stripe_payment_methods" */
export enum Stripe_Payment_Methods_Select_Column_Stripe_Payment_Methods_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDefault = 'is_default'
}

/** input type for updating data in table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Set_Input = {
  brand?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  exp_month?: InputMaybe<Scalars['Int']>;
  exp_year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  stripe_payment_method_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stripe_Payment_Methods_Stddev_Fields = {
  __typename?: 'stripe_payment_methods_stddev_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Stddev_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Payment_Methods_Stddev_Pop_Fields = {
  __typename?: 'stripe_payment_methods_stddev_pop_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Stddev_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Payment_Methods_Stddev_Samp_Fields = {
  __typename?: 'stripe_payment_methods_stddev_samp_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Stddev_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Payment_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Payment_Methods_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  exp_month?: InputMaybe<Scalars['Int']>;
  exp_year?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  last4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  stripe_payment_method_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stripe_Payment_Methods_Sum_Fields = {
  __typename?: 'stripe_payment_methods_sum_fields';
  customer_id?: Maybe<Scalars['Int']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Sum_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "stripe_payment_methods" */
export enum Stripe_Payment_Methods_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  ExpMonth = 'exp_month',
  /** column name */
  ExpYear = 'exp_year',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Last4 = 'last4',
  /** column name */
  Name = 'name',
  /** column name */
  StripePaymentMethodId = 'stripe_payment_method_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stripe_Payment_Methods_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Payment_Methods_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Payment_Methods_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Payment_Methods_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Payment_Methods_Var_Pop_Fields = {
  __typename?: 'stripe_payment_methods_var_pop_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Var_Pop_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stripe_Payment_Methods_Var_Samp_Fields = {
  __typename?: 'stripe_payment_methods_var_samp_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Var_Samp_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stripe_Payment_Methods_Variance_Fields = {
  __typename?: 'stripe_payment_methods_variance_fields';
  customer_id?: Maybe<Scalars['Float']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stripe_payment_methods" */
export type Stripe_Payment_Methods_Variance_Order_By = {
  customer_id?: InputMaybe<Order_By>;
  exp_month?: InputMaybe<Order_By>;
  exp_year?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "stripe_subscriptions" */
export type Stripe_Subscriptions = {
  __typename?: 'stripe_subscriptions';
  billing_plan_id: Scalars['Int'];
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  current_period_end?: Maybe<Scalars['timestamptz']>;
  current_period_start?: Maybe<Scalars['timestamptz']>;
  customer_id: Scalars['Int'];
  id: Scalars['Int'];
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status: Scalars['Int'];
  /** An object relationship */
  stripe_billing_plan: Stripe_Billing_Plans;
  /** An object relationship */
  stripe_customer: Stripe_Customers;
  stripe_subscription_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "stripe_subscriptions" */
export type Stripe_Subscriptions_Aggregate = {
  __typename?: 'stripe_subscriptions_aggregate';
  aggregate?: Maybe<Stripe_Subscriptions_Aggregate_Fields>;
  nodes: Array<Stripe_Subscriptions>;
};

export type Stripe_Subscriptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Stripe_Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type Stripe_Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "stripe_subscriptions" */
export type Stripe_Subscriptions_Aggregate_Fields = {
  __typename?: 'stripe_subscriptions_aggregate_fields';
  avg?: Maybe<Stripe_Subscriptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Subscriptions_Max_Fields>;
  min?: Maybe<Stripe_Subscriptions_Min_Fields>;
  stddev?: Maybe<Stripe_Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Stripe_Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Subscriptions_Variance_Fields>;
};


/** aggregate fields of "stripe_subscriptions" */
export type Stripe_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<Stripe_Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stripe_Subscriptions_Max_Order_By>;
  min?: InputMaybe<Stripe_Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<Stripe_Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Stripe_Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Stripe_Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Stripe_Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<Stripe_Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Stripe_Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Stripe_Subscriptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stripe_subscriptions" */
export type Stripe_Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<Stripe_Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stripe_Subscriptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Stripe_Subscriptions_Avg_Fields = {
  __typename?: 'stripe_subscriptions_avg_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Avg_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stripe_subscriptions". All fields are combined with a logical 'AND'. */
export type Stripe_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Subscriptions_Bool_Exp>>;
  billing_plan_id?: InputMaybe<Int_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payment_method_id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  stripe_billing_plan?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
  stripe_customer?: InputMaybe<Stripe_Customers_Bool_Exp>;
  stripe_subscription_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe_subscriptions" */
export enum Stripe_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  StripeSubscriptionsPkey = 'stripe_subscriptions_pkey',
  /** unique or primary key constraint on columns "stripe_subscription_id" */
  UxStripeSubscriptionsStripeSubscriptionId = 'ux_stripe_subscriptions_stripe_subscription_id'
}

/** input type for incrementing numeric columns in table "stripe_subscriptions" */
export type Stripe_Subscriptions_Inc_Input = {
  billing_plan_id?: InputMaybe<Scalars['Int']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_subscriptions" */
export type Stripe_Subscriptions_Insert_Input = {
  billing_plan_id?: InputMaybe<Scalars['Int']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Scalars['Int']>;
  stripe_billing_plan?: InputMaybe<Stripe_Billing_Plans_Obj_Rel_Insert_Input>;
  stripe_customer?: InputMaybe<Stripe_Customers_Obj_Rel_Insert_Input>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stripe_Subscriptions_Max_Fields = {
  __typename?: 'stripe_subscriptions_max_fields';
  billing_plan_id?: Maybe<Scalars['Int']>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['timestamptz']>;
  current_period_start?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Int']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Max_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stripe_Subscriptions_Min_Fields = {
  __typename?: 'stripe_subscriptions_min_fields';
  billing_plan_id?: Maybe<Scalars['Int']>;
  cancelled_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['timestamptz']>;
  current_period_start?: Maybe<Scalars['timestamptz']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Int']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Min_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stripe_subscriptions" */
export type Stripe_Subscriptions_Mutation_Response = {
  __typename?: 'stripe_subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Subscriptions>;
};

/** on_conflict condition type for table "stripe_subscriptions" */
export type Stripe_Subscriptions_On_Conflict = {
  constraint: Stripe_Subscriptions_Constraint;
  update_columns?: Array<Stripe_Subscriptions_Update_Column>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe_subscriptions". */
export type Stripe_Subscriptions_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_billing_plan?: InputMaybe<Stripe_Billing_Plans_Order_By>;
  stripe_customer?: InputMaybe<Stripe_Customers_Order_By>;
  stripe_subscription_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe_subscriptions */
export type Stripe_Subscriptions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stripe_subscriptions" */
export enum Stripe_Subscriptions_Select_Column {
  /** column name */
  BillingPlanId = 'billing_plan_id',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "stripe_subscriptions" */
export type Stripe_Subscriptions_Set_Input = {
  billing_plan_id?: InputMaybe<Scalars['Int']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Scalars['Int']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stripe_Subscriptions_Stddev_Fields = {
  __typename?: 'stripe_subscriptions_stddev_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Stddev_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'stripe_subscriptions_stddev_pop_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Stddev_Pop_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'stripe_subscriptions_stddev_samp_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Stddev_Samp_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "stripe_subscriptions" */
export type Stripe_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Subscriptions_Stream_Cursor_Value_Input = {
  billing_plan_id?: InputMaybe<Scalars['Int']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']>;
  customer_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payment_method_id?: InputMaybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Scalars['Int']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stripe_Subscriptions_Sum_Fields = {
  __typename?: 'stripe_subscriptions_sum_fields';
  billing_plan_id?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payment_method_id?: Maybe<Scalars['Int']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Sum_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** update columns of table "stripe_subscriptions" */
export enum Stripe_Subscriptions_Update_Column {
  /** column name */
  BillingPlanId = 'billing_plan_id',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stripe_Subscriptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Subscriptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Subscriptions_Var_Pop_Fields = {
  __typename?: 'stripe_subscriptions_var_pop_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Var_Pop_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stripe_Subscriptions_Var_Samp_Fields = {
  __typename?: 'stripe_subscriptions_var_samp_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Var_Samp_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Stripe_Subscriptions_Variance_Fields = {
  __typename?: 'stripe_subscriptions_variance_fields';
  billing_plan_id?: Maybe<Scalars['Float']>;
  customer_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payment_method_id?: Maybe<Scalars['Float']>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stripe_subscriptions" */
export type Stripe_Subscriptions_Variance_Order_By = {
  billing_plan_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  /** 1 - active, 2 - trialing, 3 - canceled, 4 - unpaid, 5 - incomplete, 6 - incomplete_expired, 7 - past_due, 8 - paused */
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "stripe_transaction" */
export type Stripe_Transaction = {
  __typename?: 'stripe_transaction';
  amount_in_cents: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  currency: Scalars['String'];
  id: Scalars['String'];
  recipient_user_id: Scalars['uuid'];
  status: Scalars['String'];
  stripe_account_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "stripe_transaction" */
export type Stripe_Transaction_Aggregate = {
  __typename?: 'stripe_transaction_aggregate';
  aggregate?: Maybe<Stripe_Transaction_Aggregate_Fields>;
  nodes: Array<Stripe_Transaction>;
};

/** aggregate fields of "stripe_transaction" */
export type Stripe_Transaction_Aggregate_Fields = {
  __typename?: 'stripe_transaction_aggregate_fields';
  avg?: Maybe<Stripe_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Stripe_Transaction_Max_Fields>;
  min?: Maybe<Stripe_Transaction_Min_Fields>;
  stddev?: Maybe<Stripe_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Stripe_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stripe_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Stripe_Transaction_Sum_Fields>;
  var_pop?: Maybe<Stripe_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Stripe_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Stripe_Transaction_Variance_Fields>;
};


/** aggregate fields of "stripe_transaction" */
export type Stripe_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stripe_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Stripe_Transaction_Avg_Fields = {
  __typename?: 'stripe_transaction_avg_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "stripe_transaction". All fields are combined with a logical 'AND'. */
export type Stripe_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Stripe_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Stripe_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Stripe_Transaction_Bool_Exp>>;
  amount_in_cents?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  recipient_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stripe_account_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "stripe_transaction" */
export enum Stripe_Transaction_Constraint {
  /** unique or primary key constraint on columns "id" */
  StripeTransactionPkey = 'stripe_transaction_pkey'
}

/** input type for incrementing numeric columns in table "stripe_transaction" */
export type Stripe_Transaction_Inc_Input = {
  amount_in_cents?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "stripe_transaction" */
export type Stripe_Transaction_Insert_Input = {
  amount_in_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  recipient_user_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_account_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Stripe_Transaction_Max_Fields = {
  __typename?: 'stripe_transaction_max_fields';
  amount_in_cents?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recipient_user_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_account_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Stripe_Transaction_Min_Fields = {
  __typename?: 'stripe_transaction_min_fields';
  amount_in_cents?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  recipient_user_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_account_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "stripe_transaction" */
export type Stripe_Transaction_Mutation_Response = {
  __typename?: 'stripe_transaction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stripe_Transaction>;
};

/** on_conflict condition type for table "stripe_transaction" */
export type Stripe_Transaction_On_Conflict = {
  constraint: Stripe_Transaction_Constraint;
  update_columns?: Array<Stripe_Transaction_Update_Column>;
  where?: InputMaybe<Stripe_Transaction_Bool_Exp>;
};

/** Ordering options when selecting data from "stripe_transaction". */
export type Stripe_Transaction_Order_By = {
  amount_in_cents?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_account_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stripe_transaction */
export type Stripe_Transaction_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "stripe_transaction" */
export enum Stripe_Transaction_Select_Column {
  /** column name */
  AmountInCents = 'amount_in_cents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientUserId = 'recipient_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeAccountId = 'stripe_account_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "stripe_transaction" */
export type Stripe_Transaction_Set_Input = {
  amount_in_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  recipient_user_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_account_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Stripe_Transaction_Stddev_Fields = {
  __typename?: 'stripe_transaction_stddev_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Stripe_Transaction_Stddev_Pop_Fields = {
  __typename?: 'stripe_transaction_stddev_pop_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Stripe_Transaction_Stddev_Samp_Fields = {
  __typename?: 'stripe_transaction_stddev_samp_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "stripe_transaction" */
export type Stripe_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stripe_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stripe_Transaction_Stream_Cursor_Value_Input = {
  amount_in_cents?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  recipient_user_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_account_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Stripe_Transaction_Sum_Fields = {
  __typename?: 'stripe_transaction_sum_fields';
  amount_in_cents?: Maybe<Scalars['Int']>;
};

/** update columns of table "stripe_transaction" */
export enum Stripe_Transaction_Update_Column {
  /** column name */
  AmountInCents = 'amount_in_cents',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientUserId = 'recipient_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeAccountId = 'stripe_account_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Stripe_Transaction_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Stripe_Transaction_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stripe_Transaction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stripe_Transaction_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Stripe_Transaction_Var_Pop_Fields = {
  __typename?: 'stripe_transaction_var_pop_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Stripe_Transaction_Var_Samp_Fields = {
  __typename?: 'stripe_transaction_var_samp_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Stripe_Transaction_Variance_Fields = {
  __typename?: 'stripe_transaction_variance_fields';
  amount_in_cents?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  accepted_legal_documents: Array<Accepted_Legal_Documents>;
  /** An aggregate relationship */
  accepted_legal_documents_aggregate: Accepted_Legal_Documents_Aggregate;
  /** fetch data from the table: "accepted_legal_documents" using primary key columns */
  accepted_legal_documents_by_pk?: Maybe<Accepted_Legal_Documents>;
  /** fetch data from the table in a streaming manner: "accepted_legal_documents" */
  accepted_legal_documents_stream: Array<Accepted_Legal_Documents>;
  /** An array relationship */
  active_in_mails: Array<Active_In_Mails>;
  /** An aggregate relationship */
  active_in_mails_aggregate: Active_In_Mails_Aggregate;
  /** fetch data from the table: "active_in_mails" using primary key columns */
  active_in_mails_by_pk?: Maybe<Active_In_Mails>;
  /** fetch data from the table in a streaming manner: "active_in_mails" */
  active_in_mails_stream: Array<Active_In_Mails>;
  /** An array relationship */
  active_support_chats: Array<Active_Support_Chats>;
  /** An aggregate relationship */
  active_support_chats_aggregate: Active_Support_Chats_Aggregate;
  /** fetch data from the table: "active_support_chats" using primary key columns */
  active_support_chats_by_pk?: Maybe<Active_Support_Chats>;
  /** fetch data from the table in a streaming manner: "active_support_chats" */
  active_support_chats_stream: Array<Active_Support_Chats>;
  /** fetch data from the table: "activity_events" */
  activity_events: Array<Activity_Events>;
  /** fetch aggregated fields from the table: "activity_events" */
  activity_events_aggregate: Activity_Events_Aggregate;
  /** fetch data from the table: "activity_events" using primary key columns */
  activity_events_by_pk?: Maybe<Activity_Events>;
  /** fetch data from the table in a streaming manner: "activity_events" */
  activity_events_stream: Array<Activity_Events>;
  /** fetch data from the table: "acuity_provider_calendar" */
  acuity_provider_calendar: Array<Acuity_Provider_Calendar>;
  /** fetch aggregated fields from the table: "acuity_provider_calendar" */
  acuity_provider_calendar_aggregate: Acuity_Provider_Calendar_Aggregate;
  /** fetch data from the table: "acuity_provider_calendar" using primary key columns */
  acuity_provider_calendar_by_pk?: Maybe<Acuity_Provider_Calendar>;
  /** fetch data from the table in a streaming manner: "acuity_provider_calendar" */
  acuity_provider_calendar_stream: Array<Acuity_Provider_Calendar>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** An array relationship */
  admin_permissions: Array<Admin_Permissions>;
  /** An aggregate relationship */
  admin_permissions_aggregate: Admin_Permissions_Aggregate;
  /** fetch data from the table: "admin_permissions" using primary key columns */
  admin_permissions_by_pk?: Maybe<Admin_Permissions>;
  /** fetch data from the table in a streaming manner: "admin_permissions" */
  admin_permissions_stream: Array<Admin_Permissions>;
  /** fetch data from the table: "age_of_majority_rules" */
  age_of_majority_rules: Array<Age_Of_Majority_Rules>;
  /** fetch aggregated fields from the table: "age_of_majority_rules" */
  age_of_majority_rules_aggregate: Age_Of_Majority_Rules_Aggregate;
  /** fetch data from the table: "age_of_majority_rules" using primary key columns */
  age_of_majority_rules_by_pk?: Maybe<Age_Of_Majority_Rules>;
  /** fetch data from the table in a streaming manner: "age_of_majority_rules" */
  age_of_majority_rules_stream: Array<Age_Of_Majority_Rules>;
  /** fetch data from the table: "allergen_classes" */
  allergen_classes: Array<Allergen_Classes>;
  /** fetch aggregated fields from the table: "allergen_classes" */
  allergen_classes_aggregate: Allergen_Classes_Aggregate;
  /** fetch data from the table: "allergen_classes" using primary key columns */
  allergen_classes_by_pk?: Maybe<Allergen_Classes>;
  /** fetch data from the table in a streaming manner: "allergen_classes" */
  allergen_classes_stream: Array<Allergen_Classes>;
  /** fetch data from the table: "app_tours" */
  app_tours: Array<App_Tours>;
  /** fetch aggregated fields from the table: "app_tours" */
  app_tours_aggregate: App_Tours_Aggregate;
  /** fetch data from the table: "app_tours" using primary key columns */
  app_tours_by_pk?: Maybe<App_Tours>;
  /** fetch data from the table in a streaming manner: "app_tours" */
  app_tours_stream: Array<App_Tours>;
  /** fetch data from the table: "app_versions" */
  app_versions: Array<App_Versions>;
  /** fetch aggregated fields from the table: "app_versions" */
  app_versions_aggregate: App_Versions_Aggregate;
  /** fetch data from the table: "app_versions" using primary key columns */
  app_versions_by_pk?: Maybe<App_Versions>;
  /** fetch data from the table in a streaming manner: "app_versions" */
  app_versions_stream: Array<App_Versions>;
  /** fetch data from the table: "appointment_media_signals" */
  appointment_media_signals: Array<Appointment_Media_Signals>;
  /** fetch aggregated fields from the table: "appointment_media_signals" */
  appointment_media_signals_aggregate: Appointment_Media_Signals_Aggregate;
  /** fetch data from the table: "appointment_media_signals" using primary key columns */
  appointment_media_signals_by_pk?: Maybe<Appointment_Media_Signals>;
  /** fetch data from the table in a streaming manner: "appointment_media_signals" */
  appointment_media_signals_stream: Array<Appointment_Media_Signals>;
  /** An array relationship */
  appointment_payments: Array<Appointment_Payments>;
  /** An aggregate relationship */
  appointment_payments_aggregate: Appointment_Payments_Aggregate;
  /** fetch data from the table: "appointment_payments" using primary key columns */
  appointment_payments_by_pk?: Maybe<Appointment_Payments>;
  /** fetch data from the table in a streaming manner: "appointment_payments" */
  appointment_payments_stream: Array<Appointment_Payments>;
  /** fetch data from the table: "appointment_requests" */
  appointment_requests: Array<Appointment_Requests>;
  /** fetch aggregated fields from the table: "appointment_requests" */
  appointment_requests_aggregate: Appointment_Requests_Aggregate;
  /** fetch data from the table: "appointment_requests" using primary key columns */
  appointment_requests_by_pk?: Maybe<Appointment_Requests>;
  /** fetch data from the table in a streaming manner: "appointment_requests" */
  appointment_requests_stream: Array<Appointment_Requests>;
  /** fetch data from the table: "appointment_status_counts" */
  appointment_status_counts: Array<Appointment_Status_Counts>;
  /** fetch aggregated fields from the table: "appointment_status_counts" */
  appointment_status_counts_aggregate: Appointment_Status_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "appointment_status_counts" */
  appointment_status_counts_stream: Array<Appointment_Status_Counts>;
  /** fetch data from the table: "appointment_status_history" */
  appointment_status_history: Array<Appointment_Status_History>;
  /** fetch aggregated fields from the table: "appointment_status_history" */
  appointment_status_history_aggregate: Appointment_Status_History_Aggregate;
  /** fetch data from the table: "appointment_status_history" using primary key columns */
  appointment_status_history_by_pk?: Maybe<Appointment_Status_History>;
  /** fetch data from the table in a streaming manner: "appointment_status_history" */
  appointment_status_history_stream: Array<Appointment_Status_History>;
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  /** fetch data from the table: "appointments" using primary key columns */
  appointments_by_pk?: Maybe<Appointments>;
  /** fetch data from the table in a streaming manner: "appointments" */
  appointments_stream: Array<Appointments>;
  /** fetch data from the table: "cart_products" */
  cart_products: Array<Cart_Products>;
  /** fetch aggregated fields from the table: "cart_products" */
  cart_products_aggregate: Cart_Products_Aggregate;
  /** fetch data from the table: "cart_products" using primary key columns */
  cart_products_by_pk?: Maybe<Cart_Products>;
  /** fetch data from the table in a streaming manner: "cart_products" */
  cart_products_stream: Array<Cart_Products>;
  /** fetch data from the table: "channel_signals" */
  channel_signals: Array<Channel_Signals>;
  /** fetch aggregated fields from the table: "channel_signals" */
  channel_signals_aggregate: Channel_Signals_Aggregate;
  /** fetch data from the table: "channel_signals" using primary key columns */
  channel_signals_by_pk?: Maybe<Channel_Signals>;
  /** fetch data from the table in a streaming manner: "channel_signals" */
  channel_signals_stream: Array<Channel_Signals>;
  /** fetch data from the table: "common_question_responses" */
  common_question_responses: Array<Common_Question_Responses>;
  /** fetch aggregated fields from the table: "common_question_responses" */
  common_question_responses_aggregate: Common_Question_Responses_Aggregate;
  /** fetch data from the table: "common_question_responses" using primary key columns */
  common_question_responses_by_pk?: Maybe<Common_Question_Responses>;
  /** fetch data from the table in a streaming manner: "common_question_responses" */
  common_question_responses_stream: Array<Common_Question_Responses>;
  /** fetch data from the table: "common_questions" */
  common_questions: Array<Common_Questions>;
  /** fetch aggregated fields from the table: "common_questions" */
  common_questions_aggregate: Common_Questions_Aggregate;
  /** fetch data from the table: "common_questions" using primary key columns */
  common_questions_by_pk?: Maybe<Common_Questions>;
  /** fetch data from the table in a streaming manner: "common_questions" */
  common_questions_stream: Array<Common_Questions>;
  /** fetch data from the table: "communication_channels" */
  communication_channels: Array<Communication_Channels>;
  /** fetch aggregated fields from the table: "communication_channels" */
  communication_channels_aggregate: Communication_Channels_Aggregate;
  /** fetch data from the table: "communication_channels" using primary key columns */
  communication_channels_by_pk?: Maybe<Communication_Channels>;
  /** fetch data from the table in a streaming manner: "communication_channels" */
  communication_channels_stream: Array<Communication_Channels>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countries_aggregate: Countries_Aggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countries_stream: Array<Countries>;
  /** fetch data from the table: "custom_auth_code" */
  custom_auth_code: Array<Custom_Auth_Code>;
  /** fetch aggregated fields from the table: "custom_auth_code" */
  custom_auth_code_aggregate: Custom_Auth_Code_Aggregate;
  /** fetch data from the table: "custom_auth_code" using primary key columns */
  custom_auth_code_by_pk?: Maybe<Custom_Auth_Code>;
  /** fetch data from the table in a streaming manner: "custom_auth_code" */
  custom_auth_code_stream: Array<Custom_Auth_Code>;
  /** An array relationship */
  dea_license_schedules: Array<Dea_License_Schedules>;
  /** An aggregate relationship */
  dea_license_schedules_aggregate: Dea_License_Schedules_Aggregate;
  /** fetch data from the table: "dea_license_schedules" using primary key columns */
  dea_license_schedules_by_pk?: Maybe<Dea_License_Schedules>;
  /** fetch data from the table in a streaming manner: "dea_license_schedules" */
  dea_license_schedules_stream: Array<Dea_License_Schedules>;
  /** fetch data from the table: "delivery_addresses" */
  delivery_addresses: Array<Delivery_Addresses>;
  /** fetch aggregated fields from the table: "delivery_addresses" */
  delivery_addresses_aggregate: Delivery_Addresses_Aggregate;
  /** fetch data from the table: "delivery_addresses" using primary key columns */
  delivery_addresses_by_pk?: Maybe<Delivery_Addresses>;
  /** fetch data from the table in a streaming manner: "delivery_addresses" */
  delivery_addresses_stream: Array<Delivery_Addresses>;
  /** fetch data from the table: "diagnostic_solution_tests" */
  diagnostic_solution_tests: Array<Diagnostic_Solution_Tests>;
  /** fetch aggregated fields from the table: "diagnostic_solution_tests" */
  diagnostic_solution_tests_aggregate: Diagnostic_Solution_Tests_Aggregate;
  /** fetch data from the table: "diagnostic_solution_tests" using primary key columns */
  diagnostic_solution_tests_by_pk?: Maybe<Diagnostic_Solution_Tests>;
  /** fetch data from the table in a streaming manner: "diagnostic_solution_tests" */
  diagnostic_solution_tests_stream: Array<Diagnostic_Solution_Tests>;
  /** fetch data from the table: "dnavisit_test_statuses" */
  dnavisit_test_statuses: Array<Dnavisit_Test_Statuses>;
  /** fetch aggregated fields from the table: "dnavisit_test_statuses" */
  dnavisit_test_statuses_aggregate: Dnavisit_Test_Statuses_Aggregate;
  /** fetch data from the table: "dnavisit_test_statuses" using primary key columns */
  dnavisit_test_statuses_by_pk?: Maybe<Dnavisit_Test_Statuses>;
  /** fetch data from the table in a streaming manner: "dnavisit_test_statuses" */
  dnavisit_test_statuses_stream: Array<Dnavisit_Test_Statuses>;
  /** fetch data from the table: "dnavisit_tests" */
  dnavisit_tests: Array<Dnavisit_Tests>;
  /** fetch aggregated fields from the table: "dnavisit_tests" */
  dnavisit_tests_aggregate: Dnavisit_Tests_Aggregate;
  /** fetch data from the table: "dnavisit_tests" using primary key columns */
  dnavisit_tests_by_pk?: Maybe<Dnavisit_Tests>;
  /** fetch data from the table in a streaming manner: "dnavisit_tests" */
  dnavisit_tests_stream: Array<Dnavisit_Tests>;
  /** fetch data from the table: "do_not_use_production_swab_codes" */
  do_not_use_production_swab_codes: Array<Do_Not_Use_Production_Swab_Codes>;
  /** fetch aggregated fields from the table: "do_not_use_production_swab_codes" */
  do_not_use_production_swab_codes_aggregate: Do_Not_Use_Production_Swab_Codes_Aggregate;
  /** fetch data from the table: "do_not_use_production_swab_codes" using primary key columns */
  do_not_use_production_swab_codes_by_pk?: Maybe<Do_Not_Use_Production_Swab_Codes>;
  /** fetch data from the table in a streaming manner: "do_not_use_production_swab_codes" */
  do_not_use_production_swab_codes_stream: Array<Do_Not_Use_Production_Swab_Codes>;
  /** fetch data from the table: "ecommerce_orders" */
  ecommerce_orders: Array<Ecommerce_Orders>;
  /** fetch aggregated fields from the table: "ecommerce_orders" */
  ecommerce_orders_aggregate: Ecommerce_Orders_Aggregate;
  /** fetch data from the table: "ecommerce_orders" using primary key columns */
  ecommerce_orders_by_pk?: Maybe<Ecommerce_Orders>;
  /** fetch data from the table in a streaming manner: "ecommerce_orders" */
  ecommerce_orders_stream: Array<Ecommerce_Orders>;
  /** An array relationship */
  education_courses: Array<Education_Courses>;
  /** An aggregate relationship */
  education_courses_aggregate: Education_Courses_Aggregate;
  /** fetch data from the table: "education_courses" using primary key columns */
  education_courses_by_pk?: Maybe<Education_Courses>;
  /** fetch data from the table in a streaming manner: "education_courses" */
  education_courses_stream: Array<Education_Courses>;
  /** fetch data from the table: "education_module_additional_materials" */
  education_module_additional_materials: Array<Education_Module_Additional_Materials>;
  /** fetch aggregated fields from the table: "education_module_additional_materials" */
  education_module_additional_materials_aggregate: Education_Module_Additional_Materials_Aggregate;
  /** fetch data from the table: "education_module_additional_materials" using primary key columns */
  education_module_additional_materials_by_pk?: Maybe<Education_Module_Additional_Materials>;
  /** fetch data from the table in a streaming manner: "education_module_additional_materials" */
  education_module_additional_materials_stream: Array<Education_Module_Additional_Materials>;
  /** An array relationship */
  education_module_items: Array<Education_Module_Items>;
  /** An aggregate relationship */
  education_module_items_aggregate: Education_Module_Items_Aggregate;
  /** fetch data from the table: "education_module_items" using primary key columns */
  education_module_items_by_pk?: Maybe<Education_Module_Items>;
  /** fetch data from the table in a streaming manner: "education_module_items" */
  education_module_items_stream: Array<Education_Module_Items>;
  /** An array relationship */
  education_modules: Array<Education_Modules>;
  /** An aggregate relationship */
  education_modules_aggregate: Education_Modules_Aggregate;
  /** fetch data from the table: "education_modules" using primary key columns */
  education_modules_by_pk?: Maybe<Education_Modules>;
  /** fetch data from the table in a streaming manner: "education_modules" */
  education_modules_stream: Array<Education_Modules>;
  /** fetch data from the table: "file_types" */
  file_types: Array<File_Types>;
  /** fetch aggregated fields from the table: "file_types" */
  file_types_aggregate: File_Types_Aggregate;
  /** fetch data from the table: "file_types" using primary key columns */
  file_types_by_pk?: Maybe<File_Types>;
  /** fetch data from the table in a streaming manner: "file_types" */
  file_types_stream: Array<File_Types>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "fullscript_allergens" */
  fullscript_allergens: Array<Fullscript_Allergens>;
  /** fetch aggregated fields from the table: "fullscript_allergens" */
  fullscript_allergens_aggregate: Fullscript_Allergens_Aggregate;
  /** fetch data from the table: "fullscript_allergens" using primary key columns */
  fullscript_allergens_by_pk?: Maybe<Fullscript_Allergens>;
  /** fetch data from the table in a streaming manner: "fullscript_allergens" */
  fullscript_allergens_stream: Array<Fullscript_Allergens>;
  /** fetch data from the table: "fullscript_clinicians" */
  fullscript_clinicians: Array<Fullscript_Clinicians>;
  /** fetch aggregated fields from the table: "fullscript_clinicians" */
  fullscript_clinicians_aggregate: Fullscript_Clinicians_Aggregate;
  /** fetch data from the table: "fullscript_clinicians" using primary key columns */
  fullscript_clinicians_by_pk?: Maybe<Fullscript_Clinicians>;
  /** fetch data from the table in a streaming manner: "fullscript_clinicians" */
  fullscript_clinicians_stream: Array<Fullscript_Clinicians>;
  /** An array relationship */
  gale_products: Array<Gale_Products>;
  /** An aggregate relationship */
  gale_products_aggregate: Gale_Products_Aggregate;
  /** fetch data from the table: "gale_products" using primary key columns */
  gale_products_by_pk?: Maybe<Gale_Products>;
  /** fetch data from the table in a streaming manner: "gale_products" */
  gale_products_stream: Array<Gale_Products>;
  /** execute function "get_appointment_status_counts" which returns "appointment_status_counts" */
  get_appointment_status_counts: Array<Appointment_Status_Counts>;
  /** execute function "get_appointment_status_counts" and query aggregates on result of table type "appointment_status_counts" */
  get_appointment_status_counts_aggregate: Appointment_Status_Counts_Aggregate;
  /** execute function "get_order_status_counts" which returns "order_status_counts" */
  get_order_status_counts: Array<Order_Status_Counts>;
  /** execute function "get_order_status_counts" and query aggregates on result of table type "order_status_counts" */
  get_order_status_counts_aggregate: Order_Status_Counts_Aggregate;
  /** execute function "get_payment_stats_by_day" which returns "payment_stats_by_day" */
  get_payment_stats_by_day: Array<Payment_Stats_By_Day>;
  /** execute function "get_payment_stats_by_day" and query aggregates on result of table type "payment_stats_by_day" */
  get_payment_stats_by_day_aggregate: Payment_Stats_By_Day_Aggregate;
  /** execute function "get_provider_payouts" which returns "provider_payouts" */
  get_provider_payouts: Array<Provider_Payouts>;
  /** execute function "get_provider_payouts" and query aggregates on result of table type "provider_payouts" */
  get_provider_payouts_aggregate: Provider_Payouts_Aggregate;
  /** execute function "get_test_kit_status_counts" which returns "test_kit_status_counts" */
  get_test_kit_status_counts: Array<Test_Kit_Status_Counts>;
  /** execute function "get_test_kit_status_counts" and query aggregates on result of table type "test_kit_status_counts" */
  get_test_kit_status_counts_aggregate: Test_Kit_Status_Counts_Aggregate;
  /** fetch data from the table: "global_configs" */
  global_configs: Array<Global_Configs>;
  /** fetch aggregated fields from the table: "global_configs" */
  global_configs_aggregate: Global_Configs_Aggregate;
  /** fetch data from the table: "global_configs" using primary key columns */
  global_configs_by_pk?: Maybe<Global_Configs>;
  /** fetch data from the table: "global_configs_names" */
  global_configs_names: Array<Global_Configs_Names>;
  /** fetch aggregated fields from the table: "global_configs_names" */
  global_configs_names_aggregate: Global_Configs_Names_Aggregate;
  /** fetch data from the table: "global_configs_names" using primary key columns */
  global_configs_names_by_pk?: Maybe<Global_Configs_Names>;
  /** fetch data from the table in a streaming manner: "global_configs_names" */
  global_configs_names_stream: Array<Global_Configs_Names>;
  /** fetch data from the table in a streaming manner: "global_configs" */
  global_configs_stream: Array<Global_Configs>;
  /** fetch data from the table: "image_source_types" */
  image_source_types: Array<Image_Source_Types>;
  /** fetch aggregated fields from the table: "image_source_types" */
  image_source_types_aggregate: Image_Source_Types_Aggregate;
  /** fetch data from the table: "image_source_types" using primary key columns */
  image_source_types_by_pk?: Maybe<Image_Source_Types>;
  /** fetch data from the table in a streaming manner: "image_source_types" */
  image_source_types_stream: Array<Image_Source_Types>;
  /** An array relationship */
  in_mail_usage: Array<In_Mail_Usage>;
  /** An aggregate relationship */
  in_mail_usage_aggregate: In_Mail_Usage_Aggregate;
  /** fetch data from the table: "in_mail_usage" using primary key columns */
  in_mail_usage_by_pk?: Maybe<In_Mail_Usage>;
  /** fetch data from the table in a streaming manner: "in_mail_usage" */
  in_mail_usage_stream: Array<In_Mail_Usage>;
  /** An array relationship */
  invitations: Array<Invitations>;
  /** An aggregate relationship */
  invitations_aggregate: Invitations_Aggregate;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** fetch data from the table in a streaming manner: "invitations" */
  invitations_stream: Array<Invitations>;
  /** fetch data from the table: "labs" */
  labs: Array<Labs>;
  /** fetch aggregated fields from the table: "labs" */
  labs_aggregate: Labs_Aggregate;
  /** fetch data from the table: "labs" using primary key columns */
  labs_by_pk?: Maybe<Labs>;
  /** fetch data from the table in a streaming manner: "labs" */
  labs_stream: Array<Labs>;
  /** fetch data from the table: "latest_persona_inquiries_per_user" */
  latest_persona_inquiries_per_user: Array<Latest_Persona_Inquiries_Per_User>;
  /** fetch aggregated fields from the table: "latest_persona_inquiries_per_user" */
  latest_persona_inquiries_per_user_aggregate: Latest_Persona_Inquiries_Per_User_Aggregate;
  /** fetch data from the table in a streaming manner: "latest_persona_inquiries_per_user" */
  latest_persona_inquiries_per_user_stream: Array<Latest_Persona_Inquiries_Per_User>;
  /** fetch data from the table: "legal_document_types" */
  legal_document_types: Array<Legal_Document_Types>;
  /** fetch aggregated fields from the table: "legal_document_types" */
  legal_document_types_aggregate: Legal_Document_Types_Aggregate;
  /** fetch data from the table: "legal_document_types" using primary key columns */
  legal_document_types_by_pk?: Maybe<Legal_Document_Types>;
  /** fetch data from the table in a streaming manner: "legal_document_types" */
  legal_document_types_stream: Array<Legal_Document_Types>;
  /** An array relationship */
  legal_document_update_notifications: Array<Legal_Document_Update_Notifications>;
  /** An aggregate relationship */
  legal_document_update_notifications_aggregate: Legal_Document_Update_Notifications_Aggregate;
  /** fetch data from the table: "legal_document_update_notifications" using primary key columns */
  legal_document_update_notifications_by_pk?: Maybe<Legal_Document_Update_Notifications>;
  /** fetch data from the table in a streaming manner: "legal_document_update_notifications" */
  legal_document_update_notifications_stream: Array<Legal_Document_Update_Notifications>;
  /** fetch data from the table: "legal_documents" */
  legal_documents: Array<Legal_Documents>;
  /** fetch aggregated fields from the table: "legal_documents" */
  legal_documents_aggregate: Legal_Documents_Aggregate;
  /** fetch data from the table: "legal_documents" using primary key columns */
  legal_documents_by_pk?: Maybe<Legal_Documents>;
  /** fetch data from the table in a streaming manner: "legal_documents" */
  legal_documents_stream: Array<Legal_Documents>;
  /** fetch data from the table: "medical_schools" */
  medical_schools: Array<Medical_Schools>;
  /** fetch aggregated fields from the table: "medical_schools" */
  medical_schools_aggregate: Medical_Schools_Aggregate;
  /** fetch data from the table: "medical_schools" using primary key columns */
  medical_schools_by_pk?: Maybe<Medical_Schools>;
  /** fetch data from the table in a streaming manner: "medical_schools" */
  medical_schools_stream: Array<Medical_Schools>;
  /** fetch data from the table: "medications" */
  medications: Array<Medications>;
  /** fetch aggregated fields from the table: "medications" */
  medications_aggregate: Medications_Aggregate;
  /** fetch data from the table: "medications" using primary key columns */
  medications_by_pk?: Maybe<Medications>;
  /** fetch data from the table in a streaming manner: "medications" */
  medications_stream: Array<Medications>;
  /** fetch data from the table: "medications_unique" */
  medications_unique: Array<Medications_Unique>;
  /** fetch aggregated fields from the table: "medications_unique" */
  medications_unique_aggregate: Medications_Unique_Aggregate;
  /** fetch data from the table in a streaming manner: "medications_unique" */
  medications_unique_stream: Array<Medications_Unique>;
  /** fetch data from the table: "molecular_tests" */
  molecular_tests: Array<Molecular_Tests>;
  /** fetch aggregated fields from the table: "molecular_tests" */
  molecular_tests_aggregate: Molecular_Tests_Aggregate;
  /** fetch data from the table: "molecular_tests" using primary key columns */
  molecular_tests_by_pk?: Maybe<Molecular_Tests>;
  /** fetch data from the table in a streaming manner: "molecular_tests" */
  molecular_tests_stream: Array<Molecular_Tests>;
  /** fetch data from the table: "mosaic_tests" */
  mosaic_tests: Array<Mosaic_Tests>;
  /** fetch aggregated fields from the table: "mosaic_tests" */
  mosaic_tests_aggregate: Mosaic_Tests_Aggregate;
  /** fetch data from the table: "mosaic_tests" using primary key columns */
  mosaic_tests_by_pk?: Maybe<Mosaic_Tests>;
  /** fetch data from the table in a streaming manner: "mosaic_tests" */
  mosaic_tests_stream: Array<Mosaic_Tests>;
  /** fetch data from the table: "nabla_notes" */
  nabla_notes: Array<Nabla_Notes>;
  /** fetch aggregated fields from the table: "nabla_notes" */
  nabla_notes_aggregate: Nabla_Notes_Aggregate;
  /** fetch data from the table: "nabla_notes" using primary key columns */
  nabla_notes_by_pk?: Maybe<Nabla_Notes>;
  /** fetch data from the table in a streaming manner: "nabla_notes" */
  nabla_notes_stream: Array<Nabla_Notes>;
  /** fetch data from the table: "npi_registry_data" */
  npi_registry_data: Array<Npi_Registry_Data>;
  /** fetch aggregated fields from the table: "npi_registry_data" */
  npi_registry_data_aggregate: Npi_Registry_Data_Aggregate;
  /** fetch data from the table: "npi_registry_data" using primary key columns */
  npi_registry_data_by_pk?: Maybe<Npi_Registry_Data>;
  /** fetch data from the table in a streaming manner: "npi_registry_data" */
  npi_registry_data_stream: Array<Npi_Registry_Data>;
  /** An array relationship */
  order_payments: Array<Order_Payments>;
  /** An aggregate relationship */
  order_payments_aggregate: Order_Payments_Aggregate;
  /** fetch data from the table: "order_payments" using primary key columns */
  order_payments_by_pk?: Maybe<Order_Payments>;
  /** fetch data from the table in a streaming manner: "order_payments" */
  order_payments_stream: Array<Order_Payments>;
  /** An array relationship */
  order_products: Array<Order_Products>;
  /** An aggregate relationship */
  order_products_aggregate: Order_Products_Aggregate;
  /** fetch data from the table: "order_products" using primary key columns */
  order_products_by_pk?: Maybe<Order_Products>;
  /** fetch data from the table in a streaming manner: "order_products" */
  order_products_stream: Array<Order_Products>;
  /** fetch data from the table: "order_status_counts" */
  order_status_counts: Array<Order_Status_Counts>;
  /** fetch aggregated fields from the table: "order_status_counts" */
  order_status_counts_aggregate: Order_Status_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "order_status_counts" */
  order_status_counts_stream: Array<Order_Status_Counts>;
  /** fetch data from the table: "order_status_history" */
  order_status_history: Array<Order_Status_History>;
  /** fetch aggregated fields from the table: "order_status_history" */
  order_status_history_aggregate: Order_Status_History_Aggregate;
  /** fetch data from the table: "order_status_history" using primary key columns */
  order_status_history_by_pk?: Maybe<Order_Status_History>;
  /** fetch data from the table in a streaming manner: "order_status_history" */
  order_status_history_stream: Array<Order_Status_History>;
  /** fetch data from the table: "orders" */
  orders: Array<Orders>;
  /** fetch aggregated fields from the table: "orders" */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table in a streaming manner: "orders" */
  orders_stream: Array<Orders>;
  /** fetch data from the table: "orders_view" */
  orders_view: Array<Orders_View>;
  /** fetch aggregated fields from the table: "orders_view" */
  orders_view_aggregate: Orders_View_Aggregate;
  /** fetch data from the table in a streaming manner: "orders_view" */
  orders_view_stream: Array<Orders_View>;
  /** fetch data from the table: "patient_achievement_events" */
  patient_achievement_events: Array<Patient_Achievement_Events>;
  /** fetch aggregated fields from the table: "patient_achievement_events" */
  patient_achievement_events_aggregate: Patient_Achievement_Events_Aggregate;
  /** fetch data from the table: "patient_achievement_events" using primary key columns */
  patient_achievement_events_by_pk?: Maybe<Patient_Achievement_Events>;
  /** fetch data from the table in a streaming manner: "patient_achievement_events" */
  patient_achievement_events_stream: Array<Patient_Achievement_Events>;
  /** fetch data from the table: "patient_achievement_progress" */
  patient_achievement_progress: Array<Patient_Achievement_Progress>;
  /** fetch aggregated fields from the table: "patient_achievement_progress" */
  patient_achievement_progress_aggregate: Patient_Achievement_Progress_Aggregate;
  /** fetch data from the table: "patient_achievement_progress" using primary key columns */
  patient_achievement_progress_by_pk?: Maybe<Patient_Achievement_Progress>;
  /** fetch data from the table in a streaming manner: "patient_achievement_progress" */
  patient_achievement_progress_stream: Array<Patient_Achievement_Progress>;
  /** fetch data from the table: "patient_achievement_unlocks" */
  patient_achievement_unlocks: Array<Patient_Achievement_Unlocks>;
  /** fetch aggregated fields from the table: "patient_achievement_unlocks" */
  patient_achievement_unlocks_aggregate: Patient_Achievement_Unlocks_Aggregate;
  /** fetch data from the table: "patient_achievement_unlocks" using primary key columns */
  patient_achievement_unlocks_by_pk?: Maybe<Patient_Achievement_Unlocks>;
  /** fetch data from the table in a streaming manner: "patient_achievement_unlocks" */
  patient_achievement_unlocks_stream: Array<Patient_Achievement_Unlocks>;
  /** fetch data from the table: "payment_stats_by_day" */
  payment_stats_by_day: Array<Payment_Stats_By_Day>;
  /** fetch aggregated fields from the table: "payment_stats_by_day" */
  payment_stats_by_day_aggregate: Payment_Stats_By_Day_Aggregate;
  /** fetch data from the table in a streaming manner: "payment_stats_by_day" */
  payment_stats_by_day_stream: Array<Payment_Stats_By_Day>;
  /** An array relationship */
  payment_transaction_orders: Array<Payment_Transaction_Orders>;
  /** An aggregate relationship */
  payment_transaction_orders_aggregate: Payment_Transaction_Orders_Aggregate;
  /** fetch data from the table: "payment_transaction_orders" using primary key columns */
  payment_transaction_orders_by_pk?: Maybe<Payment_Transaction_Orders>;
  /** fetch data from the table in a streaming manner: "payment_transaction_orders" */
  payment_transaction_orders_stream: Array<Payment_Transaction_Orders>;
  /** An array relationship */
  payment_transactions: Array<Payment_Transactions>;
  /** An aggregate relationship */
  payment_transactions_aggregate: Payment_Transactions_Aggregate;
  /** fetch data from the table: "payment_transactions" using primary key columns */
  payment_transactions_by_pk?: Maybe<Payment_Transactions>;
  /** fetch data from the table in a streaming manner: "payment_transactions" */
  payment_transactions_stream: Array<Payment_Transactions>;
  /** fetch data from the table: "pending_patient_zrt" */
  pending_patient_zrt: Array<Pending_Patient_Zrt>;
  /** fetch aggregated fields from the table: "pending_patient_zrt" */
  pending_patient_zrt_aggregate: Pending_Patient_Zrt_Aggregate;
  /** fetch data from the table: "pending_patient_zrt" using primary key columns */
  pending_patient_zrt_by_pk?: Maybe<Pending_Patient_Zrt>;
  /** fetch data from the table in a streaming manner: "pending_patient_zrt" */
  pending_patient_zrt_stream: Array<Pending_Patient_Zrt>;
  /** fetch data from the table: "persona_inquiries" */
  persona_inquiries: Array<Persona_Inquiries>;
  /** fetch aggregated fields from the table: "persona_inquiries" */
  persona_inquiries_aggregate: Persona_Inquiries_Aggregate;
  /** fetch data from the table: "persona_inquiries" using primary key columns */
  persona_inquiries_by_pk?: Maybe<Persona_Inquiries>;
  /** fetch data from the table in a streaming manner: "persona_inquiries" */
  persona_inquiries_stream: Array<Persona_Inquiries>;
  /** fetch data from the table: "persona_inquiry_status" */
  persona_inquiry_status: Array<Persona_Inquiry_Status>;
  /** fetch aggregated fields from the table: "persona_inquiry_status" */
  persona_inquiry_status_aggregate: Persona_Inquiry_Status_Aggregate;
  /** fetch data from the table: "persona_inquiry_status" using primary key columns */
  persona_inquiry_status_by_pk?: Maybe<Persona_Inquiry_Status>;
  /** fetch data from the table in a streaming manner: "persona_inquiry_status" */
  persona_inquiry_status_stream: Array<Persona_Inquiry_Status>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table in a streaming manner: "products" */
  products_stream: Array<Products>;
  /** fetch data from the table: "provider_billing" */
  provider_billing: Array<Provider_Billing>;
  /** fetch aggregated fields from the table: "provider_billing" */
  provider_billing_aggregate: Provider_Billing_Aggregate;
  /** fetch data from the table: "provider_billing" using primary key columns */
  provider_billing_by_pk?: Maybe<Provider_Billing>;
  /** fetch data from the table in a streaming manner: "provider_billing" */
  provider_billing_stream: Array<Provider_Billing>;
  /** An array relationship */
  provider_dea_licenses: Array<Provider_Dea_Licenses>;
  /** An aggregate relationship */
  provider_dea_licenses_aggregate: Provider_Dea_Licenses_Aggregate;
  /** fetch data from the table: "provider_dea_licenses" using primary key columns */
  provider_dea_licenses_by_pk?: Maybe<Provider_Dea_Licenses>;
  /** fetch data from the table in a streaming manner: "provider_dea_licenses" */
  provider_dea_licenses_stream: Array<Provider_Dea_Licenses>;
  /** fetch data from the table: "provider_payments" */
  provider_payments: Array<Provider_Payments>;
  /** fetch aggregated fields from the table: "provider_payments" */
  provider_payments_aggregate: Provider_Payments_Aggregate;
  /** fetch data from the table: "provider_payments" using primary key columns */
  provider_payments_by_pk?: Maybe<Provider_Payments>;
  /** fetch data from the table in a streaming manner: "provider_payments" */
  provider_payments_stream: Array<Provider_Payments>;
  /** fetch data from the table: "provider_payouts" */
  provider_payouts: Array<Provider_Payouts>;
  /** fetch aggregated fields from the table: "provider_payouts" */
  provider_payouts_aggregate: Provider_Payouts_Aggregate;
  /** fetch data from the table in a streaming manner: "provider_payouts" */
  provider_payouts_stream: Array<Provider_Payouts>;
  /** An array relationship */
  provider_state_licenses: Array<Provider_State_Licenses>;
  /** An aggregate relationship */
  provider_state_licenses_aggregate: Provider_State_Licenses_Aggregate;
  /** fetch data from the table: "provider_state_licenses" using primary key columns */
  provider_state_licenses_by_pk?: Maybe<Provider_State_Licenses>;
  /** fetch data from the table in a streaming manner: "provider_state_licenses" */
  provider_state_licenses_stream: Array<Provider_State_Licenses>;
  /** fetch data from the table: "provider_unread_external_notification_counts" */
  provider_unread_external_notification_counts: Array<Provider_Unread_External_Notification_Counts>;
  /** fetch aggregated fields from the table: "provider_unread_external_notification_counts" */
  provider_unread_external_notification_counts_aggregate: Provider_Unread_External_Notification_Counts_Aggregate;
  /** fetch data from the table: "provider_unread_external_notification_counts" using primary key columns */
  provider_unread_external_notification_counts_by_pk?: Maybe<Provider_Unread_External_Notification_Counts>;
  /** fetch data from the table in a streaming manner: "provider_unread_external_notification_counts" */
  provider_unread_external_notification_counts_stream: Array<Provider_Unread_External_Notification_Counts>;
  /** fetch data from the table: "question_measurement_units" */
  question_measurement_units: Array<Question_Measurement_Units>;
  /** fetch aggregated fields from the table: "question_measurement_units" */
  question_measurement_units_aggregate: Question_Measurement_Units_Aggregate;
  /** fetch data from the table: "question_measurement_units" using primary key columns */
  question_measurement_units_by_pk?: Maybe<Question_Measurement_Units>;
  /** fetch data from the table in a streaming manner: "question_measurement_units" */
  question_measurement_units_stream: Array<Question_Measurement_Units>;
  /** fetch data from the table: "question_types" */
  question_types: Array<Question_Types>;
  /** fetch aggregated fields from the table: "question_types" */
  question_types_aggregate: Question_Types_Aggregate;
  /** fetch data from the table: "question_types" using primary key columns */
  question_types_by_pk?: Maybe<Question_Types>;
  /** fetch data from the table in a streaming manner: "question_types" */
  question_types_stream: Array<Question_Types>;
  /** fetch data from the table: "question_ui_control_helper_text_position" */
  question_ui_control_helper_text_position: Array<Question_Ui_Control_Helper_Text_Position>;
  /** fetch aggregated fields from the table: "question_ui_control_helper_text_position" */
  question_ui_control_helper_text_position_aggregate: Question_Ui_Control_Helper_Text_Position_Aggregate;
  /** fetch data from the table: "question_ui_control_helper_text_position" using primary key columns */
  question_ui_control_helper_text_position_by_pk?: Maybe<Question_Ui_Control_Helper_Text_Position>;
  /** fetch data from the table in a streaming manner: "question_ui_control_helper_text_position" */
  question_ui_control_helper_text_position_stream: Array<Question_Ui_Control_Helper_Text_Position>;
  /** fetch data from the table: "question_ui_control_types" */
  question_ui_control_types: Array<Question_Ui_Control_Types>;
  /** fetch aggregated fields from the table: "question_ui_control_types" */
  question_ui_control_types_aggregate: Question_Ui_Control_Types_Aggregate;
  /** fetch data from the table: "question_ui_control_types" using primary key columns */
  question_ui_control_types_by_pk?: Maybe<Question_Ui_Control_Types>;
  /** fetch data from the table in a streaming manner: "question_ui_control_types" */
  question_ui_control_types_stream: Array<Question_Ui_Control_Types>;
  /** fetch data from the table: "questionnaire_questions" */
  questionnaire_questions: Array<Questionnaire_Questions>;
  /** fetch aggregated fields from the table: "questionnaire_questions" */
  questionnaire_questions_aggregate: Questionnaire_Questions_Aggregate;
  /** fetch data from the table: "questionnaire_questions" using primary key columns */
  questionnaire_questions_by_pk?: Maybe<Questionnaire_Questions>;
  /** fetch data from the table in a streaming manner: "questionnaire_questions" */
  questionnaire_questions_stream: Array<Questionnaire_Questions>;
  /** fetch data from the table: "questionnaire_reminders" */
  questionnaire_reminders: Array<Questionnaire_Reminders>;
  /** fetch aggregated fields from the table: "questionnaire_reminders" */
  questionnaire_reminders_aggregate: Questionnaire_Reminders_Aggregate;
  /** fetch data from the table: "questionnaire_reminders" using primary key columns */
  questionnaire_reminders_by_pk?: Maybe<Questionnaire_Reminders>;
  /** fetch data from the table in a streaming manner: "questionnaire_reminders" */
  questionnaire_reminders_stream: Array<Questionnaire_Reminders>;
  /** fetch data from the table: "questionnaire_responses" */
  questionnaire_responses: Array<Questionnaire_Responses>;
  /** fetch aggregated fields from the table: "questionnaire_responses" */
  questionnaire_responses_aggregate: Questionnaire_Responses_Aggregate;
  /** fetch data from the table: "questionnaire_responses" using primary key columns */
  questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** fetch data from the table in a streaming manner: "questionnaire_responses" */
  questionnaire_responses_stream: Array<Questionnaire_Responses>;
  /** fetch data from the table: "questionnaires" */
  questionnaires: Array<Questionnaires>;
  /** fetch aggregated fields from the table: "questionnaires" */
  questionnaires_aggregate: Questionnaires_Aggregate;
  /** fetch data from the table: "questionnaires" using primary key columns */
  questionnaires_by_pk?: Maybe<Questionnaires>;
  /** fetch data from the table in a streaming manner: "questionnaires" */
  questionnaires_stream: Array<Questionnaires>;
  /** fetch data from the table: "questions" */
  questions: Array<Questions>;
  /** fetch aggregated fields from the table: "questions" */
  questions_aggregate: Questions_Aggregate;
  /** fetch data from the table: "questions" using primary key columns */
  questions_by_pk?: Maybe<Questions>;
  /** fetch data from the table in a streaming manner: "questions" */
  questions_stream: Array<Questions>;
  /** fetch data from the table: "recommendations" */
  recommendations: Array<Recommendations>;
  /** fetch aggregated fields from the table: "recommendations" */
  recommendations_aggregate: Recommendations_Aggregate;
  /** fetch data from the table: "recommendations" using primary key columns */
  recommendations_by_pk?: Maybe<Recommendations>;
  /** fetch data from the table in a streaming manner: "recommendations" */
  recommendations_stream: Array<Recommendations>;
  /** fetch data from the table: "shipmonk_sync_metadata" */
  shipmonk_sync_metadata: Array<Shipmonk_Sync_Metadata>;
  /** fetch aggregated fields from the table: "shipmonk_sync_metadata" */
  shipmonk_sync_metadata_aggregate: Shipmonk_Sync_Metadata_Aggregate;
  /** fetch data from the table: "shipmonk_sync_metadata" using primary key columns */
  shipmonk_sync_metadata_by_pk?: Maybe<Shipmonk_Sync_Metadata>;
  /** fetch data from the table in a streaming manner: "shipmonk_sync_metadata" */
  shipmonk_sync_metadata_stream: Array<Shipmonk_Sync_Metadata>;
  /** fetch data from the table: "skintelligent_tests" */
  skintelligent_tests: Array<Skintelligent_Tests>;
  /** fetch aggregated fields from the table: "skintelligent_tests" */
  skintelligent_tests_aggregate: Skintelligent_Tests_Aggregate;
  /** fetch data from the table: "skintelligent_tests" using primary key columns */
  skintelligent_tests_by_pk?: Maybe<Skintelligent_Tests>;
  /** fetch data from the table in a streaming manner: "skintelligent_tests" */
  skintelligent_tests_stream: Array<Skintelligent_Tests>;
  /** fetch data from the table: "stripe_billing_plans" */
  stripe_billing_plans: Array<Stripe_Billing_Plans>;
  /** fetch aggregated fields from the table: "stripe_billing_plans" */
  stripe_billing_plans_aggregate: Stripe_Billing_Plans_Aggregate;
  /** fetch data from the table: "stripe_billing_plans" using primary key columns */
  stripe_billing_plans_by_pk?: Maybe<Stripe_Billing_Plans>;
  /** fetch data from the table in a streaming manner: "stripe_billing_plans" */
  stripe_billing_plans_stream: Array<Stripe_Billing_Plans>;
  /** An array relationship */
  stripe_customers: Array<Stripe_Customers>;
  /** An aggregate relationship */
  stripe_customers_aggregate: Stripe_Customers_Aggregate;
  /** fetch data from the table: "stripe_customers" using primary key columns */
  stripe_customers_by_pk?: Maybe<Stripe_Customers>;
  /** fetch data from the table in a streaming manner: "stripe_customers" */
  stripe_customers_stream: Array<Stripe_Customers>;
  /** fetch data from the table: "stripe_latest_subscription_per_user_view" */
  stripe_latest_subscription_per_user_view: Array<Stripe_Latest_Subscription_Per_User_View>;
  /** fetch aggregated fields from the table: "stripe_latest_subscription_per_user_view" */
  stripe_latest_subscription_per_user_view_aggregate: Stripe_Latest_Subscription_Per_User_View_Aggregate;
  /** fetch data from the table in a streaming manner: "stripe_latest_subscription_per_user_view" */
  stripe_latest_subscription_per_user_view_stream: Array<Stripe_Latest_Subscription_Per_User_View>;
  /** fetch data from the table: "stripe_payment_intents" */
  stripe_payment_intents: Array<Stripe_Payment_Intents>;
  /** fetch aggregated fields from the table: "stripe_payment_intents" */
  stripe_payment_intents_aggregate: Stripe_Payment_Intents_Aggregate;
  /** fetch data from the table: "stripe_payment_intents" using primary key columns */
  stripe_payment_intents_by_pk?: Maybe<Stripe_Payment_Intents>;
  /** fetch data from the table in a streaming manner: "stripe_payment_intents" */
  stripe_payment_intents_stream: Array<Stripe_Payment_Intents>;
  /** An array relationship */
  stripe_payment_methods: Array<Stripe_Payment_Methods>;
  /** An aggregate relationship */
  stripe_payment_methods_aggregate: Stripe_Payment_Methods_Aggregate;
  /** fetch data from the table: "stripe_payment_methods" using primary key columns */
  stripe_payment_methods_by_pk?: Maybe<Stripe_Payment_Methods>;
  /** fetch data from the table in a streaming manner: "stripe_payment_methods" */
  stripe_payment_methods_stream: Array<Stripe_Payment_Methods>;
  /** An array relationship */
  stripe_subscriptions: Array<Stripe_Subscriptions>;
  /** An aggregate relationship */
  stripe_subscriptions_aggregate: Stripe_Subscriptions_Aggregate;
  /** fetch data from the table: "stripe_subscriptions" using primary key columns */
  stripe_subscriptions_by_pk?: Maybe<Stripe_Subscriptions>;
  /** fetch data from the table in a streaming manner: "stripe_subscriptions" */
  stripe_subscriptions_stream: Array<Stripe_Subscriptions>;
  /** fetch data from the table: "stripe_transaction" */
  stripe_transaction: Array<Stripe_Transaction>;
  /** fetch aggregated fields from the table: "stripe_transaction" */
  stripe_transaction_aggregate: Stripe_Transaction_Aggregate;
  /** fetch data from the table: "stripe_transaction" using primary key columns */
  stripe_transaction_by_pk?: Maybe<Stripe_Transaction>;
  /** fetch data from the table in a streaming manner: "stripe_transaction" */
  stripe_transaction_stream: Array<Stripe_Transaction>;
  /** An array relationship */
  support_chat_usage: Array<Support_Chat_Usage>;
  /** An aggregate relationship */
  support_chat_usage_aggregate: Support_Chat_Usage_Aggregate;
  /** fetch data from the table: "support_chat_usage" using primary key columns */
  support_chat_usage_by_pk?: Maybe<Support_Chat_Usage>;
  /** fetch data from the table in a streaming manner: "support_chat_usage" */
  support_chat_usage_stream: Array<Support_Chat_Usage>;
  /** fetch data from the table: "swab_code_statuses" */
  swab_code_statuses: Array<Swab_Code_Statuses>;
  /** fetch aggregated fields from the table: "swab_code_statuses" */
  swab_code_statuses_aggregate: Swab_Code_Statuses_Aggregate;
  /** fetch data from the table: "swab_code_statuses" using primary key columns */
  swab_code_statuses_by_pk?: Maybe<Swab_Code_Statuses>;
  /** fetch data from the table in a streaming manner: "swab_code_statuses" */
  swab_code_statuses_stream: Array<Swab_Code_Statuses>;
  /** fetch data from the table: "swab_codes" */
  swab_codes: Array<Swab_Codes>;
  /** fetch aggregated fields from the table: "swab_codes" */
  swab_codes_aggregate: Swab_Codes_Aggregate;
  /** fetch data from the table: "swab_codes" using primary key columns */
  swab_codes_by_pk?: Maybe<Swab_Codes>;
  /** fetch data from the table in a streaming manner: "swab_codes" */
  swab_codes_stream: Array<Swab_Codes>;
  /** fetch data from the table: "swab_usage_type" */
  swab_usage_type: Array<Swab_Usage_Type>;
  /** fetch aggregated fields from the table: "swab_usage_type" */
  swab_usage_type_aggregate: Swab_Usage_Type_Aggregate;
  /** fetch data from the table: "swab_usage_type" using primary key columns */
  swab_usage_type_by_pk?: Maybe<Swab_Usage_Type>;
  /** fetch data from the table in a streaming manner: "swab_usage_type" */
  swab_usage_type_stream: Array<Swab_Usage_Type>;
  /** fetch data from the table: "test_definitions" */
  test_definitions: Array<Test_Definitions>;
  /** fetch aggregated fields from the table: "test_definitions" */
  test_definitions_aggregate: Test_Definitions_Aggregate;
  /** fetch data from the table: "test_definitions" using primary key columns */
  test_definitions_by_pk?: Maybe<Test_Definitions>;
  /** fetch data from the table in a streaming manner: "test_definitions" */
  test_definitions_stream: Array<Test_Definitions>;
  /** fetch data from the table: "test_e_prescribe_npis" */
  test_e_prescribe_npis: Array<Test_E_Prescribe_Npis>;
  /** fetch aggregated fields from the table: "test_e_prescribe_npis" */
  test_e_prescribe_npis_aggregate: Test_E_Prescribe_Npis_Aggregate;
  /** fetch data from the table: "test_e_prescribe_npis" using primary key columns */
  test_e_prescribe_npis_by_pk?: Maybe<Test_E_Prescribe_Npis>;
  /** fetch data from the table in a streaming manner: "test_e_prescribe_npis" */
  test_e_prescribe_npis_stream: Array<Test_E_Prescribe_Npis>;
  /** fetch data from the table: "test_kit_status_counts" */
  test_kit_status_counts: Array<Test_Kit_Status_Counts>;
  /** fetch aggregated fields from the table: "test_kit_status_counts" */
  test_kit_status_counts_aggregate: Test_Kit_Status_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "test_kit_status_counts" */
  test_kit_status_counts_stream: Array<Test_Kit_Status_Counts>;
  /** fetch data from the table: "test_kits_update_states_summary_log" */
  test_kits_update_states_summary_log: Array<Test_Kits_Update_States_Summary_Log>;
  /** fetch aggregated fields from the table: "test_kits_update_states_summary_log" */
  test_kits_update_states_summary_log_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  /** fetch data from the table: "test_kits_update_states_summary_log" using primary key columns */
  test_kits_update_states_summary_log_by_pk?: Maybe<Test_Kits_Update_States_Summary_Log>;
  /** fetch data from the table in a streaming manner: "test_kits_update_states_summary_log" */
  test_kits_update_states_summary_log_stream: Array<Test_Kits_Update_States_Summary_Log>;
  /** fetch data from the table: "test_types" */
  test_types: Array<Test_Types>;
  /** fetch aggregated fields from the table: "test_types" */
  test_types_aggregate: Test_Types_Aggregate;
  /** fetch data from the table: "test_types" using primary key columns */
  test_types_by_pk?: Maybe<Test_Types>;
  /** fetch data from the table in a streaming manner: "test_types" */
  test_types_stream: Array<Test_Types>;
  /** fetch data from the table: "tests" */
  tests: Array<Tests>;
  /** fetch aggregated fields from the table: "tests" */
  tests_aggregate: Tests_Aggregate;
  /** fetch data from the table: "tests" using primary key columns */
  tests_by_pk?: Maybe<Tests>;
  /** fetch data from the table in a streaming manner: "tests" */
  tests_stream: Array<Tests>;
  /** fetch data from the table: "text_addresses" */
  text_addresses: Array<Text_Addresses>;
  /** fetch aggregated fields from the table: "text_addresses" */
  text_addresses_aggregate: Text_Addresses_Aggregate;
  /** fetch data from the table: "text_addresses" using primary key columns */
  text_addresses_by_pk?: Maybe<Text_Addresses>;
  /** fetch data from the table in a streaming manner: "text_addresses" */
  text_addresses_stream: Array<Text_Addresses>;
  /** An array relationship */
  unauthenticated_questionnaire_questions: Array<Unauthenticated_Questionnaire_Questions>;
  /** An aggregate relationship */
  unauthenticated_questionnaire_questions_aggregate: Unauthenticated_Questionnaire_Questions_Aggregate;
  /** fetch data from the table: "unauthenticated_questionnaire_questions" using primary key columns */
  unauthenticated_questionnaire_questions_by_pk?: Maybe<Unauthenticated_Questionnaire_Questions>;
  /** fetch data from the table in a streaming manner: "unauthenticated_questionnaire_questions" */
  unauthenticated_questionnaire_questions_stream: Array<Unauthenticated_Questionnaire_Questions>;
  /** fetch data from the table: "unauthenticated_questionnaires" */
  unauthenticated_questionnaires: Array<Unauthenticated_Questionnaires>;
  /** fetch aggregated fields from the table: "unauthenticated_questionnaires" */
  unauthenticated_questionnaires_aggregate: Unauthenticated_Questionnaires_Aggregate;
  /** fetch data from the table: "unauthenticated_questionnaires" using primary key columns */
  unauthenticated_questionnaires_by_pk?: Maybe<Unauthenticated_Questionnaires>;
  /** fetch data from the table in a streaming manner: "unauthenticated_questionnaires" */
  unauthenticated_questionnaires_stream: Array<Unauthenticated_Questionnaires>;
  /** fetch data from the table: "unauthenticated_questions" */
  unauthenticated_questions: Array<Unauthenticated_Questions>;
  /** fetch aggregated fields from the table: "unauthenticated_questions" */
  unauthenticated_questions_aggregate: Unauthenticated_Questions_Aggregate;
  /** fetch data from the table: "unauthenticated_questions" using primary key columns */
  unauthenticated_questions_by_pk?: Maybe<Unauthenticated_Questions>;
  /** fetch data from the table in a streaming manner: "unauthenticated_questions" */
  unauthenticated_questions_stream: Array<Unauthenticated_Questions>;
  /** fetch data from the table: "universities" */
  universities: Array<Universities>;
  /** fetch aggregated fields from the table: "universities" */
  universities_aggregate: Universities_Aggregate;
  /** fetch data from the table: "universities" using primary key columns */
  universities_by_pk?: Maybe<Universities>;
  /** fetch data from the table in a streaming manner: "universities" */
  universities_stream: Array<Universities>;
  /** fetch data from the table: "used_test_e_prescribe_licenses" */
  used_test_e_prescribe_licenses: Array<Used_Test_E_Prescribe_Licenses>;
  /** fetch aggregated fields from the table: "used_test_e_prescribe_licenses" */
  used_test_e_prescribe_licenses_aggregate: Used_Test_E_Prescribe_Licenses_Aggregate;
  /** fetch data from the table: "used_test_e_prescribe_licenses" using primary key columns */
  used_test_e_prescribe_licenses_by_pk?: Maybe<Used_Test_E_Prescribe_Licenses>;
  /** fetch data from the table in a streaming manner: "used_test_e_prescribe_licenses" */
  used_test_e_prescribe_licenses_stream: Array<Used_Test_E_Prescribe_Licenses>;
  /** fetch data from the table: "user_addresses" */
  user_addresses: Array<User_Addresses>;
  /** fetch aggregated fields from the table: "user_addresses" */
  user_addresses_aggregate: User_Addresses_Aggregate;
  /** fetch data from the table: "user_addresses" using primary key columns */
  user_addresses_by_pk?: Maybe<User_Addresses>;
  /** fetch data from the table in a streaming manner: "user_addresses" */
  user_addresses_stream: Array<User_Addresses>;
  /** An array relationship */
  user_agreements: Array<User_Agreements>;
  /** An aggregate relationship */
  user_agreements_aggregate: User_Agreements_Aggregate;
  /** fetch data from the table: "user_agreements" using primary key columns */
  user_agreements_by_pk?: Maybe<User_Agreements>;
  /** fetch data from the table in a streaming manner: "user_agreements" */
  user_agreements_stream: Array<User_Agreements>;
  /** fetch data from the table: "user_auth_provider_types" */
  user_auth_provider_types: Array<User_Auth_Provider_Types>;
  /** fetch aggregated fields from the table: "user_auth_provider_types" */
  user_auth_provider_types_aggregate: User_Auth_Provider_Types_Aggregate;
  /** fetch data from the table: "user_auth_provider_types" using primary key columns */
  user_auth_provider_types_by_pk?: Maybe<User_Auth_Provider_Types>;
  /** fetch data from the table in a streaming manner: "user_auth_provider_types" */
  user_auth_provider_types_stream: Array<User_Auth_Provider_Types>;
  /** fetch data from the table: "user_auth_providers" */
  user_auth_providers: Array<User_Auth_Providers>;
  /** fetch aggregated fields from the table: "user_auth_providers" */
  user_auth_providers_aggregate: User_Auth_Providers_Aggregate;
  /** fetch data from the table: "user_auth_providers" using primary key columns */
  user_auth_providers_by_pk?: Maybe<User_Auth_Providers>;
  /** fetch data from the table in a streaming manner: "user_auth_providers" */
  user_auth_providers_stream: Array<User_Auth_Providers>;
  /** fetch data from the table: "user_auth_tokens" */
  user_auth_tokens: Array<User_Auth_Tokens>;
  /** fetch aggregated fields from the table: "user_auth_tokens" */
  user_auth_tokens_aggregate: User_Auth_Tokens_Aggregate;
  /** fetch data from the table: "user_auth_tokens" using primary key columns */
  user_auth_tokens_by_pk?: Maybe<User_Auth_Tokens>;
  /** fetch data from the table in a streaming manner: "user_auth_tokens" */
  user_auth_tokens_stream: Array<User_Auth_Tokens>;
  /** An array relationship */
  user_communication_deliveries: Array<User_Communication_Deliveries>;
  /** An aggregate relationship */
  user_communication_deliveries_aggregate: User_Communication_Deliveries_Aggregate;
  /** fetch data from the table: "user_communication_deliveries" using primary key columns */
  user_communication_deliveries_by_pk?: Maybe<User_Communication_Deliveries>;
  /** fetch data from the table in a streaming manner: "user_communication_deliveries" */
  user_communication_deliveries_stream: Array<User_Communication_Deliveries>;
  /** fetch data from the table: "user_communications" */
  user_communications: Array<User_Communications>;
  /** fetch aggregated fields from the table: "user_communications" */
  user_communications_aggregate: User_Communications_Aggregate;
  /** fetch data from the table: "user_communications" using primary key columns */
  user_communications_by_pk?: Maybe<User_Communications>;
  /** fetch data from the table in a streaming manner: "user_communications" */
  user_communications_stream: Array<User_Communications>;
  /** fetch data from the table: "user_indicators" */
  user_indicators: Array<User_Indicators>;
  /** fetch aggregated fields from the table: "user_indicators" */
  user_indicators_aggregate: User_Indicators_Aggregate;
  /** fetch data from the table: "user_indicators" using primary key columns */
  user_indicators_by_pk?: Maybe<User_Indicators>;
  /** fetch data from the table in a streaming manner: "user_indicators" */
  user_indicators_stream: Array<User_Indicators>;
  /** fetch data from the table: "user_notification_status" */
  user_notification_status: Array<User_Notification_Status>;
  /** fetch aggregated fields from the table: "user_notification_status" */
  user_notification_status_aggregate: User_Notification_Status_Aggregate;
  /** fetch data from the table: "user_notification_status" using primary key columns */
  user_notification_status_by_pk?: Maybe<User_Notification_Status>;
  /** fetch data from the table in a streaming manner: "user_notification_status" */
  user_notification_status_stream: Array<User_Notification_Status>;
  /** fetch data from the table: "user_notifications" */
  user_notifications: Array<User_Notifications>;
  /** fetch aggregated fields from the table: "user_notifications" */
  user_notifications_aggregate: User_Notifications_Aggregate;
  /** fetch data from the table: "user_notifications" using primary key columns */
  user_notifications_by_pk?: Maybe<User_Notifications>;
  /** fetch data from the table in a streaming manner: "user_notifications" */
  user_notifications_stream: Array<User_Notifications>;
  /** An array relationship */
  user_push_tokens: Array<User_Push_Tokens>;
  /** An aggregate relationship */
  user_push_tokens_aggregate: User_Push_Tokens_Aggregate;
  /** fetch data from the table: "user_push_tokens" using primary key columns */
  user_push_tokens_by_pk?: Maybe<User_Push_Tokens>;
  /** fetch data from the table in a streaming manner: "user_push_tokens" */
  user_push_tokens_stream: Array<User_Push_Tokens>;
  /** fetch data from the table: "user_scanned_data" */
  user_scanned_data: Array<User_Scanned_Data>;
  /** fetch aggregated fields from the table: "user_scanned_data" */
  user_scanned_data_aggregate: User_Scanned_Data_Aggregate;
  /** fetch data from the table: "user_scanned_data" using primary key columns */
  user_scanned_data_by_pk?: Maybe<User_Scanned_Data>;
  /** fetch data from the table in a streaming manner: "user_scanned_data" */
  user_scanned_data_stream: Array<User_Scanned_Data>;
  /** fetch data from the table: "user_settings" */
  user_settings: Array<User_Settings>;
  /** fetch aggregated fields from the table: "user_settings" */
  user_settings_aggregate: User_Settings_Aggregate;
  /** fetch data from the table: "user_settings" using primary key columns */
  user_settings_by_pk?: Maybe<User_Settings>;
  /** fetch data from the table in a streaming manner: "user_settings" */
  user_settings_stream: Array<User_Settings>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "vonage_appointment" */
  vonage_appointment: Array<Vonage_Appointment>;
  /** fetch aggregated fields from the table: "vonage_appointment" */
  vonage_appointment_aggregate: Vonage_Appointment_Aggregate;
  /** fetch data from the table: "vonage_appointment" using primary key columns */
  vonage_appointment_by_pk?: Maybe<Vonage_Appointment>;
  /** fetch data from the table in a streaming manner: "vonage_appointment" */
  vonage_appointment_stream: Array<Vonage_Appointment>;
  /** fetch data from the table: "zrt_tests" */
  zrt_tests: Array<Zrt_Tests>;
  /** fetch aggregated fields from the table: "zrt_tests" */
  zrt_tests_aggregate: Zrt_Tests_Aggregate;
  /** fetch data from the table: "zrt_tests" using primary key columns */
  zrt_tests_by_pk?: Maybe<Zrt_Tests>;
  /** fetch data from the table in a streaming manner: "zrt_tests" */
  zrt_tests_stream: Array<Zrt_Tests>;
};


export type Subscription_RootAccepted_Legal_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accepted_Legal_Documents_Order_By>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


export type Subscription_RootAccepted_Legal_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accepted_Legal_Documents_Order_By>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


export type Subscription_RootAccepted_Legal_Documents_By_PkArgs = {
  accepted_legal_document_id: Scalars['bigint'];
};


export type Subscription_RootAccepted_Legal_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Accepted_Legal_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


export type Subscription_RootActive_In_MailsArgs = {
  distinct_on?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_In_Mails_Order_By>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


export type Subscription_RootActive_In_Mails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_In_Mails_Order_By>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


export type Subscription_RootActive_In_Mails_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActive_In_Mails_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Active_In_Mails_Stream_Cursor_Input>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


export type Subscription_RootActive_Support_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Support_Chats_Order_By>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


export type Subscription_RootActive_Support_Chats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Support_Chats_Order_By>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


export type Subscription_RootActive_Support_Chats_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootActive_Support_Chats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Active_Support_Chats_Stream_Cursor_Input>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


export type Subscription_RootActivity_EventsArgs = {
  distinct_on?: InputMaybe<Array<Activity_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Events_Order_By>>;
  where?: InputMaybe<Activity_Events_Bool_Exp>;
};


export type Subscription_RootActivity_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Activity_Events_Order_By>>;
  where?: InputMaybe<Activity_Events_Bool_Exp>;
};


export type Subscription_RootActivity_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootActivity_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Activity_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Events_Bool_Exp>;
};


export type Subscription_RootAcuity_Provider_CalendarArgs = {
  distinct_on?: InputMaybe<Array<Acuity_Provider_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acuity_Provider_Calendar_Order_By>>;
  where?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
};


export type Subscription_RootAcuity_Provider_Calendar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acuity_Provider_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acuity_Provider_Calendar_Order_By>>;
  where?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
};


export type Subscription_RootAcuity_Provider_Calendar_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAcuity_Provider_Calendar_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Acuity_Provider_Calendar_Stream_Cursor_Input>>;
  where?: InputMaybe<Acuity_Provider_Calendar_Bool_Exp>;
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_By_PkArgs = {
  address_id: Scalars['uuid'];
};


export type Subscription_RootAddresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAdmin_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Admin_Permissions_Order_By>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


export type Subscription_RootAdmin_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Admin_Permissions_Order_By>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


export type Subscription_RootAdmin_Permissions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootAdmin_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Admin_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


export type Subscription_RootAge_Of_Majority_RulesArgs = {
  distinct_on?: InputMaybe<Array<Age_Of_Majority_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Age_Of_Majority_Rules_Order_By>>;
  where?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
};


export type Subscription_RootAge_Of_Majority_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Age_Of_Majority_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Age_Of_Majority_Rules_Order_By>>;
  where?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
};


export type Subscription_RootAge_Of_Majority_Rules_By_PkArgs = {
  state_code: Scalars['bpchar'];
};


export type Subscription_RootAge_Of_Majority_Rules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Age_Of_Majority_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Age_Of_Majority_Rules_Bool_Exp>;
};


export type Subscription_RootAllergen_ClassesArgs = {
  distinct_on?: InputMaybe<Array<Allergen_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Allergen_Classes_Order_By>>;
  where?: InputMaybe<Allergen_Classes_Bool_Exp>;
};


export type Subscription_RootAllergen_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Allergen_Classes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Allergen_Classes_Order_By>>;
  where?: InputMaybe<Allergen_Classes_Bool_Exp>;
};


export type Subscription_RootAllergen_Classes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAllergen_Classes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Allergen_Classes_Stream_Cursor_Input>>;
  where?: InputMaybe<Allergen_Classes_Bool_Exp>;
};


export type Subscription_RootApp_ToursArgs = {
  distinct_on?: InputMaybe<Array<App_Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Tours_Order_By>>;
  where?: InputMaybe<App_Tours_Bool_Exp>;
};


export type Subscription_RootApp_Tours_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Tours_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Tours_Order_By>>;
  where?: InputMaybe<App_Tours_Bool_Exp>;
};


export type Subscription_RootApp_Tours_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootApp_Tours_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<App_Tours_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Tours_Bool_Exp>;
};


export type Subscription_RootApp_VersionsArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Subscription_RootApp_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<App_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<App_Versions_Order_By>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Subscription_RootApp_Versions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootApp_Versions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<App_Versions_Stream_Cursor_Input>>;
  where?: InputMaybe<App_Versions_Bool_Exp>;
};


export type Subscription_RootAppointment_Media_SignalsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Media_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Media_Signals_Order_By>>;
  where?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
};


export type Subscription_RootAppointment_Media_Signals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Media_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Media_Signals_Order_By>>;
  where?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
};


export type Subscription_RootAppointment_Media_Signals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAppointment_Media_Signals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appointment_Media_Signals_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointment_Media_Signals_Bool_Exp>;
};


export type Subscription_RootAppointment_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Payments_Order_By>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


export type Subscription_RootAppointment_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Payments_Order_By>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


export type Subscription_RootAppointment_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAppointment_Payments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appointment_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointment_Payments_Bool_Exp>;
};


export type Subscription_RootAppointment_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Requests_Order_By>>;
  where?: InputMaybe<Appointment_Requests_Bool_Exp>;
};


export type Subscription_RootAppointment_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Requests_Order_By>>;
  where?: InputMaybe<Appointment_Requests_Bool_Exp>;
};


export type Subscription_RootAppointment_Requests_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAppointment_Requests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appointment_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointment_Requests_Bool_Exp>;
};


export type Subscription_RootAppointment_Status_CountsArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Subscription_RootAppointment_Status_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Subscription_RootAppointment_Status_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appointment_Status_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Subscription_RootAppointment_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_History_Order_By>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


export type Subscription_RootAppointment_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointment_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_History_Order_By>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


export type Subscription_RootAppointment_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAppointment_Status_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appointment_Status_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointment_Status_History_Bool_Exp>;
};


export type Subscription_RootAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Subscription_RootAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Subscription_RootAppointments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAppointments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appointments_Stream_Cursor_Input>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


export type Subscription_RootCart_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Cart_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cart_Products_Order_By>>;
  where?: InputMaybe<Cart_Products_Bool_Exp>;
};


export type Subscription_RootCart_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cart_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cart_Products_Order_By>>;
  where?: InputMaybe<Cart_Products_Bool_Exp>;
};


export type Subscription_RootCart_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCart_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cart_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Cart_Products_Bool_Exp>;
};


export type Subscription_RootChannel_SignalsArgs = {
  distinct_on?: InputMaybe<Array<Channel_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Signals_Order_By>>;
  where?: InputMaybe<Channel_Signals_Bool_Exp>;
};


export type Subscription_RootChannel_Signals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Signals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Signals_Order_By>>;
  where?: InputMaybe<Channel_Signals_Bool_Exp>;
};


export type Subscription_RootChannel_Signals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootChannel_Signals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Signals_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Signals_Bool_Exp>;
};


export type Subscription_RootCommon_Question_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Common_Question_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Question_Responses_Order_By>>;
  where?: InputMaybe<Common_Question_Responses_Bool_Exp>;
};


export type Subscription_RootCommon_Question_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Common_Question_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Question_Responses_Order_By>>;
  where?: InputMaybe<Common_Question_Responses_Bool_Exp>;
};


export type Subscription_RootCommon_Question_Responses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootCommon_Question_Responses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Common_Question_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Common_Question_Responses_Bool_Exp>;
};


export type Subscription_RootCommon_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Common_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Questions_Order_By>>;
  where?: InputMaybe<Common_Questions_Bool_Exp>;
};


export type Subscription_RootCommon_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Common_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Common_Questions_Order_By>>;
  where?: InputMaybe<Common_Questions_Bool_Exp>;
};


export type Subscription_RootCommon_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCommon_Questions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Common_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Common_Questions_Bool_Exp>;
};


export type Subscription_RootCommunication_ChannelsArgs = {
  distinct_on?: InputMaybe<Array<Communication_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Channels_Order_By>>;
  where?: InputMaybe<Communication_Channels_Bool_Exp>;
};


export type Subscription_RootCommunication_Channels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Communication_Channels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communication_Channels_Order_By>>;
  where?: InputMaybe<Communication_Channels_Bool_Exp>;
};


export type Subscription_RootCommunication_Channels_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCommunication_Channels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Communication_Channels_Stream_Cursor_Input>>;
  where?: InputMaybe<Communication_Channels_Bool_Exp>;
};


export type Subscription_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCountries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCustom_Auth_CodeArgs = {
  distinct_on?: InputMaybe<Array<Custom_Auth_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Custom_Auth_Code_Order_By>>;
  where?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
};


export type Subscription_RootCustom_Auth_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Auth_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Custom_Auth_Code_Order_By>>;
  where?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
};


export type Subscription_RootCustom_Auth_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCustom_Auth_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Custom_Auth_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Auth_Code_Bool_Exp>;
};


export type Subscription_RootDea_License_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dea_License_Schedules_Order_By>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};


export type Subscription_RootDea_License_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dea_License_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dea_License_Schedules_Order_By>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};


export type Subscription_RootDea_License_Schedules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDea_License_Schedules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dea_License_Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Dea_License_Schedules_Bool_Exp>;
};


export type Subscription_RootDelivery_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Addresses_Order_By>>;
  where?: InputMaybe<Delivery_Addresses_Bool_Exp>;
};


export type Subscription_RootDelivery_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Addresses_Order_By>>;
  where?: InputMaybe<Delivery_Addresses_Bool_Exp>;
};


export type Subscription_RootDelivery_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDelivery_Addresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Delivery_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Addresses_Bool_Exp>;
};


export type Subscription_RootDiagnostic_Solution_TestsArgs = {
  distinct_on?: InputMaybe<Array<Diagnostic_Solution_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnostic_Solution_Tests_Order_By>>;
  where?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
};


export type Subscription_RootDiagnostic_Solution_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Diagnostic_Solution_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Diagnostic_Solution_Tests_Order_By>>;
  where?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
};


export type Subscription_RootDiagnostic_Solution_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootDiagnostic_Solution_Tests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Diagnostic_Solution_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Diagnostic_Solution_Tests_Bool_Exp>;
};


export type Subscription_RootDnavisit_Test_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Test_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Test_Statuses_Order_By>>;
  where?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
};


export type Subscription_RootDnavisit_Test_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Test_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Test_Statuses_Order_By>>;
  where?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
};


export type Subscription_RootDnavisit_Test_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDnavisit_Test_Statuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dnavisit_Test_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
};


export type Subscription_RootDnavisit_TestsArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Tests_Order_By>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


export type Subscription_RootDnavisit_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Tests_Order_By>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


export type Subscription_RootDnavisit_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootDnavisit_Tests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dnavisit_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


export type Subscription_RootDo_Not_Use_Production_Swab_CodesArgs = {
  distinct_on?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Order_By>>;
  where?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
};


export type Subscription_RootDo_Not_Use_Production_Swab_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Do_Not_Use_Production_Swab_Codes_Order_By>>;
  where?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
};


export type Subscription_RootDo_Not_Use_Production_Swab_Codes_By_PkArgs = {
  swab_code: Scalars['String'];
};


export type Subscription_RootDo_Not_Use_Production_Swab_Codes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Do_Not_Use_Production_Swab_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Do_Not_Use_Production_Swab_Codes_Bool_Exp>;
};


export type Subscription_RootEcommerce_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Orders_Order_By>>;
  where?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
};


export type Subscription_RootEcommerce_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Orders_Order_By>>;
  where?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
};


export type Subscription_RootEcommerce_Orders_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEcommerce_Orders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ecommerce_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Ecommerce_Orders_Bool_Exp>;
};


export type Subscription_RootEducation_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Education_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Courses_Order_By>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


export type Subscription_RootEducation_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Courses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Courses_Order_By>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


export type Subscription_RootEducation_Courses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEducation_Courses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Education_Courses_Stream_Cursor_Input>>;
  where?: InputMaybe<Education_Courses_Bool_Exp>;
};


export type Subscription_RootEducation_Module_Additional_MaterialsArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Additional_Materials_Order_By>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


export type Subscription_RootEducation_Module_Additional_Materials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Additional_Materials_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Additional_Materials_Order_By>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


export type Subscription_RootEducation_Module_Additional_Materials_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEducation_Module_Additional_Materials_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Education_Module_Additional_Materials_Stream_Cursor_Input>>;
  where?: InputMaybe<Education_Module_Additional_Materials_Bool_Exp>;
};


export type Subscription_RootEducation_Module_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


export type Subscription_RootEducation_Module_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Module_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Module_Items_Order_By>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


export type Subscription_RootEducation_Module_Items_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEducation_Module_Items_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Education_Module_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Education_Module_Items_Bool_Exp>;
};


export type Subscription_RootEducation_ModulesArgs = {
  distinct_on?: InputMaybe<Array<Education_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Modules_Order_By>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};


export type Subscription_RootEducation_Modules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Education_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Education_Modules_Order_By>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};


export type Subscription_RootEducation_Modules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEducation_Modules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Education_Modules_Stream_Cursor_Input>>;
  where?: InputMaybe<Education_Modules_Bool_Exp>;
};


export type Subscription_RootFile_TypesArgs = {
  distinct_on?: InputMaybe<Array<File_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Types_Order_By>>;
  where?: InputMaybe<File_Types_Bool_Exp>;
};


export type Subscription_RootFile_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Types_Order_By>>;
  where?: InputMaybe<File_Types_Bool_Exp>;
};


export type Subscription_RootFile_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFile_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Types_Bool_Exp>;
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFullscript_AllergensArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Allergens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Allergens_Order_By>>;
  where?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
};


export type Subscription_RootFullscript_Allergens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Allergens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Allergens_Order_By>>;
  where?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
};


export type Subscription_RootFullscript_Allergens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFullscript_Allergens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fullscript_Allergens_Stream_Cursor_Input>>;
  where?: InputMaybe<Fullscript_Allergens_Bool_Exp>;
};


export type Subscription_RootFullscript_CliniciansArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Clinicians_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Clinicians_Order_By>>;
  where?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
};


export type Subscription_RootFullscript_Clinicians_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fullscript_Clinicians_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fullscript_Clinicians_Order_By>>;
  where?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
};


export type Subscription_RootFullscript_Clinicians_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFullscript_Clinicians_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fullscript_Clinicians_Stream_Cursor_Input>>;
  where?: InputMaybe<Fullscript_Clinicians_Bool_Exp>;
};


export type Subscription_RootGale_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Gale_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gale_Products_Order_By>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};


export type Subscription_RootGale_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gale_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gale_Products_Order_By>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};


export type Subscription_RootGale_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGale_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gale_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Gale_Products_Bool_Exp>;
};


export type Subscription_RootGet_Appointment_Status_CountsArgs = {
  args?: InputMaybe<Get_Appointment_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Subscription_RootGet_Appointment_Status_Counts_AggregateArgs = {
  args?: InputMaybe<Get_Appointment_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Appointment_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointment_Status_Counts_Order_By>>;
  where?: InputMaybe<Appointment_Status_Counts_Bool_Exp>;
};


export type Subscription_RootGet_Order_Status_CountsArgs = {
  args?: InputMaybe<Get_Order_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Subscription_RootGet_Order_Status_Counts_AggregateArgs = {
  args?: InputMaybe<Get_Order_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Subscription_RootGet_Payment_Stats_By_DayArgs = {
  args?: InputMaybe<Get_Payment_Stats_By_Day_Args>;
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Subscription_RootGet_Payment_Stats_By_Day_AggregateArgs = {
  args?: InputMaybe<Get_Payment_Stats_By_Day_Args>;
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Subscription_RootGet_Provider_PayoutsArgs = {
  args: Get_Provider_Payouts_Args;
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Subscription_RootGet_Provider_Payouts_AggregateArgs = {
  args: Get_Provider_Payouts_Args;
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Subscription_RootGet_Test_Kit_Status_CountsArgs = {
  args?: InputMaybe<Get_Test_Kit_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Subscription_RootGet_Test_Kit_Status_Counts_AggregateArgs = {
  args?: InputMaybe<Get_Test_Kit_Status_Counts_Args>;
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Subscription_RootGlobal_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Order_By>>;
  where?: InputMaybe<Global_Configs_Bool_Exp>;
};


export type Subscription_RootGlobal_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Order_By>>;
  where?: InputMaybe<Global_Configs_Bool_Exp>;
};


export type Subscription_RootGlobal_Configs_By_PkArgs = {
  name: Global_Configs_Names_Enum;
};


export type Subscription_RootGlobal_Configs_NamesArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Names_Order_By>>;
  where?: InputMaybe<Global_Configs_Names_Bool_Exp>;
};


export type Subscription_RootGlobal_Configs_Names_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Global_Configs_Names_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Global_Configs_Names_Order_By>>;
  where?: InputMaybe<Global_Configs_Names_Bool_Exp>;
};


export type Subscription_RootGlobal_Configs_Names_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGlobal_Configs_Names_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Global_Configs_Names_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Configs_Names_Bool_Exp>;
};


export type Subscription_RootGlobal_Configs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Global_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Configs_Bool_Exp>;
};


export type Subscription_RootImage_Source_TypesArgs = {
  distinct_on?: InputMaybe<Array<Image_Source_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Source_Types_Order_By>>;
  where?: InputMaybe<Image_Source_Types_Bool_Exp>;
};


export type Subscription_RootImage_Source_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Image_Source_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Source_Types_Order_By>>;
  where?: InputMaybe<Image_Source_Types_Bool_Exp>;
};


export type Subscription_RootImage_Source_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootImage_Source_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Image_Source_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Image_Source_Types_Bool_Exp>;
};


export type Subscription_RootIn_Mail_UsageArgs = {
  distinct_on?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<In_Mail_Usage_Order_By>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


export type Subscription_RootIn_Mail_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<In_Mail_Usage_Order_By>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


export type Subscription_RootIn_Mail_Usage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootIn_Mail_Usage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<In_Mail_Usage_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


export type Subscription_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvitations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvitations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invitations_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootLabsArgs = {
  distinct_on?: InputMaybe<Array<Labs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Labs_Order_By>>;
  where?: InputMaybe<Labs_Bool_Exp>;
};


export type Subscription_RootLabs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Labs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Labs_Order_By>>;
  where?: InputMaybe<Labs_Bool_Exp>;
};


export type Subscription_RootLabs_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLabs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Labs_Stream_Cursor_Input>>;
  where?: InputMaybe<Labs_Bool_Exp>;
};


export type Subscription_RootLatest_Persona_Inquiries_Per_UserArgs = {
  distinct_on?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Order_By>>;
  where?: InputMaybe<Latest_Persona_Inquiries_Per_User_Bool_Exp>;
};


export type Subscription_RootLatest_Persona_Inquiries_Per_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Persona_Inquiries_Per_User_Order_By>>;
  where?: InputMaybe<Latest_Persona_Inquiries_Per_User_Bool_Exp>;
};


export type Subscription_RootLatest_Persona_Inquiries_Per_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Latest_Persona_Inquiries_Per_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Latest_Persona_Inquiries_Per_User_Bool_Exp>;
};


export type Subscription_RootLegal_Document_TypesArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Types_Order_By>>;
  where?: InputMaybe<Legal_Document_Types_Bool_Exp>;
};


export type Subscription_RootLegal_Document_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Types_Order_By>>;
  where?: InputMaybe<Legal_Document_Types_Bool_Exp>;
};


export type Subscription_RootLegal_Document_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootLegal_Document_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legal_Document_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Legal_Document_Types_Bool_Exp>;
};


export type Subscription_RootLegal_Document_Update_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Update_Notifications_Order_By>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


export type Subscription_RootLegal_Document_Update_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Update_Notifications_Order_By>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


export type Subscription_RootLegal_Document_Update_Notifications_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootLegal_Document_Update_Notifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legal_Document_Update_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


export type Subscription_RootLegal_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Documents_Order_By>>;
  where?: InputMaybe<Legal_Documents_Bool_Exp>;
};


export type Subscription_RootLegal_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Documents_Order_By>>;
  where?: InputMaybe<Legal_Documents_Bool_Exp>;
};


export type Subscription_RootLegal_Documents_By_PkArgs = {
  legal_document_id: Scalars['bigint'];
};


export type Subscription_RootLegal_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legal_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Legal_Documents_Bool_Exp>;
};


export type Subscription_RootMedical_SchoolsArgs = {
  distinct_on?: InputMaybe<Array<Medical_Schools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medical_Schools_Order_By>>;
  where?: InputMaybe<Medical_Schools_Bool_Exp>;
};


export type Subscription_RootMedical_Schools_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Medical_Schools_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medical_Schools_Order_By>>;
  where?: InputMaybe<Medical_Schools_Bool_Exp>;
};


export type Subscription_RootMedical_Schools_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMedical_Schools_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Medical_Schools_Stream_Cursor_Input>>;
  where?: InputMaybe<Medical_Schools_Bool_Exp>;
};


export type Subscription_RootMedicationsArgs = {
  distinct_on?: InputMaybe<Array<Medications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Order_By>>;
  where?: InputMaybe<Medications_Bool_Exp>;
};


export type Subscription_RootMedications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Medications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Order_By>>;
  where?: InputMaybe<Medications_Bool_Exp>;
};


export type Subscription_RootMedications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMedications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Medications_Stream_Cursor_Input>>;
  where?: InputMaybe<Medications_Bool_Exp>;
};


export type Subscription_RootMedications_UniqueArgs = {
  distinct_on?: InputMaybe<Array<Medications_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Unique_Order_By>>;
  where?: InputMaybe<Medications_Unique_Bool_Exp>;
};


export type Subscription_RootMedications_Unique_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Medications_Unique_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Medications_Unique_Order_By>>;
  where?: InputMaybe<Medications_Unique_Bool_Exp>;
};


export type Subscription_RootMedications_Unique_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Medications_Unique_Stream_Cursor_Input>>;
  where?: InputMaybe<Medications_Unique_Bool_Exp>;
};


export type Subscription_RootMolecular_TestsArgs = {
  distinct_on?: InputMaybe<Array<Molecular_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Molecular_Tests_Order_By>>;
  where?: InputMaybe<Molecular_Tests_Bool_Exp>;
};


export type Subscription_RootMolecular_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Molecular_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Molecular_Tests_Order_By>>;
  where?: InputMaybe<Molecular_Tests_Bool_Exp>;
};


export type Subscription_RootMolecular_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootMolecular_Tests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Molecular_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Molecular_Tests_Bool_Exp>;
};


export type Subscription_RootMosaic_TestsArgs = {
  distinct_on?: InputMaybe<Array<Mosaic_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mosaic_Tests_Order_By>>;
  where?: InputMaybe<Mosaic_Tests_Bool_Exp>;
};


export type Subscription_RootMosaic_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mosaic_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mosaic_Tests_Order_By>>;
  where?: InputMaybe<Mosaic_Tests_Bool_Exp>;
};


export type Subscription_RootMosaic_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootMosaic_Tests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mosaic_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Mosaic_Tests_Bool_Exp>;
};


export type Subscription_RootNabla_NotesArgs = {
  distinct_on?: InputMaybe<Array<Nabla_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nabla_Notes_Order_By>>;
  where?: InputMaybe<Nabla_Notes_Bool_Exp>;
};


export type Subscription_RootNabla_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nabla_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nabla_Notes_Order_By>>;
  where?: InputMaybe<Nabla_Notes_Bool_Exp>;
};


export type Subscription_RootNabla_Notes_By_PkArgs = {
  appointment_id: Scalars['String'];
};


export type Subscription_RootNabla_Notes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nabla_Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Nabla_Notes_Bool_Exp>;
};


export type Subscription_RootNpi_Registry_DataArgs = {
  distinct_on?: InputMaybe<Array<Npi_Registry_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Npi_Registry_Data_Order_By>>;
  where?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
};


export type Subscription_RootNpi_Registry_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Npi_Registry_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Npi_Registry_Data_Order_By>>;
  where?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
};


export type Subscription_RootNpi_Registry_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNpi_Registry_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Npi_Registry_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Npi_Registry_Data_Bool_Exp>;
};


export type Subscription_RootOrder_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Payments_Order_By>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


export type Subscription_RootOrder_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Payments_Order_By>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


export type Subscription_RootOrder_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Payments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Payments_Bool_Exp>;
};


export type Subscription_RootOrder_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Products_Order_By>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


export type Subscription_RootOrder_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Products_Order_By>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


export type Subscription_RootOrder_Products_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrder_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Products_Bool_Exp>;
};


export type Subscription_RootOrder_Status_CountsArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Subscription_RootOrder_Status_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_Counts_Order_By>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Subscription_RootOrder_Status_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Status_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Status_Counts_Bool_Exp>;
};


export type Subscription_RootOrder_Status_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


export type Subscription_RootOrder_Status_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Status_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Status_History_Order_By>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


export type Subscription_RootOrder_Status_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrder_Status_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Status_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Status_History_Bool_Exp>;
};


export type Subscription_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOrders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_ViewArgs = {
  distinct_on?: InputMaybe<Array<Orders_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_View_Order_By>>;
  where?: InputMaybe<Orders_View_Bool_Exp>;
};


export type Subscription_RootOrders_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Orders_View_Order_By>>;
  where?: InputMaybe<Orders_View_Bool_Exp>;
};


export type Subscription_RootOrders_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Orders_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Orders_View_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_EventsArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Events_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Events_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_Events_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPatient_Achievement_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Achievement_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Achievement_Events_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Progress_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Progress_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_Progress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPatient_Achievement_Progress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Achievement_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Achievement_Progress_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_UnlocksArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Unlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Unlocks_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_Unlocks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Patient_Achievement_Unlocks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Patient_Achievement_Unlocks_Order_By>>;
  where?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
};


export type Subscription_RootPatient_Achievement_Unlocks_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPatient_Achievement_Unlocks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Patient_Achievement_Unlocks_Stream_Cursor_Input>>;
  where?: InputMaybe<Patient_Achievement_Unlocks_Bool_Exp>;
};


export type Subscription_RootPayment_Stats_By_DayArgs = {
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Subscription_RootPayment_Stats_By_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Stats_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Stats_By_Day_Order_By>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Subscription_RootPayment_Stats_By_Day_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Stats_By_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Stats_By_Day_Bool_Exp>;
};


export type Subscription_RootPayment_Transaction_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


export type Subscription_RootPayment_Transaction_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transaction_Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transaction_Orders_Order_By>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


export type Subscription_RootPayment_Transaction_Orders_By_PkArgs = {
  order_id: Scalars['Int'];
  payment_transaction_id: Scalars['Int'];
};


export type Subscription_RootPayment_Transaction_Orders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Transaction_Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Transaction_Orders_Bool_Exp>;
};


export type Subscription_RootPayment_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transactions_Order_By>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};


export type Subscription_RootPayment_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Transactions_Order_By>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};


export type Subscription_RootPayment_Transactions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPayment_Transactions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Transactions_Bool_Exp>;
};


export type Subscription_RootPending_Patient_ZrtArgs = {
  distinct_on?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pending_Patient_Zrt_Order_By>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


export type Subscription_RootPending_Patient_Zrt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pending_Patient_Zrt_Order_By>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


export type Subscription_RootPending_Patient_Zrt_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPending_Patient_Zrt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pending_Patient_Zrt_Stream_Cursor_Input>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


export type Subscription_RootPersona_InquiriesArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiries_Order_By>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};


export type Subscription_RootPersona_Inquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiries_Order_By>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};


export type Subscription_RootPersona_Inquiries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPersona_Inquiries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Persona_Inquiries_Stream_Cursor_Input>>;
  where?: InputMaybe<Persona_Inquiries_Bool_Exp>;
};


export type Subscription_RootPersona_Inquiry_StatusArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiry_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiry_Status_Order_By>>;
  where?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
};


export type Subscription_RootPersona_Inquiry_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Persona_Inquiry_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Persona_Inquiry_Status_Order_By>>;
  where?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
};


export type Subscription_RootPersona_Inquiry_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPersona_Inquiry_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Persona_Inquiry_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Persona_Inquiry_Status_Bool_Exp>;
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProducts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProvider_BillingArgs = {
  distinct_on?: InputMaybe<Array<Provider_Billing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Billing_Order_By>>;
  where?: InputMaybe<Provider_Billing_Bool_Exp>;
};


export type Subscription_RootProvider_Billing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Billing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Billing_Order_By>>;
  where?: InputMaybe<Provider_Billing_Bool_Exp>;
};


export type Subscription_RootProvider_Billing_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProvider_Billing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Billing_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Billing_Bool_Exp>;
};


export type Subscription_RootProvider_Dea_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Dea_Licenses_Order_By>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


export type Subscription_RootProvider_Dea_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Dea_Licenses_Order_By>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


export type Subscription_RootProvider_Dea_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_Dea_Licenses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Dea_Licenses_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


export type Subscription_RootProvider_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payments_Order_By>>;
  where?: InputMaybe<Provider_Payments_Bool_Exp>;
};


export type Subscription_RootProvider_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payments_Order_By>>;
  where?: InputMaybe<Provider_Payments_Bool_Exp>;
};


export type Subscription_RootProvider_Payments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProvider_Payments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Payments_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Payments_Bool_Exp>;
};


export type Subscription_RootProvider_PayoutsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Subscription_RootProvider_Payouts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Payouts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Payouts_Order_By>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Subscription_RootProvider_Payouts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Payouts_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Payouts_Bool_Exp>;
};


export type Subscription_RootProvider_State_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_State_Licenses_Order_By>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


export type Subscription_RootProvider_State_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_State_Licenses_Order_By>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


export type Subscription_RootProvider_State_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProvider_State_Licenses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_State_Licenses_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


export type Subscription_RootProvider_Unread_External_Notification_CountsArgs = {
  distinct_on?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Order_By>>;
  where?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
};


export type Subscription_RootProvider_Unread_External_Notification_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Unread_External_Notification_Counts_Order_By>>;
  where?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
};


export type Subscription_RootProvider_Unread_External_Notification_Counts_By_PkArgs = {
  codex_provider_id: Scalars['uuid'];
};


export type Subscription_RootProvider_Unread_External_Notification_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Provider_Unread_External_Notification_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Provider_Unread_External_Notification_Counts_Bool_Exp>;
};


export type Subscription_RootQuestion_Measurement_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Question_Measurement_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Measurement_Units_Order_By>>;
  where?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
};


export type Subscription_RootQuestion_Measurement_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Measurement_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Measurement_Units_Order_By>>;
  where?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
};


export type Subscription_RootQuestion_Measurement_Units_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootQuestion_Measurement_Units_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Measurement_Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
};


export type Subscription_RootQuestion_TypesArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


export type Subscription_RootQuestion_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Types_Order_By>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


export type Subscription_RootQuestion_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootQuestion_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Types_Bool_Exp>;
};


export type Subscription_RootQuestion_Ui_Control_Helper_Text_PositionArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
};


export type Subscription_RootQuestion_Ui_Control_Helper_Text_Position_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Helper_Text_Position_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
};


export type Subscription_RootQuestion_Ui_Control_Helper_Text_Position_By_PkArgs = {
  helper_text_position: Scalars['String'];
};


export type Subscription_RootQuestion_Ui_Control_Helper_Text_Position_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Ui_Control_Helper_Text_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
};


export type Subscription_RootQuestion_Ui_Control_TypesArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Types_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};


export type Subscription_RootQuestion_Ui_Control_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Question_Ui_Control_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Question_Ui_Control_Types_Order_By>>;
  where?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};


export type Subscription_RootQuestion_Ui_Control_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootQuestion_Ui_Control_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Question_Ui_Control_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Questions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuestionnaire_Questions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Questionnaire_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Questions_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_RemindersArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Reminders_Order_By>>;
  where?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Reminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Reminders_Order_By>>;
  where?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Reminders_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuestionnaire_Reminders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Questionnaire_Reminders_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Reminders_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Responses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootQuestionnaire_Responses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Questionnaire_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Subscription_RootQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Subscription_RootQuestionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Subscription_RootQuestionnaires_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestionnaires_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Subscription_RootQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Subscription_RootQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Questions_Order_By>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Subscription_RootQuestions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootQuestions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Questions_Bool_Exp>;
};


export type Subscription_RootRecommendationsArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Subscription_RootRecommendations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Recommendations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recommendations_Order_By>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Subscription_RootRecommendations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootRecommendations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Recommendations_Stream_Cursor_Input>>;
  where?: InputMaybe<Recommendations_Bool_Exp>;
};


export type Subscription_RootShipmonk_Sync_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Shipmonk_Sync_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipmonk_Sync_Metadata_Order_By>>;
  where?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
};


export type Subscription_RootShipmonk_Sync_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shipmonk_Sync_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Shipmonk_Sync_Metadata_Order_By>>;
  where?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
};


export type Subscription_RootShipmonk_Sync_Metadata_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShipmonk_Sync_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Shipmonk_Sync_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Shipmonk_Sync_Metadata_Bool_Exp>;
};


export type Subscription_RootSkintelligent_TestsArgs = {
  distinct_on?: InputMaybe<Array<Skintelligent_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skintelligent_Tests_Order_By>>;
  where?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
};


export type Subscription_RootSkintelligent_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Skintelligent_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Skintelligent_Tests_Order_By>>;
  where?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
};


export type Subscription_RootSkintelligent_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootSkintelligent_Tests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Skintelligent_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Skintelligent_Tests_Bool_Exp>;
};


export type Subscription_RootStripe_Billing_PlansArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Billing_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Billing_Plans_Order_By>>;
  where?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
};


export type Subscription_RootStripe_Billing_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Billing_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Billing_Plans_Order_By>>;
  where?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
};


export type Subscription_RootStripe_Billing_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStripe_Billing_Plans_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Billing_Plans_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Billing_Plans_Bool_Exp>;
};


export type Subscription_RootStripe_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customers_Order_By>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


export type Subscription_RootStripe_Customers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customers_Order_By>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


export type Subscription_RootStripe_Customers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStripe_Customers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


export type Subscription_RootStripe_Latest_Subscription_Per_User_ViewArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Order_By>>;
  where?: InputMaybe<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>;
};


export type Subscription_RootStripe_Latest_Subscription_Per_User_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Latest_Subscription_Per_User_View_Order_By>>;
  where?: InputMaybe<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>;
};


export type Subscription_RootStripe_Latest_Subscription_Per_User_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Latest_Subscription_Per_User_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Latest_Subscription_Per_User_View_Bool_Exp>;
};


export type Subscription_RootStripe_Payment_IntentsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Intents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Intents_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
};


export type Subscription_RootStripe_Payment_Intents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Intents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Intents_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
};


export type Subscription_RootStripe_Payment_Intents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStripe_Payment_Intents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Payment_Intents_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Payment_Intents_Bool_Exp>;
};


export type Subscription_RootStripe_Payment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Methods_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


export type Subscription_RootStripe_Payment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Payment_Methods_Order_By>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


export type Subscription_RootStripe_Payment_Methods_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStripe_Payment_Methods_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Payment_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Payment_Methods_Bool_Exp>;
};


export type Subscription_RootStripe_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Subscriptions_Order_By>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};


export type Subscription_RootStripe_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Subscriptions_Order_By>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};


export type Subscription_RootStripe_Subscriptions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootStripe_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Subscriptions_Bool_Exp>;
};


export type Subscription_RootStripe_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Transaction_Order_By>>;
  where?: InputMaybe<Stripe_Transaction_Bool_Exp>;
};


export type Subscription_RootStripe_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Transaction_Order_By>>;
  where?: InputMaybe<Stripe_Transaction_Bool_Exp>;
};


export type Subscription_RootStripe_Transaction_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootStripe_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stripe_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Stripe_Transaction_Bool_Exp>;
};


export type Subscription_RootSupport_Chat_UsageArgs = {
  distinct_on?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Support_Chat_Usage_Order_By>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


export type Subscription_RootSupport_Chat_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Support_Chat_Usage_Order_By>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


export type Subscription_RootSupport_Chat_Usage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSupport_Chat_Usage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Support_Chat_Usage_Stream_Cursor_Input>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


export type Subscription_RootSwab_Code_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Swab_Code_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Code_Statuses_Order_By>>;
  where?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
};


export type Subscription_RootSwab_Code_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Swab_Code_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Code_Statuses_Order_By>>;
  where?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
};


export type Subscription_RootSwab_Code_Statuses_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSwab_Code_Statuses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Swab_Code_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
};


export type Subscription_RootSwab_CodesArgs = {
  distinct_on?: InputMaybe<Array<Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Codes_Order_By>>;
  where?: InputMaybe<Swab_Codes_Bool_Exp>;
};


export type Subscription_RootSwab_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Swab_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Codes_Order_By>>;
  where?: InputMaybe<Swab_Codes_Bool_Exp>;
};


export type Subscription_RootSwab_Codes_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootSwab_Codes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Swab_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Swab_Codes_Bool_Exp>;
};


export type Subscription_RootSwab_Usage_TypeArgs = {
  distinct_on?: InputMaybe<Array<Swab_Usage_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Usage_Type_Order_By>>;
  where?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
};


export type Subscription_RootSwab_Usage_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Swab_Usage_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Swab_Usage_Type_Order_By>>;
  where?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
};


export type Subscription_RootSwab_Usage_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootSwab_Usage_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Swab_Usage_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
};


export type Subscription_RootTest_DefinitionsArgs = {
  distinct_on?: InputMaybe<Array<Test_Definitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Definitions_Order_By>>;
  where?: InputMaybe<Test_Definitions_Bool_Exp>;
};


export type Subscription_RootTest_Definitions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Definitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Definitions_Order_By>>;
  where?: InputMaybe<Test_Definitions_Bool_Exp>;
};


export type Subscription_RootTest_Definitions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTest_Definitions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Definitions_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Definitions_Bool_Exp>;
};


export type Subscription_RootTest_E_Prescribe_NpisArgs = {
  distinct_on?: InputMaybe<Array<Test_E_Prescribe_Npis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_E_Prescribe_Npis_Order_By>>;
  where?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
};


export type Subscription_RootTest_E_Prescribe_Npis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_E_Prescribe_Npis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_E_Prescribe_Npis_Order_By>>;
  where?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
};


export type Subscription_RootTest_E_Prescribe_Npis_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTest_E_Prescribe_Npis_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_E_Prescribe_Npis_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
};


export type Subscription_RootTest_Kit_Status_CountsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Subscription_RootTest_Kit_Status_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kit_Status_Counts_Order_By>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Subscription_RootTest_Kit_Status_Counts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Kit_Status_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
};


export type Subscription_RootTest_Kits_Update_States_Summary_LogArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


export type Subscription_RootTest_Kits_Update_States_Summary_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


export type Subscription_RootTest_Kits_Update_States_Summary_Log_By_PkArgs = {
  log_id: Scalars['uuid'];
};


export type Subscription_RootTest_Kits_Update_States_Summary_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Kits_Update_States_Summary_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


export type Subscription_RootTest_TypesArgs = {
  distinct_on?: InputMaybe<Array<Test_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Types_Order_By>>;
  where?: InputMaybe<Test_Types_Bool_Exp>;
};


export type Subscription_RootTest_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Types_Order_By>>;
  where?: InputMaybe<Test_Types_Bool_Exp>;
};


export type Subscription_RootTest_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootTest_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Test_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Test_Types_Bool_Exp>;
};


export type Subscription_RootTestsArgs = {
  distinct_on?: InputMaybe<Array<Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tests_Order_By>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};


export type Subscription_RootTests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tests_Order_By>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};


export type Subscription_RootTests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootTests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};


export type Subscription_RootText_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Text_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Addresses_Order_By>>;
  where?: InputMaybe<Text_Addresses_Bool_Exp>;
};


export type Subscription_RootText_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Text_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Text_Addresses_Order_By>>;
  where?: InputMaybe<Text_Addresses_Bool_Exp>;
};


export type Subscription_RootText_Addresses_By_PkArgs = {
  address_id: Scalars['uuid'];
};


export type Subscription_RootText_Addresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Text_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Text_Addresses_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questionnaire_Questions_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUnauthenticated_Questionnaire_Questions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unauthenticated_Questionnaire_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaires_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaires_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questionnaires_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUnauthenticated_Questionnaires_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unauthenticated_Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
};


export type Subscription_RootUnauthenticated_Questions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUnauthenticated_Questions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unauthenticated_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
};


export type Subscription_RootUniversitiesArgs = {
  distinct_on?: InputMaybe<Array<Universities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Universities_Order_By>>;
  where?: InputMaybe<Universities_Bool_Exp>;
};


export type Subscription_RootUniversities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Universities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Universities_Order_By>>;
  where?: InputMaybe<Universities_Bool_Exp>;
};


export type Subscription_RootUniversities_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUniversities_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Universities_Stream_Cursor_Input>>;
  where?: InputMaybe<Universities_Bool_Exp>;
};


export type Subscription_RootUsed_Test_E_Prescribe_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Order_By>>;
  where?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
};


export type Subscription_RootUsed_Test_E_Prescribe_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Order_By>>;
  where?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
};


export type Subscription_RootUsed_Test_E_Prescribe_Licenses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUsed_Test_E_Prescribe_Licenses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Used_Test_E_Prescribe_Licenses_Stream_Cursor_Input>>;
  where?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
};


export type Subscription_RootUser_AddressesArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Subscription_RootUser_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Subscription_RootUser_Addresses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUser_Addresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Subscription_RootUser_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Subscription_RootUser_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Subscription_RootUser_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Agreements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Agreements_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Provider_TypesArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Provider_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Provider_Types_Order_By>>;
  where?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Provider_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Provider_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Provider_Types_Order_By>>;
  where?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Provider_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Auth_Provider_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Auth_Provider_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
};


export type Subscription_RootUser_Auth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Providers_Order_By>>;
  where?: InputMaybe<User_Auth_Providers_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Providers_Order_By>>;
  where?: InputMaybe<User_Auth_Providers_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Providers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUser_Auth_Providers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Auth_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Providers_Bool_Exp>;
};


export type Subscription_RootUser_Auth_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Tokens_Order_By>>;
  where?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Tokens_Order_By>>;
  where?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Auth_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Auth_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Communication_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communication_Deliveries_Order_By>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};


export type Subscription_RootUser_Communication_Deliveries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communication_Deliveries_Order_By>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};


export type Subscription_RootUser_Communication_Deliveries_By_PkArgs = {
  user_communication_delivery_id: Scalars['bigint'];
};


export type Subscription_RootUser_Communication_Deliveries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Communication_Deliveries_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};


export type Subscription_RootUser_CommunicationsArgs = {
  distinct_on?: InputMaybe<Array<User_Communications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communications_Order_By>>;
  where?: InputMaybe<User_Communications_Bool_Exp>;
};


export type Subscription_RootUser_Communications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Communications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communications_Order_By>>;
  where?: InputMaybe<User_Communications_Bool_Exp>;
};


export type Subscription_RootUser_Communications_By_PkArgs = {
  user_communication_id: Scalars['bigint'];
};


export type Subscription_RootUser_Communications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Communications_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Communications_Bool_Exp>;
};


export type Subscription_RootUser_IndicatorsArgs = {
  distinct_on?: InputMaybe<Array<User_Indicators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Indicators_Order_By>>;
  where?: InputMaybe<User_Indicators_Bool_Exp>;
};


export type Subscription_RootUser_Indicators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Indicators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Indicators_Order_By>>;
  where?: InputMaybe<User_Indicators_Bool_Exp>;
};


export type Subscription_RootUser_Indicators_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootUser_Indicators_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Indicators_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Indicators_Bool_Exp>;
};


export type Subscription_RootUser_Notification_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Status_Order_By>>;
  where?: InputMaybe<User_Notification_Status_Bool_Exp>;
};


export type Subscription_RootUser_Notification_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Status_Order_By>>;
  where?: InputMaybe<User_Notification_Status_Bool_Exp>;
};


export type Subscription_RootUser_Notification_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUser_Notification_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Notification_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Notification_Status_Bool_Exp>;
};


export type Subscription_RootUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Subscription_RootUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notifications_Order_By>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Subscription_RootUser_Notifications_By_PkArgs = {
  user_communication_delivery_id: Scalars['bigint'];
};


export type Subscription_RootUser_Notifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};


export type Subscription_RootUser_Push_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Push_Tokens_Order_By>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Push_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Push_Tokens_Order_By>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Push_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Push_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Push_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


export type Subscription_RootUser_Scanned_DataArgs = {
  distinct_on?: InputMaybe<Array<User_Scanned_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Scanned_Data_Order_By>>;
  where?: InputMaybe<User_Scanned_Data_Bool_Exp>;
};


export type Subscription_RootUser_Scanned_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scanned_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Scanned_Data_Order_By>>;
  where?: InputMaybe<User_Scanned_Data_Bool_Exp>;
};


export type Subscription_RootUser_Scanned_Data_By_PkArgs = {
  user_id: Scalars['uuid'];
};


export type Subscription_RootUser_Scanned_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Scanned_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Scanned_Data_Bool_Exp>;
};


export type Subscription_RootUser_SettingsArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Settings_Order_By>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUser_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVonage_AppointmentArgs = {
  distinct_on?: InputMaybe<Array<Vonage_Appointment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vonage_Appointment_Order_By>>;
  where?: InputMaybe<Vonage_Appointment_Bool_Exp>;
};


export type Subscription_RootVonage_Appointment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vonage_Appointment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vonage_Appointment_Order_By>>;
  where?: InputMaybe<Vonage_Appointment_Bool_Exp>;
};


export type Subscription_RootVonage_Appointment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVonage_Appointment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vonage_Appointment_Stream_Cursor_Input>>;
  where?: InputMaybe<Vonage_Appointment_Bool_Exp>;
};


export type Subscription_RootZrt_TestsArgs = {
  distinct_on?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zrt_Tests_Order_By>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};


export type Subscription_RootZrt_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zrt_Tests_Order_By>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};


export type Subscription_RootZrt_Tests_By_PkArgs = {
  test_id: Scalars['uuid'];
};


export type Subscription_RootZrt_Tests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Zrt_Tests_Stream_Cursor_Input>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};

/** columns and relationships of "support_chat_usage" */
export type Support_Chat_Usage = {
  __typename?: 'support_chat_usage';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  usage_date: Scalars['date'];
  used: Scalars['Int'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "support_chat_usage" */
export type Support_Chat_Usage_Aggregate = {
  __typename?: 'support_chat_usage_aggregate';
  aggregate?: Maybe<Support_Chat_Usage_Aggregate_Fields>;
  nodes: Array<Support_Chat_Usage>;
};

export type Support_Chat_Usage_Aggregate_Bool_Exp = {
  count?: InputMaybe<Support_Chat_Usage_Aggregate_Bool_Exp_Count>;
};

export type Support_Chat_Usage_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "support_chat_usage" */
export type Support_Chat_Usage_Aggregate_Fields = {
  __typename?: 'support_chat_usage_aggregate_fields';
  avg?: Maybe<Support_Chat_Usage_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Support_Chat_Usage_Max_Fields>;
  min?: Maybe<Support_Chat_Usage_Min_Fields>;
  stddev?: Maybe<Support_Chat_Usage_Stddev_Fields>;
  stddev_pop?: Maybe<Support_Chat_Usage_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Support_Chat_Usage_Stddev_Samp_Fields>;
  sum?: Maybe<Support_Chat_Usage_Sum_Fields>;
  var_pop?: Maybe<Support_Chat_Usage_Var_Pop_Fields>;
  var_samp?: Maybe<Support_Chat_Usage_Var_Samp_Fields>;
  variance?: Maybe<Support_Chat_Usage_Variance_Fields>;
};


/** aggregate fields of "support_chat_usage" */
export type Support_Chat_Usage_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "support_chat_usage" */
export type Support_Chat_Usage_Aggregate_Order_By = {
  avg?: InputMaybe<Support_Chat_Usage_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Support_Chat_Usage_Max_Order_By>;
  min?: InputMaybe<Support_Chat_Usage_Min_Order_By>;
  stddev?: InputMaybe<Support_Chat_Usage_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Support_Chat_Usage_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Support_Chat_Usage_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Support_Chat_Usage_Sum_Order_By>;
  var_pop?: InputMaybe<Support_Chat_Usage_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Support_Chat_Usage_Var_Samp_Order_By>;
  variance?: InputMaybe<Support_Chat_Usage_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "support_chat_usage" */
export type Support_Chat_Usage_Arr_Rel_Insert_Input = {
  data: Array<Support_Chat_Usage_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Support_Chat_Usage_On_Conflict>;
};

/** aggregate avg on columns */
export type Support_Chat_Usage_Avg_Fields = {
  __typename?: 'support_chat_usage_avg_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "support_chat_usage". All fields are combined with a logical 'AND'. */
export type Support_Chat_Usage_Bool_Exp = {
  _and?: InputMaybe<Array<Support_Chat_Usage_Bool_Exp>>;
  _not?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
  _or?: InputMaybe<Array<Support_Chat_Usage_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usage_date?: InputMaybe<Date_Comparison_Exp>;
  used?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "support_chat_usage" */
export enum Support_Chat_Usage_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupportChatUsagePkey = 'support_chat_usage_pkey',
  /** unique or primary key constraint on columns "user_id", "usage_date" */
  SupportChatUsageUserIdUsageDateKey = 'support_chat_usage_user_id_usage_date_key'
}

/** input type for incrementing numeric columns in table "support_chat_usage" */
export type Support_Chat_Usage_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  used?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "support_chat_usage" */
export type Support_Chat_Usage_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  usage_date?: InputMaybe<Scalars['date']>;
  used?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Support_Chat_Usage_Max_Fields = {
  __typename?: 'support_chat_usage_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  usage_date?: Maybe<Scalars['date']>;
  used?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_date?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Support_Chat_Usage_Min_Fields = {
  __typename?: 'support_chat_usage_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  usage_date?: Maybe<Scalars['date']>;
  used?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_date?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "support_chat_usage" */
export type Support_Chat_Usage_Mutation_Response = {
  __typename?: 'support_chat_usage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Support_Chat_Usage>;
};

/** on_conflict condition type for table "support_chat_usage" */
export type Support_Chat_Usage_On_Conflict = {
  constraint: Support_Chat_Usage_Constraint;
  update_columns?: Array<Support_Chat_Usage_Update_Column>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};

/** Ordering options when selecting data from "support_chat_usage". */
export type Support_Chat_Usage_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usage_date?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: support_chat_usage */
export type Support_Chat_Usage_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "support_chat_usage" */
export enum Support_Chat_Usage_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsageDate = 'usage_date',
  /** column name */
  Used = 'used',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "support_chat_usage" */
export type Support_Chat_Usage_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  usage_date?: InputMaybe<Scalars['date']>;
  used?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Support_Chat_Usage_Stddev_Fields = {
  __typename?: 'support_chat_usage_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Support_Chat_Usage_Stddev_Pop_Fields = {
  __typename?: 'support_chat_usage_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Support_Chat_Usage_Stddev_Samp_Fields = {
  __typename?: 'support_chat_usage_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "support_chat_usage" */
export type Support_Chat_Usage_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Support_Chat_Usage_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Support_Chat_Usage_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  usage_date?: InputMaybe<Scalars['date']>;
  used?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Support_Chat_Usage_Sum_Fields = {
  __typename?: 'support_chat_usage_sum_fields';
  id?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** update columns of table "support_chat_usage" */
export enum Support_Chat_Usage_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsageDate = 'usage_date',
  /** column name */
  Used = 'used',
  /** column name */
  UserId = 'user_id'
}

export type Support_Chat_Usage_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Support_Chat_Usage_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Support_Chat_Usage_Set_Input>;
  /** filter the rows which have to be updated */
  where: Support_Chat_Usage_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Support_Chat_Usage_Var_Pop_Fields = {
  __typename?: 'support_chat_usage_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Support_Chat_Usage_Var_Samp_Fields = {
  __typename?: 'support_chat_usage_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Support_Chat_Usage_Variance_Fields = {
  __typename?: 'support_chat_usage_variance_fields';
  id?: Maybe<Scalars['Float']>;
  used?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "support_chat_usage" */
export type Support_Chat_Usage_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  used?: InputMaybe<Order_By>;
};

/** columns and relationships of "swab_code_statuses" */
export type Swab_Code_Statuses = {
  __typename?: 'swab_code_statuses';
  comment?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** aggregated selection of "swab_code_statuses" */
export type Swab_Code_Statuses_Aggregate = {
  __typename?: 'swab_code_statuses_aggregate';
  aggregate?: Maybe<Swab_Code_Statuses_Aggregate_Fields>;
  nodes: Array<Swab_Code_Statuses>;
};

/** aggregate fields of "swab_code_statuses" */
export type Swab_Code_Statuses_Aggregate_Fields = {
  __typename?: 'swab_code_statuses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Swab_Code_Statuses_Max_Fields>;
  min?: Maybe<Swab_Code_Statuses_Min_Fields>;
};


/** aggregate fields of "swab_code_statuses" */
export type Swab_Code_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Swab_Code_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "swab_code_statuses". All fields are combined with a logical 'AND'. */
export type Swab_Code_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Swab_Code_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Swab_Code_Statuses_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "swab_code_statuses" */
export enum Swab_Code_Statuses_Constraint {
  /** unique or primary key constraint on columns "name" */
  SwabCodeStatusesPkey = 'swab_code_statuses_pkey'
}

export enum Swab_Code_Statuses_Enum {
  /** Never used, can be scanned and registered. */
  Created = 'CREATED',
  /** Do not use, discarded. */
  Disabled = 'DISABLED',
  /** Discarded, do not use */
  Discarded = 'DISCARDED',
  /** Used, no longer available. */
  Used = 'USED'
}

/** Boolean expression to compare columns of type "swab_code_statuses_enum". All fields are combined with logical 'AND'. */
export type Swab_Code_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Swab_Code_Statuses_Enum>;
  _in?: InputMaybe<Array<Swab_Code_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Swab_Code_Statuses_Enum>;
  _nin?: InputMaybe<Array<Swab_Code_Statuses_Enum>>;
};

/** input type for inserting data into table "swab_code_statuses" */
export type Swab_Code_Statuses_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Swab_Code_Statuses_Max_Fields = {
  __typename?: 'swab_code_statuses_max_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Swab_Code_Statuses_Min_Fields = {
  __typename?: 'swab_code_statuses_min_fields';
  comment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "swab_code_statuses" */
export type Swab_Code_Statuses_Mutation_Response = {
  __typename?: 'swab_code_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Swab_Code_Statuses>;
};

/** on_conflict condition type for table "swab_code_statuses" */
export type Swab_Code_Statuses_On_Conflict = {
  constraint: Swab_Code_Statuses_Constraint;
  update_columns?: Array<Swab_Code_Statuses_Update_Column>;
  where?: InputMaybe<Swab_Code_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "swab_code_statuses". */
export type Swab_Code_Statuses_Order_By = {
  comment?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: swab_code_statuses */
export type Swab_Code_Statuses_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "swab_code_statuses" */
export enum Swab_Code_Statuses_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "swab_code_statuses" */
export type Swab_Code_Statuses_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "swab_code_statuses" */
export type Swab_Code_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Swab_Code_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Swab_Code_Statuses_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "swab_code_statuses" */
export enum Swab_Code_Statuses_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Name = 'name'
}

export type Swab_Code_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Swab_Code_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Swab_Code_Statuses_Bool_Exp;
};

/** Storing generated swab codes to track inventory and validate those kits as they are registered on the site */
export type Swab_Codes = {
  __typename?: 'swab_codes';
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  lab_name: Labs_Enum;
  /** Current status of swab code on system (CREATED | DISCARDED | USED) */
  status: Swab_Code_Statuses_Enum;
  swab_code: Scalars['String'];
  /** An array relationship */
  swab_codes_test: Array<Tests>;
  /** An aggregate relationship */
  swab_codes_test_aggregate: Tests_Aggregate;
  /** An object relationship */
  swab_codes_test_type: Test_Types;
  swab_usage_type: Swab_Usage_Type_Enum;
  test_type: Test_Types_Enum;
  updated_at: Scalars['timestamptz'];
};


/** Storing generated swab codes to track inventory and validate those kits as they are registered on the site */
export type Swab_CodesSwab_Codes_TestArgs = {
  distinct_on?: InputMaybe<Array<Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tests_Order_By>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};


/** Storing generated swab codes to track inventory and validate those kits as they are registered on the site */
export type Swab_CodesSwab_Codes_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tests_Order_By>>;
  where?: InputMaybe<Tests_Bool_Exp>;
};

/** aggregated selection of "swab_codes" */
export type Swab_Codes_Aggregate = {
  __typename?: 'swab_codes_aggregate';
  aggregate?: Maybe<Swab_Codes_Aggregate_Fields>;
  nodes: Array<Swab_Codes>;
};

/** aggregate fields of "swab_codes" */
export type Swab_Codes_Aggregate_Fields = {
  __typename?: 'swab_codes_aggregate_fields';
  avg?: Maybe<Swab_Codes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Swab_Codes_Max_Fields>;
  min?: Maybe<Swab_Codes_Min_Fields>;
  stddev?: Maybe<Swab_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Swab_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Swab_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Swab_Codes_Sum_Fields>;
  var_pop?: Maybe<Swab_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Swab_Codes_Var_Samp_Fields>;
  variance?: Maybe<Swab_Codes_Variance_Fields>;
};


/** aggregate fields of "swab_codes" */
export type Swab_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Swab_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Swab_Codes_Avg_Fields = {
  __typename?: 'swab_codes_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "swab_codes". All fields are combined with a logical 'AND'. */
export type Swab_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Swab_Codes_Bool_Exp>>;
  _not?: InputMaybe<Swab_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Swab_Codes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lab_name?: InputMaybe<Labs_Enum_Comparison_Exp>;
  status?: InputMaybe<Swab_Code_Statuses_Enum_Comparison_Exp>;
  swab_code?: InputMaybe<String_Comparison_Exp>;
  swab_codes_test?: InputMaybe<Tests_Bool_Exp>;
  swab_codes_test_aggregate?: InputMaybe<Tests_Aggregate_Bool_Exp>;
  swab_codes_test_type?: InputMaybe<Test_Types_Bool_Exp>;
  swab_usage_type?: InputMaybe<Swab_Usage_Type_Enum_Comparison_Exp>;
  test_type?: InputMaybe<Test_Types_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "swab_codes" */
export enum Swab_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  SwabCodesPkey = 'swab_codes_pkey',
  /** unique or primary key constraint on columns "swab_code" */
  SwabCodesSwabCodeKey = 'swab_codes_swab_code_key'
}

/** input type for incrementing numeric columns in table "swab_codes" */
export type Swab_Codes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "swab_codes" */
export type Swab_Codes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lab_name?: InputMaybe<Labs_Enum>;
  /** Current status of swab code on system (CREATED | DISCARDED | USED) */
  status?: InputMaybe<Swab_Code_Statuses_Enum>;
  swab_code?: InputMaybe<Scalars['String']>;
  swab_codes_test?: InputMaybe<Tests_Arr_Rel_Insert_Input>;
  swab_codes_test_type?: InputMaybe<Test_Types_Obj_Rel_Insert_Input>;
  swab_usage_type?: InputMaybe<Swab_Usage_Type_Enum>;
  test_type?: InputMaybe<Test_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Swab_Codes_Max_Fields = {
  __typename?: 'swab_codes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  swab_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Swab_Codes_Min_Fields = {
  __typename?: 'swab_codes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  swab_code?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "swab_codes" */
export type Swab_Codes_Mutation_Response = {
  __typename?: 'swab_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Swab_Codes>;
};

/** input type for inserting object relation for remote table "swab_codes" */
export type Swab_Codes_Obj_Rel_Insert_Input = {
  data: Swab_Codes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Swab_Codes_On_Conflict>;
};

/** on_conflict condition type for table "swab_codes" */
export type Swab_Codes_On_Conflict = {
  constraint: Swab_Codes_Constraint;
  update_columns?: Array<Swab_Codes_Update_Column>;
  where?: InputMaybe<Swab_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "swab_codes". */
export type Swab_Codes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lab_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  swab_code?: InputMaybe<Order_By>;
  swab_codes_test_aggregate?: InputMaybe<Tests_Aggregate_Order_By>;
  swab_codes_test_type?: InputMaybe<Test_Types_Order_By>;
  swab_usage_type?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: swab_codes */
export type Swab_Codes_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "swab_codes" */
export enum Swab_Codes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LabName = 'lab_name',
  /** column name */
  Status = 'status',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  SwabUsageType = 'swab_usage_type',
  /** column name */
  TestType = 'test_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "swab_codes" */
export type Swab_Codes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lab_name?: InputMaybe<Labs_Enum>;
  /** Current status of swab code on system (CREATED | DISCARDED | USED) */
  status?: InputMaybe<Swab_Code_Statuses_Enum>;
  swab_code?: InputMaybe<Scalars['String']>;
  swab_usage_type?: InputMaybe<Swab_Usage_Type_Enum>;
  test_type?: InputMaybe<Test_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Swab_Codes_Stddev_Fields = {
  __typename?: 'swab_codes_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Swab_Codes_Stddev_Pop_Fields = {
  __typename?: 'swab_codes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Swab_Codes_Stddev_Samp_Fields = {
  __typename?: 'swab_codes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "swab_codes" */
export type Swab_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Swab_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Swab_Codes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  lab_name?: InputMaybe<Labs_Enum>;
  /** Current status of swab code on system (CREATED | DISCARDED | USED) */
  status?: InputMaybe<Swab_Code_Statuses_Enum>;
  swab_code?: InputMaybe<Scalars['String']>;
  swab_usage_type?: InputMaybe<Swab_Usage_Type_Enum>;
  test_type?: InputMaybe<Test_Types_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Swab_Codes_Sum_Fields = {
  __typename?: 'swab_codes_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "swab_codes" */
export enum Swab_Codes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LabName = 'lab_name',
  /** column name */
  Status = 'status',
  /** column name */
  SwabCode = 'swab_code',
  /** column name */
  SwabUsageType = 'swab_usage_type',
  /** column name */
  TestType = 'test_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Swab_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Swab_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Swab_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Swab_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Swab_Codes_Var_Pop_Fields = {
  __typename?: 'swab_codes_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Swab_Codes_Var_Samp_Fields = {
  __typename?: 'swab_codes_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Swab_Codes_Variance_Fields = {
  __typename?: 'swab_codes_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Defines types of usage we may have for swabs. */
export type Swab_Usage_Type = {
  __typename?: 'swab_usage_type';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "swab_usage_type" */
export type Swab_Usage_Type_Aggregate = {
  __typename?: 'swab_usage_type_aggregate';
  aggregate?: Maybe<Swab_Usage_Type_Aggregate_Fields>;
  nodes: Array<Swab_Usage_Type>;
};

/** aggregate fields of "swab_usage_type" */
export type Swab_Usage_Type_Aggregate_Fields = {
  __typename?: 'swab_usage_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Swab_Usage_Type_Max_Fields>;
  min?: Maybe<Swab_Usage_Type_Min_Fields>;
};


/** aggregate fields of "swab_usage_type" */
export type Swab_Usage_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Swab_Usage_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "swab_usage_type". All fields are combined with a logical 'AND'. */
export type Swab_Usage_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Swab_Usage_Type_Bool_Exp>>;
  _not?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Swab_Usage_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "swab_usage_type" */
export enum Swab_Usage_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  SwabUsageTypePkey = 'swab_usage_type_pkey'
}

export enum Swab_Usage_Type_Enum {
  /** Standard usage of swab for test. */
  Standard = 'STANDARD',
  /** Swab used for internal testing, actual test may or may not exists with lab. */
  Test = 'TEST'
}

/** Boolean expression to compare columns of type "swab_usage_type_enum". All fields are combined with logical 'AND'. */
export type Swab_Usage_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Swab_Usage_Type_Enum>;
  _in?: InputMaybe<Array<Swab_Usage_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Swab_Usage_Type_Enum>;
  _nin?: InputMaybe<Array<Swab_Usage_Type_Enum>>;
};

/** input type for inserting data into table "swab_usage_type" */
export type Swab_Usage_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Swab_Usage_Type_Max_Fields = {
  __typename?: 'swab_usage_type_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Swab_Usage_Type_Min_Fields = {
  __typename?: 'swab_usage_type_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "swab_usage_type" */
export type Swab_Usage_Type_Mutation_Response = {
  __typename?: 'swab_usage_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Swab_Usage_Type>;
};

/** on_conflict condition type for table "swab_usage_type" */
export type Swab_Usage_Type_On_Conflict = {
  constraint: Swab_Usage_Type_Constraint;
  update_columns?: Array<Swab_Usage_Type_Update_Column>;
  where?: InputMaybe<Swab_Usage_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "swab_usage_type". */
export type Swab_Usage_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: swab_usage_type */
export type Swab_Usage_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "swab_usage_type" */
export enum Swab_Usage_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "swab_usage_type" */
export type Swab_Usage_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "swab_usage_type" */
export type Swab_Usage_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Swab_Usage_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Swab_Usage_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "swab_usage_type" */
export enum Swab_Usage_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Swab_Usage_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Swab_Usage_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Swab_Usage_Type_Bool_Exp;
};

/** columns and relationships of "test_definitions" */
export type Test_Definitions = {
  __typename?: 'test_definitions';
  config?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  questionnaire_id?: Maybe<Scalars['Int']>;
  test_type: Test_Types_Enum;
};


/** columns and relationships of "test_definitions" */
export type Test_DefinitionsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "test_definitions" */
export type Test_Definitions_Aggregate = {
  __typename?: 'test_definitions_aggregate';
  aggregate?: Maybe<Test_Definitions_Aggregate_Fields>;
  nodes: Array<Test_Definitions>;
};

/** aggregate fields of "test_definitions" */
export type Test_Definitions_Aggregate_Fields = {
  __typename?: 'test_definitions_aggregate_fields';
  avg?: Maybe<Test_Definitions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Test_Definitions_Max_Fields>;
  min?: Maybe<Test_Definitions_Min_Fields>;
  stddev?: Maybe<Test_Definitions_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Definitions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Definitions_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Definitions_Sum_Fields>;
  var_pop?: Maybe<Test_Definitions_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Definitions_Var_Samp_Fields>;
  variance?: Maybe<Test_Definitions_Variance_Fields>;
};


/** aggregate fields of "test_definitions" */
export type Test_Definitions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Definitions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Test_Definitions_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Test_Definitions_Avg_Fields = {
  __typename?: 'test_definitions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "test_definitions". All fields are combined with a logical 'AND'. */
export type Test_Definitions_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Definitions_Bool_Exp>>;
  _not?: InputMaybe<Test_Definitions_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Definitions_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  test_type?: InputMaybe<Test_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_definitions" */
export enum Test_Definitions_Constraint {
  /** unique or primary key constraint on columns "id" */
  TestDefinitionsPkey = 'test_definitions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Test_Definitions_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Test_Definitions_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Test_Definitions_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "test_definitions" */
export type Test_Definitions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "test_definitions" */
export type Test_Definitions_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  test_type?: InputMaybe<Test_Types_Enum>;
};

/** aggregate max on columns */
export type Test_Definitions_Max_Fields = {
  __typename?: 'test_definitions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Test_Definitions_Min_Fields = {
  __typename?: 'test_definitions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "test_definitions" */
export type Test_Definitions_Mutation_Response = {
  __typename?: 'test_definitions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Definitions>;
};

/** input type for inserting object relation for remote table "test_definitions" */
export type Test_Definitions_Obj_Rel_Insert_Input = {
  data: Test_Definitions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Definitions_On_Conflict>;
};

/** on_conflict condition type for table "test_definitions" */
export type Test_Definitions_On_Conflict = {
  constraint: Test_Definitions_Constraint;
  update_columns?: Array<Test_Definitions_Update_Column>;
  where?: InputMaybe<Test_Definitions_Bool_Exp>;
};

/** Ordering options when selecting data from "test_definitions". */
export type Test_Definitions_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test_definitions */
export type Test_Definitions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Test_Definitions_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "test_definitions" */
export enum Test_Definitions_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  TestType = 'test_type'
}

/** input type for updating data in table "test_definitions" */
export type Test_Definitions_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  test_type?: InputMaybe<Test_Types_Enum>;
};

/** aggregate stddev on columns */
export type Test_Definitions_Stddev_Fields = {
  __typename?: 'test_definitions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Test_Definitions_Stddev_Pop_Fields = {
  __typename?: 'test_definitions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Test_Definitions_Stddev_Samp_Fields = {
  __typename?: 'test_definitions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "test_definitions" */
export type Test_Definitions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Definitions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Definitions_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  questionnaire_id?: InputMaybe<Scalars['Int']>;
  test_type?: InputMaybe<Test_Types_Enum>;
};

/** aggregate sum on columns */
export type Test_Definitions_Sum_Fields = {
  __typename?: 'test_definitions_sum_fields';
  id?: Maybe<Scalars['Int']>;
  questionnaire_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "test_definitions" */
export enum Test_Definitions_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  TestType = 'test_type'
}

export type Test_Definitions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Test_Definitions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Test_Definitions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Test_Definitions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Test_Definitions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Test_Definitions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Test_Definitions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Definitions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Definitions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Test_Definitions_Var_Pop_Fields = {
  __typename?: 'test_definitions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Test_Definitions_Var_Samp_Fields = {
  __typename?: 'test_definitions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Test_Definitions_Variance_Fields = {
  __typename?: 'test_definitions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  questionnaire_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis = {
  __typename?: 'test_e_prescribe_npis';
  id: Scalars['Int'];
  npi: Scalars['String'];
  provider_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Aggregate = {
  __typename?: 'test_e_prescribe_npis_aggregate';
  aggregate?: Maybe<Test_E_Prescribe_Npis_Aggregate_Fields>;
  nodes: Array<Test_E_Prescribe_Npis>;
};

/** aggregate fields of "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Aggregate_Fields = {
  __typename?: 'test_e_prescribe_npis_aggregate_fields';
  avg?: Maybe<Test_E_Prescribe_Npis_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Test_E_Prescribe_Npis_Max_Fields>;
  min?: Maybe<Test_E_Prescribe_Npis_Min_Fields>;
  stddev?: Maybe<Test_E_Prescribe_Npis_Stddev_Fields>;
  stddev_pop?: Maybe<Test_E_Prescribe_Npis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_E_Prescribe_Npis_Stddev_Samp_Fields>;
  sum?: Maybe<Test_E_Prescribe_Npis_Sum_Fields>;
  var_pop?: Maybe<Test_E_Prescribe_Npis_Var_Pop_Fields>;
  var_samp?: Maybe<Test_E_Prescribe_Npis_Var_Samp_Fields>;
  variance?: Maybe<Test_E_Prescribe_Npis_Variance_Fields>;
};


/** aggregate fields of "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_E_Prescribe_Npis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Test_E_Prescribe_Npis_Avg_Fields = {
  __typename?: 'test_e_prescribe_npis_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "test_e_prescribe_npis". All fields are combined with a logical 'AND'. */
export type Test_E_Prescribe_Npis_Bool_Exp = {
  _and?: InputMaybe<Array<Test_E_Prescribe_Npis_Bool_Exp>>;
  _not?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
  _or?: InputMaybe<Array<Test_E_Prescribe_Npis_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  npi?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_e_prescribe_npis" */
export enum Test_E_Prescribe_Npis_Constraint {
  /** unique or primary key constraint on columns "id" */
  TestEPrescribeNpisPkey = 'test_e_prescribe_npis_pkey'
}

/** input type for incrementing numeric columns in table "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  npi?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Test_E_Prescribe_Npis_Max_Fields = {
  __typename?: 'test_e_prescribe_npis_max_fields';
  id?: Maybe<Scalars['Int']>;
  npi?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Test_E_Prescribe_Npis_Min_Fields = {
  __typename?: 'test_e_prescribe_npis_min_fields';
  id?: Maybe<Scalars['Int']>;
  npi?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Mutation_Response = {
  __typename?: 'test_e_prescribe_npis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_E_Prescribe_Npis>;
};

/** on_conflict condition type for table "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_On_Conflict = {
  constraint: Test_E_Prescribe_Npis_Constraint;
  update_columns?: Array<Test_E_Prescribe_Npis_Update_Column>;
  where?: InputMaybe<Test_E_Prescribe_Npis_Bool_Exp>;
};

/** Ordering options when selecting data from "test_e_prescribe_npis". */
export type Test_E_Prescribe_Npis_Order_By = {
  id?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test_e_prescribe_npis */
export type Test_E_Prescribe_Npis_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "test_e_prescribe_npis" */
export enum Test_E_Prescribe_Npis_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Npi = 'npi',
  /** column name */
  ProviderId = 'provider_id'
}

/** input type for updating data in table "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  npi?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Test_E_Prescribe_Npis_Stddev_Fields = {
  __typename?: 'test_e_prescribe_npis_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Test_E_Prescribe_Npis_Stddev_Pop_Fields = {
  __typename?: 'test_e_prescribe_npis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Test_E_Prescribe_Npis_Stddev_Samp_Fields = {
  __typename?: 'test_e_prescribe_npis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "test_e_prescribe_npis" */
export type Test_E_Prescribe_Npis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_E_Prescribe_Npis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_E_Prescribe_Npis_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  npi?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Test_E_Prescribe_Npis_Sum_Fields = {
  __typename?: 'test_e_prescribe_npis_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "test_e_prescribe_npis" */
export enum Test_E_Prescribe_Npis_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Npi = 'npi',
  /** column name */
  ProviderId = 'provider_id'
}

export type Test_E_Prescribe_Npis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Test_E_Prescribe_Npis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_E_Prescribe_Npis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_E_Prescribe_Npis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Test_E_Prescribe_Npis_Var_Pop_Fields = {
  __typename?: 'test_e_prescribe_npis_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Test_E_Prescribe_Npis_Var_Samp_Fields = {
  __typename?: 'test_e_prescribe_npis_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Test_E_Prescribe_Npis_Variance_Fields = {
  __typename?: 'test_e_prescribe_npis_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "test_kit_status_counts" */
export type Test_Kit_Status_Counts = {
  __typename?: 'test_kit_status_counts';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

export type Test_Kit_Status_Counts_Aggregate = {
  __typename?: 'test_kit_status_counts_aggregate';
  aggregate?: Maybe<Test_Kit_Status_Counts_Aggregate_Fields>;
  nodes: Array<Test_Kit_Status_Counts>;
};

/** aggregate fields of "test_kit_status_counts" */
export type Test_Kit_Status_Counts_Aggregate_Fields = {
  __typename?: 'test_kit_status_counts_aggregate_fields';
  avg?: Maybe<Test_Kit_Status_Counts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Test_Kit_Status_Counts_Max_Fields>;
  min?: Maybe<Test_Kit_Status_Counts_Min_Fields>;
  stddev?: Maybe<Test_Kit_Status_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Test_Kit_Status_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Test_Kit_Status_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Test_Kit_Status_Counts_Sum_Fields>;
  var_pop?: Maybe<Test_Kit_Status_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Test_Kit_Status_Counts_Var_Samp_Fields>;
  variance?: Maybe<Test_Kit_Status_Counts_Variance_Fields>;
};


/** aggregate fields of "test_kit_status_counts" */
export type Test_Kit_Status_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Kit_Status_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Test_Kit_Status_Counts_Avg_Fields = {
  __typename?: 'test_kit_status_counts_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "test_kit_status_counts". All fields are combined with a logical 'AND'. */
export type Test_Kit_Status_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Kit_Status_Counts_Bool_Exp>>;
  _not?: InputMaybe<Test_Kit_Status_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Kit_Status_Counts_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Test_Kit_Status_Counts_Max_Fields = {
  __typename?: 'test_kit_status_counts_max_fields';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Test_Kit_Status_Counts_Min_Fields = {
  __typename?: 'test_kit_status_counts_min_fields';
  count?: Maybe<Scalars['bigint']>;
  date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "test_kit_status_counts". */
export type Test_Kit_Status_Counts_Order_By = {
  count?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "test_kit_status_counts" */
export enum Test_Kit_Status_Counts_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Date = 'date',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Test_Kit_Status_Counts_Stddev_Fields = {
  __typename?: 'test_kit_status_counts_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Test_Kit_Status_Counts_Stddev_Pop_Fields = {
  __typename?: 'test_kit_status_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Test_Kit_Status_Counts_Stddev_Samp_Fields = {
  __typename?: 'test_kit_status_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "test_kit_status_counts" */
export type Test_Kit_Status_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Kit_Status_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Kit_Status_Counts_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Test_Kit_Status_Counts_Sum_Fields = {
  __typename?: 'test_kit_status_counts_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Test_Kit_Status_Counts_Var_Pop_Fields = {
  __typename?: 'test_kit_status_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Test_Kit_Status_Counts_Var_Samp_Fields = {
  __typename?: 'test_kit_status_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Test_Kit_Status_Counts_Variance_Fields = {
  __typename?: 'test_kit_status_counts_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log = {
  __typename?: 'test_kits_update_states_summary_log';
  from_state?: Maybe<Dnavisit_Test_Statuses_Enum>;
  internal_testing: Scalars['Boolean'];
  log_id: Scalars['uuid'];
  status_change_date: Scalars['timestamptz'];
  test_id: Scalars['uuid'];
  test_type: Test_Types_Enum;
  to_state?: Maybe<Dnavisit_Test_Statuses_Enum>;
};

/** aggregated selection of "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Aggregate = {
  __typename?: 'test_kits_update_states_summary_log_aggregate';
  aggregate?: Maybe<Test_Kits_Update_States_Summary_Log_Aggregate_Fields>;
  nodes: Array<Test_Kits_Update_States_Summary_Log>;
};

export type Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Count>;
};

export type Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_And = {
  arguments: Test_Kits_Update_States_Summary_Log_Select_Column_Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Test_Kits_Update_States_Summary_Log_Select_Column_Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Aggregate_Fields = {
  __typename?: 'test_kits_update_states_summary_log_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Test_Kits_Update_States_Summary_Log_Max_Fields>;
  min?: Maybe<Test_Kits_Update_States_Summary_Log_Min_Fields>;
};


/** aggregate fields of "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Test_Kits_Update_States_Summary_Log_Max_Order_By>;
  min?: InputMaybe<Test_Kits_Update_States_Summary_Log_Min_Order_By>;
};

/** input type for inserting array relation for remote table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input = {
  data: Array<Test_Kits_Update_States_Summary_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Kits_Update_States_Summary_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "test_kits_update_states_summary_log". All fields are combined with a logical 'AND'. */
export type Test_Kits_Update_States_Summary_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Bool_Exp>>;
  _not?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Bool_Exp>>;
  from_state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
  internal_testing?: InputMaybe<Boolean_Comparison_Exp>;
  log_id?: InputMaybe<Uuid_Comparison_Exp>;
  status_change_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_type?: InputMaybe<Test_Types_Enum_Comparison_Exp>;
  to_state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_kits_update_states_summary_log" */
export enum Test_Kits_Update_States_Summary_Log_Constraint {
  /** unique or primary key constraint on columns "log_id" */
  TestKitsUpdateStatesSummaryLogPkey = 'test_kits_update_states_summary_log_pkey'
}

/** input type for inserting data into table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Insert_Input = {
  from_state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  internal_testing?: InputMaybe<Scalars['Boolean']>;
  log_id?: InputMaybe<Scalars['uuid']>;
  status_change_date?: InputMaybe<Scalars['timestamptz']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  to_state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
};

/** aggregate max on columns */
export type Test_Kits_Update_States_Summary_Log_Max_Fields = {
  __typename?: 'test_kits_update_states_summary_log_max_fields';
  log_id?: Maybe<Scalars['uuid']>;
  status_change_date?: Maybe<Scalars['timestamptz']>;
  test_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Max_Order_By = {
  log_id?: InputMaybe<Order_By>;
  status_change_date?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Test_Kits_Update_States_Summary_Log_Min_Fields = {
  __typename?: 'test_kits_update_states_summary_log_min_fields';
  log_id?: Maybe<Scalars['uuid']>;
  status_change_date?: Maybe<Scalars['timestamptz']>;
  test_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Min_Order_By = {
  log_id?: InputMaybe<Order_By>;
  status_change_date?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Mutation_Response = {
  __typename?: 'test_kits_update_states_summary_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Kits_Update_States_Summary_Log>;
};

/** on_conflict condition type for table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_On_Conflict = {
  constraint: Test_Kits_Update_States_Summary_Log_Constraint;
  update_columns?: Array<Test_Kits_Update_States_Summary_Log_Update_Column>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "test_kits_update_states_summary_log". */
export type Test_Kits_Update_States_Summary_Log_Order_By = {
  from_state?: InputMaybe<Order_By>;
  internal_testing?: InputMaybe<Order_By>;
  log_id?: InputMaybe<Order_By>;
  status_change_date?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  to_state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test_kits_update_states_summary_log */
export type Test_Kits_Update_States_Summary_Log_Pk_Columns_Input = {
  log_id: Scalars['uuid'];
};

/** select columns of table "test_kits_update_states_summary_log" */
export enum Test_Kits_Update_States_Summary_Log_Select_Column {
  /** column name */
  FromState = 'from_state',
  /** column name */
  InternalTesting = 'internal_testing',
  /** column name */
  LogId = 'log_id',
  /** column name */
  StatusChangeDate = 'status_change_date',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TestType = 'test_type',
  /** column name */
  ToState = 'to_state'
}

/** select "test_kits_update_states_summary_log_aggregate_bool_exp_bool_and_arguments_columns" columns of table "test_kits_update_states_summary_log" */
export enum Test_Kits_Update_States_Summary_Log_Select_Column_Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  InternalTesting = 'internal_testing'
}

/** select "test_kits_update_states_summary_log_aggregate_bool_exp_bool_or_arguments_columns" columns of table "test_kits_update_states_summary_log" */
export enum Test_Kits_Update_States_Summary_Log_Select_Column_Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  InternalTesting = 'internal_testing'
}

/** input type for updating data in table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Set_Input = {
  from_state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  internal_testing?: InputMaybe<Scalars['Boolean']>;
  log_id?: InputMaybe<Scalars['uuid']>;
  status_change_date?: InputMaybe<Scalars['timestamptz']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  to_state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
};

/** Streaming cursor of the table "test_kits_update_states_summary_log" */
export type Test_Kits_Update_States_Summary_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Kits_Update_States_Summary_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Kits_Update_States_Summary_Log_Stream_Cursor_Value_Input = {
  from_state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  internal_testing?: InputMaybe<Scalars['Boolean']>;
  log_id?: InputMaybe<Scalars['uuid']>;
  status_change_date?: InputMaybe<Scalars['timestamptz']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_type?: InputMaybe<Test_Types_Enum>;
  to_state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
};

/** update columns of table "test_kits_update_states_summary_log" */
export enum Test_Kits_Update_States_Summary_Log_Update_Column {
  /** column name */
  FromState = 'from_state',
  /** column name */
  InternalTesting = 'internal_testing',
  /** column name */
  LogId = 'log_id',
  /** column name */
  StatusChangeDate = 'status_change_date',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TestType = 'test_type',
  /** column name */
  ToState = 'to_state'
}

export type Test_Kits_Update_States_Summary_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Kits_Update_States_Summary_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Kits_Update_States_Summary_Log_Bool_Exp;
};

/** columns and relationships of "test_types" */
export type Test_Types = {
  __typename?: 'test_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "test_types" */
export type Test_Types_Aggregate = {
  __typename?: 'test_types_aggregate';
  aggregate?: Maybe<Test_Types_Aggregate_Fields>;
  nodes: Array<Test_Types>;
};

/** aggregate fields of "test_types" */
export type Test_Types_Aggregate_Fields = {
  __typename?: 'test_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Test_Types_Max_Fields>;
  min?: Maybe<Test_Types_Min_Fields>;
};


/** aggregate fields of "test_types" */
export type Test_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Test_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "test_types". All fields are combined with a logical 'AND'. */
export type Test_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Test_Types_Bool_Exp>>;
  _not?: InputMaybe<Test_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Test_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "test_types" */
export enum Test_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  TestTypesPkey = 'test_types_pkey'
}

export enum Test_Types_Enum {
  DnaSkin = 'DNA_SKIN',
  DnaVitamin = 'DNA_VITAMIN',
  DsGiMap = 'DS_GI_MAP',
  MosaicOat = 'MOSAIC_OAT',
  Skintelligent = 'SKINTELLIGENT',
  ZrtHeavyMetals = 'ZRT_HEAVY_METALS',
  ZrtHormone = 'ZRT_HORMONE',
  ZrtInflammatory = 'ZRT_INFLAMMATORY',
  ZrtNeurotransmitters = 'ZRT_NEUROTRANSMITTERS'
}

/** Boolean expression to compare columns of type "test_types_enum". All fields are combined with logical 'AND'. */
export type Test_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Test_Types_Enum>;
  _in?: InputMaybe<Array<Test_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Test_Types_Enum>;
  _nin?: InputMaybe<Array<Test_Types_Enum>>;
};

/** input type for inserting data into table "test_types" */
export type Test_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Test_Types_Max_Fields = {
  __typename?: 'test_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Test_Types_Min_Fields = {
  __typename?: 'test_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "test_types" */
export type Test_Types_Mutation_Response = {
  __typename?: 'test_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Test_Types>;
};

/** input type for inserting object relation for remote table "test_types" */
export type Test_Types_Obj_Rel_Insert_Input = {
  data: Test_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Test_Types_On_Conflict>;
};

/** on_conflict condition type for table "test_types" */
export type Test_Types_On_Conflict = {
  constraint: Test_Types_Constraint;
  update_columns?: Array<Test_Types_Update_Column>;
  where?: InputMaybe<Test_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "test_types". */
export type Test_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: test_types */
export type Test_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "test_types" */
export enum Test_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "test_types" */
export type Test_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "test_types" */
export type Test_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "test_types" */
export enum Test_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Test_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test_Types_Bool_Exp;
};

/** columns and relationships of "tests" */
export type Tests = {
  __typename?: 'tests';
  created_at: Scalars['timestamptz'];
  questionaire_response_id?: Maybe<Scalars['bigint']>;
  state: Dnavisit_Test_Statuses_Enum;
  swab_code_id?: Maybe<Scalars['bigint']>;
  test_id: Scalars['uuid'];
  /** An array relationship */
  test_kits_update_states_summary_logs: Array<Test_Kits_Update_States_Summary_Log>;
  /** An aggregate relationship */
  test_kits_update_states_summary_logs_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  test_type_id: Scalars['Int'];
  /** An object relationship */
  tests_dnavisit_test_status: Dnavisit_Test_Statuses;
  /** An array relationship */
  tests_dnavisit_tests: Array<Dnavisit_Tests>;
  /** An aggregate relationship */
  tests_dnavisit_tests_aggregate: Dnavisit_Tests_Aggregate;
  /** An object relationship */
  tests_swab_code?: Maybe<Swab_Codes>;
  /** An object relationship */
  tests_test_definition: Test_Definitions;
  /** An object relationship */
  tests_user: Users;
  /** An array relationship */
  tests_zrt_tests: Array<Zrt_Tests>;
  /** An aggregate relationship */
  tests_zrt_tests_aggregate: Zrt_Tests_Aggregate;
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};


/** columns and relationships of "tests" */
export type TestsTest_Kits_Update_States_Summary_LogsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** columns and relationships of "tests" */
export type TestsTest_Kits_Update_States_Summary_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** columns and relationships of "tests" */
export type TestsTests_Dnavisit_TestsArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Tests_Order_By>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


/** columns and relationships of "tests" */
export type TestsTests_Dnavisit_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dnavisit_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dnavisit_Tests_Order_By>>;
  where?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
};


/** columns and relationships of "tests" */
export type TestsTests_Zrt_TestsArgs = {
  distinct_on?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zrt_Tests_Order_By>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};


/** columns and relationships of "tests" */
export type TestsTests_Zrt_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Zrt_Tests_Order_By>>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};

/** aggregated selection of "tests" */
export type Tests_Aggregate = {
  __typename?: 'tests_aggregate';
  aggregate?: Maybe<Tests_Aggregate_Fields>;
  nodes: Array<Tests>;
};

export type Tests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tests_Aggregate_Bool_Exp_Count>;
};

export type Tests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tests" */
export type Tests_Aggregate_Fields = {
  __typename?: 'tests_aggregate_fields';
  avg?: Maybe<Tests_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tests_Max_Fields>;
  min?: Maybe<Tests_Min_Fields>;
  stddev?: Maybe<Tests_Stddev_Fields>;
  stddev_pop?: Maybe<Tests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tests_Stddev_Samp_Fields>;
  sum?: Maybe<Tests_Sum_Fields>;
  var_pop?: Maybe<Tests_Var_Pop_Fields>;
  var_samp?: Maybe<Tests_Var_Samp_Fields>;
  variance?: Maybe<Tests_Variance_Fields>;
};


/** aggregate fields of "tests" */
export type Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tests" */
export type Tests_Aggregate_Order_By = {
  avg?: InputMaybe<Tests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tests_Max_Order_By>;
  min?: InputMaybe<Tests_Min_Order_By>;
  stddev?: InputMaybe<Tests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tests_Sum_Order_By>;
  var_pop?: InputMaybe<Tests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tests_Var_Samp_Order_By>;
  variance?: InputMaybe<Tests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tests" */
export type Tests_Arr_Rel_Insert_Input = {
  data: Array<Tests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tests_On_Conflict>;
};

/** aggregate avg on columns */
export type Tests_Avg_Fields = {
  __typename?: 'tests_avg_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tests" */
export type Tests_Avg_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tests". All fields are combined with a logical 'AND'. */
export type Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Tests_Bool_Exp>>;
  _not?: InputMaybe<Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  questionaire_response_id?: InputMaybe<Bigint_Comparison_Exp>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum_Comparison_Exp>;
  swab_code_id?: InputMaybe<Bigint_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp>;
  test_type_id?: InputMaybe<Int_Comparison_Exp>;
  tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Bool_Exp>;
  tests_dnavisit_tests?: InputMaybe<Dnavisit_Tests_Bool_Exp>;
  tests_dnavisit_tests_aggregate?: InputMaybe<Dnavisit_Tests_Aggregate_Bool_Exp>;
  tests_swab_code?: InputMaybe<Swab_Codes_Bool_Exp>;
  tests_test_definition?: InputMaybe<Test_Definitions_Bool_Exp>;
  tests_user?: InputMaybe<Users_Bool_Exp>;
  tests_zrt_tests?: InputMaybe<Zrt_Tests_Bool_Exp>;
  tests_zrt_tests_aggregate?: InputMaybe<Zrt_Tests_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "tests" */
export enum Tests_Constraint {
  /** unique or primary key constraint on columns "test_id" */
  TestsPkey = 'tests_pkey',
  /** unique or primary key constraint on columns "swab_code_id" */
  TestsSwabCodeIdKey = 'tests_swab_code_id_key'
}

/** input type for incrementing numeric columns in table "tests" */
export type Tests_Inc_Input = {
  questionaire_response_id?: InputMaybe<Scalars['bigint']>;
  swab_code_id?: InputMaybe<Scalars['bigint']>;
  test_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tests" */
export type Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  questionaire_response_id?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swab_code_id?: InputMaybe<Scalars['bigint']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input>;
  test_type_id?: InputMaybe<Scalars['Int']>;
  tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Obj_Rel_Insert_Input>;
  tests_dnavisit_tests?: InputMaybe<Dnavisit_Tests_Arr_Rel_Insert_Input>;
  tests_swab_code?: InputMaybe<Swab_Codes_Obj_Rel_Insert_Input>;
  tests_test_definition?: InputMaybe<Test_Definitions_Obj_Rel_Insert_Input>;
  tests_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  tests_zrt_tests?: InputMaybe<Zrt_Tests_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Tests_Max_Fields = {
  __typename?: 'tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  questionaire_response_id?: Maybe<Scalars['bigint']>;
  swab_code_id?: Maybe<Scalars['bigint']>;
  test_id?: Maybe<Scalars['uuid']>;
  test_type_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "tests" */
export type Tests_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tests_Min_Fields = {
  __typename?: 'tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  questionaire_response_id?: Maybe<Scalars['bigint']>;
  swab_code_id?: Maybe<Scalars['bigint']>;
  test_id?: Maybe<Scalars['uuid']>;
  test_type_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "tests" */
export type Tests_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tests" */
export type Tests_Mutation_Response = {
  __typename?: 'tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tests>;
};

/** input type for inserting object relation for remote table "tests" */
export type Tests_Obj_Rel_Insert_Input = {
  data: Tests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tests_On_Conflict>;
};

/** on_conflict condition type for table "tests" */
export type Tests_On_Conflict = {
  constraint: Tests_Constraint;
  update_columns?: Array<Tests_Update_Column>;
  where?: InputMaybe<Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "tests". */
export type Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  questionaire_response_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Order_By>;
  test_type_id?: InputMaybe<Order_By>;
  tests_dnavisit_test_status?: InputMaybe<Dnavisit_Test_Statuses_Order_By>;
  tests_dnavisit_tests_aggregate?: InputMaybe<Dnavisit_Tests_Aggregate_Order_By>;
  tests_swab_code?: InputMaybe<Swab_Codes_Order_By>;
  tests_test_definition?: InputMaybe<Test_Definitions_Order_By>;
  tests_user?: InputMaybe<Users_Order_By>;
  tests_zrt_tests_aggregate?: InputMaybe<Zrt_Tests_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tests */
export type Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** select columns of table "tests" */
export enum Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  QuestionaireResponseId = 'questionaire_response_id',
  /** column name */
  State = 'state',
  /** column name */
  SwabCodeId = 'swab_code_id',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TestTypeId = 'test_type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "tests" */
export type Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  questionaire_response_id?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swab_code_id?: InputMaybe<Scalars['bigint']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_type_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Tests_Stddev_Fields = {
  __typename?: 'tests_stddev_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tests" */
export type Tests_Stddev_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tests_Stddev_Pop_Fields = {
  __typename?: 'tests_stddev_pop_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tests" */
export type Tests_Stddev_Pop_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tests_Stddev_Samp_Fields = {
  __typename?: 'tests_stddev_samp_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tests" */
export type Tests_Stddev_Samp_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tests" */
export type Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  questionaire_response_id?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Dnavisit_Test_Statuses_Enum>;
  swab_code_id?: InputMaybe<Scalars['bigint']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_type_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Tests_Sum_Fields = {
  __typename?: 'tests_sum_fields';
  questionaire_response_id?: Maybe<Scalars['bigint']>;
  swab_code_id?: Maybe<Scalars['bigint']>;
  test_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tests" */
export type Tests_Sum_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** update columns of table "tests" */
export enum Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  QuestionaireResponseId = 'questionaire_response_id',
  /** column name */
  State = 'state',
  /** column name */
  SwabCodeId = 'swab_code_id',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TestTypeId = 'test_type_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Tests_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tests_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tests_Var_Pop_Fields = {
  __typename?: 'tests_var_pop_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tests" */
export type Tests_Var_Pop_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tests_Var_Samp_Fields = {
  __typename?: 'tests_var_samp_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tests" */
export type Tests_Var_Samp_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tests_Variance_Fields = {
  __typename?: 'tests_variance_fields';
  questionaire_response_id?: Maybe<Scalars['Float']>;
  swab_code_id?: Maybe<Scalars['Float']>;
  test_type_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tests" */
export type Tests_Variance_Order_By = {
  questionaire_response_id?: InputMaybe<Order_By>;
  swab_code_id?: InputMaybe<Order_By>;
  test_type_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "text_addresses" */
export type Text_Addresses = {
  __typename?: 'text_addresses';
  add1: Scalars['String'];
  add2?: Maybe<Scalars['String']>;
  address_id: Scalars['uuid'];
  city: Scalars['String'];
  country: Scalars['String'];
  phone: Scalars['String'];
  post_code: Scalars['String'];
  province: Scalars['String'];
  state: Scalars['String'];
};

/** aggregated selection of "text_addresses" */
export type Text_Addresses_Aggregate = {
  __typename?: 'text_addresses_aggregate';
  aggregate?: Maybe<Text_Addresses_Aggregate_Fields>;
  nodes: Array<Text_Addresses>;
};

/** aggregate fields of "text_addresses" */
export type Text_Addresses_Aggregate_Fields = {
  __typename?: 'text_addresses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Text_Addresses_Max_Fields>;
  min?: Maybe<Text_Addresses_Min_Fields>;
};


/** aggregate fields of "text_addresses" */
export type Text_Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Text_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "text_addresses". All fields are combined with a logical 'AND'. */
export type Text_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Text_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Text_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Text_Addresses_Bool_Exp>>;
  add1?: InputMaybe<String_Comparison_Exp>;
  add2?: InputMaybe<String_Comparison_Exp>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  post_code?: InputMaybe<String_Comparison_Exp>;
  province?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "text_addresses" */
export enum Text_Addresses_Constraint {
  /** unique or primary key constraint on columns "address_id" */
  TextAddressesPkey = 'text_addresses_pkey'
}

/** input type for inserting data into table "text_addresses" */
export type Text_Addresses_Insert_Input = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Text_Addresses_Max_Fields = {
  __typename?: 'text_addresses_max_fields';
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Text_Addresses_Min_Fields = {
  __typename?: 'text_addresses_min_fields';
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  address_id?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  post_code?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "text_addresses" */
export type Text_Addresses_Mutation_Response = {
  __typename?: 'text_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Text_Addresses>;
};

/** on_conflict condition type for table "text_addresses" */
export type Text_Addresses_On_Conflict = {
  constraint: Text_Addresses_Constraint;
  update_columns?: Array<Text_Addresses_Update_Column>;
  where?: InputMaybe<Text_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "text_addresses". */
export type Text_Addresses_Order_By = {
  add1?: InputMaybe<Order_By>;
  add2?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  post_code?: InputMaybe<Order_By>;
  province?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: text_addresses */
export type Text_Addresses_Pk_Columns_Input = {
  address_id: Scalars['uuid'];
};

/** select columns of table "text_addresses" */
export enum Text_Addresses_Select_Column {
  /** column name */
  Add1 = 'add1',
  /** column name */
  Add2 = 'add2',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  Province = 'province',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "text_addresses" */
export type Text_Addresses_Set_Input = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "text_addresses" */
export type Text_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Text_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Text_Addresses_Stream_Cursor_Value_Input = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  post_code?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** update columns of table "text_addresses" */
export enum Text_Addresses_Update_Column {
  /** column name */
  Add1 = 'add1',
  /** column name */
  Add2 = 'add2',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostCode = 'post_code',
  /** column name */
  Province = 'province',
  /** column name */
  State = 'state'
}

export type Text_Addresses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Text_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Text_Addresses_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

/** Unauthenticated enabling of questions to selected questionnaire */
export type Unauthenticated_Questionnaire_Questions = {
  __typename?: 'unauthenticated_questionnaire_questions';
  id: Scalars['bigint'];
  unauthenticated_question_id: Scalars['Int'];
  unauthenticated_questionnaire_id: Scalars['Int'];
  /** An object relationship */
  unauthenticated_questionnaire_questions_unauthenticated_question: Unauthenticated_Questions;
  /** An object relationship */
  unauthenticated_questionnaire_questions_unauthenticated_questionnaire: Unauthenticated_Questionnaires;
};

/** aggregated selection of "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Aggregate = {
  __typename?: 'unauthenticated_questionnaire_questions_aggregate';
  aggregate?: Maybe<Unauthenticated_Questionnaire_Questions_Aggregate_Fields>;
  nodes: Array<Unauthenticated_Questionnaire_Questions>;
};

export type Unauthenticated_Questionnaire_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Unauthenticated_Questionnaire_Questions_Aggregate_Bool_Exp_Count>;
};

export type Unauthenticated_Questionnaire_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Aggregate_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_aggregate_fields';
  avg?: Maybe<Unauthenticated_Questionnaire_Questions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unauthenticated_Questionnaire_Questions_Max_Fields>;
  min?: Maybe<Unauthenticated_Questionnaire_Questions_Min_Fields>;
  stddev?: Maybe<Unauthenticated_Questionnaire_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Unauthenticated_Questionnaire_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unauthenticated_Questionnaire_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Unauthenticated_Questionnaire_Questions_Sum_Fields>;
  var_pop?: Maybe<Unauthenticated_Questionnaire_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Unauthenticated_Questionnaire_Questions_Var_Samp_Fields>;
  variance?: Maybe<Unauthenticated_Questionnaire_Questions_Variance_Fields>;
};


/** aggregate fields of "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Unauthenticated_Questionnaire_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unauthenticated_Questionnaire_Questions_Max_Order_By>;
  min?: InputMaybe<Unauthenticated_Questionnaire_Questions_Min_Order_By>;
  stddev?: InputMaybe<Unauthenticated_Questionnaire_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unauthenticated_Questionnaire_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unauthenticated_Questionnaire_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unauthenticated_Questionnaire_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Unauthenticated_Questionnaire_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unauthenticated_Questionnaire_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Unauthenticated_Questionnaire_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Arr_Rel_Insert_Input = {
  data: Array<Unauthenticated_Questionnaire_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unauthenticated_Questionnaire_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Unauthenticated_Questionnaire_Questions_Avg_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unauthenticated_questionnaire_questions". All fields are combined with a logical 'AND'. */
export type Unauthenticated_Questionnaire_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Bool_Exp>>;
  _not?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  unauthenticated_question_id?: InputMaybe<Int_Comparison_Exp>;
  unauthenticated_questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  unauthenticated_questionnaire_questions_unauthenticated_question?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
  unauthenticated_questionnaire_questions_unauthenticated_questionnaire?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};

/** unique or primary key constraints on table "unauthenticated_questionnaire_questions" */
export enum Unauthenticated_Questionnaire_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnauthenticatedQuestionnaireQuestionsIdSeq = 'unauthenticated_questionnaire_questions_id_seq',
  /** unique or primary key constraint on columns "id" */
  UnauthenticatedQuestionnaireQuestionsPkey = 'unauthenticated_questionnaire_questions_pkey',
  /** unique or primary key constraint on columns "unauthenticated_question_id", "unauthenticated_questionnaire_id" */
  UnauthenticatedQuestionnaireQuestionsUnauthenticatedQuestio = 'unauthenticated_questionnaire_questions_unauthenticated_questio'
}

/** input type for incrementing numeric columns in table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  unauthenticated_question_id?: InputMaybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  unauthenticated_question_id?: InputMaybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: InputMaybe<Scalars['Int']>;
  unauthenticated_questionnaire_questions_unauthenticated_question?: InputMaybe<Unauthenticated_Questions_Obj_Rel_Insert_Input>;
  unauthenticated_questionnaire_questions_unauthenticated_questionnaire?: InputMaybe<Unauthenticated_Questionnaires_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Unauthenticated_Questionnaire_Questions_Max_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_max_fields';
  id?: Maybe<Scalars['bigint']>;
  unauthenticated_question_id?: Maybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unauthenticated_Questionnaire_Questions_Min_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_min_fields';
  id?: Maybe<Scalars['bigint']>;
  unauthenticated_question_id?: Maybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Mutation_Response = {
  __typename?: 'unauthenticated_questionnaire_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unauthenticated_Questionnaire_Questions>;
};

/** on_conflict condition type for table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_On_Conflict = {
  constraint: Unauthenticated_Questionnaire_Questions_Constraint;
  update_columns?: Array<Unauthenticated_Questionnaire_Questions_Update_Column>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "unauthenticated_questionnaire_questions". */
export type Unauthenticated_Questionnaire_Questions_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_questions_unauthenticated_question?: InputMaybe<Unauthenticated_Questions_Order_By>;
  unauthenticated_questionnaire_questions_unauthenticated_questionnaire?: InputMaybe<Unauthenticated_Questionnaires_Order_By>;
};

/** primary key columns input for table: unauthenticated_questionnaire_questions */
export type Unauthenticated_Questionnaire_Questions_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "unauthenticated_questionnaire_questions" */
export enum Unauthenticated_Questionnaire_Questions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  UnauthenticatedQuestionId = 'unauthenticated_question_id',
  /** column name */
  UnauthenticatedQuestionnaireId = 'unauthenticated_questionnaire_id'
}

/** input type for updating data in table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  unauthenticated_question_id?: InputMaybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Unauthenticated_Questionnaire_Questions_Stddev_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unauthenticated_Questionnaire_Questions_Stddev_Pop_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unauthenticated_Questionnaire_Questions_Stddev_Samp_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unauthenticated_Questionnaire_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unauthenticated_Questionnaire_Questions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  unauthenticated_question_id?: InputMaybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Unauthenticated_Questionnaire_Questions_Sum_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  unauthenticated_question_id?: Maybe<Scalars['Int']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** update columns of table "unauthenticated_questionnaire_questions" */
export enum Unauthenticated_Questionnaire_Questions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  UnauthenticatedQuestionId = 'unauthenticated_question_id',
  /** column name */
  UnauthenticatedQuestionnaireId = 'unauthenticated_questionnaire_id'
}

export type Unauthenticated_Questionnaire_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unauthenticated_Questionnaire_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unauthenticated_Questionnaire_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unauthenticated_Questionnaire_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unauthenticated_Questionnaire_Questions_Var_Pop_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unauthenticated_Questionnaire_Questions_Var_Samp_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unauthenticated_Questionnaire_Questions_Variance_Fields = {
  __typename?: 'unauthenticated_questionnaire_questions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  unauthenticated_question_id?: Maybe<Scalars['Float']>;
  unauthenticated_questionnaire_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unauthenticated_questionnaire_questions" */
export type Unauthenticated_Questionnaire_Questions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  unauthenticated_question_id?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_id?: InputMaybe<Order_By>;
};

/** Questionnaires for public access */
export type Unauthenticated_Questionnaires = {
  __typename?: 'unauthenticated_questionnaires';
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  /** An array relationship */
  unauthenticated_questionnaire_questions: Array<Unauthenticated_Questionnaire_Questions>;
  /** An aggregate relationship */
  unauthenticated_questionnaire_questions_aggregate: Unauthenticated_Questionnaire_Questions_Aggregate;
};


/** Questionnaires for public access */
export type Unauthenticated_QuestionnairesDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Questionnaires for public access */
export type Unauthenticated_QuestionnairesUnauthenticated_Questionnaire_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


/** Questionnaires for public access */
export type Unauthenticated_QuestionnairesUnauthenticated_Questionnaire_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};

/** aggregated selection of "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Aggregate = {
  __typename?: 'unauthenticated_questionnaires_aggregate';
  aggregate?: Maybe<Unauthenticated_Questionnaires_Aggregate_Fields>;
  nodes: Array<Unauthenticated_Questionnaires>;
};

/** aggregate fields of "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Aggregate_Fields = {
  __typename?: 'unauthenticated_questionnaires_aggregate_fields';
  avg?: Maybe<Unauthenticated_Questionnaires_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unauthenticated_Questionnaires_Max_Fields>;
  min?: Maybe<Unauthenticated_Questionnaires_Min_Fields>;
  stddev?: Maybe<Unauthenticated_Questionnaires_Stddev_Fields>;
  stddev_pop?: Maybe<Unauthenticated_Questionnaires_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unauthenticated_Questionnaires_Stddev_Samp_Fields>;
  sum?: Maybe<Unauthenticated_Questionnaires_Sum_Fields>;
  var_pop?: Maybe<Unauthenticated_Questionnaires_Var_Pop_Fields>;
  var_samp?: Maybe<Unauthenticated_Questionnaires_Var_Samp_Fields>;
  variance?: Maybe<Unauthenticated_Questionnaires_Variance_Fields>;
};


/** aggregate fields of "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unauthenticated_Questionnaires_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Unauthenticated_Questionnaires_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Unauthenticated_Questionnaires_Avg_Fields = {
  __typename?: 'unauthenticated_questionnaires_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "unauthenticated_questionnaires". All fields are combined with a logical 'AND'. */
export type Unauthenticated_Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Unauthenticated_Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Unauthenticated_Questionnaires_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  unauthenticated_questionnaire_questions?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
  unauthenticated_questionnaire_questions_aggregate?: InputMaybe<Unauthenticated_Questionnaire_Questions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "unauthenticated_questionnaires" */
export enum Unauthenticated_Questionnaires_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnauthenticatedQuestionnairesPkey = 'unauthenticated_questionnaires_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Unauthenticated_Questionnaires_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Unauthenticated_Questionnaires_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Unauthenticated_Questionnaires_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  unauthenticated_questionnaire_questions?: InputMaybe<Unauthenticated_Questionnaire_Questions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Unauthenticated_Questionnaires_Max_Fields = {
  __typename?: 'unauthenticated_questionnaires_max_fields';
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Unauthenticated_Questionnaires_Min_Fields = {
  __typename?: 'unauthenticated_questionnaires_min_fields';
  id?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Mutation_Response = {
  __typename?: 'unauthenticated_questionnaires_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unauthenticated_Questionnaires>;
};

/** input type for inserting object relation for remote table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Obj_Rel_Insert_Input = {
  data: Unauthenticated_Questionnaires_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unauthenticated_Questionnaires_On_Conflict>;
};

/** on_conflict condition type for table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_On_Conflict = {
  constraint: Unauthenticated_Questionnaires_Constraint;
  update_columns?: Array<Unauthenticated_Questionnaires_Update_Column>;
  where?: InputMaybe<Unauthenticated_Questionnaires_Bool_Exp>;
};

/** Ordering options when selecting data from "unauthenticated_questionnaires". */
export type Unauthenticated_Questionnaires_Order_By = {
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  unauthenticated_questionnaire_questions_aggregate?: InputMaybe<Unauthenticated_Questionnaire_Questions_Aggregate_Order_By>;
};

/** primary key columns input for table: unauthenticated_questionnaires */
export type Unauthenticated_Questionnaires_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Unauthenticated_Questionnaires_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "unauthenticated_questionnaires" */
export enum Unauthenticated_Questionnaires_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Notes = 'notes',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Unauthenticated_Questionnaires_Stddev_Fields = {
  __typename?: 'unauthenticated_questionnaires_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Unauthenticated_Questionnaires_Stddev_Pop_Fields = {
  __typename?: 'unauthenticated_questionnaires_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Unauthenticated_Questionnaires_Stddev_Samp_Fields = {
  __typename?: 'unauthenticated_questionnaires_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "unauthenticated_questionnaires" */
export type Unauthenticated_Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unauthenticated_Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unauthenticated_Questionnaires_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Unauthenticated_Questionnaires_Sum_Fields = {
  __typename?: 'unauthenticated_questionnaires_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "unauthenticated_questionnaires" */
export enum Unauthenticated_Questionnaires_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Notes = 'notes',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title'
}

export type Unauthenticated_Questionnaires_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Unauthenticated_Questionnaires_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Unauthenticated_Questionnaires_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Unauthenticated_Questionnaires_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Unauthenticated_Questionnaires_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unauthenticated_Questionnaires_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Unauthenticated_Questionnaires_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unauthenticated_Questionnaires_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unauthenticated_Questionnaires_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unauthenticated_Questionnaires_Var_Pop_Fields = {
  __typename?: 'unauthenticated_questionnaires_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Unauthenticated_Questionnaires_Var_Samp_Fields = {
  __typename?: 'unauthenticated_questionnaires_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Unauthenticated_Questionnaires_Variance_Fields = {
  __typename?: 'unauthenticated_questionnaires_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Unauthenticated questions for unauthenticated questionnaires */
export type Unauthenticated_Questions = {
  __typename?: 'unauthenticated_questions';
  answers?: Maybe<Scalars['jsonb']>;
  default?: Maybe<Scalars['String']>;
  dont_know_answer?: Maybe<Scalars['String']>;
  double_text_combo_helper_texts?: Maybe<Scalars['jsonb']>;
  dropdown_combo_answers?: Maybe<Scalars['jsonb']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  form_section_name?: Maybe<Scalars['String']>;
  has_tooltip?: Maybe<Scalars['Boolean']>;
  helper_text_position?: Maybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id: Scalars['Int'];
  measurement_unit?: Maybe<Question_Measurement_Units_Enum>;
  placeholder?: Maybe<Scalars['String']>;
  /** An array relationship */
  relationship_unauthenticated_questionnaire_to_unauthenticated_questions: Array<Unauthenticated_Questionnaire_Questions>;
  /** An aggregate relationship */
  relationship_unauthenticated_questionnaire_to_unauthenticated_questions_aggregate: Unauthenticated_Questionnaire_Questions_Aggregate;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  tooltip_content?: Maybe<Scalars['String']>;
  type: Question_Types_Enum;
  ui_control: Question_Ui_Control_Types_Enum;
  /** An object relationship */
  unauthenticated_questions_helper_text_position?: Maybe<Question_Ui_Control_Helper_Text_Position>;
  /** An object relationship */
  unauthenticated_questions_question_measurement_unit?: Maybe<Question_Measurement_Units>;
  /** An object relationship */
  unauthenticated_questions_question_type?: Maybe<Question_Ui_Control_Types>;
  /** An object relationship */
  unauthenticated_questions_question_ui_control?: Maybe<Question_Ui_Control_Types>;
};


/** Unauthenticated questions for unauthenticated questionnaires */
export type Unauthenticated_QuestionsAnswersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Unauthenticated questions for unauthenticated questionnaires */
export type Unauthenticated_QuestionsDouble_Text_Combo_Helper_TextsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Unauthenticated questions for unauthenticated questionnaires */
export type Unauthenticated_QuestionsDropdown_Combo_AnswersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Unauthenticated questions for unauthenticated questionnaires */
export type Unauthenticated_QuestionsRelationship_Unauthenticated_Questionnaire_To_Unauthenticated_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};


/** Unauthenticated questions for unauthenticated questionnaires */
export type Unauthenticated_QuestionsRelationship_Unauthenticated_Questionnaire_To_Unauthenticated_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unauthenticated_Questionnaire_Questions_Order_By>>;
  where?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
};

/** aggregated selection of "unauthenticated_questions" */
export type Unauthenticated_Questions_Aggregate = {
  __typename?: 'unauthenticated_questions_aggregate';
  aggregate?: Maybe<Unauthenticated_Questions_Aggregate_Fields>;
  nodes: Array<Unauthenticated_Questions>;
};

/** aggregate fields of "unauthenticated_questions" */
export type Unauthenticated_Questions_Aggregate_Fields = {
  __typename?: 'unauthenticated_questions_aggregate_fields';
  avg?: Maybe<Unauthenticated_Questions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unauthenticated_Questions_Max_Fields>;
  min?: Maybe<Unauthenticated_Questions_Min_Fields>;
  stddev?: Maybe<Unauthenticated_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Unauthenticated_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unauthenticated_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Unauthenticated_Questions_Sum_Fields>;
  var_pop?: Maybe<Unauthenticated_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Unauthenticated_Questions_Var_Samp_Fields>;
  variance?: Maybe<Unauthenticated_Questions_Variance_Fields>;
};


/** aggregate fields of "unauthenticated_questions" */
export type Unauthenticated_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unauthenticated_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Unauthenticated_Questions_Append_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Unauthenticated_Questions_Avg_Fields = {
  __typename?: 'unauthenticated_questions_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "unauthenticated_questions". All fields are combined with a logical 'AND'. */
export type Unauthenticated_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Unauthenticated_Questions_Bool_Exp>>;
  _not?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Unauthenticated_Questions_Bool_Exp>>;
  answers?: InputMaybe<Jsonb_Comparison_Exp>;
  default?: InputMaybe<String_Comparison_Exp>;
  dont_know_answer?: InputMaybe<String_Comparison_Exp>;
  double_text_combo_helper_texts?: InputMaybe<Jsonb_Comparison_Exp>;
  dropdown_combo_answers?: InputMaybe<Jsonb_Comparison_Exp>;
  dropdown_label_1?: InputMaybe<String_Comparison_Exp>;
  dropdown_label_2?: InputMaybe<String_Comparison_Exp>;
  form_section_name?: InputMaybe<String_Comparison_Exp>;
  has_tooltip?: InputMaybe<Boolean_Comparison_Exp>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum_Comparison_Exp>;
  placeholder?: InputMaybe<String_Comparison_Exp>;
  relationship_unauthenticated_questionnaire_to_unauthenticated_questions?: InputMaybe<Unauthenticated_Questionnaire_Questions_Bool_Exp>;
  relationship_unauthenticated_questionnaire_to_unauthenticated_questions_aggregate?: InputMaybe<Unauthenticated_Questionnaire_Questions_Aggregate_Bool_Exp>;
  response_property?: InputMaybe<String_Comparison_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  tooltip_content?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Question_Types_Enum_Comparison_Exp>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum_Comparison_Exp>;
  unauthenticated_questions_helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Bool_Exp>;
  unauthenticated_questions_question_measurement_unit?: InputMaybe<Question_Measurement_Units_Bool_Exp>;
  unauthenticated_questions_question_type?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
  unauthenticated_questions_question_ui_control?: InputMaybe<Question_Ui_Control_Types_Bool_Exp>;
};

/** unique or primary key constraints on table "unauthenticated_questions" */
export enum Unauthenticated_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnauthenticatedQuestionsIdSeq = 'unauthenticated_questions_id_seq',
  /** unique or primary key constraint on columns "id" */
  UnauthenticatedQuestionsPkey = 'unauthenticated_questions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Unauthenticated_Questions_Delete_At_Path_Input = {
  answers?: InputMaybe<Array<Scalars['String']>>;
  double_text_combo_helper_texts?: InputMaybe<Array<Scalars['String']>>;
  dropdown_combo_answers?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Unauthenticated_Questions_Delete_Elem_Input = {
  answers?: InputMaybe<Scalars['Int']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['Int']>;
  dropdown_combo_answers?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Unauthenticated_Questions_Delete_Key_Input = {
  answers?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['String']>;
  dropdown_combo_answers?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "unauthenticated_questions" */
export type Unauthenticated_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "unauthenticated_questions" */
export type Unauthenticated_Questions_Insert_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  default?: InputMaybe<Scalars['String']>;
  dont_know_answer?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
  dropdown_label_1?: InputMaybe<Scalars['String']>;
  dropdown_label_2?: InputMaybe<Scalars['String']>;
  form_section_name?: InputMaybe<Scalars['String']>;
  has_tooltip?: InputMaybe<Scalars['Boolean']>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum>;
  placeholder?: InputMaybe<Scalars['String']>;
  relationship_unauthenticated_questionnaire_to_unauthenticated_questions?: InputMaybe<Unauthenticated_Questionnaire_Questions_Arr_Rel_Insert_Input>;
  response_property?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  tooltip_content?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Question_Types_Enum>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum>;
  unauthenticated_questions_helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Obj_Rel_Insert_Input>;
  unauthenticated_questions_question_measurement_unit?: InputMaybe<Question_Measurement_Units_Obj_Rel_Insert_Input>;
  unauthenticated_questions_question_type?: InputMaybe<Question_Ui_Control_Types_Obj_Rel_Insert_Input>;
  unauthenticated_questions_question_ui_control?: InputMaybe<Question_Ui_Control_Types_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Unauthenticated_Questions_Max_Fields = {
  __typename?: 'unauthenticated_questions_max_fields';
  default?: Maybe<Scalars['String']>;
  dont_know_answer?: Maybe<Scalars['String']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  form_section_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tooltip_content?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Unauthenticated_Questions_Min_Fields = {
  __typename?: 'unauthenticated_questions_min_fields';
  default?: Maybe<Scalars['String']>;
  dont_know_answer?: Maybe<Scalars['String']>;
  dropdown_label_1?: Maybe<Scalars['String']>;
  dropdown_label_2?: Maybe<Scalars['String']>;
  form_section_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  response_property?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tooltip_content?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "unauthenticated_questions" */
export type Unauthenticated_Questions_Mutation_Response = {
  __typename?: 'unauthenticated_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unauthenticated_Questions>;
};

/** input type for inserting object relation for remote table "unauthenticated_questions" */
export type Unauthenticated_Questions_Obj_Rel_Insert_Input = {
  data: Unauthenticated_Questions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unauthenticated_Questions_On_Conflict>;
};

/** on_conflict condition type for table "unauthenticated_questions" */
export type Unauthenticated_Questions_On_Conflict = {
  constraint: Unauthenticated_Questions_Constraint;
  update_columns?: Array<Unauthenticated_Questions_Update_Column>;
  where?: InputMaybe<Unauthenticated_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "unauthenticated_questions". */
export type Unauthenticated_Questions_Order_By = {
  answers?: InputMaybe<Order_By>;
  default?: InputMaybe<Order_By>;
  dont_know_answer?: InputMaybe<Order_By>;
  double_text_combo_helper_texts?: InputMaybe<Order_By>;
  dropdown_combo_answers?: InputMaybe<Order_By>;
  dropdown_label_1?: InputMaybe<Order_By>;
  dropdown_label_2?: InputMaybe<Order_By>;
  form_section_name?: InputMaybe<Order_By>;
  has_tooltip?: InputMaybe<Order_By>;
  helper_text_position?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement_unit?: InputMaybe<Order_By>;
  placeholder?: InputMaybe<Order_By>;
  relationship_unauthenticated_questionnaire_to_unauthenticated_questions_aggregate?: InputMaybe<Unauthenticated_Questionnaire_Questions_Aggregate_Order_By>;
  response_property?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  tooltip_content?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  ui_control?: InputMaybe<Order_By>;
  unauthenticated_questions_helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Order_By>;
  unauthenticated_questions_question_measurement_unit?: InputMaybe<Question_Measurement_Units_Order_By>;
  unauthenticated_questions_question_type?: InputMaybe<Question_Ui_Control_Types_Order_By>;
  unauthenticated_questions_question_ui_control?: InputMaybe<Question_Ui_Control_Types_Order_By>;
};

/** primary key columns input for table: unauthenticated_questions */
export type Unauthenticated_Questions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Unauthenticated_Questions_Prepend_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "unauthenticated_questions" */
export enum Unauthenticated_Questions_Select_Column {
  /** column name */
  Answers = 'answers',
  /** column name */
  Default = 'default',
  /** column name */
  DontKnowAnswer = 'dont_know_answer',
  /** column name */
  DoubleTextComboHelperTexts = 'double_text_combo_helper_texts',
  /** column name */
  DropdownComboAnswers = 'dropdown_combo_answers',
  /** column name */
  DropdownLabel_1 = 'dropdown_label_1',
  /** column name */
  DropdownLabel_2 = 'dropdown_label_2',
  /** column name */
  FormSectionName = 'form_section_name',
  /** column name */
  HasTooltip = 'has_tooltip',
  /** column name */
  HelperTextPosition = 'helper_text_position',
  /** column name */
  Id = 'id',
  /** column name */
  MeasurementUnit = 'measurement_unit',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  ResponseProperty = 'response_property',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Text = 'text',
  /** column name */
  TooltipContent = 'tooltip_content',
  /** column name */
  Type = 'type',
  /** column name */
  UiControl = 'ui_control'
}

/** input type for updating data in table "unauthenticated_questions" */
export type Unauthenticated_Questions_Set_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  default?: InputMaybe<Scalars['String']>;
  dont_know_answer?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
  dropdown_label_1?: InputMaybe<Scalars['String']>;
  dropdown_label_2?: InputMaybe<Scalars['String']>;
  form_section_name?: InputMaybe<Scalars['String']>;
  has_tooltip?: InputMaybe<Scalars['Boolean']>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum>;
  placeholder?: InputMaybe<Scalars['String']>;
  response_property?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  tooltip_content?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Question_Types_Enum>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum>;
};

/** aggregate stddev on columns */
export type Unauthenticated_Questions_Stddev_Fields = {
  __typename?: 'unauthenticated_questions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Unauthenticated_Questions_Stddev_Pop_Fields = {
  __typename?: 'unauthenticated_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Unauthenticated_Questions_Stddev_Samp_Fields = {
  __typename?: 'unauthenticated_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "unauthenticated_questions" */
export type Unauthenticated_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unauthenticated_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unauthenticated_Questions_Stream_Cursor_Value_Input = {
  answers?: InputMaybe<Scalars['jsonb']>;
  default?: InputMaybe<Scalars['String']>;
  dont_know_answer?: InputMaybe<Scalars['String']>;
  double_text_combo_helper_texts?: InputMaybe<Scalars['jsonb']>;
  dropdown_combo_answers?: InputMaybe<Scalars['jsonb']>;
  dropdown_label_1?: InputMaybe<Scalars['String']>;
  dropdown_label_2?: InputMaybe<Scalars['String']>;
  form_section_name?: InputMaybe<Scalars['String']>;
  has_tooltip?: InputMaybe<Scalars['Boolean']>;
  helper_text_position?: InputMaybe<Question_Ui_Control_Helper_Text_Position_Enum>;
  id?: InputMaybe<Scalars['Int']>;
  measurement_unit?: InputMaybe<Question_Measurement_Units_Enum>;
  placeholder?: InputMaybe<Scalars['String']>;
  response_property?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  tooltip_content?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Question_Types_Enum>;
  ui_control?: InputMaybe<Question_Ui_Control_Types_Enum>;
};

/** aggregate sum on columns */
export type Unauthenticated_Questions_Sum_Fields = {
  __typename?: 'unauthenticated_questions_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "unauthenticated_questions" */
export enum Unauthenticated_Questions_Update_Column {
  /** column name */
  Answers = 'answers',
  /** column name */
  Default = 'default',
  /** column name */
  DontKnowAnswer = 'dont_know_answer',
  /** column name */
  DoubleTextComboHelperTexts = 'double_text_combo_helper_texts',
  /** column name */
  DropdownComboAnswers = 'dropdown_combo_answers',
  /** column name */
  DropdownLabel_1 = 'dropdown_label_1',
  /** column name */
  DropdownLabel_2 = 'dropdown_label_2',
  /** column name */
  FormSectionName = 'form_section_name',
  /** column name */
  HasTooltip = 'has_tooltip',
  /** column name */
  HelperTextPosition = 'helper_text_position',
  /** column name */
  Id = 'id',
  /** column name */
  MeasurementUnit = 'measurement_unit',
  /** column name */
  Placeholder = 'placeholder',
  /** column name */
  ResponseProperty = 'response_property',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Text = 'text',
  /** column name */
  TooltipContent = 'tooltip_content',
  /** column name */
  Type = 'type',
  /** column name */
  UiControl = 'ui_control'
}

export type Unauthenticated_Questions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Unauthenticated_Questions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Unauthenticated_Questions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Unauthenticated_Questions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Unauthenticated_Questions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unauthenticated_Questions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Unauthenticated_Questions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unauthenticated_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unauthenticated_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unauthenticated_Questions_Var_Pop_Fields = {
  __typename?: 'unauthenticated_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Unauthenticated_Questions_Var_Samp_Fields = {
  __typename?: 'unauthenticated_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Unauthenticated_Questions_Variance_Fields = {
  __typename?: 'unauthenticated_questions_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** USA universities */
export type Universities = {
  __typename?: 'universities';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "universities" */
export type Universities_Aggregate = {
  __typename?: 'universities_aggregate';
  aggregate?: Maybe<Universities_Aggregate_Fields>;
  nodes: Array<Universities>;
};

/** aggregate fields of "universities" */
export type Universities_Aggregate_Fields = {
  __typename?: 'universities_aggregate_fields';
  avg?: Maybe<Universities_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Universities_Max_Fields>;
  min?: Maybe<Universities_Min_Fields>;
  stddev?: Maybe<Universities_Stddev_Fields>;
  stddev_pop?: Maybe<Universities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Universities_Stddev_Samp_Fields>;
  sum?: Maybe<Universities_Sum_Fields>;
  var_pop?: Maybe<Universities_Var_Pop_Fields>;
  var_samp?: Maybe<Universities_Var_Samp_Fields>;
  variance?: Maybe<Universities_Variance_Fields>;
};


/** aggregate fields of "universities" */
export type Universities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Universities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Universities_Avg_Fields = {
  __typename?: 'universities_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "universities". All fields are combined with a logical 'AND'. */
export type Universities_Bool_Exp = {
  _and?: InputMaybe<Array<Universities_Bool_Exp>>;
  _not?: InputMaybe<Universities_Bool_Exp>;
  _or?: InputMaybe<Array<Universities_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "universities" */
export enum Universities_Constraint {
  /** unique or primary key constraint on columns "name" */
  UniversitiesNameKey = 'universities_name_key',
  /** unique or primary key constraint on columns "id" */
  UniversitiesPkey = 'universities_pkey'
}

/** input type for incrementing numeric columns in table "universities" */
export type Universities_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "universities" */
export type Universities_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Universities_Max_Fields = {
  __typename?: 'universities_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Universities_Min_Fields = {
  __typename?: 'universities_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "universities" */
export type Universities_Mutation_Response = {
  __typename?: 'universities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Universities>;
};

/** on_conflict condition type for table "universities" */
export type Universities_On_Conflict = {
  constraint: Universities_Constraint;
  update_columns?: Array<Universities_Update_Column>;
  where?: InputMaybe<Universities_Bool_Exp>;
};

/** Ordering options when selecting data from "universities". */
export type Universities_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: universities */
export type Universities_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "universities" */
export enum Universities_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "universities" */
export type Universities_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Universities_Stddev_Fields = {
  __typename?: 'universities_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Universities_Stddev_Pop_Fields = {
  __typename?: 'universities_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Universities_Stddev_Samp_Fields = {
  __typename?: 'universities_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "universities" */
export type Universities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Universities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Universities_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Universities_Sum_Fields = {
  __typename?: 'universities_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "universities" */
export enum Universities_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Universities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Universities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Universities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Universities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Universities_Var_Pop_Fields = {
  __typename?: 'universities_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Universities_Var_Samp_Fields = {
  __typename?: 'universities_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Universities_Variance_Fields = {
  __typename?: 'universities_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses = {
  __typename?: 'used_test_e_prescribe_licenses';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  license_number: Scalars['String'];
  provider_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Aggregate = {
  __typename?: 'used_test_e_prescribe_licenses_aggregate';
  aggregate?: Maybe<Used_Test_E_Prescribe_Licenses_Aggregate_Fields>;
  nodes: Array<Used_Test_E_Prescribe_Licenses>;
};

/** aggregate fields of "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Aggregate_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_aggregate_fields';
  avg?: Maybe<Used_Test_E_Prescribe_Licenses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Used_Test_E_Prescribe_Licenses_Max_Fields>;
  min?: Maybe<Used_Test_E_Prescribe_Licenses_Min_Fields>;
  stddev?: Maybe<Used_Test_E_Prescribe_Licenses_Stddev_Fields>;
  stddev_pop?: Maybe<Used_Test_E_Prescribe_Licenses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Used_Test_E_Prescribe_Licenses_Stddev_Samp_Fields>;
  sum?: Maybe<Used_Test_E_Prescribe_Licenses_Sum_Fields>;
  var_pop?: Maybe<Used_Test_E_Prescribe_Licenses_Var_Pop_Fields>;
  var_samp?: Maybe<Used_Test_E_Prescribe_Licenses_Var_Samp_Fields>;
  variance?: Maybe<Used_Test_E_Prescribe_Licenses_Variance_Fields>;
};


/** aggregate fields of "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Used_Test_E_Prescribe_Licenses_Avg_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "used_test_e_prescribe_licenses". All fields are combined with a logical 'AND'. */
export type Used_Test_E_Prescribe_Licenses_Bool_Exp = {
  _and?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Bool_Exp>>;
  _not?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
  _or?: InputMaybe<Array<Used_Test_E_Prescribe_Licenses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  license_number?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "used_test_e_prescribe_licenses" */
export enum Used_Test_E_Prescribe_Licenses_Constraint {
  /** unique or primary key constraint on columns "license_number" */
  IdxUsedTestEPrescribeLicenses = 'idx_used_test_e_prescribe_licenses',
  /** unique or primary key constraint on columns "id" */
  UsedTestEPrescribeLicensesPkey = 'used_test_e_prescribe_licenses_pkey'
}

/** input type for inserting data into table "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  license_number?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Used_Test_E_Prescribe_Licenses_Max_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  license_number?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Used_Test_E_Prescribe_Licenses_Min_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  license_number?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Mutation_Response = {
  __typename?: 'used_test_e_prescribe_licenses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Used_Test_E_Prescribe_Licenses>;
};

/** on_conflict condition type for table "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_On_Conflict = {
  constraint: Used_Test_E_Prescribe_Licenses_Constraint;
  update_columns?: Array<Used_Test_E_Prescribe_Licenses_Update_Column>;
  where?: InputMaybe<Used_Test_E_Prescribe_Licenses_Bool_Exp>;
};

/** Ordering options when selecting data from "used_test_e_prescribe_licenses". */
export type Used_Test_E_Prescribe_Licenses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  license_number?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: used_test_e_prescribe_licenses */
export type Used_Test_E_Prescribe_Licenses_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "used_test_e_prescribe_licenses" */
export enum Used_Test_E_Prescribe_Licenses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  ProviderId = 'provider_id'
}

/** input type for updating data in table "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  license_number?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Used_Test_E_Prescribe_Licenses_Stddev_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Used_Test_E_Prescribe_Licenses_Stddev_Pop_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Used_Test_E_Prescribe_Licenses_Stddev_Samp_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "used_test_e_prescribe_licenses" */
export type Used_Test_E_Prescribe_Licenses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Used_Test_E_Prescribe_Licenses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Used_Test_E_Prescribe_Licenses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  license_number?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Used_Test_E_Prescribe_Licenses_Sum_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "used_test_e_prescribe_licenses" */
export enum Used_Test_E_Prescribe_Licenses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LicenseNumber = 'license_number',
  /** column name */
  ProviderId = 'provider_id'
}

export type Used_Test_E_Prescribe_Licenses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Used_Test_E_Prescribe_Licenses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Used_Test_E_Prescribe_Licenses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Used_Test_E_Prescribe_Licenses_Var_Pop_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Used_Test_E_Prescribe_Licenses_Var_Samp_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Used_Test_E_Prescribe_Licenses_Variance_Fields = {
  __typename?: 'used_test_e_prescribe_licenses_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_addresses" */
export type User_Addresses = {
  __typename?: 'user_addresses';
  address_id: Scalars['uuid'];
  id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_addresses" */
export type User_Addresses_Aggregate = {
  __typename?: 'user_addresses_aggregate';
  aggregate?: Maybe<User_Addresses_Aggregate_Fields>;
  nodes: Array<User_Addresses>;
};

/** aggregate fields of "user_addresses" */
export type User_Addresses_Aggregate_Fields = {
  __typename?: 'user_addresses_aggregate_fields';
  avg?: Maybe<User_Addresses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Addresses_Max_Fields>;
  min?: Maybe<User_Addresses_Min_Fields>;
  stddev?: Maybe<User_Addresses_Stddev_Fields>;
  stddev_pop?: Maybe<User_Addresses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Addresses_Stddev_Samp_Fields>;
  sum?: Maybe<User_Addresses_Sum_Fields>;
  var_pop?: Maybe<User_Addresses_Var_Pop_Fields>;
  var_samp?: Maybe<User_Addresses_Var_Samp_Fields>;
  variance?: Maybe<User_Addresses_Variance_Fields>;
};


/** aggregate fields of "user_addresses" */
export type User_Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Addresses_Avg_Fields = {
  __typename?: 'user_addresses_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_addresses". All fields are combined with a logical 'AND'. */
export type User_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<User_Addresses_Bool_Exp>>;
  _not?: InputMaybe<User_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<User_Addresses_Bool_Exp>>;
  address_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_addresses" */
export enum User_Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAddressesPkey = 'user_addresses_pkey',
  /** unique or primary key constraint on columns "address_id", "user_id" */
  UserAddressesUserIdAddressIdKey = 'user_addresses_user_id_address_id_key'
}

/** input type for incrementing numeric columns in table "user_addresses" */
export type User_Addresses_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_addresses" */
export type User_Addresses_Insert_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Addresses_Max_Fields = {
  __typename?: 'user_addresses_max_fields';
  address_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Addresses_Min_Fields = {
  __typename?: 'user_addresses_min_fields';
  address_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_addresses" */
export type User_Addresses_Mutation_Response = {
  __typename?: 'user_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Addresses>;
};

/** on_conflict condition type for table "user_addresses" */
export type User_Addresses_On_Conflict = {
  constraint: User_Addresses_Constraint;
  update_columns?: Array<User_Addresses_Update_Column>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "user_addresses". */
export type User_Addresses_Order_By = {
  address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_addresses */
export type User_Addresses_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "user_addresses" */
export enum User_Addresses_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_addresses" */
export type User_Addresses_Set_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Addresses_Stddev_Fields = {
  __typename?: 'user_addresses_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Addresses_Stddev_Pop_Fields = {
  __typename?: 'user_addresses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Addresses_Stddev_Samp_Fields = {
  __typename?: 'user_addresses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_addresses" */
export type User_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Addresses_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Addresses_Sum_Fields = {
  __typename?: 'user_addresses_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_addresses" */
export enum User_Addresses_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type User_Addresses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Addresses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Addresses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Addresses_Var_Pop_Fields = {
  __typename?: 'user_addresses_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Addresses_Var_Samp_Fields = {
  __typename?: 'user_addresses_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Addresses_Variance_Fields = {
  __typename?: 'user_addresses_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "user_agreement_types". All fields are combined with logical 'AND'. */
export type User_Agreement_Types_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_agreement_types']>;
  _gt?: InputMaybe<Scalars['user_agreement_types']>;
  _gte?: InputMaybe<Scalars['user_agreement_types']>;
  _in?: InputMaybe<Array<Scalars['user_agreement_types']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_agreement_types']>;
  _lte?: InputMaybe<Scalars['user_agreement_types']>;
  _neq?: InputMaybe<Scalars['user_agreement_types']>;
  _nin?: InputMaybe<Array<Scalars['user_agreement_types']>>;
};

/** columns and relationships of "user_agreements" */
export type User_Agreements = {
  __typename?: 'user_agreements';
  acceptor_role?: Maybe<Scalars['smallint']>;
  agreement_type: Scalars['user_agreement_types'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['smallint']>;
  id: Scalars['Int'];
  status: Persona_Inquiry_Status_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_agreements" */
export type User_Agreements_Aggregate = {
  __typename?: 'user_agreements_aggregate';
  aggregate?: Maybe<User_Agreements_Aggregate_Fields>;
  nodes: Array<User_Agreements>;
};

export type User_Agreements_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Agreements_Aggregate_Bool_Exp_Count>;
};

export type User_Agreements_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Agreements_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_agreements" */
export type User_Agreements_Aggregate_Fields = {
  __typename?: 'user_agreements_aggregate_fields';
  avg?: Maybe<User_Agreements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Agreements_Max_Fields>;
  min?: Maybe<User_Agreements_Min_Fields>;
  stddev?: Maybe<User_Agreements_Stddev_Fields>;
  stddev_pop?: Maybe<User_Agreements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Agreements_Stddev_Samp_Fields>;
  sum?: Maybe<User_Agreements_Sum_Fields>;
  var_pop?: Maybe<User_Agreements_Var_Pop_Fields>;
  var_samp?: Maybe<User_Agreements_Var_Samp_Fields>;
  variance?: Maybe<User_Agreements_Variance_Fields>;
};


/** aggregate fields of "user_agreements" */
export type User_Agreements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_agreements" */
export type User_Agreements_Aggregate_Order_By = {
  avg?: InputMaybe<User_Agreements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Agreements_Max_Order_By>;
  min?: InputMaybe<User_Agreements_Min_Order_By>;
  stddev?: InputMaybe<User_Agreements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Agreements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Agreements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Agreements_Sum_Order_By>;
  var_pop?: InputMaybe<User_Agreements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Agreements_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Agreements_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_agreements" */
export type User_Agreements_Arr_Rel_Insert_Input = {
  data: Array<User_Agreements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Agreements_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Agreements_Avg_Fields = {
  __typename?: 'user_agreements_avg_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_agreements" */
export type User_Agreements_Avg_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_agreements". All fields are combined with a logical 'AND'. */
export type User_Agreements_Bool_Exp = {
  _and?: InputMaybe<Array<User_Agreements_Bool_Exp>>;
  _not?: InputMaybe<User_Agreements_Bool_Exp>;
  _or?: InputMaybe<Array<User_Agreements_Bool_Exp>>;
  acceptor_role?: InputMaybe<Smallint_Comparison_Exp>;
  agreement_type?: InputMaybe<User_Agreement_Types_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiration_type?: InputMaybe<Smallint_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_agreements" */
export enum User_Agreements_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAgreementsPkey = 'user_agreements_pkey',
  /** unique or primary key constraint on columns "user_id", "agreement_type" */
  UserAgreementsUserIdAgreementTypeKey = 'user_agreements_user_id_agreement_type_key'
}

/** input type for incrementing numeric columns in table "user_agreements" */
export type User_Agreements_Inc_Input = {
  acceptor_role?: InputMaybe<Scalars['smallint']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_agreements" */
export type User_Agreements_Insert_Input = {
  acceptor_role?: InputMaybe<Scalars['smallint']>;
  agreement_type?: InputMaybe<Scalars['user_agreement_types']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Agreements_Max_Fields = {
  __typename?: 'user_agreements_max_fields';
  acceptor_role?: Maybe<Scalars['smallint']>;
  agreement_type?: Maybe<Scalars['user_agreement_types']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_agreements" */
export type User_Agreements_Max_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  agreement_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Agreements_Min_Fields = {
  __typename?: 'user_agreements_min_fields';
  acceptor_role?: Maybe<Scalars['smallint']>;
  agreement_type?: Maybe<Scalars['user_agreement_types']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_agreements" */
export type User_Agreements_Min_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  agreement_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_agreements" */
export type User_Agreements_Mutation_Response = {
  __typename?: 'user_agreements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Agreements>;
};

/** on_conflict condition type for table "user_agreements" */
export type User_Agreements_On_Conflict = {
  constraint: User_Agreements_Constraint;
  update_columns?: Array<User_Agreements_Update_Column>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};

/** Ordering options when selecting data from "user_agreements". */
export type User_Agreements_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  agreement_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_agreements */
export type User_Agreements_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_agreements" */
export enum User_Agreements_Select_Column {
  /** column name */
  AcceptorRole = 'acceptor_role',
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationType = 'expiration_type',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_agreements" */
export type User_Agreements_Set_Input = {
  acceptor_role?: InputMaybe<Scalars['smallint']>;
  agreement_type?: InputMaybe<Scalars['user_agreement_types']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Agreements_Stddev_Fields = {
  __typename?: 'user_agreements_stddev_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_agreements" */
export type User_Agreements_Stddev_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Agreements_Stddev_Pop_Fields = {
  __typename?: 'user_agreements_stddev_pop_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_agreements" */
export type User_Agreements_Stddev_Pop_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Agreements_Stddev_Samp_Fields = {
  __typename?: 'user_agreements_stddev_samp_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_agreements" */
export type User_Agreements_Stddev_Samp_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_agreements" */
export type User_Agreements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Agreements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Agreements_Stream_Cursor_Value_Input = {
  acceptor_role?: InputMaybe<Scalars['smallint']>;
  agreement_type?: InputMaybe<Scalars['user_agreement_types']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Agreements_Sum_Fields = {
  __typename?: 'user_agreements_sum_fields';
  acceptor_role?: Maybe<Scalars['smallint']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_agreements" */
export type User_Agreements_Sum_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "user_agreements" */
export enum User_Agreements_Update_Column {
  /** column name */
  AcceptorRole = 'acceptor_role',
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpirationType = 'expiration_type',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Agreements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Agreements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Agreements_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Agreements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Agreements_Var_Pop_Fields = {
  __typename?: 'user_agreements_var_pop_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_agreements" */
export type User_Agreements_Var_Pop_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Agreements_Var_Samp_Fields = {
  __typename?: 'user_agreements_var_samp_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_agreements" */
export type User_Agreements_Var_Samp_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Agreements_Variance_Fields = {
  __typename?: 'user_agreements_variance_fields';
  acceptor_role?: Maybe<Scalars['Float']>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_agreements" */
export type User_Agreements_Variance_Order_By = {
  acceptor_role?: InputMaybe<Order_By>;
  /** 1 - MANUAL, 2 - END_OF_TREATMENT */
  expiration_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_auth_provider_types" */
export type User_Auth_Provider_Types = {
  __typename?: 'user_auth_provider_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "user_auth_provider_types" */
export type User_Auth_Provider_Types_Aggregate = {
  __typename?: 'user_auth_provider_types_aggregate';
  aggregate?: Maybe<User_Auth_Provider_Types_Aggregate_Fields>;
  nodes: Array<User_Auth_Provider_Types>;
};

/** aggregate fields of "user_auth_provider_types" */
export type User_Auth_Provider_Types_Aggregate_Fields = {
  __typename?: 'user_auth_provider_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Auth_Provider_Types_Max_Fields>;
  min?: Maybe<User_Auth_Provider_Types_Min_Fields>;
};


/** aggregate fields of "user_auth_provider_types" */
export type User_Auth_Provider_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Provider_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_auth_provider_types". All fields are combined with a logical 'AND'. */
export type User_Auth_Provider_Types_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Provider_Types_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Provider_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_auth_provider_types" */
export enum User_Auth_Provider_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserAuthProviderTypesPkey = 'user_auth_provider_types_pkey'
}

export enum User_Auth_Provider_Types_Enum {
  Apple = 'APPLE',
  Email = 'EMAIL',
  Google = 'GOOGLE'
}

/** Boolean expression to compare columns of type "user_auth_provider_types_enum". All fields are combined with logical 'AND'. */
export type User_Auth_Provider_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Auth_Provider_Types_Enum>;
  _in?: InputMaybe<Array<User_Auth_Provider_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Auth_Provider_Types_Enum>;
  _nin?: InputMaybe<Array<User_Auth_Provider_Types_Enum>>;
};

/** input type for inserting data into table "user_auth_provider_types" */
export type User_Auth_Provider_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Auth_Provider_Types_Max_Fields = {
  __typename?: 'user_auth_provider_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Auth_Provider_Types_Min_Fields = {
  __typename?: 'user_auth_provider_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_auth_provider_types" */
export type User_Auth_Provider_Types_Mutation_Response = {
  __typename?: 'user_auth_provider_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Provider_Types>;
};

/** on_conflict condition type for table "user_auth_provider_types" */
export type User_Auth_Provider_Types_On_Conflict = {
  constraint: User_Auth_Provider_Types_Constraint;
  update_columns?: Array<User_Auth_Provider_Types_Update_Column>;
  where?: InputMaybe<User_Auth_Provider_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_provider_types". */
export type User_Auth_Provider_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_auth_provider_types */
export type User_Auth_Provider_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_auth_provider_types" */
export enum User_Auth_Provider_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_auth_provider_types" */
export type User_Auth_Provider_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_auth_provider_types" */
export type User_Auth_Provider_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Provider_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Provider_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_auth_provider_types" */
export enum User_Auth_Provider_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type User_Auth_Provider_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Provider_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Provider_Types_Bool_Exp;
};

/** columns and relationships of "user_auth_providers" */
export type User_Auth_Providers = {
  __typename?: 'user_auth_providers';
  id: Scalars['bigint'];
  provider_data?: Maybe<Scalars['jsonb']>;
  provider_identifier: Scalars['String'];
  provider_type: User_Auth_Provider_Types_Enum;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "user_auth_providers" */
export type User_Auth_ProvidersProvider_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_auth_providers" */
export type User_Auth_Providers_Aggregate = {
  __typename?: 'user_auth_providers_aggregate';
  aggregate?: Maybe<User_Auth_Providers_Aggregate_Fields>;
  nodes: Array<User_Auth_Providers>;
};

/** aggregate fields of "user_auth_providers" */
export type User_Auth_Providers_Aggregate_Fields = {
  __typename?: 'user_auth_providers_aggregate_fields';
  avg?: Maybe<User_Auth_Providers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Auth_Providers_Max_Fields>;
  min?: Maybe<User_Auth_Providers_Min_Fields>;
  stddev?: Maybe<User_Auth_Providers_Stddev_Fields>;
  stddev_pop?: Maybe<User_Auth_Providers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Auth_Providers_Stddev_Samp_Fields>;
  sum?: Maybe<User_Auth_Providers_Sum_Fields>;
  var_pop?: Maybe<User_Auth_Providers_Var_Pop_Fields>;
  var_samp?: Maybe<User_Auth_Providers_Var_Samp_Fields>;
  variance?: Maybe<User_Auth_Providers_Variance_Fields>;
};


/** aggregate fields of "user_auth_providers" */
export type User_Auth_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Auth_Providers_Append_Input = {
  provider_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Auth_Providers_Avg_Fields = {
  __typename?: 'user_auth_providers_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_auth_providers". All fields are combined with a logical 'AND'. */
export type User_Auth_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Providers_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Providers_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  provider_data?: InputMaybe<Jsonb_Comparison_Exp>;
  provider_identifier?: InputMaybe<String_Comparison_Exp>;
  provider_type?: InputMaybe<User_Auth_Provider_Types_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_auth_providers" */
export enum User_Auth_Providers_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAuthProvidersPkey = 'user_auth_providers_pkey',
  /** unique or primary key constraint on columns "user_id", "provider_type" */
  UserAuthProvidersUserIdProviderTypeKey = 'user_auth_providers_user_id_provider_type_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Auth_Providers_Delete_At_Path_Input = {
  provider_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Auth_Providers_Delete_Elem_Input = {
  provider_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Auth_Providers_Delete_Key_Input = {
  provider_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_auth_providers" */
export type User_Auth_Providers_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_auth_providers" */
export type User_Auth_Providers_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  provider_data?: InputMaybe<Scalars['jsonb']>;
  provider_identifier?: InputMaybe<Scalars['String']>;
  provider_type?: InputMaybe<User_Auth_Provider_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Auth_Providers_Max_Fields = {
  __typename?: 'user_auth_providers_max_fields';
  id?: Maybe<Scalars['bigint']>;
  provider_identifier?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Auth_Providers_Min_Fields = {
  __typename?: 'user_auth_providers_min_fields';
  id?: Maybe<Scalars['bigint']>;
  provider_identifier?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_auth_providers" */
export type User_Auth_Providers_Mutation_Response = {
  __typename?: 'user_auth_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Providers>;
};

/** on_conflict condition type for table "user_auth_providers" */
export type User_Auth_Providers_On_Conflict = {
  constraint: User_Auth_Providers_Constraint;
  update_columns?: Array<User_Auth_Providers_Update_Column>;
  where?: InputMaybe<User_Auth_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_providers". */
export type User_Auth_Providers_Order_By = {
  id?: InputMaybe<Order_By>;
  provider_data?: InputMaybe<Order_By>;
  provider_identifier?: InputMaybe<Order_By>;
  provider_type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_auth_providers */
export type User_Auth_Providers_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Auth_Providers_Prepend_Input = {
  provider_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_auth_providers" */
export enum User_Auth_Providers_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProviderData = 'provider_data',
  /** column name */
  ProviderIdentifier = 'provider_identifier',
  /** column name */
  ProviderType = 'provider_type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_auth_providers" */
export type User_Auth_Providers_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  provider_data?: InputMaybe<Scalars['jsonb']>;
  provider_identifier?: InputMaybe<Scalars['String']>;
  provider_type?: InputMaybe<User_Auth_Provider_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Auth_Providers_Stddev_Fields = {
  __typename?: 'user_auth_providers_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Auth_Providers_Stddev_Pop_Fields = {
  __typename?: 'user_auth_providers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Auth_Providers_Stddev_Samp_Fields = {
  __typename?: 'user_auth_providers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_auth_providers" */
export type User_Auth_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Providers_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  provider_data?: InputMaybe<Scalars['jsonb']>;
  provider_identifier?: InputMaybe<Scalars['String']>;
  provider_type?: InputMaybe<User_Auth_Provider_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Auth_Providers_Sum_Fields = {
  __typename?: 'user_auth_providers_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_auth_providers" */
export enum User_Auth_Providers_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProviderData = 'provider_data',
  /** column name */
  ProviderIdentifier = 'provider_identifier',
  /** column name */
  ProviderType = 'provider_type',
  /** column name */
  UserId = 'user_id'
}

export type User_Auth_Providers_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Auth_Providers_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Auth_Providers_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Auth_Providers_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Auth_Providers_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Auth_Providers_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Auth_Providers_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Providers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Auth_Providers_Var_Pop_Fields = {
  __typename?: 'user_auth_providers_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Auth_Providers_Var_Samp_Fields = {
  __typename?: 'user_auth_providers_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Auth_Providers_Variance_Fields = {
  __typename?: 'user_auth_providers_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_auth_tokens" */
export type User_Auth_Tokens = {
  __typename?: 'user_auth_tokens';
  access_token: Scalars['String'];
  auth_token: Scalars['String'];
  created_at?: Maybe<Scalars['timestamp']>;
  expire_at: Scalars['timestamp'];
  id: Scalars['Int'];
  refresh_token: Scalars['String'];
  user_id: Scalars['String'];
};

/** aggregated selection of "user_auth_tokens" */
export type User_Auth_Tokens_Aggregate = {
  __typename?: 'user_auth_tokens_aggregate';
  aggregate?: Maybe<User_Auth_Tokens_Aggregate_Fields>;
  nodes: Array<User_Auth_Tokens>;
};

/** aggregate fields of "user_auth_tokens" */
export type User_Auth_Tokens_Aggregate_Fields = {
  __typename?: 'user_auth_tokens_aggregate_fields';
  avg?: Maybe<User_Auth_Tokens_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Auth_Tokens_Max_Fields>;
  min?: Maybe<User_Auth_Tokens_Min_Fields>;
  stddev?: Maybe<User_Auth_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<User_Auth_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Auth_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<User_Auth_Tokens_Sum_Fields>;
  var_pop?: Maybe<User_Auth_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<User_Auth_Tokens_Var_Samp_Fields>;
  variance?: Maybe<User_Auth_Tokens_Variance_Fields>;
};


/** aggregate fields of "user_auth_tokens" */
export type User_Auth_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Auth_Tokens_Avg_Fields = {
  __typename?: 'user_auth_tokens_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_auth_tokens". All fields are combined with a logical 'AND'. */
export type User_Auth_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Tokens_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Tokens_Bool_Exp>>;
  access_token?: InputMaybe<String_Comparison_Exp>;
  auth_token?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  expire_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  refresh_token?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_auth_tokens" */
export enum User_Auth_Tokens_Constraint {
  /** unique or primary key constraint on columns "auth_token" */
  UserAuthTokensAuthTokenKey = 'user_auth_tokens_auth_token_key',
  /** unique or primary key constraint on columns "id" */
  UserAuthTokensPkey = 'user_auth_tokens_pkey'
}

/** input type for incrementing numeric columns in table "user_auth_tokens" */
export type User_Auth_Tokens_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_auth_tokens" */
export type User_Auth_Tokens_Insert_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  auth_token?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  expire_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Auth_Tokens_Max_Fields = {
  __typename?: 'user_auth_tokens_max_fields';
  access_token?: Maybe<Scalars['String']>;
  auth_token?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  expire_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Auth_Tokens_Min_Fields = {
  __typename?: 'user_auth_tokens_min_fields';
  access_token?: Maybe<Scalars['String']>;
  auth_token?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  expire_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  refresh_token?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_auth_tokens" */
export type User_Auth_Tokens_Mutation_Response = {
  __typename?: 'user_auth_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Tokens>;
};

/** on_conflict condition type for table "user_auth_tokens" */
export type User_Auth_Tokens_On_Conflict = {
  constraint: User_Auth_Tokens_Constraint;
  update_columns?: Array<User_Auth_Tokens_Update_Column>;
  where?: InputMaybe<User_Auth_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_tokens". */
export type User_Auth_Tokens_Order_By = {
  access_token?: InputMaybe<Order_By>;
  auth_token?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expire_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_auth_tokens */
export type User_Auth_Tokens_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_auth_tokens" */
export enum User_Auth_Tokens_Select_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AuthToken = 'auth_token',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpireAt = 'expire_at',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_auth_tokens" */
export type User_Auth_Tokens_Set_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  auth_token?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  expire_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Auth_Tokens_Stddev_Fields = {
  __typename?: 'user_auth_tokens_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Auth_Tokens_Stddev_Pop_Fields = {
  __typename?: 'user_auth_tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Auth_Tokens_Stddev_Samp_Fields = {
  __typename?: 'user_auth_tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_auth_tokens" */
export type User_Auth_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Tokens_Stream_Cursor_Value_Input = {
  access_token?: InputMaybe<Scalars['String']>;
  auth_token?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  expire_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Auth_Tokens_Sum_Fields = {
  __typename?: 'user_auth_tokens_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_auth_tokens" */
export enum User_Auth_Tokens_Update_Column {
  /** column name */
  AccessToken = 'access_token',
  /** column name */
  AuthToken = 'auth_token',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpireAt = 'expire_at',
  /** column name */
  Id = 'id',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UserId = 'user_id'
}

export type User_Auth_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Auth_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Tokens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Auth_Tokens_Var_Pop_Fields = {
  __typename?: 'user_auth_tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Auth_Tokens_Var_Samp_Fields = {
  __typename?: 'user_auth_tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Auth_Tokens_Variance_Fields = {
  __typename?: 'user_auth_tokens_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_communication_deliveries" */
export type User_Communication_Deliveries = {
  __typename?: 'user_communication_deliveries';
  communication_channel: Communication_Channels_Enum;
  created_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user_communication: User_Communications;
  user_communication_delivery_id: Scalars['bigint'];
  user_communication_id: Scalars['bigint'];
  /** An object relationship */
  user_notification?: Maybe<User_Notifications>;
};

/** aggregated selection of "user_communication_deliveries" */
export type User_Communication_Deliveries_Aggregate = {
  __typename?: 'user_communication_deliveries_aggregate';
  aggregate?: Maybe<User_Communication_Deliveries_Aggregate_Fields>;
  nodes: Array<User_Communication_Deliveries>;
};

export type User_Communication_Deliveries_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Communication_Deliveries_Aggregate_Bool_Exp_Count>;
};

export type User_Communication_Deliveries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_communication_deliveries" */
export type User_Communication_Deliveries_Aggregate_Fields = {
  __typename?: 'user_communication_deliveries_aggregate_fields';
  avg?: Maybe<User_Communication_Deliveries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Communication_Deliveries_Max_Fields>;
  min?: Maybe<User_Communication_Deliveries_Min_Fields>;
  stddev?: Maybe<User_Communication_Deliveries_Stddev_Fields>;
  stddev_pop?: Maybe<User_Communication_Deliveries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Communication_Deliveries_Stddev_Samp_Fields>;
  sum?: Maybe<User_Communication_Deliveries_Sum_Fields>;
  var_pop?: Maybe<User_Communication_Deliveries_Var_Pop_Fields>;
  var_samp?: Maybe<User_Communication_Deliveries_Var_Samp_Fields>;
  variance?: Maybe<User_Communication_Deliveries_Variance_Fields>;
};


/** aggregate fields of "user_communication_deliveries" */
export type User_Communication_Deliveries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Aggregate_Order_By = {
  avg?: InputMaybe<User_Communication_Deliveries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Communication_Deliveries_Max_Order_By>;
  min?: InputMaybe<User_Communication_Deliveries_Min_Order_By>;
  stddev?: InputMaybe<User_Communication_Deliveries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Communication_Deliveries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Communication_Deliveries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Communication_Deliveries_Sum_Order_By>;
  var_pop?: InputMaybe<User_Communication_Deliveries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Communication_Deliveries_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Communication_Deliveries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_communication_deliveries" */
export type User_Communication_Deliveries_Arr_Rel_Insert_Input = {
  data: Array<User_Communication_Deliveries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Communication_Deliveries_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Communication_Deliveries_Avg_Fields = {
  __typename?: 'user_communication_deliveries_avg_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Avg_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_communication_deliveries". All fields are combined with a logical 'AND'. */
export type User_Communication_Deliveries_Bool_Exp = {
  _and?: InputMaybe<Array<User_Communication_Deliveries_Bool_Exp>>;
  _not?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
  _or?: InputMaybe<Array<User_Communication_Deliveries_Bool_Exp>>;
  communication_channel?: InputMaybe<Communication_Channels_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_communication?: InputMaybe<User_Communications_Bool_Exp>;
  user_communication_delivery_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_communication_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_notification?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** unique or primary key constraints on table "user_communication_deliveries" */
export enum User_Communication_Deliveries_Constraint {
  /** unique or primary key constraint on columns "user_communication_delivery_id" */
  UserCommunicationDeliveriesPkey = 'user_communication_deliveries_pkey'
}

/** input type for incrementing numeric columns in table "user_communication_deliveries" */
export type User_Communication_Deliveries_Inc_Input = {
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_communication_deliveries" */
export type User_Communication_Deliveries_Insert_Input = {
  communication_channel?: InputMaybe<Communication_Channels_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_communication?: InputMaybe<User_Communications_Obj_Rel_Insert_Input>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
  user_notification?: InputMaybe<User_Notifications_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Communication_Deliveries_Max_Fields = {
  __typename?: 'user_communication_deliveries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_communication_delivery_id?: Maybe<Scalars['bigint']>;
  user_communication_id?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Communication_Deliveries_Min_Fields = {
  __typename?: 'user_communication_deliveries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_communication_delivery_id?: Maybe<Scalars['bigint']>;
  user_communication_id?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_communication_deliveries" */
export type User_Communication_Deliveries_Mutation_Response = {
  __typename?: 'user_communication_deliveries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Communication_Deliveries>;
};

/** on_conflict condition type for table "user_communication_deliveries" */
export type User_Communication_Deliveries_On_Conflict = {
  constraint: User_Communication_Deliveries_Constraint;
  update_columns?: Array<User_Communication_Deliveries_Update_Column>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};

/** Ordering options when selecting data from "user_communication_deliveries". */
export type User_Communication_Deliveries_Order_By = {
  communication_channel?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_communication?: InputMaybe<User_Communications_Order_By>;
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
  user_notification?: InputMaybe<User_Notifications_Order_By>;
};

/** primary key columns input for table: user_communication_deliveries */
export type User_Communication_Deliveries_Pk_Columns_Input = {
  user_communication_delivery_id: Scalars['bigint'];
};

/** select columns of table "user_communication_deliveries" */
export enum User_Communication_Deliveries_Select_Column {
  /** column name */
  CommunicationChannel = 'communication_channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserCommunicationDeliveryId = 'user_communication_delivery_id',
  /** column name */
  UserCommunicationId = 'user_communication_id'
}

/** input type for updating data in table "user_communication_deliveries" */
export type User_Communication_Deliveries_Set_Input = {
  communication_channel?: InputMaybe<Communication_Channels_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type User_Communication_Deliveries_Stddev_Fields = {
  __typename?: 'user_communication_deliveries_stddev_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Stddev_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Communication_Deliveries_Stddev_Pop_Fields = {
  __typename?: 'user_communication_deliveries_stddev_pop_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Stddev_Pop_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Communication_Deliveries_Stddev_Samp_Fields = {
  __typename?: 'user_communication_deliveries_stddev_samp_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Stddev_Samp_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_communication_deliveries" */
export type User_Communication_Deliveries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Communication_Deliveries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Communication_Deliveries_Stream_Cursor_Value_Input = {
  communication_channel?: InputMaybe<Communication_Channels_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type User_Communication_Deliveries_Sum_Fields = {
  __typename?: 'user_communication_deliveries_sum_fields';
  user_communication_delivery_id?: Maybe<Scalars['bigint']>;
  user_communication_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Sum_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_communication_deliveries" */
export enum User_Communication_Deliveries_Update_Column {
  /** column name */
  CommunicationChannel = 'communication_channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserCommunicationDeliveryId = 'user_communication_delivery_id',
  /** column name */
  UserCommunicationId = 'user_communication_id'
}

export type User_Communication_Deliveries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Communication_Deliveries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Communication_Deliveries_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Communication_Deliveries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Communication_Deliveries_Var_Pop_Fields = {
  __typename?: 'user_communication_deliveries_var_pop_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Var_Pop_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Communication_Deliveries_Var_Samp_Fields = {
  __typename?: 'user_communication_deliveries_var_samp_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Var_Samp_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Communication_Deliveries_Variance_Fields = {
  __typename?: 'user_communication_deliveries_variance_fields';
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_communication_deliveries" */
export type User_Communication_Deliveries_Variance_Order_By = {
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_communications" */
export type User_Communications = {
  __typename?: 'user_communications';
  created_at: Scalars['timestamptz'];
  parameters?: Maybe<Scalars['jsonb']>;
  template_id: Scalars['String'];
  template_version: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_communication_deliveries: Array<User_Communication_Deliveries>;
  /** An aggregate relationship */
  user_communication_deliveries_aggregate: User_Communication_Deliveries_Aggregate;
  user_communication_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};


/** columns and relationships of "user_communications" */
export type User_CommunicationsParametersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_communications" */
export type User_CommunicationsUser_Communication_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communication_Deliveries_Order_By>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};


/** columns and relationships of "user_communications" */
export type User_CommunicationsUser_Communication_Deliveries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Communication_Deliveries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communication_Deliveries_Order_By>>;
  where?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
};

/** aggregated selection of "user_communications" */
export type User_Communications_Aggregate = {
  __typename?: 'user_communications_aggregate';
  aggregate?: Maybe<User_Communications_Aggregate_Fields>;
  nodes: Array<User_Communications>;
};

/** aggregate fields of "user_communications" */
export type User_Communications_Aggregate_Fields = {
  __typename?: 'user_communications_aggregate_fields';
  avg?: Maybe<User_Communications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Communications_Max_Fields>;
  min?: Maybe<User_Communications_Min_Fields>;
  stddev?: Maybe<User_Communications_Stddev_Fields>;
  stddev_pop?: Maybe<User_Communications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Communications_Stddev_Samp_Fields>;
  sum?: Maybe<User_Communications_Sum_Fields>;
  var_pop?: Maybe<User_Communications_Var_Pop_Fields>;
  var_samp?: Maybe<User_Communications_Var_Samp_Fields>;
  variance?: Maybe<User_Communications_Variance_Fields>;
};


/** aggregate fields of "user_communications" */
export type User_Communications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Communications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Communications_Append_Input = {
  parameters?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Communications_Avg_Fields = {
  __typename?: 'user_communications_avg_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_communications". All fields are combined with a logical 'AND'. */
export type User_Communications_Bool_Exp = {
  _and?: InputMaybe<Array<User_Communications_Bool_Exp>>;
  _not?: InputMaybe<User_Communications_Bool_Exp>;
  _or?: InputMaybe<Array<User_Communications_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  template_id?: InputMaybe<String_Comparison_Exp>;
  template_version?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_communication_deliveries?: InputMaybe<User_Communication_Deliveries_Bool_Exp>;
  user_communication_deliveries_aggregate?: InputMaybe<User_Communication_Deliveries_Aggregate_Bool_Exp>;
  user_communication_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_communications" */
export enum User_Communications_Constraint {
  /** unique or primary key constraint on columns "user_communication_id" */
  UserCommunicationsPkey = 'user_communications_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Communications_Delete_At_Path_Input = {
  parameters?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Communications_Delete_Elem_Input = {
  parameters?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Communications_Delete_Key_Input = {
  parameters?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_communications" */
export type User_Communications_Inc_Input = {
  template_version?: InputMaybe<Scalars['Int']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_communications" */
export type User_Communications_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  parameters?: InputMaybe<Scalars['jsonb']>;
  template_id?: InputMaybe<Scalars['String']>;
  template_version?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_communication_deliveries?: InputMaybe<User_Communication_Deliveries_Arr_Rel_Insert_Input>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Communications_Max_Fields = {
  __typename?: 'user_communications_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['String']>;
  template_version?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_communication_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Communications_Min_Fields = {
  __typename?: 'user_communications_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  template_id?: Maybe<Scalars['String']>;
  template_version?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_communication_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_communications" */
export type User_Communications_Mutation_Response = {
  __typename?: 'user_communications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Communications>;
};

/** input type for inserting object relation for remote table "user_communications" */
export type User_Communications_Obj_Rel_Insert_Input = {
  data: User_Communications_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Communications_On_Conflict>;
};

/** on_conflict condition type for table "user_communications" */
export type User_Communications_On_Conflict = {
  constraint: User_Communications_Constraint;
  update_columns?: Array<User_Communications_Update_Column>;
  where?: InputMaybe<User_Communications_Bool_Exp>;
};

/** Ordering options when selecting data from "user_communications". */
export type User_Communications_Order_By = {
  created_at?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  template_version?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_communication_deliveries_aggregate?: InputMaybe<User_Communication_Deliveries_Aggregate_Order_By>;
  user_communication_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_communications */
export type User_Communications_Pk_Columns_Input = {
  user_communication_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Communications_Prepend_Input = {
  parameters?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_communications" */
export enum User_Communications_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateVersion = 'template_version',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserCommunicationId = 'user_communication_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_communications" */
export type User_Communications_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  parameters?: InputMaybe<Scalars['jsonb']>;
  template_id?: InputMaybe<Scalars['String']>;
  template_version?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Communications_Stddev_Fields = {
  __typename?: 'user_communications_stddev_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Communications_Stddev_Pop_Fields = {
  __typename?: 'user_communications_stddev_pop_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Communications_Stddev_Samp_Fields = {
  __typename?: 'user_communications_stddev_samp_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_communications" */
export type User_Communications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Communications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Communications_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  parameters?: InputMaybe<Scalars['jsonb']>;
  template_id?: InputMaybe<Scalars['String']>;
  template_version?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_communication_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Communications_Sum_Fields = {
  __typename?: 'user_communications_sum_fields';
  template_version?: Maybe<Scalars['Int']>;
  user_communication_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_communications" */
export enum User_Communications_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  TemplateVersion = 'template_version',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserCommunicationId = 'user_communication_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Communications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Communications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Communications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Communications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Communications_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Communications_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Communications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Communications_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Communications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Communications_Var_Pop_Fields = {
  __typename?: 'user_communications_var_pop_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Communications_Var_Samp_Fields = {
  __typename?: 'user_communications_var_samp_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Communications_Variance_Fields = {
  __typename?: 'user_communications_variance_fields';
  template_version?: Maybe<Scalars['Float']>;
  user_communication_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "user_indicator_type". All fields are combined with logical 'AND'. */
export type User_Indicator_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_indicator_type']>;
  _gt?: InputMaybe<Scalars['user_indicator_type']>;
  _gte?: InputMaybe<Scalars['user_indicator_type']>;
  _in?: InputMaybe<Array<Scalars['user_indicator_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['user_indicator_type']>;
  _lte?: InputMaybe<Scalars['user_indicator_type']>;
  _neq?: InputMaybe<Scalars['user_indicator_type']>;
  _nin?: InputMaybe<Array<Scalars['user_indicator_type']>>;
};

/** columns and relationships of "user_indicators" */
export type User_Indicators = {
  __typename?: 'user_indicators';
  boolean_state: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  indicator_type: Scalars['user_indicator_type'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_indicators" */
export type User_Indicators_Aggregate = {
  __typename?: 'user_indicators_aggregate';
  aggregate?: Maybe<User_Indicators_Aggregate_Fields>;
  nodes: Array<User_Indicators>;
};

/** aggregate fields of "user_indicators" */
export type User_Indicators_Aggregate_Fields = {
  __typename?: 'user_indicators_aggregate_fields';
  avg?: Maybe<User_Indicators_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Indicators_Max_Fields>;
  min?: Maybe<User_Indicators_Min_Fields>;
  stddev?: Maybe<User_Indicators_Stddev_Fields>;
  stddev_pop?: Maybe<User_Indicators_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Indicators_Stddev_Samp_Fields>;
  sum?: Maybe<User_Indicators_Sum_Fields>;
  var_pop?: Maybe<User_Indicators_Var_Pop_Fields>;
  var_samp?: Maybe<User_Indicators_Var_Samp_Fields>;
  variance?: Maybe<User_Indicators_Variance_Fields>;
};


/** aggregate fields of "user_indicators" */
export type User_Indicators_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Indicators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Indicators_Avg_Fields = {
  __typename?: 'user_indicators_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_indicators". All fields are combined with a logical 'AND'. */
export type User_Indicators_Bool_Exp = {
  _and?: InputMaybe<Array<User_Indicators_Bool_Exp>>;
  _not?: InputMaybe<User_Indicators_Bool_Exp>;
  _or?: InputMaybe<Array<User_Indicators_Bool_Exp>>;
  boolean_state?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  indicator_type?: InputMaybe<User_Indicator_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_indicators" */
export enum User_Indicators_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserIndicatorsPkey = 'user_indicators_pkey',
  /** unique or primary key constraint on columns "user_id", "indicator_type" */
  UserIndicatorsUserIdIndicatorTypeKey = 'user_indicators_user_id_indicator_type_key'
}

/** input type for incrementing numeric columns in table "user_indicators" */
export type User_Indicators_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_indicators" */
export type User_Indicators_Insert_Input = {
  boolean_state?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  indicator_type?: InputMaybe<Scalars['user_indicator_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Indicators_Max_Fields = {
  __typename?: 'user_indicators_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  indicator_type?: Maybe<Scalars['user_indicator_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Indicators_Min_Fields = {
  __typename?: 'user_indicators_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  indicator_type?: Maybe<Scalars['user_indicator_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_indicators" */
export type User_Indicators_Mutation_Response = {
  __typename?: 'user_indicators_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Indicators>;
};

/** on_conflict condition type for table "user_indicators" */
export type User_Indicators_On_Conflict = {
  constraint: User_Indicators_Constraint;
  update_columns?: Array<User_Indicators_Update_Column>;
  where?: InputMaybe<User_Indicators_Bool_Exp>;
};

/** Ordering options when selecting data from "user_indicators". */
export type User_Indicators_Order_By = {
  boolean_state?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicator_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_indicators */
export type User_Indicators_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "user_indicators" */
export enum User_Indicators_Select_Column {
  /** column name */
  BooleanState = 'boolean_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndicatorType = 'indicator_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_indicators" */
export type User_Indicators_Set_Input = {
  boolean_state?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  indicator_type?: InputMaybe<Scalars['user_indicator_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Indicators_Stddev_Fields = {
  __typename?: 'user_indicators_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Indicators_Stddev_Pop_Fields = {
  __typename?: 'user_indicators_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Indicators_Stddev_Samp_Fields = {
  __typename?: 'user_indicators_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_indicators" */
export type User_Indicators_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Indicators_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Indicators_Stream_Cursor_Value_Input = {
  boolean_state?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  indicator_type?: InputMaybe<Scalars['user_indicator_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Indicators_Sum_Fields = {
  __typename?: 'user_indicators_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_indicators" */
export enum User_Indicators_Update_Column {
  /** column name */
  BooleanState = 'boolean_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndicatorType = 'indicator_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Indicators_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Indicators_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Indicators_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Indicators_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Indicators_Var_Pop_Fields = {
  __typename?: 'user_indicators_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Indicators_Var_Samp_Fields = {
  __typename?: 'user_indicators_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Indicators_Variance_Fields = {
  __typename?: 'user_indicators_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Enum table for status of user_notifications table */
export type User_Notification_Status = {
  __typename?: 'user_notification_status';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "user_notification_status" */
export type User_Notification_Status_Aggregate = {
  __typename?: 'user_notification_status_aggregate';
  aggregate?: Maybe<User_Notification_Status_Aggregate_Fields>;
  nodes: Array<User_Notification_Status>;
};

/** aggregate fields of "user_notification_status" */
export type User_Notification_Status_Aggregate_Fields = {
  __typename?: 'user_notification_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Notification_Status_Max_Fields>;
  min?: Maybe<User_Notification_Status_Min_Fields>;
};


/** aggregate fields of "user_notification_status" */
export type User_Notification_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Notification_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_notification_status". All fields are combined with a logical 'AND'. */
export type User_Notification_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Notification_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Notification_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Notification_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_notification_status" */
export enum User_Notification_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserNotificationStatusPkey = 'user_notification_status_pkey'
}

export enum User_Notification_Status_Enum {
  Delivered = 'DELIVERED',
  Read = 'READ',
  Seen = 'SEEN'
}

/** Boolean expression to compare columns of type "user_notification_status_enum". All fields are combined with logical 'AND'. */
export type User_Notification_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Notification_Status_Enum>;
  _in?: InputMaybe<Array<User_Notification_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Notification_Status_Enum>;
  _nin?: InputMaybe<Array<User_Notification_Status_Enum>>;
};

/** input type for inserting data into table "user_notification_status" */
export type User_Notification_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Notification_Status_Max_Fields = {
  __typename?: 'user_notification_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Notification_Status_Min_Fields = {
  __typename?: 'user_notification_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_notification_status" */
export type User_Notification_Status_Mutation_Response = {
  __typename?: 'user_notification_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Notification_Status>;
};

/** on_conflict condition type for table "user_notification_status" */
export type User_Notification_Status_On_Conflict = {
  constraint: User_Notification_Status_Constraint;
  update_columns?: Array<User_Notification_Status_Update_Column>;
  where?: InputMaybe<User_Notification_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_notification_status". */
export type User_Notification_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_notification_status */
export type User_Notification_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_notification_status" */
export enum User_Notification_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_notification_status" */
export type User_Notification_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_notification_status" */
export type User_Notification_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Notification_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Notification_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_notification_status" */
export enum User_Notification_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type User_Notification_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Notification_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Notification_Status_Bool_Exp;
};

/** columns and relationships of "user_notifications" */
export type User_Notifications = {
  __typename?: 'user_notifications';
  activity_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  data?: Maybe<Scalars['jsonb']>;
  has_priority: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_admin_notification?: Maybe<Scalars['Boolean']>;
  is_important_update?: Maybe<Scalars['Boolean']>;
  is_latest_activity: Scalars['Boolean'];
  is_modal: Scalars['Boolean'];
  is_toast?: Maybe<Scalars['Boolean']>;
  notification_type?: Maybe<Scalars['Int']>;
  status: User_Notification_Status_Enum;
  sub_account?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: Users;
  user_communication_delivery_id: Scalars['bigint'];
  user_id: Scalars['uuid'];
};


/** columns and relationships of "user_notifications" */
export type User_NotificationsDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_notifications" */
export type User_Notifications_Aggregate = {
  __typename?: 'user_notifications_aggregate';
  aggregate?: Maybe<User_Notifications_Aggregate_Fields>;
  nodes: Array<User_Notifications>;
};

/** aggregate fields of "user_notifications" */
export type User_Notifications_Aggregate_Fields = {
  __typename?: 'user_notifications_aggregate_fields';
  avg?: Maybe<User_Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Notifications_Max_Fields>;
  min?: Maybe<User_Notifications_Min_Fields>;
  stddev?: Maybe<User_Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<User_Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<User_Notifications_Sum_Fields>;
  var_pop?: Maybe<User_Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<User_Notifications_Var_Samp_Fields>;
  variance?: Maybe<User_Notifications_Variance_Fields>;
};


/** aggregate fields of "user_notifications" */
export type User_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Notifications_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Notifications_Avg_Fields = {
  __typename?: 'user_notifications_avg_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_notifications". All fields are combined with a logical 'AND'. */
export type User_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<User_Notifications_Bool_Exp>>;
  _not?: InputMaybe<User_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<User_Notifications_Bool_Exp>>;
  activity_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  has_priority?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_admin_notification?: InputMaybe<Boolean_Comparison_Exp>;
  is_important_update?: InputMaybe<Boolean_Comparison_Exp>;
  is_latest_activity?: InputMaybe<Boolean_Comparison_Exp>;
  is_modal?: InputMaybe<Boolean_Comparison_Exp>;
  is_toast?: InputMaybe<Boolean_Comparison_Exp>;
  notification_type?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<User_Notification_Status_Enum_Comparison_Exp>;
  sub_account?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_communication_delivery_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_notifications" */
export enum User_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserNotificationsIdKey = 'user_notifications_id_key',
  /** unique or primary key constraint on columns "user_communication_delivery_id" */
  UserNotificationsPkey = 'user_notifications_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Notifications_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Notifications_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Notifications_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_notifications" */
export type User_Notifications_Inc_Input = {
  notification_type?: InputMaybe<Scalars['Int']>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_notifications" */
export type User_Notifications_Insert_Input = {
  activity_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  has_priority?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_admin_notification?: InputMaybe<Scalars['Boolean']>;
  is_important_update?: InputMaybe<Scalars['Boolean']>;
  is_latest_activity?: InputMaybe<Scalars['Boolean']>;
  is_modal?: InputMaybe<Scalars['Boolean']>;
  is_toast?: InputMaybe<Scalars['Boolean']>;
  notification_type?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<User_Notification_Status_Enum>;
  sub_account?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Notifications_Max_Fields = {
  __typename?: 'user_notifications_max_fields';
  activity_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Scalars['Int']>;
  sub_account?: Maybe<Scalars['uuid']>;
  user_communication_delivery_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Notifications_Min_Fields = {
  __typename?: 'user_notifications_min_fields';
  activity_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Scalars['Int']>;
  sub_account?: Maybe<Scalars['uuid']>;
  user_communication_delivery_id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_notifications" */
export type User_Notifications_Mutation_Response = {
  __typename?: 'user_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Notifications>;
};

/** input type for inserting object relation for remote table "user_notifications" */
export type User_Notifications_Obj_Rel_Insert_Input = {
  data: User_Notifications_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Notifications_On_Conflict>;
};

/** on_conflict condition type for table "user_notifications" */
export type User_Notifications_On_Conflict = {
  constraint: User_Notifications_Constraint;
  update_columns?: Array<User_Notifications_Update_Column>;
  where?: InputMaybe<User_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "user_notifications". */
export type User_Notifications_Order_By = {
  activity_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  has_priority?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_admin_notification?: InputMaybe<Order_By>;
  is_important_update?: InputMaybe<Order_By>;
  is_latest_activity?: InputMaybe<Order_By>;
  is_modal?: InputMaybe<Order_By>;
  is_toast?: InputMaybe<Order_By>;
  notification_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_account?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_communication_delivery_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_notifications */
export type User_Notifications_Pk_Columns_Input = {
  user_communication_delivery_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Notifications_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_notifications" */
export enum User_Notifications_Select_Column {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  HasPriority = 'has_priority',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdminNotification = 'is_admin_notification',
  /** column name */
  IsImportantUpdate = 'is_important_update',
  /** column name */
  IsLatestActivity = 'is_latest_activity',
  /** column name */
  IsModal = 'is_modal',
  /** column name */
  IsToast = 'is_toast',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  Status = 'status',
  /** column name */
  SubAccount = 'sub_account',
  /** column name */
  UserCommunicationDeliveryId = 'user_communication_delivery_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_notifications" */
export type User_Notifications_Set_Input = {
  activity_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  has_priority?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_admin_notification?: InputMaybe<Scalars['Boolean']>;
  is_important_update?: InputMaybe<Scalars['Boolean']>;
  is_latest_activity?: InputMaybe<Scalars['Boolean']>;
  is_modal?: InputMaybe<Scalars['Boolean']>;
  is_toast?: InputMaybe<Scalars['Boolean']>;
  notification_type?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<User_Notification_Status_Enum>;
  sub_account?: InputMaybe<Scalars['uuid']>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Notifications_Stddev_Fields = {
  __typename?: 'user_notifications_stddev_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Notifications_Stddev_Pop_Fields = {
  __typename?: 'user_notifications_stddev_pop_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Notifications_Stddev_Samp_Fields = {
  __typename?: 'user_notifications_stddev_samp_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_notifications" */
export type User_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Notifications_Stream_Cursor_Value_Input = {
  activity_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  has_priority?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_admin_notification?: InputMaybe<Scalars['Boolean']>;
  is_important_update?: InputMaybe<Scalars['Boolean']>;
  is_latest_activity?: InputMaybe<Scalars['Boolean']>;
  is_modal?: InputMaybe<Scalars['Boolean']>;
  is_toast?: InputMaybe<Scalars['Boolean']>;
  notification_type?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<User_Notification_Status_Enum>;
  sub_account?: InputMaybe<Scalars['uuid']>;
  user_communication_delivery_id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Notifications_Sum_Fields = {
  __typename?: 'user_notifications_sum_fields';
  notification_type?: Maybe<Scalars['Int']>;
  user_communication_delivery_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_notifications" */
export enum User_Notifications_Update_Column {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  HasPriority = 'has_priority',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdminNotification = 'is_admin_notification',
  /** column name */
  IsImportantUpdate = 'is_important_update',
  /** column name */
  IsLatestActivity = 'is_latest_activity',
  /** column name */
  IsModal = 'is_modal',
  /** column name */
  IsToast = 'is_toast',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  Status = 'status',
  /** column name */
  SubAccount = 'sub_account',
  /** column name */
  UserCommunicationDeliveryId = 'user_communication_delivery_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Notifications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Notifications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Notifications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Notifications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Notifications_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Notifications_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Notifications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Notifications_Var_Pop_Fields = {
  __typename?: 'user_notifications_var_pop_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Notifications_Var_Samp_Fields = {
  __typename?: 'user_notifications_var_samp_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Notifications_Variance_Fields = {
  __typename?: 'user_notifications_variance_fields';
  notification_type?: Maybe<Scalars['Float']>;
  user_communication_delivery_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_push_tokens" */
export type User_Push_Tokens = {
  __typename?: 'user_push_tokens';
  created_at: Scalars['timestamptz'];
  device_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  platform: Scalars['String'];
  token: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_push_tokens" */
export type User_Push_Tokens_Aggregate = {
  __typename?: 'user_push_tokens_aggregate';
  aggregate?: Maybe<User_Push_Tokens_Aggregate_Fields>;
  nodes: Array<User_Push_Tokens>;
};

export type User_Push_Tokens_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Push_Tokens_Aggregate_Bool_Exp_Count>;
};

export type User_Push_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Push_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_push_tokens" */
export type User_Push_Tokens_Aggregate_Fields = {
  __typename?: 'user_push_tokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Push_Tokens_Max_Fields>;
  min?: Maybe<User_Push_Tokens_Min_Fields>;
};


/** aggregate fields of "user_push_tokens" */
export type User_Push_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_push_tokens" */
export type User_Push_Tokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Push_Tokens_Max_Order_By>;
  min?: InputMaybe<User_Push_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_push_tokens" */
export type User_Push_Tokens_Arr_Rel_Insert_Input = {
  data: Array<User_Push_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Push_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_push_tokens". All fields are combined with a logical 'AND'. */
export type User_Push_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<User_Push_Tokens_Bool_Exp>>;
  _not?: InputMaybe<User_Push_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<User_Push_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_push_tokens" */
export enum User_Push_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPushTokensPkey = 'user_push_tokens_pkey',
  /** unique or primary key constraint on columns "token" */
  UserPushTokensTokenKey = 'user_push_tokens_token_key'
}

/** input type for inserting data into table "user_push_tokens" */
export type User_Push_Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Push_Tokens_Max_Fields = {
  __typename?: 'user_push_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_push_tokens" */
export type User_Push_Tokens_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Push_Tokens_Min_Fields = {
  __typename?: 'user_push_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_push_tokens" */
export type User_Push_Tokens_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_push_tokens" */
export type User_Push_Tokens_Mutation_Response = {
  __typename?: 'user_push_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Push_Tokens>;
};

/** on_conflict condition type for table "user_push_tokens" */
export type User_Push_Tokens_On_Conflict = {
  constraint: User_Push_Tokens_Constraint;
  update_columns?: Array<User_Push_Tokens_Update_Column>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "user_push_tokens". */
export type User_Push_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_push_tokens */
export type User_Push_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_push_tokens" */
export enum User_Push_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_push_tokens" */
export type User_Push_Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_push_tokens" */
export type User_Push_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Push_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Push_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_push_tokens" */
export enum User_Push_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Push_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Push_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Push_Tokens_Bool_Exp;
};

/** Data scanned by the user with his mobile phone */
export type User_Scanned_Data = {
  __typename?: 'user_scanned_data';
  scan_completed?: Maybe<Scalars['Boolean']>;
  skip_tracking_number?: Maybe<Scalars['Boolean']>;
  swab_barcode?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_scanned_data" */
export type User_Scanned_Data_Aggregate = {
  __typename?: 'user_scanned_data_aggregate';
  aggregate?: Maybe<User_Scanned_Data_Aggregate_Fields>;
  nodes: Array<User_Scanned_Data>;
};

/** aggregate fields of "user_scanned_data" */
export type User_Scanned_Data_Aggregate_Fields = {
  __typename?: 'user_scanned_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Scanned_Data_Max_Fields>;
  min?: Maybe<User_Scanned_Data_Min_Fields>;
};


/** aggregate fields of "user_scanned_data" */
export type User_Scanned_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Scanned_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_scanned_data". All fields are combined with a logical 'AND'. */
export type User_Scanned_Data_Bool_Exp = {
  _and?: InputMaybe<Array<User_Scanned_Data_Bool_Exp>>;
  _not?: InputMaybe<User_Scanned_Data_Bool_Exp>;
  _or?: InputMaybe<Array<User_Scanned_Data_Bool_Exp>>;
  scan_completed?: InputMaybe<Boolean_Comparison_Exp>;
  skip_tracking_number?: InputMaybe<Boolean_Comparison_Exp>;
  swab_barcode?: InputMaybe<String_Comparison_Exp>;
  test_type?: InputMaybe<String_Comparison_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_scanned_data" */
export enum User_Scanned_Data_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserScannedDataPkey = 'user_scanned_data_pkey'
}

/** input type for inserting data into table "user_scanned_data" */
export type User_Scanned_Data_Insert_Input = {
  scan_completed?: InputMaybe<Scalars['Boolean']>;
  skip_tracking_number?: InputMaybe<Scalars['Boolean']>;
  swab_barcode?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Scalars['String']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Scanned_Data_Max_Fields = {
  __typename?: 'user_scanned_data_max_fields';
  swab_barcode?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Scanned_Data_Min_Fields = {
  __typename?: 'user_scanned_data_min_fields';
  swab_barcode?: Maybe<Scalars['String']>;
  test_type?: Maybe<Scalars['String']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_scanned_data" */
export type User_Scanned_Data_Mutation_Response = {
  __typename?: 'user_scanned_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Scanned_Data>;
};

/** on_conflict condition type for table "user_scanned_data" */
export type User_Scanned_Data_On_Conflict = {
  constraint: User_Scanned_Data_Constraint;
  update_columns?: Array<User_Scanned_Data_Update_Column>;
  where?: InputMaybe<User_Scanned_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "user_scanned_data". */
export type User_Scanned_Data_Order_By = {
  scan_completed?: InputMaybe<Order_By>;
  skip_tracking_number?: InputMaybe<Order_By>;
  swab_barcode?: InputMaybe<Order_By>;
  test_type?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_scanned_data */
export type User_Scanned_Data_Pk_Columns_Input = {
  user_id: Scalars['uuid'];
};

/** select columns of table "user_scanned_data" */
export enum User_Scanned_Data_Select_Column {
  /** column name */
  ScanCompleted = 'scan_completed',
  /** column name */
  SkipTrackingNumber = 'skip_tracking_number',
  /** column name */
  SwabBarcode = 'swab_barcode',
  /** column name */
  TestType = 'test_type',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_scanned_data" */
export type User_Scanned_Data_Set_Input = {
  scan_completed?: InputMaybe<Scalars['Boolean']>;
  skip_tracking_number?: InputMaybe<Scalars['Boolean']>;
  swab_barcode?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Scalars['String']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_scanned_data" */
export type User_Scanned_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Scanned_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Scanned_Data_Stream_Cursor_Value_Input = {
  scan_completed?: InputMaybe<Scalars['Boolean']>;
  skip_tracking_number?: InputMaybe<Scalars['Boolean']>;
  swab_barcode?: InputMaybe<Scalars['String']>;
  test_type?: InputMaybe<Scalars['String']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_scanned_data" */
export enum User_Scanned_Data_Update_Column {
  /** column name */
  ScanCompleted = 'scan_completed',
  /** column name */
  SkipTrackingNumber = 'skip_tracking_number',
  /** column name */
  SwabBarcode = 'swab_barcode',
  /** column name */
  TestType = 'test_type',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Scanned_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Scanned_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Scanned_Data_Bool_Exp;
};

/** columns and relationships of "user_settings" */
export type User_Settings = {
  __typename?: 'user_settings';
  account_settings?: Maybe<Scalars['jsonb']>;
  alert_settings?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  high_contrast_mode: Scalars['Boolean'];
  id: Scalars['uuid'];
  mobile_call_settings?: Maybe<Scalars['jsonb']>;
  notification_preferences?: Maybe<Scalars['jsonb']>;
  skin_treatment_banner_dismissed_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
  web_call_settings?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsAccount_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsAlert_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsMobile_Call_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsNotification_PreferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user_settings" */
export type User_SettingsWeb_Call_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_settings" */
export type User_Settings_Aggregate = {
  __typename?: 'user_settings_aggregate';
  aggregate?: Maybe<User_Settings_Aggregate_Fields>;
  nodes: Array<User_Settings>;
};

/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_Fields = {
  __typename?: 'user_settings_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Settings_Max_Fields>;
  min?: Maybe<User_Settings_Min_Fields>;
};


/** aggregate fields of "user_settings" */
export type User_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Settings_Append_Input = {
  account_settings?: InputMaybe<Scalars['jsonb']>;
  alert_settings?: InputMaybe<Scalars['jsonb']>;
  mobile_call_settings?: InputMaybe<Scalars['jsonb']>;
  notification_preferences?: InputMaybe<Scalars['jsonb']>;
  web_call_settings?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "user_settings". All fields are combined with a logical 'AND'. */
export type User_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  _not?: InputMaybe<User_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<User_Settings_Bool_Exp>>;
  account_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  alert_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  high_contrast_mode?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mobile_call_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  notification_preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  skin_treatment_banner_dismissed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  web_call_settings?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_settings" */
export enum User_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSettingsPkey = 'user_settings_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserSettingsUserIdKey = 'user_settings_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Settings_Delete_At_Path_Input = {
  account_settings?: InputMaybe<Array<Scalars['String']>>;
  alert_settings?: InputMaybe<Array<Scalars['String']>>;
  mobile_call_settings?: InputMaybe<Array<Scalars['String']>>;
  notification_preferences?: InputMaybe<Array<Scalars['String']>>;
  web_call_settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Settings_Delete_Elem_Input = {
  account_settings?: InputMaybe<Scalars['Int']>;
  alert_settings?: InputMaybe<Scalars['Int']>;
  mobile_call_settings?: InputMaybe<Scalars['Int']>;
  notification_preferences?: InputMaybe<Scalars['Int']>;
  web_call_settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Settings_Delete_Key_Input = {
  account_settings?: InputMaybe<Scalars['String']>;
  alert_settings?: InputMaybe<Scalars['String']>;
  mobile_call_settings?: InputMaybe<Scalars['String']>;
  notification_preferences?: InputMaybe<Scalars['String']>;
  web_call_settings?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "user_settings" */
export type User_Settings_Insert_Input = {
  account_settings?: InputMaybe<Scalars['jsonb']>;
  alert_settings?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_contrast_mode?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mobile_call_settings?: InputMaybe<Scalars['jsonb']>;
  notification_preferences?: InputMaybe<Scalars['jsonb']>;
  skin_treatment_banner_dismissed_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
  web_call_settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type User_Settings_Max_Fields = {
  __typename?: 'user_settings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  skin_treatment_banner_dismissed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Settings_Min_Fields = {
  __typename?: 'user_settings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  skin_treatment_banner_dismissed_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_settings" */
export type User_Settings_Mutation_Response = {
  __typename?: 'user_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Settings>;
};

/** input type for inserting object relation for remote table "user_settings" */
export type User_Settings_Obj_Rel_Insert_Input = {
  data: User_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Settings_On_Conflict>;
};

/** on_conflict condition type for table "user_settings" */
export type User_Settings_On_Conflict = {
  constraint: User_Settings_Constraint;
  update_columns?: Array<User_Settings_Update_Column>;
  where?: InputMaybe<User_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "user_settings". */
export type User_Settings_Order_By = {
  account_settings?: InputMaybe<Order_By>;
  alert_settings?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  high_contrast_mode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile_call_settings?: InputMaybe<Order_By>;
  notification_preferences?: InputMaybe<Order_By>;
  skin_treatment_banner_dismissed_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  web_call_settings?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_settings */
export type User_Settings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Settings_Prepend_Input = {
  account_settings?: InputMaybe<Scalars['jsonb']>;
  alert_settings?: InputMaybe<Scalars['jsonb']>;
  mobile_call_settings?: InputMaybe<Scalars['jsonb']>;
  notification_preferences?: InputMaybe<Scalars['jsonb']>;
  web_call_settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_settings" */
export enum User_Settings_Select_Column {
  /** column name */
  AccountSettings = 'account_settings',
  /** column name */
  AlertSettings = 'alert_settings',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighContrastMode = 'high_contrast_mode',
  /** column name */
  Id = 'id',
  /** column name */
  MobileCallSettings = 'mobile_call_settings',
  /** column name */
  NotificationPreferences = 'notification_preferences',
  /** column name */
  SkinTreatmentBannerDismissedAt = 'skin_treatment_banner_dismissed_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WebCallSettings = 'web_call_settings'
}

/** input type for updating data in table "user_settings" */
export type User_Settings_Set_Input = {
  account_settings?: InputMaybe<Scalars['jsonb']>;
  alert_settings?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_contrast_mode?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mobile_call_settings?: InputMaybe<Scalars['jsonb']>;
  notification_preferences?: InputMaybe<Scalars['jsonb']>;
  skin_treatment_banner_dismissed_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  web_call_settings?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "user_settings" */
export type User_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Settings_Stream_Cursor_Value_Input = {
  account_settings?: InputMaybe<Scalars['jsonb']>;
  alert_settings?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  high_contrast_mode?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mobile_call_settings?: InputMaybe<Scalars['jsonb']>;
  notification_preferences?: InputMaybe<Scalars['jsonb']>;
  skin_treatment_banner_dismissed_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  web_call_settings?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "user_settings" */
export enum User_Settings_Update_Column {
  /** column name */
  AccountSettings = 'account_settings',
  /** column name */
  AlertSettings = 'alert_settings',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HighContrastMode = 'high_contrast_mode',
  /** column name */
  Id = 'id',
  /** column name */
  MobileCallSettings = 'mobile_call_settings',
  /** column name */
  NotificationPreferences = 'notification_preferences',
  /** column name */
  SkinTreatmentBannerDismissedAt = 'skin_treatment_banner_dismissed_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WebCallSettings = 'web_call_settings'
}

export type User_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Settings_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING: Scalars['Boolean'];
  AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING: Scalars['Boolean'];
  EMAIL_MONTHLY_NEWSLETTER: Scalars['Boolean'];
  EMAIL_NEW_FEATURES_SERVICES_SETTINGS: Scalars['Boolean'];
  EMAIL_SPECIAL_OFFERS_SETTING: Scalars['Boolean'];
  EMAIL_SPECIAL_OFFER_FRIENDS_SETTING: Scalars['Boolean'];
  EMAIL_UNSUBSCRIBED: Scalars['Boolean'];
  PRIVACY_AFFILIATES_CODEX_LABS_SETTING: Scalars['Boolean'];
  PRIVACY_CALIFORNIA_SETTINGS: Scalars['Boolean'];
  PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING: Scalars['Boolean'];
  SENSITIVE_address_information?: Maybe<Scalars['jsonb']>;
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['date']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_etnicity?: Maybe<Scalars['jsonb']>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['uuid']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  SENSITIVE_user_measurements?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  accepted_legal_documents: Array<Accepted_Legal_Documents>;
  /** An aggregate relationship */
  accepted_legal_documents_aggregate: Accepted_Legal_Documents_Aggregate;
  account_closed_at?: Maybe<Scalars['timestamptz']>;
  account_closure_reason?: Maybe<Scalars['String']>;
  /** An array relationship */
  active_in_mails: Array<Active_In_Mails>;
  /** An aggregate relationship */
  active_in_mails_aggregate: Active_In_Mails_Aggregate;
  /** An array relationship */
  active_support_chats: Array<Active_Support_Chats>;
  /** An aggregate relationship */
  active_support_chats_aggregate: Active_Support_Chats_Aggregate;
  /** An array relationship */
  admin_permissions: Array<Admin_Permissions>;
  /** An aggregate relationship */
  admin_permissions_aggregate: Admin_Permissions_Aggregate;
  /** An array relationship */
  appointments: Array<Appointments>;
  /** An aggregate relationship */
  appointments_aggregate: Appointments_Aggregate;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  data_retention_until?: Maybe<Scalars['timestamptz']>;
  deleted_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  deleted_by_user?: Maybe<Users>;
  hide_contact_info: Scalars['Boolean'];
  hide_office_address: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  in_mail_usage: Array<In_Mail_Usage>;
  /** An aggregate relationship */
  in_mail_usage_aggregate: In_Mail_Usage_Aggregate;
  insurance_verify_later?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  invitations: Array<Invitations>;
  /** An aggregate relationship */
  invitations_aggregate: Invitations_Aggregate;
  is_active?: Maybe<Scalars['Boolean']>;
  is_admin: Scalars['Boolean'];
  kyc_child_status?: Maybe<Persona_Inquiry_Status_Enum>;
  kyc_current_status?: Maybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_status?: Maybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_update_date?: Maybe<Scalars['timestamptz']>;
  kyc_retries_count: Scalars['Int'];
  kyc_update_date?: Maybe<Scalars['timestamptz']>;
  last_login_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  legal_document_update_notifications: Array<Legal_Document_Update_Notifications>;
  /** An aggregate relationship */
  legal_document_update_notifications_aggregate: Legal_Document_Update_Notifications_Aggregate;
  /** An array relationship */
  pending_patient_zrts: Array<Pending_Patient_Zrt>;
  /** An aggregate relationship */
  pending_patient_zrts_aggregate: Pending_Patient_Zrt_Aggregate;
  provider_balance?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  provider_dea_licenses: Array<Provider_Dea_Licenses>;
  /** An aggregate relationship */
  provider_dea_licenses_aggregate: Provider_Dea_Licenses_Aggregate;
  /** An array relationship */
  provider_state_licenses: Array<Provider_State_Licenses>;
  /** An aggregate relationship */
  provider_state_licenses_aggregate: Provider_State_Licenses_Aggregate;
  /** An object relationship */
  related_user?: Maybe<Users>;
  related_user_id?: Maybe<Scalars['uuid']>;
  role: Scalars['smallint'];
  stripe_account_id?: Maybe<Scalars['String']>;
  stripe_connected_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  stripe_customers: Array<Stripe_Customers>;
  /** An aggregate relationship */
  stripe_customers_aggregate: Stripe_Customers_Aggregate;
  stripe_payouts_ready_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  support_chat_usage: Array<Support_Chat_Usage>;
  /** An aggregate relationship */
  support_chat_usage_aggregate: Support_Chat_Usage_Aggregate;
  timezone?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_agreements: Array<User_Agreements>;
  /** An aggregate relationship */
  user_agreements_aggregate: User_Agreements_Aggregate;
  /** An array relationship */
  user_push_tokens: Array<User_Push_Tokens>;
  /** An aggregate relationship */
  user_push_tokens_aggregate: User_Push_Tokens_Aggregate;
  /** An object relationship */
  user_settings?: Maybe<User_Settings>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "users" */
export type UsersSensitive_Address_InformationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersSensitive_EtnicityArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersSensitive_User_MeasurementsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAccepted_Legal_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accepted_Legal_Documents_Order_By>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAccepted_Legal_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accepted_Legal_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accepted_Legal_Documents_Order_By>>;
  where?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersActive_In_MailsArgs = {
  distinct_on?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_In_Mails_Order_By>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersActive_In_Mails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_In_Mails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_In_Mails_Order_By>>;
  where?: InputMaybe<Active_In_Mails_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersActive_Support_ChatsArgs = {
  distinct_on?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Support_Chats_Order_By>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersActive_Support_Chats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Active_Support_Chats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Active_Support_Chats_Order_By>>;
  where?: InputMaybe<Active_Support_Chats_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAdmin_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Admin_Permissions_Order_By>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAdmin_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Admin_Permissions_Order_By>>;
  where?: InputMaybe<Admin_Permissions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAppointmentsArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAppointments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appointments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appointments_Order_By>>;
  where?: InputMaybe<Appointments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersIn_Mail_UsageArgs = {
  distinct_on?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<In_Mail_Usage_Order_By>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersIn_Mail_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Mail_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<In_Mail_Usage_Order_By>>;
  where?: InputMaybe<In_Mail_Usage_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLegal_Document_Update_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Update_Notifications_Order_By>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLegal_Document_Update_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Document_Update_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Document_Update_Notifications_Order_By>>;
  where?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPending_Patient_ZrtsArgs = {
  distinct_on?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pending_Patient_Zrt_Order_By>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPending_Patient_Zrts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pending_Patient_Zrt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pending_Patient_Zrt_Order_By>>;
  where?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProvider_Dea_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Dea_Licenses_Order_By>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProvider_Dea_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_Dea_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_Dea_Licenses_Order_By>>;
  where?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProvider_State_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_State_Licenses_Order_By>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProvider_State_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Provider_State_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Provider_State_Licenses_Order_By>>;
  where?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStripe_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customers_Order_By>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStripe_Customers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stripe_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stripe_Customers_Order_By>>;
  where?: InputMaybe<Stripe_Customers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSupport_Chat_UsageArgs = {
  distinct_on?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Support_Chat_Usage_Order_By>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSupport_Chat_Usage_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Chat_Usage_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Support_Chat_Usage_Order_By>>;
  where?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_AgreementsArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Agreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Agreements_Order_By>>;
  where?: InputMaybe<User_Agreements_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Push_TokensArgs = {
  distinct_on?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Push_Tokens_Order_By>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Push_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Push_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Push_Tokens_Order_By>>;
  where?: InputMaybe<User_Push_Tokens_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING?: InputMaybe<Boolean_Comparison_Exp>;
  AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING?: InputMaybe<Boolean_Comparison_Exp>;
  EMAIL_MONTHLY_NEWSLETTER?: InputMaybe<Boolean_Comparison_Exp>;
  EMAIL_NEW_FEATURES_SERVICES_SETTINGS?: InputMaybe<Boolean_Comparison_Exp>;
  EMAIL_SPECIAL_OFFERS_SETTING?: InputMaybe<Boolean_Comparison_Exp>;
  EMAIL_SPECIAL_OFFER_FRIENDS_SETTING?: InputMaybe<Boolean_Comparison_Exp>;
  EMAIL_UNSUBSCRIBED?: InputMaybe<Boolean_Comparison_Exp>;
  PRIVACY_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Boolean_Comparison_Exp>;
  PRIVACY_CALIFORNIA_SETTINGS?: InputMaybe<Boolean_Comparison_Exp>;
  PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Boolean_Comparison_Exp>;
  SENSITIVE_address_information?: InputMaybe<Jsonb_Comparison_Exp>;
  SENSITIVE_country?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_dob?: InputMaybe<Date_Comparison_Exp>;
  SENSITIVE_email?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_etnicity?: InputMaybe<Jsonb_Comparison_Exp>;
  SENSITIVE_firstname?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_gender?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_gender_describe?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_lastname?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_phone?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_profile_picture_id?: InputMaybe<Uuid_Comparison_Exp>;
  SENSITIVE_self_identity_gender?: InputMaybe<String_Comparison_Exp>;
  SENSITIVE_user_measurements?: InputMaybe<Jsonb_Comparison_Exp>;
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  accepted_legal_documents?: InputMaybe<Accepted_Legal_Documents_Bool_Exp>;
  accepted_legal_documents_aggregate?: InputMaybe<Accepted_Legal_Documents_Aggregate_Bool_Exp>;
  account_closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_closure_reason?: InputMaybe<String_Comparison_Exp>;
  active_in_mails?: InputMaybe<Active_In_Mails_Bool_Exp>;
  active_in_mails_aggregate?: InputMaybe<Active_In_Mails_Aggregate_Bool_Exp>;
  active_support_chats?: InputMaybe<Active_Support_Chats_Bool_Exp>;
  active_support_chats_aggregate?: InputMaybe<Active_Support_Chats_Aggregate_Bool_Exp>;
  admin_permissions?: InputMaybe<Admin_Permissions_Bool_Exp>;
  admin_permissions_aggregate?: InputMaybe<Admin_Permissions_Aggregate_Bool_Exp>;
  appointments?: InputMaybe<Appointments_Bool_Exp>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Bool_Exp>;
  blocked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_retention_until?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_by_user?: InputMaybe<Users_Bool_Exp>;
  hide_contact_info?: InputMaybe<Boolean_Comparison_Exp>;
  hide_office_address?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_mail_usage?: InputMaybe<In_Mail_Usage_Bool_Exp>;
  in_mail_usage_aggregate?: InputMaybe<In_Mail_Usage_Aggregate_Bool_Exp>;
  insurance_verify_later?: InputMaybe<Boolean_Comparison_Exp>;
  invitations?: InputMaybe<Invitations_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitations_Aggregate_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_admin?: InputMaybe<Boolean_Comparison_Exp>;
  kyc_child_status?: InputMaybe<Persona_Inquiry_Status_Enum_Comparison_Exp>;
  kyc_current_status?: InputMaybe<Persona_Inquiry_Status_Enum_Comparison_Exp>;
  kyc_insurance_status?: InputMaybe<Persona_Inquiry_Status_Enum_Comparison_Exp>;
  kyc_insurance_update_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  kyc_retries_count?: InputMaybe<Int_Comparison_Exp>;
  kyc_update_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_login_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  legal_document_update_notifications?: InputMaybe<Legal_Document_Update_Notifications_Bool_Exp>;
  legal_document_update_notifications_aggregate?: InputMaybe<Legal_Document_Update_Notifications_Aggregate_Bool_Exp>;
  pending_patient_zrts?: InputMaybe<Pending_Patient_Zrt_Bool_Exp>;
  pending_patient_zrts_aggregate?: InputMaybe<Pending_Patient_Zrt_Aggregate_Bool_Exp>;
  provider_balance?: InputMaybe<Numeric_Comparison_Exp>;
  provider_dea_licenses?: InputMaybe<Provider_Dea_Licenses_Bool_Exp>;
  provider_dea_licenses_aggregate?: InputMaybe<Provider_Dea_Licenses_Aggregate_Bool_Exp>;
  provider_state_licenses?: InputMaybe<Provider_State_Licenses_Bool_Exp>;
  provider_state_licenses_aggregate?: InputMaybe<Provider_State_Licenses_Aggregate_Bool_Exp>;
  related_user?: InputMaybe<Users_Bool_Exp>;
  related_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Smallint_Comparison_Exp>;
  stripe_account_id?: InputMaybe<String_Comparison_Exp>;
  stripe_connected_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  stripe_customers?: InputMaybe<Stripe_Customers_Bool_Exp>;
  stripe_customers_aggregate?: InputMaybe<Stripe_Customers_Aggregate_Bool_Exp>;
  stripe_payouts_ready_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  support_chat_usage?: InputMaybe<Support_Chat_Usage_Bool_Exp>;
  support_chat_usage_aggregate?: InputMaybe<Support_Chat_Usage_Aggregate_Bool_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_agreements?: InputMaybe<User_Agreements_Bool_Exp>;
  user_agreements_aggregate?: InputMaybe<User_Agreements_Aggregate_Bool_Exp>;
  user_push_tokens?: InputMaybe<User_Push_Tokens_Bool_Exp>;
  user_push_tokens_aggregate?: InputMaybe<User_Push_Tokens_Aggregate_Bool_Exp>;
  user_settings?: InputMaybe<User_Settings_Bool_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  SENSITIVE_address_information?: InputMaybe<Array<Scalars['String']>>;
  SENSITIVE_etnicity?: InputMaybe<Array<Scalars['String']>>;
  SENSITIVE_user_measurements?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  SENSITIVE_address_information?: InputMaybe<Scalars['Int']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['Int']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  SENSITIVE_address_information?: InputMaybe<Scalars['String']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  kyc_retries_count?: InputMaybe<Scalars['Int']>;
  provider_balance?: InputMaybe<Scalars['numeric']>;
  role?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_MONTHLY_NEWSLETTER?: InputMaybe<Scalars['Boolean']>;
  EMAIL_NEW_FEATURES_SERVICES_SETTINGS?: InputMaybe<Scalars['Boolean']>;
  EMAIL_SPECIAL_OFFERS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_SPECIAL_OFFER_FRIENDS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_UNSUBSCRIBED?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_CALIFORNIA_SETTINGS?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
  SENSITIVE_dob?: InputMaybe<Scalars['date']>;
  SENSITIVE_email?: InputMaybe<Scalars['String']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender_describe?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: InputMaybe<Scalars['uuid']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
  accepted_legal_documents?: InputMaybe<Accepted_Legal_Documents_Arr_Rel_Insert_Input>;
  account_closed_at?: InputMaybe<Scalars['timestamptz']>;
  account_closure_reason?: InputMaybe<Scalars['String']>;
  active_in_mails?: InputMaybe<Active_In_Mails_Arr_Rel_Insert_Input>;
  active_support_chats?: InputMaybe<Active_Support_Chats_Arr_Rel_Insert_Input>;
  admin_permissions?: InputMaybe<Admin_Permissions_Arr_Rel_Insert_Input>;
  appointments?: InputMaybe<Appointments_Arr_Rel_Insert_Input>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_retention_until?: InputMaybe<Scalars['timestamptz']>;
  deleted_by?: InputMaybe<Scalars['uuid']>;
  deleted_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  hide_contact_info?: InputMaybe<Scalars['Boolean']>;
  hide_office_address?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_mail_usage?: InputMaybe<In_Mail_Usage_Arr_Rel_Insert_Input>;
  insurance_verify_later?: InputMaybe<Scalars['Boolean']>;
  invitations?: InputMaybe<Invitations_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  kyc_child_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_current_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_update_date?: InputMaybe<Scalars['timestamptz']>;
  kyc_retries_count?: InputMaybe<Scalars['Int']>;
  kyc_update_date?: InputMaybe<Scalars['timestamptz']>;
  last_login_at?: InputMaybe<Scalars['timestamptz']>;
  legal_document_update_notifications?: InputMaybe<Legal_Document_Update_Notifications_Arr_Rel_Insert_Input>;
  pending_patient_zrts?: InputMaybe<Pending_Patient_Zrt_Arr_Rel_Insert_Input>;
  provider_balance?: InputMaybe<Scalars['numeric']>;
  provider_dea_licenses?: InputMaybe<Provider_Dea_Licenses_Arr_Rel_Insert_Input>;
  provider_state_licenses?: InputMaybe<Provider_State_Licenses_Arr_Rel_Insert_Input>;
  related_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  related_user_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['smallint']>;
  stripe_account_id?: InputMaybe<Scalars['String']>;
  stripe_connected_at?: InputMaybe<Scalars['timestamptz']>;
  stripe_customers?: InputMaybe<Stripe_Customers_Arr_Rel_Insert_Input>;
  stripe_payouts_ready_at?: InputMaybe<Scalars['timestamptz']>;
  support_chat_usage?: InputMaybe<Support_Chat_Usage_Arr_Rel_Insert_Input>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_agreements?: InputMaybe<User_Agreements_Arr_Rel_Insert_Input>;
  user_push_tokens?: InputMaybe<User_Push_Tokens_Arr_Rel_Insert_Input>;
  user_settings?: InputMaybe<User_Settings_Obj_Rel_Insert_Input>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['date']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['uuid']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  account_closed_at?: Maybe<Scalars['timestamptz']>;
  account_closure_reason?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_retention_until?: Maybe<Scalars['timestamptz']>;
  deleted_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kyc_insurance_update_date?: Maybe<Scalars['timestamptz']>;
  kyc_retries_count?: Maybe<Scalars['Int']>;
  kyc_update_date?: Maybe<Scalars['timestamptz']>;
  last_login_at?: Maybe<Scalars['timestamptz']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  related_user_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['smallint']>;
  stripe_account_id?: Maybe<Scalars['String']>;
  stripe_connected_at?: Maybe<Scalars['timestamptz']>;
  stripe_payouts_ready_at?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  SENSITIVE_country?: InputMaybe<Order_By>;
  SENSITIVE_dob?: InputMaybe<Order_By>;
  SENSITIVE_email?: InputMaybe<Order_By>;
  SENSITIVE_firstname?: InputMaybe<Order_By>;
  SENSITIVE_gender?: InputMaybe<Order_By>;
  SENSITIVE_gender_describe?: InputMaybe<Order_By>;
  SENSITIVE_lastname?: InputMaybe<Order_By>;
  SENSITIVE_phone?: InputMaybe<Order_By>;
  SENSITIVE_profile_picture_id?: InputMaybe<Order_By>;
  SENSITIVE_self_identity_gender?: InputMaybe<Order_By>;
  account_closed_at?: InputMaybe<Order_By>;
  account_closure_reason?: InputMaybe<Order_By>;
  blocked_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_retention_until?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_insurance_update_date?: InputMaybe<Order_By>;
  kyc_retries_count?: InputMaybe<Order_By>;
  kyc_update_date?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  related_user_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  stripe_account_id?: InputMaybe<Order_By>;
  stripe_connected_at?: InputMaybe<Order_By>;
  stripe_payouts_ready_at?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  SENSITIVE_country?: Maybe<Scalars['String']>;
  SENSITIVE_dob?: Maybe<Scalars['date']>;
  SENSITIVE_email?: Maybe<Scalars['String']>;
  SENSITIVE_firstname?: Maybe<Scalars['String']>;
  SENSITIVE_gender?: Maybe<Scalars['String']>;
  SENSITIVE_gender_describe?: Maybe<Scalars['String']>;
  SENSITIVE_lastname?: Maybe<Scalars['String']>;
  SENSITIVE_phone?: Maybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: Maybe<Scalars['uuid']>;
  SENSITIVE_self_identity_gender?: Maybe<Scalars['String']>;
  account_closed_at?: Maybe<Scalars['timestamptz']>;
  account_closure_reason?: Maybe<Scalars['String']>;
  blocked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  data_retention_until?: Maybe<Scalars['timestamptz']>;
  deleted_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  kyc_insurance_update_date?: Maybe<Scalars['timestamptz']>;
  kyc_retries_count?: Maybe<Scalars['Int']>;
  kyc_update_date?: Maybe<Scalars['timestamptz']>;
  last_login_at?: Maybe<Scalars['timestamptz']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  related_user_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['smallint']>;
  stripe_account_id?: Maybe<Scalars['String']>;
  stripe_connected_at?: Maybe<Scalars['timestamptz']>;
  stripe_payouts_ready_at?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  SENSITIVE_country?: InputMaybe<Order_By>;
  SENSITIVE_dob?: InputMaybe<Order_By>;
  SENSITIVE_email?: InputMaybe<Order_By>;
  SENSITIVE_firstname?: InputMaybe<Order_By>;
  SENSITIVE_gender?: InputMaybe<Order_By>;
  SENSITIVE_gender_describe?: InputMaybe<Order_By>;
  SENSITIVE_lastname?: InputMaybe<Order_By>;
  SENSITIVE_phone?: InputMaybe<Order_By>;
  SENSITIVE_profile_picture_id?: InputMaybe<Order_By>;
  SENSITIVE_self_identity_gender?: InputMaybe<Order_By>;
  account_closed_at?: InputMaybe<Order_By>;
  account_closure_reason?: InputMaybe<Order_By>;
  blocked_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_retention_until?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_insurance_update_date?: InputMaybe<Order_By>;
  kyc_retries_count?: InputMaybe<Order_By>;
  kyc_update_date?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  related_user_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  stripe_account_id?: InputMaybe<Order_By>;
  stripe_connected_at?: InputMaybe<Order_By>;
  stripe_payouts_ready_at?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING?: InputMaybe<Order_By>;
  AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING?: InputMaybe<Order_By>;
  EMAIL_MONTHLY_NEWSLETTER?: InputMaybe<Order_By>;
  EMAIL_NEW_FEATURES_SERVICES_SETTINGS?: InputMaybe<Order_By>;
  EMAIL_SPECIAL_OFFERS_SETTING?: InputMaybe<Order_By>;
  EMAIL_SPECIAL_OFFER_FRIENDS_SETTING?: InputMaybe<Order_By>;
  EMAIL_UNSUBSCRIBED?: InputMaybe<Order_By>;
  PRIVACY_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Order_By>;
  PRIVACY_CALIFORNIA_SETTINGS?: InputMaybe<Order_By>;
  PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Order_By>;
  SENSITIVE_address_information?: InputMaybe<Order_By>;
  SENSITIVE_country?: InputMaybe<Order_By>;
  SENSITIVE_dob?: InputMaybe<Order_By>;
  SENSITIVE_email?: InputMaybe<Order_By>;
  SENSITIVE_etnicity?: InputMaybe<Order_By>;
  SENSITIVE_firstname?: InputMaybe<Order_By>;
  SENSITIVE_gender?: InputMaybe<Order_By>;
  SENSITIVE_gender_describe?: InputMaybe<Order_By>;
  SENSITIVE_lastname?: InputMaybe<Order_By>;
  SENSITIVE_phone?: InputMaybe<Order_By>;
  SENSITIVE_profile_picture_id?: InputMaybe<Order_By>;
  SENSITIVE_self_identity_gender?: InputMaybe<Order_By>;
  SENSITIVE_user_measurements?: InputMaybe<Order_By>;
  accepted_legal_documents_aggregate?: InputMaybe<Accepted_Legal_Documents_Aggregate_Order_By>;
  account_closed_at?: InputMaybe<Order_By>;
  account_closure_reason?: InputMaybe<Order_By>;
  active_in_mails_aggregate?: InputMaybe<Active_In_Mails_Aggregate_Order_By>;
  active_support_chats_aggregate?: InputMaybe<Active_Support_Chats_Aggregate_Order_By>;
  admin_permissions_aggregate?: InputMaybe<Admin_Permissions_Aggregate_Order_By>;
  appointments_aggregate?: InputMaybe<Appointments_Aggregate_Order_By>;
  blocked_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data_retention_until?: InputMaybe<Order_By>;
  deleted_by?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Users_Order_By>;
  hide_contact_info?: InputMaybe<Order_By>;
  hide_office_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_mail_usage_aggregate?: InputMaybe<In_Mail_Usage_Aggregate_Order_By>;
  insurance_verify_later?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitations_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_admin?: InputMaybe<Order_By>;
  kyc_child_status?: InputMaybe<Order_By>;
  kyc_current_status?: InputMaybe<Order_By>;
  kyc_insurance_status?: InputMaybe<Order_By>;
  kyc_insurance_update_date?: InputMaybe<Order_By>;
  kyc_retries_count?: InputMaybe<Order_By>;
  kyc_update_date?: InputMaybe<Order_By>;
  last_login_at?: InputMaybe<Order_By>;
  legal_document_update_notifications_aggregate?: InputMaybe<Legal_Document_Update_Notifications_Aggregate_Order_By>;
  pending_patient_zrts_aggregate?: InputMaybe<Pending_Patient_Zrt_Aggregate_Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  provider_dea_licenses_aggregate?: InputMaybe<Provider_Dea_Licenses_Aggregate_Order_By>;
  provider_state_licenses_aggregate?: InputMaybe<Provider_State_Licenses_Aggregate_Order_By>;
  related_user?: InputMaybe<Users_Order_By>;
  related_user_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  stripe_account_id?: InputMaybe<Order_By>;
  stripe_connected_at?: InputMaybe<Order_By>;
  stripe_customers_aggregate?: InputMaybe<Stripe_Customers_Aggregate_Order_By>;
  stripe_payouts_ready_at?: InputMaybe<Order_By>;
  support_chat_usage_aggregate?: InputMaybe<Support_Chat_Usage_Aggregate_Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_agreements_aggregate?: InputMaybe<User_Agreements_Aggregate_Order_By>;
  user_push_tokens_aggregate?: InputMaybe<User_Push_Tokens_Aggregate_Order_By>;
  user_settings?: InputMaybe<User_Settings_Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AutoApprovalPatientsCodexLabsSetting = 'AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING',
  /** column name */
  AutoApprovalTestkitScriptsCodexLabsSetting = 'AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING',
  /** column name */
  EmailMonthlyNewsletter = 'EMAIL_MONTHLY_NEWSLETTER',
  /** column name */
  EmailNewFeaturesServicesSettings = 'EMAIL_NEW_FEATURES_SERVICES_SETTINGS',
  /** column name */
  EmailSpecialOffersSetting = 'EMAIL_SPECIAL_OFFERS_SETTING',
  /** column name */
  EmailSpecialOfferFriendsSetting = 'EMAIL_SPECIAL_OFFER_FRIENDS_SETTING',
  /** column name */
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
  /** column name */
  PrivacyAffiliatesCodexLabsSetting = 'PRIVACY_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  PrivacyCaliforniaSettings = 'PRIVACY_CALIFORNIA_SETTINGS',
  /** column name */
  PrivacyNonAffiliatesCodexLabsSetting = 'PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  SensitiveAddressInformation = 'SENSITIVE_address_information',
  /** column name */
  SensitiveCountry = 'SENSITIVE_country',
  /** column name */
  SensitiveDob = 'SENSITIVE_dob',
  /** column name */
  SensitiveEmail = 'SENSITIVE_email',
  /** column name */
  SensitiveEtnicity = 'SENSITIVE_etnicity',
  /** column name */
  SensitiveFirstname = 'SENSITIVE_firstname',
  /** column name */
  SensitiveGender = 'SENSITIVE_gender',
  /** column name */
  SensitiveGenderDescribe = 'SENSITIVE_gender_describe',
  /** column name */
  SensitiveLastname = 'SENSITIVE_lastname',
  /** column name */
  SensitivePhone = 'SENSITIVE_phone',
  /** column name */
  SensitiveProfilePictureId = 'SENSITIVE_profile_picture_id',
  /** column name */
  SensitiveSelfIdentityGender = 'SENSITIVE_self_identity_gender',
  /** column name */
  SensitiveUserMeasurements = 'SENSITIVE_user_measurements',
  /** column name */
  AccountClosedAt = 'account_closed_at',
  /** column name */
  AccountClosureReason = 'account_closure_reason',
  /** column name */
  BlockedAt = 'blocked_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataRetentionUntil = 'data_retention_until',
  /** column name */
  DeletedBy = 'deleted_by',
  /** column name */
  HideContactInfo = 'hide_contact_info',
  /** column name */
  HideOfficeAddress = 'hide_office_address',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceVerifyLater = 'insurance_verify_later',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  KycChildStatus = 'kyc_child_status',
  /** column name */
  KycCurrentStatus = 'kyc_current_status',
  /** column name */
  KycInsuranceStatus = 'kyc_insurance_status',
  /** column name */
  KycInsuranceUpdateDate = 'kyc_insurance_update_date',
  /** column name */
  KycRetriesCount = 'kyc_retries_count',
  /** column name */
  KycUpdateDate = 'kyc_update_date',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  ProviderBalance = 'provider_balance',
  /** column name */
  RelatedUserId = 'related_user_id',
  /** column name */
  Role = 'role',
  /** column name */
  StripeAccountId = 'stripe_account_id',
  /** column name */
  StripeConnectedAt = 'stripe_connected_at',
  /** column name */
  StripePayoutsReadyAt = 'stripe_payouts_ready_at',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoApprovalPatientsCodexLabsSetting = 'AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING',
  /** column name */
  AutoApprovalTestkitScriptsCodexLabsSetting = 'AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING',
  /** column name */
  EmailMonthlyNewsletter = 'EMAIL_MONTHLY_NEWSLETTER',
  /** column name */
  EmailNewFeaturesServicesSettings = 'EMAIL_NEW_FEATURES_SERVICES_SETTINGS',
  /** column name */
  EmailSpecialOffersSetting = 'EMAIL_SPECIAL_OFFERS_SETTING',
  /** column name */
  EmailSpecialOfferFriendsSetting = 'EMAIL_SPECIAL_OFFER_FRIENDS_SETTING',
  /** column name */
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
  /** column name */
  PrivacyAffiliatesCodexLabsSetting = 'PRIVACY_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  PrivacyCaliforniaSettings = 'PRIVACY_CALIFORNIA_SETTINGS',
  /** column name */
  PrivacyNonAffiliatesCodexLabsSetting = 'PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  HideContactInfo = 'hide_contact_info',
  /** column name */
  HideOfficeAddress = 'hide_office_address',
  /** column name */
  InsuranceVerifyLater = 'insurance_verify_later',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAdmin = 'is_admin'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoApprovalPatientsCodexLabsSetting = 'AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING',
  /** column name */
  AutoApprovalTestkitScriptsCodexLabsSetting = 'AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING',
  /** column name */
  EmailMonthlyNewsletter = 'EMAIL_MONTHLY_NEWSLETTER',
  /** column name */
  EmailNewFeaturesServicesSettings = 'EMAIL_NEW_FEATURES_SERVICES_SETTINGS',
  /** column name */
  EmailSpecialOffersSetting = 'EMAIL_SPECIAL_OFFERS_SETTING',
  /** column name */
  EmailSpecialOfferFriendsSetting = 'EMAIL_SPECIAL_OFFER_FRIENDS_SETTING',
  /** column name */
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
  /** column name */
  PrivacyAffiliatesCodexLabsSetting = 'PRIVACY_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  PrivacyCaliforniaSettings = 'PRIVACY_CALIFORNIA_SETTINGS',
  /** column name */
  PrivacyNonAffiliatesCodexLabsSetting = 'PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  HideContactInfo = 'hide_contact_info',
  /** column name */
  HideOfficeAddress = 'hide_office_address',
  /** column name */
  InsuranceVerifyLater = 'insurance_verify_later',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAdmin = 'is_admin'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_MONTHLY_NEWSLETTER?: InputMaybe<Scalars['Boolean']>;
  EMAIL_NEW_FEATURES_SERVICES_SETTINGS?: InputMaybe<Scalars['Boolean']>;
  EMAIL_SPECIAL_OFFERS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_SPECIAL_OFFER_FRIENDS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_UNSUBSCRIBED?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_CALIFORNIA_SETTINGS?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
  SENSITIVE_dob?: InputMaybe<Scalars['date']>;
  SENSITIVE_email?: InputMaybe<Scalars['String']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender_describe?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: InputMaybe<Scalars['uuid']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
  account_closed_at?: InputMaybe<Scalars['timestamptz']>;
  account_closure_reason?: InputMaybe<Scalars['String']>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_retention_until?: InputMaybe<Scalars['timestamptz']>;
  deleted_by?: InputMaybe<Scalars['uuid']>;
  hide_contact_info?: InputMaybe<Scalars['Boolean']>;
  hide_office_address?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurance_verify_later?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  kyc_child_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_current_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_update_date?: InputMaybe<Scalars['timestamptz']>;
  kyc_retries_count?: InputMaybe<Scalars['Int']>;
  kyc_update_date?: InputMaybe<Scalars['timestamptz']>;
  last_login_at?: InputMaybe<Scalars['timestamptz']>;
  provider_balance?: InputMaybe<Scalars['numeric']>;
  related_user_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['smallint']>;
  stripe_account_id?: InputMaybe<Scalars['String']>;
  stripe_connected_at?: InputMaybe<Scalars['timestamptz']>;
  stripe_payouts_ready_at?: InputMaybe<Scalars['timestamptz']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_MONTHLY_NEWSLETTER?: InputMaybe<Scalars['Boolean']>;
  EMAIL_NEW_FEATURES_SERVICES_SETTINGS?: InputMaybe<Scalars['Boolean']>;
  EMAIL_SPECIAL_OFFERS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_SPECIAL_OFFER_FRIENDS_SETTING?: InputMaybe<Scalars['Boolean']>;
  EMAIL_UNSUBSCRIBED?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_CALIFORNIA_SETTINGS?: InputMaybe<Scalars['Boolean']>;
  PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING?: InputMaybe<Scalars['Boolean']>;
  SENSITIVE_address_information?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_country?: InputMaybe<Scalars['String']>;
  SENSITIVE_dob?: InputMaybe<Scalars['date']>;
  SENSITIVE_email?: InputMaybe<Scalars['String']>;
  SENSITIVE_etnicity?: InputMaybe<Scalars['jsonb']>;
  SENSITIVE_firstname?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_gender_describe?: InputMaybe<Scalars['String']>;
  SENSITIVE_lastname?: InputMaybe<Scalars['String']>;
  SENSITIVE_phone?: InputMaybe<Scalars['String']>;
  SENSITIVE_profile_picture_id?: InputMaybe<Scalars['uuid']>;
  SENSITIVE_self_identity_gender?: InputMaybe<Scalars['String']>;
  SENSITIVE_user_measurements?: InputMaybe<Scalars['jsonb']>;
  account_closed_at?: InputMaybe<Scalars['timestamptz']>;
  account_closure_reason?: InputMaybe<Scalars['String']>;
  blocked_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  data_retention_until?: InputMaybe<Scalars['timestamptz']>;
  deleted_by?: InputMaybe<Scalars['uuid']>;
  hide_contact_info?: InputMaybe<Scalars['Boolean']>;
  hide_office_address?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  insurance_verify_later?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  kyc_child_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_current_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_status?: InputMaybe<Persona_Inquiry_Status_Enum>;
  kyc_insurance_update_date?: InputMaybe<Scalars['timestamptz']>;
  kyc_retries_count?: InputMaybe<Scalars['Int']>;
  kyc_update_date?: InputMaybe<Scalars['timestamptz']>;
  last_login_at?: InputMaybe<Scalars['timestamptz']>;
  provider_balance?: InputMaybe<Scalars['numeric']>;
  related_user_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['smallint']>;
  stripe_account_id?: InputMaybe<Scalars['String']>;
  stripe_connected_at?: InputMaybe<Scalars['timestamptz']>;
  stripe_payouts_ready_at?: InputMaybe<Scalars['timestamptz']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  kyc_retries_count?: Maybe<Scalars['Int']>;
  provider_balance?: Maybe<Scalars['numeric']>;
  role?: Maybe<Scalars['smallint']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AutoApprovalPatientsCodexLabsSetting = 'AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING',
  /** column name */
  AutoApprovalTestkitScriptsCodexLabsSetting = 'AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING',
  /** column name */
  EmailMonthlyNewsletter = 'EMAIL_MONTHLY_NEWSLETTER',
  /** column name */
  EmailNewFeaturesServicesSettings = 'EMAIL_NEW_FEATURES_SERVICES_SETTINGS',
  /** column name */
  EmailSpecialOffersSetting = 'EMAIL_SPECIAL_OFFERS_SETTING',
  /** column name */
  EmailSpecialOfferFriendsSetting = 'EMAIL_SPECIAL_OFFER_FRIENDS_SETTING',
  /** column name */
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
  /** column name */
  PrivacyAffiliatesCodexLabsSetting = 'PRIVACY_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  PrivacyCaliforniaSettings = 'PRIVACY_CALIFORNIA_SETTINGS',
  /** column name */
  PrivacyNonAffiliatesCodexLabsSetting = 'PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING',
  /** column name */
  SensitiveAddressInformation = 'SENSITIVE_address_information',
  /** column name */
  SensitiveCountry = 'SENSITIVE_country',
  /** column name */
  SensitiveDob = 'SENSITIVE_dob',
  /** column name */
  SensitiveEmail = 'SENSITIVE_email',
  /** column name */
  SensitiveEtnicity = 'SENSITIVE_etnicity',
  /** column name */
  SensitiveFirstname = 'SENSITIVE_firstname',
  /** column name */
  SensitiveGender = 'SENSITIVE_gender',
  /** column name */
  SensitiveGenderDescribe = 'SENSITIVE_gender_describe',
  /** column name */
  SensitiveLastname = 'SENSITIVE_lastname',
  /** column name */
  SensitivePhone = 'SENSITIVE_phone',
  /** column name */
  SensitiveProfilePictureId = 'SENSITIVE_profile_picture_id',
  /** column name */
  SensitiveSelfIdentityGender = 'SENSITIVE_self_identity_gender',
  /** column name */
  SensitiveUserMeasurements = 'SENSITIVE_user_measurements',
  /** column name */
  AccountClosedAt = 'account_closed_at',
  /** column name */
  AccountClosureReason = 'account_closure_reason',
  /** column name */
  BlockedAt = 'blocked_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataRetentionUntil = 'data_retention_until',
  /** column name */
  DeletedBy = 'deleted_by',
  /** column name */
  HideContactInfo = 'hide_contact_info',
  /** column name */
  HideOfficeAddress = 'hide_office_address',
  /** column name */
  Id = 'id',
  /** column name */
  InsuranceVerifyLater = 'insurance_verify_later',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  KycChildStatus = 'kyc_child_status',
  /** column name */
  KycCurrentStatus = 'kyc_current_status',
  /** column name */
  KycInsuranceStatus = 'kyc_insurance_status',
  /** column name */
  KycInsuranceUpdateDate = 'kyc_insurance_update_date',
  /** column name */
  KycRetriesCount = 'kyc_retries_count',
  /** column name */
  KycUpdateDate = 'kyc_update_date',
  /** column name */
  LastLoginAt = 'last_login_at',
  /** column name */
  ProviderBalance = 'provider_balance',
  /** column name */
  RelatedUserId = 'related_user_id',
  /** column name */
  Role = 'role',
  /** column name */
  StripeAccountId = 'stripe_account_id',
  /** column name */
  StripeConnectedAt = 'stripe_connected_at',
  /** column name */
  StripePayoutsReadyAt = 'stripe_payouts_ready_at',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  kyc_retries_count?: Maybe<Scalars['Float']>;
  provider_balance?: Maybe<Scalars['Float']>;
  role?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  kyc_retries_count?: InputMaybe<Order_By>;
  provider_balance?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vonage_appointment" */
export type Vonage_Appointment = {
  __typename?: 'vonage_appointment';
  appointment_date?: Maybe<Scalars['date']>;
  appointment_time?: Maybe<Scalars['timetz']>;
  appointment_type?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  patient_id: Scalars['uuid'];
  provider_id: Scalars['uuid'];
  room_id: Scalars['uuid'];
};

/** aggregated selection of "vonage_appointment" */
export type Vonage_Appointment_Aggregate = {
  __typename?: 'vonage_appointment_aggregate';
  aggregate?: Maybe<Vonage_Appointment_Aggregate_Fields>;
  nodes: Array<Vonage_Appointment>;
};

/** aggregate fields of "vonage_appointment" */
export type Vonage_Appointment_Aggregate_Fields = {
  __typename?: 'vonage_appointment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Vonage_Appointment_Max_Fields>;
  min?: Maybe<Vonage_Appointment_Min_Fields>;
};


/** aggregate fields of "vonage_appointment" */
export type Vonage_Appointment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vonage_Appointment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vonage_appointment". All fields are combined with a logical 'AND'. */
export type Vonage_Appointment_Bool_Exp = {
  _and?: InputMaybe<Array<Vonage_Appointment_Bool_Exp>>;
  _not?: InputMaybe<Vonage_Appointment_Bool_Exp>;
  _or?: InputMaybe<Array<Vonage_Appointment_Bool_Exp>>;
  appointment_date?: InputMaybe<Date_Comparison_Exp>;
  appointment_time?: InputMaybe<Timetz_Comparison_Exp>;
  appointment_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  patient_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  room_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "vonage_appointment" */
export enum Vonage_Appointment_Constraint {
  /** unique or primary key constraint on columns "id" */
  VonageAppointmentPkey = 'vonage_appointment_pkey',
  /** unique or primary key constraint on columns "room_id" */
  VonageAppointmentRoomIdKey = 'vonage_appointment_room_id_key'
}

/** input type for inserting data into table "vonage_appointment" */
export type Vonage_Appointment_Insert_Input = {
  appointment_date?: InputMaybe<Scalars['date']>;
  appointment_time?: InputMaybe<Scalars['timetz']>;
  appointment_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  room_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Vonage_Appointment_Max_Fields = {
  __typename?: 'vonage_appointment_max_fields';
  appointment_date?: Maybe<Scalars['date']>;
  appointment_time?: Maybe<Scalars['timetz']>;
  appointment_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  room_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Vonage_Appointment_Min_Fields = {
  __typename?: 'vonage_appointment_min_fields';
  appointment_date?: Maybe<Scalars['date']>;
  appointment_time?: Maybe<Scalars['timetz']>;
  appointment_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  patient_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['uuid']>;
  room_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "vonage_appointment" */
export type Vonage_Appointment_Mutation_Response = {
  __typename?: 'vonage_appointment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vonage_Appointment>;
};

/** on_conflict condition type for table "vonage_appointment" */
export type Vonage_Appointment_On_Conflict = {
  constraint: Vonage_Appointment_Constraint;
  update_columns?: Array<Vonage_Appointment_Update_Column>;
  where?: InputMaybe<Vonage_Appointment_Bool_Exp>;
};

/** Ordering options when selecting data from "vonage_appointment". */
export type Vonage_Appointment_Order_By = {
  appointment_date?: InputMaybe<Order_By>;
  appointment_time?: InputMaybe<Order_By>;
  appointment_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  room_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vonage_appointment */
export type Vonage_Appointment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "vonage_appointment" */
export enum Vonage_Appointment_Select_Column {
  /** column name */
  AppointmentDate = 'appointment_date',
  /** column name */
  AppointmentTime = 'appointment_time',
  /** column name */
  AppointmentType = 'appointment_type',
  /** column name */
  Id = 'id',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RoomId = 'room_id'
}

/** input type for updating data in table "vonage_appointment" */
export type Vonage_Appointment_Set_Input = {
  appointment_date?: InputMaybe<Scalars['date']>;
  appointment_time?: InputMaybe<Scalars['timetz']>;
  appointment_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  room_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "vonage_appointment" */
export type Vonage_Appointment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vonage_Appointment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vonage_Appointment_Stream_Cursor_Value_Input = {
  appointment_date?: InputMaybe<Scalars['date']>;
  appointment_time?: InputMaybe<Scalars['timetz']>;
  appointment_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  patient_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['uuid']>;
  room_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "vonage_appointment" */
export enum Vonage_Appointment_Update_Column {
  /** column name */
  AppointmentDate = 'appointment_date',
  /** column name */
  AppointmentTime = 'appointment_time',
  /** column name */
  AppointmentType = 'appointment_type',
  /** column name */
  Id = 'id',
  /** column name */
  PatientId = 'patient_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  RoomId = 'room_id'
}

export type Vonage_Appointment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vonage_Appointment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vonage_Appointment_Bool_Exp;
};

/** ZRT test results */
export type Zrt_Tests = {
  __typename?: 'zrt_tests';
  created_at: Scalars['timestamptz'];
  errors?: Maybe<Scalars['jsonb']>;
  state: Scalars['String'];
  test_id: Scalars['uuid'];
  /** An array relationship */
  test_kits_update_states_summary_logs: Array<Test_Kits_Update_States_Summary_Log>;
  /** An aggregate relationship */
  test_kits_update_states_summary_logs_aggregate: Test_Kits_Update_States_Summary_Log_Aggregate;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  zrt_tests_test: Tests;
};


/** ZRT test results */
export type Zrt_TestsErrorsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** ZRT test results */
export type Zrt_TestsTest_Kits_Update_States_Summary_LogsArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};


/** ZRT test results */
export type Zrt_TestsTest_Kits_Update_States_Summary_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Test_Kits_Update_States_Summary_Log_Order_By>>;
  where?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
};

/** aggregated selection of "zrt_tests" */
export type Zrt_Tests_Aggregate = {
  __typename?: 'zrt_tests_aggregate';
  aggregate?: Maybe<Zrt_Tests_Aggregate_Fields>;
  nodes: Array<Zrt_Tests>;
};

export type Zrt_Tests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Zrt_Tests_Aggregate_Bool_Exp_Count>;
};

export type Zrt_Tests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Zrt_Tests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "zrt_tests" */
export type Zrt_Tests_Aggregate_Fields = {
  __typename?: 'zrt_tests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Zrt_Tests_Max_Fields>;
  min?: Maybe<Zrt_Tests_Min_Fields>;
};


/** aggregate fields of "zrt_tests" */
export type Zrt_Tests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Zrt_Tests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "zrt_tests" */
export type Zrt_Tests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Zrt_Tests_Max_Order_By>;
  min?: InputMaybe<Zrt_Tests_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Zrt_Tests_Append_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "zrt_tests" */
export type Zrt_Tests_Arr_Rel_Insert_Input = {
  data: Array<Zrt_Tests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Zrt_Tests_On_Conflict>;
};

/** Boolean expression to filter rows from the table "zrt_tests". All fields are combined with a logical 'AND'. */
export type Zrt_Tests_Bool_Exp = {
  _and?: InputMaybe<Array<Zrt_Tests_Bool_Exp>>;
  _not?: InputMaybe<Zrt_Tests_Bool_Exp>;
  _or?: InputMaybe<Array<Zrt_Tests_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  errors?: InputMaybe<Jsonb_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  test_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Bool_Exp>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Bool_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zrt_tests_test?: InputMaybe<Tests_Bool_Exp>;
};

/** unique or primary key constraints on table "zrt_tests" */
export enum Zrt_Tests_Constraint {
  /** unique or primary key constraint on columns "test_id" */
  ZrtTestsPkey = 'zrt_tests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Zrt_Tests_Delete_At_Path_Input = {
  errors?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Zrt_Tests_Delete_Elem_Input = {
  errors?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Zrt_Tests_Delete_Key_Input = {
  errors?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "zrt_tests" */
export type Zrt_Tests_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  test_kits_update_states_summary_logs?: InputMaybe<Test_Kits_Update_States_Summary_Log_Arr_Rel_Insert_Input>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zrt_tests_test?: InputMaybe<Tests_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Zrt_Tests_Max_Fields = {
  __typename?: 'zrt_tests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "zrt_tests" */
export type Zrt_Tests_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Zrt_Tests_Min_Fields = {
  __typename?: 'zrt_tests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  state?: Maybe<Scalars['String']>;
  test_id?: Maybe<Scalars['uuid']>;
  tracking_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "zrt_tests" */
export type Zrt_Tests_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "zrt_tests" */
export type Zrt_Tests_Mutation_Response = {
  __typename?: 'zrt_tests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Zrt_Tests>;
};

/** on_conflict condition type for table "zrt_tests" */
export type Zrt_Tests_On_Conflict = {
  constraint: Zrt_Tests_Constraint;
  update_columns?: Array<Zrt_Tests_Update_Column>;
  where?: InputMaybe<Zrt_Tests_Bool_Exp>;
};

/** Ordering options when selecting data from "zrt_tests". */
export type Zrt_Tests_Order_By = {
  created_at?: InputMaybe<Order_By>;
  errors?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  test_id?: InputMaybe<Order_By>;
  test_kits_update_states_summary_logs_aggregate?: InputMaybe<Test_Kits_Update_States_Summary_Log_Aggregate_Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zrt_tests_test?: InputMaybe<Tests_Order_By>;
};

/** primary key columns input for table: zrt_tests */
export type Zrt_Tests_Pk_Columns_Input = {
  test_id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Zrt_Tests_Prepend_Input = {
  errors?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "zrt_tests" */
export enum Zrt_Tests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  State = 'state',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "zrt_tests" */
export type Zrt_Tests_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "zrt_tests" */
export type Zrt_Tests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Zrt_Tests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Zrt_Tests_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  errors?: InputMaybe<Scalars['jsonb']>;
  state?: InputMaybe<Scalars['String']>;
  test_id?: InputMaybe<Scalars['uuid']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "zrt_tests" */
export enum Zrt_Tests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Errors = 'errors',
  /** column name */
  State = 'state',
  /** column name */
  TestId = 'test_id',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Zrt_Tests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Zrt_Tests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Zrt_Tests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Zrt_Tests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Zrt_Tests_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Zrt_Tests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Zrt_Tests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Zrt_Tests_Bool_Exp;
};


export const GetUserTestsByUserIdDocument = gql`
    query GetUserTestsByUserID($userID: uuid!, $dnaSkinTestID: Int!, $dnaVitaminTestID: Int!, $fromDate: timestamptz = "2000-01-01T00:00:00", $toDate: timestamptz = "2099-12-31T23:59:00", $states: [dnavisit_test_statuses_enum!]! = [COMPLETE, KIT_NOT_RECEIVED, RECEIVED_BY_LAB, RESULTS_WITH_PROVIDER, APPOINTMENT_SCHEDULED]) {
  tests(
    where: {user_id: {_eq: $userID}, _or: [{test_type_id: {_eq: $dnaSkinTestID}}, {test_type_id: {_eq: $dnaVitaminTestID}}], created_at: {_gte: $fromDate, _lte: $toDate}}
    order_by: {created_at: desc}
  ) {
    test_id
    created_at
    tests_test_definition {
      test_type
    }
  }
}
    `;

/**
 * __useGetUserTestsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetUserTestsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTestsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTestsByUserIdQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      dnaSkinTestID: // value for 'dnaSkinTestID'
 *      dnaVitaminTestID: // value for 'dnaVitaminTestID'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      states: // value for 'states'
 *   },
 * });
 */
export function useGetUserTestsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserTestsByUserIdQuery, GetUserTestsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTestsByUserIdQuery, GetUserTestsByUserIdQueryVariables>(GetUserTestsByUserIdDocument, options);
      }
export function useGetUserTestsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTestsByUserIdQuery, GetUserTestsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTestsByUserIdQuery, GetUserTestsByUserIdQueryVariables>(GetUserTestsByUserIdDocument, options);
        }
export type GetUserTestsByUserIdQueryHookResult = ReturnType<typeof useGetUserTestsByUserIdQuery>;
export type GetUserTestsByUserIdLazyQueryHookResult = ReturnType<typeof useGetUserTestsByUserIdLazyQuery>;
export type GetUserTestsByUserIdQueryResult = Apollo.QueryResult<GetUserTestsByUserIdQuery, GetUserTestsByUserIdQueryVariables>;
export const GetUserDnaTestsByTestsIdsDocument = gql`
    query GetUserDNATestsByTestsIDS($testIDS: [uuid!], $states: [dnavisit_test_statuses_enum!]! = [COMPLETE, KIT_NOT_RECEIVED, RECEIVED_BY_LAB, RESULTS_WITH_PROVIDER, APPOINTMENT_SCHEDULED], $limit: Int = 10, $offset: Int = 0) {
  dnavisit_tests(
    where: {test_id: {_in: $testIDS}, state: {_in: $states}, errors: {_is_null: true}}
    order_by: {created_at: desc}
    limit: $limit
    offset: $offset
  ) {
    test_id
    state
    tracking_number
    patient_pdf_id
    visit_summary_pdf_id
    sapphiros_barcode
    visit_summary_appointment_date
    visit_summary_appointment_url
    created_at
  }
  dnavisit_tests_aggregate(
    where: {test_id: {_in: $testIDS}, state: {_in: $states}, errors: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserDnaTestsByTestsIdsQuery__
 *
 * To run a query within a React component, call `useGetUserDnaTestsByTestsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDnaTestsByTestsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDnaTestsByTestsIdsQuery({
 *   variables: {
 *      testIDS: // value for 'testIDS'
 *      states: // value for 'states'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUserDnaTestsByTestsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDnaTestsByTestsIdsQuery, GetUserDnaTestsByTestsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDnaTestsByTestsIdsQuery, GetUserDnaTestsByTestsIdsQueryVariables>(GetUserDnaTestsByTestsIdsDocument, options);
      }
export function useGetUserDnaTestsByTestsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDnaTestsByTestsIdsQuery, GetUserDnaTestsByTestsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDnaTestsByTestsIdsQuery, GetUserDnaTestsByTestsIdsQueryVariables>(GetUserDnaTestsByTestsIdsDocument, options);
        }
export type GetUserDnaTestsByTestsIdsQueryHookResult = ReturnType<typeof useGetUserDnaTestsByTestsIdsQuery>;
export type GetUserDnaTestsByTestsIdsLazyQueryHookResult = ReturnType<typeof useGetUserDnaTestsByTestsIdsLazyQuery>;
export type GetUserDnaTestsByTestsIdsQueryResult = Apollo.QueryResult<GetUserDnaTestsByTestsIdsQuery, GetUserDnaTestsByTestsIdsQueryVariables>;
export const GetDiagnosticReportsByParticipantsDocument = gql`
    query GetDiagnosticReportsByParticipants($patientCodexId: String!, $providerCodexId: String!, $state: [Hasura_Dnavisit_Test_Statuses_Enum!]) {
  getDiagnosticReportsByParticipants(
    patientCodexId: $patientCodexId
    providerCodexId: $providerCodexId
    state: $state
  ) {
    diagnosticReports {
      createdAt
      providerPdf {
        contentType
        creation
        fileId
        fileName
        size
        url
      }
      statusHistory {
        datetime
        status
      }
      patientPdf {
        contentType
        creation
        fileId
        fileName
        size
        url
      }
      diagnosticReportId
      diagnosticReportStatus
      diagnosticReportTestType
      providerPdfId
      swabCode
    }
  }
}
    `;

/**
 * __useGetDiagnosticReportsByParticipantsQuery__
 *
 * To run a query within a React component, call `useGetDiagnosticReportsByParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosticReportsByParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosticReportsByParticipantsQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      providerCodexId: // value for 'providerCodexId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDiagnosticReportsByParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetDiagnosticReportsByParticipantsQuery, GetDiagnosticReportsByParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiagnosticReportsByParticipantsQuery, GetDiagnosticReportsByParticipantsQueryVariables>(GetDiagnosticReportsByParticipantsDocument, options);
      }
export function useGetDiagnosticReportsByParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiagnosticReportsByParticipantsQuery, GetDiagnosticReportsByParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiagnosticReportsByParticipantsQuery, GetDiagnosticReportsByParticipantsQueryVariables>(GetDiagnosticReportsByParticipantsDocument, options);
        }
export type GetDiagnosticReportsByParticipantsQueryHookResult = ReturnType<typeof useGetDiagnosticReportsByParticipantsQuery>;
export type GetDiagnosticReportsByParticipantsLazyQueryHookResult = ReturnType<typeof useGetDiagnosticReportsByParticipantsLazyQuery>;
export type GetDiagnosticReportsByParticipantsQueryResult = Apollo.QueryResult<GetDiagnosticReportsByParticipantsQuery, GetDiagnosticReportsByParticipantsQueryVariables>;
export const GetProviderDiagnosticReportsByPatientDocument = gql`
    query GetProviderDiagnosticReportsByPatient($patientCodexId: String!, $exceptAppointmentCodexId: String!, $state: [Hasura_Dnavisit_Test_Statuses_Enum!]) {
  getDiagnosticReportsByPatient(
    patientCodexId: $patientCodexId
    exceptAppointmentCodexId: $exceptAppointmentCodexId
    state: $state
  ) {
    diagnosticReports {
      diagnosticReportId
      diagnosticReportStatus
      diagnosticReportTestType
      providerPdfId
      swabCode
      statusHistory {
        datetime
        status
      }
      providerPdf {
        contentType
        creation
        fileId
        fileName
        size
        url
      }
    }
    total
  }
}
    `;

/**
 * __useGetProviderDiagnosticReportsByPatientQuery__
 *
 * To run a query within a React component, call `useGetProviderDiagnosticReportsByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderDiagnosticReportsByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderDiagnosticReportsByPatientQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      exceptAppointmentCodexId: // value for 'exceptAppointmentCodexId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetProviderDiagnosticReportsByPatientQuery(baseOptions: Apollo.QueryHookOptions<GetProviderDiagnosticReportsByPatientQuery, GetProviderDiagnosticReportsByPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderDiagnosticReportsByPatientQuery, GetProviderDiagnosticReportsByPatientQueryVariables>(GetProviderDiagnosticReportsByPatientDocument, options);
      }
export function useGetProviderDiagnosticReportsByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderDiagnosticReportsByPatientQuery, GetProviderDiagnosticReportsByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderDiagnosticReportsByPatientQuery, GetProviderDiagnosticReportsByPatientQueryVariables>(GetProviderDiagnosticReportsByPatientDocument, options);
        }
export type GetProviderDiagnosticReportsByPatientQueryHookResult = ReturnType<typeof useGetProviderDiagnosticReportsByPatientQuery>;
export type GetProviderDiagnosticReportsByPatientLazyQueryHookResult = ReturnType<typeof useGetProviderDiagnosticReportsByPatientLazyQuery>;
export type GetProviderDiagnosticReportsByPatientQueryResult = Apollo.QueryResult<GetProviderDiagnosticReportsByPatientQuery, GetProviderDiagnosticReportsByPatientQueryVariables>;
export const GetDiagnosticReportsByPatientDocument = gql`
    query GetDiagnosticReportsByPatient($patientCodexId: String!, $exceptAppointmentCodexId: String!, $state: [Hasura_Dnavisit_Test_Statuses_Enum!]) {
  getDiagnosticReportsByPatient(
    patientCodexId: $patientCodexId
    exceptAppointmentCodexId: $exceptAppointmentCodexId
    state: $state
  ) {
    diagnosticReports {
      diagnosticReportId
      diagnosticReportStatus
      diagnosticReportTestType
      patientPdfId
      swabCode
      statusHistory {
        datetime
        status
      }
      patientPdf {
        contentType
        creation
        fileId
        fileName
        size
        url
      }
    }
    total
  }
}
    `;

/**
 * __useGetDiagnosticReportsByPatientQuery__
 *
 * To run a query within a React component, call `useGetDiagnosticReportsByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosticReportsByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosticReportsByPatientQuery({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      exceptAppointmentCodexId: // value for 'exceptAppointmentCodexId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDiagnosticReportsByPatientQuery(baseOptions: Apollo.QueryHookOptions<GetDiagnosticReportsByPatientQuery, GetDiagnosticReportsByPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiagnosticReportsByPatientQuery, GetDiagnosticReportsByPatientQueryVariables>(GetDiagnosticReportsByPatientDocument, options);
      }
export function useGetDiagnosticReportsByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiagnosticReportsByPatientQuery, GetDiagnosticReportsByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiagnosticReportsByPatientQuery, GetDiagnosticReportsByPatientQueryVariables>(GetDiagnosticReportsByPatientDocument, options);
        }
export type GetDiagnosticReportsByPatientQueryHookResult = ReturnType<typeof useGetDiagnosticReportsByPatientQuery>;
export type GetDiagnosticReportsByPatientLazyQueryHookResult = ReturnType<typeof useGetDiagnosticReportsByPatientLazyQuery>;
export type GetDiagnosticReportsByPatientQueryResult = Apollo.QueryResult<GetDiagnosticReportsByPatientQuery, GetDiagnosticReportsByPatientQueryVariables>;
export const GetAcuityCalendarDocument = gql`
    mutation GetAcuityCalendar($providerId: String!) {
  GetAcuityCalendarInformation(providerId: $providerId) {
    calendar_id
    active
    owner_id
    provider_calendar
    provider_id
  }
}
    `;
export type GetAcuityCalendarMutationFn = Apollo.MutationFunction<GetAcuityCalendarMutation, GetAcuityCalendarMutationVariables>;

/**
 * __useGetAcuityCalendarMutation__
 *
 * To run a mutation, you first call `useGetAcuityCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAcuityCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAcuityCalendarMutation, { data, loading, error }] = useGetAcuityCalendarMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetAcuityCalendarMutation(baseOptions?: Apollo.MutationHookOptions<GetAcuityCalendarMutation, GetAcuityCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAcuityCalendarMutation, GetAcuityCalendarMutationVariables>(GetAcuityCalendarDocument, options);
      }
export type GetAcuityCalendarMutationHookResult = ReturnType<typeof useGetAcuityCalendarMutation>;
export type GetAcuityCalendarMutationResult = Apollo.MutationResult<GetAcuityCalendarMutation>;
export type GetAcuityCalendarMutationOptions = Apollo.BaseMutationOptions<GetAcuityCalendarMutation, GetAcuityCalendarMutationVariables>;
export const UpdateAvailabilityOverridesDocument = gql`
    mutation UpdateAvailabilityOverrides($overrides: [AvailabilityOverrideGroupInput!]!) {
  UpdateAvailabilityOverrides(
    updateAvailabilityOverridesInput: {overrides: $overrides}
  ) {
    message
    status
  }
}
    `;
export type UpdateAvailabilityOverridesMutationFn = Apollo.MutationFunction<UpdateAvailabilityOverridesMutation, UpdateAvailabilityOverridesMutationVariables>;

/**
 * __useUpdateAvailabilityOverridesMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityOverridesMutation, { data, loading, error }] = useUpdateAvailabilityOverridesMutation({
 *   variables: {
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useUpdateAvailabilityOverridesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityOverridesMutation, UpdateAvailabilityOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityOverridesMutation, UpdateAvailabilityOverridesMutationVariables>(UpdateAvailabilityOverridesDocument, options);
      }
export type UpdateAvailabilityOverridesMutationHookResult = ReturnType<typeof useUpdateAvailabilityOverridesMutation>;
export type UpdateAvailabilityOverridesMutationResult = Apollo.MutationResult<UpdateAvailabilityOverridesMutation>;
export type UpdateAvailabilityOverridesMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityOverridesMutation, UpdateAvailabilityOverridesMutationVariables>;
export const GetAcuityProviderTimeSlotsDocument = gql`
    query GetAcuityProviderTimeSlots($providerCalendarId: String!, $date: String!) {
  GetProviderTimeSlots(providerCalendarId: $providerCalendarId, date: $date) {
    providerWorkingHours {
      data {
        Monday
        Tuesday
        Wednesday
        Thursday
        Friday
        Saturday
        Sunday
      }
    }
    blocks {
      start
      end
      enabled
    }
  }
}
    `;

/**
 * __useGetAcuityProviderTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetAcuityProviderTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcuityProviderTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcuityProviderTimeSlotsQuery({
 *   variables: {
 *      providerCalendarId: // value for 'providerCalendarId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetAcuityProviderTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetAcuityProviderTimeSlotsQuery, GetAcuityProviderTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcuityProviderTimeSlotsQuery, GetAcuityProviderTimeSlotsQueryVariables>(GetAcuityProviderTimeSlotsDocument, options);
      }
export function useGetAcuityProviderTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcuityProviderTimeSlotsQuery, GetAcuityProviderTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcuityProviderTimeSlotsQuery, GetAcuityProviderTimeSlotsQueryVariables>(GetAcuityProviderTimeSlotsDocument, options);
        }
export type GetAcuityProviderTimeSlotsQueryHookResult = ReturnType<typeof useGetAcuityProviderTimeSlotsQuery>;
export type GetAcuityProviderTimeSlotsLazyQueryHookResult = ReturnType<typeof useGetAcuityProviderTimeSlotsLazyQuery>;
export type GetAcuityProviderTimeSlotsQueryResult = Apollo.QueryResult<GetAcuityProviderTimeSlotsQuery, GetAcuityProviderTimeSlotsQueryVariables>;
export const GetFreeProvidersByTimeSlotsDocument = gql`
    query GetFreeProvidersByTimeSlots($speciality: [String!], $providerCanSpeak: [String!], $search: String, $state: String, $offset: Int, $limit: Int, $gender: [String!], $date: String!, $appointmentTypeId: String!, $appointmentAccepted: [String!], $medicalRole: [String!], $serverOfferedRange: String, $sortBy: String, $sortByDirections: String, $yearOfExpirienceRange: String) {
  getFreeProvidersByTimeSlots(
    input: {date: $date, languages: $providerCanSpeak, gender: $gender, state: $state, specialty: $speciality, search: $search, appointmentTypeId: $appointmentTypeId, acceptedAppointments: $appointmentAccepted, medicalRole: $medicalRole, serverOfferedRange: $serverOfferedRange, sortBy: $sortBy, sortOrder: $sortByDirections, yearOfExperienceRange: $yearOfExpirienceRange}
    offset: $offset
    limit: $limit
  ) {
    total
    providers {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_email
      SENSITIVE_phone
      SENSITIVE_gender
      SENSITIVE_national_provider_identifier
      SENSITIVE_languages_of_communication
      SENSITIVE_about
      SENSITIVE_education {
        medicalSchool
        residency
        undergraduate
      }
      SENSITIVE_credentials {
        yearsOfPractice
        certifications
        fellowships
        medicalRole
        titles
        stateLicenses {
          id
          state
          licenseType
          licenseNumber
          expirationDate
        }
      }
      serviceOfferings {
        active
        healthCareServiceFhirId
        price
        priceCategory
        serviceType
      }
      SENSITIVE_address_information {
        address1
        address2
        country
        city
        state
        province
        zipCode
      }
      SENSITIVE_profile_picture_id
      SENSITIVE_office_information {
        officeName
        email
        address1
        city
        state
      }
    }
  }
}
    `;

/**
 * __useGetFreeProvidersByTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetFreeProvidersByTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeProvidersByTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeProvidersByTimeSlotsQuery({
 *   variables: {
 *      speciality: // value for 'speciality'
 *      providerCanSpeak: // value for 'providerCanSpeak'
 *      search: // value for 'search'
 *      state: // value for 'state'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      gender: // value for 'gender'
 *      date: // value for 'date'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      appointmentAccepted: // value for 'appointmentAccepted'
 *      medicalRole: // value for 'medicalRole'
 *      serverOfferedRange: // value for 'serverOfferedRange'
 *      sortBy: // value for 'sortBy'
 *      sortByDirections: // value for 'sortByDirections'
 *      yearOfExpirienceRange: // value for 'yearOfExpirienceRange'
 *   },
 * });
 */
export function useGetFreeProvidersByTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetFreeProvidersByTimeSlotsQuery, GetFreeProvidersByTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeProvidersByTimeSlotsQuery, GetFreeProvidersByTimeSlotsQueryVariables>(GetFreeProvidersByTimeSlotsDocument, options);
      }
export function useGetFreeProvidersByTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeProvidersByTimeSlotsQuery, GetFreeProvidersByTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeProvidersByTimeSlotsQuery, GetFreeProvidersByTimeSlotsQueryVariables>(GetFreeProvidersByTimeSlotsDocument, options);
        }
export type GetFreeProvidersByTimeSlotsQueryHookResult = ReturnType<typeof useGetFreeProvidersByTimeSlotsQuery>;
export type GetFreeProvidersByTimeSlotsLazyQueryHookResult = ReturnType<typeof useGetFreeProvidersByTimeSlotsLazyQuery>;
export type GetFreeProvidersByTimeSlotsQueryResult = Apollo.QueryResult<GetFreeProvidersByTimeSlotsQuery, GetFreeProvidersByTimeSlotsQueryVariables>;
export const GetProviderAvailabilityMonthDatesDocument = gql`
    query GetProviderAvailabilityMonthDates($appointmentTypeId: String!, $month: String!, $providerCalendarId: String, $isReschedule: Boolean) {
  GetProviderAvailabilityMonthDates(
    appointmentTypeId: $appointmentTypeId
    month: $month
    isReschedule: $isReschedule
    providerCalendarId: $providerCalendarId
  ) {
    dates
  }
}
    `;

/**
 * __useGetProviderAvailabilityMonthDatesQuery__
 *
 * To run a query within a React component, call `useGetProviderAvailabilityMonthDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAvailabilityMonthDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAvailabilityMonthDatesQuery({
 *   variables: {
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      month: // value for 'month'
 *      providerCalendarId: // value for 'providerCalendarId'
 *      isReschedule: // value for 'isReschedule'
 *   },
 * });
 */
export function useGetProviderAvailabilityMonthDatesQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAvailabilityMonthDatesQuery, GetProviderAvailabilityMonthDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAvailabilityMonthDatesQuery, GetProviderAvailabilityMonthDatesQueryVariables>(GetProviderAvailabilityMonthDatesDocument, options);
      }
export function useGetProviderAvailabilityMonthDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAvailabilityMonthDatesQuery, GetProviderAvailabilityMonthDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAvailabilityMonthDatesQuery, GetProviderAvailabilityMonthDatesQueryVariables>(GetProviderAvailabilityMonthDatesDocument, options);
        }
export type GetProviderAvailabilityMonthDatesQueryHookResult = ReturnType<typeof useGetProviderAvailabilityMonthDatesQuery>;
export type GetProviderAvailabilityMonthDatesLazyQueryHookResult = ReturnType<typeof useGetProviderAvailabilityMonthDatesLazyQuery>;
export type GetProviderAvailabilityMonthDatesQueryResult = Apollo.QueryResult<GetProviderAvailabilityMonthDatesQuery, GetProviderAvailabilityMonthDatesQueryVariables>;
export const GetProviderAvailabilityServiceTypesDocument = gql`
    query GetProviderAvailabilityServiceTypes($providerCalendarId: String!) {
  GetProviderAvailabilityServiceTypes(providerCalendarId: $providerCalendarId) {
    serviceTypes {
      active
      category
      description
      duration
      id
      name
      paddingAfter
      paddingBefore
      price
      type
    }
  }
}
    `;

/**
 * __useGetProviderAvailabilityServiceTypesQuery__
 *
 * To run a query within a React component, call `useGetProviderAvailabilityServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAvailabilityServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAvailabilityServiceTypesQuery({
 *   variables: {
 *      providerCalendarId: // value for 'providerCalendarId'
 *   },
 * });
 */
export function useGetProviderAvailabilityServiceTypesQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAvailabilityServiceTypesQuery, GetProviderAvailabilityServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAvailabilityServiceTypesQuery, GetProviderAvailabilityServiceTypesQueryVariables>(GetProviderAvailabilityServiceTypesDocument, options);
      }
export function useGetProviderAvailabilityServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAvailabilityServiceTypesQuery, GetProviderAvailabilityServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAvailabilityServiceTypesQuery, GetProviderAvailabilityServiceTypesQueryVariables>(GetProviderAvailabilityServiceTypesDocument, options);
        }
export type GetProviderAvailabilityServiceTypesQueryHookResult = ReturnType<typeof useGetProviderAvailabilityServiceTypesQuery>;
export type GetProviderAvailabilityServiceTypesLazyQueryHookResult = ReturnType<typeof useGetProviderAvailabilityServiceTypesLazyQuery>;
export type GetProviderAvailabilityServiceTypesQueryResult = Apollo.QueryResult<GetProviderAvailabilityServiceTypesQuery, GetProviderAvailabilityServiceTypesQueryVariables>;
export const GetProviderAvailabilityTimeSlotsDocument = gql`
    query GetProviderAvailabilityTimeSlots($appointmentTypeId: String!, $date: String!, $providerCalendarId: String, $isReschedule: Boolean) {
  GetProviderAvailabilityTimeSlots(
    appointmentTypeId: $appointmentTypeId
    date: $date
    providerCalendarId: $providerCalendarId
    isReschedule: $isReschedule
  ) {
    timeSlots {
      slotsAvailable
      time
    }
  }
}
    `;

/**
 * __useGetProviderAvailabilityTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetProviderAvailabilityTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderAvailabilityTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderAvailabilityTimeSlotsQuery({
 *   variables: {
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      date: // value for 'date'
 *      providerCalendarId: // value for 'providerCalendarId'
 *      isReschedule: // value for 'isReschedule'
 *   },
 * });
 */
export function useGetProviderAvailabilityTimeSlotsQuery(baseOptions: Apollo.QueryHookOptions<GetProviderAvailabilityTimeSlotsQuery, GetProviderAvailabilityTimeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderAvailabilityTimeSlotsQuery, GetProviderAvailabilityTimeSlotsQueryVariables>(GetProviderAvailabilityTimeSlotsDocument, options);
      }
export function useGetProviderAvailabilityTimeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderAvailabilityTimeSlotsQuery, GetProviderAvailabilityTimeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderAvailabilityTimeSlotsQuery, GetProviderAvailabilityTimeSlotsQueryVariables>(GetProviderAvailabilityTimeSlotsDocument, options);
        }
export type GetProviderAvailabilityTimeSlotsQueryHookResult = ReturnType<typeof useGetProviderAvailabilityTimeSlotsQuery>;
export type GetProviderAvailabilityTimeSlotsLazyQueryHookResult = ReturnType<typeof useGetProviderAvailabilityTimeSlotsLazyQuery>;
export type GetProviderAvailabilityTimeSlotsQueryResult = Apollo.QueryResult<GetProviderAvailabilityTimeSlotsQuery, GetProviderAvailabilityTimeSlotsQueryVariables>;
export const GetAvailableAppointmentTypesDocument = gql`
    query GetAvailableAppointmentTypes {
  GetAvailableAppointmentTypes {
    appointmentTypes {
      active
      addonIDs
      calendarIDs
      category
      classSize
      color
      description
      duration
      formIDs
      id
      name
      paddingAfter
      paddingBefore
      price
      type
      private
      schedulingUrl
      image
    }
  }
}
    `;

/**
 * __useGetAvailableAppointmentTypesQuery__
 *
 * To run a query within a React component, call `useGetAvailableAppointmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableAppointmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableAppointmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableAppointmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableAppointmentTypesQuery, GetAvailableAppointmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableAppointmentTypesQuery, GetAvailableAppointmentTypesQueryVariables>(GetAvailableAppointmentTypesDocument, options);
      }
export function useGetAvailableAppointmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableAppointmentTypesQuery, GetAvailableAppointmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableAppointmentTypesQuery, GetAvailableAppointmentTypesQueryVariables>(GetAvailableAppointmentTypesDocument, options);
        }
export type GetAvailableAppointmentTypesQueryHookResult = ReturnType<typeof useGetAvailableAppointmentTypesQuery>;
export type GetAvailableAppointmentTypesLazyQueryHookResult = ReturnType<typeof useGetAvailableAppointmentTypesLazyQuery>;
export type GetAvailableAppointmentTypesQueryResult = Apollo.QueryResult<GetAvailableAppointmentTypesQuery, GetAvailableAppointmentTypesQueryVariables>;
export const GetNotesByAppointmentIdDocument = gql`
    query GetNotesByAppointmentId($appointmentCodexId: String!) {
  getAppointmentNotesByAppointmentId(appointmentCodexId: $appointmentCodexId) {
    nabla_notes {
      appointment_id
      nabla_notes
    }
  }
}
    `;

/**
 * __useGetNotesByAppointmentIdQuery__
 *
 * To run a query within a React component, call `useGetNotesByAppointmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesByAppointmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesByAppointmentIdQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useGetNotesByAppointmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotesByAppointmentIdQuery, GetNotesByAppointmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesByAppointmentIdQuery, GetNotesByAppointmentIdQueryVariables>(GetNotesByAppointmentIdDocument, options);
      }
export function useGetNotesByAppointmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesByAppointmentIdQuery, GetNotesByAppointmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesByAppointmentIdQuery, GetNotesByAppointmentIdQueryVariables>(GetNotesByAppointmentIdDocument, options);
        }
export type GetNotesByAppointmentIdQueryHookResult = ReturnType<typeof useGetNotesByAppointmentIdQuery>;
export type GetNotesByAppointmentIdLazyQueryHookResult = ReturnType<typeof useGetNotesByAppointmentIdLazyQuery>;
export type GetNotesByAppointmentIdQueryResult = Apollo.QueryResult<GetNotesByAppointmentIdQuery, GetNotesByAppointmentIdQueryVariables>;
export const GetAvailabilityOverridesDocument = gql`
    query GetAvailabilityOverrides {
  GetAvailabilityOverrides {
    overrides {
      startDate
      intervals {
        toTimePeriod
        to
        fromTimePeriod
        from
      }
      endDate
    }
  }
}
    `;

/**
 * __useGetAvailabilityOverridesQuery__
 *
 * To run a query within a React component, call `useGetAvailabilityOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilityOverridesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailabilityOverridesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailabilityOverridesQuery, GetAvailabilityOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailabilityOverridesQuery, GetAvailabilityOverridesQueryVariables>(GetAvailabilityOverridesDocument, options);
      }
export function useGetAvailabilityOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailabilityOverridesQuery, GetAvailabilityOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailabilityOverridesQuery, GetAvailabilityOverridesQueryVariables>(GetAvailabilityOverridesDocument, options);
        }
export type GetAvailabilityOverridesQueryHookResult = ReturnType<typeof useGetAvailabilityOverridesQuery>;
export type GetAvailabilityOverridesLazyQueryHookResult = ReturnType<typeof useGetAvailabilityOverridesLazyQuery>;
export type GetAvailabilityOverridesQueryResult = Apollo.QueryResult<GetAvailabilityOverridesQuery, GetAvailabilityOverridesQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    code
    name
    flag
    id
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const UpsertEducationCourseDocument = gql`
    mutation UpsertEducationCourse($input: EducationCourseInput!) {
  upsertEducationCourse(input: $input) {
    message
    status
  }
}
    `;
export type UpsertEducationCourseMutationFn = Apollo.MutationFunction<UpsertEducationCourseMutation, UpsertEducationCourseMutationVariables>;

/**
 * __useUpsertEducationCourseMutation__
 *
 * To run a mutation, you first call `useUpsertEducationCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEducationCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEducationCourseMutation, { data, loading, error }] = useUpsertEducationCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEducationCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEducationCourseMutation, UpsertEducationCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEducationCourseMutation, UpsertEducationCourseMutationVariables>(UpsertEducationCourseDocument, options);
      }
export type UpsertEducationCourseMutationHookResult = ReturnType<typeof useUpsertEducationCourseMutation>;
export type UpsertEducationCourseMutationResult = Apollo.MutationResult<UpsertEducationCourseMutation>;
export type UpsertEducationCourseMutationOptions = Apollo.BaseMutationOptions<UpsertEducationCourseMutation, UpsertEducationCourseMutationVariables>;
export const DeleteEducationCourseDocument = gql`
    mutation DeleteEducationCourse($id: String!) {
  deleteEducationCourse(id: $id) {
    message
    status
  }
}
    `;
export type DeleteEducationCourseMutationFn = Apollo.MutationFunction<DeleteEducationCourseMutation, DeleteEducationCourseMutationVariables>;

/**
 * __useDeleteEducationCourseMutation__
 *
 * To run a mutation, you first call `useDeleteEducationCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEducationCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEducationCourseMutation, { data, loading, error }] = useDeleteEducationCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEducationCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEducationCourseMutation, DeleteEducationCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEducationCourseMutation, DeleteEducationCourseMutationVariables>(DeleteEducationCourseDocument, options);
      }
export type DeleteEducationCourseMutationHookResult = ReturnType<typeof useDeleteEducationCourseMutation>;
export type DeleteEducationCourseMutationResult = Apollo.MutationResult<DeleteEducationCourseMutation>;
export type DeleteEducationCourseMutationOptions = Apollo.BaseMutationOptions<DeleteEducationCourseMutation, DeleteEducationCourseMutationVariables>;
export const GetEducationCoursesDocument = gql`
    query GetEducationCourses($limit: Int = 10, $offset: Int = 0) {
  getEducationCourses(pagination: {limit: $limit, offset: $offset}) {
    courses {
      contentCounters {
        type
        value
      }
      courseImageFile {
        fileId
      }
      description
      createdAt
      id
      title
      updatedAt
      visibilityRoles
    }
    total
  }
}
    `;

/**
 * __useGetEducationCoursesQuery__
 *
 * To run a query within a React component, call `useGetEducationCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationCoursesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEducationCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetEducationCoursesQuery, GetEducationCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEducationCoursesQuery, GetEducationCoursesQueryVariables>(GetEducationCoursesDocument, options);
      }
export function useGetEducationCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEducationCoursesQuery, GetEducationCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEducationCoursesQuery, GetEducationCoursesQueryVariables>(GetEducationCoursesDocument, options);
        }
export type GetEducationCoursesQueryHookResult = ReturnType<typeof useGetEducationCoursesQuery>;
export type GetEducationCoursesLazyQueryHookResult = ReturnType<typeof useGetEducationCoursesLazyQuery>;
export type GetEducationCoursesQueryResult = Apollo.QueryResult<GetEducationCoursesQuery, GetEducationCoursesQueryVariables>;
export const GetEducationCourseDetailsDocument = gql`
    query GetEducationCourseDetails($id: String!) {
  getEducationCourseDetails(id: $id) {
    courseImageFile {
      fileId
    }
    description
    createdAt
    educationModules {
      additionalMaterialsModules {
        createdAt
        id
        linkedModule {
          courseId
          id
          title
        }
        linkedModuleId
        moduleId
      }
      courseId
      createdAt
      educationModuleItems {
        category
        createdAt
        file {
          contentType
          creation
          fileName
          size
          url
          fileId
        }
        id
        moduleId
        title
        updatedAt
      }
      id
      title
      updatedAt
    }
    id
    visibilityRoles
    title
    updatedAt
  }
}
    `;

/**
 * __useGetEducationCourseDetailsQuery__
 *
 * To run a query within a React component, call `useGetEducationCourseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationCourseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationCourseDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEducationCourseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEducationCourseDetailsQuery, GetEducationCourseDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEducationCourseDetailsQuery, GetEducationCourseDetailsQueryVariables>(GetEducationCourseDetailsDocument, options);
      }
export function useGetEducationCourseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEducationCourseDetailsQuery, GetEducationCourseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEducationCourseDetailsQuery, GetEducationCourseDetailsQueryVariables>(GetEducationCourseDetailsDocument, options);
        }
export type GetEducationCourseDetailsQueryHookResult = ReturnType<typeof useGetEducationCourseDetailsQuery>;
export type GetEducationCourseDetailsLazyQueryHookResult = ReturnType<typeof useGetEducationCourseDetailsLazyQuery>;
export type GetEducationCourseDetailsQueryResult = Apollo.QueryResult<GetEducationCourseDetailsQuery, GetEducationCourseDetailsQueryVariables>;
export const GetEducationModulesDocument = gql`
    query GetEducationModules($query: String, $roles: [ROLES_ENUM!], $excludeModuleIds: [String!], $limit: Int = 10, $offset: Int = 0) {
  getEducationModules(
    filters: {query: $query, excludeModuleIds: $excludeModuleIds, roles: $roles}
    pagination: {limit: $limit, offset: $offset}
  ) {
    modules {
      title
      id
    }
  }
}
    `;

/**
 * __useGetEducationModulesQuery__
 *
 * To run a query within a React component, call `useGetEducationModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationModulesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      roles: // value for 'roles'
 *      excludeModuleIds: // value for 'excludeModuleIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEducationModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetEducationModulesQuery, GetEducationModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEducationModulesQuery, GetEducationModulesQueryVariables>(GetEducationModulesDocument, options);
      }
export function useGetEducationModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEducationModulesQuery, GetEducationModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEducationModulesQuery, GetEducationModulesQueryVariables>(GetEducationModulesDocument, options);
        }
export type GetEducationModulesQueryHookResult = ReturnType<typeof useGetEducationModulesQuery>;
export type GetEducationModulesLazyQueryHookResult = ReturnType<typeof useGetEducationModulesLazyQuery>;
export type GetEducationModulesQueryResult = Apollo.QueryResult<GetEducationModulesQuery, GetEducationModulesQueryVariables>;
export const RegisterTestKitDocument = gql`
    mutation RegisterTestKit($swabBarcode: String!, $trackingNumber: String, $testType: String!, $questionnaireResponses: jsonb!, $questionnaireResponseResourceId: String) {
  RegisterTestKit(
    testKit: {swabBarcode: $swabBarcode, trackingNumber: $trackingNumber, testType: $testType, questionnaireResponses: $questionnaireResponses, questionnaireResponseResourceId: $questionnaireResponseResourceId}
  ) {
    status
    message
  }
}
    `;
export type RegisterTestKitMutationFn = Apollo.MutationFunction<RegisterTestKitMutation, RegisterTestKitMutationVariables>;

/**
 * __useRegisterTestKitMutation__
 *
 * To run a mutation, you first call `useRegisterTestKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterTestKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerTestKitMutation, { data, loading, error }] = useRegisterTestKitMutation({
 *   variables: {
 *      swabBarcode: // value for 'swabBarcode'
 *      trackingNumber: // value for 'trackingNumber'
 *      testType: // value for 'testType'
 *      questionnaireResponses: // value for 'questionnaireResponses'
 *      questionnaireResponseResourceId: // value for 'questionnaireResponseResourceId'
 *   },
 * });
 */
export function useRegisterTestKitMutation(baseOptions?: Apollo.MutationHookOptions<RegisterTestKitMutation, RegisterTestKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterTestKitMutation, RegisterTestKitMutationVariables>(RegisterTestKitDocument, options);
      }
export type RegisterTestKitMutationHookResult = ReturnType<typeof useRegisterTestKitMutation>;
export type RegisterTestKitMutationResult = Apollo.MutationResult<RegisterTestKitMutation>;
export type RegisterTestKitMutationOptions = Apollo.BaseMutationOptions<RegisterTestKitMutation, RegisterTestKitMutationVariables>;
export const RegisterDiagnosticSolutionTestKitDocument = gql`
    mutation registerDiagnosticSolutionTestKit($providerCodexId: String!, $zrtSwabCode: String!, $trackingNumber: String) {
  RegisterDiagnosticSolutionTestKit(
    registerTestKitDto: {codexProviderId: $providerCodexId, swabCode: $zrtSwabCode, trackingNumber: $trackingNumber}
  ) {
    testId
    test_type
  }
}
    `;
export type RegisterDiagnosticSolutionTestKitMutationFn = Apollo.MutationFunction<RegisterDiagnosticSolutionTestKitMutation, RegisterDiagnosticSolutionTestKitMutationVariables>;

/**
 * __useRegisterDiagnosticSolutionTestKitMutation__
 *
 * To run a mutation, you first call `useRegisterDiagnosticSolutionTestKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDiagnosticSolutionTestKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDiagnosticSolutionTestKitMutation, { data, loading, error }] = useRegisterDiagnosticSolutionTestKitMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *      zrtSwabCode: // value for 'zrtSwabCode'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useRegisterDiagnosticSolutionTestKitMutation(baseOptions?: Apollo.MutationHookOptions<RegisterDiagnosticSolutionTestKitMutation, RegisterDiagnosticSolutionTestKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterDiagnosticSolutionTestKitMutation, RegisterDiagnosticSolutionTestKitMutationVariables>(RegisterDiagnosticSolutionTestKitDocument, options);
      }
export type RegisterDiagnosticSolutionTestKitMutationHookResult = ReturnType<typeof useRegisterDiagnosticSolutionTestKitMutation>;
export type RegisterDiagnosticSolutionTestKitMutationResult = Apollo.MutationResult<RegisterDiagnosticSolutionTestKitMutation>;
export type RegisterDiagnosticSolutionTestKitMutationOptions = Apollo.BaseMutationOptions<RegisterDiagnosticSolutionTestKitMutation, RegisterDiagnosticSolutionTestKitMutationVariables>;
export const RegisterTestKitByMyProviderDocument = gql`
    mutation RegisterTestKitByMyProvider($providerCodexId: String!, $testType: String!, $trackingNumber: String, $zrtSwabCode: String!) {
  requestZrtTest(
    providerCodexId: $providerCodexId
    testType: $testType
    zrtSwabCode: $zrtSwabCode
    trackingNumber: $trackingNumber
  ) {
    requestStatus
    serviceRequestId
  }
}
    `;
export type RegisterTestKitByMyProviderMutationFn = Apollo.MutationFunction<RegisterTestKitByMyProviderMutation, RegisterTestKitByMyProviderMutationVariables>;

/**
 * __useRegisterTestKitByMyProviderMutation__
 *
 * To run a mutation, you first call `useRegisterTestKitByMyProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterTestKitByMyProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerTestKitByMyProviderMutation, { data, loading, error }] = useRegisterTestKitByMyProviderMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *      testType: // value for 'testType'
 *      trackingNumber: // value for 'trackingNumber'
 *      zrtSwabCode: // value for 'zrtSwabCode'
 *   },
 * });
 */
export function useRegisterTestKitByMyProviderMutation(baseOptions?: Apollo.MutationHookOptions<RegisterTestKitByMyProviderMutation, RegisterTestKitByMyProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterTestKitByMyProviderMutation, RegisterTestKitByMyProviderMutationVariables>(RegisterTestKitByMyProviderDocument, options);
      }
export type RegisterTestKitByMyProviderMutationHookResult = ReturnType<typeof useRegisterTestKitByMyProviderMutation>;
export type RegisterTestKitByMyProviderMutationResult = Apollo.MutationResult<RegisterTestKitByMyProviderMutation>;
export type RegisterTestKitByMyProviderMutationOptions = Apollo.BaseMutationOptions<RegisterTestKitByMyProviderMutation, RegisterTestKitByMyProviderMutationVariables>;
export const RegisterMosaicTestKitDocument = gql`
    mutation registerMosaicTestKit($providerCodexId: String!, $testId: String!, $validateNpi: Boolean, $trackingNumber: String) {
  RegisterMosaicTestKit(
    registerTestKitDto: {providerCodexId: $providerCodexId, testId: $testId, validateNpi: $validateNpi, trackingNumber: $trackingNumber}
  ) {
    testId
    trackingNumber
  }
}
    `;
export type RegisterMosaicTestKitMutationFn = Apollo.MutationFunction<RegisterMosaicTestKitMutation, RegisterMosaicTestKitMutationVariables>;

/**
 * __useRegisterMosaicTestKitMutation__
 *
 * To run a mutation, you first call `useRegisterMosaicTestKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMosaicTestKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMosaicTestKitMutation, { data, loading, error }] = useRegisterMosaicTestKitMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *      testId: // value for 'testId'
 *      validateNpi: // value for 'validateNpi'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useRegisterMosaicTestKitMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMosaicTestKitMutation, RegisterMosaicTestKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMosaicTestKitMutation, RegisterMosaicTestKitMutationVariables>(RegisterMosaicTestKitDocument, options);
      }
export type RegisterMosaicTestKitMutationHookResult = ReturnType<typeof useRegisterMosaicTestKitMutation>;
export type RegisterMosaicTestKitMutationResult = Apollo.MutationResult<RegisterMosaicTestKitMutation>;
export type RegisterMosaicTestKitMutationOptions = Apollo.BaseMutationOptions<RegisterMosaicTestKitMutation, RegisterMosaicTestKitMutationVariables>;
export const UpdateTestKitProviderDocument = gql`
    mutation UpdateTestKitProvider($providerCodexId: String!, $swabCode: String!) {
  updateTestKitProvider(providerCodexId: $providerCodexId, swabCode: $swabCode) {
    message
    status
  }
}
    `;
export type UpdateTestKitProviderMutationFn = Apollo.MutationFunction<UpdateTestKitProviderMutation, UpdateTestKitProviderMutationVariables>;

/**
 * __useUpdateTestKitProviderMutation__
 *
 * To run a mutation, you first call `useUpdateTestKitProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestKitProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestKitProviderMutation, { data, loading, error }] = useUpdateTestKitProviderMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *      swabCode: // value for 'swabCode'
 *   },
 * });
 */
export function useUpdateTestKitProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestKitProviderMutation, UpdateTestKitProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestKitProviderMutation, UpdateTestKitProviderMutationVariables>(UpdateTestKitProviderDocument, options);
      }
export type UpdateTestKitProviderMutationHookResult = ReturnType<typeof useUpdateTestKitProviderMutation>;
export type UpdateTestKitProviderMutationResult = Apollo.MutationResult<UpdateTestKitProviderMutation>;
export type UpdateTestKitProviderMutationOptions = Apollo.BaseMutationOptions<UpdateTestKitProviderMutation, UpdateTestKitProviderMutationVariables>;
export const RegisterDnaVitaminTestKitDocument = gql`
    mutation RegisterDnaVitaminTestKit($testKitId: String!, $trackingNumber: String) {
  RegisterDnaVitaminTestKit(
    registerTestKitDto: {trackingNumber: $trackingNumber, testKitId: $testKitId}
  ) {
    dnaVitaminOrderId
    testKitId
    trackingNumber
  }
}
    `;
export type RegisterDnaVitaminTestKitMutationFn = Apollo.MutationFunction<RegisterDnaVitaminTestKitMutation, RegisterDnaVitaminTestKitMutationVariables>;

/**
 * __useRegisterDnaVitaminTestKitMutation__
 *
 * To run a mutation, you first call `useRegisterDnaVitaminTestKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDnaVitaminTestKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDnaVitaminTestKitMutation, { data, loading, error }] = useRegisterDnaVitaminTestKitMutation({
 *   variables: {
 *      testKitId: // value for 'testKitId'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useRegisterDnaVitaminTestKitMutation(baseOptions?: Apollo.MutationHookOptions<RegisterDnaVitaminTestKitMutation, RegisterDnaVitaminTestKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterDnaVitaminTestKitMutation, RegisterDnaVitaminTestKitMutationVariables>(RegisterDnaVitaminTestKitDocument, options);
      }
export type RegisterDnaVitaminTestKitMutationHookResult = ReturnType<typeof useRegisterDnaVitaminTestKitMutation>;
export type RegisterDnaVitaminTestKitMutationResult = Apollo.MutationResult<RegisterDnaVitaminTestKitMutation>;
export type RegisterDnaVitaminTestKitMutationOptions = Apollo.BaseMutationOptions<RegisterDnaVitaminTestKitMutation, RegisterDnaVitaminTestKitMutationVariables>;
export const DeleteRecommendationByRequestUserCodexIdDocument = gql`
    mutation DeleteRecommendationByRequestUserCodexId($recommendationId: String!) {
  deleteRecommendationByRequestUserCodexId(recommendationId: $recommendationId) {
    message
    status
  }
}
    `;
export type DeleteRecommendationByRequestUserCodexIdMutationFn = Apollo.MutationFunction<DeleteRecommendationByRequestUserCodexIdMutation, DeleteRecommendationByRequestUserCodexIdMutationVariables>;

/**
 * __useDeleteRecommendationByRequestUserCodexIdMutation__
 *
 * To run a mutation, you first call `useDeleteRecommendationByRequestUserCodexIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecommendationByRequestUserCodexIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecommendationByRequestUserCodexIdMutation, { data, loading, error }] = useDeleteRecommendationByRequestUserCodexIdMutation({
 *   variables: {
 *      recommendationId: // value for 'recommendationId'
 *   },
 * });
 */
export function useDeleteRecommendationByRequestUserCodexIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecommendationByRequestUserCodexIdMutation, DeleteRecommendationByRequestUserCodexIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecommendationByRequestUserCodexIdMutation, DeleteRecommendationByRequestUserCodexIdMutationVariables>(DeleteRecommendationByRequestUserCodexIdDocument, options);
      }
export type DeleteRecommendationByRequestUserCodexIdMutationHookResult = ReturnType<typeof useDeleteRecommendationByRequestUserCodexIdMutation>;
export type DeleteRecommendationByRequestUserCodexIdMutationResult = Apollo.MutationResult<DeleteRecommendationByRequestUserCodexIdMutation>;
export type DeleteRecommendationByRequestUserCodexIdMutationOptions = Apollo.BaseMutationOptions<DeleteRecommendationByRequestUserCodexIdMutation, DeleteRecommendationByRequestUserCodexIdMutationVariables>;
export const RequestDnaTestKitDocument = gql`
    mutation RequestDnaTestKit($swabCode: String!, $providerCodexId: String, $testType: Hasura_Test_Types_Enum!, $trackingNumber: String) {
  requestDnaTestKit(
    input: {swabCode: $swabCode, testType: $testType, trackingNumber: $trackingNumber, providerCodexId: $providerCodexId}
  ) {
    success
    swabCode
  }
}
    `;
export type RequestDnaTestKitMutationFn = Apollo.MutationFunction<RequestDnaTestKitMutation, RequestDnaTestKitMutationVariables>;

/**
 * __useRequestDnaTestKitMutation__
 *
 * To run a mutation, you first call `useRequestDnaTestKitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDnaTestKitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDnaTestKitMutation, { data, loading, error }] = useRequestDnaTestKitMutation({
 *   variables: {
 *      swabCode: // value for 'swabCode'
 *      providerCodexId: // value for 'providerCodexId'
 *      testType: // value for 'testType'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useRequestDnaTestKitMutation(baseOptions?: Apollo.MutationHookOptions<RequestDnaTestKitMutation, RequestDnaTestKitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDnaTestKitMutation, RequestDnaTestKitMutationVariables>(RequestDnaTestKitDocument, options);
      }
export type RequestDnaTestKitMutationHookResult = ReturnType<typeof useRequestDnaTestKitMutation>;
export type RequestDnaTestKitMutationResult = Apollo.MutationResult<RequestDnaTestKitMutation>;
export type RequestDnaTestKitMutationOptions = Apollo.BaseMutationOptions<RequestDnaTestKitMutation, RequestDnaTestKitMutationVariables>;
export const PendingPatientZrtTestDocument = gql`
    query PendingPatientZrtTest($offset: Int, $limit: Int, $userId: uuid) {
  pending_patient_zrt(
    where: {user_id: {_eq: $userId}}
    offset: $offset
    limit: $limit
    distinct_on: created_at
    order_by: {created_at: desc}
  ) {
    id
    created_at
    notification_id
    provider_full_name
    test_type
    swabcode
    status
    provider_id
    user_id
  }
}
    `;

/**
 * __usePendingPatientZrtTestQuery__
 *
 * To run a query within a React component, call `usePendingPatientZrtTestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingPatientZrtTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingPatientZrtTestQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePendingPatientZrtTestQuery(baseOptions?: Apollo.QueryHookOptions<PendingPatientZrtTestQuery, PendingPatientZrtTestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingPatientZrtTestQuery, PendingPatientZrtTestQueryVariables>(PendingPatientZrtTestDocument, options);
      }
export function usePendingPatientZrtTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingPatientZrtTestQuery, PendingPatientZrtTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingPatientZrtTestQuery, PendingPatientZrtTestQueryVariables>(PendingPatientZrtTestDocument, options);
        }
export type PendingPatientZrtTestQueryHookResult = ReturnType<typeof usePendingPatientZrtTestQuery>;
export type PendingPatientZrtTestLazyQueryHookResult = ReturnType<typeof usePendingPatientZrtTestLazyQuery>;
export type PendingPatientZrtTestQueryResult = Apollo.QueryResult<PendingPatientZrtTestQuery, PendingPatientZrtTestQueryVariables>;
export const GetTestKitResultsByRequestPatientCodexIdForPatientDocument = gql`
    query GetTestKitResultsByRequestPatientCodexIdForPatient($fromDate: String, $toDate: String, $limit: Int = 10, $offset: Int = 0, $providerFullNameQuery: String, $testType: [Hasura_Test_Types_Enum!]) {
  getTestKitResultsByRequestPatientCodexId(
    input: {dates: {fromDate: $fromDate, toDate: $toDate}, pagination: {limit: $limit, offset: $offset}, providerFullNameQuery: $providerFullNameQuery, testType: $testType}
  ) {
    diagnosticReports {
      createdAt
      diagnosticReportId
      diagnosticReportStatus
      diagnosticReportTestType
      patientPdf {
        contentType
        creation
        fileId
        fileName
        size
        url
      }
      providerCodexId
      providerFirstName
      providerLastName
      swabCode
    }
    total
  }
}
    `;

/**
 * __useGetTestKitResultsByRequestPatientCodexIdForPatientQuery__
 *
 * To run a query within a React component, call `useGetTestKitResultsByRequestPatientCodexIdForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestKitResultsByRequestPatientCodexIdForPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestKitResultsByRequestPatientCodexIdForPatientQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerFullNameQuery: // value for 'providerFullNameQuery'
 *      testType: // value for 'testType'
 *   },
 * });
 */
export function useGetTestKitResultsByRequestPatientCodexIdForPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetTestKitResultsByRequestPatientCodexIdForPatientQuery, GetTestKitResultsByRequestPatientCodexIdForPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestKitResultsByRequestPatientCodexIdForPatientQuery, GetTestKitResultsByRequestPatientCodexIdForPatientQueryVariables>(GetTestKitResultsByRequestPatientCodexIdForPatientDocument, options);
      }
export function useGetTestKitResultsByRequestPatientCodexIdForPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestKitResultsByRequestPatientCodexIdForPatientQuery, GetTestKitResultsByRequestPatientCodexIdForPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestKitResultsByRequestPatientCodexIdForPatientQuery, GetTestKitResultsByRequestPatientCodexIdForPatientQueryVariables>(GetTestKitResultsByRequestPatientCodexIdForPatientDocument, options);
        }
export type GetTestKitResultsByRequestPatientCodexIdForPatientQueryHookResult = ReturnType<typeof useGetTestKitResultsByRequestPatientCodexIdForPatientQuery>;
export type GetTestKitResultsByRequestPatientCodexIdForPatientLazyQueryHookResult = ReturnType<typeof useGetTestKitResultsByRequestPatientCodexIdForPatientLazyQuery>;
export type GetTestKitResultsByRequestPatientCodexIdForPatientQueryResult = Apollo.QueryResult<GetTestKitResultsByRequestPatientCodexIdForPatientQuery, GetTestKitResultsByRequestPatientCodexIdForPatientQueryVariables>;
export const PendingZrtTestDocument = gql`
    subscription PendingZrtTest($offset: Int, $limit: Int, $userId: uuid) {
  pending_patient_zrt(
    where: {user_id: {_eq: $userId}}
    offset: $offset
    limit: $limit
    distinct_on: created_at
    order_by: {created_at: desc}
  ) {
    id
    created_at
    notification_id
    provider_full_name
    test_type
    swabcode
    status
    provider_id
    user_id
    questionnaire_required
    questionnaire_updated_at
    diagnostic_report_id
    user {
      id
      account_closed_at
      SENSITIVE_firstname
      SENSITIVE_lastname
    }
  }
}
    `;

/**
 * __usePendingZrtTestSubscription__
 *
 * To run a query within a React component, call `usePendingZrtTestSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePendingZrtTestSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingZrtTestSubscription({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePendingZrtTestSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PendingZrtTestSubscription, PendingZrtTestSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PendingZrtTestSubscription, PendingZrtTestSubscriptionVariables>(PendingZrtTestDocument, options);
      }
export type PendingZrtTestSubscriptionHookResult = ReturnType<typeof usePendingZrtTestSubscription>;
export type PendingZrtTestSubscriptionResult = Apollo.SubscriptionResult<PendingZrtTestSubscription>;
export const GetDnaTestKitWithResultByUserIdDocument = gql`
    subscription GetDnaTestKitWithResultByUserId($userId: uuid!) {
  tests(
    where: {tests_test_definition: {test_type: {_eq: DNA_VITAMIN}}, user_id: {_eq: $userId}, state: {_eq: RESULTS_WITH_PROVIDER}}
    order_by: {created_at: desc}
    limit: 2
  ) {
    user_id
    state
    test_id
  }
}
    `;

/**
 * __useGetDnaTestKitWithResultByUserIdSubscription__
 *
 * To run a query within a React component, call `useGetDnaTestKitWithResultByUserIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDnaTestKitWithResultByUserIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDnaTestKitWithResultByUserIdSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDnaTestKitWithResultByUserIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetDnaTestKitWithResultByUserIdSubscription, GetDnaTestKitWithResultByUserIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDnaTestKitWithResultByUserIdSubscription, GetDnaTestKitWithResultByUserIdSubscriptionVariables>(GetDnaTestKitWithResultByUserIdDocument, options);
      }
export type GetDnaTestKitWithResultByUserIdSubscriptionHookResult = ReturnType<typeof useGetDnaTestKitWithResultByUserIdSubscription>;
export type GetDnaTestKitWithResultByUserIdSubscriptionResult = Apollo.SubscriptionResult<GetDnaTestKitWithResultByUserIdSubscription>;
export const GetLatestDnaVisitTestsDocument = gql`
    mutation GetLatestDnaVisitTests {
  GetLatestDnaVisitTests
}
    `;
export type GetLatestDnaVisitTestsMutationFn = Apollo.MutationFunction<GetLatestDnaVisitTestsMutation, GetLatestDnaVisitTestsMutationVariables>;

/**
 * __useGetLatestDnaVisitTestsMutation__
 *
 * To run a mutation, you first call `useGetLatestDnaVisitTestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLatestDnaVisitTestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLatestDnaVisitTestsMutation, { data, loading, error }] = useGetLatestDnaVisitTestsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestDnaVisitTestsMutation(baseOptions?: Apollo.MutationHookOptions<GetLatestDnaVisitTestsMutation, GetLatestDnaVisitTestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetLatestDnaVisitTestsMutation, GetLatestDnaVisitTestsMutationVariables>(GetLatestDnaVisitTestsDocument, options);
      }
export type GetLatestDnaVisitTestsMutationHookResult = ReturnType<typeof useGetLatestDnaVisitTestsMutation>;
export type GetLatestDnaVisitTestsMutationResult = Apollo.MutationResult<GetLatestDnaVisitTestsMutation>;
export type GetLatestDnaVisitTestsMutationOptions = Apollo.BaseMutationOptions<GetLatestDnaVisitTestsMutation, GetLatestDnaVisitTestsMutationVariables>;
export const GetDnaTestBySwabcodeIdWithNoErrorsDocument = gql`
    mutation GetDnaTestBySwabcodeIdWithNoErrors($swabCode: String!) {
  getDnaTestBySwabCodeIDWithNoErrors(swab_code: $swabCode) {
    existingDnaTests
  }
}
    `;
export type GetDnaTestBySwabcodeIdWithNoErrorsMutationFn = Apollo.MutationFunction<GetDnaTestBySwabcodeIdWithNoErrorsMutation, GetDnaTestBySwabcodeIdWithNoErrorsMutationVariables>;

/**
 * __useGetDnaTestBySwabcodeIdWithNoErrorsMutation__
 *
 * To run a mutation, you first call `useGetDnaTestBySwabcodeIdWithNoErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDnaTestBySwabcodeIdWithNoErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDnaTestBySwabcodeIdWithNoErrorsMutation, { data, loading, error }] = useGetDnaTestBySwabcodeIdWithNoErrorsMutation({
 *   variables: {
 *      swabCode: // value for 'swabCode'
 *   },
 * });
 */
export function useGetDnaTestBySwabcodeIdWithNoErrorsMutation(baseOptions?: Apollo.MutationHookOptions<GetDnaTestBySwabcodeIdWithNoErrorsMutation, GetDnaTestBySwabcodeIdWithNoErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDnaTestBySwabcodeIdWithNoErrorsMutation, GetDnaTestBySwabcodeIdWithNoErrorsMutationVariables>(GetDnaTestBySwabcodeIdWithNoErrorsDocument, options);
      }
export type GetDnaTestBySwabcodeIdWithNoErrorsMutationHookResult = ReturnType<typeof useGetDnaTestBySwabcodeIdWithNoErrorsMutation>;
export type GetDnaTestBySwabcodeIdWithNoErrorsMutationResult = Apollo.MutationResult<GetDnaTestBySwabcodeIdWithNoErrorsMutation>;
export type GetDnaTestBySwabcodeIdWithNoErrorsMutationOptions = Apollo.BaseMutationOptions<GetDnaTestBySwabcodeIdWithNoErrorsMutation, GetDnaTestBySwabcodeIdWithNoErrorsMutationVariables>;
export const GetLatestDnaTestsForSuperAdminDocument = gql`
    query GetLatestDnaTestsForSuperAdmin {
  dnavisit_tests(
    order_by: {created_at: desc}
    where: {created_at: {_gte: "2023-10-01T00:00:00Z"}}
  ) {
    state
    errors
    dnavisit_tests_test {
      tests_user {
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_email
        id
      }
      tests_test_definition {
        test_type
      }
    }
    sapphiros_barcode
    created_at
    tracking_number
    dna_test_questionnaire_pdf_id
    health_questionnaire_pdf_id
    provider_report_pdf_id
    patient_pdf_id
    sapphiros_report_pdf_id
    visit_summary_pdf_id
  }
}
    `;

/**
 * __useGetLatestDnaTestsForSuperAdminQuery__
 *
 * To run a query within a React component, call `useGetLatestDnaTestsForSuperAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestDnaTestsForSuperAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestDnaTestsForSuperAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestDnaTestsForSuperAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestDnaTestsForSuperAdminQuery, GetLatestDnaTestsForSuperAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestDnaTestsForSuperAdminQuery, GetLatestDnaTestsForSuperAdminQueryVariables>(GetLatestDnaTestsForSuperAdminDocument, options);
      }
export function useGetLatestDnaTestsForSuperAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestDnaTestsForSuperAdminQuery, GetLatestDnaTestsForSuperAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestDnaTestsForSuperAdminQuery, GetLatestDnaTestsForSuperAdminQueryVariables>(GetLatestDnaTestsForSuperAdminDocument, options);
        }
export type GetLatestDnaTestsForSuperAdminQueryHookResult = ReturnType<typeof useGetLatestDnaTestsForSuperAdminQuery>;
export type GetLatestDnaTestsForSuperAdminLazyQueryHookResult = ReturnType<typeof useGetLatestDnaTestsForSuperAdminLazyQuery>;
export type GetLatestDnaTestsForSuperAdminQueryResult = Apollo.QueryResult<GetLatestDnaTestsForSuperAdminQuery, GetLatestDnaTestsForSuperAdminQueryVariables>;
export const ValidateFedexTrackingNumberDocument = gql`
    query ValidateFedexTrackingNumber($trackingNumber: String!) {
  ValidateFedexTrackingNumber(trackingNumber: $trackingNumber) {
    isValid
  }
}
    `;

/**
 * __useValidateFedexTrackingNumberQuery__
 *
 * To run a query within a React component, call `useValidateFedexTrackingNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateFedexTrackingNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateFedexTrackingNumberQuery({
 *   variables: {
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useValidateFedexTrackingNumberQuery(baseOptions: Apollo.QueryHookOptions<ValidateFedexTrackingNumberQuery, ValidateFedexTrackingNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateFedexTrackingNumberQuery, ValidateFedexTrackingNumberQueryVariables>(ValidateFedexTrackingNumberDocument, options);
      }
export function useValidateFedexTrackingNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateFedexTrackingNumberQuery, ValidateFedexTrackingNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateFedexTrackingNumberQuery, ValidateFedexTrackingNumberQueryVariables>(ValidateFedexTrackingNumberDocument, options);
        }
export type ValidateFedexTrackingNumberQueryHookResult = ReturnType<typeof useValidateFedexTrackingNumberQuery>;
export type ValidateFedexTrackingNumberLazyQueryHookResult = ReturnType<typeof useValidateFedexTrackingNumberLazyQuery>;
export type ValidateFedexTrackingNumberQueryResult = Apollo.QueryResult<ValidateFedexTrackingNumberQuery, ValidateFedexTrackingNumberQueryVariables>;
export const GetSignedUrlFromStorageDocument = gql`
    mutation GetSignedUrlFromStorage($fileId: String!) {
  GetSignUrlFormStorage(fileId: $fileId) {
    status
    url
  }
}
    `;
export type GetSignedUrlFromStorageMutationFn = Apollo.MutationFunction<GetSignedUrlFromStorageMutation, GetSignedUrlFromStorageMutationVariables>;

/**
 * __useGetSignedUrlFromStorageMutation__
 *
 * To run a mutation, you first call `useGetSignedUrlFromStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlFromStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUrlFromStorageMutation, { data, loading, error }] = useGetSignedUrlFromStorageMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetSignedUrlFromStorageMutation(baseOptions?: Apollo.MutationHookOptions<GetSignedUrlFromStorageMutation, GetSignedUrlFromStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSignedUrlFromStorageMutation, GetSignedUrlFromStorageMutationVariables>(GetSignedUrlFromStorageDocument, options);
      }
export type GetSignedUrlFromStorageMutationHookResult = ReturnType<typeof useGetSignedUrlFromStorageMutation>;
export type GetSignedUrlFromStorageMutationResult = Apollo.MutationResult<GetSignedUrlFromStorageMutation>;
export type GetSignedUrlFromStorageMutationOptions = Apollo.BaseMutationOptions<GetSignedUrlFromStorageMutation, GetSignedUrlFromStorageMutationVariables>;
export const GetSignedUrlFromStorageByAdminDocument = gql`
    mutation GetSignedUrlFromStorageByAdmin($userId: String!, $fileId: String!) {
  GetSignUrlFromStorageByAdmin(filePath: {userId: $userId, fileId: $fileId}) {
    status
    url
  }
}
    `;
export type GetSignedUrlFromStorageByAdminMutationFn = Apollo.MutationFunction<GetSignedUrlFromStorageByAdminMutation, GetSignedUrlFromStorageByAdminMutationVariables>;

/**
 * __useGetSignedUrlFromStorageByAdminMutation__
 *
 * To run a mutation, you first call `useGetSignedUrlFromStorageByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlFromStorageByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUrlFromStorageByAdminMutation, { data, loading, error }] = useGetSignedUrlFromStorageByAdminMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetSignedUrlFromStorageByAdminMutation(baseOptions?: Apollo.MutationHookOptions<GetSignedUrlFromStorageByAdminMutation, GetSignedUrlFromStorageByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSignedUrlFromStorageByAdminMutation, GetSignedUrlFromStorageByAdminMutationVariables>(GetSignedUrlFromStorageByAdminDocument, options);
      }
export type GetSignedUrlFromStorageByAdminMutationHookResult = ReturnType<typeof useGetSignedUrlFromStorageByAdminMutation>;
export type GetSignedUrlFromStorageByAdminMutationResult = Apollo.MutationResult<GetSignedUrlFromStorageByAdminMutation>;
export type GetSignedUrlFromStorageByAdminMutationOptions = Apollo.BaseMutationOptions<GetSignedUrlFromStorageByAdminMutation, GetSignedUrlFromStorageByAdminMutationVariables>;
export const GetVonageSignUrlFormStorageDocument = gql`
    mutation GetVonageSignUrlFormStorage($appointmentId: String!, $fileId: String!) {
  GetVonageSignUrlFormStorage(appointmentId: $appointmentId, fileId: $fileId) {
    status
    url
  }
}
    `;
export type GetVonageSignUrlFormStorageMutationFn = Apollo.MutationFunction<GetVonageSignUrlFormStorageMutation, GetVonageSignUrlFormStorageMutationVariables>;

/**
 * __useGetVonageSignUrlFormStorageMutation__
 *
 * To run a mutation, you first call `useGetVonageSignUrlFormStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVonageSignUrlFormStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVonageSignUrlFormStorageMutation, { data, loading, error }] = useGetVonageSignUrlFormStorageMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetVonageSignUrlFormStorageMutation(baseOptions?: Apollo.MutationHookOptions<GetVonageSignUrlFormStorageMutation, GetVonageSignUrlFormStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetVonageSignUrlFormStorageMutation, GetVonageSignUrlFormStorageMutationVariables>(GetVonageSignUrlFormStorageDocument, options);
      }
export type GetVonageSignUrlFormStorageMutationHookResult = ReturnType<typeof useGetVonageSignUrlFormStorageMutation>;
export type GetVonageSignUrlFormStorageMutationResult = Apollo.MutationResult<GetVonageSignUrlFormStorageMutation>;
export type GetVonageSignUrlFormStorageMutationOptions = Apollo.BaseMutationOptions<GetVonageSignUrlFormStorageMutation, GetVonageSignUrlFormStorageMutationVariables>;
export const GetProviderPatientSignedUrlDocument = gql`
    mutation GetProviderPatientSignedUrl($patientCodexId: String!, $fileId: String!) {
  GetProviderPatientSignedUrl(patientCodexId: $patientCodexId, fileId: $fileId) {
    status
    url
  }
}
    `;
export type GetProviderPatientSignedUrlMutationFn = Apollo.MutationFunction<GetProviderPatientSignedUrlMutation, GetProviderPatientSignedUrlMutationVariables>;

/**
 * __useGetProviderPatientSignedUrlMutation__
 *
 * To run a mutation, you first call `useGetProviderPatientSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPatientSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getProviderPatientSignedUrlMutation, { data, loading, error }] = useGetProviderPatientSignedUrlMutation({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetProviderPatientSignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetProviderPatientSignedUrlMutation, GetProviderPatientSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetProviderPatientSignedUrlMutation, GetProviderPatientSignedUrlMutationVariables>(GetProviderPatientSignedUrlDocument, options);
      }
export type GetProviderPatientSignedUrlMutationHookResult = ReturnType<typeof useGetProviderPatientSignedUrlMutation>;
export type GetProviderPatientSignedUrlMutationResult = Apollo.MutationResult<GetProviderPatientSignedUrlMutation>;
export type GetProviderPatientSignedUrlMutationOptions = Apollo.BaseMutationOptions<GetProviderPatientSignedUrlMutation, GetProviderPatientSignedUrlMutationVariables>;
export const GetEncounterSignUrlFromStorageDocument = gql`
    mutation getEncounterSignUrlFromStorage($encounterId: String = "", $fileId: String = "") {
  GetEncounterSignUrlFromStorage(
    filePath: {encounterId: $encounterId, fileId: $fileId}
  ) {
    status
    url
  }
}
    `;
export type GetEncounterSignUrlFromStorageMutationFn = Apollo.MutationFunction<GetEncounterSignUrlFromStorageMutation, GetEncounterSignUrlFromStorageMutationVariables>;

/**
 * __useGetEncounterSignUrlFromStorageMutation__
 *
 * To run a mutation, you first call `useGetEncounterSignUrlFromStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEncounterSignUrlFromStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEncounterSignUrlFromStorageMutation, { data, loading, error }] = useGetEncounterSignUrlFromStorageMutation({
 *   variables: {
 *      encounterId: // value for 'encounterId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetEncounterSignUrlFromStorageMutation(baseOptions?: Apollo.MutationHookOptions<GetEncounterSignUrlFromStorageMutation, GetEncounterSignUrlFromStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEncounterSignUrlFromStorageMutation, GetEncounterSignUrlFromStorageMutationVariables>(GetEncounterSignUrlFromStorageDocument, options);
      }
export type GetEncounterSignUrlFromStorageMutationHookResult = ReturnType<typeof useGetEncounterSignUrlFromStorageMutation>;
export type GetEncounterSignUrlFromStorageMutationResult = Apollo.MutationResult<GetEncounterSignUrlFromStorageMutation>;
export type GetEncounterSignUrlFromStorageMutationOptions = Apollo.BaseMutationOptions<GetEncounterSignUrlFromStorageMutation, GetEncounterSignUrlFromStorageMutationVariables>;
export const GetFileByIdDocument = gql`
    query GetFileById($fileId: uuid!) {
  files_by_pk(id: $fileId) {
    id
    file_name
    created_at
  }
}
    `;

/**
 * __useGetFileByIdQuery__
 *
 * To run a query within a React component, call `useGetFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileByIdQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFileByIdQuery, GetFileByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileByIdQuery, GetFileByIdQueryVariables>(GetFileByIdDocument, options);
      }
export function useGetFileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileByIdQuery, GetFileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileByIdQuery, GetFileByIdQueryVariables>(GetFileByIdDocument, options);
        }
export type GetFileByIdQueryHookResult = ReturnType<typeof useGetFileByIdQuery>;
export type GetFileByIdLazyQueryHookResult = ReturnType<typeof useGetFileByIdLazyQuery>;
export type GetFileByIdQueryResult = Apollo.QueryResult<GetFileByIdQuery, GetFileByIdQueryVariables>;
export const GetSignUrlFromStorageForRequesterDocument = gql`
    query GetSignUrlFromStorageForRequester($fileId: String!, $requestedUserId: String!) {
  GetSignUrlFromStorageForRequester(
    fileId: $fileId
    requestedUserId: $requestedUserId
  ) {
    status
    url
  }
}
    `;

/**
 * __useGetSignUrlFromStorageForRequesterQuery__
 *
 * To run a query within a React component, call `useGetSignUrlFromStorageForRequesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignUrlFromStorageForRequesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignUrlFromStorageForRequesterQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      requestedUserId: // value for 'requestedUserId'
 *   },
 * });
 */
export function useGetSignUrlFromStorageForRequesterQuery(baseOptions: Apollo.QueryHookOptions<GetSignUrlFromStorageForRequesterQuery, GetSignUrlFromStorageForRequesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignUrlFromStorageForRequesterQuery, GetSignUrlFromStorageForRequesterQueryVariables>(GetSignUrlFromStorageForRequesterDocument, options);
      }
export function useGetSignUrlFromStorageForRequesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignUrlFromStorageForRequesterQuery, GetSignUrlFromStorageForRequesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignUrlFromStorageForRequesterQuery, GetSignUrlFromStorageForRequesterQueryVariables>(GetSignUrlFromStorageForRequesterDocument, options);
        }
export type GetSignUrlFromStorageForRequesterQueryHookResult = ReturnType<typeof useGetSignUrlFromStorageForRequesterQuery>;
export type GetSignUrlFromStorageForRequesterLazyQueryHookResult = ReturnType<typeof useGetSignUrlFromStorageForRequesterLazyQuery>;
export type GetSignUrlFromStorageForRequesterQueryResult = Apollo.QueryResult<GetSignUrlFromStorageForRequesterQuery, GetSignUrlFromStorageForRequesterQueryVariables>;
export const GetThirdPartyConfigDocument = gql`
    query GetThirdPartyConfig {
  frontEndAuthConfigs
}
    `;

/**
 * __useGetThirdPartyConfigQuery__
 *
 * To run a query within a React component, call `useGetThirdPartyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdPartyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdPartyConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThirdPartyConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetThirdPartyConfigQuery, GetThirdPartyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThirdPartyConfigQuery, GetThirdPartyConfigQueryVariables>(GetThirdPartyConfigDocument, options);
      }
export function useGetThirdPartyConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThirdPartyConfigQuery, GetThirdPartyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThirdPartyConfigQuery, GetThirdPartyConfigQueryVariables>(GetThirdPartyConfigDocument, options);
        }
export type GetThirdPartyConfigQueryHookResult = ReturnType<typeof useGetThirdPartyConfigQuery>;
export type GetThirdPartyConfigLazyQueryHookResult = ReturnType<typeof useGetThirdPartyConfigLazyQuery>;
export type GetThirdPartyConfigQueryResult = Apollo.QueryResult<GetThirdPartyConfigQuery, GetThirdPartyConfigQueryVariables>;
export const GetBarcodeScanningDisabledStateDocument = gql`
    subscription GetBarcodeScanningDisabledState {
  global_configs(where: {name: {_eq: BARCODE_SCANNING_DISABLED}}) {
    value
  }
}
    `;

/**
 * __useGetBarcodeScanningDisabledStateSubscription__
 *
 * To run a query within a React component, call `useGetBarcodeScanningDisabledStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetBarcodeScanningDisabledStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBarcodeScanningDisabledStateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetBarcodeScanningDisabledStateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetBarcodeScanningDisabledStateSubscription, GetBarcodeScanningDisabledStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetBarcodeScanningDisabledStateSubscription, GetBarcodeScanningDisabledStateSubscriptionVariables>(GetBarcodeScanningDisabledStateDocument, options);
      }
export type GetBarcodeScanningDisabledStateSubscriptionHookResult = ReturnType<typeof useGetBarcodeScanningDisabledStateSubscription>;
export type GetBarcodeScanningDisabledStateSubscriptionResult = Apollo.SubscriptionResult<GetBarcodeScanningDisabledStateSubscription>;
export const GetInactivityModalVariablesDocument = gql`
    subscription GetInactivityModalVariables {
  global_configs(
    where: {_or: [{name: {_eq: INACTIVITY_MODAL_STATUS}}, {name: {_eq: INACTIVITY_MODAL_OVERALL_TIMEOUT_VARIABLE}}, {name: {_eq: INACTIVITY_MODAL_PROMPT_BEFORE_IDLE_VARIABLE}}]}
  ) {
    value
  }
}
    `;

/**
 * __useGetInactivityModalVariablesSubscription__
 *
 * To run a query within a React component, call `useGetInactivityModalVariablesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetInactivityModalVariablesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInactivityModalVariablesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetInactivityModalVariablesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetInactivityModalVariablesSubscription, GetInactivityModalVariablesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetInactivityModalVariablesSubscription, GetInactivityModalVariablesSubscriptionVariables>(GetInactivityModalVariablesDocument, options);
      }
export type GetInactivityModalVariablesSubscriptionHookResult = ReturnType<typeof useGetInactivityModalVariablesSubscription>;
export type GetInactivityModalVariablesSubscriptionResult = Apollo.SubscriptionResult<GetInactivityModalVariablesSubscription>;
export const GetUserLogoutBasedOnLastActivityVariablesDocument = gql`
    subscription GetUserLogoutBasedOnLastActivityVariables {
  global_configs(
    where: {_or: [{name: {_eq: USER_LOGOUT_BASED_ON_LAST_ACTIVITY}}, {name: {_eq: USER_LOGOUT_BASED_ON_LAST_ACTIVITY_TIME_LIMIT}}]}
  ) {
    value
  }
}
    `;

/**
 * __useGetUserLogoutBasedOnLastActivityVariablesSubscription__
 *
 * To run a query within a React component, call `useGetUserLogoutBasedOnLastActivityVariablesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLogoutBasedOnLastActivityVariablesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLogoutBasedOnLastActivityVariablesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLogoutBasedOnLastActivityVariablesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetUserLogoutBasedOnLastActivityVariablesSubscription, GetUserLogoutBasedOnLastActivityVariablesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserLogoutBasedOnLastActivityVariablesSubscription, GetUserLogoutBasedOnLastActivityVariablesSubscriptionVariables>(GetUserLogoutBasedOnLastActivityVariablesDocument, options);
      }
export type GetUserLogoutBasedOnLastActivityVariablesSubscriptionHookResult = ReturnType<typeof useGetUserLogoutBasedOnLastActivityVariablesSubscription>;
export type GetUserLogoutBasedOnLastActivityVariablesSubscriptionResult = Apollo.SubscriptionResult<GetUserLogoutBasedOnLastActivityVariablesSubscription>;
export const GetMyVisitSummaryModalDisabledStateDocument = gql`
    subscription GetMyVisitSummaryModalDisabledState {
  global_configs(where: {name: {_eq: MYVISIT_SUMMARY_MODAL_DISABLED}}) {
    value
  }
}
    `;

/**
 * __useGetMyVisitSummaryModalDisabledStateSubscription__
 *
 * To run a query within a React component, call `useGetMyVisitSummaryModalDisabledStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVisitSummaryModalDisabledStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVisitSummaryModalDisabledStateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetMyVisitSummaryModalDisabledStateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetMyVisitSummaryModalDisabledStateSubscription, GetMyVisitSummaryModalDisabledStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetMyVisitSummaryModalDisabledStateSubscription, GetMyVisitSummaryModalDisabledStateSubscriptionVariables>(GetMyVisitSummaryModalDisabledStateDocument, options);
      }
export type GetMyVisitSummaryModalDisabledStateSubscriptionHookResult = ReturnType<typeof useGetMyVisitSummaryModalDisabledStateSubscription>;
export type GetMyVisitSummaryModalDisabledStateSubscriptionResult = Apollo.SubscriptionResult<GetMyVisitSummaryModalDisabledStateSubscription>;
export const GetAppointmentsDisabledStateDocument = gql`
    subscription GetAppointmentsDisabledState {
  global_configs(where: {name: {_eq: APPOINTMENT_ROUTES_DISABLE}}) {
    value
  }
}
    `;

/**
 * __useGetAppointmentsDisabledStateSubscription__
 *
 * To run a query within a React component, call `useGetAppointmentsDisabledStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsDisabledStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsDisabledStateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentsDisabledStateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetAppointmentsDisabledStateSubscription, GetAppointmentsDisabledStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetAppointmentsDisabledStateSubscription, GetAppointmentsDisabledStateSubscriptionVariables>(GetAppointmentsDisabledStateDocument, options);
      }
export type GetAppointmentsDisabledStateSubscriptionHookResult = ReturnType<typeof useGetAppointmentsDisabledStateSubscription>;
export type GetAppointmentsDisabledStateSubscriptionResult = Apollo.SubscriptionResult<GetAppointmentsDisabledStateSubscription>;
export const GetSignUpProviderRouteStateDocument = gql`
    subscription GetSignUpProviderRouteState {
  global_configs(where: {name: {_eq: ENABLE_SIGN_UP_PROVIDER}}) {
    value
  }
}
    `;

/**
 * __useGetSignUpProviderRouteStateSubscription__
 *
 * To run a query within a React component, call `useGetSignUpProviderRouteStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSignUpProviderRouteStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignUpProviderRouteStateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetSignUpProviderRouteStateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetSignUpProviderRouteStateSubscription, GetSignUpProviderRouteStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetSignUpProviderRouteStateSubscription, GetSignUpProviderRouteStateSubscriptionVariables>(GetSignUpProviderRouteStateDocument, options);
      }
export type GetSignUpProviderRouteStateSubscriptionHookResult = ReturnType<typeof useGetSignUpProviderRouteStateSubscription>;
export type GetSignUpProviderRouteStateSubscriptionResult = Apollo.SubscriptionResult<GetSignUpProviderRouteStateSubscription>;
export const GetChannelSignalsDocument = gql`
    subscription GetChannelSignals($channel: String!, $key: String!) {
  channel_signals(where: {channel: {_eq: $channel}, _and: {key: {_eq: $key}}}) {
    last_updated
  }
}
    `;

/**
 * __useGetChannelSignalsSubscription__
 *
 * To run a query within a React component, call `useGetChannelSignalsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSignalsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSignalsSubscription({
 *   variables: {
 *      channel: // value for 'channel'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetChannelSignalsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetChannelSignalsSubscription, GetChannelSignalsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetChannelSignalsSubscription, GetChannelSignalsSubscriptionVariables>(GetChannelSignalsDocument, options);
      }
export type GetChannelSignalsSubscriptionHookResult = ReturnType<typeof useGetChannelSignalsSubscription>;
export type GetChannelSignalsSubscriptionResult = Apollo.SubscriptionResult<GetChannelSignalsSubscription>;
export const GetAppointmentMediaSignalsDocument = gql`
    subscription GetAppointmentMediaSignals($user_id: uuid!) {
  appointment_media_signals(where: {user_id: {_eq: $user_id}}) {
    file_id
    id
    lastUpdatedAt
    location
    user_id
  }
}
    `;

/**
 * __useGetAppointmentMediaSignalsSubscription__
 *
 * To run a query within a React component, call `useGetAppointmentMediaSignalsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentMediaSignalsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentMediaSignalsSubscription({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetAppointmentMediaSignalsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetAppointmentMediaSignalsSubscription, GetAppointmentMediaSignalsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetAppointmentMediaSignalsSubscription, GetAppointmentMediaSignalsSubscriptionVariables>(GetAppointmentMediaSignalsDocument, options);
      }
export type GetAppointmentMediaSignalsSubscriptionHookResult = ReturnType<typeof useGetAppointmentMediaSignalsSubscription>;
export type GetAppointmentMediaSignalsSubscriptionResult = Apollo.SubscriptionResult<GetAppointmentMediaSignalsSubscription>;
export const GetGoogleMeetLinkDocument = gql`
    mutation getGoogleMeetLink($appointmentId: String!, $patientId: String!, $providerId: String!) {
  RegisterGoogleMeet(
    body: {appointmentId: $appointmentId, patientId: $patientId, providerId: $providerId}
  ) {
    appointmentId
    conferenceId
    endTime
    eventId
    meetLink
    startTime
    transcriptionEnabled
  }
}
    `;
export type GetGoogleMeetLinkMutationFn = Apollo.MutationFunction<GetGoogleMeetLinkMutation, GetGoogleMeetLinkMutationVariables>;

/**
 * __useGetGoogleMeetLinkMutation__
 *
 * To run a mutation, you first call `useGetGoogleMeetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleMeetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getGoogleMeetLinkMutation, { data, loading, error }] = useGetGoogleMeetLinkMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      patientId: // value for 'patientId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetGoogleMeetLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetGoogleMeetLinkMutation, GetGoogleMeetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetGoogleMeetLinkMutation, GetGoogleMeetLinkMutationVariables>(GetGoogleMeetLinkDocument, options);
      }
export type GetGoogleMeetLinkMutationHookResult = ReturnType<typeof useGetGoogleMeetLinkMutation>;
export type GetGoogleMeetLinkMutationResult = Apollo.MutationResult<GetGoogleMeetLinkMutation>;
export type GetGoogleMeetLinkMutationOptions = Apollo.BaseMutationOptions<GetGoogleMeetLinkMutation, GetGoogleMeetLinkMutationVariables>;
export const AcceptLegalDocumentDocument = gql`
    mutation AcceptLegalDocument($legal_document_type: Hasura_Legal_Document_Types_Enum!) {
  acceptLegalDocument(input: {type: $legal_document_type}) {
    status
    message
  }
}
    `;
export type AcceptLegalDocumentMutationFn = Apollo.MutationFunction<AcceptLegalDocumentMutation, AcceptLegalDocumentMutationVariables>;

/**
 * __useAcceptLegalDocumentMutation__
 *
 * To run a mutation, you first call `useAcceptLegalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLegalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLegalDocumentMutation, { data, loading, error }] = useAcceptLegalDocumentMutation({
 *   variables: {
 *      legal_document_type: // value for 'legal_document_type'
 *   },
 * });
 */
export function useAcceptLegalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLegalDocumentMutation, AcceptLegalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLegalDocumentMutation, AcceptLegalDocumentMutationVariables>(AcceptLegalDocumentDocument, options);
      }
export type AcceptLegalDocumentMutationHookResult = ReturnType<typeof useAcceptLegalDocumentMutation>;
export type AcceptLegalDocumentMutationResult = Apollo.MutationResult<AcceptLegalDocumentMutation>;
export type AcceptLegalDocumentMutationOptions = Apollo.BaseMutationOptions<AcceptLegalDocumentMutation, AcceptLegalDocumentMutationVariables>;
export const PublishLegalDocumentDocument = gql`
    mutation PublishLegalDocument($input: PublishLegalDocumentInput!) {
  publishLegalDocument(input: $input) {
    type
    updatedByFullName
    version
  }
}
    `;
export type PublishLegalDocumentMutationFn = Apollo.MutationFunction<PublishLegalDocumentMutation, PublishLegalDocumentMutationVariables>;

/**
 * __usePublishLegalDocumentMutation__
 *
 * To run a mutation, you first call `usePublishLegalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishLegalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishLegalDocumentMutation, { data, loading, error }] = usePublishLegalDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishLegalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<PublishLegalDocumentMutation, PublishLegalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishLegalDocumentMutation, PublishLegalDocumentMutationVariables>(PublishLegalDocumentDocument, options);
      }
export type PublishLegalDocumentMutationHookResult = ReturnType<typeof usePublishLegalDocumentMutation>;
export type PublishLegalDocumentMutationResult = Apollo.MutationResult<PublishLegalDocumentMutation>;
export type PublishLegalDocumentMutationOptions = Apollo.BaseMutationOptions<PublishLegalDocumentMutation, PublishLegalDocumentMutationVariables>;
export const GetAcceptedLegalDocumentsDocument = gql`
    query GetAcceptedLegalDocuments($user_id: uuid!) {
  accepted_legal_documents(where: {user_id: {_eq: $user_id}}) {
    accepted_legal_document_id
    legal_document {
      content_web
      content_mobile
      legal_document_type
    }
  }
}
    `;

/**
 * __useGetAcceptedLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAcceptedLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcceptedLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcceptedLegalDocumentsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetAcceptedLegalDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetAcceptedLegalDocumentsQuery, GetAcceptedLegalDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcceptedLegalDocumentsQuery, GetAcceptedLegalDocumentsQueryVariables>(GetAcceptedLegalDocumentsDocument, options);
      }
export function useGetAcceptedLegalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcceptedLegalDocumentsQuery, GetAcceptedLegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcceptedLegalDocumentsQuery, GetAcceptedLegalDocumentsQueryVariables>(GetAcceptedLegalDocumentsDocument, options);
        }
export type GetAcceptedLegalDocumentsQueryHookResult = ReturnType<typeof useGetAcceptedLegalDocumentsQuery>;
export type GetAcceptedLegalDocumentsLazyQueryHookResult = ReturnType<typeof useGetAcceptedLegalDocumentsLazyQuery>;
export type GetAcceptedLegalDocumentsQueryResult = Apollo.QueryResult<GetAcceptedLegalDocumentsQuery, GetAcceptedLegalDocumentsQueryVariables>;
export const GetLegalDocumentAcceptanceByLegalDocumentTypeDocument = gql`
    query GetLegalDocumentAcceptanceByLegalDocumentType($user_id: uuid!, $legal_document_type: legal_document_types_enum!) {
  accepted_legal_documents(
    where: {user_id: {_eq: $user_id}, _and: {legal_document: {legal_document_type: {_eq: $legal_document_type}}}}
  ) {
    accepted_legal_document_id
    acceptance_date
    legal_document {
      content_web
      content_mobile
      legal_document_type
    }
  }
}
    `;

/**
 * __useGetLegalDocumentAcceptanceByLegalDocumentTypeQuery__
 *
 * To run a query within a React component, call `useGetLegalDocumentAcceptanceByLegalDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegalDocumentAcceptanceByLegalDocumentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegalDocumentAcceptanceByLegalDocumentTypeQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      legal_document_type: // value for 'legal_document_type'
 *   },
 * });
 */
export function useGetLegalDocumentAcceptanceByLegalDocumentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetLegalDocumentAcceptanceByLegalDocumentTypeQuery, GetLegalDocumentAcceptanceByLegalDocumentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegalDocumentAcceptanceByLegalDocumentTypeQuery, GetLegalDocumentAcceptanceByLegalDocumentTypeQueryVariables>(GetLegalDocumentAcceptanceByLegalDocumentTypeDocument, options);
      }
export function useGetLegalDocumentAcceptanceByLegalDocumentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegalDocumentAcceptanceByLegalDocumentTypeQuery, GetLegalDocumentAcceptanceByLegalDocumentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegalDocumentAcceptanceByLegalDocumentTypeQuery, GetLegalDocumentAcceptanceByLegalDocumentTypeQueryVariables>(GetLegalDocumentAcceptanceByLegalDocumentTypeDocument, options);
        }
export type GetLegalDocumentAcceptanceByLegalDocumentTypeQueryHookResult = ReturnType<typeof useGetLegalDocumentAcceptanceByLegalDocumentTypeQuery>;
export type GetLegalDocumentAcceptanceByLegalDocumentTypeLazyQueryHookResult = ReturnType<typeof useGetLegalDocumentAcceptanceByLegalDocumentTypeLazyQuery>;
export type GetLegalDocumentAcceptanceByLegalDocumentTypeQueryResult = Apollo.QueryResult<GetLegalDocumentAcceptanceByLegalDocumentTypeQuery, GetLegalDocumentAcceptanceByLegalDocumentTypeQueryVariables>;
export const GetLegalDocumentDocument = gql`
    query GetLegalDocument($type: Hasura_Legal_Document_Types_Enum!) {
  getLegalDocument(input: {type: $type}) {
    contentWeb
    type
    contentMobile
    updatedByFullName
  }
}
    `;

/**
 * __useGetLegalDocumentQuery__
 *
 * To run a query within a React component, call `useGetLegalDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegalDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegalDocumentQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLegalDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetLegalDocumentQuery, GetLegalDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegalDocumentQuery, GetLegalDocumentQueryVariables>(GetLegalDocumentDocument, options);
      }
export function useGetLegalDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegalDocumentQuery, GetLegalDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegalDocumentQuery, GetLegalDocumentQueryVariables>(GetLegalDocumentDocument, options);
        }
export type GetLegalDocumentQueryHookResult = ReturnType<typeof useGetLegalDocumentQuery>;
export type GetLegalDocumentLazyQueryHookResult = ReturnType<typeof useGetLegalDocumentLazyQuery>;
export type GetLegalDocumentQueryResult = Apollo.QueryResult<GetLegalDocumentQuery, GetLegalDocumentQueryVariables>;
export const GetLegalDocumentsDocument = gql`
    query GetLegalDocuments($input: GetLegalDocumentsInput = {}) {
  getLegalDocuments(input: $input) {
    legalDocuments {
      contentMobile
      contentWeb
      type
      updatedAt
      updatedByFullName
      version
    }
  }
}
    `;

/**
 * __useGetLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useGetLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegalDocumentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLegalDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetLegalDocumentsQuery, GetLegalDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegalDocumentsQuery, GetLegalDocumentsQueryVariables>(GetLegalDocumentsDocument, options);
      }
export function useGetLegalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegalDocumentsQuery, GetLegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegalDocumentsQuery, GetLegalDocumentsQueryVariables>(GetLegalDocumentsDocument, options);
        }
export type GetLegalDocumentsQueryHookResult = ReturnType<typeof useGetLegalDocumentsQuery>;
export type GetLegalDocumentsLazyQueryHookResult = ReturnType<typeof useGetLegalDocumentsLazyQuery>;
export type GetLegalDocumentsQueryResult = Apollo.QueryResult<GetLegalDocumentsQuery, GetLegalDocumentsQueryVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($inMailId: String!, $text: String!, $attachments: [FileAttachmentInput!]) {
  sendInMailMessage(
    input: {recipientCodexId: $inMailId, text: $text, attachments: $attachments}
  ) {
    message
    status
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      inMailId: // value for 'inMailId'
 *      text: // value for 'text'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const GetInMailUsageDocument = gql`
    query GetInMailUsage {
  getInMailUsage {
    used
    updatedAt
  }
}
    `;

/**
 * __useGetInMailUsageQuery__
 *
 * To run a query within a React component, call `useGetInMailUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInMailUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInMailUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInMailUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetInMailUsageQuery, GetInMailUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInMailUsageQuery, GetInMailUsageQueryVariables>(GetInMailUsageDocument, options);
      }
export function useGetInMailUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInMailUsageQuery, GetInMailUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInMailUsageQuery, GetInMailUsageQueryVariables>(GetInMailUsageDocument, options);
        }
export type GetInMailUsageQueryHookResult = ReturnType<typeof useGetInMailUsageQuery>;
export type GetInMailUsageLazyQueryHookResult = ReturnType<typeof useGetInMailUsageLazyQuery>;
export type GetInMailUsageQueryResult = Apollo.QueryResult<GetInMailUsageQuery, GetInMailUsageQueryVariables>;
export const GetInMailsByProviderIdDocument = gql`
    query GetInMailsByProviderId($limit: Int = 10, $offset: Int = 0, $providerCodexId: String, $queryName: String) {
  getUserInMailsByRequestId(
    limit: $limit
    offset: $offset
    filter: {contactCodexId: $providerCodexId, queryName: $queryName}
  ) {
    inMails {
      createdAt
      lastMessageAt
      id
      patient {
        firstName
        lastName
        codexId
      }
      provider {
        codexId
        firstName
        lastName
      }
    }
    total
  }
}
    `;

/**
 * __useGetInMailsByProviderIdQuery__
 *
 * To run a query within a React component, call `useGetInMailsByProviderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInMailsByProviderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInMailsByProviderIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerCodexId: // value for 'providerCodexId'
 *      queryName: // value for 'queryName'
 *   },
 * });
 */
export function useGetInMailsByProviderIdQuery(baseOptions?: Apollo.QueryHookOptions<GetInMailsByProviderIdQuery, GetInMailsByProviderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInMailsByProviderIdQuery, GetInMailsByProviderIdQueryVariables>(GetInMailsByProviderIdDocument, options);
      }
export function useGetInMailsByProviderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInMailsByProviderIdQuery, GetInMailsByProviderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInMailsByProviderIdQuery, GetInMailsByProviderIdQueryVariables>(GetInMailsByProviderIdDocument, options);
        }
export type GetInMailsByProviderIdQueryHookResult = ReturnType<typeof useGetInMailsByProviderIdQuery>;
export type GetInMailsByProviderIdLazyQueryHookResult = ReturnType<typeof useGetInMailsByProviderIdLazyQuery>;
export type GetInMailsByProviderIdQueryResult = Apollo.QueryResult<GetInMailsByProviderIdQuery, GetInMailsByProviderIdQueryVariables>;
export const MessageDetailDocument = gql`
    query MessageDetail($filter: GetInMailDetailInput, $limit: Int = 100, $pageToken: String = "") {
  getInMailDetail(filter: $filter, limit: $limit, pageToken: $pageToken) {
    provider {
      profilePictureId
      lastName
      firstName
      codexId
    }
    patient {
      codexId
      firstName
      lastName
      profilePictureId
    }
    messages {
      date
      attachments {
        url
        title
        size
        contentType
      }
      senderCodexId
      text
    }
    nextPageToken
    lastMessageAt
    id
    createdAt
  }
}
    `;

/**
 * __useMessageDetailQuery__
 *
 * To run a query within a React component, call `useMessageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDetailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useMessageDetailQuery(baseOptions?: Apollo.QueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
      }
export function useMessageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
        }
export type MessageDetailQueryHookResult = ReturnType<typeof useMessageDetailQuery>;
export type MessageDetailLazyQueryHookResult = ReturnType<typeof useMessageDetailLazyQuery>;
export type MessageDetailQueryResult = Apollo.QueryResult<MessageDetailQuery, MessageDetailQueryVariables>;
export const GetProviderInMailsCountsDocument = gql`
    query GetProviderInMailsCounts($providerCodexId: String, $queryName: String) {
  getUserInMailsByRequestId(
    filter: {contactCodexId: $providerCodexId, queryName: $queryName}
  ) {
    total
    newTotal
  }
}
    `;

/**
 * __useGetProviderInMailsCountsQuery__
 *
 * To run a query within a React component, call `useGetProviderInMailsCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderInMailsCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderInMailsCountsQuery({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *      queryName: // value for 'queryName'
 *   },
 * });
 */
export function useGetProviderInMailsCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderInMailsCountsQuery, GetProviderInMailsCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderInMailsCountsQuery, GetProviderInMailsCountsQueryVariables>(GetProviderInMailsCountsDocument, options);
      }
export function useGetProviderInMailsCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderInMailsCountsQuery, GetProviderInMailsCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderInMailsCountsQuery, GetProviderInMailsCountsQueryVariables>(GetProviderInMailsCountsDocument, options);
        }
export type GetProviderInMailsCountsQueryHookResult = ReturnType<typeof useGetProviderInMailsCountsQuery>;
export type GetProviderInMailsCountsLazyQueryHookResult = ReturnType<typeof useGetProviderInMailsCountsLazyQuery>;
export type GetProviderInMailsCountsQueryResult = Apollo.QueryResult<GetProviderInMailsCountsQuery, GetProviderInMailsCountsQueryVariables>;
export const GetProviderInMailsDocument = gql`
    query GetProviderInMails($limit: Int = 10, $offset: Int = 0, $providerCodexId: String, $queryName: String) {
  getUserInMailsByRequestId(
    limit: $limit
    offset: $offset
    filter: {contactCodexId: $providerCodexId, queryName: $queryName}
  ) {
    inMails {
      createdAt
      id
      lastMessageAt
      patient {
        codexId
        firstName
        lastName
        profilePictureId
      }
      provider {
        codexId
        firstName
        lastName
        profilePictureId
      }
      read
    }
    contactsWithoutChats {
      codexId
      firstName
      lastName
      profilePictureId
    }
    newTotal
    total
  }
}
    `;

/**
 * __useGetProviderInMailsQuery__
 *
 * To run a query within a React component, call `useGetProviderInMailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderInMailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderInMailsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      providerCodexId: // value for 'providerCodexId'
 *      queryName: // value for 'queryName'
 *   },
 * });
 */
export function useGetProviderInMailsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderInMailsQuery, GetProviderInMailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderInMailsQuery, GetProviderInMailsQueryVariables>(GetProviderInMailsDocument, options);
      }
export function useGetProviderInMailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderInMailsQuery, GetProviderInMailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderInMailsQuery, GetProviderInMailsQueryVariables>(GetProviderInMailsDocument, options);
        }
export type GetProviderInMailsQueryHookResult = ReturnType<typeof useGetProviderInMailsQuery>;
export type GetProviderInMailsLazyQueryHookResult = ReturnType<typeof useGetProviderInMailsLazyQuery>;
export type GetProviderInMailsQueryResult = Apollo.QueryResult<GetProviderInMailsQuery, GetProviderInMailsQueryVariables>;
export const UpdateInAppNotificationDocument = gql`
    mutation UpdateInAppNotification($id: String!, $status: String!) {
  updateInAppNotificationById(notificationId: $id, input: {status: $status}) {
    message
    status
  }
}
    `;
export type UpdateInAppNotificationMutationFn = Apollo.MutationFunction<UpdateInAppNotificationMutation, UpdateInAppNotificationMutationVariables>;

/**
 * __useUpdateInAppNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateInAppNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInAppNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInAppNotificationMutation, { data, loading, error }] = useUpdateInAppNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateInAppNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInAppNotificationMutation, UpdateInAppNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInAppNotificationMutation, UpdateInAppNotificationMutationVariables>(UpdateInAppNotificationDocument, options);
      }
export type UpdateInAppNotificationMutationHookResult = ReturnType<typeof useUpdateInAppNotificationMutation>;
export type UpdateInAppNotificationMutationResult = Apollo.MutationResult<UpdateInAppNotificationMutation>;
export type UpdateInAppNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateInAppNotificationMutation, UpdateInAppNotificationMutationVariables>;
export const UpdateProfileNotificationDocument = gql`
    mutation UpdateProfileNotification {
  UpdateProfileNotification {
    status
    message
  }
}
    `;
export type UpdateProfileNotificationMutationFn = Apollo.MutationFunction<UpdateProfileNotificationMutation, UpdateProfileNotificationMutationVariables>;

/**
 * __useUpdateProfileNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateProfileNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileNotificationMutation, { data, loading, error }] = useUpdateProfileNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateProfileNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileNotificationMutation, UpdateProfileNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileNotificationMutation, UpdateProfileNotificationMutationVariables>(UpdateProfileNotificationDocument, options);
      }
export type UpdateProfileNotificationMutationHookResult = ReturnType<typeof useUpdateProfileNotificationMutation>;
export type UpdateProfileNotificationMutationResult = Apollo.MutationResult<UpdateProfileNotificationMutation>;
export type UpdateProfileNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateProfileNotificationMutation, UpdateProfileNotificationMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($notificationId: String!) {
  deleteUserNotification(notificationId: $notificationId) {
    status
    message
  }
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const UpdateAllUserNotificationStatusDocument = gql`
    mutation UpdateAllUserNotificationStatus($status: String!, $isLatestActivity: Boolean = false) {
  updateAllUserNotificationsStatus(
    input: {status: $status, isLatestActivity: $isLatestActivity}
  ) {
    status
    message
  }
}
    `;
export type UpdateAllUserNotificationStatusMutationFn = Apollo.MutationFunction<UpdateAllUserNotificationStatusMutation, UpdateAllUserNotificationStatusMutationVariables>;

/**
 * __useUpdateAllUserNotificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAllUserNotificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllUserNotificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllUserNotificationStatusMutation, { data, loading, error }] = useUpdateAllUserNotificationStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      isLatestActivity: // value for 'isLatestActivity'
 *   },
 * });
 */
export function useUpdateAllUserNotificationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllUserNotificationStatusMutation, UpdateAllUserNotificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllUserNotificationStatusMutation, UpdateAllUserNotificationStatusMutationVariables>(UpdateAllUserNotificationStatusDocument, options);
      }
export type UpdateAllUserNotificationStatusMutationHookResult = ReturnType<typeof useUpdateAllUserNotificationStatusMutation>;
export type UpdateAllUserNotificationStatusMutationResult = Apollo.MutationResult<UpdateAllUserNotificationStatusMutation>;
export type UpdateAllUserNotificationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateAllUserNotificationStatusMutation, UpdateAllUserNotificationStatusMutationVariables>;
export const UpdateNotificationPreferencesDocument = gql`
    mutation UpdateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
  updateNotificationPreferences(input: $input) {
    message
    status
  }
}
    `;
export type UpdateNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;

/**
 * __useUpdateNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferencesMutation, { data, loading, error }] = useUpdateNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>(UpdateNotificationPreferencesDocument, options);
      }
export type UpdateNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const GetUserNotificationByUserIdDocument = gql`
    subscription GetUserNotificationByUserId($limit: Int = 10, $offset: Int = 0, $sort: order_by = desc, $where: user_notifications_bool_exp!) {
  user_notifications(
    order_by: {created_at: $sort}
    limit: $limit
    offset: $offset
    where: $where
  ) {
    data
    id
    status
    user_communication_delivery_id
    user_id
    activity_type
    is_toast
    is_modal
    notification_type
    is_important_update
  }
}
    `;

/**
 * __useGetUserNotificationByUserIdSubscription__
 *
 * To run a query within a React component, call `useGetUserNotificationByUserIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationByUserIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationByUserIdSubscription({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserNotificationByUserIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetUserNotificationByUserIdSubscription, GetUserNotificationByUserIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserNotificationByUserIdSubscription, GetUserNotificationByUserIdSubscriptionVariables>(GetUserNotificationByUserIdDocument, options);
      }
export type GetUserNotificationByUserIdSubscriptionHookResult = ReturnType<typeof useGetUserNotificationByUserIdSubscription>;
export type GetUserNotificationByUserIdSubscriptionResult = Apollo.SubscriptionResult<GetUserNotificationByUserIdSubscription>;
export const GetUserNotificationCountsByUserIdDocument = gql`
    subscription GetUserNotificationCountsByUserId($where: user_notifications_bool_exp!) {
  user_notifications_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserNotificationCountsByUserIdSubscription__
 *
 * To run a query within a React component, call `useGetUserNotificationCountsByUserIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationCountsByUserIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationCountsByUserIdSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserNotificationCountsByUserIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetUserNotificationCountsByUserIdSubscription, GetUserNotificationCountsByUserIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserNotificationCountsByUserIdSubscription, GetUserNotificationCountsByUserIdSubscriptionVariables>(GetUserNotificationCountsByUserIdDocument, options);
      }
export type GetUserNotificationCountsByUserIdSubscriptionHookResult = ReturnType<typeof useGetUserNotificationCountsByUserIdSubscription>;
export type GetUserNotificationCountsByUserIdSubscriptionResult = Apollo.SubscriptionResult<GetUserNotificationCountsByUserIdSubscription>;
export const GetUserNotificationCountsDocument = gql`
    subscription GetUserNotificationCounts {
  user_notifications_aggregate(where: {status: {_neq: READ}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserNotificationCountsSubscription__
 *
 * To run a query within a React component, call `useGetUserNotificationCountsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationCountsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationCountsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationCountsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetUserNotificationCountsSubscription, GetUserNotificationCountsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserNotificationCountsSubscription, GetUserNotificationCountsSubscriptionVariables>(GetUserNotificationCountsDocument, options);
      }
export type GetUserNotificationCountsSubscriptionHookResult = ReturnType<typeof useGetUserNotificationCountsSubscription>;
export type GetUserNotificationCountsSubscriptionResult = Apollo.SubscriptionResult<GetUserNotificationCountsSubscription>;
export const GetExternalNotificationCountsDocument = gql`
    subscription GetExternalNotificationCounts {
  provider_unread_external_notification_counts {
    dosespot_unread_notifications
  }
}
    `;

/**
 * __useGetExternalNotificationCountsSubscription__
 *
 * To run a query within a React component, call `useGetExternalNotificationCountsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalNotificationCountsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalNotificationCountsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalNotificationCountsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetExternalNotificationCountsSubscription, GetExternalNotificationCountsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetExternalNotificationCountsSubscription, GetExternalNotificationCountsSubscriptionVariables>(GetExternalNotificationCountsDocument, options);
      }
export type GetExternalNotificationCountsSubscriptionHookResult = ReturnType<typeof useGetExternalNotificationCountsSubscription>;
export type GetExternalNotificationCountsSubscriptionResult = Apollo.SubscriptionResult<GetExternalNotificationCountsSubscription>;
export const UserNotificationByUserIdDocument = gql`
    query UserNotificationByUserId($limit: Int = 10, $offset: Int = 0, $sort: order_by = desc, $where: user_notifications_bool_exp!) {
  user_notifications(
    order_by: {created_at: $sort}
    limit: $limit
    offset: $offset
    where: $where
  ) {
    data
    id
    status
    is_latest_activity
    user_communication_delivery_id
    user_id
    activity_type
  }
}
    `;

/**
 * __useUserNotificationByUserIdQuery__
 *
 * To run a query within a React component, call `useUserNotificationByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationByUserIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUserNotificationByUserIdQuery(baseOptions: Apollo.QueryHookOptions<UserNotificationByUserIdQuery, UserNotificationByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationByUserIdQuery, UserNotificationByUserIdQueryVariables>(UserNotificationByUserIdDocument, options);
      }
export function useUserNotificationByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationByUserIdQuery, UserNotificationByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationByUserIdQuery, UserNotificationByUserIdQueryVariables>(UserNotificationByUserIdDocument, options);
        }
export type UserNotificationByUserIdQueryHookResult = ReturnType<typeof useUserNotificationByUserIdQuery>;
export type UserNotificationByUserIdLazyQueryHookResult = ReturnType<typeof useUserNotificationByUserIdLazyQuery>;
export type UserNotificationByUserIdQueryResult = Apollo.QueryResult<UserNotificationByUserIdQuery, UserNotificationByUserIdQueryVariables>;
export const GetNotificationsByUserIdWithCountsDocument = gql`
    query getNotificationsByUserIdWithCounts($limit: Int = 10, $offset: Int = 0, $sortDirection: OrderByDirections = DESC, $isLatestActivity: Boolean, $includeStatuses: [String!] = ["DELIVERED", "READ", "SEEN"], $isModal: Boolean = false, $isToast: Boolean = false) {
  getNotificationsByRequestUserIdWithCounts(
    includeStatuses: $includeStatuses
    limit: $limit
    offset: $offset
    sortDirection: $sortDirection
    isLatestActivity: $isLatestActivity
    isModal: $isModal
    isToast: $isToast
  ) {
    notifications {
      activity_type
      created_at
      data
      has_priority
      id
      status
      is_admin_notification
      user_communication_delivery_id
    }
    unreadCount
    total
  }
}
    `;

/**
 * __useGetNotificationsByUserIdWithCountsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsByUserIdWithCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsByUserIdWithCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsByUserIdWithCountsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortDirection: // value for 'sortDirection'
 *      isLatestActivity: // value for 'isLatestActivity'
 *      includeStatuses: // value for 'includeStatuses'
 *      isModal: // value for 'isModal'
 *      isToast: // value for 'isToast'
 *   },
 * });
 */
export function useGetNotificationsByUserIdWithCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsByUserIdWithCountsQuery, GetNotificationsByUserIdWithCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsByUserIdWithCountsQuery, GetNotificationsByUserIdWithCountsQueryVariables>(GetNotificationsByUserIdWithCountsDocument, options);
      }
export function useGetNotificationsByUserIdWithCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsByUserIdWithCountsQuery, GetNotificationsByUserIdWithCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsByUserIdWithCountsQuery, GetNotificationsByUserIdWithCountsQueryVariables>(GetNotificationsByUserIdWithCountsDocument, options);
        }
export type GetNotificationsByUserIdWithCountsQueryHookResult = ReturnType<typeof useGetNotificationsByUserIdWithCountsQuery>;
export type GetNotificationsByUserIdWithCountsLazyQueryHookResult = ReturnType<typeof useGetNotificationsByUserIdWithCountsLazyQuery>;
export type GetNotificationsByUserIdWithCountsQueryResult = Apollo.QueryResult<GetNotificationsByUserIdWithCountsQuery, GetNotificationsByUserIdWithCountsQueryVariables>;
export const NotificationPreferencesDocument = gql`
    query NotificationPreferences {
  notificationPreferences {
    preferences {
      channels {
        email
        push
      }
      category
    }
  }
}
    `;

/**
 * __useNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
      }
export function useNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>(NotificationPreferencesDocument, options);
        }
export type NotificationPreferencesQueryHookResult = ReturnType<typeof useNotificationPreferencesQuery>;
export type NotificationPreferencesLazyQueryHookResult = ReturnType<typeof useNotificationPreferencesLazyQuery>;
export type NotificationPreferencesQueryResult = Apollo.QueryResult<NotificationPreferencesQuery, NotificationPreferencesQueryVariables>;
export const SignupProviderDocument = gql`
    mutation SignupProvider($email: String!, $password: String, $firebaseToken: String) {
  SignupProvider(
    providerData: {email: $email, password: $password, firebaseToken: $firebaseToken}
  ) {
    message
    status
  }
}
    `;
export type SignupProviderMutationFn = Apollo.MutationFunction<SignupProviderMutation, SignupProviderMutationVariables>;

/**
 * __useSignupProviderMutation__
 *
 * To run a mutation, you first call `useSignupProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupProviderMutation, { data, loading, error }] = useSignupProviderMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firebaseToken: // value for 'firebaseToken'
 *   },
 * });
 */
export function useSignupProviderMutation(baseOptions?: Apollo.MutationHookOptions<SignupProviderMutation, SignupProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupProviderMutation, SignupProviderMutationVariables>(SignupProviderDocument, options);
      }
export type SignupProviderMutationHookResult = ReturnType<typeof useSignupProviderMutation>;
export type SignupProviderMutationResult = Apollo.MutationResult<SignupProviderMutation>;
export type SignupProviderMutationOptions = Apollo.BaseMutationOptions<SignupProviderMutation, SignupProviderMutationVariables>;
export const CreateScheduledAppointmentDocument = gql`
    mutation CreateScheduledAppointment($datetime: String!, $calendarId: Int!, $appointmentTypeId: Int!, $promoCode: String, $appointmentRequestId: String, $appointmentData: CreateFHIRAppointmentInputWithoutPatientCodexId!, $paymentProvider: PaymentProviderEnum = Stripe) {
  createScheduledAppointment(
    body: {datetime: $datetime, calendarId: $calendarId, appointmentTypeId: $appointmentTypeId, promoCode: $promoCode, paymentProvider: $paymentProvider, appointmentData: $appointmentData, appointmentRequestId: $appointmentRequestId}
  ) {
    paymentLink
    stripeRedirectedLink
  }
}
    `;
export type CreateScheduledAppointmentMutationFn = Apollo.MutationFunction<CreateScheduledAppointmentMutation, CreateScheduledAppointmentMutationVariables>;

/**
 * __useCreateScheduledAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateScheduledAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledAppointmentMutation, { data, loading, error }] = useCreateScheduledAppointmentMutation({
 *   variables: {
 *      datetime: // value for 'datetime'
 *      calendarId: // value for 'calendarId'
 *      appointmentTypeId: // value for 'appointmentTypeId'
 *      promoCode: // value for 'promoCode'
 *      appointmentRequestId: // value for 'appointmentRequestId'
 *      appointmentData: // value for 'appointmentData'
 *      paymentProvider: // value for 'paymentProvider'
 *   },
 * });
 */
export function useCreateScheduledAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledAppointmentMutation, CreateScheduledAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledAppointmentMutation, CreateScheduledAppointmentMutationVariables>(CreateScheduledAppointmentDocument, options);
      }
export type CreateScheduledAppointmentMutationHookResult = ReturnType<typeof useCreateScheduledAppointmentMutation>;
export type CreateScheduledAppointmentMutationResult = Apollo.MutationResult<CreateScheduledAppointmentMutation>;
export type CreateScheduledAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateScheduledAppointmentMutation, CreateScheduledAppointmentMutationVariables>;
export const RegisterPatchProviderDocument = gql`
    mutation RegisterPatchProvider($providerData: ProviderRegisterPatchInput) {
  RegisterPatchProvider(providerData: $providerData) {
    message
    status
  }
}
    `;
export type RegisterPatchProviderMutationFn = Apollo.MutationFunction<RegisterPatchProviderMutation, RegisterPatchProviderMutationVariables>;

/**
 * __useRegisterPatchProviderMutation__
 *
 * To run a mutation, you first call `useRegisterPatchProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPatchProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPatchProviderMutation, { data, loading, error }] = useRegisterPatchProviderMutation({
 *   variables: {
 *      providerData: // value for 'providerData'
 *   },
 * });
 */
export function useRegisterPatchProviderMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPatchProviderMutation, RegisterPatchProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPatchProviderMutation, RegisterPatchProviderMutationVariables>(RegisterPatchProviderDocument, options);
      }
export type RegisterPatchProviderMutationHookResult = ReturnType<typeof useRegisterPatchProviderMutation>;
export type RegisterPatchProviderMutationResult = Apollo.MutationResult<RegisterPatchProviderMutation>;
export type RegisterPatchProviderMutationOptions = Apollo.BaseMutationOptions<RegisterPatchProviderMutation, RegisterPatchProviderMutationVariables>;
export const CreateCalendarAndDefineRegularHoursDocument = gql`
    mutation CreateCalendarAndDefineRegularHours($input: CreateCalendarAndDefineRegularHoursInput!) {
  CreateCalendarAndDefineRegularHours(
    createCalendarAndDefineRegularHoursInput: $input
  ) {
    Monday
    Tuesday
    Wednesday
    Thursday
    Friday
    Saturday
    Sunday
  }
}
    `;
export type CreateCalendarAndDefineRegularHoursMutationFn = Apollo.MutationFunction<CreateCalendarAndDefineRegularHoursMutation, CreateCalendarAndDefineRegularHoursMutationVariables>;

/**
 * __useCreateCalendarAndDefineRegularHoursMutation__
 *
 * To run a mutation, you first call `useCreateCalendarAndDefineRegularHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarAndDefineRegularHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarAndDefineRegularHoursMutation, { data, loading, error }] = useCreateCalendarAndDefineRegularHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarAndDefineRegularHoursMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarAndDefineRegularHoursMutation, CreateCalendarAndDefineRegularHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalendarAndDefineRegularHoursMutation, CreateCalendarAndDefineRegularHoursMutationVariables>(CreateCalendarAndDefineRegularHoursDocument, options);
      }
export type CreateCalendarAndDefineRegularHoursMutationHookResult = ReturnType<typeof useCreateCalendarAndDefineRegularHoursMutation>;
export type CreateCalendarAndDefineRegularHoursMutationResult = Apollo.MutationResult<CreateCalendarAndDefineRegularHoursMutation>;
export type CreateCalendarAndDefineRegularHoursMutationOptions = Apollo.BaseMutationOptions<CreateCalendarAndDefineRegularHoursMutation, CreateCalendarAndDefineRegularHoursMutationVariables>;
export const UpdateCalendarRegularHoursDocument = gql`
    mutation UpdateCalendarRegularHours($input: UpdateCalendarRegularHoursInput!) {
  UpdateCalendarRegularHours(updateCalendarRegularHoursInput: $input) {
    Monday
    Tuesday
    Wednesday
    Thursday
    Friday
    Saturday
    Sunday
  }
}
    `;
export type UpdateCalendarRegularHoursMutationFn = Apollo.MutationFunction<UpdateCalendarRegularHoursMutation, UpdateCalendarRegularHoursMutationVariables>;

/**
 * __useUpdateCalendarRegularHoursMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarRegularHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarRegularHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarRegularHoursMutation, { data, loading, error }] = useUpdateCalendarRegularHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarRegularHoursMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarRegularHoursMutation, UpdateCalendarRegularHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarRegularHoursMutation, UpdateCalendarRegularHoursMutationVariables>(UpdateCalendarRegularHoursDocument, options);
      }
export type UpdateCalendarRegularHoursMutationHookResult = ReturnType<typeof useUpdateCalendarRegularHoursMutation>;
export type UpdateCalendarRegularHoursMutationResult = Apollo.MutationResult<UpdateCalendarRegularHoursMutation>;
export type UpdateCalendarRegularHoursMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarRegularHoursMutation, UpdateCalendarRegularHoursMutationVariables>;
export const DisconnectStripeAccountDocument = gql`
    mutation DisconnectStripeAccount {
  DisconnectStripeAccount {
    status
  }
}
    `;
export type DisconnectStripeAccountMutationFn = Apollo.MutationFunction<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>;

/**
 * __useDisconnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectStripeAccountMutation, { data, loading, error }] = useDisconnectStripeAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>(DisconnectStripeAccountDocument, options);
      }
export type DisconnectStripeAccountMutationHookResult = ReturnType<typeof useDisconnectStripeAccountMutation>;
export type DisconnectStripeAccountMutationResult = Apollo.MutationResult<DisconnectStripeAccountMutation>;
export type DisconnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectStripeAccountMutation, DisconnectStripeAccountMutationVariables>;
export const CloseProviderAccountDocument = gql`
    mutation CloseProviderAccount {
  closeProviderAccount {
    status
    message
  }
}
    `;
export type CloseProviderAccountMutationFn = Apollo.MutationFunction<CloseProviderAccountMutation, CloseProviderAccountMutationVariables>;

/**
 * __useCloseProviderAccountMutation__
 *
 * To run a mutation, you first call `useCloseProviderAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseProviderAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeProviderAccountMutation, { data, loading, error }] = useCloseProviderAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useCloseProviderAccountMutation(baseOptions?: Apollo.MutationHookOptions<CloseProviderAccountMutation, CloseProviderAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseProviderAccountMutation, CloseProviderAccountMutationVariables>(CloseProviderAccountDocument, options);
      }
export type CloseProviderAccountMutationHookResult = ReturnType<typeof useCloseProviderAccountMutation>;
export type CloseProviderAccountMutationResult = Apollo.MutationResult<CloseProviderAccountMutation>;
export type CloseProviderAccountMutationOptions = Apollo.BaseMutationOptions<CloseProviderAccountMutation, CloseProviderAccountMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription {
  cancelSubscription {
    message
    status
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ExportProviderDataDocument = gql`
    mutation ExportProviderData {
  ExportProviderData {
    downloadUrl
  }
}
    `;
export type ExportProviderDataMutationFn = Apollo.MutationFunction<ExportProviderDataMutation, ExportProviderDataMutationVariables>;

/**
 * __useExportProviderDataMutation__
 *
 * To run a mutation, you first call `useExportProviderDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportProviderDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportProviderDataMutation, { data, loading, error }] = useExportProviderDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportProviderDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportProviderDataMutation, ExportProviderDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportProviderDataMutation, ExportProviderDataMutationVariables>(ExportProviderDataDocument, options);
      }
export type ExportProviderDataMutationHookResult = ReturnType<typeof useExportProviderDataMutation>;
export type ExportProviderDataMutationResult = Apollo.MutationResult<ExportProviderDataMutation>;
export type ExportProviderDataMutationOptions = Apollo.BaseMutationOptions<ExportProviderDataMutation, ExportProviderDataMutationVariables>;
export const PrescribeVeradigmDocument = gql`
    mutation PrescribeVeradigm($patientCodexId: String, $mode: EPrescribeSSOMode = PatientLockDownMode) {
  ePrescribeJwt(input: {patientCodexId: $patientCodexId, mode: $mode}) {
    jwt
  }
}
    `;
export type PrescribeVeradigmMutationFn = Apollo.MutationFunction<PrescribeVeradigmMutation, PrescribeVeradigmMutationVariables>;

/**
 * __usePrescribeVeradigmMutation__
 *
 * To run a mutation, you first call `usePrescribeVeradigmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrescribeVeradigmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prescribeVeradigmMutation, { data, loading, error }] = usePrescribeVeradigmMutation({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function usePrescribeVeradigmMutation(baseOptions?: Apollo.MutationHookOptions<PrescribeVeradigmMutation, PrescribeVeradigmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrescribeVeradigmMutation, PrescribeVeradigmMutationVariables>(PrescribeVeradigmDocument, options);
      }
export type PrescribeVeradigmMutationHookResult = ReturnType<typeof usePrescribeVeradigmMutation>;
export type PrescribeVeradigmMutationResult = Apollo.MutationResult<PrescribeVeradigmMutation>;
export type PrescribeVeradigmMutationOptions = Apollo.BaseMutationOptions<PrescribeVeradigmMutation, PrescribeVeradigmMutationVariables>;
export const SyncEPrescribeMedicationsByPatientDocument = gql`
    mutation SyncEPrescribeMedicationsByPatient($patientCodexId: String!, $providerCodexId: String, $appointmentCodexId: String) {
  syncEPrescribeMedicationsByPatient(
    patientCodexId: $patientCodexId
    providerCodexId: $providerCodexId
    appointmentCodexId: $appointmentCodexId
  ) {
    message
    status
  }
}
    `;
export type SyncEPrescribeMedicationsByPatientMutationFn = Apollo.MutationFunction<SyncEPrescribeMedicationsByPatientMutation, SyncEPrescribeMedicationsByPatientMutationVariables>;

/**
 * __useSyncEPrescribeMedicationsByPatientMutation__
 *
 * To run a mutation, you first call `useSyncEPrescribeMedicationsByPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEPrescribeMedicationsByPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEPrescribeMedicationsByPatientMutation, { data, loading, error }] = useSyncEPrescribeMedicationsByPatientMutation({
 *   variables: {
 *      patientCodexId: // value for 'patientCodexId'
 *      providerCodexId: // value for 'providerCodexId'
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *   },
 * });
 */
export function useSyncEPrescribeMedicationsByPatientMutation(baseOptions?: Apollo.MutationHookOptions<SyncEPrescribeMedicationsByPatientMutation, SyncEPrescribeMedicationsByPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEPrescribeMedicationsByPatientMutation, SyncEPrescribeMedicationsByPatientMutationVariables>(SyncEPrescribeMedicationsByPatientDocument, options);
      }
export type SyncEPrescribeMedicationsByPatientMutationHookResult = ReturnType<typeof useSyncEPrescribeMedicationsByPatientMutation>;
export type SyncEPrescribeMedicationsByPatientMutationResult = Apollo.MutationResult<SyncEPrescribeMedicationsByPatientMutation>;
export type SyncEPrescribeMedicationsByPatientMutationOptions = Apollo.BaseMutationOptions<SyncEPrescribeMedicationsByPatientMutation, SyncEPrescribeMedicationsByPatientMutationVariables>;
export const UpdateBecomePatientRequestStatusDocument = gql`
    mutation UpdateBecomePatientRequestStatus($requestStatus: ProviderRequestStatus!, $patientFhirId: String!) {
  updateBecomePatientRequestStatus(
    updateBecomePatientRequestStatusInput: {patientFhirId: $patientFhirId, requestStatus: $requestStatus}
  ) {
    requestStatus
  }
}
    `;
export type UpdateBecomePatientRequestStatusMutationFn = Apollo.MutationFunction<UpdateBecomePatientRequestStatusMutation, UpdateBecomePatientRequestStatusMutationVariables>;

/**
 * __useUpdateBecomePatientRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBecomePatientRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBecomePatientRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBecomePatientRequestStatusMutation, { data, loading, error }] = useUpdateBecomePatientRequestStatusMutation({
 *   variables: {
 *      requestStatus: // value for 'requestStatus'
 *      patientFhirId: // value for 'patientFhirId'
 *   },
 * });
 */
export function useUpdateBecomePatientRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBecomePatientRequestStatusMutation, UpdateBecomePatientRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBecomePatientRequestStatusMutation, UpdateBecomePatientRequestStatusMutationVariables>(UpdateBecomePatientRequestStatusDocument, options);
      }
export type UpdateBecomePatientRequestStatusMutationHookResult = ReturnType<typeof useUpdateBecomePatientRequestStatusMutation>;
export type UpdateBecomePatientRequestStatusMutationResult = Apollo.MutationResult<UpdateBecomePatientRequestStatusMutation>;
export type UpdateBecomePatientRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBecomePatientRequestStatusMutation, UpdateBecomePatientRequestStatusMutationVariables>;
export const GetDosespotExternalUnreadNotificationDocument = gql`
    query GetDosespotExternalUnreadNotification($codexProviderId: uuid!) {
  provider_unread_external_notification_counts(
    where: {codex_provider_id: {_eq: $codexProviderId}}
  ) {
    dosespot_unread_notifications
  }
}
    `;

/**
 * __useGetDosespotExternalUnreadNotificationQuery__
 *
 * To run a query within a React component, call `useGetDosespotExternalUnreadNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDosespotExternalUnreadNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDosespotExternalUnreadNotificationQuery({
 *   variables: {
 *      codexProviderId: // value for 'codexProviderId'
 *   },
 * });
 */
export function useGetDosespotExternalUnreadNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetDosespotExternalUnreadNotificationQuery, GetDosespotExternalUnreadNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDosespotExternalUnreadNotificationQuery, GetDosespotExternalUnreadNotificationQueryVariables>(GetDosespotExternalUnreadNotificationDocument, options);
      }
export function useGetDosespotExternalUnreadNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDosespotExternalUnreadNotificationQuery, GetDosespotExternalUnreadNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDosespotExternalUnreadNotificationQuery, GetDosespotExternalUnreadNotificationQueryVariables>(GetDosespotExternalUnreadNotificationDocument, options);
        }
export type GetDosespotExternalUnreadNotificationQueryHookResult = ReturnType<typeof useGetDosespotExternalUnreadNotificationQuery>;
export type GetDosespotExternalUnreadNotificationLazyQueryHookResult = ReturnType<typeof useGetDosespotExternalUnreadNotificationLazyQuery>;
export type GetDosespotExternalUnreadNotificationQueryResult = Apollo.QueryResult<GetDosespotExternalUnreadNotificationQuery, GetDosespotExternalUnreadNotificationQueryVariables>;
export const ValidateNpiDocument = gql`
    query ValidateNpi($npiNumber: String = "") {
  ValidateNpiNumber(npiNumber: $npiNumber) {
    isValid
  }
}
    `;

/**
 * __useValidateNpiQuery__
 *
 * To run a query within a React component, call `useValidateNpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateNpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateNpiQuery({
 *   variables: {
 *      npiNumber: // value for 'npiNumber'
 *   },
 * });
 */
export function useValidateNpiQuery(baseOptions?: Apollo.QueryHookOptions<ValidateNpiQuery, ValidateNpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateNpiQuery, ValidateNpiQueryVariables>(ValidateNpiDocument, options);
      }
export function useValidateNpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateNpiQuery, ValidateNpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateNpiQuery, ValidateNpiQueryVariables>(ValidateNpiDocument, options);
        }
export type ValidateNpiQueryHookResult = ReturnType<typeof useValidateNpiQuery>;
export type ValidateNpiLazyQueryHookResult = ReturnType<typeof useValidateNpiLazyQuery>;
export type ValidateNpiQueryResult = Apollo.QueryResult<ValidateNpiQuery, ValidateNpiQueryVariables>;
export const GetAppointmentSummaryDocument = gql`
    query GetAppointmentSummary($appointmentId: String!) {
  getAppointmentSummary(appointmentCodexId: $appointmentId) {
    summaryPdfFileId
    summary
    transcription
  }
}
    `;

/**
 * __useGetAppointmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetAppointmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSummaryQuery({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>(GetAppointmentSummaryDocument, options);
      }
export function useGetAppointmentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>(GetAppointmentSummaryDocument, options);
        }
export type GetAppointmentSummaryQueryHookResult = ReturnType<typeof useGetAppointmentSummaryQuery>;
export type GetAppointmentSummaryLazyQueryHookResult = ReturnType<typeof useGetAppointmentSummaryLazyQuery>;
export type GetAppointmentSummaryQueryResult = Apollo.QueryResult<GetAppointmentSummaryQuery, GetAppointmentSummaryQueryVariables>;
export const GetBillingInfoDocument = gql`
    query GetBillingInfo {
  getProviderBilling {
    id
    previous_week_payout
    previous_week_refund
    reserved_balance
    upcoming_payment
    total_payouts
    provider_id
  }
}
    `;

/**
 * __useGetBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingInfoQuery, GetBillingInfoQueryVariables>(GetBillingInfoDocument, options);
      }
export function useGetBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingInfoQuery, GetBillingInfoQueryVariables>(GetBillingInfoDocument, options);
        }
export type GetBillingInfoQueryHookResult = ReturnType<typeof useGetBillingInfoQuery>;
export type GetBillingInfoLazyQueryHookResult = ReturnType<typeof useGetBillingInfoLazyQuery>;
export type GetBillingInfoQueryResult = Apollo.QueryResult<GetBillingInfoQuery, GetBillingInfoQueryVariables>;
export const GetFilesByRequestUserCodexIdByProviderDocument = gql`
    query GetFilesByRequestUserCodexIdByProvider($sourceTypes: [MediaFileSourceType!] = APPOINTMENT_DIAGNOSTICS, $patientCodexId: String! = "", $limit: Int! = 10, $offset: Int = 0, $dates: DateFilterArgs) {
  getFilesByRequestUserCodexId(
    input: {patientCodexId: $patientCodexId, sourceTypes: $sourceTypes, dates: $dates, pagination: {limit: $limit, offset: $offset}}
  ) {
    files {
      fileId
      fileName
      url
      contentType
      size
      sourceType
      creation
      authorCodexId
      patient {
        SENSITIVE_lastname
        SENSITIVE_firstname
        id
      }
      provider {
        SENSITIVE_lastname
        SENSITIVE_firstname
        id
      }
    }
    total
  }
}
    `;

/**
 * __useGetFilesByRequestUserCodexIdByProviderQuery__
 *
 * To run a query within a React component, call `useGetFilesByRequestUserCodexIdByProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesByRequestUserCodexIdByProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesByRequestUserCodexIdByProviderQuery({
 *   variables: {
 *      sourceTypes: // value for 'sourceTypes'
 *      patientCodexId: // value for 'patientCodexId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useGetFilesByRequestUserCodexIdByProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesByRequestUserCodexIdByProviderQuery, GetFilesByRequestUserCodexIdByProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesByRequestUserCodexIdByProviderQuery, GetFilesByRequestUserCodexIdByProviderQueryVariables>(GetFilesByRequestUserCodexIdByProviderDocument, options);
      }
export function useGetFilesByRequestUserCodexIdByProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesByRequestUserCodexIdByProviderQuery, GetFilesByRequestUserCodexIdByProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesByRequestUserCodexIdByProviderQuery, GetFilesByRequestUserCodexIdByProviderQueryVariables>(GetFilesByRequestUserCodexIdByProviderDocument, options);
        }
export type GetFilesByRequestUserCodexIdByProviderQueryHookResult = ReturnType<typeof useGetFilesByRequestUserCodexIdByProviderQuery>;
export type GetFilesByRequestUserCodexIdByProviderLazyQueryHookResult = ReturnType<typeof useGetFilesByRequestUserCodexIdByProviderLazyQuery>;
export type GetFilesByRequestUserCodexIdByProviderQueryResult = Apollo.QueryResult<GetFilesByRequestUserCodexIdByProviderQuery, GetFilesByRequestUserCodexIdByProviderQueryVariables>;
export const EPrescribeMyTasksCountDocument = gql`
    query ePrescribeMyTasksCount {
  ePrescribeMyTasksCount {
    total
  }
}
    `;

/**
 * __useEPrescribeMyTasksCountQuery__
 *
 * To run a query within a React component, call `useEPrescribeMyTasksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEPrescribeMyTasksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEPrescribeMyTasksCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useEPrescribeMyTasksCountQuery(baseOptions?: Apollo.QueryHookOptions<EPrescribeMyTasksCountQuery, EPrescribeMyTasksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EPrescribeMyTasksCountQuery, EPrescribeMyTasksCountQueryVariables>(EPrescribeMyTasksCountDocument, options);
      }
export function useEPrescribeMyTasksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EPrescribeMyTasksCountQuery, EPrescribeMyTasksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EPrescribeMyTasksCountQuery, EPrescribeMyTasksCountQueryVariables>(EPrescribeMyTasksCountDocument, options);
        }
export type EPrescribeMyTasksCountQueryHookResult = ReturnType<typeof useEPrescribeMyTasksCountQuery>;
export type EPrescribeMyTasksCountLazyQueryHookResult = ReturnType<typeof useEPrescribeMyTasksCountLazyQuery>;
export type EPrescribeMyTasksCountQueryResult = Apollo.QueryResult<EPrescribeMyTasksCountQuery, EPrescribeMyTasksCountQueryVariables>;
export const GetProviderPayoutTransactionsDocument = gql`
    query GetProviderPayoutTransactions($limit: Int = 10, $offset: Int = 0) {
  getProviderPayoutTransactions(limit: $limit, offset: $offset) {
    payouts {
      appointment_id
      appointments_total
      category
      created_at
      id
      invoice_number
      paid_at
      patient {
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_email
        id
      }
      service_fee
      service_total
      status
      stripe_fee
      stripe_net_amount
      stripe_payment_amount
      stripe_processing_fee
      subscription_id
    }
    total
  }
}
    `;

/**
 * __useGetProviderPayoutTransactionsQuery__
 *
 * To run a query within a React component, call `useGetProviderPayoutTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPayoutTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPayoutTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProviderPayoutTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderPayoutTransactionsQuery, GetProviderPayoutTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPayoutTransactionsQuery, GetProviderPayoutTransactionsQueryVariables>(GetProviderPayoutTransactionsDocument, options);
      }
export function useGetProviderPayoutTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPayoutTransactionsQuery, GetProviderPayoutTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPayoutTransactionsQuery, GetProviderPayoutTransactionsQueryVariables>(GetProviderPayoutTransactionsDocument, options);
        }
export type GetProviderPayoutTransactionsQueryHookResult = ReturnType<typeof useGetProviderPayoutTransactionsQuery>;
export type GetProviderPayoutTransactionsLazyQueryHookResult = ReturnType<typeof useGetProviderPayoutTransactionsLazyQuery>;
export type GetProviderPayoutTransactionsQueryResult = Apollo.QueryResult<GetProviderPayoutTransactionsQuery, GetProviderPayoutTransactionsQueryVariables>;
export const GetProviderPayoutDetailsDocument = gql`
    query GetProviderPayoutDetails($appointmentStatus: [String!], $limit: Int = 10, $offset: Int = 0, $paymentTransactionId: Int) {
  getProviderPayoutDetails(
    paymentTransactionId: $paymentTransactionId
    offset: $offset
    limit: $limit
    appointmentStatus: $appointmentStatus
  ) {
    appointment {
      acuityId
      appointmentCodexId
      codexPatientId
      codexProviderId
      created
      patientFirstName
      patientLastName
      end
      start
      status
      appointmentType
      appointmentStatus
      paymentInformation {
        amount
        balanceImpact
      }
    }
    total
  }
}
    `;

/**
 * __useGetProviderPayoutDetailsQuery__
 *
 * To run a query within a React component, call `useGetProviderPayoutDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPayoutDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPayoutDetailsQuery({
 *   variables: {
 *      appointmentStatus: // value for 'appointmentStatus'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      paymentTransactionId: // value for 'paymentTransactionId'
 *   },
 * });
 */
export function useGetProviderPayoutDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderPayoutDetailsQuery, GetProviderPayoutDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPayoutDetailsQuery, GetProviderPayoutDetailsQueryVariables>(GetProviderPayoutDetailsDocument, options);
      }
export function useGetProviderPayoutDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPayoutDetailsQuery, GetProviderPayoutDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPayoutDetailsQuery, GetProviderPayoutDetailsQueryVariables>(GetProviderPayoutDetailsDocument, options);
        }
export type GetProviderPayoutDetailsQueryHookResult = ReturnType<typeof useGetProviderPayoutDetailsQuery>;
export type GetProviderPayoutDetailsLazyQueryHookResult = ReturnType<typeof useGetProviderPayoutDetailsLazyQuery>;
export type GetProviderPayoutDetailsQueryResult = Apollo.QueryResult<GetProviderPayoutDetailsQuery, GetProviderPayoutDetailsQueryVariables>;
export const GetBecomePatientRequestsDocument = gql`
    query GetBecomePatientRequests($statuses: [ProviderRequestStatus!]) {
  getBecomePatientRequests(input: {statuses: $statuses}) {
    items {
      date
      requestStatus
      patient {
        SENSITIVE_country
        SENSITIVE_dob
        SENSITIVE_email
        SENSITIVE_etnicity
        SENSITIVE_firstname
        SENSITIVE_gender
        SENSITIVE_gender_describe
        SENSITIVE_lastname
        SENSITIVE_phone
        id
        SENSITIVE_profile_picture_id
        SENSITIVE_address_information {
          state
          country
        }
        identifiers {
          fhirId
          codexId
        }
        parentCodexId
      }
      parent {
        autonomy_determination_status
        SENSITIVE_dob
        SENSITIVE_country
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        SENSITIVE_profile_picture_id
        SENSITIVE_address_information {
          state
          country
        }
        id
      }
    }
    serverNow
    total
  }
}
    `;

/**
 * __useGetBecomePatientRequestsQuery__
 *
 * To run a query within a React component, call `useGetBecomePatientRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBecomePatientRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBecomePatientRequestsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetBecomePatientRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetBecomePatientRequestsQuery, GetBecomePatientRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBecomePatientRequestsQuery, GetBecomePatientRequestsQueryVariables>(GetBecomePatientRequestsDocument, options);
      }
export function useGetBecomePatientRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBecomePatientRequestsQuery, GetBecomePatientRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBecomePatientRequestsQuery, GetBecomePatientRequestsQueryVariables>(GetBecomePatientRequestsDocument, options);
        }
export type GetBecomePatientRequestsQueryHookResult = ReturnType<typeof useGetBecomePatientRequestsQuery>;
export type GetBecomePatientRequestsLazyQueryHookResult = ReturnType<typeof useGetBecomePatientRequestsLazyQuery>;
export type GetBecomePatientRequestsQueryResult = Apollo.QueryResult<GetBecomePatientRequestsQuery, GetBecomePatientRequestsQueryVariables>;
export const AppointmentThirdPartyDocument = gql`
    subscription AppointmentThirdParty($appointmentId: uuid!) {
  appointments(where: {id: {_eq: $appointmentId}}) {
    id
    is_message_list_ready
    is_prescription_ready
    is_transcription_ready
  }
}
    `;

/**
 * __useAppointmentThirdPartySubscription__
 *
 * To run a query within a React component, call `useAppointmentThirdPartySubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentThirdPartySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentThirdPartySubscription({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentThirdPartySubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentThirdPartySubscription, AppointmentThirdPartySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentThirdPartySubscription, AppointmentThirdPartySubscriptionVariables>(AppointmentThirdPartyDocument, options);
      }
export type AppointmentThirdPartySubscriptionHookResult = ReturnType<typeof useAppointmentThirdPartySubscription>;
export type AppointmentThirdPartySubscriptionResult = Apollo.SubscriptionResult<AppointmentThirdPartySubscription>;
export const SummaryNotificationsDocument = gql`
    subscription SummaryNotifications($userId: uuid!, $limit: Int = 20, $offset: Int = 0) {
  appointments(
    where: {user_id: {_eq: $userId}, summary_notification: {_eq: true}}
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    createdAt
    appointment_date
    status
    provider_full_name
    is_test_kit_appointment
  }
}
    `;

/**
 * __useSummaryNotificationsSubscription__
 *
 * To run a query within a React component, call `useSummaryNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSummaryNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryNotificationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSummaryNotificationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<SummaryNotificationsSubscription, SummaryNotificationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SummaryNotificationsSubscription, SummaryNotificationsSubscriptionVariables>(SummaryNotificationsDocument, options);
      }
export type SummaryNotificationsSubscriptionHookResult = ReturnType<typeof useSummaryNotificationsSubscription>;
export type SummaryNotificationsSubscriptionResult = Apollo.SubscriptionResult<SummaryNotificationsSubscription>;
export const SaveQuestionnaireDocument = gql`
    mutation SaveQuestionnaire($questionnaireId: Int!, $responses: jsonb!, $is_complete: Boolean) {
  SaveQuestionnaire(
    questionnaire: {questionnaireId: $questionnaireId, responses: $responses, is_complete: $is_complete}
  ) {
    status
    message
  }
}
    `;
export type SaveQuestionnaireMutationFn = Apollo.MutationFunction<SaveQuestionnaireMutation, SaveQuestionnaireMutationVariables>;

/**
 * __useSaveQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSaveQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionnaireMutation, { data, loading, error }] = useSaveQuestionnaireMutation({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      responses: // value for 'responses'
 *      is_complete: // value for 'is_complete'
 *   },
 * });
 */
export function useSaveQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionnaireMutation, SaveQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuestionnaireMutation, SaveQuestionnaireMutationVariables>(SaveQuestionnaireDocument, options);
      }
export type SaveQuestionnaireMutationHookResult = ReturnType<typeof useSaveQuestionnaireMutation>;
export type SaveQuestionnaireMutationResult = Apollo.MutationResult<SaveQuestionnaireMutation>;
export type SaveQuestionnaireMutationOptions = Apollo.BaseMutationOptions<SaveQuestionnaireMutation, SaveQuestionnaireMutationVariables>;
export const SaveQuestionnaireManuallyDocument = gql`
    mutation SaveQuestionnaireManually($questionnaireId: Int!, $userID: uuid!, $responses: jsonb!, $isComplete: Boolean!) {
  insert_questionnaire_responses_one(
    object: {responses: $responses, user_id: $userID, is_complete: $isComplete, questionnaire_id: $questionnaireId}
  ) {
    id
    responses
  }
}
    `;
export type SaveQuestionnaireManuallyMutationFn = Apollo.MutationFunction<SaveQuestionnaireManuallyMutation, SaveQuestionnaireManuallyMutationVariables>;

/**
 * __useSaveQuestionnaireManuallyMutation__
 *
 * To run a mutation, you first call `useSaveQuestionnaireManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionnaireManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionnaireManuallyMutation, { data, loading, error }] = useSaveQuestionnaireManuallyMutation({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      userID: // value for 'userID'
 *      responses: // value for 'responses'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useSaveQuestionnaireManuallyMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionnaireManuallyMutation, SaveQuestionnaireManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuestionnaireManuallyMutation, SaveQuestionnaireManuallyMutationVariables>(SaveQuestionnaireManuallyDocument, options);
      }
export type SaveQuestionnaireManuallyMutationHookResult = ReturnType<typeof useSaveQuestionnaireManuallyMutation>;
export type SaveQuestionnaireManuallyMutationResult = Apollo.MutationResult<SaveQuestionnaireManuallyMutation>;
export type SaveQuestionnaireManuallyMutationOptions = Apollo.BaseMutationOptions<SaveQuestionnaireManuallyMutation, SaveQuestionnaireManuallyMutationVariables>;
export const UpdateQuestionnaireDocument = gql`
    mutation UpdateQuestionnaire($questionnaireId: Int!, $responses: jsonb!) {
  UpdateQuestionnaire(
    questionnaire: {questionnaireId: $questionnaireId, responses: $responses}
  ) {
    status
    message
  }
}
    `;
export type UpdateQuestionnaireMutationFn = Apollo.MutationFunction<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>;

/**
 * __useUpdateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionnaireMutation, { data, loading, error }] = useUpdateQuestionnaireMutation({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useUpdateQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>(UpdateQuestionnaireDocument, options);
      }
export type UpdateQuestionnaireMutationHookResult = ReturnType<typeof useUpdateQuestionnaireMutation>;
export type UpdateQuestionnaireMutationResult = Apollo.MutationResult<UpdateQuestionnaireMutation>;
export type UpdateQuestionnaireMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>;
export const UpdateUserQuestionnaireResponseDocument = gql`
    mutation UpdateUserQuestionnaireResponse($newResponse: jsonb!, $userID: uuid!, $questionnaireID: Int!, $is_complete: Boolean) {
  update_questionnaire_responses(
    _set: {responses: $newResponse}
    where: {user_id: {_eq: $userID}, questionnaire_id: {_eq: $questionnaireID}, is_complete: {_eq: $is_complete}}
  ) {
    returning {
      responses
    }
  }
}
    `;
export type UpdateUserQuestionnaireResponseMutationFn = Apollo.MutationFunction<UpdateUserQuestionnaireResponseMutation, UpdateUserQuestionnaireResponseMutationVariables>;

/**
 * __useUpdateUserQuestionnaireResponseMutation__
 *
 * To run a mutation, you first call `useUpdateUserQuestionnaireResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserQuestionnaireResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserQuestionnaireResponseMutation, { data, loading, error }] = useUpdateUserQuestionnaireResponseMutation({
 *   variables: {
 *      newResponse: // value for 'newResponse'
 *      userID: // value for 'userID'
 *      questionnaireID: // value for 'questionnaireID'
 *      is_complete: // value for 'is_complete'
 *   },
 * });
 */
export function useUpdateUserQuestionnaireResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserQuestionnaireResponseMutation, UpdateUserQuestionnaireResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserQuestionnaireResponseMutation, UpdateUserQuestionnaireResponseMutationVariables>(UpdateUserQuestionnaireResponseDocument, options);
      }
export type UpdateUserQuestionnaireResponseMutationHookResult = ReturnType<typeof useUpdateUserQuestionnaireResponseMutation>;
export type UpdateUserQuestionnaireResponseMutationResult = Apollo.MutationResult<UpdateUserQuestionnaireResponseMutation>;
export type UpdateUserQuestionnaireResponseMutationOptions = Apollo.BaseMutationOptions<UpdateUserQuestionnaireResponseMutation, UpdateUserQuestionnaireResponseMutationVariables>;
export const UpdateUserLatestQuestionnaireDocument = gql`
    mutation UpdateUserLatestQuestionnaire($id: bigint!, $responses: jsonb!, $isComplete: Boolean!) {
  update_questionnaire_responses(
    where: {id: {_eq: $id}}
    _set: {responses: $responses, is_complete: $isComplete}
  ) {
    affected_rows
  }
}
    `;
export type UpdateUserLatestQuestionnaireMutationFn = Apollo.MutationFunction<UpdateUserLatestQuestionnaireMutation, UpdateUserLatestQuestionnaireMutationVariables>;

/**
 * __useUpdateUserLatestQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateUserLatestQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLatestQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLatestQuestionnaireMutation, { data, loading, error }] = useUpdateUserLatestQuestionnaireMutation({
 *   variables: {
 *      id: // value for 'id'
 *      responses: // value for 'responses'
 *      isComplete: // value for 'isComplete'
 *   },
 * });
 */
export function useUpdateUserLatestQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLatestQuestionnaireMutation, UpdateUserLatestQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLatestQuestionnaireMutation, UpdateUserLatestQuestionnaireMutationVariables>(UpdateUserLatestQuestionnaireDocument, options);
      }
export type UpdateUserLatestQuestionnaireMutationHookResult = ReturnType<typeof useUpdateUserLatestQuestionnaireMutation>;
export type UpdateUserLatestQuestionnaireMutationResult = Apollo.MutationResult<UpdateUserLatestQuestionnaireMutation>;
export type UpdateUserLatestQuestionnaireMutationOptions = Apollo.BaseMutationOptions<UpdateUserLatestQuestionnaireMutation, UpdateUserLatestQuestionnaireMutationVariables>;
export const UpdateSelfReportedMedicationDocument = gql`
    mutation UpdateSelfReportedMedication($medications: [SelfReportedMedicationInput!] = []) {
  updateSelfReportedMedication(input: {medications: $medications}) {
    message
    status
  }
}
    `;
export type UpdateSelfReportedMedicationMutationFn = Apollo.MutationFunction<UpdateSelfReportedMedicationMutation, UpdateSelfReportedMedicationMutationVariables>;

/**
 * __useUpdateSelfReportedMedicationMutation__
 *
 * To run a mutation, you first call `useUpdateSelfReportedMedicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfReportedMedicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelfReportedMedicationMutation, { data, loading, error }] = useUpdateSelfReportedMedicationMutation({
 *   variables: {
 *      medications: // value for 'medications'
 *   },
 * });
 */
export function useUpdateSelfReportedMedicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelfReportedMedicationMutation, UpdateSelfReportedMedicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelfReportedMedicationMutation, UpdateSelfReportedMedicationMutationVariables>(UpdateSelfReportedMedicationDocument, options);
      }
export type UpdateSelfReportedMedicationMutationHookResult = ReturnType<typeof useUpdateSelfReportedMedicationMutation>;
export type UpdateSelfReportedMedicationMutationResult = Apollo.MutationResult<UpdateSelfReportedMedicationMutation>;
export type UpdateSelfReportedMedicationMutationOptions = Apollo.BaseMutationOptions<UpdateSelfReportedMedicationMutation, UpdateSelfReportedMedicationMutationVariables>;
export const GetQuestionnaireByIdDocument = gql`
    query GetQuestionnaireById($questionnaire_id: Int!) {
  questionnaires(where: {id: {_eq: $questionnaire_id}}) {
    title
    subtitle
    data
    questionnaires_questionnaire_questions {
      questionnaire_questions_question {
        id
        text
        subtitle
        answers
        ui_control
        dont_know_answer
        double_text_combo_helper_texts
        dropdown_combo_answers
        dropdown_label_1
        dropdown_label_2
        measurement_unit
        response_property
      }
    }
  }
}
    `;

/**
 * __useGetQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireByIdQuery({
 *   variables: {
 *      questionnaire_id: // value for 'questionnaire_id'
 *   },
 * });
 */
export function useGetQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionnaireByIdQuery, GetQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionnaireByIdQuery, GetQuestionnaireByIdQueryVariables>(GetQuestionnaireByIdDocument, options);
      }
export function useGetQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireByIdQuery, GetQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionnaireByIdQuery, GetQuestionnaireByIdQueryVariables>(GetQuestionnaireByIdDocument, options);
        }
export type GetQuestionnaireByIdQueryHookResult = ReturnType<typeof useGetQuestionnaireByIdQuery>;
export type GetQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireByIdLazyQuery>;
export type GetQuestionnaireByIdQueryResult = Apollo.QueryResult<GetQuestionnaireByIdQuery, GetQuestionnaireByIdQueryVariables>;
export const GetQuestionnaireByUserIdAndQuestionnaireIdDocument = gql`
    query GetQuestionnaireByUserIdAndQuestionnaireID($user_id: uuid!, $questionnaire_id: Int = 40) {
  questionnaire_responses(
    where: {questionnaire_id: {_eq: $questionnaire_id}, user_id: {_eq: $user_id}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    is_complete
  }
}
    `;

/**
 * __useGetQuestionnaireByUserIdAndQuestionnaireIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireByUserIdAndQuestionnaireIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireByUserIdAndQuestionnaireIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireByUserIdAndQuestionnaireIdQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      questionnaire_id: // value for 'questionnaire_id'
 *   },
 * });
 */
export function useGetQuestionnaireByUserIdAndQuestionnaireIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionnaireByUserIdAndQuestionnaireIdQuery, GetQuestionnaireByUserIdAndQuestionnaireIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionnaireByUserIdAndQuestionnaireIdQuery, GetQuestionnaireByUserIdAndQuestionnaireIdQueryVariables>(GetQuestionnaireByUserIdAndQuestionnaireIdDocument, options);
      }
export function useGetQuestionnaireByUserIdAndQuestionnaireIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireByUserIdAndQuestionnaireIdQuery, GetQuestionnaireByUserIdAndQuestionnaireIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionnaireByUserIdAndQuestionnaireIdQuery, GetQuestionnaireByUserIdAndQuestionnaireIdQueryVariables>(GetQuestionnaireByUserIdAndQuestionnaireIdDocument, options);
        }
export type GetQuestionnaireByUserIdAndQuestionnaireIdQueryHookResult = ReturnType<typeof useGetQuestionnaireByUserIdAndQuestionnaireIdQuery>;
export type GetQuestionnaireByUserIdAndQuestionnaireIdLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireByUserIdAndQuestionnaireIdLazyQuery>;
export type GetQuestionnaireByUserIdAndQuestionnaireIdQueryResult = Apollo.QueryResult<GetQuestionnaireByUserIdAndQuestionnaireIdQuery, GetQuestionnaireByUserIdAndQuestionnaireIdQueryVariables>;
export const GetQuestionnaireResponsesByUserAndQuestionnaireIdDocument = gql`
    query GetQuestionnaireResponsesByUserAndQuestionnaireID($questionnaire_id: Int!, $user_id: uuid!) {
  questionnaire_responses(
    where: {questionnaire_id: {_eq: $questionnaire_id}, user_id: {_eq: $user_id}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    responses
  }
}
    `;

/**
 * __useGetQuestionnaireResponsesByUserAndQuestionnaireIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireResponsesByUserAndQuestionnaireIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireResponsesByUserAndQuestionnaireIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireResponsesByUserAndQuestionnaireIdQuery({
 *   variables: {
 *      questionnaire_id: // value for 'questionnaire_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetQuestionnaireResponsesByUserAndQuestionnaireIdQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionnaireResponsesByUserAndQuestionnaireIdQuery, GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionnaireResponsesByUserAndQuestionnaireIdQuery, GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryVariables>(GetQuestionnaireResponsesByUserAndQuestionnaireIdDocument, options);
      }
export function useGetQuestionnaireResponsesByUserAndQuestionnaireIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireResponsesByUserAndQuestionnaireIdQuery, GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionnaireResponsesByUserAndQuestionnaireIdQuery, GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryVariables>(GetQuestionnaireResponsesByUserAndQuestionnaireIdDocument, options);
        }
export type GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryHookResult = ReturnType<typeof useGetQuestionnaireResponsesByUserAndQuestionnaireIdQuery>;
export type GetQuestionnaireResponsesByUserAndQuestionnaireIdLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireResponsesByUserAndQuestionnaireIdLazyQuery>;
export type GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryResult = Apollo.QueryResult<GetQuestionnaireResponsesByUserAndQuestionnaireIdQuery, GetQuestionnaireResponsesByUserAndQuestionnaireIdQueryVariables>;
export const GetLatestQuestionnaireByIdDocument = gql`
    query GetLatestQuestionnaireById($questionnaire_id: Int!) {
  questionnaire_responses(
    where: {questionnaire_id: {_eq: $questionnaire_id}, is_complete: {_eq: false}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    responses
    id
  }
}
    `;

/**
 * __useGetLatestQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useGetLatestQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestQuestionnaireByIdQuery({
 *   variables: {
 *      questionnaire_id: // value for 'questionnaire_id'
 *   },
 * });
 */
export function useGetLatestQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLatestQuestionnaireByIdQuery, GetLatestQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestQuestionnaireByIdQuery, GetLatestQuestionnaireByIdQueryVariables>(GetLatestQuestionnaireByIdDocument, options);
      }
export function useGetLatestQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestQuestionnaireByIdQuery, GetLatestQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestQuestionnaireByIdQuery, GetLatestQuestionnaireByIdQueryVariables>(GetLatestQuestionnaireByIdDocument, options);
        }
export type GetLatestQuestionnaireByIdQueryHookResult = ReturnType<typeof useGetLatestQuestionnaireByIdQuery>;
export type GetLatestQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useGetLatestQuestionnaireByIdLazyQuery>;
export type GetLatestQuestionnaireByIdQueryResult = Apollo.QueryResult<GetLatestQuestionnaireByIdQuery, GetLatestQuestionnaireByIdQueryVariables>;
export const UploadCapturedImageDocument = gql`
    mutation UploadCapturedImage($image: String!, $filename: String, $source: String!, $token: String) {
  UploadCapturedImage(
    image: {image: $image, filename: $filename, source: $source, token: $token}
  ) {
    sessionId
    message
    status
  }
}
    `;
export type UploadCapturedImageMutationFn = Apollo.MutationFunction<UploadCapturedImageMutation, UploadCapturedImageMutationVariables>;

/**
 * __useUploadCapturedImageMutation__
 *
 * To run a mutation, you first call `useUploadCapturedImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCapturedImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCapturedImageMutation, { data, loading, error }] = useUploadCapturedImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *      filename: // value for 'filename'
 *      source: // value for 'source'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUploadCapturedImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadCapturedImageMutation, UploadCapturedImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCapturedImageMutation, UploadCapturedImageMutationVariables>(UploadCapturedImageDocument, options);
      }
export type UploadCapturedImageMutationHookResult = ReturnType<typeof useUploadCapturedImageMutation>;
export type UploadCapturedImageMutationResult = Apollo.MutationResult<UploadCapturedImageMutation>;
export type UploadCapturedImageMutationOptions = Apollo.BaseMutationOptions<UploadCapturedImageMutation, UploadCapturedImageMutationVariables>;
export const GetFileUrlFromStorageDocument = gql`
    mutation GetFileUrlFromStorage($fileId: String!) {
  GetSignUrlFormStorage(fileId: $fileId) {
    url
    status
  }
}
    `;
export type GetFileUrlFromStorageMutationFn = Apollo.MutationFunction<GetFileUrlFromStorageMutation, GetFileUrlFromStorageMutationVariables>;

/**
 * __useGetFileUrlFromStorageMutation__
 *
 * To run a mutation, you first call `useGetFileUrlFromStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetFileUrlFromStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getFileUrlFromStorageMutation, { data, loading, error }] = useGetFileUrlFromStorageMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileUrlFromStorageMutation(baseOptions?: Apollo.MutationHookOptions<GetFileUrlFromStorageMutation, GetFileUrlFromStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetFileUrlFromStorageMutation, GetFileUrlFromStorageMutationVariables>(GetFileUrlFromStorageDocument, options);
      }
export type GetFileUrlFromStorageMutationHookResult = ReturnType<typeof useGetFileUrlFromStorageMutation>;
export type GetFileUrlFromStorageMutationResult = Apollo.MutationResult<GetFileUrlFromStorageMutation>;
export type GetFileUrlFromStorageMutationOptions = Apollo.BaseMutationOptions<GetFileUrlFromStorageMutation, GetFileUrlFromStorageMutationVariables>;
export const GetSkintellingentTestByUserIdDocument = gql`
    query GetSkintellingentTestByUserId($offset: Int = 0, $limit: Int = 10, $fromDate: timestamptz = "1970-01-01", $toDate: timestamptz = "9999-12-31", $orderBy: [skintelligent_tests_order_by!] = {skintelligent_tests_test: {created_at: desc}}) {
  skintelligent_tests(
    where: {errors: {_is_null: true}, result_image_id: {_is_null: false}, report_id: {_is_null: false}, skintelligent_tests_test: {created_at: {_gt: $fromDate, _lt: $toDate}}}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    test_id
    inflammatory
    comedone
    pih
    total_lesions
    report_id
    result_image_id
    skintelligent_tests_test {
      created_at
    }
    skintelligent_tests_image_source_type {
      value
    }
  }
  skintelligent_tests_aggregate(
    where: {errors: {_is_null: true}, result_image_id: {_is_null: false}, report_id: {_is_null: false}, skintelligent_tests_test: {created_at: {_gt: $fromDate, _lt: $toDate}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSkintellingentTestByUserIdQuery__
 *
 * To run a query within a React component, call `useGetSkintellingentTestByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkintellingentTestByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkintellingentTestByUserIdQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSkintellingentTestByUserIdQuery(baseOptions?: Apollo.QueryHookOptions<GetSkintellingentTestByUserIdQuery, GetSkintellingentTestByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkintellingentTestByUserIdQuery, GetSkintellingentTestByUserIdQueryVariables>(GetSkintellingentTestByUserIdDocument, options);
      }
export function useGetSkintellingentTestByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkintellingentTestByUserIdQuery, GetSkintellingentTestByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkintellingentTestByUserIdQuery, GetSkintellingentTestByUserIdQueryVariables>(GetSkintellingentTestByUserIdDocument, options);
        }
export type GetSkintellingentTestByUserIdQueryHookResult = ReturnType<typeof useGetSkintellingentTestByUserIdQuery>;
export type GetSkintellingentTestByUserIdLazyQueryHookResult = ReturnType<typeof useGetSkintellingentTestByUserIdLazyQuery>;
export type GetSkintellingentTestByUserIdQueryResult = Apollo.QueryResult<GetSkintellingentTestByUserIdQuery, GetSkintellingentTestByUserIdQueryVariables>;
export const GetSkintellingentTestsCountDocument = gql`
    query GetSkintellingentTestsCount {
  skintelligent_tests_aggregate(
    where: {errors: {_is_null: true}, result_image_id: {_is_null: false}, report_id: {_is_null: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSkintellingentTestsCountQuery__
 *
 * To run a query within a React component, call `useGetSkintellingentTestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkintellingentTestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkintellingentTestsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSkintellingentTestsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetSkintellingentTestsCountQuery, GetSkintellingentTestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkintellingentTestsCountQuery, GetSkintellingentTestsCountQueryVariables>(GetSkintellingentTestsCountDocument, options);
      }
export function useGetSkintellingentTestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkintellingentTestsCountQuery, GetSkintellingentTestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkintellingentTestsCountQuery, GetSkintellingentTestsCountQueryVariables>(GetSkintellingentTestsCountDocument, options);
        }
export type GetSkintellingentTestsCountQueryHookResult = ReturnType<typeof useGetSkintellingentTestsCountQuery>;
export type GetSkintellingentTestsCountLazyQueryHookResult = ReturnType<typeof useGetSkintellingentTestsCountLazyQuery>;
export type GetSkintellingentTestsCountQueryResult = Apollo.QueryResult<GetSkintellingentTestsCountQuery, GetSkintellingentTestsCountQueryVariables>;
export const GetMedicationsDocument = gql`
    query GetMedications($limit: Int, $offset: Int, $search: String) {
  getMedications(search: $search, limit: $limit, offset: $offset) {
    medications {
      activeIngredUnit
      activeNumeratorStrength
      productId
      id
      productNdc
      proprietaryName
    }
  }
}
    `;

/**
 * __useGetMedicationsQuery__
 *
 * To run a query within a React component, call `useGetMedicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMedicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMedicationsQuery, GetMedicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMedicationsQuery, GetMedicationsQueryVariables>(GetMedicationsDocument, options);
      }
export function useGetMedicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMedicationsQuery, GetMedicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMedicationsQuery, GetMedicationsQueryVariables>(GetMedicationsDocument, options);
        }
export type GetMedicationsQueryHookResult = ReturnType<typeof useGetMedicationsQuery>;
export type GetMedicationsLazyQueryHookResult = ReturnType<typeof useGetMedicationsLazyQuery>;
export type GetMedicationsQueryResult = Apollo.QueryResult<GetMedicationsQuery, GetMedicationsQueryVariables>;
export const GetSkintellingentTestBySessionIdDocument = gql`
    subscription GetSkintellingentTestBySessionId($sessionId: String) {
  skintelligent_tests(where: {session_id: {_eq: $sessionId}}) {
    test_id
    session_id
    result_image_id
    report_id
    pih
    overall_score
    inflammatory
    image_source
    errors
    comedone
    total_lesions
    result_processed
    skintelligent_tests_image_source_type {
      value
      comment
    }
    skintelligent_tests_test {
      created_at
    }
    skintelligent_tests_result_image {
      id
      type
    }
  }
}
    `;

/**
 * __useGetSkintellingentTestBySessionIdSubscription__
 *
 * To run a query within a React component, call `useGetSkintellingentTestBySessionIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSkintellingentTestBySessionIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkintellingentTestBySessionIdSubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSkintellingentTestBySessionIdSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetSkintellingentTestBySessionIdSubscription, GetSkintellingentTestBySessionIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetSkintellingentTestBySessionIdSubscription, GetSkintellingentTestBySessionIdSubscriptionVariables>(GetSkintellingentTestBySessionIdDocument, options);
      }
export type GetSkintellingentTestBySessionIdSubscriptionHookResult = ReturnType<typeof useGetSkintellingentTestBySessionIdSubscription>;
export type GetSkintellingentTestBySessionIdSubscriptionResult = Apollo.SubscriptionResult<GetSkintellingentTestBySessionIdSubscription>;
export const GetSkintellingentTestsByUserIdDocument = gql`
    subscription GetSkintellingentTestsByUserId($userId: uuid!) {
  skintelligent_tests_aggregate(
    where: {skintelligent_tests_test: {user_id: {_eq: $userId}}}
    order_by: {skintelligent_tests_test: {created_at: desc}}
  ) {
    nodes {
      session_id
    }
  }
}
    `;

/**
 * __useGetSkintellingentTestsByUserIdSubscription__
 *
 * To run a query within a React component, call `useGetSkintellingentTestsByUserIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSkintellingentTestsByUserIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkintellingentTestsByUserIdSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSkintellingentTestsByUserIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetSkintellingentTestsByUserIdSubscription, GetSkintellingentTestsByUserIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetSkintellingentTestsByUserIdSubscription, GetSkintellingentTestsByUserIdSubscriptionVariables>(GetSkintellingentTestsByUserIdDocument, options);
      }
export type GetSkintellingentTestsByUserIdSubscriptionHookResult = ReturnType<typeof useGetSkintellingentTestsByUserIdSubscription>;
export type GetSkintellingentTestsByUserIdSubscriptionResult = Apollo.SubscriptionResult<GetSkintellingentTestsByUserIdSubscription>;
export const CreateSubscriptionMethodDocument = gql`
    mutation CreateSubscriptionMethod($paymentMethodName: String = "", $stripePaymentMethodId: String = "") {
  createSubscription(
    paymentMethodName: $paymentMethodName
    stripePaymentMethodId: $stripePaymentMethodId
  ) {
    billingPlan {
      amount
      name
      currency
    }
    paymentIntent {
      clientSecret
      status
      stripePaymentIntent
    }
    currentPeriodEnd
    currentPeriodStart
    id
    status
  }
}
    `;
export type CreateSubscriptionMethodMutationFn = Apollo.MutationFunction<CreateSubscriptionMethodMutation, CreateSubscriptionMethodMutationVariables>;

/**
 * __useCreateSubscriptionMethodMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMethodMutation, { data, loading, error }] = useCreateSubscriptionMethodMutation({
 *   variables: {
 *      paymentMethodName: // value for 'paymentMethodName'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useCreateSubscriptionMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMethodMutation, CreateSubscriptionMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMethodMutation, CreateSubscriptionMethodMutationVariables>(CreateSubscriptionMethodDocument, options);
      }
export type CreateSubscriptionMethodMutationHookResult = ReturnType<typeof useCreateSubscriptionMethodMutation>;
export type CreateSubscriptionMethodMutationResult = Apollo.MutationResult<CreateSubscriptionMethodMutation>;
export type CreateSubscriptionMethodMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMethodMutation, CreateSubscriptionMethodMutationVariables>;
export const AttachPaymentMethodDocument = gql`
    mutation AttachPaymentMethod($paymentMethodName: String = "", $stripePaymentMethodId: String = "") {
  attachPaymentMethod(
    paymentMethodName: $paymentMethodName
    stripePaymentMethodId: $stripePaymentMethodId
  ) {
    id
  }
}
    `;
export type AttachPaymentMethodMutationFn = Apollo.MutationFunction<AttachPaymentMethodMutation, AttachPaymentMethodMutationVariables>;

/**
 * __useAttachPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAttachPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachPaymentMethodMutation, { data, loading, error }] = useAttachPaymentMethodMutation({
 *   variables: {
 *      paymentMethodName: // value for 'paymentMethodName'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useAttachPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AttachPaymentMethodMutation, AttachPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachPaymentMethodMutation, AttachPaymentMethodMutationVariables>(AttachPaymentMethodDocument, options);
      }
export type AttachPaymentMethodMutationHookResult = ReturnType<typeof useAttachPaymentMethodMutation>;
export type AttachPaymentMethodMutationResult = Apollo.MutationResult<AttachPaymentMethodMutation>;
export type AttachPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AttachPaymentMethodMutation, AttachPaymentMethodMutationVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation SetDefaultPaymentMethod($paymentMethodId: Int!) {
  setDefaultPaymentMethod(input: {paymentMethodCodexId: $paymentMethodId}) {
    message
    status
  }
}
    `;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const GetClientSecretDocument = gql`
    mutation GetClientSecret {
  createProviderSetupIntent {
    clientSecret
  }
}
    `;
export type GetClientSecretMutationFn = Apollo.MutationFunction<GetClientSecretMutation, GetClientSecretMutationVariables>;

/**
 * __useGetClientSecretMutation__
 *
 * To run a mutation, you first call `useGetClientSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetClientSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getClientSecretMutation, { data, loading, error }] = useGetClientSecretMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetClientSecretMutation(baseOptions?: Apollo.MutationHookOptions<GetClientSecretMutation, GetClientSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetClientSecretMutation, GetClientSecretMutationVariables>(GetClientSecretDocument, options);
      }
export type GetClientSecretMutationHookResult = ReturnType<typeof useGetClientSecretMutation>;
export type GetClientSecretMutationResult = Apollo.MutationResult<GetClientSecretMutation>;
export type GetClientSecretMutationOptions = Apollo.BaseMutationOptions<GetClientSecretMutation, GetClientSecretMutationVariables>;
export const RefundPaymentTransactionDocument = gql`
    mutation RefundPaymentTransaction($id: Float!) {
  refundPaymentTransaction(id: $id) {
    id
    order_ids
  }
}
    `;
export type RefundPaymentTransactionMutationFn = Apollo.MutationFunction<RefundPaymentTransactionMutation, RefundPaymentTransactionMutationVariables>;

/**
 * __useRefundPaymentTransactionMutation__
 *
 * To run a mutation, you first call `useRefundPaymentTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentTransactionMutation, { data, loading, error }] = useRefundPaymentTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundPaymentTransactionMutation(baseOptions?: Apollo.MutationHookOptions<RefundPaymentTransactionMutation, RefundPaymentTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundPaymentTransactionMutation, RefundPaymentTransactionMutationVariables>(RefundPaymentTransactionDocument, options);
      }
export type RefundPaymentTransactionMutationHookResult = ReturnType<typeof useRefundPaymentTransactionMutation>;
export type RefundPaymentTransactionMutationResult = Apollo.MutationResult<RefundPaymentTransactionMutation>;
export type RefundPaymentTransactionMutationOptions = Apollo.BaseMutationOptions<RefundPaymentTransactionMutation, RefundPaymentTransactionMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation DeletePaymentMethod($paymentMethodCodexId: Int!) {
  deletePaymentMethod(paymentMethodCodexId: $paymentMethodCodexId) {
    message
    status
  }
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      paymentMethodCodexId: // value for 'paymentMethodCodexId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const GetPaymentMethodListDocument = gql`
    query GetPaymentMethodList {
  getPaymentMethodList {
    paymentMethods {
      brand
      created_at
      last4
      name
      stripeId
      updated_at
      isDefault
      expirationYear
      expirationMonth
      id
    }
    total
  }
}
    `;

/**
 * __useGetPaymentMethodListQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodListQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodListQuery, GetPaymentMethodListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodListQuery, GetPaymentMethodListQueryVariables>(GetPaymentMethodListDocument, options);
      }
export function useGetPaymentMethodListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodListQuery, GetPaymentMethodListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodListQuery, GetPaymentMethodListQueryVariables>(GetPaymentMethodListDocument, options);
        }
export type GetPaymentMethodListQueryHookResult = ReturnType<typeof useGetPaymentMethodListQuery>;
export type GetPaymentMethodListLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodListLazyQuery>;
export type GetPaymentMethodListQueryResult = Apollo.QueryResult<GetPaymentMethodListQuery, GetPaymentMethodListQueryVariables>;
export const GetStripeSubscriptionsDocument = gql`
    query GetStripeSubscriptions {
  stripe_subscriptions(
    limit: 1
    order_by: {status: asc, current_period_end: desc, id: desc}
  ) {
    id
    customer_id
    payment_method_id
    status
    current_period_end
    cancelled_at
    billing_plan_id
    stripe_billing_plan {
      amount_cents
      created_at
      currency
      id
      interval
      interval_count
      name
      trial_period_days
      updated_at
    }
  }
}
    `;

/**
 * __useGetStripeSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetStripeSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeSubscriptionsQuery, GetStripeSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeSubscriptionsQuery, GetStripeSubscriptionsQueryVariables>(GetStripeSubscriptionsDocument, options);
      }
export function useGetStripeSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeSubscriptionsQuery, GetStripeSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeSubscriptionsQuery, GetStripeSubscriptionsQueryVariables>(GetStripeSubscriptionsDocument, options);
        }
export type GetStripeSubscriptionsQueryHookResult = ReturnType<typeof useGetStripeSubscriptionsQuery>;
export type GetStripeSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetStripeSubscriptionsLazyQuery>;
export type GetStripeSubscriptionsQueryResult = Apollo.QueryResult<GetStripeSubscriptionsQuery, GetStripeSubscriptionsQueryVariables>;
export const GetProviderPaymentDetailsDocument = gql`
    query GetProviderPaymentDetails {
  getProviderPaymentDetails {
    amount
    lastPaymentAt
  }
}
    `;

/**
 * __useGetProviderPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetProviderPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPaymentDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProviderPaymentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderPaymentDetailsQuery, GetProviderPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPaymentDetailsQuery, GetProviderPaymentDetailsQueryVariables>(GetProviderPaymentDetailsDocument, options);
      }
export function useGetProviderPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPaymentDetailsQuery, GetProviderPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPaymentDetailsQuery, GetProviderPaymentDetailsQueryVariables>(GetProviderPaymentDetailsDocument, options);
        }
export type GetProviderPaymentDetailsQueryHookResult = ReturnType<typeof useGetProviderPaymentDetailsQuery>;
export type GetProviderPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetProviderPaymentDetailsLazyQuery>;
export type GetProviderPaymentDetailsQueryResult = Apollo.QueryResult<GetProviderPaymentDetailsQuery, GetProviderPaymentDetailsQueryVariables>;
export const GetMyBillingPlanDocument = gql`
    query GetMyBillingPlan {
  getMyBillingPlan {
    amount
    currency
  }
}
    `;

/**
 * __useGetMyBillingPlanQuery__
 *
 * To run a query within a React component, call `useGetMyBillingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBillingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBillingPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBillingPlanQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBillingPlanQuery, GetMyBillingPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBillingPlanQuery, GetMyBillingPlanQueryVariables>(GetMyBillingPlanDocument, options);
      }
export function useGetMyBillingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBillingPlanQuery, GetMyBillingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBillingPlanQuery, GetMyBillingPlanQueryVariables>(GetMyBillingPlanDocument, options);
        }
export type GetMyBillingPlanQueryHookResult = ReturnType<typeof useGetMyBillingPlanQuery>;
export type GetMyBillingPlanLazyQueryHookResult = ReturnType<typeof useGetMyBillingPlanLazyQuery>;
export type GetMyBillingPlanQueryResult = Apollo.QueryResult<GetMyBillingPlanQuery, GetMyBillingPlanQueryVariables>;
export const GetDiscountCodeDocument = gql`
    query GetDiscountCode($promoCode: String = "") {
  getDiscountCode(promoCode: $promoCode) {
    amountOff
    percentOff
  }
}
    `;

/**
 * __useGetDiscountCodeQuery__
 *
 * To run a query within a React component, call `useGetDiscountCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountCodeQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useGetDiscountCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>(GetDiscountCodeDocument, options);
      }
export function useGetDiscountCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>(GetDiscountCodeDocument, options);
        }
export type GetDiscountCodeQueryHookResult = ReturnType<typeof useGetDiscountCodeQuery>;
export type GetDiscountCodeLazyQueryHookResult = ReturnType<typeof useGetDiscountCodeLazyQuery>;
export type GetDiscountCodeQueryResult = Apollo.QueryResult<GetDiscountCodeQuery, GetDiscountCodeQueryVariables>;
export const GetSubscriptionBillingHistoryDocument = gql`
    query GetSubscriptionBillingHistory($invoiceNumber: String, $limit: Int = 10, $offset: Int = 0) {
  getSubscriptionBillingHistory(
    invoiceNumber: $invoiceNumber
    limit: $limit
    offset: $offset
  ) {
    total
    transactions {
      invoice_number
      category
      created_at
      id
      paid_at
      payment_provider
      status
      total
      subscription {
        id
        currentPeriodEnd
        currentPeriodStart
        status
      }
      stripe_payment_amount
      stripe_net_amount
      stripe_fee
    }
  }
}
    `;

/**
 * __useGetSubscriptionBillingHistoryQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionBillingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionBillingHistoryQuery({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSubscriptionBillingHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionBillingHistoryQuery, GetSubscriptionBillingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionBillingHistoryQuery, GetSubscriptionBillingHistoryQueryVariables>(GetSubscriptionBillingHistoryDocument, options);
      }
export function useGetSubscriptionBillingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionBillingHistoryQuery, GetSubscriptionBillingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionBillingHistoryQuery, GetSubscriptionBillingHistoryQueryVariables>(GetSubscriptionBillingHistoryDocument, options);
        }
export type GetSubscriptionBillingHistoryQueryHookResult = ReturnType<typeof useGetSubscriptionBillingHistoryQuery>;
export type GetSubscriptionBillingHistoryLazyQueryHookResult = ReturnType<typeof useGetSubscriptionBillingHistoryLazyQuery>;
export type GetSubscriptionBillingHistoryQueryResult = Apollo.QueryResult<GetSubscriptionBillingHistoryQuery, GetSubscriptionBillingHistoryQueryVariables>;
export const UpdateProviderApprovalDocument = gql`
    mutation updateProviderApproval($codexId: String!, $approved: Boolean!) {
  patchCodexApproval(approved: $approved, codexProviderID: $codexId) {
    update_providers_one {
      codex_approved
    }
  }
}
    `;
export type UpdateProviderApprovalMutationFn = Apollo.MutationFunction<UpdateProviderApprovalMutation, UpdateProviderApprovalMutationVariables>;

/**
 * __useUpdateProviderApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateProviderApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderApprovalMutation, { data, loading, error }] = useUpdateProviderApprovalMutation({
 *   variables: {
 *      codexId: // value for 'codexId'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useUpdateProviderApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderApprovalMutation, UpdateProviderApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderApprovalMutation, UpdateProviderApprovalMutationVariables>(UpdateProviderApprovalDocument, options);
      }
export type UpdateProviderApprovalMutationHookResult = ReturnType<typeof useUpdateProviderApprovalMutation>;
export type UpdateProviderApprovalMutationResult = Apollo.MutationResult<UpdateProviderApprovalMutation>;
export type UpdateProviderApprovalMutationOptions = Apollo.BaseMutationOptions<UpdateProviderApprovalMutation, UpdateProviderApprovalMutationVariables>;
export const PatchFhirProviderDocument = gql`
    mutation patchFhirProvider($codexId: String!, $input: PatchFHIRProviderInput!) {
  saPatchFHIRProvider(providerCodexId: $codexId, patchFHIRProviderInput: $input) {
    update_providers_one {
      id
    }
  }
}
    `;
export type PatchFhirProviderMutationFn = Apollo.MutationFunction<PatchFhirProviderMutation, PatchFhirProviderMutationVariables>;

/**
 * __usePatchFhirProviderMutation__
 *
 * To run a mutation, you first call `usePatchFhirProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchFhirProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchFhirProviderMutation, { data, loading, error }] = usePatchFhirProviderMutation({
 *   variables: {
 *      codexId: // value for 'codexId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchFhirProviderMutation(baseOptions?: Apollo.MutationHookOptions<PatchFhirProviderMutation, PatchFhirProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchFhirProviderMutation, PatchFhirProviderMutationVariables>(PatchFhirProviderDocument, options);
      }
export type PatchFhirProviderMutationHookResult = ReturnType<typeof usePatchFhirProviderMutation>;
export type PatchFhirProviderMutationResult = Apollo.MutationResult<PatchFhirProviderMutation>;
export type PatchFhirProviderMutationOptions = Apollo.BaseMutationOptions<PatchFhirProviderMutation, PatchFhirProviderMutationVariables>;
export const ArchiveOrderDocument = gql`
    mutation ArchiveOrder($id: Int!) {
  archiveOrder(id: $id) {
    message
    status
  }
}
    `;
export type ArchiveOrderMutationFn = Apollo.MutationFunction<ArchiveOrderMutation, ArchiveOrderMutationVariables>;

/**
 * __useArchiveOrderMutation__
 *
 * To run a mutation, you first call `useArchiveOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOrderMutation, { data, loading, error }] = useArchiveOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveOrderMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOrderMutation, ArchiveOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOrderMutation, ArchiveOrderMutationVariables>(ArchiveOrderDocument, options);
      }
export type ArchiveOrderMutationHookResult = ReturnType<typeof useArchiveOrderMutation>;
export type ArchiveOrderMutationResult = Apollo.MutationResult<ArchiveOrderMutation>;
export type ArchiveOrderMutationOptions = Apollo.BaseMutationOptions<ArchiveOrderMutation, ArchiveOrderMutationVariables>;
export const UpdateOrderStatusDocument = gql`
    mutation UpdateOrderStatus($orderId: Int!, $status: OrderStatusEnum!) {
  updateOrderStatus(input: {orderId: $orderId, status: $status}) {
    message
    status
  }
}
    `;
export type UpdateOrderStatusMutationFn = Apollo.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, options);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = Apollo.MutationResult<UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export const AddSwabCodesDocument = gql`
    mutation addSwabCodes($swabCodes: [AddSwabCodeInput!]) {
  AddSwabCodes(input: {swabCodes: $swabCodes}) {
    existingSwabCodes
    invalidSwabCodesDueSomeIssue
    invalidSwabCodesDueToTypes
    totalAdded
  }
}
    `;
export type AddSwabCodesMutationFn = Apollo.MutationFunction<AddSwabCodesMutation, AddSwabCodesMutationVariables>;

/**
 * __useAddSwabCodesMutation__
 *
 * To run a mutation, you first call `useAddSwabCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSwabCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSwabCodesMutation, { data, loading, error }] = useAddSwabCodesMutation({
 *   variables: {
 *      swabCodes: // value for 'swabCodes'
 *   },
 * });
 */
export function useAddSwabCodesMutation(baseOptions?: Apollo.MutationHookOptions<AddSwabCodesMutation, AddSwabCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSwabCodesMutation, AddSwabCodesMutationVariables>(AddSwabCodesDocument, options);
      }
export type AddSwabCodesMutationHookResult = ReturnType<typeof useAddSwabCodesMutation>;
export type AddSwabCodesMutationResult = Apollo.MutationResult<AddSwabCodesMutation>;
export type AddSwabCodesMutationOptions = Apollo.BaseMutationOptions<AddSwabCodesMutation, AddSwabCodesMutationVariables>;
export const SignupDelegatedAdminDocument = gql`
    mutation SignupDelegatedAdmin($firebaseToken: String = "", $firstname: String = "", $lastname: String = "", $token: String = "") {
  SignupDelegatedAdmin(
    delegatedAdminData: {firebaseToken: $firebaseToken, firstname: $firstname, lastname: $lastname, token: $token}
  ) {
    status
    message
  }
}
    `;
export type SignupDelegatedAdminMutationFn = Apollo.MutationFunction<SignupDelegatedAdminMutation, SignupDelegatedAdminMutationVariables>;

/**
 * __useSignupDelegatedAdminMutation__
 *
 * To run a mutation, you first call `useSignupDelegatedAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupDelegatedAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupDelegatedAdminMutation, { data, loading, error }] = useSignupDelegatedAdminMutation({
 *   variables: {
 *      firebaseToken: // value for 'firebaseToken'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSignupDelegatedAdminMutation(baseOptions?: Apollo.MutationHookOptions<SignupDelegatedAdminMutation, SignupDelegatedAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupDelegatedAdminMutation, SignupDelegatedAdminMutationVariables>(SignupDelegatedAdminDocument, options);
      }
export type SignupDelegatedAdminMutationHookResult = ReturnType<typeof useSignupDelegatedAdminMutation>;
export type SignupDelegatedAdminMutationResult = Apollo.MutationResult<SignupDelegatedAdminMutation>;
export type SignupDelegatedAdminMutationOptions = Apollo.BaseMutationOptions<SignupDelegatedAdminMutation, SignupDelegatedAdminMutationVariables>;
export const CreateDelegatedAdminDocument = gql`
    mutation CreateDelegatedAdmin($permissions: [AdminPermissionType!]!, $email: String = "") {
  createDelegatedAdminInvitation(
    input: {email: $email, permissions: $permissions}
  ) {
    message
    status
  }
}
    `;
export type CreateDelegatedAdminMutationFn = Apollo.MutationFunction<CreateDelegatedAdminMutation, CreateDelegatedAdminMutationVariables>;

/**
 * __useCreateDelegatedAdminMutation__
 *
 * To run a mutation, you first call `useCreateDelegatedAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDelegatedAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDelegatedAdminMutation, { data, loading, error }] = useCreateDelegatedAdminMutation({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateDelegatedAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateDelegatedAdminMutation, CreateDelegatedAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDelegatedAdminMutation, CreateDelegatedAdminMutationVariables>(CreateDelegatedAdminDocument, options);
      }
export type CreateDelegatedAdminMutationHookResult = ReturnType<typeof useCreateDelegatedAdminMutation>;
export type CreateDelegatedAdminMutationResult = Apollo.MutationResult<CreateDelegatedAdminMutation>;
export type CreateDelegatedAdminMutationOptions = Apollo.BaseMutationOptions<CreateDelegatedAdminMutation, CreateDelegatedAdminMutationVariables>;
export const UpdateDelegatedAdminDocument = gql`
    mutation UpdateDelegatedAdmin($permissions: [AdminPermissionType!]!, $id: String!) {
  updateDelegatedAdminPermissions(
    input: {delegatedAdminCodexId: $id, permissions: $permissions}
  ) {
    message
    status
  }
}
    `;
export type UpdateDelegatedAdminMutationFn = Apollo.MutationFunction<UpdateDelegatedAdminMutation, UpdateDelegatedAdminMutationVariables>;

/**
 * __useUpdateDelegatedAdminMutation__
 *
 * To run a mutation, you first call `useUpdateDelegatedAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDelegatedAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDelegatedAdminMutation, { data, loading, error }] = useUpdateDelegatedAdminMutation({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDelegatedAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDelegatedAdminMutation, UpdateDelegatedAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDelegatedAdminMutation, UpdateDelegatedAdminMutationVariables>(UpdateDelegatedAdminDocument, options);
      }
export type UpdateDelegatedAdminMutationHookResult = ReturnType<typeof useUpdateDelegatedAdminMutation>;
export type UpdateDelegatedAdminMutationResult = Apollo.MutationResult<UpdateDelegatedAdminMutation>;
export type UpdateDelegatedAdminMutationOptions = Apollo.BaseMutationOptions<UpdateDelegatedAdminMutation, UpdateDelegatedAdminMutationVariables>;
export const ResendDelegatedAdminInvitationDocument = gql`
    mutation ResendDelegatedAdminInvitation($delegatedAdminCodexId: String = "") {
  resendDelegatedAdminInvitation(
    input: {delegatedAdminCodexId: $delegatedAdminCodexId}
  ) {
    message
    status
  }
}
    `;
export type ResendDelegatedAdminInvitationMutationFn = Apollo.MutationFunction<ResendDelegatedAdminInvitationMutation, ResendDelegatedAdminInvitationMutationVariables>;

/**
 * __useResendDelegatedAdminInvitationMutation__
 *
 * To run a mutation, you first call `useResendDelegatedAdminInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendDelegatedAdminInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendDelegatedAdminInvitationMutation, { data, loading, error }] = useResendDelegatedAdminInvitationMutation({
 *   variables: {
 *      delegatedAdminCodexId: // value for 'delegatedAdminCodexId'
 *   },
 * });
 */
export function useResendDelegatedAdminInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendDelegatedAdminInvitationMutation, ResendDelegatedAdminInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendDelegatedAdminInvitationMutation, ResendDelegatedAdminInvitationMutationVariables>(ResendDelegatedAdminInvitationDocument, options);
      }
export type ResendDelegatedAdminInvitationMutationHookResult = ReturnType<typeof useResendDelegatedAdminInvitationMutation>;
export type ResendDelegatedAdminInvitationMutationResult = Apollo.MutationResult<ResendDelegatedAdminInvitationMutation>;
export type ResendDelegatedAdminInvitationMutationOptions = Apollo.BaseMutationOptions<ResendDelegatedAdminInvitationMutation, ResendDelegatedAdminInvitationMutationVariables>;
export const DeleteDelegatedAdminDocument = gql`
    mutation DeleteDelegatedAdmin($delegatedAdminCodexId: String = "") {
  deleteDelegatedAdmin(input: {delegatedAdminCodexId: $delegatedAdminCodexId}) {
    message
    status
  }
}
    `;
export type DeleteDelegatedAdminMutationFn = Apollo.MutationFunction<DeleteDelegatedAdminMutation, DeleteDelegatedAdminMutationVariables>;

/**
 * __useDeleteDelegatedAdminMutation__
 *
 * To run a mutation, you first call `useDeleteDelegatedAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDelegatedAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDelegatedAdminMutation, { data, loading, error }] = useDeleteDelegatedAdminMutation({
 *   variables: {
 *      delegatedAdminCodexId: // value for 'delegatedAdminCodexId'
 *   },
 * });
 */
export function useDeleteDelegatedAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDelegatedAdminMutation, DeleteDelegatedAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDelegatedAdminMutation, DeleteDelegatedAdminMutationVariables>(DeleteDelegatedAdminDocument, options);
      }
export type DeleteDelegatedAdminMutationHookResult = ReturnType<typeof useDeleteDelegatedAdminMutation>;
export type DeleteDelegatedAdminMutationResult = Apollo.MutationResult<DeleteDelegatedAdminMutation>;
export type DeleteDelegatedAdminMutationOptions = Apollo.BaseMutationOptions<DeleteDelegatedAdminMutation, DeleteDelegatedAdminMutationVariables>;
export const UpdateProductAvailabilityDocument = gql`
    mutation UpdateProductAvailability($inStock: Boolean!, $id: Int!) {
  updateProductAvailability(input: {id: $id, inStock: $inStock}) {
    message
    status
  }
}
    `;
export type UpdateProductAvailabilityMutationFn = Apollo.MutationFunction<UpdateProductAvailabilityMutation, UpdateProductAvailabilityMutationVariables>;

/**
 * __useUpdateProductAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateProductAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductAvailabilityMutation, { data, loading, error }] = useUpdateProductAvailabilityMutation({
 *   variables: {
 *      inStock: // value for 'inStock'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProductAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductAvailabilityMutation, UpdateProductAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductAvailabilityMutation, UpdateProductAvailabilityMutationVariables>(UpdateProductAvailabilityDocument, options);
      }
export type UpdateProductAvailabilityMutationHookResult = ReturnType<typeof useUpdateProductAvailabilityMutation>;
export type UpdateProductAvailabilityMutationResult = Apollo.MutationResult<UpdateProductAvailabilityMutation>;
export type UpdateProductAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateProductAvailabilityMutation, UpdateProductAvailabilityMutationVariables>;
export const SyncShipMonkDocument = gql`
    mutation SyncShipMonk {
  syncShipMonkProducts {
    message
  }
}
    `;
export type SyncShipMonkMutationFn = Apollo.MutationFunction<SyncShipMonkMutation, SyncShipMonkMutationVariables>;

/**
 * __useSyncShipMonkMutation__
 *
 * To run a mutation, you first call `useSyncShipMonkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncShipMonkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncShipMonkMutation, { data, loading, error }] = useSyncShipMonkMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncShipMonkMutation(baseOptions?: Apollo.MutationHookOptions<SyncShipMonkMutation, SyncShipMonkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncShipMonkMutation, SyncShipMonkMutationVariables>(SyncShipMonkDocument, options);
      }
export type SyncShipMonkMutationHookResult = ReturnType<typeof useSyncShipMonkMutation>;
export type SyncShipMonkMutationResult = Apollo.MutationResult<SyncShipMonkMutation>;
export type SyncShipMonkMutationOptions = Apollo.BaseMutationOptions<SyncShipMonkMutation, SyncShipMonkMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($id: Int!) {
  deleteProduct(id: $id) {
    message
  }
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const UpdateProductByAdminDocument = gql`
    mutation UpdateProductByAdmin($inStock: Boolean!, $title: String = "", $shortDescription: String, $id: Int!, $defaultFileId: String!, $price: Float, $providerPrice: Float, $madeIn: String, $fileIds: [String!], $description: String, $contents: String, $category: Int!) {
  updateProduct(
    input: {category: $category, inStock: $inStock, productId: $id, title: $title, contents: $contents, description: $description, fileIds: $fileIds, madeIn: $madeIn, price: $price, shortDescription: $shortDescription, defaultFileId: $defaultFileId, providerPrice: $providerPrice}
  ) {
    id
    updated_at
  }
}
    `;
export type UpdateProductByAdminMutationFn = Apollo.MutationFunction<UpdateProductByAdminMutation, UpdateProductByAdminMutationVariables>;

/**
 * __useUpdateProductByAdminMutation__
 *
 * To run a mutation, you first call `useUpdateProductByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductByAdminMutation, { data, loading, error }] = useUpdateProductByAdminMutation({
 *   variables: {
 *      inStock: // value for 'inStock'
 *      title: // value for 'title'
 *      shortDescription: // value for 'shortDescription'
 *      id: // value for 'id'
 *      defaultFileId: // value for 'defaultFileId'
 *      price: // value for 'price'
 *      providerPrice: // value for 'providerPrice'
 *      madeIn: // value for 'madeIn'
 *      fileIds: // value for 'fileIds'
 *      description: // value for 'description'
 *      contents: // value for 'contents'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useUpdateProductByAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductByAdminMutation, UpdateProductByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductByAdminMutation, UpdateProductByAdminMutationVariables>(UpdateProductByAdminDocument, options);
      }
export type UpdateProductByAdminMutationHookResult = ReturnType<typeof useUpdateProductByAdminMutation>;
export type UpdateProductByAdminMutationResult = Apollo.MutationResult<UpdateProductByAdminMutation>;
export type UpdateProductByAdminMutationOptions = Apollo.BaseMutationOptions<UpdateProductByAdminMutation, UpdateProductByAdminMutationVariables>;
export const SendSupportMessageDocument = gql`
    mutation SendSupportMessage($inMailId: String!, $text: String!, $attachments: [FileAttachmentInput!]) {
  sendSupportMessage(
    input: {attachments: $attachments, chatId: $inMailId, text: $text}
  ) {
    message
    status
  }
}
    `;
export type SendSupportMessageMutationFn = Apollo.MutationFunction<SendSupportMessageMutation, SendSupportMessageMutationVariables>;

/**
 * __useSendSupportMessageMutation__
 *
 * To run a mutation, you first call `useSendSupportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportMessageMutation, { data, loading, error }] = useSendSupportMessageMutation({
 *   variables: {
 *      inMailId: // value for 'inMailId'
 *      text: // value for 'text'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendSupportMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportMessageMutation, SendSupportMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportMessageMutation, SendSupportMessageMutationVariables>(SendSupportMessageDocument, options);
      }
export type SendSupportMessageMutationHookResult = ReturnType<typeof useSendSupportMessageMutation>;
export type SendSupportMessageMutationResult = Apollo.MutationResult<SendSupportMessageMutation>;
export type SendSupportMessageMutationOptions = Apollo.BaseMutationOptions<SendSupportMessageMutation, SendSupportMessageMutationVariables>;
export const GetDiagnosticReportsDocument = gql`
    query getDiagnosticReports($limit: Int, $pageToken: String, $patientFhirId: String, $providerFhirId: String, $types: [String!], $search: String) {
  getDiagnosticReports(
    paging: {limit: $limit, pageToken: $pageToken, search: $search}
    narrowing: {patientFhirId: $patientFhirId, providerFhirId: $providerFhirId}
    types: $types
  ) {
    count
    total
    nextPageToken
    prevPageToken
    reports {
      dates
      type
      identifiers
      status
      flags
      patient {
        identifiers
        first
        last
      }
      provider {
        identifiers
        first
        last
      }
      appointment {
        appointmentId
        end
        start
        created
        lastUpdate
      }
    }
  }
}
    `;

/**
 * __useGetDiagnosticReportsQuery__
 *
 * To run a query within a React component, call `useGetDiagnosticReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosticReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosticReportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *      patientFhirId: // value for 'patientFhirId'
 *      providerFhirId: // value for 'providerFhirId'
 *      types: // value for 'types'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDiagnosticReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetDiagnosticReportsQuery, GetDiagnosticReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiagnosticReportsQuery, GetDiagnosticReportsQueryVariables>(GetDiagnosticReportsDocument, options);
      }
export function useGetDiagnosticReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiagnosticReportsQuery, GetDiagnosticReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiagnosticReportsQuery, GetDiagnosticReportsQueryVariables>(GetDiagnosticReportsDocument, options);
        }
export type GetDiagnosticReportsQueryHookResult = ReturnType<typeof useGetDiagnosticReportsQuery>;
export type GetDiagnosticReportsLazyQueryHookResult = ReturnType<typeof useGetDiagnosticReportsLazyQuery>;
export type GetDiagnosticReportsQueryResult = Apollo.QueryResult<GetDiagnosticReportsQuery, GetDiagnosticReportsQueryVariables>;
export const GetAppointmentsDocument = gql`
    query getAppointments($patientFhirId: String, $providerFhirId: String, $statuses: [String!], $limit: Int = 10, $pageToken: String, $search: String, $orderBy: SAAppointmentOrderBy = {}, $types: [AppointmentTypeEnum!], $toDate: String, $fromDate: String) {
  getAppointments(
    paging: {limit: $limit, pageToken: $pageToken, search: $search}
    toDate: $toDate
    fromDate: $fromDate
    types: $types
    orderBy: $orderBy
    narrowing: {patientFhirId: $patientFhirId, providerFhirId: $providerFhirId}
    statuses: $statuses
  ) {
    count
    total
    nextPageToken
    prevPageToken
    appointments {
      identifiers
      type
      dates
      status
      logs
      patient {
        identifiers
        first
        last
      }
      provider {
        identifiers
        first
        last
      }
    }
  }
}
    `;

/**
 * __useGetAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsQuery({
 *   variables: {
 *      patientFhirId: // value for 'patientFhirId'
 *      providerFhirId: // value for 'providerFhirId'
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      types: // value for 'types'
 *      toDate: // value for 'toDate'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useGetAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
      }
export function useGetAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsQuery, GetAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsQuery, GetAppointmentsQueryVariables>(GetAppointmentsDocument, options);
        }
export type GetAppointmentsQueryHookResult = ReturnType<typeof useGetAppointmentsQuery>;
export type GetAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAppointmentsLazyQuery>;
export type GetAppointmentsQueryResult = Apollo.QueryResult<GetAppointmentsQuery, GetAppointmentsQueryVariables>;
export const GetPatientsDocument = gql`
    query GetPatients($search: String, $providerCodexId: String, $patientCodexId: String, $assignedAtFrom: String, $assignedAtTo: String, $limit: Int = 10, $orderBy: SAPatientOrderBy, $pageToken: String) {
  getPatients(
    filter: {providerCodexId: $providerCodexId, patientCodexId: $patientCodexId, assignedAtFrom: $assignedAtFrom, assignedAtTo: $assignedAtTo}
    orderBy: $orderBy
    paging: {limit: $limit, pageToken: $pageToken, search: $search}
  ) {
    count
    nextPageToken
    prevPageToken
    total
    patients {
      dates
      flags
      assignedAt
      birthDate
      gender
      profilePhoto
      appointmentCount
      testKitCount
      parentCodexId
      phone
      email
      nextAppointment {
        identifiers
        flags
        dates
      }
      identifiers
      first
      last
    }
  }
}
    `;

/**
 * __useGetPatientsQuery__
 *
 * To run a query within a React component, call `useGetPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      providerCodexId: // value for 'providerCodexId'
 *      patientCodexId: // value for 'patientCodexId'
 *      assignedAtFrom: // value for 'assignedAtFrom'
 *      assignedAtTo: // value for 'assignedAtTo'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useGetPatientsQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
      }
export function useGetPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsQuery, GetPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsQuery, GetPatientsQueryVariables>(GetPatientsDocument, options);
        }
export type GetPatientsQueryHookResult = ReturnType<typeof useGetPatientsQuery>;
export type GetPatientsLazyQueryHookResult = ReturnType<typeof useGetPatientsLazyQuery>;
export type GetPatientsQueryResult = Apollo.QueryResult<GetPatientsQuery, GetPatientsQueryVariables>;
export const GetProvidersDocument = gql`
    query GetProviders($search: String, $limit: Int = 10, $pageToken: String, $orderBy: SAProviderOrderBy) {
  getProviders(
    paging: {limit: $limit, pageToken: $pageToken, search: $search}
    orderBy: $orderBy
  ) {
    count
    nextPageToken
    prevPageToken
    total
    providers {
      appointmentCount
      birthDate
      dates
      email
      first
      flags
      identifiers
      gender
      last
      patientCount
      phone
      profilePhoto
      providerOutput {
        SENSITIVE_email
        SENSITIVE_phone
        SENSITIVE_credentials {
          stateLicenses {
            licenseNumber
            state
            expirationDate
          }
          certifications
        }
        SENSITIVE_national_provider_identifier
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_dob
        SENSITIVE_address_information {
          state
          zipCode
          address1
        }
      }
      statuses {
        BAA {
          status
          updatedAt
        }
        HIPAA {
          status
          updatedAt
        }
        fullScriptAccount {
          status
          updatedAt
        }
        personaId {
          status
          updatedAt
        }
        personaInsurance {
          status
          updatedAt
        }
        stripeAccount {
          status
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetProvidersQuery__
 *
 * To run a query within a React component, call `useGetProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
      }
export function useGetProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
        }
export type GetProvidersQueryHookResult = ReturnType<typeof useGetProvidersQuery>;
export type GetProvidersLazyQueryHookResult = ReturnType<typeof useGetProvidersLazyQuery>;
export type GetProvidersQueryResult = Apollo.QueryResult<GetProvidersQuery, GetProvidersQueryVariables>;
export const GetOrdersDocument = gql`
    query getOrders($to: String, $statuses: [OrderStatusEnum!], $patientQuery: String, $idQuery: String, $from: String, $limit: Int = 10, $offset: Int, $direction: OrderByDirections = ASC, $field: OrdersOrderByCriterias = CREATED_AT, $isArchived: Boolean = false) {
  getOrders(
    limit: $limit
    offset: $offset
    filter: {from: $from, idQuery: $idQuery, patientQuery: $patientQuery, statuses: $statuses, to: $to, isArchived: $isArchived}
    orderBy: {direction: $direction, field: $field}
  ) {
    orders {
      created_at
      delivery_address {
        address1
        address2
        city
        country
        created_at
        id
        is_deleted
        phone
        state
        updated_at
        user_id
        zip_code
      }
      delivery_address_id
      delivery_date
      id
      is_archived
      order_products {
        created_at
        id
        order_id
        provider {
          SENSITIVE_email
          SENSITIVE_lastname
          SENSITIVE_firstname
          id
          acuityCalendarId
          acuityOwnerId
          fullscriptId
          ePrescribeUserId
          identifiers {
            patientRequestsListId
            mosaicId
            fullscriptId
            fhirId
            codexId
            acuityOwnerId
            acuityCalendarId
          }
        }
        product {
          aeromed_number
          is_shipmonk_active
          contents
          created_at
          description
          expiration_period
          id
          image_url
          in_stock
          made_in
          po_number
          price
          quantity
          short_description
          title
          updated_at
        }
        product_id
        quantity
        updated_at
      }
      patient {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
        parentCodexId
        sapphirosId
        identifiers {
          acuityCalendar
          acuityId
          acuityOwner
          codexId
          fhirId
          mosaicId
          sapphirosId
        }
      }
      shipping_cost
      status
      subtotal_amount
      tax_amount
      total_amount
      tracking_number
      updated_at
      user_id
    }
    total
  }
}
    `;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      to: // value for 'to'
 *      statuses: // value for 'statuses'
 *      patientQuery: // value for 'patientQuery'
 *      idQuery: // value for 'idQuery'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      direction: // value for 'direction'
 *      field: // value for 'field'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetOrderByIdDocument = gql`
    query getOrderById($id: Int!) {
  getOrderById(id: $id) {
    created_at
    id
    statusHistory {
      status
      datetime
    }
    delivery_address {
      address1
      address2
      city
      country
      phone
      state
      zip_code
    }
    delivery_date
    is_archived
    order_products {
      quantity
      product_id
      product {
        aeromed_number
        is_shipmonk_active
        contents
        created_at
        description
        expiration_period
        in_stock
        price
        quantity
        title
      }
      owner_id
      patientOwner {
        id
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_email
        parentCodexId
        identifiers {
          codexId
          fhirId
          mosaicId
        }
      }
      provider {
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_email
        id
        identifiers {
          acuityCalendarId
          acuityOwnerId
          codexId
          ePrescribeUserId
          fhirId
          fullscriptId
          mosaicId
          patientRequestsListId
        }
      }
    }
    patient {
      id
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_phone
      SENSITIVE_email
      identifiers {
        codexId
        fhirId
        mosaicId
      }
    }
    provider {
      id
      SENSITIVE_firstname
      SENSITIVE_email
      SENSITIVE_lastname
    }
    payment {
      appointment_id
      category
      id
      discount {
        amountOff
        percentOff
        code
      }
      order_ids
      paid_at
      patient_id
      payer_role
      service_fee
      service_total
      status
      total
      transaction_type
      stripe_net_amount
      stripe_fee
      stripe_payment_amount
      stripe_processing_fee
    }
    status
    subtotal_amount
    shipping_cost
    tracking_number
    total_amount
    tax_amount
  }
}
    `;

/**
 * __useGetOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrderByIdQuery, GetOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderByIdQuery, GetOrderByIdQueryVariables>(GetOrderByIdDocument, options);
      }
export function useGetOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderByIdQuery, GetOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderByIdQuery, GetOrderByIdQueryVariables>(GetOrderByIdDocument, options);
        }
export type GetOrderByIdQueryHookResult = ReturnType<typeof useGetOrderByIdQuery>;
export type GetOrderByIdLazyQueryHookResult = ReturnType<typeof useGetOrderByIdLazyQuery>;
export type GetOrderByIdQueryResult = Apollo.QueryResult<GetOrderByIdQuery, GetOrderByIdQueryVariables>;
export const GetAvailableSwabCodesDocument = gql`
    query GetAvailableSwabCodes($to: String, $from: String, $limit: Int, $offset: Int, $types: [Hasura_Test_Types_Enum!], $search: String) {
  getSwabCodes(
    filter: {to: $to, from: $from, types: $types}
    limit: $limit
    offset: $offset
    search: $search
  ) {
    swab_codes {
      created_at
      id
      lab_name
      status
      swab_code
      swab_usage_type
      test_type
      swab_codes_test {
        created_at
        state
        test_id
        user_id
      }
    }
    total
  }
}
    `;

/**
 * __useGetAvailableSwabCodesQuery__
 *
 * To run a query within a React component, call `useGetAvailableSwabCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableSwabCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableSwabCodesQuery({
 *   variables: {
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      types: // value for 'types'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAvailableSwabCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableSwabCodesQuery, GetAvailableSwabCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableSwabCodesQuery, GetAvailableSwabCodesQueryVariables>(GetAvailableSwabCodesDocument, options);
      }
export function useGetAvailableSwabCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableSwabCodesQuery, GetAvailableSwabCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableSwabCodesQuery, GetAvailableSwabCodesQueryVariables>(GetAvailableSwabCodesDocument, options);
        }
export type GetAvailableSwabCodesQueryHookResult = ReturnType<typeof useGetAvailableSwabCodesQuery>;
export type GetAvailableSwabCodesLazyQueryHookResult = ReturnType<typeof useGetAvailableSwabCodesLazyQuery>;
export type GetAvailableSwabCodesQueryResult = Apollo.QueryResult<GetAvailableSwabCodesQuery, GetAvailableSwabCodesQueryVariables>;
export const GetPaymentTransactionsDocument = gql`
    query GetPaymentTransactions($search: String, $direction: OrderByDirections = DESC, $field: PaymentTransactionOrderByCriterias = CREATED_AT, $offset: Int = 10, $limit: Int = 10, $to: String, $from: String, $userCodexId: String, $paymentProvider: PaymentProviderEnum, $discountApplied: Boolean, $statuses: [PaymentTransactionStatusEnum!], $types: [PaymentTransactionPaymentTypeEnum!], $categories: [PaymentTransactionPaymentCategoryEnum!]) {
  getPaymentTransactions(
    limit: $limit
    offset: $offset
    orderBy: {direction: $direction, field: $field}
    filter: {paymentProvider: $paymentProvider, discountApplied: $discountApplied, categories: $categories, search: $search, from: $from, statuses: $statuses, to: $to, types: $types, userCodexId: $userCodexId}
  ) {
    total
    transactions {
      appointment_id
      category
      created_at
      order_ids
      id
      invoice_number
      paid_at
      payer_role
      patient {
        SENSITIVE_email
        id
        created_at
        updated_at
      }
      patient_id
      provider {
        SENSITIVE_email
        id
      }
      provider_id
      service_fee
      service_total
      status
      stripe_fee
      total
      order_ids
      transaction_type
    }
  }
}
    `;

/**
 * __useGetPaymentTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTransactionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      direction: // value for 'direction'
 *      field: // value for 'field'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      userCodexId: // value for 'userCodexId'
 *      paymentProvider: // value for 'paymentProvider'
 *      discountApplied: // value for 'discountApplied'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useGetPaymentTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>(GetPaymentTransactionsDocument, options);
      }
export function useGetPaymentTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>(GetPaymentTransactionsDocument, options);
        }
export type GetPaymentTransactionsQueryHookResult = ReturnType<typeof useGetPaymentTransactionsQuery>;
export type GetPaymentTransactionsLazyQueryHookResult = ReturnType<typeof useGetPaymentTransactionsLazyQuery>;
export type GetPaymentTransactionsQueryResult = Apollo.QueryResult<GetPaymentTransactionsQuery, GetPaymentTransactionsQueryVariables>;
export const GetPaymentTransactionByIdDocument = gql`
    query GetPaymentTransactionById($id: Int!) {
  getPaymentTransactionById(id: $id) {
    appointment_id
    appointment {
      created
      start
      status
      appointmentStatus
      appointmentCodexId
      appointmentId
      paymentInformation {
        amount
        discount {
          amountOff
          code
          percentOff
        }
      }
    }
    discount {
      amountOff
      code
      percentOff
    }
    category
    created_at
    updated_at
    id
    order_ids
    paid_at
    payer_role
    patient {
      SENSITIVE_email
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_phone
      identifiers {
        codexId
        fhirId
        sapphirosId
      }
      id
    }
    provider {
      SENSITIVE_email
      SENSITIVE_firstname
      SENSITIVE_lastname
      SENSITIVE_phone
      id
      identifiers {
        mosaicId
        fullscriptId
        fhirId
        codexId
        acuityCalendarId
      }
    }
    service_fee
    service_total
    status
    stripe_fee
    subscription_id
    total
    transaction_type
    weeklyPaymentDetails {
      periodEnd
      periodStart
      completedAppointments
    }
    subscription {
      status
      id
      currentPeriodStart
      currentPeriodEnd
    }
    orders {
      created_at
      carrier
      id
      shipping_cost
      status
      subtotal_amount
      tax_amount
      total_amount
      payment {
        appointment_id
        category
        id
        order_ids
        paid_at
        patient_id
        payer_role
        service_fee
        service_total
        status
        total
        transaction_type
        stripe_net_amount
        stripe_fee
        stripe_payment_amount
        stripe_processing_fee
      }
      order_products {
        quantity
        product_id
        product {
          aeromed_number
          is_shipmonk_active
          contents
          created_at
          description
          expiration_period
          in_stock
          price
          quantity
          title
        }
        owner_id
        patientOwner {
          id
          SENSITIVE_firstname
          SENSITIVE_lastname
          SENSITIVE_email
          parentCodexId
          identifiers {
            codexId
            fhirId
            mosaicId
          }
        }
        provider {
          SENSITIVE_firstname
          SENSITIVE_lastname
          SENSITIVE_email
          id
          identifiers {
            acuityCalendarId
            acuityOwnerId
            codexId
            ePrescribeUserId
            fhirId
            fullscriptId
            mosaicId
            patientRequestsListId
          }
        }
      }
      patient {
        id
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        SENSITIVE_email
        identifiers {
          codexId
          fhirId
          mosaicId
        }
      }
    }
    related_payments {
      appointment_id
      category
      created_at
      updated_at
      id
      order_ids
      paid_at
      payer_role
      patient {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
      }
      provider {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
      }
      service_fee
      service_total
      status
      stripe_fee
      subscription_id
      total
      transaction_type
      weeklyPaymentDetails {
        periodEnd
        periodStart
        completedAppointments
      }
    }
  }
}
    `;

/**
 * __useGetPaymentTransactionByIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentTransactionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTransactionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTransactionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentTransactionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentTransactionByIdQuery, GetPaymentTransactionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTransactionByIdQuery, GetPaymentTransactionByIdQueryVariables>(GetPaymentTransactionByIdDocument, options);
      }
export function useGetPaymentTransactionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTransactionByIdQuery, GetPaymentTransactionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTransactionByIdQuery, GetPaymentTransactionByIdQueryVariables>(GetPaymentTransactionByIdDocument, options);
        }
export type GetPaymentTransactionByIdQueryHookResult = ReturnType<typeof useGetPaymentTransactionByIdQuery>;
export type GetPaymentTransactionByIdLazyQueryHookResult = ReturnType<typeof useGetPaymentTransactionByIdLazyQuery>;
export type GetPaymentTransactionByIdQueryResult = Apollo.QueryResult<GetPaymentTransactionByIdQuery, GetPaymentTransactionByIdQueryVariables>;
export const ValidateDelegatedAdminInvitationTokenDocument = gql`
    query ValidateDelegatedAdminInvitationToken($token: String!, $email: String!) {
  validateDelegatedAdminInvitationToken(input: {token: $token, email: $email}) {
    isValid
    email
  }
}
    `;

/**
 * __useValidateDelegatedAdminInvitationTokenQuery__
 *
 * To run a query within a React component, call `useValidateDelegatedAdminInvitationTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateDelegatedAdminInvitationTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateDelegatedAdminInvitationTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateDelegatedAdminInvitationTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateDelegatedAdminInvitationTokenQuery, ValidateDelegatedAdminInvitationTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateDelegatedAdminInvitationTokenQuery, ValidateDelegatedAdminInvitationTokenQueryVariables>(ValidateDelegatedAdminInvitationTokenDocument, options);
      }
export function useValidateDelegatedAdminInvitationTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateDelegatedAdminInvitationTokenQuery, ValidateDelegatedAdminInvitationTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateDelegatedAdminInvitationTokenQuery, ValidateDelegatedAdminInvitationTokenQueryVariables>(ValidateDelegatedAdminInvitationTokenDocument, options);
        }
export type ValidateDelegatedAdminInvitationTokenQueryHookResult = ReturnType<typeof useValidateDelegatedAdminInvitationTokenQuery>;
export type ValidateDelegatedAdminInvitationTokenLazyQueryHookResult = ReturnType<typeof useValidateDelegatedAdminInvitationTokenLazyQuery>;
export type ValidateDelegatedAdminInvitationTokenQueryResult = Apollo.QueryResult<ValidateDelegatedAdminInvitationTokenQuery, ValidateDelegatedAdminInvitationTokenQueryVariables>;
export const GetDelegatedAdminsDocument = gql`
    query GetDelegatedAdmins($limit: Int = 10, $offset: Int = 0, $direction: OrderByDirections, $field: DelegatedAdminOrderByCriterias, $search: String, $fromDate: String, $toDate: String, $status: Boolean) {
  getDelegatedAdmins(
    pagination: {limit: $limit, offset: $offset}
    orderBy: {direction: $direction, field: $field}
    filters: {search: $search, inviteDateTo: $toDate, inviteDateFrom: $fromDate, isAccepted: $status, isDeleted: false}
  ) {
    total
    delegatedAdmins {
      acceptedAt
      accountDeletedAt
      email
      firstName
      id
      invitationId
      invitedAt
      lastName
    }
  }
}
    `;

/**
 * __useGetDelegatedAdminsQuery__
 *
 * To run a query within a React component, call `useGetDelegatedAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDelegatedAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDelegatedAdminsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      direction: // value for 'direction'
 *      field: // value for 'field'
 *      search: // value for 'search'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDelegatedAdminsQuery(baseOptions?: Apollo.QueryHookOptions<GetDelegatedAdminsQuery, GetDelegatedAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDelegatedAdminsQuery, GetDelegatedAdminsQueryVariables>(GetDelegatedAdminsDocument, options);
      }
export function useGetDelegatedAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDelegatedAdminsQuery, GetDelegatedAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDelegatedAdminsQuery, GetDelegatedAdminsQueryVariables>(GetDelegatedAdminsDocument, options);
        }
export type GetDelegatedAdminsQueryHookResult = ReturnType<typeof useGetDelegatedAdminsQuery>;
export type GetDelegatedAdminsLazyQueryHookResult = ReturnType<typeof useGetDelegatedAdminsLazyQuery>;
export type GetDelegatedAdminsQueryResult = Apollo.QueryResult<GetDelegatedAdminsQuery, GetDelegatedAdminsQueryVariables>;
export const GetDelegatedAdminByIdDocument = gql`
    query GetDelegatedAdminById($delegatedAdminCodexId: String!) {
  getDelegatedAdminDetails(input: {delegatedAdminCodexId: $delegatedAdminCodexId}) {
    acceptedAt
    email
    firstName
    invitationId
    id
    invitedAt
    lastName
    accountDeletedAt
    deletedByEmail
    permissions
  }
}
    `;

/**
 * __useGetDelegatedAdminByIdQuery__
 *
 * To run a query within a React component, call `useGetDelegatedAdminByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDelegatedAdminByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDelegatedAdminByIdQuery({
 *   variables: {
 *      delegatedAdminCodexId: // value for 'delegatedAdminCodexId'
 *   },
 * });
 */
export function useGetDelegatedAdminByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDelegatedAdminByIdQuery, GetDelegatedAdminByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDelegatedAdminByIdQuery, GetDelegatedAdminByIdQueryVariables>(GetDelegatedAdminByIdDocument, options);
      }
export function useGetDelegatedAdminByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDelegatedAdminByIdQuery, GetDelegatedAdminByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDelegatedAdminByIdQuery, GetDelegatedAdminByIdQueryVariables>(GetDelegatedAdminByIdDocument, options);
        }
export type GetDelegatedAdminByIdQueryHookResult = ReturnType<typeof useGetDelegatedAdminByIdQuery>;
export type GetDelegatedAdminByIdLazyQueryHookResult = ReturnType<typeof useGetDelegatedAdminByIdLazyQuery>;
export type GetDelegatedAdminByIdQueryResult = Apollo.QueryResult<GetDelegatedAdminByIdQuery, GetDelegatedAdminByIdQueryVariables>;
export const GetAdminAppointmentDetailsDocument = gql`
    query GetAdminAppointmentDetails($appointmentCodexId: String, $appointmentFhirId: String) {
  getAppointmentDetails(
    appointmentCodexId: $appointmentCodexId
    appointmentFhirId: $appointmentFhirId
  ) {
    appointmentIds
    appointmentStart
    createdAt
    appointmentStatus
    originalTransaction {
      category
      created_at
      id
      status
      order_ids
      service_fee
      service_total
      stripe_fee
      stripe_net_amount
      stripe_payment_amount
      stripe_processing_fee
      total
      transaction_type
      patient {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
      }
      provider {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
      }
    }
    refundTransactions {
      category
      created_at
      id
      status
      service_fee
      service_total
      stripe_fee
      stripe_net_amount
      stripe_payment_amount
      stripe_processing_fee
      total
      order_ids
      transaction_type
      patient {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
      }
      provider {
        SENSITIVE_email
        SENSITIVE_firstname
        SENSITIVE_lastname
        SENSITIVE_phone
        id
      }
    }
    status
    transactionCategory
    patient {
      first
      email
      flags
      identifiers
      last
      phone
      dates
      appointmentCount
      testKitCount
    }
    statusHistory {
      datetime
      status
    }
    provider {
      dates
      email
      first
      flags
      identifiers
      appointmentCount
      patientCount
      statuses {
        BAA {
          status
          updatedAt
        }
        HIPAA {
          status
          updatedAt
        }
        fullScriptAccount {
          status
          updatedAt
        }
        personaId {
          status
          updatedAt
        }
        personaInsurance {
          status
          updatedAt
        }
        stripeAccount {
          status
          updatedAt
        }
      }
      last
      phone
    }
  }
}
    `;

/**
 * __useGetAdminAppointmentDetailsQuery__
 *
 * To run a query within a React component, call `useGetAdminAppointmentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAppointmentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAppointmentDetailsQuery({
 *   variables: {
 *      appointmentCodexId: // value for 'appointmentCodexId'
 *      appointmentFhirId: // value for 'appointmentFhirId'
 *   },
 * });
 */
export function useGetAdminAppointmentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminAppointmentDetailsQuery, GetAdminAppointmentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAppointmentDetailsQuery, GetAdminAppointmentDetailsQueryVariables>(GetAdminAppointmentDetailsDocument, options);
      }
export function useGetAdminAppointmentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAppointmentDetailsQuery, GetAdminAppointmentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAppointmentDetailsQuery, GetAdminAppointmentDetailsQueryVariables>(GetAdminAppointmentDetailsDocument, options);
        }
export type GetAdminAppointmentDetailsQueryHookResult = ReturnType<typeof useGetAdminAppointmentDetailsQuery>;
export type GetAdminAppointmentDetailsLazyQueryHookResult = ReturnType<typeof useGetAdminAppointmentDetailsLazyQuery>;
export type GetAdminAppointmentDetailsQueryResult = Apollo.QueryResult<GetAdminAppointmentDetailsQuery, GetAdminAppointmentDetailsQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($inStock: Boolean, $categories: [Int!], $limit: Int!, $offset: Int = 0, $search: String) {
  getProducts(
    offset: $offset
    search: $search
    limit: $limit
    categories: $categories
    inStock: $inStock
  ) {
    products {
      aeromed_number
      category
      created_at
      updated_at
      description
      id
      in_stock
      is_shipmonk_active
      provider_price
      price
      quantity
      reserved_quantity
      sku
      title
    }
    total
    lastShipMonkSyncAt
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      inStock: // value for 'inStock'
 *      categories: // value for 'categories'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDetailsDocument = gql`
    query GetProductDetails($id: Int!) {
  getProductDetails(id: $id) {
    aeromed_number
    description
    created_at
    id
    in_stock
    is_shipmonk_active
    is_shipmonk_deleted
    po_number
    price
    quantity
    short_description
    title
    sku
    updated_at
    specs {
      contents
      expiration_period
      made_in
    }
    category
    provider_price
    default_image_id
    image_ids
  }
}
    `;

/**
 * __useGetProductDetailsQuery__
 *
 * To run a query within a React component, call `useGetProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetProductDetailsQuery, GetProductDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductDetailsQuery, GetProductDetailsQueryVariables>(GetProductDetailsDocument, options);
      }
export function useGetProductDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductDetailsQuery, GetProductDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductDetailsQuery, GetProductDetailsQueryVariables>(GetProductDetailsDocument, options);
        }
export type GetProductDetailsQueryHookResult = ReturnType<typeof useGetProductDetailsQuery>;
export type GetProductDetailsLazyQueryHookResult = ReturnType<typeof useGetProductDetailsLazyQuery>;
export type GetProductDetailsQueryResult = Apollo.QueryResult<GetProductDetailsQuery, GetProductDetailsQueryVariables>;
export const GetTestKitAdminDetailsDocument = gql`
    query GetTestKitAdminDetails($swabcode: String!) {
  getTestKitDetails(swabcode: $swabcode) {
    codexId
    fhirId
    labOrderId
    patient {
      codexId
      email
      fhirId
      firstName
      lastName
    }
    provider {
      codexId
      email
      fhirId
      firstName
      lastName
    }
    questionnaireCompleted
    status
    statusHistory {
      datetime
      status
    }
    swabCode
    trackingNumber
    type
  }
}
    `;

/**
 * __useGetTestKitAdminDetailsQuery__
 *
 * To run a query within a React component, call `useGetTestKitAdminDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestKitAdminDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestKitAdminDetailsQuery({
 *   variables: {
 *      swabcode: // value for 'swabcode'
 *   },
 * });
 */
export function useGetTestKitAdminDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTestKitAdminDetailsQuery, GetTestKitAdminDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestKitAdminDetailsQuery, GetTestKitAdminDetailsQueryVariables>(GetTestKitAdminDetailsDocument, options);
      }
export function useGetTestKitAdminDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestKitAdminDetailsQuery, GetTestKitAdminDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestKitAdminDetailsQuery, GetTestKitAdminDetailsQueryVariables>(GetTestKitAdminDetailsDocument, options);
        }
export type GetTestKitAdminDetailsQueryHookResult = ReturnType<typeof useGetTestKitAdminDetailsQuery>;
export type GetTestKitAdminDetailsLazyQueryHookResult = ReturnType<typeof useGetTestKitAdminDetailsLazyQuery>;
export type GetTestKitAdminDetailsQueryResult = Apollo.QueryResult<GetTestKitAdminDetailsQuery, GetTestKitAdminDetailsQueryVariables>;
export const GetAppointmentStatsDocument = gql`
    query GetAppointmentStats($fromDate: String, $toDate: String) {
  getAppointmentStats(fromDate: $fromDate, toDate: $toDate) {
    appointmentStats {
      total
      breakdown {
        status
        total
      }
    }
    date
  }
}
    `;

/**
 * __useGetAppointmentStatsQuery__
 *
 * To run a query within a React component, call `useGetAppointmentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentStatsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetAppointmentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>(GetAppointmentStatsDocument, options);
      }
export function useGetAppointmentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>(GetAppointmentStatsDocument, options);
        }
export type GetAppointmentStatsQueryHookResult = ReturnType<typeof useGetAppointmentStatsQuery>;
export type GetAppointmentStatsLazyQueryHookResult = ReturnType<typeof useGetAppointmentStatsLazyQuery>;
export type GetAppointmentStatsQueryResult = Apollo.QueryResult<GetAppointmentStatsQuery, GetAppointmentStatsQueryVariables>;
export const GetOrderStatsDocument = gql`
    query getOrderStats($fromDate: String, $toDate: String) {
  getOrderStats(toDate: $toDate, fromDate: $fromDate) {
    date
    orderStats {
      total
      breakdown {
        status
        total
      }
    }
  }
}
    `;

/**
 * __useGetOrderStatsQuery__
 *
 * To run a query within a React component, call `useGetOrderStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderStatsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrderStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderStatsQuery, GetOrderStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderStatsQuery, GetOrderStatsQueryVariables>(GetOrderStatsDocument, options);
      }
export function useGetOrderStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderStatsQuery, GetOrderStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderStatsQuery, GetOrderStatsQueryVariables>(GetOrderStatsDocument, options);
        }
export type GetOrderStatsQueryHookResult = ReturnType<typeof useGetOrderStatsQuery>;
export type GetOrderStatsLazyQueryHookResult = ReturnType<typeof useGetOrderStatsLazyQuery>;
export type GetOrderStatsQueryResult = Apollo.QueryResult<GetOrderStatsQuery, GetOrderStatsQueryVariables>;
export const GetTestKitStatsDocument = gql`
    query GetTestKitStats($fromDate: String, $toDate: String, $filters: TestKitStatsFiltersInput = {}) {
  getTestKitStats(filters: $filters, fromDate: $fromDate, toDate: $toDate) {
    date
    testKitStats {
      breakdown {
        status
        total
      }
      total
    }
  }
}
    `;

/**
 * __useGetTestKitStatsQuery__
 *
 * To run a query within a React component, call `useGetTestKitStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestKitStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestKitStatsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTestKitStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTestKitStatsQuery, GetTestKitStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestKitStatsQuery, GetTestKitStatsQueryVariables>(GetTestKitStatsDocument, options);
      }
export function useGetTestKitStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestKitStatsQuery, GetTestKitStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestKitStatsQuery, GetTestKitStatsQueryVariables>(GetTestKitStatsDocument, options);
        }
export type GetTestKitStatsQueryHookResult = ReturnType<typeof useGetTestKitStatsQuery>;
export type GetTestKitStatsLazyQueryHookResult = ReturnType<typeof useGetTestKitStatsLazyQuery>;
export type GetTestKitStatsQueryResult = Apollo.QueryResult<GetTestKitStatsQuery, GetTestKitStatsQueryVariables>;
export const GetGeneralDashboardStatsDocument = gql`
    query GetGeneralDashboardStats {
  getGeneralDashboardStats {
    totalAppointments
    totalPatients
    totalProviders
    totalRevenue
    totalTestKits
  }
}
    `;

/**
 * __useGetGeneralDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetGeneralDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralDashboardStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneralDashboardStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralDashboardStatsQuery, GetGeneralDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralDashboardStatsQuery, GetGeneralDashboardStatsQueryVariables>(GetGeneralDashboardStatsDocument, options);
      }
export function useGetGeneralDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralDashboardStatsQuery, GetGeneralDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralDashboardStatsQuery, GetGeneralDashboardStatsQueryVariables>(GetGeneralDashboardStatsDocument, options);
        }
export type GetGeneralDashboardStatsQueryHookResult = ReturnType<typeof useGetGeneralDashboardStatsQuery>;
export type GetGeneralDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetGeneralDashboardStatsLazyQuery>;
export type GetGeneralDashboardStatsQueryResult = Apollo.QueryResult<GetGeneralDashboardStatsQuery, GetGeneralDashboardStatsQueryVariables>;
export const GetUserRegistrationStatsDocument = gql`
    query GetUserRegistrationStats($fromDate: String, $toDate: String) {
  getUserRegistrationStats(toDate: $toDate, fromDate: $fromDate) {
    date
    userRegistrationStats {
      totalAdultPatients
      totalMinorPatients
      totalPatients
      totalProviders
    }
  }
}
    `;

/**
 * __useGetUserRegistrationStatsQuery__
 *
 * To run a query within a React component, call `useGetUserRegistrationStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRegistrationStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRegistrationStatsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetUserRegistrationStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRegistrationStatsQuery, GetUserRegistrationStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRegistrationStatsQuery, GetUserRegistrationStatsQueryVariables>(GetUserRegistrationStatsDocument, options);
      }
export function useGetUserRegistrationStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRegistrationStatsQuery, GetUserRegistrationStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRegistrationStatsQuery, GetUserRegistrationStatsQueryVariables>(GetUserRegistrationStatsDocument, options);
        }
export type GetUserRegistrationStatsQueryHookResult = ReturnType<typeof useGetUserRegistrationStatsQuery>;
export type GetUserRegistrationStatsLazyQueryHookResult = ReturnType<typeof useGetUserRegistrationStatsLazyQuery>;
export type GetUserRegistrationStatsQueryResult = Apollo.QueryResult<GetUserRegistrationStatsQuery, GetUserRegistrationStatsQueryVariables>;
export const GetPaymentStatsDocument = gql`
    query GetPaymentStats($fromDate: String, $toDate: String) {
  getPaymentStats(toDate: $toDate, fromDate: $fromDate) {
    paymentStats {
      refunds
      paymentForOrders
      paymentForAppointments
      feeReceivedByCodex
    }
    date
  }
}
    `;

/**
 * __useGetPaymentStatsQuery__
 *
 * To run a query within a React component, call `useGetPaymentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStatsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetPaymentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentStatsQuery, GetPaymentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentStatsQuery, GetPaymentStatsQueryVariables>(GetPaymentStatsDocument, options);
      }
export function useGetPaymentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentStatsQuery, GetPaymentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentStatsQuery, GetPaymentStatsQueryVariables>(GetPaymentStatsDocument, options);
        }
export type GetPaymentStatsQueryHookResult = ReturnType<typeof useGetPaymentStatsQuery>;
export type GetPaymentStatsLazyQueryHookResult = ReturnType<typeof useGetPaymentStatsLazyQuery>;
export type GetPaymentStatsQueryResult = Apollo.QueryResult<GetPaymentStatsQuery, GetPaymentStatsQueryVariables>;
export const GetUserActivityLogDocument = gql`
    query GetUserActivityLog($userCodexId: String!, $offset: Int = 0) {
  getUserActivityLog(userCodexId: $userCodexId, limit: 50, offset: $offset) {
    logs {
      createdAt
      eventType
      id
      metadata {
        agreementType
        admin {
          email
          first
          identifiers
          last
          dates
          flags
        }
        appointment_id
        course {
          title
          id
          createdAt
        }
        legalDocument {
          type
          updatedAt
          updatedByFullName
          version
        }
        order_id
        patient {
          id
          SENSITIVE_lastname
          SENSITIVE_email
          SENSITIVE_firstname
        }
        product {
          category
          id
          title
          test_type
        }
        swab_code
        test_type
        provider {
          SENSITIVE_firstname
          SENSITIVE_lastname
          SENSITIVE_email
          id
        }
      }
    }
    total
  }
}
    `;

/**
 * __useGetUserActivityLogQuery__
 *
 * To run a query within a React component, call `useGetUserActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivityLogQuery({
 *   variables: {
 *      userCodexId: // value for 'userCodexId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUserActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivityLogQuery, GetUserActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivityLogQuery, GetUserActivityLogQueryVariables>(GetUserActivityLogDocument, options);
      }
export function useGetUserActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivityLogQuery, GetUserActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivityLogQuery, GetUserActivityLogQueryVariables>(GetUserActivityLogDocument, options);
        }
export type GetUserActivityLogQueryHookResult = ReturnType<typeof useGetUserActivityLogQuery>;
export type GetUserActivityLogLazyQueryHookResult = ReturnType<typeof useGetUserActivityLogLazyQuery>;
export type GetUserActivityLogQueryResult = Apollo.QueryResult<GetUserActivityLogQuery, GetUserActivityLogQueryVariables>;
export const GetSupportChatDetailDocument = gql`
    query GetSupportChatDetail($chatId: String, $pageToken: String = "", $limit: Int = 10) {
  getSupportChatDetail(
    filter: {chatId: $chatId}
    limit: $limit
    pageToken: $pageToken
  ) {
    createdAt
    id
    lastMessageAt
    messages {
      attachments {
        url
        title
        creation
        contentType
        size
      }
      date
      senderCodexId
      text
    }
    nextPageToken
    read
    role
    usage {
      updatedAt
      used
    }
    user {
      codexId
      firstName
      lastName
      profilePictureId
    }
  }
}
    `;

/**
 * __useGetSupportChatDetailQuery__
 *
 * To run a query within a React component, call `useGetSupportChatDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportChatDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportChatDetailQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      pageToken: // value for 'pageToken'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSupportChatDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportChatDetailQuery, GetSupportChatDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportChatDetailQuery, GetSupportChatDetailQueryVariables>(GetSupportChatDetailDocument, options);
      }
export function useGetSupportChatDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportChatDetailQuery, GetSupportChatDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportChatDetailQuery, GetSupportChatDetailQueryVariables>(GetSupportChatDetailDocument, options);
        }
export type GetSupportChatDetailQueryHookResult = ReturnType<typeof useGetSupportChatDetailQuery>;
export type GetSupportChatDetailLazyQueryHookResult = ReturnType<typeof useGetSupportChatDetailLazyQuery>;
export type GetSupportChatDetailQueryResult = Apollo.QueryResult<GetSupportChatDetailQuery, GetSupportChatDetailQueryVariables>;
export const GetSupportChatsDocument = gql`
    query GetSupportChats($filter: GetSupportChatsInput, $limit: Int = 10, $offset: Int = 0) {
  getSupportChats(filter: $filter, limit: $limit, offset: $offset) {
    newTotal
    total
    chats {
      createdAt
      id
      read
      lastMessageAt
      role
      user {
        codexId
        firstName
        lastName
        profilePictureId
      }
    }
  }
}
    `;

/**
 * __useGetSupportChatsQuery__
 *
 * To run a query within a React component, call `useGetSupportChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportChatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSupportChatsQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportChatsQuery, GetSupportChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportChatsQuery, GetSupportChatsQueryVariables>(GetSupportChatsDocument, options);
      }
export function useGetSupportChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportChatsQuery, GetSupportChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportChatsQuery, GetSupportChatsQueryVariables>(GetSupportChatsDocument, options);
        }
export type GetSupportChatsQueryHookResult = ReturnType<typeof useGetSupportChatsQuery>;
export type GetSupportChatsLazyQueryHookResult = ReturnType<typeof useGetSupportChatsLazyQuery>;
export type GetSupportChatsQueryResult = Apollo.QueryResult<GetSupportChatsQuery, GetSupportChatsQueryVariables>;
export const GetVerificationRequestsDocument = gql`
    query GetVerificationRequests($filter: SAVerificationRequestFilter!, $orderBy: SAVerificationRequestOrderBy!, $limit: Int = 40, $offset: Int = 0) {
  getVerificationRequests(
    filter: $filter
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    requests {
      statusHistory {
        status
        datetime
      }
      userCodexId
      updatedAt
      type
      status
      personaInquiryId
      id
      fullName
      createdAt
      email
      childFullName
      childCodexId
    }
    total
  }
}
    `;

/**
 * __useGetVerificationRequestsQuery__
 *
 * To run a query within a React component, call `useGetVerificationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerificationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerificationRequestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVerificationRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetVerificationRequestsQuery, GetVerificationRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerificationRequestsQuery, GetVerificationRequestsQueryVariables>(GetVerificationRequestsDocument, options);
      }
export function useGetVerificationRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerificationRequestsQuery, GetVerificationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerificationRequestsQuery, GetVerificationRequestsQueryVariables>(GetVerificationRequestsDocument, options);
        }
export type GetVerificationRequestsQueryHookResult = ReturnType<typeof useGetVerificationRequestsQuery>;
export type GetVerificationRequestsLazyQueryHookResult = ReturnType<typeof useGetVerificationRequestsLazyQuery>;
export type GetVerificationRequestsQueryResult = Apollo.QueryResult<GetVerificationRequestsQuery, GetVerificationRequestsQueryVariables>;
export const GetSuperAdminsDocument = gql`
    query GetSuperAdmins($offset: Int = 10, $limit: Int = 0, $search: String = "", $orderBy: SuperAdminOrderByInput = {}) {
  getSuperAdmins(
    pagination: {limit: $limit, offset: $offset}
    filters: {search: $search}
    orderBy: $orderBy
  ) {
    superAdmins {
      id
      email
      createdAt
    }
    total
  }
}
    `;

/**
 * __useGetSuperAdminsQuery__
 *
 * To run a query within a React component, call `useGetSuperAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuperAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuperAdminsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSuperAdminsQuery(baseOptions?: Apollo.QueryHookOptions<GetSuperAdminsQuery, GetSuperAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuperAdminsQuery, GetSuperAdminsQueryVariables>(GetSuperAdminsDocument, options);
      }
export function useGetSuperAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuperAdminsQuery, GetSuperAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuperAdminsQuery, GetSuperAdminsQueryVariables>(GetSuperAdminsDocument, options);
        }
export type GetSuperAdminsQueryHookResult = ReturnType<typeof useGetSuperAdminsQuery>;
export type GetSuperAdminsLazyQueryHookResult = ReturnType<typeof useGetSuperAdminsLazyQuery>;
export type GetSuperAdminsQueryResult = Apollo.QueryResult<GetSuperAdminsQuery, GetSuperAdminsQueryVariables>;
export const GetSwabCodeValidBySwabcodeDocument = gql`
    query GetSwabCodeValidBySwabcode($swabcode: String!) {
  GetSwabCodeValidBySwabcode(swabcode: $swabcode) {
    isValid
    id
    lab_name
    status
    swab_code
    swab_usage_type
    test_type
  }
}
    `;

/**
 * __useGetSwabCodeValidBySwabcodeQuery__
 *
 * To run a query within a React component, call `useGetSwabCodeValidBySwabcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwabCodeValidBySwabcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwabCodeValidBySwabcodeQuery({
 *   variables: {
 *      swabcode: // value for 'swabcode'
 *   },
 * });
 */
export function useGetSwabCodeValidBySwabcodeQuery(baseOptions: Apollo.QueryHookOptions<GetSwabCodeValidBySwabcodeQuery, GetSwabCodeValidBySwabcodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwabCodeValidBySwabcodeQuery, GetSwabCodeValidBySwabcodeQueryVariables>(GetSwabCodeValidBySwabcodeDocument, options);
      }
export function useGetSwabCodeValidBySwabcodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwabCodeValidBySwabcodeQuery, GetSwabCodeValidBySwabcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwabCodeValidBySwabcodeQuery, GetSwabCodeValidBySwabcodeQueryVariables>(GetSwabCodeValidBySwabcodeDocument, options);
        }
export type GetSwabCodeValidBySwabcodeQueryHookResult = ReturnType<typeof useGetSwabCodeValidBySwabcodeQuery>;
export type GetSwabCodeValidBySwabcodeLazyQueryHookResult = ReturnType<typeof useGetSwabCodeValidBySwabcodeLazyQuery>;
export type GetSwabCodeValidBySwabcodeQueryResult = Apollo.QueryResult<GetSwabCodeValidBySwabcodeQuery, GetSwabCodeValidBySwabcodeQueryVariables>;
export const FinishTourDocument = gql`
    mutation FinishTour($appTourType: AppTourTypes!) {
  finishAppTour(appTourType: $appTourType) {
    status
  }
}
    `;
export type FinishTourMutationFn = Apollo.MutationFunction<FinishTourMutation, FinishTourMutationVariables>;

/**
 * __useFinishTourMutation__
 *
 * To run a mutation, you first call `useFinishTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishTourMutation, { data, loading, error }] = useFinishTourMutation({
 *   variables: {
 *      appTourType: // value for 'appTourType'
 *   },
 * });
 */
export function useFinishTourMutation(baseOptions?: Apollo.MutationHookOptions<FinishTourMutation, FinishTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishTourMutation, FinishTourMutationVariables>(FinishTourDocument, options);
      }
export type FinishTourMutationHookResult = ReturnType<typeof useFinishTourMutation>;
export type FinishTourMutationResult = Apollo.MutationResult<FinishTourMutation>;
export type FinishTourMutationOptions = Apollo.BaseMutationOptions<FinishTourMutation, FinishTourMutationVariables>;
export const ResetAppTourDocument = gql`
    mutation ResetAppTour($appTourType: AppTourTypes!) {
  resetAppTour(appTourType: $appTourType) {
    status
  }
}
    `;
export type ResetAppTourMutationFn = Apollo.MutationFunction<ResetAppTourMutation, ResetAppTourMutationVariables>;

/**
 * __useResetAppTourMutation__
 *
 * To run a mutation, you first call `useResetAppTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAppTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAppTourMutation, { data, loading, error }] = useResetAppTourMutation({
 *   variables: {
 *      appTourType: // value for 'appTourType'
 *   },
 * });
 */
export function useResetAppTourMutation(baseOptions?: Apollo.MutationHookOptions<ResetAppTourMutation, ResetAppTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAppTourMutation, ResetAppTourMutationVariables>(ResetAppTourDocument, options);
      }
export type ResetAppTourMutationHookResult = ReturnType<typeof useResetAppTourMutation>;
export type ResetAppTourMutationResult = Apollo.MutationResult<ResetAppTourMutation>;
export type ResetAppTourMutationOptions = Apollo.BaseMutationOptions<ResetAppTourMutation, ResetAppTourMutationVariables>;
export const GetAppToursDocument = gql`
    query GetAppTours {
  getAppTours {
    app_tours {
      id
      type
    }
  }
}
    `;

/**
 * __useGetAppToursQuery__
 *
 * To run a query within a React component, call `useGetAppToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppToursQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppToursQuery(baseOptions?: Apollo.QueryHookOptions<GetAppToursQuery, GetAppToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppToursQuery, GetAppToursQueryVariables>(GetAppToursDocument, options);
      }
export function useGetAppToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppToursQuery, GetAppToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppToursQuery, GetAppToursQueryVariables>(GetAppToursDocument, options);
        }
export type GetAppToursQueryHookResult = ReturnType<typeof useGetAppToursQuery>;
export type GetAppToursLazyQueryHookResult = ReturnType<typeof useGetAppToursLazyQuery>;
export type GetAppToursQueryResult = Apollo.QueryResult<GetAppToursQuery, GetAppToursQueryVariables>;
export const GetUnauthenticatedQuestionnaireByIdDocument = gql`
    query GetUnauthenticatedQuestionnaireById($questionnaire_id: Int!) {
  unauthenticated_questionnaires(where: {id: {_eq: $questionnaire_id}}) {
    title
    subtitle
    data
    unauthenticated_questionnaire_questions {
      unauthenticated_questionnaire_questions_unauthenticated_question {
        id
        text
        subtitle
        answers
        ui_control
        dont_know_answer
        double_text_combo_helper_texts
        dropdown_combo_answers
        dropdown_label_1
        dropdown_label_2
        response_property
        has_tooltip
        tooltip_content
        placeholder
      }
    }
  }
}
    `;

/**
 * __useGetUnauthenticatedQuestionnaireByIdQuery__
 *
 * To run a query within a React component, call `useGetUnauthenticatedQuestionnaireByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnauthenticatedQuestionnaireByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnauthenticatedQuestionnaireByIdQuery({
 *   variables: {
 *      questionnaire_id: // value for 'questionnaire_id'
 *   },
 * });
 */
export function useGetUnauthenticatedQuestionnaireByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUnauthenticatedQuestionnaireByIdQuery, GetUnauthenticatedQuestionnaireByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnauthenticatedQuestionnaireByIdQuery, GetUnauthenticatedQuestionnaireByIdQueryVariables>(GetUnauthenticatedQuestionnaireByIdDocument, options);
      }
export function useGetUnauthenticatedQuestionnaireByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnauthenticatedQuestionnaireByIdQuery, GetUnauthenticatedQuestionnaireByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnauthenticatedQuestionnaireByIdQuery, GetUnauthenticatedQuestionnaireByIdQueryVariables>(GetUnauthenticatedQuestionnaireByIdDocument, options);
        }
export type GetUnauthenticatedQuestionnaireByIdQueryHookResult = ReturnType<typeof useGetUnauthenticatedQuestionnaireByIdQuery>;
export type GetUnauthenticatedQuestionnaireByIdLazyQueryHookResult = ReturnType<typeof useGetUnauthenticatedQuestionnaireByIdLazyQuery>;
export type GetUnauthenticatedQuestionnaireByIdQueryResult = Apollo.QueryResult<GetUnauthenticatedQuestionnaireByIdQuery, GetUnauthenticatedQuestionnaireByIdQueryVariables>;
export const GetUnauthenticatedQuestionsByIdsDocument = gql`
    query GetUnauthenticatedQuestionsByIds($ids: [Int!]!) {
  unauthenticated_questions(where: {id: {_in: $ids}}) {
    id
    text
    subtitle
    answers
    placeholder
    ui_control
    response_property
  }
}
    `;

/**
 * __useGetUnauthenticatedQuestionsByIdsQuery__
 *
 * To run a query within a React component, call `useGetUnauthenticatedQuestionsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnauthenticatedQuestionsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnauthenticatedQuestionsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetUnauthenticatedQuestionsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUnauthenticatedQuestionsByIdsQuery, GetUnauthenticatedQuestionsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnauthenticatedQuestionsByIdsQuery, GetUnauthenticatedQuestionsByIdsQueryVariables>(GetUnauthenticatedQuestionsByIdsDocument, options);
      }
export function useGetUnauthenticatedQuestionsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnauthenticatedQuestionsByIdsQuery, GetUnauthenticatedQuestionsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnauthenticatedQuestionsByIdsQuery, GetUnauthenticatedQuestionsByIdsQueryVariables>(GetUnauthenticatedQuestionsByIdsDocument, options);
        }
export type GetUnauthenticatedQuestionsByIdsQueryHookResult = ReturnType<typeof useGetUnauthenticatedQuestionsByIdsQuery>;
export type GetUnauthenticatedQuestionsByIdsLazyQueryHookResult = ReturnType<typeof useGetUnauthenticatedQuestionsByIdsLazyQuery>;
export type GetUnauthenticatedQuestionsByIdsQueryResult = Apollo.QueryResult<GetUnauthenticatedQuestionsByIdsQuery, GetUnauthenticatedQuestionsByIdsQueryVariables>;
export const SaveDnaScannedDataDocument = gql`
    mutation SaveDnaScannedData($testType: String, $swabBarcode: String, $trackingNumber: String, $skipTrackingNumber: Boolean, $token: String) {
  SaveDnaScannedData(
    dnaScannedData: {testType: $testType, swabBarcode: $swabBarcode, trackingNumber: $trackingNumber, skipTrackingNumber: $skipTrackingNumber, token: $token}
  ) {
    message
    status
  }
}
    `;
export type SaveDnaScannedDataMutationFn = Apollo.MutationFunction<SaveDnaScannedDataMutation, SaveDnaScannedDataMutationVariables>;

/**
 * __useSaveDnaScannedDataMutation__
 *
 * To run a mutation, you first call `useSaveDnaScannedDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDnaScannedDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDnaScannedDataMutation, { data, loading, error }] = useSaveDnaScannedDataMutation({
 *   variables: {
 *      testType: // value for 'testType'
 *      swabBarcode: // value for 'swabBarcode'
 *      trackingNumber: // value for 'trackingNumber'
 *      skipTrackingNumber: // value for 'skipTrackingNumber'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSaveDnaScannedDataMutation(baseOptions?: Apollo.MutationHookOptions<SaveDnaScannedDataMutation, SaveDnaScannedDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDnaScannedDataMutation, SaveDnaScannedDataMutationVariables>(SaveDnaScannedDataDocument, options);
      }
export type SaveDnaScannedDataMutationHookResult = ReturnType<typeof useSaveDnaScannedDataMutation>;
export type SaveDnaScannedDataMutationResult = Apollo.MutationResult<SaveDnaScannedDataMutation>;
export type SaveDnaScannedDataMutationOptions = Apollo.BaseMutationOptions<SaveDnaScannedDataMutation, SaveDnaScannedDataMutationVariables>;
export const ClearAllSavedDnaScannedDataForUserIdDocument = gql`
    mutation ClearAllSavedDnaScannedDataForUserId($userId: uuid!) {
  delete_user_scanned_data(where: {user_id: {_eq: $userId}}) {
    affected_rows
  }
}
    `;
export type ClearAllSavedDnaScannedDataForUserIdMutationFn = Apollo.MutationFunction<ClearAllSavedDnaScannedDataForUserIdMutation, ClearAllSavedDnaScannedDataForUserIdMutationVariables>;

/**
 * __useClearAllSavedDnaScannedDataForUserIdMutation__
 *
 * To run a mutation, you first call `useClearAllSavedDnaScannedDataForUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAllSavedDnaScannedDataForUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAllSavedDnaScannedDataForUserIdMutation, { data, loading, error }] = useClearAllSavedDnaScannedDataForUserIdMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useClearAllSavedDnaScannedDataForUserIdMutation(baseOptions?: Apollo.MutationHookOptions<ClearAllSavedDnaScannedDataForUserIdMutation, ClearAllSavedDnaScannedDataForUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAllSavedDnaScannedDataForUserIdMutation, ClearAllSavedDnaScannedDataForUserIdMutationVariables>(ClearAllSavedDnaScannedDataForUserIdDocument, options);
      }
export type ClearAllSavedDnaScannedDataForUserIdMutationHookResult = ReturnType<typeof useClearAllSavedDnaScannedDataForUserIdMutation>;
export type ClearAllSavedDnaScannedDataForUserIdMutationResult = Apollo.MutationResult<ClearAllSavedDnaScannedDataForUserIdMutation>;
export type ClearAllSavedDnaScannedDataForUserIdMutationOptions = Apollo.BaseMutationOptions<ClearAllSavedDnaScannedDataForUserIdMutation, ClearAllSavedDnaScannedDataForUserIdMutationVariables>;
export const GetDnaScannedDataByUserIdDocument = gql`
    subscription GetDnaScannedDataByUserId($user_id: uuid!) {
  user_scanned_data(where: {user_id: {_eq: $user_id}}) {
    test_type
    swab_barcode
    tracking_number
    skip_tracking_number
    scan_completed
    updated_at
  }
}
    `;

/**
 * __useGetDnaScannedDataByUserIdSubscription__
 *
 * To run a query within a React component, call `useGetDnaScannedDataByUserIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDnaScannedDataByUserIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDnaScannedDataByUserIdSubscription({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetDnaScannedDataByUserIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetDnaScannedDataByUserIdSubscription, GetDnaScannedDataByUserIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDnaScannedDataByUserIdSubscription, GetDnaScannedDataByUserIdSubscriptionVariables>(GetDnaScannedDataByUserIdDocument, options);
      }
export type GetDnaScannedDataByUserIdSubscriptionHookResult = ReturnType<typeof useGetDnaScannedDataByUserIdSubscription>;
export type GetDnaScannedDataByUserIdSubscriptionResult = Apollo.SubscriptionResult<GetDnaScannedDataByUserIdSubscription>;
export const SignupUserDocument = gql`
    mutation SignupUser($dob: String, $email: String!, $password: String, $firebaseToken: String, $firstname: String, $gender: String, $lastname: String, $phone: String, $country: String) {
  SignupUser(
    userData: {dob: $dob, email: $email, password: $password, firebaseToken: $firebaseToken, firstname: $firstname, gender: $gender, lastname: $lastname, phone: $phone, country: $country}
  ) {
    message
    status
  }
}
    `;
export type SignupUserMutationFn = Apollo.MutationFunction<SignupUserMutation, SignupUserMutationVariables>;

/**
 * __useSignupUserMutation__
 *
 * To run a mutation, you first call `useSignupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupUserMutation, { data, loading, error }] = useSignupUserMutation({
 *   variables: {
 *      dob: // value for 'dob'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firebaseToken: // value for 'firebaseToken'
 *      firstname: // value for 'firstname'
 *      gender: // value for 'gender'
 *      lastname: // value for 'lastname'
 *      phone: // value for 'phone'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSignupUserMutation(baseOptions?: Apollo.MutationHookOptions<SignupUserMutation, SignupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupUserMutation, SignupUserMutationVariables>(SignupUserDocument, options);
      }
export type SignupUserMutationHookResult = ReturnType<typeof useSignupUserMutation>;
export type SignupUserMutationResult = Apollo.MutationResult<SignupUserMutation>;
export type SignupUserMutationOptions = Apollo.BaseMutationOptions<SignupUserMutation, SignupUserMutationVariables>;
export const GenerateCustomTokenDocument = gql`
    mutation GenerateCustomToken {
  GenerateCustomToken {
    token
    message
    status
  }
}
    `;
export type GenerateCustomTokenMutationFn = Apollo.MutationFunction<GenerateCustomTokenMutation, GenerateCustomTokenMutationVariables>;

/**
 * __useGenerateCustomTokenMutation__
 *
 * To run a mutation, you first call `useGenerateCustomTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCustomTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCustomTokenMutation, { data, loading, error }] = useGenerateCustomTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateCustomTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCustomTokenMutation, GenerateCustomTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCustomTokenMutation, GenerateCustomTokenMutationVariables>(GenerateCustomTokenDocument, options);
      }
export type GenerateCustomTokenMutationHookResult = ReturnType<typeof useGenerateCustomTokenMutation>;
export type GenerateCustomTokenMutationResult = Apollo.MutationResult<GenerateCustomTokenMutation>;
export type GenerateCustomTokenMutationOptions = Apollo.BaseMutationOptions<GenerateCustomTokenMutation, GenerateCustomTokenMutationVariables>;
export const ValidateCustomTokenDocument = gql`
    mutation ValidateCustomToken($token: String!) {
  ValidateCustomToken(token: {token: $token}) {
    message
    status
  }
}
    `;
export type ValidateCustomTokenMutationFn = Apollo.MutationFunction<ValidateCustomTokenMutation, ValidateCustomTokenMutationVariables>;

/**
 * __useValidateCustomTokenMutation__
 *
 * To run a mutation, you first call `useValidateCustomTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCustomTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCustomTokenMutation, { data, loading, error }] = useValidateCustomTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateCustomTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateCustomTokenMutation, ValidateCustomTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateCustomTokenMutation, ValidateCustomTokenMutationVariables>(ValidateCustomTokenDocument, options);
      }
export type ValidateCustomTokenMutationHookResult = ReturnType<typeof useValidateCustomTokenMutation>;
export type ValidateCustomTokenMutationResult = Apollo.MutationResult<ValidateCustomTokenMutation>;
export type ValidateCustomTokenMutationOptions = Apollo.BaseMutationOptions<ValidateCustomTokenMutation, ValidateCustomTokenMutationVariables>;
export const AccountDeletionDocument = gql`
    mutation AccountDeletion($token: String!, $userId: String!) {
  AccountDeletion(account: {token: $token, userId: $userId}) {
    status
    message
  }
}
    `;
export type AccountDeletionMutationFn = Apollo.MutationFunction<AccountDeletionMutation, AccountDeletionMutationVariables>;

/**
 * __useAccountDeletionMutation__
 *
 * To run a mutation, you first call `useAccountDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountDeletionMutation, { data, loading, error }] = useAccountDeletionMutation({
 *   variables: {
 *      token: // value for 'token'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountDeletionMutation(baseOptions?: Apollo.MutationHookOptions<AccountDeletionMutation, AccountDeletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountDeletionMutation, AccountDeletionMutationVariables>(AccountDeletionDocument, options);
      }
export type AccountDeletionMutationHookResult = ReturnType<typeof useAccountDeletionMutation>;
export type AccountDeletionMutationResult = Apollo.MutationResult<AccountDeletionMutation>;
export type AccountDeletionMutationOptions = Apollo.BaseMutationOptions<AccountDeletionMutation, AccountDeletionMutationVariables>;
export const UpdatePersonalInfoDocument = gql`
    mutation UpdatePersonalInfo($id: uuid!, $SENSITIVE_dob: date, $SENSITIVE_etnicity: jsonb, $SENSITIVE_firstname: String, $SENSITIVE_gender: String, $SENSITIVE_lastname: String, $SENSITIVE_self_identity_gender: String, $SENSITIVE_user_measurements: jsonb) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {SENSITIVE_dob: $SENSITIVE_dob, SENSITIVE_etnicity: $SENSITIVE_etnicity, SENSITIVE_firstname: $SENSITIVE_firstname, SENSITIVE_gender: $SENSITIVE_gender, SENSITIVE_lastname: $SENSITIVE_lastname, SENSITIVE_self_identity_gender: $SENSITIVE_self_identity_gender, SENSITIVE_user_measurements: $SENSITIVE_user_measurements}
  ) {
    SENSITIVE_address_information
    SENSITIVE_country
    SENSITIVE_dob
    SENSITIVE_email
    SENSITIVE_etnicity
    SENSITIVE_firstname
    SENSITIVE_gender
    SENSITIVE_lastname
    SENSITIVE_phone
    SENSITIVE_self_identity_gender
    SENSITIVE_user_measurements
    id
  }
}
    `;
export type UpdatePersonalInfoMutationFn = Apollo.MutationFunction<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;

/**
 * __useUpdatePersonalInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoMutation, { data, loading, error }] = useUpdatePersonalInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      SENSITIVE_dob: // value for 'SENSITIVE_dob'
 *      SENSITIVE_etnicity: // value for 'SENSITIVE_etnicity'
 *      SENSITIVE_firstname: // value for 'SENSITIVE_firstname'
 *      SENSITIVE_gender: // value for 'SENSITIVE_gender'
 *      SENSITIVE_lastname: // value for 'SENSITIVE_lastname'
 *      SENSITIVE_self_identity_gender: // value for 'SENSITIVE_self_identity_gender'
 *      SENSITIVE_user_measurements: // value for 'SENSITIVE_user_measurements'
 *   },
 * });
 */
export function useUpdatePersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>(UpdatePersonalInfoDocument, options);
      }
export type UpdatePersonalInfoMutationHookResult = ReturnType<typeof useUpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationResult = Apollo.MutationResult<UpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;
export const UpdateContactInfoDocument = gql`
    mutation UpdateContactInfo($id: uuid!, $SENSITIVE_address_information: jsonb, $SENSITIVE_phone: String, $SENSITIVE_country: String) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {SENSITIVE_address_information: $SENSITIVE_address_information, SENSITIVE_phone: $SENSITIVE_phone, SENSITIVE_country: $SENSITIVE_country}
  ) {
    SENSITIVE_address_information
    SENSITIVE_country
    SENSITIVE_dob
    SENSITIVE_email
    SENSITIVE_etnicity
    SENSITIVE_firstname
    SENSITIVE_gender
    SENSITIVE_lastname
    SENSITIVE_phone
    SENSITIVE_self_identity_gender
    SENSITIVE_user_measurements
    id
  }
}
    `;
export type UpdateContactInfoMutationFn = Apollo.MutationFunction<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>;

/**
 * __useUpdateContactInfoMutation__
 *
 * To run a mutation, you first call `useUpdateContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactInfoMutation, { data, loading, error }] = useUpdateContactInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      SENSITIVE_address_information: // value for 'SENSITIVE_address_information'
 *      SENSITIVE_phone: // value for 'SENSITIVE_phone'
 *      SENSITIVE_country: // value for 'SENSITIVE_country'
 *   },
 * });
 */
export function useUpdateContactInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>(UpdateContactInfoDocument, options);
      }
export type UpdateContactInfoMutationHookResult = ReturnType<typeof useUpdateContactInfoMutation>;
export type UpdateContactInfoMutationResult = Apollo.MutationResult<UpdateContactInfoMutation>;
export type UpdateContactInfoMutationOptions = Apollo.BaseMutationOptions<UpdateContactInfoMutation, UpdateContactInfoMutationVariables>;
export const UpdateProfileInfoDocument = gql`
    mutation UpdateProfileInfo($id: uuid!, $SENSITIVE_dob: date, $SENSITIVE_etnicity: jsonb, $SENSITIVE_firstname: String, $SENSITIVE_gender: String, $SENSITIVE_lastname: String, $SENSITIVE_self_identity_gender: String, $SENSITIVE_user_measurements: jsonb, $SENSITIVE_address_information: jsonb, $SENSITIVE_phone: String, $SENSITIVE_country: String) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {SENSITIVE_dob: $SENSITIVE_dob, SENSITIVE_etnicity: $SENSITIVE_etnicity, SENSITIVE_firstname: $SENSITIVE_firstname, SENSITIVE_gender: $SENSITIVE_gender, SENSITIVE_lastname: $SENSITIVE_lastname, SENSITIVE_self_identity_gender: $SENSITIVE_self_identity_gender, SENSITIVE_user_measurements: $SENSITIVE_user_measurements, SENSITIVE_address_information: $SENSITIVE_address_information, SENSITIVE_phone: $SENSITIVE_phone, SENSITIVE_country: $SENSITIVE_country}
  ) {
    SENSITIVE_address_information
    SENSITIVE_country
    SENSITIVE_dob
    SENSITIVE_email
    SENSITIVE_etnicity
    SENSITIVE_firstname
    SENSITIVE_gender
    SENSITIVE_lastname
    SENSITIVE_phone
    SENSITIVE_self_identity_gender
    SENSITIVE_user_measurements
    id
  }
}
    `;
export type UpdateProfileInfoMutationFn = Apollo.MutationFunction<UpdateProfileInfoMutation, UpdateProfileInfoMutationVariables>;

/**
 * __useUpdateProfileInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProfileInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileInfoMutation, { data, loading, error }] = useUpdateProfileInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      SENSITIVE_dob: // value for 'SENSITIVE_dob'
 *      SENSITIVE_etnicity: // value for 'SENSITIVE_etnicity'
 *      SENSITIVE_firstname: // value for 'SENSITIVE_firstname'
 *      SENSITIVE_gender: // value for 'SENSITIVE_gender'
 *      SENSITIVE_lastname: // value for 'SENSITIVE_lastname'
 *      SENSITIVE_self_identity_gender: // value for 'SENSITIVE_self_identity_gender'
 *      SENSITIVE_user_measurements: // value for 'SENSITIVE_user_measurements'
 *      SENSITIVE_address_information: // value for 'SENSITIVE_address_information'
 *      SENSITIVE_phone: // value for 'SENSITIVE_phone'
 *      SENSITIVE_country: // value for 'SENSITIVE_country'
 *   },
 * });
 */
export function useUpdateProfileInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileInfoMutation, UpdateProfileInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileInfoMutation, UpdateProfileInfoMutationVariables>(UpdateProfileInfoDocument, options);
      }
export type UpdateProfileInfoMutationHookResult = ReturnType<typeof useUpdateProfileInfoMutation>;
export type UpdateProfileInfoMutationResult = Apollo.MutationResult<UpdateProfileInfoMutation>;
export type UpdateProfileInfoMutationOptions = Apollo.BaseMutationOptions<UpdateProfileInfoMutation, UpdateProfileInfoMutationVariables>;
export const UpdatePhoneAndCountryByUserIdDocument = gql`
    mutation UpdatePhoneAndCountryByUserID($id: uuid!, $SENSITIVE_phone: String!, $SENSITIVE_country: String!) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {SENSITIVE_phone: $SENSITIVE_phone, SENSITIVE_country: $SENSITIVE_country}
  ) {
    id
    SENSITIVE_country
    SENSITIVE_phone
    updated_at
  }
}
    `;
export type UpdatePhoneAndCountryByUserIdMutationFn = Apollo.MutationFunction<UpdatePhoneAndCountryByUserIdMutation, UpdatePhoneAndCountryByUserIdMutationVariables>;

/**
 * __useUpdatePhoneAndCountryByUserIdMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneAndCountryByUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneAndCountryByUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneAndCountryByUserIdMutation, { data, loading, error }] = useUpdatePhoneAndCountryByUserIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      SENSITIVE_phone: // value for 'SENSITIVE_phone'
 *      SENSITIVE_country: // value for 'SENSITIVE_country'
 *   },
 * });
 */
export function useUpdatePhoneAndCountryByUserIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneAndCountryByUserIdMutation, UpdatePhoneAndCountryByUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneAndCountryByUserIdMutation, UpdatePhoneAndCountryByUserIdMutationVariables>(UpdatePhoneAndCountryByUserIdDocument, options);
      }
export type UpdatePhoneAndCountryByUserIdMutationHookResult = ReturnType<typeof useUpdatePhoneAndCountryByUserIdMutation>;
export type UpdatePhoneAndCountryByUserIdMutationResult = Apollo.MutationResult<UpdatePhoneAndCountryByUserIdMutation>;
export type UpdatePhoneAndCountryByUserIdMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneAndCountryByUserIdMutation, UpdatePhoneAndCountryByUserIdMutationVariables>;
export const UpdateProfilePictureDocument = gql`
    mutation UpdateProfilePicture($image: String!, $filename: String) {
  UpdateProfilePicture(image: {image: $image, filename: $filename}) {
    message
    status
    fileId
    contentType
  }
}
    `;
export type UpdateProfilePictureMutationFn = Apollo.MutationFunction<UpdateProfilePictureMutation, UpdateProfilePictureMutationVariables>;

/**
 * __useUpdateProfilePictureMutation__
 *
 * To run a mutation, you first call `useUpdateProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfilePictureMutation, { data, loading, error }] = useUpdateProfilePictureMutation({
 *   variables: {
 *      image: // value for 'image'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useUpdateProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfilePictureMutation, UpdateProfilePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfilePictureMutation, UpdateProfilePictureMutationVariables>(UpdateProfilePictureDocument, options);
      }
export type UpdateProfilePictureMutationHookResult = ReturnType<typeof useUpdateProfilePictureMutation>;
export type UpdateProfilePictureMutationResult = Apollo.MutationResult<UpdateProfilePictureMutation>;
export type UpdateProfilePictureMutationOptions = Apollo.BaseMutationOptions<UpdateProfilePictureMutation, UpdateProfilePictureMutationVariables>;
export const UpdateProviderProfilePictureDocument = gql`
    mutation UpdateProviderProfilePicture($image: String!, $filename: String) {
  UpdateProviderProfilePicture(image: {image: $image, filename: $filename}) {
    message
    status
    fileId
    contentType
  }
}
    `;
export type UpdateProviderProfilePictureMutationFn = Apollo.MutationFunction<UpdateProviderProfilePictureMutation, UpdateProviderProfilePictureMutationVariables>;

/**
 * __useUpdateProviderProfilePictureMutation__
 *
 * To run a mutation, you first call `useUpdateProviderProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderProfilePictureMutation, { data, loading, error }] = useUpdateProviderProfilePictureMutation({
 *   variables: {
 *      image: // value for 'image'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useUpdateProviderProfilePictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderProfilePictureMutation, UpdateProviderProfilePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderProfilePictureMutation, UpdateProviderProfilePictureMutationVariables>(UpdateProviderProfilePictureDocument, options);
      }
export type UpdateProviderProfilePictureMutationHookResult = ReturnType<typeof useUpdateProviderProfilePictureMutation>;
export type UpdateProviderProfilePictureMutationResult = Apollo.MutationResult<UpdateProviderProfilePictureMutation>;
export type UpdateProviderProfilePictureMutationOptions = Apollo.BaseMutationOptions<UpdateProviderProfilePictureMutation, UpdateProviderProfilePictureMutationVariables>;
export const GenerateSessionTokenForPersonaDocument = gql`
    mutation GenerateSessionTokenForPersona($inquiryId: String) {
  GetPersonaSessionToken(inquiryId: $inquiryId) {
    sessionToken
  }
}
    `;
export type GenerateSessionTokenForPersonaMutationFn = Apollo.MutationFunction<GenerateSessionTokenForPersonaMutation, GenerateSessionTokenForPersonaMutationVariables>;

/**
 * __useGenerateSessionTokenForPersonaMutation__
 *
 * To run a mutation, you first call `useGenerateSessionTokenForPersonaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSessionTokenForPersonaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSessionTokenForPersonaMutation, { data, loading, error }] = useGenerateSessionTokenForPersonaMutation({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *   },
 * });
 */
export function useGenerateSessionTokenForPersonaMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSessionTokenForPersonaMutation, GenerateSessionTokenForPersonaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSessionTokenForPersonaMutation, GenerateSessionTokenForPersonaMutationVariables>(GenerateSessionTokenForPersonaDocument, options);
      }
export type GenerateSessionTokenForPersonaMutationHookResult = ReturnType<typeof useGenerateSessionTokenForPersonaMutation>;
export type GenerateSessionTokenForPersonaMutationResult = Apollo.MutationResult<GenerateSessionTokenForPersonaMutation>;
export type GenerateSessionTokenForPersonaMutationOptions = Apollo.BaseMutationOptions<GenerateSessionTokenForPersonaMutation, GenerateSessionTokenForPersonaMutationVariables>;
export const UpdateCustomAuthCodeAsUsedDocument = gql`
    mutation UpdateCustomAuthCodeAsUsed($email: String!, $code: String!) {
  update_custom_auth_code(
    where: {SENSITIVE_email: {_eq: $email}, _and: {code: {_eq: $code}}}
    _set: {used: true}
  ) {
    affected_rows
  }
}
    `;
export type UpdateCustomAuthCodeAsUsedMutationFn = Apollo.MutationFunction<UpdateCustomAuthCodeAsUsedMutation, UpdateCustomAuthCodeAsUsedMutationVariables>;

/**
 * __useUpdateCustomAuthCodeAsUsedMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAuthCodeAsUsedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAuthCodeAsUsedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAuthCodeAsUsedMutation, { data, loading, error }] = useUpdateCustomAuthCodeAsUsedMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUpdateCustomAuthCodeAsUsedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAuthCodeAsUsedMutation, UpdateCustomAuthCodeAsUsedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAuthCodeAsUsedMutation, UpdateCustomAuthCodeAsUsedMutationVariables>(UpdateCustomAuthCodeAsUsedDocument, options);
      }
export type UpdateCustomAuthCodeAsUsedMutationHookResult = ReturnType<typeof useUpdateCustomAuthCodeAsUsedMutation>;
export type UpdateCustomAuthCodeAsUsedMutationResult = Apollo.MutationResult<UpdateCustomAuthCodeAsUsedMutation>;
export type UpdateCustomAuthCodeAsUsedMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAuthCodeAsUsedMutation, UpdateCustomAuthCodeAsUsedMutationVariables>;
export const DeleteUserSessionDocument = gql`
    mutation DeleteUserSession {
  deleteUserSession {
    message
    status
  }
}
    `;
export type DeleteUserSessionMutationFn = Apollo.MutationFunction<DeleteUserSessionMutation, DeleteUserSessionMutationVariables>;

/**
 * __useDeleteUserSessionMutation__
 *
 * To run a mutation, you first call `useDeleteUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserSessionMutation, { data, loading, error }] = useDeleteUserSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserSessionMutation, DeleteUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserSessionMutation, DeleteUserSessionMutationVariables>(DeleteUserSessionDocument, options);
      }
export type DeleteUserSessionMutationHookResult = ReturnType<typeof useDeleteUserSessionMutation>;
export type DeleteUserSessionMutationResult = Apollo.MutationResult<DeleteUserSessionMutation>;
export type DeleteUserSessionMutationOptions = Apollo.BaseMutationOptions<DeleteUserSessionMutation, DeleteUserSessionMutationVariables>;
export const AcceptUserAgreementDocument = gql`
    mutation AcceptUserAgreement($agreementType: UserAgreementTypes!, $acceptorRole: UserAgreementAcceptorRole, $autonomyDeterminationStatus: AutonomyDeterminationStatus, $expiration: UserAgreementExpirationType, $minorAutonomyEvidence: [MinorAutonomyEvidenceTypes!]) {
  acceptUserAgreement(
    input: {agreementType: $agreementType, acceptorRole: $acceptorRole, expiration: $expiration, autonomyDeterminationStatus: $autonomyDeterminationStatus, minorAutonomyEvidence: $minorAutonomyEvidence}
  ) {
    status
  }
}
    `;
export type AcceptUserAgreementMutationFn = Apollo.MutationFunction<AcceptUserAgreementMutation, AcceptUserAgreementMutationVariables>;

/**
 * __useAcceptUserAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptUserAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserAgreementMutation, { data, loading, error }] = useAcceptUserAgreementMutation({
 *   variables: {
 *      agreementType: // value for 'agreementType'
 *      acceptorRole: // value for 'acceptorRole'
 *      autonomyDeterminationStatus: // value for 'autonomyDeterminationStatus'
 *      expiration: // value for 'expiration'
 *      minorAutonomyEvidence: // value for 'minorAutonomyEvidence'
 *   },
 * });
 */
export function useAcceptUserAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptUserAgreementMutation, AcceptUserAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptUserAgreementMutation, AcceptUserAgreementMutationVariables>(AcceptUserAgreementDocument, options);
      }
export type AcceptUserAgreementMutationHookResult = ReturnType<typeof useAcceptUserAgreementMutation>;
export type AcceptUserAgreementMutationResult = Apollo.MutationResult<AcceptUserAgreementMutation>;
export type AcceptUserAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptUserAgreementMutation, AcceptUserAgreementMutationVariables>;
export const UpdateCartProductsProviderDocument = gql`
    mutation UpdateCartProductsProvider($cartProductIds: [Int!]!, $providerCodexId: String!) {
  updateCartProductsProvider(
    input: {cartProductIds: $cartProductIds, providerCodexId: $providerCodexId}
  ) {
    message
    status
  }
}
    `;
export type UpdateCartProductsProviderMutationFn = Apollo.MutationFunction<UpdateCartProductsProviderMutation, UpdateCartProductsProviderMutationVariables>;

/**
 * __useUpdateCartProductsProviderMutation__
 *
 * To run a mutation, you first call `useUpdateCartProductsProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartProductsProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartProductsProviderMutation, { data, loading, error }] = useUpdateCartProductsProviderMutation({
 *   variables: {
 *      cartProductIds: // value for 'cartProductIds'
 *      providerCodexId: // value for 'providerCodexId'
 *   },
 * });
 */
export function useUpdateCartProductsProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartProductsProviderMutation, UpdateCartProductsProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartProductsProviderMutation, UpdateCartProductsProviderMutationVariables>(UpdateCartProductsProviderDocument, options);
      }
export type UpdateCartProductsProviderMutationHookResult = ReturnType<typeof useUpdateCartProductsProviderMutation>;
export type UpdateCartProductsProviderMutationResult = Apollo.MutationResult<UpdateCartProductsProviderMutation>;
export type UpdateCartProductsProviderMutationOptions = Apollo.BaseMutationOptions<UpdateCartProductsProviderMutation, UpdateCartProductsProviderMutationVariables>;
export const AcceptProviderAgreementDocument = gql`
    mutation AcceptProviderAgreement($agreementType: UserAgreementTypes!) {
  acceptUserAgreement(input: {agreementType: $agreementType}) {
    status
  }
}
    `;
export type AcceptProviderAgreementMutationFn = Apollo.MutationFunction<AcceptProviderAgreementMutation, AcceptProviderAgreementMutationVariables>;

/**
 * __useAcceptProviderAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptProviderAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptProviderAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptProviderAgreementMutation, { data, loading, error }] = useAcceptProviderAgreementMutation({
 *   variables: {
 *      agreementType: // value for 'agreementType'
 *   },
 * });
 */
export function useAcceptProviderAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptProviderAgreementMutation, AcceptProviderAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptProviderAgreementMutation, AcceptProviderAgreementMutationVariables>(AcceptProviderAgreementDocument, options);
      }
export type AcceptProviderAgreementMutationHookResult = ReturnType<typeof useAcceptProviderAgreementMutation>;
export type AcceptProviderAgreementMutationResult = Apollo.MutationResult<AcceptProviderAgreementMutation>;
export type AcceptProviderAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptProviderAgreementMutation, AcceptProviderAgreementMutationVariables>;
export const CreateSubPatientDocument = gql`
    mutation CreateSubPatient($firstName: String = "", $lastName: String = "", $dob: String!, $relationship: SubPatientRelationship, $gender: String!) {
  createSubPatient(
    input: {firstName: $firstName, lastName: $lastName, relationship: $relationship, SENSITIVE_dob: $dob, gender: $gender}
  ) {
    id
  }
}
    `;
export type CreateSubPatientMutationFn = Apollo.MutationFunction<CreateSubPatientMutation, CreateSubPatientMutationVariables>;

/**
 * __useCreateSubPatientMutation__
 *
 * To run a mutation, you first call `useCreateSubPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubPatientMutation, { data, loading, error }] = useCreateSubPatientMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dob: // value for 'dob'
 *      relationship: // value for 'relationship'
 *      gender: // value for 'gender'
 *   },
 * });
 */
export function useCreateSubPatientMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubPatientMutation, CreateSubPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubPatientMutation, CreateSubPatientMutationVariables>(CreateSubPatientDocument, options);
      }
export type CreateSubPatientMutationHookResult = ReturnType<typeof useCreateSubPatientMutation>;
export type CreateSubPatientMutationResult = Apollo.MutationResult<CreateSubPatientMutation>;
export type CreateSubPatientMutationOptions = Apollo.BaseMutationOptions<CreateSubPatientMutation, CreateSubPatientMutationVariables>;
export const ExportUserDataDocument = gql`
    mutation ExportUserData {
  ExportUserData {
    downloadUrl
  }
}
    `;
export type ExportUserDataMutationFn = Apollo.MutationFunction<ExportUserDataMutation, ExportUserDataMutationVariables>;

/**
 * __useExportUserDataMutation__
 *
 * To run a mutation, you first call `useExportUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUserDataMutation, { data, loading, error }] = useExportUserDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportUserDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportUserDataMutation, ExportUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUserDataMutation, ExportUserDataMutationVariables>(ExportUserDataDocument, options);
      }
export type ExportUserDataMutationHookResult = ReturnType<typeof useExportUserDataMutation>;
export type ExportUserDataMutationResult = Apollo.MutationResult<ExportUserDataMutation>;
export type ExportUserDataMutationOptions = Apollo.BaseMutationOptions<ExportUserDataMutation, ExportUserDataMutationVariables>;
export const CloseAccountDocument = gql`
    mutation CloseAccount {
  closeAccount {
    message
    status
  }
}
    `;
export type CloseAccountMutationFn = Apollo.MutationFunction<CloseAccountMutation, CloseAccountMutationVariables>;

/**
 * __useCloseAccountMutation__
 *
 * To run a mutation, you first call `useCloseAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeAccountMutation, { data, loading, error }] = useCloseAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useCloseAccountMutation(baseOptions?: Apollo.MutationHookOptions<CloseAccountMutation, CloseAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseAccountMutation, CloseAccountMutationVariables>(CloseAccountDocument, options);
      }
export type CloseAccountMutationHookResult = ReturnType<typeof useCloseAccountMutation>;
export type CloseAccountMutationResult = Apollo.MutationResult<CloseAccountMutation>;
export type CloseAccountMutationOptions = Apollo.BaseMutationOptions<CloseAccountMutation, CloseAccountMutationVariables>;
export const BlockUserDocument = gql`
    mutation BlockUser($userCodexId: String!, $blocked: Boolean!) {
  blockUser(userCodexId: $userCodexId, blocked: $blocked) {
    message
    status
  }
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      userCodexId: // value for 'userCodexId'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const CreateBecomePatientRequestDocument = gql`
    mutation CreateBecomePatientRequest($providerCodexId: String!) {
  createBecomePatientRequest(providerCodexId: $providerCodexId) {
    requestStatus
  }
}
    `;
export type CreateBecomePatientRequestMutationFn = Apollo.MutationFunction<CreateBecomePatientRequestMutation, CreateBecomePatientRequestMutationVariables>;

/**
 * __useCreateBecomePatientRequestMutation__
 *
 * To run a mutation, you first call `useCreateBecomePatientRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBecomePatientRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBecomePatientRequestMutation, { data, loading, error }] = useCreateBecomePatientRequestMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *   },
 * });
 */
export function useCreateBecomePatientRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateBecomePatientRequestMutation, CreateBecomePatientRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBecomePatientRequestMutation, CreateBecomePatientRequestMutationVariables>(CreateBecomePatientRequestDocument, options);
      }
export type CreateBecomePatientRequestMutationHookResult = ReturnType<typeof useCreateBecomePatientRequestMutation>;
export type CreateBecomePatientRequestMutationResult = Apollo.MutationResult<CreateBecomePatientRequestMutation>;
export type CreateBecomePatientRequestMutationOptions = Apollo.BaseMutationOptions<CreateBecomePatientRequestMutation, CreateBecomePatientRequestMutationVariables>;
export const ConfirmProviderPatientAgreementDocument = gql`
    mutation ConfirmProviderPatientAgreement($providerCodexId: String!) {
  confirmProviderPatientAgreement(providerCodexId: $providerCodexId) {
    requestStatus
  }
}
    `;
export type ConfirmProviderPatientAgreementMutationFn = Apollo.MutationFunction<ConfirmProviderPatientAgreementMutation, ConfirmProviderPatientAgreementMutationVariables>;

/**
 * __useConfirmProviderPatientAgreementMutation__
 *
 * To run a mutation, you first call `useConfirmProviderPatientAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmProviderPatientAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmProviderPatientAgreementMutation, { data, loading, error }] = useConfirmProviderPatientAgreementMutation({
 *   variables: {
 *      providerCodexId: // value for 'providerCodexId'
 *   },
 * });
 */
export function useConfirmProviderPatientAgreementMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmProviderPatientAgreementMutation, ConfirmProviderPatientAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmProviderPatientAgreementMutation, ConfirmProviderPatientAgreementMutationVariables>(ConfirmProviderPatientAgreementDocument, options);
      }
export type ConfirmProviderPatientAgreementMutationHookResult = ReturnType<typeof useConfirmProviderPatientAgreementMutation>;
export type ConfirmProviderPatientAgreementMutationResult = Apollo.MutationResult<ConfirmProviderPatientAgreementMutation>;
export type ConfirmProviderPatientAgreementMutationOptions = Apollo.BaseMutationOptions<ConfirmProviderPatientAgreementMutation, ConfirmProviderPatientAgreementMutationVariables>;
export const GetUsersByIdDocument = gql`
    query GetUsersById($id: uuid!) {
  users(where: {id: {_eq: $id}, is_active: {_eq: true}}) {
    id
    SENSITIVE_phone
    SENSITIVE_lastname
    SENSITIVE_gender
    SENSITIVE_firstname
    SENSITIVE_email
    SENSITIVE_dob
    SENSITIVE_country
    SENSITIVE_self_identity_gender
    SENSITIVE_user_measurements
    SENSITIVE_etnicity
    SENSITIVE_address_information
    SENSITIVE_profile_picture_id
  }
}
    `;

/**
 * __useGetUsersByIdQuery__
 *
 * To run a query within a React component, call `useGetUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUsersByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByIdQuery, GetUsersByIdQueryVariables>(GetUsersByIdDocument, options);
      }
export function useGetUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByIdQuery, GetUsersByIdQueryVariables>(GetUsersByIdDocument, options);
        }
export type GetUsersByIdQueryHookResult = ReturnType<typeof useGetUsersByIdQuery>;
export type GetUsersByIdLazyQueryHookResult = ReturnType<typeof useGetUsersByIdLazyQuery>;
export type GetUsersByIdQueryResult = Apollo.QueryResult<GetUsersByIdQuery, GetUsersByIdQueryVariables>;
export const GetUsersByEmailDocument = gql`
    query GetUsersByEmail($email: String!) {
  users(where: {SENSITIVE_email: {_eq: $email}}) {
    id
    SENSITIVE_dob
    SENSITIVE_email
    SENSITIVE_firstname
    SENSITIVE_gender
    SENSITIVE_phone
    SENSITIVE_country
    SENSITIVE_lastname
    SENSITIVE_self_identity_gender
    SENSITIVE_user_measurements
    SENSITIVE_etnicity
    SENSITIVE_address_information
    SENSITIVE_profile_picture_id
    account_closed_at
    account_closure_reason
    blocked_at
  }
}
    `;

/**
 * __useGetUsersByEmailQuery__
 *
 * To run a query within a React component, call `useGetUsersByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUsersByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByEmailQuery, GetUsersByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByEmailQuery, GetUsersByEmailQueryVariables>(GetUsersByEmailDocument, options);
      }
export function useGetUsersByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByEmailQuery, GetUsersByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByEmailQuery, GetUsersByEmailQueryVariables>(GetUsersByEmailDocument, options);
        }
export type GetUsersByEmailQueryHookResult = ReturnType<typeof useGetUsersByEmailQuery>;
export type GetUsersByEmailLazyQueryHookResult = ReturnType<typeof useGetUsersByEmailLazyQuery>;
export type GetUsersByEmailQueryResult = Apollo.QueryResult<GetUsersByEmailQuery, GetUsersByEmailQueryVariables>;
export const GetChildVerificationStatusDocument = gql`
    query GetChildVerificationStatus($id: uuid!) {
  users(where: {id: {_eq: $id}, is_active: {_eq: true}}) {
    kyc_child_status
    SENSITIVE_dob
  }
}
    `;

/**
 * __useGetChildVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetChildVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildVerificationStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChildVerificationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetChildVerificationStatusQuery, GetChildVerificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildVerificationStatusQuery, GetChildVerificationStatusQueryVariables>(GetChildVerificationStatusDocument, options);
      }
export function useGetChildVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildVerificationStatusQuery, GetChildVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildVerificationStatusQuery, GetChildVerificationStatusQueryVariables>(GetChildVerificationStatusDocument, options);
        }
export type GetChildVerificationStatusQueryHookResult = ReturnType<typeof useGetChildVerificationStatusQuery>;
export type GetChildVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetChildVerificationStatusLazyQuery>;
export type GetChildVerificationStatusQueryResult = Apollo.QueryResult<GetChildVerificationStatusQuery, GetChildVerificationStatusQueryVariables>;
export const GetPersonaVerificationStatusByEmailDocument = gql`
    query GetPersonaVerificationStatusByEmail($email: String!) {
  users(where: {SENSITIVE_email: {_eq: $email}, is_active: {_eq: true}}) {
    kyc_current_status
    kyc_update_date
  }
}
    `;

/**
 * __useGetPersonaVerificationStatusByEmailQuery__
 *
 * To run a query within a React component, call `useGetPersonaVerificationStatusByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonaVerificationStatusByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonaVerificationStatusByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetPersonaVerificationStatusByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetPersonaVerificationStatusByEmailQuery, GetPersonaVerificationStatusByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonaVerificationStatusByEmailQuery, GetPersonaVerificationStatusByEmailQueryVariables>(GetPersonaVerificationStatusByEmailDocument, options);
      }
export function useGetPersonaVerificationStatusByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonaVerificationStatusByEmailQuery, GetPersonaVerificationStatusByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonaVerificationStatusByEmailQuery, GetPersonaVerificationStatusByEmailQueryVariables>(GetPersonaVerificationStatusByEmailDocument, options);
        }
export type GetPersonaVerificationStatusByEmailQueryHookResult = ReturnType<typeof useGetPersonaVerificationStatusByEmailQuery>;
export type GetPersonaVerificationStatusByEmailLazyQueryHookResult = ReturnType<typeof useGetPersonaVerificationStatusByEmailLazyQuery>;
export type GetPersonaVerificationStatusByEmailQueryResult = Apollo.QueryResult<GetPersonaVerificationStatusByEmailQuery, GetPersonaVerificationStatusByEmailQueryVariables>;
export const GetAgreementsByUserIdDocument = gql`
    query GetAgreementsByUserId($id: uuid!) {
  user_agreements(where: {user_id: {_eq: $id}}) {
    agreement_type
    created_at
    id
    status
    user_id
  }
}
    `;

/**
 * __useGetAgreementsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetAgreementsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementsByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgreementsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementsByUserIdQuery, GetAgreementsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementsByUserIdQuery, GetAgreementsByUserIdQueryVariables>(GetAgreementsByUserIdDocument, options);
      }
export function useGetAgreementsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementsByUserIdQuery, GetAgreementsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementsByUserIdQuery, GetAgreementsByUserIdQueryVariables>(GetAgreementsByUserIdDocument, options);
        }
export type GetAgreementsByUserIdQueryHookResult = ReturnType<typeof useGetAgreementsByUserIdQuery>;
export type GetAgreementsByUserIdLazyQueryHookResult = ReturnType<typeof useGetAgreementsByUserIdLazyQuery>;
export type GetAgreementsByUserIdQueryResult = Apollo.QueryResult<GetAgreementsByUserIdQuery, GetAgreementsByUserIdQueryVariables>;
export const GetAgreementAgeOfMajorityByUserIdDocument = gql`
    query GetAgreementAgeOfMajorityByUserId($id: uuid!) {
  user_agreements(
    where: {user_id: {_eq: $id}, agreement_type: {_eq: AGE_OF_MAJORITY}}
  ) {
    agreement_type
    created_at
    id
    status
    user_id
  }
}
    `;

/**
 * __useGetAgreementAgeOfMajorityByUserIdQuery__
 *
 * To run a query within a React component, call `useGetAgreementAgeOfMajorityByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementAgeOfMajorityByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementAgeOfMajorityByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgreementAgeOfMajorityByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementAgeOfMajorityByUserIdQuery, GetAgreementAgeOfMajorityByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementAgeOfMajorityByUserIdQuery, GetAgreementAgeOfMajorityByUserIdQueryVariables>(GetAgreementAgeOfMajorityByUserIdDocument, options);
      }
export function useGetAgreementAgeOfMajorityByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementAgeOfMajorityByUserIdQuery, GetAgreementAgeOfMajorityByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementAgeOfMajorityByUserIdQuery, GetAgreementAgeOfMajorityByUserIdQueryVariables>(GetAgreementAgeOfMajorityByUserIdDocument, options);
        }
export type GetAgreementAgeOfMajorityByUserIdQueryHookResult = ReturnType<typeof useGetAgreementAgeOfMajorityByUserIdQuery>;
export type GetAgreementAgeOfMajorityByUserIdLazyQueryHookResult = ReturnType<typeof useGetAgreementAgeOfMajorityByUserIdLazyQuery>;
export type GetAgreementAgeOfMajorityByUserIdQueryResult = Apollo.QueryResult<GetAgreementAgeOfMajorityByUserIdQuery, GetAgreementAgeOfMajorityByUserIdQueryVariables>;
export const GetAgreementSudRecordsByUserIdDocument = gql`
    query GetAgreementSudRecordsByUserId($id: uuid!) {
  user_agreements(
    where: {user_id: {_eq: $id}, agreement_type: {_eq: NOTICE_OF_PRIVACY_SUD_RECORDS}}
  ) {
    agreement_type
    created_at
    id
    status
    user_id
    acceptor_role
  }
}
    `;

/**
 * __useGetAgreementSudRecordsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetAgreementSudRecordsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementSudRecordsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementSudRecordsByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgreementSudRecordsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementSudRecordsByUserIdQuery, GetAgreementSudRecordsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementSudRecordsByUserIdQuery, GetAgreementSudRecordsByUserIdQueryVariables>(GetAgreementSudRecordsByUserIdDocument, options);
      }
export function useGetAgreementSudRecordsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementSudRecordsByUserIdQuery, GetAgreementSudRecordsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementSudRecordsByUserIdQuery, GetAgreementSudRecordsByUserIdQueryVariables>(GetAgreementSudRecordsByUserIdDocument, options);
        }
export type GetAgreementSudRecordsByUserIdQueryHookResult = ReturnType<typeof useGetAgreementSudRecordsByUserIdQuery>;
export type GetAgreementSudRecordsByUserIdLazyQueryHookResult = ReturnType<typeof useGetAgreementSudRecordsByUserIdLazyQuery>;
export type GetAgreementSudRecordsByUserIdQueryResult = Apollo.QueryResult<GetAgreementSudRecordsByUserIdQuery, GetAgreementSudRecordsByUserIdQueryVariables>;
export const GetAgreementSubstanceByUserIdDocument = gql`
    query GetAgreementSubstanceByUserId($id: uuid!) {
  user_agreements(
    where: {user_id: {_eq: $id}, agreement_type: {_eq: CONSENT_TO_USE_AND_DISCLOSE_SUD_RECORDS}}
  ) {
    agreement_type
    created_at
    id
    status
    user_id
    expiration_type
  }
}
    `;

/**
 * __useGetAgreementSubstanceByUserIdQuery__
 *
 * To run a query within a React component, call `useGetAgreementSubstanceByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgreementSubstanceByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgreementSubstanceByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgreementSubstanceByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetAgreementSubstanceByUserIdQuery, GetAgreementSubstanceByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgreementSubstanceByUserIdQuery, GetAgreementSubstanceByUserIdQueryVariables>(GetAgreementSubstanceByUserIdDocument, options);
      }
export function useGetAgreementSubstanceByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgreementSubstanceByUserIdQuery, GetAgreementSubstanceByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgreementSubstanceByUserIdQuery, GetAgreementSubstanceByUserIdQueryVariables>(GetAgreementSubstanceByUserIdDocument, options);
        }
export type GetAgreementSubstanceByUserIdQueryHookResult = ReturnType<typeof useGetAgreementSubstanceByUserIdQuery>;
export type GetAgreementSubstanceByUserIdLazyQueryHookResult = ReturnType<typeof useGetAgreementSubstanceByUserIdLazyQuery>;
export type GetAgreementSubstanceByUserIdQueryResult = Apollo.QueryResult<GetAgreementSubstanceByUserIdQuery, GetAgreementSubstanceByUserIdQueryVariables>;
export const GetUserPersonaInquiryIdDocument = gql`
    query GetUserPersonaInquiryId($id: uuid!) {
  persona_inquiries(where: {user_id: {_eq: $id}}) {
    persona_inquiry_id
  }
}
    `;

/**
 * __useGetUserPersonaInquiryIdQuery__
 *
 * To run a query within a React component, call `useGetUserPersonaInquiryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPersonaInquiryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPersonaInquiryIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserPersonaInquiryIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserPersonaInquiryIdQuery, GetUserPersonaInquiryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPersonaInquiryIdQuery, GetUserPersonaInquiryIdQueryVariables>(GetUserPersonaInquiryIdDocument, options);
      }
export function useGetUserPersonaInquiryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPersonaInquiryIdQuery, GetUserPersonaInquiryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPersonaInquiryIdQuery, GetUserPersonaInquiryIdQueryVariables>(GetUserPersonaInquiryIdDocument, options);
        }
export type GetUserPersonaInquiryIdQueryHookResult = ReturnType<typeof useGetUserPersonaInquiryIdQuery>;
export type GetUserPersonaInquiryIdLazyQueryHookResult = ReturnType<typeof useGetUserPersonaInquiryIdLazyQuery>;
export type GetUserPersonaInquiryIdQueryResult = Apollo.QueryResult<GetUserPersonaInquiryIdQuery, GetUserPersonaInquiryIdQueryVariables>;
export const GetUserEmailPreferencesDocument = gql`
    query GetUserEmailPreferences($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    EMAIL_NEW_FEATURES_SERVICES_SETTINGS
    EMAIL_MONTHLY_NEWSLETTER
    EMAIL_SPECIAL_OFFERS_SETTING
    EMAIL_SPECIAL_OFFER_FRIENDS_SETTING
    EMAIL_UNSUBSCRIBED
  }
}
    `;

/**
 * __useGetUserEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEmailPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserEmailPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetUserEmailPreferencesQuery, GetUserEmailPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEmailPreferencesQuery, GetUserEmailPreferencesQueryVariables>(GetUserEmailPreferencesDocument, options);
      }
export function useGetUserEmailPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEmailPreferencesQuery, GetUserEmailPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEmailPreferencesQuery, GetUserEmailPreferencesQueryVariables>(GetUserEmailPreferencesDocument, options);
        }
export type GetUserEmailPreferencesQueryHookResult = ReturnType<typeof useGetUserEmailPreferencesQuery>;
export type GetUserEmailPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserEmailPreferencesLazyQuery>;
export type GetUserEmailPreferencesQueryResult = Apollo.QueryResult<GetUserEmailPreferencesQuery, GetUserEmailPreferencesQueryVariables>;
export const GetUserPrivacyPreferencesDocument = gql`
    query GetUserPrivacyPreferences($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    PRIVACY_AFFILIATES_CODEX_LABS_SETTING
    PRIVACY_NON_AFFILIATES_CODEX_LABS_SETTING
    PRIVACY_CALIFORNIA_SETTINGS
  }
}
    `;

/**
 * __useGetUserPrivacyPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPrivacyPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPrivacyPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPrivacyPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserPrivacyPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetUserPrivacyPreferencesQuery, GetUserPrivacyPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPrivacyPreferencesQuery, GetUserPrivacyPreferencesQueryVariables>(GetUserPrivacyPreferencesDocument, options);
      }
export function useGetUserPrivacyPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPrivacyPreferencesQuery, GetUserPrivacyPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPrivacyPreferencesQuery, GetUserPrivacyPreferencesQueryVariables>(GetUserPrivacyPreferencesDocument, options);
        }
export type GetUserPrivacyPreferencesQueryHookResult = ReturnType<typeof useGetUserPrivacyPreferencesQuery>;
export type GetUserPrivacyPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserPrivacyPreferencesLazyQuery>;
export type GetUserPrivacyPreferencesQueryResult = Apollo.QueryResult<GetUserPrivacyPreferencesQuery, GetUserPrivacyPreferencesQueryVariables>;
export const GetUserAutoApprovalPreferencesDocument = gql`
    query GetUserAutoApprovalPreferences($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    AUTO_APPROVAL_PATIENTS_CODEX_LABS_SETTING
    AUTO_APPROVAL_TESTKIT_SCRIPTS_CODEX_LABS_SETTING
  }
}
    `;

/**
 * __useGetUserAutoApprovalPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserAutoApprovalPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAutoApprovalPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAutoApprovalPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAutoApprovalPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetUserAutoApprovalPreferencesQuery, GetUserAutoApprovalPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAutoApprovalPreferencesQuery, GetUserAutoApprovalPreferencesQueryVariables>(GetUserAutoApprovalPreferencesDocument, options);
      }
export function useGetUserAutoApprovalPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAutoApprovalPreferencesQuery, GetUserAutoApprovalPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAutoApprovalPreferencesQuery, GetUserAutoApprovalPreferencesQueryVariables>(GetUserAutoApprovalPreferencesDocument, options);
        }
export type GetUserAutoApprovalPreferencesQueryHookResult = ReturnType<typeof useGetUserAutoApprovalPreferencesQuery>;
export type GetUserAutoApprovalPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserAutoApprovalPreferencesLazyQuery>;
export type GetUserAutoApprovalPreferencesQueryResult = Apollo.QueryResult<GetUserAutoApprovalPreferencesQuery, GetUserAutoApprovalPreferencesQueryVariables>;
export const GetUserAlertPreferencesDocument = gql`
    query GetUserAlertPreferences($id: uuid!) {
  user_settings(where: {user_id: {_eq: $id}}) {
    alert_settings
  }
}
    `;

/**
 * __useGetUserAlertPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserAlertPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAlertPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAlertPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAlertPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetUserAlertPreferencesQuery, GetUserAlertPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAlertPreferencesQuery, GetUserAlertPreferencesQueryVariables>(GetUserAlertPreferencesDocument, options);
      }
export function useGetUserAlertPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAlertPreferencesQuery, GetUserAlertPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAlertPreferencesQuery, GetUserAlertPreferencesQueryVariables>(GetUserAlertPreferencesDocument, options);
        }
export type GetUserAlertPreferencesQueryHookResult = ReturnType<typeof useGetUserAlertPreferencesQuery>;
export type GetUserAlertPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserAlertPreferencesLazyQuery>;
export type GetUserAlertPreferencesQueryResult = Apollo.QueryResult<GetUserAlertPreferencesQuery, GetUserAlertPreferencesQueryVariables>;
export const GetSubPatientsByParentDocument = gql`
    query GetSubPatientsByParent {
  getSubPatientsByParent {
    subPatients {
      birthDate
      firstName
      id
      lastName
      parentCodexId
      parentRelationship
      profilePhoto
      child_fully_verified
      blocked_at
    }
    total
  }
}
    `;

/**
 * __useGetSubPatientsByParentQuery__
 *
 * To run a query within a React component, call `useGetSubPatientsByParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubPatientsByParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubPatientsByParentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubPatientsByParentQuery(baseOptions?: Apollo.QueryHookOptions<GetSubPatientsByParentQuery, GetSubPatientsByParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubPatientsByParentQuery, GetSubPatientsByParentQueryVariables>(GetSubPatientsByParentDocument, options);
      }
export function useGetSubPatientsByParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubPatientsByParentQuery, GetSubPatientsByParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubPatientsByParentQuery, GetSubPatientsByParentQueryVariables>(GetSubPatientsByParentDocument, options);
        }
export type GetSubPatientsByParentQueryHookResult = ReturnType<typeof useGetSubPatientsByParentQuery>;
export type GetSubPatientsByParentLazyQueryHookResult = ReturnType<typeof useGetSubPatientsByParentLazyQuery>;
export type GetSubPatientsByParentQueryResult = Apollo.QueryResult<GetSubPatientsByParentQuery, GetSubPatientsByParentQueryVariables>;
export const GetClosedSubPatientsByParentDocument = gql`
    query GetClosedSubPatientsByParent {
  getSubPatientsByParent(isClosed: true) {
    subPatients {
      birthDate
      firstName
      id
      lastName
      parentCodexId
      parentRelationship
      profilePhoto
      child_fully_verified
      blocked_at
    }
    closedTotal
  }
}
    `;

/**
 * __useGetClosedSubPatientsByParentQuery__
 *
 * To run a query within a React component, call `useGetClosedSubPatientsByParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClosedSubPatientsByParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClosedSubPatientsByParentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClosedSubPatientsByParentQuery(baseOptions?: Apollo.QueryHookOptions<GetClosedSubPatientsByParentQuery, GetClosedSubPatientsByParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClosedSubPatientsByParentQuery, GetClosedSubPatientsByParentQueryVariables>(GetClosedSubPatientsByParentDocument, options);
      }
export function useGetClosedSubPatientsByParentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClosedSubPatientsByParentQuery, GetClosedSubPatientsByParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClosedSubPatientsByParentQuery, GetClosedSubPatientsByParentQueryVariables>(GetClosedSubPatientsByParentDocument, options);
        }
export type GetClosedSubPatientsByParentQueryHookResult = ReturnType<typeof useGetClosedSubPatientsByParentQuery>;
export type GetClosedSubPatientsByParentLazyQueryHookResult = ReturnType<typeof useGetClosedSubPatientsByParentLazyQuery>;
export type GetClosedSubPatientsByParentQueryResult = Apollo.QueryResult<GetClosedSubPatientsByParentQuery, GetClosedSubPatientsByParentQueryVariables>;
export const MyHistoryOrdersDocument = gql`
    query myHistoryOrders($limit: Int = 10, $offset: Int = 0, $direction: OrderByDirections = DESC, $field: OrdersOrderByCriterias = CREATED_AT, $filter: OrderFilterInput) {
  getOrders(
    limit: $limit
    offset: $offset
    filter: $filter
    orderBy: {direction: $direction, field: $field}
  ) {
    orders {
      id
      created_at
      status
      order_products {
        product {
          category
          title
          test_type
        }
      }
      total_amount
      statusHistory {
        status
        datetime
      }
    }
    total
  }
}
    `;

/**
 * __useMyHistoryOrdersQuery__
 *
 * To run a query within a React component, call `useMyHistoryOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHistoryOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHistoryOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      direction: // value for 'direction'
 *      field: // value for 'field'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMyHistoryOrdersQuery(baseOptions?: Apollo.QueryHookOptions<MyHistoryOrdersQuery, MyHistoryOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyHistoryOrdersQuery, MyHistoryOrdersQueryVariables>(MyHistoryOrdersDocument, options);
      }
export function useMyHistoryOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyHistoryOrdersQuery, MyHistoryOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyHistoryOrdersQuery, MyHistoryOrdersQueryVariables>(MyHistoryOrdersDocument, options);
        }
export type MyHistoryOrdersQueryHookResult = ReturnType<typeof useMyHistoryOrdersQuery>;
export type MyHistoryOrdersLazyQueryHookResult = ReturnType<typeof useMyHistoryOrdersLazyQuery>;
export type MyHistoryOrdersQueryResult = Apollo.QueryResult<MyHistoryOrdersQuery, MyHistoryOrdersQueryVariables>;
export const GetPatientStateAgeOfMajorityDocument = gql`
    query GetPatientStateAgeOfMajority {
  getPatientStateAgeOfMajority {
    ageOfMajority
    state
  }
}
    `;

/**
 * __useGetPatientStateAgeOfMajorityQuery__
 *
 * To run a query within a React component, call `useGetPatientStateAgeOfMajorityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientStateAgeOfMajorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientStateAgeOfMajorityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPatientStateAgeOfMajorityQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientStateAgeOfMajorityQuery, GetPatientStateAgeOfMajorityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientStateAgeOfMajorityQuery, GetPatientStateAgeOfMajorityQueryVariables>(GetPatientStateAgeOfMajorityDocument, options);
      }
export function useGetPatientStateAgeOfMajorityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientStateAgeOfMajorityQuery, GetPatientStateAgeOfMajorityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientStateAgeOfMajorityQuery, GetPatientStateAgeOfMajorityQueryVariables>(GetPatientStateAgeOfMajorityDocument, options);
        }
export type GetPatientStateAgeOfMajorityQueryHookResult = ReturnType<typeof useGetPatientStateAgeOfMajorityQuery>;
export type GetPatientStateAgeOfMajorityLazyQueryHookResult = ReturnType<typeof useGetPatientStateAgeOfMajorityLazyQuery>;
export type GetPatientStateAgeOfMajorityQueryResult = Apollo.QueryResult<GetPatientStateAgeOfMajorityQuery, GetPatientStateAgeOfMajorityQueryVariables>;
export const GetFilesByRequestUserCodexIdDocument = gql`
    query GetFilesByRequestUserCodexId($contentTypes: [FileTypesEnum!], $limit: Int = 10, $offset: Int = 0, $from: String, $to: String, $sourceTypes: [MediaFileSourceType!]) {
  getFilesByRequestUserCodexId(
    input: {pagination: {limit: $limit, offset: $offset}, dates: {fromDate: $from, toDate: $to}, sourceTypes: $sourceTypes, contentTypes: $contentTypes}
  ) {
    files {
      contentType
      fileId
      sourceType
      url
      appointment {
        appointmentCodexId
        appointmentType
        start
      }
      provider {
        SENSITIVE_credentials {
          titles
          medicalRole
        }
        SENSITIVE_firstname
        SENSITIVE_lastname
        id
      }
    }
    total
  }
}
    `;

/**
 * __useGetFilesByRequestUserCodexIdQuery__
 *
 * To run a query within a React component, call `useGetFilesByRequestUserCodexIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesByRequestUserCodexIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesByRequestUserCodexIdQuery({
 *   variables: {
 *      contentTypes: // value for 'contentTypes'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sourceTypes: // value for 'sourceTypes'
 *   },
 * });
 */
export function useGetFilesByRequestUserCodexIdQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesByRequestUserCodexIdQuery, GetFilesByRequestUserCodexIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesByRequestUserCodexIdQuery, GetFilesByRequestUserCodexIdQueryVariables>(GetFilesByRequestUserCodexIdDocument, options);
      }
export function useGetFilesByRequestUserCodexIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesByRequestUserCodexIdQuery, GetFilesByRequestUserCodexIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesByRequestUserCodexIdQuery, GetFilesByRequestUserCodexIdQueryVariables>(GetFilesByRequestUserCodexIdDocument, options);
        }
export type GetFilesByRequestUserCodexIdQueryHookResult = ReturnType<typeof useGetFilesByRequestUserCodexIdQuery>;
export type GetFilesByRequestUserCodexIdLazyQueryHookResult = ReturnType<typeof useGetFilesByRequestUserCodexIdLazyQuery>;
export type GetFilesByRequestUserCodexIdQueryResult = Apollo.QueryResult<GetFilesByRequestUserCodexIdQuery, GetFilesByRequestUserCodexIdQueryVariables>;
export const GetReceiptsHistoryDocument = gql`
    query GetReceiptsHistory($input: ReceiptHistoryInput!) {
  getReceiptsHistory(input: $input) {
    receipts {
      paymentTransactionId
      paidAt
      category
      amount
    }
    total
  }
}
    `;

/**
 * __useGetReceiptsHistoryQuery__
 *
 * To run a query within a React component, call `useGetReceiptsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptsHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReceiptsHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetReceiptsHistoryQuery, GetReceiptsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptsHistoryQuery, GetReceiptsHistoryQueryVariables>(GetReceiptsHistoryDocument, options);
      }
export function useGetReceiptsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptsHistoryQuery, GetReceiptsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptsHistoryQuery, GetReceiptsHistoryQueryVariables>(GetReceiptsHistoryDocument, options);
        }
export type GetReceiptsHistoryQueryHookResult = ReturnType<typeof useGetReceiptsHistoryQuery>;
export type GetReceiptsHistoryLazyQueryHookResult = ReturnType<typeof useGetReceiptsHistoryLazyQuery>;
export type GetReceiptsHistoryQueryResult = Apollo.QueryResult<GetReceiptsHistoryQuery, GetReceiptsHistoryQueryVariables>;
export const GetReceiptsHistoryByPatientDocument = gql`
    query GetReceiptsHistoryByPatient($input: ReceiptHistoryInput = {pagingArgs: {limit: 10, offset: 0}}) {
  getReceiptsHistory(input: $input) {
    totalSpentOnOrders
    totalSpentOnAppointments
    total
    receipts {
      amount
      category
      paidAt
      paymentTransactionId
    }
  }
}
    `;

/**
 * __useGetReceiptsHistoryByPatientQuery__
 *
 * To run a query within a React component, call `useGetReceiptsHistoryByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiptsHistoryByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiptsHistoryByPatientQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReceiptsHistoryByPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetReceiptsHistoryByPatientQuery, GetReceiptsHistoryByPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiptsHistoryByPatientQuery, GetReceiptsHistoryByPatientQueryVariables>(GetReceiptsHistoryByPatientDocument, options);
      }
export function useGetReceiptsHistoryByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiptsHistoryByPatientQuery, GetReceiptsHistoryByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiptsHistoryByPatientQuery, GetReceiptsHistoryByPatientQueryVariables>(GetReceiptsHistoryByPatientDocument, options);
        }
export type GetReceiptsHistoryByPatientQueryHookResult = ReturnType<typeof useGetReceiptsHistoryByPatientQuery>;
export type GetReceiptsHistoryByPatientLazyQueryHookResult = ReturnType<typeof useGetReceiptsHistoryByPatientLazyQuery>;
export type GetReceiptsHistoryByPatientQueryResult = Apollo.QueryResult<GetReceiptsHistoryByPatientQuery, GetReceiptsHistoryByPatientQueryVariables>;
export const GetAppointmentPaymentInfoByPatientDocument = gql`
    query GetAppointmentPaymentInfoByPatient($find: String, $offset: Int = 0, $limit: Int = 10, $sort: String, $sortDirection: Float = 0) {
  getFHIRAppointmentByRequestPatientCodexId(
    find: $find
    offset: $offset
    limit: $limit
    sort: $sort
    sortDirection: $sortDirection
    appointmentStatus: ["fulfilled"]
  ) {
    appointment {
      appointmentType
      providerFirstName
      providerLastName
      start
      end
      paymentSessionOpenedAt
      paymentInformation {
        amount
      }
      appointmentCodexId
    }
    total
  }
}
    `;

/**
 * __useGetAppointmentPaymentInfoByPatientQuery__
 *
 * To run a query within a React component, call `useGetAppointmentPaymentInfoByPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentPaymentInfoByPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentPaymentInfoByPatientQuery({
 *   variables: {
 *      find: // value for 'find'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetAppointmentPaymentInfoByPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentPaymentInfoByPatientQuery, GetAppointmentPaymentInfoByPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentPaymentInfoByPatientQuery, GetAppointmentPaymentInfoByPatientQueryVariables>(GetAppointmentPaymentInfoByPatientDocument, options);
      }
export function useGetAppointmentPaymentInfoByPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentPaymentInfoByPatientQuery, GetAppointmentPaymentInfoByPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentPaymentInfoByPatientQuery, GetAppointmentPaymentInfoByPatientQueryVariables>(GetAppointmentPaymentInfoByPatientDocument, options);
        }
export type GetAppointmentPaymentInfoByPatientQueryHookResult = ReturnType<typeof useGetAppointmentPaymentInfoByPatientQuery>;
export type GetAppointmentPaymentInfoByPatientLazyQueryHookResult = ReturnType<typeof useGetAppointmentPaymentInfoByPatientLazyQuery>;
export type GetAppointmentPaymentInfoByPatientQueryResult = Apollo.QueryResult<GetAppointmentPaymentInfoByPatientQuery, GetAppointmentPaymentInfoByPatientQueryVariables>;
export const GetUsersVerificationStatusesByEmailDocument = gql`
    query getUsersVerificationStatusesByEmail($email: String!) {
  users(where: {SENSITIVE_email: {_eq: $email}, is_active: {_eq: true}}) {
    kyc_current_status
    kyc_insurance_status
    kyc_update_date
    insurance_verify_later
  }
}
    `;

/**
 * __useGetUsersVerificationStatusesByEmailQuery__
 *
 * To run a query within a React component, call `useGetUsersVerificationStatusesByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersVerificationStatusesByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersVerificationStatusesByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUsersVerificationStatusesByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUsersVerificationStatusesByEmailQuery, GetUsersVerificationStatusesByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersVerificationStatusesByEmailQuery, GetUsersVerificationStatusesByEmailQueryVariables>(GetUsersVerificationStatusesByEmailDocument, options);
      }
export function useGetUsersVerificationStatusesByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersVerificationStatusesByEmailQuery, GetUsersVerificationStatusesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersVerificationStatusesByEmailQuery, GetUsersVerificationStatusesByEmailQueryVariables>(GetUsersVerificationStatusesByEmailDocument, options);
        }
export type GetUsersVerificationStatusesByEmailQueryHookResult = ReturnType<typeof useGetUsersVerificationStatusesByEmailQuery>;
export type GetUsersVerificationStatusesByEmailLazyQueryHookResult = ReturnType<typeof useGetUsersVerificationStatusesByEmailLazyQuery>;
export type GetUsersVerificationStatusesByEmailQueryResult = Apollo.QueryResult<GetUsersVerificationStatusesByEmailQuery, GetUsersVerificationStatusesByEmailQueryVariables>;
export const GetMyAcceptedLegalDocumentsDocument = gql`
    query GetMyAcceptedLegalDocuments {
  getAcceptedLegalDocuments {
    acceptedLegalDocuments {
      acceptanceDate
      acceptedVersion
      latestVersion
      type
    }
  }
}
    `;

/**
 * __useGetMyAcceptedLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useGetMyAcceptedLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAcceptedLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAcceptedLegalDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAcceptedLegalDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAcceptedLegalDocumentsQuery, GetMyAcceptedLegalDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAcceptedLegalDocumentsQuery, GetMyAcceptedLegalDocumentsQueryVariables>(GetMyAcceptedLegalDocumentsDocument, options);
      }
export function useGetMyAcceptedLegalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAcceptedLegalDocumentsQuery, GetMyAcceptedLegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAcceptedLegalDocumentsQuery, GetMyAcceptedLegalDocumentsQueryVariables>(GetMyAcceptedLegalDocumentsDocument, options);
        }
export type GetMyAcceptedLegalDocumentsQueryHookResult = ReturnType<typeof useGetMyAcceptedLegalDocumentsQuery>;
export type GetMyAcceptedLegalDocumentsLazyQueryHookResult = ReturnType<typeof useGetMyAcceptedLegalDocumentsLazyQuery>;
export type GetMyAcceptedLegalDocumentsQueryResult = Apollo.QueryResult<GetMyAcceptedLegalDocumentsQuery, GetMyAcceptedLegalDocumentsQueryVariables>;
export const SubscriptionAgreementAgeOfMajorityByUserIdDocument = gql`
    subscription SubscriptionAgreementAgeOfMajorityByUserId($id: uuid!) {
  user_agreements(
    where: {user_id: {_eq: $id}, agreement_type: {_eq: AGE_OF_MAJORITY}}
  ) {
    agreement_type
    created_at
    id
    status
    user_id
  }
}
    `;

/**
 * __useSubscriptionAgreementAgeOfMajorityByUserIdSubscription__
 *
 * To run a query within a React component, call `useSubscriptionAgreementAgeOfMajorityByUserIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionAgreementAgeOfMajorityByUserIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionAgreementAgeOfMajorityByUserIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionAgreementAgeOfMajorityByUserIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscriptionAgreementAgeOfMajorityByUserIdSubscription, SubscriptionAgreementAgeOfMajorityByUserIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscriptionAgreementAgeOfMajorityByUserIdSubscription, SubscriptionAgreementAgeOfMajorityByUserIdSubscriptionVariables>(SubscriptionAgreementAgeOfMajorityByUserIdDocument, options);
      }
export type SubscriptionAgreementAgeOfMajorityByUserIdSubscriptionHookResult = ReturnType<typeof useSubscriptionAgreementAgeOfMajorityByUserIdSubscription>;
export type SubscriptionAgreementAgeOfMajorityByUserIdSubscriptionResult = Apollo.SubscriptionResult<SubscriptionAgreementAgeOfMajorityByUserIdSubscription>;
export const SubscriptionUserIndicatorsDocument = gql`
    subscription SubscriptionUserIndicators($ids: [uuid!]) {
  user_indicators(where: {user_id: {_in: $ids}}) {
    boolean_state
    created_at
    id
    indicator_type
    updated_at
    user_id
  }
}
    `;

/**
 * __useSubscriptionUserIndicatorsSubscription__
 *
 * To run a query within a React component, call `useSubscriptionUserIndicatorsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUserIndicatorsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionUserIndicatorsSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSubscriptionUserIndicatorsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscriptionUserIndicatorsSubscription, SubscriptionUserIndicatorsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscriptionUserIndicatorsSubscription, SubscriptionUserIndicatorsSubscriptionVariables>(SubscriptionUserIndicatorsDocument, options);
      }
export type SubscriptionUserIndicatorsSubscriptionHookResult = ReturnType<typeof useSubscriptionUserIndicatorsSubscription>;
export type SubscriptionUserIndicatorsSubscriptionResult = Apollo.SubscriptionResult<SubscriptionUserIndicatorsSubscription>;
export const GetUsersVerificationStatusByEmailDocument = gql`
    subscription GetUsersVerificationStatusByEmail($email: String!) {
  users(where: {SENSITIVE_email: {_eq: $email}, is_active: {_eq: true}}) {
    kyc_current_status
    kyc_insurance_status
    kyc_update_date
    insurance_verify_later
  }
}
    `;

/**
 * __useGetUsersVerificationStatusByEmailSubscription__
 *
 * To run a query within a React component, call `useGetUsersVerificationStatusByEmailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersVerificationStatusByEmailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersVerificationStatusByEmailSubscription({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUsersVerificationStatusByEmailSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetUsersVerificationStatusByEmailSubscription, GetUsersVerificationStatusByEmailSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUsersVerificationStatusByEmailSubscription, GetUsersVerificationStatusByEmailSubscriptionVariables>(GetUsersVerificationStatusByEmailDocument, options);
      }
export type GetUsersVerificationStatusByEmailSubscriptionHookResult = ReturnType<typeof useGetUsersVerificationStatusByEmailSubscription>;
export type GetUsersVerificationStatusByEmailSubscriptionResult = Apollo.SubscriptionResult<GetUsersVerificationStatusByEmailSubscription>;
export const GetChildVerificationStatusByEmailDocument = gql`
    subscription GetChildVerificationStatusByEmail($id: uuid!) {
  users(where: {id: {_eq: $id}, is_active: {_eq: true}}) {
    kyc_child_status
    SENSITIVE_dob
  }
}
    `;

/**
 * __useGetChildVerificationStatusByEmailSubscription__
 *
 * To run a query within a React component, call `useGetChildVerificationStatusByEmailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetChildVerificationStatusByEmailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildVerificationStatusByEmailSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChildVerificationStatusByEmailSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetChildVerificationStatusByEmailSubscription, GetChildVerificationStatusByEmailSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetChildVerificationStatusByEmailSubscription, GetChildVerificationStatusByEmailSubscriptionVariables>(GetChildVerificationStatusByEmailDocument, options);
      }
export type GetChildVerificationStatusByEmailSubscriptionHookResult = ReturnType<typeof useGetChildVerificationStatusByEmailSubscription>;
export type GetChildVerificationStatusByEmailSubscriptionResult = Apollo.SubscriptionResult<GetChildVerificationStatusByEmailSubscription>;
export const RegisterAuthProviderDocument = gql`
    mutation RegisterAuthProvider($provider_type: String!) {
  RegisterAuthProvider(provider: {providerType: $provider_type}) {
    message
    status
  }
}
    `;
export type RegisterAuthProviderMutationFn = Apollo.MutationFunction<RegisterAuthProviderMutation, RegisterAuthProviderMutationVariables>;

/**
 * __useRegisterAuthProviderMutation__
 *
 * To run a mutation, you first call `useRegisterAuthProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAuthProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAuthProviderMutation, { data, loading, error }] = useRegisterAuthProviderMutation({
 *   variables: {
 *      provider_type: // value for 'provider_type'
 *   },
 * });
 */
export function useRegisterAuthProviderMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAuthProviderMutation, RegisterAuthProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAuthProviderMutation, RegisterAuthProviderMutationVariables>(RegisterAuthProviderDocument, options);
      }
export type RegisterAuthProviderMutationHookResult = ReturnType<typeof useRegisterAuthProviderMutation>;
export type RegisterAuthProviderMutationResult = Apollo.MutationResult<RegisterAuthProviderMutation>;
export type RegisterAuthProviderMutationOptions = Apollo.BaseMutationOptions<RegisterAuthProviderMutation, RegisterAuthProviderMutationVariables>;
export const AddServiceOfferingsDocument = gql`
    mutation addServiceOfferings($offerings: [AddServiceOfferingInput!]!) {
  addServiceOfferings(
    registerPatchFHIRProviderServiceOfferingsInput: {offerings: $offerings}
  ) {
    update_providers_one {
      id
      isStripeConnected
      serviceOfferings {
        active
        healthCareServiceFhirId
        price
        priceCategory
        serviceType
      }
    }
  }
}
    `;
export type AddServiceOfferingsMutationFn = Apollo.MutationFunction<AddServiceOfferingsMutation, AddServiceOfferingsMutationVariables>;

/**
 * __useAddServiceOfferingsMutation__
 *
 * To run a mutation, you first call `useAddServiceOfferingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceOfferingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceOfferingsMutation, { data, loading, error }] = useAddServiceOfferingsMutation({
 *   variables: {
 *      offerings: // value for 'offerings'
 *   },
 * });
 */
export function useAddServiceOfferingsMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceOfferingsMutation, AddServiceOfferingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceOfferingsMutation, AddServiceOfferingsMutationVariables>(AddServiceOfferingsDocument, options);
      }
export type AddServiceOfferingsMutationHookResult = ReturnType<typeof useAddServiceOfferingsMutation>;
export type AddServiceOfferingsMutationResult = Apollo.MutationResult<AddServiceOfferingsMutation>;
export type AddServiceOfferingsMutationOptions = Apollo.BaseMutationOptions<AddServiceOfferingsMutation, AddServiceOfferingsMutationVariables>;
export const ConnectStripeAccountDocument = gql`
    mutation ConnectStripeAccount($code: String!) {
  ConnectStripeAccount(connectStripeAccountInput: {code: $code}) {
    status
  }
}
    `;
export type ConnectStripeAccountMutationFn = Apollo.MutationFunction<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>;

/**
 * __useConnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useConnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectStripeAccountMutation, { data, loading, error }] = useConnectStripeAccountMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>(ConnectStripeAccountDocument, options);
      }
export type ConnectStripeAccountMutationHookResult = ReturnType<typeof useConnectStripeAccountMutation>;
export type ConnectStripeAccountMutationResult = Apollo.MutationResult<ConnectStripeAccountMutation>;
export type ConnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<ConnectStripeAccountMutation, ConnectStripeAccountMutationVariables>;
export const GetVonageArchivesDocument = gql`
    mutation GetVonageArchives($sessionId: String!) {
  GetVonageArchives(sessionId: $sessionId) {
    archives
  }
}
    `;
export type GetVonageArchivesMutationFn = Apollo.MutationFunction<GetVonageArchivesMutation, GetVonageArchivesMutationVariables>;

/**
 * __useGetVonageArchivesMutation__
 *
 * To run a mutation, you first call `useGetVonageArchivesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVonageArchivesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVonageArchivesMutation, { data, loading, error }] = useGetVonageArchivesMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetVonageArchivesMutation(baseOptions?: Apollo.MutationHookOptions<GetVonageArchivesMutation, GetVonageArchivesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetVonageArchivesMutation, GetVonageArchivesMutationVariables>(GetVonageArchivesDocument, options);
      }
export type GetVonageArchivesMutationHookResult = ReturnType<typeof useGetVonageArchivesMutation>;
export type GetVonageArchivesMutationResult = Apollo.MutationResult<GetVonageArchivesMutation>;
export type GetVonageArchivesMutationOptions = Apollo.BaseMutationOptions<GetVonageArchivesMutation, GetVonageArchivesMutationVariables>;
export const GetVonageSessionDocument = gql`
    mutation GetVonageSession($room: String!) {
  GetVonageSession(room: $room) {
    sessionId
    token
    apiKey
  }
}
    `;
export type GetVonageSessionMutationFn = Apollo.MutationFunction<GetVonageSessionMutation, GetVonageSessionMutationVariables>;

/**
 * __useGetVonageSessionMutation__
 *
 * To run a mutation, you first call `useGetVonageSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVonageSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVonageSessionMutation, { data, loading, error }] = useGetVonageSessionMutation({
 *   variables: {
 *      room: // value for 'room'
 *   },
 * });
 */
export function useGetVonageSessionMutation(baseOptions?: Apollo.MutationHookOptions<GetVonageSessionMutation, GetVonageSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetVonageSessionMutation, GetVonageSessionMutationVariables>(GetVonageSessionDocument, options);
      }
export type GetVonageSessionMutationHookResult = ReturnType<typeof useGetVonageSessionMutation>;
export type GetVonageSessionMutationResult = Apollo.MutationResult<GetVonageSessionMutation>;
export type GetVonageSessionMutationOptions = Apollo.BaseMutationOptions<GetVonageSessionMutation, GetVonageSessionMutationVariables>;
export const VonageCaptionsStartDocument = gql`
    mutation VonageCaptionsStart($sessionId: String = "") {
  VonageCaptionsStart(sessionId: $sessionId) {
    captionsId
    status
  }
}
    `;
export type VonageCaptionsStartMutationFn = Apollo.MutationFunction<VonageCaptionsStartMutation, VonageCaptionsStartMutationVariables>;

/**
 * __useVonageCaptionsStartMutation__
 *
 * To run a mutation, you first call `useVonageCaptionsStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVonageCaptionsStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vonageCaptionsStartMutation, { data, loading, error }] = useVonageCaptionsStartMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useVonageCaptionsStartMutation(baseOptions?: Apollo.MutationHookOptions<VonageCaptionsStartMutation, VonageCaptionsStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VonageCaptionsStartMutation, VonageCaptionsStartMutationVariables>(VonageCaptionsStartDocument, options);
      }
export type VonageCaptionsStartMutationHookResult = ReturnType<typeof useVonageCaptionsStartMutation>;
export type VonageCaptionsStartMutationResult = Apollo.MutationResult<VonageCaptionsStartMutation>;
export type VonageCaptionsStartMutationOptions = Apollo.BaseMutationOptions<VonageCaptionsStartMutation, VonageCaptionsStartMutationVariables>;
export const VonageCaptionsStopDocument = gql`
    mutation VonageCaptionsStop($sessionId: String = "") {
  VonageCaptionsStop(sessionId: $sessionId) {
    captionsId
    status
  }
}
    `;
export type VonageCaptionsStopMutationFn = Apollo.MutationFunction<VonageCaptionsStopMutation, VonageCaptionsStopMutationVariables>;

/**
 * __useVonageCaptionsStopMutation__
 *
 * To run a mutation, you first call `useVonageCaptionsStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVonageCaptionsStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vonageCaptionsStopMutation, { data, loading, error }] = useVonageCaptionsStopMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useVonageCaptionsStopMutation(baseOptions?: Apollo.MutationHookOptions<VonageCaptionsStopMutation, VonageCaptionsStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VonageCaptionsStopMutation, VonageCaptionsStopMutationVariables>(VonageCaptionsStopDocument, options);
      }
export type VonageCaptionsStopMutationHookResult = ReturnType<typeof useVonageCaptionsStopMutation>;
export type VonageCaptionsStopMutationResult = Apollo.MutationResult<VonageCaptionsStopMutation>;
export type VonageCaptionsStopMutationOptions = Apollo.BaseMutationOptions<VonageCaptionsStopMutation, VonageCaptionsStopMutationVariables>;
export const UpdateCallSettingsDocument = gql`
    mutation UpdateCallSettings($settings: JSON!) {
  updateCallSettings(input: {platform: WEB, settings: $settings}) {
    message
    status
  }
}
    `;
export type UpdateCallSettingsMutationFn = Apollo.MutationFunction<UpdateCallSettingsMutation, UpdateCallSettingsMutationVariables>;

/**
 * __useUpdateCallSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCallSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallSettingsMutation, { data, loading, error }] = useUpdateCallSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateCallSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallSettingsMutation, UpdateCallSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallSettingsMutation, UpdateCallSettingsMutationVariables>(UpdateCallSettingsDocument, options);
      }
export type UpdateCallSettingsMutationHookResult = ReturnType<typeof useUpdateCallSettingsMutation>;
export type UpdateCallSettingsMutationResult = Apollo.MutationResult<UpdateCallSettingsMutation>;
export type UpdateCallSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCallSettingsMutation, UpdateCallSettingsMutationVariables>;
export const GetCallSettingsDocument = gql`
    query GetCallSettings {
  getCallSettings(platform: WEB)
}
    `;

/**
 * __useGetCallSettingsQuery__
 *
 * To run a query within a React component, call `useGetCallSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCallSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallSettingsQuery, GetCallSettingsQueryVariables>(GetCallSettingsDocument, options);
      }
export function useGetCallSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallSettingsQuery, GetCallSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallSettingsQuery, GetCallSettingsQueryVariables>(GetCallSettingsDocument, options);
        }
export type GetCallSettingsQueryHookResult = ReturnType<typeof useGetCallSettingsQuery>;
export type GetCallSettingsLazyQueryHookResult = ReturnType<typeof useGetCallSettingsLazyQuery>;
export type GetCallSettingsQueryResult = Apollo.QueryResult<GetCallSettingsQuery, GetCallSettingsQueryVariables>;